webpackJsonp([0,2],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getModulesNames = __webpack_require__(1);
	
	var _getModulesNames2 = _interopRequireDefault(_getModulesNames);
	
	var _external = __webpack_require__(2);
	
	var _app = __webpack_require__(3);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(4);
	
	var _config = __webpack_require__(158);
	
	var _bootstrap = __webpack_require__(164);
	
	var _components = __webpack_require__(172);
	
	var _services = __webpack_require__(839);
	
	var _directives = __webpack_require__(851);
	
	var _utility = __webpack_require__(863);
	
	var _filters = __webpack_require__(895);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module("app", _external.external.concat((0, _getModulesNames2.default)([_config.ConfigsModule, _bootstrap.BootstrapModule, _components.ComponentsModule, _services.ServicesModule, _directives.DirectivesModule, _utility.UtilityModule, _filters.FiltersModule]))).value("$routerRootComponent", "app").component("app", {
		template: _app2.default,
		controller: _app3.AppController,
		controllerAs: "app"
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (modulesArray) {
	  var modules = [];
	  modulesArray.filter(function (module) {
	    return modules.push(module.name);
	  });
	  return modules;
	};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
				value: true
	});
	var external = exports.external = ["ngCookies", "ngSanitize", "ngMaterial", "ngMessages", "ui.router", "ui.router.title", "ui.router.stateHelper", "uiSwitch", "ngNotify", "ui.select", "vcRecaptcha", "gettext", "ngResource", "md.data.table", "mgo-angular-wizard", "ngMaterialDatePicker", "color.picker", "dndLists"];

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = "<section layout=\"column\" flex layout-fill>\n\t<md-toolbar class=\"md-toolbar--with-border\">\n\t\t<navbar></navbar>\n\t</md-toolbar>\n\n\t<section layout=\"row\" flex layout-fill>\n\t\t<md-sidenav\n\t\t\t\t\tclass=\"md-sidenav-left\"\n\t\t\t\t\tmd-component-id=\"left\"\n\t\t\t\t\tmd-whiteframe=\"4\"\n\t\t\t\t\tng-if=\"app.isAuthenticated()\">\n\t\t</md-sidenav>\n\n\t\t<section layout=\"column\" flex>\n\t\t\t<md-content flex layout-align=\"top center\" id=\"app\" class=\"app-container\">\n\t\t\t\t<ui-view></ui-view>\n\t\t\t</md-content>\n\t\t</section>\n\t</section>\n</section>\n\n\n";

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AppController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	__webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = [];
	/* eslint-disable */
	var favicons = {
		1: __webpack_require__(153),
		2: __webpack_require__(154),
		3: __webpack_require__(155),
		4: __webpack_require__(156),
		5: __webpack_require__(157)
	};
	
	var AppController = exports.AppController = function (_ActiveController) {
		AppController.$inject = ["$injector"];
		(0, _inherits3.default)(AppController, _ActiveController);
	
		function AppController($injector) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, AppController);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (AppController.__proto__ || (0, _getPrototypeOf2.default)(AppController)).call(this, $injector, dependencies));
	
			var defaultFormat = "YYYY-MM-DDTHH:mm:ss";
	
			window.moment.locale("pl");
			window.moment.defaultFormat = defaultFormat;
			window.moment.defaultFormatUtc = defaultFormat;
	
			_this.openedComponent = null;
	
			return _this;
		}
	
		(0, _createClass3.default)(AppController, [{
			key: "isAuthenticated",
			value: function isAuthenticated() {
				return this.$auth.isAuthenticated();
			}
		}]);
		return AppController;
	}(_controller2.default);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(6), __esModule: true };

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	module.exports = __webpack_require__(14).Object.getPrototypeOf;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(8);
	var $getPrototypeOf = __webpack_require__(10);
	
	__webpack_require__(18)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(34);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(35), __esModule: true };

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(36);
	var $Object = __webpack_require__(14).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(27), 'Object', { defineProperty: __webpack_require__(23).f });


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(83);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(87);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(84), __esModule: true };

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(85);
	module.exports = __webpack_require__(14).Object.setPrototypeOf;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(19);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(86).set });


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(25);
	var anObject = __webpack_require__(24);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(20)(Function.call, __webpack_require__(78).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(101);
	
	var _collectionRepository = __webpack_require__(103);
	
	var _collectionRepository2 = _interopRequireDefault(_collectionRepository);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalDependencies = ["$q", "$stateParams", "$state", "$filter", "$rootScope", "$log", "$auth", "$mdDialog", "$mdToast", "gettext"];
	
	var ActiveController = function () {
	    ActiveController.$inject = ["$injector"];
	    function ActiveController($injector) {
	
	        "ngInject";
	
	        var _this = this;
	
	        var childDependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	        (0, _classCallCheck3.default)(this, ActiveController);
	        this.$injector = $injector;
	
	        try {
	            this.importDependencies(childDependencies);
	        } catch (e) {
	            //this.$log.error(e);
	            console.log(e);
	        }
	
	        this._componentId = angular.copy(Math.random().toString(36).substr(2, 10));
	        this.componentId = this.constructor.name + "-" + this._componentId;
	
	        this.translate = function (key) {
	            return _this.$filter("translate")(key);
	        };
	
	        if (this.$stateParams.uri) {
	            this.uri = this.$filter("decodeUri")(this.$stateParams.uri);
	        }
	
	        if (this.$auth.isAuthenticated()) {
	            //this.isSuperadmin = this.$auth.getUser().permissions.indexOf("superadmin") !== -1;
	        }
	
	        this.noData = false;
	    }
	
	    (0, _createClass3.default)(ActiveController, [{
	        key: "getComponentId",
	        value: function getComponentId(suffix) {
	            suffix = suffix ? "-" + suffix : "";
	            return "#" + this.componentId + suffix;
	        }
	    }, {
	        key: "$getDataBeforeRun",
	        value: function $getDataBeforeRun(queries) {
	            var _this2 = this;
	
	            this.controllerReady = false;
	            var deferred = this.$q.defer();
	            this.$q.all(queries).then(function (response) {
	                return deferred.resolve(response);
	            }).then(function () {
	                return _this2.controllerReady = true;
	            });
	            return deferred.promise;
	        }
	    }, {
	        key: "$setDataAfterRun",
	        value: function $setDataAfterRun(response) {
	            this.tableConfiguration.next_uri = response.next_uri;
	            this.objects = (0, _lodash.uniqBy)([].concat((0, _toConsumableArray3.default)(this.objects), (0, _toConsumableArray3.default)(response.objects || response)), "uri");
	            this.objects.length === 0 && (this.noData = true);
	        }
	    }, {
	        key: "importDependencies",
	        value: function importDependencies(childDependencies) {
	            var _this3 = this;
	
	            try {
	                var duplicatedDependencies = [],
	                    toApply = [];
	
	                var executeApply = function executeApply(dependenciesToApply) {
	                    return (0, _lodash.forEach)(dependenciesToApply, function (dependence) {
	                        return _this3[dependence] = _this3.$injector.get(dependence);
	                    });
	                };
	
	                executeApply(globalDependencies);
	
	                (0, _lodash.filter)(childDependencies, function (dependence) {
	                    return (0, _lodash.includes)(globalDependencies, dependence) ? duplicatedDependencies.push(dependence) : toApply.push(dependence);
	                });
	
	                executeApply(toApply);
	
	                if (duplicatedDependencies.length) {
	                    return this.$log.warn("Warning, you have duplicated dependencies in your child controller based on $controller, there was not implemented but for Improved legibility your code, remove it.", duplicatedDependencies);
	                }
	            } catch (error) {
	                this.$log.error("There is something wrong in your dependencies and ActiveController can't include it.", childDependencies, this, error);
	                throw error;
	            }
	        }
	    }, {
	        key: "$openModal",
	        value: function $openModal(modalName, size, config) {
	            return this.$uibModal.open(config ? (0, _lodash.assign)({ component: modalName, size: size || "lg" }, config) : { component: modalName, size: size || "lg" });
	        }
	    }, {
	        key: "$closeModal",
	        value: function $closeModal($event) {
	            $event.preventDefault();
	            this.close({ $value: "cancel" });
	        }
	    }, {
	        key: "$notify",
	        value: function $notify(key, state) {
	            this.ngNotify.set(this.translate(key.toUpperCase()), state);
	        }
	    }, {
	        key: "$getCollection",
	        value: function $getCollection($uri) {
	            return _collectionRepository2.default.collection[$uri || this.uri];
	        }
	    }]);
	    return ActiveController;
	}();
	
	exports.default = ActiveController;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(92);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(93), __esModule: true };

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(41);
	__webpack_require__(94);
	module.exports = __webpack_require__(14).Array.from;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(20);
	var $export = __webpack_require__(19);
	var toObject = __webpack_require__(8);
	var call = __webpack_require__(95);
	var isArrayIter = __webpack_require__(96);
	var toLength = __webpack_require__(56);
	var createProperty = __webpack_require__(97);
	var getIterFn = __webpack_require__(98);
	
	$export($export.S + $export.F * !__webpack_require__(100)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(24);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(46);
	var ITERATOR = __webpack_require__(61)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(23);
	var createDesc = __webpack_require__(31);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(99);
	var ITERATOR = __webpack_require__(61)('iterator');
	var Iterators = __webpack_require__(46);
	module.exports = __webpack_require__(14).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(54);
	var TAG = __webpack_require__(61)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(61)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.11';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(102)(module)))

/***/ }),
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollectionRepository = function CollectionRepository() {
		(0, _classCallCheck3.default)(this, CollectionRepository);
	
		this.collection = [];
	};
	
	var collectionRepository = new CollectionRepository();
	
	exports.default = collectionRepository;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(105);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./styles.scss", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./styles.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:HKNova-Regular;src:url(" + __webpack_require__(107) + ");src:url(" + __webpack_require__(107) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(108) + ") format(\"woff2\"),url(" + __webpack_require__(109) + ") format(\"woff\"),url(" + __webpack_require__(110) + ") format(\"truetype\"),url(" + __webpack_require__(111) + "#HKNova-Regular) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:HKNova-ExtraLight;src:url(" + __webpack_require__(112) + ");src:url(" + __webpack_require__(112) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(113) + ") format(\"woff2\"),url(" + __webpack_require__(114) + ") format(\"woff\"),url(" + __webpack_require__(115) + ") format(\"truetype\"),url(" + __webpack_require__(116) + "#HKNova-ExtraLight) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:HKNova-ExtraBold;src:url(" + __webpack_require__(117) + ");src:url(" + __webpack_require__(117) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(118) + ") format(\"woff2\"),url(" + __webpack_require__(119) + ") format(\"woff\"),url(" + __webpack_require__(120) + ") format(\"truetype\"),url(" + __webpack_require__(121) + "#HKNova-ExtraBold) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:HKNova-Heavy;src:url(" + __webpack_require__(122) + ");src:url(" + __webpack_require__(122) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(123) + ") format(\"woff2\"),url(" + __webpack_require__(124) + ") format(\"woff\"),url(" + __webpack_require__(125) + ") format(\"truetype\"),url(" + __webpack_require__(126) + "#HKNova-Heavy) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:HKNova-SemiBold;src:url(" + __webpack_require__(127) + ");src:url(" + __webpack_require__(127) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(128) + ") format(\"woff2\"),url(" + __webpack_require__(129) + ") format(\"woff\"),url(" + __webpack_require__(130) + ") format(\"truetype\"),url(" + __webpack_require__(131) + "#HKNova-SemiBold) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:HKNova-Medium;src:url(" + __webpack_require__(132) + ");src:url(" + __webpack_require__(132) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(133) + ") format(\"woff2\"),url(" + __webpack_require__(134) + ") format(\"woff\"),url(" + __webpack_require__(135) + ") format(\"truetype\"),url(" + __webpack_require__(136) + "#HKNova-Medium) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:HKNova-Light;src:url(" + __webpack_require__(137) + ");src:url(" + __webpack_require__(137) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(138) + ") format(\"woff2\"),url(" + __webpack_require__(139) + ") format(\"woff\"),url(" + __webpack_require__(140) + ") format(\"truetype\"),url(" + __webpack_require__(141) + "#HKNova-Light) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:HKNova-Bold;src:url(" + __webpack_require__(142) + ");src:url(" + __webpack_require__(142) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(143) + ") format(\"woff2\"),url(" + __webpack_require__(144) + ") format(\"woff\"),url(" + __webpack_require__(145) + ") format(\"truetype\"),url(" + __webpack_require__(146) + "#HKNova-Bold) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:HKNova-Thin;src:url(" + __webpack_require__(147) + ");src:url(" + __webpack_require__(147) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(148) + ") format(\"woff2\"),url(" + __webpack_require__(149) + ") format(\"woff\"),url(" + __webpack_require__(150) + ") format(\"truetype\"),url(" + __webpack_require__(151) + "#HKNova-Thin) format(\"svg\");font-weight:400;font-style:normal}.steps-indicator{font-family:HKNova-Regular;right:0;bottom:0;left:0;padding:20px 0 0;height:80px;list-style:none;max-width:1440px;width:100%;margin:0 auto;counter-reset:flag;display:flex;justify-content:space-evenly}.steps-indicator.steps-2:before{left:25%;right:25%}.steps-indicator.steps-3:before{left:16.66667%;right:16.66667%}.steps-indicator.steps-4:before{left:12.5%;right:12.5%}.steps-indicator.steps-5:before{left:10%;right:10%}.steps-indicator.steps-6:before{left:8.33333%;right:8.33333%}.steps-indicator.steps-7:before{left:7.14286%;right:7.14286%}.steps-indicator.steps-8:before{left:6.25%;right:6.25%}.steps-indicator.steps-9:before{left:5.55556%;right:5.55556%}.steps-indicator.steps-10:before{left:5%;right:5%}.steps-indicator *{box-sizing:border-box}.steps-indicator li{position:relative;float:left;margin:0;padding:0;padding-top:10px;text-align:center;line-height:15px;color:#25282a;font-size:11.787px;font-style:normal;font-weight:400}.steps-indicator li a{color:#000;text-decoration:none;text-transform:capitalize;transition:.25s;cursor:pointer}.steps-indicator li a:before{content:counter(flag) \". \";counter-increment:flag}.steps-indicator li a:hover{color:#4d4d4d}.steps-indicator.steps-2 li{width:50%}.steps-indicator.steps-3 li{width:33.33333%}.steps-indicator.steps-4 li{width:25%}.steps-indicator.steps-5 li{width:20%}.steps-indicator.steps-6 li{width:16.66667%}.steps-indicator.steps-7 li{width:14.28571%}.steps-indicator.steps-8 li{width:12.5%}.steps-indicator.steps-9 li{width:11.11111%}.steps-indicator.steps-10 li{width:10%}.steps-indicator.steps-11 li{width:9.09091%}.steps-indicator li.default{pointer-events:none}.steps-indicator li.default a:hover{color:gray}.steps-indicator li.current,.steps-indicator li.editing{pointer-events:none}.steps-indicator li.current a,.steps-indicator li.editing a{font-family:HKNova-Medium;text-decoration:underline}md-dialog.dtp{font-size:14px;line-height:1.42857143;color:#333;background-color:#fff;max-height:none;min-width:300px;width:300px}.noselect{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.dtp :focus{outline:none!important}.dtp table{border-spacing:0;border-collapse:collapse;width:100%}.dtp .table>tbody>tr>td,.dtp .table>tbody>tr>th,.dtp .table>tfoot>tr>td,.dtp .table>tfoot>tr>th,.dtp .table>thead>tr>td,.dtp .table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.dtp,.dtp *{box-sizing:border-box!important}.dtp>.dtp-content{max-width:300px;max-height:500px}.dtp>.dtp-content>.dtp-date-view>header.dtp-header,.dtp div.dtp-date,.dtp div.dtp-time{background:#ee2737;color:#fff;text-align:center}.dtp div.dtp-date,.dtp div.dtp-time{padding:10px}.dtp div.dtp-date>div{padding:0;margin:0}.dtp div.dtp-actual-month{font-size:1.5em;cursor:pointer}.dtp div.dtp-actual-maxtime,.dtp div.dtp-actual-num{font-size:2em;line-height:.9}.dtp div.dtp-actual-maxtime{color:#dcedc8}.dtp div.dtp-actual-maxtime span.selected{color:#fff}.dtp div.dtp-actual-year{font-size:1.6em;color:#dcedc8;cursor:pointer}.dtp div.dtp-month-btn{font-size:1.4em;line-height:30px;cursor:pointer}.dtp div.dtp-month-btn-prev{text-align:right}.dtp div.dtp-month-btn-next{text-align:left}.dtp div.dtp-year-btn{font-size:1.4em;line-height:30px;cursor:pointer;color:#dcedc8}.dtp div.dtp-year-btn-prev{text-align:right}.dtp div.dtp-year-btn-next{text-align:left}.dtp div.dtp-picker{padding:10px 10px 0;text-align:center;overflow:hidden}.dtp div.dtp-actual-time,.dtp div.dtp-picker-month{font-size:1.2em;font-weight:500;text-align:center}.dtp div.dtp-actual-time.p60 span.selected{color:#ee2737}.dtp .dtp-close{position:absolute;top:0;right:5px;font-size:16px}.dtp .dtp-close>a{color:#fff;text-decoration:none}.dtp .dtp-close>a>i{font-size:1em}.dtp table.dtp-picker-days{margin:0;min-height:220px}.dtp md-virtual-repeat-container.months{height:260px}.dtp table.dtp-picker-days,.dtp table.dtp-picker-days tr,.dtp table.dtp-picker-days tr>td{border:none}.dtp table.dtp-picker-days tr>td{font-size:11px;text-align:center;padding:0}.dtp table.dtp-picker-days tr>td>span.dtp-select-day{color:#bdbdbd!important}.dtp table.dtp-picker-days tr>td,.dtp table.dtp-picker-days tr>td>.dtp-select-day{width:36px;height:36px}.dtp table.dtp-picker-days tr>td>.dtp-select-day{display:inline-block}.dtp .dtp-picker-time>a,.dtp table.dtp-picker-days tr>td>.dtp-select-day{color:#212121;text-decoration:none;padding:10px;border-radius:50%!important}.dtp table.dtp-picker-days tr>td>a.selected{background:#ee2737;color:#fff}.dtp table.dtp-picker-days tr>td>a.selected.hilite{padding:6px;font-size:16px;font-weight:500;background:#ee2737;color:#fff}.dtp table.dtp-picker-days tr>td>a.hilite:not(.selected){padding:6px;font-size:16px;font-weight:500;color:#ee2737}.dtp table.dtp-picker-days tr>td>a:hover:not(.selected){background:#ddd}.dtp table.dtp-picker-days tr>th{color:#757575;text-align:center;font-weight:700;padding:4px 3px;width:38px;height:28px}.dtp .p10>a{color:#ee2737;text-decoration:none}.dtp .p10{width:10%}.dtp .p10,.dtp .p20{display:inline-block}.dtp .p20{width:20%}.dtp .p60{width:60%}.dtp .p60,.dtp .p80{display:inline-block}.dtp .p80{width:80%}.dtp div.dtp-picker-datetime{padding-bottom:25px}.dtp span.dtp-actual-meridien{font-size:.6em}.dtp div.dtp-actual-meridien{height:20px}.dtp a.dtp-meridien-am,.dtp a.dtp-meridien-pm{position:relative;color:#212121;font-weight:500;padding:7px 5px;border-radius:50%!important;text-decoration:none;background:#eee;font-size:10px}.dtp .dtp-actual-meridien a.selected{background:#ee2737;color:#fff}.dtp .dtp-picker-time>a{display:block;line-height:23px;padding:3px}.dtp .dtp-picker-time{position:absolute;width:30px;height:30px;font-size:1.1em;border-radius:50%;cursor:pointer;text-align:center!important}.dtp .dtp-picker-time>a.dtp-select-hour.selected{background:#ee2737;color:#fff}.dtp .dtp-picker-time>a.dtp-select-hour.disabled,.dtp .dtp-picker-time>a.dtp-select-minute.disabled{color:#757575}.dtp .dtp-picker-time>a.dtp-select-minute.selected{background:#ee2737;color:#fff}.dtp div.dtp-picker-clock{margin:10px 20px 0;padding:10px;border-radius:50%!important;background:#eee;direction:ltr;cursor:default}.dtp-clock-center{width:15px;height:15px;background:#757575;border-radius:50%;position:absolute;z-index:50}.dtp .dtp-hand,.dtp .dtp-hour-hand{position:absolute;width:4px;margin-left:-2px;background:#bdbdbd;transform:rotate(0deg);transform-origin:bottom;z-index:1}.dtp .dtp-minute-hand{width:2px;margin-left:-1px}.dtp .dtp-second-hand{width:1px;margin-left:-1px}.dtp .dtp-hand.on{background:#ee2737}.dtp .dtp-buttons{padding-bottom:10px;text-align:right}.dtp.hidden,.dtp .hidden{display:none}.dtp .invisible{visibility:hidden}.dtp .left{float:left}.dtp .right{float:right}.dtp .clearfix{clear:both}.dtp .center{text-align:center}[dir=rtl] .dtp div.dtp-month-btn-next,[dir=rtl] .dtp div.dtp-month-btn-prev,[dir=rtl] .dtp div.dtp-year-btn-next,[dir=rtl] .dtp div.dtp-year-btn-prev{transform:rotate(180deg)}.dtp-btn-cancel,.dtp-btn-ok,l .dtp-btn-today{min-width:70px}.dtp-clear{position:absolute;top:0;right:-10px}.dtp-no-msclear::-ms-clear{display:none;width:0;height:0}.dtp-btn-calendar{position:absolute;top:-3px;left:-10px}.dtp-input{max-width:calc(100% - 30px)}.dtp-input,md-input-container.md-icon-float:not(.md-input-has-value):not(.md-input-focused) label{margin-left:30px}body,html{font-family:HKNova-Regular}.app-container{min-width:800px}.app-container>ui-view{display:flex;align-items:center;justify-content:center;width:100%}.app-container>ui-view clients,.app-container>ui-view configurations,.app-container>ui-view media{width:100%;min-height:80vh;min-width:800px;height:fit-content;display:flex;align-items:center;justify-content:center}.app-container>ui-view clients>ui-view,.app-container>ui-view configuration-list,.app-container>ui-view configurations>ui-view{width:100%}.app-container>ui-view configuration-list md-card{min-width:800px;width:98%}.app-container>ui-view configuration-update{height:calc(100vh - 50px);display:flex;width:100%;align-items:flex-start;justify-content:center;min-width:98vw}.app-container>ui-view configuration-update>.layout-row{width:100%}.app-container>ui-view deployments{width:100%;min-height:80vh;min-width:800px;height:fit-content;display:flex;align-items:center;justify-content:center}.app-container>ui-view deployments>ui-view{width:100%}.app-container>ui-view deployment-list{min-width:800px}.app-container>ui-view client-list,.app-container>ui-view client-list md-card,.app-container>ui-view deployment-list md-card{min-width:800px;width:98%}.app-container>ui-view analytics,.app-container>ui-view booths,.app-container>ui-view users{width:100%;min-height:80vh;min-width:800px;height:fit-content;display:flex;align-items:center;justify-content:center}.app-container>ui-view analytics md-card,.app-container>ui-view booths md-card,.app-container>ui-view users md-card{width:98%}md-card{width:800px}.tt-multiline{height:auto;line-height:12px;padding:7px 12px}md-dialog .status{font-size:small}md-dialog input.upper-cased{text-transform:uppercase!important}md-dialog md-input-container.md-button-right .button-group{position:absolute;right:0;margin-top:-6px}md-dialog md-input-container.md-button-right .button-group button{min-width:0;margin:0;padding-bottom:6px}md-dialog md-input-container .hint{position:absolute;left:2px;right:auto;bottom:-2px;font-size:10px;line-height:12px;transition:all .3s cubic-bezier(.55,0,.55,.2)}md-dialog md-input-container .hint.info{color:grey}md-dialog md-input-container .hint.status{color:green}md-dialog md-input-container .hint.error{color:#ee2737}md-dialog.md-transition-in{max-width:700px}md-dialog.md-content-overflow .md-actions,md-dialog.md-content-overflow md-dialog-actions{border-top:none}md-toast.error .md-toast-content{background-color:#ee2737}md-toast.loading{top:45px}md-toast.loading .md-toast-content{background-color:#ee2737}md-toolbar{min-height:47px}md-toolbar navbar .md-toolbar-tools{background-color:#ee2737}md-toolbar md-input-container.md-input-focused:not(.md-input-invalid) input.md-input,md-toolbar md-input-container input.md-input{border-color:#fff;color:#fff}md-toolbar md-input-container.md-input-focused:not(.md-input-invalid) input.md-input::placeholder{color:#fff;border-width:0 0 1px}md-toolbar md-input-container.md-input-has-placeholder input::placeholder{color:#fff;opacity:1}md-toolbar.md-toolbar--with-border{min-height:48px}md-toolbar.md-table-toolbar .md-toolbar-tools md-icon,md-toolbar.md-table-toolbar:not(.md-menu-toolbar).md-default{color:#fff}md-table-container.no-items{padding-top:30px;padding-bottom:30px;text-align:center;line-height:1.8}md-table-container .md-table{transition:background-color .2s}md-table-container .md-table .md-row:hover{background-color:#dbdbdb;cursor:pointer}md-table-container .md-table .md-row:hover td.underline-on-hover{text-decoration:underline}md-table-container .md-table .md-row:hover td.show-button-on-hover{position:relative}md-table-container .md-table .md-row:hover td.show-button-on-hover button.md-button{display:inline-block;position:absolute;right:0;top:3px}md-table-container .md-table .md-row td.show-button-on-hover button.md-button{display:none}md-table-container .md-table .md-row td:last-child{padding-right:0}md-table-container .md-table .md-row td .no-md-select{color:rgba(0,0,0,.38);font-size:smaller}h2.page-title{font-weight:400;margin:45px 0 -5px;text-align:center;font-size:18px}.md-button{text-transform:capitalize;padding-left:16px;padding-right:16px}.clear-both{clear:both}md-input-container{margin:10px 0}.md-toolbar-search{position:relative}.md-toolbar-search md-input-container{position:absolute;right:10px;top:16px;margin:0;height:34px;max-width:450px;width:100%}.md-toolbar-search md-input-container input{padding-right:30px}.md-toolbar-search .md-button{position:absolute;right:12px;bottom:12px}md-option i{float:left;position:relative;top:-3px;margin:0 5px 0 0}.dialog-description-container{padding:40px 50px 0;height:560px;position:relative;margin-right:10px}.dialog-description-container h2{margin:0;font-size:24px}.dialog-description-container p{margin:20px 0;color:#717171;font-size:17px}.dialog-description-container .line{width:calc(100% + 40px);margin:0 0 0 -20px;border-top:1px solid hsla(0,0%,44%,.33)}.dialog-description-container md-switch{margin-top:50px;font-size:16px;display:flex;justify-content:space-between}.dialog-description-container .print-switch{margin-top:30px}.dialog-description-container .ss-bg-info{display:flex;color:#848484;font-size:15px;margin:15px 0 0}.dialog-description-container .ss-bg-info.ss-disabled{opacity:.7}.dialog-description-container .ss-bg-info.ss-disabled .icon{color:#848484}.dialog-description-container .ss-bg-info .icon{width:40px;color:#ee2737}.dialog-description-container .ss-tm-download{display:flex;color:#ee2737;font-size:15px;margin:10px 0 0}.dialog-description-container .ss-tm-download.ss-disabled{opacity:.7;color:#848484}.dialog-description-container .ss-tm-download.ss-disabled .info-text{text-decoration:none;cursor:default}.dialog-description-container .ss-tm-download .icon{width:30px;color:#ee2737}.dialog-description-container .ss-tm-download .info-text{text-decoration:underline;cursor:pointer}.dialog-description-container md-dialog-actions{position:absolute;bottom:15px;right:22px;font-size:20px}.dialog-description-container md-dialog-actions button{font-size:20px;text-transform:uppercase}.dialog-description-container upload span{font-size:15px}.digital-dialog{min-height:600px}.digital-dialog-cont{min-height:560px}.print-dialog{min-height:600px}.print-dialog-cont{min-height:560px}.strip-dialog{min-height:600px}.strip-dialog-cont{min-height:560px}.dialog-transparent{background:transparent}.dialog-transparent .preview{background-color:#fafafa}.dialog-transparent .preview html-preview{border:1px solid #d3d3d3}.dialog-transparent .switch-holder{background-color:#fff;margin-top:10px}.dialog-transparent .switch-holder md-switch{font-size:17px;display:flex;align-items:center;justify-content:space-between;margin:16px 20px 16px 30px}.dialog-transparent .switch-holder md-radio-group{display:flex;align-items:center;justify-content:flex-start;font-size:13px;height:60px;min-width:400px;padding:10px 30px}.dialog-transparent .switch-holder md-radio-group md-radio-button{position:relative;top:1px;margin:-3px 10px 0}.scene-dialog{margin-right:10px;min-height:705px;overflow:hidden}.scene-dialog h2{text-transform:uppercase}.scene-dialog h2 i{color:dimgray;position:relative;top:2px;cursor:pointer;outline:none}.scene-dialog form{max-height:58px}.scene-dialog form input{text-transform:uppercase!important}.scene-dialog form md-icon{font-size:30px;color:dimgray;position:relative;top:2px;cursor:pointer;outline:none}.scene-dialog form md-icon:hover{color:#00c853}.scene-dialog p{font-size:13px}.scene-dialog .line{width:100%;border-top:1px solid hsla(0,0%,44%,.33)}.scene-dialog .mirroring{display:flex;align-items:center;font-size:14px}.scene-dialog .mirroring md-switch{margin-left:10px}.scene-dialog .upload-main{display:flex;margin:0 20px}.scene-dialog .upload-main .upload-block{flex:1;min-height:350px;box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9;margin:0 5px;padding:10px;position:relative;max-width:48%}.scene-dialog .upload-main .upload-block .option-btn-group{z-index:40}.scene-dialog .upload-main .upload-block .bottom-scroll,.scene-dialog .upload-main .upload-block .top-scroll{position:absolute;height:30px;width:100%;z-index:35;display:flex;align-items:center;justify-content:center}.scene-dialog .upload-main .upload-block .bottom-scroll i,.scene-dialog .upload-main .upload-block .top-scroll i{color:dimgray;font-size:28px}.scene-dialog .upload-main .upload-block .top-scroll{top:142px}.scene-dialog .upload-main .upload-block .bottom-scroll{bottom:-15px}.scene-dialog .upload-main .upload-block .heading{display:flex;font-weight:bolder;align-items:center}.scene-dialog .upload-main .upload-block .heading i{margin:0 3px}.scene-dialog .upload-main .upload-block .ss-bg-info{display:flex;color:#848484;font-size:13px;margin:15px 0 0}.scene-dialog .upload-main .upload-block .ss-bg-info.ss-disabled{opacity:.7}.scene-dialog .upload-main .upload-block .ss-bg-info.ss-disabled .icon{color:#848484}.scene-dialog .upload-main .upload-block .ss-bg-info .icon{width:40px;color:#ee2737}.scene-dialog .upload-main .upload-block .files-options{display:flex;justify-content:space-between;color:#848484;align-items:center;font-size:13px;margin:10px;width:200px}.scene-dialog .upload-main .upload-block .files-options i{font-size:17px;cursor:pointer;outline:none;position:relative;top:2px}.scene-dialog .upload-main .upload-block .files-options i.active{color:#000}.scene-dialog .upload-main .upload-block .files-list{height:180px;overflow:scroll;font-size:13px}.scene-dialog .upload-main .upload-block .files-list .file{display:flex;width:fit-content;align-items:center;color:dimgray;margin:4px 7px;cursor:pointer;border-radius:20px;padding:1px 3px;line-break:anywhere}.scene-dialog .upload-main .upload-block .files-list .file:hover{background-color:rgba(0,0,0,.07)}.scene-dialog .upload-main .upload-block .files-list .file i{font-size:14px;margin:0 3px}.scene-dialog .upload-main .upload-block .files-list{scrollbar-width:none;-ms-overflow-style:none}.scene-dialog .upload-main .upload-block .files-list::-webkit-scrollbar{width:0;height:0}.scene-dialog .dndDraggingSource{display:none!important}.scene-dialog .dndPlaceholder{height:3px;background-color:#f0f0f0;list-style-type:none;width:75%;margin:5px 7px}.scene-dialog .animation-time{margin:0 30px;display:flex;align-items:center}.scene-dialog .animation-time .anim-time-counter{display:inline-block;width:24px;text-align:right}.scene-dialog .animation-time.hidden{visibility:hidden;opacity:0}.scene-dialog .animation-time p{margin:0 10px;font-size:15px}.scene-dialog .animation-time md-slider-container{width:250px}.scene-dialog.ai-scene-dialog{max-width:400px!important;min-height:500px;top:-60px}.scene-dialog.ai-scene-dialog .upload-main .upload-block{max-width:unset;min-height:310px}.scene-dialog-transparent{min-height:705px;overflow:hidden;box-shadow:none}.scene-dialog-transparent .switch-holder{border-bottom-left-radius:4px;border-bottom-right-radius:4px}.scene-dialog-transparent .switch-holder md-radio-button{margin-top:-3px}.scene-dialog-transparent .switch-holder .hide-dots md-radio-button{margin-left:-26px}.scene-dialog-transparent .switch-holder .hide-dots .md-ink-ripple{display:none}@media screen and (max-height:880px){.scene-dialog{min-height:665px}.scene-dialog .mirroring{margin-bottom:-20px}.scene-dialog .upload-main{margin:0 20px}.scene-dialog .upload-main .upload-block{min-height:280px}.scene-dialog .upload-main .upload-block .bottom-scroll,.scene-dialog .upload-main .upload-block .top-scroll{height:20px}.scene-dialog .upload-main .upload-block .top-scroll{top:157px}.scene-dialog .upload-main .upload-block .bottom-scroll{bottom:-15px}.scene-dialog .upload-main .upload-block .files-options{font-size:13px;margin:10px;width:200px}.scene-dialog .upload-main .upload-block .files-options i{top:2px}.scene-dialog .upload-main .upload-block .files-list{height:150px}.scene-dialog-transparent{min-height:665px}.scene-dialog-transparent .switch-holder{border-bottom-left-radius:4px;border-bottom-right-radius:4px}}@media screen and (max-width:1650px){.dialog-description-container{padding:40px 50px 0;height:560px;position:relative;margin-right:10px}.dialog-description-container h2{margin:0;font-size:21px}.dialog-description-container p{margin:20px 0;color:#717171;font-size:16px}.dialog-description-container .line{width:calc(100% + 40px);margin:0 0 0 -20px;border-top:1px solid hsla(0,0%,44%,.33)}.dialog-description-container md-switch{margin-top:50px;font-size:16px;display:flex;justify-content:space-between}.dialog-description-container .print-switch{margin-top:30px}.dialog-description-container .ss-bg-info{display:flex;color:#848484;font-size:15px;margin:20px 0 0}.dialog-description-container .ss-bg-info.ss-disabled{opacity:.7}.dialog-description-container .ss-bg-info.ss-disabled .icon{color:#848484}.dialog-description-container .ss-bg-info .icon{width:40px;color:#ee2737}.dialog-description-container .ss-tm-download{display:flex;color:#ee2737;font-size:15px;margin:10px 0 0;text-decoration:underline}.dialog-description-container .ss-tm-download.ss-disabled{opacity:.7;color:#848484}.dialog-description-container .ss-tm-download.ss-disabled .info-text{text-decoration:none;cursor:default}.dialog-description-container .ss-tm-download .icon{width:30px;color:#ee2737;text-decoration:underline}.dialog-description-container .ss-tm-download .info-text{text-decoration:underline;cursor:pointer}.dialog-description-container md-dialog-actions{position:absolute;bottom:15px;right:22px;font-size:20px}.dialog-description-container md-dialog-actions button{font-size:20px;text-transform:uppercase}.dialog-description-container upload span{font-size:14px}}md-radio-group .md-checked .md-ink-ripple,md-radio-group.md-default-theme .md-checked .md-ink-ripple{color:rgba(238,39,55,.26)}md-radio-button.md-default-theme .md-on,md-radio-button .md-on{background-color:#ee2737}md-radio-button.md-checked .md-off,md-radio-button.md-default-theme.md-checked .md-off{border-color:rgba(238,39,55,.87)}md-slider.md-default-theme .md-thumb:after,md-slider .md-thumb:after{border-color:#ee2737;background-color:#ee2737}md-slider.md-default-theme .md-sign:after,md-slider .md-sign:after{border-top-color:#ee2737}md-slider.md-default-theme .md-sign,md-slider.md-default-theme .md-track.md-track-fill,md-slider .md-sign,md-slider .md-track.md-track-fill{background-color:#ee2737}md-switch.md-checked .md-bar,md-switch.md-default-theme.md-checked .md-bar{background-color:rgba(238,39,55,.5)}md-switch.md-checked .md-thumb,md-switch.md-default-theme.md-checked .md-thumb,md-toolbar.md-table-toolbar:not(.md-menu-toolbar).md-default{background-color:#ee2737}.md-button.md-default-theme.md-primary.md-fab,.md-button.md-default-theme.md-primary.md-raised,.md-button.md-primary.md-fab,.md-button.md-primary.md-raised{background-color:#ee2737;border-radius:6px;color:#fff}md-menu-item a{text-decoration:none;color:inherit}.icon-wrapper{width:24px;height:24px;display:flex;align-items:center;justify-content:center;margin-left:5px}.icon-wrapper.header-nav-icon{margin-left:0;margin-right:5px}.custom-toast{display:flex;width:367px;top:60px!important}.custom-toast .md-toast-content{padding:20px 15px;flex-direction:column;justify-content:center;align-items:flex-end;gap:10px}.custom-toast .md-toast-content:before{display:none}.custom-toast h4{font-weight:700;margin-top:0;margin-bottom:0}.custom-toast .custom-toast-content,.custom-toast h4{color:#fff;text-align:right;font-size:14px;font-style:normal;line-height:100%}.custom-toast .custom-toast-content{font-weight:400}.margin-bottom-30{margin-bottom:30px}.promting-scene .upload-block{font-size:13px}.promting-scene .md-button.btn-file{margin-left:0}color-picker.color-picker-label .color-picker-input-wrapper,color-picker.color-picker-label .color-picker-wrapper{width:100%;height:100%}color-picker.color-picker-label .color-picker-wrapper .color-picker-input{display:none}color-picker.color-picker-label .color-picker-wrapper .color-picker-swatch:not(.input-group-addon){top:0;left:0;width:100%;height:100%;border-radius:inherit;cursor:pointer}.color-picker-wrapper .color-picker-panel .color-picker-actions .color-eyedropper{display:flex;align-items:center;justify-content:center;gap:4px;width:100%;margin:0;padding:4px 0;border:none;border-top:1px solid #e9e9e9;background:#fff;color:#25282a;cursor:pointer}.color-picker-wrapper .color-picker-panel .color-picker-actions .color-eyedropper:hover{background:#f2f2f2}.color-picker-wrapper .color-picker-panel .color-picker-actions .color-eyedropper .material-icons{font-size:18px}", ""]);
	
	// exports


/***/ }),
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Regular.eot";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Regular.woff2";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Regular.woff";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Regular.ttf";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Regular.svg";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-ExtraLight.eot";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-ExtraLight.woff2";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-ExtraLight.woff";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-ExtraLight.ttf";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-ExtraLight.svg";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-ExtraBold.eot";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-ExtraBold.woff2";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-ExtraBold.woff";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-ExtraBold.ttf";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-ExtraBold.svg";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Heavy.eot";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Heavy.woff2";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Heavy.woff";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Heavy.ttf";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Heavy.svg";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-SemiBold.eot";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-SemiBold.woff2";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-SemiBold.woff";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-SemiBold.ttf";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-SemiBold.svg";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Medium.eot";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Medium.woff2";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Medium.woff";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Medium.ttf";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Medium.svg";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Light.eot";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Light.woff2";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Light.woff";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Light.ttf";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Light.svg";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Bold.eot";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Bold.woff2";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Bold.woff";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Bold.ttf";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Bold.svg";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Thin.eot";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Thin.woff2";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Thin.woff";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Thin.ttf";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/HKNova-Thin.svg";

/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/favicon-32.png";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/favicon-180.png";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/favicon-270.png";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/favicon-512.png";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/up_logo.svg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ConfigsModule = undefined;
	
	var _httpProvider = __webpack_require__(159);
	
	var _locationProvider = __webpack_require__(160);
	
	var _stateProvider = __webpack_require__(161);
	
	var _upreachPaletteProvider = __webpack_require__(162);
	
	var _resourceProvider = __webpack_require__(163);
	
	var _resourceProvider2 = _interopRequireDefault(_resourceProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import {modalProvider}          from "./modalProvider.config";
	
	var api = {
		"Login": "/api/rest-auth/login/",
		"Logout": "/api/rest-auth/logout/",
		"Configurations": "/api/configurations/",
		"Deployments": "/api/deployments/",
		"TwoFactor": "/api/rest-auth/enable-2fa/"
	};
	
	var ConfigsModule = exports.ConfigsModule = angular.module("app.configs", []).constant({
		"CONFIG": {
			"API": api,
			"ContentType": "application/json"
		}
	}).config(_httpProvider.httpProvider).config(_locationProvider.locationProviderConfig).config(_stateProvider.stateProviderConfig).config(_upreachPaletteProvider.upreachPaletteProvider).config(_resourceProvider2.default);
	//.config(modalProvider);

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	"use strict";
	
	httpProvider.$inject = ["$httpProvider"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.httpProvider = httpProvider;
	/* eslint-disable */
	
	/**
	 *
	 * @param $httpProvider
	 */
	function httpProvider($httpProvider) {
	
		"ngInject";
	
		var unauthorizedInterceptor = function unauthorizedInterceptor($q, $injector) {
			return {
				responseError: function responseError(response) {
					if (response.status === 401 && !response.config.ignore401) {
						return $injector.get("$auth").logout();
					}
					return $q.reject(response);
				}
			};
		};
		unauthorizedInterceptor.$inject = ["$q", "$injector"];
	
		var forbiddenInterceptor = function forbiddenInterceptor($q, $injector) {
			"ngInject";
	
			return {
				responseError: function responseError(response) {
					if (response.status === 403) {
						if (!response.config.url.includes('remove-bg') && !response.config.url.includes('replicate-remove-bg')) {
							$injector.get("$state").go("forbidden");
						}
					}
					return $q.reject(response);
				}
			};
		};
		forbiddenInterceptor.$inject = ["$q", "$injector"];
	
		var notfoundInterceptor = function notfoundInterceptor($q, $injector) {
			return {
				responseError: function responseError(response) {
					if (response.status === 404) {
						$injector.get("$state").go("orders");
					}
					return $q.reject(response);
				}
			};
		};
	
		$httpProvider.interceptors.push(unauthorizedInterceptor, forbiddenInterceptor);
	
		if (window.GaeMiniProfiler) {
			var gaeMiniProfilerInterceptor = function gaeMiniProfilerInterceptor($q, $injector) {
				return {
					response: function response(_response) {
						// var xhr = response;
						var requestId = _response.headers("X-MiniProfiler-Id");
						if (requestId) {
							var queryString = _response.headers("X-MiniProfiler-QS");
							GaeMiniProfiler.fetch(requestId, queryString);
						}
						return _response;
					}
				};
			};
			gaeMiniProfilerInterceptor.$inject = ["$q", "$injector"];
			$httpProvider.interceptors.push(gaeMiniProfilerInterceptor);
		}
	}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	"use strict";
	
	locationProviderConfig.$inject = ["$locationProvider"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.locationProviderConfig = locationProviderConfig;
	function locationProviderConfig($locationProvider) {
		"ngInject";
	
		$locationProvider.html5Mode(true);
	}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	"use strict";
	
	stateProviderConfig.$inject = ["$urlRouterProvider"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.stateProviderConfig = stateProviderConfig;
	function stateProviderConfig($urlRouterProvider) {
	
		"ngInject";
	
		$urlRouterProvider.when("/", "/app/deployments/");
	}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	"use strict";
	
	upreachPaletteProvider.$inject = ["$mdThemingProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.upreachPaletteProvider = upreachPaletteProvider;
	function upreachPaletteProvider($mdThemingProvider) {
	
	    "ngInject";
	
	    $mdThemingProvider.definePalette("upreachPalette", {
	        "50": "ffe6ea",
	        "100": "ffc1cb",
	        "200": "ff98a8",
	        "300": "ff6f85",
	        "400": "ff506a",
	        "500": "ff3150",
	        "600": "ff2c49",
	        "700": "ff2540",
	        "800": "ff1f37",
	        "900": "ff1327",
	        "A100": "ffffff",
	        "A200": "fffafa",
	        "A400": "ffc7cb",
	        "A700": "ffadb3",
	        "contrastDefaultColor": "light",
	        "contrastDarkColors": ["50", "100", "200", "300", "400", "A100", "A200", "A400", "A700"],
	        "contrastLightColors": ["500", "600", "700", "800", "900"]
	    });
	
	    $mdThemingProvider.theme("default").primaryPalette("upreachPalette");
	}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	resourceProviderConfig.$inject = ["$resourceProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = resourceProviderConfig;
	
	var _lodash = __webpack_require__(101);
	
	function resourceProviderConfig($resourceProvider) {
	
	    "ngInject";
	
	    $resourceProvider.defaults = {
	        stripTrailingSlashes: false,
	        actions: {
	            query: {
	                method: 'GET',
	                isArray: true,
	                transformResponse: function transformResponse(data, headersGetter, status) {
	                    if (data) {
	                        data = JSON.parse(data);
	                        if (data && data.results) {
	                            var _result = data.results;
	                            _result._meta = (0, _lodash.pick)(data, ["count", "next", "previous", "page", "page_count"]);
	                            _result._meta.status = status;
	                            return _result;
	                        } else if (data && data.length) {
	                            return data;
	                        }
	                    }
	                    var result = [];
	                    result._meta = { count: 0, next: null, previous: null, status: status, page: 1, page_count: 1 };
	                    return result;
	                }
	            },
	            get: {
	                method: 'GET',
	                isArray: false,
	                transformResponse: function transformResponse(data) {
	                    return JSON.parse(data);
	                }
	            },
	            create: {
	                method: 'POST',
	                transformResponse: function transformResponse(data) {
	                    return JSON.parse(data);
	                }
	            },
	            update: {
	                method: 'PUT',
	                transformResponse: function transformResponse(data) {
	                    return JSON.parse(data);
	                }
	            },
	            delete: {
	                method: 'DELETE',
	                transformResponse: function transformResponse(data) {
	                    return null;
	                }
	            }
	        }
	    };
	} /* eslint-disable */

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.BootstrapModule = undefined;
	
	var _http = __webpack_require__(165);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _notification = __webpack_require__(166);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _moment = __webpack_require__(167);
	
	var _accountCheck = __webpack_require__(169);
	
	var _updateCompany = __webpack_require__(170);
	
	var _updateUser = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BootstrapModule = exports.BootstrapModule = angular.module("app.bootstrap", []).run(_http2.default).run(_notification2.default).run(_moment.momentRun).run(_accountCheck.accountCheckRun).run(_updateCompany.updateCompanyRun).run(_updateUser.updateUserRun).run(["gettextCatalog", function (gettextCatalog) {
		gettextCatalog.setCurrentLanguage("en");
	}]);

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	"use strict";
	
	HttpConfiguratorRun.$inject = ["$httpConfigurator"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = HttpConfiguratorRun;
	function HttpConfiguratorRun($httpConfigurator) {
		"ngInject";
	
		$httpConfigurator.setDefaultsHeaders();
	}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	"use strict";
	
	notificationRun.$inject = ["ngNotify"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = notificationRun;
	function notificationRun(ngNotify) {
	
		"ngInject";
	
		ngNotify.addTheme("skatCzytnikiNotification", "skat-czytniki-notification");
		ngNotify.config({
			theme: "skatCzytnikiNotification",
			duration: 3000,
			type: "info",
			sticky: false,
			html: false
		});
	}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	momentRun.$inject = ["$rootScope", "$auth"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.momentRun = momentRun;
	
	var _languages = __webpack_require__(168);
	
	var defaultFormat = "YYYY-MM-DD[T]HH:mm:ss.SSS";
	
	function momentRun($rootScope, $auth) {
		"ngInject";
	
		var momentConfiguration = $rootScope.$on("$stateChangeStart", function () {
			if ($auth.isAuthenticated() && momentConfiguration) {
				window.moment.tz.setDefault($auth.getUser().timezone);
				window.moment.locale((0, _languages.lang)());
				momentConfiguration = null;
			}
		});
		window.moment.defaultFormat = defaultFormat;
		window.moment.defaultFormatUtc = defaultFormat;
		window.moment.fn.toJSON = function () {
			return this.format(defaultFormat);
		};
	}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.lang = lang;
	
	var _lodash = __webpack_require__(101);
	
	function lang() {
		var languages = navigator.languages,
		    isElectron = navigator.appVersion.indexOf("Electron") > -1;
	
		return !isElectron && (languages && !(0, _lodash.isEmpty)(languages) && languages[0].split("-")[0] || navigator.language.split("-")[0] || "pl") || "pl";
	}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	accountCheckRun.$inject = ["$auth", "$rootScope", "$state", "$location"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.accountCheckRun = accountCheckRun;
	
	var _lodash = __webpack_require__(101);
	
	function accountCheckRun($auth, $rootScope, $state, $location) {
	
		"ngInject";
	
		var is = function is(event, toState) {
			if (!(0, _lodash.includes)(["auth.signin", "auth.signup", "auth.password", "auth.acceptInvite", "auth.resetPassword", "auth.twoFactor", "auth.twoFactorSuccess"], toState.name) && !$auth.isAuthenticated()) {
				sessionStorage.clear();
				localStorage.clear();
				$state.go("auth.signin");
				return event.preventDefault();
			}
		};
	
		$rootScope.$on("$stateChangeStart", function (event, toState) {
			return is(event, toState);
		});
	
		if (!$auth.isAuthenticated() && $location.absUrl().indexOf("password") === -1 && $location.absUrl().indexOf("email") === -1 && $location.absUrl().indexOf("accept-invite") === -1 && $location.absUrl().indexOf("password-set") === -1) {
			$state.go("auth.signin");
			return false;
		}
	}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	"use strict";
	
	updateCompanyRun.$inject = ["$auth", "$companies"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.updateCompanyRun = updateCompanyRun;
	function updateCompanyRun($auth, $companies) {
		"ngInject";
	
		if ($auth.isAuthenticated()) {
			$companies.fetch();
		}
	}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	"use strict";
	
	updateUserRun.$inject = ["$auth"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.updateUserRun = updateUserRun;
	function updateUserRun($auth) {
		"ngInject";
	
		if ($auth.isAuthenticated()) {
			$auth.me();
		}
	}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ComponentsModule = undefined;
	
	var _router = __webpack_require__(173);
	
	var _getModulesNames = __webpack_require__(1);
	
	var _getModulesNames2 = _interopRequireDefault(_getModulesNames);
	
	var _auth = __webpack_require__(174);
	
	var _layout = __webpack_require__(215);
	
	var _configurationsModule = __webpack_require__(231);
	
	var _configurationsModule2 = _interopRequireDefault(_configurationsModule);
	
	var _deploymentsModule = __webpack_require__(341);
	
	var _deploymentsModule2 = _interopRequireDefault(_deploymentsModule);
	
	var _clientsModule = __webpack_require__(502);
	
	var _clientsModule2 = _interopRequireDefault(_clientsModule);
	
	var _boothsModule = __webpack_require__(522);
	
	var _boothsModule2 = _interopRequireDefault(_boothsModule);
	
	var _usersModule = __webpack_require__(535);
	
	var _usersModule2 = _interopRequireDefault(_usersModule);
	
	var _address = __webpack_require__(544);
	
	var _selectSearch = __webpack_require__(547);
	
	var _apiSelectSearch = __webpack_require__(552);
	
	var _htmlPreview = __webpack_require__(557);
	
	var _scenePreview = __webpack_require__(715);
	
	var _startScreenArea = __webpack_require__(720);
	
	var _photoInput = __webpack_require__(725);
	
	var _phoneMsg = __webpack_require__(730);
	
	var _emailPreview = __webpack_require__(735);
	
	var _loader = __webpack_require__(740);
	
	var _analytics = __webpack_require__(744);
	
	var _media = __webpack_require__(770);
	
	var _formPreviewComponent = __webpack_require__(781);
	
	var _charts = __webpack_require__(787);
	
	var _charts2 = _interopRequireDefault(_charts);
	
	var _liveViewPreview = __webpack_require__(798);
	
	var _htmlCustomBtnPreview = __webpack_require__(804);
	
	var _individualTextOutputPreview = __webpack_require__(821);
	
	var _individualTextScreenPreview = __webpack_require__(827);
	
	var _aiHtmlPreview = __webpack_require__(832);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComponentsModule = exports.ComponentsModule = angular.module("app.components", (0, _getModulesNames2.default)([_auth.AuthModule, _layout.LayoutModule, _configurationsModule2.default, _deploymentsModule2.default, _analytics.AnalyticsModule, _clientsModule2.default, _boothsModule2.default, _usersModule2.default, _charts2.default, _media.MediaModule])).config(_router.Router).component("addressForm", _address.addressComponent).component("selectSearch", _selectSearch.selectSearchComponent).component("apiSelectSearch", _apiSelectSearch.apiSelectSearchComponent).component("htmlPreview", _htmlPreview.htmlPreviewComponent).component("scenePreview", _scenePreview.scenePreviewComponent).component("liveViewPreview", _liveViewPreview.liveViewPreviewComponent).component("formsPreview", _formPreviewComponent.formPreviewComponent).component("loader", _loader.loaderComponent).component("startScreenArea", _startScreenArea.startScreenAreaComponent).component("photoInput", _photoInput.photoInputComponent).component("phoneMsg", _phoneMsg.phoneMsgComponent).component("emailPreview", _emailPreview.emailPreviewComponent).component("htmlCustomBtnPreview", _htmlCustomBtnPreview.htmlCustomBtnPreviewComponent).component("individualTextOutputPreview", _individualTextOutputPreview.individualTextOutputPreviewComponent).component("individualTextScreenPreview", _individualTextScreenPreview.individualTextScreenPreviewComponent).component("aiHtmlPreview", _aiHtmlPreview.aiHtmlPreviewComponent);

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	"use strict";
	
	Router.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Router = Router;
	/**
	 *
	 * @param $stateProvider
	 */
	function Router($stateProvider) {
		"ngInject";
	
		$stateProvider.state({
			name: "requests",
			url: "/app/requests",
			template: "<requests-fetch-all-component></requests-fetch-all-component>"
		}).state({
			name: "portalAddCompanyRequests",
			url: "/app/portalAddCompanyRequests",
			template: "<portal-add-company-requests-component></portal-add-company-requests-component>"
		}).state({
			name: "portalAddUserRequests",
			url: "/app/portalAddUserRequests",
			template: "<portal-add-user-requests-component></portal-add-user-requests-component>"
		}).state({
			name: "forbidden",
			url: "/app/no-access",
			template: "<no-access></no-access>"
		});
	}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AuthModule = undefined;
	
	var _auth = __webpack_require__(175);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _signin = __webpack_require__(180);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _acceptInvite = __webpack_require__(192);
	
	var _acceptInvite2 = _interopRequireDefault(_acceptInvite);
	
	var _resetPassword = __webpack_require__(195);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _auth3 = __webpack_require__(198);
	
	var _password = __webpack_require__(199);
	
	var _password2 = _interopRequireDefault(_password);
	
	var _twoFactor = __webpack_require__(204);
	
	var _twoFactor2 = _interopRequireDefault(_twoFactor);
	
	var _twoFactorSuccess = __webpack_require__(209);
	
	var _twoFactorSuccess2 = _interopRequireDefault(_twoFactorSuccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthModule = exports.AuthModule = angular.module("auth", [_password2.default.name]).config(_auth3.AuthRouter).component("auth", _auth2.default).component("signin", _signin2.default).component("acceptInvite", _acceptInvite2.default).component("resetPassword", _resetPassword2.default).component("twoFactor", _twoFactor2.default).component("twoFactorSuccess", _twoFactorSuccess2.default);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _auth = __webpack_require__(176);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _auth3 = __webpack_require__(177);
	
	var _auth4 = _interopRequireDefault(_auth3);
	
	__webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthComponent = {
		template: _auth2.default,
		controller: _auth4.default,
		controllerAs: "auth"
	};
	
	exports.default = AuthComponent;

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	module.exports = "<section\n\t\tlayout=\"row\"\n\t\tlayout-align=\"center center\"\n\t\tlayout-fill>\n\t<div class=\"login-container\">\n\t\t<ui-view></ui-view>\n\t</div>\n</section>\n\n\n";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthController = function AuthController($auth) {
		"ngInject";
	
		(0, _classCallCheck3.default)(this, AuthController);
		this.$auth = $auth;
	};
	AuthController.$inject = ["$auth"];
	
	exports.default = AuthController;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(179);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./auth.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./auth.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "auth .login-container{max-width:440px;min-width:340px}", ""]);
	
	// exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _signin = __webpack_require__(181);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _signin3 = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var controllerAs = "signin";
	
	var SigninComponent = {
		template: _signin2.default,
		controller: _signin3.SigninController,
		controllerAs: controllerAs,
		require: {
			app: "^^app"
		}
	};
	
	exports.default = SigninComponent;

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\" layout-align=\"center center\" flex>\n\t<h2 ng-bind=\"'Log In' | translate\"></h2>\n</div>\n\n<form\n\tclass=\"form-signin\"\n\tng-class=\"{'request-loader': formSignin.$submitted==true}\"\n\tname=\"formSignin\"\n\tng-submit=\"signin.$onSubmit(formSignin)\"\n\tnovalidate>\n\n\n\t<md-input-container class=\"md-block\">\n\t\t<label\n\t\t\t\tng-bind=\"'Email Address' | translate\"\n\t\t\t\tfor=\"inputEmail\"></label>\n\n\t\t<input\n\t\t\tng-model=\"signin.user.email\"\n\t\t\ttype=\"email\"\n\t\t\tname=\"email\"\n\t\t\tid=\"inputEmail\"\n\t\t\tmaxlength=\"100\"\n\t\t\tng-pattern=\"/^.+@.+\\..+$/\"\n\t\t\trequired>\n\n\t\t<div ng-messages=\"formSignin.email.$error\" role=\"alert\">\n\t\t\t<div ng-message-exp=\"['required', 'maxlength', 'pattern']\"\n\t\t\t\t\t ng-bind=\"'Your email must be between 10 and 100 characters long and look like an e-mail address.' | translate\">\n\t\t\t</div>\n\t\t</div>\n\t</md-input-container>\n\n\t<md-input-container class=\"md-block\">\n\t\t<label\n\t\t\t\tng-bind=\"'Password' | translate\"\n\t\t\t\tfor=\"inputPassword\"></label>\n\n\t\t<input\n\t\t\tng-model=\"signin.user.password\"\n\t\t\ttype=\"password\"\n\t\t\tname=\"password\"\n\t\t\tid=\"inputPassword\"\n\t\t\trequired>\n\n\t\t<div ng-messages=\"formSignin.password.$error\" role=\"alert\">\n\t\t\t<div ng-message=\"required\"\n\t\t\t\t\t ng-bind=\"'This is required!' | translate\">\n\t\t\t</div>\n\t\t</div>\n\t</md-input-container>\n\n\n\t<div class=\"form-group text-right\">\n\t\t<small>\n\t\t\t<a ui-sref=\"auth.password\"\n\t\t\t\t class=\"rules\">\n\t\t\t\t{{'Forgot your password?' | translate}}\n\t\t\t</a>\n\t\t</small>\n\t</div>\n\n\t<div layout=\"row\" layout-align=\"center center\" flex>\n\t\t<md-button ng-disabled=\"formSignin.$invalid\" type=\"submit\" class=\"md-raised md-primary\" ng-bind=\"'Sign in' | translate\"></md-button>\n\t</div>\n</form>\n";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SigninController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$companies"];
	
	var SigninController = exports.SigninController = function (_$controller) {
		SigninController.$inject = ["$injector"];
		(0, _inherits3.default)(SigninController, _$controller);
	
		function SigninController($injector) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, SigninController);
			return (0, _possibleConstructorReturn3.default)(this, (SigninController.__proto__ || (0, _getPrototypeOf2.default)(SigninController)).call(this, $injector, dependencies));
		}
	
		(0, _createClass3.default)(SigninController, [{
			key: "$redirect",
			value: function $redirect() {
				if (this.$auth.isAuthenticated()) {
					return this.$state.go("deployments");
				}
			}
		}, {
			key: "$onSubmit",
			value: function $onSubmit(formSignin) {
				var _this2 = this;
	
				return this.$auth.authenticate(this.user).then(function (data) {
					if (data && data.requires_2fa) {
						sessionStorage.setItem("2fa_email", _this2.user.email);
						sessionStorage.setItem("2fa_password", _this2.user.password);
						_this2.$state.go("auth.twoFactor");
						return;
					}
					return _this2.$companies.fetch().then(function () {
						return _this2.$redirect();
					});
				}).finally(function () {
					return formSignin.$submitted = false;
				});
			}
		}, {
			key: "$onInit",
			value: function $onInit() {
				this.$redirect();
			}
		}]);
		return SigninController;
	}(_index.$controller);

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.bindings = exports.$service = exports.$controller = undefined;
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	var _service = __webpack_require__(184);
	
	var _service2 = _interopRequireDefault(_service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $controller = exports.$controller = _controller2.default;
	var $service = exports.$service = _service2.default;
	var bindings = exports.bindings = {
		resolve: "<",
		close: "&",
		dismiss: "&"
	};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(185);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _lodash = __webpack_require__(101);
	
	var _cache = __webpack_require__(188);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _collectionRepository = __webpack_require__(103);
	
	var _collectionRepository2 = _interopRequireDefault(_collectionRepository);
	
	var _reference = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActiveService = function (_ActiveCache) {
		ActiveService.$inject = ["$injector"];
		(0, _inherits3.default)(ActiveService, _ActiveCache);
	
		/**
	  *
	  * @param $injector
	  */
		function ActiveService($injector) {
	
			"ngInject";
	
			(0, _classCallCheck3.default)(this, ActiveService);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (ActiveService.__proto__ || (0, _getPrototypeOf2.default)(ActiveService)).call(this));
	
			_this.reference = _reference.reference;
	
			_this.$injector = $injector;
	
			_this.$q = $injector.get("$q");
			_this.$http = $injector.get("$http");
			_this.notify = $injector.get("ngNotify");
			_this.config = $injector.get("CONFIG");
			_this.$filter = $injector.get("$filter");
			_this.$log = $injector.get("$log");
			_this.uri = null;
			_this.block = false;
	
			_this.translate = function (key) {
				return _this.$filter("translate")(key);
			};
	
			_this.$get = _this.activeGet;
	
			return _this;
		}
	
		(0, _createClass3.default)(ActiveService, [{
			key: "normalizeChildrensToUris",
			value: function normalizeChildrensToUris(data) {
				var dataQuery = angular.copy(data);
	
				(0, _keys2.default)(dataQuery).map(function (key) {
					var dQk = dataQuery[key];
					if (!dQk) {
						return;
					}
					if ((typeof dQk === "undefined" ? "undefined" : (0, _typeof3.default)(dQk)) === "object" && dQk.hasOwnProperty("uri")) {
						dataQuery[key] = dQk.uri;
					}
				});
	
				return dataQuery;
			}
	
			/**
	   *
	   * @param url
	   * @param query
	   * @returns {Function}
	   */
	
		}, {
			key: "get",
			value: function get() {
				var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				var deferred = this.$q.defer();
				var config = void 0;
				if (query) {
					config = {
						paramSerializer: "$httpParamSerializerJQLike",
						params: query,
						cache: false
					};
				}
				this.$http.get(url, config).then(function (response) {
					deferred.resolve(response.data);
				}).catch(function (errors) {
					return deferred.reject(errors);
				});
				return deferred.promise;
			}
	
			/**
	   *
	   * @param url
	   * @param data
	   * @param config
	   * @returns {Function}
	   */
	
		}, {
			key: "post",
			value: function post() {
				var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
				var _this2 = this;
	
				var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
				if (false === this.block) {
	
					var deferred = this.$q.defer();
					this.$http.post(url, this.normalizeChildrensToUris(data), config).then(function (response) {
						_this2.block = false;
						deferred.resolve(response.data);
					}).catch(function (errors) {
						return deferred.reject(errors);
					});
					return deferred.promise;
				}
			}
	
			/**
	   *
	   * @param url
	   * @param data
	   * @returns {Function}
	   */
	
		}, {
			key: "put",
			value: function put() {
				var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				var deferred = this.$q.defer();
				this.$http.put(url, this.normalizeChildrensToUris(data)).then(function (response) {
					return deferred.resolve(response.data);
				}).catch(function (errors) {
					return deferred.reject(errors);
				});
				return deferred.promise;
			}
	
			/**
	   *
	   * @param url
	   * @returns {*|Function|jQuery.promise|promise.promise|b.promise|d.promise}
	   */
	
		}, {
			key: "delete",
			value: function _delete(url) {
				var deferred = this.$q.defer();
				this.$http.delete(url).then(function (response) {
					return deferred.resolve(response.data);
				}).catch(function (errors) {
					return deferred.reject(errors);
				});
				return deferred.promise;
			}
	
			/**
	   *
	   * @param uri
	   * @param search
	   * @returns {Function}
	   */
	
		}, {
			key: "list",
			value: function list(uri, search) {
				return this.activeGet(uri, search);
			}
	
			/**
	   *
	   * @param uri
	   * @param data
	   * @returns {Function}
	   */
	
		}, {
			key: "create",
			value: function create(uri, data) {
				return this.activePost(uri, data);
			}
	
			/**
	   *
	   * @param id
	   * @param data
	   * @returns {Function}
	   */
	
		}, {
			key: "update",
			value: function update(uri, data) {
				return this.activePut(uri, data);
			}
	
			/**
	   *
	   * @param uri
	   * @returns {*|Function|jQuery.promise|promise.promise|b.promise|d.promise}
	   */
	
		}, {
			key: "destroy",
			value: function destroy(uri) {
				return this.activeDelete(uri);
			}
	
			/**
	   *
	   * @param requestConfiguration
	   * @returns {Function}
	   */
	
		}, {
			key: "fetchAll",
			value: function fetchAll(requestConfiguration) {
				var _this3 = this;
	
				return !requestConfiguration ? this.activeGet(this.uri).then(function (objects) {
					_collectionRepository2.default.collection[_this3.uri] && delete _collectionRepository2.default.collection[_this3.uri];
					_collectionRepository2.default.collection[_this3.uri] = _this3.reference.create(_collectionRepository2.default.collection[_this3.uri], objects);
				}) : this.$search(this.uri, requestConfiguration, this.uri);
			}
	
			/**
	   *
	   * @param key
	   * @returns {Function}
	   */
	
		}, {
			key: "init",
			value: function init(key) {
				var deferred = this.$q.defer();
				if ((0, _lodash.isEmpty)(this[key])) {
					return this.fetchAll();
				} else {
					deferred.resolve(this[key]);
				}
				return deferred.promise;
			}
		}, {
			key: "$search",
			value: function $search(baseUri, requestConfiguration, referenceName) {
				var _this4 = this;
	
				!referenceName && (referenceName = baseUri);
	
				var additional = "?query={}",
				    uri = void 0,
				    isBoolean = function isBoolean(value) {
					return typeof value === "boolean" ? value : "\"" + value + "\"";
				};
	
				var getFilters = function getFilters() {
					var filter = "";
					(0, _lodash.forOwn)(requestConfiguration.filter, function (value, key) {
						if (value !== null) {
							filter += "\"" + key + "\": " + isBoolean(value) + ",";
						}
					});
					return filter.slice(0, -1);
				};
	
				try {
	
					if (requestConfiguration.search) {
						additional = "?query={\"_global\": \"" + requestConfiguration.search + "\"}";
					}
	
					if (requestConfiguration.filter) {
						additional = "?query={" + getFilters() + "}";
					}
	
					if (requestConfiguration.search && requestConfiguration.filter) {
						additional = "?query={" + ("\"_global\": \"" + requestConfiguration.search + "\",") + getFilters() + "}";
					}
	
					if (requestConfiguration.order) {
						additional = additional + "&order=" + requestConfiguration.order;
					}
	
					if (requestConfiguration.limit) {
						additional = additional + "&limit=" + requestConfiguration.limit;
					}
	
					if (requestConfiguration.cursor) {
						additional = additional + "&with_cursor=1";
					}
	
					uri = requestConfiguration.search ? baseUri + additional : requestConfiguration.next_uri ? requestConfiguration.next_uri : baseUri + additional;
				} catch (e) {
					uri = baseUri;
				}
	
				return this.activeGet(uri).then(function (response) {
					try {
						if (requestConfiguration.order || requestConfiguration.search) {
							_collectionRepository2.default.collection[referenceName] = [];
							requestConfiguration.order = null;
						}
						if (response.objects && !response.objects.length) {
							_collectionRepository2.default.collection[referenceName] = [];
						} else {
							_collectionRepository2.default.collection[referenceName] = _this4.reference.create(_collectionRepository2.default.collection[referenceName], response.objects ? response.objects : response, _this4.channelCallbacks || null);
						}
						return response;
					} catch (e) {
						_this4.$log.error(e);
					}
				});
			}
		}, {
			key: "getObjects",
			value: function getObjects(uri) {
				return _collectionRepository2.default.collection[uri || this.uri];
			}
		}, {
			key: "$push",
			value: function $push(data, uri) {
				var _this5 = this;
	
				!_collectionRepository2.default.collection[uri || this.uri] && (_collectionRepository2.default.collection[uri || this.uri] = []);
				var updateCollectionRepository = function updateCollectionRepository(entity) {
					return _collectionRepository2.default.collection[uri || _this5.uri].push(entity);
				};
				if ((0, _lodash.isArray)(data)) {
					data.map(function (entity) {
						return updateCollectionRepository(entity);
					});
					return;
				}
				updateCollectionRepository(data);
			}
		}]);
		return ActiveService;
	}(_cache2.default);
	
	exports.default = ActiveService;

/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(189);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActiveCache = function () {
		function ActiveCache() {
			(0, _classCallCheck3.default)(this, ActiveCache);
	
			this.$storage = localStorage;
		}
	
		/**
	  *
	  * @param key
	  * @param value
	  */
	
	
		(0, _createClass3.default)(ActiveCache, [{
			key: "cacheSet",
			value: function cacheSet(key, value) {
				this.$storage.setItem(key, (0, _stringify2.default)(value));
			}
	
			/**
	   *
	   * @param key
	   */
	
		}, {
			key: "cacheGet",
			value: function cacheGet(key) {
				return JSON.parse(this.$storage.getItem(key));
			}
	
			/**
	   *
	   * @param key
	   * @param subKey
	   * @param value
	   */
	
		}, {
			key: "cacheUpdate",
			value: function cacheUpdate(key, subKey, value) {
				var data = this.cacheGet(key);
				data[subKey] = value;
				this.cacheSet(key, data);
			}
	
			/**
	   *
	   * @param key
	   */
	
		}, {
			key: "cacheRemove",
			value: function cacheRemove(key) {
				this.$storage.removeItem(key);
			}
		}, {
			key: "cacheClear",
			value: function cacheClear() {
				this.$storage.clear();
			}
		}]);
		return ActiveCache;
	}();
	
	exports.default = ActiveCache;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(190), __esModule: true };

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(14);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.reference = undefined;
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(185);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.create = create;
	exports.update = update;
	exports.destroy = destroy;
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param referencedArray
	 * @param data
	 * @param channelCallbacks
	 * @returns {Array}
	 */
	function create() {
		var referencedArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		var channelCallbacks = arguments[2];
	
		data.map(function (_object) {
	
			var index = (0, _lodash.findIndex)(referencedArray, { uri: _object.uri });
	
			if (channelCallbacks && channelCallbacks.update && _object) {
				_object.update = channelCallbacks.update;
				_object.update({});
			}
	
			if (index === -1) {
				referencedArray.push(_object);
			} else {
				referencedArray[index] = _object;
			}
		});
		return referencedArray;
	}
	
	/**
	 *
	 * @param reference
	 * @param data
	 */
	function update() {
		var reference = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
		try {
			(0, _keys2.default)(reference).map(function (key) {
	
				if ((0, _typeof3.default)(reference[key]) != (0, _typeof3.default)(data[key])) {
					return;
				}
	
				if ((0, _typeof3.default)(reference[key]) === "object" && !(0, _lodash.isNull)(reference[key])) {
					update(reference[key], data[key]);
				} else {
					reference[key] = data[key];
				}
			});
		} catch (e) {
			return;
		}
	}
	
	/**
	 *
	 * @param referencedArray
	 * @param key
	 * @param value
	 */
	function destroy() {
		var referencedArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String;
		var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : String;
	
	
		referencedArray.filter(function (reference, iterator) {
			if (reference[key] === value) {
				referencedArray.splice(iterator, 1);
			}
		});
	}
	
	var reference = exports.reference = {
		create: create,
		update: update,
		destroy: destroy
	};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _acceptInvite = __webpack_require__(193);
	
	var _acceptInvite2 = _interopRequireDefault(_acceptInvite);
	
	var _acceptInvite3 = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AcceptInviteComponent = {
	    template: _acceptInvite2.default,
	    controller: _acceptInvite3.acceptInviteController,
	    controllerAs: "acceptInvite"
	};
	
	exports.default = AcceptInviteComponent;

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\" layout-align=\"center center\" flex>\n    <h2 ng-bind=\"'Set password' | translate\"></h2>\n</div>\n\n<form\n        class=\"form-signin\"\n        ng-class=\"{'request-loader': formSignin.$submitted==true}\"\n        name=\"formSignin\"\n        ng-submit=\"acceptInvite.$onSubmit()\"\n        autocomplete=\"off\"\n        novalidate>\n\n    <md-input-container class=\"md-block\">\n        <label\n                ng-bind=\"'First name' | translate\"\n                for=\"firstName\"></label>\n\n        <input\n                ng-model=\"acceptInvite.user.first_name\"\n                type=\"text\"\n                name=\"firstName\"\n                id=\"firstName\"\n                minlength=\"2\"\n                maxlength=\"24\"\n                required\n                autocomplete=\"off\">\n\n        <div ng-messages=\"formSignin.firstName.$error\" role=\"alert\">\n            <div ng-message-exp=\"['required', 'maxlength', 'minlength']\"\n                 ng-bind=\"'First name should contain at least 2 characters' | translate\">\n            </div>\n        </div>\n    </md-input-container>\n\n    <md-input-container class=\"md-block\">\n        <label\n                ng-bind=\"'Last name' | translate\"\n                for=\"lastName\"></label>\n\n        <input\n                ng-model=\"acceptInvite.user.last_name\"\n                type=\"text\"\n                name=\"lastName\"\n                id=\"lastName\"\n                minlength=\"2\"\n                maxlength=\"24\"\n                required\n                autocomplete=\"off\">\n\n        <div ng-messages=\"formSignin.lastName.$error\" role=\"alert\">\n            <div ng-message-exp=\"['required', 'maxlength', 'minlength']\"\n                 ng-bind=\"'Last name should contain at least 2 characters' | translate\">\n            </div>\n        </div>\n    </md-input-container>\n\n    <md-input-container class=\"md-block\">\n        <label\n                ng-bind=\"'Password' | translate\"\n                for=\"password\"></label>\n\n        <input\n                ng-model=\"acceptInvite.user.new_password\"\n                type=\"password\"\n                name=\"password\"\n                id=\"password\"\n                minlength=\"8\"\n                maxlength=\"100\"\n                ng-pattern=\"'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'\"\n                required\n                autocomplete=\"new-password\">\n\n        <div ng-messages=\"formSignin.password.$error\" role=\"alert\">\n            <div ng-message-exp=\"['required', 'maxlength', 'minlength', 'pattern']\"\n                 ng-bind=\"'Please make sure your password contains at least 8 characters and has at least one number, one uppercase letter, one lowercase letter, one symbol ($, #, @, %, ^, &, !, *)' | translate\">\n            </div>\n        </div>\n    </md-input-container>\n\n    <md-input-container class=\"md-block\">\n        <label\n                ng-bind=\"'Confirm password' | translate\"\n                for=\"rePassword\"></label>\n\n        <input\n                ng-model=\"acceptInvite.user.re_new_password\"\n                type=\"password\"\n                name=\"rePassword\"\n                id=\"rePassword\"\n                match-password=\"acceptInvite.user.new_password\"\n                minlength=\"8\"\n                maxlength=\"100\"\n                required\n                autocomplete=\"new-password\">\n\n        <div ng-messages=\"formSignin.rePassword.$error\" role=\"alert\">\n            <div ng-message-exp=\"['matchPassword']\"\n                 ng-bind=\"'Passwords do not match!' | translate\">\n            </div>\n        </div>\n    </md-input-container>\n\n    <div layout=\"row\" layout-align=\"center center\" flex>\n        <md-button ng-disabled=\"formSignin.$invalid\" type=\"submit\" class=\"md-raised md-primary\" ng-bind=\"'Set password' | translate\"></md-button>\n    </div>\n</form>\n";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.acceptInviteController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$mdToast"];
	
	var acceptInviteController = exports.acceptInviteController = function (_$controller) {
	    acceptInviteController.$inject = ["$injector", "$stateParams"];
	    (0, _inherits3.default)(acceptInviteController, _$controller);
	
	    function acceptInviteController($injector, $stateParams) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, acceptInviteController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (acceptInviteController.__proto__ || (0, _getPrototypeOf2.default)(acceptInviteController)).call(this, $injector, dependencies));
	
	        _this.$stateParams = $stateParams;
	        _this.user = {
	            new_password: "",
	            re_new_password: "",
	            invitation: _this.$stateParams.token,
	            first_name: "",
	            last_name: ""
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(acceptInviteController, [{
	        key: "$onSubmit",
	        value: function $onSubmit() {
	            var _this2 = this;
	
	            this.$auth.$http({
	                url: "/api/signup/",
	                method: "POST",
	                data: this.user
	            }).then(function () {
	                _this2.$mdToast.show(_this2.$mdToast.simple().position("bottom right").hideDelay(5000).textContent("User created!"));
	                _this2.$state.go("auth.signin");
	            }).catch(function () {
	                _this2.$mdToast.show(_this2.$mdToast.simple().position("bottom right").hideDelay(3000).textContent("Can't accept invitation!"));
	            });
	        }
	    }]);
	    return acceptInviteController;
	}(_index.$controller);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _resetPassword = __webpack_require__(196);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _resetPassword3 = __webpack_require__(197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResetPasswordComponent = {
	    template: _resetPassword2.default,
	    controller: _resetPassword3.resetPasswordController,
	    controllerAs: "resetPassword"
	};
	
	exports.default = ResetPasswordComponent;

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\" layout-align=\"center center\" flex>\n    <h2 ng-bind=\"'Set new password' | translate\"></h2>\n</div>\n\n<form\n        class=\"form-signin\"\n        ng-class=\"{'request-loader': formSignin.$submitted==true}\"\n        name=\"formSignin\"\n        ng-submit=\"resetPassword.$onSubmit()\"\n        novalidate>\n\n\n    <md-input-container class=\"md-block\">\n        <label\n                ng-bind=\"'Password' | translate\"\n                for=\"password\"></label>\n\n        <input\n                ng-model=\"resetPassword.user.new_password\"\n                type=\"password\"\n                name=\"password\"\n                id=\"password\"\n                minlength=\"8\"\n                maxlength=\"100\"\n                ng-pattern=\"'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'\"\n                required>\n\n        <div ng-messages=\"formSignin.password.$error\" role=\"alert\">\n            <div ng-message-exp=\"['required', 'maxlength', 'minlength', 'pattern']\"\n                 ng-bind=\"'Please make sure your password contains at least 8 characters and has at least one number, one uppercase letter, one lowercase letter, one symbol ($, #, @, %, ^, &, !, *)' | translate\">\n            </div>\n        </div>\n    </md-input-container>\n\n    <md-input-container class=\"md-block\">\n        <label\n                ng-bind=\"'Confirm password' | translate\"\n                for=\"rePassword\"></label>\n\n        <input\n                ng-model=\"resetPassword.user.re_new_password\"\n                type=\"password\"\n                name=\"rePassword\"\n                match-password=\"resetPassword.user.new_password\"\n                id=\"rePassword\"\n                minlength=\"8\"\n                maxlength=\"100\"\n                required>\n\n        <div ng-messages=\"formSignin.rePassword.$error\" role=\"alert\">\n            <div ng-message-exp=\"['matchPassword']\"\n                 ng-bind=\"'Passwords do not match!' | translate\">\n            </div>\n        </div>\n    </md-input-container>\n\n    <div layout=\"row\" layout-align=\"center center\" flex>\n        <md-button ng-disabled=\"formSignin.$invalid\" type=\"submit\" class=\"md-raised md-primary\" ng-bind=\"'Change password' | translate\"></md-button>\n    </div>\n</form>";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.resetPasswordController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$mdToast"];
	
	var resetPasswordController = exports.resetPasswordController = function (_$controller) {
	    resetPasswordController.$inject = ["$injector", "$stateParams"];
	    (0, _inherits3.default)(resetPasswordController, _$controller);
	
	    function resetPasswordController($injector, $stateParams) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, resetPasswordController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (resetPasswordController.__proto__ || (0, _getPrototypeOf2.default)(resetPasswordController)).call(this, $injector, dependencies));
	
	        _this.$stateParams = $stateParams;
	        _this.user = {
	            new_password: "",
	            re_new_password: "",
	            token: _this.$stateParams.token
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(resetPasswordController, [{
	        key: "$onSubmit",
	        value: function $onSubmit() {
	            var _this2 = this;
	
	            this.$auth.$http({
	                url: "/api/password/reset/confirm/",
	                method: "POST",
	                data: this.user
	            }).then(function () {
	                _this2.$mdToast.show(_this2.$mdToast.simple().position("bottom right").hideDelay(5000).textContent("Password changed!"));
	                _this2.$state.go("auth.signin");
	            }).catch(function () {
	                _this2.$mdToast.show(_this2.$mdToast.simple().position("bottom right").hideDelay(3000).textContent("Can't change password!"));
	            });
	        }
	    }]);
	    return resetPasswordController;
	}(_index.$controller);

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	"use strict";
	
	AuthRouter.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AuthRouter = AuthRouter;
	/**
	 *
	 * @param $stateProvider
	 */
	function AuthRouter($stateProvider) {
		"ngInject";
	
		$stateProvider.state({
			name: "auth",
			template: "<auth></auth>"
		}).state({
			name: "auth.signin",
			url: "/app/signin",
			template: "<signin></signin>",
			resolve: {
				$title: function $title() {
					return "Sign in | UpReach Cloud";
				}
			}
		}).state({
			name: "auth.acceptInvite",
			url: "/app/accept-invite/:token/",
			template: "<accept-invite></accept-invite>",
			resolve: {
				$title: function $title() {
					return "Accept invite | UpReach Cloud";
				}
			}
		}).state({
			name: "auth.password",
			url: "/app/password/",
			template: "<password></password>",
			resolve: {
				$title: function $title() {
					return "Reset password | UpReach Cloud";
				}
			}
		}).state({
			name: "auth.resetPassword",
			url: "/app/password-set/:token/",
			template: "<reset-password></reset-password>",
			resolve: {
				$title: function $title() {
					return "Confirm password | UpReach Cloud";
				}
			}
		}).state({
			name: "auth.twoFactor",
			url: "/app/two-factor/",
			template: "<two-factor></two-factor>",
			resolve: {
				$title: function $title() {
					return "Two-Factor Authentication | UpReach Cloud";
				}
			}
		}).state({
			name: "auth.twoFactorSuccess",
			url: "/app/two-factor-success/",
			template: "<two-factor-success></two-factor-success>",
			resolve: {
				$title: function $title() {
					return "Two-Factor Enabled | UpReach Cloud";
				}
			}
		});
	}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _password = __webpack_require__(200);
	
	var _password2 = _interopRequireDefault(_password);
	
	var _password3 = __webpack_require__(203);
	
	var _password4 = _interopRequireDefault(_password3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordModule = angular.module("password", []).service("$password", _password4.default).component("password", _password2.default);
	
	exports.default = PasswordModule;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _password = __webpack_require__(201);
	
	var _password2 = _interopRequireDefault(_password);
	
	var _password3 = __webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordComponent = {
		template: _password2.default,
		controller: _password3.passwordController,
		controllerAs: "password"
	};
	
	exports.default = PasswordComponent;

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\" layout-align=\"center center\" flex>\n\t<h2 ng-bind=\"'Enter your email for password reset' | translate\"></h2>\n</div>\n\n<form\n\t\tclass=\"form-signin\"\n\t\tng-class=\"{'request-loader': formReset.$submitted==true}\"\n\t\tname=\"formReset\"\n\t\tng-submit=\"password.$onSubmit(resetSignin)\"\n\t\tnovalidate>\n\n\n\t<md-input-container class=\"md-block\">\n\t\t<label\n\t\t\t\tng-bind=\"'Email Address' | translate\"\n\t\t\t\tfor=\"inputEmail\"></label>\n\n\t\t<input\n\t\t\t\tng-model=\"password.email\"\n\t\t\t\ttype=\"email\"\n\t\t\t\tname=\"email\"\n\t\t\t\tid=\"inputEmail\"\n\t\t\t\tmaxlength=\"100\"\n\t\t\t\tng-pattern=\"/^.+@.+\\..+$/\"\n\t\t\t\trequired>\n\n\t\t<div ng-messages=\"formReset.email.$error\" role=\"alert\">\n\t\t\t<div ng-message-exp=\"['required', 'maxlength', 'pattern']\"\n\t\t\t\t ng-bind=\"'Your email must be between 10 and 100 characters long and look like an e-mail address.' | translate\">\n\t\t\t</div>\n\t\t</div>\n\t</md-input-container>\n\n\t<div layout=\"row\" layout-align=\"center center\" flex>\n\t\t<md-button ng-disabled=\"formReset.$invalid\" type=\"submit\" class=\"md-raised md-primary\" ng-bind=\"'Confirm' | translate\"></md-button>\n\t</div>\n</form>";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.passwordController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = [];
	
	var passwordController = exports.passwordController = function (_$controller) {
	    passwordController.$inject = ["$injector", "$httpConfigurator"];
	    (0, _inherits3.default)(passwordController, _$controller);
	
	    function passwordController($injector, $httpConfigurator) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, passwordController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (passwordController.__proto__ || (0, _getPrototypeOf2.default)(passwordController)).call(this, $injector, dependencies));
	
	        _this.$httpConfigurator = $httpConfigurator;
	        _this.email = null;
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(passwordController, [{
	        key: "$onSubmit",
	        value: function $onSubmit() {
	            var _this2 = this;
	
	            this.$auth.$http({
	                url: "/api/password/reset/",
	                method: "POST",
	                data: { email: this.email }
	            }).then(function () {
	                _this2.$mdToast.show(_this2.$mdToast.simple().position("bottom right").hideDelay(5000).textContent("Reset link sent to your email!"));
	                _this2.$state.go("auth.signin");
	            }).catch(function () {
	                _this2.$mdToast.show(_this2.$mdToast.simple().position("bottom right").hideDelay(3000).textContent("User with provided email not found"));
	            });
	        }
	    }]);
	    return passwordController;
	}(_index.$controller);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _service = __webpack_require__(184);
	
	var _service2 = _interopRequireDefault(_service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordService = function (_ActiveService) {
		PasswordService.$inject = ["$injector", "CONFIG", "$translates", "$auth", "$httpConfigurator", "$state"];
		(0, _inherits3.default)(PasswordService, _ActiveService);
	
		function PasswordService($injector, CONFIG, $translates, $auth, $httpConfigurator, $state) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, PasswordService);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordService.__proto__ || (0, _getPrototypeOf2.default)(PasswordService)).call(this, $injector));
	
			_this.CONFIG = CONFIG;
			_this.$translates = $translates;
			_this.$auth = $auth;
			_this.$httpConfigurator = $httpConfigurator;
			_this.$state = $state;
			return _this;
		}
	
		/**
	  *
	  * @param data
	  * @returns {Function}
	  */
	
	
		(0, _createClass3.default)(PasswordService, [{
			key: "request",
			value: function request(data) {
				var _this2 = this;
	
				return this.activePost(this.CONFIG.API.passwordResets, data).then(function () {
					return _this2.notify.set(_this2.translate("PASSWORD_REQUEST_SUCCESS"), "success");
				});
			}
		}, {
			key: "reset",
			value: function reset(data) {
				var _this3 = this;
	
				var deferred = this.$q.defer();
				this.$http({
					url: "/api/users/me",
					method: "GET",
					headers: { "X-RapidGAE-Magic-Link": data.token }
				}).then(function (response) {
					_this3.$httpConfigurator.setHeaders(response.headers("x-rapidgae-session-user"));
					_this3.activePut(response.data.uri, {
						password: data.password
					}).then(function () {
						return _this3.$auth.authenticate({ email: response.data.email, password: data.password });
					}).then(function () {
						return _this3.$state.go("booking", { target: "working" });
					});
					deferred.resolve();
				}).catch(function () {
					return deferred.reject();
				});
				return deferred.promise;
			}
		}]);
		return PasswordService;
	}(_service2.default);
	
	exports.default = PasswordService;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _twoFactor = __webpack_require__(205);
	
	var _twoFactor2 = _interopRequireDefault(_twoFactor);
	
	var _twoFactor3 = __webpack_require__(206);
	
	__webpack_require__(207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwoFactorComponent = {
	    template: _twoFactor2.default,
	    controller: _twoFactor3.TwoFactorController,
	    controllerAs: "twoFactor"
	};
	
	exports.default = TwoFactorComponent;

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\" layout-align=\"center center\" flex class=\"column\">\n    <h2>Two-Factor <br> authentification</h2>\n    <p>Enter the 6-digit code sent to your <br> email address to verify your account.</p>\n</div>\n<form name=\"form2FA\" ng-submit=\"twoFactor.$onSubmit()\" novalidate>\n    <p class=\"low-text\">Enter OTP</p>\n    <div layout=\"row\" layout-align=\"center center\">\n        <input\n            ng-repeat=\"i in [0,1,2,3,4,5]\"\n            type=\"text\"\n            maxlength=\"1\"\n            minlength=\"1\"\n            class=\"otp-input\"\n            placeholder=\"X\"\n            ng-model=\"twoFactor.otpArr[i]\"\n            ng-keyup=\"twoFactor.onKeyUp($event, i)\"\n            ng-paste=\"twoFactor.onPaste($event)\"\n            autocomplete=\"off\"\n            inputmode=\"numeric\"\n            required\n        />\n    </div>\n    <div layout=\"row\" layout-align=\"center center\" flex class=\"column\">\n        <md-button type=\"submit\" class=\"md-raised md-primary submit-btn\" ng-disabled=\"form2FA.$invalid\">Verify</md-button>\n        <div style=\"margin-top: 12px;\">\n            <span class=\"link\" ng-click=\"twoFactor.resendCode()\" ng-class=\"{disabled: twoFactor.resendDisabled}\">\n              Didn't get a verification code? Resend\n            </span>\n            <span ng-if=\"twoFactor.resendMessage\" style=\"margin-left:8px; color:#4caf50;\">{{twoFactor.resendMessage}}</span>\n        </div>\n    </div>\n</form> \n";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TwoFactorController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwoFactorController = exports.TwoFactorController = function (_$controller) {
	    TwoFactorController.$inject = ["$injector", "$state", "$auth", "$timeout"];
	    (0, _inherits3.default)(TwoFactorController, _$controller);
	
	    function TwoFactorController($injector, $state, $auth, $timeout) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, TwoFactorController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (TwoFactorController.__proto__ || (0, _getPrototypeOf2.default)(TwoFactorController)).call(this, $injector, []));
	
	        _this.$state = $state;
	        _this.$auth = $auth;
	        _this.$timeout = $timeout;
	        _this.otpArr = ["", "", "", "", "", ""];
	        _this.email = sessionStorage.getItem("2fa_email");
	        _this.password = sessionStorage.getItem("2fa_password");
	        _this.resendDisabled = false;
	        _this.resendMessage = "";
	        return _this;
	    }
	
	    (0, _createClass3.default)(TwoFactorController, [{
	        key: "onKeyUp",
	        value: function onKeyUp(event, idx) {
	            var input = event.target;
	            var value = input.value;
	
	            // Only allow numbers
	            if (!/^[0-9]$/.test(value) && value !== "") {
	                this.otpArr[idx] = "";
	                return;
	            }
	
	            // Move to next input if not last and value entered
	            if (value && idx < 5) {
	                var next = input.parentElement.querySelectorAll("input")[idx + 1];
	                if (next) next.focus();
	            }
	            // Replace value in last input
	            if (idx === 5 && value.length > 1) {
	                this.otpArr[5] = value.slice(-1);
	            }
	        }
	    }, {
	        key: "onPaste",
	        value: function onPaste(event) {
	            var _this2 = this;
	
	            event.preventDefault();
	            var paste = (event.clipboardData || window.clipboardData).getData("text").replace(/\D/g, "");
	            for (var i = 0; i < 6; i++) {
	                this.otpArr[i] = paste[i] || "";
	            }
	            // Фокус на перший незаповнений
	            this.$timeout(function () {
	                var inputs = event.target.parentElement.querySelectorAll("input");
	                for (var _i = 0; _i < 6; _i++) {
	                    if (!_this2.otpArr[_i]) {
	                        inputs[_i].focus();
	                        break;
	                    }
	                }
	            });
	        }
	    }, {
	        key: "$onSubmit",
	        value: function $onSubmit() {
	            var _this3 = this;
	
	            var otp = this.otpArr.join("");
	            if (otp.length !== 6) return;
	            this.$auth.authenticate({
	                email: this.email,
	                password: this.password,
	                token: otp
	            }, true).then(function (data) {
	                sessionStorage.removeItem("2fa_email");
	                sessionStorage.removeItem("2fa_password");
	                _this3.$auth.finalizeLogin(data).then(function () {
	                    _this3.$state.go("auth.twoFactorSuccess");
	                }).catch(function (err) {
	                    console.error("finalizeLogin error", err);
	                });
	            });
	        }
	    }, {
	        key: "resendCode",
	        value: function resendCode() {
	            var _this4 = this;
	
	            if (this.resendDisabled) return;
	            this.resendDisabled = true;
	            this.resendMessage = "";
	
	            this.$auth.authenticate({
	                email: this.email,
	                password: this.password
	            }).then(function (data) {
	                if (data && data.requires_2fa) {
	                    _this4.resendMessage = "Verification code sent!";
	                } else {
	                    _this4.resendMessage = "Unexpected response!";
	                }
	            }).catch(function () {
	                _this4.resendMessage = "Failed to resend code!";
	            }).finally(function () {
	                _this4.$timeout(function () {
	                    _this4.resendDisabled = false;
	                    _this4.resendMessage = "";
	                }, 10000);
	            });
	        }
	    }]);
	    return TwoFactorController;
	}(_index.$controller);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(208);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./two-factor.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./two-factor.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "two-factor{display:flex;flex-direction:column;align-items:center}two-factor .layout-row{display:flex;flex-direction:row}two-factor .layout-row.layout-align-center-center{justify-content:center}two-factor .layout-row.column{flex-direction:column}two-factor .layout-row.column.layout-align-center-center{align-items:center}two-factor h2{font-size:38px;font-weight:700;line-height:36px;margin-bottom:10px}two-factor h2,two-factor p{text-align:center;font-style:normal}two-factor p{color:#000;font-size:14px;font-weight:400;line-height:normal;margin-bottom:0}two-factor form{max-width:270px;margin-top:45px}two-factor form .low-text{font-weight:400;font-size:14px;line-height:100%;letter-spacing:0;color:#666;margin-bottom:12px;margin-top:0;text-align:left}two-factor form .otp-input{width:38px;height:59.69px;border:1px solid #000;gap:13px;margin:auto}two-factor form .submit-btn{margin-top:45px;display:flex;width:258px;height:34px;padding:10px;flex-direction:column;justify-content:center;align-items:center;gap:10px;color:#fff;font-weight:700}two-factor form .link,two-factor form .submit-btn{font-size:14px;font-style:normal;line-height:normal}two-factor form .link{color:#7eafff;text-align:center;font-weight:400;cursor:pointer;text-decoration:none}.otp-input{width:40px;height:48px;font-size:2rem;text-align:center;margin:0 4px;border:1px solid #ccc;border-radius:6px;transition:border-color .2s;outline:none;background:#fff}.otp-input:focus{border-color:#e91e63;box-shadow:0 0 0 2px #e91e6340}@media (max-width:480px){.otp-input{width:32px;height:40px;font-size:1.2rem;margin:0 2px}}.two-factor-container{max-width:340px;margin:0 auto;padding:24px 16px;background:#fafbfc;border-radius:10px;box-shadow:0 2px 12px #0001}.link{color:#e91e63;cursor:pointer;text-decoration:underline;transition:color .2s}.link.disabled{color:#bbb;pointer-events:none;text-decoration:none}", ""]);
	
	// exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _twoFactorSuccess = __webpack_require__(210);
	
	var _twoFactorSuccess2 = _interopRequireDefault(_twoFactorSuccess);
	
	var _twoFactorSuccess3 = __webpack_require__(212);
	
	var _twoFactorSuccess4 = _interopRequireDefault(_twoFactorSuccess3);
	
	__webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwoFactorSuccessComponent = {
	    template: _twoFactorSuccess2.default,
	    controller: _twoFactorSuccess4.default,
	    controllerAs: "success"
	};
	
	exports.default = TwoFactorSuccessComponent;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"two-factor-success-container\" layout=\"column\" layout-align=\"center center\" flex>\n    <h2 style=\"display: flex;align-items: center\"><img src=\"" + __webpack_require__(211) + "\" alt=\"success-icon\"> Success</h2>\n    <div>Two-Factor Authentication has been<br>enabled for your account.</div>\n    <div style=\"margin-top: 64px\">\n        From now on, you'll need to enter both your password and a 6-digit security code sent to your <br> email address every time you log in.\n    </div>\n    <div class=\"low-text\">\n        Make sure you have access to your inbox to receive future login codes.\n    </div>\n    <md-button class=\"md-raised md-primary submit-btn\" ng-click=\"success.done()\" >Done</md-button>\n</div>\n";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/success-icon.png";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwoFactorSuccessController = function () {
	    TwoFactorSuccessController.$inject = ["$state"];
	    function TwoFactorSuccessController($state) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, TwoFactorSuccessController);
	        this.$state = $state;
	    }
	
	    (0, _createClass3.default)(TwoFactorSuccessController, [{
	        key: "done",
	        value: function done() {
	            this.$state.go("deployments");
	        }
	    }]);
	    return TwoFactorSuccessController;
	}();
	
	exports.default = TwoFactorSuccessController;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(214);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./two-factor-success.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./two-factor-success.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, ".two-factor-success-container{color:#000;font-size:14px;font-style:normal;font-weight:400;line-height:normal;text-align:center}.two-factor-success-container h2{color:#25282a;text-align:center;font-size:38px;font-style:normal;font-weight:700;line-height:36px}.two-factor-success-container h2 img{height:36px;width:auto;margin-right:12px}.two-factor-success-container .low-text{color:#666;text-align:center;font-size:14px;font-style:normal;font-weight:400;line-height:normal;margin-top:12px;margin-bottom:45px}.two-factor-success-container .submit-btn{display:flex;width:258px;height:34px;padding:10px;flex-direction:column;justify-content:center;align-items:center;gap:10px;border-radius:5px;box-shadow:0 4px 4px 0 rgba(0,0,0,.15);color:#fff;font-size:14px;font-style:normal;font-weight:700;line-height:normal}", ""]);
	
	// exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LayoutModule = undefined;
	
	var _navbar = __webpack_require__(216);
	
	var _sidebar = __webpack_require__(225);
	
	var LayoutModule = exports.LayoutModule = angular.module("layout", [_navbar.NavbarModule.name, _sidebar.SidebarModule.name]);

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.NavbarModule = undefined;
	
	var _navabar = __webpack_require__(217);
	
	var _navabar2 = _interopRequireDefault(_navabar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarModule = exports.NavbarModule = angular.module("navbar", []).component("navbar", _navabar2.default);

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _navbar = __webpack_require__(218);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(221);
	
	__webpack_require__(223);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarComponent = {
		template: _navbar2.default,
		controller: _navbar3.NavbarController,
		controllerAs: "navbar",
		require: {
			app: "^^app"
		}
	};
	
	exports.default = navbarComponent;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"md-toolbar-tools\">\n\t<div class=\"logo-holder\">\n\t\t<div class=\"upreach-logo\"></div>\n\t</div>\n\t<span flex md-truncate class=\"email\">{{ email }}</span>\n\t<a ng-if=\"navbar.isAuthenticated()\"\n\t\t permission-hide=\"Client,Sub-User\"\n\t\t ui-sref=\"clients\"\n\t\t ui-sref-active=\"active\">\n\t\t<md-icon class=\"material-icons\">supervisor_account</md-icon>\n\t\t<span ng-bind=\"'Clients' | translate\"></span>\n\t</a>\n\n\t<a ng-if=\"navbar.isAuthenticated()\"\n\t   ui-sref=\"deployments\"\n\t\t ui-sref-active=\"active\">\n\t\t<md-icon class=\"material-icons\">view_list</md-icon>\n\t\t<span ng-bind=\"'Deployments' | translate\"></span>\n\t</a>\n\n\t<a ng-if=\"navbar.isAuthenticated()\"\n\t\t ui-sref=\"configurations\"\n\t\t ui-sref-active=\"active\">\n        <img width=\"20px\" src=\"" + __webpack_require__(219) + "\" alt=\"\">\n\t\t<span style=\"vertical-align: super\" ng-bind=\"'Configurations' | translate\"></span>\n\t</a>\n\n\t<a ng-if=\"navbar.isAuthenticated()\"\n\t\t ui-sref=\"media\"\n\t\t ui-sref-active=\"active\">\n\t\t<md-icon class=\"material-icons\">photo_library</md-icon>\n\t\t<span ng-bind=\"'Media' | translate\"></span>\n\t</a>\n\n\t<a ng-if=\"navbar.isAuthenticated()\"\n\t\t ui-sref=\"analytics\"\n\t\t ui-sref-active=\"active\">\n\t\t<md-icon class=\"material-icons\">insert_chart</md-icon>\n\t\t<span ng-bind=\"'Analytics' | translate\"></span>\n\t</a>\n\n\n\t<md-menu ng-if=\"navbar.isAuthenticated()\">\n\t\t<button ng-click=\"$mdMenu.open()\">\n\t\t\t<md-icon class=\"material-icons\">settings</md-icon>\n\t\t\t<span ng-bind=\"'Settings' | translate\"></span>\n\t\t</button>\n\t\t<md-menu-content>\n\t\t\t<md-menu-item>\n\t\t\t\t<div ng-if=\"navbar.isAuthenticated()\" class=\"header-icon\">\n\t\t\t\t\t<a ui-sref=\"booths\"\n\t\t\t\t\t   ui-sref-active=\"active\">\n\t\t\t\t\t\t<md-icon class=\"material-icons\">devices</md-icon>\n\t\t\t\t\t\t<span ng-bind=\"'Devices' | translate\"></span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</md-menu-item>\n\t\t\t<md-menu-item permission-hide=\"Client,Sub-User\">\n\t\t\t\t<div ng-if=\"navbar.isAuthenticated()\" class=\"header-icon\">\n\t\t\t\t\t<a ui-sref=\"users\"\n\t\t\t\t\t   ui-sref-active=\"active\">\n\t\t\t\t\t\t<md-icon class=\"material-icons\">people</md-icon>\n\t\t\t\t\t\t<span ng-bind=\"'Users' | translate\"></span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</md-menu-item>\n\t\t\t<md-menu-item >\n\t\t\t\t<div ng-if=\"navbar.isAuthenticated()\" ng-click=\"navbar.onTwoFactorStateChange()\" class=\"header-icon\" style=\"display: flex;align-items: center\">\n\t\t\t\t\t<div class=\"icon-wrapper header-nav-icon\">\n\t\t\t\t\t\t<img src=\"" + __webpack_require__(220) + "\" alt=\"2factorAuth-icon\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<span ng-bind=\"'2FA' | translate\"></span>\n\t\t\t\t</div>\n\t\t\t</md-menu-item>\n\t\t\t<md-menu-item>\n\t\t\t\t<div ng-if=\"navbar.isAuthenticated()\" ng-click=\"navbar.logout()\" class=\"header-icon\">\n\t\t\t\t\t<md-icon class=\"material-icons\">exit_to_app</md-icon>\n\t\t\t\t\t<span ng-bind=\"'Logout' | translate\"></span>\n\t\t\t\t</div>\n\t\t\t</md-menu-item>\n\t\t</md-menu-content>\n\t</md-menu>\n\n\t<a ng-if=\"navbar.isAuthenticated()\" href=\"http://support.upreach.com/\">\n\t\t<md-icon class=\"material-icons\">help</md-icon>\n\t\t<span ng-bind=\"'Help' | translate\"></span>\n\t</a>\n\n\t<!--<md-button-->\n\t\t\t<!--ng-if=\"navbar.isAuthenticated()\"-->\n\t\t\t<!--class=\"md-fab md-mini md-hue-3\" aria-label=\"Favorite\">-->\n\t\t<!--&lt;!&ndash; <md-icon md-svg-icon=\"img/icons/favorite.svg\"></md-icon> &ndash;&gt;-->\n\t<!--</md-button>-->\n\n</div>\n";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/auto_fix_high.svg";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/2factor-icon.svg";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.NavbarController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _package = __webpack_require__(222);
	
	var packageVariables = _interopRequireWildcard(_package);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = [];
	
	var NavbarController = exports.NavbarController = function (_$controller) {
		NavbarController.$inject = ["$injector", "$scope", "$auth", "$rootScope"];
		(0, _inherits3.default)(NavbarController, _$controller);
	
		function NavbarController($injector, $scope, $auth, $rootScope) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, NavbarController);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (NavbarController.__proto__ || (0, _getPrototypeOf2.default)(NavbarController)).call(this, $injector, dependencies));
	
			$scope.version = packageVariables.version;
			$scope.auth = $auth;
			$rootScope.$on("$stateChangeSuccess", function () {
				return $scope.email = $scope.auth.getUser() ? $scope.auth.getUser().email : null;
			});
			$scope.two_factor_enabled = $scope.auth.getUser() ? $scope.auth.getUser().two_factor_enabled : null;
	
			_this.watchStateChanges();
	
			return _this;
		}
	
		(0, _createClass3.default)(NavbarController, [{
			key: "watchStateChanges",
			value: function watchStateChanges() {
				return this.$rootScope.$on("$stateChangeSuccess", function () {
					return window.$("#navbar-navigation").not(".collapsed").click();
				});
			}
		}, {
			key: "isAuthenticated",
			value: function isAuthenticated() {
				return this.$auth.isAuthenticated();
			}
		}, {
			key: "logout",
			value: function logout() {
				return this.$auth.logout();
			}
		}, {
			key: "$navbarBrandRedirect",
			value: function $navbarBrandRedirect() {
				if (!this.isAuthenticated()) {
					return this.$state.go("auth.signin");
				} else {
					return this.$state.go("companies");
				}
			}
		}, {
			key: "$updateUserRedirect",
			value: function $updateUserRedirect() {
				return this.$state.go("users.update", { uri: this.$filter("encodeUri")(this.$auth.getUser().uri) });
			}
		}, {
			key: "onTwoFactorStateChange",
			value: function onTwoFactorStateChange() {
				var _this2 = this;
	
				this.$auth.twoFactorAuthenticationState({ enable: !this.$auth.getUser().two_factor_enabled }).then(function (resp) {
					var msg = resp && resp.detail ? resp.detail : "2Factor is " + !_this2.$auth.getUser().two_factor_enabled;
					_this2.$mdToast.show(_this2.$mdToast.simple().textContent(msg).position("top right").hideDelay(3000));
				});
			}
		}]);
		return NavbarController;
	}(_index.$controller);

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	module.exports = {"name":"upreachcloud-frontend","title":"upreachcloud-frontend","version":"1.0.0","homepage":"http://localhost","author":{"name":"ITPP","url":"http://localhost"},"dependencies":{"@angular/router":"0.2.0","angular":"1.6.3","angular-animate":"1.6.3","angular-animation-fx":"0.1.5","angular-aria":"^1.6.10","angular-bootstrap-datetimepicker":"^1.1.3","angular-clock":"^0.5.1","angular-cookies":"1.6.3","angular-datatables":"~0.5.5","angular-date-time-input":"^1.2.1","angular-daterangepicker":"~0.2.3-alpha1","angular-drag-and-drop-lists":"^2.1.0","angular-fixed-table-header":"^0.2.1","angular-gettext":"^2.3.10","angular-gettext-loader":"^1.0.1","angular-gettext-plugin":"^1.0.1","angular-material":"^1.1.9","angular-material-data-table":"^0.10.10","angular-messages":"^1.6.10","angular-mocks":"1.6.3","angular-rangeslider":"0.0.14","angular-recaptcha":"^4.1.0","angular-sanitize":"1.6.3","angular-svg-round-progressbar":"~0.4.8","angular-ui-bootstrap":"^2.2.0","angular-ui-router":"^0.3.1","angular-ui-router-title":"^0.1.1","angular-ui-router.statehelper":"^1.3.1","angular-ui-switch":"https://github.com/morphik/angular-ui-switch.git","angular-virtual-keyboard":"^0.4.3","angular-wizard":"^1.1.1","angularjs-color-picker":"^3.4.8","animate.css":"^3.5.2","bootstrap-css-only":"3.3.6","bootstrap-daterangepicker":"^2.1.24","crypto-js":"^3.1.8","eslint-loader":"^1.9.0","file-saver":"^1.3.8","font-awesome":"^4.7.0","html2canvas":"^1.0.0-rc.3","jspdf":"^1.5.3","lodash":"^4.13.1","material-icons":"^0.2.3","moment-timezone":"^0.5.11","ng-material-datetimepicker":"^1.15.2","ng-notify":"https://github.com/morphik/ng-notify.git","normalize.css":"4.1.1","save-as":"^0.1.8","source-map":"^0.5.6","source-sans-pro":"^2.0.10","ui-router-route-to-components":"^0.1.0","ui-select":"^0.19.6","vee-validate":"^2.0.0-beta.17","vue":"^2.5.2"},"devDependencies":{"angular-mocks":"1.5.7","babel-core":"6.10.4","babel-loader":"6.2.4","babel-plugin-transform-async-to-generator":"^6.24.1","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.9.0","babel-preset-stage-0":"^6.16.0","babel-register":"6.26.0","colors":"^1.1.2","copy-webpack-plugin":"^4.0.1","css-loader":"0.23.1","eslint":"^4.2.0","extract-text-webpack-plugin":"^1.0.1","file-loader":"0.9.0","gulp":"^3.9.1","gulp-regex-rename":"^0.1.0","gulp-rename":"^1.2.2","gulp-replace-name":"^1.0.1","gulp-template":"4.0.0","html-loader":"^0.5.5","html-webpack-plugin":"^2.15.0","ip":"^1.1.4","json-loader":"^0.5.4","mocha":"5.2.0","ng-annotate-loader":"^0.1.0","node-libs-browser":"1.0.0","node-sass":"^4.2.0","phantomjs-prebuilt":"2.1.7","raw-loader":"0.5.1","rimraf":"^2.5.2","run-sequence":"1.2.1","sass-loader":"^4.1.1","strip-loader":"^0.1.2","style-loader":"0.13.1","stylus":"^0.54.5","stylus-loader":"2.1.1","url-loader":"0.5.7","webpack":"^1.13.1","webpack-dev-middleware":"^1.8.4","webpack-dev-server":"^1.14.1","webpack-md5-hash":"0.0.5","webpack-merge":"^0.14.0","webpack-stream":"3.2.0","yargs":"^6.6.0"},"scripts":{"start":"webpack-dev-server --inline --progress --port 3000 --targetName='app'","build":"rimraf build && webpack --config webpack/webpack.prod.js --progress --profile --bail --targetName='app'","test":"NODE_PATH=. mocha --require babel-register --require test/setup.js \"test/**/*.spec.js\""},"keywords":["angular","webpack","es6"]}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(224);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "navbar{min-width:800px}navbar .md-toolbar-tools{height:47px}navbar .logo-holder{position:relative}navbar .logo-holder .upreach-logo{background:url(" + __webpack_require__(157) + ") no-repeat;width:120px;height:14px;margin-left:40px;background-size:contain}navbar .email{color:#fff;margin:0 20px;font-size:14px}navbar .nav-wrapper{display:flex;align-items:flex-start;justify-content:space-between}navbar .nav-wrapper a{height:20px}navbar .nav-wrapper .md-menu{height:100%;display:flex;align-items:flex-start;margin:0}navbar a{color:#fff;text-transform:capitalize;margin:0 16px;font-size:14px;transition:all .3s ease-in-out;border-bottom:1px solid transparent}navbar a.active,navbar a:hover{border-bottom:1px solid #fff!important}navbar md-menu button{color:#fff;text-transform:capitalize;margin:0 5px;font-size:14px;transition:all .3s ease-in-out;border:none;background-color:transparent;border-bottom:1px solid transparent}navbar md-menu button:hover{color:#fff}navbar md-menu button.active,navbar md-menu button:hover{border-bottom:1px solid #fff!important}navbar md-menu button:focus{border:none;outline:none;border-bottom:1px solid #fff!important}navbar .material-icons{font-size:20px}md-menu-item .header-icon{font-size:14px;cursor:pointer;width:85px}md-menu-item .header-icon md-icon{margin:0}", ""]);
	
	// exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SidebarModule = undefined;
	
	var _sidebar = __webpack_require__(226);
	
	var SidebarModule = exports.SidebarModule = angular.module("sidebar", []).component("sidebar", _sidebar.SidebarComponent);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SidebarComponent = undefined;
	
	var _sidebar = __webpack_require__(227);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _sidebar3 = __webpack_require__(228);
	
	var _sidebar4 = _interopRequireDefault(_sidebar3);
	
	__webpack_require__(229);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidebarComponent = exports.SidebarComponent = { template: _sidebar2.default, controller: _sidebar4.default };

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"sidebar-wrapper\">\n\t<ul class=\"sidebar-nav\">\n\n    <li class=\"header\">Załaduj24</li>\n\n\t\t<li class=\"sidebar-brand\" ui-sref=\"companies\" ui-sref-active=\"active\">\n\t\t\t<span class=\"fa fa-users\"></span>\n\t\t\t<span ng-bind=\"'MODULE_NAME_COMPANIES' | translate\"></span>\n\t\t</li>\n\n\t\t<li class=\"sidebar-brand\" ui-sref=\"users\" ui-sref-active=\"active\" permission-show=\"user.company.manage\" permission-hide=\"companies.manage\">\n\t\t\t<span class=\"fa fa-users\"></span>\n\t\t\t<span ng-bind=\"'MODULE_NAME_users' | translate\"></span>\n\t\t</li>\n\n\t\t<li class=\"sidebar-brand svg-icon\" ui-sref=\"requests\" ui-sref-active=\"active\" permission-show=\"companies.manage\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><path d=\"M25.197,40.961h33.75c0.828,0,1.5-0.671,1.5-1.5c0-0.828-0.672-1.5-1.5-1.5h-33.75c-0.829,0-1.5,0.672-1.5,1.5  C23.697,40.29,24.369,40.961,25.197,40.961z M25.197,32.519h33.75c0.828,0,1.5-0.671,1.5-1.5c0-0.828-0.672-1.5-1.5-1.5h-33.75  c-0.829,0-1.5,0.672-1.5,1.5C23.697,31.848,24.369,32.519,25.197,32.519z M25.197,48.528h27.75c0.828,0,1.5-0.671,1.5-1.5  c0-0.828-0.672-1.5-1.5-1.5h-27.75c-0.829,0-1.5,0.672-1.5,1.5C23.697,47.857,24.369,48.528,25.197,48.528z M42.947,53.096h-17.75  c-0.829,0-1.5,0.672-1.5,1.5s0.671,1.5,1.5,1.5h17.75c0.829,0,1.5-0.672,1.5-1.5S43.776,53.096,42.947,53.096z M37.994,60.664  H25.197c-0.829,0-1.5,0.672-1.5,1.5s0.671,1.5,1.5,1.5h12.797c0.829,0,1.5-0.672,1.5-1.5S38.823,60.664,37.994,60.664z   M72.877,69.777c-0.074-0.18-0.183-0.342-0.317-0.479c-0.003-0.003-0.004-0.007-0.007-0.01l-7.541-7.541  c-0.586-0.586-1.535-0.586-2.121,0s-0.586,1.535,0,2.121l4.982,4.982H53.326c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5h14.543  l-4.98,4.98c-0.586,0.586-0.586,1.535,0,2.121c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439l7.532-7.532  c0.145-0.142,0.26-0.313,0.338-0.503c0.002-0.006,0.003-0.011,0.005-0.017c0.067-0.171,0.107-0.355,0.107-0.55v-0.004  c-0.001-0.19-0.04-0.372-0.105-0.54C72.883,69.798,72.882,69.788,72.877,69.777z M68.49,50.063V24.422  c0-0.396-0.156-0.775-0.435-1.057L53.972,9.157c-0.282-0.284-0.665-0.444-1.065-0.444H17.154c-0.829,0-1.5,0.672-1.5,1.5V78.97  c0,0.828,0.671,1.5,1.5,1.5h27.938c3.574,6.442,10.441,10.817,18.317,10.817c11.545,0,20.937-9.392,20.937-20.936  C84.346,60.562,77.583,52.344,68.49,50.063z M54.406,13.857l8.985,9.064h-8.985V13.857z M43.745,77.47h-25.09V11.713h32.752v12.709  c0,0.828,0.672,1.5,1.5,1.5H65.49V49.52c-0.685-0.068-1.379-0.105-2.081-0.105c-11.545,0-20.938,9.393-20.938,20.938  C42.472,72.854,42.936,75.244,43.745,77.47z M63.409,88.287c-9.891,0-17.938-8.046-17.938-17.936  c0-9.891,8.047-17.938,17.938-17.938s17.937,8.047,17.937,17.938C81.346,80.241,73.3,88.287,63.409,88.287z\"></path></svg>\n\t\t\t<span ng-bind=\"'MODULE_NAME_requests' | translate\"></span>\n\t\t\t<span ng-bind=\"$ctrl.badges['/api/create-company-requests']\" ng-if=\"$ctrl.badges['/api/create-company-requests'] !== 0\" class=\"badge badge-info\"></span>\n\t\t</li>\n\n    <li class=\"header\">Portal Przewoźnika</li>\n\n\t\t<li class=\"sidebar-brand svg-icon\" ui-sref=\"portalAddCompanyRequests\" ui-sref-active=\"active\" permission-show=\"companies.manage\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><path d=\"M25.197,40.961h33.75c0.828,0,1.5-0.671,1.5-1.5c0-0.828-0.672-1.5-1.5-1.5h-33.75c-0.829,0-1.5,0.672-1.5,1.5  C23.697,40.29,24.369,40.961,25.197,40.961z M25.197,32.519h33.75c0.828,0,1.5-0.671,1.5-1.5c0-0.828-0.672-1.5-1.5-1.5h-33.75  c-0.829,0-1.5,0.672-1.5,1.5C23.697,31.848,24.369,32.519,25.197,32.519z M25.197,48.528h27.75c0.828,0,1.5-0.671,1.5-1.5  c0-0.828-0.672-1.5-1.5-1.5h-27.75c-0.829,0-1.5,0.672-1.5,1.5C23.697,47.857,24.369,48.528,25.197,48.528z M42.947,53.096h-17.75  c-0.829,0-1.5,0.672-1.5,1.5s0.671,1.5,1.5,1.5h17.75c0.829,0,1.5-0.672,1.5-1.5S43.776,53.096,42.947,53.096z M37.994,60.664  H25.197c-0.829,0-1.5,0.672-1.5,1.5s0.671,1.5,1.5,1.5h12.797c0.829,0,1.5-0.672,1.5-1.5S38.823,60.664,37.994,60.664z   M72.877,69.777c-0.074-0.18-0.183-0.342-0.317-0.479c-0.003-0.003-0.004-0.007-0.007-0.01l-7.541-7.541  c-0.586-0.586-1.535-0.586-2.121,0s-0.586,1.535,0,2.121l4.982,4.982H53.326c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5h14.543  l-4.98,4.98c-0.586,0.586-0.586,1.535,0,2.121c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439l7.532-7.532  c0.145-0.142,0.26-0.313,0.338-0.503c0.002-0.006,0.003-0.011,0.005-0.017c0.067-0.171,0.107-0.355,0.107-0.55v-0.004  c-0.001-0.19-0.04-0.372-0.105-0.54C72.883,69.798,72.882,69.788,72.877,69.777z M68.49,50.063V24.422  c0-0.396-0.156-0.775-0.435-1.057L53.972,9.157c-0.282-0.284-0.665-0.444-1.065-0.444H17.154c-0.829,0-1.5,0.672-1.5,1.5V78.97  c0,0.828,0.671,1.5,1.5,1.5h27.938c3.574,6.442,10.441,10.817,18.317,10.817c11.545,0,20.937-9.392,20.937-20.936  C84.346,60.562,77.583,52.344,68.49,50.063z M54.406,13.857l8.985,9.064h-8.985V13.857z M43.745,77.47h-25.09V11.713h32.752v12.709  c0,0.828,0.672,1.5,1.5,1.5H65.49V49.52c-0.685-0.068-1.379-0.105-2.081-0.105c-11.545,0-20.938,9.393-20.938,20.938  C42.472,72.854,42.936,75.244,43.745,77.47z M63.409,88.287c-9.891,0-17.938-8.046-17.938-17.936  c0-9.891,8.047-17.938,17.938-17.938s17.937,8.047,17.937,17.938C81.346,80.241,73.3,88.287,63.409,88.287z\"></path></svg>\n\t\t\t<span ng-bind=\"'MODULE_NAME_PortalAddCompanyRequests' | translate\"></span>\n\t\t\t<span ng-bind=\"$ctrl.badges['/api/portal-add-company-requests']\" ng-if=\"$ctrl.badges['/api/portal-add-company-requests'] !== 0\" class=\"badge badge-info\"></span>\n\t\t</li>\n\n\t</ul>\n\t<ul class=\"sidebar-footer\">\n\t\t<li class=\"sidebar-brand\" ui-sref=\"users.update({uri: (('' | me).uri | encodeUri)})\">\n\t\t\t<span class=\"fa fa-user\"></span>\n\t\t\t<span ng-bind=\"'USER_PROFILE' | translate\"></span>\n\t\t</li>\n    <li class=\"sidebar-brand\">\n\t\t\t<a href=\"mailto:portalskat@skat.com.pl\">\n        <span class=\"fa fa-question-circle\"></span>\n\t\t\t  <span ng-bind=\"'CONTACT' | translate\"></span>\n      </a>\n\t\t</li>\n\t\t<li class=\"sidebar-brand\" ng-click=\"sidebar.logout()\">\n\t\t\t<span class=\"fa fa-sign-out\"></span>\n\t\t\t<span ng-bind=\"'USER_LOGOUT' | translate\"></span>\n\t\t</li>\n\t</ul>\n</div>";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SidebarController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$search", "CONFIG"];
	
	var SidebarController = exports.SidebarController = function (_$controller) {
		SidebarController.$inject = ["$injector"];
		(0, _inherits3.default)(SidebarController, _$controller);
	
		function SidebarController($injector) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, SidebarController);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (SidebarController.__proto__ || (0, _getPrototypeOf2.default)(SidebarController)).call(this, $injector, dependencies));
	
			_this.badges = [];
	
			_this.$rootScope.$on("$watchCollection", function (e, data) {
	
				if (data.uri.indexOf("company-requests") !== -1) {
					_this.$rootScope.$apply(function () {
						_this.updateBadge(data.uri);
					});
				}
			});
	
			_this.$rootScope.$on("updateBadge", function (e, uri) {
				return _this.updateBadge(uri);
			});
			return _this;
		}
	
		(0, _createClass3.default)(SidebarController, [{
			key: "$onInit",
			value: function $onInit() {
				var _this2 = this;
	
				var count = function count(key) {
					return _this2.$search.$search(_this2.CONFIG.API[key], { filter: { status: "pending" } }).then(function (data) {
						_this2.badges[_this2.CONFIG.API[key]] = data.objects.filter(function (o) {
							return o.status == "pending";
						}).length;
					});
				};
	
				this.$getDataBeforeRun([count("CreateCompanyRequests"), count("PortalAddCompanyRequests")]);
			}
		}, {
			key: "updateBadge",
			value: function updateBadge(uri) {
				this.badges[uri] = this.$getCollection(uri).filter(function (o) {
					return o.status == "pending";
				}).length;
			}
		}, {
			key: "isAuthenticated",
			value: function isAuthenticated() {
				return this.$auth.isAuthenticated();
			}
		}, {
			key: "logout",
			value: function logout() {
				return this.$auth.logout();
			}
		}]);
		return SidebarController;
	}(_index.$controller);
	
	exports.default = SidebarController;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(230);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sidebar.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./sidebar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _configurationsRouter = __webpack_require__(232);
	
	var _configurationsRouter2 = _interopRequireDefault(_configurationsRouter);
	
	var _configurationsComponent = __webpack_require__(233);
	
	var _configurationsComponent2 = _interopRequireDefault(_configurationsComponent);
	
	var _configurationList = __webpack_require__(236);
	
	var _configurationList2 = _interopRequireDefault(_configurationList);
	
	var _configurationUpdate = __webpack_require__(269);
	
	var _configurationUpdate2 = _interopRequireDefault(_configurationUpdate);
	
	var _quickSetup = __webpack_require__(293);
	
	var _quickSetup2 = _interopRequireDefault(_quickSetup);
	
	var _scenes = __webpack_require__(318);
	
	var _scenes2 = _interopRequireDefault(_scenes);
	
	var _scenesList = __webpack_require__(323);
	
	var _scenesList2 = _interopRequireDefault(_scenesList);
	
	var _liveView = __webpack_require__(336);
	
	var _liveView2 = _interopRequireDefault(_liveView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Module = angular.module("app.configurations", []).component("configurations", _configurationsComponent2.default).component("configurationList", _configurationList2.default).component("configurationUpdate", _configurationUpdate2.default).component("quickSetup", _quickSetup2.default).component("scenes", _scenes2.default).component("liveView", _liveView2.default).component("scenesList", _scenesList2.default).config(_configurationsRouter2.default);
	
	exports.default = Module;

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	"use strict";
	
	Router.$inject = ["$stateProvider", "$urlRouterProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Router;
	function Router($stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $urlRouterProvider.when("/app/configurations", "/app/configurations/");
	
	    $stateProvider.state({
	        name: "configurations",
	        url: "/app/configurations",
	        template: "<configurations></configurations>"
	    }).state({
	        name: "configurations.list",
	        url: "/",
	        template: "<configuration-list></configuration-list>",
	        resolve: {
	            $title: function $title() {
	                return "Configurations | UpReach Cloud";
	            }
	        }
	    }).state({
	        name: "configurations.update",
	        url: "/:cid/?:isNew",
	        template: "<configuration-update></configuration-update>",
	        resolve: {
	            $title: function $title() {
	                return "Configuration Update | UpReach Cloud";
	            }
	        }
	    }).state({
	        name: "configurations.setup",
	        url: "/setup/:cid/?:isNew",
	        template: "<quick-setup></quick-setup>",
	        resolve: {
	            $title: function $title() {
	                return "Configuration Setup | UpReach Cloud";
	            }
	        }
	    }).state({
	        name: "configurations.create",
	        url: "/create",
	        template: "<configuration-update></configuration-update>",
	        resolve: {
	            $title: function $title() {
	                return "Configuration Create | UpReach Cloud";
	            }
	        }
	    });
	}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _configurations = __webpack_require__(234);
	
	var _configurations2 = _interopRequireDefault(_configurations);
	
	var _configurations3 = __webpack_require__(235);
	
	var _configurations4 = _interopRequireDefault(_configurations3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigurationsComponent = {
		template: _configurations2.default,
		controller: _configurations4.default,
		controllerAs: "controller"
	};
	
	exports.default = ConfigurationsComponent;

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Controller = function (_$controller) {
	    Controller.$inject = ["$injector"];
	    (0, _inherits3.default)(Controller, _$controller);
	
	    function Controller($injector) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, Controller);
	        return (0, _possibleConstructorReturn3.default)(this, (Controller.__proto__ || (0, _getPrototypeOf2.default)(Controller)).call(this, $injector));
	    }
	
	    return Controller;
	}(_index.$controller);
	
	exports.default = Controller;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _configurationList = __webpack_require__(237);
	
	var _configurationList2 = _interopRequireDefault(_configurationList);
	
	var _configurationList3 = __webpack_require__(238);
	
	var _configurationList4 = _interopRequireDefault(_configurationList3);
	
	__webpack_require__(267);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Component = {
		template: _configurationList2.default,
		controller: _configurationList4.default,
		controllerAs: "controller"
	};
	
	exports.default = Component;

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	module.exports = "<md-content layout=\"column\" flex layout-align=\"top center\">\n    <md-card>\n        <md-toolbar class=\"md-table-toolbar md-default\" ng-hide=\"options.rowSelection && selected.length\">\n            <div class=\"md-toolbar-tools\">\n                <span>Configurations</span>\n                <div flex></div>\n\n                <div flex=\"70\" class=\"md-toolbar-tools md-toolbar-search\" ng-if=\"filter.show\" layout=\"row\" layout-align=\"center right\">\n                    <md-input-container md-no-float flex>\n                        <input ng-blur=\"controller.onSearchBlur()\" type=\"text\" id=\"search-field\" placeholder=\"Search in the Configurations\" ng-model=\"query.search\" ng-model-options=\"filter.options\" class=\"ng-pristine ng-valid ng-touched\">\n                    </md-input-container>\n                    <button class=\"md-icon-button md-button md-ink-ripple\" type=\"button\" ng-click=\"controller.removeFilter()\" layout-align=\"center right\">\n                        <md-icon class=\"material-icons\">search</md-icon>\n                        <div class=\"md-ripple-container\"></div>\n                    </button>\n                </div>\n                <md-button class=\"md-icon-button md-button md-ink-ripple\" ng-click=\"controller.showFilter()\" ng-if=\"!filter.show\" ng-show=\"configurations._meta.count\">\n                    <md-icon class=\"material-icons\">search</md-icon>\n                    <div class=\"md-ripple-container\"></div>\n                </md-button>\n\n                <md-button class=\"md-icon-button\" ng-click=\"controller.addNew()\" ng-show=\"!loading\">\n                    <md-icon class=\"material-icons\">add</md-icon>\n                </md-button>\n            </div>\n        </md-toolbar>\n\n        <md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"options.rowSelection && selected.length\">\n            <div class=\"md-toolbar-tools\">\n                <span>{{selected.length}} {{selected.length > 1 ? 'items' : 'item'}} selected</span>\n            </div>\n        </md-toolbar>\n\n        <md-table-container ng-if=\"! configurations._meta.count\" class=\"no-items\">\n            <div ng-if=\"loading\" translate>Loading configurations...</div>\n            <div ng-if=\"!loading && !filter.show\" translate>You have no configurations available.<br/> Press the Plus button on the top right of this table to add your first configuration!</div>\n            <div ng-if=\"!loading && filter.show\" translate>No results found for: '{{ query.search }}'</div>\n        </md-table-container>\n        <md-table-container ng-if=\"configurations._meta.count\">\n            <table md-table md-row-select=\"options.rowSelection\" multiple=\"{{options.multiSelect}}\" ng-model=\"selected\" md-progress=\"promise\">\n                <thead ng-if=\"!options.decapitate\" md-head md-order=\"query.order\" md-on-reorder=\"logOrder\">\n                <tr md-row>\n                    <th md-column md-order-by=\"_name\"><span>{{'Configuration Name' | translate}}</span></th>\n                    <th md-column md-order-by=\"_company__name\" ng-hide=\"controller.isClient()\"><span>{{'Client Name' | translate}}</span></th>\n                    <th md-column md-order-by=\"_deployments__name\"><span>{{'Deployments' | translate}}</span></th>\n                    <th md-column md-order-by=\"_updated\"><span>{{'Last Edited' | translate}}</span></th>\n                    <th md-column></th>\n                </tr>\n                </thead>\n                <tbody md-body>\n                <tr md-row md-select=\"configuration\" md-on-select=\"logItem\" md-auto-select=\"options.autoSelect\" class=\"md-row\"\n                    ng-repeat=\"item in configurations | filter: filter.search | orderBy: query.order | limitTo: query.limit : (query.page -1) * query.limit\"\n                    ng-click=\"controller.openConfig(item)\">\n                    <td md-cell class=\"underline-on-hover show-button-on-hover\" ng-click=\"controller.editName($event, item)\">{{item.name}}<md-button\n                            aria-label=\"{{'Edit configuration name' | translate }}\" class=\"md-icon-button\">\n                              <md-icon class=\"material-icons\">edit</md-icon>\n                        </md-button>\n                    </td>\n                    <td md-cell ng-hide=\"controller.isClient()\"> <!-- {{item.company | relation:companies:\"name\"}} -->\n                        <api-select-search\n                                model=\"item.company\"\n                                multiple=\"false\"\n                                collection=\"company\"\n                                selected-values=\"[item.company_info]\"\n                                on-value-change=\"controller.changeCompany(value, item)\"\n                                label=\"'No company'\"\n                                search-label=\"'Search company'\"></api-select-search>\n                        <span ng-bind=\"item.company | getObjectByUrl:companies:'name'\"\n                              permission-hide=\"Admin,Manager\">\n                        </span>\n                    </td>\n                    <td md-cell>\n                        <span title=\"{{controller.transformDeploymentsArr(item.deployments_info, true)}}\">{{controller.transformDeploymentsArr(item.deployments_info)}}</span>\n                    </td>\n                    <td md-cell>\n                        <span>{{item.updated}}</span>\n                    </td>\n                    <td md-cell layout=\"row\" layout-align=\"center end\">\n                        <span flex></span>\n                        <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\" ng-if=\"item.url == companies[item.company].default_configuration\">star</md-icon>\n                        <md-menu md-position-mode=\"target-right target\" aria-label=\"*\">\n                          <md-button aria-label=\"Menu options\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                              <md-icon class=\"material-icons\">more_vert</md-icon>\n                          </md-button>\n                          <md-menu-content width=\"3\" >\n<!--                            <md-menu-item permission-hide=\"Client,Sub-User\">-->\n<!--                              <md-button ng-click=\"controller.showSecretID($event, item)\">-->\n<!--                                  <div layout=\"row\" flex>-->\n<!--                                    <p flex translate>Configuration ID</p>-->\n<!--                                    <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">fingerprint</md-icon>-->\n<!--                                  </div>-->\n<!--                              </md-button>-->\n<!--                            </md-menu-item>-->\n                            <md-menu-item>\n                              <md-button ng-click=\"controller.addNew($event, item)\">\n                                  <div layout=\"row\" flex>\n                                    <p flex translate>Copy configuration</p>\n                                    <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">content_copy</md-icon>\n                                  </div>\n                              </md-button>\n                            </md-menu-item>\n                              <md-menu-item>\n                                  <md-button ng-click=\"controller.openInNewTab(item.url | getObjectId, item.json.admin.isAdvanced)\">\n                                      <div layout=\"row\" flex>\n                                          <p flex translate>Open in new tab</p>\n                                          <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">tab</md-icon>\n                                      </div>\n                                  </md-button>\n                              </md-menu-item>\n                              <md-menu-item>\n                                  <md-button ng-click=\"controller.downloadAllAssets($event, item)\">\n                                      <div layout=\"row\" flex>\n                                          <p flex translate>Download assets</p>\n                                          <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">file_download</md-icon>\n                                      </div>\n                                  </md-button>\n                              </md-menu-item>\n                            <md-menu-item>\n                              <md-button ng-click=\"controller.openDeleteDialog($event, item)\">\n                                  <div layout=\"row\" flex>\n                                    <p flex translate>Delete</p>\n                                    <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">delete</md-icon>\n                                  </div>\n                              </md-button>\n                            </md-menu-item>\n                          </md-menu-content>\n                        </md-menu>\n                    </td>\n\n                </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <button md-button ng-if=\"canAddMore && !loading\" ng-click=\"controller.addMoreItems()\" style=\"color: #FF0051\">Load more</button>\n\n        <!--<md-table-pagination ng-if=\"configurations._meta.count > 10\" md-limit=\"10\"  md-page=\"query.page\" md-page-select=\"true\" md-total=\"{{configurations._meta.count}}\"  ></md-table-pagination>-->\n    </md-card>\n</md-content>\n";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(239);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	var _secretidController = __webpack_require__(256);
	
	var _secretidController2 = _interopRequireDefault(_secretidController);
	
	var _secretid = __webpack_require__(257);
	
	var _secretid2 = _interopRequireDefault(_secretid);
	
	var _configurationCreate = __webpack_require__(258);
	
	var _configurationCreate2 = __webpack_require__(259);
	
	var _configurationCreate3 = _interopRequireDefault(_configurationCreate2);
	
	var _deleteDialog = __webpack_require__(260);
	
	var _deleteDialog2 = __webpack_require__(261);
	
	var _deleteDialog3 = _interopRequireDefault(_deleteDialog2);
	
	var _defaulfConfigConstant = __webpack_require__(262);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Company", "$Configuration", "$companies", "gettextCatalog", "$mdEditDialog"];
	
	var Controller = function (_$controller) {
	    Controller.$inject = ["$injector", "$scope", "$state", "$timeout", "$auth", "$window", "$ToastService", "$UndoDeleteService"];
	    (0, _inherits3.default)(Controller, _$controller);
	
	    function Controller($injector, $scope, $state, $timeout, $auth, $window, $ToastService, $UndoDeleteService) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, Controller);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Controller.__proto__ || (0, _getPrototypeOf2.default)(Controller)).call(this, $injector, dependencies));
	
	        _this.$state = $state;
	        _this.$timeout = $timeout;
	        _this.$window = $window;
	        _this.$auth = $auth;
	        _this.$scope = $scope;
	        _this.$scope.loading = true;
	        _this.$scope.query = { page: 1, search: "" };
	        _this.$scope.filter = {};
	        _this.$scope.configurations = [];
	        _this.$scope.pageCount = 0;
	        _this.$scope.canAddMore = true;
	        _this.toastService = $ToastService;
	        _this.undoDelete = $UndoDeleteService;
	        _this.$scope.logOrder = function () {
	            _this.$scope.query.ordering = _this.$scope.query.order.replace("_", "");
	            _this.query(true);
	        };
	
	        _this.searchByKeyPress = function (event) {
	            var keyName = event.key;
	            var letters = "abcdefghijklmnopqrstuvwxyz";
	            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
	                _this.$scope.$apply(function () {
	                    _this.$scope.filter.show = true;
	                    if (!_this.$scope.query.search) {
	                        _this.$scope.query.search = keyName;
	                    }
	                });
	                (0, _lodash.delay)(function () {
	                    document.getElementById("search-field").focus();
	                }, 100);
	            }
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Controller, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.$scope.filter.show = false;
	            this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
	            document.addEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "$onDestroy",
	        value: function $onDestroy() {
	            document.removeEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "query",
	        value: function query(isNew) {
	            var _this2 = this;
	
	            this.$scope.query.page = isNew ? 1 : this.$scope.query.page;
	
	            var configurations = this.$Configuration.query(this.$scope.query);
	            _promise2.default.all([configurations.$promise]).then(function () {
	                var _$scope$configuration;
	
	                _this2.$scope.query.page = configurations._meta.page || 1;
	                _this2.$scope.loading = false;
	
	                isNew ? _this2.$scope.configurations = configurations : (_$scope$configuration = _this2.$scope.configurations).push.apply(_$scope$configuration, (0, _toConsumableArray3.default)(configurations));
	                _this2.$scope.pageCount = configurations._meta.page_count;
	                _this2.$scope.canAddMore = _this2.$scope.query.page !== _this2.$scope.pageCount;
	
	                _this2.$scope.$apply();
	            }).catch(function () {
	                _this2.toastService.showError("Can't load list of configurations", 5000);
	            });
	        }
	    }, {
	        key: "openDeleteDialog",
	        value: function openDeleteDialog(ev, item) {
	            var _this3 = this;
	
	            this.$mdDialog.show({
	                title: "Configuration Delete",
	                controller: _deleteDialog.DeleteDialogController,
	                template: _deleteDialog3.default,
	                targetEvent: event,
	                locals: {
	                    callback: function callback() {
	                        _this3.deleteItem(ev, item);
	                    },
	                    target: "configuration",
	                    item: item
	                }
	            });
	        }
	    }, {
	        key: "downloadAllAssets",
	        value: function downloadAllAssets(event, item) {
	            var _this4 = this;
	
	            this.$auth.$http({
	                url: "/api/configuration-assets-zip/",
	                method: "PUT",
	                data: {
	                    configuration: item.id,
	                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
	                }
	            }).then(function (resp) {
	                if (resp.data && resp.data.zip_url) {
	                    _this4.createZip(resp.data.zip_url);
	                } else {
	                    _this4.$mdToast.show(_this4.$mdToast.simple().position("bottom right").hideDelay(5000).textContent("This configuration has no assets!"));
	                }
	            }).catch(function (e) {
	                console.log(e);
	            });
	        }
	    }, {
	        key: "createZip",
	        value: function createZip(zipUrl) {
	            var _this5 = this;
	
	            this.created = false;
	            var interval = null;
	            var MAX_TRIES = 60; // *5 sec
	
	
	            var tryDownload = function tryDownload() {
	                _this5.downloadZip(zipUrl).then(function (resp) {
	                    _this5.created = true;
	                    window.location.assign(resp.data.file);
	                }).catch(function (e) {
	                    if (e.status === 510) {
	                        _this5.created = false;
	                    } else {
	                        _this5.created = true;
	                    }
	                });
	            };
	            var ping = 0;
	            interval = setInterval(function () {
	                if (_this5.created || ping >= MAX_TRIES) {
	                    clearInterval(interval);
	                    if (ping >= MAX_TRIES) {
	                        _this5.$mdToast.show(_this5.$mdToast.simple().position("bottom right").hideDelay(5000).textContent("Download time turned out!"));
	                    }
	                } else {
	                    ping++;
	                    tryDownload();
	                }
	            }, 5000);
	        }
	    }, {
	        key: "downloadZip",
	        value: function downloadZip(url) {
	            var _this6 = this;
	
	            return this.$auth.$http({
	                url: url,
	                method: "GET"
	            }).then(function (resp) {
	                return resp;
	            }).catch(function (e) {
	                return _this6.$q.reject(e);
	            });
	        }
	    }, {
	        key: "deleteItem",
	        value: function deleteItem(ev, item) {
	            var _this7 = this;
	
	            item.$delete().then(function () {
	                _this7.toastService.deleteToast("Deleted configuration \"" + item.name + "\".", function () {
	                    _this7.undoDelete.undoDelete("configurations", item.id).then(function () {
	                        _this7.toastService.showSimple("Deletion undone", 5000);
	                        _this7.query(true);
	                    }).catch(function () {
	                        _this7.toastService.showError("Could not undone deletion", 5000);
	                    });
	                });
	                _this7.query(true);
	            }).catch(function (err) {
	                console.log(err);
	                _this7.toastService.showError("Could not delete configuration \"" + item.name + "\".", 5000);
	            });
	        }
	    }, {
	        key: "addMoreItems",
	        value: function addMoreItems() {
	            this.$scope.query.page++;
	            this.query();
	        }
	    }, {
	        key: "onQueryFilterChange",
	        value: function onQueryFilterChange() {
	            var _this8 = this;
	
	            this.$scope.query.page = 1;
	            var newValue = (0, _lodash.clone)(this.$scope.query.search);
	            this.$scope.loading = true;
	            this.searhDelayTimeout = setTimeout(function () {
	                var prewValue = (0, _lodash.clone)(_this8.$scope.query.search);
	                if (prewValue === newValue) {
	                    clearTimeout(_this8.searhDelayTimeout);
	                    _this8.query(true);
	                }
	            }, 500);
	        }
	    }, {
	        key: "addNew",
	        value: function addNew(event) {
	            var _this9 = this;
	
	            var sourceConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            console.log(this.$auth.isRole("Admin"));
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Create new configuration",
	                controller: _configurationCreate.ConfigurationCreateController,
	                template: _configurationCreate3.default,
	                targetEvent: event,
	                locals: {
	                    callback: function callback(configuration) {
	                        _this9.createConfig(configuration);
	                    },
	                    companies: this.$scope.companies,
	                    userCompany: this.$companies.getCached(),
	                    sourceConfig: sourceConfig
	                }
	            });
	        }
	    }, {
	        key: "transformDeploymentsArr",
	        value: function transformDeploymentsArr(arr, title) {
	            var newArr = [];
	            (0, _lodash.forEach)(arr, function (dp) {
	                newArr.push(dp.name);
	            });
	            var str = newArr.length > 1 ? newArr.join(title ? "\n" : ", ") : newArr.join("");
	            return str.length > 25 && !title ? str.slice(0, 25) + " ..." : str;
	        }
	    }, {
	        key: "createConfig",
	        value: function createConfig(configuration) {
	            var _this10 = this;
	
	            var createConfig = function createConfig() {
	                var newConfig = _this10.$Configuration.create(configuration);
	                newConfig.$promise.then(function () {
	                    return _this10.$scope.configurations.unshift(newConfig);
	                }).then(function () {
	                    _this10.openConfig(newConfig);
	                });
	            };
	            // get default configuration if set
	            configuration.json = configuration.json || _defaulfConfigConstant.DEFAULT_CONFIG;
	            if (this.$auth.isRole("Admin") || this.$auth.isRole("Manager")) {
	                configuration = this.changeDefaultConfigForAdmins(configuration);
	            }
	            configuration.json.admin.isAdvanced = !configuration.enableWizard;
	            delete configuration.enableWizard;
	            createConfig();
	        }
	    }, {
	        key: "showSecretID",
	        value: function showSecretID(ev, item) {
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Set/Share Configuration ID",
	                controller: _secretidController2.default,
	                template: _secretid2.default,
	                targetEvent: ev,
	                escapeToClose: false,
	                locals: {
	                    selectedItem: item,
	                    secretKind: this.gettextCatalog.getString("Configuration")
	                }
	            });
	        }
	    }, {
	        key: "editName",
	        value: function editName(ev, item) {
	            var _this11 = this;
	
	            if (["md-icon", "button"].indexOf(ev.target.tagName.toLowerCase()) < 0) return; // workaround for editDialog requirement - currentTarget = table cell.
	
	            ev.stopPropagation();
	
	            var editDialog = {
	                modelValue: item.name,
	                placeholder: this.gettextCatalog.getString("Enter new name"),
	                save: function save(input) {
	                    item.name = input.$modelValue;
	                    item.$update().then(function () {
	                        _this11.toastService.showSimple("Saved new configuration name \"" + item.name + "\".", 5000);
	                    }).catch(function () {
	                        _this11.toastService.showError("Could not save new configuration name \"" + item.name + "\".", 5000);
	                    });
	                },
	                targetEvent: ev,
	                title: this.gettextCatalog.getString("Enter new name"),
	                validators: {
	                    "md-maxlength": 50
	                }
	            };
	
	            this.$mdEditDialog.small(editDialog).then(function () {
	                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                    args[_key] = arguments[_key];
	                }
	
	                console.log("$mdEditDialog promise resolved with args: ", args);
	            });
	        }
	    }, {
	        key: "setAsCompanyDefault",
	        value: function setAsCompanyDefault(ev, item) {
	            var _this12 = this;
	
	            var company = this.$scope.companies[item.company_info];
	            var msgText = "";
	            if (company.default_configuration === item.url) {
	                company.default_configuration = null;
	                msgText = "Configuration \"" + item.name + "\" is now unset from the default for \"" + company.name + "\"";
	            } else {
	                company.default_configuration = item.url;
	                msgText = "Configuration \"" + item.name + "\" is now the default for \"" + company.name + "\"";
	            }
	            company.$update().then(function () {
	                _this12.toastService.showSimple(msgText, 5000);
	            }).catch(function () {
	                _this12.toastService.showError("Could not set default configuration for \"" + company.name + "\".", 5000);
	            });
	        }
	    }, {
	        key: "removeFilter",
	        value: function removeFilter() {
	            this.$scope.filter.show = false;
	            this.$scope.query.search = "";
	        }
	    }, {
	        key: "showFilter",
	        value: function showFilter() {
	            this.$scope.filter.show = true;
	            (0, _lodash.delay)(function () {
	                document.getElementById("search-field").focus();
	            }, 100);
	        }
	    }, {
	        key: "changeCompany",
	        value: function changeCompany(value, item) {
	            var _this13 = this;
	
	            if (value && value.length) {
	                item.$update().then(function () {
	                    _this13.toastService.showSimple("Configuration updated", 5000);
	                    _this13.query(true);
	                }).catch(function () {
	                    _this13.toastService.showError("Could not update configuration \"" + item.name + "\".", 5000);
	                });
	            }
	        }
	    }, {
	        key: "openConfig",
	        value: function openConfig(item) {
	            if (item.json.admin.isAdvanced || item.json.admin.isAdvanced === undefined) {
	                this.$state.go("configurations.update", { cid: this.$filter("getObjectId")(item.url) });
	            } else if (item.json.admin.isAdvanced === false) {
	                this.$state.go("configurations.setup", { cid: this.$filter("getObjectId")(item.url) });
	            }
	        }
	    }, {
	        key: "onSearchBlur",
	        value: function onSearchBlur() {
	            if (!this.$scope.query.search) {
	                this.$scope.filter.show = false;
	            }
	        }
	    }, {
	        key: "changeDefaultConfigForAdmins",
	        value: function changeDefaultConfigForAdmins(config) {
	            config.json.admin.photoBooth.startScreenDesignSharing = false;
	
	            config.json.admin.gifBooth.startScreenDesignSharing = false;
	
	            config.json.admin.boomerangBooth.startScreenDesignSharing = false;
	
	            config.json.admin.digitalStartScreenDesign = false;
	            config.json.admin.printStartScreenDesign = false;
	            config.json.admin.stripStartScreenDesign = false;
	
	            return config;
	        }
	    }, {
	        key: "isClient",
	        value: function isClient() {
	            return this.$auth.isRole("Client") || this.$auth.isRole("Sub-User");
	        }
	    }, {
	        key: "openInNewTab",
	        value: function openInNewTab(id, isAdvanced) {
	            if (isAdvanced || isAdvanced === undefined) {
	                this.$window.open(this.$window.location.href + id + "/", "_black");
	            } else if (isAdvanced === false) {
	                this.$window.open(this.$window.location.href + "setup/" + id + "/", "_blank");
	            }
	        }
	    }]);
	    return Controller;
	}(_index.$controller);
	
	exports.default = Controller;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(240), __esModule: true };

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(79);
	__webpack_require__(41);
	__webpack_require__(62);
	__webpack_require__(241);
	__webpack_require__(254);
	__webpack_require__(255);
	module.exports = __webpack_require__(14).Promise;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(16);
	var global = __webpack_require__(15);
	var ctx = __webpack_require__(20);
	var classof = __webpack_require__(99);
	var $export = __webpack_require__(19);
	var isObject = __webpack_require__(25);
	var aFunction = __webpack_require__(21);
	var anInstance = __webpack_require__(242);
	var forOf = __webpack_require__(243);
	var speciesConstructor = __webpack_require__(244);
	var task = __webpack_require__(245).set;
	var microtask = __webpack_require__(247)();
	var newPromiseCapabilityModule = __webpack_require__(248);
	var perform = __webpack_require__(249);
	var userAgent = __webpack_require__(250);
	var promiseResolve = __webpack_require__(251);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(61)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(252)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(60)($Promise, PROMISE);
	__webpack_require__(253)(PROMISE);
	Wrapper = __webpack_require__(14)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(100)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(20);
	var call = __webpack_require__(95);
	var isArrayIter = __webpack_require__(96);
	var anObject = __webpack_require__(24);
	var toLength = __webpack_require__(56);
	var getIterFn = __webpack_require__(98);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(24);
	var aFunction = __webpack_require__(21);
	var SPECIES = __webpack_require__(61)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(20);
	var invoke = __webpack_require__(246);
	var html = __webpack_require__(59);
	var cel = __webpack_require__(29);
	var global = __webpack_require__(15);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(54)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 246 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var macrotask = __webpack_require__(245).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(54)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(21);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 249 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(24);
	var isObject = __webpack_require__(25);
	var newPromiseCapability = __webpack_require__(248);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(22);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var core = __webpack_require__(14);
	var dP = __webpack_require__(23);
	var DESCRIPTORS = __webpack_require__(27);
	var SPECIES = __webpack_require__(61)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(19);
	var core = __webpack_require__(14);
	var global = __webpack_require__(15);
	var speciesConstructor = __webpack_require__(244);
	var promiseResolve = __webpack_require__(251);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(19);
	var newPromiseCapability = __webpack_require__(248);
	var perform = __webpack_require__(249);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 256 */
/***/ (function(module, exports) {

	"use strict";
	
	SecretIdDialogController.$inject = ["$scope", "$mdDialog", "gettextCatalog", "selectedItem", "secretKind"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SecretIdDialogController;
	function SecretIdDialogController($scope, $mdDialog, gettextCatalog, selectedItem, secretKind) {
	    "ngInject";
	
	    $scope.selectedItem = selectedItem;
	    var original_secret_id = selectedItem.secret_id;
	    $scope.secretKind = secretKind;
	    $scope.status = { info: true };
	
	    $scope.$watch("selectedItem.secret_id", function (curr) {
	        if (curr != original_secret_id) {
	            $scope.status = { modify: true };
	        }
	    });
	
	    $scope.closeDialog = function () {
	        if ($scope.status.alreadyTaken) {
	            $scope.selectedItem.secret_id = original_secret_id;
	        }
	        $mdDialog.hide();
	    };
	
	    $scope.copyToClipboard = function () {
	        document.getElementById("secret_id_input").select();
	        document.execCommand("copy");
	        $scope.status = { copied: true };
	    };
	
	    $scope.saveSecretID = function () {
	        $scope.selectedItem.$update().then(function () {
	            $scope.status = { saved: true };
	        }).catch(function () {
	            $scope.status = { alreadyTaken: true };
	        });
	    };
	    $scope.removeSpacing = function () {
	        $scope.selectedItem.secret_id = $scope.selectedItem.secret_id.replace(/\s+/g, "");
	    };
	}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Reveal Secret ID Dialog\">\n    <md-dialog-content translate layout=\"column\">\n        <div class=\"md-dialog-content\">\n            <div translate>Your {{secretKind}} ID:</div>\n            <div layout=\"row\" flex>\n                <md-input-container flex class=\"md-icon-float md-block md-title\" style=\"width: 200px\">\n                    <input flex=\"grow\" ng-model=\"selectedItem.secret_id\" id=\"secret_id_input\" flex-order=\"0\" ng-change=\"removeSpacing()\">\n\n                    <div ng-if=\"selectedItem.secret_id && selectedItem.secret_id.length >= 3\">\n                        <div class=\"hint info\" ng-if=\"status.info\" translate>Copy {{secretKind}} ID to clipboard for sharing or set custom one.</div>\n                        <div class=\"hint info\" ng-if=\"status.modify\" translate>Click `Save` to set your custom {{secretKind}} ID.</div>\n                        <div class=\"hint status\" ng-if=\"status.copied\" translate>You can now share your {{secretKind}} ID. Paste it into an e-mail or messenger.</div>\n                        <div class=\"hint status\" ng-if=\"status.saved\" translate>Saved your custom {{secretKind}} ID. Copy to clipboard and share it.</div>\n                        <div class=\"hint error\" ng-if=\"status.alreadyTaken\" translate>This {{secretKind}} ID is already taken. Use different one.</div>\n                    </div>\n                    <div class=\"hint error\" ng-if=\"!selectedItem.secret_id || selectedItem.secret_id.length < 3\" translate>ID should be at least 3 characters length</div>\n\n                </md-input-container>\n                <div>\n                    <md-button class=\"md-icon-button md-primary\" ng-click=\"copyToClipboard()\" md-tooltip=\"{{'Copy to Clipboard' | translate}}\" flex=\"none\" flex-order=\"1\">\n                        <md-tooltip translate>Copy to clipboard for sharing</md-tooltip>\n                        <md-icon class=\"material-icons\">content_copy</md-icon>\n                    </md-button>\n                </div>\n            </div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\" class=\"md-primary\" translate ng-if=\"!status.modify\">\n            Close\n        </md-button>\n        <md-button ng-click=\"saveSecretID()\" class=\"md-primary\" translate ng-if=\"status.modify\" ng-disabled=\"!selectedItem.secret_id || selectedItem.secret_id.length < 3\">\n            Save\n        </md-button>\n    </md-dialog-actions>\n</md-dialog>";

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ConfigurationCreateController = exports.ConfigurationCreateController = ["$scope", "$mdDialog", "callback", "userCompany", "sourceConfig", function ConfigurationCreateController($scope, $mdDialog, callback, userCompany, sourceConfig) {
	    "ngInject";
	
	    $scope.callback = callback;
	    $scope.sourceConfig = sourceConfig;
	    $scope.configuration = {
	        company: $scope.sourceConfig ? $scope.sourceConfig.company : userCompany.url,
	        name: $scope.sourceConfig ? $scope.sourceConfig.name + " (copy)" : "",
	        enableWizard: $scope.sourceConfig ? !$scope.sourceConfig.json.admin.isAdvanced : false
	    };
	
	    // if json provided than clone configuration
	    $scope.sourceConfig && ($scope.configuration.json = $scope.sourceConfig.json);
	    $scope.selectedCompany = userCompany ? [userCompany] : [];
	
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	
	    $scope.create = function () {
	        callback($scope.configuration);
	        document.onkeypress = function () {};
	        $mdDialog.hide();
	    };
	
	    document.onkeypress = function (ev) {
	        if (ev.key === "Enter") {
	            if ($scope.configuration.company && $scope.configuration.name && $scope.configuration.name.length >= 3) {
	                $scope.create();
	            }
	        }
	    };
	}];

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Create new configuration\">\n    <md-dialog-content style=\"overflow: hidden; width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\" ng-if=\"!sourceConfig\">{{'Create new configuration' | translate}}</h2>\n            <h2 class=\"md-title\" ng-if=\"sourceConfig\">{{'Copy configuration' | translate}}</h2>\n            <form name=\"configurationCreateForm\">\n                <md-input-container md-no-float class=\"md-inline-form\" style=\"width: 100%;\">\n                    <label for=\"configurationName\">{{'Configuration name' | translate}}</label>\n                    <input\n                            flex=\"grow\"\n                            ng-model=\"configuration.name\"\n                            id=\"configurationName\"\n                            flex-order=\"0\"\n                            minlength=\"3\"\n                            maxlength=\"36\"\n                            md-autofocus\n                            required/>\n                </md-input-container>\n\n                <api-select-search\n                        model=\"configuration.company\"\n                        multiple=\"false\"\n                        collection=\"company\"\n                        selected-values=\"selectedCompany\"\n                        label=\"'Select company'\"\n                        width=\"100%\"\n                        search-label=\"'Search company'\"></api-select-search>\n\n                <md-switch md-invert\n                           ng-if=\"!sourceConfig\"\n                           ng-model=\"configuration.enableWizard\">\n                    Open in Quick Setup Wizard\n                </md-switch>\n            </form>\n        </div>\n\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n            ng-click=\"create()\"\n            class=\"md-primary\"\n            ng-disabled=\"!configuration.name || !configuration.company\">{{'Create' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>";

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DeleteDialogController = exports.DeleteDialogController = ["$scope", "$mdDialog", "callback", "target", "item", function DeleteDialogController($scope, $mdDialog, callback, target, item) {
	    "ngInject";
	
	    $scope.callback = callback;
	    $scope.target = target;
	    $scope.item = item;
	
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	
	    $scope.delete = function () {
	        callback();
	        $mdDialog.hide();
	    };
	}];

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Delete item\">\n    <md-dialog-content style=\"overflow: hidden; width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\" ng-if=\"!sourceConfig\">{{'Are you sure you want to delete ' + target + ' \"' + item.name + '\"?'| translate}}</h2>\n\n            <p ng-if=\"target === 'configuration' && item.deployments_info && item.deployments_info.length\">\n                This configuration is assigned to deployment(s):\n                <ul>\n                    <li ng-repeat=\"deployment in item.deployments_info\">{{deployment.name}};</li>\n                </ul>\n            </p>\n\n            <p ng-if=\"target === 'deployment' && item.configurations_info && item.configurations_info.length\">\n                This deployment has configuration(s) active:\n                <ul>\n                    <li ng-repeat=\"config in item.configurations_info\">{{config.name}};</li>\n                </ul>\n            </p>\n\n            <p ng-if=\"target === 'company' && item.booth_ids && item.booth_ids.length\">\n                This company has booth(s) assigned:\n                <ul>\n                    <li ng-repeat=\"booth in item.booth_ids\">{{booth}};</li>\n                </ul>\n            </p>\n        </div>\n\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"delete ()\"\n                class=\"md-primary\">{{'Delete' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DEFAULT_CONFIG = undefined;
	
	var _individualText = __webpack_require__(263);
	
	var DEFAULT_CONFIG = exports.DEFAULT_CONFIG = {
	    admin: {
	        ai: {
	            customLogo: {
	                active: false,
	                customLogoFile: null
	            },
	            wandershareApi: {
	                active: false,
	                aging_active: false,
	                aging_api_key: "",
	                aging_api_secret: "",
	                aging_age_slider_allowed: false,
	                aging_fixed_age: 0,
	                aging_priority: 0
	            },
	            replicate: {
	                replicate_remove_bg_active: false,
	                replicate_api_key: "",
	                replicate_prompting_active: false,
	                replicate_prompt_quality: "normal",
	                replicate_model: "google/nano-banana-2"
	            },
	            faceSwap: {
	                active: false,
	                face_swap_active: false,
	                face_swap_api_key: "",
	                face_swap_multi_active: false,
	                scenesNamesShow: false,
	                scenesBtnTitleShow: false,
	                sceneBtnTitle: "",
	                faceSwapScenes: {
	                    enabled: false,
	                    enable_animated_bg_files: false,
	                    randomizeSceneSelection: false,
	                    finalSize: {
	                        width: 333,
	                        height: 500
	                    },
	                    internalPictureSize: {
	                        width: 333,
	                        height: 500
	                    },
	                    layoutAspectRatio: {
	                        width: null,
	                        height: null
	                    },
	                    pictureAspectRatio: {
	                        width: null,
	                        height: null
	                    },
	                    internalPicturePosition: {
	                        topX: 0,
	                        topY: 0
	                    },
	                    internalPictureRotation: 0,
	                    scenesList: [],
	                    scenesNamesShow: false,
	                    opacity: 50,
	                    scenesBtnTitleShow: false,
	                    sceneBtnTitle: ""
	                },
	                faceSwapOverlays: {
	                    enabled: false,
	                    enable_animated_bg_files: false,
	                    randomizeSceneSelection: false,
	                    finalSize: {
	                        width: 333,
	                        height: 500
	                    },
	                    internalPictureSize: {
	                        width: 333,
	                        height: 500
	                    },
	                    layoutAspectRatio: {
	                        width: null,
	                        height: null
	                    },
	                    pictureAspectRatio: {
	                        width: null,
	                        height: null
	                    },
	                    internalPicturePosition: {
	                        topX: 0,
	                        topY: 0
	                    },
	                    internalPictureRotation: 0,
	                    scenesList: [],
	                    scenesNamesShow: false,
	                    opacity: 50,
	                    scenesBtnTitleShow: false,
	                    sceneBtnTitle: ""
	                }
	            }
	        },
	        disablePostFilters: true,
	        standbyScreen: false,
	        general: {
	            screenOrientation: "landscape",
	            width: 1920,
	            height: 1080,
	            aspectRatio: {
	                width: 2,
	                height: 1
	            }
	        },
	        standbyScreenActivateTime: 30,
	        standbyScreenImage: null,
	        digitalStartScreenDesign: true,
	        printStartScreenDesign: true,
	        stripStartScreenDesign: true,
	        showQRCode: true,
	        individualText: (0, _individualText.getDefaultIndividualText)(),
	        offlineQrCode: {
	            enabled: false,
	            background: null,
	            doneButton: {
	                width: 6,
	                height: 6,
	                x: 89,
	                y: 92.5,
	                customIcon: null
	            },
	            qrCode: {
	                width: 7,
	                height: 7,
	                x: 50,
	                y: 11
	            }
	        },
	        filtersNamesShow: false,
	        maxCountOfPrintCopies: 5,
	        enableAutoPrint: false,
	        autoPrintCopies: 1,
	        isAdvanced: false,
	        cuttingLine: true,
	        upreachBadge: false,
	        disableSceneAfterCapture: false,
	        photoBooth: {
	            enabled: true,
	            allowSharing: true,
	            allowSharePrintFile: true,
	            printWithoutScene: false,
	            allowPrinting: true,
	            playbackSpeed: 1.5,
	            countdownTime: 5,
	            showPrinterBleeds: false,
	            startScreenDesignSharing: true,
	            printingBackgroundMode: "color",
	            sharingBackgroundMode: "color",
	            printingBackgroundColor: "#ffffff",
	            sharingBackgroundColor: "#ffffff",
	            showLiveViewOverlays: true,
	            shouldOutputPhotoMirrored: true,
	            sharingLogos: [{
	                width: "95%",
	                height: "10%",
	                bottom: "2.5%",
	                left: "2.5%"
	            }],
	            sharingLogoAreas: [{
	                width: "100%",
	                height: "15%",
	                bottom: "0",
	                left: "0"
	            }],
	            printingLogos: [{
	                width: "75%",
	                left: "12.5%",
	                bottom: "6%",
	                height: "15%"
	            }],
	            savedData: {
	                sharingOverlayFiles: "",
	                sharingBackgroundFiles: ""
	            },
	            sharingFile: {
	                finalSize: {
	                    width: 500,
	                    height: 500
	                },
	                internalPictureSize: {
	                    width: 500,
	                    height: 500
	                },
	                internalPicturePosition: {
	                    topX: 0,
	                    topY: 0
	                },
	                internalPictureRotation: 0,
	                layoutAspectRatio: {
	                    width: null,
	                    height: null
	                }
	            },
	            aspectRatio: {
	                width: 1,
	                height: 1
	            },
	            //  finalSize 1252×1843 = portrait 2:3, 300dpi, 3mm bleed; extraLargePrintFile removed
	            printFile: {
	                framesToPrint: 3,
	                finalSize: {
	                    width: 1252,
	                    height: 1843
	                },
	                internalPhotos: [{
	                    size: {
	                        width: 1252,
	                        height: 1843
	                    },
	                    pos: {
	                        topX: 0,
	                        topY: 0
	                    },
	                    rotation: 0,
	                    name: "1"
	                }],
	                activePhotoStrip: false
	            }
	        },
	        gifBooth: {
	            enabled: true,
	            allowSharing: true,
	            allowSharePrintFile: true,
	            printWithoutScene: false,
	            allowPrinting: true,
	            countdownTime: 5,
	            playbackSpeed: 1.5,
	            showPrinterBleeds: false,
	            startScreenDesignSharing: true,
	            printingBackgroundMode: "color",
	            sharingBackgroundMode: "color",
	            printingBackgroundColor: "#ffffff",
	            sharingBackgroundColor: "#ffffff",
	            showLiveViewOverlays: true,
	            shouldOutputPhotoMirrored: true,
	            sharingLogos: [{
	                width: "95%",
	                height: "10%",
	                bottom: "2.5%",
	                left: "2.5%"
	            }],
	            sharingLogoAreas: [{
	                width: "100%",
	                height: "15%",
	                bottom: "0",
	                left: "0"
	            }],
	            printingLogos: [{
	                bottom: "2.5%",
	                height: "10%",
	                width: "40%",
	                left: "5%"
	            }, {
	                bottom: "2.5%",
	                height: "10%",
	                width: "40%",
	                right: "5%"
	            }],
	            savedData: {
	                sharingOverlayFiles: "",
	                sharingBackgroundFiles: ""
	            },
	            sharingFile: {
	                finalSize: {
	                    width: 500,
	                    height: 500
	                },
	                internalPicturePosition: {
	                    topX: 0,
	                    topY: 0
	                },
	                internalPictureRotation: 0,
	                layoutAspectRatio: {
	                    width: null,
	                    height: null
	                },
	                internalPictureSize: {
	                    width: 500,
	                    height: 500
	                }
	            },
	            aspectRatio: {
	                width: 1,
	                height: 1
	            },
	            //  finalSize 1252×1843 (portrait 300dpi, 3mm bleed)
	            printFile: {
	                framesToPrint: 3,
	                finalSize: {
	                    width: 1252,
	                    height: 1843
	                },
	                internalPhotos: [{
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    pos: {
	                        topX: 80,
	                        topY: 82
	                    },
	                    rotation: 0,
	                    name: "1a"
	                }, {
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    pos: {
	                        topX: 80,
	                        topY: 577
	                    },
	                    rotation: 0,
	                    name: "2a"
	                }, {
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    pos: {
	                        topX: 80,
	                        topY: 1072
	                    },
	                    rotation: 0,
	                    name: "3a"
	                }, {
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    pos: {
	                        topX: 680,
	                        topY: 82
	                    },
	                    rotation: 0,
	                    name: "1b"
	                }, {
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    pos: {
	                        topX: 680,
	                        topY: 577
	                    },
	                    rotation: 0,
	                    name: "2b"
	                }, {
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    pos: {
	                        topX: 680,
	                        topY: 1072
	                    },
	                    rotation: 0,
	                    name: "3b"
	                }],
	                activePhotoStrip: true
	            }
	        },
	        boomerangBooth: {
	            enabled: true,
	            allowSharing: true,
	            allowPrinting: true,
	            allowSharePrintFile: true,
	            printWithoutScene: false,
	            showPrinterBleeds: false,
	            startScreenDesignSharing: true,
	            printingBackgroundMode: "color",
	            sharingBackgroundMode: "color",
	            printingBackgroundColor: "#ffffff",
	            sharingBackgroundColor: "#ffffff",
	            showLiveViewOverlays: true,
	            shouldOutputPhotoMirrored: true,
	            sharingLogos: [{
	                width: "95%",
	                height: "10%",
	                bottom: "2.5%",
	                left: "2.5%"
	            }],
	            sharingLogoAreas: [{
	                width: "100%",
	                height: "15%",
	                bottom: "0",
	                left: "0"
	            }],
	            printingLogos: [{
	                bottom: "2.5%",
	                height: "10%",
	                width: "40%",
	                left: "5%"
	            }, {
	                bottom: "2.5%",
	                height: "10%",
	                width: "40%",
	                right: "5%"
	            }],
	            countdownTime: 5,
	            playbackSpeed: 1.5,
	            captureTime: 1.5,
	            aspectRatio: {
	                width: 1,
	                height: 1
	            },
	            //  finalSize 1252×1843 (portrait 300dpi, 3mm bleed)
	            printFile: {
	                framesToPrint: 3,
	                finalSize: {
	                    width: 1252,
	                    height: 1843
	                },
	                internalPhotos: [{
	                    pos: {
	                        topX: 80,
	                        topY: 82
	                    },
	                    name: "1a",
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    rotation: 0
	                }, {
	                    pos: {
	                        topX: 80,
	                        topY: 577
	                    },
	                    name: "2a",
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    rotation: 0
	                }, {
	                    pos: {
	                        topX: 80,
	                        topY: 1072
	                    },
	                    name: "3a",
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    rotation: 0
	                }, {
	                    pos: {
	                        topX: 680,
	                        topY: 82
	                    },
	                    name: "1b",
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    rotation: 0
	                }, {
	                    pos: {
	                        topX: 680,
	                        topY: 577
	                    },
	                    name: "2b",
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    rotation: 0
	                }, {
	                    pos: {
	                        topX: 680,
	                        topY: 1072
	                    },
	                    name: "3b",
	                    size: {
	                        width: 480,
	                        height: 480
	                    },
	                    rotation: 0
	                }],
	                activePhotoStrip: true
	            },
	            savedData: {
	                sharingOverlayFiles: "",
	                sharingBackgroundFiles: ""
	            },
	            sharingFile: {
	                finalSize: {
	                    width: 500,
	                    height: 500
	                },
	                internalPictureSize: {
	                    width: 500,
	                    height: 500
	                },
	                layoutAspectRatio: {
	                    width: null,
	                    height: null
	                },
	                internalPicturePosition: {
	                    topX: 0,
	                    topY: 0
	                },
	                internalPictureRotation: 0
	            }
	        },
	        videoBooth: {
	            enabled: false,
	            allowSharing: true,
	            shouldOutputPhotoMirrored: true,
	            enableChromakey: false,
	            enableSoundRecording: false,
	            countdownTime: 5,
	            playbackSpeed: 1,
	            captureTime: 1.5,
	            resolutionOptions: "hd",
	            sliderValue: 300
	        },
	        startScreenAreas: {
	            single: {
	                width: "25vh",
	                height: "25vh",
	                y: "60vh",
	                x: "20vw"
	            },
	            gif: {
	                width: "25vh",
	                height: "25vh",
	                y: "60vh",
	                x: "40vw"
	            },
	            boomerang: {
	                width: "25vh",
	                height: "25vh",
	                y: "60vh",
	                x: "60vw"
	            },
	            video: {
	                width: "25vh",
	                height: "25vh",
	                y: "60vh",
	                x: "80vw"
	            }
	        },
	        startScreenDefaultIcons: false,
	        startScreenReturnTime: 90,
	        startScreenPreviewSize: {
	            width: 1920,
	            height: 1080
	        },
	        startScreenBackgroundMode: "color",
	        startScreenBackgroundColor: "#ffffff",
	        startScreenImageStyle: "stretch",
	        startScreenLogo: {
	            enabled: true,
	            file: {},
	            position: 2,
	            size: 30
	        },
	        startScreenLiveView: {
	            enabled: false,
	            backgroundOpacity: 50,
	            iconsOpacity: 100
	        },
	        // removeBg: {
	        //     active: true,
	        //     apiKey: "",
	        //     totalCredit: 123,
	        //     availableCredits: 0,
	        //     balance: 0,
	        //     assigned: 0,
	        //     used: 0
	        // },
	        cameraPresetName: "Default",
	        outputSettings: {
	            enableEmailSharing: true,
	            enableSmsSharing: false
	        },
	        scenes: {
	            enabled: false,
	            randomizeSceneSelection: false,
	            finalSize: {
	                width: 500,
	                height: 500
	            },
	            internalPictureSize: {
	                width: 500,
	                height: 500
	            },
	            layoutAspectRatio: {
	                width: null,
	                height: null
	            },
	            pictureAspectRatio: {
	                width: null,
	                height: null
	            },
	            internalPicturePosition: {
	                topX: 0,
	                topY: 0
	            },
	            internalPictureRotation: 0,
	            scenesList: [],
	            scenesNamesShow: false,
	            opacity: 50,
	            scenesBtnTitleShow: false,
	            sceneBtnTitle: ""
	        },
	        liveView: {
	            enabled: true,
	            forAllScenes: true,
	            liveViewMode: "regular",
	            liveViewPreviewSize: {
	                width: 1920,
	                height: 1080
	            },
	            liveViewBackgroundMode: "color",
	            liveViewBackgroundColor: "#ffffff",
	            liveViewBackground: "",
	            filter: {
	                enabled: true,
	                liveViewBackgroundMode: "color",
	                liveViewBackgroundColor: "#ffffff",
	                liveViewBackground: ""
	            },
	            output: {
	                enabled: true,
	                liveViewBackgroundMode: "color",
	                liveViewBackgroundColor: "#ffffff",
	                liveViewBackground: ""
	            },
	            shouldOutputPhotoMirrored: true,
	            hideOutputPictureVideo: false,
	            hideSharingOptions: false,
	            customButtons: {
	                active: false,
	                generalUiButtonsSettings: {
	                    back: { width: 4.5, height: 4.5, x: 8, y: 7 },
	                    sharingBackBtn: { width: 3.5, height: 3.5, x: 8, y: 7 },
	                    capture: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                    proceed: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                    email: { width: 5.5, height: 5.5, x: 16.5, y: 88 },
	                    sms: { width: 3.5, height: 3.5, x: 35, y: 88 },
	                    print: { width: 3.5, height: 3.5, x: 45, y: 88 },
	                    done: { width: 6, height: 6, x: 89, y: 92.5 },
	                    qrCode: { width: 7, height: 7, x: 50, y: 11, text: "Scan me to download", textSize: 12, textColor: "black" },
	                    close: { width: 3.5, height: 3.5, x: 5, y: 28 },
	                    next: { width: 5, height: 5, x: 93, y: 50 },
	                    closeError: { width: 5, height: 5, x: 93, y: 50 }
	                },
	                captureModeButtonsSettings: {
	                    single: { width: 3.5, height: 3.5, x: 8, y: 44 },
	                    gif: { width: 3.5, height: 3.5, x: 8, y: 49 },
	                    boomerang: { width: 3.5, height: 3.5, x: 8, y: 55 },
	                    scene: { scenePopupColor: "#FFF", width: 36, height: 48, x: 50, y: 57 },
	                    filter: { width: 5, height: 5, x: 8, y: 38 }
	                }
	            },
	            customLogo: {
	                enabled: true,
	                file: null,
	                hideDefaultLogo: false,
	                background: {
	                    enabled: true,
	                    mode: "color",
	                    color: "white",
	                    image: null
	                },
	                screenText: {
	                    enabled: false,
	                    title: "Your image is being created",
	                    subText: "It may take a few seconds text",
	                    color: "black"
	                }
	            }
	        },
	        offlineForms: {
	            enabled: false,
	            formRequired: false,
	            isSendFromForm: false,
	            when: "afterPhoto",
	            isMultipleAnswers: false,
	            formInputs: [{
	                required: true,
	                active: true,
	                title: "Name"
	            }, {
	                required: false,
	                active: true,
	                title: "E-Mail"
	            }, {
	                required: true,
	                active: true,
	                title: "Phone Number"
	            }],
	            customInputs: [{
	                required: false,
	                active: false,
	                title: "",
	                inputMode: "text",
	                choices: [{ text: "" }]
	            }, {
	                required: false,
	                active: false,
	                title: "",
	                inputMode: "text",
	                choices: [{ text: "" }]
	            }, {
	                required: false,
	                active: false,
	                title: "",
	                inputMode: "text",
	                choices: [{ text: "" }]
	            }, {
	                required: false,
	                active: false,
	                title: "",
	                inputMode: "text",
	                choices: [{ text: "" }]
	            }, {
	                required: false,
	                active: false,
	                title: "",
	                inputMode: "text",
	                choices: [{ text: "" }]
	            }],
	            formCheckboxes: [{
	                required: true,
	                active: true,
	                title: "",
	                description: "",
	                usePdf: false,
	                fileName: "",
	                fileUrl: "",
	                fileId: null,
	                isInfobox: false,
	                typeIsCheckbox: true,
	                infoBoxCustomText: "Press here to review the full statement…"
	            }, {
	                required: false,
	                active: false,
	                title: "",
	                description: "",
	                usePdf: false,
	                fileName: "",
	                fileUrl: "",
	                fileId: null,
	                isInfobox: false,
	                typeIsCheckbox: true,
	                infoBoxCustomText: "Press here to review the full statement…"
	            }, {
	                required: false,
	                active: false,
	                title: "",
	                description: "",
	                usePdf: false,
	                fileName: "",
	                fileUrl: "",
	                fileId: null,
	                isInfobox: false,
	                typeIsCheckbox: true,
	                infoBoxCustomText: "Press here to review the full statement…"
	            }, {
	                required: false,
	                active: false,
	                title: "",
	                description: "",
	                usePdf: false,
	                fileName: "",
	                fileUrl: "",
	                fileId: null,
	                isInfobox: false,
	                typeIsCheckbox: true,
	                infoBoxCustomText: "Press here to review the full statement…"
	            }, {
	                required: false,
	                active: false,
	                title: "",
	                description: "",
	                usePdf: false,
	                fileName: "",
	                fileUrl: "",
	                fileId: null,
	                isInfobox: false,
	                typeIsCheckbox: true,
	                infoBoxCustomText: "Press here to review the full statement…"
	            }],
	            infoBoxCustomize: false,
	            formCheckboxesTypeLikeRadiobutton: false,
	            formSignature: {
	                required: true,
	                active: false,
	                title: "Signature"
	            },
	            backgroundImage: null
	        },
	        noise: {
	            active: false,
	            value: 0
	        },
	        gdpr: {
	            showGdpr: false,
	            gdprFile: null,
	            gdprCustomButtonsEnabled: false,
	            gdprAcceptButtonImage: null,
	            gdprDeclineButtonImage: null
	        }
	    },
	    client: {
	        emailSender: "UpReach Photo System <photos@upreach.com>",
	        advancedHtmlInput: false,
	        emailText: "",
	        emailTextRow: "",
	        emailTemplate: "English",
	        emailSubject: "Your UpReach photo",
	        allowEmailAttachments: true,
	        emailDisclaimer: false,
	        emailDisclaimerRequire: false,
	        emailDisclaimerText: "",
	        emailTitle: "Hey, nice snap!",
	        emailTextNoHtml: "Here you are, please find attached your awesome UpReach photo. Thank you so much for visiting us!\n Scroll down to download & share your image.",
	        smsText: "Hey, nice snap!\nVisit the live gallery to download & share your UpReach photo: ",
	        smsDisclaimer: false,
	        smsDisclaimerRequire: false,
	        smsDisclaimerText: ""
	    }
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.INDIVIDUAL_TEXT_VERTICAL_ALIGN_OPTIONS = exports.INDIVIDUAL_TEXT_ALIGN_OPTIONS = exports.INDIVIDUAL_TEXT_INPUT_TYPES = exports.INDIVIDUAL_TEXT_VERSION = exports.INDIVIDUAL_TEXT_MAX_FIELDS = undefined;
	
	var _isFinite = __webpack_require__(264);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(185);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.sanitizeIndividualText = sanitizeIndividualText;
	exports.getDefaultIndividualText = getDefaultIndividualText;
	exports.scaleOutputFont = scaleOutputFont;
	exports.normalizeIndividualText = normalizeIndividualText;
	exports.getInkWidth = getInkWidth;
	exports.getTextLineLayout = getTextLineLayout;
	exports.cutTextToWidth = cutTextToWidth;
	exports.getOutputBox = getOutputBox;
	exports.moveOutput = moveOutput;
	exports.clampOutputPosition = clampOutputPosition;
	exports.clampScreenArea = clampScreenArea;
	exports.getScreenBox = getScreenBox;
	exports.moveScreenArea = moveScreenArea;
	exports.snapToGuides = snapToGuides;
	exports.getBoxGuides = getBoxGuides;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Individual Text Field screen (json.admin.individualText).
	 *
	 * Every element is a box placed by its center:
	 * - on the screen (output preview, explanation, each field, Done button): x/y = center in % of the screen width/height,
	 *   width in % of the screen width, height in % of the screen height;
	 * - text on the output picture: x/y = center in % of the print canvas width/height, width/height in % of the canvas;
	 *   the text is aligned inside the box by `align` (left / center / right) and `verticalAlign` (top / center / bottom).
	 * The output picture is the Scenes Digital layout when the scenes are on, otherwise the screen of the General tab.
	 * Font sizes are px: of the screen (general.width × general.height) or of the output picture;
	 * `outputSize` is the output picture size (px) the output font sizes are set for.
	 * `version` marks these units; older saved values are converted on load:
	 * before 2 positions were px of the Single Photo print canvas, before 3 the output font sizes were px of that canvas.
	 */
	
	var INDIVIDUAL_TEXT_MAX_FIELDS = exports.INDIVIDUAL_TEXT_MAX_FIELDS = 3;
	
	var INDIVIDUAL_TEXT_VERSION = exports.INDIVIDUAL_TEXT_VERSION = 3;
	
	/** Allowed user input per field: letters and symbols, or digits and what the numeric keypad offers. */
	var INDIVIDUAL_TEXT_INPUT_TYPES = exports.INDIVIDUAL_TEXT_INPUT_TYPES = [{ value: "letters", label: "Letters and symbols" }, { value: "digits", label: "Digits only" }];
	
	var INDIVIDUAL_TEXT_ALIGN_OPTIONS = exports.INDIVIDUAL_TEXT_ALIGN_OPTIONS = [{ value: "left", label: "Left" }, { value: "center", label: "Center" }, { value: "right", label: "Right" }];
	
	var INDIVIDUAL_TEXT_VERTICAL_ALIGN_OPTIONS = exports.INDIVIDUAL_TEXT_VERTICAL_ALIGN_OPTIONS = [{ value: "top", label: "Top" }, { value: "center", label: "Center" }, { value: "bottom", label: "Bottom" }];
	
	var DIGITS_FORBIDDEN = /[^0-9.,+-]/g;
	var LETTERS_FORBIDDEN = /[0-9]/g;
	
	/** Removes characters the field's input type does not allow. */
	function sanitizeIndividualText(value, inputType) {
	    if (!value) {
	        return "";
	    }
	    return String(value).replace(inputType === "digits" ? DIGITS_FORBIDDEN : LETTERS_FORBIDDEN, "");
	}
	
	function getDefaultField(index) {
	    var isNumber = index === 2;
	    return {
	        id: "field" + (index + 1),
	        enabled: false,
	        // false: the device prints output.text as it is; true: the user can change it
	        userEditable: false,
	        inputType: isNumber ? "digits" : "letters",
	        font: null,
	        label: {
	            text: ["First name", "Last name", "Number"][index],
	            color: "#ffffff",
	            fontSize: 40
	        },
	        // Input background on the device is the label color
	        input: {
	            textColor: "#000000",
	            fontSize: 44
	        },
	        area: { width: 30, height: 8, x: 50, y: 66 + index * 9 },
	        output: {
	            // Text set in the cloud, printed on the picture (and prefilled on the device)
	            text: "",
	            x: 27.5,
	            y: 4.5 + index * 5,
	            width: 48,
	            height: 4.5,
	            align: "left",
	            verticalAlign: "top",
	            fontSize: 64,
	            minFontSize: 32,
	            color: "#000000"
	        }
	    };
	}
	
	function getDefaultIndividualText() {
	    var fields = [];
	    for (var i = 0; i < INDIVIDUAL_TEXT_MAX_FIELDS; i++) {
	        fields.push(getDefaultField(i));
	    }
	    return {
	        version: INDIVIDUAL_TEXT_VERSION,
	        enabled: false,
	        background: null,
	        // Width follows the print layout aspect ratio (see start-screen-area aspect-ratio)
	        outputPreview: { width: 16, height: 50, x: 50, y: 29 },
	        explanation: {
	            enabled: false,
	            text: "",
	            font: null,
	            color: "#ffffff",
	            fontSize: 44,
	            // The text is made smaller down to this size to fit the area
	            minFontSize: 24,
	            area: { width: 40, height: 4, x: 50, y: 58 }
	        },
	        fields: fields,
	        outputSize: null,
	        doneButton: { width: 3.5, height: 6, x: 89, y: 92.5, customIcon: null }
	    };
	}
	
	function fillDefaults(target, defaults) {
	    (0, _keys2.default)(defaults).forEach(function (key) {
	        var def = defaults[key];
	        if (target[key] === undefined || target[key] === null && def !== null) {
	            target[key] = def;
	        } else if (def && (typeof def === "undefined" ? "undefined" : (0, _typeof3.default)(def)) === "object" && !Array.isArray(def) && (0, _typeof3.default)(target[key]) === "object") {
	            fillDefaults(target[key], def);
	        }
	    });
	    return target;
	}
	
	/**
	 * Converts a screen area saved before version 2 to the center box:
	 * "topLeft" areas had x/y at the top left corner; the others had the width in % of the screen height.
	 */
	function convertScreenArea(area, screenWidth, screenHeight) {
	    if (!area) {
	        return;
	    }
	    var width = Number(area.width) || 0;
	    var height = Number(area.height) || 0;
	    if (area.anchor === "topLeft") {
	        area.x = (Number(area.x) || 0) + width / 2;
	        area.y = (Number(area.y) || 0) + height / 2;
	    } else {
	        area.width = width * screenHeight / screenWidth;
	    }
	    delete area.anchor;
	}
	
	/**
	 * Converts output text saved before version 2 (px of the print canvas) to the center box in %:
	 * "topLeft" had x/y at the box top left corner; older text had x at the alignment anchor of a maxWidth wide line.
	 */
	function convertOutput(output, canvasWidth, canvasHeight) {
	    if (!output) {
	        return;
	    }
	    var fontSize = Number(output.fontSize) || 64;
	    var left = Number(output.x) || 0;
	    var width = Number(output.width) || 0;
	    var height = Number(output.height) || 0;
	    if (output.anchor !== "topLeft") {
	        width = Number(output.maxWidth) || 600;
	        left -= output.align === "center" ? width / 2 : output.align === "right" ? width : 0;
	        // The text was placed by its top: a box of one line keeps it there
	        height = fontSize;
	    }
	    output.x = roundTenth((left + width / 2) / canvasWidth * 100);
	    output.y = roundTenth(((Number(output.y) || 0) + height / 2) / canvasHeight * 100);
	    output.width = roundTenth(width / canvasWidth * 100);
	    output.height = roundTenth(height / canvasHeight * 100);
	    delete output.anchor;
	    delete output.maxWidth;
	}
	
	/** Scales the px font sizes of the output text, e.g. when the output picture gets another height. */
	function scaleOutputFont(output, ratio) {
	    output.fontSize = Math.max(1, Math.round(Number(output.fontSize) * ratio));
	    output.minFontSize = Math.max(1, Math.round(Number(output.minFontSize) * ratio));
	}
	
	/**
	 * Adds missing properties to a saved config so older configs keep working,
	 * and converts values saved before INDIVIDUAL_TEXT_VERSION (screen, print canvas and output picture size in px).
	 */
	function normalizeIndividualText(value, screen, canvas, picture) {
	    var defaults = getDefaultIndividualText();
	    if (!value || (typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) !== "object") {
	        return defaults;
	    }
	    var fields = Array.isArray(value.fields) ? value.fields : [];
	    if (!value.version || value.version < 2) {
	        var screenWidth = screen && screen.width || 1920;
	        var screenHeight = screen && screen.height || 1080;
	        convertScreenArea(value.outputPreview, screenWidth, screenHeight);
	        convertScreenArea(value.doneButton, screenWidth, screenHeight);
	        convertScreenArea(value.explanation && value.explanation.area, screenWidth, screenHeight);
	        fields.forEach(function (field) {
	            if (field) {
	                convertScreenArea(field.area, screenWidth, screenHeight);
	                convertOutput(field.output, canvas && canvas.width || 1240, canvas && canvas.height || 1844);
	            }
	        });
	        value.version = 2;
	    }
	    if (value.version === 2) {
	        // The font sizes keep their size relative to the picture height
	        var canvasHeight = canvas && canvas.height || 1844;
	        if (picture && picture.height) {
	            fields.forEach(function (field) {
	                return field && field.output && scaleOutputFont(field.output, picture.height / canvasHeight);
	            });
	        }
	        value.version = INDIVIDUAL_TEXT_VERSION;
	    }
	    fillDefaults(value, defaults);
	    value.fields = defaults.fields.map(function (def, i) {
	        return fillDefaults(fields[i] || {}, def);
	    });
	    // The start-screen-area inputs have a 0.5 step: other values would fail their validation
	    var areas = [value.outputPreview, value.explanation.area, value.doneButton].concat(value.fields.map(function (field) {
	        return field.area;
	    }));
	    areas.forEach(function (area) {
	        return ["width", "height", "x", "y"].forEach(function (key) {
	            area[key] = roundHalf(Number(area[key]) || 0);
	        });
	    });
	    value.fields.forEach(function (field) {
	        return ["width", "height", "x", "y"].forEach(function (key) {
	            field.output[key] = roundTenth(Number(field.output[key]) || 0);
	        });
	    });
	    return value;
	}
	
	function clamp(value, min, max) {
	    var number = Number(value);
	    if (!(0, _isFinite2.default)(number)) {
	        return min;
	    }
	    return Math.min(Math.max(number, Math.min(min, max)), Math.max(min, max));
	}
	
	/** Positions use the 0.5 step of the start-screen-area inputs; other values fail their step validation. */
	function roundHalf(value) {
	    return Math.round(value * 2) / 2;
	}
	
	function roundTenth(value) {
	    return Math.round(value * 10) / 10;
	}
	
	function floorHalf(value) {
	    return Math.floor(value * 2) / 2;
	}
	
	/** Width of the letters themselves (canvas TextMetrics), without the side bearings. */
	function getInkWidth(metrics) {
	    return (metrics.actualBoundingBoxLeft || 0) + (metrics.actualBoundingBoxRight || metrics.width || 0);
	}
	
	/**
	 * Places one line of text so its letters touch the text box on the aligned sides, as the booth draws it:
	 * no space of the font above or below the letters and no side bearing.
	 * metrics: canvas TextMetrics of the line, px. Returns the line's left and top in the box and its line height, px.
	 */
	function getTextLineLayout(metrics, boxWidth, boxHeight, align, verticalAlign) {
	    var inkLeft = metrics.actualBoundingBoxLeft || 0;
	    var inkRight = metrics.actualBoundingBoxRight || metrics.width || 0;
	    var inkAscent = metrics.actualBoundingBoxAscent || 0;
	    var inkDescent = metrics.actualBoundingBoxDescent || 0;
	    var fontAscent = metrics.fontBoundingBoxAscent || inkAscent;
	    var fontDescent = metrics.fontBoundingBoxDescent || inkDescent;
	
	    // left: the text start, so the first letter's left edge is at the box's left
	    var left = inkLeft;
	    if (align === "right") {
	        left = boxWidth - inkRight;
	    } else if (align === "center") {
	        left = (boxWidth - inkLeft - inkRight) / 2 + inkLeft;
	    }
	    // baseline: so the top of the highest letter is at the box's top, or the bottom of the lowest one at its bottom
	    var baseline = inkAscent;
	    if (verticalAlign === "bottom") {
	        baseline = boxHeight - inkDescent;
	    } else if (verticalAlign === "center") {
	        baseline = (boxHeight - inkAscent - inkDescent) / 2 + inkAscent;
	    }
	    // A line as high as the font's ascent + descent has its baseline fontAscent below its top
	    return { left: left, top: baseline - fontAscent, lineHeight: fontAscent + fontDescent };
	}
	
	/** The text cut with "…" until measureWidth(text) fits maxWidth; the whole text when it fits. */
	function cutTextToWidth(text, maxWidth, measureWidth) {
	    if (measureWidth(text) <= maxWidth) {
	        return text;
	    }
	    for (var end = text.length - 1; end > 0; end--) {
	        var cut = text.slice(0, end).replace(/\s+$/, "") + "…";
	        if (measureWidth(cut) <= maxWidth) {
	            return cut;
	        }
	    }
	    return "…";
	}
	
	/** The output text box in px of the print canvas: {left, top, width, height}. */
	function getOutputBox(output, canvasWidth, canvasHeight) {
	    var width = output.width * canvasWidth / 100;
	    var height = output.height * canvasHeight / 100;
	    return {
	        left: output.x * canvasWidth / 100 - width / 2,
	        top: output.y * canvasHeight / 100 - height / 2,
	        width: width,
	        height: height
	    };
	}
	
	/** Moves the output text so its box starts at left/top (px of the print canvas). */
	function moveOutput(output, left, top, canvasWidth, canvasHeight) {
	    var box = getOutputBox(output, canvasWidth, canvasHeight);
	    output.x = (left + box.width / 2) / canvasWidth * 100;
	    output.y = (top + box.height / 2) / canvasHeight * 100;
	}
	
	/**
	 * Keeps the text box inside the print canvas.
	 * changed = "fontSize": a bigger font makes the box higher; otherwise the box height limits the font.
	 */
	function clampOutputPosition(output, canvasWidth, canvasHeight, changed) {
	    if (!output || !canvasWidth || !canvasHeight) {
	        return;
	    }
	    output.width = roundTenth(clamp(output.width, 0.1, 100));
	    if (changed === "fontSize" && Number(output.fontSize) > output.height * canvasHeight / 100) {
	        output.height = Math.ceil(output.fontSize / canvasHeight * 1000) / 10;
	    }
	    output.height = roundTenth(clamp(output.height, 0.1, 100));
	    // The text fits the box height
	    output.fontSize = Math.round(clamp(output.fontSize, 1, Math.floor(output.height * canvasHeight / 100)));
	    output.minFontSize = Math.round(clamp(output.minFontSize, 1, output.fontSize));
	    output.x = roundTenth(clamp(output.x, output.width / 2, 100 - output.width / 2));
	    output.y = roundTenth(clamp(output.y, output.height / 2, 100 - output.height / 2));
	}
	
	/**
	 * Keeps a screen element inside the screen, also after the screen size changes.
	 * With keepRatio a too big element is scaled down with its proportions.
	 */
	function clampScreenArea(area, keepRatio) {
	    if (!area) {
	        return;
	    }
	    if (keepRatio && area.width > 0 && area.height > 0) {
	        var scale = Math.min(1, 100 / area.width, 100 / area.height);
	        area.width *= scale;
	        area.height *= scale;
	    }
	    area.width = floorHalf(clamp(area.width, 0, 100));
	    area.height = floorHalf(clamp(area.height, 0, 100));
	    // Emptied coordinates go to the center instead of the edge
	    ["x", "y"].forEach(function (key) {
	        if (!(0, _isFinite2.default)(Number(area[key])) || area[key] === null || area[key] === "") {
	            area[key] = 50;
	        }
	    });
	    // Same rounded limits as start-screen-area's validation, so the inputs accept the result
	    area.x = clamp(roundHalf(Number(area.x)), roundHalf(area.width / 2), roundHalf(100 - area.width / 2));
	    area.y = clamp(roundHalf(Number(area.y)), roundHalf(area.height / 2), roundHalf(100 - area.height / 2));
	}
	
	/** A screen element as a box in % of the screen width (left, width) and height (top, height). */
	function getScreenBox(area) {
	    return { left: area.x - area.width / 2, top: area.y - area.height / 2, width: area.width, height: area.height };
	}
	
	/** Moves a screen element so its box starts at left/top (% of the screen). */
	function moveScreenArea(area, left, top) {
	    area.x = left + area.width / 2;
	    area.y = top + area.height / 2;
	}
	
	/**
	 * Moves a dragged box so its start, center or end lands on the closest guide within `threshold`.
	 * Returns the new start and the guide it snapped to (null when nothing is close enough).
	 */
	function snapToGuides(start, size, guides, threshold) {
	    var best = null;
	    [0, size / 2, size].forEach(function (offset) {
	        guides.forEach(function (guide) {
	            var diff = guide - (start + offset);
	            if (Math.abs(diff) <= threshold && (!best || Math.abs(diff) < Math.abs(best.diff))) {
	                best = { diff: diff, guide: guide };
	            }
	        });
	    });
	    return best ? { start: start + best.diff, guide: best.guide } : { start: start, guide: null };
	}
	
	/** Start, center and end of a box: the lines other boxes snap to. */
	function getBoxGuides(start, size) {
	    return [start, start + size / 2, start + size];
	}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(265), __esModule: true };

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(266);
	module.exports = __webpack_require__(14).Number.isFinite;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(19);
	var _isFinite = __webpack_require__(15).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(268);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./configuration-list.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./configuration-list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "configuration-list md-card{width:98%;min-width:800px}configuration-list md-select.md-table-select>.md-select-value>span>.md-text{display:inline-block!important}", ""]);
	
	// exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _configurationUpdate = __webpack_require__(270);
	
	var _configurationUpdate2 = _interopRequireDefault(_configurationUpdate);
	
	var _configurationUpdate3 = __webpack_require__(271);
	
	var _configurationUpdate4 = _interopRequireDefault(_configurationUpdate3);
	
	__webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigurationUpdateComponent = {
	    template: _configurationUpdate2.default,
	    controller: _configurationUpdate4.default,
	    controllerAs: "ctrl"
	};
	
	exports.default = ConfigurationUpdateComponent;

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\">\n  <div flex=\"90\" flex-xs=\"100\" flex-offset-xs=\"0\" style=\"margin: 0 auto\">\n\n    <h2 class=\"page-title\" ng-if=\"ctrl.isNew\" ng-bind=\"'Create a new configuration' | translate\"></h2>\n    <h2 class=\"page-title\" ng-if=\"!ctrl.isNew\">{{ 'Update configuration: ' | translate }}{{ ctrl.config.name }}</h2>\n\n    <!-- wizard -->\n    <wizard on-finish=\"ctrl.saveConfiguration(true)\"\n            indicators-position=\"top\"\n            edit-mode=\"true\"\n            ng-class=\"{'disable-steps':ctrl.json.admin.scenes.scenesBtnTitleShow && (ctrl.json.admin.scenes.sceneBtnTitle === undefined || ctrl.json.admin.scenes.sceneBtnTitle.length < 1)}\">\n\n      <!-- standby screen step -->\n      <wz-step\n              wz-title=\"{{'General' | translate}}\"\n              canexit=\"!ctrl.loading\"\n              canenter=\"!ctrl.loading\"\n              class=\"tab-container\">\n\n          <section layout=\"row\" layout-sm=\"column\" layout-padding class=\"general-page\">\n              <div flex=\"50\">\n                  <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                      <div flex-sm=\"100\">\n                          <strong class=\"bold\" >\n                              {{'All screens' | translate}}\n                          </strong>\n                          <p>\n                              {{'The setting influences all following settings and previews.' | translate}}\n                          </p>\n                      </div>\n                  </div>\n\n                  <div layout=\"row\" layout-padding>\n                      <div class=\"photos-within-layout wider scenes-photo\" style=\"margin-right: 20px\">\n                          <md-input-container class=\"md-block\">\n                              <input\n                                      ng-change=\"ctrl.changeLayoutSize()\"\n                                      ng-model=\"ctrl.json.admin.general.width\"\n                                      type=\"number\"\n                                      max=\"4000\"\n                                      min=\"{{ctrl.getLayoutMinSize('width')}}\"\n                                      step=\"2\"\n                                      placeholder=\"Width\"\n                                      id=\"layout-width\">\n                          </md-input-container>\n                          <md-input-container class=\"md-block\">\n                              <input\n                                      ng-change=\"ctrl.changeLayoutSize()\"\n                                      ng-model=\"ctrl.json.admin.general.height\"\n                                      type=\"number\"\n                                      max=\"4000\"\n                                      min=\"{{ctrl.getLayoutMinSize('height')}}\"\n                                      step=\"2\"\n                                      placeholder=\"Height\"\n                                      id=\"layout-height\">\n                          </md-input-container>\n                      </div>\n\n                  </div>\n\n                  <div layout=\"row\" layout-padding>\n                      <md-radio-group\n                              ng-model=\"ctrl.json.admin.general.screenOrientation\"\n                              ng-change=\"ctrl.onOrientationChange()\"\n                              aria-label=\"Set logo position\">\n                          <md-radio-button class=\"top-left\"   ng-value=\"'landscape'\">Landscape</md-radio-button>\n                          <md-radio-button class=\"top-middle\" ng-value=\"'portrait'\">Portrait</md-radio-button>\n                      </md-radio-group>\n                  </div>\n\n                  <div layout=\"row\" layout-padding>\n                      <strong class=\"bold\">\n                          {{'Standby Screen Settings' | translate}}\n                      </strong>\n                  </div>\n\n                  <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                      <div flex-sm=\"100\">\n                          <strong>\n                              <p>{{'The Standby Screen is what people will see when the device is not active.' | translate}}<br>{{'Users can close it by tapping anywhere on the screen.' | translate}}</p>\n                              <p>{{'An attractive Standby Screen means more people taking photos!' | translate}}</p>\n                          </strong>\n                      </div>\n                  </div>\n\n                  <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                      <div  flex-sm=\"100\">\n                          <md-switch md-invert\n                                     ng-model=\"ctrl.json.admin.standbyScreen\"\n                                     ng-change=\"ctrl.changeStandByScreenState(ctrl.json.admin.standbyScreen)\">\n                              {{'Use a Standby Screen' | translate}}\n                          </md-switch>\n\n                          <div ng-class=\"{'item-disabled': !ctrl.json.admin.standbyScreen}\">\n                              <p>{{'Idle time until the device goes into Standby mode:' | translate}} <strong>{{ctrl.json.admin.standbyScreenActivateTime}}</strong> {{'seconds' | translate}}</p>\n                              <md-slider-container>\n                                  <md-slider\n                                          min=\"0\"\n                                          max=\"60\"\n                                          step=\"10\"\n                                          md-discrete\n                                          ng-model=\"ctrl.json.admin.standbyScreenActivateTime\"\n                                          ng-disabled=\"!ctrl.json.admin.standbyScreen\"\n                                          aria-label=\"slider\">\n                                  </md-slider>\n                              </md-slider-container>\n\n                              <md-switch\n                                      md-invert\n                                      ng-model=\"ctrl.json.admin.standbyScreenAfterEachSession\"\n                                      ng-disabled=\"!ctrl.json.admin.standbyScreen\">\n                                  {{'Display the Standby Screen after each session' | translate}}\n                              </md-switch>\n\n                              <div class=\"upload-container\">\n                                  <upload\n                                          model=\"ctrl.json.admin.standbyScreenImage\"\n                                          uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                          custom-label=\"{{'Upload a Background' | translate}}\"\n                                          file-types=\".jpg,.jpeg,.gif,.png,.mp4\"\n                                          extra-info=\"{{'(Image/video in JPG, PNG, GIF, or mp4; ' + ctrl.fileSizes.startScreen + 'mb;' + ctrl.json.admin.general.width +' x '+ ctrl.json.admin.general.height  | translate}}\"\n                                          max-size=\"ctrl.fileSizes.startScreen\"\n                                          is-overlay=\"false\"\n                                          display-icon=\"true\"\n                                          ng-disabled=\"!ctrl.json.admin.standbyScreen\">\n                                  </upload>\n\n                                  <div class=\"file-title\" ng-if=\"ctrl.json.admin.standbyScreenImage\">\n                                      <span title=\"{{ctrl.json.admin.standbyScreenImage.attachment_file | getFileName}}\">Uploaded: {{ ctrl.json.admin.standbyScreenImage.attachment_file | getFileName:12 }}</span>\n                                      <md-button\n                                              class=\"md-icon-button md-primary\"\n                                              ng-click=\"ctrl.json.admin.standbyScreenImage = null\">\n                                          <md-icon style=\"color: gray\">delete</md-icon>\n                                      </md-button>\n                                  </div>\n                              </div>\n\n\n                          </div>\n\n                      </div>\n\n                  </div>\n\n                  <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                      <div style=\"width: 100%\" flex-sm=\"100\">\n                          <a href=\"#\"\n                             ng-click=\"ctrl.resetStep('standby')\"\n                             class=\"md-primary reset-link\">\n                              {{'Reset the Standby Screen to the default settings' | translate}}\n                          </a>\n                          <md-button class=\"md-primary md-raised\" wz-next style=\"float: right\">{{'Next' | translate}}</md-button>\n                      </div>\n                  </div>\n              </div>\n\n\n              <div flex=\"50\" flex-sm=\"100\">\n                  <p><strong>{{'Standby Screen Preview' | translate}}</strong></p>\n                  <html-preview\n                          pr-width=\"{{ctrl.json.admin.general.width}}\"\n                          pr-height=\"{{ctrl.json.admin.general.height}}\"\n                          index=\"{{ctrl.json.admin.general.height / 330}}\"\n                          background=\"{{[ctrl.json.admin.standbyScreenImage.attachment_file]}}\"\n                          video-background=\"{{ctrl.getFileType(ctrl.json.admin.standbyScreenImage) === 'mp4' ? ctrl.json.admin.standbyScreenImage : '' }}\">\n                  </html-preview>\n              </div>\n          </section>\n\n      </wz-step>\n      <!-- end of standby screen step -->\n        <!-- AI screen step -->\n        <wz-step\n                wz-title=\"{{'AI & AR Features' | translate}}\"\n                canexit=\"!ctrl.loading\"\n                canenter=\"!ctrl.loading\">\n\n                <section ng-if=\"ctrl.isActiveStep('AI & AR Features')\" layout=\"row\" layout-sm=\"column\" layout-padding class=\"ai-features\">\n                    <section flex=\"60\" style=\"padding-left: 14px\">\n                        <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                            <div flex-sm=\"100\" class=\"page-title\">\n                                <strong class=\"bold\">\n                                    {{'AI & AR Features' | translate}}\n                                </strong>\n                            </div>\n                        </div>\n\n                        <!--removeBg start-->\n                        <h2>Canva API</h2>\n                        <div class=\"ai-item-wrapper\">\n                            <h3>Remove BG</h3>\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.removeBg.active\"\n                                    ng-click=\"ctrl.setRemoveBgData(\n                      {active: !ctrl.json.admin.removeBg.active})\">\n                                Enable background removal <br/>(for photo + GIF)<br>\n                                <p></p>\n                            </md-switch>\n                            <div ng-hide=\"!ctrl.json.admin.removeBg.active\" style=\"width: 85%;min-width: 617px\"\n                                 class=\"remove-bg-block\">\n                                <h3>remove.bg <span>connection</span></h3>\n                                <p>Status:\n                                    <span class=\"text-link\" ng-click=\"ctrl.connectRemoveBg()\">\n                          {{ctrl.removeBgIsConnectedState ? 'Connected' : 'Press to Connect'}}\n                      </span>\n                                </p>\n                                <div class=\"key-wrapper\" ng-hide=\"!ctrl.showApiKeyForm\">\n                                    <input type=\"text\" ng-model=\"ctrl.removeBg.api_key\" placeholder=\"Type API Key\">\n                                    <button class=\"btn btn-primary\"\n                                            ng-click=\"ctrl.setKeyRemoveBgData(\n                              {active: true,\n                              api_key: ctrl.removeBg.api_key == undefined ? '' : ctrl.removeBg.api_key})\">\n                                        Add API key\n                                    </button>\n                                    <a href=\"https://www.remove.bg/ru/api#remove-background\" target=\"_blank\">\n                                        Information on getting an API key\n                                    </a>\n                                </div>\n                                <div class=\"container\">\n                                    <div class=\"row\">\n                                        <div class=\"col-4 col-title\">\n                                            <h5>Total credits</h5>\n                                            <span>Credits in your account</span>\n                                        </div>\n                                        <div class=\"col-8 col-auto\">\n                                            <h2>{{ctrl.removeBg.total_credit | json}}</h2>\n                                        </div>\n                                    </div>\n                                    <div class=\"row\">\n                                        <div class=\"col-4 col-title\">\n                                            <h5>Available credits</h5>\n                                            <span>Available credits in your account to use</span>\n                                        </div>\n                                        <div class=\"col-8 col-auto\">\n                                            <h2>{{ctrl.removeBg.available_credit | json}}</h2>\n                                        </div>\n                                    </div>\n                                    <div class=\"row\">\n                                        <div class=\"col-4 col-title\">\n                                            <h5>Current credit status</h5>\n                                            <span>Assigned credits for this event. Clicking reset will remove all assigned credits and reset them to zero.</span>\n                                        </div>\n                                        <div class=\"col-2 col-s-wrapper\">\n                                            <h5>Assigned</h5>\n                                            <input type=\"number\" ng-model=\"ctrl.removeBg.assigned\"\n                                                   ng-value=\"ctrl.removeBg.assigned\" disabled readonly>\n                                        </div>\n                                        <div class=\"col-2 col-s-wrapper\">\n                                            <h5>Used</h5>\n                                            <input type=\"number\" ng-model=\"ctrl.removeBg.used\"\n                                                   ng-value=\"ctrl.removeBg.used\"\n                                                   disabled readonly>\n                                        </div>\n                                        <div class=\"col-2 col-s-wrapper\">\n                                            <h5>Balance</h5>\n                                            <input type=\"number\" ng-model=\"ctrl.removeBg.balance\"\n                                                   ng-value=\"ctrl.removeBg.balance\" disabled readonly>\n                                        </div>\n                                        <div class=\"col-2 col-s-wrapper\">\n                                            <button class=\"btn btn-danger\" ng-click=\"ctrl.setRemoveBgData({used: 0})\">\n                                                Reset\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class=\"row\">\n                                        <div class=\"col-4 col-title\">\n                                            <h5>Add credit</h5>\n                                            <span>Assign credits to this event. Background removal will disappear for the users once your credits are gone.</span>\n                                        </div>\n                                        <div class=\"col-2 col-s-wrapper\">\n                                            <input type=\"text\"\n                                                   oninput=\"this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*)\\./g, '$1');\"\n                                                   ng-model=\"assignValue\" maxlength=\"6\">\n                                        </div>\n                                        <div class=\"col-2 col-s-wrapper\">\n                                            <button class=\"btn btn-primary\"\n                                                    ng-click=\"ctrl.setRemoveBgData({assigned: +assignValue})\">Allocate\n                                            </button>\n                                        </div>\n                                        <div class=\"col-4 col-auto\">\n                                            <button class=\"btn btn-primary\"\n                                                    onclick=\"window.open('https://www.remove.bg/de/pricing','_blank')\">\n                                                Buy\n                                                more credits\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <!--removeBg end-->\n                        <!--local removeBg start-->\n                        <md-switch\n                                md-invert\n                                ng-model=\"ctrl.json.admin.removeBgOffline.remove_bg_offline_active\"\n                                ng-click=\"ctrl.setLocalRemoveBgState({remove_bg_offline_active:!ctrl.json.admin.removeBgOffline.remove_bg_offline_active});\n                                            ctrl.handleFeatureDeactivation('remove_bg_offline', !ctrl.json.admin.removeBgOffline.remove_bg_offline_active)\">\n                            Remove background image off-line feature\n                        </md-switch>\n                        <!--local removeBg end-->\n                        <hr>\n\n                        <!--unscreen start-->\n                        <div class=\"ai-item-wrapper\">\n                            <h3>Unscreen</h3>\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.unscreen.us_active\"\n                                    ng-click=\"ctrl.setUnscreenData(\n                      {us_active: !ctrl.json.admin.unscreen.us_active});\n                        ctrl.handleFeatureDeactivation('remove_bg_video', !ctrl.json.admin.unscreen.us_active)\">\n                                Enable background removal <br/>(for video)\n                            </md-switch>\n                            <div ng-hide=\"!ctrl.json.admin.unscreen.us_active\" style=\"width: 85%;min-width: 617px\"\n                                 class=\"remove-bg-block\">\n                                <h3>Unscreen <span>connection</span></h3>\n                                <p>Status:\n                                    <span class=\"text-link\" ng-click=\"ctrl.connectUnscreen()\">\n                          {{ctrl.unscreenIsConnectedState ? 'Connected' : 'Press to Connect'}}\n                      </span>\n                                </p>\n                                <div class=\"key-wrapper\" ng-hide=\"!ctrl.showUnscreenApiKeyForm\">\n                                    <input type=\"text\" ng-model=\"ctrl.unscreen.us_api_key\" placeholder=\"Type API Key\">\n                                    <button class=\"btn btn-primary\"\n                                            ng-click=\"ctrl.setUnscreenData(\n                              {us_active: true,\n                              us_api_key: ctrl.unscreen.us_api_key == undefined ? '' : ctrl.unscreen.us_api_key})\">\n                                        Add API key\n                                    </button>\n                                    <a href=\"https://www.unscreen.com/api\" target=\"_blank\">\n                                        Information on getting an API key\n                                    </a>\n                                </div>\n                            </div>\n                        </div>\n                        <!--unscreen end-->\n                        <hr>\n                        <!--replicate start-->\n                        <h2>Replicate API</h2>\n                        <div class=\"ai-item-wrapper\">\n                            <h3>Remove BG (Replicate)</h3>\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.ai.replicate.replicate_remove_bg_active\"\n                                    ng-click=\"ctrl.setReplicateData(\n                      {replicate_remove_bg_active: !ctrl.json.admin.ai.replicate.replicate_remove_bg_active});ctrl.handleFeatureDeactivation('remove_bg_online', !ctrl.json.admin.ai.replicate.replicate_remove_bg_active || ctrl.json.admin.ai.remaker.remaker_remove_bg_active)\">\n                      Enable background removal <br/>(for photo + GIF)<br>\n                                <p></p>\n                            </md-switch>\n                            <div ng-hide=\"!ctrl.json.admin.ai.replicate.replicate_remove_bg_active\" style=\"width: 85%;min-width: 617px\"\n                                 class=\"remove-bg-block\">\n                                <h3>Replicate <span>connection</span></h3>\n                                <p>Status:\n                                    <span class=\"text-link\" ng-click=\"ctrl.connectReplicate()\">\n                          {{ctrl.replicateIsConnectedState ? 'Connected' : 'Press to Connect'}}\n                      </span>\n                                </p>\n                                <div class=\"key-wrapper\" ng-hide=\"!ctrl.showReplicateApiKeyForm\">\n                                    <input type=\"text\" ng-model=\"ctrl.replicate.replicate_api_key\" placeholder=\"Type API Key\">\n                                    <button class=\"btn btn-primary\"\n                                            ng-click=\"ctrl.setKeyReplicateData(\n                              {replicate_remove_bg_active: true,\n                              replicate_api_key: ctrl.replicate.replicate_api_key == undefined ? '' : ctrl.replicate.replicate_api_key})\">\n                                        Add API key\n                                    </button>\n                                    <a href=\"https://replicate.com/\" target=\"_blank\">\n                                        Information on getting an API key\n                                    </a>\n                                </div>\n                            </div>\n                            <md-switch\n                                    md-invert\n                                    class=\"ai-activation-toggle\"\n                                    ng-model=\"ctrl.json.admin.ai.replicate.replicate_prompting_active\"\n                                    ng-change=\"ctrl.onReplicatePromptingToggle()\">\n                                Enable prompting\n                            </md-switch>\n                        </div>\n                        <!--replicate end-->\n\n                        <hr>\n                        <!--  Wondershare API start-->\n                        <div class=\"ai-item-wrapper\">\n                            <md-switch\n                                    md-invert\n                                    class=\"ai-item-wrapper__title\"\n                                    ng-model=\"ctrl.json.admin.ai.wandershareApi.active\"\n                                    ng-change=\"ctrl.saveConfiguration(false)\"\n                            ng-click=\"ctrl.handleFeatureDeactivation('wandershare_api', !ctrl.json.admin.ai.wandershareApi.active)\">\n                                Wondershare API\n                            </md-switch>\n                            <div ng-if=\"ctrl.json.admin.ai.wandershareApi.active\">\n                                <div style=\"width: 85%;min-width: 617px\" class=\"settings-block\">\n                                    <p>Status:\n                                        <span class=\"text-link\" ng-click=\"ctrl.connectWandershareApi()\">\n                          {{ctrl.wandershareApiIsConnectedState ? 'Connected' : 'Press to Connect'}}\n                      </span>\n                                    </p>\n                                    <div class=\"key-wrapper\" ng-hide=\"!ctrl.showWandershareApiKeyForm\">\n                                        <input type=\"text\" ng-model=\"ctrl.wandershareApi.aging_api_key\" placeholder=\"Type API Key\" >\n                                        <input type=\"text\" ng-model=\"ctrl.wandershareApi.aging_api_secret\" placeholder=\"Type Secret API Key\" >\n                                        <button class=\"btn btn-primary\"\n                                                ng-click=\"ctrl.setKeyWandershareApiData({\n                              aging_api_key: ctrl.wandershareApi.aging_api_key == undefined ? '' : ctrl.wandershareApi.aging_api_key,\n                              aging_api_secret: ctrl.wandershareApi.aging_api_key == undefined ? '' : ctrl.wandershareApi.aging_api_secret})\">\n                                            Add API key\n                                        </button>\n                                    </div>\n                                </div>\n                                <md-switch\n                                        md-invert\n                                        class=\"ai-activation-toggle\"\n                                        ng-model=\"ctrl.json.admin.ai.wandershareApi.aging_active\"\n                                        ng-click=\"ctrl.setWandershareApiData(\n                      {aging_active: !ctrl.wandershareApi.aging_active})\">\n                                    Aging Filter\n                                </md-switch>\n                                <md-switch\n                                        md-invert\n                                        class=\"ai-activation-toggle\"\n                                        ng-model=\"ctrl.json.admin.ai.wandershareApi.aging_age_slider_allowed\"\n                                        ng-click=\"ctrl.setWandershareApiData(\n                      {aging_age_slider_allowed: ctrl.json.admin.ai.wandershareApi.aging_age_slider_allowed})\">\n                                    Set fixed age: {{ctrl.json.admin.ai.wandershareApi.aging_fixed_age}}\n                                </md-switch>\n                                <md-slider-container ng-hide=\"!ctrl.json.admin.ai.wandershareApi.aging_age_slider_allowed\" >\n                                    <md-slider\n                                            min=\"1\"\n                                            max=\"100\"\n                                            step=\"1\"\n                                            md-discrete\n                                            ng-model=\"ctrl.json.admin.ai.wandershareApi.aging_fixed_age\"\n                                            ng-change=\"ctrl.setWandershareApiData(\n                      {aging_fixed_age: ctrl.json.admin.ai.wandershareApi.aging_fixed_age})\"\n                                            aria-label=\"slider\">\n                                    </md-slider>\n                                </md-slider-container>\n\n                            </div>\n\n                        </div>\n                        <!--                    Wondershare API end-->\n                        <hr>\n                        <!--remaker start-->\n                        <h2>Remaker API</h2>\n                        <div class=\"ai-item-wrapper\">\n                            <h3>Remove BG (Remaker)</h3>\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.ai.remaker.remaker_remove_bg_active\"\n                                    ng-click=\"ctrl.setRemakerData(\n                      {remaker_remove_bg_active: !ctrl.json.admin.ai.remaker.remaker_remove_bg_active});ctrl.handleFeatureDeactivation('remove_bg_online', !ctrl.json.admin.ai.remaker.remaker_remove_bg_active || ctrl.json.admin.ai.replicate.replicate_remove_bg_active)\">\n                                Enable background removal <br/>(for photo + GIF)<br>\n                                <p></p>\n                            </md-switch>\n                            <div ng-hide=\"!ctrl.json.admin.ai.remaker.remaker_remove_bg_active\" style=\"width: 85%;min-width: 617px\"\n                                 class=\"remove-bg-block\">\n                                <h3>Remaker <span>connection</span></h3>\n                                <p>Status:\n                                    <span class=\"text-link\" ng-click=\"ctrl.connectRemaker()\">\n                          {{ctrl.remakerIsConnectedState ? 'Connected' : 'Press to Connect'}}\n                      </span>\n                                </p>\n                                <div class=\"key-wrapper\" ng-hide=\"!ctrl.showRemakerApiKeyForm\">\n                                    <input type=\"text\" ng-model=\"ctrl.remaker.remaker_api_key\" placeholder=\"Type API Key\">\n                                    <button class=\"btn btn-primary\"\n                                            ng-click=\"ctrl.setKeyRemakerData(\n                              {remaker_remove_bg_active: true,\n                              remaker_api_key: ctrl.remaker.remaker_api_key == undefined ? '' : ctrl.remaker.remaker_api_key})\">\n                                        Add API key\n                                    </button>\n                                    <a href=\"https://remaker.ai/\" target=\"_blank\">\n                                        Information on getting an API key\n                                    </a>\n                                </div>\n                            </div>\n                        </div>\n                        <!--remaker end-->\n                        <hr>\n                        <!--                Faceswap Ai start-->\n                        <div class=\"ai-item-wrapper\">\n                            <md-switch\n                                    md-invert\n                                    class=\"ai-item-wrapper__title\"\n                                    ng-model=\"ctrl.json.admin.ai.faceSwap.active\"\n                                    ng-change=\"ctrl.saveConfiguration(false)\"\n                            ng-click=\"ctrl.handleFeatureDeactivation('faceswap', !ctrl.json.admin.ai.faceSwap.active)\">\n                                Remaker API\n                            </md-switch>\n                            <div style=\"width: 85%;min-width: 617px\" ng-if=\"ctrl.json.admin.ai.faceSwap.active\" class=\"settings-block\">\n                                <p>Status:\n                                    <span class=\"text-link\" ng-click=\"ctrl.displayFaceSwapConnectBlock = !ctrl.displayFaceSwapConnectBlock\">\n                          {{ctrl.showFaceSwapApiKeyForm ? 'Connected' : 'Press to Connect'}}\n                      </span>\n                                </p>\n                                <div class=\"key-wrapper\" ng-hide=\"!ctrl.displayFaceSwapConnectBlock\">\n                                    <input type=\"text\" ng-model=\"ctrl.json.admin.ai.faceSwap.face_swap_api_key\" placeholder=\"Type API Key\" >\n                                    <button class=\"btn btn-primary\"\n                                            ng-click=\"ctrl.setKeyFaceSwapApiData({\n                              face_swap_api_key: ctrl.json.admin.ai.faceSwap.face_swap_api_key == undefined ? '' : ctrl.json.admin.ai.faceSwap.face_swap_api_key})\">\n                                        Add API key\n                                    </button>\n                                </div>\n                            </div>\n                            <md-switch\n                                    md-invert\n                                    class=\"ai-activation-toggle\"\n                                    ng-if=\"ctrl.json.admin.ai.faceSwap.active\"\n                                    ng-model=\"ctrl.json.admin.ai.faceSwap.face_swap_active\"\n                                    ng-click=\"ctrl.setFaceSwapApiData(\n                      {face_swap_active: !ctrl.json.admin.ai.faceSwap.face_swap_active})\">\n                                FaceSwap (Single Person):\n                            </md-switch>\n\n                            <md-switch\n                                    md-invert\n                                    class=\"ai-activation-toggle\"\n                                    ng-if=\"ctrl.json.admin.ai.faceSwap.active\"\n                                    ng-click=\"ctrl.onChangeMultiFaceswap(!ctrl.json.admin.ai.faceSwap.face_swap_multi_active);\n                                                ctrl.handleFeatureDeactivation('multi_faceswap', !ctrl.json.admin.ai.faceSwap.face_swap_multi_active)\"\n                                    ng-model=\"ctrl.json.admin.ai.faceSwap.face_swap_multi_active\">\n                                Multiple People:\n                            </md-switch>\n                            <p class=\"low-text\">If you turn on FaceSwap, the App will only recognize one person. If you turn on Multiple People, the App will recognize multiple people where users will be replaced.\n                                In order for this to take effect, you will need to upload one or several target images with more than one person.</p>\n\n                            <md-switch md-invert\n                                       class=\"ai-activation-toggle\"\n                                       ng-show=\"ctrl.json.admin.ai.faceSwap.active\"\n                                       ng-change=\"ctrl.saveConfiguration(false)\"\n                                       ng-model=\"ctrl.json.admin.ai.faceSwap.scenesNamesShow\">\n                                <strong>{{'Display Scenes` names' | translate}}</strong>\n                            </md-switch>\n                            <div class=\"scene-btn-title\" ng-show=\"ctrl.json.admin.ai.faceSwap.active\">\n                                <md-switch md-invert\n                                           class=\"ai-activation-toggle\"\n                                           ng-change=\"ctrl.saveConfiguration(false)\"\n                                           ng-model=\"ctrl.json.admin.ai.faceSwap.scenesBtnTitleShow\">\n                                    <strong>{{'Display Scene button title' | translate}}</strong>\n                                </md-switch>\n                                <form name=\"setFaceSwapSceneBtnTitle\" ng-if=\"ctrl.json.admin.ai.faceSwap.scenesBtnTitleShow\">\n                                    <div class=\"scene-btn-title-wrapper\">\n                                        <md-input-container class=\"md-block\">\n                                            <input\n                                                    ng-model=\"ctrl.json.admin.ai.faceSwap.sceneBtnTitle\"\n                                                    name=\"title\"\n                                                    type=\"text\"\n                                                    maxlength=\"20\"\n                                                    minlength=\"1\"\n                                                    required=\"ctrl.json.admin.ai.faceSwap.scenesBtnTitleShow\"\n                                                    placeholder=\"Title for scene button in application\"\n                                                    id=\"scene-btn-title\"\n                                                    ng-change=\"ctrl.changeFaceSwapSceneBtnTitle()\">\n                                        </md-input-container>\n                                        <div class=\"form-alert\" ng-messages=\"ctrl.json.admin.ai.faceSwap.scenesBtnTitleShow && setFaceSwapSceneBtnTitle.title.$error\" role=\"alert\">\n                                            <div ng-message-exp=\"['required','maxlength', 'minlength']\"\n                                                 ng-bind=\"'The title should be between 1 and 20 symbols' | translate\">\n                                            </div>\n                                        </div>\n                                    </div>\n                                </form>\n                            </div>\n\n\n                            <div class=\"scenes-wrapper\" style=\"display: none\" >\n                                <p><strong>Target Image for FaceSwap</strong></p>\n                                <p class=\"low-text\">The uploaded target image will be where the user's face is projected.</p>\n                                <p>Target Images List:</p>\n                                <scenes-list\n                                        model=\"ctrl.json.admin.ai.faceSwap.faceSwapScenes\"\n                                        company=\"ctrl.config.company\"\n                                        single=\"true\"\n                                        gif=\"false\"\n                                        boomerang=\"false\"\n                                        hide-bg=\"true\"\n                                        ai-feature=\"true\"\n                                        unscreen-is-active=\"ctrl.unscreenIsActive\"\n                                        ai-background=\"true\"\n                                ></scenes-list>\n                                <p>Overlays list:</p>\n                                <scenes-list\n                                        model=\"ctrl.json.admin.ai.faceSwap.faceSwapOverlays\"\n                                        company=\"ctrl.config.company\"\n                                        single=\"true\"\n                                        gif=\"false\"\n                                        boomerang=\"false\"\n                                        hide-bg=\"true\"\n                                        ai-feature=\"true\"\n                                        unscreen-is-active=\"ctrl.unscreenIsActive\"\n                                        ai-overlay=\"true\"\n                                ></scenes-list>\n                            </div>\n                        <!--                Faceswap Ai end-->\n\n                        <div class=\"ai-item-wrapper custom-logo\" style=\"display: none\">\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.ai.customLogo.active\"\n                                    ng-change=\"ctrl.saveConfiguration(false)\">\n                                Custom Loading Screen Logo\n                            </md-switch>\n                            <div class=\"upload-container flex-container\" ng-if=\"ctrl.json.admin.ai.customLogo.active\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                        custom-label=\"{{'Upload Logo' | translate}}\"\n                                        file-types=\".png\"\n                                        max-size=\"2\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"false\"\n                                        old-file=\"ctrl.json.admin.ai.customLogo.fileId\"\n                                        callback=\"ctrl.customLogoUpload(file, 'customLogoFile')\">\n                                </upload>\n\n                                <div class=\"upload-info-wrapper\">\n                                    <div class=\"file-title\" ng-repeat=\"file in ctrl.json.admin.ai.customLogo.customLogoFile\">\n                                        <p>\n                                            <md-button\n                                                    class=\"md-icon-button md-primary\"\n                                                    ng-click=\"ctrl.customLogoDeleteFile(0,'customLogo', 'customLogoFile')\">\n                                                <md-icon style=\"color: gray\">delete</md-icon>\n                                            </md-button>\n                                            <span title=\"{{file.original_name }}\">Uploaded: {{ file.original_name }}</span>\n                                        </p>\n                                    </div>\n                                </div>\n                            </div>\n                            <p class=\"sub-text\" ng-if=\"ctrl.json.admin.ai.customLogo.active\">Format: .png <br>Size: < 2mb</p>\n                        </div>\n                    </section>\n                    <div flex=\"40\" flex-sm=\"100\" class=\"html-holder\">\n                        <p><strong>{{'AI Feature Preview' | translate}}</strong></p>\n\n                        <ai-html-preview\n                                pr-width=\"{{ctrl.json.admin.general.width}}\"\n                                pr-height=\"{{ctrl.json.admin.general.height}}\"\n                                index=\"{{ctrl.json.admin.general.height / 330}}\"\n                                display-slider=\"ctrl.json.admin.ai.wandershareApi.aging_age_slider_allowed\"\n                        >\n                        </ai-html-preview>\n                    </div>\n                </section>\n            <div ng-if=\"ctrl.isActiveStep('AI & AR Features')\" layout=\"row\" layout-sm=\"column\" layout-padding class=\"step-footer\">\n                <div style=\"width: 100%\" flex-sm=\"100\">\n                    <a href=\"#\"\n                       ng-click=\"ctrl.resetStep('ai')\"\n                       class=\"md-primary reset-link\">\n                        {{'Reset the AI & AR Features to the default settings' | translate}}\n                    </a>\n                    <md-button class=\"md-primary md-raised\" wz-next style=\"float: right\">{{'Next' | translate}}</md-button>\n                </div>\n            </div>\n\n        </wz-step>\n        <!-- end of AI screen step -->\n      <!-- start screen step -->\n      <wz-step wz-title=\"{{'Start Screen' | translate}}\"\n               canenter=\"!ctrl.loading\"\n               canexit=\"ctrl.canExitStartScreen() && !ctrl.loading\">\n          <section class=\"start-screen-page\">\n              <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                  <div flex=\"50\" flex-sm=\"100\">\n                      <p>\n                          <strong>The Start Screen is where the user can choose a capture mode.</strong>\n                      </p>\n                  </div>\n              </div>\n\n              <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                  <div flex=\"60\" flex-sm=\"100\">\n\n                      <div class=\"settings-ss\">\n                          <div class=\"setting-section\" ng-class=\"{'logo-disabled': !ctrl.json.admin.startScreenLogo.enabled}\">\n                              <div class=\"toggle\">\n                                  <md-switch\n                                          md-invert\n                                          ng-model=\"ctrl.json.admin.startScreenLogo.enabled\">\n                                      {{'Logo' | translate}}\n                                  </md-switch>\n                                  <div class=\"ss-bg-info logo-info\">\n                                      <div class=\"icon\">\n                                          <i class=\"material-icons\">\n                                              info\n                                          </i>\n                                      </div>\n                                      <div class=\"info-text\">\n                                          Format .png .jpg .gif <br>\n                                          Size {{ctrl.fileSizes.startScreen}} mb\n                                      </div>\n                                  </div>\n                                  <upload\n                                          model=\"ctrl.json.admin.startScreenLogo.file\"\n                                          uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                          custom-label=\"{{'Upload' | translate}}\"\n                                          file-types=\".jpg,.jpeg,.png,.gif\"\n                                          max-size=\"ctrl.fileSizes.startScreen\"\n                                          is-overlay=\"false\"\n                                          display-icon=\"true\"\n                                          ng-disabled=\"!ctrl.json.admin.startScreenLogo.enabled\">\n                                  </upload>\n                                  <div class=\"file-title\" ng-if=\"ctrl.json.admin.startScreenLogo.file.attachment_file\" title=\"{{ctrl.json.admin.startScreenLogo.file.attachment_file | getFileName}}\">\n                                      <span>Uploaded: {{ ctrl.json.admin.startScreenLogo.file.attachment_file | getFileName:12 }}</span>\n                                      <md-button\n                                              class=\"md-icon-button md-primary\"\n                                              ng-click=\"ctrl.json.admin.startScreenLogo.file = {}\"\n                                              ng-disabled=\"!ctrl.json.admin.startScreenLogo.enabled\">\n                                          <md-icon>delete</md-icon>\n                                      </md-button>\n                                  </div>\n                                  <span class=\"slider-title\" ng-hide=\"!ctrl.json.admin.startScreenLogo.file.attachment_file\">Adjust logo size</span>\n                                  <md-slider-container ng-hide=\"!ctrl.json.admin.startScreenLogo.file.attachment_file\">\n                                      <md-slider\n                                              min=\"15\"\n                                              max=\"30\"\n                                              md-discrete\n                                              ng-model=\"ctrl.json.admin.startScreenLogo.size\"\n                                              aria-label=\"slider\"\n                                              ng-disabled=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.startScreenLogo.file.attachment_file\">\n                                      </md-slider>\n                                  </md-slider-container>\n                                  <div class=\"logo-sel-cont\" ng-hide=\"!ctrl.json.admin.startScreenLogo.file.attachment_file\">\n                                      <span class=\"logo-selector-title\">Select logo position</span>\n                                      <div class=\"logo-selector\">\n                                          <html-preview\n                                                  pr-width=\"{{1920}}\"\n                                                  pr-height=\"{{1080}}\"\n                                                  index=\"{{6.5}}\"\n                                                  background=\"{{[ctrl.json.admin.startScreenBackground.attachment_file]}}\"\n                                                  video-background=\"{{ctrl.getFileType(ctrl.json.admin.startScreenBackground) === 'mp4' ? ctrl.json.admin.startScreenBackground.attachment_file : '' }}\"\n                                                  areas=\"{{ctrl.json.admin.startScreenAreas}}\"\n                                                  related-values=\"true\"\n                                                  hide-overlay=\"true\"\n                                                  gif=\"{{ctrl.animatedIcons}}\"\n                                                  logo-type=\"'start'\"\n                                                  logo-size=\"ctrl.json.admin.startScreenLogo.size\"\n                                                  logo-position=\"ctrl.json.admin.startScreenLogo.position\"\n                                                  bg-mode=\"ctrl.json.admin.startScreenBackgroundMode\"\n                                                  bg-color=\"ctrl.json.admin.startScreenBackgroundColor\"\n                                                  bg-style=\"ctrl.json.admin.startScreenImageStyle\"\n                                                  hide-gif-icon=\"!ctrl.json.admin.gifBooth.enabled\"\n                                                  hide-photo-icon=\"!ctrl.json.admin.photoBooth.enabled\"\n                                                  transparency=\"ctrl.json.admin.startScreenLiveView\"\n                                                  hide-boomerang-icon=\"!ctrl.json.admin.boomerangBooth.enabled\">\n                                          </html-preview>\n                                          <md-radio-group\n                                                  ng-model=\"ctrl.json.admin.startScreenLogo.position\"\n                                                  ng-disabled=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                                  ng-change=\"ctrl.changeAreas()\"\n                                                  aria-label=\"Set logo position\">\n                                              <md-radio-button class=\"top-left\" ng-value=\"1\" aria-label=\"top left position\"></md-radio-button>\n                                              <md-radio-button class=\"top-middle\" ng-value=\"2\" aria-label=\"top middle position\"></md-radio-button>\n                                              <md-radio-button class=\"top-right\" ng-value=\"3\" aria-label=\"top right position\"></md-radio-button>\n                                              <md-radio-button class=\"bottom-left\" ng-value=\"4\" aria-label=\"bottom left position\"></md-radio-button>\n                                              <md-radio-button class=\"bottom-middle\" ng-value=\"5\" aria-label=\"bottom middle position\"></md-radio-button>\n                                              <md-radio-button class=\"bottom-right\" ng-value=\"6\" aria-label=\"bottom right position\"></md-radio-button>\n                                          </md-radio-group>\n                                      </div>\n                                  </div>\n\n                              </div>\n                          </div>\n                          <div class=\"setting-section\">\n                              <div class=\"ss-title\">\n                                  Background\n                              </div>\n                              <md-radio-group ng-model=\"ctrl.json.admin.startScreenBackgroundMode\" ng-change=\"ctrl.onModeChange()\">\n                                  <md-radio-button value=\"color\">Choose background color: </md-radio-button>\n                                  <color-picker class=\"color-picker-label\"\n                                                ng-model=\"ctrl.json.admin.startScreenBackgroundColor\"\n                                                options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n                                  <md-radio-button value=\"image\">Upload background image</md-radio-button>\n                              </md-radio-group>\n                              <div class=\"ss-bg-info\" ng-class=\"{'ss-disabled': ctrl.json.admin.startScreenBackgroundMode === 'color'}\">\n                                  <div class=\"icon\">\n                                      <i class=\"material-icons\">\n                                          info\n                                      </i>\n                                  </div>\n                                  <div class=\"info-text\">\n                                      {{\"Dimension \" + ctrl.json.admin.startScreenPreviewSize.width + \"x\" + ctrl.json.admin.startScreenPreviewSize.height + \"px\"}} <br>\n                                      Format .png .jpg .gif <br>\n                                      Size {{ctrl.fileSizes.startScreen}} mb\n                                  </div>\n                              </div>\n\n                              <div class=\"ss-tm-download\" ng-class=\"{'ss-disabled': ctrl.json.admin.startScreenBackgroundMode === 'color'}\">\n                                  <div class=\"icon\">\n                                      <i class=\"material-icons\">\n                                          get_app\n                                      </i>\n                                  </div>\n                                  <div class=\"info-text\">\n                                      Download Photoshop template\n                                  </div>\n                              </div>\n                              <upload\n                                      model=\"ctrl.json.admin.startScreenBackground\"\n                                      callback=\"ctrl.checkBackgroundResolution()\"\n                                      uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                      custom-label=\"{{'Upload' | translate}}\"\n                                      file-types=\".jpg,.jpeg,.gif,.png,.mp4\"\n                                      max-size=\"ctrl.fileSizes.startScreen\"\n                                      is-overlay=\"false\"\n                                      display-icon=\"true\"\n                                      ng-disabled=\"ctrl.json.admin.startScreenBackgroundMode === 'color'\">\n                              </upload>\n                              <div class=\"file-title\" ng-if=\"ctrl.json.admin.startScreenBackground.attachment_file\" title=\"{{ctrl.json.admin.startScreenBackground.attachment_file | getFileName}}\">\n                                  <span>Uploaded: {{ ctrl.json.admin.startScreenBackground.attachment_file | getFileName:12 }}</span>\n                                  <md-button\n                                          class=\"md-icon-button md-primary\"\n                                          ng-click=\"ctrl.json.admin.startScreenBackground.attachment_file = null\">\n                                      <md-icon>delete</md-icon>\n                                  </md-button>\n                              </div>\n                              <div class=\"image-crop\" ng-show=\"ctrl.json.admin.startScreenBackground.attachment_file && ctrl.json.admin.startScreenBackgroundMode !== 'color' && ctrl.showBgToggle\"  ng-class=\"{'ss-disabled': ctrl.json.admin.startScreenBackgroundMode === 'color'}\">\n                                  <div\n                                          class=\"title-crop\"\n                                          ng-class=\"{'crop-active': ctrl.json.admin.startScreenImageStyle === 'crop'}\"\n                                          ng-click=\"ctrl.json.admin.startScreenImageStyle = 'crop'\">\n                                      Crop image\n                                  </div>\n                                  <div class=\"toggle-small\">\n                                      <md-switch\n                                              md-invert\n                                              aria-label=\"set image style\"\n                                              ng-model=\"ctrl.json.admin.startScreenImageStyle\"\n                                              ng-true-value=\"'stretch'\"\n                                              ng-false-value=\"'crop'\"\n                                              ng-disabled=\"ctrl.json.admin.startScreenBackgroundMode === 'color'\">\n                                      </md-switch>\n                                  </div>\n                                  <div\n                                          class=\"title-crop\"\n                                          ng-class=\"{'crop-active': ctrl.json.admin.startScreenImageStyle === 'stretch'}\"\n                                          ng-click=\"ctrl.json.admin.startScreenImageStyle = 'stretch'\">\n                                      Stretch image\n                                  </div>\n                              </div>\n                          </div>\n                      </div>\n\n                      <div class=\"start-permision\">\n                          <md-switch\n                                  md-invert\n                                  ng-model=\"ctrl.json.admin.photoBooth.enabled\"\n                                  ng-change=\"ctrl.removeButtons()\">\n                              {{'Enable Single Photo in this configuration' | translate}}\n                          </md-switch>\n                          <md-switch\n                                  md-invert\n                                  ng-model=\"ctrl.json.admin.gifBooth.enabled\"\n                                  ng-change=\"ctrl.removeButtons()\">\n                              {{'Enable GIFs in this configuration' | translate}}\n                          </md-switch>\n                          <md-switch\n                                  md-invert\n                                  ng-model=\"ctrl.json.admin.boomerangBooth.enabled\"\n                                  ng-change=\"ctrl.removeButtons()\">\n                              {{'Enable Boomerangs in this configuration' | translate}}\n                          </md-switch>\n                          <md-switch\n                                  md-invert\n                                  ng-model=\"ctrl.json.admin.videoBooth.enabled\"\n                                  ng-change=\"ctrl.onVideoBoothEnabledChange()\">\n                              {{'Enable Video in this configuration (Android / Web only)' | translate}}\n                          </md-switch>\n\n                      </div>\n\n                      <p><strong>{{'Capture button settings:' | translate}}</strong></p>\n\n                      <div layout=\"row\" class=\"area-editor\">\n                          <div flex=\"30\" style=\"padding-top: 6px;\">{{'Single Photo button dimensions:' | translate}}</div>\n\n                          <start-screen-area\n                                  style=\"width: 100%\"\n                                  ng-if=\"ctrl.json.admin\"\n                                  model=\"ctrl.json.admin.startScreenAreas.single\"\n                                  is-disabled=\"!ctrl.json.admin.photoBooth.enabled\"\n                                  pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                                  pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                                  relative-size=\"ctrl.animatedIcons\"\n                                  company=\"ctrl.config.company\">\n                          </start-screen-area>\n\n                      </div>\n                      <div layout=\"row\" class=\"area-editor\">\n                          <div flex=\"30\">{{'Gif button dimensions:' | translate}}</div>\n\n                          <start-screen-area\n                                  style=\"width: 100%\"\n                                  ng-if=\"ctrl.json.admin\"\n                                  model=\"ctrl.json.admin.startScreenAreas.gif\"\n                                  is-disabled=\"!ctrl.json.admin.gifBooth.enabled\"\n                                  pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                                  pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                                  relative-size=\"ctrl.animatedIcons\"\n                                  company=\"ctrl.config.company\">\n                          </start-screen-area>\n\n                      </div>\n                      <div layout=\"row\" class=\"area-editor\">\n                          <div flex=\"30\">{{'Boomerang button dimensions:' | translate}}</div>\n\n                          <start-screen-area\n                                  style=\"width: 100%\"\n                                  ng-if=\"ctrl.json.admin\"\n                                  model=\"ctrl.json.admin.startScreenAreas.boomerang\"\n                                  is-disabled=\"!ctrl.json.admin.boomerangBooth.enabled\"\n                                  pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                                  pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                                  relative-size=\"ctrl.animatedIcons\"\n                                  company=\"ctrl.config.company\">\n                          </start-screen-area>\n\n                      </div>\n\n                      <div layout=\"row\" class=\"area-editor\">\n                          <div flex=\"30\" class=\"area-title\">{{'Video button dimensions:' | translate}}</div>\n\n                          <start-screen-area\n                                  style=\"width: 100%\"\n                                  ng-if=\"ctrl.json.admin\"\n                                  model=\"ctrl.json.admin.startScreenAreas.video\"\n                                  is-disabled=\"!ctrl.json.admin.videoBooth.enabled\"\n                                  pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                                  pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                                  relative-size=\"ctrl.animatedIcons\"\n                                  company=\"ctrl.config.company\">\n                          </start-screen-area>\n\n                      </div>\n\n\n                      <p><strong>{{'Camera settings:' | translate}}</strong></p>\n\n                      <md-input-container>\n                          <md-select ng-model=\"ctrl.json.admin.cameraPresetName\" aria-label=\"camera setting\">\n                              <md-option ng-value=\"'Default'\">Default</md-option>\n                              <md-option ng-value=\"'Sunlight'\">Sunlight</md-option>\n                              <md-option ng-value=\"'Night'\">Night</md-option>\n                          </md-select>\n                      </md-input-container>\n\n                      <md-switch\n                              md-invert\n                              ng-model=\"ctrl.json.admin.skipStartscreen\">\n                          {{'SKIP STARTSCREEN' | translate}}\n                      </md-switch>\n\n                      <md-switch\n                              md-invert\n                              ng-model=\"ctrl.animatedIcons\"\n                              ng-change=\"ctrl.onIconChange()\">\n                          {{'Default UpReach animated icons' | translate}}\n                      </md-switch>\n\n                      <md-switch\n                              md-invert\n                              ng-model=\"ctrl.json.admin.showPrinterCounter\">\n                          {{'Show printer counter' | translate}}\n                      </md-switch>\n\n                      <md-switch\n                              md-invert\n                              ng-change=\"ctrl.json.admin.enableChromakey ? ctrl.json.admin.disablePostFilters = true : null\"\n                              ng-model=\"ctrl.json.admin.enableChromakey\">\n                          {{'Enable chromakey' | translate}}\n                      </md-switch>\n\n                      <md-switch\n                              md-invert\n                              title=\"{{ctrl.json.admin.enableChromakey ? 'Filters is not enabled with chromakey option' : ''}}\"\n                              ng-change=\"ctrl.json.admin.enableChromakey ? ctrl.json.admin.disablePostFilters = true : null\"\n                              ng-model=\"ctrl.json.admin.disablePostFilters\">\n                          {{'Disable filters' | translate}}\n                      </md-switch>\n\n                      <md-switch\n                              md-invert\n                              ng-model=\"ctrl.json.admin.noise.active\">\n                          {{'Grain/noise' | translate}}\n                      </md-switch>\n                      <p ng-hide=\"!ctrl.json.admin.noise.active\">Noise percent</p>\n\n                      <md-slider-container ng-hide=\"!ctrl.json.admin.noise.active\" style=\"width: 70%\">\n                          <md-slider\n                                  min=\"0\"\n                                  max=\"100\"\n                                  step=\"1\"\n                                  md-discrete\n                                  ng-model=\"ctrl.json.admin.noise.value\"\n                                  aria-label=\"slider\">\n                          </md-slider>\n                      </md-slider-container>\n\n                      <md-switch\n                              md-invert\n                              ng-model=\"ctrl.json.admin.filtersNamesShow\">\n                          {{'Display Filters` names' | translate}}\n                      </md-switch>\n\n                      <md-switch\n                              md-invert\n                              ng-model=\"ctrl.json.admin.shouldRawPhotoUploaded\">\n                          {{'Save raw photos on the cloud' | translate}}\n                      </md-switch>\n\n                      <md-switch\n                              md-invert\n                              ng-model=\"ctrl.json.admin.startScreenLiveView.enabled\">\n                          {{'Display live view on the start screen' | translate}}\n                      </md-switch>\n                      <p ng-hide=\"!ctrl.json.admin.startScreenLiveView.enabled\">Opacity of the actual background</p>\n\n                      <md-slider-container ng-hide=\"!ctrl.json.admin.startScreenLiveView.enabled\" style=\"width: 70%\">\n\n                          <md-slider\n                                  min=\"0\"\n                                  max=\"100\"\n                                  step=\"5\"\n                                  md-discrete\n                                  ng-model=\"ctrl.json.admin.startScreenLiveView.backgroundOpacity\"\n                                  aria-label=\"slider\">\n                          </md-slider>\n                      </md-slider-container>\n\n                      <p ng-hide=\"!ctrl.json.admin.startScreenLiveView.enabled\">Opacity of the capture mode icons</p>\n\n                      <md-slider-container ng-hide=\"!ctrl.json.admin.startScreenLiveView.enabled\" style=\"width: 70%\">\n                          <md-slider\n                                  min=\"0\"\n                                  max=\"100\"\n                                  step=\"5\"\n                                  md-discrete\n                                  ng-model=\"ctrl.json.admin.startScreenLiveView.iconsOpacity\"\n                                  aria-label=\"slider\">\n                          </md-slider>\n                      </md-slider-container>\n\n                      <md-switch\n                              md-invert\n                              ng-model=\"ctrl.json.admin.upreachBadge\">\n                          {{'UpReach Badge' | translate}}\n                      </md-switch>\n\n                      <!--gdpr start-->\n                      <div class=\"row gdpr-wrapper\">\n                          <md-switch\n                                  md-invert\n                                  ng-model=\"ctrl.json.admin.gdpr.showGdpr\"\n                                  ng-change=\"ctrl.setGdprData(\n                      !ctrl.json.admin.gdpr.showGdpr)\">\n                              Enable GDPR compliant Start Screen\n                          </md-switch>\n                          <div class=\"upload-container flex-container\">\n                              <upload\n                                      uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                      custom-label=\"{{'Upload File' | translate}}\"\n                                      file-types=\".pdf,.png,.jpg\"\n                                      max-size=\"ctrl.fileSizes.gdprDocument\"\n                                      is-overlay=\"false\"\n                                      display-icon=\"false\"\n                                      old-file=\"ctrl.json.admin.gdpr.fileId\"\n                                      callback=\"ctrl.pdfGdprUpload(file, 'gdprFile')\">\n                              </upload>\n\n                              <div class=\"upload-info-wrapper\">\n                                  <div class=\"file-title\" ng-repeat=\"file in ctrl.json.admin.gdpr.gdprFile\">\n                                      <p>\n                                          <md-button\n                                                  class=\"md-icon-button md-primary\"\n                                                  ng-click=\"ctrl.gdprDeleteFile(ctrl.json.admin.gdpr.fileId, 'gdprFile')\">\n                                              <md-icon style=\"color: gray\">delete</md-icon>\n                                          </md-button>\n                                          <span title=\"{{file.original_name }}\">Uploaded: {{ file.original_name }}</span>\n                                      </p>\n                                  </div>\n                                  <p class=\"sub-text\">Format: .pdf, .png, .jpg <br>Size: < {{ctrl.fileSizes.gdprDocument}}mb</p>\n                              </div>\n                          </div>\n                      </div>\n                      <div ng-hide=\"!ctrl.json.admin.gdpr.showGdpr\" style=\"width: 85%;min-width: 617px\" class=\"gdpr-block\">\n                          <div class=\"col\">\n                              <div class=\"row strong-text\">\n                                  <md-switch\n                                          md-invert\n                                          ng-model=\"ctrl.json.admin.gdpr.gdprCustomButtonsEnabled\"\n                                          ng-change=\"ctrl.useGdprCustomButton(\n                      !ctrl.json.admin.gdpr.gdprCustomButtonsEnabled)\">\n                                      GDPR Buttons Upload\n                                  </md-switch>\n                              </div>\n                              <div class=\"row\">\n                                  <p class=\"sub-block-title\">Accept Button</p>\n                                  <div class=\"upload-container flex-container\">\n                                      <upload\n                                              uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                              custom-label=\"{{'Upload File' | translate}}\"\n                                              file-types=\".jpg,.jpeg,.svg,.png\"\n                                              ng-disabled=\"!ctrl.json.admin.gdpr.gdprCustomButtonsEnabled\"\n                                              max-size=\"ctrl.fileSizes.print\"\n                                              is-overlay=\"false\"\n                                              display-icon=\"false\"\n                                              callback=\"ctrl.gdprCustomButtonUpload(file, 'gdprAcceptButtonImage')\">\n                                      </upload>\n                                      <div class=\"upload-info-wrapper\">\n                                          <div class=\"file-title\" ng-repeat=\"file in ctrl.json.admin.gdpr.gdprAcceptButtonImage\">\n                                              <p>\n                                                  <md-button\n                                                          class=\"md-icon-button md-primary\"\n                                                          ng-click=\"ctrl.deleteFile(0, 'gdpr', 'gdprAcceptButtonImage',true)\">\n                                                      <md-icon style=\"color: gray\">delete</md-icon>\n                                                  </md-button>\n                                                  <span title=\"{{file.original_name }}\">Uploaded: {{ file.original_name }}</span>\n                                              </p>\n                                          </div>\n                                          <p class=\"sub-text\">Format: .svg, .png, .jpg <br>Size: < {{ctrl.fileSizes.print}}mb</p>\n                                      </div>\n                                  </div>\n                              </div>\n                              <div class=\"row\">\n                                  <p class=\"sub-block-title\">Decline Button</p>\n                                  <div class=\"upload-container flex-container\">\n                                      <upload\n                                              uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                              custom-label=\"{{'Upload File' | translate}}\"\n                                              file-types=\".jpg,.jpeg,.svg,.png\"\n                                              ng-disabled=\"!ctrl.json.admin.gdpr.gdprCustomButtonsEnabled\"\n                                              max-size=\"ctrl.fileSizes.print\"\n                                              is-overlay=\"false\"\n                                              display-icon=\"false\"\n                                              callback=\"ctrl.gdprCustomButtonUpload(file, 'gdprDeclineButtonImage')\">\n                                      </upload>\n                                      <div class=\"upload-info-wrapper\">\n                                          <div class=\"file-title\" ng-repeat=\"file in ctrl.json.admin.gdpr.gdprDeclineButtonImage\">\n                                              <p>\n                                                  <md-button\n                                                          class=\"md-icon-button md-primary\"\n                                                          ng-click=\"ctrl.deleteFile(0, 'gdpr', 'gdprDeclineButtonImage',true)\">\n                                                      <md-icon style=\"color: gray\">delete</md-icon>\n                                                  </md-button>\n                                                  <span title=\"{{file.original_name }}\">Uploaded: {{ file.original_name }}</span>\n                                              </p>\n                                          </div>\n                                          <p class=\"sub-text\">Format: .svg, .png, .jpg <br>Size: < {{ctrl.fileSizes.print}}mb</p>\n                                      </div>\n                                  </div>\n                              </div>\n                          </div>\n                      </div>\n                      <!--gdpr end-->\n\n                      <strong>\n                          <p>Admin's phone number for notification:</p>\n                      </strong>\n                      <form name=\"ctrl.notificationForm\">\n                          <md-input-container>\n                              <input\n                                      id=\"notificationPhone\"\n                                      name=\"notificationPhone\"\n                                      ng-model=\"ctrl.json.admin.notificationPhoneNumber\"\n                                      ng-pattern=\"/^\\d+$/\"\n                                      aria-label=\"Phone number\"\n                                      maxlength=\"15\"\n                                      type=\"text\">\n                              <div ng-messages=\"ctrl.notificationForm.notificationPhone.$error\" role=\"alert\">\n                                  <div ng-message-exp=\"['pattern']\" ng-bind=\"'Should contain numbers only' | translate\"></div>\n                              </div>\n                          </md-input-container>\n                      </form>\n\n                      <p>{{'Time after photo mode will return to the start screen: ' | translate}} <strong>{{ctrl.json.admin.startScreenReturnTime}}</strong> {{'seconds' | translate}}</p>\n                      <md-slider-container style=\"width: 70%\">\n                          <md-slider\n                                  min=\"30\"\n                                  max=\"120\"\n                                  step=\"5\"\n                                  md-discrete\n                                  ng-model=\"ctrl.json.admin.startScreenReturnTime\"\n                                  aria-label=\"slider\">\n                          </md-slider>\n                      </md-slider-container>\n                  </div>\n                  <div flex=\"40\" flex-sm=\"100\">\n                      <html-preview\n                              ng-show=\"ctrl.json.admin.general.width && ctrl.json.admin.general.height\"\n                              pr-width=\"{{ctrl.json.admin.general.width || 1920}}\"\n                              pr-height=\"{{ctrl.json.admin.general.height || 1080}}\"\n                              index=\"{{ctrl.json.admin.general.width > ctrl.json.admin.general.height ? (ctrl.json.admin.general.width * 1.7 / 1000) : (ctrl.json.admin.general.height * 1.7 / 1000)}}\"\n                              background=\"{{[ctrl.json.admin.startScreenBackground.attachment_file]}}\"\n                              video-background=\"{{ctrl.getFileType(ctrl.json.admin.startScreenBackground) === 'mp4' ? ctrl.json.admin.startScreenBackground.attachment_file : '' }}\"\n                              areas=\"{{ctrl.json.admin.startScreenAreas || {y: 0} }}\"\n                              related-values=\"true\"\n                              screen=\"start-screen\"\n                              show-title=\"true\"\n                              gif=\"{{ctrl.animatedIcons}}\"\n                              hide-photo-bg=\"!ctrl.animatedIcons\"\n                              ignore-overflow=\"true\"\n                              logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                              logo-size=\"ctrl.json.admin.startScreenLogo.size\"\n                              logo-position=\"ctrl.json.admin.startScreenLogo.position\"\n                              logo-type=\"'start'\"\n                              bg-mode=\"ctrl.json.admin.startScreenBackgroundMode\"\n                              bg-color=\"ctrl.json.admin.startScreenBackgroundColor\"\n                              bg-style=\"ctrl.json.admin.startScreenImageStyle\"\n                              hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled\"\n                              hide-gif-icon=\"!ctrl.json.admin.gifBooth.enabled\"\n                              hide-photo-icon=\"!ctrl.json.admin.photoBooth.enabled\"\n                              hide-video-icon=\"!ctrl.json.admin.videoBooth.enabled\"\n                              hide-boomerang-icon=\"!ctrl.json.admin.boomerangBooth.enabled\"\n                              transparency=\"ctrl.json.admin.startScreenLiveView\"\n                              badge-active=\"ctrl.json.admin.upreachBadge\">\n                      </html-preview>\n\n                  </div>\n              </div>\n\n              <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                  <div flex=\"50\" flex-sm=\"100\">\n                      <a href=\"#\"\n                         ng-click=\"ctrl.resetStep('start-screen')\"\n                         class=\"md-primary reset-link\">\n                          {{'Reset the Start Screen to the default settings' | translate}}\n                      </a>\n                      <md-button class=\"md-primary md-raised\" wz-next style=\"float: right\">{{'Next' | translate}}</md-button>\n                  </div>\n              </div>\n          </section>\n\n      </wz-step>\n\n            <!-- live view screen step -->\n            <wz-step\n                    wz-title=\"{{'Live View' | translate}}\">\n                <live-view\n                        ng-if=\"ctrl.json.admin.liveView;ctrl.isActiveStep('Live View')\"\n                        model=\"ctrl.json.admin.liveView\"\n                        sharing-qr=\"ctrl.json.admin.showQRCode\"\n                        sharing-sms=\"ctrl.json.admin.outputSettings.enableSmsSharing\"\n                        sharing-email=\"ctrl.json.admin.outputSettings.enableEmailSharing\"\n                        sharing-print=\"ctrl.hasPrintingInEnabledBooth()\"\n                        show-single=\"ctrl.json.admin.photoBooth.enabled\"\n                        show-gif=\"ctrl.json.admin.gifBooth.enabled\"\n                        show-boomerang=\"ctrl.json.admin.boomerangBooth.enabled\"\n                        show-filter=\"!ctrl.json.admin.disablePostFilters\"\n                        show-scenes=\"ctrl.json.admin.scenes.enabled\"\n                        general=\"ctrl.json.admin.general\"\n                        config=\"ctrl.config\"\n                        callback=\"ctrl.updateViewMode()\"\n                        reset=\"ctrl.resetStep('live-view')\"\n                        is-portraite=\"ctrl.json.admin.general.screenOrientation === 'portrait' ? true : false\"\n                        is-single=\"ctrl.checkBoothOptions()\"\n                ></live-view>\n            </wz-step>\n            <!-- end of live view screen step -->\n\n            <!-- scenes screen step -->\n            <wz-step\n                    wz-title=\"{{'Scenes' | translate}}\"\n                     canenter=\"!ctrl.loading\"\n                     canexit=\"ctrl.canExitScenes() && !ctrl.loading\">\n                <div ng-if=\"ctrl.isActiveStep('Scenes') && ctrl.hasCustomSceneScreenMismatch()\"\n                     class=\"custom-scene-warning\"\n                     layout=\"row\"\n                     layout-align=\"start center\">\n                    <md-icon>warning</md-icon>\n                    <span style=\"width: 100%;\">{{ctrl.getCustomSceneScreenWarningText()}}</span>\n                </div>\n                <scenes\n                        ng-if=\"ctrl.json.admin.scenes;ctrl.isActiveStep('Scenes')\"\n                        model=\"ctrl.json.admin.scenes\"\n                        general=\"ctrl.json.admin.general\"\n                        live-view=\"ctrl.json.admin.liveView\"\n                        company=\"ctrl.config.company\"\n                        single=\"ctrl.json.admin.photoBooth.enabled\"\n                        gif=\"ctrl.json.admin.gifBooth.enabled\"\n                        boomerang=\"ctrl.json.admin.boomerangBooth.enabled\"\n                        hide-photo-bg=\"ctrl.json.admin.enableChromakey\"\n                        callback=\"ctrl.onSceneDisable()\"\n                        unscreen-is-active=\"ctrl.json.admin.unscreen.us_active\"\n                        is-portraite=\"ctrl.json.admin.general.screenOrientation === 'portrait' ? true : false\"\n                        is-remove-bg-is-active=\"ctrl.json.admin.ai.replicate.replicate_remove_bg_active || ctrl.json.admin.ai.remaker.remaker_remove_bg_active\"\n                        new-design=\"true\"\n                        prompting-enabled=\"ctrl.json.admin.ai.replicate.replicate_remove_bg_active && ctrl.json.admin.ai.replicate.replicate_prompting_active\"\n                        prompting-quality=\"ctrl.json.admin.ai.replicate.replicate_prompt_quality\"\n                        active-modes=\"{photo:ctrl.json.admin.photoBooth.enabled,gif:ctrl.json.admin.gifBooth.enabled,boomerang: ctrl.json.admin.boomerangBooth.enabled,video: ctrl.json.admin.videoBooth.enabled}\"\n                        active-features=\"ctrl.sceneActiveFeatures\"\n                ></scenes>\n                <div ng-if=\"ctrl.isActiveStep('Scenes')\" layout=\"row\" class=\"general-footer\">\n                    <div flex=\"100\" flex-sm=\"100\">\n                        <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                            <div class=\"reset-btn-wrapper\" flex-sm=\"100\">\n                                <p>\n                                    <a href=\"#\"\n                                       ng-click=\"ctrl.resetStep('scenes')\"\n                                       class=\"md-primary reset-link\">\n                                        {{'Reset' | translate}}\n                                    </a>\n                                    {{'This puts everything back to default settings' | translate}}\n                                </p>\n                                <md-button class=\"md-primary md-raised\" wz-next style=\"float: right\">{{'Next' |\n                                    translate}}\n                                </md-button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </wz-step>\n            <!-- end of scenes screen step -->\n\n            <!-- single photo step -->\n            <wz-step\n                    wz-title=\"{{'Single Photo' | translate}}\"\n                    canenter=\"!ctrl.loading\"\n                    canexit=\"ctrl.canExitScreen('singlePhoto', 'photoBooth') && !ctrl.loading\"\n                    wz-disabled=\"{{ctrl.isStepDisabled('photoBooth')}}\">\n\n                <div ng-if=\"ctrl.isActiveStep('Single Photo')\" layout=\"row\" layout-sm=\"column\" layout-padding>\n\n                    <div flex=\"50\" flex-sm=\"100\">\n                        <div ng-class=\"{'item-disabled': !ctrl.json.admin.photoBooth.enabled}\">\n                            <p>{{'Countdown time:' | translate}}\n                                <strong>{{ctrl.json.admin.photoBooth.countdownTime}}</strong> {{'seconds' | translate}}\n                            </p>\n                            <md-slider-container>\n                                <md-slider\n                                        min=\"1\"\n                                        max=\"10\"\n                                        step=\"1\"\n                                        md-discrete\n                                        ng-model=\"ctrl.json.admin.photoBooth.countdownTime\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled\"\n                                        aria-label=\"slider\">\n                                </md-slider>\n                            </md-slider-container>\n                        </div>\n                        <p>{{'Photo Capture aspect ratio:' | translate}}</p>\n                        <md-radio-group\n                                ng-model=\"ctrl.viewValue.singlePhoto.photoCaptureRatio\"\n                                class=\"radio-inline-custom\"\n                                ng-change=\"ctrl.changePhotosAspectRatio('singlePhoto', true)\"\n                                ng-disabled=\"!ctrl.json.admin.photoBooth.enabled\">\n                            <md-radio-button value=\"square\" class=\"md-primary\">{{'Square (1:1)' | translate}}\n                            </md-radio-button>\n                            <md-radio-button value=\"landscape\" class=\"md-primary\">{{'Landscape (3:2)' | translate}}\n                            </md-radio-button>\n                            <md-radio-button value=\"portrait\" class=\"md-primary\">{{'Portrait (2:3)' | translate}}\n                            </md-radio-button>\n                            <md-radio-button value=\"custom\" class=\"md-primary\">{{'Custom' | translate}}\n                            </md-radio-button>\n                            <div class=\"photos-within-layout\" style=\"display: inline-block\">\n\n                                <form name=\"customPhotoSingle\">\n                                    <md-input-container class=\"md-block\">\n                                        <input\n                                                ng-required=\"ctrl.viewValue.singlePhoto.photoCaptureRatio === 'custom'\"\n                                                ng-model=\"ctrl.viewValue.singlePhoto.customPhotoWidth\"\n                                                type=\"number\"\n                                                min=\"{{ctrl.Math.round(ctrl.viewValue.singlePhoto.customPhotoHeight / 10)}}\"\n                                                max=\"{{ ctrl.Math.round(ctrl.viewValue.singlePhoto.customPhotoHeight * 10) }}\"\n                                                placeholder=\"Width\"\n                                                id=\"single-photo-ratio-width\"\n                                                ng-change=\"ctrl.changePhotosAspectRatio()\"\n                                                ng-blur=\"ctrl.viewValue.singlePhoto.customPhotoWidth = ctrl.viewValue.singlePhoto.customPhotoWidth || 1\"\n                                                ng-disabled=\"ctrl.viewValue.singlePhoto.photoCaptureRatio !== 'custom'\">\n                                    </md-input-container>\n                                    <md-input-container class=\"md-block\">\n                                        <input\n                                                ng-required=\"ctrl.viewValue.singlePhoto.photoCaptureRatio === 'custom'\"\n                                                ng-model=\"ctrl.viewValue.singlePhoto.customPhotoHeight\"\n                                                type=\"number\"\n                                                min=\"{{ctrl.Math.round(ctrl.viewValue.singlePhoto.customPhotoWidth / 10) }}\"\n                                                max=\"{{ctrl.Math.round(ctrl.viewValue.singlePhoto.customPhotoWidth * 10) }}\"\n                                                placeholder=\"Height\"\n                                                id=\"single-photo-ratio-height\"\n                                                ng-change=\"ctrl.changePhotosAspectRatio()\"\n                                                ng-blur=\"ctrl.viewValue.singlePhoto.customPhotoHeight = ctrl.viewValue.singlePhoto.customPhotoHeight || 0\"\n                                                ng-disabled=\"ctrl.viewValue.singlePhoto.photoCaptureRatio !== 'custom'\">\n                                    </md-input-container>\n                                </form>\n\n                            </div>\n\n                        </md-radio-group>\n\n                        <div ng-class=\"{'item-disabled': !ctrl.json.admin.photoBooth.enabled}\">\n\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.photoBooth.allowPrinting\"\n                                    ng-disabled=\"!ctrl.json.admin.photoBooth.enabled\"\n                                    ng-change=\"ctrl.checkOption('photoBooth', 'printing')\">\n                                Allow printing of Single Photos ({{ctrl.getCanvasTitle(\"singlePhoto\")}})\n                            </md-switch>\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.photoBooth.allowSharePrintFile\"\n                                    ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowPrinting\">\n                                Allow sharing of print file\n                            </md-switch>\n\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.photoBooth.printWithoutScenes\"\n                                    ng-if=\"ctrl.json.admin.scenes.enabled\">\n                                Insert photo without Scene\n                            </md-switch>\n\n                            <md-switch md-invert\n                                       ng-model=\"ctrl.json.admin.photoBooth.shouldOutputPhotoMirrored\"\n                                       ng-disabled=\"!ctrl.json.admin.photoBooth.enabled\">\n                                {{'Mirror photo' | translate}}\n                            </md-switch>\n\n                            <!-- md-select instead of radio: A1–A6, 10×15, 15×20, 2:3–4:3 -->\n                            <md-input-container>\n                                <label>{{'Layout aspect ratio:' | translate}}</label>\n                                <md-select\n                                        ng-model=\"ctrl.viewValue.singlePhoto.layoutAspectRatio\"\n                                        ng-change=\"ctrl.changeSinglePhotoLayoutRatio('singlePhoto')\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowPrinting\">\n                                    <md-optgroup ng-repeat=\"group in ctrl.printFormatOptionGroups\"\n                                                 label=\"{{group.label | translate}}\">\n                                        <md-option ng-repeat=\"opt in group.options\" ng-value=\"opt.id\">\n                                            {{opt.label | translate}}\n                                        </md-option>\n                                    </md-optgroup>\n                                </md-select>\n                            </md-input-container>\n                            <md-input-container>\n                                <label>{{'Print quality / DPI' | translate}}</label>\n                                <md-select\n                                        ng-model=\"ctrl.viewValue.singlePhoto.printDpi\"\n                                        ng-change=\"ctrl.changeSinglePhotoLayoutRatio('singlePhoto')\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowPrinting\">\n                                    <md-option ng-repeat=\"opt in ctrl.printDpiOptions\" ng-value=\"opt.value\">\n                                        {{opt.label | translate}}\n                                    </md-option>\n                                </md-select>\n                            </md-input-container>\n\n                            <div class=\"switch-with-tip\">\n                                <md-switch\n                                        md-invert\n                                        ng-model=\"ctrl.viewValue.singlePhoto.strip\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowPrinting\"\n                                        ng-change=\"ctrl.activatePhotoStrips()\">\n                                    {{'Activate Photo Strips' | translate}}\n                                </md-switch>\n                                <small>Activating Photo Strips will cut the print in half</small><br>\n                                <small>This is only possible for the 10×15 and 7.6×9 formats and depends on the printer the user is using</small>\n                            </div>\n\n                            <div class=\"photos-within-layout\">\n                                <p>{{'Photo(s) within the layout' | translate}}</p>\n\n                                <div class=\"photo-layout\" ng-repeat=\"photo in ctrl.viewValue.singlePhoto.photosArr\">\n\n                                    <photo-input\n                                            model=\"photo\"\n                                            layout-width=\"ctrl.viewValue.singlePhoto.printCanvasWidth\"\n                                            layout-height=\"ctrl.viewValue.singlePhoto.printCanvasHeight\"\n                                            ratio=\"{{ctrl.viewValue.singlePhoto.photoCaptureRatio}}\"\n                                            custom-ratio=\"{width: ctrl.viewValue.singlePhoto.customPhotoWidth, height: ctrl.viewValue.singlePhoto.customPhotoHeight}\"\n                                    ></photo-input>\n\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.removePhoto($index, 'singlePhoto', 'a')\"\n                                            ng-if=\"ctrl.viewValue.singlePhoto.photosArr.length > 1\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                                <md-button\n                                        class=\"add-ph\"\n                                        ng-if=\"ctrl.viewValue.singlePhoto.photosArr.length < 3\"\n                                        ng-click=\"ctrl.addNewPhoto('singlePhoto', 'a')\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowPrinting\">\n                                    Add this photo again\n                                </md-button>\n\n                                <div class=\"photo-layout\" ng-if=\"ctrl.viewValue.singlePhoto.strippedPhotosArr.length\"\n                                     ng-repeat=\"photo in ctrl.viewValue.singlePhoto.strippedPhotosArr\">\n\n                                    <photo-input\n                                            model=\"photo\"\n                                            is-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowPrinting\"\n                                            layout-width=\"ctrl.viewValue.singlePhoto.printCanvasWidth\"\n                                            layout-height=\"ctrl.viewValue.singlePhoto.printCanvasHeight\"\n                                            ratio=\"{{ctrl.viewValue.singlePhoto.photoCaptureRatio}}\"\n                                            custom-ratio=\"{width: ctrl.viewValue.singlePhoto.customPhotoWidth, height: ctrl.viewValue.singlePhoto.customPhotoHeight}\"\n                                    ></photo-input>\n\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.removePhoto($index, 'singlePhoto', 'b')\"\n                                            ng-if=\"ctrl.viewValue.singlePhoto.strippedPhotosArr.length > 1\"\n                                            ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowPrinting\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                                <md-button\n                                        ng-if=\"ctrl.viewValue.singlePhoto.strippedPhotosArr.length && ctrl.viewValue.singlePhoto.strippedPhotosArr.length < 3\"\n                                        class=\"add-ph\"\n                                        ng-click=\"ctrl.addNewPhoto('singlePhoto', 'b')\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowPrinting\">\n                                    Add this photo again\n                                </md-button>\n                            </div>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                        custom-label=\"{{'Upload a Background' | translate}}\"\n                                        file-types=\".jpg,.jpeg,.png\"\n                                        extra-info=\"{{'(JPG, PNG; ' + ctrl.fileSizes.print + 'mb; ' + ctrl.viewValue.singlePhoto.printCanvasWidth + 'x' + ctrl.viewValue.singlePhoto.printCanvasHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled\"\n                                        max-size=\"ctrl.fileSizes.print\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        callback=\"ctrl.testUpload(file, 'photoBooth', 'printingBackgroundFiles')\">\n                                </upload>\n\n                                <div class=\"file-title\"\n                                     ng-repeat=\"file in ctrl.json.admin.photoBooth.printingBackgroundFiles\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName:12 }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'photoBooth', 'printingBackgroundFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                        custom-label=\"{{'Upload an Overlay' | translate}}\"\n                                        file-types=\".png\"\n                                        extra-info=\"{{'(PNG; ' + ctrl.fileSizes.print + 'mb; ' + ctrl.viewValue.singlePhoto.printCanvasWidth + 'x' + ctrl.viewValue.singlePhoto.printCanvasHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled\"\n                                        max-size=\"ctrl.fileSizes.print\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        callback=\"ctrl.testUpload(file, 'photoBooth', 'printingOverlayFiles')\">\n                                </upload>\n\n                                <div class=\"file-title\"\n                                     ng-repeat=\"file in ctrl.json.admin.photoBooth.printingOverlayFiles\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'photoBooth', 'printingOverlayFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n                        </div>\n\n                    </div>\n                    <div flex=\"50\" flex-sm=\"100\" class=\"preview-container\">\n                        <p><strong>Single Photo preview - Print ({{ ctrl.getCanvasTitle(\"singlePhoto\") }})</strong></p>\n                        <md-switch\n                                class=\"printer-bleed\"\n                                md-invert\n                                ng-model=\"ctrl.json.admin.photoBooth.showPrinterBleeds\"\n                                ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowPrinting\">\n                            {{'Show printer bleed' | translate}}\n                        </md-switch>\n                        <!--  index, print-dpi — dynamic for preview and bleed (A1–A6, etc.) -->\n                        <html-preview\n                                single=\"true\"\n                                pr-width=\"{{ctrl.viewValue.singlePhoto.printCanvasWidth}}\"\n                                pr-height=\"{{ctrl.viewValue.singlePhoto.printCanvasHeight}}\"\n                                index=\"{{ ctrl.getPrintPreviewIndex('singlePhoto') }}\"\n                                print-dpi=\"{{ ctrl.getPrintDpi('singlePhoto') }}\"\n                                background=\"{{ctrl.json.admin.photoBooth.printingBackgroundFiles}}\"\n                                overlay=\"{{ctrl.json.admin.photoBooth.printingOverlayFiles}}\"\n                                video-background=\"{{ctrl.checkIsVideo(ctrl.json.admin.photoBooth.printingBackgroundFiles) ? ctrl.json.admin.photoBooth.printingBackgroundFiles : null}}\"\n                                video-overlay=\"{{ctrl.checkIsVideo(ctrl.json.admin.photoBooth.printingOverlayFiles) ? ctrl.json.admin.photoBooth.printingOverlayFiles : null}}\"\n                                areas=\"{{ctrl.mergeArrays(ctrl.viewValue.singlePhoto.photosArr, ctrl.viewValue.singlePhoto.strippedPhotosArr)}}\"\n                                style=\"margin: 0 auto\"\n                                strip=\"{{ctrl.viewValue.singlePhoto.strip}}\"\n                                ratio=\"{{ctrl.viewValue.singlePhoto.layoutAspectRatio}}\"\n                                printer-bleed=\"{{ctrl.json.admin.photoBooth.showPrinterBleeds}}\"\n                                logo-type=\"'print'\"\n                                logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                bg-mode=\"ctrl.json.admin.photoBooth.printingBackgroundMode\"\n                                bg-color=\"ctrl.json.admin.photoBooth.printingBackgroundColor\"\n                                hide-scene=\"ctrl.json.admin.photoBooth.printWithoutScenes\"\n                                bg-style=\"'stretch'\"\n                                hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled\"\n                                logos-arr=\"ctrl.json.admin.photoBooth.printingLogos\"\n                                scenes=\"ctrl.json.admin.scenes\"\n                                hide-photo-bg=\"ctrl.json.admin.scenes.enabled ? true : false\"\n                                mirror=\"ctrl.json.admin.photoBooth.shouldOutputPhotoMirrored\">\n                        </html-preview>\n                    </div>\n                </div>\n\n                <div ng-if=\"ctrl.isActiveStep('Single Photo')\" layout=\"row\" layout-sm=\"column\" layout-padding>\n                    <div flex=\"50\" flex-sm=\"100\">\n\n                        <div ng-class=\"{'item-disabled': !ctrl.json.admin.photoBooth.enabled}\">\n\n                            <div>\n                                <md-tooltip ng-if=\"ctrl.json.admin.scenes.enabled\" md-direction=\"top\">{{'Required while Scenes are enabled' | translate}}</md-tooltip>\n                                <md-switch\n                                        md-invert\n                                        ng-model=\"ctrl.json.admin.photoBooth.allowSharing\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || ctrl.json.admin.scenes.enabled\"\n                                        ng-change=\"ctrl.checkOption('photoBooth', 'sharing')\">\n                                    Allow sharing of digital Single Photos ({{ctrl.getDigitalCanvasTitle(\"singlePhoto\", true)}})\n                                </md-switch>\n                            </div>\n\n                            <div flex-sm=\"100\">\n                                <p>{{'Layout aspect ratio:' | translate}}</p>\n                                <md-radio-group\n                                        ng-model=\"ctrl.viewValue.singlePhoto.digitalFormat.layoutAspectRatio\"\n                                        class=\"radio-inline-custom\"\n                                        ng-change=\"ctrl.changeLayoutRatio('singlePhoto', true)\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowSharing\">\n                                    <md-radio-button value=\"square\" class=\"md-primary\">{{'Square (1:1)' | translate}}\n                                    </md-radio-button>\n                                    <md-radio-button value=\"landscape\" class=\"md-primary\">{{'Landscape (3:2)' |\n                                        translate}}\n                                    </md-radio-button>\n                                    <md-radio-button value=\"portrait\" class=\"md-primary\">{{'Portrait (2:3)' |\n                                        translate}}\n                                    </md-radio-button>\n                                    <md-radio-button value=\"custom\" class=\"md-primary\">{{'Custom' | translate}}\n                                    </md-radio-button>\n                                    <div class=\"photos-within-layout\" style=\"display: inline-block\" ng-class=\"{'active':ctrl.viewValue.singlePhoto.digitalFormat.layoutAspectRatio === 'custom'}\">\n                                        <md-input-container class=\"md-block\">\n                                            <input\n                                                    ng-model=\"ctrl.viewValue.singlePhoto.digitalFormat.customPhotoWidth\"\n                                                    type=\"number\"\n                                                    min=\"{{ctrl.Math.round(ctrl.viewValue.singlePhoto.digitalFormat.customPhotoHeight / 10)}}\"\n                                                    max=\"{{ ctrl.Math.round(ctrl.viewValue.singlePhoto.digitalFormat.customPhotoHeight * 10) }}\"\n                                                    placeholder=\"Width\"\n                                                    id=\"single-photo-digital-ratio-width\"\n                                                    ng-change=\"ctrl.changeLayoutRatio()\"\n                                                    ng-blur=\"ctrl.viewValue.singlePhoto.digitalFormat.customPhotoWidth = ctrl.viewValue.singlePhoto.digitalFormat.customPhotoWidth || 1\"\n                                                    ng-disabled=\"ctrl.viewValue.singlePhoto.digitalFormat.layoutAspectRatio !== 'custom' || !ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowSharing\">\n                                        </md-input-container>\n                                        <md-input-container class=\"md-block\">\n                                            <input\n                                                    ng-model=\"ctrl.viewValue.singlePhoto.digitalFormat.customPhotoHeight\"\n                                                    type=\"number\"\n                                                    min=\"{{ctrl.Math.round(ctrl.viewValue.singlePhoto.digitalFormat.customPhotoWidth / 10)}}\"\n                                                    max=\"{{ ctrl.Math.round(ctrl.viewValue.singlePhoto.digitalFormat.customPhotoWidth * 10) }}\"\n                                                    placeholder=\"Height\"\n                                                    id=\"single-photo-digital-ratio-height\"\n                                                    ng-change=\"ctrl.changeLayoutRatio()\"\n                                                    ng-blur=\"ctrl.viewValue.singlePhoto.digitalFormat.customPhotoHeight = ctrl.viewValue.singlePhoto.digitalFormat.customPhotoHeight || 1\"\n                                                    ng-disabled=\"ctrl.viewValue.singlePhoto.digitalFormat.layoutAspectRatio !== 'custom' || !ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowSharing\">\n                                        </md-input-container>\n                                    </div>\n\n                                </md-radio-group>\n                            </div>\n\n                            <div class=\"photos-within-layout wider\">\n                                <p>{{'Layout size'}}</p>\n                                <div>\n                                    <md-input-container class=\"md-block\">\n                                        <input\n                                                ng-model=\"ctrl.viewValue.singlePhoto.digitalFormat.layoutWidth\"\n                                                type=\"number\"\n                                                min=\"500\"\n                                                step=\"2\"\n                                                max=\"4000\"\n                                                placeholder=\"Width (px)\"\n                                                id=\"sharing-layout-width\"\n                                                ng-change=\"ctrl.changeSharingLayoutSize('singlePhoto', 'width')\">\n                                    </md-input-container>\n                                    <md-input-container class=\"md-block\">\n                                        <input\n                                                ng-model=\"ctrl.viewValue.singlePhoto.digitalFormat.layoutHeight\"\n                                                type=\"number\"\n                                                min=\"500\"\n                                                max=\"4000\"\n                                                step=\"2\"\n                                                placeholder=\"Height (px)\"\n                                                id=\"sharing-layout-height\"\n                                                ng-change=\"ctrl.changeSharingLayoutSize('singlePhoto', 'height')\">\n                                    </md-input-container>\n                                </div>\n\n                            </div>\n\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.photoBooth.startScreenDesignSharing\"\n                                    ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowSharing\"\n                                    ng-change=\"ctrl.checkStartScreenDesign('photoBooth')\">\n                                <strong>Use design from the start screen</strong>\n                            </md-switch>\n\n                            <md-switch md-invert\n                                       ng-model=\"ctrl.json.admin.photoBooth.showLiveViewOverlays\"\n                                       ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowSharing\">\n                                <strong>{{'Show live view overlays' | translate}}</strong>\n                            </md-switch>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments-many/'}}\"\n                                        custom-label=\"{{'Upload a Background(s)' | translate}}\"\n                                        file-types=\".jpg,.jpeg,.png\"\n                                        multiple=\"true\"\n                                        extra-info=\"{{'(JPG, PNG; ' + ctrl.fileSizes.sharing + 'mb; ' + ctrl.viewValue.singlePhoto.digitalFormat.layoutWidth + 'x' + ctrl.viewValue.singlePhoto.digitalFormat.layoutHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || ctrl.json.admin.photoBooth.startScreenDesignSharing || ctrl.json.admin.scenes.enabled\"\n                                        max-size=\"ctrl.fileSizes.sharing\"\n                                        callback=\"ctrl.testUpload(file, 'photoBooth', 'sharingBackgroundFiles')\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        images-array=\"ctrl.json.admin.photoBooth.sharingBackgroundFiles\">\n                                </upload>\n\n                                <div class=\"file-title\"\n                                     ng-repeat=\"file in ctrl.json.admin.photoBooth.sharingBackgroundFiles\"\n                                     ng-hide=\"ctrl.json.admin.scenes.enabled\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName:12 }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'photoBooth', 'sharingBackgroundFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments-many/'}}\"\n                                        custom-label=\"{{'Upload an Overlay(s)' | translate}}\"\n                                        file-types=\".png\"\n                                        multiple=\"true\"\n                                        extra-info=\"{{'(PNG; ' + ctrl.fileSizes.sharing + 'mb; ' + ctrl.viewValue.singlePhoto.digitalFormat.layoutWidth + 'x' + ctrl.viewValue.singlePhoto.digitalFormat.layoutHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || ctrl.json.admin.photoBooth.startScreenDesignSharing || ctrl.json.admin.scenes.enabled\"\n                                        callback=\"ctrl.testUpload(file, 'photoBooth', 'sharingOverlayFiles')\"\n                                        max-size=\"ctrl.fileSizes.sharing\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        images-array=\"ctrl.json.admin.photoBooth.sharingOverlayFiles\">\n                                </upload>\n\n                                <div class=\"file-title\"\n                                     ng-repeat=\"file in ctrl.json.admin.photoBooth.sharingOverlayFiles\"\n                                     ng-hide=\"ctrl.json.admin.photoBooth.startScreenDesignSharing || ctrl.json.admin.scenes.enabled\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName:12 }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'photoBooth', 'sharingOverlayFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n\n                            <div layout=\"row\"\n                                 ng-if=\"(ctrl.json.admin.photoBooth.sharingOverlayFiles && ctrl.json.admin.photoBooth.sharingOverlayFiles.length > 1) || (ctrl.json.admin.photoBooth.sharingBackgroundFiles && ctrl.json.admin.photoBooth.sharingBackgroundFiles.length > 1)\">\n                                <div flex=\"70\">\n                                    <p>{{'Animated overlay/background time: ' | translate}} <strong>{{\n                                        ctrl.json.admin.photoBooth.playbackSpeed }}</strong> {{'seconds' | translate}}\n                                    </p>\n                                    <md-slider-container>\n                                        <md-slider\n                                                min=\"1\"\n                                                max=\"5\"\n                                                step=\"0.5\"\n                                                md-discrete\n                                                ng-model=\"ctrl.json.admin.photoBooth.playbackSpeed\"\n                                                ng-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowSharing || ctrl.json.admin.scenes.enabled\"\n                                                aria-label=\"slider\">\n                                        </md-slider>\n                                    </md-slider-container>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"photos-within-layout\">\n                            <p>{{'Photo within the layout' | translate}}</p>\n\n                            <div class=\"photo-layout\">\n\n                                <photo-input\n                                        model=\"ctrl.viewValue.singlePhoto.digitalFormat.photos[0]\"\n                                        is-disabled=\"!ctrl.json.admin.photoBooth.enabled || !ctrl.json.admin.photoBooth.allowSharing\"\n                                        layout-width=\"ctrl.viewValue.singlePhoto.digitalFormat.layoutWidth\"\n                                        layout-height=\"ctrl.viewValue.singlePhoto.digitalFormat.layoutHeight\"\n                                        ratio=\"{{ctrl.viewValue.singlePhoto.photoCaptureRatio}}\"\n                                        custom-ratio=\"{width: ctrl.viewValue.singlePhoto.digitalFormat.customPhotoWidth, height: ctrl.viewValue.singlePhoto.digitalFormat.customPhotoHeight}\"\n                                ></photo-input>\n\n                            </div>\n                        </div>\n\n                    </div>\n                    <div flex=\"50\" flex-sm=\"100\" class=\"preview-container\">\n                        <p><strong>Single Photo preview - Digital ({{ctrl.getDigitalCanvasTitle(\"singlePhoto\",\n                            true)}})</strong></p>\n                        <html-preview\n                                single=\"true\"\n                                pr-width=\"{{\n                    ctrl.json.admin.liveView.liveViewMode === 'fullscreen'\n                      ? ctrl.json.admin.general.width\n                      : ctrl.viewValue.singlePhoto.digitalFormat.layoutWidth\n                  }}\"\n\n                                pr-height=\"{{\n                    ctrl.json.admin.liveView.liveViewMode === 'fullscreen'\n                      ? ctrl.json.admin.general.height\n                      : ctrl.viewValue.singlePhoto.digitalFormat.layoutHeight\n                  }}\"\n\n                                index=\"{{\n                    ctrl.json.admin.liveView.liveViewMode !== 'fullscreen'\n                      ? (ctrl.viewValue.singlePhoto.digitalFormat.layoutWidth > ctrl.viewValue.singlePhoto.digitalFormat.layoutHeight\n                          ? (ctrl.viewValue.singlePhoto.digitalFormat.layoutWidth * 2.5 / 1000)\n                          : (ctrl.viewValue.singlePhoto.digitalFormat.layoutHeight * 2.5 / 1000))\n                      : (ctrl.json.admin.general.width > ctrl.json.admin.general.height\n                          ? (ctrl.json.admin.general.width * 2.5 / 1000)\n                          : (ctrl.json.admin.general.height * 2.5 / 1000))\n                    }}\"\n                                background=\"{{ctrl.json.admin.photoBooth.sharingBackgroundFiles}}\"\n                                overlay=\"{{ctrl.json.admin.photoBooth.sharingOverlayFiles}}\"\n                                video-background=\"{{ctrl.checkIsVideo(ctrl.json.admin.photoBooth.sharingBackgroundFiles[0])? ctrl.json.admin.photoBooth.sharingBackgroundFiles[0] : null}}\"\n                                video-overlay=\"{{ctrl.checkIsVideo(ctrl.json.admin.photoBooth.sharingOverlayFiles[0])? ctrl.json.admin.photoBooth.sharingOverlayFiles[0] : null}}\"\n                                areas=\"{{ctrl.viewValue.singlePhoto.digitalFormat.photos}}\"\n                                animation-speed=\"{{ctrl.json.admin.photoBooth.playbackSpeed}}\"\n                                style=\"margin: 0 auto\"\n                                logo-type=\"'digital'\"\n                                logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                bg-mode=\"ctrl.json.admin.photoBooth.sharingBackgroundMode\"\n                                bg-color=\"ctrl.json.admin.photoBooth.sharingBackgroundColor\"\n                                hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.photoBooth.startScreenDesignSharing\"\n                                hide-photo-bg=\"ctrl.json.admin.enableChromakey\"\n                                mirror=\"ctrl.json.admin.photoBooth.shouldOutputPhotoMirrored\">\n                        </html-preview>\n                    </div>\n                </div>\n\n                <div ng-if=\"ctrl.isActiveStep('Single Photo')\" layout=\"row\" class=\"general-footer\">\n                    <div flex=\"100\" flex-sm=\"100\">\n                        <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                            <div class=\"reset-btn-wrapper\" flex-sm=\"100\">\n                                <p>\n                                    <a href=\"#\"\n                                       ng-click=\"ctrl.resetStep('single-photo')\"\n                                       class=\"md-primary reset-link\">\n                                        {{'Reset' | translate}}\n                                    </a>\n                                    {{'This puts everything back to default settings' | translate}}\n                                </p>\n                                <md-button class=\"md-primary md-raised\" wz-next style=\"float: right\">{{'Next' |\n                                    translate}}\n                                </md-button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n            </wz-step>\n            <!-- end of single photo step -->\n\n            <!-- gif step -->\n            <wz-step\n                    wz-title=\"{{'GIF' | translate}}\"\n                    canenter=\"!ctrl.loading\"\n                    wz-disabled=\"{{ctrl.isStepDisabled('gifBooth')}}\"\n                    canexit=\"ctrl.canExitScreen('gif', 'gifBooth') && !ctrl.loading\">\n\n                <div ng-if=\"ctrl.isActiveStep('GIF')\" layout=\"row\" layout-sm=\"column\" layout-padding>\n                    <div flex=\"50\" flex-sm=\"100\">\n                        <div ng-class=\"{'item-disabled': !ctrl.json.admin.gifBooth.enabled}\">\n                            <p>{{'Countdown time:' | translate}}\n                                <strong>{{ctrl.json.admin.gifBooth.countdownTime}}</strong> {{'seconds' | translate}}\n                            </p>\n                            <md-slider-container>\n                                <md-slider\n                                        min=\"1\"\n                                        max=\"10\"\n                                        step=\"1\"\n                                        md-discrete\n                                        ng-model=\"ctrl.json.admin.gifBooth.countdownTime\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled\"\n                                        aria-label=\"slider\">\n                                </md-slider>\n                            </md-slider-container>\n                        </div>\n                        <p>{{'Photo Capture aspect ratio:' | translate}}</p>\n                        <md-radio-group\n                                ng-model=\"ctrl.viewValue.gif.photoCaptureRatio\"\n                                class=\"radio-inline-custom\"\n                                ng-change=\"ctrl.changePhotosAspectRatio('gif', true)\"\n                                ng-disabled=\"!ctrl.json.admin.gifBooth.enabled\">\n                            <md-radio-button value=\"square\" class=\"md-primary\">{{'Square (1:1)' | translate}}\n                            </md-radio-button>\n                            <md-radio-button value=\"landscape\" class=\"md-primary\">{{'Landscape (3:2)' | translate}}\n                            </md-radio-button>\n                            <md-radio-button value=\"portrait\" class=\"md-primary\">{{'Portrait (2:3)' | translate}}\n                            </md-radio-button>\n                            <md-radio-button value=\"custom\" class=\"md-primary\">{{'Custom' | translate}}\n                            </md-radio-button>\n                            <div class=\"photos-within-layout\" style=\"display: inline-block\">\n                                <md-input-container class=\"md-block\">\n                                    <input\n                                            ng-model=\"ctrl.viewValue.gif.customPhotoWidth\"\n                                            type=\"number\"\n                                            min=\"{{ctrl.Math.round(ctrl.viewValue.gif.customPhotoHeight / 10)}}\"\n                                            max=\"{{ ctrl.Math.round(ctrl.viewValue.gif.customPhotoHeight * 10) }}\"\n                                            placeholder=\"Width\"\n                                            id=\"gif-ratio-width\"\n                                            ng-change=\"ctrl.changePhotosAspectRatio('gif')\"\n                                            ng-blur=\"ctrl.viewValue.gif.customPhotoWidth = ctrl.viewValue.gif.customPhotoWidth || 1\"\n                                            ng-disabled=\"ctrl.viewValue.gif.photoCaptureRatio !== 'custom'\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block\">\n                                    <input\n                                            ng-model=\"ctrl.viewValue.gif.customPhotoHeight\"\n                                            type=\"number\"\n                                            min=\"{{ctrl.Math.round(ctrl.viewValue.gif.customPhotoWidth / 10)}}\"\n                                            max=\"{{ ctrl.Math.round(ctrl.viewValue.gif.customPhotoWidth * 10) }}\"\n                                            placeholder=\"Height\"\n                                            id=\"gif-ratio-height\"\n                                            ng-change=\"ctrl.changePhotosAspectRatio('gif')\"\n                                            ng-blur=\"ctrl.viewValue.gif.customPhotoHeight = ctrl.viewValue.gif.customPhotoHeight || 1\"\n                                            ng-disabled=\"ctrl.viewValue.gif.photoCaptureRatio !== 'custom'\">\n                                </md-input-container>\n                            </div>\n\n                        </md-radio-group>\n\n                        <div ng-class=\"{'item-disabled': !ctrl.json.admin.gifBooth.enabled}\">\n\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.gifBooth.allowPrinting\"\n                                    ng-disabled=\"!ctrl.json.admin.gifBooth.enabled\"\n                                    ng-change=\"ctrl.checkOption('gifBooth', 'printing')\">\n                                Allow printing of GIFs ({{ctrl.getCanvasTitle(\"gif\")}})\n                            </md-switch>\n\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.gifBooth.allowSharePrintFile\"\n                                    ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowPrinting\">\n                                Allow sharing of print file\n                            </md-switch>\n\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.gifBooth.printWithoutScenes\"\n                                    ng-if=\"ctrl.json.admin.scenes.enabled\">\n                                Insert photo without Scene\n                            </md-switch>\n                            <md-switch md-invert\n                                       ng-model=\"ctrl.json.admin.gifBooth.shouldOutputPhotoMirrored\"\n                                       ng-disabled=\"!ctrl.json.admin.gifBooth.enabled\">\n                                {{'Mirror photo' | translate}}\n                            </md-switch>\n\n                            <!--  md-select format and DPI for GIF -->\n                            <md-input-container>\n                                <label>{{'Layout aspect ratio:' | translate}}</label>\n                                <md-select\n                                        ng-model=\"ctrl.viewValue.gif.layoutAspectRatio\"\n                                        ng-change=\"ctrl.changeSinglePhotoLayoutRatio('gif')\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowPrinting\">\n                                    <md-optgroup ng-repeat=\"group in ctrl.printFormatOptionGroups\"\n                                                 label=\"{{group.label | translate}}\">\n                                        <md-option ng-repeat=\"opt in group.options\" ng-value=\"opt.id\">\n                                            {{opt.label | translate}}\n                                        </md-option>\n                                    </md-optgroup>\n                                </md-select>\n                            </md-input-container>\n                            <md-input-container>\n                                <label>{{'Print quality / DPI' | translate}}</label>\n                                <md-select\n                                        ng-model=\"ctrl.viewValue.gif.printDpi\"\n                                        ng-change=\"ctrl.changeSinglePhotoLayoutRatio('gif')\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowPrinting\">\n                                    <md-option ng-repeat=\"opt in ctrl.printDpiOptions\" ng-value=\"opt.value\">\n                                        {{opt.label | translate}}\n                                    </md-option>\n                                </md-select>\n                            </md-input-container>\n\n                            <div class=\"switch-with-tip\">\n                                <md-switch\n                                        md-invert\n                                        ng-model=\"ctrl.viewValue.gif.strip\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowPrinting\"\n                                        ng-change=\"ctrl.activatePhotoStrips('gif')\">\n                                    {{'Activate Photo Strips' | translate}}\n                                </md-switch>\n                                <small>Activating Photo Strips will cut the print in half</small><br>\n                                <small>This is only possible for the 10×15 and 7.6×9 formats and depends on the printer the user is using</small>\n                            </div>\n\n                            <div class=\"photos-within-layout\">\n                                <p>{{'Photo(s) within the layout' | translate}}</p>\n\n                                <div class=\"photo-layout\" ng-repeat=\"photo in ctrl.viewValue.gif.photosArr\">\n\n                                    <photo-input\n                                            model=\"photo\"\n                                            is-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowPrinting\"\n                                            layout-width=\"ctrl.viewValue.gif.printCanvasWidth\"\n                                            layout-height=\"ctrl.viewValue.gif.printCanvasHeight\"\n                                            ratio=\"{{ctrl.viewValue.gif.photoCaptureRatio}}\"\n                                            custom-ratio=\"{width: ctrl.viewValue.gif.customPhotoWidth, height: ctrl.viewValue.gif.customPhotoHeight}\"\n                                    ></photo-input>\n\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.removePhoto($index, 'gif', 'a')\"\n                                            ng-if=\"ctrl.viewValue.gif.photosArr.length > 1\"\n                                            ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowPrinting\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                                <md-button\n                                        class=\"add-ph\"\n                                        ng-if=\"ctrl.viewValue.gif.photosArr.length < 3\"\n                                        ng-click=\"ctrl.addNewPhoto('gif', 'a')\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowPrinting\">\n                                    Add this photo again\n                                </md-button>\n                                <div class=\"photo-layout\" ng-if=\"ctrl.viewValue.gif.strippedPhotosArr.length\"\n                                     ng-repeat=\"photo in ctrl.viewValue.gif.strippedPhotosArr\">\n\n                                    <photo-input\n                                            model=\"photo\"\n                                            is-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowPrinting\"\n                                            layout-width=\"ctrl.viewValue.gif.printCanvasWidth\"\n                                            layout-height=\"ctrl.viewValue.gif.printCanvasHeight\"\n                                            ratio=\"{{ctrl.viewValue.gif.photoCaptureRatio}}\"\n                                            custom-ratio=\"{width: ctrl.viewValue.gif.customPhotoWidth, height: ctrl.viewValue.gif.customPhotoHeight}\"\n                                    ></photo-input>\n\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.removePhoto($index, 'gif', 'b')\"\n                                            ng-if=\"ctrl.viewValue.gif.strippedPhotosArr.length > 1\"\n                                            ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowPrinting\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                                <md-button\n                                        class=\"add-ph\"\n                                        ng-click=\"ctrl.addNewPhoto('gif', 'b')\"\n                                        ng-if=\"ctrl.viewValue.gif.strippedPhotosArr.length && ctrl.viewValue.gif.strippedPhotosArr.length < 3\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowPrinting\">\n                                    Add this photo again\n                                </md-button>\n                            </div>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                        custom-label=\"{{'Upload a Background' | translate}}\"\n                                        file-types=\".jpg,.jpeg,.png\"\n                                        extra-info=\"{{'(JPG, PNG; ' + ctrl.fileSizes.print + 'mb; ' + ctrl.viewValue.gif.printCanvasWidth + 'x' + ctrl.viewValue.gif.printCanvasHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled\"\n                                        max-size=\"ctrl.fileSizes.print\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        callback=\"ctrl.testUpload(file, 'gifBooth', 'printingBackgroundFiles')\">\n                                </upload>\n\n                                <div class=\"file-title\"\n                                     ng-repeat=\"file in ctrl.json.admin.gifBooth.printingBackgroundFiles\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName:12 }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'gifBooth', 'printingBackgroundFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                        custom-label=\"{{'Upload an Overlay' | translate}}\"\n                                        file-types=\".png\"\n                                        extra-info=\"{{'(PNG; ' + ctrl.fileSizes.print + 'mb; ' + ctrl.viewValue.gif.printCanvasWidth + 'x' + ctrl.viewValue.gif.printCanvasHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled\"\n                                        max-size=\"ctrl.fileSizes.print\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        callback=\"ctrl.testUpload(file, 'gifBooth', 'printingOverlayFiles')\">\n                                </upload>\n\n                                <div class=\"file-title\"\n                                     ng-repeat=\"file in ctrl.json.admin.gifBooth.printingOverlayFiles\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'gifBooth', 'printingOverlayFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n\n                        </div>\n\n                    </div>\n                    <div flex=\"50\" flex-sm=\"100\" class=\"preview-container\">\n                        <p><strong>GIF preview - Print ({{ctrl.getCanvasTitle(\"gif\")}})</strong></p>\n                        <md-switch\n                                class=\"printer-bleed\"\n                                md-invert\n                                ng-model=\"ctrl.json.admin.gifBooth.showPrinterBleeds\"\n                                ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowPrinting\">\n                            {{'Show printer bleed' | translate}}\n                        </md-switch>\n                        <!--  index, print-dpi for GIF preview -->\n                        <html-preview\n                                pr-width=\"{{ctrl.viewValue.gif.printCanvasWidth}}\"\n                                pr-height=\"{{ctrl.viewValue.gif.printCanvasHeight}}\"\n                                index=\"{{ ctrl.getPrintPreviewIndex('gif') }}\"\n                                print-dpi=\"{{ ctrl.getPrintDpi('gif') }}\"\n                                background=\"{{ctrl.json.admin.gifBooth.printingBackgroundFiles}}\"\n                                overlay=\"{{ctrl.json.admin.gifBooth.printingOverlayFiles}}\"\n                                video-background=\"{{ctrl.checkIsVideo(ctrl.json.admin.gifBooth.printingBackgroundFiles) ? ctrl.json.admin.gifBooth.printingBackgroundFiles : null}}\"\n                                video-overlay=\"{{ctrl.checkIsVideo(ctrl.json.admin.gifBooth.printingOverlayFiles) ? ctrl.json.admin.gifBooth.printingOverlayFiles : null}}\"\n                                areas=\"{{ctrl.mergeArrays(ctrl.viewValue.gif.photosArr, ctrl.viewValue.gif.strippedPhotosArr)}}\"\n                                style=\"margin: 0 auto\"\n                                strip=\"{{ctrl.viewValue.gif.strip}}\"\n                                ratio=\"{{ctrl.viewValue.gif.layoutAspectRatio}}\"\n                                printer-bleed=\"{{ctrl.json.admin.gifBooth.showPrinterBleeds}}\"\n                                logo-type=\"'strip'\"\n                                logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                bg-mode=\"ctrl.json.admin.gifBooth.printingBackgroundMode\"\n                                bg-color=\"ctrl.json.admin.gifBooth.printingBackgroundColor\"\n                                hide-scene=\"ctrl.json.admin.gifBooth.printWithoutScenes\"\n                                bg-style=\"'stretch'\"\n                                hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled\"\n                                logos-arr=\"ctrl.json.admin.gifBooth.printingLogos\"\n                                scenes=\"ctrl.json.admin.scenes\"\n                                hide-photo-bg=\"ctrl.json.admin.scenes.enabled ? true : false\"\n                                mirror=\"ctrl.json.admin.gifBooth.shouldOutputPhotoMirrored\">\n                        </html-preview>\n                    </div>\n                </div>\n\n                <div ng-if=\"ctrl.isActiveStep('GIF')\" layout=\"row\" layout-sm=\"column\" layout-padding>\n                    <div flex=\"50\" flex-sm=\"100\">\n\n                        <div ng-class=\"{'item-disabled': !ctrl.json.admin.gifBooth.enabled}\">\n\n                            <div>\n                                <md-tooltip ng-if=\"ctrl.json.admin.scenes.enabled\" md-direction=\"top\">{{'Required while Scenes are enabled' | translate}}</md-tooltip>\n                                <md-switch\n                                        md-invert\n                                        ng-model=\"ctrl.json.admin.gifBooth.allowSharing\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || ctrl.json.admin.scenes.enabled\"\n                                        ng-change=\"ctrl.checkOption('gifBooth', 'sharing')\">\n                                    Allow sharing of digital GIFs ({{ctrl.getDigitalCanvasTitle(\"gif\", true)}})\n                                </md-switch>\n                            </div>\n\n                            <div flex-sm=\"100\">\n                                <p>{{'Layout aspect ratio:' | translate}}</p>\n                                <md-radio-group\n                                        ng-if=\"ctrl.json.admin.liveView.liveViewMode !== 'fullscreen'\"\n                                        ng-model=\"ctrl.viewValue.gif.digitalFormat.layoutAspectRatio\"\n                                        class=\"radio-inline-custom\"\n                                        ng-change=\"ctrl.changeLayoutRatio('gif', true)\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowSharing\">\n                                    <md-radio-button value=\"square\" class=\"md-primary\">{{'Square (1:1)' | translate}}\n                                    </md-radio-button>\n                                    <md-radio-button value=\"landscape\" class=\"md-primary\">{{'Landscape (3:2)' |\n                                        translate}}\n                                    </md-radio-button>\n                                    <md-radio-button value=\"portrait\" class=\"md-primary\">{{'Portrait (2:3)' |\n                                        translate}}\n                                    </md-radio-button>\n                                    <md-radio-button value=\"custom\" class=\"md-primary\">{{'Custom' | translate}}\n                                    </md-radio-button>\n                                    <div class=\"photos-within-layout\" style=\"display: inline-block\"  ng-class=\"{'active':ctrl.viewValue.singlePhoto.digitalFormat.layoutAspectRatio === 'custom'}\">\n                                        <md-input-container class=\"md-block\">\n                                            <input\n                                                    ng-model=\"ctrl.viewValue.gif.digitalFormat.customPhotoWidth\"\n                                                    type=\"number\"\n                                                    min=\"{{ctrl.Math.round(ctrl.viewValue.gif.digitalFormat.customPhotoHeight / 10)}}\"\n                                                    max=\"{{ ctrl.Math.round(ctrl.viewValue.gif.digitalFormat.customPhotoHeight * 10) }}\"\n                                                    placeholder=\"Width\"\n                                                    id=\"gif-digital-ratio-width\"\n                                                    ng-change=\"ctrl.changeLayoutRatio('gif')\"\n                                                    ng-blur=\"ctrl.viewValue.gif.digitalFormat.customPhotoWidth = ctrl.viewValue.gif.digitalFormat.customPhotoWidth || 1\"\n                                                    ng-disabled=\"ctrl.viewValue.gif.digitalFormat.layoutAspectRatio !== 'custom' || !ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowSharing\">\n                                        </md-input-container>\n                                        <md-input-container class=\"md-block\">\n                                            <input\n                                                    ng-model=\"ctrl.viewValue.gif.digitalFormat.customPhotoHeight\"\n                                                    type=\"number\"\n                                                    min=\"{{ctrl.Math.round(ctrl.viewValue.gif.digitalFormat.customPhotoWidth / 10)}}\"\n                                                    max=\"{{ ctrl.Math.round(ctrl.viewValue.gif.digitalFormat.customPhotoWidth * 10) }}\"\n                                                    placeholder=\"Height\"\n                                                    id=\"gif-digital-ratio-height\"\n                                                    ng-change=\"ctrl.changeLayoutRatio('gif')\"\n                                                    ng-blur=\"ctrl.viewValue.gif.digitalFormat.customPhotoHeight = ctrl.viewValue.gif.digitalFormat.customPhotoHeight || 1\"\n                                                    ng-disabled=\"ctrl.viewValue.gif.digitalFormat.layoutAspectRatio !== 'custom' || !ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowSharing\">\n                                        </md-input-container>\n                                    </div>\n\n                                </md-radio-group>\n\n                                <div ng-if=\"ctrl.json.admin.liveView.liveViewMode === 'fullscreen'\"\n                                     class=\"photos-within-layout\" style=\"display: inline-block\">\n                                    <md-input-container class=\"md-block\">\n                                        <md-tooltip md-direction=\"top\">You can change it on general tab</md-tooltip>\n                                        <input\n                                                ng-model=\"ctrl.json.admin.general.aspectRatio.width\"\n                                                type=\"number\"\n                                                placeholder=\"Width\"\n                                                id=\"gif-digital-ratio-width\"\n                                                ng-disabled=\"true\">\n                                    </md-input-container>\n                                    <md-input-container class=\"md-block\">\n                                        <md-tooltip md-direction=\"top\">You can change it on general tab</md-tooltip>\n                                        <input\n                                                ng-model=\"ctrl.json.admin.general.aspectRatio.height\"\n                                                type=\"number\"\n                                                placeholder=\"Height\"\n                                                id=\"gif-digital-ratio-height\"\n                                                ng-disabled=\"true\">\n                                    </md-input-container>\n                                </div>\n                            </div>\n\n                            <div class=\"photos-within-layout wider\">\n                                <p>{{'Layout size'}}</p>\n                                <div ng-if=\"ctrl.json.admin.liveView.liveViewMode !== 'fullscreen'\">\n                                    <md-input-container class=\"md-block\">\n                                        <input\n                                                ng-model=\"ctrl.viewValue.gif.digitalFormat.layoutWidth\"\n                                                type=\"number\"\n                                                min=\"500\"\n                                                max=\"4000\"\n                                                step=\"2\"\n                                                placeholder=\"Width (px)\"\n                                                id=\"gif-layout-width\"\n                                                ng-change=\"ctrl.changeSharingLayoutSize('gif', 'width')\">\n                                    </md-input-container>\n                                    <md-input-container class=\"md-block\">\n                                        <input\n                                                ng-model=\"ctrl.viewValue.gif.digitalFormat.layoutHeight\"\n                                                type=\"number\"\n                                                min=\"500\"\n                                                max=\"4000\"\n                                                step=\"2\"\n                                                placeholder=\"Height (px)\"\n                                                id=\"gif-layout-height\"\n                                                ng-change=\"ctrl.changeSharingLayoutSize('gif', 'height')\">\n                                    </md-input-container>\n                                </div>\n                                <div ng-if=\"ctrl.json.admin.liveView.liveViewMode === 'fullscreen'\">\n                                    <md-input-container class=\"md-block\">\n                                        <md-tooltip md-direction=\"top\">You can change it on general tab</md-tooltip>\n                                        <input\n                                                ng-model=\"ctrl.json.admin.general.width\"\n                                                type=\"number\"\n                                                placeholder=\"Width (px)\"\n                                                id=\"gif-layout-width\"\n                                                ng-disabled=\"true\">\n                                    </md-input-container>\n                                    <md-input-container class=\"md-block\">\n                                        <md-tooltip md-direction=\"top\">You can change it on general tab</md-tooltip>\n                                        <input\n                                                ng-model=\"ctrl.json.admin.general.height\"\n                                                type=\"number\"\n                                                step=\"2\"\n                                                placeholder=\"Height (px)\"\n                                                id=\"gif-layout-height\"\n                                                ng-disabled=\"true\">\n                                    </md-input-container>\n                                </div>\n                            </div>\n\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.gifBooth.startScreenDesignSharing\"\n                                    ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowSharing\"\n                                    ng-change=\"ctrl.checkStartScreenDesign('gifBooth')\">\n                                <strong>Use design from the start screen</strong>\n                            </md-switch>\n\n                            <md-switch md-invert\n                                       ng-model=\"ctrl.json.admin.gifBooth.showLiveViewOverlays\"\n                                       ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowSharing\">\n                                <strong>{{'Show live view overlays' | translate}}</strong>\n                            </md-switch>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments-many/'}}\"\n                                        custom-label=\"{{'Upload a Background' | translate}}\"\n                                        file-types=\".jpg,.jpeg,.png\"\n                                        multiple=\"true\"\n                                        extra-info=\"{{'(JPG, PNG; ' + ctrl.fileSizes.sharing + 'mb; ' + ctrl.viewValue.gif.digitalFormat.layoutWidth + 'x' + ctrl.viewValue.gif.digitalFormat.layoutHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || ctrl.json.admin.gifBooth.startScreenDesignSharing || ctrl.json.admin.scenes.enabled\"\n                                        callback=\"ctrl.testUpload(file, 'gifBooth', 'sharingBackgroundFiles')\"\n                                        max-size=\"ctrl.fileSizes.sharing\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        images-array=\"ctrl.json.admin.gifBooth.sharingBackgroundFiles\">\n                                </upload>\n\n                                <div class=\"file-title\"\n                                     ng-repeat=\"file in ctrl.json.admin.gifBooth.sharingBackgroundFiles\"\n                                     ng-hide=\"ctrl.json.admin.gifBooth.startScreenDesignSharing || ctrl.json.admin.scenes.enabled\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName:12 }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'gifBooth', 'sharingBackgroundFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments-many/'}}\"\n                                        custom-label=\"{{'Upload an Overlay' | translate}}\"\n                                        file-types=\".png\"\n                                        multiple=\"true\"\n                                        extra-info=\"{{'(PNG; ' + ctrl.fileSizes.sharing + 'mb; ' + ctrl.viewValue.gif.digitalFormat.layoutWidth + 'x' + ctrl.viewValue.gif.digitalFormat.layoutHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || ctrl.json.admin.gifBooth.startScreenDesignSharing || ctrl.json.admin.scenes.enabled\"\n                                        callback=\"ctrl.testUpload(file, 'gifBooth', 'sharingOverlayFiles')\"\n                                        max-size=\"ctrl.fileSizes.sharing\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        images-array=\"ctrl.json.admin.gifBooth.sharingOverlayFiles\">\n                                </upload>\n\n                                <div class=\"file-title\" ng-repeat=\"file in ctrl.json.admin.gifBooth.sharingOverlayFiles\"\n                                     ng-hide=\"ctrl.json.admin.gifBooth.startScreenDesignSharing || ctrl.json.admin.scenes.enabled\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'gifBooth', 'sharingOverlayFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n\n                            <div layout=\"row\">\n                                <div flex=\"70\">\n                                    <p>{{'Playback speed: 3 photos / ' | translate}} <strong>{{\n                                        ctrl.json.admin.gifBooth.playbackSpeed }}</strong> {{'seconds' | translate}}</p>\n                                    <md-slider-container>\n                                        <md-slider\n                                                min=\"1\"\n                                                max=\"5\"\n                                                step=\"0.5\"\n                                                md-discrete\n                                                ng-model=\"ctrl.json.admin.gifBooth.playbackSpeed\"\n                                                ng-change=\"ctrl.changeGifDuration()\"\n                                                ng-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowSharing || ctrl.json.admin.scenes.enabled\"\n                                                aria-label=\"slider\">\n                                        </md-slider>\n                                    </md-slider-container>\n                                </div>\n                            </div>\n\n\n                            <div class=\"photos-within-layout\">\n                                <p>{{'Photo within the layout' | translate}}</p>\n\n                                <div class=\"photo-layout\">\n\n                                    <photo-input\n                                            model=\"ctrl.viewValue.gif.digitalFormat.photos[0]\"\n                                            is-disabled=\"!ctrl.json.admin.gifBooth.enabled || !ctrl.json.admin.gifBooth.allowSharing \"\n                                            layout-width=\"ctrl.viewValue.gif.digitalFormat.layoutWidth\"\n                                            layout-height=\"ctrl.viewValue.gif.digitalFormat.layoutHeight\"\n                                            ratio=\"{{ctrl.viewValue.gif.photoCaptureRatio}}\"\n                                            custom-ratio=\"{width: ctrl.viewValue.gif.customPhotoWidth, height: ctrl.viewValue.gif.customPhotoHeight}\"\n                                    ></photo-input>\n\n                                </div>\n                            </div>\n                        </div>\n\n                    </div>\n                    <div flex=\"50\" flex-sm=\"100\" class=\"preview-container\">\n                        <p><strong>GIF preview - Digital ({{ctrl.getDigitalCanvasTitle(\"gif\", true)}})</strong></p>\n                        <html-preview\n                                pr-width=\"{{\n                    ctrl.json.admin.liveView.liveViewMode === 'fullscreen'\n                      ? ctrl.json.admin.general.width\n                      : ctrl.viewValue.gif.digitalFormat.layoutWidth\n                     }}\"\n\n                                pr-height=\"{{\n                    ctrl.json.admin.liveView.liveViewMode === 'fullscreen'\n                      ? ctrl.json.admin.general.height\n                      : ctrl.viewValue.gif.digitalFormat.layoutHeight\n                    }}\"\n\n                                index=\"{{\n                    ctrl.json.admin.liveView.liveViewMode !== 'fullscreen'\n                      ? (ctrl.viewValue.gif.digitalFormat.layoutWidth > ctrl.viewValue.gif.digitalFormat.layoutHeight\n                          ? (ctrl.viewValue.gif.digitalFormat.layoutWidth * 2.5 / 1000)\n                          : (ctrl.viewValue.gif.digitalFormat.layoutHeight * 2.5 / 1000))\n                      : (ctrl.json.admin.general.width > ctrl.json.admin.general.height\n                          ? (ctrl.json.admin.general.width * 2.5 / 1000)\n                          : (ctrl.json.admin.general.height * 2.5 / 1000))\n                      }}\"\n                                background=\"{{ctrl.json.admin.gifBooth.sharingBackgroundFiles}}\"\n                                overlay=\"{{ctrl.json.admin.gifBooth.sharingOverlayFiles}}\"\n                                video-background=\"{{ctrl.checkIsVideo(ctrl.json.admin.gifBooth.sharingBackgroundFiles[0]) ? ctrl.json.admin.gifBooth.sharingBackgroundFiles[0] : null}}\"\n                                video-overlay=\"{{ctrl.checkIsVideo(ctrl.json.admin.gifBooth.sharingOverlayFiles[0]) ? ctrl.json.admin.gifBooth.sharingOverlayFiles[0] : null}}\"\n                                areas=\"{{ctrl.viewValue.gif.digitalFormat.photos}}\"\n                                gif-speed=\"{{ctrl.json.admin.gifBooth.playbackSpeed}}\"\n                                animation-speed=\"{{ctrl.json.admin.gifBooth.playbackSpeed}}\"\n                                style=\"margin: 0 auto\"\n                                logo-type=\"'digital'\"\n                                logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                bg-mode=\"ctrl.json.admin.gifBooth.sharingBackgroundMode\"\n                                bg-color=\"ctrl.json.admin.gifBooth.sharingBackgroundColor\"\n                                hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.gifBooth.startScreenDesignSharing\"\n                                hide-photo-bg=\"ctrl.json.admin.scenes.enabled ? true : false\"\n                                mirror=\"ctrl.json.admin.gifBooth.shouldOutputPhotoMirrored\">\n                        </html-preview>\n                    </div>\n                </div>\n\n                <div ng-if=\"ctrl.isActiveStep('GIF')\" layout=\"row\" class=\"general-footer\">\n                    <div flex=\"100\" flex-sm=\"100\">\n                        <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                            <div class=\"reset-btn-wrapper\" flex-sm=\"100\">\n                                <p>\n                                    <a href=\"#\"\n                                       ng-click=\"ctrl.resetStep('gif')\"\n                                       class=\"md-primary reset-link\">\n                                        {{'Reset' | translate}}\n                                    </a>\n                                    {{'This puts everything back to default settings' | translate}}\n                                </p>\n                                <md-button class=\"md-primary md-raised\" wz-next style=\"float: right\">{{'Next' |\n                                    translate}}\n                                </md-button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n            </wz-step>\n            <!-- end of gif step -->\n\n            <!-- boomerang step -->\n            <wz-step\n                    wz-title=\"{{'Boomerang' | translate}}\"\n                    canenter=\"!ctrl.loading\"\n                    wz-disabled=\"{{ctrl.isStepDisabled('boomerangBooth')}}\"\n                    canexit=\"ctrl.canExitScreen('boomerang', 'boomerangBooth') && !ctrl.loading\">\n\n                <div ng-if=\"ctrl.isActiveStep('Boomerang')\" layout=\"row\" layout-sm=\"column\" layout-padding>\n                    <div flex=\"50\" flex-sm=\"100\">\n                        <div ng-class=\"{'item-disabled': !ctrl.json.admin.boomerangBooth.enabled}\">\n\n                            <p>{{'Countdown time:' | translate}} <strong>{{ctrl.json.admin.boomerangBooth.countdownTime}}</strong>\n                                {{'seconds' | translate}}</p>\n                            <md-slider-container>\n                                <md-slider\n                                        min=\"1\"\n                                        max=\"10\"\n                                        step=\"1\"\n                                        md-discrete\n                                        ng-model=\"ctrl.json.admin.boomerangBooth.countdownTime\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled\"\n                                        aria-label=\"slider\">\n                                </md-slider>\n                            </md-slider-container>\n\n                            <p>{{'Capture time:' | translate}}\n                                <strong>{{ctrl.json.admin.boomerangBooth.captureTime}}</strong> {{'seconds' |\n                                translate}}</p>\n                            <md-slider-container>\n                                <md-slider\n                                        min=\"1\"\n                                        max=\"8\"\n                                        step=\"0.5\"\n                                        md-discrete\n                                        ng-model=\"ctrl.json.admin.boomerangBooth.captureTime\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled\"\n                                        aria-label=\"slider\">\n                                </md-slider>\n                            </md-slider-container>\n\n                        </div>\n                        <p>{{'Photo Capture aspect ratio:' | translate}}</p>\n                        <md-radio-group\n                                ng-model=\"ctrl.viewValue.boomerang.photoCaptureRatio\"\n                                class=\"radio-inline-custom\"\n                                ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled\"\n                                ng-change=\"ctrl.changePhotosAspectRatio('boomerang', true)\">\n                            <md-radio-button value=\"square\" class=\"md-primary\">{{'Square (1:1)' | translate}}\n                            </md-radio-button>\n                            <md-radio-button value=\"landscape\" class=\"md-primary\">{{'Landscape (3:2)' | translate}}\n                            </md-radio-button>\n                            <md-radio-button value=\"portrait\" class=\"md-primary\">{{'Portrait (2:3)' | translate}}\n                            </md-radio-button>\n                            <md-radio-button value=\"custom\" class=\"md-primary\">{{'Custom' | translate}}\n                            </md-radio-button>\n                            <div class=\"photos-within-layout\" style=\"display: inline-block\">\n                                <md-input-container class=\"md-block\">\n                                    <input\n                                            ng-model=\"ctrl.viewValue.boomerang.customPhotoWidth\"\n                                            type=\"number\"\n                                            min=\"{{ctrl.Math.round(ctrl.viewValue.boomerang.customPhotoHeight / 10)}}\"\n                                            max=\"{{ ctrl.Math.round(ctrl.viewValue.boomerang.customPhotoHeight * 10) }}\"\n                                            placeholder=\"Width\"\n                                            id=\"boomerang-ratio-width\"\n                                            ng-change=\"ctrl.changePhotosAspectRatio('boomerang')\"\n                                            ng-blur=\"ctrl.viewValue.boomerang.customPhotoWidth = ctrl.viewValue.boomerang.customPhotoWidth || 1\"\n                                            ng-disabled=\"ctrl.viewValue.boomerang.photoCaptureRatio !== 'custom'\">\n                                </md-input-container>\n                                <md-input-container class=\"md-block\">\n                                    <input\n                                            ng-model=\"ctrl.viewValue.boomerang.customPhotoHeight\"\n                                            type=\"number\"\n                                            min=\"{{ctrl.Math.round(ctrl.viewValue.boomerang.customPhotoWidth / 10)}}\"\n                                            max=\"{{ ctrl.Math.round(ctrl.viewValue.boomerang.customPhotoWidth * 10) }}\"\n                                            placeholder=\"Height\"\n                                            id=\"boomerang-ratio-height\"\n                                            ng-change=\"ctrl.changePhotosAspectRatio('boomerang')\"\n                                            ng-blur=\"ctrl.viewValue.boomerang.customPhotoHeight = ctrl.viewValue.boomerang.customPhotoHeight || 1\"\n                                            ng-disabled=\"ctrl.viewValue.boomerang.photoCaptureRatio !== 'custom'\">\n                                </md-input-container>\n                            </div>\n\n                        </md-radio-group>\n\n                        <div ng-class=\"{'disabled': !ctrl.json.admin.boomerangBooth.enabled}\">\n\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.boomerangBooth.allowPrinting\"\n                                    ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled\"\n                                    ng-change=\"ctrl.checkOption('boomerangBooth', 'printing')\">\n                                Allow printing of Boomerangs ({{ctrl.getCanvasTitle(\"boomerang\")}})\n                            </md-switch>\n\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.boomerangBooth.allowSharePrintFile\"\n                                    ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowPrinting\">\n                                Allow sharing of print file\n                            </md-switch>\n\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.boomerangBooth.printWithoutScenes\"\n                                    ng-if=\"ctrl.json.admin.scenes.enabled\">\n                                Insert photo without Scene\n                            </md-switch>\n                            <md-switch md-invert\n                                       ng-model=\"ctrl.json.admin.boomerangBooth.shouldOutputPhotoMirrored\"\n                                       ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled\">\n                                {{'Mirror photo' | translate}}\n                            </md-switch>\n\n                            <!--  md-select format and DPI for Boomerang -->\n                            <md-input-container>\n                                <label>{{'Layout aspect ratio:' | translate}}</label>\n                                <md-select\n                                        ng-model=\"ctrl.viewValue.boomerang.layoutAspectRatio\"\n                                        ng-change=\"ctrl.changeSinglePhotoLayoutRatio('boomerang')\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowPrinting\">\n                                    <md-optgroup ng-repeat=\"group in ctrl.printFormatOptionGroups\"\n                                                 label=\"{{group.label | translate}}\">\n                                        <md-option ng-repeat=\"opt in group.options\" ng-value=\"opt.id\">\n                                            {{opt.label | translate}}\n                                        </md-option>\n                                    </md-optgroup>\n                                </md-select>\n                            </md-input-container>\n                            <md-input-container>\n                                <label>{{'Print quality / DPI' | translate}}</label>\n                                <md-select\n                                        ng-model=\"ctrl.viewValue.boomerang.printDpi\"\n                                        ng-change=\"ctrl.changeSinglePhotoLayoutRatio('boomerang')\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowPrinting\">\n                                    <md-option ng-repeat=\"opt in ctrl.printDpiOptions\" ng-value=\"opt.value\">\n                                        {{opt.label | translate}}\n                                    </md-option>\n                                </md-select>\n                            </md-input-container>\n\n                            <div class=\"switch-with-tip\">\n                                <md-switch\n                                        md-invert\n                                        ng-model=\"ctrl.viewValue.boomerang.strip\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowPrinting\"\n                                        ng-change=\"ctrl.activatePhotoStrips('boomerang')\">\n                                    {{'Activate Photo Strips' | translate}}\n                                </md-switch>\n                                <small>Activating Photo Strips will cut the print in half</small><br>\n                                <small>This is only possible for the 10×15 and 7.6×9 formats and depends on the printer the user is using</small>\n                            </div>\n\n                            <div class=\"photos-within-layout\">\n                                <p>{{'Photo(s) within the layout' | translate}}</p>\n\n                                <div class=\"photo-layout\" ng-repeat=\"photo in ctrl.viewValue.boomerang.photosArr\">\n\n                                    <photo-input\n                                            model=\"photo\"\n                                            is-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowPrinting\"\n                                            layout-width=\"ctrl.viewValue.boomerang.printCanvasWidth\"\n                                            layout-height=\"ctrl.viewValue.boomerang.printCanvasHeight\"\n                                            ratio=\"{{ctrl.viewValue.boomerang.photoCaptureRatio}}\"\n                                            custom-ratio=\"{width: ctrl.viewValue.boomerang.customPhotoWidth, height: ctrl.viewValue.boomerang.customPhotoHeight}\"\n                                    ></photo-input>\n\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.removePhoto($index, 'boomerang', 'a')\"\n                                            ng-if=\"ctrl.viewValue.boomerang.photosArr.length > 1\"\n                                            ng-disabled=\"!ctrl.json.admin.boomerangBooth.allowPrinting\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                                <md-button\n                                        class=\"add-ph\"\n                                        ng-if=\"ctrl.viewValue.boomerang.photosArr.length < 3\"\n                                        ng-click=\"ctrl.addNewPhoto('boomerang', 'a')\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.allowPrinting\">Add this photo again\n                                </md-button>\n\n\n                                <div class=\"photo-layout\" ng-if=\"ctrl.viewValue.boomerang.strippedPhotosArr.length\"\n                                     ng-repeat=\"photo in ctrl.viewValue.boomerang.strippedPhotosArr\">\n\n                                    <photo-input\n                                            model=\"photo\"\n                                            is-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowPrinting\"\n                                            layout-width=\"ctrl.viewValue.boomerang.printCanvasWidth\"\n                                            layout-height=\"ctrl.viewValue.boomerang.printCanvasHeight\"\n                                            ratio=\"{{ctrl.viewValue.boomerang.photoCaptureRatio}}\"\n                                            custom-ratio=\"{width: ctrl.viewValue.boomerang.customPhotoWidth, height: ctrl.viewValue.boomerang.customPhotoHeight}\"\n                                    ></photo-input>\n\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.removePhoto($index, 'boomerang', 'b')\"\n                                            ng-if=\"ctrl.viewValue.boomerang.strippedPhotosArr.length > 1\"\n                                            ng-disabled=\"!ctrl.json.admin.boomerangBooth.allowPrinting\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                                <md-button\n                                        class=\"add-ph\"\n                                        ng-if=\"ctrl.viewValue.boomerang.strippedPhotosArr.length && ctrl.viewValue.boomerang.strippedPhotosArr.length < 3\"\n                                        ng-click=\"ctrl.addNewPhoto('boomerang', 'b')\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.allowPrinting\">Add this photo again\n                                </md-button>\n                            </div>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                        custom-label=\"{{'Upload a Background' | translate}}\"\n                                        file-types=\".jpg,.jpeg,.png\"\n                                        extra-info=\"{{'(JPG, PNG; ' + ctrl.fileSizes.print + 'mb; ' + ctrl.viewValue.boomerang.printCanvasWidth + 'x' + ctrl.viewValue.boomerang.printCanvasHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowPrinting\"\n                                        max-size=\"ctrl.fileSizes.print\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        callback=\"ctrl.testUpload(file, 'boomerangBooth', 'printingBackgroundFiles')\">\n                                </upload>\n\n                                <div class=\"file-title\"\n                                     ng-repeat=\"file in ctrl.json.admin.boomerangBooth.printingBackgroundFiles\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'boomerangBooth', 'printingBackgroundFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                        custom-label=\"{{'Upload an Overlay' | translate}}\"\n                                        file-types=\".png\"\n                                        extra-info=\"{{'(PNG; ' + ctrl.fileSizes.print + 'mb; ' + ctrl.viewValue.boomerang.printCanvasWidth + 'x' + ctrl.viewValue.boomerang.printCanvasHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowPrinting\"\n                                        max-size=\"ctrl.fileSizes.print\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        callback=\"ctrl.testUpload(file, 'boomerangBooth', 'printingOverlayFiles')\">\n                                </upload>\n\n                                <div class=\"file-title\"\n                                     ng-repeat=\"file in ctrl.json.admin.boomerangBooth.printingOverlayFiles\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName:12 }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'boomerangBooth', 'printingOverlayFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n\n                        </div>\n\n                    </div>\n                    <div flex=\"50\" flex-sm=\"100\" class=\"preview-container\">\n                        <p class=\"preview-container\"><strong>Boomerang preview - Print\n                            ({{ctrl.getCanvasTitle(\"boomerang\")}})</strong></p>\n                        <md-switch\n                                class=\"printer-bleed\"\n                                md-invert\n                                ng-model=\"ctrl.json.admin.boomerangBooth.showPrinterBleeds\"\n                                ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowPrinting\">\n                            {{'Show printer bleed' | translate}}\n                        </md-switch>\n                        <!-- index, print-dpi for Boomerang preview -->\n                        <html-preview\n                                boomerang=\"true\"\n                                pr-width=\"{{ctrl.viewValue.boomerang.printCanvasWidth}}\"\n                                pr-height=\"{{ctrl.viewValue.boomerang.printCanvasHeight}}\"\n                                index=\"{{ ctrl.getPrintPreviewIndex('boomerang') }}\"\n                                print-dpi=\"{{ ctrl.getPrintDpi('boomerang') }}\"\n                                background=\"{{ctrl.json.admin.boomerangBooth.printingBackgroundFiles}}\"\n                                overlay=\"{{ctrl.json.admin.boomerangBooth.printingOverlayFiles}}\"\n                                video-background=\"{{ctrl.checkIsVideo(ctrl.json.admin.boomerangBooth.printingBackgroundFiles) ? ctrl.json.admin.boomerangBooth.printingBackgroundFiles : null}}\"\n                                video-overlay=\"{{ctrl.checkIsVideo(ctrl.json.admin.boomerangBooth.printingOverlayFiles) ? ctrl.json.admin.boomerangBooth.printingOverlayFiles : null}}\"\n                                areas=\"{{ctrl.mergeArrays(ctrl.viewValue.boomerang.photosArr, ctrl.viewValue.boomerang.strippedPhotosArr)}}\"\n                                style=\"margin: 0 auto\"\n                                strip=\"{{ctrl.viewValue.boomerang.strip}}\"\n                                ratio=\"{{ctrl.viewValue.boomerang.layoutAspectRatio}}\"\n                                printer-bleed=\"{{ctrl.json.admin.boomerangBooth.showPrinterBleeds}}\"\n                                logo-type=\"'strip'\"\n                                logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                bg-mode=\"ctrl.json.admin.boomerangBooth.printingBackgroundMode\"\n                                bg-color=\"ctrl.json.admin.boomerangBooth.printingBackgroundColor\"\n                                hide-scene=\"ctrl.json.admin.boomerangBooth.printWithoutScenes\"\n                                bg-style=\"'stretch'\"\n                                hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled\"\n                                logos-arr=\"ctrl.json.admin.boomerangBooth.printingLogos\"\n                                scenes=\"ctrl.json.admin.scenes\"\n                                hide-photo-bg=\"ctrl.json.admin.scenes.enabled ? true : false\"\n                                mirror=\"ctrl.json.admin.boomerangBooth.shouldOutputPhotoMirrored\">\n                        </html-preview>\n                    </div>\n                </div>\n\n                <div ng-if=\"ctrl.isActiveStep('Boomerang')\" layout=\"row\" layout-sm=\"column\" layout-padding>\n                    <div flex=\"50\" flex-sm=\"100\">\n\n                        <div ng-class=\"{'disabled': !ctrl.json.admin.boomerangBooth.enabled}\">\n\n                            <div>\n                                <md-tooltip ng-if=\"ctrl.json.admin.scenes.enabled\" md-direction=\"top\">{{'Required while Scenes are enabled' | translate}}</md-tooltip>\n                                <md-switch\n                                        md-invert\n                                        ng-model=\"ctrl.json.admin.boomerangBooth.allowSharing\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || ctrl.json.admin.scenes.enabled\"\n                                        ng-change=\"ctrl.checkOption('boomerangBooth', 'sharing')\">\n                                    Allow sharing of digital Boomerangs ({{ctrl.getDigitalCanvasTitle(\"boomerang\", true)}})\n                                </md-switch>\n                            </div>\n\n                            <div flex-sm=\"100\">\n                                <p>{{'Layout aspect ratio:' | translate}}</p>\n                                <md-radio-group\n                                        ng-if=\"ctrl.json.admin.liveView.liveViewMode !== 'fullscreen'\"\n                                        ng-model=\"ctrl.viewValue.boomerang.digitalFormat.layoutAspectRatio\"\n                                        class=\"radio-inline-custom\"\n                                        ng-change=\"ctrl.changeLayoutRatio('boomerang', true)\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.allowSharing\">\n                                    <md-radio-button value=\"square\" class=\"md-primary\">{{'Square (1:1)' | translate}}\n                                    </md-radio-button>\n                                    <md-radio-button value=\"landscape\" class=\"md-primary\">{{'Landscape (3:2)' |\n                                        translate}}\n                                    </md-radio-button>\n                                    <md-radio-button value=\"portrait\" class=\"md-primary\">{{'Portrait (2:3)' |\n                                        translate}}\n                                    </md-radio-button>\n                                    <md-radio-button value=\"custom\" class=\"md-primary\">{{'Custom' | translate}}\n                                    </md-radio-button>\n                                    <div class=\"photos-within-layout\" style=\"display: inline-block\"  ng-class=\"{'active':ctrl.viewValue.singlePhoto.digitalFormat.layoutAspectRatio === 'custom'}\">\n                                        <md-input-container class=\"md-block\">\n                                            <input\n                                                    ng-model=\"ctrl.viewValue.boomerang.digitalFormat.customPhotoWidth\"\n                                                    type=\"number\"\n                                                    min=\"{{ctrl.Math.round(ctrl.viewValue.boomerang.digitalFormat.customPhotoHeight / 10)}}\"\n                                                    max=\"{{ ctrl.Math.round(ctrl.viewValue.boomerang.digitalFormat.customPhotoHeight * 10) }}\"\n                                                    placeholder=\"Width\"\n                                                    id=\"boomerang-digital-ratio-width\"\n                                                    ng-change=\"ctrl.changeLayoutRatio('boomerang')\"\n                                                    ng-blur=\"ctrl.viewValue.boomerang.digitalFormat.customPhotoWidth = ctrl.viewValue.boomerang.digitalFormat.customPhotoWidth || 1\"\n                                                    ng-disabled=\"ctrl.viewValue.boomerang.digitalFormat.layoutAspectRatio !== 'custom' || !ctrl.json.admin.boomerangBooth.allowSharing\">\n                                        </md-input-container>\n                                        <md-input-container class=\"md-block\">\n                                            <input\n                                                    ng-model=\"ctrl.viewValue.boomerang.digitalFormat.customPhotoHeight\"\n                                                    type=\"number\"\n                                                    min=\"{{ctrl.Math.round(ctrl.viewValue.boomerang.digitalFormat.customPhotoWidth / 10)}}\"\n                                                    max=\"{{ ctrl.Math.round(ctrl.viewValue.boomerang.digitalFormat.customPhotoWidth * 10) }}\"\n                                                    placeholder=\"Height\"\n                                                    id=\"boomerang-digital-ratio-height\"\n                                                    ng-change=\"ctrl.changeLayoutRatio('boomerang')\"\n                                                    ng-blur=\"ctrl.viewValue.boomerang.digitalFormat.customPhotoHeight = ctrl.viewValue.boomerang.digitalFormat.customPhotoHeight || 1\"\n                                                    ng-disabled=\"ctrl.viewValue.boomerang.digitalFormat.layoutAspectRatio !== 'custom' || !ctrl.json.admin.boomerangBooth.allowSharing\">\n                                        </md-input-container>\n                                    </div>\n\n                                </md-radio-group>\n\n                                <div ng-if=\"ctrl.json.admin.liveView.liveViewMode === 'fullscreen'\"\n                                     class=\"photos-within-layout\" style=\"display: inline-block\">\n                                    <md-input-container class=\"md-block\">\n                                        <md-tooltip md-direction=\"top\">You can change it on general tab</md-tooltip>\n                                        <input\n                                                ng-model=\"ctrl.json.admin.general.aspectRatio.width\"\n                                                type=\"number\"\n                                                placeholder=\"Width\"\n                                                id=\"boomerang-digital-ratio-width\"\n                                                ng-disabled=\"true\">\n                                    </md-input-container>\n                                    <md-input-container class=\"md-block\">\n                                        <md-tooltip md-direction=\"top\">You can change it on general tab</md-tooltip>\n                                        <input\n                                                ng-model=\"ctrl.json.admin.general.aspectRatio.height\"\n                                                type=\"number\"\n                                                placeholder=\"Height\"\n                                                id=\"boomerang-digital-ratio-height\"\n                                                ng-disabled=\"true\">\n                                    </md-input-container>\n                                </div>\n                            </div>\n\n                            <div class=\"photos-within-layout wider\">\n                                <p>{{'Layout size'}}</p>\n                                <div ng-if=\"ctrl.json.admin.liveView.liveViewMode !== 'fullscreen'\">\n                                    <md-input-container class=\"md-block\">\n                                        <input\n                                                ng-model=\"ctrl.viewValue.boomerang.digitalFormat.layoutWidth\"\n                                                type=\"number\"\n                                                min=\"500\"\n                                                max=\"4000\"\n                                                step=\"2\"\n                                                placeholder=\"Width (px)\"\n                                                id=\"boomerang-layout-width\"\n                                                ng-change=\"ctrl.changeSharingLayoutSize('boomerang', 'width')\">\n                                    </md-input-container>\n                                    <md-input-container class=\"md-block\">\n                                        <input\n                                                ng-model=\"ctrl.viewValue.boomerang.digitalFormat.layoutHeight\"\n                                                type=\"number\"\n                                                min=\"500\"\n                                                max=\"4000\"\n                                                step=\"2\"\n                                                placeholder=\"Height (px)\"\n                                                id=\"boomerang-layout-height\"\n                                                ng-change=\"ctrl.changeSharingLayoutSize('boomerang', 'height')\">\n                                    </md-input-container>\n                                </div>\n                                <div ng-if=\"ctrl.json.admin.liveView.liveViewMode === 'fullscreen'\">\n                                    <md-input-container class=\"md-block\">\n                                        <md-tooltip md-direction=\"top\">You can change it on general tab</md-tooltip>\n                                        <input\n                                                ng-model=\"ctrl.json.admin.general.width\"\n                                                type=\"number\"\n                                                placeholder=\"Width (px)\"\n                                                id=\"boomerang-layout-width\"\n                                                ng-disabled=\"true\">\n                                    </md-input-container>\n                                    <md-input-container class=\"md-block\">\n                                        <md-tooltip md-direction=\"top\">You can change it on general tab</md-tooltip>\n                                        <input\n                                                ng-model=\"ctrl.json.admin.general.height\"\n                                                type=\"number\"\n                                                placeholder=\"Height (px)\"\n                                                id=\"boomerang-layout-height\"\n                                                ng-disabled=\"true\">\n                                    </md-input-container>\n                                </div>\n                            </div>\n\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.boomerangBooth.startScreenDesignSharing\"\n                                    ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowSharing\"\n                                    ng-change=\"ctrl.checkStartScreenDesign('boomerangBooth')\">\n                                <strong>Use design from the start screen</strong>\n                            </md-switch>\n\n                            <md-switch md-invert\n                                       ng-model=\"ctrl.json.admin.boomerangBooth.showLiveViewOverlays\"\n                                       ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowSharing\">\n                                <strong>{{'Show live view overlays' | translate}}</strong>\n                            </md-switch>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments-many/'}}\"\n                                        custom-label=\"{{'Upload a Background' | translate}}\"\n                                        file-types=\".jpg,.jpeg,.png\"\n                                        multiple=\"true\"\n                                        extra-info=\"{{'(JPG, PNG; ' + ctrl.fileSizes.sharing + 'mb; ' + ctrl.viewValue.boomerang.digitalFormat.layoutWidth + 'x' + ctrl.viewValue.boomerang.digitalFormat.layoutHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowSharing || ctrl.json.admin.boomerangBooth.startScreenDesignSharing || ctrl.json.admin.scenes.enabled\"\n                                        callback=\"ctrl.testUpload(file, 'boomerangBooth', 'sharingBackgroundFiles')\"\n                                        max-size=\"ctrl.fileSizes.sharing\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        images-array=\"ctrl.json.admin.boomerangBooth.sharingBackgroundFiles\">\n                                </upload>\n\n                                <div class=\"file-title\"\n                                     ng-repeat=\"file in ctrl.json.admin.boomerangBooth.sharingBackgroundFiles\"\n                                     ng-hide=\"ctrl.json.admin.boomerangBooth.startScreenDesignSharing || ctrl.json.admin.scenes.enabled\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName:12 }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'boomerangBooth', 'sharingBackgroundFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n\n                            <div class=\"upload-container\">\n                                <upload\n                                        uri=\"{{ctrl.config.company + 'attachments-many/'}}\"\n                                        custom-label=\"{{'Upload an Overlay' | translate}}\"\n                                        file-types=\".png\"\n                                        multiple=\"true\"\n                                        extra-info=\"{{'(PNG; ' + ctrl.fileSizes.sharing + 'mb; ' + ctrl.viewValue.boomerang.digitalFormat.layoutWidth + 'x' + ctrl.viewValue.boomerang.digitalFormat.layoutHeight + ')' | translate}}\"\n                                        ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowSharing || ctrl.json.admin.boomerangBooth.startScreenDesignSharing || ctrl.json.admin.scenes.enabled\"\n                                        callback=\"ctrl.testUpload(file, 'boomerangBooth', 'sharingOverlayFiles')\"\n                                        max-size=\"ctrl.fileSizes.sharing\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        images-array=\"ctrl.json.admin.boomerangBooth.sharingOverlayFiles\">\n                                </upload>\n\n                                <div class=\"file-title\"\n                                     ng-repeat=\"file in ctrl.json.admin.boomerangBooth.sharingOverlayFiles\"\n                                     ng-hide=\"ctrl.json.admin.boomerangBooth.startScreenDesignSharing || ctrl.json.admin.scenes.enabled\">\n                                    <span title=\"{{file | getFileName}}\">Uploaded: {{ file | getFileName:12 }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.deleteFile($index, 'boomerangBooth', 'sharingOverlayFiles')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n\n                            <div layout=\"row\">\n                                <div flex=\"80\">\n                                    <p>{{'Playback time' | translate}} <strong>{{\n                                        ctrl.json.admin.boomerangBooth.playbackSpeed }}</strong> {{'seconds' |\n                                        translate}}</p>\n                                    <md-slider-container>\n                                        <md-slider\n                                                min=\"1\"\n                                                max=\"8\"\n                                                step=\"0.5\"\n                                                md-discrete\n                                                ng-model=\"ctrl.json.admin.boomerangBooth.playbackSpeed\"\n                                                ng-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowSharing\"\n                                                aria-label=\"slider\">\n                                        </md-slider>\n                                    </md-slider-container>\n                                </div>\n                            </div>\n\n\n                            <div class=\"photos-within-layout\">\n                                <p>{{'Photo within the layout' | translate}}</p>\n\n                                <div class=\"photo-layout\">\n                                    <photo-input\n                                            model=\"ctrl.viewValue.boomerang.digitalFormat.photos[0]\"\n                                            is-disabled=\"!ctrl.json.admin.boomerangBooth.enabled || !ctrl.json.admin.boomerangBooth.allowSharing \"\n                                            layout-width=\"ctrl.viewValue.boomerang.digitalFormat.layoutWidth\"\n                                            layout-height=\"ctrl.viewValue.boomerang.digitalFormat.layoutHeight\"\n                                            ratio=\"{{ctrl.viewValue.boomerang.photoCaptureRatio}}\"\n                                            custom-ratio=\"{width: ctrl.viewValue.boomerang.customPhotoWidth, height: ctrl.viewValue.boomerang.customPhotoHeight}\"\n                                    ></photo-input>\n\n                                </div>\n                            </div>\n                        </div>\n\n                    </div>\n                    <div flex=\"50\" flex-sm=\"100\" class=\"preview-container\">\n                        <p><strong>Boomerang preview - Digital ({{ctrl.getDigitalCanvasTitle(\"boomerang\", true)}})</strong></p>\n                        <html-preview\n                                pr-width=\"{{\n                    ctrl.json.admin.liveView.liveViewMode === 'fullscreen'\n                      ? ctrl.json.admin.general.width\n                      : ctrl.viewValue.boomerang.digitalFormat.layoutWidth\n                     }}\"\n\n                                pr-height=\"{{\n                    ctrl.json.admin.liveView.liveViewMode === 'fullscreen'\n                      ? ctrl.json.admin.general.height\n                      : ctrl.viewValue.boomerang.digitalFormat.layoutHeight\n                    }}\"\n\n                                index=\"{{\n                    ctrl.json.admin.liveView.liveViewMode !== 'fullscreen'\n                      ? (ctrl.viewValue.boomerang.digitalFormat.layoutWidth > ctrl.viewValue.boomerang.digitalFormat.layoutHeight\n                          ? (ctrl.viewValue.boomerang.digitalFormat.layoutWidth * 2.5 / 1000)\n                          : (ctrl.viewValue.boomerang.digitalFormat.layoutHeight * 2.5 / 1000))\n                      : (ctrl.json.admin.general.width > ctrl.json.admin.general.height\n                          ? (ctrl.json.admin.general.width * 2.5 / 1000)\n                          : (ctrl.json.admin.general.height * 2.5 / 1000))\n                      }}\"\n\n                                background=\"{{ctrl.json.admin.boomerangBooth.sharingBackgroundFiles}}\"\n                                overlay=\"{{ctrl.json.admin.boomerangBooth.sharingOverlayFiles}}\"\n                                video-background=\"{{ctrl.checkIsVideo(ctrl.json.admin.gifBooth.sharingBackgroundFiles[0]) ? ctrl.json.admin.gifBooth.sharingBackgroundFiles[0] : null}}\"\n                                video-overlay=\"{{ctrl.checkIsVideo(ctrl.json.admin.gifBooth.sharingOverlayFiles[0]) ? ctrl.json.admin.gifBooth.sharingOverlayFiles[0] : null}}\"\n                                areas=\"{{ctrl.viewValue.boomerang.digitalFormat.photos}}\"\n                                style=\"margin: 0 auto\"\n                                video-time=\"ctrl.json.admin.boomerangBooth.captureTime\"\n                                video-speed=\"ctrl.json.admin.boomerangBooth.playbackSpeed\"\n                                animation-speed=\"{{ctrl.json.admin.boomerangBooth.playbackSpeed}}\"\n                                logo-type=\"'digital'\"\n                                logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                bg-mode=\"ctrl.json.admin.boomerangBooth.sharingBackgroundMode\"\n                                bg-color=\"ctrl.json.admin.boomerangBooth.sharingBackgroundColor\"\n                                hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.boomerangBooth.startScreenDesignSharing\"\n                                hide-photo-bg=\"ctrl.json.admin.scenes.enabled ? true : false\"\n                                mirror=\"ctrl.json.admin.boomerangBooth.shouldOutputPhotoMirrored\">\n                        </html-preview>\n                    </div>\n                </div>\n\n                <div ng-if=\"ctrl.isActiveStep('Boomerang')\" layout=\"row\" class=\"general-footer\">\n                    <div flex=\"100\" flex-sm=\"100\">\n                        <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                            <div class=\"reset-btn-wrapper\" flex-sm=\"100\">\n                                <p>\n                                    <a href=\"#\"\n                                       ng-click=\"ctrl.resetStep('boomerang')\"\n                                       class=\"md-primary reset-link\">\n                                        {{'Reset' | translate}}\n                                    </a>\n                                    {{'This puts everything back to default settings' | translate}}\n                                </p>\n                                <md-button class=\"md-primary md-raised\" wz-next style=\"float: right\">{{'Next' |\n                                    translate}}\n                                </md-button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </wz-step>\n            <!-- end of boomerang step -->\n\n            <!-- video screen step -->\n            <wz-step\n                    wz-title=\"{{'Video' | translate}}\"\n                    canexit=\"!ctrl.loading\"\n                    canenter=\"!ctrl.loading\"\n                    wz-disabled=\"{{ctrl.isStepDisabled('videoBooth')}}\"\n                    class=\"tab-container\">\n                <span ng-if=\"ctrl.isActiveStep('Video')\" class=\"go-back-btn\" wz-previous>{{'< Back' | translate}}</span>\n\n                <section ng-if=\"ctrl.isActiveStep('Video')\" layout=\"row\" layout-sm=\"column\" layout-padding class=\"video-page\">\n                    <div flex=\"50\" style=\"padding-right: 50px\">\n\n                        <div layout-padding>\n                            <strong class=\"part-title bold\">{{'Video' | translate}}</strong>\n                        </div>\n\n                        <div ng-class=\"{'item-disabled': !ctrl.json.admin.videoBooth.enabled}\">\n\n                            <p>{{'Countdown before taking video:' | translate}} <strong>{{ctrl.json.admin.videoBooth.countdownTime}}</strong>\n                                {{'seconds' | translate}}</p>\n                            <md-slider-container>\n                                <md-slider\n                                        min=\"1\"\n                                        max=\"10\"\n                                        step=\"1\"\n                                        md-discrete\n                                        ng-model=\"ctrl.json.admin.videoBooth.countdownTime\"\n                                        ng-disabled=\"!ctrl.json.admin.videoBooth.enabled\"\n                                        aria-label=\"slider\">\n                                </md-slider>\n                            </md-slider-container>\n\n                            <p>{{'Capture time:' | translate}}\n                                <strong>{{ctrl.formatTime(ctrl.json.admin.videoBooth.captureTime)}}</strong>\n                            </p>\n                            <p class=\"sub-text\">{{'Max. capture time: 10min' | translate }}<br>\n                                {{'File size per minute: 4K = 320MB / Full HD = 149MB / HD = 105MB' | translate}}\n                            </p>\n                            <md-slider-container>\n                                <md-slider\n                                        min=\"0\"\n                                        max=\"600\"\n                                        step=\"10\"\n                                        ng-model=\"ctrl.json.admin.videoBooth.sliderValue\"\n                                        ng-disabled=\"!ctrl.json.admin.videoBooth.enabled\"\n                                        ng-change=\"ctrl.updateCaptureTime()\"\n                                        md-tooltip=\"{{ctrl.formatTime(ctrl.json.admin.videoBooth.captureTime)}}\"\n                                        aria-label=\"slider\">\n                                </md-slider>\n                            </md-slider-container>\n\n                            <div style=\"display: none\">\n                                <p>{{'Playbacktime:' | translate}}\n                                    <strong>{{ctrl.json.admin.videoBooth.playbackSpeed}}x</strong> {{'speed' |\n                                    translate}}</p>\n                                <p class=\"sub-text\">{{'1x Speed is regular, anything below, creates a slow motion effect.' | translate}}<br>\n                                    {{'Anything above 1x Speed creates a timelapse effect' | translate}}</p>\n                                <md-slider-container>\n                                    <md-slider\n                                            min=\"0.00\"\n                                            max=\"2\"\n                                            step=\"0.05\"\n                                            md-discrete\n                                            ng-model=\"ctrl.json.admin.videoBooth.playbackSpeed\"\n                                            ng-disabled=\"!ctrl.json.admin.videoBooth.enabled\"\n                                            aria-label=\"slider\">\n                                    </md-slider>\n                                </md-slider-container>\n                            </div>\n\n                        </div>\n\n                        <div layout-padding class=\"video-resolution-settings\">\n                            <strong class=\"part-title bold\">{{'Video Resolution' | translate}}</strong>\n                            <p class=\"sub-text\">\n                                {{'Decide, in what resolution you want your video to be' | translate}}\n                            </p>\n                            <md-radio-group ng-model=\"ctrl.json.admin.videoBooth.resolutionOptions\" required>\n                                <md-radio-button value=\"hd\" class=\"md-primary\">{{'HD (1080x720px or 720x1080px)' | translate}}\n                                    <span>{{'File size per minute HD = ca. 105mb' | translate}}</span>\n                                </md-radio-button>\n                                <md-radio-button value=\"fullHd\" class=\"md-primary\">{{'Full HD (1920x1080px or 1080x1920px)' | translate}}\n                                    <span>{{'File size per minute Full HD = ca. 149MB' | translate}}</span>\n                                </md-radio-button>\n                                <md-radio-button value=\"4k\" class=\"md-primary\">{{'4K Ultra HD (3840x2160px or 2160x3840px)' | translate}}\n                                    <span>{{'File size per minute: 4K = ca. 320MB' | translate}}</span>\n                                </md-radio-button>\n                            </md-radio-group>\n                        </div>\n\n                        <div layout-padding class=\"video-capture-settings\">\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.videoBooth.enableChromakey\"\n                                    ng-disabled=\"!ctrl.json.admin.videoBooth.enabled\"\n                                    ng-change=\"ctrl.onVideoChromakeyChange()\">\n                                {{'Enable chromakey for video' | translate}}\n                            </md-switch>\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.json.admin.videoBooth.enableSoundRecording\"\n                                    ng-disabled=\"!ctrl.json.admin.videoBooth.enabled\">\n                                {{'Enable sound recording' | translate}}\n                            </md-switch>\n                        </div>\n\n<!--                        <div layout-padding class=\"video-sharing-settings\">-->\n<!--                            <strong class=\"part-title bold\">{{'Digital Video Sharing settings' | translate}}</strong>-->\n<!--                            <md-switch md-invert-->\n<!--                                       ng-model=\"ctrl.json.admin.videoBooth.allowSharing\"-->\n<!--                                       ng-disabled=\"!ctrl.json.admin.videoBooth.enabled\">-->\n<!--                                {{'Allow sharing of digital Video' | translate}}-->\n<!--                            </md-switch>-->\n<!--                        </div>-->\n\n                    </div>\n\n\n                    <div flex=\"50\" flex-sm=\"100\" style=\"display: flex;flex-direction: column;align-items: flex-start;padding-left: 50px\">\n                        <div class=\"layout-padding\">\n                            <strong class=\"part-title bold\">Video Preview</strong>\n                        </div>\n                        <html-preview\n                                video=\"true\"\n                                pr-width=\"{{ctrl.json.admin.general.width}}\"\n                                pr-height=\"{{ctrl.json.admin.general.height}}\"\n                                index=\"{{ctrl.json.admin.general.width > ctrl.json.admin.general.height ? (ctrl.json.admin.general.width * 2.2 / 1000) : (ctrl.json.admin.general.height * 2.2 / 1000)}}\"\n                                areas=\"{{ctrl.viewValue.video.digitalFormat.photos}}\"\n                                video-time=\"ctrl.json.admin.videoBooth.captureTime\"\n                                video-speed=\"ctrl.json.admin.videoBooth.playbackSpeed\"\n                                animation-speed=\"{{ctrl.json.admin.videoBooth.playbackSpeed}}\"\n                                logo-type=\"'digital'\"\n                                mirror=\"ctrl.json.admin.videoBooth.shouldOutputPhotoMirrored\"\n                                margin=\"true\"\n                                show-title=\"true\"\n                                video-mode=\"true\">\n                        </html-preview>\n                    </div>\n                </section>\n                <div ng-if=\"ctrl.isActiveStep('Video')\" layout=\"row\" class=\"general-footer\">\n                    <div flex=\"100\" flex-sm=\"100\">\n                        <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                            <div class=\"reset-btn-wrapper\" flex-sm=\"100\">\n                                <p>\n                                    <a href=\"#\"\n                                       ng-click=\"ctrl.resetStep('video')\"\n                                       class=\"md-primary reset-link\">\n                                        {{'Reset' | translate}}\n                                    </a>\n                                    {{'This puts everything back to default settings' | translate}}\n                                </p>\n                                <md-button class=\"md-primary md-raised\" wz-next style=\"float: right\">{{'Next' |\n                                    translate}}\n                                </md-button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n            </wz-step>\n            <!-- end of video screen step -->\n\n\n            <!-- individual text field step -->\n            <wz-step\n                    wz-title=\"{{'Individual Text Field' | translate}}\"\n                    canenter=\"!ctrl.loading\"\n                    canexit=\"!ctrl.loading\"\n                    wz-disabled=\"{{ctrl.isStepDisabled('photoBooth')}}\">\n                <span ng-if=\"ctrl.isActiveStep('Individual Text Field')\" class=\"go-back-btn\" wz-previous>{{'< Back' | translate}}</span>\n\n                <div ng-if=\"ctrl.isActiveStep('Individual Text Field')\"\n                     class=\"individual-text-section\"\n                     ng-class=\"{'individual-text-section--portrait': ctrl.isIndividualTextPortrait()}\"\n                     layout=\"row\" layout-sm=\"column\" layout-padding>\n                    <div flex=\"55\" flex-sm=\"100\" class=\"individual-text-settings\">\n                        <md-switch md-invert class=\"part-title\" ng-model=\"ctrl.json.admin.individualText.enabled\">\n                            <strong>{{'Individual Text Field' | translate}}</strong>\n                        </md-switch>\n                        <p class=\"part-title__sub-text\">\n                            {{'After a single photo is taken, the user enters a name, a number, etc. The text is printed on the photo at the position set below. Drag the elements on the previews or enter the values manually.' | translate}}\n                        </p>\n\n                        <div ng-if=\"ctrl.json.admin.individualText.enabled\">\n                            <!-- 1. background -->\n                            <h4>{{'Background' | translate}}</h4>\n                            <div class=\"upload-container\">\n                                <upload\n                                        model=\"ctrl.json.admin.individualText.background\"\n                                        uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                        delete-previous=\"true\"\n                                        custom-label=\"{{'Upload a background' | translate}}\"\n                                        file-types=\".jpg,.jpeg,.gif,.png,.mp4,.mov,.webm\"\n                                        max-size=\"ctrl.fileSizes.startScreen\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"false\">\n                                </upload>\n                                <div class=\"file-title\" ng-if=\"ctrl.json.admin.individualText.background\">\n                                    <span title=\"{{ctrl.json.admin.individualText.background.attachment_file | getFileName}}\">Uploaded: {{ ctrl.json.admin.individualText.background.attachment_file | getFileName:12 }}</span>\n                                    <md-button class=\"md-icon-button md-primary\"\n                                               ng-click=\"ctrl.deleteIndividualTextAttachment(ctrl.json.admin.individualText, 'background')\">\n                                        <md-icon style=\"color: gray\">delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </div>\n                            <p class=\"upload-container__sub-text\">{{'Image or Video. Allowed file formats: .jpg, .png, .gif, .mp4, .mov or .webm.' | translate}}<br>\n                                {{'Max. file size:' | translate}} {{ctrl.fileSizes.startScreen}}mb</p>\n\n                            <!-- 2. output picture on the screen -->\n                            <div layout=\"row\" class=\"area-editor\">\n                                <start-screen-area\n                                        keep-invalid=\"true\"\n                                        screen-width-units=\"true\"\n                                        model=\"ctrl.json.admin.individualText.outputPreview\"\n                                        pixel-width=\"ctrl.getIndividualTextScreenSize().width\"\n                                        pixel-height=\"ctrl.getIndividualTextScreenSize().height\"\n                                        hide-upload=\"true\"\n                                        aspect-ratio=\"ctrl.getIndividualTextOutputRatio()\"\n                                        title=\"{{'Output picture on the screen:' | translate}}\">\n                                </start-screen-area>\n                            </div>\n\n                            <!-- 3. explanation -->\n                            <div class=\"individual-text-block\">\n                                <div class=\"individual-text-block__header\">\n                                    <md-switch md-invert class=\"part-title\" ng-model=\"ctrl.json.admin.individualText.explanation.enabled\">\n                                        <strong>{{'Explanation' | translate}}</strong>\n                                    </md-switch>\n                                    <md-button class=\"md-icon-button\"\n                                               ng-if=\"ctrl.json.admin.individualText.explanation.enabled\"\n                                               ng-click=\"ctrl.individualTextCollapsed.explanation = !ctrl.individualTextCollapsed.explanation\"\n                                               aria-label=\"toggle settings\">\n                                        <md-icon>{{ctrl.individualTextCollapsed.explanation ? 'expand_more' : 'expand_less'}}</md-icon>\n                                    </md-button>\n                                </div>\n                                <div ng-if=\"ctrl.json.admin.individualText.explanation.enabled\" ng-hide=\"ctrl.individualTextCollapsed.explanation\">\n                                    <md-input-container class=\"md-block\">\n                                        <label>{{'Explanation text' | translate}}</label>\n                                        <input ng-model=\"ctrl.json.admin.individualText.explanation.text\">\n                                    </md-input-container>\n                                    <div layout=\"row\" layout-wrap class=\"individual-text-row\">\n                                        <div class=\"individual-text-color\">\n                                            <span class=\"individual-text-color__label\">{{'Text color' | translate}}</span>\n                                            <color-picker ng-model=\"ctrl.json.admin.individualText.explanation.color\" options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n                                        </div>\n                                        <md-input-container class=\"individual-text-number\">\n                                            <label>{{'Font size (px)' | translate}}</label>\n                                            <input type=\"number\" min=\"1\" step=\"1\" ng-model=\"ctrl.json.admin.individualText.explanation.fontSize\"\n                                                   ng-blur=\"ctrl.clampIndividualTextExplanation()\">\n                                        </md-input-container>\n                                        <md-input-container class=\"individual-text-number\">\n                                            <label>{{'Min. font size' | translate}}</label>\n                                            <input type=\"number\" min=\"1\" step=\"1\" ng-model=\"ctrl.json.admin.individualText.explanation.minFontSize\"\n                                                   ng-blur=\"ctrl.clampIndividualTextExplanation()\">\n                                        </md-input-container>\n                                    </div>\n                                    <p class=\"part-title__sub-text\">\n                                        {{'Text that does not fit the area is made smaller down to the min. font size, then cut.' | translate}}\n                                    </p>\n                                    <div class=\"upload-container\">\n                                        <upload\n                                                model=\"ctrl.json.admin.individualText.explanation.font\"\n                                                uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                                delete-previous=\"true\"\n                                                custom-label=\"{{'Upload a font' | translate}}\"\n                                                file-types=\".ttf,.otf\"\n                                                max-size=\"5\"\n                                                is-overlay=\"false\"\n                                                display-icon=\"false\">\n                                        </upload>\n                                        <div class=\"file-title\" ng-if=\"ctrl.json.admin.individualText.explanation.font\">\n                                            <span title=\"{{ctrl.json.admin.individualText.explanation.font.attachment_file | getFileName}}\">Uploaded: {{ ctrl.json.admin.individualText.explanation.font.attachment_file | getFileName:12 }}</span>\n                                            <md-button class=\"md-icon-button md-primary\"\n                                                       ng-click=\"ctrl.deleteIndividualTextAttachment(ctrl.json.admin.individualText.explanation, 'font')\">\n                                                <md-icon style=\"color: gray\">delete</md-icon>\n                                            </md-button>\n                                        </div>\n                                    </div>\n                                    <div layout=\"row\" class=\"area-editor\">\n                                        <start-screen-area\n                                                keep-invalid=\"true\"\n                                                screen-width-units=\"true\"\n                                                model=\"ctrl.json.admin.individualText.explanation.area\"\n                                                pixel-width=\"ctrl.getIndividualTextScreenSize().width\"\n                                                pixel-height=\"ctrl.getIndividualTextScreenSize().height\"\n                                                hide-upload=\"true\"\n                                                title=\"{{'Explanation on the screen:' | translate}}\">\n                                        </start-screen-area>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <!-- 4. text fields -->\n                            <div class=\"individual-text-block\"\n                                 ng-repeat=\"field in ctrl.json.admin.individualText.fields track by field.id\">\n                                <div class=\"individual-text-block__header\">\n                                    <md-switch md-invert class=\"part-title\" ng-model=\"field.enabled\">\n                                        <strong>{{'Text field' | translate}} {{$index + 1}}</strong>\n                                        <span class=\"individual-text-id\">id: {{field.id}}</span>\n                                    </md-switch>\n                                    <md-button class=\"md-icon-button\"\n                                               ng-if=\"field.enabled\"\n                                               ng-click=\"ctrl.individualTextCollapsed[field.id] = !ctrl.individualTextCollapsed[field.id]\"\n                                               aria-label=\"toggle settings\">\n                                        <md-icon>{{ctrl.individualTextCollapsed[field.id] ? 'expand_more' : 'expand_less'}}</md-icon>\n                                    </md-button>\n                                </div>\n                                <div ng-if=\"field.enabled\" ng-hide=\"ctrl.individualTextCollapsed[field.id]\">\n                                    <!-- for the screen and the picture -->\n                                    <div layout=\"row\" layout-wrap class=\"individual-text-row\">\n                                        <md-input-container flex=\"40\">\n                                            <label>{{'Allowed input' | translate}}</label>\n                                            <md-select ng-model=\"field.inputType\" aria-label=\"allowed input\"\n                                                       ng-change=\"ctrl.sanitizeIndividualTextValue(field)\">\n                                                <md-option ng-repeat=\"type in ctrl.individualTextInputTypes\" ng-value=\"type.value\">\n                                                    {{type.label | translate}}\n                                                </md-option>\n                                            </md-select>\n                                        </md-input-container>\n                                        <div class=\"upload-container individual-text-font\">\n                                            <upload\n                                                    model=\"field.font\"\n                                                    uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                                    delete-previous=\"true\"\n                                                    custom-label=\"{{'Upload a font' | translate}}\"\n                                                    file-types=\".ttf,.otf\"\n                                                    max-size=\"5\"\n                                                    is-overlay=\"false\"\n                                                    display-icon=\"false\">\n                                            </upload>\n                                            <div class=\"file-title\" ng-if=\"field.font\">\n                                                <span title=\"{{field.font.attachment_file | getFileName}}\">Uploaded: {{ field.font.attachment_file | getFileName:12 }}</span>\n                                                <md-button class=\"md-icon-button md-primary\"\n                                                           ng-click=\"ctrl.deleteIndividualTextAttachment(field, 'font')\">\n                                                    <md-icon style=\"color: gray\">delete</md-icon>\n                                                </md-button>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <p class=\"upload-container__sub-text\">{{'Font for the field name, the input and the printed text. Allowed file formats: .ttf, .otf' | translate}}</p>\n\n                                    <div class=\"individual-text-group\">\n                                        <h4 class=\"individual-text-group__title\">{{'On the screen' | translate}}</h4>\n                                        <div layout=\"row\" layout-wrap class=\"individual-text-row\">\n                                            <md-input-container flex=\"40\">\n                                                <label>{{'Field name' | translate}}</label>\n                                                <input ng-model=\"field.label.text\">\n                                            </md-input-container>\n                                            <md-input-container class=\"individual-text-number\">\n                                                <label>{{'Font size (px)' | translate}}</label>\n                                                <input type=\"number\" min=\"1\" step=\"1\" ng-model=\"field.label.fontSize\">\n                                            </md-input-container>\n                                            <div class=\"individual-text-color\">\n                                                <span class=\"individual-text-color__label\">{{'Name and input background color' | translate}}</span>\n                                                <color-picker ng-model=\"field.label.color\" options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n                                            </div>\n                                        </div>\n                                        <div layout=\"row\" layout-wrap class=\"individual-text-row\">\n                                            <md-input-container class=\"individual-text-number\">\n                                                <label>{{'Input font size (px)' | translate}}</label>\n                                                <input type=\"number\" min=\"1\" step=\"1\" ng-model=\"field.input.fontSize\">\n                                            </md-input-container>\n                                            <div class=\"individual-text-color\">\n                                                <span class=\"individual-text-color__label\">{{'Input text color' | translate}}</span>\n                                                <color-picker ng-model=\"field.input.textColor\" options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n                                            </div>\n                                        </div>\n                                        <div layout=\"row\" class=\"area-editor\">\n                                            <start-screen-area\n                                                    keep-invalid=\"true\"\n                                                    screen-width-units=\"true\"\n                                                    model=\"field.area\"\n                                                    pixel-width=\"ctrl.getIndividualTextScreenSize().width\"\n                                                    pixel-height=\"ctrl.getIndividualTextScreenSize().height\"\n                                                    hide-upload=\"true\"\n                                                    title=\"{{'Field position:' | translate}}\">\n                                            </start-screen-area>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"individual-text-group\">\n                                        <h4 class=\"individual-text-group__title\">{{'On the output picture' | translate}}</h4>\n                                        <div layout=\"row\" layout-wrap class=\"individual-text-row individual-text-row--center\">\n                                            <md-input-container flex>\n                                                <label>{{'Text' | translate}}</label>\n                                                <input ng-model=\"field.output.text\" ng-change=\"ctrl.sanitizeIndividualTextValue(field)\">\n                                            </md-input-container>\n                                            <md-switch md-invert ng-model=\"field.userEditable\">\n                                                {{'User can edit text' | translate}}\n                                            </md-switch>\n                                        </div>\n                                        <!-- the text box: center and size, % of the print layout -->\n                                        <div layout=\"row\" layout-wrap class=\"individual-text-row\">\n                                            <md-input-container class=\"individual-text-number\">\n                                                <label>X (%)</label>\n                                                <input type=\"number\" step=\"0.1\" ng-model=\"field.output.x\"\n                                                       ng-blur=\"ctrl.clampIndividualTextOutput(field)\">\n                                            </md-input-container>\n                                            <md-input-container class=\"individual-text-number\">\n                                                <label>Y (%)</label>\n                                                <input type=\"number\" step=\"0.1\" ng-model=\"field.output.y\"\n                                                       ng-blur=\"ctrl.clampIndividualTextOutput(field)\">\n                                            </md-input-container>\n                                            <md-input-container class=\"individual-text-number\">\n                                                <label>{{'Width (%)' | translate}}</label>\n                                                <input type=\"number\" step=\"0.1\" ng-model=\"field.output.width\"\n                                                       ng-blur=\"ctrl.clampIndividualTextOutput(field)\">\n                                            </md-input-container>\n                                            <md-input-container class=\"individual-text-number\">\n                                                <label>{{'Height (%)' | translate}}</label>\n                                                <input type=\"number\" step=\"0.1\" ng-model=\"field.output.height\"\n                                                       ng-blur=\"ctrl.clampIndividualTextOutput(field)\">\n                                            </md-input-container>\n                                        </div>\n                                        <!-- the text inside the box -->\n                                        <div layout=\"row\" layout-wrap class=\"individual-text-row\">\n                                            <md-input-container class=\"individual-text-select\">\n                                                <label>{{'Horizontal alignment' | translate}}</label>\n                                                <md-select ng-model=\"field.output.align\" aria-label=\"horizontal alignment\">\n                                                    <md-option ng-repeat=\"align in ctrl.individualTextAlignOptions\" ng-value=\"align.value\">\n                                                        {{align.label | translate}}\n                                                    </md-option>\n                                                </md-select>\n                                            </md-input-container>\n                                            <md-input-container class=\"individual-text-select\">\n                                                <label>{{'Vertical alignment' | translate}}</label>\n                                                <md-select ng-model=\"field.output.verticalAlign\" aria-label=\"vertical alignment\">\n                                                    <md-option ng-repeat=\"align in ctrl.individualTextVerticalAlignOptions\" ng-value=\"align.value\">\n                                                        {{align.label | translate}}\n                                                    </md-option>\n                                                </md-select>\n                                            </md-input-container>\n                                        </div>\n                                        <!-- the text look -->\n                                        <div layout=\"row\" layout-wrap class=\"individual-text-row\">\n                                            <md-input-container class=\"individual-text-number\">\n                                                <label>{{'Font size' | translate}}</label>\n                                                <input type=\"number\" min=\"1\" step=\"1\" ng-model=\"field.output.fontSize\"\n                                                       ng-blur=\"ctrl.clampIndividualTextOutput(field, 'fontSize')\">\n                                            </md-input-container>\n                                            <md-input-container class=\"individual-text-number\">\n                                                <label>{{'Min. font size' | translate}}</label>\n                                                <input type=\"number\" min=\"1\" step=\"1\" ng-model=\"field.output.minFontSize\"\n                                                       ng-blur=\"ctrl.clampIndividualTextOutput(field)\">\n                                            </md-input-container>\n                                            <div class=\"individual-text-color\">\n                                                <span class=\"individual-text-color__label\">{{'Text color' | translate}}</span>\n                                                <color-picker ng-model=\"field.output.color\" options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n                                            </div>\n                                        </div>\n                                        <p class=\"part-title__sub-text\">\n                                            {{'X and Y are the center of the text box, in % of the picture width and height. Width and height are % of the picture. The text is aligned inside the box. Long text is made smaller down to the min. font size, then cut with \"…\". A bigger font size (px) makes the box higher; the box height limits the font size.' | translate}}\n                                        </p>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <!-- 5. done button -->\n                            <div class=\"individual-text-block individual-text-done\">\n                                <h4>{{'Done button' | translate}}</h4>\n                                <div layout=\"row\" class=\"area-editor\">\n                                    <start-screen-area\n                                            keep-invalid=\"true\"\n                                            screen-width-units=\"true\"\n                                            upload-hint=\"{{'Image or Video. Allowed file formats: .svg, .png, .mp4, .mov or .webm.' | translate}} {{'Max. file size:' | translate}} {{ctrl.fileSizes.startScreen}}mb\"\n                                            model=\"ctrl.json.admin.individualText.doneButton\"\n                                            pixel-width=\"ctrl.getIndividualTextScreenSize().width\"\n                                            pixel-height=\"ctrl.getIndividualTextScreenSize().height\"\n                                            company=\"ctrl.config.company\"\n                                            custom-buttons-options=\"true\"\n                                            max-size=\"ctrl.fileSizes.startScreen\"\n                                            delete-previous=\"true\"\n                                            title=\"{{'Done button on the screen:' | translate}}\">\n                                    </start-screen-area>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div flex=\"45\" flex-sm=\"100\" class=\"individual-text-previews\" ng-if=\"ctrl.json.admin.individualText.enabled\">\n                        <div class=\"individual-text-previews__list\"\n                             ng-class=\"{'individual-text-previews__list--row': ctrl.getIndividualTextPreviewLayout().row}\"\n                             available-size=\"ctrl.individualTextPreviewSpace\">\n                            <div class=\"individual-text-previews__item\">\n                                <p class=\"part-title\"><strong>{{'Screen preview' | translate}} {{ctrl.getIndividualTextScreenTitle()}}</strong></p>\n                                <p class=\"part-title__sub-text\">{{'Drag the elements to place them on the screen. The screen has the size and orientation of the General tab.' | translate}}</p>\n                                <individual-text-screen-preview\n                                        settings=\"ctrl.json.admin.individualText\"\n                                        screen-width=\"ctrl.getIndividualTextScreenSize().width\"\n                                        screen-height=\"ctrl.getIndividualTextScreenSize().height\"\n                                        index=\"ctrl.getIndividualTextScreenIndex()\">\n                                    <individual-text-output-preview\n                                            settings=\"ctrl.json.admin.individualText\"\n                                            canvas-width=\"ctrl.getIndividualTextOutput().width\"\n                                            canvas-height=\"ctrl.getIndividualTextOutput().height\"\n                                            index=\"ctrl.getIndividualTextOutputIndexInScreen()\"\n                                            editable=\"true\">\n                                        <!-- Re-created on resize: html-preview places the photos only when the areas change -->\n                                        <html-preview\n                                                ng-repeat=\"outputIndex in [ctrl.getIndividualTextOutputIndexInScreen()] track by outputIndex\"\n                                                single=\"true\"\n                                                pr-width=\"{{ctrl.getIndividualTextOutput().width}}\"\n                                                pr-height=\"{{ctrl.getIndividualTextOutput().height}}\"\n                                                index=\"{{outputIndex}}\"\n                                                background=\"{{ctrl.getIndividualTextOutput().background}}\"\n                                                overlay=\"{{ctrl.getIndividualTextOutput().overlay}}\"\n                                                video-background=\"{{ctrl.getIndividualTextOutput().background}}\"\n                                                video-overlay=\"{{ctrl.getIndividualTextOutput().overlay}}\"\n                                                areas=\"{{ctrl.getIndividualTextOutput().areas}}\"\n                                                animation-speed=\"{{ctrl.getIndividualTextOutput().animationTime}}\"\n                                                ignore-overflow=\"true\"\n                                                hide-title=\"true\"\n                                                bg-style=\"'crop'\"\n                                                bg-mode=\"'image'\"\n                                                hide-photo-bg=\"ctrl.json.admin.enableChromakey\">\n                                        </html-preview>\n                                    </individual-text-output-preview>\n                                </individual-text-screen-preview>\n                            </div>\n\n                            <div class=\"individual-text-previews__item\">\n                                <p class=\"part-title\"><strong>{{'Output picture preview' | translate}} {{ctrl.getIndividualTextOutputTitle()}}</strong></p>\n                                <p class=\"part-title__sub-text\">{{'Drag the texts to place them on the picture: the Digital layout of the Scenes, or the screen of the General tab when the scenes are off.' | translate}}</p>\n                                <individual-text-output-preview\n                                        settings=\"ctrl.json.admin.individualText\"\n                                        canvas-width=\"ctrl.getIndividualTextOutput().width\"\n                                        canvas-height=\"ctrl.getIndividualTextOutput().height\"\n                                        index=\"ctrl.getIndividualTextOutputIndex()\"\n                                        editable=\"true\">\n                                    <!-- Re-created on resize: html-preview places the photos only when the areas change -->\n                                    <html-preview\n                                            ng-repeat=\"outputIndex in [ctrl.getIndividualTextOutputIndex()] track by outputIndex\"\n                                            single=\"true\"\n                                            pr-width=\"{{ctrl.getIndividualTextOutput().width}}\"\n                                            pr-height=\"{{ctrl.getIndividualTextOutput().height}}\"\n                                            index=\"{{outputIndex}}\"\n                                            background=\"{{ctrl.getIndividualTextOutput().background}}\"\n                                            overlay=\"{{ctrl.getIndividualTextOutput().overlay}}\"\n                                            video-background=\"{{ctrl.getIndividualTextOutput().background}}\"\n                                            video-overlay=\"{{ctrl.getIndividualTextOutput().overlay}}\"\n                                            areas=\"{{ctrl.getIndividualTextOutput().areas}}\"\n                                            animation-speed=\"{{ctrl.getIndividualTextOutput().animationTime}}\"\n                                            ignore-overflow=\"true\"\n                                            hide-title=\"true\"\n                                            bg-style=\"'crop'\"\n                                            bg-mode=\"'image'\"\n                                            hide-photo-bg=\"ctrl.json.admin.enableChromakey\">\n                                    </html-preview>\n                                </individual-text-output-preview>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"ctrl.isActiveStep('Individual Text Field')\" layout=\"row\" class=\"general-footer\">\n                    <div flex=\"100\" flex-sm=\"100\">\n                        <div layout=\"row\" layout-sm=\"column\" layout-padding>\n                            <div class=\"reset-btn-wrapper\" flex-sm=\"100\">\n                                <p>\n                                    <a href=\"#\"\n                                       ng-click=\"ctrl.resetStep('individual-text')\"\n                                       class=\"md-primary reset-link\">\n                                        {{'Reset' | translate}}\n                                    </a>\n                                    {{'This puts everything back to default settings' | translate}}\n                                </p>\n                                <md-button class=\"md-primary md-raised\" wz-next style=\"float: right\">{{'Next' |\n                                    translate}}\n                                </md-button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </wz-step>\n            <!-- end of individual text field step -->\n\n      <!-- sharing settings step -->\n      <wz-step\n          wz-title=\"{{'Sharing Settings' | translate}}\"\n          canenter=\"!ctrl.loading\"\n          canexit=\"ctrl.canExitSharingScreen() && !ctrl.loading\">\n\n        <form ng-if=\"ctrl.isActiveStep('Sharing Settings')\"\n            ng-class=\"{'request-loader': formSharing.$submitted==true}\"\n            name=\"ctrl.formSharing\">\n\n          <div layout=\"row\" layout-sm=\"column\" layout-padding>\n            <div flex=\"50\" flex-sm=\"100\" class=\"form-sharing\">\n\n              <md-switch md-invert\n                         ng-model=\"ctrl.json.admin.outputSettings.enableEmailSharing\">\n                <strong>{{'Share via email' | translate}}</strong>\n              </md-switch>\n\n              <md-switch md-invert\n                         ng-model=\"ctrl.json.client.advancedHtmlInput\"\n                         ng-disabled=\"ctrl.disableEmailFields()\"\n                         ng-change=\"ctrl.onAdvancedInputChange()\">\n                <strong>{{'Advanced HTML input' | translate}}</strong>\n              </md-switch>\n\n              <md-input-container\n                      style=\"width: 40%\"\n                      ng-disabled=\"ctrl.disableEmailFields()\"\n                      ng-if=\"!ctrl.json.client.advancedHtmlInput\">\n                <label>{{'Email templates' | translate}}</label>\n                <md-select\n                        ng-model=\"ctrl.json.client.emailTemplate\"\n                        ng-disabled=\"ctrl.disableEmailFields()\"\n                        ng-change=\"ctrl.onTemplateChange()\">\n                  <md-option ng-value=\"'German informal'\">German informal</md-option>\n                  <md-option ng-value=\"'German formal'\">German formal</md-option>\n                  <md-option ng-value=\"'English'\" selected>English</md-option>\n                </md-select>\n              </md-input-container>\n\n              <md-input-container class=\"md-block md-short-input\">\n                <label\n                    ng-bind=\"'Email address of sender' | translate\"\n                    for=\"inputEmail\"></label>\n\n                <input\n                  ng-model=\"ctrl.json.client.emailSender\"\n                  type=\"text\"\n                  name=\"emailSender\"\n                  id=\"inputEmail\"\n                  maxlength=\"100\"\n                  ng-pattern=\"/(.+)@(.+){2,}\\.(.+){2,}/\"\n                  ng-disabled=\"ctrl.disableEmailFields()\"\n                  ng-required=\"ctrl.json.admin.outputSettings.enableEmailSharing\">\n\n                <div ng-messages=\"ctrl.formSharing.emailSender.$error\" role=\"alert\">\n                  <div ng-message-exp=\"['required', 'maxlength', 'pattern']\"\n                       ng-bind=\"'Email must be between 10 and 100 characters long and look like an e-mail address.' | translate\">\n                  </div>\n                </div>\n              </md-input-container>\n\n              <md-input-container class=\"md-block md-short-input\">\n                <label\n                    ng-bind=\"'Email subject' | translate\"\n                    for=\"inputEmailSubject\"></label>\n\n                <input\n                  ng-model=\"ctrl.json.client.emailSubject\"\n                  type=\"text\"\n                  name=\"emailSubject\"\n                  id=\"inputEmailSubject\"\n                  maxlength=\"100\"\n                  ng-disabled=\"ctrl.disableEmailFields()\"\n                  ng-required=\"ctrl.json.admin.outputSettings.enableEmailSharing\">\n\n                <div ng-messages=\"ctrl.formSharing.emailSubject.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide email subject' | translate\"></div>\n                </div>\n              </md-input-container>\n\n              <md-input-container\n                      class=\"md-block md-short-input\">\n                <label\n                        ng-bind=\"'Email title' | translate\"\n                        for=\"inputEmailTitle\"></label>\n\n                <input\n                        ng-model=\"ctrl.json.client.emailTitle\"\n                        type=\"text\"\n                        name=\"emailTitle\"\n                        id=\"inputEmailTitle\"\n                        maxlength=\"40\"\n                        ng-disabled=\"ctrl.disableEmailFields()\"\n                        ng-required=\"ctrl.json.admin.outputSettings.enableEmailSharing\">\n\n                <div ng-messages=\"ctrl.formSharing.emailTitle.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide valid email title' | translate\"></div>\n                </div>\n              </md-input-container>\n\n              <md-input-container\n                      class=\"md-block\">\n                <label\n                        ng-bind=\"'Email text' | translate\"\n                        for=\"inputEmailTextNoHtml\"></label>\n\n                <textarea\n                        ng-model=\"ctrl.json.client.emailTextNoHtml\"\n                        type=\"text\"\n                        name=\"emailTextNoHtml\"\n                        id=\"inputEmailTextNoHtml\"\n                        style=\"min-height: 50px\"\n                        md-no-autogrow\n                        rows=\"1\"\n                        md-maxlength=\"3000\"\n                        max-rows=\"8\"\n                        md-detect-hidden\n                        ng-disabled=\"ctrl.disableEmailFields()\"\n                        ng-required=\"ctrl.json.admin.outputSettings.enableEmailSharing\">\n                </textarea>\n\n                <div ng-messages=\"ctrl.formSharing.emailTextNoHtml.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide email text' | translate\"></div>\n                </div>\n              </md-input-container>\n\n              <md-input-container\n                      class=\"md-block\"\n                      ng-if=\"ctrl.json.client.advancedHtmlInput\">\n                <label\n                    ng-bind=\"'Email text (HTML)' | translate\"\n                    for=\"inputEmailText\"></label>\n\n                <textarea\n                  ng-model=\"ctrl.json.client.emailTextRow\"\n                  type=\"text\"\n                  name=\"emailText\"\n                  id=\"inputEmailText\"\n                  style=\"min-height: 50px\"\n                  md-no-autogrow\n                  rows=\"1\"\n                  max-rows=\"8\"\n                  md-detect-hidden\n                  ng-disabled=\"ctrl.disableEmailFields()\"\n                  ng-required=\"ctrl.json.admin.outputSettings.enableEmailSharing\">\n                </textarea>\n\n                <div ng-messages=\"ctrl.formSharing.emailText.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide email text' | translate\"></div>\n                </div>\n              </md-input-container>\n\n              <md-switch md-invert\n                         ng-model=\"ctrl.json.client.allowEmailAttachments\"\n                         ng-disabled=\"ctrl.disableEmailFields()\">\n                <strong>{{'Allow email attachments' | translate}}</strong>\n              </md-switch>\n\n              <md-switch md-invert style=\"margin-top: 0\"\n                         ng-model=\"ctrl.json.client.emailDisclaimer\"\n                         ng-disabled=\"ctrl.disableEmailFields()\">\n                <strong>{{'Add a disclaimer' | translate}}</strong>\n              </md-switch>\n\n              <md-input-container class=\"md-block\">\n                <label\n                    ng-bind=\"'Email disclaimer text' | translate\"\n                    for=\"inputEmailDisclaimerText\"></label>\n\n                <textarea\n                  ng-model=\"ctrl.json.client.emailDisclaimerText\"\n                  type=\"text\"\n                  name=\"emailDisclaimerText\"\n                  id=\"inputEmailDisclaimerText\"\n                  style=\"min-height: 50px\"\n                  md-no-autogrow\n                  rows=\"1\"\n                  max-rows=\"8\"\n                  md-detect-hidden\n                  md-select-on-focus\n                  ng-disabled=\"ctrl.disableEmailFields() || !ctrl.json.client.emailDisclaimer\"\n                  ng-required=\"ctrl.json.admin.outputSettings.enableEmailSharing && ctrl.json.client.emailDisclaimer\">\n                </textarea>\n\n                <div ng-messages=\"ctrl.formSharing.emailDisclaimerText.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide email disclaimer' | translate\"></div>\n                </div>\n              </md-input-container>\n\n                <md-switch md-invert class=\"require-switch\"\n                           ng-show=\"ctrl.json.client.emailDisclaimer\"\n                           ng-model=\"ctrl.json.client.emailDisclaimerRequire\"\n                           ng-disabled=\"ctrl.disableEmailFields() || !ctrl.json.client.emailDisclaimer\">\n                    <strong>{{'Required' | translate}}</strong>\n                </md-switch>\n            </div>\n\n            <div flex=\"50\" flex-sm=\"100\">\n              <md-switch\n                      md-invert\n                      style=\"margin-top: 40px\"\n                      ng-model=\"ctrl.json.admin.showQRCode\">\n                <strong>{{'Show QR Code' | translate}}</strong>\n              </md-switch>\n                <p ng-hide=\"ctrl.hidePrintFields()\">{{'Number of prints per session:' | translate}} <strong>{{ctrl.json.admin.maxCountOfPrintCopies}}</strong></p>\n                <md-slider-container\n                        style=\"width: 400px\"\n                        ng-hide=\"ctrl.hidePrintFields()\">\n                    <md-slider\n                            min=\"1\"\n                            max=\"5\"\n                            step=\"1\"\n                            md-discrete\n                            ng-model=\"ctrl.json.admin.maxCountOfPrintCopies\"\n                            ng-change=\"ctrl.onCountOfPrintsChange(ctrl.json.admin.maxCountOfPrintCopies)\"\n                            ng-hide=\"ctrl.hidePrintFields()\"\n                            aria-label=\"slider\">\n                    </md-slider>\n                </md-slider-container>\n\n                <md-switch\n                        md-invert\n                        ng-hide=\"ctrl.hidePrintFields()\"\n                        ng-model=\"ctrl.json.admin.enableAutoPrint\">\n                    <strong>{{'Enable auto print' | translate}}</strong>\n                </md-switch>\n\n                <md-radio-group\n                        ng-model=\"ctrl.json.admin.autoPrintCopies\"\n                        class=\"radio-inline-custom\"\n                        ng-hide=\"ctrl.hidePrintFields()\"\n                        ng-disabled=\"!ctrl.json.admin.enableAutoPrint\">\n                    <span>Auto print copies: </span>\n                    <md-radio-button ng-value=\"1\" class=\"md-primary\">{{'1 print' | translate}}</md-radio-button>\n                    <md-radio-button ng-disabled=\"ctrl.json.admin.maxCountOfPrintCopies < 2\" ng-value=\"2\" class=\"md-primary\">{{'2 prints' | translate}}</md-radio-button>\n                </md-radio-group>\n\n              <md-switch\n                      md-invert ng-model=\"ctrl.json.admin.outputSettings.enableSmsSharing\"\n                      ng-disabled=\"ctrl.json.admin.outputSettings.formReplace === 'sms' || ctrl.json.admin.outputSettings.formReplace === 'both'\">\n                <strong>{{'Share via SMS' | translate}}</strong>\n              </md-switch>\n\n              <md-input-container class=\"md-blok\">\n                <label\n                    ng-bind=\"'SMS text' | translate\"\n                    for=\"inputSMSText\"></label>\n\n                <textarea\n                  ng-model=\"ctrl.json.client.smsText\"\n                  type=\"text\"\n                  name=\"emailSMS\"\n                  id=\"inputSMSText\"\n                  style=\"min-height: 50px\"\n                  md-no-autogrow\n                  rows=\"1\"\n                  max-rows=\"8\"\n                  md-detect-hidden\n                  md-maxlength=\"120\"\n                  ng-disabled=\"ctrl.disableSmsFields()\"\n                  ng-required=\"ctrl.json.admin.outputSettings.enableSmsSharing\">\n                </textarea>\n\n                <div ng-messages=\"ctrl.formSharing.emailSMS.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide SMS text' | translate\"></div>\n                </div>\n              </md-input-container>\n\n              <md-switch md-invert\n                         ng-model=\"ctrl.json.client.smsDisclaimer\"\n                         ng-disabled=\"ctrl.disableSmsFields()\">\n                <strong>{{'Add a disclaimer' | translate}}</strong>\n              </md-switch>\n\n              <md-input-container class=\"md-block\">\n                <label\n                    ng-bind=\"'SMS disclaimer text' | translate\"\n                    for=\"inputSMSDisclaimerText\"></label>\n\n                <textarea\n                  ng-model=\"ctrl.json.client.smsDisclaimerText\"\n                  type=\"text\"\n                  name=\"SMSDisclaimerText\"\n                  id=\"inputSMSDisclaimerText\"\n                  style=\"min-height: 50px\"\n                  md-no-autogrow\n                  rows=\"1\"\n                  max-rows=\"8\"\n                  md-detect-hidden\n                  md-select-on-focus\n                  ng-disabled=\"ctrl.disableSmsFields() || !ctrl.json.client.smsDisclaimer\"\n                  ng-required=\"ctrl.json.admin.outputSettings.enableEmailSharing && ctrl.json.client.smsDisclaimer\">\n                </textarea>\n\n                <div ng-messages=\"ctrl.formSharing.SMSDisclaimerText.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide SMS disclaimer' | translate\"></div>\n                </div>\n              </md-input-container>\n\n                <md-switch md-invert class=\"require-switch\"\n                           ng-show=\"ctrl.json.client.smsDisclaimer\"\n                           ng-model=\"ctrl.json.client.smsDisclaimerRequire\"\n                           ng-disabled=\"ctrl.disableSmsFields() || !ctrl.json.client.smsDisclaimer\">\n                    <strong>{{'Required' | translate}}</strong>\n                </md-switch>\n\n            </div>\n          </div>\n\n          <div class=\"offline-qr-section\" ng-if=\"ctrl.json.admin.offlineQrCode\">\n              <md-switch md-invert\n                         class=\"part-title\"\n                         ng-model=\"ctrl.json.admin.offlineQrCode.enabled\">\n                  <strong>{{'Offline QR Code' | translate}}</strong>\n              </md-switch>\n              <p class=\"part-title__sub-text\">\n                  {{'When enabled, the sharing screen uses the standard QR code on a custom background. Upload the background and the Done button, then set their position and size.' | translate}}\n              </p>\n\n              <div layout=\"row\" layout-sm=\"column\" layout-padding\n                   ng-if=\"ctrl.json.admin.offlineQrCode.enabled\">\n                  <div flex=\"60\" flex-sm=\"100\">\n                      <div class=\"upload-container\">\n                          <upload\n                                  model=\"ctrl.json.admin.offlineQrCode.background\"\n                                  uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                  delete-previous=\"true\"\n                                  custom-label=\"{{'Upload a background' | translate}}\"\n                                  file-types=\".jpg,.jpeg,.gif,.png,.mp4\"\n                                  max-size=\"15\"\n                                  is-overlay=\"false\"\n                                  display-icon=\"false\">\n                          </upload>\n\n                          <div class=\"file-title\" ng-if=\"ctrl.json.admin.offlineQrCode.background\">\n                              <span title=\"{{ctrl.json.admin.offlineQrCode.background.attachment_file | getFileName}}\">Uploaded: {{ ctrl.json.admin.offlineQrCode.background.attachment_file | getFileName:12 }}</span>\n                              <md-button\n                                      class=\"md-icon-button md-primary\"\n                                      ng-click=\"ctrl.deleteOfflineQrBackground()\">\n                                  <md-icon style=\"color: gray\">delete</md-icon>\n                              </md-button>\n                          </div>\n                      </div>\n                      <p class=\"upload-container__sub-text\">Image or Video.<br>\n                          Allowed file formats: .jpg, .png, .gif or .mp4.<br>\n                          Max. file size: 15mb / Max video length: 60 sec</p>\n\n                      <div layout=\"row\" class=\"area-editor\">\n                          <start-screen-area\n                                  model=\"ctrl.json.admin.offlineQrCode.doneButton\"\n                                  pixel-width=\"ctrl.json.admin.general.width\"\n                                  pixel-height=\"ctrl.json.admin.general.height\"\n                                  company=\"ctrl.config.company\"\n                                  custom-buttons-options=\"true\"\n                                  delete-previous=\"true\"\n                                  short-upload-title=\"true\"\n                                  title=\"{{'Done button dimensions:' | translate}}\">\n                          </start-screen-area>\n                      </div>\n\n                      <div layout=\"row\" class=\"area-editor\">\n                          <start-screen-area\n                                  model=\"ctrl.json.admin.offlineQrCode.qrCode\"\n                                  pixel-width=\"ctrl.json.admin.general.width\"\n                                  pixel-height=\"ctrl.json.admin.general.height\"\n                                  relative-size=\"true\"\n                                  title=\"{{'QR code dimensions:' | translate}}\">\n                          </start-screen-area>\n                      </div>\n                  </div>\n\n                  <div flex=\"40\" flex-sm=\"100\" class=\"offline-qr-preview\">\n                      <p class=\"part-title\"><strong>{{'Offline QR Code Preview' | translate}}</strong></p>\n                      <html-custom-btn-preview\n                              enabled=\"true\"\n                              pr-width=\"{{ctrl.json.admin.general.width}}\"\n                              pr-height=\"{{ctrl.json.admin.general.height}}\"\n                              index=\"{{ctrl.json.admin.general.height / 330}}\"\n                              related-values=\"true\"\n                              areas=\"{{ctrl.getOfflineQrPreviewAreas()}}\"\n                              background=\"{{ctrl.getOfflineQrBackgroundForPreview()}}\"\n                              video-background=\"{{ctrl.getOfflineQrVideoBackground()}}\"\n                              bg-mode=\"ctrl.getOfflineQrBackgroundMode()\"\n                              bg-color=\"'#ffffff'\"\n                              bg-style=\"stretch\"\n                              transparency=\"0\"\n                              done-btn=\"true\"\n                              qr-code-btn=\"true\"\n                              hide-photo-bg=\"true\"\n                              hide-overlay=\"true\"\n                              hide-title=\"true\"\n                              margin=\"true\">\n                      </html-custom-btn-preview>\n                  </div>\n              </div>\n          </div>\n\n          <div layout=\"row\" layout-sm=\"column\" layout-padding>\n             <div flex=\"50\" flex-sm=\"100\">\n               <a href=\"#\"\n                  ng-click=\"ctrl.resetStep('sharing')\"\n                  class=\"md-primary reset-link\">{{'Reset to the default UpReach sharing settings' | translate}}\n               </a>\n              <md-button class=\"md-primary md-raised\" wz-next style=\"float: right\">{{'Next' | translate}}</md-button>\n            </div>\n          </div>\n\n        </form>\n      </wz-step>\n      <!-- end of sharing settings step -->\n\n      <!-- offline forms step -->\n      <wz-step\n              wz-title=\"{{'Forms' | translate}}\"\n              canenter=\"!ctrl.loading\"\n              canexit=\"!ctrl.loading\">\n\n        <section ng-if=\"ctrl.isActiveStep('Forms')\"\n              class=\"form-offline-forms\">\n\n          <div layout=\"row\" layout-sm=\"column\" class=\"form-page\" layout-padding>\n              <div layout=\"column\" layout-sm=\"column\" class=\"left-side\">\n                  <div>\n                      <md-switch ng-model=\"ctrl.json.admin.offlineForms.enabled\" ng-change=\"ctrl.onSharingFormChange(); ctrl.onFormConfigurationChange()\">\n                          <strong style=\"font-size: 18px\">{{'Enable User Consent' | translate}}</strong>\n                      </md-switch>\n\n                      <md-switch ng-model=\"ctrl.json.admin.offlineForms.formRequired\" ng-class=\"{'disabled-input': !ctrl.json.admin.offlineForms.enabled}\">\n                          <strong style=\"font-size: 15px\">{{'Consent mandatory' | translate}}</strong>\n                      </md-switch>\n\n                      <p>\n                          You can add an user consent form to your configuration. <br>\n                          This enables to ask you for the user's consent, gather additional information on the user and to make specific consents mandatory to allow usage of the experience.\n                      </p>\n\n                      <md-switch ng-model=\"ctrl.json.admin.offlineForms.isSendFromForm\" ng-class=\"{'disabled-input': !ctrl.json.admin.offlineForms.enabled}\" ng-change=\"ctrl.changeEmailState()\">\n                          <strong style=\"font-size: 15px\">{{'Use Forms for Email sharing' | translate}}</strong>\n                      </md-switch>\n\n                      <p>\n                          If enabled, the user will receive their photos/videos <br>\n                          (to the email they have entered in the form) after adding their information and giving their consent.\n                      </p>\n\n                      <h3>When should the form be shown?</h3>\n                      <p>\n                          Decide when in the user flow the forms should be shown. Before taking the photo or when sharing? Take\n                          into consideration that this might affect accessibility and usability of the experience.\n                      </p>\n\n                      <md-input-container style=\"margin-bottom: 30px\">\n                          <md-select ng-model=\"ctrl.json.admin.offlineForms.when\" ng-disabled=\"!ctrl.json.admin.offlineForms.enabled\">\n                              <md-option ng-repeat=\"state in ctrl.whenOfflineForm\" ng-value=\"state.value\">\n                                  {{state.label}}\n                              </md-option>\n                          </md-select>\n                      </md-input-container>\n                  </div>\n\n                   <form\n                      class=\"form-offline-forms\"\n                      name=\"ctrl.formOfflineForms\"\n                      validate>\n                       <div flex-sm=\"100\" style=\"padding-bottom: 60px\">\n                           <hr style=\"color: #B7B7B7\">\n                           <h3>Information to be added by the user</h3>\n                           <p>The user can be asked to enter different kinds of information. You can make these entries mandatory.</p>\n\n                           <div class=\"inputs-switch\" layout=\"row\"\n                                ng-class=\"{'disabled-input': !ctrl.json.admin.offlineForms.enabled}\"\n                                ng-repeat=\"input in ctrl.json.admin.offlineForms.formInputs\">\n                               <md-switch class=\"sort-switch\" ng-model=\"input.active\" ng-change=\"ctrl.onFormConfigurationChange(input)\"></md-switch>\n                               <div class=\"custom-container\" layout=\"row\" ng-class=\"{'disabled-input': !input.active}\">\n                                   <strong style=\"line-height: 34px\">{{input.title}}</strong>\n                                   <md-switch md-invert ng-model=\"input.required\" ng-disabled=\"ctrl.json.admin.offlineForms.isSendFromForm && input.title === 'E-Mail'\">\n                                       <strong>Mandatory</strong>\n                                   </md-switch>\n                               </div>\n                           </div>\n\n                           <h3>Custom Fields</h3>\n                           <p>When a client asked for a custom field, you can activate up to five. Choose to type custom questions and answers or activate a multiple choice field</p>\n\n                           <md-switch\n                                   ng-class=\"{'disabled-input': !ctrl.json.admin.offlineForms.enabled}\"\n                                   ng-disabled=\"!ctrl.json.admin.offlineForms.enabled\"\n                                   ng-model=\"ctrl.formsOneAnswer\">\n                               <p>User can pick only one answer</p>\n                           </md-switch>\n\n                           <div class=\"inputs-switch\" layout=\"row\"\n                                ng-class=\"{'disabled-input': !ctrl.json.admin.offlineForms.enabled}\"\n                                ng-repeat=\"input in ctrl.json.admin.offlineForms.customInputs\" ng-init=\"inputIndex = $index\">\n                               <md-switch class=\"sort-switch\" ng-model=\"input.active\" ng-change=\"ctrl.onFormConfigurationChange(input)\"></md-switch>\n                               <div class=\"custom-container\" layout=\"column\" ng-class=\"{'disabled-input': !input.active,'error-card': ctrl.isErrorFiield('custom_input_' + $index)}\">\n                                   <div class=\"inner-switch\" layout=\"row\">\n                                       <md-input-container md-no-float\n                                                           class=\"custom-input\">\n                                           <input name=\"custom_input_{{$index}}\" ng-model=\"input.title\" placeholder=\"Custom field\" type=\"text\" ng-required=\"input.active\" minlength=\"1\" maxlength=\"150\">\n                                           <div ng-messages=\"ctrl.formOfflineForms['custom_input_' + $index].$error\" role=\"alert\">\n                                               <div ng-message=\"maxlength\">That's too long!</div>\n                                               <div ng-message=\"minlength\">Need fill this field!</div>\n                                               <div ng-message=\"required\">{{'Please provide valid input' | translate}}</div>\n                                           </div>\n                                           <div style=\"font-size: 12px\" ng-if=\"input.title && ctrl.isCustomTitleUnique(input.title, $index)\"\n                                                ng-messages=\"true\" role=\"alert\" ng-bind=\"'Please provide unique title' | translate\"></div>\n                                       </md-input-container>\n\n                                       <div class=\"property-container\" layout=\"row\">\n                                           <p>Property:</p>\n                                           <div layout=\"row\">\n                                               <md-button\n                                                       ng-class=\"{'property-active': input.inputMode === 'text'}\"\n                                                       ng-click=\"\n                                                        input.inputMode = 'text';\n                                                        !input.choices.length ? ctrl.addChoiceField(inputIndex) : false \">\n                                                   Text\n                                               </md-button>\n                                               <md-button\n                                                       ng-class=\"{'property-active': input.inputMode === 'multiple'}\"\n                                                       ng-click=\"\n                                                        input.inputMode = 'multiple';\n                                                        !input.choices.length ? ctrl.addChoiceField(inputIndex) : false\">\n                                                   Multiple\n                                               </md-button>\n                                           </div>\n                                       </div>\n\n                                       <md-switch md-invert ng-model=\"input.required\">\n                                           <strong>Mandatory</strong>\n                                       </md-switch>\n                                   </div>\n\n                                   <div layout=\"row\" ng-if=\"input.inputMode === 'multiple'\" ng-repeat=\"choice in input.choices\">\n                                       <md-input-container style=\"margin-top: 15px\" md-no-float\n                                                           class=\"choice-input\">\n                                           <label class=\"answer-label\" style=\"pointer-events: all\" for=\"choiceInput\">\n                                               Answer option {{$index + 1}}\n                                               <span ng-if=\"input.choices.length !== 1 && input.inputMode === 'multiple'\" ng-click=\"ctrl.removeChoiceField(inputIndex, $index)\">Delete</span>\n                                           </label>\n                                           <input ng-model=\"choice.text\" placeholder=\"Enter answer\" type=\"text\" maxlength=\"300\">\n                                       </md-input-container>\n                                       <md-button\n                                               ng-if=\"input.choices.length === $index + 1 && $index !== 5\"\n                                               class=\"add-choice-button md-fab\"\n                                               aria-label=\"Eat cake\" ng-click=\"ctrl.addChoiceField(inputIndex)\">\n                                           <span>\n                                               +\n                                           </span>\n                                       </md-button>\n                                   </div>\n\n                                   <div layout=\"row\" ng-if=\"input.inputMode === 'text'\">\n                                       <md-input-container style=\"margin-top: 15px\" md-no-float\n                                                           class=\"choice-input\">\n                                           <label class=\"answer-label\" style=\"pointer-events: all\" for=\"choiceInput\">\n                                               Text Field\n                                           </label>\n                                           <input disabled ng-model=\"choice.text\" placeholder=\"User is able to type freely\" type=\"text\">\n                                       </md-input-container>\n                                   </div>\n\n                               </div>\n                           </div>\n                           <div class=\"inputs-switch\" layout=\"row\" ng-class=\"{'disabled-input': !ctrl.json.admin.offlineForms.enabled}\">\n                               <md-switch class=\"sort-switch\"\n                                          ng-model=\"ctrl.json.admin.offlineForms.formSignature.active\"\n                                          ng-change=\"ctrl.onFormConfigurationChange(ctrl.json.admin.offlineForms.formSignature)\"></md-switch>\n                               <div ng-class=\"{'disabled-input': !ctrl.json.admin.offlineForms.formSignature.active}\" class=\"custom-container\" layout=\"row\" >\n                                   <strong style=\"line-height: 34px\">{{ctrl.json.admin.offlineForms.formSignature.title}}</strong>\n                                   <md-switch md-invert ng-model=\"ctrl.json.admin.offlineForms.formSignature.required\">\n                                       <strong>Mandatory</strong>\n                                   </md-switch>\n                               </div>\n                           </div>\n                       </div>\n\n                       <div flex-sm=\"100\">\n                           <hr style=\"color: #B7B7B7\">\n                           <h3>Checkboxes</h3>\n                           <p>You can add checkboxes for the user to acknowledge when using the system under your terms and conditions.</p>\n                           <md-switch ng-model=\"ctrl.json.admin.offlineForms.infoBoxCustomize\"\n                                      ng-disabled=\"!ctrl.json.admin.offlineForms.enabled\"\n                                      ng-class=\"{'disabled-input' : !ctrl.json.admin.offlineForms.enabled}\">\n                               <p class=\"font-height-low\">Customize the placeholder text.</p>\n                           </md-switch>\n\n                           <md-switch ng-model=\"ctrl.json.admin.offlineForms.formCheckboxesTypeLikeRadiobutton\"\n                                      ng-change=\"ctrl.setCheckboxesLikeRadiobutton(ctrl.json.admin.offlineForms.formCheckboxesTypeLikeRadiobutton)\"\n                                      ng-disabled=\"ctrl.checkIsActiveCheckboxesOfTypeCheckbox(ctrl.json.admin.offlineForms.formCheckboxes);\n                                                   ctrl.checkIsActiveCheckboxesOfTypeCheckbox(ctrl.json.admin.offlineForms.formCheckboxes) ?\n                                                    ctrl.json.admin.offlineForms.formCheckboxesTypeLikeRadiobutton = false : ''\"\n                                      ng-class=\"{'disabled-input' : ctrl.checkIsActiveCheckboxesOfTypeCheckbox(ctrl.json.admin.offlineForms.formCheckboxes)}\">\n                               <p class=\"font-height-low\">User <span>has to select</span> one mandatory checkbox.<br>User can only select one.</p>\n                           </md-switch>\n                           <div ng-repeat=\"checkboxForm in ctrl.json.admin.offlineForms.formCheckboxes\"\n                                ng-class=\"{'disabled-input': !ctrl.json.admin.offlineForms.enabled}\"\n                                style=\"margin-bottom: 30px\">\n                               <md-switch ng-model=\"checkboxForm.active\" ng-change=\"ctrl.onFormConfigurationChange(checkboxForm)\">\n                                   <strong>Checkbox {{$index + 1}}</strong>\n                               </md-switch>\n                               <div layout=\"column\" class=\"checkbox-body\" ng-class=\"{'disabled-input' : !checkboxForm.active,'error-card': ctrl.isErrorFiield('checkboxTitle_' + $index)}\">\n\n                                   <div layout=\"row\" class=\"body-top\">\n                                       <div class=\"wrapper\">\n                                           <md-input-container\n                                                   class=\"md-block md-short-input\">\n                                               <label\n                                                       ng-bind=\"'Checkbox title' | translate\"\n                                               ></label>\n                                               <input ng-model=\"checkboxForm.title\"\n                                                      type=\"text\"\n                                                      name=\"checkboxTitle_{{$index}}\"\n                                                      maxlength=\"180\"\n                                                      ng-disabled=\"!checkboxForm.active\"\n                                                      ng-required=\"checkboxForm.active\">\n                                               <div ng-messages=\"ctrl.formOfflineForms['checkboxTitle_' + $index].$error\" role=\"alert\">\n                                                   <div ng-message=\"required\" ng-bind=\"'Please provide valid checkbox title' | translate\"></div>\n                                               </div>\n                                           </md-input-container>\n                                           <md-input-container\n                                                   class=\"md-block md-short-input\" ng-if=\"ctrl.json.admin.offlineForms.infoBoxCustomize\">\n                                               <label ng-bind=\"'Infobox placeholder' | translate\"></label>\n                                               <input ng-model=\"checkboxForm.infoBoxCustomText\"\n                                                      type=\"text\"\n                                                      name=\"infoBoxCustomText_{{$index}}\"\n                                                      maxlength=\"60\"\n                                                      minlength=\"1\"\n                                                      ng-disabled=\"!checkboxForm.active\"\n                                                      ng-required=\"checkboxForm.active\">\n                                               <div ng-messages=\"ctrl.formOfflineForms['infoBoxCustomText_' + $index].$error\" role=\"alert\">\n                                                   <div ng-message=\"required\" ng-bind=\"'Please provide valid infobox placeholder' | translate\"></div>\n                                               </div>\n                                           </md-input-container>\n                                           <md-input-container class=\"md-block\" ng-if=\"!checkboxForm.usePdf\">\n                                               <label>{{'Checkbox text' | translate}}</label>\n                                               <textarea\n                                                       ng-model=\"checkboxForm.description\"\n                                                       class=\"paste-code\"\n                                                       name=\"checkboxText\"\n                                                       style=\"min-height: 150px\"\n                                                       md-no-autogrow\n                                                       rows=\"3\"\n                                                       maxlength=\"15000\"\n                                                       max-rows=\"7\"\n                                                       md-detect-hidden\n                                                       ng-disabled=\"!checkboxForm.active\"\n                                                       md-select-on-focus></textarea>\n\n                                               <div ng-messages=\"formOfflineForms.checkboxText.$error\" role=\"alert\">\n                                                   <div ng-message=\"required\" ng-bind=\"'Please provide valid checkbox text' | translate\"></div>\n                                               </div>\n                                           </md-input-container>\n                                           <div class=\"upload-wrapper\" ng-if=\"checkboxForm.usePdf\">\n                                               <upload\n                                                       uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                                       custom-label=\"{{'Upload PDF' | translate}}\"\n                                                       file-types=\".pdf\"\n                                                       max-size=\"ctrl.fileSizes.pdf\"\n                                                       old-file=\"checkboxForm.fileId\"\n                                                       is-overlay=\"false\"\n                                                       display-icon=\"true\"\n                                                       callback=\"ctrl.pdfUpload(file, 'offlineForms', $index)\">\n                                               </upload>\n\n                                               <span title=\"{{checkboxForm.fileName}}\" ng-if=\"checkboxForm.fileName != '' && checkboxForm.fileName != null\">{{checkboxForm.fileName}}</span>\n                                               <span ng-if=\"checkboxForm.fileName == '' || checkboxForm.fileName == null\">(PDF; 4mb)</span>\n                                               <md-button\n                                                       ng-if=\"checkboxForm.fileName != '' && checkboxForm.fileName != null\"\n                                                       class=\"md-icon-button md-primary\"\n                                                       ng-click=\"ctrl.pdfDeleteFile(checkboxForm.fileId,'offlineForms', $index)\"\n                                                       ng-disabled=\"checkboxForm.fileId == null\">\n                                                   <md-icon style=\"color: gray\">delete</md-icon>\n                                               </md-button>\n                                           </div>\n                                       </div>\n\n\n                                        <div class=\"toggle-wrapper\" style=\"margin-right: 3%\">\n                                            <md-switch ng-model=\"checkboxForm.isInfobox\" ng-change=\"checkboxForm.isInfobox ? checkboxForm.required = false : checkboxForm.required\">\n                                                <strong>Infobox</strong>\n                                            </md-switch>\n                                            <md-switch ng-model=\"checkboxForm.required\"\n                                                       ng-disabled=\"checkboxForm.isInfobox;\n                                                                    ctrl.json.admin.offlineForms.formCheckboxesTypeLikeRadiobutton;\n                                                                    ctrl.json.admin.offlineForms.formCheckboxesTypeLikeRadiobutton ? checkboxForm.required = false : ''\"\n                                                       ng-class=\"{'disabled-input' : ctrl.json.admin.offlineForms.formCheckboxesTypeLikeRadiobutton || checkboxForm.isInfobox}\">\n                                                <strong>Mandatory</strong>\n                                            </md-switch>\n                                            <md-switch ng-model=\"checkboxForm.usePdf\" >\n                                                <strong>Upload PDF</strong>\n                                            </md-switch>\n                                        </div>\n                                   </div>\n\n                               </div>\n                           </div>\n                       </div>\n                   </form>\n\n                  <div class=\"upload-container\" style=\"margin-bottom: 120px\">\n                      <hr style=\"color: #B7B7B7\">\n                      <h3>Background Image</h3>\n                      <p>You can upload an background image ({{ctrl.json.admin.general.width +' x '+ ctrl.json.admin.general.height}}px) to the data Form screen.</p>\n\n                      <upload ng-class=\"{'disabled-input': !ctrl.json.admin.offlineForms.enabled}\"\n                              model=\"ctrl.json.admin.offlineForms.backgroundImage\"\n                              uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                              custom-label=\"{{'Upload a Background' | translate}}\"\n                              file-types=\".jpg,.jpeg,.png\"\n                              callback=\"ctrl.formBackground(file)\"\n                              extra-info=\"{{'(JPG, PNG; ' + ctrl.fileSizes.startScreen + 'mb;' + ctrl.json.admin.general.width +' x '+ ctrl.json.admin.general.height + ')'  | translate}}\"\n                              max-size=\"ctrl.fileSizes.startScreen\"\n                              display-icon=\"true\"\n                              is-overlay=\"false\">\n                      </upload>\n                      <div class=\"file-title\"\n                           ng-if=\"ctrl.json.admin.offlineForms.backgroundImage.attachment_file\"\n                           title=\"{{ctrl.json.admin.offlineForms.backgroundImage.attachment_file | getFileName}}\">\n                          <span>Uploaded: {{ ctrl.json.admin.offlineForms.backgroundImage.attachment_file | getFileName: 12 }}</span>\n                          <md-button\n                                  class=\"md-icon-button md-primary\"\n                                  ng-click=\"ctrl.deleteOfflineFormsBackground()\">\n                              <md-icon>delete</md-icon>\n                          </md-button>\n                      </div>\n                  </div>\n              </div>\n\n              <div layout=\"column\" layout-sm=\"column\" layout-padding style=\"width: 46%\">\n                  <div flex=\"50\" flex-sm=\"100\">\n                      <forms-preview\n                              defined-inputs=\"ctrl.json.admin.offlineForms.formInputs\"\n                              custom-inputs=\"ctrl.json.admin.offlineForms.customInputs\"\n                              checkboxes=\"ctrl.json.admin.offlineForms.formCheckboxes\"\n                              signature=\"ctrl.json.admin.offlineForms.formSignature\"\n                              one-answer=\"ctrl.formsOneAnswer\"\n                              enabled=\"ctrl.json.admin.offlineForms.enabled\"\n                      ></forms-preview>\n                  </div>\n              </div>\n          </div>\n        </section>\n\n        <div ng-if=\"ctrl.isActiveStep('Forms')\" layout=\"row\" layout-sm=\"column\" layout-padding>\n          <div flex=\"100\" flex-sm=\"100\">\n            <a href=\"#\"\n               ng-click=\"ctrl.resetStep('forms')\"\n               class=\"md-primary reset-link\">{{'Reset to the default UpReach Offline Forms' | translate}}\n            </a>\n            <md-button class=\"md-primary md-raised\" wz-finish style=\"float: right\" ng-disabled=\"ctrl.formOfflineForms.$invalid && ctrl.formOfflineForms.enabled\">{{'Save configuration' | translate}}</md-button>\n          </div>\n        </div>\n\n      </wz-step>\n      <!-- end of offline forms step -->\n\n    </wizard>\n  </div>\n</div>\n";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(189);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(272);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _isFinite = __webpack_require__(264);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	var _fileSizes = __webpack_require__(277);
	
	var _colorPicker = __webpack_require__(278);
	
	var _printFormatsConstant = __webpack_require__(279);
	
	var _individualText = __webpack_require__(263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Print formats A1–A6, 10×15, 15×20, 2:3–4:3; getPixelsForFormat, options for md-select
	var dependencies = ["$Configuration", "$companies", "$service"];
	var REPLICATE_PROMPT_MODELS = {
	    pro: "google/nano-banana-pro",
	    normal: "google/nano-banana-2",
	    faster: "black-forest-labs/flux-kontext-pro"
	};
	var REPLICATE_PROMPT_DEFAULT_QUALITY = "normal";
	var VIDEO_CHROMAKEY_FEATURE = "video_chromakey";
	
	var ConfigurationUpdateController = function (_$controller) {
	    ConfigurationUpdateController.$inject = ["$injector", "$stateParams", "$scope", "$photoTransform", "$ToViewValue", "$ToBoothValue", "$EmailTemplates", "$DetectChanges", "$auth", "$ToastService", "WizardHandler", "$upload"];
	    (0, _inherits3.default)(ConfigurationUpdateController, _$controller);
	
	    function ConfigurationUpdateController($injector, $stateParams, $scope, $photoTransform, $ToViewValue, $ToBoothValue, $EmailTemplates, $DetectChanges, $auth, $ToastService, WizardHandler, $upload) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, ConfigurationUpdateController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ConfigurationUpdateController.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationUpdateController)).call(this, $injector, dependencies));
	
	        _this.$scope = $scope;
	        _this.$stateParams = $stateParams;
	        _this.isNew = _this.$stateParams.isNew;
	        _this.photoTransform = $photoTransform;
	        _this.toViewValue = $ToViewValue;
	        _this.toBoothValue = $ToBoothValue;
	        _this.emailTemplates = $EmailTemplates;
	        _this.detectChanges = $DetectChanges;
	        _this.$auth = $auth;
	        _this.Math = Math;
	        _this.pickerOptions = (0, _assign2.default)({}, _colorPicker.COLOR_PICKER_OPTIONS);
	        _this.toastService = $ToastService;
	        _this.loading = true;
	        _this.wizardHandler = WizardHandler;
	        _this.formsOneAnswer = false;
	        _this.loadingTost = {
	            template: "<md-toast>Saving changes ...</md-toast>",
	            hideDelay: 0,
	            position: "top right",
	            toastClass: "loading"
	        };
	        _this.$http = $injector.get("$http");
	        _this.showApiKeyForm = false;
	        _this.showReplicateApiKeyForm = false;
	        _this.showRemakerApiKeyForm = false;
	        _this.removeBg = {};
	        _this.replicate = {};
	        _this.remaker = {};
	        _this.unscreen = {};
	        _this.wandershareApi = {};
	        _this.displayFaceSwapConnectBlock = false;
	        _this.removeBgIsConnectedState = false;
	        _this.replicateIsConnectedState = false;
	        _this.remakerIsConnectedState = false;
	        _this.unscreenIsConnectedState = false;
	        _this.wandershareApiIsConnectedState = false;
	        _this.faceSwapApiIsConnectedState = false;
	        _this.faceSwapMultiOptionToggle = false;
	        _this.$upload = $upload;
	        _this.formErrorFields = [];
	        _this.sceneActiveFeatures = [];
	        _this.gdpr = {
	            showGdpr: false,
	            gdprFile: null,
	            fileId: null,
	            gdprCustomButtonsEnabled: false,
	            gdprAcceptButtonImage: null,
	            gdprDeclineButtonImage: null
	        };
	
	        // Options for md-select "Layout aspect ratio" and "Print quality / DPI"
	        _this.printFormatOptionGroups = _printFormatsConstant.PRINT_FORMAT_OPTION_GROUPS;
	        _this.printDpiOptions = _printFormatsConstant.PRINT_DPI_OPTIONS;
	        _this.individualTextInputTypes = _individualText.INDIVIDUAL_TEXT_INPUT_TYPES;
	        _this.individualTextAlignOptions = _individualText.INDIVIDUAL_TEXT_ALIGN_OPTIONS;
	        _this.individualTextVerticalAlignOptions = _individualText.INDIVIDUAL_TEXT_VERTICAL_ALIGN_OPTIONS;
	        // Collapsed setting blocks of the Individual Text tab, by field id (not saved)
	        _this.individualTextCollapsed = {};
	        _this.watchIndividualTextLayout();
	
	        $scope.$on("wizard:stepChanged", function (event, args) {
	            _this.currentStep = args.step.wzTitle;
	            if (_this.canExitSharingScreen() && _this.canExitScreen("singlePhoto", "photoBooth") && _this.canExitScreen("gif", "gifBooth") && _this.canExitScreen("boomerang", "boomerangBooth") && _this.canExitStartScreen() && _this.canExitCustomButtons() && _this.canExitScenes() && _this.canExitFaceSwapScenes() && _this.canExitFaceSwapOverlays() && _this.canExitForms()) {
	                _this.checkDesignForAllModes();
	                _this.changeScenes();
	                _this.saveConfiguration(false);
	            } else if (!_this.loading) {
	                _this.saveConfiguration(false);
	                _this.canExitWizard();
	            }
	        });
	        $scope.$on("wizard:stepChangeFailed", function () {
	            if (!_this.loading) {
	                if (!_this.canExitSharingScreen() && _this.currentStep === "Sharing Settings" && _this.formSharing && _this.formSharing.$valid) {
	                    _this.showErrorDialog("Error", "<p>You must allow email, QR-code or sms sharing if</p> <p>this option is provided in photo modes</p>");
	                } else if (!_this.canExitScenes()) {
	                    _this.showErrorDialog("Error", "<p>Please, enable at least one scene and </p> <p>fill out all fields  or disable this option</p>");
	                } else {
	                    _this.showErrorDialog("Error", "<p>Please, fill out the missing fields</p>");
	                }
	            }
	        });
	        _this.whenOfflineForm = [{
	            "value": "beforePhoto",
	            "label": "before taking photo"
	        }, {
	            "value": "afterPhoto",
	            "label": "after taking photo"
	        }];
	        _this.fileSizes = _fileSizes.FILE_SIZES;
	
	        // temporary set canvas size for printout
	        _this.printCanvasWidth = 1240;
	        _this.printCanvasHeight = 1844;
	        _this.animatedIcons = false;
	        _this.viewValue = _this.toViewValue.getDefaultViewValue();
	        _this.storedConfig = angular.copy(_this.viewValue);
	
	        var config = void 0;
	        if ($stateParams.cid && $stateParams.cid !== "create") {
	            config = _this.$Configuration.get({ id: $stateParams.cid });
	        } else {
	            config = _this.$Configuration.get({ url: _this.$companies.getCached().default_configuration });
	        }
	
	        config && config.$promise.then(function (config) {
	            _this.config = config;
	            delete config["us_active"];
	            delete config["us_api_key"];
	            _this.json = config.json;
	            if (!_this.json.admin.videoBooth) {
	                (0, _assign2.default)(_this.json.admin, {
	                    videoBooth: {
	                        enabled: false,
	                        allowSharing: true,
	                        enableChromakey: false,
	                        enableSoundRecording: false,
	                        countdownTime: 5,
	                        playbackSpeed: 1,
	                        captureTime: 1.5,
	                        resolutionOptions: "hd",
	                        sliderValue: 300
	                    }
	                });
	            }
	            _this.ensureVideoBoothFields(_this.json.admin.videoBooth);
	            if (_this.json.admin.removeBg == undefined) {
	                _this.json.admin["removeBg"] = { active: false };
	            }
	            if (_this.json.admin.unscreen == undefined) {
	                _this.json.admin["unscreen"] = { us_active: false };
	            }
	            if (_this.json.admin.ai == undefined) {
	                _this.json.admin["ai"] = { wandershareApi: { active: false, aging_active: false } };
	            }
	            if (_this.json.admin.ai.replicate == undefined) {
	                _this.json.admin.ai["replicate"] = {
	                    replicate_remove_bg_active: false,
	                    replicate_api_key: "",
	                    replicate_prompting_active: false,
	                    replicate_prompt_quality: REPLICATE_PROMPT_DEFAULT_QUALITY,
	                    replicate_model: REPLICATE_PROMPT_MODELS[REPLICATE_PROMPT_DEFAULT_QUALITY]
	                };
	            } else {
	                _this.normalizeReplicatePromptingState(_this.json.admin.ai.replicate);
	            }
	            if (_this.json.admin.ai.remaker == undefined) {
	                _this.json.admin.ai["remaker"] = { remaker_remove_bg_active: false, remaker_api_key: "" };
	            }
	            if (_this.json.admin.ai.wandershareApi == undefined) {
	                _this.json.admin["ai.wandershareApi"] = { active: false, aging_active: false };
	            } else {
	                _this.getWondershareApiData();
	            }
	            if (_this.json.admin.ai.faceSwap == undefined) {
	                _this.json.admin["ai.faceSwap"] = {
	                    active: false,
	                    face_swap_active: false,
	                    face_swap_api_key: "",
	                    display_scene_button_title: false,
	                    display_scene_names: false
	                };
	            }
	            if (_this.json.admin.gdpr == undefined) {
	                (0, _assign2.default)(_this.json.admin, {
	                    gdpr: {
	                        showGdpr: false,
	                        gdprFile: null,
	                        fileId: null,
	                        gdprCustomButtonsEnabled: false,
	                        gdprAcceptButtonImage: null,
	                        gdprDeclineButtonImage: null
	                    }
	                });
	            }
	            if (_this.json.admin.ai.customLogo == undefined) {
	                (0, _assign2.default)(_this.json.admin.ai, {
	                    customLogo: {
	                        active: false,
	                        customLogoFile: null,
	                        fileId: null
	                    }
	                });
	            }
	            if (_this.json.admin.liveView.customLogo === undefined) {
	                (0, _assign2.default)(_this.json.admin.liveView, {
	                    customLogo: {
	                        enabled: true,
	                        file: null,
	                        hideDefaultLogo: false,
	                        background: {
	                            enabled: true,
	                            mode: "color",
	                            color: "white",
	                            image: null
	                        },
	                        screenText: {
	                            enabled: false,
	                            title: "Your image is being created",
	                            subText: "It may take a few seconds text",
	                            color: "black"
	                        }
	                    }
	                });
	            }
	            if (_this.json.admin.liveView.customLogo && _this.json.admin.liveView.customLogo.hideDefaultLogo === undefined) {
	                _this.json.admin.liveView.customLogo.hideDefaultLogo = false;
	            }
	            _this.ensureCustomSceneScreenConfig();
	            if (!_this.json.admin.hasOwnProperty("filtersNamesShow")) {
	                (0, _assign2.default)(_this.json.admin, { filtersNamesShow: false });
	            }
	            _this.ensureIndividualText();
	            _this.ensureOfflineQrCode();
	            _this.deleteUpdatedProperties();
	            _this.copiedConfig = (0, _lodash.cloneDeep)(_this.config);
	            if (_this.json.client && _this.json.client.emailTextNoHtml) {
	                _this.json.client.emailTextNoHtml = _this.emailTemplates.removeLineBreaks(_this.json.client.emailTextNoHtml);
	            }
	            _this.transformConfigToViewValue();
	            if (_this.json.admin.liveView && _this.json.admin.liveView.customButtons === undefined) {
	                (0, _assign2.default)(_this.json.admin.liveView, {
	                    customButtons: {
	                        active: false,
	                        generalUiButtonsSettings: {
	                            back: { width: 4.5, height: 4.5, x: 8, y: 7 },
	                            sharingBackBtn: { width: 3.5, height: 3.5, x: 8, y: 7 },
	                            capture: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                            proceed: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                            email: { width: 5.5, height: 5.5, x: 16.5, y: 88 },
	                            sms: { width: 3.5, height: 3.5, x: 35, y: 88 },
	                            print: { width: 3.5, height: 3.5, x: 45, y: 88 },
	                            done: { width: 6, height: 6, x: 89, y: 92.5 },
	                            qrCode: { width: 7, height: 7, x: 50, y: 11, text: "Scan me to download", textSize: 12, textColor: "black" },
	                            close: { width: 3.5, height: 3.5, x: 5, y: 28 },
	                            next: { width: 5, height: 5, x: 93, y: 50 },
	                            closeError: { width: 5, height: 5, x: 93, y: 50 }
	                        },
	                        captureModeButtonsSettings: {
	                            single: { width: 3.5, height: 3.5, x: 8, y: 44 },
	                            gif: { width: 3.5, height: 3.5, x: 8, y: 49 },
	                            boomerang: { width: 3.5, height: 3.5, x: 8, y: 55 },
	                            scene: { scenePopupColor: "#FFF", width: 36, height: 48, x: 50, y: 57 },
	                            filter: { width: 5, height: 5, x: 8, y: 38 }
	                        }
	                    }
	                });
	            }
	            _this.ensureGeneralUiButtonsSettings();
	            if (_this.json.admin.liveView && _this.json.admin.liveView.hideOutputPictureVideo === undefined) {
	                _this.json.admin.liveView.hideOutputPictureVideo = false;
	            }
	            if (_this.json.admin.liveView && _this.json.admin.liveView.hideSharingOptions === undefined) {
	                _this.json.admin.liveView.hideSharingOptions = false;
	            }
	            _this.json && _this.json.admin.offlineForms && !_this.json.admin.offlineForms.when && (_this.json.admin.offlineForms.when = "afterPhoto");
	            if (_this.config.json.client && !_this.config.json.client.advancedHtmlInput && _this.config.json.client.advancedHtmlInput !== false) {
	                _this.config.json.client.advancedHtmlInput = true;
	            }
	            //use this for fix 'this.json.admin.offlineForms.when' on old configuration where selected value 'onStart'
	            if (_this.json && _this.json.admin.offlineForms && _this.json.admin.offlineForms.when === "onStart") {
	                _this.json.admin.offlineForms.when = "beforePhoto";
	            }
	            _this.checkBackgroundResolution();
	            _this.getRemoveBgData();
	            _this.getReplicateData();
	            _this.getReplicatePromptingData();
	            _this.getRemakerData();
	            _this.getUnscreenData();
	            //this.getWondershareApiData();
	            _this.getFaceSwapApiData();
	
	            _this.loading = false;
	            _this.updateCaptureTime();
	            _this.ensureVideoBoothFields(_this.json.admin.videoBooth);
	            _this.rebuildSceneActiveFeatures();
	        }).catch(function (e) {
	            console.error(e);
	            _this.$state.go("configurations");
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(ConfigurationUpdateController, [{
	        key: "canExitWizard",
	        value: function canExitWizard() {
	            if (!this.canExitStartScreen()) {
	                this.wizardHandler.wizard().goTo("Start Screen");
	            } else if (!this.canExitScreen("singlePhoto", "photoBooth")) {
	                this.wizardHandler.wizard().goTo("Single Photo");
	            } else if (!this.canExitScreen("gif", "gifBooth")) {
	                this.wizardHandler.wizard().goTo("GIF");
	            } else if (!this.canExitScreen("boomerang", "boomerangBooth")) {
	                this.wizardHandler.wizard().goTo("Boomerang");
	            } else if (!this.canExitSharingScreen()) {
	                this.wizardHandler.wizard().goTo("Sharing Settings");
	            } else if (!this.canExitScenes()) {
	                this.wizardHandler.wizard().goTo("Scenes");
	            } else if (!this.canExitForms() && this.wizardHandler.wizard().currentStepTitle() !== "Forms") {
	                this.showErrorDialog("Error", "Enter all required inputs");
	                this.wizardHandler.wizard().goTo("Forms");
	            }
	        }
	    }, {
	        key: "onAreaChange",
	        value: function onAreaChange() {
	            this.json.admin.startScreenAreas.random = Math.random();
	            this.checkBackgroundResolution();
	        }
	    }, {
	        key: "$onInit",
	        value: function $onInit() {
	            this.canExitSinglePhoto = function () {
	                return true;
	            };
	            this.changeSinglePhotoLayoutRatio("singlePhoto");
	            this.changeSinglePhotoLayoutRatio("gif");
	            this.changeSinglePhotoLayoutRatio("boomerang");
	            if (this.isNew) {
	                this.setPhotosForPrint("singlePhoto");
	                this.setPhotosForPrint("gif");
	                this.setPhotosForPrint("boomerang");
	            }
	            this.activatePhotoStrips("gif");
	            this.activatePhotoStrips("boomerang");
	        }
	    }, {
	        key: "transformConfigToViewValue",
	        value: function transformConfigToViewValue() {
	            this.animatedIcons = this.json.admin.startScreenDefaultIcons;
	            var mainConfig = (0, _lodash.cloneDeep)(this.json.admin);
	
	            // Get single photos values
	            if (mainConfig.photoBooth.sharingFile || mainConfig.photoBooth.printFile) {
	                this.viewValue.singlePhoto.photoCaptureRatio = this.toViewValue.getPhotoCaptureRatio("photoBooth", mainConfig);
	                if (this.viewValue.singlePhoto.photoCaptureRatio === "custom") {
	                    this.viewValue.singlePhoto.customPhotoWidth = mainConfig.photoBooth.aspectRatio.width;
	                    this.viewValue.singlePhoto.customPhotoHeight = mainConfig.photoBooth.aspectRatio.height;
	                }
	                this.viewValue.singlePhoto.layoutAspectRatio = this.toViewValue.getPrintLayoutRatio("photoBooth", mainConfig);
	                this.viewValue.singlePhoto.printDpi = this.toViewValue.getPrintDpi("photoBooth", mainConfig);
	                // Pixels from format map (3mm bleed); replaces hardcoded 1240×1844, 2520×1890, etc.
	                var pSingle = (0, _printFormatsConstant.getPixelsForFormat)(this.viewValue.singlePhoto.layoutAspectRatio, this.viewValue.singlePhoto.printDpi);
	                this.viewValue.singlePhoto.printCanvasWidth = pSingle.width;
	                this.viewValue.singlePhoto.printCanvasHeight = pSingle.height;
	                this.viewValue.singlePhoto.strip = mainConfig.photoBooth.printFile.activePhotoStrip;
	                this.viewValue.singlePhoto.photosArr = this.toViewValue.getArrayOfPrintingPhotos("photoBooth", mainConfig);
	                this.viewValue.singlePhoto.strippedPhotosArr = this.toViewValue.getStrippedPhotos("photoBooth", mainConfig);
	                this.viewValue.singlePhoto.digitalFormat.layoutAspectRatio = this.toViewValue.getLayoutCaptureRatio("photoBooth", mainConfig);
	                this.viewValue.singlePhoto.digitalFormat.photos = this.toViewValue.getSharingPhoto("photoBooth", mainConfig);
	                if (this.viewValue.singlePhoto.digitalFormat.layoutAspectRatio === "custom") {
	                    if (this.json.admin.ai.faceSwap.active) {
	                        // this.viewValue.singlePhoto.digitalFormat.customPhotoWidth = this.toViewValue.detectAspectRatioObject(this.json.admin.general.width,this.json.admin.general.height).w;
	                        // this.viewValue.singlePhoto.digitalFormat.customPhotoHeight = this.toViewValue.detectAspectRatioObject(this.json.admin.general.width,this.json.admin.general.height).h;
	                        this.viewValue.singlePhoto.digitalFormat.customPhotoWidth = mainConfig.photoBooth.sharingFile.layoutAspectRatio.width;
	                        this.viewValue.singlePhoto.digitalFormat.customPhotoHeight = mainConfig.photoBooth.sharingFile.layoutAspectRatio.height;
	                    } else {
	                        this.viewValue.singlePhoto.digitalFormat.customPhotoWidth = mainConfig.photoBooth.sharingFile.layoutAspectRatio.width;
	                        this.viewValue.singlePhoto.digitalFormat.customPhotoHeight = mainConfig.photoBooth.sharingFile.layoutAspectRatio.height;
	                    }
	                }
	                this.viewValue.singlePhoto.digitalFormat.layoutWidth = mainConfig.photoBooth.sharingFile.finalSize.width;
	                this.viewValue.singlePhoto.digitalFormat.layoutHeight = mainConfig.photoBooth.sharingFile.finalSize.height;
	            } else {
	                this.viewValue.singlePhoto = (0, _lodash.cloneDeep)(this.storedConfig.singlePhoto);
	                this.changeSinglePhotoLayoutRatio("singlePhoto");
	                this.setPhotosForPrint("singlePhoto");
	            }
	
	            // Get gif values
	            if (mainConfig.gifBooth.sharingFile || mainConfig.gifBooth.printFile) {
	                this.viewValue.gif.photoCaptureRatio = this.toViewValue.getPhotoCaptureRatio("gifBooth", mainConfig);
	                if (this.viewValue.gif.photoCaptureRatio === "custom") {
	                    this.viewValue.gif.customPhotoWidth = mainConfig.gifBooth.aspectRatio.width;
	                    this.viewValue.gif.customPhotoHeight = mainConfig.gifBooth.aspectRatio.height;
	                }
	                this.viewValue.gif.layoutAspectRatio = this.toViewValue.getPrintLayoutRatio("gifBooth", mainConfig);
	                this.viewValue.gif.printDpi = this.toViewValue.getPrintDpi("gifBooth", mainConfig);
	                // Pixels from format map
	                var pGif = (0, _printFormatsConstant.getPixelsForFormat)(this.viewValue.gif.layoutAspectRatio, this.viewValue.gif.printDpi);
	                this.viewValue.gif.printCanvasWidth = pGif.width;
	                this.viewValue.gif.printCanvasHeight = pGif.height;
	                this.viewValue.gif.strip = mainConfig.gifBooth.printFile.activePhotoStrip;
	                this.viewValue.gif.photosArr = this.toViewValue.getArrayOfPrintingPhotos("gifBooth", mainConfig);
	                this.viewValue.gif.strippedPhotosArr = this.toViewValue.getStrippedPhotos("gifBooth", mainConfig);
	                this.viewValue.gif.digitalFormat.layoutAspectRatio = this.toViewValue.getLayoutCaptureRatio("gifBooth", mainConfig);
	                this.viewValue.gif.digitalFormat.photos = this.toViewValue.getSharingPhoto("gifBooth", mainConfig);
	                if (this.viewValue.gif.digitalFormat.layoutAspectRatio === "custom") {
	                    if (this.json.admin.ai.faceSwap.active) {
	                        // this.viewValue.gif.digitalFormat.customPhotoWidth = this.toViewValue.detectAspectRatioObject(this.json.admin.general.width,this.json.admin.general.height).w;
	                        // this.viewValue.gif.digitalFormat.customPhotoHeight = this.toViewValue.detectAspectRatioObject(this.json.admin.general.width,this.json.admin.general.height).h;
	                        this.viewValue.gif.digitalFormat.customPhotoWidth = mainConfig.gifBooth.sharingFile.layoutAspectRatio.width;
	                        this.viewValue.gif.digitalFormat.customPhotoHeight = mainConfig.gifBooth.sharingFile.layoutAspectRatio.height;
	                    } else {
	                        this.viewValue.gif.digitalFormat.customPhotoWidth = mainConfig.gifBooth.sharingFile.layoutAspectRatio.width;
	                        this.viewValue.gif.digitalFormat.customPhotoHeight = mainConfig.gifBooth.sharingFile.layoutAspectRatio.height;
	                    }
	                }
	                this.viewValue.gif.digitalFormat.layoutWidth = mainConfig.gifBooth.sharingFile.finalSize.width;
	                this.viewValue.gif.digitalFormat.layoutHeight = mainConfig.gifBooth.sharingFile.finalSize.height;
	            } else {
	                this.viewValue.gif = (0, _lodash.cloneDeep)(this.storedConfig.gif);
	                this.changeSinglePhotoLayoutRatio("gif");
	                this.setPhotosForPrint("gif");
	                this.activatePhotoStrips("gif");
	            }
	
	            // get boomerang values
	            if (mainConfig.boomerangBooth.sharingFile || mainConfig.boomerangBooth.printFile) {
	                this.viewValue.boomerang.photoCaptureRatio = this.toViewValue.getPhotoCaptureRatio("boomerangBooth", mainConfig);
	                if (this.viewValue.boomerang.photoCaptureRatio === "custom") {
	                    this.viewValue.boomerang.customPhotoWidth = mainConfig.boomerangBooth.aspectRatio.width;
	                    this.viewValue.boomerang.customPhotoHeight = mainConfig.boomerangBooth.aspectRatio.height;
	                }
	                this.viewValue.boomerang.layoutAspectRatio = this.toViewValue.getPrintLayoutRatio("boomerangBooth", mainConfig);
	                this.viewValue.boomerang.printDpi = this.toViewValue.getPrintDpi("boomerangBooth", mainConfig);
	                // Pixels from format map
	                var pBoom = (0, _printFormatsConstant.getPixelsForFormat)(this.viewValue.boomerang.layoutAspectRatio, this.viewValue.boomerang.printDpi);
	                this.viewValue.boomerang.printCanvasWidth = pBoom.width;
	                this.viewValue.boomerang.printCanvasHeight = pBoom.height;
	                this.viewValue.boomerang.strip = mainConfig.boomerangBooth.printFile.activePhotoStrip;
	                this.viewValue.boomerang.photosArr = this.toViewValue.getArrayOfPrintingPhotos("boomerangBooth", mainConfig);
	                this.viewValue.boomerang.strippedPhotosArr = this.toViewValue.getStrippedPhotos("boomerangBooth", mainConfig);
	                this.viewValue.boomerang.digitalFormat.layoutAspectRatio = this.toViewValue.getLayoutCaptureRatio("boomerangBooth", mainConfig);
	                this.viewValue.boomerang.digitalFormat.photos = this.toViewValue.getSharingPhoto("boomerangBooth", mainConfig);
	                if (this.viewValue.boomerang.digitalFormat.layoutAspectRatio === "custom") {
	                    if (this.json.admin.ai.faceSwap.active) {
	                        // this.viewValue.boomerang.digitalFormat.customPhotoWidth = this.toViewValue.detectAspectRatioObject(this.json.admin.general.width,this.json.admin.general.height).w;
	                        // this.viewValue.boomerang.digitalFormat.customPhotoHeight = this.toViewValue.detectAspectRatioObject(this.json.admin.general.width,this.json.admin.general.height).h;
	                        this.viewValue.boomerang.digitalFormat.customPhotoWidth = mainConfig.boomerangBooth.sharingFile.layoutAspectRatio.width;
	                        this.viewValue.boomerang.digitalFormat.customPhotoHeight = mainConfig.boomerangBooth.sharingFile.layoutAspectRatio.height;
	                    } else {
	                        this.viewValue.boomerang.digitalFormat.customPhotoWidth = mainConfig.boomerangBooth.sharingFile.layoutAspectRatio.width;
	                        this.viewValue.boomerang.digitalFormat.customPhotoHeight = mainConfig.boomerangBooth.sharingFile.layoutAspectRatio.height;
	                    }
	                }
	                this.viewValue.boomerang.digitalFormat.layoutWidth = mainConfig.boomerangBooth.sharingFile.finalSize.width;
	                this.viewValue.boomerang.digitalFormat.layoutHeight = mainConfig.boomerangBooth.sharingFile.finalSize.height;
	            } else {
	                this.viewValue.boomerang = (0, _lodash.cloneDeep)(this.storedConfig.boomerang);
	                this.changeSinglePhotoLayoutRatio("boomerang");
	                this.setPhotosForPrint("boomerang");
	                this.activatePhotoStrips("boomerang");
	            }
	
	            // get video values
	            if (!mainConfig.videoBooth) {
	                (0, _assign2.default)(mainConfig, {
	                    videoBooth: {
	                        enabled: true,
	                        allowSharing: true,
	                        enableChromakey: false,
	                        enableSoundRecording: false,
	                        countdownTime: 3,
	                        playbackSpeed: 1,
	                        captureTime: 1.5,
	                        resolutionOptions: "hd",
	                        sliderValue: 300
	                    }
	                });
	            }
	            this.ensureVideoBoothFields(mainConfig.videoBooth);
	
	            this.formsOneAnswer = !this.json.admin.offlineForms.isMultipleAnswers;
	
	            this.json.admin.startScreenAreas = this.toViewValue.getStartScreenValues(!this.json.admin.startScreenAreas ? this.toViewValue.getDefaultStartScreenAreas() : this.json.admin.startScreenAreas);
	
	            if (this.json && this.json.admin && this.json.admin.liveView && !this.json.admin.liveView.hasOwnProperty("customButtons")) {
	                (0, _assign2.default)(this.json.admin.liveView, {
	                    customButtons: {
	                        active: false,
	                        generalUiButtonsSettings: {
	                            back: { width: 4.5, height: 4.5, x: 8, y: 7 },
	                            sharingBackBtn: { width: 3.5, height: 3.5, x: 8, y: 7 },
	                            capture: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                            proceed: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                            email: { width: 5.5, height: 5.5, x: 16.5, y: 88 },
	                            sms: { width: 3.5, height: 3.5, x: 35, y: 88 },
	                            print: { width: 3.5, height: 3.5, x: 45, y: 88 },
	                            done: { width: 6, height: 6, x: 89, y: 92.5 },
	                            qrCode: { width: 7, height: 7, x: 50, y: 11, text: "Scan me to download", textSize: 12, textColor: "black" },
	                            close: { width: 3.5, height: 3.5, x: 5, y: 28 },
	                            next: { width: 5, height: 5, x: 93, y: 50 },
	                            closeError: { width: 5, height: 5, x: 93, y: 50 }
	                        },
	                        captureModeButtonsSettings: {
	                            single: { width: 3.5, height: 3.5, x: 8, y: 44 },
	                            gif: { width: 3.5, height: 3.5, x: 8, y: 49 },
	                            boomerang: { width: 3.5, height: 3.5, x: 8, y: 55 },
	                            scene: { scenePopupColor: "#FFF", width: 36, height: 48, x: 50, y: 57 },
	                            filter: { width: 5, height: 5, x: 8, y: 38 }
	                        }
	                    }
	                });
	            }
	            this.ensureCustomSceneScreenConfig();
	            this.ensureGeneralUiButtonsSettings();
	
	            this.json.admin.photoBooth.playbackSpeed = this.json.admin.photoBooth.playbackSpeed || 1;
	
	            this.json.admin.startScreenPreviewSize = this.json.admin.startScreenPreviewSize || { width: 1920, height: 1080 };
	
	            this.getBackgroundsFromOldConfigs("photoBooth", "sharingBackgroundFiles", "sharingBackground");
	            this.getBackgroundsFromOldConfigs("photoBooth", "printingBackgroundFiles", "printBackground");
	
	            if (!this.json.admin.photoBooth.startScreenDesignSharing) {
	                this.getBackgroundsFromOldConfigs("photoBooth", "sharingOverlayFiles", "sharingOverlay");
	            }
	
	            this.getBackgroundsFromOldConfigs("gifBooth", "sharingBackgroundFiles", "sharingBackground");
	            this.getBackgroundsFromOldConfigs("gifBooth", "printingBackgroundFiles", "printBackground");
	
	            if (!this.json.admin.gifBooth.startScreenDesignSharing) {
	                this.getBackgroundsFromOldConfigs("gifBooth", "sharingOverlayFiles", "sharingOverlay");
	            }
	
	            this.getBackgroundsFromOldConfigs("boomerangBooth", "sharingBackgroundFiles", "sharingBackground");
	            this.getBackgroundsFromOldConfigs("boomerangBooth", "printingBackgroundFiles", "printBackground");
	
	            if (!this.json.admin.boomerangBooth.startScreenDesignSharing) {
	                this.getBackgroundsFromOldConfigs("boomerangBooth", "sharingOverlayFiles", "sharingOverlay");
	            }
	
	            if (this.json.admin.showQRCode === undefined) {
	                this.json.admin.showQRCode = true;
	            }
	            this.ensureIndividualText();
	            this.ensureOfflineQrCode();
	
	            if (this.json.admin.isAdvanced === undefined) {
	                this.json.admin.startScreenBackgroundMode = this.json.admin.startScreenBackgroundMode || "color";
	                this.json.admin.startScreenBackgroundColor = this.json.admin.startScreenBackgroundColor || "#ffffff";
	                this.json.admin.startScreenImageStyle = this.json.admin.startScreenImageStyle || "stretch";
	                this.json.admin.startScreenLogo = this.json.admin.startScreenLogo || {
	                    enabled: true,
	                    file: {},
	                    position: 2,
	                    size: 30
	                };
	                this.json.admin.photoBooth.printingLogos = [{
	                    width: "75%",
	                    left: "12.5%",
	                    bottom: "6%",
	                    height: "15%"
	                }];
	                this.json.admin.gifBooth.printingLogos = [{
	                    bottom: "2.5%",
	                    height: "10%",
	                    width: "40%",
	                    left: "5%"
	                }, {
	                    bottom: "2.5%",
	                    height: "10%",
	                    width: "40%",
	                    right: "5%"
	                }];
	                this.json.admin.boomerangBooth.printingLogos = [{
	                    bottom: "2.5%",
	                    height: "10%",
	                    width: "40%",
	                    left: "5%"
	                }, {
	                    bottom: "2.5%",
	                    height: "10%",
	                    width: "40%",
	                    right: "5%"
	                }];
	            }
	            if (this.json.admin.startScreenLiveView === undefined) {
	                this.json.admin.startScreenLiveView = {
	                    enabled: false,
	                    backgroundOpacity: 50,
	                    iconsOpacity: 100
	                };
	            }
	
	            this.json.client.emailTextRow = this.json.client.emailTextRow || this.json.client.emailText;
	
	            this.checkDesignForAllModes();
	            this.json.admin.scenes = this.toViewValue.transformScenes(this.json.admin.scenes);
	            this.json.admin.ai.faceSwap.faceSwapScenes = this.toViewValue.transformScenes(this.json.admin.ai.faceSwap.faceSwapScenes, false, {
	                height: this.json.admin.general.height,
	                width: this.json.admin.general.width
	            });
	            (0, _assign2.default)(this.json.admin.ai.faceSwap.faceSwapScenes, {
	                layoutHeight: this.json.admin.general.height,
	                layoutWidth: this.json.admin.general.width
	            });
	
	            this.json.admin.ai.faceSwap.faceSwapOverlays = this.toViewValue.transformScenes(this.json.admin.ai.faceSwap.faceSwapOverlays, false, {
	                height: this.json.admin.general.height,
	                width: this.json.admin.general.width
	            });
	            (0, _assign2.default)(this.json.admin.ai.faceSwap.faceSwapOverlays, {
	                layoutHeight: this.json.admin.general.height,
	                layoutWidth: this.json.admin.general.width
	            });
	        }
	
	        // Old config check after implementing animated backgrounds and overlays
	
	    }, {
	        key: "getBackgroundsFromOldConfigs",
	        value: function getBackgroundsFromOldConfigs(config, arr, file) {
	            if (!config && !this.json.admin[config]) {
	                return;
	            }
	
	            if (this.json.admin[config][file] && this.json.admin[config][file].attachment_file && !this.json.admin[config][arr]) {
	                this.json.admin[config][arr] = [];
	                this.json.admin[config][arr].push(this.json.admin[config][file].attachment_file);
	            }
	        }
	    }, {
	        key: "getCanvasTitle",
	        value: function getCanvasTitle(value, type) {
	            if (this.json && this.json.admin && !this.json.admin.liveView) {
	                this.json.admin.liveView = this.toViewValue.getDefaultLiveViewData();
	            }
	            if (this.json && this.json.admin.liveView && this.json.admin.liveView.liveViewMode === "fullscreen" && type) {
	                return this.json.admin.general.screenOrientation === "portrait" && this.json.admin.liveView.liveViewMode === "fullscreen" ? "2:3" : this.json.admin.general.aspectRatio.width + ":" + this.json.admin.general.aspectRatio.height;
	            }
	
	            var config = type ? this.viewValue[value].digitalFormat : this.viewValue[value];
	            switch (config.layoutAspectRatio) {
	                case "landscape":
	                    return "3:2";
	                case "portrait":
	                    return "2:3";
	                case "landscape_4_3":
	                    return "4:3";
	                case "portrait_3_4":
	                    return "3:4";
	                case "square":
	                    return "1:1";
	                case "custom":
	                    return config.customPhotoWidth + ":" + config.customPhotoHeight;
	                default:
	                    // A1–A6, 10×15, 15×10, 15×20, 20×15
	                    return (0, _printFormatsConstant.getFormatShortLabel)(config.layoutAspectRatio) || "";
	            }
	        }
	    }, {
	        key: "getDigitalCanvasTitle",
	        value: function getDigitalCanvasTitle(value, type) {
	            if (this.json && this.json.admin && !this.json.admin.liveView) {
	                this.json.admin.liveView = this.toViewValue.getDefaultLiveViewData();
	            }
	            if (this.json && this.json.admin.liveView && this.json.admin.liveView.liveViewMode === "fullscreen" && type) {
	                return this.json.admin.general.screenOrientation === "portrait" && this.json.admin.liveView.liveViewMode === "fullscreen" && !this.json.admin.ai.faceSwap.active ? "2:3" : this.json.admin.general.aspectRatio.width + ":" + this.json.admin.general.aspectRatio.height;
	            }
	
	            var config = type ? this.viewValue[value].digitalFormat : this.viewValue[value];
	            switch (config.layoutAspectRatio) {
	                case "landscape":
	                    return "3:2";
	                case "portrait":
	                    return "2:3";
	                case "landscape_4_3":
	                    return "4:3";
	                case "portrait_3_4":
	                    return "3:4";
	                case "square":
	                    return "1:1";
	                case "custom":
	                    return config.customPhotoWidth + ":" + config.customPhotoHeight;
	            }
	        }
	    }, {
	        key: "checkOption",
	        value: function checkOption(value, mode) {
	            var config = this.json.admin[value];
	            if (mode === "printing" && !config.allowPrinting) {
	                config.allowSharePrintFile = false;
	            }
	            if (mode === "sharing" && this.json.admin.scenes.enabled) {
	                config.allowSharing = true;
	            }
	        }
	    }, {
	        key: "formBackground",
	        value: function formBackground(v) {
	            console.log(this.json.admin.offlineForms, v);
	        }
	    }, {
	        key: "isStepDisabled",
	        value: function isStepDisabled(value) {
	            return this.json && this.json.admin && this.json.admin[value] && this.json.admin[value].enabled ? "false" : "true";
	        }
	    }, {
	        key: "canExitScreen",
	        value: function canExitScreen(value, booth) {
	            var config = this.viewValue[value];
	            if (document.getElementsByClassName("red-border").length) {
	                return false;
	            }
	            // Check custom photo width
	            // if (config.photoCaptureRatio === "custom") {
	            //     Object.assign(config,{
	            //         customPhotoHeight: this.toViewValue.detectAspectRatioObject(config.customPhotoWidth,config.customPhotoHeight).h,
	            //         customPhotoWidth:this.toViewValue.detectAspectRatioObject(config.customPhotoWidth,config.customPhotoHeight).w});
	            // }
	            if (config.photoCaptureRatio === "custom" && (!config.customPhotoHeight || !config.customPhotoWidth)) {
	                return false;
	            }
	
	            // Check sharing area
	            if (this.json && this.json.admin && this.json.admin[booth] && this.json.admin[booth].allowSharing) {
	                // if (config.digitalFormat.layoutAspectRatio === "custom") {
	                //     Object.assign(config.digitalFormat,{customPhotoHeight: this.toViewValue.detectAspectRatioObject(config.digitalFormat.layoutWidth,config.digitalFormat.layoutHeight).h,customPhotoWidth:this.toViewValue.detectAspectRatioObject(config.digitalFormat.layoutWidth,config.digitalFormat.layoutHeight).w});
	                // }
	                if (config.digitalFormat.layoutAspectRatio === "custom" && (!config.digitalFormat.customPhotoHeight || !config.digitalFormat.customPhotoWidth)) {
	                    return false;
	                }
	
	                var valid = true;
	                (0, _lodash.forEach)(config.digitalFormat.photos, function (ph) {
	                    if (!ph.width && ph.width !== 0 || !ph.height && ph.height !== 0 || !ph.y && ph.y !== 0 || !ph.x && ph.x !== 0 || !ph.angle && ph.angle !== 0) {
	                        valid = false;
	                    }
	                });
	
	                if (!valid) return false;
	            }
	
	            // Check printing photos
	            if (this.json && this.json.admin && this.json.admin[booth] && this.json.admin[booth].allowPrinting) {
	                var _valid = true;
	                (0, _lodash.forEach)(config.photosArr, function (ph) {
	                    if (!ph.width && ph.width !== 0 || !ph.height && ph.height !== 0 || !ph.y && ph.y !== 0 || !ph.x && ph.x !== 0 || !ph.angle && ph.angle !== 0) {
	                        _valid = false;
	                    }
	                });
	                if (!_valid) return false;
	
	                // Check stripped photos
	                if (config.strip) {
	                    var _valid2 = true;
	                    (0, _lodash.forEach)(config.strippedPhotosArr, function (ph) {
	                        if (!ph.width && ph.width !== 0 || !ph.height && ph.height !== 0 || !ph.y && ph.y !== 0 || !ph.x && ph.x !== 0 || !ph.angle && ph.angle !== 0) {
	                            _valid2 = false;
	                        }
	                    });
	                    if (!_valid2) return false;
	                }
	            }
	            return true;
	        }
	    }, {
	        key: "canExitSharingScreen",
	        value: function canExitSharingScreen() {
	            var val = this.json && this.json.admin ? this.json.admin : null;
	            if (!val || !val.outputSettings) {
	                return true;
	            }
	            if (val.offlineQrCode && val.offlineQrCode.enabled && !this.isOfflineQrLayoutValid(val.offlineQrCode)) {
	                return false;
	            }
	
	            // Allow exit when all sharing methods are disabled (email, SMS, QR)
	            if (!val.outputSettings.enableEmailSharing && !val.outputSettings.enableSmsSharing && !val.showQRCode) {
	                return true;
	            }
	
	            // Check for showQRCode: if active, ignore email and SMS verification
	            if (val.showQRCode) {
	                // We only check disclaimers and the form, if any.
	                if (this.json.client.emailDisclaimer && this.json.client.emailDisclaimerText === undefined || this.json.client.smsDisclaimer && this.json.client.smsDisclaimerText === undefined) {
	                    return false;
	                }
	                if (this.formSharing && this.formSharing.$invalid) {
	                    return false;
	                }
	                return true;
	            }
	
	            // If showQRCode is not active, we perform the old verification via email and SMS
	            if (!val.outputSettings.enableEmailSharing && !val.outputSettings.enableSmsSharing) {
	                if (val.photoBooth && val.photoBooth.enabled && val.photoBooth.allowSharing || val.gifBooth && val.gifBooth.enabled && val.gifBooth.allowSharing || val.boomerangBooth && val.boomerangBooth.enabled && val.boomerangBooth.allowSharing || val.videoBooth && val.videoBooth.enabled && val.videoBooth.allowSharing) {
	                    return false;
	                } else {
	                    return true;
	                }
	            }
	
	            if (this.json.client.emailDisclaimer && this.json.client.emailDisclaimerText === undefined || this.json.client.smsDisclaimer && this.json.client.smsDisclaimerText === undefined) {
	                return false;
	            }
	
	            if (this.formSharing && this.formSharing.$invalid) {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: "canExitForms",
	        value: function canExitForms() {
	            if (!this.json) {
	                return true;
	            }
	            if (this.json.admin.offlineForms && this.json.admin.offlineForms.enabled && this.formOfflineForms) {
	                return this.formOfflineForms && this.formOfflineForms.$valid;
	            } else {
	                return true;
	            }
	        }
	    }, {
	        key: "onOrientationChange",
	        value: function onOrientationChange() {
	            var width = void 0,
	                height = void 0;
	
	            width = this.json.admin.general.width;
	            height = this.json.admin.general.height;
	
	            this.json.admin.general.width = height;
	            this.json.admin.general.height = width;
	            if (this.json.admin.liveView.liveViewMode === "fullscreen") {
	                if (this.json.admin.general.screenOrientation === "portrait" && !this.json.admin.scenes.enabled) {
	                    this.viewValue.singlePhoto.digitalFormat.layoutAspectRatio = "portrait";
	                    this.json.admin.scenes.sceneLayoutAspectRatio = "portrait";
	                    this.json.admin.scenes.customLayoutHeight = null;
	                    this.json.admin.scenes.customLayoutWidth = null;
	                    this.json.admin.scenes.layoutWidth = this.json.admin.general.width;
	                    this.json.admin.scenes.layoutHeight = this.json.admin.general.height;
	                    this.json.admin.scenes.photoAspectRatio = "portrait";
	                    this.json.admin.scenes.customPhotoHeight = null;
	                    this.json.admin.scenes.customLayoutWidth = null;
	                    this.json.admin.scenes.photos = [{
	                        width: 333,
	                        height: 500,
	                        x: 0,
	                        y: 0,
	                        angle: 0,
	                        image: true
	                    }];
	                    this.json.admin.ai.faceSwap.faceSwapScenes.sceneLayoutAspectRatio = "portrait";
	                    this.json.admin.ai.faceSwap.faceSwapScenes.customLayoutHeight = null;
	                    this.json.admin.ai.faceSwap.faceSwapScenes.customLayoutWidth = null;
	                    this.json.admin.ai.faceSwap.faceSwapScenes.layoutWidth = this.json.admin.general.width;
	                    this.json.admin.ai.faceSwap.faceSwapScenes.layoutHeight = this.json.admin.general.height;
	                    this.json.admin.ai.faceSwap.faceSwapScenes.photoAspectRatio = "portrait";
	                    this.json.admin.ai.faceSwap.faceSwapScenes.customPhotoHeight = null;
	                    this.json.admin.ai.faceSwap.faceSwapScenes.customLayoutWidth = null;
	                    this.json.admin.ai.faceSwap.faceSwapScenes.enable_animated_bg_files = false;
	                    this.json.admin.ai.faceSwap.faceSwapScenes.photos = [{
	                        width: 333,
	                        height: 500,
	                        x: 0,
	                        y: 0,
	                        angle: 0,
	                        image: true
	                    }];
	
	                    this.json.admin.ai.faceSwap.faceSwapOverlays.sceneLayoutAspectRatio = "portrait";
	                    this.json.admin.ai.faceSwap.faceSwapOverlays.customLayoutHeight = null;
	                    this.json.admin.ai.faceSwap.faceSwapOverlays.customLayoutWidth = null;
	                    this.json.admin.ai.faceSwap.faceSwapOverlays.layoutWidth = this.json.admin.general.width;
	                    this.json.admin.ai.faceSwap.faceSwapOverlays.layoutHeight = this.json.admin.general.height;
	                    this.json.admin.ai.faceSwap.faceSwapOverlays.photoAspectRatio = "portrait";
	                    this.json.admin.ai.faceSwap.faceSwapOverlays.customPhotoHeight = null;
	                    this.json.admin.ai.faceSwap.faceSwapOverlays.customLayoutWidth = null;
	                    this.json.admin.ai.faceSwap.faceSwapOverlays.enable_animated_bg_files = false;
	                    this.json.admin.ai.faceSwap.faceSwapOverlays.photos = [{
	                        width: 333,
	                        height: 500,
	                        x: 0,
	                        y: 0,
	                        angle: 0,
	                        image: true
	                    }];
	
	                    this.json.admin.general.aspectRatio = { width: 2, height: 3 };
	                }
	            }
	            this.updateViewMode();
	        }
	    }, {
	        key: "updateViewMode",
	        value: function updateViewMode() {
	            if (this.json.admin.liveView.liveViewMode === "fullscreen") {
	
	                this.json.admin.scenes.layoutWidth = this.json.admin.general.width;
	                this.json.admin.scenes.layoutHeight = this.json.admin.general.height;
	                if (this.json.admin.general.screenOrientation === "portrait" && !this.json.admin.scenes.enabled) {
	                    this.viewValue.singlePhoto.digitalFormat.layoutAspectRatio = "portrait";
	                    this.json.admin.scenes.sceneLayoutAspectRatio = "portrait";
	                    this.json.admin.scenes.customLayoutHeight = null;
	                    this.json.admin.scenes.customLayoutWidth = null;
	                    // this.json.admin.scenes.layoutHeight = 500;
	                    // this.json.admin.scenes.layoutWidth = 333;
	                    this.json.admin.scenes.photoAspectRatio = "portrait";
	                    this.json.admin.scenes.customPhotoHeight = null;
	                    this.json.admin.scenes.customLayoutWidth = null;
	                    this.json.admin.scenes.photos = [{
	                        width: 333,
	                        height: 500,
	                        x: 0,
	                        y: 0,
	                        angle: 0,
	                        image: true
	                    }];
	                    this.json.admin.general.aspectRatio = { width: 2, height: 3 };
	                } else {
	                    this.json.admin.scenes.sceneLayoutAspectRatio = "custom";
	                    this.viewValue.singlePhoto.digitalFormat.layoutAspectRatio = "custom";
	                    this.json.admin.scenes.photoAspectRatio = "custom";
	                    this.json.admin.scenes.sceneLayoutAspectRatio = "custom";
	                    this.json.admin.scenes.photos = [{
	                        width: this.json.admin.general.width,
	                        height: this.json.admin.general.height,
	                        x: 0,
	                        y: 0,
	                        angle: 0,
	                        image: true
	                    }];
	                    this.json.admin.general.aspectRatio = this.toBoothValue.transformPhotoAspectRatio("singlePhoto", this.viewValue);
	
	                    this.json.admin.scenes.customLayoutWidth = this.json.admin.general.aspectRatio.width;
	                    this.json.admin.scenes.customLayoutHeight = this.json.admin.general.aspectRatio.height;
	                }
	                this.changeScenes();
	            } else {
	                this.changePhotosAspectRatio("singlePhoto");
	                this.changePhotosAspectRatio("gif");
	                this.changePhotosAspectRatio("boomerang");
	            }
	            this.saveDataInConfig();
	        }
	    }, {
	        key: "resetStep",
	        value: function resetStep(params) {
	            var _this2 = this;
	
	            var dpi = 300;
	            var confirm = this.$mdDialog.confirm().title("Are you sure you want to reset to the default settings?").textContent("Resetting will delete all the work you've done so far").ariaLabel("Confirm").ok("RESET").cancel("Cancel");
	            this.$mdDialog.show(confirm).then(function () {
	                switch (params) {
	                    case "standby":
	                        _this2.json.admin.standbyScreen = false;
	                        _this2.json.admin.standbyScreenActivateTime = 30;
	                        _this2.json.admin.standbyScreenImage = null;
	                        break;
	                    case "start-screen":
	                        _this2.json.admin.photoBooth.enabled = true;
	                        _this2.json.admin.disablePostFilters = true;
	                        _this2.json.admin.gifBooth.enabled = true;
	                        _this2.json.admin.filtersNamesShow = false;
	                        _this2.json.admin.boomerangBooth.enabled = true;
	                        _this2.json.admin.videoBooth.enabled = false;
	                        _this2.json.admin.startScreenAreas.single = { width: 40, height: 40, x: 25, y: 60 };
	                        _this2.json.admin.startScreenAreas.gif = { width: 40, height: 40, x: 50, y: 60 };
	                        _this2.json.admin.startScreenAreas.boomerang = { width: 40, height: 40, x: 75, y: 60 };
	                        _this2.json.admin.startScreenAreas.video = { width: 40, height: 40, x: 95, y: 60 };
	                        _this2.json.admin.startScreenAreas.random = Math.random();
	                        _this2.json.admin.startScreenDefaultIcons = false;
	                        _this2.json.admin.startScreenBackground = null;
	                        _this2.json.admin.startScreenReturnTime = 90;
	                        _this2.json.admin.cameraPresetName = "Default";
	                        _this2.json.admin.startScreenPreviewSize = {
	                            width: 1920,
	                            height: 1080
	                        };
	                        _this2.animatedIcons = false;
	                        _this2.json.admin.startScreenLiveView = {
	                            enabled: false,
	                            backgroundOpacity: 50,
	                            iconsOpacity: 100
	                        };
	                        _this2.json.admin.startScreenBackgroundMode = "color";
	                        _this2.json.admin.startScreenBackgroundColor = "#ffffff";
	                        _this2.json.admin.startScreenImageStyle = "stretch";
	                        _this2.json.admin.startScreenLogo = {
	                            enabled: true,
	                            file: {},
	                            position: 2,
	                            size: 30
	                        };
	                        _this2.json.admin.disableSceneAfterCapture = false;
	                        break;
	                    case "ai":
	                        _this2.json.admin.ai = {
	                            customLogo: {
	                                active: false,
	                                customLogoFile: null
	                            },
	                            replicate: {
	                                replicate_remove_bg_active: false,
	                                replicate_api_key: "",
	                                replicate_prompting_active: false,
	                                replicate_prompt_quality: REPLICATE_PROMPT_DEFAULT_QUALITY,
	                                replicate_model: REPLICATE_PROMPT_MODELS[REPLICATE_PROMPT_DEFAULT_QUALITY]
	                            },
	                            wandershareApi: {
	                                active: false,
	                                aging_active: false,
	                                aging_api_key: "",
	                                aging_api_secret: "",
	                                aging_age_slider_allowed: false,
	                                aging_fixed_age: 0,
	                                aging_priority: 0
	                            },
	                            faceSwap: {
	                                active: false,
	                                face_swap_active: false,
	                                face_swap_api_key: "",
	                                face_swap_multi_active: false,
	                                scenesNamesShow: false,
	                                scenesBtnTitleShow: false,
	                                sceneBtnTitle: "",
	                                faceSwapScenes: {
	                                    enabled: false,
	                                    enable_animated_bg_files: false,
	                                    randomizeSceneSelection: false,
	                                    finalSize: {
	                                        width: 333,
	                                        height: 500
	                                    },
	                                    internalPictureSize: {
	                                        width: 333,
	                                        height: 500
	                                    },
	                                    layoutAspectRatio: {
	                                        width: null,
	                                        height: null
	                                    },
	                                    pictureAspectRatio: {
	                                        width: null,
	                                        height: null
	                                    },
	                                    internalPicturePosition: {
	                                        topX: 0,
	                                        topY: 0
	                                    },
	                                    internalPictureRotation: 0,
	                                    scenesList: [],
	                                    scenesNamesShow: false,
	                                    opacity: 50,
	                                    scenesBtnTitleShow: false,
	                                    sceneBtnTitle: ""
	                                },
	                                faceSwapOverlays: {
	                                    enabled: false,
	                                    enable_animated_bg_files: false,
	                                    randomizeSceneSelection: false,
	                                    finalSize: {
	                                        width: 333,
	                                        height: 500
	                                    },
	                                    internalPictureSize: {
	                                        width: 333,
	                                        height: 500
	                                    },
	                                    layoutAspectRatio: {
	                                        width: null,
	                                        height: null
	                                    },
	                                    pictureAspectRatio: {
	                                        width: null,
	                                        height: null
	                                    },
	                                    internalPicturePosition: {
	                                        topX: 0,
	                                        topY: 0
	                                    },
	                                    internalPictureRotation: 0,
	                                    scenesList: [],
	                                    scenesNamesShow: false,
	                                    opacity: 50,
	                                    scenesBtnTitleShow: false,
	                                    sceneBtnTitle: ""
	                                }
	                            }
	                        };
	                        _this2.json.admin.ai.faceSwap.faceSwapScenes.photos = [{
	                            width: 1920,
	                            height: 1080,
	                            x: 0,
	                            y: 0,
	                            angle: 0,
	                            image: true
	                        }];
	                        _this2.json.admin.ai.faceSwap.faceSwapOverlays.photos = [{
	                            width: 1920,
	                            height: 1080,
	                            x: 0,
	                            y: 0,
	                            angle: 0,
	                            image: true
	                        }];
	                        // Reset removeBg
	                        _this2.json.admin.removeBg = { active: false };
	                        _this2.setRemoveBgData({ active: false });
	                        // Reset replicate
	                        _this2.json.admin.ai.replicate = {
	                            replicate_remove_bg_active: false,
	                            replicate_api_key: "",
	                            replicate_prompting_active: false,
	                            replicate_prompt_quality: REPLICATE_PROMPT_DEFAULT_QUALITY,
	                            replicate_model: REPLICATE_PROMPT_MODELS[REPLICATE_PROMPT_DEFAULT_QUALITY]
	                        };
	                        _this2.setReplicateData({ replicate_remove_bg_active: false });
	                        // Reset remaker
	                        _this2.json.admin.ai.remaker = { remaker_remove_bg_active: false, remaker_api_key: "" };
	                        _this2.setRemakerData({ remaker_remove_bg_active: false });
	                        // Reset removeBgOffline
	                        if (_this2.json.admin.removeBgOffline) {
	                            _this2.json.admin.removeBgOffline.remove_bg_offline_active = false;
	                            _this2.setLocalRemoveBgState({ remove_bg_offline_active: false });
	                        }
	                        // Reset unscreen
	                        if (_this2.json.admin.unscreen) {
	                            _this2.json.admin.unscreen.us_active = false;
	                            _this2.setUnscreenData({ us_active: false });
	                        }
	                        break;
	                    case "live-view":
	                        _this2.json.admin.liveView = {
	                            enabled: true,
	                            forAllScenes: true,
	                            liveViewMode: "regular",
	                            liveViewPreviewSize: {
	                                width: 1920,
	                                height: 1080
	                            },
	                            liveViewBackgroundMode: "color",
	                            liveViewBackgroundColor: "#ffffff",
	                            liveViewBackground: "",
	                            filter: {
	                                enabled: true,
	                                liveViewBackgroundMode: "color",
	                                liveViewBackgroundColor: "#ffffff",
	                                liveViewBackground: ""
	                            },
	                            output: {
	                                enabled: true,
	                                liveViewBackgroundMode: "color",
	                                liveViewBackgroundColor: "#ffffff",
	                                liveViewBackground: ""
	                            },
	                            shouldOutputPhotoMirrored: true,
	                            hideOutputPictureVideo: false,
	                            hideSharingOptions: false,
	                            customButtons: {
	                                active: false,
	                                generalUiButtonsSettings: {
	                                    back: { width: 4.5, height: 4.5, x: 8, y: 7 },
	                                    sharingBackBtn: { width: 3.5, height: 3.5, x: 8, y: 7 },
	                                    capture: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                                    proceed: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                                    email: { width: 5.5, height: 5.5, x: 16.5, y: 88 },
	                                    sms: { width: 3.5, height: 3.5, x: 35, y: 88 },
	                                    print: { width: 3.5, height: 3.5, x: 45, y: 88 },
	                                    done: { width: 6, height: 6, x: 89, y: 92.5 },
	                                    qrCode: { width: 7, height: 7, x: 50, y: 11, text: "Scan me to download", textSize: 12, textColor: "black" },
	                                    close: { width: 3.5, height: 3.5, x: 5, y: 28 },
	                                    next: { width: 5, height: 5, x: 93, y: 50 },
	                                    closeError: { width: 5, height: 5, x: 93, y: 50 }
	                                },
	                                captureModeButtonsSettings: {
	                                    single: { width: 3.5, height: 3.5, x: 8, y: 44 },
	                                    gif: { width: 3.5, height: 3.5, x: 8, y: 49 },
	                                    boomerang: { width: 3.5, height: 3.5, x: 8, y: 55 },
	                                    scene: { scenePopupColor: "#FFF", width: 36, height: 48, x: 50, y: 57 },
	                                    filter: { width: 5, height: 5, x: 8, y: 38 }
	                                }
	                            },
	                            customSceneScreen: {
	                                enabled: false,
	                                numberOfScenes: 1,
	                                background: {},
	                                touchpoints: []
	                            }
	                        };
	                        break;
	                    case "scenes":
	                        _this2.json.admin.scenes.enabled = false;
	                        _this2.json.admin.scenes.scenesNamesShow = false;
	                        _this2.json.admin.scenes.randomizeSceneSelection = false;
	                        _this2.json.admin.scenes.sceneLayoutAspectRatio = "custom";
	                        _this2.json.admin.scenes.customLayoutHeight = null;
	                        _this2.json.admin.scenes.customLayoutWidth = null;
	                        _this2.json.admin.scenes.layoutHeight = 1080;
	                        _this2.json.admin.scenes.layoutWidth = 1920;
	                        _this2.json.admin.scenes.photoAspectRatio = "custom";
	                        _this2.json.admin.scenes.customPhotoHeight = null;
	                        _this2.json.admin.scenes.customLayoutWidth = null;
	                        _this2.json.admin.scenes.photos = [{
	                            width: 1920,
	                            height: 1080,
	                            x: 0,
	                            y: 0,
	                            angle: 0,
	                            image: true
	                        }];
	                        _this2.json.admin.scenes.opacity = 50;
	                        _this2.json.admin.scenes.scenesBtnTitleShow = false;
	                        _this2.json.admin.scenes.sceneBtnTitle = "";
	                        delete _this2.json.admin.scenes.scenesList;
	                        _this2.json.admin.scenes.scenesList = [];
	
	                        _this2.json.admin.photoBooth.sharingBackgroundFiles = [];
	                        _this2.json.admin.photoBooth.sharingOverlayFiles = [];
	
	                        _this2.json.admin.gifBooth.sharingBackgroundFiles = [];
	                        _this2.json.admin.gifBooth.sharingOverlayFiles = [];
	
	                        _this2.json.admin.boomerangBooth.sharingBackgroundFiles = [];
	                        _this2.json.admin.boomerangBooth.sharingOverlayFiles = [];
	
	                        _this2.json.admin.photoBooth.savedData.sharingBackgroundFiles = [];
	                        _this2.json.admin.photoBooth.savedData.sharingOverlayFiles = [];
	
	                        _this2.json.admin.gifBooth.savedData.sharingBackgroundFiles = [];
	                        _this2.json.admin.gifBooth.savedData.sharingOverlayFiles = [];
	
	                        _this2.json.admin.boomerangBooth.savedData.sharingBackgroundFiles = [];
	                        _this2.json.admin.boomerangBooth.savedData.sharingOverlayFiles = [];
	
	                        break;
	                    case "single-photo":
	                        _this2.viewValue.singlePhoto = {
	                            photoCaptureRatio: "custom",
	                            customPhotoWidth: null,
	                            customPhotoHeight: null,
	                            layoutAspectRatio: "portrait",
	                            printCanvasWidth: 6 * dpi + 40,
	                            printCanvasHeight: 4 * dpi + 44,
	                            strip: false,
	                            photosArr: [],
	                            strippedPhotosArr: [],
	                            digitalFormat: {
	                                layoutAspectRatio: "custom",
	                                photos: [{}],
	                                customPhotoWidth: null,
	                                customPhotoHeight: null,
	                                layoutHeight: 500,
	                                layoutWidth: 500
	                            }
	                        };
	                        _this2.changeSinglePhotoLayoutRatio("singlePhoto");
	                        _this2.setPhotosForPrint("singlePhoto");
	                        _this2.json.admin.photoBooth.allowSharing = true;
	                        _this2.json.admin.photoBooth.allowSharePrintFile = true;
	                        _this2.json.admin.photoBooth.allowPrinting = true;
	                        _this2.json.admin.photoBooth.printWithoutScenes = false;
	                        _this2.json.admin.photoBooth.showPrinterBleeds = false;
	                        _this2.json.admin.photoBooth.printingBackgroundFiles = [];
	                        _this2.json.admin.photoBooth.printingOverlayFiles = [];
	                        _this2.json.admin.photoBooth.sharingBackgroundFiles = [];
	                        _this2.json.admin.photoBooth.savedData.sharingBackgroundFiles = [];
	                        _this2.json.admin.photoBooth.savedData.sharingOverlayFiles = [];
	                        _this2.json.admin.photoBooth.sharingBackgroundFilesValidRatio = null;
	                        _this2.json.admin.photoBooth.sharingOverlayFiles = [];
	                        _this2.json.admin.photoBooth.sharingOverlayFilesValidRatio = null;
	                        _this2.json.admin.photoBooth.countdownTime = 5;
	                        _this2.json.admin.photoBooth.playbackSpeed = 1.5;
	
	                        _this2.json.admin.photoBooth.startScreenDesignSharing = !(_this2.$auth.isRole("Admin") || _this2.$auth.isRole("Manager"));
	                        _this2.json.admin.photoBooth.showLiveViewOverlays = true;
	                        _this2.json.admin.photoBooth.shouldOutputPhotoMirrored = true;
	                        _this2.checkStartScreenDesign("photoBooth");
	                        _this2.json.admin.photoBooth.printingLogos = [{
	                            width: "75%",
	                            left: "12.5%",
	                            bottom: "6%",
	                            height: "15%"
	                        }];
	                        break;
	                    case "gif":
	                        _this2.viewValue.gif = (0, _lodash.cloneDeep)(_this2.storedConfig.gif);
	                        _this2.viewValue.gif.strip = true;
	                        _this2.changeSinglePhotoLayoutRatio("gif");
	                        _this2.setPhotosForPrint("gif");
	                        _this2.activatePhotoStrips("gif");
	                        _this2.json.admin.gifBooth.allowSharing = true;
	                        _this2.json.admin.gifBooth.allowSharePrintFile = true;
	                        _this2.json.admin.gifBooth.allowPrinting = true;
	                        _this2.json.admin.gifBooth.printWithoutScenes = false;
	                        _this2.json.admin.gifBooth.showPrinterBleeds = false;
	                        _this2.json.admin.gifBooth.printingBackgroundFiles = [];
	                        _this2.json.admin.gifBooth.printingOverlayFiles = [];
	                        _this2.json.admin.gifBooth.sharingBackgroundFiles = [];
	                        _this2.json.admin.gifBooth.savedData.sharingBackgroundFiles = [];
	                        _this2.json.admin.gifBooth.savedData.sharingOverlayFiles = [];
	                        _this2.json.admin.gifBooth.sharingBackgroundFilesValidRatio = null;
	                        _this2.json.admin.gifBooth.sharingOverlayFiles = [];
	                        _this2.json.admin.gifBooth.sharingOverlayFilesValidRatio = null;
	                        _this2.json.admin.gifBooth.countdownTime = 5;
	                        _this2.json.admin.gifBooth.playbackSpeed = 1.5;
	
	                        _this2.json.admin.gifBooth.startScreenDesignSharing = !(_this2.$auth.isRole("Admin") || _this2.$auth.isRole("Manager"));
	                        _this2.json.admin.gifBooth.showLiveViewOverlays = true;
	                        _this2.json.admin.gifBooth.shouldOutputPhotoMirrored = true;
	                        _this2.checkStartScreenDesign("gifBooth");
	                        _this2.json.admin.gifBooth.printingLogos = [{
	                            bottom: "2.5%",
	                            height: "10%",
	                            width: "40%",
	                            left: "5%"
	                        }, {
	                            bottom: "2.5%",
	                            height: "10%",
	                            width: "40%",
	                            right: "5%"
	                        }];
	                        break;
	                    case "boomerang":
	                        _this2.viewValue.boomerang = (0, _lodash.cloneDeep)(_this2.storedConfig.boomerang);
	                        _this2.viewValue.boomerang.strip = true;
	                        _this2.changeSinglePhotoLayoutRatio("boomerang");
	                        _this2.setPhotosForPrint("boomerang");
	                        _this2.activatePhotoStrips("boomerang");
	                        _this2.json.admin.boomerangBooth.allowSharing = true;
	                        _this2.json.admin.boomerangBooth.allowSharePrintFile = true;
	                        _this2.json.admin.boomerangBooth.allowPrinting = true;
	                        _this2.json.admin.boomerangBooth.printWithoutScenes = false;
	                        _this2.json.admin.boomerangBooth.showPrinterBleeds = false;
	                        _this2.json.admin.boomerangBooth.printingBackgroundFiles = [];
	                        _this2.json.admin.boomerangBooth.printingOverlayFiles = [];
	                        _this2.json.admin.boomerangBooth.sharingBackgroundFiles = [];
	                        _this2.json.admin.boomerangBooth.savedData.sharingBackgroundFiles = [];
	                        _this2.json.admin.boomerangBooth.savedData.sharingOverlayFiles = [];
	                        _this2.json.admin.boomerangBooth.sharingBackgroundFilesValidRatio = null;
	                        _this2.json.admin.boomerangBooth.sharingOverlayFiles = [];
	                        _this2.json.admin.boomerangBooth.sharingOverlayFilesValidRatio = null;
	                        _this2.json.admin.boomerangBooth.countdownTime = 5;
	                        _this2.json.admin.boomerangBooth.playbackSpeed = 1.5;
	                        _this2.json.admin.boomerangBooth.captureTime = 1.5;
	
	                        _this2.json.admin.boomerangBooth.startScreenDesignSharing = !(_this2.$auth.isRole("Admin") || _this2.$auth.isRole("Manager"));
	                        _this2.json.admin.boomerangBooth.showLiveViewOverlays = true;
	                        _this2.json.admin.boomerangBooth.shouldOutputPhotoMirrored = true;
	                        _this2.checkStartScreenDesign("boomerangBooth");
	                        _this2.json.admin.boomerangBooth.printingLogos = [{
	                            bottom: "2.5%",
	                            height: "10%",
	                            width: "40%",
	                            left: "5%"
	                        }, {
	                            bottom: "2.5%",
	                            height: "10%",
	                            width: "40%",
	                            right: "5%"
	                        }];
	                        break;
	                    case "video":
	                        _this2.viewValue.video = (0, _lodash.cloneDeep)(_this2.storedConfig.video);
	                        _this2.json.admin.videoBooth.allowSharing = true;
	                        _this2.json.admin.videoBooth.countdownTime = 5;
	                        _this2.json.admin.videoBooth.playbackSpeed = 1;
	                        _this2.json.admin.videoBooth.captureTime = 1.5;
	                        _this2.json.admin.videoBooth.sliderValue = 300;
	                        _this2.json.admin.videoBooth.shouldOutputPhotoMirrored = true;
	                        _this2.json.admin.videoBooth.enableChromakey = false;
	                        _this2.json.admin.videoBooth.enableSoundRecording = false;
	                        _this2.clearVideoChromakeyFromScenes();
	                        break;
	                    case "sharing":
	                        _this2.json.client = {
	                            emailSender: "photos@upreach.com",
	                            advancedHtmlInput: false,
	                            emailText: "",
	                            emailTextRow: "",
	                            emailTemplate: "English",
	                            emailSubject: "Your UpReach photo",
	                            allowEmailAttachments: true,
	                            emailDisclaimer: false,
	                            emailDisclaimerRequire: false,
	                            emailDisclaimerText: "",
	                            emailTitle: "Hey, nice snap!",
	                            emailTextNoHtml: "Here you are, please find attached your awesome UpReach photo. Thank you so much for visiting us!\n Scroll down to download & share your image.",
	                            smsText: "Hey, nice snap!\nVisit the live gallery to download & share your UpReach photo: ",
	                            smsDisclaimer: false,
	                            smsDisclaimerRequire: false, //Add this as toggle
	                            smsDisclaimerText: ""
	
	                        };
	                        _this2.json.admin.maxCountOfPrintCopies = 5;
	                        _this2.json.admin.enableAutoPrint = false;
	                        _this2.json.admin.autoPrintCopies = 1;
	                        _this2.json.admin.outputSettings = {
	                            enableEmailSharing: true,
	                            enableSmsSharing: false
	                        };
	                        _this2.json.admin.showQRCode = true;
	                        _this2.json.admin.offlineQrCode = _this2.getDefaultOfflineQrCode();
	                        _this2.json.client.emailTextRow = _this2.emailTemplates.getTemplate("english", _this2.json.client.emailTitle, _this2.json.client.emailTextNoHtml);
	                        break;
	                    case "individual-text":
	                        _this2.json.admin.individualText = (0, _individualText.getDefaultIndividualText)();
	                        break;
	                    case "forms":
	                        _this2.json.admin.offlineForms.whenOfflineForm = [{
	                            "value": "beforePhoto",
	                            "label": "before taking photo"
	                        }, {
	                            "value": "afterPhoto",
	                            "label": "after taking photo"
	                        }, {
	                            "value": "optional",
	                            "label": "optional"
	                        }];
	                        _this2.json.admin.offlineForms.formInputs = [{
	                            required: true,
	                            active: true,
	                            title: "Name"
	                        }, {
	                            required: false,
	                            active: true,
	                            title: "E-Mail"
	                        }, {
	                            required: true,
	                            active: true,
	                            title: "Phone Number"
	                        }];
	
	                        _this2.json.admin.offlineForms.customInputs = [{
	                            required: false,
	                            active: false,
	                            title: "",
	                            inputMode: "text",
	                            choices: [{ text: "" }]
	                        }, {
	                            required: false,
	                            active: false,
	                            title: "",
	                            inputMode: "text",
	                            choices: [{ text: "" }]
	                        }, {
	                            required: false,
	                            active: false,
	                            title: "",
	                            inputMode: "text",
	                            choices: [{ text: "" }]
	                        }, {
	                            required: false,
	                            active: false,
	                            title: "",
	                            inputMode: "text",
	                            choices: [{ text: "" }]
	                        }, {
	                            required: false,
	                            active: false,
	                            title: "",
	                            inputMode: "text",
	                            choices: [{ text: "" }]
	                        }];
	                        _this2.json.admin.offlineForms.formCheckboxes = [{
	                            required: true,
	                            active: true,
	                            title: "",
	                            description: "",
	                            usePdf: false,
	                            fileName: "",
	                            fileUrl: "",
	                            fileId: null,
	                            isInfobox: false,
	                            typeIsCheckbox: true,
	                            infoBoxCustomText: "Press here to review the full statement…"
	                        }, {
	                            required: false,
	                            active: false,
	                            title: "",
	                            description: "",
	                            usePdf: false,
	                            fileName: "",
	                            fileUrl: "",
	                            fileId: null,
	                            isInfobox: false,
	                            typeIsCheckbox: true,
	                            infoBoxCustomText: "Press here to review the full statement…"
	                        }, {
	                            required: false,
	                            active: false,
	                            title: "",
	                            description: "",
	                            usePdf: false,
	                            fileName: "",
	                            fileUrl: "",
	                            fileId: null,
	                            isInfobox: false,
	                            typeIsCheckbox: true,
	                            infoBoxCustomText: "Press here to review the full statement…"
	                        }, {
	                            required: false,
	                            active: false,
	                            title: "",
	                            description: "",
	                            usePdf: false,
	                            fileName: "",
	                            fileUrl: "",
	                            fileId: null,
	                            isInfobox: false,
	                            typeIsCheckbox: true,
	                            infoBoxCustomText: "Press here to review the full statement…"
	                        }, {
	                            required: false,
	                            active: false,
	                            title: "",
	                            description: "",
	                            usePdf: false,
	                            fileName: "",
	                            fileUrl: "",
	                            fileId: null,
	                            isInfobox: false,
	                            typeIsCheckbox: true,
	                            infoBoxCustomText: "Press here to review the full statement…"
	                        }];
	                        _this2.json.admin.offlineForms.infoBoxCustomize = false;
	                        _this2.json.admin.offlineForms.formCheckboxesTypeLikeRadiobutton = false;
	
	                        _this2.json.admin.offlineForms.formSignature = {
	                            "required": true,
	                            "active": false,
	                            "title": "Signature"
	                        };
	                        _this2.json.admin.offlineForms.backgroundImage = null;
	                        _this2.json.admin.offlineForms.isSendFromForm = false;
	                        _this2.json.admin.offlineForms.enabled = false;
	                        break;
	                }
	            });
	        }
	
	        /**
	         * Remove buttons from start screen preview when some option disabled
	         * @param value
	         */
	
	    }, {
	        key: "ensureVideoBoothFields",
	        value: function ensureVideoBoothFields(videoBooth) {
	            if (!videoBooth) {
	                return;
	            }
	            if (videoBooth.enableChromakey === undefined) {
	                videoBooth.enableChromakey = false;
	            }
	            if (videoBooth.enableSoundRecording === undefined) {
	                videoBooth.enableSoundRecording = false;
	            }
	        }
	    }, {
	        key: "clearVideoChromakeyFromScenes",
	        value: function clearVideoChromakeyFromScenes() {
	            if (!this.json || !this.json.admin || !this.json.admin.scenes || !this.json.admin.scenes.scenesList) {
	                return;
	            }
	            this.json.admin.scenes.scenesList.forEach(function (scene) {
	                if (scene.selectedFeature && scene.selectedFeature.value === VIDEO_CHROMAKEY_FEATURE) {
	                    scene.selectedFeature = null;
	                }
	            });
	        }
	    }, {
	        key: "rebuildSceneActiveFeatures",
	        value: function rebuildSceneActiveFeatures() {
	            if (!this.json || !this.json.admin) {
	                this.sceneActiveFeatures = [];
	                return;
	            }
	            var admin = this.json.admin;
	            this.sceneActiveFeatures = [{ feature: "2d_to_3d", active: !!(admin.ai["2Dto3D"] && admin.ai["2Dto3D"].immersity_2d_to_3d_active) }, { feature: "faceswap", active: !!admin.ai.faceSwap.active }, { feature: "multi_faceswap", active: !!admin.ai.faceSwap.face_swap_multi_active }, { feature: "wandershare_api", active: !!admin.ai.wandershareApi.active }, {
	                feature: "remove_bg_online",
	                active: !!(admin.ai.replicate.replicate_remove_bg_active || admin.ai.remaker.remaker_remove_bg_active)
	            }, {
	                feature: "replicate_prompting",
	                active: !!(admin.ai.replicate.replicate_remove_bg_active && admin.ai.replicate.replicate_prompting_active)
	            }, { feature: "remove_bg_offline", active: !!(admin.removeBgOffline && admin.removeBgOffline.remove_bg_offline_active) }, { feature: "remove_bg_video", active: !!(admin.unscreen && admin.unscreen.us_active) }, {
	                feature: VIDEO_CHROMAKEY_FEATURE,
	                active: !!(admin.videoBooth && admin.videoBooth.enableChromakey)
	            }];
	        }
	    }, {
	        key: "onVideoChromakeyChange",
	        value: function onVideoChromakeyChange() {
	            this.rebuildSceneActiveFeatures();
	            if (!this.json.admin.videoBooth.enableChromakey) {
	                this.clearVideoChromakeyFromScenes();
	            }
	        }
	    }, {
	        key: "onVideoBoothEnabledChange",
	        value: function onVideoBoothEnabledChange() {
	            if (!this.json.admin.videoBooth.enabled) {
	                this.json.admin.videoBooth.enableChromakey = false;
	                this.clearVideoChromakeyFromScenes();
	            }
	            this.removeButtons();
	        }
	    }, {
	        key: "removeButtons",
	        value: function removeButtons() {
	            if (!this.json.admin.startScreenAreas) {
	                return;
	            }
	            this.json.admin.startScreenAreas.random = Math.random();
	
	            var photo = this.json.admin.photoBooth.enabled;
	            var gif = this.json.admin.gifBooth.enabled;
	            var boomerang = this.json.admin.boomerangBooth.enabled;
	            var video = this.json.admin.videoBooth.enabled;
	            var isTop = this.json.admin.startScreenLogo.position <= 4;
	            if (this.json.admin.startScreenAreas.single.width && this.json.admin.startScreenAreas.gif.width && this.json.admin.startScreenAreas.boomerang.width && this.json.admin.startScreenAreas.video.width) {
	                return;
	            }
	            this.json.admin.startScreenAreas.single = { width: 40, height: 40, x: 25, y: isTop ? 60 : 40 };
	            this.json.admin.startScreenAreas.gif = { width: 40, height: 40, x: 50, y: isTop ? 60 : 40 };
	            this.json.admin.startScreenAreas.boomerang = { width: 40, height: 40, x: 75, y: isTop ? 60 : 40 };
	            this.json.admin.startScreenAreas.video = { width: 40, height: 40, x: 95, y: isTop ? 60 : 40 };
	
	            if (photo && gif && !boomerang && video) {
	                this.json.admin.startScreenAreas.single.x = 37.5;
	                this.json.admin.startScreenAreas.gif.x = 62.5;
	                this.json.admin.startScreenAreas.boomerang = {};
	                this.json.admin.startScreenAreas.video.x = 75;
	            } else if (photo && !gif && boomerang && video) {
	                this.json.admin.startScreenAreas.single.x = 37.5;
	                this.json.admin.startScreenAreas.gif = {};
	                this.json.admin.startScreenAreas.boomerang.x = 62.5;
	                this.json.admin.startScreenAreas.video.x = 75;
	            } else if (!photo && gif && boomerang && video) {
	                this.json.admin.startScreenAreas.single = {};
	                this.json.admin.startScreenAreas.gif.x = 37.5;
	                this.json.admin.startScreenAreas.boomerang.x = 62.5;
	                this.json.admin.startScreenAreas.video.x = 75;
	            } else if (!photo && !gif && boomerang && video) {
	                this.json.admin.startScreenAreas.single = {};
	                this.json.admin.startScreenAreas.gif = {};
	                this.json.admin.startScreenAreas.boomerang.x = 50;
	                this.json.admin.startScreenAreas.video.x = 75;
	            } else if (!photo && gif && !boomerang && video) {
	                this.json.admin.startScreenAreas.single = {};
	                this.json.admin.startScreenAreas.gif.x = 50;
	                this.json.admin.startScreenAreas.boomerang = {};
	                this.json.admin.startScreenAreas.video.x = 75;
	            } else if (photo && !gif && !boomerang && video) {
	                this.json.admin.startScreenAreas.single.x = 50;
	                this.json.admin.startScreenAreas.gif = {};
	                this.json.admin.startScreenAreas.boomerang = {};
	                this.json.admin.startScreenAreas.video.x = 75;
	            } else if (photo && gif && boomerang && !video) {
	                this.json.admin.startScreenAreas.single.x = 37.5;
	                this.json.admin.startScreenAreas.gif.x = 62.5;
	                this.json.admin.startScreenAreas.boomerang.x = 50;
	                this.json.admin.startScreenAreas.video = {};
	            } else if (!photo && !gif && !boomerang && video) {
	                this.json.admin.startScreenAreas.single.x = {};
	                this.json.admin.startScreenAreas.gif.x = {};
	                this.json.admin.startScreenAreas.boomerang.x = {};
	                this.json.admin.startScreenAreas.video.x = 75;
	            }
	        }
	    }, {
	        key: "canExitScenes",
	        value: function canExitScenes() {
	            var checkEnabledScenes = function checkEnabledScenes(arr) {
	                var enabled = false;
	                (0, _lodash.forEach)(arr, function (s) {
	                    if (s.enabled) {
	                        enabled = true;
	                    }
	                });
	                return enabled;
	            };
	
	            if (!this.json || !this.json.admin || !this.json.admin.scenes) {
	                return;
	            }
	            if (this.json.admin.scenes && this.json.admin.scenes.enabled && (!this.json.admin.scenes.scenesList.length || !checkEnabledScenes(this.json.admin.scenes.scenesList))) {
	                return false;
	            }
	            var s = this.json.admin.scenes;
	            if (!s.sceneLayoutAspectRatio) return false;
	            if (!s.layoutHeight) return false;
	            if (!s.layoutWidth) return false;
	            if (!s.photos || !s.photos[0].width || !s.photos[0].height || !s.photos[0].x && s.photos[0].x !== 0 || !s.photos[0].y && s.photos[0].y !== 0) {
	                return false;
	            }
	
	            // s.photos = scenes.photos;
	            return true;
	        }
	    }, {
	        key: "ensureCustomSceneScreenConfig",
	        value: function ensureCustomSceneScreenConfig() {
	            if (!this.json || !this.json.admin || !this.json.admin.liveView) {
	                return;
	            }
	            var liveView = this.json.admin.liveView;
	            if (!liveView.customSceneScreen) {
	                liveView.customSceneScreen = {};
	            }
	            if (liveView.customSceneScreen.enabled === undefined) {
	                liveView.customSceneScreen.enabled = false;
	            }
	            if (!(0, _isFinite2.default)(parseInt(liveView.customSceneScreen.numberOfScenes, 10)) || parseInt(liveView.customSceneScreen.numberOfScenes, 10) < 1) {
	                liveView.customSceneScreen.numberOfScenes = 1;
	            } else {
	                liveView.customSceneScreen.numberOfScenes = parseInt(liveView.customSceneScreen.numberOfScenes, 10);
	            }
	            if (!liveView.customSceneScreen.background || (0, _typeof3.default)(liveView.customSceneScreen.background) !== "object") {
	                liveView.customSceneScreen.background = {};
	            }
	            if (!(0, _lodash.isArray)(liveView.customSceneScreen.touchpoints)) {
	                liveView.customSceneScreen.touchpoints = [];
	            }
	            var nextTouchpoints = [];
	            for (var i = 0; i < liveView.customSceneScreen.numberOfScenes; i++) {
	                var existing = liveView.customSceneScreen.touchpoints[i] || {};
	                nextTouchpoints.push((0, _extends3.default)({
	                    width: 20,
	                    height: 20,
	                    x: 15 + i % 4 * 22,
	                    y: 20 + Math.floor(i / 4) * 25,
	                    angle: 0,
	                    scene_title: "",
	                    custom_icon: null,
	                    customIcon: null
	                }, existing, {
	                    scene_index: i + 1
	                }));
	            }
	            liveView.customSceneScreen.touchpoints = nextTouchpoints;
	        }
	    }, {
	        key: "ensureGeneralUiButtonsSettings",
	        value: function ensureGeneralUiButtonsSettings() {
	            if (!this.json || !this.json.admin || !this.json.admin.liveView) {
	                return;
	            }
	            var customButtons = this.json.admin.liveView.customButtons;
	            if (!customButtons || !customButtons.generalUiButtonsSettings) {
	                return;
	            }
	            var settings = customButtons.generalUiButtonsSettings;
	            if (settings.proceed) {
	                return;
	            }
	            var defaultProceed = { width: 5.5, height: 5.5, x: 92, y: 50 };
	            settings.proceed = settings.capture ? (0, _lodash.cloneDeep)(settings.capture) : defaultProceed;
	        }
	    }, {
	        key: "getCustomSceneScreenMismatch",
	        value: function getCustomSceneScreenMismatch() {
	            this.ensureCustomSceneScreenConfig();
	            if (!this.json || !this.json.admin || !this.json.admin.liveView || !this.json.admin.liveView.customSceneScreen) {
	                return null;
	            }
	            var customSceneScreen = this.json.admin.liveView.customSceneScreen;
	            if (!customSceneScreen.enabled) {
	                return null;
	            }
	            var expectedCount = parseInt(customSceneScreen.numberOfScenes, 10) || 1;
	            var scenesList = this.json.admin.scenes && (0, _lodash.isArray)(this.json.admin.scenes.scenesList) ? this.json.admin.scenes.scenesList : [];
	            var actualCount = scenesList.length;
	            if (expectedCount === actualCount) {
	                return null;
	            }
	            return {
	                expectedCount: expectedCount,
	                actualCount: actualCount
	            };
	        }
	    }, {
	        key: "hasCustomSceneScreenMismatch",
	        value: function hasCustomSceneScreenMismatch() {
	            return !!this.getCustomSceneScreenMismatch();
	        }
	    }, {
	        key: "getCustomSceneScreenWarningText",
	        value: function getCustomSceneScreenWarningText() {
	            var mismatch = this.getCustomSceneScreenMismatch();
	            if (!mismatch) {
	                return "";
	            }
	            if (mismatch.actualCount < mismatch.expectedCount) {
	                return "You set " + mismatch.expectedCount + " scenes, but only " + mismatch.actualCount + " were created";
	            }
	            return mismatch.actualCount + " scenes were created instead of " + mismatch.expectedCount;
	        }
	    }, {
	        key: "canExitFaceSwapScenes",
	        value: function canExitFaceSwapScenes() {
	            var checkEnabledScenes = function checkEnabledScenes(arr) {
	                var enabled = false;
	                (0, _lodash.forEach)(arr, function (s) {
	                    if (s.enabled) {
	                        enabled = true;
	                    }
	                });
	                return enabled;
	            };
	            if (!this.json || !this.json.admin || !this.json.admin.ai.faceSwap.faceSwapScenes) {
	                return;
	            }
	            if (this.json.admin.ai.faceSwap.faceSwapScenes && this.json.admin.ai.faceSwap.faceSwapScenes.enabled && (!this.json.admin.ai.faceSwap.faceSwapScenes.scenesList.length || !checkEnabledScenes(this.json.admin.ai.faceSwap.faceSwapScenes.scenesList))) {
	                return false;
	            }
	            var s = this.json.admin.ai.faceSwap.faceSwapScenes;
	
	            if (!s.sceneLayoutAspectRatio) return false;
	            if (!s.layoutHeight) return false;
	            if (!s.layoutWidth) return false;
	            if (!s.photos || !s.photos[0].width || !s.photos[0].height || !s.photos[0].x && s.photos[0].x !== 0 || !s.photos[0].y && s.photos[0].y !== 0) {
	                return false;
	            }
	
	            // s.photos = scenes.photos;
	            return true;
	        }
	    }, {
	        key: "canExitFaceSwapOverlays",
	        value: function canExitFaceSwapOverlays() {
	            var checkEnabledScenes = function checkEnabledScenes(arr) {
	                var enabled = false;
	                (0, _lodash.forEach)(arr, function (s) {
	                    if (s.enabled) {
	                        enabled = true;
	                    }
	                });
	                return enabled;
	            };
	
	            if (!this.json || !this.json.admin || !this.json.admin.ai.faceSwap.faceSwapOverlays) {
	                return;
	            }
	            if (this.json.admin.ai.faceSwap.faceSwapOverlays && this.json.admin.ai.faceSwap.faceSwapOverlays.enabled && (!this.json.admin.ai.faceSwap.faceSwapOverlays.scenesList.length || !checkEnabledScenes(this.json.admin.ai.faceSwap.faceSwapOverlays.scenesList))) {
	                return false;
	            }
	            var s = this.json.admin.ai.faceSwap.faceSwapOverlays;
	
	            if (!s.sceneLayoutAspectRatio) return false;
	            if (!s.layoutHeight) return false;
	            if (!s.layoutWidth) return false;
	            if (!s.photos || !s.photos[0].width || !s.photos[0].height || !s.photos[0].x && s.photos[0].x !== 0 || !s.photos[0].y && s.photos[0].y !== 0) {
	                return false;
	            }
	
	            // s.photos = scenes.photos;
	            return true;
	        }
	
	        /**
	         * Check if user can exit start screen
	         * @returns {boolean}
	         */
	
	    }, {
	        key: "canExitStartScreen",
	        value: function canExitStartScreen() {
	            var p = this.json && this.json.admin && this.json.admin.startScreenAreas ? this.json.admin.startScreenAreas : false;
	
	            if (!p) {
	                return false;
	            }
	
	            if (this.json.admin.photoBooth && !this.json.admin.photoBooth.enabled && this.json.admin.gifBooth && !this.json.admin.gifBooth.enabled && this.json.admin.boomerangBooth && !this.json.admin.boomerangBooth.enabled && this.json.admin.videoBooth && !this.json.admin.videoBooth.enabled) {
	
	                return false;
	            }
	
	            if (p.single && (!p.single.width || !p.single.height || typeof p.single.x !== "number" || typeof p.single.y !== "number") && this.json.admin.photoBooth.enabled || this.json.admin.photoBooth && this.json.admin.photoBooth.enabled && !p.single) {
	                return false;
	            }
	
	            if (p.gif && (!p.gif.width || !p.gif.height || typeof p.gif.x !== "number" || typeof p.gif.y !== "number") && this.json.admin.gifBooth.enabled || this.json.admin.gifBooth && this.json.admin.gifBooth.enabled && !p.gif) {
	                return false;
	            }
	
	            if (p.boomerang && (!p.boomerang.width || !p.boomerang.height || typeof p.boomerang.x !== "number" || typeof p.boomerang.y !== "number") && this.json.admin.boomerangBooth.enabled || this.json.admin.boomerangBooth && this.json.admin.boomerangBooth.enabled && !p.boomerang) {
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: "canExitCustomButtons",
	        value: function canExitCustomButtons() {
	            var p = this.json && this.json.admin && this.json.admin.liveView.customButtons ? this.json.admin.liveView.customButtons : false;
	
	            if (!p) {
	                return false;
	            }
	
	            if (p.generalUiButtonsSettings.back && (!p.generalUiButtonsSettings.back.width || !p.generalUiButtonsSettings.back.height || typeof p.generalUiButtonsSettings.back.x !== "number" || typeof p.generalUiButtonsSettings.back.y !== "number")) {
	                return false;
	            }
	
	            if (p.generalUiButtonsSettings.sharingBackBtn && (!p.generalUiButtonsSettings.sharingBackBtn.width || !p.generalUiButtonsSettings.sharingBackBtn.height || typeof p.generalUiButtonsSettings.sharingBackBtn.x !== "number" || typeof p.generalUiButtonsSettings.sharingBackBtn.y !== "number")) {
	                return false;
	            }
	
	            if (p.generalUiButtonsSettings.capture && (!p.generalUiButtonsSettings.capture.width || !p.generalUiButtonsSettings.capture.height || typeof p.generalUiButtonsSettings.capture.x !== "number" || typeof p.generalUiButtonsSettings.capture.y !== "number")) {
	                return false;
	            }
	
	            if (p.generalUiButtonsSettings.proceed && (!p.generalUiButtonsSettings.proceed.width || !p.generalUiButtonsSettings.proceed.height || typeof p.generalUiButtonsSettings.proceed.x !== "number" || typeof p.generalUiButtonsSettings.proceed.y !== "number")) {
	                return false;
	            }
	
	            if (p.generalUiButtonsSettings.next && (!p.generalUiButtonsSettings.next.width || !p.generalUiButtonsSettings.next.height || typeof p.generalUiButtonsSettings.next.x !== "number" || typeof p.generalUiButtonsSettings.next.y !== "number")) {
	                return false;
	            }
	
	            if (p.generalUiButtonsSettings.close && (!p.generalUiButtonsSettings.close.width || !p.generalUiButtonsSettings.close.height || typeof p.generalUiButtonsSettings.close.x !== "number" || typeof p.generalUiButtonsSettings.close.y !== "number")) {
	                return false;
	            }
	
	            if (p.generalUiButtonsSettings.closeError && (!p.generalUiButtonsSettings.closeError.width || !p.generalUiButtonsSettings.closeError.height || typeof p.generalUiButtonsSettings.closeError.x !== "number" || typeof p.generalUiButtonsSettings.closeError.y !== "number")) {
	                return false;
	            }
	
	            if (p.generalUiButtonsSettings.email && (!p.generalUiButtonsSettings.email.width || !p.generalUiButtonsSettings.email.height || typeof p.generalUiButtonsSettings.email.x !== "number" || typeof p.generalUiButtonsSettings.email.y !== "number")) {
	                return false;
	            }
	            if (p.generalUiButtonsSettings.sms && (!p.generalUiButtonsSettings.sms.width || !p.generalUiButtonsSettings.sms.height || typeof p.generalUiButtonsSettings.sms.x !== "number" || typeof p.generalUiButtonsSettings.sms.y !== "number")) {
	                return false;
	            }
	            if (p.generalUiButtonsSettings.print && (!p.generalUiButtonsSettings.print.width || !p.generalUiButtonsSettings.print.height || typeof p.generalUiButtonsSettings.print.x !== "number" || typeof p.generalUiButtonsSettings.print.y !== "number")) {
	                return false;
	            }
	            if (p.generalUiButtonsSettings.done && (!p.generalUiButtonsSettings.done.width || !p.generalUiButtonsSettings.done.height || typeof p.generalUiButtonsSettings.done.x !== "number" || typeof p.generalUiButtonsSettings.done.y !== "number")) {
	                return false;
	            }
	            if (p.generalUiButtonsSettings.qrCode && (!p.generalUiButtonsSettings.qrCode.width || !p.generalUiButtonsSettings.qrCode.height || typeof p.generalUiButtonsSettings.qrCode.x !== "number" || typeof p.generalUiButtonsSettings.qrCode.y !== "number")) {
	                return false;
	            }
	            if (p.captureModeButtonsSettings.single && (!p.captureModeButtonsSettings.single.width || !p.captureModeButtonsSettings.single.height || typeof p.captureModeButtonsSettings.single.x !== "number" || typeof p.captureModeButtonsSettings.single.y !== "number")) {
	                return false;
	            }
	            if (p.captureModeButtonsSettings.gif && (!p.captureModeButtonsSettings.gif.width || !p.captureModeButtonsSettings.gif.height || typeof p.captureModeButtonsSettings.gif.x !== "number" || typeof p.captureModeButtonsSettings.gif.y !== "number")) {
	                return false;
	            }
	            if (p.captureModeButtonsSettings.boomerang && (!p.captureModeButtonsSettings.boomerang.width || !p.captureModeButtonsSettings.boomerang.height || typeof p.captureModeButtonsSettings.boomerang.x !== "number" || typeof p.captureModeButtonsSettings.boomerang.y !== "number")) {
	                return false;
	            }
	            if (p.captureModeButtonsSettings.scene && (!p.captureModeButtonsSettings.scene.width || !p.captureModeButtonsSettings.scene.height || typeof p.captureModeButtonsSettings.scene.x !== "number" || typeof p.captureModeButtonsSettings.scene.y !== "number")) {
	                return false;
	            }
	            if (p.captureModeButtonsSettings.filter && (!p.captureModeButtonsSettings.filter.width || !p.captureModeButtonsSettings.filter.height || typeof p.captureModeButtonsSettings.filter.x !== "number" || typeof p.captureModeButtonsSettings.filter.y !== "number")) {
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: "onIconChange",
	        value: function onIconChange() {
	            if (this.animatedIcons) {
	                var p = this.json && this.json.admin && this.json.admin.startScreenAreas ? this.json.admin.startScreenAreas : false;
	
	                if (!p) {
	                    return false;
	                }
	
	                for (var key in p) {
	                    if (p.hasOwnProperty(key) && p[key].width && p[key].height) {
	                        p[key].width = Math.min(p[key].width, p[key].height);
	                        p[key].height = Math.min(p[key].width, p[key].height);
	                    }
	                }
	            }
	        }
	
	        /**
	         * Format/DPI change: pixels from getPixelsForFormat; reset layout to one frame on canvas;
	         * if strip — activatePhotoStrips. Called from md-select format and DPI.
	         */
	
	    }, {
	        key: "changeSinglePhotoLayoutRatio",
	        value: function changeSinglePhotoLayoutRatio(value) {
	            var config = this.viewValue[value];
	            var formatId = config.layoutAspectRatio;
	            var dpi = config.printDpi != null ? config.printDpi : 300;
	            var p = (0, _printFormatsConstant.getPixelsForFormat)(formatId, dpi);
	            config.printCanvasWidth = p.width;
	            config.printCanvasHeight = p.height;
	
	            config.photosArr = [{
	                x: 0,
	                y: 0,
	                width: p.width,
	                height: p.height,
	                angle: 0,
	                title: "1",
	                image: true
	            }];
	            config.strippedPhotosArr = [];
	            if (config.strip) {
	                this.activatePhotoStrips(value);
	            }
	            this.changePhotosAspectRatio(value);
	        }
	
	        /** Preview scale: longest canvas side ≈ 400px on screen; DPI must not shrink the preview. */
	
	    }, {
	        key: "getPrintPreviewIndex",
	        value: function getPrintPreviewIndex(typ) {
	            var config = this.viewValue[typ];
	            if (!config || config.printCanvasWidth == null || config.printCanvasHeight == null) {
	                return 4.5;
	            }
	            var targetDisplayMax = 400;
	            var currentMax = Math.max(config.printCanvasWidth, config.printCanvasHeight);
	            if (currentMax <= 0) {
	                return 4.5;
	            }
	            return currentMax / targetDisplayMax;
	        }
	
	        /** DPI for html-preview (bleed); fallback 300. */
	
	    }, {
	        key: "getPrintDpi",
	        value: function getPrintDpi(typ) {
	            var config = this.viewValue[typ];
	            return config && config.printDpi != null ? config.printDpi : 300;
	        }
	
	        // Only when new configuration loaded
	
	    }, {
	        key: "setPhotosForPrint",
	        value: function setPhotosForPrint(value) {
	            var config = this.viewValue[value];
	            var gifPhotosQuantity = [1, 2, 3];
	            var photosDefaultPosY = [82, 577, 1072];
	            config.photosArr = [];
	            config.strippedPhotosArr = [];
	            config.digitalFormat.photos = [];
	            switch (value) {
	                case "singlePhoto":
	                    // Use printCanvasWidth/Height (from format); fallback 1252×1843 (portrait 300dpi)
	                    config.photosArr.push({
	                        width: config.printCanvasWidth || 1252,
	                        height: config.printCanvasHeight || 1843,
	                        x: 0,
	                        y: 0,
	                        angle: 0,
	                        title: "1",
	                        image: true
	                    });
	                    break;
	                case "gif":
	                case "boomerang":
	                    (0, _lodash.forEach)(gifPhotosQuantity, function (gif) {
	                        config.photosArr.push({
	                            width: 480,
	                            height: 480,
	                            x: 80,
	                            y: photosDefaultPosY[gif - 1],
	                            angle: 0,
	                            title: gif + "",
	                            image: true
	                        });
	                    });
	                    break;
	                case "video":
	                    (0, _lodash.forEach)(gifPhotosQuantity, function (gif) {
	                        config.photosArr.push({
	                            width: 480,
	                            height: 480,
	                            x: 80,
	                            y: photosDefaultPosY[gif - 1],
	                            angle: 0,
	                            title: gif + "",
	                            image: true
	                        });
	                    });
	                    break;
	            }
	            config.digitalFormat.photos = [{
	                width: 500,
	                height: 500,
	                y: 0,
	                x: 0,
	                angle: 0,
	                video: value === "boomerang",
	                trueVideo: value === "video",
	                gif: value === "gif",
	                duration: this.json && this.json.admin && this.json.admin.gifBooth.playbackSpeed ? this.json.admin.gifBooth.playbackSpeed : 2,
	                image: value === "singlePhoto"
	            }];
	        }
	    }, {
	        key: "changePhotosAspectRatio",
	        value: function changePhotosAspectRatio() {
	            var _this3 = this;
	
	            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "singlePhoto";
	            var isClick = arguments[1];
	
	            var config = this.viewValue[value],
	                widthIndex = void 0,
	                heightIndex = void 0;
	            (0, _lodash.forEach)(config.photosArr, function (ph) {
	                ph.storedWidth = ph.width;
	                ph.storedHeight = ph.height;
	                ph.width = getSquare(ph.width, ph.height);
	                ph.height = getSquare(ph.width, ph.height);
	            });
	            (0, _lodash.forEach)(config.strippedPhotosArr, function (ph) {
	                ph.storedWidth = ph.width;
	                ph.storedHeight = ph.height;
	                ph.width = getSquare(ph.width, ph.height);
	                ph.height = getSquare(ph.width, ph.height);
	            });
	            (0, _lodash.forEach)(config.digitalFormat.photos, function (ph) {
	                ph.storedWidth = ph.width;
	                ph.storedHeight = ph.height;
	                ph.width = getSquare(ph.width, ph.height);
	                ph.height = getSquare(ph.width, ph.height);
	            });
	
	            switch (config.photoCaptureRatio) {
	                case "square":
	                    widthIndex = 1;
	                    heightIndex = 1;
	                    config.customPhotoHeight = null;
	                    config.customPhotoWidth = null;
	                    break;
	                case "landscape":
	                    widthIndex = 3;
	                    heightIndex = 2;
	                    config.customPhotoHeight = null;
	                    config.customPhotoWidth = null;
	                    break;
	                case "portrait":
	                    widthIndex = 2;
	                    heightIndex = 3;
	                    config.customPhotoHeight = null;
	                    config.customPhotoWidth = null;
	                    break;
	                case "custom":
	                    if (isClick || config.customPhotoHeight === 0 || config.customPhotoWidth === 0 || config.customPhotoWidth < 0 || config.customPhotoHeight < 0) {
	                        config.customPhotoWidth = 1;
	                        config.customPhotoHeight = 1;
	                    }
	                    if (config.customPhotoHeight / config.customPhotoWidth >= 0.1 && config.customPhotoHeight / config.customPhotoWidth <= 10) {
	                        widthIndex = config.customPhotoWidth;
	                        heightIndex = config.customPhotoHeight;
	                    }
	                    if (!isClick) {
	                        widthIndex = widthIndex || 1;
	                        heightIndex = heightIndex || 1;
	                    }
	            }
	
	            if (widthIndex && heightIndex) {
	                if (widthIndex >= heightIndex) {
	                    (0, _lodash.forEach)(config.photosArr, function (ph) {
	                        ph.height = Math.round(heightIndex * ph.width / widthIndex);
	                        _this3.photoTransform.centrePhoto(ph);
	                    });
	                    (0, _lodash.forEach)(config.strippedPhotosArr, function (ph) {
	                        ph.height = Math.round(heightIndex * ph.width / widthIndex);
	                        _this3.photoTransform.centrePhoto(ph);
	                    });
	                    (0, _lodash.forEach)(config.digitalFormat.photos, function (ph) {
	                        ph.height = Math.round(heightIndex * ph.width / widthIndex);
	                        _this3.photoTransform.centrePhoto(ph);
	                    });
	                } else {
	                    (0, _lodash.forEach)(config.photosArr, function (ph) {
	                        ph.width = Math.round(widthIndex * ph.height / heightIndex);
	                        _this3.photoTransform.centrePhoto(ph);
	                    });
	                    (0, _lodash.forEach)(config.strippedPhotosArr, function (ph) {
	                        ph.width = Math.round(widthIndex * ph.height / heightIndex);
	                        _this3.photoTransform.centrePhoto(ph);
	                    });
	                    (0, _lodash.forEach)(config.digitalFormat.photos, function (ph) {
	                        ph.width = Math.round(widthIndex * ph.height / heightIndex);
	                        _this3.photoTransform.centrePhoto(ph);
	                    });
	                }
	                // if (isClick) {
	                //     config.strippedPhotosArr = this.photoTransform.removeOverlap(config.strippedPhotosArr, config.layoutAspectRatio);
	                //     config.photosArr = this.photoTransform.removeOverlap(config.photosArr, config.layoutAspectRatio);
	                //     config.digitalFormat.photos = this.photoTransform.removeOverlap(config.digitalFormat.photos, config.layoutAspectRatio);
	                //     }
	            }
	
	            function getSquare(a, b) {
	                return Math.max(a, b);
	            }
	        }
	    }, {
	        key: "changeLayoutSize",
	        value: function changeLayoutSize() {
	            var aspectRation = void 0,
	                width = void 0,
	                height = void 0;
	            var gcd = function gcd(a, b) {
	                return b === 0 ? a : gcd(b, a % b);
	            };
	            width = this.json.admin.general.width;
	            height = this.json.admin.general.height;
	            aspectRation = gcd(width, height);
	
	            this.json.admin.general.aspectRatio.width = width / aspectRation;
	            this.json.admin.general.aspectRatio.height = height / aspectRation;
	
	            if (this.json.admin.liveView.liveViewMode === "fullscreen") this.updateViewMode();
	        }
	    }, {
	        key: "changeLayoutRatio",
	        value: function changeLayoutRatio() {
	            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "singlePhoto";
	            var isClick = arguments[1];
	
	            var config = this.viewValue[value].digitalFormat,
	                widthIndex = void 0,
	                heightIndex = void 0;
	            config.layoutHeight = 500;
	            config.layoutWidth = 500;
	            config.photos[0].changed = Math.random();
	            switch (config.layoutAspectRatio) {
	                case "square":
	                    config.layoutHeight = 500;
	                    config.layoutWidth = 500;
	                    config.customPhotoWidth = null;
	                    config.customPhotoHeight = null;
	                    break;
	                case "landscape":
	                    config.layoutHeight = 333;
	                    config.layoutWidth = 500;
	                    config.customPhotoWidth = null;
	                    config.customPhotoHeight = null;
	                    break;
	                case "portrait":
	                    config.layoutHeight = 500;
	                    config.layoutWidth = 333;
	                    config.customPhotoWidth = null;
	                    config.customPhotoHeight = null;
	                    break;
	                case "custom":
	                    if (isClick || config.customPhotoHeight === 0 || config.customPhotoWidth === 0 || config.customPhotoWidth < 0 || config.customPhotoHeight < 0) {
	                        config.customPhotoWidth = 1;
	                        config.customPhotoHeight = 1;
	                    }
	                    if (config.customPhotoHeight / config.customPhotoWidth >= 0.1 && config.customPhotoHeight / config.customPhotoWidth <= 10) {
	                        widthIndex = config.customPhotoWidth;
	                        heightIndex = config.customPhotoHeight;
	                    }
	            }
	
	            if (widthIndex && heightIndex) {
	                if (widthIndex > heightIndex) {
	                    config.layoutHeight = Math.round(heightIndex * config.layoutWidth / widthIndex);
	                } else {
	                    config.layoutWidth = Math.round(widthIndex * config.layoutHeight / heightIndex);
	                }
	            }
	
	            if (!config.photos[0].width || !config.photos[0].height) {
	                (0, _assign2.default)(config.photos[0], { width: config.layoutWidth, height: config.layoutHeight });
	            }
	            var ph = config.photos[0];
	            ph.x = 0;
	            ph.y = 0;
	            var maxSide = Math.min(config.layoutHeight, config.layoutWidth);
	
	            if (ph.width >= ph.height) {
	                ph.width = maxSide;
	                this.changePhotosSize(ph, value, "width");
	            } else if (ph.width < ph.height) {
	                ph.height = maxSide;
	                this.changePhotosSize(ph, value, "height");
	            }
	        }
	    }, {
	        key: "changePhotosSize",
	        value: function changePhotosSize(item) {
	            var setting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "singlePhoto";
	            var value = arguments[2];
	
	            var config = setting ? this.viewValue[setting] : null,
	                widthIndex = void 0,
	                heightIndex = void 0;
	
	            widthIndex = 1;
	            heightIndex = 1;
	            if (config) {
	                switch (config.photoCaptureRatio) {
	                    case "square":
	                        break;
	                    case "landscape":
	                        widthIndex = 3;
	                        heightIndex = 2;
	                        break;
	                    case "portrait":
	                        widthIndex = 2;
	                        heightIndex = 3;
	                        break;
	                    case "custom":
	                        if (widthIndex && heightIndex) {
	                            widthIndex = config.customPhotoWidth;
	                            heightIndex = config.customPhotoHeight;
	                        }
	                        break;
	                }
	            }
	
	            if (value === "height") {
	                item.width = Math.round(item.height * widthIndex / heightIndex);
	            } else {
	                item.height = Math.round(item.width * heightIndex / widthIndex);
	            }
	        }
	    }, {
	        key: "changeSharingLayoutSize",
	        value: function changeSharingLayoutSize(setting, value) {
	            var _this4 = this;
	
	            var config = this.viewValue[setting],
	                widthIndex = void 0,
	                heightIndex = void 0;
	            var round2 = function round2(num) {
	                return _this4.Math.ceil(num / 2) * 2;
	            };
	
	            widthIndex = 1;
	            heightIndex = 1;
	            switch (config.digitalFormat.layoutAspectRatio) {
	                case "square":
	                    break;
	                case "landscape":
	                    widthIndex = 3;
	                    heightIndex = 2;
	                    break;
	                case "portrait":
	                    widthIndex = 2;
	                    heightIndex = 3;
	                    break;
	                case "custom":
	                    if (widthIndex && heightIndex) {
	                        widthIndex = config.digitalFormat.customPhotoWidth;
	                        heightIndex = config.digitalFormat.customPhotoHeight;
	                    }
	                    break;
	            }
	            if (value === "height") {
	                config.digitalFormat.layoutWidth = Math.round(config.digitalFormat.layoutHeight * widthIndex / heightIndex);
	                config.digitalFormat.layoutWidth = round2(config.digitalFormat.layoutWidth);
	            } else {
	                if (config.digitalFormat.layoutWidth) {
	                    config.digitalFormat.layoutHeight = Math.round(config.digitalFormat.layoutWidth * heightIndex / widthIndex);
	                    config.digitalFormat.layoutHeight = round2(config.digitalFormat.layoutHeight);
	                } else {
	                    config.digitalFormat.layoutHeight = Math.round(this.json.admin.general.width * heightIndex / widthIndex);
	                    config.digitalFormat.layoutHeight = round2(this.json.admin.general.height);
	                }
	            }
	            var ph = config.digitalFormat.photos[0];
	            ph.x = 0;
	            ph.y = 0;
	            var maxSide = Math.min(config.digitalFormat.layoutHeight ? config.digitalFormat.layoutHeight : this.json.admin.general.height, config.digitalFormat.layoutWidth ? config.digitalFormat.layoutWidth : this.json.admin.general.width);
	
	            if (ph.width >= ph.height) {
	                ph.width = maxSide;
	                ph.changed = Math.random();
	                this.changePhotosSize(ph, setting, "width");
	            } else if (ph.width < ph.height) {
	                ph.height = maxSide;
	                ph.changed = Math.random();
	                this.changePhotosSize(ph, setting, "height");
	            }
	        }
	    }, {
	        key: "addNewPhoto",
	        value: function addNewPhoto() {
	            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "singlePhoto";
	            var side = arguments[1];
	
	            var config = this.viewValue[value];
	            var lastPhoto = side === "a" ? config.photosArr[config.photosArr.length - 1] : config.strippedPhotosArr[config.strippedPhotosArr.length - 1];
	
	            var newPhoto = {
	                width: lastPhoto.width,
	                height: lastPhoto.height,
	                x: lastPhoto.x,
	                y: lastPhoto.y,
	                angle: lastPhoto.angle,
	                title: getName(side === "a" ? config.photosArr : config.strippedPhotosArr),
	                image: lastPhoto.image,
	                video: lastPhoto.video,
	                trueVideo: lastPhoto.trueVideo
	            };
	            if (config.layoutAspectRatio === "portrait" || config.layoutAspectRatio === "portrait_3_4") {
	                newPhoto.y += lastPhoto.height + this.photoTransform.getMargin(side === "a" ? config.photosArr : config.strippedPhotosArr, "portrait");
	                if (newPhoto.y + newPhoto.height > config.printCanvasHeight) {
	                    this.showErrorDialog("Error", "You can't add photo outside the printing area!<br><br>Move or change size of existing photo(s)");
	                    return;
	                }
	            } else {
	                newPhoto.x += lastPhoto.width + this.photoTransform.getMargin(side === "a" ? config.photosArr : config.strippedPhotosArr, "landscape");
	                if (newPhoto.x + newPhoto.width > config.printCanvasWidth) {
	                    this.showErrorDialog("Error", "You can't add photo outside the printing area!<br><br>Move or change size of existing photo(s)");
	                    return;
	                }
	            }
	            side === "a" ? config.photosArr.push(newPhoto) : config.strippedPhotosArr.push(newPhoto);
	
	            function getName(arr) {
	                var editedArr = [];
	                var title = void 0;
	                (0, _lodash.forEach)(arr, function (ph) {
	                    editedArr.push(Number(ph.title.replace("a", "").replace("b", "")));
	                });
	
	                for (var i = 1; i <= editedArr.length; i++) {
	                    if (editedArr.indexOf(i) === -1) {
	                        title = config.strip ? i + side : i + "";
	                    }
	                }
	
	                if (!title) {
	                    title = config.strip ? editedArr[editedArr.length - 1] + 1 + side : editedArr[editedArr.length - 1] + 1 + "";
	                }
	
	                return title;
	            }
	        }
	    }, {
	        key: "removePhoto",
	        value: function removePhoto(photo) {
	            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "singlePhoto";
	            var side = arguments[2];
	
	            var config = this.viewValue[value];
	            side === "a" ? config.photosArr.splice(photo, 1) : config.strippedPhotosArr.splice(photo, 1);
	        }
	    }, {
	        key: "resetPhotoArr",
	        value: function resetPhotoArr() {
	            var config = this.viewValue["singlePhoto"];
	            while (config.photosArr.length > 1) {
	                config.photosArr.pop();
	            }
	        }
	
	        /**
	         * Photo Strips: isLandscape = (width > height); previously layoutAspectRatio === "landscape".
	         * Universal for A1–A6, 10×15, 15×20: portrait — split by width, landscape — by height.
	         */
	
	    }, {
	        key: "activatePhotoStrips",
	        value: function activatePhotoStrips() {
	            var _this5 = this;
	
	            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "singlePhoto";
	
	            var config = this.viewValue[value];
	            if (config.strip) {
	                var isLandscape = (config.printCanvasWidth || 0) > (config.printCanvasHeight || 0);
	                if (isLandscape) {
	                    // Landscape: split by height (two rows)
	                    (0, _lodash.forEach)(config.photosArr, function (ph) {
	                        if (ph.height > config.printCanvasHeight / 2) {
	                            ph.height = config.printCanvasHeight / 2 - 142;
	                            ph.y += 80;
	                        }
	                        _this5.changePhotosSize(ph, value, "height");
	                        ph.height + ph.y > config.printCanvasHeight / 2 ? ph.y = ph.y - config.printCanvasHeight / 2 : null;
	                        ph.y < 0 ? ph.y = 0 : null;
	                        ph.title += "a";
	                        ph.image = true;
	                    });
	
	                    // Add new photos
	                    var stripedArr = [];
	                    (0, _lodash.forEach)(config.photosArr, function (ph) {
	                        stripedArr.push({
	                            width: ph.width,
	                            height: ph.height,
	                            x: ph.x,
	                            y: config.printCanvasHeight - ph.y - ph.height,
	                            angle: ph.angle,
	                            title: ph.title.replace("a", "b"),
	                            image: true
	                        });
	                    });
	                    //config.photosArr = [...config.photosArr, ...stripedArr];
	                    config.strippedPhotosArr = stripedArr;
	                } else {
	                    // Portrait: split by width (two columns)
	                    (0, _lodash.forEach)(config.photosArr, function (ph) {
	                        if (ph.width > config.printCanvasWidth / 2) {
	                            ph.width = config.printCanvasWidth / 2 - 142;
	                            ph.x += 80;
	                        }
	                        _this5.changePhotosSize(ph, value, "width");
	                        ph.width + ph.x > config.printCanvasWidth / 2 ? ph.x = ph.x - config.printCanvasWidth / 2 : null;
	                        ph.x < 0 ? ph.x = 0 : null;
	                        ph.title += "a";
	                        ph.image = true;
	                    });
	
	                    // Add new photos
	                    var _stripedArr = [];
	                    (0, _lodash.forEach)(config.photosArr, function (ph) {
	                        _stripedArr.push({
	                            width: ph.width,
	                            height: ph.height,
	                            x: config.printCanvasWidth - ph.x - ph.width,
	                            y: ph.y,
	                            angle: ph.angle,
	                            title: ph.title.replace("a", "b"),
	                            image: true
	                        });
	                    });
	                    config.strippedPhotosArr = _stripedArr;
	                }
	            } else {
	                config.photosArr = (0, _lodash.filter)(config.photosArr, function (ph) {
	                    return ph.title.indexOf("b") === -1;
	                });
	                (0, _lodash.forEach)(config.photosArr, function (ph) {
	                    ph.title = ph.title.replace("a", "");
	                });
	                config.strippedPhotosArr = [];
	            }
	        }
	    }, {
	        key: "mergeArrays",
	        value: function mergeArrays(arr1, arr2) {
	            return [].concat((0, _toConsumableArray3.default)(arr1), (0, _toConsumableArray3.default)(arr2));
	        }
	    }, {
	        key: "showMessage",
	        value: function showMessage() {
	            !this.canExitSinglePhoto() && this.$mdDialog.show(this.$mdDialog.alert().clickOutsideToClose(true).title(this.gettext("Error")).htmlContent(this.gettext("Your choices are incompatibile. You must either:<br><br>- Allow printing or sharing digital Single Photos (or both), or<br>- Disable Single Photos in this configuration")).ariaLabel(this.gettext("Error")).ok("OK").targetEvent(event));
	        }
	    }, {
	        key: "showErrorDialog",
	        value: function showErrorDialog(title, HTMLtext) {
	            this.$mdDialog.show(this.$mdDialog.alert().clickOutsideToClose(true).title(this.gettext(title)).htmlContent(this.gettext(HTMLtext)).ariaLabel(this.gettext("Error")).ok("OK").targetEvent(event));
	        }
	    }, {
	        key: "saveConfiguration",
	        value: function saveConfiguration(exit) {
	            var _this6 = this;
	
	            if (!this.json) return false;
	
	            if (!this.canExitForms()) {
	                this.getErrorItems(this.formOfflineForms.$error.required);
	                this.showErrorDialog("Error", "Enter all required inputs");
	                return false;
	            }
	            if (this.json.admin.ai.faceSwap.active) {
	                (0, _assign2.default)(this.config.json.admin.general.aspectRatio, {
	                    width: this.toViewValue.detectAspectRatioObject(this.config.json.admin.general.width, this.config.json.admin.general.height).w,
	                    height: this.toViewValue.detectAspectRatioObject(this.config.json.admin.general.width, this.config.json.admin.general.height).h
	                });
	            }
	            var transformValue = {
	                general: this.config.json.admin.general,
	                liveView: this.config.json.admin.liveView
	            };
	            this.filterForms();
	            this.config.json = angular.copy(this.json);
	            this.config.json.admin.photoBooth.sharingFile = this.toBoothValue.transformSharingPhoto("singlePhoto", this.viewValue, transformValue, !this.json.admin.ai.faceSwap.active);
	            this.config.json.admin.photoBooth.aspectRatio = this.toBoothValue.transformPhotoAspectRatio("singlePhoto", this.viewValue);
	            this.config.json.admin.photoBooth.printFile = this.toBoothValue.transformPrintingPhotos("singlePhoto", this.viewValue);
	
	            this.config.json.admin.gifBooth.sharingFile = this.toBoothValue.transformSharingPhoto("gif", this.viewValue, transformValue, !this.json.admin.ai.faceSwap.active);
	            this.config.json.admin.gifBooth.aspectRatio = this.toBoothValue.transformPhotoAspectRatio("gif", this.viewValue);
	            this.config.json.admin.gifBooth.printFile = this.toBoothValue.transformPrintingPhotos("gif", this.viewValue);
	
	            this.config.json.admin.boomerangBooth.sharingFile = this.toBoothValue.transformSharingPhoto("boomerang", this.viewValue, transformValue, !this.json.admin.ai.faceSwap.active);
	            this.config.json.admin.boomerangBooth.aspectRatio = this.toBoothValue.transformPhotoAspectRatio("boomerang", this.viewValue);
	            this.config.json.admin.boomerangBooth.printFile = this.toBoothValue.transformPrintingPhotos("boomerang", this.viewValue);
	
	            this.config.json.admin.startScreenDefaultIcons = this.animatedIcons;
	            if (this.config.json.client.emailTextNoHtml) {
	                this.config.json.client.emailTextNoHtml = this.emailTemplates.addLineBreaks(this.config.json.client.emailTextNoHtml);
	            }
	            this.config.json.admin.startScreenAreas = this.toBoothValue.transformStartScreenAreas(this.config.json.admin.startScreenAreas);
	            if (this.config.json.admin.startScreenLogo) {
	                this.config.json.admin.startScreenLogo.boothStyle = this.toBoothValue.setLogoStyle(this.config.json.admin.startScreenLogo);
	            }
	            this.config.json.admin.scenes = this.toBoothValue.transformScenes(this.config.json.admin.scenes);
	            this.config.json.admin.ai.faceSwap.faceSwapScenes = this.toBoothValue.transformScenes(this.config.json.admin.ai.faceSwap.faceSwapScenes, false, {
	                height: this.json.admin.general.height,
	                width: this.json.admin.general.width
	            });
	            (0, _assign2.default)(this.json.admin.ai.faceSwap.faceSwapScenes, {
	                layoutHeight: this.json.admin.general.height,
	                layoutWidth: this.json.admin.general.width
	            });
	            this.config.json.admin.ai.faceSwap.faceSwapOverlays = this.toBoothValue.transformScenes(this.config.json.admin.ai.faceSwap.faceSwapOverlays, false, {
	                height: this.json.admin.general.height,
	                width: this.json.admin.general.width
	            });
	            (0, _assign2.default)(this.json.admin.ai.faceSwap.faceSwapOverlays, {
	                layoutHeight: this.json.admin.general.height,
	                layoutWidth: this.json.admin.general.width
	            });
	
	            this.createTemplateFromDefault();
	            // Compared as sent (like $DetectChanges): keys left undefined, e.g. by addPropertiesFromServer, are not changes
	            var changed = !(0, _lodash.isEqual)(JSON.parse(angular.toJson(this.copiedConfig.json)), JSON.parse(angular.toJson(this.config.json)));
	            if (changed || exit) {
	                this.loading = true;
	                this.$mdToast.show(this.loadingTost);
	                this.config.json.admin.photoBooth.updatePrint = this.detectChanges.checkBoothPrintChange(this.config.json.admin.photoBooth, this.copiedConfig.json.admin.photoBooth, this.config.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	                this.config.json.admin.photoBooth.updateSharing = this.detectChanges.checkBoothSharingChange(this.config.json.admin.photoBooth, this.copiedConfig.json.admin.photoBooth, this.config.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	
	                this.config.json.admin.gifBooth.updatePrint = this.detectChanges.checkBoothPrintChange(this.config.json.admin.gifBooth, this.copiedConfig.json.admin.gifBooth, this.config.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	                this.config.json.admin.gifBooth.updateSharing = this.detectChanges.checkBoothSharingChange(this.config.json.admin.gifBooth, this.copiedConfig.json.admin.gifBooth, this.config.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	
	                this.config.json.admin.boomerangBooth.updatePrint = this.detectChanges.checkBoothPrintChange(this.config.json.admin.boomerangBooth, this.copiedConfig.json.admin.boomerangBooth, this.config.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	                this.config.json.admin.boomerangBooth.updateSharing = this.detectChanges.checkBoothSharingChange(this.config.json.admin.boomerangBooth, this.copiedConfig.json.admin.boomerangBooth, this.config.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	
	                this.config.json.admin.scenes = this.detectChanges.detectScenesChanges(this.config.json.admin.scenes, this.copiedConfig.json.admin.scenes);
	                this.config.json.admin.ai.faceSwap.faceSwapScenes = this.detectChanges.detectScenesChanges(this.config.json.admin.ai.faceSwap.faceSwapScenes, this.copiedConfig.json.admin.ai.faceSwap.faceSwapScenes);
	                (0, _assign2.default)(this.json.admin.ai.faceSwap.faceSwapScenes, {
	                    layoutHeight: this.json.admin.general.height,
	                    layoutWidth: this.json.admin.general.width
	                });
	                this.config.json.admin.ai.faceSwap.faceSwapOverlays = this.detectChanges.detectScenesChanges(this.config.json.admin.ai.faceSwap.faceSwapOverlays, this.copiedConfig.json.admin.ai.faceSwap.faceSwapOverlays);
	                (0, _assign2.default)(this.json.admin.ai.faceSwap.faceSwapOverlays, {
	                    layoutHeight: this.json.admin.general.height,
	                    layoutWidth: this.json.admin.general.width
	                });
	
	                // Remove "Extra large print file" feature: do not send in config; old app: undefined = false
	                delete this.config.json.admin.extraLargePrintFile;
	
	                this.$Configuration.update(this.config).$promise.then(function (resp) {
	                    delete resp["us_active"];
	                    delete resp["us_api_key"];
	                    if (exit) {
	                        _this6.toastService.showSimple("Configuration saved!", 5000);
	                        _this6.$state.go("configurations");
	                    }
	                    _this6.addPropertiesFromServer(resp);
	                    _this6.deleteUpdatedProperties();
	                    _this6.copiedConfig = (0, _lodash.cloneDeep)(_this6.config);
	                    if (_this6.json.client && _this6.json.client.emailTextNoHtml) {
	                        _this6.config.json.client.emailTextNoHtml = _this6.emailTemplates.removeLineBreaks(_this6.config.json.client.emailTextNoHtml);
	                    }
	                    _this6.loading = false;
	                    _this6.$mdToast.hide(_this6.loadingTost);
	                }).catch(function (error) {
	                    _this6.showErrorDialog("Error", "<p>" + (error.data && error.data.error ? error.data.error : "Some error occured") + "</p>");
	                    _this6.$state.go("configurations");
	                });
	            }
	        }
	    }, {
	        key: "getErrorItems",
	        value: function getErrorItems(el) {
	            var _this7 = this;
	
	            this.formErrorFields = [];
	            if (Array.isArray(el)) {
	                el.forEach(function (e) {
	                    _this7.formErrorFields.push(e.$name);
	                    _this7.formOfflineForms[e.$name].$touched = true;
	                    _this7.formOfflineForms[e.$name].$dirty = true;
	                });
	            }
	            return this.formErrorFields;
	        }
	    }, {
	        key: "isErrorFiield",
	        value: function isErrorFiield(name) {
	            return this.formErrorFields.includes(name);
	        }
	    }, {
	        key: "deleteUpdatedProperties",
	        value: function deleteUpdatedProperties() {
	            delete this.config.updated;
	            if (this.config.json.admin.startScreenAreas) {
	                delete this.config.json.admin.startScreenAreas.random;
	            }
	
	            delete this.config.json.admin.photoBooth.updatePrint;
	            delete this.config.json.admin.photoBooth.updateSharing;
	
	            delete this.config.json.admin.gifBooth.updatePrint;
	            delete this.config.json.admin.gifBooth.updateSharing;
	
	            delete this.config.json.admin.boomerangBooth.updatePrint;
	            delete this.config.json.admin.boomerangBooth.updateSharing;
	
	            if (this.config.json.admin.scenes && this.config.json.admin.scenes.scenesList && this.config.json.admin.scenes.scenesList.length) {
	                (0, _lodash.forEach)(this.config.json.admin.scenes.scenesList, function (s) {
	                    delete s.updateScene;
	                });
	            }
	            if (this.config.json.admin.ai.faceSwap.faceSwapScenes && this.config.json.admin.ai.faceSwap.faceSwapScenes.scenesList && this.config.json.admin.ai.faceSwap.faceSwapScenes.scenesList.length) {
	                (0, _lodash.forEach)(this.config.json.admin.ai.faceSwap.faceSwapScenes.scenesList, function (s) {
	                    delete s.updateScene;
	                });
	            }
	            if (this.config.json.admin.ai.faceSwap.faceSwapOverlays && this.config.json.admin.ai.faceSwap.faceSwapOverlays.scenesList && this.config.json.admin.ai.faceSwap.faceSwapOverlays.scenesList.length) {
	                (0, _lodash.forEach)(this.config.json.admin.ai.faceSwap.faceSwapOverlays.scenesList, function (s) {
	                    delete s.updateScene;
	                });
	            }
	        }
	    }, {
	        key: "addPropertiesFromServer",
	        value: function addPropertiesFromServer(resp) {
	            var _this8 = this;
	
	            this.json.admin.photoBooth.printOverlay = (0, _lodash.cloneDeep)(resp.json.admin.photoBooth.printOverlay);
	            this.json.admin.photoBooth.printBackground = (0, _lodash.cloneDeep)(resp.json.admin.photoBooth.printBackground);
	            this.json.admin.photoBooth.sharingOverlay = (0, _lodash.cloneDeep)(resp.json.admin.photoBooth.sharingOverlay);
	
	            this.json.admin.photoBooth.sharingBackground = (0, _lodash.cloneDeep)(resp.json.admin.photoBooth.sharingBackground);
	            this.json.admin.gifBooth.printOverlay = (0, _lodash.cloneDeep)(resp.json.admin.gifBooth.printOverlay);
	
	            this.json.admin.gifBooth.printBackground = (0, _lodash.cloneDeep)(resp.json.admin.gifBooth.printBackground);
	            this.json.admin.gifBooth.sharingOverlay = (0, _lodash.cloneDeep)(resp.json.admin.gifBooth.sharingOverlay);
	            this.json.admin.gifBooth.sharingBackground = (0, _lodash.cloneDeep)(resp.json.admin.gifBooth.sharingBackground);
	
	            this.json.admin.boomerangBooth.printOverlay = (0, _lodash.cloneDeep)(resp.json.admin.boomerangBooth.printOverlay);
	            this.json.admin.boomerangBooth.printBackground = (0, _lodash.cloneDeep)(resp.json.admin.boomerangBooth.printBackground);
	
	            this.json.admin.boomerangBooth.sharingOverlay = (0, _lodash.cloneDeep)(resp.json.admin.boomerangBooth.sharingOverlay);
	            this.json.admin.boomerangBooth.sharingBackground = (0, _lodash.cloneDeep)(resp.json.admin.boomerangBooth.sharingBackground);
	
	            if (resp.json.admin.scenes && this.json.admin.scenes) {
	                (0, _lodash.forEach)(resp.json.admin.scenes.scenesList, function (scene, i) {
	                    _this8.json.admin.scenes.scenesList[i].finalBackground = scene.finalBackground;
	                    _this8.json.admin.scenes.scenesList[i].finalOverlay = scene.finalOverlay;
	                });
	            }
	            if (resp.json.admin.ai.faceSwap.faceSwapScenes && this.json.admin.ai.faceSwap.faceSwapScenes) {
	                (0, _lodash.forEach)(resp.json.admin.ai.faceSwap.faceSwapScenes.scenesList, function (scene, i) {
	                    _this8.json.admin.ai.faceSwap.faceSwapScenes.scenesList[i].finalBackground = scene.finalBackground;
	                    _this8.json.admin.ai.faceSwap.faceSwapScenes.scenesList[i].finalOverlay = scene.finalOverlay;
	                });
	            }
	            if (resp.json.admin.ai.faceSwap.faceSwapOverlays && this.json.admin.ai.faceSwap.faceSwapOverlays) {
	                (0, _lodash.forEach)(resp.json.admin.ai.faceSwap.faceSwapOverlays.scenesList, function (scene, i) {
	                    _this8.json.admin.ai.faceSwap.faceSwapOverlays.scenesList[i].finalBackground = scene.finalBackground;
	                    _this8.json.admin.ai.faceSwap.faceSwapOverlays.scenesList[i].finalOverlay = scene.finalOverlay;
	                });
	            }
	
	            this.json.admin.liveView.customButtons = resp.json.admin.liveView.customButtons;
	        }
	    }, {
	        key: "getFileType",
	        value: function getFileType(file) {
	            if (!file) {
	                return true;
	            }
	
	            if (!file.attachment_file) {
	                return true;
	            }
	
	            if (typeof file.attachment_file !== "string") {
	                return true;
	            }
	
	            var str = file.attachment_file.split(".");
	
	            return str[str.length - 1];
	        }
	    }, {
	        key: "changeGifDuration",
	        value: function changeGifDuration() {
	            this.viewValue.gif.digitalFormat.photos[0].duration = this.json.admin.gifBooth.playbackSpeed;
	        }
	    }, {
	        key: "disableEmailFields",
	        value: function disableEmailFields() {
	            if (!this.json || !this.json.admin || !this.json.admin.outputSettings) {
	                return false;
	            }
	            return !this.json.admin.outputSettings.enableEmailSharing;
	        }
	    }, {
	        key: "disableSmsFields",
	        value: function disableSmsFields() {
	            if (!this.json || !this.json.admin || !this.json.admin.outputSettings) {
	                return false;
	            }
	            return !this.json.admin.outputSettings.enableSmsSharing;
	        }
	    }, {
	        key: "hidePrintFields",
	        value: function hidePrintFields() {
	            if (!this.json || !this.json.admin) {
	                return false;
	            }
	            var hide = false;
	            if ((!this.json.admin.photoBooth.enabled || !this.json.admin.photoBooth.allowPrinting) && (!this.json.admin.gifBooth.enabled || !this.json.admin.gifBooth.allowPrinting) && (!this.json.admin.boomerangBooth.enabled || !this.json.admin.boomerangBooth.allowPrinting)) {
	                hide = true;
	            }
	            return hide;
	        }
	    }, {
	        key: "hasPrintingInEnabledBooth",
	        value: function hasPrintingInEnabledBooth() {
	            var _this9 = this;
	
	            if (!this.json || !this.json.admin) {
	                return false;
	            }
	            var booths = ["photoBooth", "gifBooth", "boomerangBooth"];
	            return booths.some(function (booth) {
	                return _this9.json.admin[booth] && _this9.json.admin[booth].enabled && _this9.json.admin[booth].allowPrinting;
	            });
	        }
	    }, {
	        key: "onFormConfigurationChange",
	        value: function onFormConfigurationChange(input) {
	            var _this10 = this;
	
	            if ([].concat((0, _toConsumableArray3.default)(this.json.admin.offlineForms.formInputs), (0, _toConsumableArray3.default)(this.json.admin.offlineForms.customInputs), (0, _toConsumableArray3.default)(this.json.admin.offlineForms.formSignature), (0, _toConsumableArray3.default)(this.json.admin.offlineForms.formCheckboxes)).find(function (item) {
	                return item.active;
	            }) || !this.json.admin.offlineForms.enabled) {
	                return true;
	            } else {
	                var confirm = this.$mdDialog.confirm().title("No active inputs left").textContent("Do you want to disable User Consent?").ariaLabel("dialog window").ok("Confirm").cancel("Cancel");
	                this.$mdDialog.show(confirm).then(function () {
	                    _this10.json.admin.offlineForms.enabled = false;
	                }, function () {
	                    if (input) {
	                        input.active = true;
	                    } else {
	                        _this10.json.admin.offlineForms.formInputs[0].active = true;
	                    }
	                });
	            }
	        }
	    }, {
	        key: "addChoiceField",
	        value: function addChoiceField(customFieldIndex) {
	            this.json.admin.offlineForms.customInputs[customFieldIndex].choices.push({ text: "" });
	        }
	    }, {
	        key: "removeChoiceField",
	        value: function removeChoiceField(customFieldIndex, choiceIndex) {
	            this.json.admin.offlineForms.customInputs[customFieldIndex].choices.splice(choiceIndex, 1);
	        }
	    }, {
	        key: "isCustomTitleUnique",
	        value: function isCustomTitleUnique(title, ci) {
	            return this.json.admin.offlineForms.customInputs.some(function (input, i) {
	                return input.title === title && ci !== i;
	            });
	        }
	    }, {
	        key: "onCountOfPrintsChange",
	        value: function onCountOfPrintsChange(printsCount) {
	            printsCount < 2 ? this.json.admin.autoPrintCopies = 1 : false;
	        }
	    }, {
	        key: "filterForms",
	        value: function filterForms() {
	            this.json.admin.offlineForms.isMultipleAnswers = !this.formsOneAnswer;
	            this.json.admin.offlineForms.customInputs = this.json.admin.offlineForms.customInputs.map(function (input) {
	                return (0, _extends3.default)({}, input, {
	                    choices: input.inputMode !== "multiple" ? [] : input.choices.filter(function (choice) {
	                        return choice.text;
	                    })
	                });
	            });
	        }
	
	        // Email sharing code
	
	    }, {
	        key: "onAdvancedInputChange",
	        value: function onAdvancedInputChange() {
	            if (!this.json.client.advancedHtmlInput) {
	                this.json.client.emailTemplate = "English";
	                this.json.client.emailSubject = "Your UpReach photo";
	            }
	            this.onTemplateChange();
	        }
	    }, {
	        key: "onTemplateChange",
	        value: function onTemplateChange() {
	            switch (this.json.client.emailTemplate) {
	                case "German informal":
	                    this.json.client.emailSubject = "Dein UpReach Foto";
	                    this.json.client.emailTitle = "Hey, super Foto!";
	                    this.json.client.emailTextNoHtml = "Bitte schön, dein tolles UpReach-Foto findest du im Anhang 🎉 Vielen Dank für deinen Besuch! 🙏\n" + "Scrolle ans Ende der E-Mail, um das Foto herunterzuladen & zu teilen.";
	                    this.json.client.emailTextRow = this.emailTemplates.getTemplate("germanInformal", this.json.client.emailTitle, this.json.client.emailTextNoHtml);
	                    this.json.client.smsText = "Hey, super Foto! 🎉\n" + "Besuche die Live-Galerie, um dein UpReach-Foto herunterzuladen & zu teilen: ";
	                    return;
	                case "German formal":
	                    this.json.client.emailSubject = "Ihr UpReach Foto";
	                    this.json.client.emailTitle = "Hey, super Foto!";
	                    this.json.client.emailTextNoHtml = "Bitte sehr, Ihr tolles UpReach-Foto finden Sie im Anhang 🎉 Vielen Dank für Ihren Besuch! 🙏\n" + "Scrollen Sie ans Ende der E-Mail, um das Foto herunterzuladen & zu teilen.";
	                    this.json.client.emailTextRow = this.emailTemplates.getTemplate("germanFormal", this.json.client.emailTitle, this.json.client.emailTextNoHtml);
	                    this.json.client.smsText = "Hey, super Foto! 🎉\n" + "Besuchen Sie die Live-Galerie, um Ihr UpReach-Foto herunterzuladen & zu teilen: ";
	                    return;
	                case "English":
	                    this.json.client.emailSubject = "Your UpReach photo";
	                    this.json.client.emailTitle = "Hey, nice snap!";
	                    this.json.client.emailTextNoHtml = "Here you are, please find attached your awesome UpReach photo. Thank you so much for visiting us!\n Scroll down to download & share your image.";
	                    this.json.client.emailTextRow = this.emailTemplates.getTemplate("english", this.json.client.emailTitle, this.json.client.emailTextNoHtml);
	                    this.json.client.smsText = "Hey, nice snap!\nVisit the live gallery to download & share your UpReach photo: ";
	                    return;
	            }
	        }
	    }, {
	        key: "createTemplateFromDefault",
	        value: function createTemplateFromDefault() {
	            this.config.json.client.emailText = (0, _lodash.cloneDeep)(this.config.json.client.emailTextRow);
	            if (!this.json.client.advancedHtmlInput) {
	                var template = null;
	                switch (this.json.client.emailTemplate) {
	                    case "German informal":
	                        template = "germanInformal";
	                        break;
	                    case "German formal":
	                        template = "germanFormal";
	                        break;
	                    case "English":
	                        template = "english";
	                        break;
	                }
	                if (template) {
	                    this.config.json.client.emailText = this.emailTemplates.getTemplate(template, this.config.json.client.emailTitle, this.config.json.client.emailTextNoHtml);
	                }
	            } else {
	                this.config.json.client.emailText = this.emailTemplates.replaceItems(this.config.json.client.emailTextRow, this.json.client.emailTitle, this.json.client.emailTextNoHtml);
	            }
	        }
	    }, {
	        key: "testUpload",
	        value: function testUpload(file, value, mode) {
	            if (this.json && this.json.admin) {
	                if (!this.json.admin[value][mode]) {
	                    this.json.admin[value][mode] = [];
	                }
	                if (mode.indexOf("printing") !== -1) {
	                    this.json.admin[value][mode][0] = file.attachment_file;
	                } else {
	                    if ((0, _lodash.isArray)(file)) {
	                        var _json$admin$value$mod;
	
	                        var newArr = [];
	                        (0, _lodash.forEach)(file, function (f) {
	                            newArr.push(f.attachment_file);
	                        });
	                        (_json$admin$value$mod = this.json.admin[value][mode]).push.apply(_json$admin$value$mod, newArr);
	                    } else {
	                        this.json.admin[value][mode].push(file.attachment_file);
	                        this.json.admin[value][mode + "ValidRatio"] = { width: file.width, height: file.height };
	                    }
	                }
	            }
	        }
	    }, {
	        key: "gdprCustomButtonUpload",
	        value: function gdprCustomButtonUpload(file, mode) {
	            if (this.json && this.json.admin) {
	                if (!this.json.admin["gdpr"][mode]) {
	                    this.json.admin["gdpr"][mode] = [];
	                }
	                if ((0, _lodash.isArray)(file)) {
	                    var _json$admin$gdpr$mode;
	
	                    var newArr = [];
	                    (0, _lodash.forEach)(file, function (f) {
	                        newArr.push(f.attachment_file);
	                    });
	                    (_json$admin$gdpr$mode = this.json.admin["gdpr"][mode]).push.apply(_json$admin$gdpr$mode, newArr);
	                } else {
	                    this.json.admin["gdpr"][mode] = [];
	                    this.json.admin["gdpr"][mode].push(file);
	                }
	            }
	        }
	    }, {
	        key: "pdfUpload",
	        value: function pdfUpload(file, value, index) {
	            if (this.json && this.json.admin) {
	                if (!this.json.admin[value]["formCheckboxes"]) {
	                    this.json.admin[value]["formCheckboxes"] = [];
	                }
	                this.json.admin[value]["formCheckboxes"][index].fileUrl = file.attachment_file;
	                this.json.admin[value]["formCheckboxes"][index].fileName = file.original_name;
	                this.json.admin[value]["formCheckboxes"][index].usePdf = true;
	                var urlParts = file.url.split("/");
	                this.json.admin[value]["formCheckboxes"][index].fileId = urlParts[urlParts.length - 2];
	                this.saveDataInConfig();
	            }
	        }
	    }, {
	        key: "pdfGdprUpload",
	        value: function pdfGdprUpload(file, mode) {
	            if (this.json && this.json.admin) {
	                if (!this.json.admin.gdpr[mode]) {
	                    this.json.admin.gdpr[mode] = [];
	                }
	                this.json.admin.gdpr[mode] = [];
	                this.json.admin.gdpr[mode].push(file);
	                var urlParts = file.url.split("/");
	                this.json.admin.gdpr.fileId = urlParts[urlParts.length - 2];
	                this.saveDataInConfig();
	            }
	        }
	    }, {
	        key: "customLogoUpload",
	        value: function customLogoUpload(file, mode) {
	            if (this.json && this.json.admin) {
	                if (!this.json.admin.ai["customLogo"][mode]) {
	                    this.json.admin.ai["customLogo"][mode] = [];
	                }
	                if ((0, _lodash.isArray)(file)) {
	                    var _json$admin$ai$custom;
	
	                    var newArr = [];
	                    (0, _lodash.forEach)(file, function (f) {
	                        newArr.push(f.attachment_file);
	                    });
	                    (_json$admin$ai$custom = this.json.admin.ai["customLogo"][mode]).push.apply(_json$admin$ai$custom, newArr);
	                } else {
	                    this.json.admin.ai["customLogo"][mode] = [];
	                    this.json.admin.ai["customLogo"][mode].push(file);
	                }
	                this.saveConfiguration(false);
	            }
	        }
	    }, {
	        key: "pdfDeleteFile",
	        value: function pdfDeleteFile(fileId, value, index) {
	            var _this11 = this;
	
	            if (this.json && this.json.admin) {
	                this.$upload.delete("/api/attachments/" + fileId + "/").then(function (resp) {
	                    if (resp) {
	                        _this11.json.admin[value]["formCheckboxes"][index].fileId = null;
	                        _this11.json.admin[value]["formCheckboxes"][index].fileUrl = "";
	                        _this11.json.admin[value]["formCheckboxes"][index].fileName = "";
	                        _this11.toastService.showSimple("File id deleted!", 5000);
	                        _this11.saveDataInConfig();
	                    }
	                }, function (error) {
	                    if (fileId === null) {
	                        _this11.showErrorDialog("Error", "<p>The file is missing!</p>");
	                    } else {
	                        _this11.showErrorDialog("Error", "<p>" + (error.data && error.data.error ? error.data.error : "Cannot DELETE " + _this11.json.admin[value]["formCheckboxes"][index].fileName) + "</p>");
	                    }
	                });
	            }
	        }
	    }, {
	        key: "gdprDeleteFile",
	        value: function gdprDeleteFile(fileId, value) {
	            var _this12 = this;
	
	            if (this.json && this.json.admin) {
	                this.$upload.delete("/api/attachments/" + fileId + "/").then(function (resp) {
	                    if (resp) {
	                        _this12.json.admin.gdpr[value] = [];
	                        _this12.json.admin.gdpr.fileId = null;
	                        _this12.toastService.showSimple("File id deleted!", 5000);
	                        _this12.saveDataInConfig();
	                    }
	                }, function (error) {
	                    if (fileId === null) {
	                        _this12.showErrorDialog("Error", "<p>The file is missing!</p>");
	                    } else {
	                        _this12.showErrorDialog("Error", "<p>" + (error.data && error.data.error ? error.data.error : "Cannot DELETE " + _this12.json.admin.gdpr[value][0].fileName) + "</p>");
	                    }
	                });
	            }
	        }
	    }, {
	        key: "deleteFile",
	        value: function deleteFile(index, value, mode) {
	            var isGdpr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	            if (this.json && this.json.admin) {
	                this.json.admin[value][mode].splice(index, 1);
	                if (this.json.admin[value][mode].length === 0) {
	                    this.json.admin[value][mode] = [];
	                    if (!isGdpr) {
	                        this.json.admin[value][mode + "ValidRatio"] = null;
	                    } else {
	                        this.saveDataInConfig();
	                    }
	                }
	            }
	        }
	    }, {
	        key: "customLogoDeleteFile",
	        value: function customLogoDeleteFile(index, value, mode) {
	            if (this.json && this.json.admin) {
	                this.json.admin.ai[value][mode].splice(index, 1);
	                if (this.json.admin.ai[value][mode].length === 0) {
	                    this.json.admin.ai[value][mode] = [];
	                }
	                this.saveConfiguration(false);
	            }
	        }
	    }, {
	        key: "checkStartScreenDesign",
	        value: function checkStartScreenDesign(booth) {
	            this.json.admin[booth].printingBackgroundMode = "image";
	            this.json.admin[booth].printingBackgroundColor = "#ffffff";
	            //this.json.admin[booth].printingBackgroundFiles = [];
	
	            if (this.json.admin[booth].startScreenDesignSharing) {
	                this.json.admin[booth].sharingBackgroundMode = this.json.admin.startScreenBackgroundMode;
	                this.json.admin[booth].sharingBackgroundColor = this.json.admin.startScreenBackgroundColor;
	                if (this.json.admin[booth].sharingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
	                    this.json.admin[booth].sharingBackgroundFiles = [this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file];
	                }
	            } else {
	                this.json.admin[booth].sharingBackgroundMode = "image";
	                this.json.admin[booth].sharingBackgroundColor = "#ffffff";
	                //this.json.admin[booth].sharingBackgroundFiles = [];
	            }
	        }
	    }, {
	        key: "checkDesignForAllModes",
	        value: function checkDesignForAllModes() {
	            this.checkStartScreenDesign("photoBooth");
	            this.checkStartScreenDesign("gifBooth");
	            this.checkStartScreenDesign("boomerangBooth");
	        }
	    }, {
	        key: "checkBackgroundResolution",
	        value: function checkBackgroundResolution() {
	            var _this13 = this;
	
	            setTimeout(function () {
	                if (_this13.json.admin && _this13.json.admin.startScreenBackground && _this13.json.admin.startScreenBackground.attachment_file) {
	                    var isVideo = _this13.json.admin.startScreenBackground.attachment_file.indexOf(".mp4") !== -1;
	                    var VALID_RESOLUTION = _this13.json.admin.startScreenPreviewSize.width / _this13.json.admin.startScreenPreviewSize.height;
	                    var media = isVideo ? new Video() : new Image();
	                    media.src = _this13.json.admin.startScreenBackground.attachment_file;
	                    if (isVideo) {
	                        media.onloadeddata = function () {
	                            if (media.videoWidth / media.videoHeight !== VALID_RESOLUTION) {
	                                _this13.showBgToggle = true;
	                            } else {
	                                _this13.showBgToggle = false;
	                            }
	                        };
	                    } else {
	                        media.onload = function () {
	                            if (media.width / media.height !== VALID_RESOLUTION) {
	                                _this13.showBgToggle = true;
	                            } else {
	                                _this13.showBgToggle = false;
	                            }
	                        };
	                    }
	                } else {
	                    _this13.showBgToggle = false;
	                }
	            });
	
	            function Video() {
	                return document.createElement("video");
	            }
	        }
	    }, {
	        key: "changeAreas",
	        value: function changeAreas() {
	            if (this.json.admin.startScreenLogo.position <= 3) {
	                this.json.admin.startScreenAreas.single.y && this.json.admin.startScreenAreas.single.y <= 50 ? this.json.admin.startScreenAreas.single.y = 100 - this.json.admin.startScreenAreas.single.y : null;
	                this.json.admin.startScreenAreas.gif.y && this.json.admin.startScreenAreas.gif.y <= 50 ? this.json.admin.startScreenAreas.gif.y = 100 - this.json.admin.startScreenAreas.gif.y : null;
	                this.json.admin.startScreenAreas.boomerang.y && this.json.admin.startScreenAreas.boomerang.y <= 50 ? this.json.admin.startScreenAreas.boomerang.y = 100 - this.json.admin.startScreenAreas.boomerang.y : null;
	                this.json.admin.startScreenAreas.video.y && this.json.admin.startScreenAreas.video.y <= 50 ? this.json.admin.startScreenAreas.video.y = 100 - this.json.admin.startScreenAreas.video.y : null;
	            } else {
	                this.json.admin.startScreenAreas.single.y && this.json.admin.startScreenAreas.single.y > 50 ? this.json.admin.startScreenAreas.single.y = 100 - this.json.admin.startScreenAreas.single.y : null;
	                this.json.admin.startScreenAreas.gif.y && this.json.admin.startScreenAreas.gif.y > 50 ? this.json.admin.startScreenAreas.gif.y = 100 - this.json.admin.startScreenAreas.gif.y : null;
	                this.json.admin.startScreenAreas.boomerang.y && this.json.admin.startScreenAreas.boomerang.y > 50 ? this.json.admin.startScreenAreas.boomerang.y = 100 - this.json.admin.startScreenAreas.boomerang.y : null;
	                this.json.admin.startScreenAreas.video.y && this.json.admin.startScreenAreas.video.y > 50 ? this.json.admin.startScreenAreas.video.y = 100 - this.json.admin.startScreenAreas.video.y : null;
	            }
	        }
	
	        // Fullscreen mode sets the scene ratios to "custom" without a size, saved as layoutAspectRatio/pictureAspectRatio {}.
	        // Copied to Single Photo, GIF and Boomerang, such a ratio does not let the wizard leave them: take the size from the scene.
	
	    }, {
	        key: "fillSceneCustomRatios",
	        value: function fillSceneCustomRatios(scenes) {
	            if (scenes.sceneLayoutAspectRatio === "custom" && (!scenes.customLayoutWidth || !scenes.customLayoutHeight)) {
	                var layout = this.toViewValue.detectAspectRatioObject(Math.round(scenes.layoutWidth), Math.round(scenes.layoutHeight));
	                scenes.customLayoutWidth = layout.w;
	                scenes.customLayoutHeight = layout.h;
	            }
	            var photo = scenes.photos && scenes.photos[0];
	            if (photo && scenes.photoAspectRatio === "custom" && (!scenes.customPhotoWidth || !scenes.customPhotoHeight)) {
	                var ratio = this.toViewValue.detectAspectRatioObject(Math.round(photo.width), Math.round(photo.height));
	                scenes.customPhotoWidth = ratio.w;
	                scenes.customPhotoHeight = ratio.h;
	            }
	        }
	    }, {
	        key: "changeScenes",
	        value: function changeScenes() {
	            if (!this.json) {
	                return;
	            }
	            if (!this.json.admin.ai.faceSwap.active) {
	                if (this.json.admin.scenes && this.json.admin.scenes.enabled && this.json.admin.scenes.scenesList.length || this.json.admin.liveView.liveViewMode === "fullscreen") {
	                    var sc = this.json.admin.scenes;
	                    this.fillSceneCustomRatios(sc);
	                    // Set single photo
	                    this.viewValue.singlePhoto.digitalFormat.customPhotoHeight = sc.customLayoutHeight;
	                    this.viewValue.singlePhoto.digitalFormat.customPhotoWidth = sc.customLayoutWidth;
	                    this.viewValue.singlePhoto.digitalFormat.layoutAspectRatio = sc.sceneLayoutAspectRatio;
	                    this.viewValue.singlePhoto.digitalFormat.layoutHeight = sc.layoutHeight;
	                    this.viewValue.singlePhoto.digitalFormat.layoutWidth = sc.layoutWidth;
	                    if (this.json.admin.scenes.enabled) {
	                        this.viewValue.singlePhoto.photoCaptureRatio = sc.photoAspectRatio;
	                    }
	                    if (this.json.admin.scenes.enabled) {
	                        this.viewValue.singlePhoto.customPhotoHeight = sc.customPhotoHeight;
	                        this.viewValue.singlePhoto.customPhotoWidth = sc.customPhotoWidth;
	                    }
	                    if (sc.scenesList.length > 0) {
	                        this.viewValue.singlePhoto.digitalFormat.photos = [{
	                            width: sc.scenesList[0].photos[0].width,
	                            height: sc.scenesList[0].photos[0].height,
	                            x: sc.scenesList[0].photos[0].x,
	                            y: sc.scenesList[0].photos[0].y,
	                            angle: sc.scenesList[0].photos[0].angle,
	                            image: true
	                        }];
	                    }
	                    this.changePhotosAspectRatio("singlePhoto");
	
	                    //set gif
	                    this.viewValue.gif.digitalFormat.customPhotoHeight = sc.customLayoutHeight;
	                    this.viewValue.gif.digitalFormat.customPhotoWidth = sc.customLayoutWidth;
	                    this.viewValue.gif.digitalFormat.layoutAspectRatio = sc.sceneLayoutAspectRatio;
	                    this.viewValue.gif.digitalFormat.layoutHeight = sc.layoutHeight;
	                    this.viewValue.gif.digitalFormat.layoutWidth = sc.layoutWidth;
	                    this.viewValue.gif.photoCaptureRatio = sc.photoAspectRatio;
	                    this.viewValue.gif.customPhotoHeight = sc.customPhotoHeight;
	                    this.viewValue.gif.customPhotoWidth = sc.customPhotoWidth;
	                    if (sc.scenesList.length > 0) {
	                        this.viewValue.gif.digitalFormat.photos = [{
	                            width: sc.scenesList[0].photos[0].width,
	                            height: sc.scenesList[0].photos[0].height,
	                            x: sc.scenesList[0].photos[0].x,
	                            y: sc.scenesList[0].photos[0].y,
	                            angle: sc.scenesList[0].photos[0].angle,
	                            gif: true
	                        }];
	                    }
	                    this.changePhotosAspectRatio("gif");
	
	                    //set boomerang
	                    this.viewValue.boomerang.digitalFormat.customPhotoHeight = sc.customLayoutHeight;
	                    this.viewValue.boomerang.digitalFormat.customPhotoWidth = sc.customLayoutWidth;
	                    this.viewValue.boomerang.digitalFormat.layoutAspectRatio = sc.sceneLayoutAspectRatio;
	                    this.viewValue.boomerang.digitalFormat.layoutHeight = sc.layoutHeight;
	                    this.viewValue.boomerang.digitalFormat.layoutWidth = sc.layoutWidth;
	                    this.viewValue.boomerang.photoCaptureRatio = sc.photoAspectRatio;
	                    this.viewValue.boomerang.customPhotoHeight = sc.customPhotoHeight;
	                    this.viewValue.boomerang.customPhotoWidth = sc.customPhotoWidth;
	                    if (sc.scenesList.length > 0) {
	                        this.viewValue.boomerang.digitalFormat.photos = [{
	                            width: sc.scenesList[0].photos[0].width,
	                            height: sc.scenesList[0].photos[0].height,
	                            x: sc.scenesList[0].photos[0].x,
	                            y: sc.scenesList[0].photos[0].y,
	                            angle: sc.scenesList[0].photos[0].angle,
	                            video: true
	                        }];
	                    }
	                    this.changePhotosAspectRatio("boomerang");
	
	                    //set video
	                    this.viewValue.video.digitalFormat.customPhotoHeight = sc.customLayoutHeight;
	                    this.viewValue.video.digitalFormat.customPhotoWidth = sc.customLayoutWidth;
	                    this.viewValue.video.digitalFormat.layoutAspectRatio = sc.sceneLayoutAspectRatio;
	                    this.viewValue.video.digitalFormat.layoutHeight = sc.layoutHeight;
	                    this.viewValue.video.digitalFormat.layoutWidth = sc.layoutWidth;
	                    this.viewValue.video.photoCaptureRatio = sc.photoAspectRatio;
	                    this.viewValue.video.customPhotoHeight = sc.customPhotoHeight;
	                    this.viewValue.video.customPhotoWidth = sc.customPhotoWidth;
	                    if (sc.scenesList.length > 0) {
	                        this.viewValue.video.digitalFormat.photos = [{
	                            width: sc.scenesList[0].photos[0].width,
	                            height: sc.scenesList[0].photos[0].height,
	                            x: sc.scenesList[0].photos[0].x,
	                            y: sc.scenesList[0].photos[0].y,
	                            angle: sc.scenesList[0].photos[0].angle,
	                            trueVideo: true
	                        }];
	                    }
	                    this.changePhotosAspectRatio("video");
	
	                    if (this.json.admin.scenes.enabled) {
	                        if (sc.scenesList.length > 0) {
	                            this.setOverlaysAndBackgroundFilesOnScenes(sc.scenesList[0]);
	                        }
	                    } else {
	                        if (this.json.admin.photoBooth.savedData === undefined) {
	                            var savedData = {
	                                sharingOverlayFiles: "",
	                                sharingBackgroundFiles: ""
	                            };
	                            (0, _assign2.default)(this.json.admin.photoBooth, { savedData: savedData });
	                        }
	                        if (this.json.admin.gifBooth.savedData === undefined) {
	                            var _savedData = {
	                                sharingOverlayFiles: "",
	                                sharingBackgroundFiles: ""
	                            };
	                            (0, _assign2.default)(this.json.admin.gifBooth, { savedData: _savedData });
	                        }
	                        if (this.json.admin.boomerangBooth.savedData === undefined) {
	                            var _savedData2 = {
	                                sharingOverlayFiles: "",
	                                sharingBackgroundFiles: ""
	                            };
	                            (0, _assign2.default)(this.json.admin.boomerangBooth, { savedData: _savedData2 });
	                        }
	                        (0, _assign2.default)(this.json.admin.photoBooth.savedData, {
	                            sharingOverlayFiles: this.json.admin.photoBooth.sharingOverlayFiles,
	                            sharingBackgroundFiles: this.json.admin.photoBooth.sharingBackgroundFiles
	                        });
	                        (0, _assign2.default)(this.json.admin.gifBooth.savedData, {
	                            sharingOverlayFiles: this.json.admin.gifBooth.sharingOverlayFiles,
	                            sharingBackgroundFiles: this.json.admin.gifBooth.sharingBackgroundFiles
	                        });
	                        (0, _assign2.default)(this.json.admin.boomerangBooth.savedData, {
	                            sharingOverlayFiles: this.json.admin.boomerangBooth.sharingOverlayFiles,
	                            sharingBackgroundFiles: this.json.admin.boomerangBooth.sharingBackgroundFiles
	                        });
	                    }
	
	                    this.json.admin.photoBooth.allowSharing = true;
	                    this.json.admin.gifBooth.allowSharing = true;
	                    this.json.admin.boomerangBooth.allowSharing = true;
	                }
	            }
	        }
	    }, {
	        key: "setOverlaysAndBackgroundFilesOnScenes",
	        value: function setOverlaysAndBackgroundFilesOnScenes(firstScene) {
	            var getFiles = function getFiles(arr) {
	                if (!arr || !arr.length || !arr[0] || !arr[0].hasOwnProperty("attachment_file")) return [];
	                return arr.map(function (file) {
	                    return file.attachment_file_alpha || file.attachment_file;
	                });
	            };
	
	            var getFirstFrameFiles = function getFirstFrameFiles(arr) {
	                if (arr && arr.length >= 1) {
	                    if (arr[0] !== null && !arr[0].hasOwnProperty("first_frame")) {
	                        return null;
	                    }
	
	                    if (arr[0].first_frame !== null) {
	                        return arr.reduce(function (newString, file) {
	                            return newString || file.first_frame_alpha || file.first_frame;
	                        }, null);
	                    } else {
	                        return arr.reduce(function (newString, file) {
	                            return newString || file.attachment_file_alpha || file.attachment_file;
	                        }, null);
	                    }
	                } else {
	                    return null;
	                }
	            };
	            this.json.admin.photoBooth.sharingBackgroundFiles = getFiles([firstScene.finalBackground]);
	            this.json.admin.photoBooth.sharingOverlayFiles = getFiles([firstScene.overlayFiles]);
	            this.json.admin.gifBooth.sharingBackgroundFiles = getFiles([firstScene.finalBackground]);
	            this.json.admin.gifBooth.sharingOverlayFiles = getFiles([firstScene.overlayFiles]);
	            this.json.admin.boomerangBooth.sharingBackgroundFiles = getFiles([firstScene.finalBackground]);
	            this.json.admin.boomerangBooth.sharingOverlayFiles = getFiles([firstScene.overlayFiles]);
	
	            if (this.json.admin.photoBooth.printBackground && !this.json.admin.photoBooth.printBackground.attachment_file) {
	                this.json.admin.photoBooth.printBackground.attachment_file = this.json.admin.photoBooth.printBackground.thumbnail_file;
	            }
	
	            var setPrintOverlay = function setPrintOverlay(booth) {
	                if (booth.printOverlay === null) {
	                    return false;
	                }
	                if (booth.printOverlay) {
	                    booth.printOverlay.attachment_file = getFirstFrameFiles(firstScene.overlayFiles, "overlay");
	                    if (booth.printOverlay.attachment_file === null) {
	                        (0, _assign2.default)(booth.printOverlay, { attachment_file: booth.printOverlay.thumbnail_file });
	                    }
	                } else {
	                    if (firstScene.overlayFiles[0] === undefined) {
	                        (0, _assign2.default)(booth, { printOverlay: null });
	                    } else {
	                        (0, _assign2.default)(booth, { printOverlay: firstScene.overlayFiles[0] });
	                        if (booth.printOverlay.attachment_file.includes(".mp4" || ".gif")) {
	                            (0, _assign2.default)(booth.printOverlay, { attachment_file: booth.printOverlay.first_frame });
	                        }
	                    }
	                }
	            };
	
	            var setPrintBackground = function setPrintBackground(booth) {
	                if (booth.printBackground !== null && booth.printBackground !== undefined) {
	                    booth.printBackground.attachment_file = getFirstFrameFiles([firstScene.finalBackground ? firstScene.finalBackground : firstScene.backgroundFiles], "background");
	                    if (booth.printBackground.attachment_file === null) {
	                        (0, _assign2.default)(booth.printBackground, { attachment_file: booth.printBackground.thumbnail_file });
	                    }
	                } else {
	                    (0, _assign2.default)(booth, { printBackground: firstScene.finalBackground ? firstScene.finalBackground[0] : null });
	                }
	                if (booth.printBackground && booth.printBackground.attachment_file === null && booth.printBackground.thumbnail_file !== null) {
	                    booth.printBackground.attachment_file = booth.printBackground.thumbnail_file;
	                }
	            };
	
	            setPrintBackground(this.json.admin.photoBooth);
	            setPrintBackground(this.json.admin.gifBooth);
	            setPrintBackground(this.json.admin.boomerangBooth);
	            setPrintOverlay(this.json.admin.photoBooth);
	            setPrintOverlay(this.json.admin.gifBooth);
	            setPrintOverlay(this.json.admin.boomerangBooth);
	        }
	    }, {
	        key: "onSceneDisable",
	        value: function onSceneDisable() {
	            if (this.json.admin.scenes && !this.json.admin.scenes.enabled) {
	                if (this.json.admin.photoBooth.savedData && this.json.admin.photoBooth.savedData.sharingOverlayFiles !== undefined) {
	                    this.json.admin.photoBooth.sharingOverlayFiles = this.json.admin.photoBooth.savedData.sharingOverlayFiles;
	                }
	                if (this.json.admin.gifBooth.savedData && this.json.admin.gifBooth.savedData.sharingOverlayFiles !== undefined) {
	                    this.json.admin.gifBooth.sharingOverlayFiles = this.json.admin.gifBooth.savedData.sharingOverlayFiles;
	                }
	                if (this.json.admin.boomerangBooth.savedData && this.json.admin.boomerangBooth.savedData.sharingOverlayFiles !== undefined) {
	                    this.json.admin.boomerangBooth.sharingOverlayFiles = this.json.admin.boomerangBooth.savedData.sharingOverlayFiles;
	                }
	                if (this.json.admin.photoBooth.savedData && this.json.admin.photoBooth.savedData.sharingBackgroundFiles !== undefined) {
	                    this.json.admin.photoBooth.sharingBackgroundFiles = this.json.admin.photoBooth.savedData.sharingBackgroundFiles;
	                }
	                if (this.json.admin.gifBooth.savedData && this.json.admin.gifBooth.savedData.sharingBackgroundFiles !== undefined) {
	                    this.json.admin.gifBooth.sharingBackgroundFiles = this.json.admin.gifBooth.savedData.sharingBackgroundFiles;
	                }
	                if (this.json.admin.boomerangBooth.savedData && this.json.admin.boomerangBooth.savedData.sharingBackgroundFiles !== undefined) {
	                    this.json.admin.boomerangBooth.sharingBackgroundFiles = this.json.admin.boomerangBooth.savedData.sharingBackgroundFiles;
	                }
	            }
	        }
	
	        /**
	         * The add-on settings (remove.bg, Replicate, Remaker, Unscreen, aging, face swap) come from their own endpoints
	         * after the page has copied the loaded configuration (copiedConfig). Makes the same change in that copy:
	         * otherwise the next step change sees a difference nobody made and saves the configuration.
	         */
	
	    }, {
	        key: "updateCopiedConfig",
	        value: function updateCopiedConfig(update) {
	            if (this.copiedConfig && this.copiedConfig.json && this.copiedConfig.json.admin) {
	                update(this.copiedConfig.json.admin);
	            }
	        }
	    }, {
	        key: "getRemoveBgData",
	        value: function getRemoveBgData() {
	            var _this14 = this;
	
	            this.$service.get("/api/configurations/" + this.$stateParams.cid + "/remove-bg/").then(function (resp) {
	                _this14.removeBg = resp;
	                _this14.removeBgIsConnectedState = resp.api_key === "" ? false : true;
	                _this14.json.admin.removeBg = _this14.removeBg;
	                _this14.updateCopiedConfig(function (admin) {
	                    admin.removeBg = (0, _lodash.cloneDeep)(resp);
	                });
	            }).catch(function (err) {
	                _this14.removeBgIsConnectedState = false;
	                _this14.toastService.showError(err.statusText, 5000, "bottom right");
	            });
	        }
	
	        /**
	         * Merges replicate-remove-bg API response into config without clobbering prompting fields
	         * that are loaded from /replicate-prompting/ when the remove-bg payload omits them.
	         */
	
	    }, {
	        key: "applyReplicateRemoveBgResponseToState",
	        value: function applyReplicateRemoveBgResponseToState(resp) {
	            var _this15 = this;
	
	            if (!resp) {
	                return;
	            }
	            this.replicate = resp;
	            if (!this.json.admin.ai.replicate) {
	                this.json.admin.ai.replicate = {};
	            }
	            var prev = (0, _lodash.cloneDeep)(this.json.admin.ai.replicate);
	            (0, _assign2.default)(this.json.admin.ai.replicate, resp);
	            var promptingKeys = ["replicate_prompting_active", "replicate_prompt_quality", "replicate_model"];
	            promptingKeys.forEach(function (key) {
	                if (resp[key] === undefined && prev[key] !== undefined) {
	                    _this15.json.admin.ai.replicate[key] = prev[key];
	                }
	            });
	            this.normalizeReplicatePromptingState(this.json.admin.ai.replicate, prev);
	            this.replicateIsConnectedState = resp.replicate_api_key === "" ? false : true;
	        }
	    }, {
	        key: "getReplicateData",
	        value: function getReplicateData() {
	            var _this16 = this;
	
	            this.$service.get("/api/configurations/" + this.$stateParams.cid + "/replicate-remove-bg/").then(function (resp) {
	                _this16.applyReplicateRemoveBgResponseToState(resp);
	                _this16.updateCopiedConfig(function (admin) {
	                    admin.ai.replicate = (0, _lodash.cloneDeep)(_this16.json.admin.ai.replicate);
	                });
	            }).catch(function (err) {
	                _this16.replicateIsConnectedState = false;
	                _this16.toastService.showError(err.statusText, 5000, "bottom right");
	            });
	        }
	    }, {
	        key: "getReplicatePromptingData",
	        value: function getReplicatePromptingData() {
	            var _this17 = this;
	
	            this.$service.get("/api/configurations/" + this.$stateParams.cid + "/replicate-prompting/").then(function (resp) {
	                if (!_this17.json.admin.ai.replicate) {
	                    _this17.json.admin.ai.replicate = {};
	                }
	                _this17.json.admin.ai.replicate.replicate_prompting_active = resp.replicate_prompting_active;
	                if (resp.replicate_api_key !== undefined && resp.replicate_api_key !== null) {
	                    _this17.json.admin.ai.replicate.replicate_api_key = resp.replicate_api_key;
	                }
	                _this17.updateCopiedConfig(function (admin) {
	                    admin.ai.replicate = (0, _lodash.cloneDeep)(_this17.json.admin.ai.replicate);
	                });
	            }).catch(function (err) {
	                _this17.toastService.showError(err.statusText, 5000, "bottom right");
	            });
	        }
	    }, {
	        key: "getRemakerData",
	        value: function getRemakerData() {
	            var _this18 = this;
	
	            this.$service.get("/api/configurations/" + this.$stateParams.cid + "/remaker-remove-bg/").then(function (resp) {
	                _this18.remaker = resp;
	                _this18.remakerIsConnectedState = resp.remaker_api_key === "" ? false : true;
	                _this18.json.admin.ai.remaker = _this18.remaker;
	                _this18.updateCopiedConfig(function (admin) {
	                    admin.ai.remaker = (0, _lodash.cloneDeep)(resp);
	                });
	            }).catch(function (err) {
	                _this18.remakerIsConnectedState = false;
	                _this18.toastService.showError(err.statusText, 5000, "bottom right");
	            });
	        }
	    }, {
	        key: "getUnscreenData",
	        value: function getUnscreenData() {
	            var _this19 = this;
	
	            this.$service.get("/api/configurations/" + this.$stateParams.cid + "/unscreen/").then(function (resp) {
	                _this19.unscreen = resp;
	                _this19.unscreenIsConnectedState = resp.us_api_key === "" ? false : true;
	                _this19.json.admin.unscreen = _this19.unscreen;
	                _this19.updateCopiedConfig(function (admin) {
	                    admin.unscreen = (0, _lodash.cloneDeep)(resp);
	                });
	            }).catch(function (err) {
	                _this19.unscreenIsConnectedState = false;
	                _this19.toastService.showError(err.statusText, 5000, "bottom right");
	            });
	        }
	    }, {
	        key: "getWondershareApiData",
	        value: function getWondershareApiData() {
	            var _this20 = this;
	
	            this.$service.get("/api/configurations/" + this.$stateParams.cid + "/wondershare-aging/").then(function (resp) {
	                _this20.wandershareApi = resp;
	                _this20.wandershareApiIsConnectedState = resp.aging_api_key === "" ? false : true;
	                (0, _assign2.default)(_this20.json.admin.ai.wandershareApi, resp);
	                (0, _assign2.default)(_this20.json.admin.ai.wandershareApi, { aging_age_slider_allowed: !resp.aging_age_slider_allowed });
	                _this20.updateCopiedConfig(function (admin) {
	                    admin.ai.wandershareApi = (0, _lodash.cloneDeep)(_this20.json.admin.ai.wandershareApi);
	                });
	            }).catch(function (err) {
	                _this20.wandershareApiIsConnectedState = false;
	                _this20.toastService.showError(err.statusText, 5000, "bottom right");
	            });
	        }
	    }, {
	        key: "getFaceSwapApiData",
	        value: function getFaceSwapApiData() {
	            var _this21 = this;
	
	            this.$service.get("/api/configurations/" + this.$stateParams.cid + "/face-swap/").then(function (resp) {
	                //Object.assign(this.faceSwapApi,resp);
	                (0, _assign2.default)(_this21.json.admin.ai.faceSwap, resp);
	                // Only the keys of the response: faceSwapScenes have another format in the copy
	                _this21.updateCopiedConfig(function (admin) {
	                    (0, _assign2.default)(admin.ai.faceSwap, (0, _lodash.cloneDeep)(resp));
	                });
	                _this21.faceSwapApiIsConnectedState = resp.face_swap_api_key === "" ? false : true;
	                //this.json.admin.ai.faceSwap = this.faceSwapApi;
	            }).catch(function (err) {
	                _this21.faceSwapApiIsConnectedState = false;
	                _this21.toastService.showError(err.statusText, 5000, "bottom right");
	            });
	        }
	    }, {
	        key: "setRemoveBgData",
	        value: function setRemoveBgData(data) {
	            var _this22 = this;
	
	            // Логіка removeBg працює незалежно від Replicate та Remaker
	            if (data.active) {
	                setTimeout(function () {
	                    _this22.$service.put("/api/configurations/" + _this22.$stateParams.cid + "/remove-bg/", data).then(function (resp) {
	                        _this22.removeBg = resp;
	                        _this22.json.admin.removeBg = _this22.removeBg;
	                        _this22.removeBgIsConnectedState = resp.api_key === "" ? false : true;
	                        _this22.saveDataInConfig();
	                    }).catch(function (err) {
	                        _this22.removeBgIsConnectedState = false;
	                        _this22.toastService.showError(err.active[0], 5000, "bottom right");
	                    });
	                }, 600);
	            } else if (!data.active) {
	                this.$service.put("/api/configurations/" + this.$stateParams.cid + "/remove-bg/", data).then(function (resp) {
	                    _this22.removeBg = resp;
	                    _this22.json.admin.removeBg = _this22.removeBg;
	                    _this22.removeBgIsConnectedState = resp.api_key === "" ? false : true;
	                    _this22.saveDataInConfig();
	                }).catch(function (err) {
	                    _this22.removeBgIsConnectedState = false;
	                    _this22.toastService.showError(err.active[0], 5000, "bottom right");
	                });
	            }
	        }
	    }, {
	        key: "setReplicateData",
	        value: function setReplicateData(data) {
	            var _this23 = this;
	
	            // Replicate працює незалежно від removeBg, але взаємовиключно з Remaker
	            if (data.replicate_remove_bg_active && this.json.admin.ai.remaker && this.json.admin.ai.remaker.remaker_remove_bg_active) {
	                // Вимикаємо Remaker, якщо вмикаємо Replicate
	                this.json.admin.ai.remaker.remaker_remove_bg_active = false;
	                this.setRemakerData({ remaker_remove_bg_active: false });
	            }
	
	            if (data.replicate_remove_bg_active) {
	                setTimeout(function () {
	                    _this23.$service.put("/api/configurations/" + _this23.$stateParams.cid + "/replicate-remove-bg/", data).then(function (resp) {
	                        _this23.applyReplicateRemoveBgResponseToState(resp);
	                        _this23.saveDataInConfig();
	                    }).catch(function (err) {
	                        _this23.replicateIsConnectedState = false;
	                        _this23.toastService.showError(err.replicate_remove_bg_active[0], 5000, "bottom right");
	                    });
	                }, 600);
	            } else if (!data.replicate_remove_bg_active) {
	                this.$service.put("/api/configurations/" + this.$stateParams.cid + "/replicate-remove-bg/", data).then(function (resp) {
	                    _this23.applyReplicateRemoveBgResponseToState(resp);
	                    _this23.saveDataInConfig();
	                }).catch(function (err) {
	                    _this23.replicateIsConnectedState = false;
	                    _this23.toastService.showError(err.replicate_remove_bg_active[0], 5000, "bottom right");
	                });
	            }
	        }
	    }, {
	        key: "setRemakerData",
	        value: function setRemakerData(data) {
	            var _this24 = this;
	
	            // Remaker працює незалежно від removeBg, але взаємовиключно з Replicate
	            if (data.remaker_remove_bg_active && this.json.admin.ai.replicate && this.json.admin.ai.replicate.replicate_remove_bg_active) {
	                // Вимикаємо Replicate, якщо вмикаємо Remaker
	                this.json.admin.ai.replicate.replicate_remove_bg_active = false;
	                this.setReplicateData({ replicate_remove_bg_active: false });
	            }
	
	            if (data.remaker_remove_bg_active) {
	                setTimeout(function () {
	                    _this24.$service.put("/api/configurations/" + _this24.$stateParams.cid + "/remaker-remove-bg/", data).then(function (resp) {
	                        _this24.remaker = resp;
	                        _this24.json.admin.ai.remaker = _this24.remaker;
	                        _this24.remakerIsConnectedState = resp.remaker_api_key === "" ? false : true;
	                        _this24.saveDataInConfig();
	                    }).catch(function (err) {
	                        _this24.remakerIsConnectedState = false;
	                        _this24.toastService.showError(err.remaker_remove_bg_active[0], 5000, "bottom right");
	                    });
	                }, 600);
	            } else if (!data.remaker_remove_bg_active) {
	                this.$service.put("/api/configurations/" + this.$stateParams.cid + "/remaker-remove-bg/", data).then(function (resp) {
	                    _this24.remaker = resp;
	                    _this24.json.admin.ai.remaker = _this24.remaker;
	                    _this24.remakerIsConnectedState = resp.remaker_api_key === "" ? false : true;
	                    _this24.saveDataInConfig();
	                }).catch(function (err) {
	                    _this24.remakerIsConnectedState = false;
	                    _this24.toastService.showError(err.remaker_remove_bg_active[0], 5000, "bottom right");
	                });
	            }
	        }
	    }, {
	        key: "setKeyReplicateData",
	        value: function setKeyReplicateData(data) {
	            var _this25 = this;
	
	            this.$service.put("/api/configurations/" + this.$stateParams.cid + "/replicate-remove-bg/", data).then(function (resp) {
	                _this25.applyReplicateRemoveBgResponseToState(resp);
	                _this25.saveDataInConfig();
	                if (resp.replicate_api_key !== "") {
	                    _this25.toastService.showSimple("API key was added successfully", 5000);
	                } else {
	                    _this25.toastService.showError("Enter API key", 5000, "bottom right");
	                }
	                _this25.connectReplicate();
	            }).catch(function (err) {
	                _this25.replicateIsConnectedState = false;
	                if (err.status === 403) {
	                    _this25.replicate = err.data;
	                    _this25.toastService.showError("Forbidden", 5000, "bottom right");
	                } else {
	                    if (err.data && err.data.assigned) {
	                        err.data.assigned.forEach(function (text) {
	                            _this25.toastService.showError(text, 5000, "bottom right");
	                        });
	                    } else if (err.data && err.data.replicate_remove_bg_active) {
	                        _this25.toastService.showError(err.data.replicate_remove_bg_active[0], 5000, "bottom right");
	                    }
	                }
	            });
	        }
	    }, {
	        key: "connectReplicate",
	        value: function connectReplicate() {
	            this.showReplicateApiKeyForm = !this.showReplicateApiKeyForm;
	        }
	    }, {
	        key: "normalizeReplicatePromptingState",
	        value: function normalizeReplicatePromptingState(replicateConfig, fallbackConfig) {
	            if (!replicateConfig) {
	                return;
	            }
	
	            if (replicateConfig.replicate_prompting_active === undefined) {
	                replicateConfig.replicate_prompting_active = false;
	            }
	
	            if (!REPLICATE_PROMPT_MODELS[replicateConfig.replicate_prompt_quality]) {
	                if (fallbackConfig && REPLICATE_PROMPT_MODELS[fallbackConfig.replicate_prompt_quality]) {
	                    replicateConfig.replicate_prompt_quality = fallbackConfig.replicate_prompt_quality;
	                } else {
	                    replicateConfig.replicate_prompt_quality = REPLICATE_PROMPT_DEFAULT_QUALITY;
	                }
	            }
	
	            if (!replicateConfig.replicate_model) {
	                replicateConfig.replicate_model = REPLICATE_PROMPT_MODELS[replicateConfig.replicate_prompt_quality];
	            }
	        }
	    }, {
	        key: "setReplicatePromptingQuality",
	        value: function setReplicatePromptingQuality(quality) {
	            if (!REPLICATE_PROMPT_MODELS[quality]) {
	                return;
	            }
	
	            if (!this.json.admin.ai.replicate) {
	                this.json.admin.ai.replicate = {};
	            }
	
	            // Optimistic UI update: backend may not echo custom prompting fields back
	            this.json.admin.ai.replicate.replicate_prompting_active = true;
	            this.json.admin.ai.replicate.replicate_prompt_quality = quality;
	            this.json.admin.ai.replicate.replicate_model = REPLICATE_PROMPT_MODELS[quality];
	
	            var payload = {
	                replicate_prompting_active: true,
	                replicate_prompt_quality: quality,
	                replicate_model: REPLICATE_PROMPT_MODELS[quality]
	            };
	
	            if (this.json.admin.ai.replicate && this.json.admin.ai.replicate.replicate_remove_bg_active !== undefined) {
	                payload.replicate_remove_bg_active = this.json.admin.ai.replicate.replicate_remove_bg_active;
	            }
	
	            this.setReplicateData(payload);
	        }
	    }, {
	        key: "onReplicatePromptingToggle",
	        value: function onReplicatePromptingToggle() {
	            var _this26 = this;
	
	            if (!this.json.admin.ai.replicate) {
	                this.json.admin.ai.replicate = {};
	            }
	
	            var previousValue = !this.json.admin.ai.replicate.replicate_prompting_active;
	            var currentValue = this.json.admin.ai.replicate.replicate_prompting_active;
	
	            var payload = {
	                replicate_prompting_active: currentValue
	            };
	
	            if (this.json.admin.ai.replicate.replicate_api_key !== undefined) {
	                payload.replicate_api_key = this.json.admin.ai.replicate.replicate_api_key;
	            }
	
	            this.$service.put("/api/configurations/" + this.$stateParams.cid + "/replicate-prompting/", payload).then(function (resp) {
	                if (!_this26.json.admin.ai.replicate) {
	                    _this26.json.admin.ai.replicate = {};
	                }
	                _this26.json.admin.ai.replicate.replicate_prompting_active = resp.replicate_prompting_active;
	                if (resp.replicate_api_key !== undefined && resp.replicate_api_key !== null) {
	                    _this26.json.admin.ai.replicate.replicate_api_key = resp.replicate_api_key;
	                }
	            }).catch(function (err) {
	                _this26.json.admin.ai.replicate.replicate_prompting_active = previousValue;
	                var errorMessage = err && err.data && err.data.replicate_prompting_active ? err.data.replicate_prompting_active[0] : err.statusText;
	                _this26.toastService.showError(errorMessage, 5000, "bottom right");
	            });
	        }
	    }, {
	        key: "setKeyRemakerData",
	        value: function setKeyRemakerData(data) {
	            var _this27 = this;
	
	            this.$service.put("/api/configurations/" + this.$stateParams.cid + "/remaker-remove-bg/", data).then(function (resp) {
	                _this27.remaker = resp;
	                _this27.json.admin.ai.remaker = _this27.remaker;
	                _this27.remakerIsConnectedState = resp.remaker_api_key === "" ? false : true;
	                _this27.saveDataInConfig();
	                if (resp.remaker_api_key !== "") {
	                    _this27.toastService.showSimple("API key was added successfully", 5000);
	                } else {
	                    _this27.toastService.showError("Enter API key", 5000, "bottom right");
	                }
	                _this27.connectRemaker();
	            }).catch(function (err) {
	                _this27.remakerIsConnectedState = false;
	                if (err.status === 403) {
	                    _this27.remaker = err.data;
	                    _this27.toastService.showError("Forbidden", 5000, "bottom right");
	                } else {
	                    if (err.data && err.data.assigned) {
	                        err.data.assigned.forEach(function (text) {
	                            _this27.toastService.showError(text, 5000, "bottom right");
	                        });
	                    } else if (err.data && err.data.remaker_remove_bg_active) {
	                        _this27.toastService.showError(err.data.remaker_remove_bg_active[0], 5000, "bottom right");
	                    } else if (err.data && err.data.remaker_api_key) {
	                        _this27.toastService.showError(err.data.remaker_api_key[0], 5000, "bottom right");
	                    }
	                }
	            });
	        }
	    }, {
	        key: "connectRemaker",
	        value: function connectRemaker() {
	            this.showRemakerApiKeyForm = !this.showRemakerApiKeyForm;
	        }
	    }, {
	        key: "setUnscreenData",
	        value: function setUnscreenData(data) {
	            var _this28 = this;
	
	            this.$service.put("/api/configurations/" + this.$stateParams.cid + "/unscreen/", data).then(function (resp) {
	                _this28.unscreen = resp;
	                _this28.json.admin.unscreen = _this28.unscreen;
	                _this28.unscreenIsConnectedState = resp.us_api_key === "" ? false : true;
	                _this28.saveDataInConfig();
	            }).catch(function (err) {
	                _this28.unscreenIsConnectedState = false;
	                err.data.assigned.forEach(function (text) {
	                    _this28.toastService.showError(text, 5000, "bottom right");
	                });
	            });
	        }
	    }, {
	        key: "setWandershareApiData",
	        value: function setWandershareApiData(data) {
	            var _this29 = this;
	
	            this.$service.put("/api/configurations/" + this.$stateParams.cid + "/wondershare-aging/", data).then(function (resp) {
	                _this29.wandershareApi = resp;
	                //Object.assign(this.json.admin.ai.wandershareApi,resp);
	                _this29.wandershareApiIsConnectedState = resp.aging_api_key === "" ? false : true;
	                //this.saveDataInConfig();
	            }).catch(function (err) {
	                _this29.wandershareApiIsConnectedState = false;
	                err.data.assigned.forEach(function (text) {
	                    _this29.toastService.showError(text, 5000, "bottom right");
	                });
	            });
	        }
	    }, {
	        key: "setFaceSwapApiData",
	        value: function setFaceSwapApiData(data) {
	            var _this30 = this;
	
	            this.$service.put("/api/configurations/" + this.$stateParams.cid + "/face-swap/", data).then(function (resp) {
	                (0, _assign2.default)(_this30.json.admin.ai.faceSwap, resp);
	                _this30.json.admin.ai.faceSwap.faceSwapScenes.enabled = resp.face_swap_active;
	                _this30.json.admin.ai.faceSwap.faceSwapOverlays.enabled = resp.face_swap_active;
	                _this30.faceSwapApiIsConnectedState = resp.face_swap_api_key === "" ? false : true;
	                _this30.saveDataInConfig();
	            }).catch(function (err) {
	                _this30.faceSwapApiIsConnectedState = false;
	                err.data.assigned.forEach(function (text) {
	                    _this30.toastService.showError(text, 5000, "bottom right");
	                });
	            });
	        }
	    }, {
	        key: "onChangeMultiFaceswap",
	        value: function onChangeMultiFaceswap(data) {
	            var _this31 = this;
	
	            this.$service.put("/api/configurations/" + this.$stateParams.cid + "/face-swap/", { face_swap_multi_active: data }).then(function (resp) {
	                _this31.json.admin.ai.faceSwap.face_swap_multi_active = resp.face_swap_multi_active;
	                _this31.saveDataInConfig();
	            }).catch(function (err) {
	                _this31.faceSwapApiIsConnectedState = false;
	                err.data.assigned.forEach(function (text) {
	                    _this31.toastService.showError(text, 5000, "bottom right");
	                });
	            });
	        }
	    }, {
	        key: "setLocalRemoveBgState",
	        value: function setLocalRemoveBgState(data) {
	            var _this32 = this;
	
	            if (data.remove_bg_offline_active) {
	                setTimeout(function () {
	                    _this32.$service.put("/api/configurations/" + _this32.$stateParams.cid + "/remove-bg-offline/", data).then(function () {
	                        _this32.saveDataInConfig();
	                    }).catch(function (err) {
	                        _this32.toastService.showError(err.remove_bg_offline_active[0], 5000, "bottom right");
	                    });
	                }, 600);
	            } else if (!data.remove_bg_offline_active) {
	                this.$service.put("/api/configurations/" + this.$stateParams.cid + "/remove-bg-offline/", data).then(function (resp) {
	                    _this32.json.admin.removeBgOffline = resp;
	                    _this32.saveDataInConfig();
	                }).catch(function (err) {
	                    _this32.toastService.showError(err.remove_bg_offline_active[0], 5000, "bottom right");
	                });
	            }
	        }
	    }, {
	        key: "setKeyRemoveBgData",
	        value: function setKeyRemoveBgData(data) {
	            var _this33 = this;
	
	            this.$service.put("/api/configurations/" + this.$stateParams.cid + "/remove-bg/", data).then(function (resp) {
	                _this33.removeBg = resp;
	                _this33.json.admin.removeBg = _this33.removeBg;
	                _this33.removeBgIsConnectedState = resp.api_key === "" ? false : true;
	                _this33.saveDataInConfig();
	                if (resp.api_key !== "") {
	                    _this33.toastService.showSimple("API key was added successfully", 5000);
	                } else {
	                    _this33.toastService.showError("Enter API key", 5000, "bottom right");
	                }
	                _this33.connectRemoveBg();
	            }).catch(function (err) {
	                _this33.removeBgIsConnectedState = false;
	                if (err.status === 403) {
	                    _this33.removeBg = err.data;
	                    _this33.toastService.showError("Forbidden", 5000, "bottom right");
	                } else {
	                    err.data.assigned.forEach(function (text) {
	                        _this33.toastService.showError(text, 5000, "bottom right");
	                    });
	                }
	            });
	        }
	    }, {
	        key: "setKeyWandershareApiData",
	        value: function setKeyWandershareApiData(data) {
	            var _this34 = this;
	
	            this.$service.put("/api/configurations/" + this.$stateParams.cid + "/wondershare-aging/", data).then(function (resp) {
	                _this34.wandershareApi = resp;
	                //Object.assign(this.json.admin.ai.wandershareApi,resp);
	                _this34.wandershareApiIsConnectedState = resp.aging_api_key === "" ? false : true;
	                _this34.saveDataInConfig();
	                if (resp.api_key !== "") {
	                    _this34.toastService.showSimple("API key was added successfully", 5000);
	                } else {
	                    _this34.toastService.showError("Enter API key", 5000, "bottom right");
	                }
	                _this34.connectWandershareApi();
	            }).catch(function (err) {
	                _this34.wandershareApiIsConnectedState = false;
	                if (err.status === 403) {
	                    _this34.wandershareApi = err.data;
	                    _this34.toastService.showError("Forbidden", 5000, "bottom right");
	                } else {
	                    if (err.data) {
	                        err.data.assigned.forEach(function (text) {
	                            _this34.toastService.showError(text, 5000, "bottom right");
	                        });
	                    }
	                }
	            });
	        }
	    }, {
	        key: "setKeyFaceSwapApiData",
	        value: function setKeyFaceSwapApiData(data) {
	            var _this35 = this;
	
	            this.$service.put("/api/configurations/" + this.$stateParams.cid + "/face-swap/", data).then(function (resp) {
	                //Object.assign(this.faceSwapApi,resp);
	                (0, _assign2.default)(_this35.json.admin.ai.faceSwap, resp);
	                _this35.faceSwapApiIsConnectedState = resp.face_swap_api_key === "" ? false : true;
	                _this35.json.admin.ai.faceSwap.faceSwapScenes.enabled = resp.face_swap_active;
	                _this35.json.admin.ai.faceSwap.faceSwapOverlays.enabled = resp.face_swap_active;
	                _this35.saveDataInConfig();
	                if (resp.face_swap_api_key !== "") {
	                    _this35.toastService.showSimple("API key was added successfully", 5000);
	                } else {
	                    _this35.toastService.showError("Enter API key", 5000, "bottom right");
	                }
	                _this35.showFaceSwapApiKeyForm = true;
	            }).catch(function (err) {
	                _this35.faceSwapApiIsConnectedState = false;
	                if (err.status === 403) {
	                    (0, _assign2.default)(_this35.json.admin.ai.faceSwap, err.data);
	                    _this35.toastService.showError("Forbidden", 5000, "bottom right");
	                } else {
	                    if (err.data) {
	                        err.data.assigned.forEach(function (text) {
	                            _this35.toastService.showError(text, 5000, "bottom right");
	                        });
	                    }
	                }
	            });
	        }
	    }, {
	        key: "connectRemoveBg",
	        value: function connectRemoveBg() {
	            this.showApiKeyForm = !this.showApiKeyForm;
	        }
	    }, {
	        key: "connectUnscreen",
	        value: function connectUnscreen() {
	            this.showUnscreenApiKeyForm = !this.showUnscreenApiKeyForm;
	        }
	    }, {
	        key: "connectWandershareApi",
	        value: function connectWandershareApi() {
	            this.showWandershareApiKeyForm = !this.showWandershareApiKeyForm;
	        }
	    }, {
	        key: "connectFaceSwapApi",
	        value: function connectFaceSwapApi() {
	            this.showFaceSwapApiKeyForm = !this.showFaceSwapApiKeyForm;
	        }
	    }, {
	        key: "saveDataInConfig",
	        value: function saveDataInConfig() {
	            if (this.canExitSharingScreen() && this.canExitScreen("singlePhoto", "photoBooth") && this.canExitScreen("gif", "gifBooth") && this.canExitScreen("boomerang", "boomerangBooth") && this.canExitStartScreen() && this.canExitCustomButtons() && this.canExitScenes() && this.canExitFaceSwapScenes() && this.canExitFaceSwapOverlays() && this.canExitForms()) {
	                this.checkDesignForAllModes();
	                this.changeScenes();
	                this.saveConfiguration(false);
	            } else if (!this.loading) {
	                this.canExitWizard();
	            }
	        }
	    }, {
	        key: "changeEmailState",
	        value: function changeEmailState() {
	            this.json.admin.offlineForms.formInputs[1].required = true;
	        }
	    }, {
	        key: "changeStandByScreenState",
	        value: function changeStandByScreenState(state) {
	            if (!state) this.json.admin.standbyScreenAfterEachSession = false;
	        }
	    }, {
	        key: "ensureIndividualText",
	        value: function ensureIndividualText() {
	            if (!this.json || !this.json.admin) {
	                return;
	            }
	            this.json.admin.individualText = (0, _individualText.normalizeIndividualText)(this.json.admin.individualText, this.getIndividualTextScreenSize(), this.getSinglePhotoCanvasSize(), this.getIndividualTextOutput());
	        }
	
	        /**
	         * The picture the texts go on, like the Scenes tab "Scene preview - Digital": with the scenes on,
	         * the first scene on the Digital layout (the screen size in the fullscreen live view mode);
	         * with the scenes off, the photo over the whole screen of the General tab.
	         */
	
	    }, {
	        key: "getIndividualTextOutput",
	        value: function getIndividualTextOutput() {
	            var admin = this.json.admin;
	            var general = admin.general || {};
	            var scenes = admin.scenes || {};
	            var getFiles = function getFiles(files) {
	                return (files || []).filter(Boolean).map(function (file) {
	                    return file.attachment_file_alpha || file.attachment_file;
	                });
	            };
	            if (scenes.enabled) {
	                // The Size of the Scenes tab, in fullscreen too: layoutWidth/Height while editing, finalSize as saved
	                // (before the Scenes values are built)
	                var layout = {
	                    width: scenes.layoutWidth || scenes.finalSize && scenes.finalSize.width,
	                    height: scenes.layoutHeight || scenes.finalSize && scenes.finalSize.height
	                };
	                // Before the first scene is created the size is still the scenes layout, as in "Scene preview - Digital"
	                var scene = scenes.scenesList && scenes.scenesList[0] || {};
	                return {
	                    width: layout.width || general.width,
	                    height: layout.height || general.height,
	                    // 3:2, 2:3 or 1:1 as named in the Scenes tab; a custom ratio is taken from the size
	                    ratio: scenes.sceneLayoutAspectRatio === "custom" ? null : this.toBoothValue.getSceneRatio(scenes.sceneLayoutAspectRatio),
	                    background: getFiles(scene.backgroundFiles),
	                    overlay: getFiles(scene.overlayFiles),
	                    areas: scenes.photos,
	                    animationTime: scene.animationTime
	                };
	            }
	            return {
	                width: general.width,
	                height: general.height,
	                background: [],
	                overlay: [],
	                areas: [{ x: 0, y: 0, width: general.width, height: general.height, image: true }]
	            };
	        }
	
	        /** "(9:16, 1080x1920px)" after a preview title; the ratio of the size unless given as {width, height}. */
	
	    }, {
	        key: "getIndividualTextSizeTitle",
	        value: function getIndividualTextSizeTitle(width, height, ratio) {
	            width = Math.round(width);
	            height = Math.round(height);
	            if (!width || !height) {
	                return "";
	            }
	            var r = ratio && ratio.width && ratio.height ? { w: ratio.width, h: ratio.height } : this.toViewValue.detectAspectRatioObject(width, height);
	            return "(" + r.w + ":" + r.h + ", " + width + "x" + height + "px)";
	        }
	
	        /** The screen of the Screen preview is always the screen of the General tab, with the scenes on too. */
	
	    }, {
	        key: "getIndividualTextScreenSize",
	        value: function getIndividualTextScreenSize() {
	            var general = this.json.admin.general || {};
	            return { width: general.width, height: general.height };
	        }
	    }, {
	        key: "getIndividualTextScreenTitle",
	        value: function getIndividualTextScreenTitle() {
	            var screen = this.getIndividualTextScreenSize();
	            return this.getIndividualTextSizeTitle(screen.width, screen.height);
	        }
	    }, {
	        key: "getIndividualTextOutputTitle",
	        value: function getIndividualTextOutputTitle() {
	            var output = this.getIndividualTextOutput();
	            return this.getIndividualTextSizeTitle(output.width, output.height, output.ratio);
	        }
	
	        /** Single Photo print canvas (px) from the saved config, before viewValue is built; null when unknown. */
	
	    }, {
	        key: "getSinglePhotoCanvasSize",
	        value: function getSinglePhotoCanvasSize() {
	            try {
	                var admin = this.json.admin;
	                var size = (0, _printFormatsConstant.getPixelsForFormat)(this.toViewValue.getPrintLayoutRatio("photoBooth", admin), this.toViewValue.getPrintDpi("photoBooth", admin));
	                return size && size.width && size.height ? size : null;
	            } catch (error) {
	                return null;
	            }
	        }
	    }, {
	        key: "isIndividualTextPortrait",
	        value: function isIndividualTextPortrait() {
	            return this.json.admin.general.screenOrientation === "portrait";
	        }
	
	        /**
	         * Places the two previews in the free space of the previews column (individualTextPreviewSpace):
	         * side by side with one height, or one under the other sharing the height so both get about the same area.
	         * Picks the variant where the smaller preview is bigger. Both fit the window height, so the sticky column stays visible.
	         */
	
	    }, {
	        key: "getIndividualTextPreviewLayout",
	        value: function getIndividualTextPreviewLayout() {
	            var screen = this.getIndividualTextScreenSize();
	            var space = this.individualTextPreviewSpace || { width: 500, height: 900 };
	            var screenRatio = screen.width / screen.height;
	            var outputRatio = this.getIndividualTextOutputRatio() || 2 / 3;
	            // Titles above a preview and the gap between previews, px
	            var title = 80;
	            var gap = 24;
	            // The app header and the titles above the first row; a small window still gets readable previews
	            var height = Math.max(360, space.height - 50 - title);
	            var width = Math.max(300, space.width - 8);
	
	            var rowHeight = Math.min(height, (width - gap) / (screenRatio + outputRatio));
	            var row = { row: true, screenHeight: rowHeight, outputHeight: rowHeight };
	
	            // One under the other: equal areas, then each no wider than the column, the freed height to the other one
	            var columnHeight = height - title;
	            var screenHeight = Math.min(columnHeight / (1 + Math.sqrt(screenRatio / outputRatio)), width / screenRatio);
	            var outputHeight = Math.min(columnHeight - screenHeight, width / outputRatio);
	            screenHeight = Math.min(columnHeight - outputHeight, width / screenRatio);
	            var column = { row: false, screenHeight: screenHeight, outputHeight: outputHeight };
	
	            var smallerArea = function smallerArea(layout) {
	                return Math.min(layout.screenHeight * layout.screenHeight * screenRatio, layout.outputHeight * layout.outputHeight * outputRatio);
	            };
	            return smallerArea(row) >= smallerArea(column) ? row : column;
	        }
	    }, {
	        key: "getIndividualTextScreenIndex",
	        value: function getIndividualTextScreenIndex() {
	            return this.getIndividualTextScreenSize().height / this.getIndividualTextPreviewLayout().screenHeight;
	        }
	
	        /** The output picture on the screen keeps the proportions of the output picture. */
	
	    }, {
	        key: "getIndividualTextOutputRatio",
	        value: function getIndividualTextOutputRatio() {
	            var output = this.getIndividualTextOutput();
	            return output.width && output.height ? output.width / output.height : null;
	        }
	
	        /** Never smaller than the picture inside the screen preview. */
	
	    }, {
	        key: "getIndividualTextOutputIndex",
	        value: function getIndividualTextOutputIndex() {
	            var output = this.getIndividualTextOutput();
	            if (!output.height) {
	                return 1;
	            }
	            var fit = output.height / this.getIndividualTextPreviewLayout().outputHeight;
	            return Math.min(fit, this.getIndividualTextOutputIndexInScreen());
	        }
	
	        /** html-preview index that fits the output picture into the output box on the screen preview. */
	
	    }, {
	        key: "getIndividualTextOutputIndexInScreen",
	        value: function getIndividualTextOutputIndexInScreen() {
	            var area = this.json.admin.individualText.outputPreview;
	            var screenIndex = this.getIndividualTextScreenIndex();
	            var screen = this.getIndividualTextScreenSize();
	            var boxWidth = area.width / 100 * screen.width / screenIndex;
	            var boxHeight = area.height / 100 * screen.height / screenIndex;
	            var output = this.getIndividualTextOutput();
	            if (!boxWidth || !boxHeight || !output.width || !output.height) {
	                return 1;
	            }
	            return Math.max(output.width / boxWidth, output.height / boxHeight);
	        }
	    }, {
	        key: "clampIndividualTextOutput",
	        value: function clampIndividualTextOutput(field, changed) {
	            var output = this.getIndividualTextOutput();
	            (0, _individualText.clampOutputPosition)(field.output, output.width, output.height, changed);
	        }
	
	        /** Min. font size is not bigger than the font size. */
	
	    }, {
	        key: "clampIndividualTextExplanation",
	        value: function clampIndividualTextExplanation() {
	            var explanation = this.json.admin.individualText.explanation;
	            explanation.fontSize = Math.max(1, Number(explanation.fontSize) || 1);
	            explanation.minFontSize = Math.min(Math.max(1, Number(explanation.minFontSize) || 1), explanation.fontSize);
	        }
	
	        /**
	         * The screen size and the output picture (Scenes, General) change on other tabs, while the Individual Text tab is not shown.
	         * Fits its elements right away: its inputs would otherwise empty the values out of their new limits.
	         */
	
	    }, {
	        key: "watchIndividualTextLayout",
	        value: function watchIndividualTextLayout() {
	            var _this36 = this;
	
	            this.$scope.$watchGroup([function () {
	                return _this36.json && _this36.getIndividualTextScreenSize().width;
	            }, function () {
	                return _this36.json && _this36.getIndividualTextScreenSize().height;
	            }], function () {
	                return _this36.fitIndividualTextScreen();
	            });
	
	            this.$scope.$watchGroup([function () {
	                return _this36.json && _this36.getIndividualTextOutput().width;
	            }, function () {
	                return _this36.json && _this36.getIndividualTextOutput().height;
	            }], function (size) {
	                var settings = _this36.json && _this36.json.admin.individualText;
	                if (!settings || !size[0] || !size[1]) {
	                    return;
	                }
	                // Positions are % of the picture and keep their place; px font sizes follow its height,
	                // also when the picture changed on another tab or in another session (outputSize is the saved one)
	                var saved = settings.outputSize;
	                if (saved && saved.height && saved.height !== size[1]) {
	                    settings.fields.forEach(function (field) {
	                        return (0, _individualText.scaleOutputFont)(field.output, size[1] / saved.height);
	                    });
	                }
	                settings.outputSize = { width: size[0], height: size[1] };
	                settings.fields.forEach(function (field) {
	                    return (0, _individualText.clampOutputPosition)(field.output, size[0], size[1]);
	                });
	                _this36.fitIndividualTextScreen();
	            });
	        }
	    }, {
	        key: "fitIndividualTextScreen",
	        value: function fitIndividualTextScreen() {
	            var settings = this.json && this.json.admin.individualText;
	            var screen = this.json && this.getIndividualTextScreenSize();
	            if (!settings || !screen || !screen.width || !screen.height) {
	                return;
	            }
	            var ratio = this.getIndividualTextOutputRatio();
	            if (ratio) {
	                // Same px proportions as the print layout: width is % of the screen width, height % of its height
	                settings.outputPreview.width = settings.outputPreview.height * ratio * screen.height / screen.width;
	            }
	            (0, _individualText.clampScreenArea)(settings.outputPreview, true);
	            [settings.explanation.area, settings.doneButton].concat(settings.fields.map(function (field) {
	                return field.area;
	            })).forEach(function (area) {
	                return (0, _individualText.clampScreenArea)(area);
	            });
	        }
	
	        /** Keeps the cloud text within the field's allowed input. */
	
	    }, {
	        key: "sanitizeIndividualTextValue",
	        value: function sanitizeIndividualTextValue(field) {
	            field.output.text = (0, _individualText.sanitizeIndividualText)(field.output.text, field.inputType);
	        }
	    }, {
	        key: "deleteIndividualTextAttachment",
	        value: function deleteIndividualTextAttachment(owner, key) {
	            var attachment = owner[key];
	            owner[key] = null;
	            this.deleteCompanyAttachment(attachment);
	        }
	    }, {
	        key: "getDefaultOfflineQrCode",
	        value: function getDefaultOfflineQrCode() {
	            return {
	                enabled: false,
	                background: null,
	                doneButton: {
	                    width: 6,
	                    height: 6,
	                    x: 89,
	                    y: 92.5,
	                    customIcon: null
	                },
	                qrCode: {
	                    width: 7,
	                    height: 7,
	                    x: 50,
	                    y: 11
	                }
	            };
	        }
	    }, {
	        key: "ensureOfflineQrCode",
	        value: function ensureOfflineQrCode() {
	            if (!this.json || !this.json.admin) {
	                return;
	            }
	            if (!this.json.admin.offlineQrCode) {
	                this.json.admin.offlineQrCode = this.getDefaultOfflineQrCode();
	                return;
	            }
	            var defaults = this.getDefaultOfflineQrCode();
	            var offlineQr = this.json.admin.offlineQrCode;
	            if (offlineQr.enabled === undefined) {
	                offlineQr.enabled = false;
	            }
	            if (offlineQr.background === undefined) {
	                offlineQr.background = null;
	            }
	            offlineQr.doneButton = this.normalizeOfflineQrArea(offlineQr.doneButton, defaults.doneButton, true);
	            offlineQr.qrCode = this.normalizeOfflineQrArea(offlineQr.qrCode, defaults.qrCode, false);
	        }
	    }, {
	        key: "normalizeOfflineQrArea",
	        value: function normalizeOfflineQrArea(area, defaults, keepIcon) {
	            var source = area && (typeof area === "undefined" ? "undefined" : (0, _typeof3.default)(area)) === "object" ? area : {};
	            source.width = this.normalizeOfflineQrNumber(source.width, defaults.width);
	            source.height = this.normalizeOfflineQrNumber(source.height, defaults.height);
	            source.x = this.normalizeOfflineQrNumber(source.x, defaults.x);
	            source.y = this.normalizeOfflineQrNumber(source.y, defaults.y);
	            if (keepIcon) {
	                if (source.customIcon === undefined) {
	                    source.customIcon = null;
	                }
	            } else {
	                delete source.customIcon;
	            }
	            return source;
	        }
	    }, {
	        key: "normalizeOfflineQrNumber",
	        value: function normalizeOfflineQrNumber(value, fallback) {
	            var parsed = Number(value);
	            return (0, _isFinite2.default)(parsed) ? parsed : fallback;
	        }
	    }, {
	        key: "isOfflineQrLayoutValid",
	        value: function isOfflineQrLayoutValid(offlineQr) {
	            return this.isOfflineQrAreaValid(offlineQr.doneButton) && this.isOfflineQrAreaValid(offlineQr.qrCode);
	        }
	    }, {
	        key: "isOfflineQrAreaValid",
	        value: function isOfflineQrAreaValid(area) {
	            return !!(area && area.width && area.height && typeof area.x === "number" && typeof area.y === "number");
	        }
	    }, {
	        key: "deleteOfflineQrBackground",
	        value: function deleteOfflineQrBackground() {
	            if (!this.json || !this.json.admin || !this.json.admin.offlineQrCode) {
	                return;
	            }
	            var background = this.json.admin.offlineQrCode.background;
	            this.json.admin.offlineQrCode.background = null;
	            this.deleteCompanyAttachment(background);
	        }
	    }, {
	        key: "deleteCompanyAttachment",
	        value: function deleteCompanyAttachment(attachment) {
	            if (!this.config || !this.config.company || !attachment) {
	                return;
	            }
	            this.$upload.deleteCompanyAttachment(this.config.company + "attachments/", attachment);
	        }
	    }, {
	        key: "getOfflineQrBackgroundFile",
	        value: function getOfflineQrBackgroundFile() {
	            var background = this.json && this.json.admin && this.json.admin.offlineQrCode ? this.json.admin.offlineQrCode.background : null;
	            if (!background || !background.attachment_file || typeof background.attachment_file !== "string") {
	                return "";
	            }
	            return background.attachment_file;
	        }
	    }, {
	        key: "getOfflineQrBackgroundMode",
	        value: function getOfflineQrBackgroundMode() {
	            return this.getOfflineQrBackgroundFile() ? "image" : "color";
	        }
	    }, {
	        key: "getOfflineQrBackgroundForPreview",
	        value: function getOfflineQrBackgroundForPreview() {
	            var file = this.getOfflineQrBackgroundFile();
	            if (!file || this.getFileType({ attachment_file: file }) === "mp4") {
	                return "[]";
	            }
	            return (0, _stringify2.default)([file]);
	        }
	    }, {
	        key: "getOfflineQrVideoBackground",
	        value: function getOfflineQrVideoBackground() {
	            var file = this.getOfflineQrBackgroundFile();
	            return file && this.getFileType({ attachment_file: file }) === "mp4" ? file : "";
	        }
	    }, {
	        key: "getOfflineQrPreviewAreas",
	        value: function getOfflineQrPreviewAreas() {
	            if (!this.json || !this.json.admin || !this.json.admin.offlineQrCode) {
	                return {};
	            }
	            return {
	                done: this.json.admin.offlineQrCode.doneButton,
	                qrCode: this.json.admin.offlineQrCode.qrCode
	            };
	        }
	    }, {
	        key: "checkIsVideo",
	        value: function checkIsVideo(name) {
	            if (name === undefined || name === null) {
	                return false;
	            } else {
	                return name.indexOf(".mp4") !== -1 || name.indexOf(".webm") !== -1;
	            }
	        }
	    }, {
	        key: "deleteOfflineFormsBackground",
	        value: function deleteOfflineFormsBackground() {
	            var _this37 = this;
	
	            this.$upload.delete(this.json.admin.offlineForms.backgroundImage.url).then(function () {
	                _this37.json.admin.offlineForms.backgroundImage = null;
	                _this37.saveDataInConfig();
	            });
	        }
	    }, {
	        key: "setCheckboxesLikeRadiobutton",
	        value: function setCheckboxesLikeRadiobutton(val) {
	            this.json.admin.offlineForms.formCheckboxes.map(function (el) {
	                if (!el.isInfobox) {
	                    el.typeIsCheckbox = val;
	                } else {
	                    el.typeIsCheckbox = false;
	                }
	            });
	        }
	    }, {
	        key: "checkIsActiveCheckboxesOfTypeCheckbox",
	        value: function checkIsActiveCheckboxesOfTypeCheckbox(form) {
	            if (form) {
	                var arr = form.filter(function (el) {
	                    return !el.isInfobox && el.active;
	                });
	                return arr.length <= 1;
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: "setGdprData",
	        value: function setGdprData(value) {
	            this.json.admin.gdpr.showGdpr = !value;
	            this.saveDataInConfig();
	        }
	    }, {
	        key: "useGdprCustomButton",
	        value: function useGdprCustomButton(value) {
	            this.json.admin.gdpr.gdprCustomButtonsEnabled = !value;
	            this.saveDataInConfig();
	        }
	    }, {
	        key: "setCustomLogo",
	        value: function setCustomLogo(data) {
	            if (data.customLogoFile == undefined) {
	                (0, _assign2.default)(this.json.admin.ai.customLogo, { customLogoFile: [] });
	            }
	            this.saveDataInConfig();
	        }
	    }, {
	        key: "isActiveStep",
	        value: function isActiveStep(title) {
	            return this.currentStep === title;
	        }
	    }, {
	        key: "stepChanged",
	        value: function stepChanged(step) {
	            this.currentStep = step; // step може відповідати номеру кроку
	        }
	    }, {
	        key: "checkBoothOptions",
	        value: function checkBoothOptions() {
	            var _this38 = this;
	
	            var booths = ["photoBooth", "gifBooth", "boomerangBooth", "videoBooth"];
	            var enabledBooths = booths.filter(function (booth) {
	                return _this38.json.admin[booth] && _this38.json.admin[booth].enabled;
	            });
	
	            if (enabledBooths.length === 1) {
	                var booth = enabledBooths[0];
	
	                if (booth === "videoBooth") {
	                    return this.json.admin[booth] && this.json.admin[booth].allowSharing === true;
	                }
	
	                var allowPrinting = this.json.admin[booth] && this.json.admin[booth].allowPrinting;
	                var allowSharing = this.json.admin[booth] && this.json.admin[booth].allowSharing;
	
	                return allowPrinting === true && allowSharing === false || allowPrinting === false && allowSharing === true;
	            }
	
	            return false;
	        }
	    }, {
	        key: "formatTime",
	        value: function formatTime(milliseconds) {
	            var totalSeconds = Math.floor(milliseconds / 1000);
	            var minutes = Math.floor(totalSeconds / 60);
	            var seconds = totalSeconds % 60;
	
	            var result = "";
	            if (minutes > 0) {
	                result += minutes + " min ";
	            }
	            if (seconds > 0 || minutes === 0) {
	                result += seconds + " seconds";
	            }
	            return result.trim();
	        }
	    }, {
	        key: "updateCaptureTime",
	        value: function updateCaptureTime() {
	            this.json.admin.videoBooth.captureTime = this.json.admin.videoBooth.sliderValue * 1000;
	        }
	    }, {
	        key: "handleFeatureDeactivation",
	        value: function handleFeatureDeactivation(featureName, isActive) {
	            if (!this.json || !this.json.admin || !this.json.admin.scenes || !this.json.admin.scenes.scenesList) {
	                return;
	            }
	            if (!isActive) {
	                this.json.admin.scenes.scenesList.forEach(function (scene) {
	                    if (scene.selectedFeature && scene.selectedFeature.value === featureName) {
	                        scene.enabled = isActive;
	                    }
	                });
	            }
	        }
	    }]);
	    return ConfigurationUpdateController;
	}(_index.$controller);
	
	exports.default = ConfigurationUpdateController;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(274), __esModule: true };

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(275);
	module.exports = __webpack_require__(14).Object.assign;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(19);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(276) });


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(50);
	var gOPS = __webpack_require__(73);
	var pIE = __webpack_require__(74);
	var toObject = __webpack_require__(8);
	var IObject = __webpack_require__(53);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(28)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 277 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// Max valid sizes for uploaded photos in mb
	var FILE_SIZES = exports.FILE_SIZES = {
	    startScreen: 60,
	    print: 5,
	    sharing: 2.5,
	    scenes: 50,
	    pdf: 4,
	    gdprDocument: 10,
	    favicon: 0.5,
	    customLogo: 2
	};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.COLOR_PICKER_SWATCH_OPTIONS = exports.COLOR_PICKER_OPTIONS = undefined;
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// angularjs-color-picker options: the native <input type="color"> opens cut or in the window corner in some browsers.
	// Colors stay "#rrggbb" as the native input saved them. dynamicHue is off: for white or black the hue slider would be all white or black.
	var COLOR_PICKER_OPTIONS = exports.COLOR_PICKER_OPTIONS = {
	    alpha: false,
	    format: "hexString",
	    case: "lower",
	    swatchBootstrap: false,
	    dynamicHue: false
	};
	
	// Only the round swatch (.color-picker-label), without the hex input
	var COLOR_PICKER_SWATCH_OPTIONS = exports.COLOR_PICKER_SWATCH_OPTIONS = (0, _assign2.default)({}, COLOR_PICKER_OPTIONS, { swatchOnly: true });

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LEGACY_FORMAT_IDS = exports.PRINT_DPI_OPTIONS = exports.PRINT_FORMAT_OPTION_GROUPS = exports.CARD_FORMAT_OPTIONS = exports.STICKER_FORMAT_OPTIONS = exports.PRINT_FORMAT_OPTIONS = exports.PRINT_DPI_VALUES = exports.PRINT_FORMATS = undefined;
	
	var _slicedToArray2 = __webpack_require__(280);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(287);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getIterator2 = __webpack_require__(284);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _isFinite = __webpack_require__(264);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	exports.mmToPx = mmToPx;
	exports.getPixelsForFormat = getPixelsForFormat;
	exports.getFormatShortLabel = getFormatShortLabel;
	exports.getFormatAndDpiFromPixels = getFormatAndDpiFromPixels;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Print format constants: A1–A6, 10×15, 15×20, 7.6×9, sticker 4×4–6×6, credit card 8.6×5.4, 2:3, 3:2, 3:4, 4:3.
	 * Net size in mm; 3mm bleed applied in mmToPx: finalMm = mm + 6, px = round((finalMm/25.4)*dpi).
	 * Used by: to-view-value, to-booth-value, configuration-update.
	 */
	var BLEED_MM = 6; // 3mm per side (6mm total)
	var MM_PER_INCH = 25.4;
	
	/** formatId -> { mmWidth, mmHeight } (net size in mm) */
	var PRINT_FORMATS = exports.PRINT_FORMATS = {
	    portrait: { mmWidth: 100, mmHeight: 150 }, // 2:3
	    landscape: { mmWidth: 150, mmHeight: 100 }, // 3:2
	    portrait_3_4: { mmWidth: 150, mmHeight: 200 }, // 3:4
	    landscape_4_3: { mmWidth: 200, mmHeight: 150 }, // 4:3
	    a1_portrait: { mmWidth: 594, mmHeight: 841 },
	    a1_landscape: { mmWidth: 841, mmHeight: 594 },
	    a2_portrait: { mmWidth: 420, mmHeight: 594 },
	    a2_landscape: { mmWidth: 594, mmHeight: 420 },
	    a3_portrait: { mmWidth: 297, mmHeight: 420 },
	    a3_landscape: { mmWidth: 420, mmHeight: 297 },
	    a4_portrait: { mmWidth: 210, mmHeight: 297 },
	    a4_landscape: { mmWidth: 297, mmHeight: 210 },
	    a5_portrait: { mmWidth: 148, mmHeight: 210 },
	    a5_landscape: { mmWidth: 210, mmHeight: 148 },
	    a6_portrait: { mmWidth: 105, mmHeight: 148 },
	    a6_landscape: { mmWidth: 148, mmHeight: 105 },
	    "10x15": { mmWidth: 100, mmHeight: 150 },
	    "15x10": { mmWidth: 150, mmHeight: 100 },
	    "15x20": { mmWidth: 150, mmHeight: 200 },
	    "20x15": { mmWidth: 200, mmHeight: 150 },
	    "7.6x9": { mmWidth: 76, mmHeight: 90 },
	    "4x4": { mmWidth: 40, mmHeight: 40 },
	    "4.5x4.5": { mmWidth: 45, mmHeight: 45 },
	    "5x5": { mmWidth: 50, mmHeight: 50 },
	    "5.5x5.5": { mmWidth: 55, mmHeight: 55 },
	    "6x6": { mmWidth: 60, mmHeight: 60 },
	    // Credit card / ID card (ISO/IEC 7810 ID-1)
	    "8.6x5.4": { mmWidth: 85.6, mmHeight: 54 },
	    "5.4x8.6": { mmWidth: 54, mmHeight: 85.6 }
	};
	
	var PRINT_DPI_VALUES = exports.PRINT_DPI_VALUES = [72, 150, 300, 600];
	
	/**
	 * @param {number} mm - net size in mm
	 * @param {number} dpi
	 * @param {boolean} [includeBleed=true] - add 6mm (3mm per side)
	 * @returns {number}
	 */
	function mmToPx(mm, dpi) {
	    var includeBleed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    var bleedTotal = includeBleed ? BLEED_MM : 0;
	    var finalMm = mm + bleedTotal;
	    return Math.round(finalMm / MM_PER_INCH * dpi);
	}
	
	/**
	 * @param {string} formatId
	 * @param {number} dpi
	 * @returns {{ width: number, height: number }}
	 */
	function getPixelsForFormat(formatId, dpi) {
	    var f = PRINT_FORMATS[formatId];
	    if (!f) return { width: 1240, height: 1844 };
	    return {
	        width: mmToPx(f.mmWidth, dpi, true),
	        height: mmToPx(f.mmHeight, dpi, true)
	    };
	}
	
	/** Options for format md-select: { id, label } */
	var PRINT_FORMAT_OPTIONS = exports.PRINT_FORMAT_OPTIONS = [{ id: "portrait", label: "Portrait (2:3)" }, { id: "landscape", label: "Landscape (3:2)" }, { id: "portrait_3_4", label: "Portrait (3:4)" }, { id: "landscape_4_3", label: "Landscape (4:3)" }, { id: "a1_portrait", label: "DIN A1 Portrait" }, { id: "a1_landscape", label: "DIN A1 Landscape" }, { id: "a2_portrait", label: "DIN A2 Portrait" }, { id: "a2_landscape", label: "DIN A2 Landscape" }, { id: "a3_portrait", label: "DIN A3 Portrait" }, { id: "a3_landscape", label: "DIN A3 Landscape" }, { id: "a4_portrait", label: "DIN A4 Portrait" }, { id: "a4_landscape", label: "DIN A4 Landscape" }, { id: "a5_portrait", label: "DIN A5 Portrait" }, { id: "a5_landscape", label: "DIN A5 Landscape" }, { id: "a6_portrait", label: "DIN A6 Portrait" }, { id: "a6_landscape", label: "DIN A6 Landscape" }, { id: "10x15", label: "10×15 cm" }, { id: "15x10", label: "15×10 cm" }, { id: "15x20", label: "15×20 cm" }, { id: "20x15", label: "20×15 cm" }, { id: "7.6x9", label: "7.6×9 cm" }];
	
	/** Options for sticker format md-select: { id, label } */
	var STICKER_FORMAT_OPTIONS = exports.STICKER_FORMAT_OPTIONS = [{ id: "4x4", label: "4×4 cm" }, { id: "4.5x4.5", label: "4.5×4.5 cm" }, { id: "5x5", label: "5×5 cm" }, { id: "5.5x5.5", label: "5.5×5.5 cm" }, { id: "6x6", label: "6×6 cm" }];
	
	/** Options for credit card / ID card format md-select: { id, label } */
	var CARD_FORMAT_OPTIONS = exports.CARD_FORMAT_OPTIONS = [{ id: "8.6x5.4", label: "Card Landscape (8.6×5.4 cm)" }, { id: "5.4x8.6", label: "Card Portrait (5.4×8.6 cm)" }];
	
	/** Grouped options for format md-select: { label, options } */
	var PRINT_FORMAT_OPTION_GROUPS = exports.PRINT_FORMAT_OPTION_GROUPS = [{ label: "Print formats", options: PRINT_FORMAT_OPTIONS }, { label: "Sticker formats", options: STICKER_FORMAT_OPTIONS }, { label: "Credit card / ID card formats", options: CARD_FORMAT_OPTIONS }];
	
	/** Options for DPI md-select: { value, label } */
	var PRINT_DPI_OPTIONS = exports.PRINT_DPI_OPTIONS = [{ value: 72, label: "72 (Preview)" }, { value: 150, label: "150 (Draft)" }, { value: 300, label: "300 (Print Std.)" }, { value: 600, label: "600 (High-End)" }];
	
	/** Legacy formatIds that map to old layoutAspectRatio (for reverse lookup) */
	var LEGACY_FORMAT_IDS = exports.LEGACY_FORMAT_IDS = ["portrait", "landscape", "portrait_3_4", "landscape_4_3"];
	
	/**
	 * Short label for formatId, e.g. for "Allow printing (…)" toggles: "2:3", "A4", "10×15".
	 */
	function getFormatShortLabel(formatId) {
	    if (!formatId) return "";
	    var cm = {
	        "10x15": "10×15", "15x10": "15×10", "15x20": "15×20", "20x15": "20×15", "7.6x9": "7.6×9",
	        "4x4": "4×4", "4.5x4.5": "4.5×4.5", "5x5": "5×5", "5.5x5.5": "5.5×5.5", "6x6": "6×6",
	        "8.6x5.4": "8.6×5.4", "5.4x8.6": "5.4×8.6"
	    };
	    if (cm[formatId]) return cm[formatId];
	    var m = String(formatId).match(/^a(\d)_(?:portrait|landscape)$/);
	    return m ? "A" + m[1] : "";
	}
	
	/**
	 * Reverse lookup: from finalSize.width/height finds best-matching formatId and dpi.
	 * Used for migrating old configs (pixels only) and when printLayoutFormat/printDpi are missing.
	 */
	function getFormatAndDpiFromPixels(width, height) {
	    if (!(0, _isFinite2.default)(width) || !(0, _isFinite2.default)(height) || width <= 0 || height <= 0) {
	        return { formatId: "portrait", dpi: 300 };
	    }
	    var best = { formatId: null, dpi: 300, diff: Infinity };
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (0, _getIterator3.default)(PRINT_DPI_VALUES), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var dpi = _step.value;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(PRINT_FORMATS)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _step2$value = (0, _slicedToArray3.default)(_step2.value, 1),
	                        id = _step2$value[0];
	
	                    var p = getPixelsForFormat(id, dpi);
	                    var diff = Math.abs(p.width - width) + Math.abs(p.height - height);
	                    if (diff < best.diff) {
	                        best = { formatId: id, dpi: dpi, diff: diff };
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    if (best.formatId) return { formatId: best.formatId, dpi: best.dpi };
	    return { formatId: width > height ? "landscape" : "portrait", dpi: 300 };
	}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(281);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(284);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(282), __esModule: true };

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(62);
	__webpack_require__(41);
	module.exports = __webpack_require__(283);


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(99);
	var ITERATOR = __webpack_require__(61)('iterator');
	var Iterators = __webpack_require__(46);
	module.exports = __webpack_require__(14).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(285), __esModule: true };

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(62);
	__webpack_require__(41);
	module.exports = __webpack_require__(286);


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(24);
	var get = __webpack_require__(98);
	module.exports = __webpack_require__(14).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(288), __esModule: true };

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(289);
	module.exports = __webpack_require__(14).Object.entries;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(19);
	var $entries = __webpack_require__(290)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(50);
	var toIObject = __webpack_require__(52);
	var isEnum = __webpack_require__(74).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(292);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./configuration-update.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./configuration-update.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "configuration-update{font-size:14px}configuration-update html-preview .preview-main{box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9}configuration-update html-preview .preview-main.mirror .area img,configuration-update html-preview .preview-main.mirror scene-preview .scene img{transform:scaleX(-1)!important}configuration-update .bold{font-family:HKNova-Bold}configuration-update .settings-ss{display:flex;justify-content:flex-start;margin:0 25px;margin-top:16px}configuration-update .settings-ss .setting-section{flex:1;max-width:275px;width:275px;min-width:275px;box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9;padding:10px 0 10px 20px;position:relative}configuration-update .settings-ss .setting-section.logo-disabled{color:#9e9e9e;opacity:.5}configuration-update .settings-ss .setting-section:first-child{margin-right:18px}configuration-update .settings-ss .setting-section:last-child{margin-left:18px}configuration-update .settings-ss .setting-section .md-label{min-width:180px}configuration-update .settings-ss .setting-section md-switch{font-size:18px}configuration-update .settings-ss .setting-section md-switch .md-container{transform:scale(1.2) translateX(20px)!important}configuration-update .settings-ss .setting-section upload{margin-top:15px}configuration-update .settings-ss .setting-section .file-title{width:50%;margin-left:10px;min-width:275px;font-size:14px;color:#a8a8a9;white-space:nowrap}configuration-update .settings-ss .setting-section .file-title md-icon{color:#a8a8a9!important}configuration-update .settings-ss .setting-section .file-title md-icon:hover{color:#848484}configuration-update .settings-ss .setting-section .slider-title{padding:0 0 0 7px;display:inline-block;color:#848484;margin-top:25px;font-size:16px}configuration-update .settings-ss .setting-section md-slider-container{padding:0 40px 0 8px}configuration-update .settings-ss .setting-section md-slider-container .md-sign{display:none}configuration-update .settings-ss .setting-section md-slider-container md-slider[md-discrete]:not([disabled]).md-active .md-thumb{transform:scale(.7)}configuration-update .settings-ss .setting-section md-slider-container .md-track-ticks{display:none}configuration-update .settings-ss .setting-section .logo-sel-cont{margin:0 40px 0 8px;font-size:16px}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector{height:147px}configuration-update .settings-ss .setting-section .logo-sel-cont html-preview .preview-main{transform-origin:top left;transform:scale(.76)}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector-title{width:100%;margin:0 auto;display:block;color:#848484}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector{width:100%;margin:0 auto;position:relative}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group{width:0;height:0;z-index:200}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button{position:absolute;margin:0}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.top-left{top:4%;left:8%}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.top-middle{top:4%;left:calc(50% - 10px)}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.top-right{top:4%;right:5%}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.bottom-left{bottom:15%;left:8%}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.bottom-middle{bottom:15%;left:calc(50% - 10px)}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.bottom-right{bottom:15%;right:5%}configuration-update .settings-ss .setting-section .logo-sel-cont .logo-selector img{width:100%}configuration-update .settings-ss .setting-section .ss-title{margin:22px 10px;font-size:18px}configuration-update .settings-ss .setting-section md-radio-group{font-size:15px;margin:10px 0 0 30px}configuration-update .settings-ss .setting-section md-radio-group .color-picker-label{display:block;position:absolute;top:99px;right:20px;border-radius:50%;outline:none;border:1px solid #d3d3d3;width:16px;height:16px;cursor:pointer}configuration-update .settings-ss .setting-section md-radio-group md-radio-button{margin:0 0 30px 10px;font-size:15px;width:19px}configuration-update .settings-ss .setting-section .ss-bg-info{display:flex;color:#848484;font-size:14px;margin:0 0 0 10px}configuration-update .settings-ss .setting-section .ss-bg-info.logo-info{margin-top:15px;margin-bottom:-15px}configuration-update .settings-ss .setting-section .ss-bg-info.ss-disabled{opacity:.7}configuration-update .settings-ss .setting-section .ss-bg-info.ss-disabled .icon{color:#848484}configuration-update .settings-ss .setting-section .ss-bg-info .icon{width:40px;color:#ee2737}configuration-update .settings-ss .setting-section .ss-tm-download{display:flex;color:#ee2737;font-size:14px;margin:10px 0 0 10px}configuration-update .settings-ss .setting-section .ss-tm-download.ss-disabled{opacity:.7;color:#848484}configuration-update .settings-ss .setting-section .ss-tm-download.ss-disabled .info-text{text-decoration:none;cursor:default}configuration-update .settings-ss .setting-section .ss-tm-download .icon{width:30px}configuration-update .settings-ss .setting-section .ss-tm-download .info-text{text-decoration:underline;cursor:pointer}configuration-update .settings-ss .setting-section .image-crop{display:flex;margin:10px 0 0 10px;align-items:center;color:#848484;font-size:14px}configuration-update .settings-ss .setting-section .image-crop.ss-disabled{opacity:.7}configuration-update .settings-ss .setting-section .image-crop md-switch{margin:0;width:40px;min-width:40px;transform:translateX(-32px)}configuration-update .settings-ss .setting-section .image-crop md-switch .md-label{min-width:2px}configuration-update .settings-ss .setting-section .image-crop md-switch .md-thumb{background-color:#ff4081}configuration-update .settings-ss .setting-section .image-crop md-switch .md-bar{background-color:rgba(255,64,129,.5)}configuration-update .settings-ss .setting-section .image-crop .title-crop{margin:0 5px;outline:none;cursor:pointer;font-size:14px}configuration-update .settings-ss .setting-section .image-crop .title-crop.crop-active{color:#ff4081}configuration-update .steps{clear:both}configuration-update .steps .item-disabled{color:#b0b0b0!important}configuration-update .steps .start-permision{font-size:12px;font-weight:700;margin:40px 0;width:60%;min-width:310px}configuration-update .steps .start-permision md-switch{min-width:310px;margin:10px 0;display:flex;justify-content:space-between}configuration-update .steps .upload-container .file-title{width:50%;margin-left:220px;min-width:255px;font-size:12px;color:gray}configuration-update .steps .radio-inline-custom md-radio-button{display:inline-block;margin:5px}configuration-update .steps .switch-with-tip{margin:40px 0}configuration-update .steps .switch-with-tip md-switch{margin-bottom:0}configuration-update .steps .preview-container p{text-align:center}configuration-update .steps .photos-within-layout .ph-name{font-weight:700}configuration-update .steps .photos-within-layout md-input-container{width:55px;display:inline-block;padding:0;margin:10px 4px 0}configuration-update .steps .photos-within-layout md-input-container.md-icon-float:not(.md-input-has-value):not(.md-input-focused) label{margin-left:5px}configuration-update .steps .photos-within-layout .add-ph{color:#ee2737;margin:0 20% 0 80%}configuration-update .steps .photos-within-layout.wider md-input-container{min-width:80px}configuration-update .steps .photos-within-layout.active,configuration-update .steps .photos-within-layout.active md-input-container input,configuration-update .steps .photos-within-layout.active md-input-container label{color:#000}configuration-update .steps .single-photo-landscape{width:80%}configuration-update .steps .single-photo-portrait{width:40%}configuration-update .steps .area-editor .color-picker-label{width:18px;height:18px;border:1px solid #c9c9c9;border-radius:50%}configuration-update .steps .area-editor .color-picker-wrapper{display:flex;align-items:center;justify-content:flex-start}configuration-update .steps .area-editor .color-picker-wrapper p{margin:0 10px}configuration-update .steps .area-editor .upload-container{display:flex}configuration-update .steps .area-editor .upload-container .md-button.md-primary.md-raised{width:120px}configuration-update .steps .area-editor .file-title{display:flex;align-items:center;flex-direction:row-reverse;justify-content:flex-end;height:26px;padding-top:10px}configuration-update .steps .area-editor .file-title .md-button.md-icon-button{min-height:26px;height:26px;width:26px;padding:0}configuration-update .steps .area-editor md-input-container{margin:0 0 0 10px;max-width:47px}configuration-update .steps .area-editor .custom-width{max-width:90px;min-width:40px}configuration-update .steps .area-editor .custom-width .hide{display:flex!important;opacity:0}configuration-update .steps .reset-link{display:block;float:left;margin-top:10px}configuration-update .steps textarea.paste-code{font-size:12px;line-height:16px;font-family:monospace}configuration-update .steps md-switch .md-label{min-width:300px}configuration-update .steps .photo-layout{font-size:12px;min-width:540px}configuration-update .steps .md-short-input{min-width:328px}configuration-update .gif-container,configuration-update .video-container{border:1px solid #d3d3d3;height:270px;width:480px}configuration-update .gif-container img,configuration-update .gif-container video,configuration-update .video-container img,configuration-update .video-container video{height:100%;width:100%;object-fit:fill}configuration-update .form-page{justify-content:space-between;min-width:1150px}configuration-update .form-page .disabled-input{opacity:.4;pointer-events:none}configuration-update .form-page .left-side{width:46%}@media (max-width:959px){configuration-update .form-page .left-side{order:2}}configuration-update .form-page .left-side h3{margin-top:55px}configuration-update .form-page p{font-size:13px}configuration-update .form-page .inputs-switch .md-switch,configuration-update .form-page .inputs-switch .sort-switch .md-label{min-width:unset}configuration-update .form-page .inputs-switch input{outline:none;background:transparent;border:none;width:150px;border-bottom:1px solid #9f9f9f;margin-bottom:3px}configuration-update .form-page .inputs-switch .custom-container{width:100%;min-width:340px;max-width:600px;box-shadow:0 3px 6px rgba(0,0,0,.16);margin:14px 6px;padding:0 6px;justify-content:space-between}configuration-update .form-page .inputs-switch .custom-container.error-card{border:1px solid red}configuration-update .form-page .inputs-switch .custom-container .inner-switch{justify-content:space-between;width:100%}configuration-update .form-page .inputs-switch .custom-container .answer-label span{text-decoration:underline;cursor:pointer}configuration-update .form-page .inputs-switch .custom-container .property-container p{margin-right:4px}configuration-update .form-page .inputs-switch .custom-container .property-container .md-button{background:#eee;height:28px;line-height:28px;min-width:unset;min-height:28px;margin:8px 0 0;padding:0 8px}configuration-update .form-page .inputs-switch .custom-container .property-container .property-active{background:#ee2737;color:#fff}configuration-update .form-page .inputs-switch .custom-container .custom-input{min-width:unset;margin:0}configuration-update .form-page .inputs-switch .custom-container .custom-input ::placeholder{color:#000;opacity:.5}configuration-update .form-page .inputs-switch .custom-container strong{vertical-align:middle}configuration-update .form-page .inputs-switch .custom-container .add-choice-button{width:24px;height:24px;min-height:24px;background:#ee2737;padding:0!important;margin-top:16px;line-height:24px}configuration-update .form-page .inputs-switch .custom-container .add-choice-button span{font-size:18px}configuration-update .form-page .inputs-switch .custom-container .choice-input{height:25px;width:calc(100% - 30px)}configuration-update .form-page .inputs-switch .custom-container .choice-input input{width:100%}configuration-update .form-page .inputs-switch .custom-container .choice-input ::placeholder{color:rgba(0,0,0,.7);opacity:1}configuration-update .form-page .inputs-switch .custom-container md-switch{margin:0;line-height:34px;height:40px}configuration-update .form-page .inputs-switch .custom-container md-switch .md-label{min-width:unset}configuration-update .form-page .checkbox-body{padding:10px 6px;box-shadow:0 3px 6px rgba(0,0,0,.16)}configuration-update .form-page .checkbox-body.error-card{border:1px solid red!important}configuration-update .form-page .checkbox-body .body-top{justify-content:space-between}configuration-update .form-page .checkbox-body .body-top .wrapper{display:flex;flex-direction:column;width:calc(100% - 165px)}configuration-update .form-page .checkbox-body .body-top .toggle-wrapper{display:flex;flex-direction:column}configuration-update .form-page .checkbox-body .body-top md-switch .md-label{min-width:unset}configuration-update .form-page .checkbox-body .body-top .upload-wrapper{display:flex;flex-direction:row;justify-content:flex-start;align-items:center}configuration-update .form-page .checkbox-body .body-top .upload-wrapper .md-button.md-icon-button{height:36px!important}configuration-update .form-page .checkbox-body .body-top .upload-wrapper span{padding:0 5px;width:calc(100% - 175px);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}configuration-update .form-page .checkbox-body .body-top .upload-wrapper upload{width:130px}configuration-update .form-page .checkbox-body .body-top .upload-wrapper upload label{width:100%;margin:0}configuration-update .require-switch{font-size:14px;order:5;height:25px;margin:0 80px 0 auto}configuration-update .require-switch .md-label{min-width:100px!important}configuration-update .form-sharing i{float:left;position:relative;top:-3px;margin:0 10px 0 0}configuration-update .printer-bleed{margin:10px auto;width:fit-content}.scene-nav{margin-top:-40px!important}.scene-nav .disabled{opacity:.5;cursor:none}.custom-scene-warning{margin:12px 0 30px;padding:10px 12px;border:1px solid #f0c36d;background-color:#fff8e1;color:#8a5a00;border-radius:4px;font-size:14px}.custom-scene-warning md-icon{color:#c57c00;margin-right:8px}.remove-bg-block{padding-top:42px}.remove-bg-block *{box-sizing:border-box}.remove-bg-block h3{font-style:normal;font-weight:700;font-size:16px;line-height:20px;color:#25282a;margin-top:0;margin-bottom:7px}.remove-bg-block h3 span,.remove-bg-block p{font-style:normal;font-weight:400;font-size:14px;line-height:18px}.remove-bg-block p{color:#25282a;margin-bottom:36px}.remove-bg-block p .text-link{cursor:pointer;text-decoration-line:underline;color:#ff1744}.remove-bg-block .btn,.remove-bg-block p .text-link{font-style:normal;font-weight:400;font-size:14px;line-height:18px}.remove-bg-block .btn{display:flex;flex-direction:row;justify-content:center;align-items:center;padding:10px 6px;gap:10px;border:none;border-radius:4px;color:#fff;width:100%}.remove-bg-block .btn.btn-danger{background:#ff1744}.remove-bg-block .btn.btn-primary{background:#25282a}.remove-bg-block .key-wrapper{display:flex;flex-direction:column;align-items:flex-start;margin-bottom:15px}.remove-bg-block .key-wrapper input{font-style:normal;font-weight:400;font-size:14px;line-height:18px;color:#25282a;border-radius:4px;background:#fff;border:1px solid rgba(0,0,0,.5);display:flex;flex-direction:row;align-items:center;padding:10px 6px;gap:10px;width:100%;max-width:216px}.remove-bg-block .key-wrapper a{text-decoration:none;text-align:center}.remove-bg-block .key-wrapper button{margin-top:5px;margin-bottom:5px;width:216px}.remove-bg-block .container{display:flex;flex-direction:column}.remove-bg-block .container .row{display:flex;flex-wrap:wrap;margin:calc(var(--bs-gutter-y) * -1) calc(var(--bs-gutter-x) * -.5) 22px}.remove-bg-block .container .row>*{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y);box-sizing:border-box}.remove-bg-block .container .row .col-auto{flex:0 0 auto;width:auto}.remove-bg-block .container .row .col-1{flex:0 0 auto;width:8.33333333%}.remove-bg-block .container .row .col-2{flex:0 0 auto;width:16.66666667%}.remove-bg-block .container .row .col-3{flex:0 0 auto;width:25%}.remove-bg-block .container .row .col-4{flex:0 0 auto;width:33.33333333%}.remove-bg-block .container .row .col-5{flex:0 0 auto;width:41.66666667%}.remove-bg-block .container .row .col-6{flex:0 0 auto;width:50%}.remove-bg-block .container .row .col-7{flex:0 0 auto;width:58.33333333%}.remove-bg-block .container .row .col-8{flex:0 0 auto;width:66.66666667%}.remove-bg-block .container .row .col-9{flex:0 0 auto;width:75%}.remove-bg-block .container .row .col-10{flex:0 0 auto;width:83.33333333%}.remove-bg-block .container .row .col-11{flex:0 0 auto;width:91.66666667%}.remove-bg-block .container .row .col-12{flex:0 0 auto;width:100%}.remove-bg-block .container .row .col-title{padding-right:10px}.remove-bg-block .container .row .col-title h5{font-style:normal;font-weight:700;font-size:14px;line-height:18px;color:#25282a;margin-top:0;margin-bottom:4px}.remove-bg-block .container .row .col-title span{font-style:normal;font-weight:400;font-size:8px;line-height:10px;color:#25282a}.remove-bg-block .container .row .col-auto{display:flex;align-items:flex-start;flex-direction:column;justify-content:flex-end;padding-left:10px;padding-right:10px}.remove-bg-block .container .row .col-auto h2{font-style:normal;font-weight:400;font-size:24px;line-height:30px;color:#25282a;margin:0}.remove-bg-block .container .row .col-s-wrapper{display:flex;align-items:flex-start;flex-direction:column;justify-content:flex-end;padding-left:10px;padding-right:10px}.remove-bg-block .container .row .col-s-wrapper h5{font-style:normal;font-weight:700;font-size:14px;line-height:18px;color:#25282a;margin-top:0;margin-bottom:5px}.remove-bg-block .container .row .col-s-wrapper input{font-style:normal;font-weight:400;font-size:14px;line-height:18px;color:#25282a;border-radius:4px;background:#fff;border:1px solid rgba(0,0,0,.5);display:flex;flex-direction:row;align-items:center;padding:10px 6px;gap:10px;width:100%;max-width:fit-content}.remove-bg-block .container .row .col-s-wrapper input:disabled{background:#e8e8e8;border:none}.replicate-prompt-options{margin-top:16px}.replicate-prompt-options h4{margin:0 0 10px;font-size:14px;font-weight:700;color:#25282a}.replicate-prompt-options__list{display:flex;gap:10px;flex-wrap:wrap}.replicate-prompt-options__option{border:1px solid rgba(0,0,0,.25);border-radius:6px;background:#fff;color:#25282a;padding:10px 12px;min-width:200px;text-align:left;display:flex;flex-direction:column;gap:2px}.replicate-prompt-options__option strong{font-size:14px;line-height:18px}.replicate-prompt-options__option span{font-size:12px;line-height:16px;opacity:.8}.replicate-prompt-options__option.active{border-color:#25282a;box-shadow:inset 0 0 0 1px #25282a}.form-offline-forms .font-height-low{line-height:15px;margin:0;font-weight:bolder;font-size:15px}.disable-steps .steps-indicator{opacity:.5;cursor:none;pointer-events:none}.row{display:flex;flex-direction:row}.row--col{flex-direction:column}.sub-block-title{width:130px;min-width:130px}.html-holder p strong{font-size:20px}.flex-container{display:flex;align-items:center;justify-content:flex-start}.flex-container .btn-file{margin-top:0!important}.flex-container .upload-info-wrapper{display:flex;flex-direction:column;align-items:flex-start;justify-content:center;padding-left:20px}.flex-container .upload-info-wrapper .sub-text{display:flex;align-items:center;margin:2px 0;font-size:9px;color:#737373;font-family:Inter;font-style:normal;font-weight:400;line-height:normal}.flex-container .upload-info-wrapper .file-title{width:auto!important;margin:0!important}.flex-container .upload-info-wrapper .file-title p{display:flex;align-items:center;margin:2px 0;font-size:10px;color:#737373;font-family:Inter;font-style:normal;font-weight:400;line-height:normal}.flex-container .upload-info-wrapper .file-title p button{padding:0!important;height:auto!important;width:auto!important;line-height:14px!important;min-height:auto!important;min-width:auto!important;margin-left:0!important;margin-right:5px!important}.flex-container .upload-info-wrapper .file-title p button md-icon{width:15px;height:15px;font-size:16px;min-width:15px;min-height:15px;border-radius:0}.gdpr-wrapper{display:flex;flex-direction:row;align-items:center;justify-content:flex-start}.gdpr-wrapper .upload-container .md-button.md-primary.md-raised{margin-left:10px}.gdpr-block .strong-text{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:normal}.step{position:relative}.layout-padding{padding-left:0!important}.general-page .preview-main,.start-screen-page .preview-main{margin:initial}.ai-activation-toggle{font-style:normal;font-weight:700;font-size:16px;line-height:20px;color:#25282a;margin-top:0;margin-bottom:7px}.ai-activation-toggle .md-label{color:#25282a;font-size:14px;font-style:normal;font-weight:400;line-height:normal}.ai-features{min-height:calc(100vh - 310px)}.ai-features .layout-padding{padding:0}.ai-features .page-title{padding:0;margin-bottom:30px}.ai-features .page-title strong{color:#25282a;font-size:20px;font-style:normal;font-weight:800;line-height:normal}.ai-features .ai-item-wrapper__title{margin:0!important}.ai-features .ai-item-wrapper__title,.ai-features h3{color:#25282a;font-size:14px;font-style:normal;font-weight:600;line-height:normal}.ai-features .scenes-tooltips{display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-end;height:290px}.ai-features .scenes-tooltips .info-tooltip{border-radius:5px;background:#e3bddd;color:#000;font-size:11px;font-style:normal;font-weight:400;line-height:16px;padding:10px;margin-top:22px;max-width:524px}.ai-features .scenes-tooltips .info-tooltip strong{color:#000;font-size:11px;font-style:normal;font-weight:600;line-height:16px}.ai-features.custom-logo{width:150%;display:flex;flex-direction:row;position:relative}.ai-features.custom-logo md-switch{margin-left:0!important}.ai-features.custom-logo md-switch .md-label{min-width:200px;max-width:200px}.ai-features.custom-logo .upload-container{margin-left:15px}.ai-features.custom-logo .sub-text{position:absolute;color:gray;font-size:8px;font-style:normal;font-weight:400;line-height:normal;top:45px}.ai-features h2{color:#25282a;font-size:14px;font-style:normal;font-weight:600;line-height:normal}.ai-features .ai-item-wrapper{margin:0}.ai-features .preview-main{margin:initial}.ai-features .settings-block{margin:0 8px;margin-left:0;margin-bottom:24px}.ai-features .settings-block *{box-sizing:border-box}.ai-features .settings-block h3{font-style:normal;font-weight:700;font-size:16px;line-height:20px;color:#25282a;margin-top:0;margin-bottom:7px}.ai-features .settings-block h3 span,.ai-features .settings-block p{font-style:normal;font-weight:400;font-size:14px;line-height:18px}.ai-features .settings-block p{color:#25282a;margin-bottom:10px}.ai-features .settings-block p .text-link{cursor:pointer;font-style:normal;font-weight:400;font-size:14px;line-height:18px;text-decoration-line:underline;color:#ff1744}.ai-features .settings-block .btn{display:flex;flex-direction:row;justify-content:center;align-items:center;padding:10px 6px;gap:10px;border:none;border-radius:4px;font-style:normal;font-weight:400;font-size:14px;line-height:18px;color:#fff;width:100%}.ai-features .settings-block .btn.btn-danger{background:#ff1744}.ai-features .settings-block .btn.btn-primary{background:#25282a}.ai-features .settings-block .key-wrapper{display:flex;flex-direction:column;align-items:flex-start;margin-bottom:15px}.ai-features .settings-block .key-wrapper input{margin:5px 0;font-style:normal;font-weight:400;font-size:14px;line-height:18px;color:#25282a;border-radius:4px;background:#fff;border:1px solid rgba(0,0,0,.5);display:flex;flex-direction:row;align-items:center;padding:10px 6px;gap:10px;width:100%;max-width:216px}.ai-features .settings-block .key-wrapper a{text-decoration:none;text-align:center}.ai-features .settings-block .key-wrapper button{margin-top:5px;margin-bottom:5px;width:216px}.ai-features .settings-block .container{display:flex;flex-direction:column}.ai-features .settings-block .container .row{display:flex;flex-wrap:wrap;margin:calc(var(--bs-gutter-y) * -1) calc(var(--bs-gutter-x) * -.5) 22px}.ai-features .settings-block .container .row>*{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y);box-sizing:border-box}.ai-features .settings-block .container .row .col-auto{flex:0 0 auto;width:auto}.ai-features .settings-block .container .row .col-1{flex:0 0 auto;width:8.33333333%}.ai-features .settings-block .container .row .col-2{flex:0 0 auto;width:16.66666667%}.ai-features .settings-block .container .row .col-3{flex:0 0 auto;width:25%}.ai-features .settings-block .container .row .col-4{flex:0 0 auto;width:33.33333333%}.ai-features .settings-block .container .row .col-5{flex:0 0 auto;width:41.66666667%}.ai-features .settings-block .container .row .col-6{flex:0 0 auto;width:50%}.ai-features .settings-block .container .row .col-7{flex:0 0 auto;width:58.33333333%}.ai-features .settings-block .container .row .col-8{flex:0 0 auto;width:66.66666667%}.ai-features .settings-block .container .row .col-9{flex:0 0 auto;width:75%}.ai-features .settings-block .container .row .col-10{flex:0 0 auto;width:83.33333333%}.ai-features .settings-block .container .row .col-11{flex:0 0 auto;width:91.66666667%}.ai-features .settings-block .container .row .col-12{flex:0 0 auto;width:100%}.ai-features .settings-block .container .row .col-title{padding-right:10px}.ai-features .settings-block .container .row .col-title h5{font-style:normal;font-weight:700;font-size:14px;line-height:18px;color:#25282a;margin-top:0;margin-bottom:4px}.ai-features .settings-block .container .row .col-title span{font-style:normal;font-weight:400;font-size:8px;line-height:10px;color:#25282a}.ai-features .settings-block .container .row .col-auto{display:flex;align-items:flex-start;flex-direction:column;justify-content:flex-end;padding-left:10px;padding-right:10px}.ai-features .settings-block .container .row .col-auto h2{font-style:normal;font-weight:400;font-size:24px;line-height:30px;color:#25282a;margin:0}.ai-features .settings-block .container .row .col-s-wrapper{display:flex;align-items:flex-start;flex-direction:column;justify-content:flex-end;padding-left:10px;padding-right:10px}.ai-features .settings-block .container .row .col-s-wrapper h5{font-style:normal;font-weight:700;font-size:14px;line-height:18px;color:#25282a;margin-top:0;margin-bottom:5px}.ai-features .settings-block .container .row .col-s-wrapper input{font-style:normal;font-weight:400;font-size:14px;line-height:18px;color:#25282a;border-radius:4px;background:#fff;border:1px solid rgba(0,0,0,.5);display:flex;flex-direction:row;align-items:center;padding:10px 6px;gap:10px;width:100%;max-width:fit-content}.ai-features .settings-block .container .row .col-s-wrapper input:disabled{background:#e8e8e8;border:none}.tab-container{max-width:1440px;width:100%;margin:0 auto;position:relative}p{color:#25282a;font-size:14px;font-style:normal;font-weight:400;line-height:normal}.general-page .mode-options md-radio-group{display:flex;align-items:end}.general-page .mode-options md-radio-button{height:20px;width:20px;display:flex;justify-content:center;align-items:center}.general-page .mode-options .option-wrapper{display:flex;flex-direction:column;align-items:center;margin-right:48px}.general-page .mode-options .option-wrapper span{margin-bottom:3px}.general-page .photos-within-layout md-input-container:first-child{margin-right:29px}.general-page .photos-within-layout md-input-container .md-input{border-color:#000}.general-page .line-divider{border-bottom:1px solid #000;display:flex;align-items:center;width:100%}.general-page .line-divider .row{width:100%}.general-page .line-divider .md-input{border-bottom:none;padding:0}.general-page.web-app-part md-input-container .md-input[disabled]{background-image:none;border-bottom-color:rgba(0,0,0,.5)}.general-page.web-app-part .link-builder-block{border-bottom:1px solid #000;display:flex;align-items:center;width:100%}.general-page.web-app-part .link-builder-block .layout-row{display:flex;align-items:center;width:100%}.general-page.web-app-part .link-builder-block .layout-row .md-input{border-bottom:none;padding:0}.general-page.web-app-part .invalid-input{border-color:red}.general-page.web-app-part md-input-container.md-input-has-placeholder label,.general-page.web-app-part md-input-container.md-input-has-value label{color:#434648;font-size:12px;font-style:normal;font-weight:400;line-height:normal}.general-page.web-app-part md-select .md-select-value{border-bottom-color:#000}.general-page.web-app-part .error-message{color:red;font-size:12px;margin-top:4px}.part-title{color:#25282a;font-size:20px;font-style:normal;font-weight:700;line-height:normal}.part-title__sub-text{color:gray;font-size:14px}.label-text,.part-title__sub-text{font-style:normal;font-weight:400;line-height:normal}.label-text{color:#434648;font-size:12px}.go-back-btn{position:absolute;top:-160px;left:0;cursor:pointer;padding-left:40px}.general-footer .reset-btn-wrapper{display:flex;justify-content:space-between;width:100%;align-items:center}.general-footer .reset-btn-wrapper p{max-width:380px;display:flex;align-items:center}.general-footer .reset-btn-wrapper p a{margin-top:0;margin-right:5px;color:#ff1744!important}.general-footer .reset-btn-wrapper button{width:125px;font-weight:400;max-height:28px;min-height:28px;line-height:14px}.standby-page{position:relative;min-height:calc(100vh - 310px)}.standby-page .part-title{color:#25282a;font-size:20px;font-style:normal;font-weight:700;line-height:normal}.standby-page .part-title .md-label{min-width:unset;margin-left:10px}.standby-page .part-title__sub-text{color:gray;font-size:14px;font-style:normal;font-weight:400;line-height:normal;margin:0}.standby-page .paragraph,.standby-page p{color:#25282a;font-size:14px;font-style:normal;font-weight:400;line-height:normal}.standby-page .paragraph .md-container{margin-left:15px}.standby-page .slider-item{margin-bottom:47px;margin-top:19px}.standby-page .upload-container{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;margin-top:39px;margin-bottom:28px}.standby-page .upload-container .md-button.md-primary.md-raised{margin-top:0}.standby-page .upload-container .file-title{margin-left:15px!important}configuration-update .start-screen-page{position:relative}configuration-update .start-screen-page .part-title{margin:0}configuration-update .start-screen-page .part-title__sub-text{margin:16px 25px 52px 0}configuration-update .start-screen-page .preview-title .part-title{margin:0;margin-bottom:10px}configuration-update .start-screen-page h4{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:normal}configuration-update .start-screen-page .background-settings{margin:0}configuration-update .start-screen-page .background-settings .toggle-wrapper{display:flex;flex-direction:row;align-items:center;margin-bottom:23px;margin-top:20px;color:#25282a;font-size:14px;font-style:normal;font-weight:400;line-height:normal}configuration-update .start-screen-page .background-settings .toggle-wrapper upload{margin-left:10px}configuration-update .start-screen-page .background-settings .toggle-wrapper form .md-button.md-primary.md-raised{min-width:105px;width:auto;margin-top:0}configuration-update .start-screen-page .background-settings .toggle-wrapper form .file-title{color:#25282a;font-size:12px;font-style:normal;font-weight:400;line-height:20px}configuration-update .start-screen-page .background-settings .toggle-wrapper md-radio-button{margin-bottom:0}configuration-update .start-screen-page .background-settings .start-screen-color-picker{margin-left:20px}configuration-update .start-screen-page .background-settings .start-screen-color-picker .color-picker-input{width:90px;height:24px;padding:0 0 0 28px;border:none;border-bottom:1px solid #e9e9e9;background:transparent;font-family:monospace;font-size:14px}configuration-update .start-screen-page .background-settings .start-screen-color-picker .color-picker-swatch:not(.input-group-addon){top:2px;width:18px;height:18px;border:1px solid #000;border-radius:100px}configuration-update .start-screen-page .start-permision{margin:0;margin-top:73px;margin-bottom:89px}configuration-update .start-screen-page .start-permision md-switch{margin:14px 0}configuration-update .start-screen-page .start-permision .md-label{color:#25282a;font-size:14px;font-style:normal;font-weight:400;line-height:normal}configuration-update .start-screen-page .capture-btn-wrapper{margin:0}configuration-update .start-screen-page .capture-btn-wrapper p strong{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:normal}configuration-update .start-screen-page .capture-btn-wrapper .part-title__sub-text{color:#25282a;font-size:11px;font-style:normal;font-weight:400;line-height:16px;margin:14px 0 48px}configuration-update .start-screen-page .capture-btn-wrapper .area-editor{margin-bottom:30px}configuration-update .start-screen-page .capture-btn-wrapper .area-editor.disabled{opacity:.5;cursor:none;pointer-events:none}configuration-update .start-screen-page .capture-btn-wrapper .area-editor .area-title{color:#25282a;font-size:14px;font-style:normal;font-weight:400;line-height:normal}configuration-update .start-screen-page .capture-btn-wrapper .area-editor start-screen-area{width:100%}configuration-update .start-screen-page .capture-btn-wrapper .area-editor start-screen-area .custom-width{min-width:80px;max-width:unset}configuration-update .start-screen-page .capture-btn-wrapper .area-editor start-screen-area .custom-width .md-input{color:#25282a;font-size:14px;font-style:normal;font-weight:400;line-height:normal;border-bottom-color:#000;margin-top:20px}configuration-update .start-screen-page .capture-btn-wrapper .area-editor start-screen-area .custom-width md-input-container.md-input-has-value label{color:gray;font-size:14px;font-style:normal;font-weight:400;line-height:normal;bottom:unset;top:-12px}configuration-update .start-screen-page .capture-btn-wrapper .area-editor start-screen-area md-input-container .md-errors-spacer{display:none!important}configuration-update .start-screen-page .capture-btn-wrapper .area-editor start-screen-area .upload-container{flex-direction:column;margin-left:10px;min-width:180px}configuration-update .start-screen-page .capture-btn-wrapper .area-editor start-screen-area .upload-container .md-button.md-primary.md-raised{margin-top:0;width:105px}configuration-update .start-screen-page .capture-btn-wrapper .area-editor start-screen-area .upload-container .file-title{margin-left:0!important;flex-direction:row!important;justify-content:flex-start!important}configuration-update .start-screen-page .capture-btn-wrapper .area-editor start-screen-area .upload-container .file-title span{text-overflow:ellipsis;overflow:hidden;width:90px;white-space:nowrap}.upload-container .material-icons{font-size:19px}.upload-container__sub-text{color:#25282a!important;font-size:11px!important;font-style:normal!important;font-weight:500!important;line-height:16px!important}.upload-container .md-button.md-primary.md-raised{margin-left:0}.upload-container p{flex-direction:row-reverse;justify-content:flex-end}.upload-container .file-title{color:#25282a!important;font-size:12px;font-style:normal;font-weight:400;line-height:20px}.upload-container .scenes-wrapper p.low-text{color:gray;font-size:11px;font-style:normal;font-weight:500;line-height:normal}.upload-container .scenes-wrapper p strong{color:#25282a;font-size:14px;font-style:normal;font-weight:600;line-height:normal}.upload-container .scenes-wrapper scenes-list .main-scenes{left:0;width:100%}.upload-container .scenes-wrapper scenes-list .main-scenes .scene{width:calc(100% - 10px);max-width:unset}.upload-container .scenes-wrapper scenes-list .main-scenes .scene .name .title .title-text{max-width:180px}.upload-container .scenes-wrapper scenes-list .main-scenes.bordered:after,.upload-container .scenes-wrapper scenes-list .main-scenes.bordered:before{width:100%;max-width:unset;left:0}.video-page .part-title{padding-left:0}.video-page .sub-text{color:gray;font-size:12px;font-style:normal;font-weight:400;line-height:14px;margin:0}.video-page .video-resolution-settings{margin-top:40px}.video-page .video-resolution-settings .sub-text{padding-left:0}.video-page .video-resolution-settings md-radio-button .md-label{display:flex;flex-direction:column;color:#25282a;font-size:14px;font-style:normal;font-weight:400;line-height:normal;padding-top:12px}.video-page .video-resolution-settings md-radio-button .md-label span{color:gray;font-size:12px;font-style:normal;font-weight:400;line-height:14px}.video-page .video-resolution-settings md-radio-button .md-container,.video-page .video-resolution-settings md-radio-button .md-off{width:18px;height:18px}.video-page .video-resolution-settings md-radio-button.md-checked .md-off{border-color:#ff1744}.video-page .video-resolution-settings md-radio-button .md-on{width:18px;height:18px;background-color:#ff1744}.video-page .video-sharing-settings .upload-container{display:flex;flex-direction:row}.video-page .video-sharing-settings .upload-container .upload-info-wrapper .file-title{margin-left:0}.video-page .video-sharing-settings .upload-container .upload-info-wrapper .file-title p{color:#737373;font-family:Inter;font-size:10px;font-style:normal;font-weight:400;line-height:normal;margin-top:5px}.video-page .video-sharing-settings .upload-container .upload-info-wrapper .file-title p md-icon{width:16px;height:16px;min-height:16px;min-width:16px}.video-page .video-sharing-settings .upload-container .upload-info-wrapper .file-title p .md-button.md-icon-button{width:16px;height:16px;padding:0;min-height:16px;margin-left:0}.video-page .video-sharing-settings .upload-container .upload-info-wrapper .file-title p .md-button.md-icon-button .material-icons{font-size:16px}.video-page .video-sharing-settings .upload-container .upload-info-wrapper .sub-text{opacity:.4;font-size:9px;font-style:normal;font-weight:500;line-height:14px}.individual-text-section,.offline-qr-section{width:100%;margin-top:12px;padding-top:8px;border-top:1px solid #e9e9e9}.individual-text-section .part-title,.offline-qr-section .part-title{color:#25282a;font-size:18px;font-weight:700}.individual-text-section .part-title .md-label,.offline-qr-section .part-title .md-label{min-width:unset;margin-left:10px}.individual-text-section .part-title__sub-text,.offline-qr-section .part-title__sub-text{color:gray;font-size:14px;font-weight:400;max-width:640px;margin:8px 0 0}.individual-text-section .upload-container,.offline-qr-section .upload-container{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;margin-top:28px;margin-bottom:12px}.individual-text-section .upload-container .md-button.md-primary.md-raised,.offline-qr-section .upload-container .md-button.md-primary.md-raised{margin-top:0}.individual-text-section .upload-container .file-title,.offline-qr-section .upload-container .file-title{display:flex;align-items:center;margin-left:15px}.individual-text-section .area-editor,.offline-qr-section .area-editor{margin-top:28px}.individual-text-section .area-editor start-screen-area,.offline-qr-section .area-editor start-screen-area{width:100%;flex-wrap:wrap}.individual-text-section .area-editor start-screen-area .title-item,.offline-qr-section .area-editor start-screen-area .title-item{min-width:220px}.individual-text-section .area-editor start-screen-area .custom-width,.offline-qr-section .area-editor start-screen-area .custom-width{min-width:80px;max-width:110px}.individual-text-section .area-editor start-screen-area .upload-container,.offline-qr-section .area-editor start-screen-area .upload-container{flex-direction:column;align-items:flex-start;margin-top:0;margin-left:8px;min-width:180px}.individual-text-section .offline-qr-preview .part-title,.offline-qr-section .offline-qr-preview .part-title{margin-bottom:8px}.individual-text-section{border-top:none}.individual-text-section h4{margin:20px 0 4px}.individual-text-section .individual-text-block{margin-top:16px;padding-top:8px;border-top:1px solid #e9e9e9}.individual-text-section .individual-text-block__header{display:flex;align-items:center;justify-content:space-between}.individual-text-section .area-editor start-screen-area .title-item{min-width:170px}.individual-text-section .area-editor start-screen-area .custom-width{flex:0 1 80px;min-width:70px;max-width:80px}.individual-text-section .area-editor start-screen-area .custom-width md-input-container{max-width:none;width:calc(100% - 10px)}.individual-text-section .individual-text-done start-screen-area{flex-wrap:wrap}.individual-text-section .individual-text-done start-screen-area .upload-container{order:-1;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;align-items:center;top:0;margin:0 0 8px}.individual-text-section .individual-text-done start-screen-area .upload-container .md-button.md-primary.md-raised{width:auto}.individual-text-section .individual-text-done start-screen-area .upload-container .file-title{width:auto!important;min-width:0!important;margin-left:12px!important;flex-direction:row;height:auto;padding-top:0}.individual-text-section .individual-text-done start-screen-area .upload-container .upload-container__sub-text{flex:0 0 100%;margin:4px 0 12px}.individual-text-section .individual-text-id{margin-left:8px;color:gray;font-size:12px;font-weight:400}.individual-text-section .individual-text-row{align-items:flex-start}.individual-text-section .individual-text-row md-input-container{min-width:90px;margin-right:16px}.individual-text-section .individual-text-row .individual-text-number{flex:0 0 90px;width:90px}.individual-text-section .individual-text-row .individual-text-number label{overflow:visible}.individual-text-section .individual-text-row .individual-text-select{flex:0 0 140px;width:140px}.individual-text-section .individual-text-group{margin:16px 0 8px;padding-left:16px;border-left:3px solid #e9e9e9}.individual-text-section .individual-text-group__title{margin:0 0 4px;color:gray;font-size:12px;font-weight:600;letter-spacing:.05em;text-transform:uppercase}.individual-text-section .individual-text-group .area-editor{margin-top:8px}.individual-text-section .individual-text-row--center{align-items:center}.individual-text-section .individual-text-row--center md-switch{margin:4px 0 28px}.individual-text-section .individual-text-row--center md-switch .md-label{width:auto;min-width:0;margin-right:12px}.individual-text-section .individual-text-font{display:flex;align-items:center;margin-top:18px}.individual-text-section div.upload-container .file-title{width:auto;min-width:0;margin-left:12px}.individual-text-section .individual-text-color{display:inline-flex;flex-direction:column;margin:-4px 24px 0 0}.individual-text-section .individual-text-color__label{padding-left:2px;color:rgba(0,0,0,.54);font-size:12px;line-height:15px;white-space:nowrap}.individual-text-section .individual-text-color color-picker{display:block;margin-top:2px}.individual-text-section .color-picker-wrapper .color-picker-input{width:100px;height:30px;padding:0 0 0 36px;border:none;border-bottom:1px solid #e9e9e9;background:transparent;font-family:monospace;font-size:14px}.individual-text-section .color-picker-wrapper .color-picker-swatch:not(.input-group-addon){top:1px;width:28px;height:28px;border:1px solid #e9e9e9;border-radius:0}.individual-text-section .individual-text-previews{position:sticky;top:0;align-self:flex-start}.individual-text-section .individual-text-previews__list{display:flex;flex-direction:column}.individual-text-section .individual-text-previews__list--row{flex-direction:row;flex-wrap:wrap;align-items:flex-start;gap:24px}.individual-text-section .individual-text-previews__list--row .individual-text-previews__item{width:min-content}.individual-text-section .individual-text-previews .part-title{margin:16px 0 4px}.individual-text-section .individual-text-previews .part-title__sub-text{margin:0 0 12px}.individual-text-section .individual-text-previews individual-text-output-preview{display:block;text-align:center}.individual-text-section--portrait>.individual-text-settings{flex:1 1 42%;max-width:42%}.individual-text-section--portrait>.individual-text-settings .area-editor start-screen-area .title-item{min-width:130px;max-width:150px}.individual-text-section--portrait>.individual-text-previews{flex:1 1 58%;max-width:58%}", ""]);
	
	// exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _quickSetup = __webpack_require__(294);
	
	var _quickSetup2 = _interopRequireDefault(_quickSetup);
	
	var _quickSetup3 = __webpack_require__(301);
	
	var _quickSetup4 = _interopRequireDefault(_quickSetup3);
	
	__webpack_require__(311);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuickSetupComponent = {
	    template: _quickSetup2.default,
	    controller: _quickSetup4.default,
	    controllerAs: "ctrl"
	};
	
	exports.default = QuickSetupComponent;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<loader ng-show=\"ctrl.loading\"></loader>\n<div class=\"main-container\" ng-show=\"!ctrl.loading\">\n\n    <span class=\"config-title\">Configuration:\n        <span class=\"name\">{{ctrl.config.name}}</span>\n        <span>\n            <i class=\"material-icons\" ng-click=\"ctrl.openChangeNameDialog($event)\">\n                edit\n            </i>\n        </span>\n    </span>\n    <div class=\"save-container\">\n        <md-button ng-click=\"ctrl.nextStep()\" ng-if=\"ctrl.currentStep !== 4\">\n            Next\n        </md-button>\n        <md-button ng-click=\"ctrl.saveConfig('draft')\" ng-if=\"ctrl.currentStep === 4\">\n            Save\n        </md-button>\n        <span ng-if=\"ctrl.currentStep !== 4\" ng-click=\"ctrl.saveConfig('draft')\">Save draft and continue later</span>\n        <span ng-if=\"ctrl.currentStep === 4\" class=\"final\"  ng-click=\"ctrl.saveConfig('advanced')\">Save & go to advanced settings</span>\n    </div>\n\n    <div class=\"wizard-container\">\n\n        <wizard indicators-position=\"top\"\n                edit-mode=\"true\">\n\n            <wz-step wz-title=\"Modes\" canexit=\"ctrl.canExitModeScreen()\">\n                <div class=\"mode\">\n                    <div class=\"info\">\n                        <span class=\"header\">\n                            1. Select your capture modes\n                        </span>\n                        <span class=\"info-main\">Welcome to the UpReach Quick Setup Wizard. It allows you to personalize your UpReach <br>\n                                            experience in a simple & visual way.</span>\n\n                        <span class=\"info-main\">First, select your desired capture modes. This will determine how the start screen looks <br>\n                                            like and what output the user can receive.</span>\n                    </div>\n\n                    <div class=\"modes\">\n                        <div class=\"mode-container\" ng-click=\"ctrl.selectMode('photoBooth')\" ng-class=\"{disabled: !ctrl.json.admin.photoBooth.enabled}\">\n                            <div class=\"toggle\">\n                                <md-switch\n                                        md-invert\n                                        ng-model=\"ctrl.json.admin.photoBooth.enabled\">\n                                    {{'Photo' | translate}}\n                                </md-switch>\n                            </div>\n                            <div class=\"photos\">\n                                <div class=\"img-holder photo\"></div>\n                                <div class=\"img-holder photo-print\"></div>\n                            </div>\n                            <div class=\"options-container\">\n                                <div class=\"photo\">\n                                    <img src=\"" + __webpack_require__(295) + "\" alt=\"single-icon\">\n                                </div>\n                                <div class=\"info-text\">\n                                    <div class=\"text\">1 single square photo which can be printed on 10x15cm with a nostalgic polaroid feel. Timeless and classy, perfect for all occasions.</div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"mode-container\" ng-click=\"ctrl.selectMode('gifBooth')\" ng-class=\"{disabled: !ctrl.json.admin.gifBooth.enabled}\">\n                            <div class=\"toggle\">\n                                <md-switch\n                                        md-invert\n                                        ng-model=\"ctrl.json.admin.gifBooth.enabled\">\n                                    {{'GIF' | translate}}\n                                </md-switch>\n                            </div>\n                            <div class=\"photos\">\n                                <div class=\"img-holder gif\"></div>\n                                <div class=\"img-holder gif-print\"></div>\n                            </div>\n                            <div class=\"options-container\">\n                                <div class=\"photo\">\n                                    <img src=\"" + __webpack_require__(296) + "\" alt=\"single-icon\">\n                                </div>\n                                <div class=\"info-text\">\n                                    <div class=\"text\">3 different photos resulting in a stop-motion animation. Printed on 10x15cm & cut into two identical photo strips. A modern interpretation of the classic photo booth style.</div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"mode-container\" ng-click=\"ctrl.selectMode('boomerangBooth')\" ng-class=\"{disabled: !ctrl.json.admin.boomerangBooth.enabled}\">\n                            <div class=\"toggle\">\n                                <md-switch\n                                        md-invert\n                                        ng-model=\"ctrl.json.admin.boomerangBooth.enabled\">\n                                    {{'Boomerang' | translate}}\n                                </md-switch>\n                            </div>\n                            <div class=\"photos\">\n                                <div class=\"img-holder boomerang\">\n                                    <video id=\"boomerang-video-pr\" autoplay loop></video>\n                                </div>\n                                <div class=\"img-holder boomerang-print\"></div>\n                            </div>\n                            <div class=\"options-container\">\n                                <div class=\"photo\">\n                                    <img src=\"" + __webpack_require__(297) + "\" alt=\"single-icon\">\n                                </div>\n                                <div class=\"info-text\">\n                                    <div class=\"text\">1,5sec video played back & forth repeatedly. Printed on 10x15cm & cut into two identical photo strips. State-of-the-art of social video content.</div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n            </wz-step>\n\n            <wz-step wz-title=\"Start screen\">\n                <div class=\"start-screen\">\n                    <div class=\"main-container-ss\">\n                        <div class=\"info\">\n                            <span class=\"header\">\n                                2. Create your start screen\n                            </span>\n                            <span class=\"info-main\">Our start screen displays all capture modes which you have selected. It is the first screen <br>\n                                                the user sees when approaching the photo system and is also being displayed after each <br>\n                                                user session.</span>\n\n                            <span class=\"info-main\">You can upload your own logo and background image or simply choose a background <br>\n                                                color.</span>\n                        </div>\n                        <div class=\"settings-ss\">\n                            <div class=\"setting-section\" ng-class=\"{'logo-disabled': !ctrl.json.admin.startScreenLogo.enabled}\">\n                                <div class=\"toggle\">\n                                    <md-switch\n                                            md-invert\n                                            ng-model=\"ctrl.json.admin.startScreenLogo.enabled\">\n                                        {{'Logo' | translate}}\n                                    </md-switch>\n                                    <div class=\"ss-bg-info logo-info\">\n                                        <div class=\"icon\">\n                                            <i class=\"material-icons\">\n                                                info\n                                            </i>\n                                        </div>\n                                        <div class=\"info-text\">\n                                            Format .png .jpg .gif <br>\n                                            Size {{ctrl.fileSizes.startScreen}} mb\n                                        </div>\n                                    </div>\n                                    <upload\n                                            model=\"ctrl.json.admin.startScreenLogo.file\"\n                                            uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                            custom-label=\"{{'Upload' | translate}}\"\n                                            file-types=\".jpg,.jpeg,.png,.gif\"\n                                            max-size=\"ctrl.fileSizes.startScreen\"\n                                            is-overlay=\"false\"\n                                            display-icon=\"true\"\n                                            ng-disabled=\"!ctrl.json.admin.startScreenLogo.enabled\">\n                                    </upload>\n                                    <div class=\"file-title\" ng-if=\"ctrl.json.admin.startScreenLogo.file.attachment_file\" title=\"{{ctrl.json.admin.startScreenLogo.file.attachment_file | getFileName}}\">\n                                        <span>Uploaded: {{ ctrl.json.admin.startScreenLogo.file.attachment_file | getFileName:12 }}</span>\n                                        <md-button\n                                                class=\"md-icon-button md-primary\"\n                                                ng-click=\"ctrl.json.admin.startScreenLogo.file = {}\"\n                                                ng-disabled=\"!ctrl.json.admin.startScreenLogo.enabled\">\n                                            <md-icon>delete</md-icon>\n                                        </md-button>\n                                    </div>\n                                    <span class=\"slider-title\" ng-hide=\"!ctrl.json.admin.startScreenLogo.file.attachment_file\">Adjust logo size</span>\n                                    <md-slider-container ng-hide=\"!ctrl.json.admin.startScreenLogo.file.attachment_file\">\n                                        <md-slider\n                                                min=\"15\"\n                                                max=\"30\"\n                                                md-discrete\n                                                ng-model=\"ctrl.json.admin.startScreenLogo.size\"\n                                                aria-label=\"slider\"\n                                                ng-disabled=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.startScreenLogo.file.attachment_file\">\n                                        </md-slider>\n                                    </md-slider-container>\n                                    <div class=\"logo-sel-cont\" ng-hide=\"!ctrl.json.admin.startScreenLogo.file.attachment_file\">\n                                        <span class=\"logo-selector-title\">Select logo position</span>\n                                        <div class=\"logo-selector\">\n                                            <html-preview\n                                                    class=\"custom-preview\"\n                                                    pr-width=\"{{1920}}\"\n                                                    pr-height=\"{{1080}}\"\n                                                    index=\"{{7.5}}\"\n                                                    background=\"{{[ctrl.json.admin.startScreenBackground.attachment_file]}}\"\n                                                    video-background=\"{{ctrl.getFileType(ctrl.json.admin.startScreenBackground) === 'mp4' ? ctrl.json.admin.startScreenBackground.attachment_file : '' }}\"\n                                                    areas=\"{{ctrl.json.admin.startScreenAreas}}\"\n                                                    related-values=\"true\"\n                                                    hide-overlay=\"true\"\n                                                    gif=\"{{true}}\"\n                                                    logo-type=\"'start'\"\n                                                    logo-size=\"ctrl.json.admin.startScreenLogo.size\"\n                                                    logo-position=\"ctrl.json.admin.startScreenLogo.position\"\n                                                    bg-mode=\"ctrl.json.admin.startScreenBackgroundMode\"\n                                                    bg-color=\"ctrl.json.admin.startScreenBackgroundColor\"\n                                                    bg-style=\"ctrl.json.admin.startScreenImageStyle\">\n                                            </html-preview>\n                                            <md-radio-group ng-model=\"ctrl.json.admin.startScreenLogo.position\" ng-disabled=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.startScreenLogo.file.attachment_file\" ng-change=\"ctrl.changeAreas()\">\n                                                <md-radio-button class=\"top-left\" ng-value=\"1\"></md-radio-button>\n                                                <md-radio-button class=\"top-middle\" ng-value=\"2\"></md-radio-button>\n                                                <md-radio-button class=\"top-right\" ng-value=\"3\"></md-radio-button>\n                                                <md-radio-button class=\"bottom-left\" ng-value=\"4\"></md-radio-button>\n                                                <md-radio-button class=\"bottom-middle\" ng-value=\"5\"></md-radio-button>\n                                                <md-radio-button class=\"bottom-right\" ng-value=\"6\"></md-radio-button>\n                                            </md-radio-group>\n                                        </div>\n                                    </div>\n\n                                </div>\n                            </div>\n                            <div class=\"setting-section\">\n                                <div class=\"ss-title\">\n                                    Background\n                                </div>\n                                <md-radio-group ng-model=\"ctrl.json.admin.startScreenBackgroundMode\" ng-change=\"ctrl.onModeChange()\">\n                                    <md-radio-button value=\"color\">Choose background color: </md-radio-button>\n                                    <color-picker class=\"color-picker-label\"\n                                                  ng-model=\"ctrl.json.admin.startScreenBackgroundColor\"\n                                                  options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n                                    <md-radio-button value=\"image\">Upload background image</md-radio-button>\n                                </md-radio-group>\n                                <div class=\"ss-bg-info\" ng-class=\"{'ss-disabled': ctrl.json.admin.startScreenBackgroundMode === 'color'}\">\n                                    <div class=\"icon\">\n                                        <i class=\"material-icons\">\n                                            info\n                                        </i>\n                                    </div>\n                                    <div class=\"info-text\">\n                                        Dimension 1920x1080 px <br>\n                                        Format .png .jpg .gif <br>\n                                        Size {{ctrl.fileSizes.startScreen}} mb\n                                    </div>\n                                </div>\n\n                                <div class=\"ss-tm-download\" ng-class=\"{'ss-disabled': ctrl.json.admin.startScreenBackgroundMode === 'color'}\">\n                                    <div class=\"icon\">\n                                        <i class=\"material-icons\">\n                                            get_app\n                                        </i>\n                                    </div>\n                                    <div class=\"info-text\">\n                                        Download Photoshop template\n                                    </div>\n                                </div>\n                                <upload\n                                        model=\"ctrl.json.admin.startScreenBackground\"\n                                        uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                        custom-label=\"{{'Upload' | translate}}\"\n                                        file-types=\".jpg,.jpeg,.gif,.png,.mp4\"\n                                        max-size=\"ctrl.fileSizes.startScreen\"\n                                        callback=\"ctrl.checkBackgroundResolution()\"\n                                        is-overlay=\"false\"\n                                        display-icon=\"true\"\n                                        ng-disabled=\"ctrl.json.admin.startScreenBackgroundMode === 'color'\">\n                                </upload>\n                                <div class=\"file-title\" ng-if=\"ctrl.json.admin.startScreenBackground.attachment_file\" title=\"{{ctrl.json.admin.startScreenBackground.attachment_file | getFileName}}\">\n                                    <span>Uploaded: {{ ctrl.json.admin.startScreenBackground.attachment_file | getFileName:12 }}</span>\n                                    <md-button\n                                            class=\"md-icon-button md-primary\"\n                                            ng-click=\"ctrl.json.admin.startScreenBackground.attachment_file = null\">\n                                        <md-icon>delete</md-icon>\n                                    </md-button>\n                                </div>\n                                <div class=\"image-crop\" ng-show=\"ctrl.json.admin.startScreenBackground.attachment_file && ctrl.json.admin.startScreenBackgroundMode !== 'color' && ctrl.showBgToggle\"  ng-class=\"{'ss-disabled': ctrl.json.admin.startScreenBackgroundMode === 'color'}\">\n                                    <div\n                                            class=\"title-crop\"\n                                            ng-class=\"{'crop-active': ctrl.json.admin.startScreenImageStyle === 'crop'}\"\n                                            ng-click=\"ctrl.json.admin.startScreenImageStyle = 'crop'\">\n                                        Crop image\n                                    </div>\n                                    <div class=\"toggle-small\">\n                                        <md-switch\n                                                md-invert\n                                                ng-model=\"ctrl.json.admin.startScreenImageStyle\"\n                                                ng-true-value=\"'stretch'\"\n                                                ng-false-value=\"'crop'\"\n                                                ng-disabled=\"ctrl.json.admin.startScreenBackgroundMode === 'color'\">\n                                        </md-switch>\n                                    </div>\n                                    <div\n                                            class=\"title-crop\"\n                                            ng-class=\"{'crop-active': ctrl.json.admin.startScreenImageStyle === 'stretch'}\"\n                                            ng-click=\"ctrl.json.admin.startScreenImageStyle = 'stretch'\">\n                                        Stretch image\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"booth-preview\">\n                        <img src=\"" + __webpack_require__(298) + "\" alt=\"Booth\" class=\"booth-image\">\n                        <div class=\"preview-container\">\n                            <html-preview\n                                    pr-width=\"{{1920}}\"\n                                    pr-height=\"{{1090}}\"\n                                    index=\"{{3.16}}\"\n                                    background=\"{{[ctrl.json.admin.startScreenBackground.attachment_file]}}\"\n                                    video-background=\"{{ctrl.getFileType(ctrl.json.admin.startScreenBackground) === 'mp4' ? ctrl.json.admin.startScreenBackground.attachment_file : '' }}\"\n                                    areas=\"{{ctrl.json.admin.startScreenAreas}}\"\n                                    related-values=\"true\"\n                                    gif=\"{{true}}\"\n                                    ignore-overflow=\"true\"\n                                    hide-overlay=\"true\"\n                                    logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                    logo-size=\"ctrl.json.admin.startScreenLogo.size\"\n                                    logo-position=\"ctrl.json.admin.startScreenLogo.position\"\n                                    logo-type=\"'start'\"\n                                    bg-mode=\"ctrl.json.admin.startScreenBackgroundMode\"\n                                    bg-color=\"ctrl.json.admin.startScreenBackgroundColor\"\n                                    bg-style=\"ctrl.json.admin.startScreenImageStyle\"\n                                    hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled\"\n                                    badge-active=\"true\">\n                            </html-preview>\n                        </div>\n                    </div>\n\n                </div>\n            </wz-step>\n\n            <wz-step wz-title=\"Design\" canexit=\"ctrl.canExitDesignScreen()\">\n                <div class=\"design\">\n                    <div class=\"info\">\n                            <span class=\"header\">\n                                3. Design your photo & video layouts\n                            </span>\n                        <span class=\"info-main\">Now it’s time to design your layouts of the final sharing & printing output files. <br>\n                                                By default we will use your logo and background from the start screen. <br>\n                                                Do you want something custom? Click on “Custom Design” to see more options.</span>\n\n                    </div>\n\n                    <div class=\"design-container\">\n                        <div class=\"design-digital\" ng-class=\"{'design-disabled': !ctrl.wizardOptions.enableSharing}\">\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.wizardOptions.enableSharing\"\n                                    ng-change=\"ctrl.changeSharing()\">\n                                {{'Enable digital layout' | translate}}\n                            </md-switch>\n                            <div class=\"divider\"></div>\n                            <div class=\"design-d-info\">\n                                Used for the digital sharing version of all selected capture <br>\n                                modes. Size: 500x500px\n                            </div>\n                            <div class=\"design-d-pr-container\" ng-if=\"ctrl.json\">\n                                <html-preview\n                                        single=\"true\"\n                                        ng-hide=\"!ctrl.json.admin.photoBooth.enabled\"\n                                        pr-width=\"{{500}}\"\n                                        pr-height=\"{{500}}\"\n                                        index=\"{{3}}\"\n                                        bg-color=\"ctrl.json.admin.startScreenBackgroundColor\"\n                                        logo-type=\"'digital'\"\n                                        background=\"{{ctrl.json.admin.photoBooth.sharingBackgroundFiles}}\"\n                                        logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                        overlay=\"{{ctrl.wizardOptions.digitalOverlay}}\"\n                                        areas=\"{{ [ctrl.digitalImages.photo] }}\"\n                                        bg-mode=\"ctrl.json.admin.startScreenBackgroundMode\"\n                                        hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.digitalStartScreenDesign\">\n                                </html-preview>\n                                <html-preview\n                                        ng-hide=\"!ctrl.json.admin.gifBooth.enabled\"\n                                        pr-width=\"{{500}}\"\n                                        pr-height=\"{{500}}\"\n                                        index=\"{{3}}\"\n                                        logo-type=\"'digital'\"\n                                        background=\"{{ctrl.json.admin.gifBooth.sharingBackgroundFiles}}\"\n                                        bg-color=\"ctrl.json.admin.startScreenBackgroundColor\"\n                                        logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                        overlay=\"{{ctrl.wizardOptions.digitalOverlay}}\"\n                                        areas=\"{{ [ctrl.digitalImages.gif] }}\"\n                                        bg-mode=\"ctrl.json.admin.startScreenBackgroundMode\"\n                                        hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.digitalStartScreenDesign\">\n                                </html-preview>\n                                <html-preview\n                                        ng-hide=\"!ctrl.json.admin.boomerangBooth.enabled\"\n                                        pr-width=\"{{500}}\"\n                                        pr-height=\"{{500}}\"\n                                        index=\"{{3}}\"\n                                        bg-color=\"ctrl.json.admin.startScreenBackgroundColor\"\n                                        logo-type=\"'digital'\"\n                                        background=\"{{ctrl.json.admin.boomerangBooth.sharingBackgroundFiles}}\"\n                                        logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                        hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.digitalStartScreenDesign\"\n                                        overlay=\"{{ctrl.wizardOptions.digitalOverlay}}\"\n                                        bg-mode=\"ctrl.json.admin.startScreenBackgroundMode\"\n                                        areas=\"{{ [ctrl.digitalImages.video] }}\">\n                                </html-preview>\n                            </div>\n                            <button\n                                    class=\"md-button md-raised md-primary custom-design-btn\"\n                                    ng-click=\"ctrl.openDigitalDialog($event)\"\n                                    ng-disabled=\"!ctrl.wizardOptions.enableSharing\">\n                                <i class=\"material-icons\">\n                                    brush\n                                </i>\n                                Custom Design\n                            </button>\n                        </div>\n                        <div class=\"design-print\" ng-class=\"{'design-disabled': !ctrl.wizardOptions.enablePrinting}\">\n                            <md-switch\n                                    md-invert\n                                    ng-model=\"ctrl.wizardOptions.enablePrinting\"\n                                    ng-change=\"ctrl.changePrinting()\">\n                                {{'Enable printing' | translate}}\n                            </md-switch>\n                            <div class=\"divider\"></div>\n                            <div class=\"design-p-pr-container\">\n                                <div class=\"single\" ng-hide=\"!ctrl.json.admin.photoBooth.enabled\">\n                                    <div class=\"title-print\">Single Photo - <small>Photo mode</small></div>\n                                    <div class=\"text-print\">10x15cm premium photo paper.</div>\n                                    <div class=\"print-ph-holder\">\n                                        <html-preview\n                                                single=\"true\"\n                                                pr-width=\"{{1240}}\"\n                                                pr-height=\"{{1844}}\"\n                                                index=\"{{9}}\"\n                                                logo-type=\"'print'\"\n                                                logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                                background=\"{{ctrl.json.admin.photoBooth.printingBackgroundFiles}}\"\n                                                overlay=\"{{ctrl.wizardOptions.printOverlay}}\"\n                                                areas=\"{{ ctrl.printImage }}\"\n                                                hide-title=\"true\"\n                                                bg-style=\"'crop'\"\n                                                bg-mode=\"ctrl.json.admin.photoBooth.printingBackgroundMode\"\n                                                bg-color=\"ctrl.json.admin.photoBooth.printingBackgroundColor\"\n                                                hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.printStartScreenDesign\"\n                                                logos-arr=\"ctrl.json.admin.photoBooth.printingLogos\">\n                                        </html-preview>\n                                    </div>\n                                    <button class=\"md-button md-raised md-primary\" ng-click=\"ctrl.openPrintlDialog($event)\" ng-disabled=\"!ctrl.wizardOptions.enablePrinting || !ctrl.json.admin.photoBooth.enabled\">\n                                        <i class=\"material-icons\">\n                                            brush\n                                        </i>\n                                        Custom Design\n                                    </button>\n                                </div>\n                                <div class=\"strips\" ng-hide=\"!ctrl.json.admin.gifBooth.enabled && !ctrl.json.admin.boomerangBooth.enabled\">\n                                    <div class=\"title-print\">Photo Strips - <small>Gif & Boomerang</small></div>\n                                    <div class=\"text-print\">10x15cm premium photo paper, <br>\n                                                            cut into 2 photo strips.</div>\n                                    <div class=\"print-ph-holder\">\n                                        <html-preview\n                                                ng-hide=\"!ctrl.json.admin.gifBooth.enabled && ctrl.json.admin.boomerangBooth.enabled\"\n                                                pr-width=\"{{1240}}\"\n                                                pr-height=\"{{1844}}\"\n                                                index=\"{{9.6}}\"\n                                                logo-type=\"'strip'\"\n                                                logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                                overlay=\"{{ctrl.wizardOptions.stripOverlay}}\"\n                                                background=\"{{ctrl.json.admin.gifBooth.printingBackgroundFiles}}\"\n                                                areas=\"{{ ctrl.stripImages }}\"\n                                                hide-title=\"true\"\n                                                bg-style=\"'crop'\"\n                                                bg-mode=\"ctrl.json.admin.gifBooth.printingBackgroundMode\"\n                                                bg-color=\"ctrl.json.admin.gifBooth.printingBackgroundColor\"\n                                                hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.stripStartScreenDesign\"\n                                                logos-arr=\"ctrl.json.admin.gifBooth.printingLogos\">\n                                        </html-preview>\n                                        <html-preview\n                                                boomerang=\"true\"\n                                                ng-hide=\"!ctrl.json.admin.boomerangBooth.enabled && ctrl.json.admin.gifBooth.enabled\"\n                                                pr-width=\"{{1240}}\"\n                                                pr-height=\"{{1844}}\"\n                                                index=\"{{9.6}}\"\n                                                logo-type=\"'strip'\"\n                                                logo=\"ctrl.json.admin.startScreenLogo.file.attachment_file\"\n                                                overlay=\"{{ctrl.wizardOptions.stripOverlay}}\"\n                                                background=\"{{ctrl.json.admin.boomerangBooth.printingBackgroundFiles}}\"\n                                                areas=\"{{ ctrl.stripImages }}\"\n                                                hide-title=\"true\"\n                                                bg-style=\"'crop'\"\n                                                bg-mode=\"ctrl.json.admin.boomerangBooth.printingBackgroundMode\"\n                                                bg-color=\"ctrl.json.admin.boomerangBooth.printingBackgroundColor\"\n                                                hide-logo=\"!ctrl.json.admin.startScreenLogo.enabled || !ctrl.json.admin.stripStartScreenDesign\"\n                                                logos-arr=\"ctrl.json.admin.boomerangBooth.printingLogos\">\n                                        </html-preview>\n                                    </div>\n                                    <button class=\"md-button md-raised md-primary\" ng-click=\"ctrl.openStripDialog($event)\" ng-disabled=\"!ctrl.wizardOptions.enablePrinting || (!ctrl.json.admin.boomerangBooth.enabled && !ctrl.json.admin.gifBooth.enabled)\">\n                                        <i class=\"material-icons\">\n                                            brush\n                                        </i>\n                                        Custom Design\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </wz-step>\n\n            <wz-step wz-title=\"Sharing\">\n                <div class=\"sharing\">\n                    <div class=\"info\">\n                            <span class=\"header\">\n                                4. Enter your messages for social media sharing\n                            </span>\n                        <span class=\"info-main\">After taking a photo or video the user can print and share it. Here you can customize <br>\n                                                the messages which the users will receive if they choose email or SMS sharing.</span>\n\n                    </div>\n\n                    <div class=\"sharing-container\">\n                        <div class=\"sms-sharing\">\n                            <div class=\"phone-cont\" ng-class=\"{'phone-disabled': !ctrl.json.admin.outputSettings.enableSmsSharing}\">\n                                <md-switch\n                                        md-invert\n                                        ng-model=\"ctrl.json.admin.outputSettings.enableSmsSharing\">\n                                    {{'Enable SMS sharing' | translate}}\n                                </md-switch>\n                                <div class=\"switch-desc\">\n                                    Contains a link to the photo.\n                                </div>\n                                <phone-msg text=\"ctrl.json.client.smsText\"></phone-msg>\n                                <img class=\"phone-img\" src=\"" + __webpack_require__(299) + "\" alt=\"sms\">\n                            </div>\n                            <div class=\"share-input-cont\">\n                                <div class=\"input-block sms\" ng-hide=\"!ctrl.json.admin.outputSettings.enableSmsSharing\">\n                                    <md-input-container class=\"md-blok\">\n                                        <label\n                                                ng-bind=\"'Edit SMS message' | translate\"\n                                                for=\"inputSMSText\"></label>\n\n                                        <textarea\n                                                ng-model=\"ctrl.json.client.smsText\"\n                                                type=\"text\"\n                                                name=\"emailSMS\"\n                                                id=\"inputSMSText\"\n                                                md-no-autogrow\n                                                rows=\"3\"\n                                                max-rows=\"8\"\n                                                md-detect-hidden\n                                                maxlength=\"120\"\n                                                md-maxlength=\"120\">\n                                        </textarea>\n\n                                    </md-input-container>\n                                    <div class=\"dot\"></div>\n                                </div>\n                                <div\n                                        ng-hide=\"!ctrl.json.admin.outputSettings.enableSmsSharing\"\n                                        class=\"reset\"\n                                        ng-click=\"ctrl.resetSMS()\"\n                                >Reset to default settings</div>\n                            </div>\n                        </div>\n                        <div class=\"email-sharing\">\n                            <div class=\"phone-cont\" ng-class=\"{'phone-disabled': !ctrl.json.admin.outputSettings.enableEmailSharing}\">\n                                <md-switch\n                                        md-invert\n                                        ng-model=\"ctrl.json.admin.outputSettings.enableEmailSharing\">\n                                    {{'Enable email sharing' | translate}}\n                                </md-switch>\n                                <div class=\"switch-desc\">\n                                    Contains the photos as attachment.\n                                </div>\n                                <email-preview\n                                    title=\"ctrl.json.client.emailTitle\"\n                                    text=\"ctrl.json.client.emailTextNoHtml\"\n                                    data=\"{{ctrl.json.admin}}\"\n                                    template=\"{{ctrl.json.client.emailTemplate}}\"></email-preview>\n                                <img class=\"phone-img\" src=\"" + __webpack_require__(300) + "\" alt=\"email\">\n                            </div>\n                            <div class=\"share-input-cont\">\n                                <div class=\"input-block lang\" ng-hide=\"!ctrl.json.admin.outputSettings.enableEmailSharing\">\n                                    <md-input-container\n                                            ng-disabled=\"!ctrl.json.admin.outputSettings.enableEmailSharing\">\n                                        <label>{{'Email language' | translate}}</label>\n                                        <md-select ng-model=\"ctrl.json.client.emailTemplate\" ng-change=\"ctrl.onTemplateChange()\">\n                                            <md-option ng-value=\"'German informal'\" selected>German informal</md-option>\n                                            <md-option ng-value=\"'German formal'\">German formal</md-option>\n                                            <md-option ng-value=\"'English'\">English</md-option>\n                                        </md-select>\n                                    </md-input-container>\n                                </div>\n\n                                <div class=\"input-block subject\" ng-hide=\"!ctrl.json.admin.outputSettings.enableEmailSharing\">\n                                    <md-input-container class=\"md-block md-short-input\">\n                                        <label\n                                                ng-bind=\"'Email subject' | translate\"\n                                                for=\"inputEmailSubject\"></label>\n\n                                        <input\n                                                ng-model=\"ctrl.json.client.emailSubject\"\n                                                type=\"text\"\n                                                name=\"emailSubject\"\n                                                id=\"inputEmailSubject\"\n                                                maxlength=\"100\"\n                                                ng-required=\"ctrl.json.admin.outputSettings.enableEmailSharing\">\n\n                                        <div ng-messages=\"ctrl.formSharing.emailSubject.$error\" role=\"alert\">\n                                            <div ng-message=\"required\" ng-bind=\"'Please provide email subject' | translate\"></div>\n                                        </div>\n                                    </md-input-container>\n                                </div>\n\n                                <div class=\"input-block title\" ng-hide=\"!ctrl.json.admin.outputSettings.enableEmailSharing\">\n                                    <md-input-container\n                                            class=\"md-block md-short-input\">\n                                        <label\n                                                ng-bind=\"'Email title' | translate\"\n                                                for=\"inputEmailTitle\"></label>\n\n                                        <textarea\n                                                ng-model=\"ctrl.json.client.emailTitle\"\n                                                type=\"text\"\n                                                name=\"emailTitle\"\n                                                id=\"inputEmailTitle\"\n                                                maxlength=\"40\"\n                                                md-maxlength=\"40\"\n                                                max-rows=\"1\"\n                                                rows=\"1\">\n                                        </textarea>\n\n                                        <div ng-messages=\"ctrl.sampleMail.title\" role=\"alert\">\n                                            <div ng-message=\"required\" ng-bind=\"'Please provide valid email title' | translate\"></div>\n                                        </div>\n                                    </md-input-container>\n                                    <div class=\"dot\"></div>\n                                </div>\n\n                                <div class=\"input-block message\" ng-hide=\"!ctrl.json.admin.outputSettings.enableEmailSharing\">\n                                    <md-input-container\n                                            class=\"md-block\">\n                                        <label\n                                                ng-bind=\"'Email text' | translate\"\n                                                for=\"inputEmailTextNoHtml\"></label>\n\n                                        <textarea\n                                                ng-model=\"ctrl.json.client.emailTextNoHtml\"\n                                                type=\"text\"\n                                                name=\"emailTextNoHtml\"\n                                                id=\"inputEmailTextNoHtml\"\n                                                style=\"min-height: 50px\"\n                                                md-no-autogrow\n                                                maxlength=\"3000\"\n                                                md-maxlength=\"3000\"\n                                                rows=\"2\"\n                                                max-rows=\"8\"\n                                                md-detect-hidden>\n                                        </textarea>\n                                        <div ng-messages=\"ctrl.formSharing.emailTextNoHtml.$error\" role=\"alert\">\n                                            <div ng-message=\"required\" ng-bind=\"'Please provide email text' | translate\"></div>\n                                        </div>\n                                    </md-input-container>\n                                    <div class=\"dot\"></div>\n                                </div>\n                                <div\n                                        ng-hide=\"!ctrl.json.admin.outputSettings.enableEmailSharing\"\n                                        class=\"reset\"\n                                        ng-click=\"ctrl.resetEmail()\">Reset to default settings</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </wz-step>\n        </wizard>\n\n    </div>\n</div>\n\n";

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/image-pr.png";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/gif-pr.png";

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/boomerang-pr.png";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/Booth-front.png";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/SMS.png";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/email.png";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	var _digitalLayout = __webpack_require__(302);
	
	var _digitalLayout2 = __webpack_require__(303);
	
	var _digitalLayout3 = _interopRequireDefault(_digitalLayout2);
	
	var _printLayout = __webpack_require__(304);
	
	var _printLayout2 = __webpack_require__(305);
	
	var _printLayout3 = _interopRequireDefault(_printLayout2);
	
	var _stripLayout = __webpack_require__(306);
	
	var _stripLayout2 = __webpack_require__(307);
	
	var _stripLayout3 = _interopRequireDefault(_stripLayout2);
	
	var _changeName = __webpack_require__(308);
	
	var _changeName2 = __webpack_require__(309);
	
	var _changeName3 = _interopRequireDefault(_changeName2);
	
	var _fileSizes = __webpack_require__(277);
	
	var _colorPicker = __webpack_require__(278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Configuration", "$companies"];
	
	var QuickSetupController = function (_$controller) {
	    QuickSetupController.$inject = ["$injector", "$stateParams", "$scope", "$ToViewValue", "$ToBoothValue", "$EmailTemplates", "$DetectChanges", "WizardHandler"];
	    (0, _inherits3.default)(QuickSetupController, _$controller);
	
	    function QuickSetupController($injector, $stateParams, $scope, $ToViewValue, $ToBoothValue, $EmailTemplates, $DetectChanges, WizardHandler) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, QuickSetupController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (QuickSetupController.__proto__ || (0, _getPrototypeOf2.default)(QuickSetupController)).call(this, $injector, dependencies));
	
	        _this.$scope = $scope;
	        _this.$stateParams = $stateParams;
	        _this.wizard = WizardHandler;
	        _this.isNew = _this.$stateParams.isNew;
	        _this.test = null;
	        _this.toViewValue = $ToViewValue;
	        _this.pickerOptions = (0, _assign2.default)({}, _colorPicker.COLOR_PICKER_SWATCH_OPTIONS);
	        _this.loading = true;
	        _this.toBoothValue = $ToBoothValue;
	        _this.emailTemplates = $EmailTemplates;
	        _this.detectChanges = $DetectChanges;
	        _this.currentStep = 1;
	        _this.showBgToggle = false;
	        _this.wizardOptions = {
	            enablePrinting: true,
	            enableSharing: true,
	            digitalOverlay: null,
	            printOverlay: null,
	            stripOverlay: null
	        };
	        _this.canLeavePage = false;
	        $scope.$on("$stateChangeStart", function (event) {
	            if (!_this.canLeavePage) {
	                var answer = confirm("You may have unsaved changes in your configuration, if you leave they will be lost!");
	                if (!answer) {
	                    event.preventDefault();
	                }
	            }
	        });
	        window.onbeforeunload = function () {
	            if (window.location.href.indexOf("setup") !== -1 && !_this.canLeavePage) {
	                return "You may have unsaved changes in your configuration, if you leave they will be lost!";
	            }
	        };
	        _this.digitalImages = {
	            photo: {
	                width: 500,
	                height: 500,
	                x: 0,
	                y: 0,
	                image: true
	            },
	            gif: {
	                width: 500,
	                height: 500,
	                x: 0,
	                y: 0,
	                gif: true
	            },
	            video: {
	                width: 500,
	                height: 500,
	                x: 0,
	                y: 0,
	                video: true
	            }
	        };
	        _this.printImage = [{
	            width: 1240,
	            height: 1240,
	            x: 0,
	            y: 72,
	            image: true
	        }];
	        _this.stripImages = [{
	            width: 480,
	            height: 480,
	            x: 80,
	            y: 82,
	            rotation: 0,
	            title: "1a",
	            image: true
	        }, {
	            width: 480,
	            height: 480,
	            x: 80,
	            y: 577,
	            rotation: 0,
	            title: "2a",
	            image: true
	        }, {
	            width: 480,
	            height: 480,
	            x: 80,
	            y: 1072,
	            rotation: 0,
	            title: "3a",
	            image: true
	        }, {
	            width: 480,
	            height: 480,
	            x: 684,
	            y: 82,
	            rotation: 0,
	            title: "1b",
	            image: true
	        }, {
	            width: 480,
	            height: 480,
	            x: 684,
	            y: 577,
	            rotation: 0,
	            title: "2b",
	            image: true
	        }, {
	            width: 480,
	            height: 480,
	            x: 684,
	            y: 1072,
	            rotation: 0,
	            title: "3b",
	            image: true
	        }];
	        _this.fileSizes = _fileSizes.FILE_SIZES;
	        var config = void 0;
	        if ($stateParams.cid && $stateParams.cid !== "create") {
	            config = _this.$Configuration.get({ id: $stateParams.cid });
	        } else {
	            config = _this.$Configuration.get({ url: _this.$companies.getCached().default_configuration });
	        }
	
	        $scope.$on("wizard:stepChanged", function (ev) {
	            _this.currentStep = ev.targetScope.currentStepNumber();
	            //this.saveConfig();
	            _this.onModeChange();
	        });
	
	        config && config.$promise.then(function (config) {
	            _this.config = config;
	            _this.json = config.json;
	            _this.json.admin.startScreenAreas = _this.toViewValue.getStartScreenValues(_this.json.admin.startScreenAreas);
	            _this.setWizardOptions();
	
	            _this.deleteUpdatedProperties();
	            _this.copiedConfig = (0, _lodash.cloneDeep)(_this.config);
	
	            if (_this.json.client && _this.json.client.emailTextNoHtml) {
	                _this.json.client.emailTextNoHtml = _this.emailTemplates.removeLineBreaks(_this.json.client.emailTextNoHtml);
	            }
	            _this.loading = false;
	            _this.checkBackgroundResolution();
	            _this.onModeChange();
	            var video = document.getElementById("boomerang-video-pr");
	            video.src = __webpack_require__(310);
	            video.playbackRate = 2;
	        }).catch(function (e) {
	            console.log(e);
	            //this.$state.go("configurations");
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(QuickSetupController, [{
	        key: "deleteUpdatedProperties",
	        value: function deleteUpdatedProperties() {
	            delete this.config.updated;
	            delete this.config.json.admin.startScreenAreas.random;
	
	            delete this.config.json.admin.photoBooth.updatePrint;
	            delete this.config.json.admin.photoBooth.updateSharing;
	
	            delete this.config.json.admin.gifBooth.updatePrint;
	            delete this.config.json.admin.gifBooth.updateSharing;
	
	            delete this.config.json.admin.boomerangBooth.updatePrint;
	            delete this.config.json.admin.boomerangBooth.updateSharing;
	        }
	    }, {
	        key: "openChangeNameDialog",
	        value: function openChangeNameDialog(ev) {
	            var _this2 = this;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Change configuration name",
	                controller: _changeName.ChangeNameController,
	                template: _changeName3.default,
	                targetEvent: ev,
	                locals: {
	                    callback: function callback(data) {
	                        return _this2.changeName(data);
	                    },
	                    name: this.config.name,
	                    isUpperCase: false
	                }
	            });
	        }
	    }, {
	        key: "openDigitalDialog",
	        value: function openDigitalDialog(ev) {
	            var _this3 = this;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Set/Share Configuration ID",
	                controller: _digitalLayout.DigitalLayoutController,
	                template: _digitalLayout3.default,
	                targetEvent: ev,
	                locals: {
	                    callback: function callback(data) {
	                        return _this3.setDigitalLayouts(data);
	                    },
	                    overlay: { attachment_file: this.wizardOptions.digitalOverlay },
	                    company: this.config.company,
	                    startScreenDesign: this.json.admin.digitalStartScreenDesign,
	                    logo: this.json.admin.startScreenLogo.file,
	                    showLogo: this.json.admin.startScreenLogo.enabled,
	                    activeMode: this.json.admin.gifBooth.enabled ? "gif" : this.json.admin.boomerangBooth.enabled ? "boomerang" : "single",
	                    background: {
	                        file: this.json.admin.startScreenBackground,
	                        color: this.json.admin.startScreenBackgroundColor,
	                        mode: this.json.admin.startScreenBackgroundMode
	                    }
	                }
	            });
	        }
	    }, {
	        key: "openPrintlDialog",
	        value: function openPrintlDialog(ev) {
	            var _this4 = this;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Set/Share Configuration ID",
	                controller: _printLayout.PrintLayoutController,
	                template: _printLayout3.default,
	                targetEvent: ev,
	                locals: {
	                    callback: function callback(data) {
	                        return _this4.setPrintLayout(data);
	                    },
	                    overlay: { attachment_file: this.wizardOptions.printOverlay },
	                    company: this.config.company,
	                    bleed: this.config.json.admin.photoBooth.showPrinterBleeds,
	                    photos: this.printImage,
	                    startScreenDesign: this.json.admin.printStartScreenDesign,
	                    logo: this.json.admin.startScreenLogo.file,
	                    showLogo: this.json.admin.startScreenLogo.enabled,
	                    logosArr: this.json.admin.photoBooth.printingLogos,
	                    background: {
	                        file: this.json.admin.startScreenBackground,
	                        color: this.json.admin.startScreenBackgroundColor,
	                        mode: this.json.admin.startScreenBackgroundMode,
	                        logo: this.json.admin.startScreenLogo.file
	                    }
	                }
	            });
	        }
	    }, {
	        key: "openStripDialog",
	        value: function openStripDialog(ev) {
	            var _this5 = this;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Set/Share Configuration ID",
	                controller: _stripLayout.StripLayoutController,
	                template: _stripLayout3.default,
	                targetEvent: ev,
	                locals: {
	                    callback: function callback(data) {
	                        return _this5.setStripLayout(data);
	                    },
	                    overlay: { attachment_file: this.wizardOptions.stripOverlay },
	                    company: this.config.company,
	                    bleed: this.config.json.admin.gifBooth.showPrinterBleeds,
	                    photos: this.stripImages,
	                    startScreenDesign: this.json.admin.stripStartScreenDesign,
	                    logo: this.json.admin.startScreenLogo.file,
	                    showLogo: this.json.admin.startScreenLogo.enabled,
	                    cuttingLine: this.json.admin.cuttingLine,
	                    boomerang: !this.json.admin.gifBooth.enabled,
	                    video: !this.json.admin.videoBooth.enabled,
	                    logosArr: this.json.admin.gifBooth.printingLogos,
	                    background: {
	                        file: this.json.admin.startScreenBackground,
	                        color: this.json.admin.startScreenBackgroundColor,
	                        mode: this.json.admin.startScreenBackgroundMode
	                    }
	                }
	            });
	        }
	    }, {
	        key: "selectMode",
	        value: function selectMode(mode) {
	            this.json.admin[mode].enabled = !this.json.admin[mode].enabled;
	
	            var photo = this.json.admin.photoBooth.enabled;
	            var gif = this.json.admin.gifBooth.enabled;
	            var boomerang = this.json.admin.boomerangBooth.enabled;
	            var video = this.json.admin.videoBooth.enabled;
	            var isTop = this.json.admin.startScreenLogo.position <= 4;
	
	            this.json.admin.startScreenAreas.single = { width: 40, height: 40, x: 25, y: isTop ? 60 : 40 };
	            this.json.admin.startScreenAreas.gif = { width: 40, height: 40, x: 50, y: isTop ? 60 : 40 };
	            this.json.admin.startScreenAreas.boomerang = { width: 40, height: 40, x: 75, y: isTop ? 60 : 40 };
	            this.json.admin.startScreenAreas.video = { width: 40, height: 40, x: 95, y: isTop ? 60 : 40 };
	
	            if (photo && gif && !boomerang && !video) {
	                this.json.admin.startScreenAreas.single.x = 37.5;
	                this.json.admin.startScreenAreas.gif.x = 62.5;
	                this.json.admin.startScreenAreas.boomerang = {};
	                this.json.admin.startScreenAreas.video = {};
	            } else if (photo && !gif && boomerang && !video) {
	                this.json.admin.startScreenAreas.single.x = 37.5;
	                this.json.admin.startScreenAreas.gif = 0;
	                this.json.admin.startScreenAreas.boomerang.x = 62.5;
	                this.json.admin.startScreenAreas.video = {};
	            } else if (!photo && gif && boomerang && !video) {
	                this.json.admin.startScreenAreas.single = {};
	                this.json.admin.startScreenAreas.gif.x = 37.5;
	                this.json.admin.startScreenAreas.boomerang.x = 62.5;
	                this.json.admin.startScreenAreas.video = {};
	            } else if (!photo && !gif && boomerang && video) {
	                this.json.admin.startScreenAreas.single = {};
	                this.json.admin.startScreenAreas.gif = {};
	                this.json.admin.startScreenAreas.boomerang.x = 50;
	                this.json.admin.startScreenAreas.video = {};
	            } else if (!photo && gif && !boomerang && !video) {
	                this.json.admin.startScreenAreas.single = {};
	                this.json.admin.startScreenAreas.gif.x = 50;
	                this.json.admin.startScreenAreas.boomerang = {};
	                this.json.admin.startScreenAreas.video = {};
	            } else if (photo && !gif && !boomerang && !video) {
	                this.json.admin.startScreenAreas.single.x = 50;
	                this.json.admin.startScreenAreas.gif = {};
	                this.json.admin.startScreenAreas.boomerang = {};
	                this.json.admin.startScreenAreas.video = {};
	            } else if (photo && !gif && !boomerang && video) {
	                this.json.admin.startScreenAreas.single.x = 50;
	                this.json.admin.startScreenAreas.gif = {};
	                this.json.admin.startScreenAreas.boomerang = {};
	                this.json.admin.startScreenAreas.video = 37.5;
	            } else if (photo && gif && !boomerang && video) {
	                this.json.admin.startScreenAreas.single.x = 37.5;
	                this.json.admin.startScreenAreas.gif = 62.5;
	                this.json.admin.startScreenAreas.boomerang = {};
	                this.json.admin.startScreenAreas.video = 95;
	            } else if (!photo && !gif && !boomerang && video) {
	                this.json.admin.startScreenAreas.single.x = {};
	                this.json.admin.startScreenAreas.gif = {};
	                this.json.admin.startScreenAreas.boomerang = {};
	                this.json.admin.startScreenAreas.video = 95;
	            }
	
	            this.checkModes(mode);
	        }
	    }, {
	        key: "setDigitalLayouts",
	        value: function setDigitalLayouts(data) {
	            if (data.overlay && data.overlay.attachment_file) {
	                this.wizardOptions.digitalOverlay = data.overlay.attachment_file;
	                this.json.admin.photoBooth.sharingOverlayFiles = [data.overlay.attachment_file];
	                this.json.admin.gifBooth.sharingOverlayFiles = [data.overlay.attachment_file];
	                this.json.admin.boomerangBooth.sharingOverlayFiles = [data.overlay.attachment_file];
	            } else {
	                this.wizardOptions.digitalOverlay = null;
	                this.json.admin.photoBooth.sharingOverlayFiles = [];
	                this.json.admin.gifBooth.sharingOverlayFiles = [];
	                this.json.admin.boomerangBooth.sharingOverlayFiles = [];
	            }
	            this.json.admin.digitalStartScreenDesign = data.startScreenDesign;
	
	            this.setDigitalBackground();
	        }
	    }, {
	        key: "setDigitalBackground",
	        value: function setDigitalBackground() {
	            if (!this.json) return;
	
	            if (this.json.admin.digitalStartScreenDesign) {
	                this.json.admin.gifBooth.sharingBackgroundColor = this.json.admin.startScreenBackgroundColor;
	                this.json.admin.gifBooth.sharingBackgroundMode = this.json.admin.startScreenBackgroundMode;
	                this.json.admin.gifBooth.startScreenDesignSharing = true;
	
	                if (this.json.admin.gifBooth.sharingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
	                    this.json.admin.gifBooth.sharingBackgroundFiles = [this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file];
	                }
	
	                this.json.admin.photoBooth.sharingBackgroundColor = this.json.admin.startScreenBackgroundColor;
	                this.json.admin.photoBooth.sharingBackgroundMode = this.json.admin.startScreenBackgroundMode;
	                this.json.admin.photoBooth.startScreenDesignSharing = true;
	
	                if (this.json.admin.photoBooth.sharingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
	                    this.json.admin.photoBooth.sharingBackgroundFiles = [this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file];
	                }
	
	                this.json.admin.boomerangBooth.sharingBackgroundColor = this.json.admin.startScreenBackgroundColor;
	                this.json.admin.boomerangBooth.sharingBackgroundMode = this.json.admin.startScreenBackgroundMode;
	                this.json.admin.boomerangBooth.startScreenDesignSharing = true;
	
	                if (this.json.admin.boomerangBooth.sharingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
	                    this.json.admin.boomerangBooth.sharingBackgroundFiles = [this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file];
	                }
	            } else {
	                this.json.admin.gifBooth.sharingBackgroundFiles = [];
	                this.json.admin.gifBooth.backgroundColor = "#ffffff";
	                this.json.admin.gifBooth.backgroundMode = this.json.admin.startScreenBackgroundMode;
	                this.json.admin.gifBooth.startScreenDesignSharing = false;
	
	                this.json.admin.photoBooth.sharingBackgroundFiles = [];
	                this.json.admin.photoBooth.backgroundColor = "#ffffff";
	                this.json.admin.photoBooth.backgroundMode = this.json.admin.startScreenBackgroundMode;
	                this.json.admin.photoBooth.startScreenDesignSharing = false;
	
	                this.json.admin.boomerangBooth.sharingBackgroundFiles = [];
	                this.json.admin.boomerangBooth.backgroundColor = "#ffffff";
	                this.json.admin.boomerangBooth.backgroundMode = this.json.admin.startScreenBackgroundMode;
	                this.json.admin.boomerangBooth.startScreenDesignSharing = false;
	            }
	        }
	    }, {
	        key: "setPrintLayout",
	        value: function setPrintLayout(data) {
	            if (!this.json) return;
	
	            if (data.overlay && data.overlay.attachment_file) {
	                this.wizardOptions.printOverlay = data.overlay.attachment_file;
	                this.json.admin.photoBooth.printingOverlayFiles = [data.overlay.attachment_file];
	            } else {
	                this.wizardOptions.printOverlay = null;
	                this.json.admin.photoBooth.printingOverlayFiles = [];
	            }
	            this.json.admin.photoBooth.showPrinterBleeds = data.bleed;
	            this.json.admin.printStartScreenDesign = data.startScreenDesign;
	
	            this.setPrintBackground();
	        }
	    }, {
	        key: "setPrintBackground",
	        value: function setPrintBackground() {
	            if (!this.json) return;
	
	            if (this.json.admin.printStartScreenDesign) {
	                this.json.admin.photoBooth.printingBackgroundColor = this.json.admin.startScreenBackgroundColor;
	                this.json.admin.photoBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;
	
	                if (this.json.admin.photoBooth.printingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
	                    this.json.admin.photoBooth.printingBackgroundFiles = [this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file];
	                }
	            } else {
	                this.json.admin.photoBooth.printingBackgroundFiles = [];
	                this.json.admin.photoBooth.printingBackgroundColor = "#ffffff";
	                this.json.admin.photoBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;
	            }
	        }
	    }, {
	        key: "setStripLayout",
	        value: function setStripLayout(data) {
	            if (!this.json) return;
	
	            if (data.overlay && data.overlay.attachment_file) {
	                this.wizardOptions.stripOverlay = data.overlay.attachment_file;
	                this.json.admin.gifBooth.printingOverlayFiles = [data.overlay.attachment_file];
	                this.json.admin.boomerangBooth.printingOverlayFiles = [data.overlay.attachment_file];
	            } else {
	                this.wizardOptions.stripOverlay = null;
	                this.json.admin.gifBooth.printingOverlayFiles = [];
	                this.json.admin.boomerangBooth.printingOverlayFiles = [];
	            }
	            this.json.admin.gifBooth.showPrinterBleeds = data.bleed;
	            this.json.admin.gifBooth.showPrinterBleeds = data.bleed;
	            this.json.admin.stripStartScreenDesign = data.startScreenDesign;
	            this.json.admin.cuttingLine = data.cuttingLine;
	
	            this.setStripBackground();
	        }
	    }, {
	        key: "setStripBackground",
	        value: function setStripBackground() {
	            if (!this.json) return;
	
	            if (this.json.admin.stripStartScreenDesign) {
	                this.json.admin.gifBooth.printingBackgroundColor = this.json.admin.startScreenBackgroundColor;
	                this.json.admin.gifBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;
	
	                if (this.json.admin.gifBooth.printingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
	                    this.json.admin.gifBooth.printingBackgroundFiles = [this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file];
	                }
	
	                this.json.admin.boomerangBooth.printingBackgroundColor = this.json.admin.startScreenBackgroundColor;
	                this.json.admin.boomerangBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;
	
	                if (this.json.admin.boomerangBooth.printingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
	                    this.json.admin.boomerangBooth.printingBackgroundFiles = [this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file];
	                }
	            } else {
	                this.json.admin.gifBooth.printingBackgroundFiles = [];
	                this.json.admin.gifBooth.printingBackgroundColor = "#ffffff";
	                this.json.admin.gifBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;
	
	                this.json.admin.boomerangBooth.printingBackgroundFiles = [];
	                this.json.admin.boomerangBooth.printingBackgroundColor = "#ffffff";
	                this.json.admin.boomerangBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;
	            }
	        }
	    }, {
	        key: "changeName",
	        value: function changeName(title) {
	            this.config.name = title;
	            this.saveConfig();
	        }
	    }, {
	        key: "saveConfig",
	        value: function saveConfig(action) {
	            var _this6 = this;
	
	            if (!this.canExitSharingScreen()) {
	                return false;
	            }
	            if (action) {
	                this.canLeavePage = true;
	            }
	            if (action === "advanced") {
	                this.config.json.admin.isAdvanced = true;
	            }
	            if (this.config.json.client.emailTextNoHtml) {
	                this.config.json.client.emailTextNoHtml = this.emailTemplates.addLineBreaks(this.config.json.client.emailTextNoHtml);
	            }
	            this.createTemplateFromDefault();
	            var configToSave = (0, _lodash.cloneDeep)(this.config);
	            configToSave.json.admin.startScreenAreas = this.toBoothValue.transformStartScreenAreas(configToSave.json.admin.startScreenAreas);
	            configToSave.json.admin.startScreenLogo.boothStyle = this.toBoothValue.setLogoStyle(configToSave.json.admin.startScreenLogo);
	
	            configToSave.json.admin.photoBooth.updatePrint = this.detectChanges.checkBoothPrintChange(configToSave.json.admin.photoBooth, this.copiedConfig.json.admin.photoBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	            configToSave.json.admin.photoBooth.updateSharing = this.detectChanges.checkBoothSharingChange(configToSave.json.admin.photoBooth, this.copiedConfig.json.admin.photoBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	
	            configToSave.json.admin.gifBooth.updatePrint = this.detectChanges.checkBoothPrintChange(configToSave.json.admin.gifBooth, this.copiedConfig.json.admin.gifBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	            configToSave.json.admin.gifBooth.updateSharing = this.detectChanges.checkBoothSharingChange(configToSave.json.admin.gifBooth, this.copiedConfig.json.admin.gifBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	
	            configToSave.json.admin.boomerangBooth.updatePrint = this.detectChanges.checkBoothPrintChange(configToSave.json.admin.boomerangBooth, this.copiedConfig.json.admin.boomerangBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	            configToSave.json.admin.boomerangBooth.updateSharing = this.detectChanges.checkBoothSharingChange(configToSave.json.admin.boomerangBooth, this.copiedConfig.json.admin.boomerangBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	
	            configToSave.json.admin.videoBooth.updateSharing = this.detectChanges.checkBoothSharingChange(configToSave.json.admin.videoBooth, this.copiedConfig.json.admin.videoBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
	            this.$Configuration.update(configToSave).$promise.then(function (r) {
	                var toast = _this6.$mdToast.simple().textContent(_this6.gettext("Configuration saved!")).highlightAction(true).highlightClass("md-accent").position("bottom right");
	                _this6.$mdToast.show(toast);
	                if (action === "advanced") {
	                    _this6.$state.go("configurations.update", { cid: _this6.$filter("getObjectId")(r.url) });
	                } else if (action === "draft") {
	                    _this6.$state.go("configurations");
	                }
	            }).catch(function (error) {
	                _this6.showErrorDialog("Error", "<p>" + (error.data && error.data.error ? error.data.error : "Some error occured") + "</p>");
	                _this6.$state.go("configurations");
	            });
	        }
	    }, {
	        key: "setWizardOptions",
	        value: function setWizardOptions() {
	            this.wizardOptions.digitalOverlay = this.json.admin.photoBooth.sharingOverlayFiles ? this.json.admin.photoBooth.sharingOverlayFiles[0] : null;
	            this.wizardOptions.printOverlay = this.json.admin.photoBooth.printingOverlayFiles ? this.json.admin.photoBooth.printingOverlayFiles[0] : null;
	            this.wizardOptions.stripOverlay = this.json.admin.gifBooth.printingOverlayFiles ? this.json.admin.gifBooth.printingOverlayFiles[0] : null;
	            this.wizardOptions.enablePrinting = this.json.admin.photoBooth.allowPrinting;
	            this.wizardOptions.enableSharing = this.json.admin.photoBooth.allowSharing;
	        }
	
	        // Screen validation
	
	    }, {
	        key: "canExitModeScreen",
	        value: function canExitModeScreen() {
	            if (!this.json || !this.json.admin) return false;
	
	            var modes = this.json.admin;
	            // if no mode was selected
	            if (!modes.gifBooth.enabled && !modes.photoBooth.enabled && !modes.boomerangBooth.enabled && !modes.videoBooth.enabled) {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: "canExitDesignScreen",
	        value: function canExitDesignScreen() {
	            if (!this.json || !this.json.admin) return false;
	
	            return true;
	        }
	    }, {
	        key: "canExitSharingScreen",
	        value: function canExitSharingScreen() {
	            if (!this.json || !this.json.admin || !this.json.client) return false;
	
	            if (this.json.admin.outputSettings.enableSmsSharing && !this.json.client.smsText) {
	                this.showErrorDialog("Error", "<p>Please, provide SMS sharing text</p>");
	                return false;
	            }
	
	            if (this.json.admin.outputSettings.enableSmsSharing && (!this.json.client.emailSubject || !this.json.client.emailTitle || !this.json.client.emailTextNoHtml)) {
	                this.showErrorDialog("Error", "<p>Please, provide all email sharing information</p>");
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: "changeSharing",
	        value: function changeSharing() {
	            this.json.admin.photoBooth.allowSharing = this.wizardOptions.enableSharing;
	            this.json.admin.gifBooth.allowSharing = this.wizardOptions.enableSharing;
	            this.json.admin.boomerangBooth.allowSharing = this.wizardOptions.enableSharing;
	            this.json.admin.videoBooth.allowSharing = this.wizardOptions.enableSharing;
	        }
	    }, {
	        key: "changePrinting",
	        value: function changePrinting() {
	            this.json.admin.photoBooth.allowPrinting = this.wizardOptions.enablePrinting;
	            this.json.admin.gifBooth.allowPrinting = this.wizardOptions.enablePrinting;
	            this.json.admin.boomerangBooth.allowPrinting = this.wizardOptions.enablePrinting;
	            this.json.admin.videoBooth.allowPrinting = this.wizardOptions.enablePrinting;
	        }
	    }, {
	        key: "changeAreas",
	        value: function changeAreas() {
	            if (this.json.admin.startScreenLogo.position <= 3) {
	                this.json.admin.startScreenAreas.single.y ? this.json.admin.startScreenAreas.single.y = 60 : null;
	                this.json.admin.startScreenAreas.gif.y ? this.json.admin.startScreenAreas.gif.y = 60 : null;
	                this.json.admin.startScreenAreas.boomerang.y ? this.json.admin.startScreenAreas.boomerang.y = 60 : null;
	                this.json.admin.startScreenAreas.video.y ? this.json.admin.startScreenAreas.video.y = 60 : null;
	            } else {
	                this.json.admin.startScreenAreas.single.y ? this.json.admin.startScreenAreas.single.y = 40 : null;
	                this.json.admin.startScreenAreas.gif.y ? this.json.admin.startScreenAreas.gif.y = 40 : null;
	                this.json.admin.startScreenAreas.boomerang.y ? this.json.admin.startScreenAreas.boomerang.y = 40 : null;
	                this.json.admin.startScreenAreas.video.y ? this.json.admin.startScreenAreas.video.y = 40 : null;
	            }
	        }
	    }, {
	        key: "createTemplateFromDefault",
	        value: function createTemplateFromDefault() {
	            var template = null;
	            switch (this.json.client.emailTemplate) {
	                case "German informal":
	                    template = "germanInformal";
	                    break;
	                case "German formal":
	                    template = "germanFormal";
	                    break;
	                case "English":
	                    template = "english";
	                    break;
	            }
	            if (template) {
	                this.config.json.client.emailText = this.emailTemplates.getTemplate(template, this.config.json.client.emailTitle, this.config.json.client.emailTextNoHtml);
	            }
	        }
	    }, {
	        key: "onTemplateChange",
	        value: function onTemplateChange() {
	            switch (this.json.client.emailTemplate) {
	                case "German informal":
	                    this.json.client.emailSubject = "Dein UpReach Foto";
	                    this.json.client.emailTitle = "Hey, super Foto!";
	                    this.json.client.emailTextNoHtml = "Bitte schön, dein tolles UpReach-Foto findest du im Anhang 🎉 Vielen Dank für deinen Besuch! 🙏\n" + "Scrolle ans Ende der E-Mail, um das Foto herunterzuladen & zu teilen.";
	                    this.json.client.smsText = "Hey, super Foto! 🎉\n" + "Besuche die Live-Galerie, um dein UpReach-Foto herunterzuladen & zu teilen: ";
	                    return;
	                case "German formal":
	                    this.json.client.emailSubject = "Ihr UpReach Foto";
	                    this.json.client.emailTitle = "Hey, super Foto!";
	                    this.json.client.emailTextNoHtml = "Bitte sehr, Ihr tolles UpReach-Foto finden Sie im Anhang 🎉 Vielen Dank für Ihren Besuch! 🙏\n" + "Scrollen Sie ans Ende der E-Mail, um das Foto herunterzuladen & zu teilen.";
	                    this.json.client.smsText = "Hey, super Foto! 🎉\n" + "Besuchen Sie die Live-Galerie, um Ihr UpReach-Foto herunterzuladen & zu teilen: ";
	                    return;
	                case "English":
	                    this.json.client.emailSubject = "Your UpReach photo";
	                    this.json.client.emailTitle = "Hey, nice snap!";
	                    this.json.client.emailTextNoHtml = "Here you are, please find attached your awesome UpReach photo. Thank you so much for visiting us!\n Scroll down to download & share your image.";
	                    this.json.client.smsText = "Hey, nice snap!\nVisit the live gallery to download & share your UpReach photo: ";
	                    return;
	            }
	        }
	    }, {
	        key: "onModeChange",
	        value: function onModeChange() {
	            this.setDigitalBackground();
	            this.setPrintBackground();
	            this.setStripBackground();
	        }
	    }, {
	        key: "resetEmail",
	        value: function resetEmail() {
	            this.json.client.emailTemplate = "English";
	            this.json.client.emailSubject = "Your UpReach photo";
	            this.json.client.emailTitle = "Hey, nice snap!";
	            this.json.client.emailTextNoHtml = "Here you are, please find attached your awesome UpReach photo. Thank you so much for visiting us!\n Scroll down to download & share your image.";
	        }
	    }, {
	        key: "resetSMS",
	        value: function resetSMS() {
	            this.json.client.smsText = "Hey, nice snap!\n Visit the live gallery to download & share your UpReach photo: ";
	        }
	    }, {
	        key: "nextStep",
	        value: function nextStep() {
	            this.wizard.wizard().next();
	        }
	    }, {
	        key: "checkBackgroundResolution",
	        value: function checkBackgroundResolution() {
	            var _this7 = this;
	
	            setTimeout(function () {
	                if (_this7.json.admin && _this7.json.admin.startScreenBackground && _this7.json.admin.startScreenBackground.attachment_file) {
	                    var isVideo = _this7.json.admin.startScreenBackground.attachment_file.indexOf(".mp4") !== -1;
	                    var VALID_RESOLUTION = 1920 / 1080;
	                    var media = isVideo ? new Video() : new Image();
	                    media.src = _this7.json.admin.startScreenBackground.attachment_file;
	                    if (isVideo) {
	                        media.onloadeddata = function () {
	                            if (media.videoWidth / media.videoHeight !== VALID_RESOLUTION) {
	                                _this7.showBgToggle = true;
	                            } else {
	                                _this7.showBgToggle = false;
	                            }
	                        };
	                    } else {
	                        media.onload = function () {
	                            if (media.width / media.height !== VALID_RESOLUTION) {
	                                _this7.showBgToggle = true;
	                            } else {
	                                _this7.showBgToggle = false;
	                            }
	                        };
	                    }
	                } else {
	                    _this7.showBgToggle = false;
	                }
	            });
	
	            function Video() {
	                return document.createElement("video");
	            }
	        }
	    }, {
	        key: "checkModes",
	        value: function checkModes(booth) {
	            if (booth === "photoBooth") {
	                if (!this.json.admin.gifBooth.enabled && !this.json.admin.boomerangBooth.enabled && !this.json.admin.videoBooth.enabled) {
	                    this.json.admin.photoBooth.enabled = true;
	                }
	            }
	
	            if (booth === "gifBooth") {
	                if (!this.json.admin.photoBooth.enabled && !this.json.admin.boomerangBooth.enabled && !this.json.admin.videoBooth.enabled) {
	                    this.json.admin.gifBooth.enabled = true;
	                }
	            }
	
	            if (booth === "boomerangBooth") {
	                if (!this.json.admin.gifBooth.enabled && !this.json.admin.photoBooth.enabled && !this.json.admin.videoBooth.enabled) {
	                    this.json.admin.boomerangBooth.enabled = true;
	                }
	            }
	
	            if (booth === "videoBooth") {
	                if (!this.json.admin.gifBooth.enabled && !this.json.admin.photoBooth.enabled && !this.json.admin.boomerangBooth.enabled) {
	                    this.json.admin.videoBooth.enabled = true;
	                }
	            }
	        }
	    }, {
	        key: "showErrorDialog",
	        value: function showErrorDialog(title, HTMLtext) {
	            this.$mdDialog.show(this.$mdDialog.alert().clickOutsideToClose(true).title(this.gettext(title)).htmlContent(this.gettext(HTMLtext)).ariaLabel(this.gettext("Error")).ok("OK").targetEvent(event));
	        }
	    }, {
	        key: "getFileType",
	        value: function getFileType(file) {
	            if (!file) {
	                return true;
	            }
	
	            if (!file.attachment_file) {
	                return true;
	            }
	
	            if (typeof file.attachment_file !== "string") {
	                return true;
	            }
	
	            var str = file.attachment_file.split(".");
	
	            return str[str.length - 1];
	        }
	    }]);
	    return QuickSetupController;
	}(_index.$controller);
	
	exports.default = QuickSetupController;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DigitalLayoutController = undefined;
	
	var _lodash = __webpack_require__(101);
	
	var _fileSizes = __webpack_require__(277);
	
	var DigitalLayoutController = exports.DigitalLayoutController = ["$scope", "$mdDialog", "callback", "company", "overlay", "startScreenDesign", "background", "logo", "showLogo", "activeMode", function DigitalLayoutController($scope, $mdDialog, callback, company, overlay, startScreenDesign, background, logo, showLogo, activeMode) {
	    "ngInject";
	
	    // if json provided than clone configuration
	
	    $scope.sourceConfig && ($scope.configuration.json = $scope.sourceConfig.json);
	
	    $scope.overlay = overlay;
	    $scope.callback = callback;
	    $scope.company = company;
	    $scope.startScreenDesign = startScreenDesign;
	    $scope.background = background;
	    $scope.savedFile = $scope.startScreenDesign ? (0, _lodash.cloneDeep)($scope.background.file) : null;
	    $scope.savedColor = $scope.startScreenDesign ? (0, _lodash.cloneDeep)($scope.background.color) : null;
	    $scope.logo = logo;
	    $scope.showLogo = $scope.startScreenDesign ? showLogo : false;
	    $scope.activeMode = activeMode;
	    $scope.single = $scope.activeMode === "single";
	    $scope.fileSizes = _fileSizes.FILE_SIZES;
	    $scope.photos = [{
	        width: 500,
	        height: 500,
	        x: 0,
	        y: 0,
	        image: $scope.activeMode === "single",
	        gif: $scope.activeMode === "gif",
	        video: $scope.activeMode === "boomerang"
	    }];
	
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	
	    $scope.create = function () {
	        var data = {
	            overlay: $scope.overlay,
	            startScreenDesign: $scope.startScreenDesign
	        };
	        $scope.callback(data);
	        $mdDialog.hide();
	    };
	
	    $scope.deleteFile = function () {
	        $scope.overlay = null;
	    };
	
	    $scope.onChangeOption = function () {
	        if ($scope.startScreenDesign) {
	            $scope.savedFile = (0, _lodash.cloneDeep)($scope.background.file);
	            $scope.savedColor = (0, _lodash.cloneDeep)($scope.background.color);
	            $scope.showLogo = true;
	        } else {
	            $scope.savedFile = null;
	            $scope.savedColor = null;
	            $scope.showLogo = false;
	        }
	    };
	}];

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Create new configuration\" class=\"dialog-description-container digital-dialog-cont\">\n    <h2>Digital - <small>All selected modes</small></h2>\n    <p>Please upload your custom overlay <br>\n        design for the digital sharing version of <br>\n        all capture modes. it will be placed on <br>\n        top of the images</p>\n    <div class=\"line\"></div>\n\n    <md-switch\n            ng-change=\"onChangeOption()\"\n            md-invert\n            ng-model=\"startScreenDesign\">\n        {{'Use design from the start screen' | translate}}\n    </md-switch>\n\n    <div class=\"ss-bg-info\" ng-class=\"{'ss-disabled': ctrl.json.admin.startScreenBackgroundMode === 'color'}\">\n        <div class=\"icon\">\n            <i class=\"material-icons\">\n                info\n            </i>\n        </div>\n        <div class=\"info-text\">\n            Dimension 500x500 px <br>\n            Format .png <br>\n            Size {{fileSizes.sharing}} mb\n        </div>\n    </div>\n\n    <div class=\"ss-tm-download\" ng-class=\"{'ss-disabled': ctrl.json.admin.startScreenBackgroundMode === 'color'}\">\n        <div class=\"icon\">\n            <i class=\"material-icons\">\n                get_app\n            </i>\n        </div>\n        <div class=\"info-text\">\n            Download Photoshop template\n        </div>\n    </div>\n    <upload\n            model=\"overlay\"\n            uri=\"{{company + 'attachments/'}}\"\n            custom-label=\"{{'Upload' | translate}}\"\n            file-types=\".png\"\n            max-size=\"fileSizes.sharing\"\n            hide-error-popup=\"true\"\n            is-overlay=\"false\"\n            display-icon=\"true\"\n            ng-disabled=\"ctrl.json.admin.startScreenBackgroundMode === 'color'\">\n    </upload>\n    <div class=\"file-title\" ng-if=\"overlay && overlay.attachment_file\" title=\"{{overlay.attachment_file | getFileName}}\">\n        <span>Uploaded: {{ overlay.attachment_file | getFileName:12 }}</span>\n        <md-button\n                class=\"md-icon-button md-primary\"\n                ng-click=\"deleteFile()\">\n            <md-icon style=\"color: gray\">delete</md-icon>\n        </md-button>\n    </div>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"create()\"\n                class=\"md-primary\"\n                ng-disabled=\"configurationCreateForm.$invalid\">{{'Save' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>\n<md-dialog aria-label=\"Create new configuration\" class=\"digital-dialog\">\n    <html-preview\n            single=\"single\"\n            pr-width=\"{{500}}\"\n            pr-height=\"{{500}}\"\n            index=\"{{0.8334}}\"\n            background=\"{{[(savedFile.first_frame || savedFile.attachment_file)]}}\"\n            logo-type=\"'digital'\"\n            logo=\"logo.attachment_file\"\n            hide-logo=\"!showLogo\"\n            overlay=\"{{overlay.attachment_file}}\"\n            areas=\"{{photos}}\"\n            animation-speed=\"{{1.5}}\"\n            style=\"margin: 0 auto\"\n            bg-style=\"'crop'\"\n            hide-title=\"true\"\n            bg-mode=\"background.mode\"\n            bg-color=\"savedColor\">\n    </html-preview>\n</md-dialog>\n";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PrintLayoutController = undefined;
	
	var _lodash = __webpack_require__(101);
	
	var _fileSizes = __webpack_require__(277);
	
	var PrintLayoutController = exports.PrintLayoutController = ["$scope", "$mdDialog", "callback", "company", "overlay", "bleed", "photos", "startScreenDesign", "background", "logo", "showLogo", "logosArr", function PrintLayoutController($scope, $mdDialog, callback, company, overlay, bleed, photos, startScreenDesign, background, logo, showLogo, logosArr) {
	    "ngInject";
	
	    // if json provided than clone configuration
	
	    $scope.sourceConfig && ($scope.configuration.json = $scope.sourceConfig.json);
	    $scope.callback = callback;
	    $scope.company = company;
	    $scope.overlay = overlay;
	    $scope.bleed = bleed;
	    $scope.photos = photos;
	    $scope.startScreenDesign = startScreenDesign;
	    $scope.background = background;
	    $scope.savedFile = $scope.startScreenDesign ? (0, _lodash.cloneDeep)($scope.background.file) : null;
	    $scope.savedColor = $scope.startScreenDesign ? (0, _lodash.cloneDeep)($scope.background.color) : null;
	    $scope.logo = logo;
	    $scope.showLogo = $scope.startScreenDesign ? showLogo : false;
	    $scope.logosArr = logosArr;
	    $scope.fileSizes = _fileSizes.FILE_SIZES;
	
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	
	    $scope.create = function () {
	        var data = {
	            overlay: $scope.overlay,
	            bleed: $scope.bleed,
	            startScreenDesign: $scope.startScreenDesign
	        };
	        $scope.callback(data);
	        $mdDialog.hide();
	    };
	
	    $scope.deleteFile = function () {
	        $scope.overlay = null;
	    };
	
	    $scope.onChangeOption = function () {
	        if ($scope.startScreenDesign) {
	            $scope.savedFile = (0, _lodash.cloneDeep)($scope.background.file);
	            $scope.savedColor = (0, _lodash.cloneDeep)($scope.background.color);
	            $scope.showLogo = true;
	        } else {
	            $scope.savedFile = null;
	            $scope.savedColor = null;
	            $scope.showLogo = false;
	        }
	    };
	}];

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Create new configuration\" class=\"dialog-description-container print-dialog-cont\">\n    <h2>Single Photo - <small>Photo mode</small></h2>\n    <p>Please upload your custom overlay design<br>\n        for the printout of the \"Photo\" mode. It will<br>\n        be placed on top of the image.<br>\n\n    <p>The printer size is 1200x1800px <br>\n        (10x15cm) but your design must be set up <br>\n        at 1240x1844px due to printer bleed</p>\n    <div class=\"line\"></div>\n\n    <md-switch\n            ng-change=\"onChangeOption()\"\n            md-invert\n            ng-model=\"startScreenDesign\"\n            class=\"print-switch\">\n        {{'Use design from the start screen' | translate}}\n    </md-switch>\n\n    <div class=\"ss-bg-info\">\n        <div class=\"icon\">\n            <i class=\"material-icons\">\n                info\n            </i>\n        </div>\n        <div class=\"info-text\">\n            Dimension 1240:1844 px <br>\n            Format .png <br>\n            Size {{fileSizes.print}} mb\n        </div>\n    </div>\n\n    <div class=\"ss-tm-download\">\n        <div class=\"icon\">\n            <i class=\"material-icons\">\n                get_app\n            </i>\n        </div>\n        <div class=\"info-text\">\n            Download Photoshop template\n        </div>\n    </div>\n    <upload\n            model=\"overlay\"\n            uri=\"{{company + 'attachments/'}}\"\n            custom-label=\"{{'Upload' | translate}}\"\n            max-size=\"fileSizes.print\"\n            hide-error-popup=\"true\"\n            is-overlay=\"false\"\n            display-icon=\"true\"\n            file-types=\".png\">\n    </upload>\n    <div class=\"file-title\" ng-if=\"overlay && overlay.attachment_file\" title=\"{{overlay.attachment_file | getFileName}}\">\n        <span>Uploaded: {{ overlay.attachment_file | getFileName }}</span>\n        <md-button\n                class=\"md-icon-button md-primary\"\n                ng-click=\"deleteFile()\">\n            <md-icon style=\"color: gray\">delete</md-icon>\n        </md-button>\n    </div>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"create()\"\n                class=\"md-primary\"\n                ng-disabled=\"configurationCreateForm.$invalid\">{{'Save' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>\n<md-dialog aria-label=\"Create new configuration\" class=\"dialog-transparent print-dialog\">\n    <html-preview\n            single=\"true\"\n            pr-width=\"{{1240}}\"\n            pr-height=\"{{1844}}\"\n            index=\"{{3.48962}}\"\n            logo-type=\"'print'\"\n            logo=\"logo.attachment_file\"\n            hide-logo=\"!showLogo\"\n            background=\"{{[(savedFile.first_frame || savedFile.attachment_file)]}}\"\n            overlay=\"{{[overlay.attachment_file]}}\"\n            areas=\"{{photos}}\"\n            animation-speed=\"{{1.5}}\"\n            style=\"margin: 0 auto\"\n            ignore-overflow=\"true\"\n            printer-bleed=\"{{bleed}}\"\n            hide-title=\"true\"\n            bg-style=\"'crop'\"\n            bg-mode=\"background.mode\"\n            bg-color=\"savedColor\"\n            logos-arr=\"logosArr\">\n    </html-preview>\n    <div class=\"switch-holder\">\n        <md-switch\n                md-invert\n                ng-model=\"bleed\">\n            {{'Preview printer bleed' | translate}}\n        </md-switch>\n    </div>\n</md-dialog>\n";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.StripLayoutController = undefined;
	
	var _lodash = __webpack_require__(101);
	
	var _fileSizes = __webpack_require__(277);
	
	var StripLayoutController = exports.StripLayoutController = ["$scope", "$mdDialog", "callback", "company", "overlay", "bleed", "photos", "startScreenDesign", "background", "logo", "showLogo", "cuttingLine", "boomerang", "logosArr", function StripLayoutController($scope, $mdDialog, callback, company, overlay, bleed, photos, startScreenDesign, background, logo, showLogo, cuttingLine, boomerang, logosArr) {
	    "ngInject";
	
	    // if json provided than clone configuration
	
	    $scope.sourceConfig && ($scope.configuration.json = $scope.sourceConfig.json);
	    $scope.callback = callback;
	    $scope.company = company;
	    $scope.overlay = overlay;
	    $scope.bleed = bleed;
	    $scope.photos = photos;
	    $scope.cuttingLine = cuttingLine;
	    $scope.startScreenDesign = startScreenDesign;
	    $scope.background = background;
	    $scope.savedFile = $scope.startScreenDesign ? (0, _lodash.cloneDeep)($scope.background.file) : null;
	    $scope.savedColor = $scope.startScreenDesign ? (0, _lodash.cloneDeep)($scope.background.color) : null;
	    $scope.logo = logo;
	    $scope.showLogo = $scope.startScreenDesign ? showLogo : false;
	    $scope.boomerang = boomerang;
	    $scope.logosArr = logosArr;
	    $scope.fileSizes = _fileSizes.FILE_SIZES;
	
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	
	    $scope.create = function () {
	        var data = {
	            overlay: $scope.overlay,
	            bleed: $scope.bleed,
	            startScreenDesign: $scope.startScreenDesign,
	            cuttingLine: $scope.cuttingLine
	        };
	        $scope.callback(data);
	        $mdDialog.hide();
	    };
	
	    $scope.deleteFile = function () {
	        $scope.overlay = null;
	    };
	
	    $scope.onChangeOption = function () {
	        if ($scope.startScreenDesign) {
	            $scope.savedFile = (0, _lodash.cloneDeep)($scope.background.file);
	            $scope.savedColor = (0, _lodash.cloneDeep)($scope.background.color);
	            $scope.showLogo = true;
	        } else {
	            $scope.savedFile = null;
	            $scope.savedColor = null;
	            $scope.showLogo = false;
	        }
	    };
	}];

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Create new configuration\" class=\"dialog-description-container strip-dialog-cont\">\n    <h2>Photo Strips - <small>GIF & Boomerang</small></h2>\n    <p>Please upload your custom overlay design <br>\n        for the printout of the „GIF“ & „Boomerang“ <br>\n        modes. It will be placed on top of the <br>\n        images.</p>\n\n    <p>The printed size is 1200x1800px (10x15cm) <br>\n        cut into 2 strips, but your design must be set <br>\n        up at 1240x1844px due to printer bleed. </p>\n    <div class=\"line\"></div>\n\n    <md-switch\n            ng-change=\"onChangeOption()\"\n            md-invert\n            ng-model=\"startScreenDesign\"\n            class=\"print-switch\">\n        {{'Use design from the start screen' | translate}}\n    </md-switch>\n\n    <div class=\"ss-bg-info\" ng-class=\"{'ss-disabled': ctrl.json.admin.startScreenBackgroundMode === 'color'}\">\n        <div class=\"icon\">\n            <i class=\"material-icons\">\n                info\n            </i>\n        </div>\n        <div class=\"info-text\">\n            Dimension 1240:1844 px <br>\n            Format .png <br>\n            Size {{fileSizes.print}} mb\n        </div>\n    </div>\n\n    <div class=\"ss-tm-download\" ng-class=\"{'ss-disabled': ctrl.json.admin.startScreenBackgroundMode === 'color'}\">\n        <div class=\"icon\">\n            <i class=\"material-icons\">\n                get_app\n            </i>\n        </div>\n        <div class=\"info-text\">\n            Download Photoshop template\n        </div>\n    </div>\n    <upload\n            model=\"overlay\"\n            uri=\"{{company + 'attachments/'}}\"\n            custom-label=\"{{'Upload' | translate}}\"\n            max-size=\"fileSizes.print\"\n            hide-error-popup=\"true\"\n            file-types=\".png\"\n            is-overlay=\"false\"\n            display-icon=\"true\"\n            ng-disabled=\"ctrl.json.admin.startScreenBackgroundMode === 'color'\">\n    </upload>\n    <div class=\"file-title\" ng-if=\"overlay && overlay.attachment_file\" title=\"{{overlay.attachment_file | getFileName}}\">\n        <span>Uploaded: {{ overlay.attachment_file | getFileName:12 }}</span>\n        <md-button\n                class=\"md-icon-button md-primary\"\n                ng-click=\"deleteFile()\">\n            <md-icon style=\"color: gray\">delete</md-icon>\n        </md-button>\n    </div>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"create()\"\n                class=\"md-primary\"\n                ng-disabled=\"configurationCreateForm.$invalid\">{{'Save' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>\n<md-dialog aria-label=\"Create new configuration\" class=\"dialog-transparent strip-dialog\">\n    <html-preview\n            boomerang=\"boomerang\"\n            pr-width=\"{{1240}}\"\n            pr-height=\"{{1844}}\"\n            index=\"{{3.8355}}\"\n            strip=\"{{cuttingLine}}\"\n            ratio=\"{{'portrait'}}\"\n            logo-type=\"'strip'\"\n            logo=\"logo.attachment_file\"\n            hide-logo=\"!showLogo\"\n            background=\"{{[(savedFile.first_frame || savedFile.attachment_file)]}}\"\n            overlay=\"{{[overlay.attachment_file]}}\"\n            areas=\"{{photos}}\"\n            animation-speed=\"{{1.5}}\"\n            style=\"margin: 0 auto\"\n            ignore-overflow=\"true\"\n            printer-bleed=\"{{bleed}}\"\n            bg-mode=\"background.mode\"\n            bg-color=\"savedColor\"\n            bg-style=\"'crop'\"\n            hide-title=\"true\"\n            logos-arr=\"logosArr\">\n    </html-preview>\n    <div class=\"switch-holder double-switch\">\n        <md-switch\n                md-invert\n                ng-model=\"bleed\">\n            {{'Preview printer bleed' | translate}}\n        </md-switch>\n        <md-switch\n                md-invert\n                ng-model=\"cuttingLine\">\n            {{'Preview cutting line' | translate}}\n        </md-switch>\n    </div>\n</md-dialog>\n";

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ChangeNameController = exports.ChangeNameController = ["$scope", "$mdDialog", "name", "callback", "title", "isUpperCase", function ChangeNameController($scope, $mdDialog, name, callback, title, isUpperCase) {
	    "ngInject";
	
	    $scope.name = name;
	    $scope.callback = callback;
	    $scope.title = title;
	    $scope.isUpperCase = isUpperCase || false;
	    // if json provided than clone configuration
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	
	    $scope.create = function () {
	        $scope.callback($scope.name);
	        $mdDialog.hide();
	        document.onkeypress = function () {};
	    };
	
	    document.onkeypress = function (ev) {
	        if (ev.key === "Enter") {
	            if ($scope.name) {
	                $scope.create();
	            }
	        }
	    };
	}];

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Configuration\">\n    <md-dialog-content style=\"overflow: hidden; width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\">{{title | translate}}</h2>\n            <form name=\"configurationCreateForm\">\n                <md-input-container md-no-float class=\"md-inline-form\" style=\"width: 100%;\">\n                    <input\n                            flex=\"grow\"\n                            ng-model=\"name\"\n                            id=\"configurationName\"\n                            flex-order=\"0\"\n                            ng-class=\"{'upper-cased': isUpperCase}\"\n                            minlength=\"3\"\n                            maxlength=\"36\"\n                            md-autofocus\n                            required/>\n                </md-input-container>\n            </form>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"create()\"\n                class=\"md-primary\"\n                ng-disabled=\"configurationCreateForm.$invalid\">{{'Change' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "videos/short-preview.4d7ee947232840142cfcdc1528a5c4a7.mp4";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(312);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./quick-setup.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./quick-setup.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "quick-setup upload span{font-size:15px}quick-setup .custom-preview .preview-main{border:1px solid #d3d3d3}quick-setup .main-container{position:relative;min-width:1280px;height:calc(100vh - 55px);overflow:hidden}quick-setup .main-container .config-title{font-size:15px;display:inline-block;margin:23px;color:#000;position:absolute;max-width:23%}quick-setup .main-container .config-title .name{font-weight:bolder}quick-setup .main-container .config-title i{cursor:pointer;color:grey;position:relative;font-size:15px;top:1px}quick-setup .main-container .save-container{position:absolute;margin:0 21px;right:0;display:flex;flex-direction:column;align-items:flex-end}quick-setup .main-container .save-container button{background:#ee2737;color:#fff;width:120px;height:40px;border-radius:23px;font-size:17px;margin-top:20px;margin-right:0}quick-setup .main-container .save-container span{font-size:15px;color:#969696;text-decoration:underline;cursor:pointer}quick-setup .main-container .save-container span.final{color:#ff3150}quick-setup .main-container .mode .info{display:flex;flex-direction:column;margin:0 25px 35px}quick-setup .main-container .mode .info .header{color:#000;font-size:22px;margin:10px 0}quick-setup .main-container .mode .info .info-main{color:#848484;font-size:18px;margin:10px 0}quick-setup .main-container .mode .modes{display:flex;margin:20px 0;justify-content:space-between}quick-setup .main-container .mode .modes .mode-container{flex:1;box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9;cursor:pointer;outline:none}quick-setup .main-container .mode .modes .mode-container.disabled{color:#9e9e9e;opacity:.5}quick-setup .main-container .mode .modes .mode-container.disabled .text{color:#9e9e9e!important;font-size:16px;padding:0 70px 20px 10px;line-height:20px}quick-setup .main-container .mode .modes .mode-container .toggle{margin:20px 15px 20px 45px;position:relative}quick-setup .main-container .mode .modes .mode-container .toggle:before{content:\"\";position:absolute;width:100%;height:100%;z-index:20}quick-setup .main-container .mode .modes .mode-container .toggle md-switch{display:flex;align-items:center;justify-content:space-between;margin:16px 10px;font-size:21px}quick-setup .main-container .mode .modes .mode-container .toggle md-switch .md-container{transform:scale(1.4) translateX(-8px)}quick-setup .main-container .mode .modes .mode-container .photos{display:flex}quick-setup .main-container .mode .modes .mode-container .photos .img-holder{flex:1;width:50%;height:50%;display:inline-block;padding-bottom:50%;box-sizing:padding-box;background-color:#e9ebea}quick-setup .main-container .mode .modes .mode-container .photos .img-holder.boomerang,quick-setup .main-container .mode .modes .mode-container .photos .img-holder.gif,quick-setup .main-container .mode .modes .mode-container .photos .img-holder.photo{background-size:cover;background-position:50% 50%}quick-setup .main-container .mode .modes .mode-container .photos .img-holder.boomerang-print,quick-setup .main-container .mode .modes .mode-container .photos .img-holder.gif-print,quick-setup .main-container .mode .modes .mode-container .photos .img-holder.photo-print{background-size:75%;background-position:50% 50%;background-repeat:no-repeat}quick-setup .main-container .mode .modes .mode-container .photos .img-holder.photo{background-image:url(" + __webpack_require__(313) + ")}quick-setup .main-container .mode .modes .mode-container .photos .img-holder.gif{background-image:url(" + __webpack_require__(314) + ")}quick-setup .main-container .mode .modes .mode-container .photos .img-holder.boomerang{object-fit:contain;position:relative;overflow:hidden}quick-setup .main-container .mode .modes .mode-container .photos .img-holder.boomerang video{width:178%;height:100%;position:absolute;left:-39%}quick-setup .main-container .mode .modes .mode-container .photos .img-holder.photo-print{background-image:url(" + __webpack_require__(315) + ")}quick-setup .main-container .mode .modes .mode-container .photos .img-holder.gif-print{background-image:url(" + __webpack_require__(316) + ")}quick-setup .main-container .mode .modes .mode-container .photos .img-holder.boomerang-print{background-image:url(" + __webpack_require__(317) + ")}quick-setup .main-container .mode .modes .mode-container .options-container{margin-top:10px;display:flex}quick-setup .main-container .mode .modes .mode-container .options-container .photo{flex:1;padding:15px 15px 0 25px}quick-setup .main-container .mode .modes .mode-container .options-container .photo img{width:100%;height:auto}quick-setup .main-container .mode .modes .mode-container .options-container .info-text{flex:4}quick-setup .main-container .mode .modes .mode-container .options-container .info-text .text{color:#000;font-size:16px;padding:0 70px 20px 10px;line-height:20px}quick-setup .main-container .mode .modes .mode-container:nth-child(2){margin:0 45px}quick-setup .main-container .start-screen{display:flex}quick-setup .main-container .start-screen .main-container-ss{flex:6}quick-setup .main-container .start-screen .main-container-ss .info{display:flex;flex-direction:column;margin:0 25px 35px}quick-setup .main-container .start-screen .main-container-ss .info .header{color:#000;font-size:22px;margin:10px 0}quick-setup .main-container .start-screen .main-container-ss .info .info-main{color:#848484;font-size:18px;margin:10px 0}quick-setup .main-container .start-screen .main-container-ss .settings-ss{display:flex;justify-content:flex-start;margin:0 25px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section{flex:1;max-width:321px;box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9;padding:20px 0 20px 40px;position:relative}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section.logo-disabled{color:#9e9e9e;opacity:.5}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section:first-child{margin-right:25px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section:last-child{margin-left:25px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section upload{margin-top:25px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .file-title{width:50%;margin-left:10px;min-width:275px;font-size:16px;color:#a8a8a9;white-space:nowrap}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .file-title md-icon{color:#a8a8a9!important}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .file-title md-icon:hover{color:#848484}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .slider-title{padding:0 0 0 10px;display:inline-block;color:#848484;margin-top:35px;font-size:17px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-slider-container{padding:0 50px 0 10px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-slider-container .md-sign{display:none}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-slider-container md-slider[md-discrete]:not([disabled]).md-active .md-thumb{transform:scale(.7)}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-slider-container .md-track-ticks{display:none}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont{margin:0 50px 0 10px;font-size:17px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector-title{width:100%;margin:0 auto;display:block;color:#848484}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector{width:100%;margin:0 auto;position:relative}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group{width:0;height:0;z-index:200}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button{position:absolute;margin:0}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button .md-off{background-color:#fff}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.top-left{top:4%;left:8%}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.top-middle{top:4%;left:calc(50% - 10px)}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.top-right{top:4%;right:5%}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.bottom-left{bottom:15%;left:8%}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.bottom-middle{bottom:15%;left:calc(50% - 10px)}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.bottom-right{bottom:15%;right:5%}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector img{width:100%}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-title{margin:16px 10px;font-size:24px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-radio-group{margin:10px 0 0 30px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-radio-group .color-picker-label{display:block;position:absolute;top:102px;right:26px;border-radius:50%;outline:none;border:1px solid #d3d3d3;width:22px;height:22px;cursor:pointer}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-radio-group md-radio-button{margin:0 0 30px 10px;font-size:17px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-bg-info{display:flex;color:#848484;font-size:15px;margin:0 0 0 10px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-bg-info.logo-info{margin-top:30px;margin-bottom:-30px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-bg-info.ss-disabled{opacity:.7}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-bg-info.ss-disabled .icon{color:#848484}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-bg-info .icon{width:40px;color:#ee2737}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-tm-download{display:flex;color:#ee2737;font-size:15px;margin:10px 0 0 10px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-tm-download.ss-disabled{opacity:.7;color:#848484}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-tm-download.ss-disabled .info-text{text-decoration:none;cursor:default}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-tm-download .icon{width:30px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-tm-download .info-text{text-decoration:underline;cursor:pointer}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .image-crop{display:flex;margin:10px 0 0 10px;align-items:center;color:#848484;font-size:15px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .image-crop.ss-disabled{opacity:.7}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .image-crop md-switch{margin:0}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .image-crop md-switch .md-thumb{background-color:#ff4081}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .image-crop md-switch .md-bar{background-color:rgba(255,64,129,.5)}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .image-crop .title-crop{margin:0 5px;outline:none;cursor:pointer}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .image-crop .title-crop.crop-active{color:#ff4081}quick-setup .main-container .start-screen .booth-preview{flex:4;max-width:710px;position:relative}quick-setup .main-container .start-screen .booth-preview .booth-image{position:absolute;top:70px;width:650px;z-index:0}quick-setup .main-container .start-screen .booth-preview .preview-container{z-index:7;position:absolute;top:418px;left:21px}quick-setup .main-container .design{padding-bottom:20px}quick-setup .main-container .design .info{display:flex;flex-direction:column;margin:0 25px 35px}quick-setup .main-container .design .info .header{color:#000;font-size:22px;margin:10px 0}quick-setup .main-container .design .info .info-main{color:#848484;font-size:18px;margin:10px 0}quick-setup .main-container .design .design-container{display:flex}quick-setup .main-container .design .design-container .design-digital{flex:9;margin-right:21px}quick-setup .main-container .design .design-container .design-digital .design-d-info{font-size:17px;color:#717171;margin-top:32px;height:110px}quick-setup .main-container .design .design-container .design-digital .design-d-pr-container{height:180px;display:flex;justify-content:center}quick-setup .main-container .design .design-container .design-digital .design-d-pr-container html-preview{margin:0 10px}quick-setup .main-container .design .design-container .design-digital .design-d-pr-container html-preview .preview-main{box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9}quick-setup .main-container .design .design-container .design-print{flex:11;margin-left:21px}quick-setup .main-container .design .design-container .design-print .design-p-pr-container{display:flex}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .single{flex:4}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .strips{flex:5}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .title-print{font-size:19px;color:#000;margin-top:32px}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .text-print{color:#717171;font-size:19px;margin-top:5px;height:78px}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .print-ph-holder{height:250px;margin-right:10px;display:flex;justify-content:center}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .print-ph-holder html-preview{margin:0 10px}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .print-ph-holder html-preview .preview-main{box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9}quick-setup .main-container .design .design-container .design-print .design-p-pr-container button{margin-top:-10px}quick-setup .main-container .design .design-container .design-digital,quick-setup .main-container .design .design-container .design-print{box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9;padding:20px 40px}quick-setup .main-container .design .design-container .design-digital.design-disabled,quick-setup .main-container .design .design-container .design-print.design-disabled{color:#9e9e9e;opacity:.5}quick-setup .main-container .design .design-container .design-digital md-switch,quick-setup .main-container .design .design-container .design-print md-switch{font-size:22px;margin-left:0}quick-setup .main-container .design .design-container .design-digital md-switch .md-container,quick-setup .main-container .design .design-container .design-print md-switch .md-container{transform:scale(1.3) translateX(25px)}quick-setup .main-container .design .design-container .design-digital .divider,quick-setup .main-container .design .design-container .design-print .divider{border-top:1px solid hsla(0,0%,44%,.33)}quick-setup .main-container .design .design-container .design-digital button,quick-setup .main-container .design .design-container .design-print button{margin:60px auto 0;display:block;font-size:17px;padding:4px 30px}quick-setup .main-container .design .design-container .design-digital button i,quick-setup .main-container .design .design-container .design-print button i{position:relative;top:4px}quick-setup .main-container .sharing .info{display:flex;flex-direction:column;margin:-20px 25px 35px}quick-setup .main-container .sharing .info .header{color:#000;font-size:22px;margin:10px 0}quick-setup .main-container .sharing .info .info-main{color:#848484;font-size:18px;margin:10px 0}quick-setup .main-container .sharing .sharing-container{display:flex}quick-setup .main-container .sharing .sharing-container .email-sharing,quick-setup .main-container .sharing .sharing-container .sms-sharing{flex:1;display:flex}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont{width:358px;position:relative}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont.phone-disabled,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont.phone-disabled{color:#9e9e9e;opacity:.5}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont md-switch,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont md-switch{font-size:21px;margin-left:25px}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont md-switch .md-container,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont md-switch .md-container{transform:scale(1.2) translateX(25px)}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont .switch-desc,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont .switch-desc{margin-left:25px;font-size:16px;color:#717171;margin-top:-10px;white-space:nowrap}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont phone-msg,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont phone-msg{position:absolute;top:258px;left:33px}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont email-preview,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont email-preview{position:absolute;top:166px;left:31px}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont .phone-img,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont .phone-img{margin-top:20px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont{height:500px;flex-grow:2;display:flex;flex-direction:column;margin:0 40px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block{box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9;width:80%;padding:30px 26px 0;background-color:#fff}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block md-input-container,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block md-input-container{width:100%}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.sms,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.sms{margin-top:257px;position:relative}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.sms .dot,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.sms .dot{position:absolute;width:19px;height:19px;border-radius:50%;background-color:#ee2737;top:27px;left:-136px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.sms:before,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.sms:before{content:\"\";position:absolute;width:128px;border:1px solid #ee2737;border-radius:2px;top:17px;left:-129px;transform:rotate(-15deg);z-index:0}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.sms:after,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.sms:after{content:\"\";position:absolute;width:176px;border:1px solid #ee2737;border-radius:2px;bottom:60px;left:-152px;transform:rotate(45deg);z-index:0}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.lang,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.lang{margin-top:55px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.subject,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.subject{margin-top:15px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.title,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.title{margin-top:15px;position:relative}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.title .dot,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.title .dot{position:absolute;width:19px;height:19px;border-radius:50%;background-color:#ee2737;top:-47px;left:-97px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.title:before,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.title:before{content:\"\";position:absolute;width:96px;border:1px solid #ee2737;border-radius:2px;top:-19px;left:-94px;transform:rotate(22deg);z-index:0}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.title:after,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.title:after{content:\"\";position:absolute;width:162px;border:1px solid #ee2737;border-radius:2px;bottom:69px;left:-123px;transform:rotate(60deg);z-index:0}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.message,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.message{margin-top:15px;position:relative}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.message .dot,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.message .dot{position:absolute;width:19px;height:19px;border-radius:50%;background-color:#ee2737;top:-61px;left:-97px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.message:before,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.message:before{content:\"\";position:absolute;width:106px;border:1px solid #ee2737;border-radius:2px;top:-28px;left:-102px;transform:rotate(31deg);z-index:0}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.message:after,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.message:after{content:\"\";position:absolute;width:202px;border:1px solid #ee2737;border-radius:2px;bottom:90px;left:-144px;transform:rotate(66deg);z-index:0}quick-setup .main-container .reset{font-size:15px;text-align:right;color:#888;cursor:pointer;text-decoration:underline;margin-top:7px;width:80%;padding:0 0 0 60px;outline:none}quick-setup .toggle md-switch{display:flex;align-items:center;justify-content:space-between;margin:16px 10px;font-size:24px}quick-setup .toggle md-switch .md-container{transform:scale(1.5) translateX(-8px)}quick-setup .wizard-container{max-width:1450px;margin:-10px auto;padding:0 25px}quick-setup .steps-indicator{width:760px;position:relative;font-size:20px;display:flex;justify-content:space-between}quick-setup .steps-indicator li.editing a{color:#ff3150}quick-setup .steps-indicator li a{display:inline-block;position:relative}quick-setup .steps-indicator li a:hover{text-decoration:underline}quick-setup .steps-indicator li:before{content:\"\";width:40px;height:0;border-top:1px solid #000;position:absolute;right:-5px;top:16px}quick-setup .steps-indicator li:after{content:\"\";width:4px;height:4px;border-top:1px solid #000;border-right:1px solid #000;position:absolute;right:-4px;top:14px;transform:rotate(45deg)}quick-setup .steps-indicator li:nth-child(2):before{right:-30px}quick-setup .steps-indicator li:nth-child(2):after{right:-29px}quick-setup .steps-indicator li:nth-child(3):before{right:-15px}quick-setup .steps-indicator li:nth-child(3):after{right:-14px}quick-setup .steps-indicator li:last-child:before{width:0;border:none}quick-setup .steps-indicator li:last-child:after{width:0;height:0;border:none}@media screen and (max-width:1650px){quick-setup .wizard-container{max-width:1280px}quick-setup .steps-indicator{width:540px;position:relative;font-size:15px;display:flex;justify-content:space-between}quick-setup .steps-indicator li.editing a{color:#ff3150}quick-setup .steps-indicator li:before{width:27px}quick-setup .steps-indicator li:nth-child(2):before{right:-25px}quick-setup .steps-indicator li:nth-child(2):after{right:-26px}quick-setup .steps-indicator li:nth-child(3):before{right:-15px}quick-setup .steps-indicator li:nth-child(3):after{right:-14px}quick-setup .steps-indicator li:last-child:before{width:0;border:none}quick-setup .steps-indicator li:last-child:after{width:0;height:0;border:none}quick-setup .config-title{font-size:15px!important}quick-setup .save-container button{width:118px!important;height:38px!important;font-size:15px!important}quick-setup .save-container span{font-size:15px!important}quick-setup .mode .info{margin:-48px 25px 0!important}quick-setup .mode .info .header{font-size:22px!important}quick-setup .mode .info .info-main{font-size:15px!important}quick-setup .mode .modes{margin:10px 0!important}quick-setup .mode .modes .mode-container .toggle{margin:10px 15px 10px 45px!important}quick-setup .mode .modes .mode-container .toggle md-switch{font-size:21px!important}quick-setup .mode .modes .mode-container .toggle md-switch .md-container{transform:scale(1.3) translateX(-8px)!important}quick-setup .mode .modes .mode-container .options-container .info-text .text{font-size:14px!important;padding:0 35px 20px 10px!important}quick-setup .main-container .start-screen{margin-top:-48px}quick-setup .main-container .start-screen .main-container-ss .info{margin:0 15px 25px 25px}quick-setup .main-container .start-screen .main-container-ss .info .header{font-size:22px;margin:5px 0}quick-setup .main-container .start-screen .main-container-ss .info .info-main{font-size:15px;margin:5px 0}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section{max-width:275px;padding:10px 0 10px 20px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section:first-child{margin-right:18px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section:last-child{margin-left:18px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-switch{font-size:18px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-switch .md-container{transform:scale(1.2) translateX(-8px)!important}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section upload{margin-top:15px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .file-title{font-size:14px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .slider-title{padding:0 0 0 7px;margin-top:5px;font-size:16px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-slider-container{padding:0 40px 0 8px;margin-top:-15px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont{margin:0 40px 0 8px;font-size:16px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont .logo-selector{height:147px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .logo-sel-cont html-preview .preview-main{transform-origin:top left;transform:scale(.89)}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-title{margin:22px 10px 10px;font-size:18px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-radio-group{font-size:15px;margin:10px 0 0 30px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-radio-group .color-picker-label{top:88px;right:21px;width:16px;height:16px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section md-radio-group md-radio-button{margin:0 0 15px 10px;font-size:15px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-bg-info{display:flex;color:#848484;font-size:14px;margin:0 0 0 10px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-bg-info.logo-info{margin-top:15px;margin-bottom:-15px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-bg-info.ss-disabled{opacity:.7}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-bg-info.ss-disabled .icon{color:#848484}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-bg-info .icon{width:40px;color:#ee2737}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-tm-download{display:flex;color:#ee2737;font-size:14px;margin:10px 0 0 10px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-tm-download.ss-disabled{opacity:.7;color:#848484}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .ss-tm-download.ss-disabled .info-text{text-decoration:none;cursor:default}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .image-crop{font-size:14px}quick-setup .main-container .start-screen .main-container-ss .settings-ss .setting-section .image-crop md-switch{transform:scale(.8)}quick-setup .main-container .start-screen .booth-preview{max-width:510px}quick-setup .main-container .start-screen .booth-preview .booth-image{top:70px;width:490px}quick-setup .main-container .start-screen .booth-preview .preview-container{z-index:7;position:absolute;top:332px;left:15px;transform:scale(.757);transform-origin:top left}quick-setup .main-container .design{padding-bottom:20px;margin-top:-48px}quick-setup .main-container .design .info{margin:0 15px 25px 25px}quick-setup .main-container .design .info .header{font-size:22px;margin:5px 0}quick-setup .main-container .design .info .info-main{font-size:15px;margin:5px 0}quick-setup .main-container .design .design-container{display:flex}quick-setup .main-container .design .design-container .design-digital{flex:9;margin-right:21px}quick-setup .main-container .design .design-container .design-digital html-preview .preview-main{transform:scale(.75)}quick-setup .main-container .design .design-container .design-digital .design-d-info{font-size:16px;color:#717171;margin-top:10px;height:90px}quick-setup .main-container .design .design-container .design-digital .design-d-pr-container{height:200px;display:flex;justify-content:center}quick-setup .main-container .design .design-container .design-digital .design-d-pr-container html-preview{margin:-5px -15px}quick-setup .main-container .design .design-container .design-print{flex:11;margin-left:15px}quick-setup .main-container .design .design-container .design-print .design-p-pr-container{display:flex}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .single{flex:4}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .strips{flex:5}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .title-print{font-size:16px;color:#000;margin-top:10px}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .text-print{color:#717171;font-size:16px;margin-top:5px;height:58px}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .print-ph-holder{height:227px;margin-right:10px;display:flex;justify-content:center}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .print-ph-holder html-preview{margin:-20px -15px}quick-setup .main-container .design .design-container .design-print .design-p-pr-container .print-ph-holder html-preview .preview-main{transform:scale(.75)}quick-setup .main-container .design .design-container .design-print .design-p-pr-container button{margin-top:0}quick-setup .main-container .design .design-container .design-digital,quick-setup .main-container .design .design-container .design-print{padding:0 30px 30px}quick-setup .main-container .design .design-container .design-digital md-switch,quick-setup .main-container .design .design-container .design-print md-switch{font-size:17px;margin:16px 0 10px}quick-setup .main-container .design .design-container .design-digital md-switch .md-container,quick-setup .main-container .design .design-container .design-print md-switch .md-container{transform:translateX(25px)}quick-setup .main-container .design .design-container .design-digital .divider,quick-setup .main-container .design .design-container .design-print .divider{border-top:1px solid hsla(0,0%,44%,.33)}quick-setup .main-container .design .design-container .design-digital button,quick-setup .main-container .design .design-container .design-print button{margin:20px auto 0;display:block;font-size:16px;padding:4px 25px}quick-setup .main-container .design .design-container .design-digital button i,quick-setup .main-container .design .design-container .design-print button i{position:relative;top:4px}quick-setup .main-container .sharing .info{margin:-48px 15px 0 25px}quick-setup .main-container .sharing .info .header{color:#000;font-size:22px;margin:10px 0}quick-setup .main-container .sharing .info .info-main{color:#848484;font-size:15px;margin:10px 0}quick-setup .main-container .sharing .sharing-container{display:flex}quick-setup .main-container .sharing .sharing-container .email-sharing,quick-setup .main-container .sharing .sharing-container .sms-sharing{flex:1;display:flex}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont{width:358px;position:relative;transform:scale(.8);transform-origin:top left}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont.phone-disabled,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont.phone-disabled{color:#9e9e9e;opacity:.5}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont md-switch,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont md-switch{font-size:20px;margin-left:25px}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont md-switch .md-container,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont md-switch .md-container{transform:scale(1) translateX(25px)}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont .switch-desc,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont .switch-desc{margin-left:25px;font-size:15px;color:#717171;margin-top:-10px;white-space:nowrap}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont phone-msg,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont phone-msg{position:absolute;top:255px;left:33px}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont email-preview,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont email-preview{position:absolute;top:164px;left:31px}quick-setup .main-container .sharing .sharing-container .email-sharing .phone-cont .phone-img,quick-setup .main-container .sharing .sharing-container .sms-sharing .phone-cont .phone-img{margin-top:20px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont{height:500px;flex-grow:2;display:flex;flex-direction:column;margin:0 40px 0 0}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block{box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9;width:80%;padding:20px 10px 0;background-color:#fff;font-size:14px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block md-input-container,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block md-input-container{width:100%}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.sms,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.sms{margin-top:187px;position:relative}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.sms .dot,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.sms .dot{position:absolute;width:19px;height:19px;border-radius:50%;background-color:#ee2737;top:27px;left:-150px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.sms:before,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.sms:before{content:\"\";position:absolute;width:139px;border:1px solid #ee2737;border-radius:2px;top:17px;left:-139px;transform:rotate(-15deg);z-index:0}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.sms:after,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.sms:after{content:\"\";position:absolute;width:176px;border:1px solid #ee2737;border-radius:2px;bottom:55px;left:-157px;transform:rotate(40deg);z-index:0}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.lang,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.lang{margin-top:5px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.subject,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.subject{margin-top:15px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.title,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.title{margin-top:15px;position:relative}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.title .dot,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.title .dot{position:absolute;width:19px;height:19px;border-radius:50%;background-color:#ee2737;top:-47px;left:-114px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.title:before,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.title:before{content:\"\";position:absolute;width:102px;border:1px solid #ee2737;border-radius:2px;top:-19px;left:-101px;transform:rotate(20deg);z-index:0}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.title:after,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.title:after{content:\"\";position:absolute;width:162px;border:1px solid #ee2737;border-radius:2px;bottom:64px;left:-130px;transform:rotate(53deg);z-index:0}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.message,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.message{margin-top:15px;position:relative}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.message .dot,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.message .dot{position:absolute;width:19px;height:19px;border-radius:50%;background-color:#ee2737;top:-61px;left:-113px}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.message:before,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.message:before{content:\"\";position:absolute;width:106px;border:1px solid #ee2737;border-radius:2px;top:-25px;left:-102px;transform:rotate(27deg);z-index:0}quick-setup .main-container .sharing .sharing-container .email-sharing .share-input-cont .input-block.message:after,quick-setup .main-container .sharing .sharing-container .sms-sharing .share-input-cont .input-block.message:after{content:\"\";position:absolute;width:202px;border:1px solid #ee2737;border-radius:2px;bottom:87px;left:-151px;transform:rotate(61deg);z-index:0}quick-setup .main-container .reset{font-size:13px;padding:0 0 0 20px}}@media screen and (max-height:720px){quick-setup .main-container{overflow-y:scroll}quick-setup .main-container .start-screen{max-height:790px;padding-bottom:50px;overflow:hidden}quick-setup .main-container .sharing{max-height:600px;overflow:hidden}}", ""]);
	
	// exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/photo.png";

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/gif-preview.gif";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/image_print.png";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/gif_print.png";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/boomerang_print.png";

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _scenes = __webpack_require__(319);
	
	var _scenes2 = _interopRequireDefault(_scenes);
	
	var _scenes3 = __webpack_require__(320);
	
	var _scenes4 = _interopRequireDefault(_scenes3);
	
	__webpack_require__(321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScenesComponent = {
	    template: _scenes2.default,
	    controller: _scenes4.default,
	    controllerAs: "ctrl",
	    bindings: {
	        model: "=",
	        general: "<",
	        liveView: "=",
	        company: "<",
	        single: "<",
	        gif: "<",
	        boomerang: "<",
	        video: "<",
	        hidePhotoBg: "<",
	        callback: "&",
	        unscreenIsActive: "<",
	        isPortraite: "<",
	        isRemoveBgIsActive: "=",
	        disabled: "<",
	        newDesign: "<",
	        activeFeatures: "<",
	        activeModes: "<",
	        promptingEnabled: "<",
	        promptingQuality: "<"
	    }
	};
	
	exports.default = ScenesComponent;

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\" layout-sm=\"column\" layout-padding>\n    <div flex=\"50\">\n        <md-switch\n                class=\"main-switch\"\n                md-invert\n                aria-label=\"Enable scenes\"\n                ng-change=\"ctrl.onSceneToggleChange()\"\n                ng-model=\"ctrl.model.enabled\">\n                <i class=\"material-icons\">\n                    insert_photo\n                </i>\n            <strong>{{'Scenes' | translate}}</strong>\n        </md-switch>\n        <p class=\"scene-description\">\n            With custom scenes users can fully immerse into your brand experience.Scenes are <br>\n            sets of background and overlay images along with a color filter. They can be <br>\n            animated by uploading multiple frames. The user can choose among all created <br>\n            designs. <br>\n            To add your logo or branding, please use the layout design of each capture mode <br>\n            instead.\n        </p>\n        <p class=\"scenes-title\"><strong>Scenes aspect ratio</strong></p>\n        <div class=\"ratio-container\" style=\"height: 45px; margin-top: -4px\">\n            <md-radio-group\n                    ng-model=\"ctrl.model.sceneLayoutAspectRatio\"\n                    aria-label=\"radio group\"\n                    class=\"radio-inline-custom\"\n                    ng-disabled=\"!ctrl.model.enabled\"\n                    ng-change=\"ctrl.onLayoutDialogOpen('{{ctrl.model.sceneLayoutAspectRatio}}')\">\n                <md-radio-button value=\"square\" class=\"md-primary\">{{'Square (1:1)' | translate}}</md-radio-button>\n                <md-radio-button value=\"landscape\" class=\"md-primary\">{{'Landscape (3:2)' | translate}}</md-radio-button>\n                <md-radio-button value=\"portrait\" class=\"md-primary\">{{'Portrait (2:3)' | translate}}</md-radio-button>\n                <md-radio-button value=\"custom\" class=\"md-primary\">{{'Custom' | translate}}</md-radio-button>\n                <div class=\"photos-within-layout\" style=\"display: inline-block\">\n                    <md-input-container class=\"md-block\">\n                        <input\n                                ng-model=\"ctrl.model.customLayoutWidth\"\n                                type=\"number\"\n                                min=\"{{ctrl.Math.round(ctrl.model.customLayoutHeight / 10)}}\"\n                                max=\"{{ ctrl.Math.round(ctrl.model.customLayoutHeight * 10) }}\"\n                                placeholder=\"Width\"\n                                ng-change=\"ctrl.onLayoutDialogOpen()\"\n                                ng-blur=\"ctrl.model.customLayoutWidth = ctrl.model.customLayoutWidth || 1\"\n                                ng-disabled=\"ctrl.model.sceneLayoutAspectRatio !== 'custom' || !ctrl.model.enabled\">\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <input\n                                ng-model=\"ctrl.model.customLayoutHeight\"\n                                type=\"number\"\n                                min=\"{{ctrl.Math.round(ctrl.model.customLayoutWidth / 10)}}\"\n                                max=\"{{ ctrl.Math.round(ctrl.model.customLayoutWidth * 10) }}\"\n                                placeholder=\"Height\"\n                                ng-change=\"ctrl.onLayoutDialogOpen()\"\n                                ng-blur=\"ctrl.model.customLayoutHeight = ctrl.model.customLayoutHeight || 1\"\n                                ng-disabled=\"ctrl.model.sceneLayoutAspectRatio !== 'custom' || !ctrl.model.enabled\">\n                    </md-input-container>\n                </div>\n            </md-radio-group>\n        </div>\n\n        <div class=\"photos-within-layout wider scenes-photo\">\n            <span>{{'Size'}}</span>\n            <md-input-container class=\"md-block\">\n                <input\n                        ng-model=\"ctrl.model.layoutWidth\"\n                        type=\"number\"\n                        max=\"4000\"\n                        min=\"{{ctrl.getLayoutMinSize('width')}}\"\n                        step=\"2\"\n                        ng-disabled=\"!ctrl.model.enabled \"\n                        placeholder=\"Width (px)\"\n                        id=\"gif-layout-width\"\n                        ng-change=\"ctrl.changeSharingLayoutSize('gif', 'width')\">\n            </md-input-container>\n            <md-input-container class=\"md-block\">\n                <input\n                        ng-model=\"ctrl.model.layoutHeight\"\n                        type=\"number\"\n                        max=\"4000\"\n                        min=\"{{ctrl.getLayoutMinSize('height')}}\"\n                        step=\"2\"\n                        ng-disabled=\"!ctrl.model.enabled \"\n                        placeholder=\"Height (px)\"\n                        id=\"gif-layout-height\"\n                        ng-change=\"ctrl.changeSharingLayoutSize('gif', 'height')\">\n            </md-input-container>\n        </div>\n\n        <p class=\"scenes-title\"><strong>Photo aspect ratio & position</strong></p>\n        <div class=\"ratio-container\">\n            <md-radio-group\n                    aria-label=\"radio group\"\n                    ng-model=\"ctrl.model.photoAspectRatio\"\n                    class=\"radio-inline-custom\"\n                    ng-disabled=\"!ctrl.model.enabled\"\n                    ng-change=\"ctrl.changePhotosAspectRatio()\">\n                <md-radio-button value=\"square\" class=\"md-primary\">{{'Square (1:1)' | translate}}</md-radio-button>\n                <md-radio-button value=\"landscape\" class=\"md-primary\">{{'Landscape (3:2)' | translate}}</md-radio-button>\n                <md-radio-button value=\"portrait\" class=\"md-primary\">{{'Portrait (2:3)' | translate}}</md-radio-button>\n                <md-radio-button value=\"custom\" class=\"md-primary\">{{'Custom' | translate}}</md-radio-button>\n                <div class=\"photos-within-layout\" style=\"display: inline-block\">\n                    <md-input-container class=\"md-block\">\n                        <md-tooltip md-direction=\"top\">You can change it on general tab</md-tooltip>\n                        <input\n                                ng-model=\"ctrl.model.customPhotoWidth\"\n                                type=\"number\"\n                                min=\"{{ctrl.Math.round(ctrl.model.customPhotoHeight / 10)}}\"\n                                max=\"{{ ctrl.Math.round(ctrl.model.customPhotoHeight * 10) }}\"\n                                placeholder=\"Width\"\n                                ng-change=\"ctrl.changePhotosAspectRatio()\"\n                                ng-blur=\"ctrl.model.customPhotoWidth = ctrl.model.customPhotoWidth || 1\"\n                                ng-disabled=\"ctrl.model.photoAspectRatio !== 'custom' || !ctrl.model.enabled\">\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <md-tooltip md-direction=\"top\">You can change it on general tab</md-tooltip>\n                        <input\n                                ng-model=\"ctrl.model.customPhotoHeight\"\n                                type=\"number\"\n                                min=\"{{ctrl.Math.round(ctrl.model.customPhotoWidth / 10)}}\"\n                                max=\"{{ ctrl.Math.round(ctrl.model.customPhotoWidth * 10) }}\"\n                                placeholder=\"Height\"\n                                ng-change=\"ctrl.changePhotosAspectRatio()\"\n                                ng-blur=\"ctrl.model.customPhotoHeight = ctrl.model.customPhotoHeight || 1\"\n                                ng-disabled=\"ctrl.model.photoAspectRatio !== 'custom' || !ctrl.model.enabled\">\n                    </md-input-container>\n                </div>\n            </md-radio-group>\n        </div>\n\n        <div class=\"photos-within-layout\">\n            <div class=\"photo-layout\">\n                <photo-input\n                        model=\"ctrl.model.photos[0]\"\n                        is-disabled=\"!ctrl.model.enabled\"\n                        layout-width=\"ctrl.model.layoutWidth\"\n                        layout-height=\"ctrl.model.layoutHeight\"\n                        ratio=\"{{ctrl.model.photoAspectRatio}}\"\n                        custom-ratio=\"{width: ctrl.model.customPhotoWidth, height: ctrl.model.customPhotoHeight}\"\n                ></photo-input>\n            </div>\n        </div>\n\n        <md-switch md-invert\n                   class=\"scenes-random\"\n                   ng-model=\"ctrl.model.scenesNamesShow\">\n            <strong>{{'Display Scenes` names' | translate}}</strong>\n        </md-switch>\n        <div class=\"scene-btn-title\">\n            <md-switch md-invert\n                       class=\"scenes-random\"\n                       ng-model=\"ctrl.model.scenesBtnTitleShow\">\n                <strong>{{'Display Scene button title' | translate}}</strong>\n            </md-switch>\n            <form name=\"setSceneBtnTitle\" ng-if=\"ctrl.model.scenesBtnTitleShow\">\n                <div class=\"scene-btn-title-wrapper\">\n                    <md-input-container class=\"md-block\">\n                        <input\n                                ng-model=\"ctrl.model.sceneBtnTitle\"\n                                name=\"title\"\n                                type=\"text\"\n                                maxlength=\"20\"\n                                minlength=\"1\"\n                                required=\"ctrl.model.scenesBtnTitleShow\"\n                                placeholder=\"Title for scene button in application\"\n                                id=\"scene-btn-title\"\n                                ng-change=\"ctrl.changeSceneBtnTitle()\">\n                    </md-input-container>\n                    <div class=\"form-alert\" ng-messages=\"ctrl.model.scenesBtnTitleShow && setSceneBtnTitle.title.$error\" role=\"alert\">\n                        <div ng-message-exp=\"['required','maxlength', 'minlength']\"\n                             ng-bind=\"'The title should be between 1 and 20 symbols' | translate\">\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n\n        <md-switch md-invert\n                   class=\"scenes-random\"\n                   ng-model=\"ctrl.model.randomizeSceneSelection\"\n                   ng-disabled=\"ctrl.model.scenesList.length <= 1\">\n            <strong>{{'Randomize Scene selection' | translate}}</strong>\n            <span>{{\"Users randomly get one of your scenes and cannot choose.\" | translate}}</span>\n        </md-switch>\n\n        <p style=\"display: none;\">{{ctrl.model.scenesList.length <= 1 ? ctrl.model.randomizeSceneSelection = false : ''}}</p>\n\n        <div class=\"scenes-create-block\">\n            <h3>Create Scenes</h3>\n            <p>Add scenes to your experience. Each scene is a pair of one background and one foreground overlay. You can upload as many scenes as you like — they’ll be shown in the order listed below.</p>\n            <p><strong>Uploaded Scene Assets have to match the Aspect Ratio and Size made in Scene Settings</strong></p>\n            <span>Scenes are shown to users in the exact order you arrange them here. Use the drag handle to reorder.</span>\n\n            <scenes-list\n                    model=\"ctrl.model\"\n                    company=\"ctrl.company\"\n                    single=\"ctrl.single\"\n                    gif=\"ctrl.gif\"\n                    boomerang=\"ctrl.boomerang\"\n                    hide-bg=\"ctrl.hidePhotoBg\"\n                    unscreen-is-active=\"ctrl.unscreenIsActive\"\n                    ai-background=\"true\"\n                    ai-overlay=\"true\"\n                    new-design=\"ctrl.newDesign\"\n                    active-features=\"ctrl.activeFeatures \"\n                    active-modes=\"ctrl.activeModes\"\n                    prompting-enabled=\"ctrl.promptingEnabled\"\n                    prompting-quality=\"ctrl.promptingQuality\"\n            ></scenes-list>\n        </div>\n    </div>\n\n    <div flex=\"50\" class=\"preview-container\">\n        <div style=\"width: 500px\">\n            <p><strong>Scene preview - Digital ({{ctrl.getCanvasTitle()}})</strong></p>\n            <html-preview\n                    single=\"true\"\n\n                    pr-width=\"{{\n                        ctrl.liveView.liveViewMode === 'fullscreen'\n                          ? ctrl.general.width\n                          : ctrl.model.layoutWidth\n                      }}\"\n\n                    pr-height=\"{{\n                        ctrl.liveView.liveViewMode === 'fullscreen'\n                          ? ctrl.general.height\n                          : ctrl.model.layoutHeight\n                      }}\"\n\n                    index=\"{{\n                        ctrl.liveView.liveViewMode !== 'fullscreen'\n                          ? (ctrl.model.layoutWidth > ctrl.model.layoutHeight\n                              ? (ctrl.model.layoutWidth * 2.5 / 1000)\n                              : (ctrl.model.layoutHeight * 2.5 / 1000))\n                          : (ctrl.general.width > ctrl.general.height\n                              ? (ctrl.general.width * 2.5 / 1000)\n                              : (ctrl.general.height * 2.5 / 1000))\n                       }}\"\n                    background=\"{{ctrl.model.enabled ? ctrl.getFiles(ctrl.model.scenesList[0].backgroundFiles) : ''}}\"\n                    overlay=\"{{ctrl.model.enabled ? ctrl.getFiles(ctrl.model.scenesList[0].overlayFiles) : ''}}\"\n                    video-background=\"{{ctrl.model.enabled ? ctrl.getFiles(ctrl.model.scenesList[0].backgroundFiles) : null}}\"\n                    video-overlay=\"{{ctrl.model.enabled ? ctrl.getFiles(ctrl.model.scenesList[0].overlayFiles) : null}}\"\n                    areas=\"{{ctrl.model.photos}}\"\n                    animation-speed=\"{{ctrl.model.scenesList[0].animationTime}}\"\n                    ignore-overflow=\"true\"\n                    hide-title=\"true\"\n                    bg-style=\"'crop'\"\n                    bg-mode=\"'image'\"\n                    hide-photo-bg=\"ctrl.hidePhotoBg\"\n                    live-view-opacity=\"{{ctrl.isRemoveBgIsActive ? ctrl.model.opacity : undefined}}\">\n            </html-preview>\n            <div class=\"opacity-slider-block\" ng-if=\"ctrl.isRemoveBgIsActive\">\n                <p>Opacity of Scene Overlay in Live View</p>\n                <p class=\"opacity-note\">Note: This setting applies to the Single Photo and GIF capture modes.<br>\n                    It does not apply to the Boomerang capture mode.</p>\n                <md-slider-container>\n                    <md-slider\n                            min=\"30\"\n                            max=\"100\"\n                            step=\"10\"\n                            md-discrete\n                            ng-model=\"ctrl.model.opacity\"\n                            aria-label=\"slider\">\n                    </md-slider>\n                </md-slider-container>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Configuration", "$companies"];
	
	var ScenesController = function (_$controller) {
	    ScenesController.$inject = ["$injector", "$scope", "$photoTransform", "$ToViewValue"];
	    (0, _inherits3.default)(ScenesController, _$controller);
	
	    function ScenesController($injector, $scope, $photoTransform, $ToViewValue) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, ScenesController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ScenesController.__proto__ || (0, _getPrototypeOf2.default)(ScenesController)).call(this, $injector, dependencies));
	
	        _this.$scope = $scope;
	        _this.Math = Math;
	        _this.photoTransform = $photoTransform;
	        _this.toViewValue = $ToViewValue;
	        return _this;
	    }
	
	    (0, _createClass3.default)(ScenesController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this2 = this;
	
	            this.$scope.$watch(function () {
	                return _this2.model.photos[0].width;
	            }, function () {
	                _this2.setEachScene();
	            });
	            this.$scope.$watch(function () {
	                return _this2.model.photos[0].height;
	            }, function () {
	                _this2.setEachScene();
	            });
	            this.$scope.$watch(function () {
	                return _this2.model.photos[0].x;
	            }, function () {
	                _this2.setEachScene();
	            });
	            this.$scope.$watch(function () {
	                return _this2.model.photos[0].y;
	            }, function () {
	                _this2.setEachScene();
	            });
	            this.$scope.$watch(function () {
	                return _this2.model.photos[0].angle;
	            }, function () {
	                _this2.setEachScene();
	            });
	            this.$scope.$watch(function () {
	                return _this2.liveView;
	            }, function () {
	                _this2.setEachScene();
	            });
	            this.$scope.$watch(function () {
	                return _this2.model;
	            }, function () {
	                if (!_this2.model.hasOwnProperty("scenesNamesShow")) {
	                    (0, _assign2.default)(_this2.model, { scenesNamesShow: false });
	                }
	            });
	            this.$scope.$watch(function () {
	                if (!_this2.model.opacity) {
	                    _this2.model.opacity = 50;
	                }
	            });
	        }
	    }, {
	        key: "$onChanges",
	        value: function $onChanges(changes) {
	            if (changes.previousValue !== changes.currentValue) this.setEachScene();
	        }
	    }, {
	        key: "onLayoutDialogOpen",
	        value: function onLayoutDialogOpen(oldValue) {
	            var _this3 = this;
	
	            if (oldValue) {
	                var confirm = this.$mdDialog.confirm().title("Change aspect ratio & crop scenes?").textContent("Your already created scenes will be cropped to fit the new scene aspect ratio.").ariaLabel("Scene delete").ok("CONTINUE").cancel("CANCEL");
	                this.$mdDialog.show(confirm).then(function () {
	                    _this3.setLayout();
	                }).catch(function () {
	                    _this3.model.sceneLayoutAspectRatio = oldValue;
	                    _this3.setLayout();
	                });
	            } else {
	                this.setLayout();
	            }
	        }
	    }, {
	        key: "setLayout",
	        value: function setLayout() {
	            var round2 = function round2(x) {
	                return Math.ceil(x / 2) * 2;
	            };
	            var widthIndex = void 0,
	                heightIndex = void 0;
	            this.model.layoutHeight = 500;
	            this.model.layoutWidth = 500;
	            this.model.photos[0].changed = Math.random();
	            switch (this.model.sceneLayoutAspectRatio) {
	                case "square":
	                    this.model.customLayoutWidth = null;
	                    this.model.customLayoutHeight = null;
	                    break;
	                case "landscape":
	                    this.model.layoutHeight = 334;
	                    this.model.layoutWidth = 500;
	                    this.model.customLayoutWidth = null;
	                    this.model.customLayoutHeight = null;
	                    break;
	                case "portrait":
	                    this.model.layoutHeight = 500;
	                    this.model.layoutWidth = 334;
	                    this.model.customLayoutWidth = null;
	                    this.model.customLayoutHeight = null;
	                    break;
	                case "custom":
	                    if (!this.model.customLayoutHeight || !this.model.customLayoutWidth || this.model.customLayoutWidth < 0 || this.model.customLayoutHeight < 0) {
	                        this.model.customLayoutWidth = 1;
	                        this.model.customLayoutHeight = 1;
	                    }
	                    if (this.model.customLayoutHeight / this.model.customLayoutWidth >= 0.1 && this.model.customLayoutHeight / this.model.customLayoutWidth <= 10) {
	                        widthIndex = this.model.customLayoutWidth;
	                        heightIndex = this.model.customLayoutHeight;
	                    }
	            }
	
	            if (widthIndex && heightIndex) {
	                if (widthIndex > heightIndex) {
	                    this.model.layoutHeight = round2(heightIndex * this.model.layoutWidth / widthIndex);
	                } else {
	                    this.model.layoutWidth = round2(widthIndex * this.model.layoutHeight / heightIndex);
	                }
	            }
	            this.setEachScene();
	        }
	    }, {
	        key: "changeSharingLayoutSize",
	        value: function changeSharingLayoutSize(setting, value) {
	            var _this4 = this;
	
	            var widthIndex = void 0,
	                heightIndex = void 0;
	            var round2 = function round2(num) {
	                return _this4.Math.ceil(num / 2) * 2;
	            };
	
	            widthIndex = 1;
	            heightIndex = 1;
	            switch (this.model.sceneLayoutAspectRatio) {
	                case "square":
	                    break;
	                case "landscape":
	                    widthIndex = 3;
	                    heightIndex = 2;
	                    break;
	                case "portrait":
	                    widthIndex = 2;
	                    heightIndex = 3;
	                    break;
	                case "custom":
	                    if (widthIndex && heightIndex) {
	                        widthIndex = this.model.customLayoutWidth;
	                        heightIndex = this.model.customLayoutHeight;
	                    }
	                    break;
	            }
	            if (value === "height") {
	                this.model.layoutWidth = Math.round(this.model.layoutHeight * widthIndex / heightIndex);
	                this.model.layoutWidth = round2(this.model.layoutWidth);
	            } else {
	                this.model.layoutHeight = Math.round(this.model.layoutWidth * heightIndex / widthIndex);
	                this.model.layoutHeight = round2(this.model.layoutHeight);
	            }
	            this.setEachScene();
	        }
	    }, {
	        key: "changePhotosAspectRatio",
	        value: function changePhotosAspectRatio() {
	            var _this5 = this;
	
	            var widthIndex = void 0,
	                heightIndex = void 0;
	            (0, _lodash.forEach)(this.model.photos, function (ph) {
	                ph.storedWidth = ph.width;
	                ph.storedHeight = ph.height;
	                ph.width = getSquare(ph.width, ph.height);
	                ph.height = getSquare(ph.width, ph.height);
	            });
	
	            switch (this.model.photoAspectRatio) {
	                case "square":
	                    widthIndex = 1;
	                    heightIndex = 1;
	                    this.model.customPhotoHeight = null;
	                    this.model.customPhotoWidth = null;
	                    break;
	                case "landscape":
	                    widthIndex = 3;
	                    heightIndex = 2;
	                    this.model.customPhotoHeight = null;
	                    this.model.customPhotoWidth = null;
	                    break;
	                case "portrait":
	                    widthIndex = 2;
	                    heightIndex = 3;
	                    this.model.customPhotoHeight = null;
	                    this.model.customPhotoWidth = null;
	                    break;
	                case "custom":
	                    if (!this.model.customPhotoHeight || !this.model.customPhotoWidth || this.model.customPhotoWidth < 0 || this.model.customPhotoHeight < 0) {
	                        this.model.customPhotoWidth = 1;
	                        this.model.customPhotoHeight = 1;
	                    }
	                    if (this.model.customPhotoHeight / this.model.customPhotoWidth >= 0.1 && this.model.customPhotoHeight / this.model.customPhotoWidth <= 10) {
	                        widthIndex = this.model.customPhotoWidth;
	                        heightIndex = this.model.customPhotoHeight;
	                    }
	                    break;
	            }
	
	            if (widthIndex && heightIndex) {
	                if (widthIndex >= heightIndex) {
	                    (0, _lodash.forEach)(this.model.photos, function (ph) {
	                        ph.height = Math.round(heightIndex * ph.width / widthIndex);
	                        _this5.photoTransform.centrePhoto(ph);
	                    });
	                } else {
	                    (0, _lodash.forEach)(this.model.photos, function (ph) {
	                        ph.width = Math.round(widthIndex * ph.height / heightIndex);
	                        _this5.photoTransform.centrePhoto(ph);
	                    });
	                }
	            }
	
	            this.setEachScene();
	
	            function getSquare(a, b) {
	                return Math.max(a, b);
	            }
	        }
	    }, {
	        key: "getLayoutMinSize",
	        value: function getLayoutMinSize(config) {
	            var _this6 = this;
	
	            var getValidSize = function getValidSize(ratio) {
	                var graterSide = _this6.model.customLayoutWidth > _this6.model.customLayoutHeight ? _this6.model.customLayoutWidth : _this6.model.customLayoutHeight;
	                var smallerSide = _this6.model.customLayoutWidth < _this6.model.customLayoutHeight ? _this6.model.customLayoutWidth : _this6.model.customLayoutHeight;
	                switch (ratio) {
	                    case "square":
	                        return 500;
	                    case "portrait":
	                        return 334;
	                    case "landscape":
	                        return 334;
	                    case "custom":
	                        return Math.ceil(smallerSide * 500 / graterSide / 2) * 2;
	                    default:
	                        return 500;
	                }
	            };
	
	            if (this.model.sceneLayoutAspectRatio === "square" || this.model.sceneLayoutAspectRatio === "portrait" || this.model.sceneLayoutAspectRatio === "custom" && this.model.customLayoutWidth < this.model.customLayoutHeight) {
	                if (config === "height") {
	                    return 500;
	                } else {
	                    return getValidSize(this.model.sceneLayoutAspectRatio);
	                }
	            } else {
	                if (config === "height") {
	                    return getValidSize(this.model.sceneLayoutAspectRatio);
	                } else {
	                    return 500;
	                }
	            }
	        }
	    }, {
	        key: "getFiles",
	        value: function getFiles(arr) {
	            if (!arr || !arr.length) return [];
	            var newArr = [];
	            (0, _lodash.forEach)(arr, function (file) {
	                if (file.attachment_file_alpha) {
	                    newArr.push(file.attachment_file_alpha);
	                } else {
	                    newArr.push(file.attachment_file);
	                }
	            });
	            return newArr;
	        }
	    }, {
	        key: "getCanvasTitle",
	        value: function getCanvasTitle() {
	            // The preview is the screen size here: its own ratio, e.g. 9:16 for 1080×1920
	            if (this.liveView && this.liveView.liveViewMode === "fullscreen") {
	                var ratio = this.toViewValue.detectAspectRatioObject(Number(this.general.width), Number(this.general.height));
	                return ratio.w + ":" + ratio.h;
	            }
	
	            switch (this.model.sceneLayoutAspectRatio) {
	                case "landscape":
	                    return "3:2";
	                case "portrait":
	                    return "2:3";
	                case "square":
	                    return "1:1";
	                case "custom":
	                    return this.model.customLayoutWidth + ":" + this.model.customLayoutHeight;
	            }
	        }
	    }, {
	        key: "setEachScene",
	        value: function setEachScene() {
	            var _this7 = this;
	
	            this.model.photos[0].image = true;
	            this.model.photos[0].gif = false;
	            this.model.photos[0].video = false;
	            (0, _lodash.forEach)(this.model.scenesList, function (s) {
	                s.sceneLayoutAspectRatio = _this7.model.sceneLayoutAspectRatio;
	                s.customLayoutHeight = _this7.model.customLayoutHeight;
	                s.customLayoutWidth = _this7.model.customLayoutWidth;
	                s.layoutHeight = _this7.model.layoutHeight;
	                s.layoutWidth = _this7.model.layoutWidth;
	                s.photoAspectRatio = _this7.model.photoAspectRatio;
	                s.customPhotoHeight = _this7.model.customPhotoHeight;
	                s.customPhotoWidth = _this7.model.customPhotoWidth;
	                s.photos = _this7.model.photos;
	                s.scenesList = {
	                    photo: true,
	                    gif: true,
	                    boomerang: true,
	                    video: true
	                };
	                if (!s.captureModes) {
	                    s.captureModes = [{
	                        mode: "photo",
	                        enabled: true
	                    }, {
	                        mode: "gif",
	                        enabled: true
	                    }, {
	                        mode: "boomerang",
	                        enabled: true
	                    }, {
	                        mode: "video",
	                        enabled: true
	                    }];
	                }
	            });
	        }
	    }, {
	        key: "onSceneToggleChange",
	        value: function onSceneToggleChange() {
	            this.callback();
	        }
	    }, {
	        key: "changeSceneBtnTitle",
	        value: function changeSceneBtnTitle() {
	            console.log(this.model.scenesBtnTitleShow, "|| =>", this.model.sceneBtnTitle);
	        }
	    }]);
	    return ScenesController;
	}(_index.$controller);
	
	exports.default = ScenesController;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(322);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./scenes.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./scenes.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "scenes .main-switch{font-size:16px;width:70px;margin-top:-40px}scenes .main-switch .md-label{min-width:100px!important}scenes .main-switch i{position:relative;top:4px}scenes .scene-description{font-size:13px;display:inline-block;max-width:590px}scenes .ratio-container{font-size:12px;margin:-15px 0 -12px;min-width:590px}scenes .photos-within-layout{position:relative;z-index:10;font-size:12px}scenes .photos-within-layout md-input-container .md-input:disabled{color:rgba(0,0,0,.38)}scenes .photos-within-layout md-input-container .md-input{color:rgba(0,0,0,.87)}scenes .scenes-photo{margin:14px 0 -22px}scenes .scenes-random{display:flex;margin:0 0 5px;z-index:30;font-size:13px;width:fit-content;min-width:620px}scenes .opacity-slider-block{max-width:270px;margin:0 auto;padding-top:50px}scenes .opacity-slider-block p{margin:0;margin-bottom:5px;text-align:justify!important}scenes .opacity-slider-block p.opacity-note{font-size:10px}scenes .scene-btn-title .form-alert{color:red}", ""]);
	
	// exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _scenesList = __webpack_require__(324);
	
	var _scenesList2 = _interopRequireDefault(_scenesList);
	
	var _scenesList3 = __webpack_require__(330);
	
	var _scenesList4 = _interopRequireDefault(_scenesList3);
	
	__webpack_require__(334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScenesListComponent = {
	    template: _scenesList2.default,
	    controller: _scenesList4.default,
	    controllerAs: "ctrl",
	    bindings: {
	        model: "=",
	        company: "<",
	        single: "<",
	        gif: "<",
	        boomerang: "<",
	        video: "<",
	        hideBg: "<",
	        aiFeature: "<",
	        unscreenIsActive: "<",
	        aiBackground: "<",
	        aiOverlay: "<",
	        newDesign: "<",
	        activeFeatures: "<",
	        activeModes: "<",
	        promptingEnabled: "<",
	        promptingQuality: "<"
	    }
	};
	
	exports.default = ScenesListComponent;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<p class=\"scenes-title\" ng-if=\"!ctrl.aiOverlay && !ctrl.aiFeature || !ctrl.aiBackground && !ctrl.aiFeature\"><strong>Available scenes</strong> The topmost scene will be the default scene.</p>\n<div class=\"main-scenes\" ng-class=\"{bordered: ctrl.model.scenesList.length > 1}\">\n    <div class=\"scroll-container\" id=\"scenes-list\" >\n        <div class=\"scroll-items\" dnd-list=\"ctrl.model.scenesList\">\n            <div class=\"scene\"\n                 ng-repeat=\"scene in ctrl.model.scenesList\"\n                 dnd-draggable=\"scene\"\n                 dnd-effect-allowed=\"move\"\n                 dnd-moved=\"ctrl.model.scenesList.splice($index, 1)\"\n            ng-if=\"!ctrl.newDesign\">\n<!--                <div class=\"default-layer\" ng-if=\"$index === 0 && scene.enabled\">-->\n<!--                    <i class=\"material-icons\">-->\n<!--                        <md-tooltip>Default scene</md-tooltip>-->\n<!--                        stars-->\n<!--                    </i>-->\n<!--                </div>-->\n                <div class=\"toggle\" dnd-nodrag>\n                    <md-switch\n                            ng-model=\"scene.enabled\"\n                            ng-change=\"ctrl.sortByEnabled()\"\n                            aria-label=\"Is scene enabled\">\n                    </md-switch>\n                </div>\n                <div class=\"preview\" dnd-nodrag>\n                    <div class=\"image-holder\">\n                        <html-preview\n                                hide-photo-bg=\"ctrl.hideBg\"\n                                single=\"true\"\n                                pr-width=\"{{scene.layoutWidth}}\"\n                                pr-height=\"{{scene.layoutHeight}}\"\n                                index=\"{{scene.layoutWidth > scene.layoutHeight ? (scene.layoutWidth * 18.5 / 1000) : (scene.layoutHeight * 18.5 / 1000)}}\"\n                                background=\"{{ctrl.getFile(scene.backgroundFiles)}}\"\n                                overlay=\"{{ctrl.getFile(scene.overlayFiles)}}\"\n                                video-background=\"{{scene.enable_animated_bg_files ? ctrl.getFile(scene.backgroundFiles) : null}}\"\n                                video-overlay=\"{{scene.enable_animated_overlay_files ? ctrl.getFile(scene.overlayFiles) : null}}\"\n                                animation-speed=\"{{scene.animationTime}}\"\n                                style=\"margin: 0 auto\"\n                                ignore-overflow=\"true\"\n                                hide-title=\"true\"\n                                bg-style=\"'crop'\"\n                                bg-mode=\"image\">\n                        </html-preview>\n                    </div>\n                </div>\n<!--                <p>{{scene.overlayFiles[0].attachment_file_alpha}}</p>-->\n                <div class=\"name\" dnd-nodrag>\n                    <div class=\"name-container\">\n                        <div class=\"title\"><span class=\"title-text\">{{scene.title}}</span>\n                            <md-tooltip>{{scene.title}}</md-tooltip>\n                            <i class=\"material-icons\" ng-click=\"ctrl.changeName($event, scene)\">\n                                create\n                            </i>\n                        </div>\n                        <div class=\"icons-list\">\n                            <i class=\"material-icons\" ng-if=\"scene.overlayFiles.length\">\n                                <md-tooltip>Overlay</md-tooltip>\n                                flip_to_front\n                            </i>\n                            <i class=\"material-icons\" ng-if=\"scene.backgroundFiles.length\">\n                                <md-tooltip>Background</md-tooltip>\n                                flip_to_back\n                            </i>\n                            <i class=\"material-icons\" ng-if=\"scene.overlayFiles.length > 1 || scene.backgroundFiles.length > 1\">\n                                <md-tooltip>Animation</md-tooltip>\n                                theaters\n                            </i>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"icons\" dnd-nodrag>\n                    <i class=\"material-icons\" ng-click=\"ctrl.addNewSceneDialog(scene, $index)\">\n                        <md-tooltip>Edit scene</md-tooltip>\n                        create\n                    </i>\n                    <i class=\"material-icons copy-icon\" ng-click=\"ctrl.copyScene(scene, $index)\">\n                        <md-tooltip>Copy scene</md-tooltip>\n                        filter_none\n                    </i>\n                    <i class=\"material-icons\" ng-click=\"ctrl.deleteScene($index)\">\n                        <md-tooltip>Delete scene</md-tooltip>\n                        delete\n                    </i>\n                    <i class=\"material-icons drag-icon\" dnd-handle>\n                        drag_handle\n                    </i>\n                </div>\n            </div>\n            <div class=\"new-scene-version\"\n                 ng-repeat=\"scene in ctrl.model.scenesList\"\n                 dnd-draggable=\"scene\"\n                 dnd-effect-allowed=\"move\"\n                 dnd-moved=\"ctrl.model.scenesList.splice($index, 1)\"\n                 ng-if=\"ctrl.newDesign\">\n                <div class=\"row scene-item-header\" dnd-nodrag>\n                    <div class=\"preview\" ng-if=\"scene.selectedFeature.value !== 'wandershare_api'\" dnd-nodrag>\n                        <div class=\"image-holder\">\n                            <html-preview\n                                    hide-photo-bg=\"ctrl.hideBg\"\n                                    single=\"true\"\n                                    pr-width=\"{{scene.layoutWidth}}\"\n                                    pr-height=\"{{scene.layoutHeight}}\"\n                                    index=\"{{scene.layoutWidth > scene.layoutHeight ? (scene.layoutWidth * 16.5 / 1000) : (scene.layoutHeight * 16.5 / 1000)}}\"\n                                    background=\"{{ctrl.getFile(scene.backgroundFiles)}}\"\n                                    overlay=\"{{ctrl.getFile(scene.overlayFiles)}}\"\n                                    video-background=\"{{scene.enable_animated_bg_files ? ctrl.getFile(scene.backgroundFiles) : null}}\"\n                                    video-overlay=\"{{scene.enable_animated_overlay_files ? ctrl.getFile(scene.overlayFiles) : null}}\"\n                                    animation-speed=\"{{scene.animationTime}}\"\n                                    style=\"margin: 0 auto\"\n                                    ignore-overflow=\"true\"\n                                    hide-title=\"true\"\n                                    bg-style=\"'crop'\"\n                                    bg-mode=\"image\">\n                            </html-preview>\n                        </div>\n                    </div>\n                    <div class=\"preview faceSwap-preview\" ng-if=\"scene.selectedFeature.value === 'wandershare_api'\" dnd-nodrag>\n                        <img src=\"" + __webpack_require__(325) + "\" alt=\"fase-swap-icon\">\n                    </div>\n                    <div class=\"main-scene-info\" dnd-nodrag>\n                        <div class=\"name\" dnd-nodrag>\n                            <div class=\"name-container\">\n                                <div class=\"title\">\n                                    <span class=\"title-text\">{{scene.title}}</span>\n                                    <div class=\"toggle\" dnd-nodrag>\n                                        <md-switch\n                                                ng-model=\"scene.enabled\"\n                                                ng-change=\"ctrl.sortByEnabled()\"\n                                                aria-label=\"Is scene enabled\">\n                                        </md-switch>\n                                    </div>\n                                </div>\n                                <div class=\"icons-list\" ng-style=\"{'opacity': scene.selectedFeature.value !== 'wandershare_api' ? 1 : 0}\">\n                                    <div class=\"icon-wrapper\" ng-if=\"scene.overlayFiles.length\">\n                                        <i class=\"material-icons\" >\n                                            flip_to_front\n                                        </i>\n                                        Overlay\n                                    </div>\n                                    <div class=\"icon-wrapper\" ng-if=\"scene.backgroundFiles.length\">\n                                        <i class=\"material-icons\" >\n                                            flip_to_back\n                                        </i>\n                                        Background\n                                    </div>\n                                    <div class=\"icon-wrapper\" ng-if=\"scene.overlayFiles.length > 1 || scene.backgroundFiles.length > 1\">\n                                        <i class=\"material-icons\" >\n                                            theaters\n                                        </i>\n                                        Animation\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"scenes-edit-block\" dnd-nodrag>\n                        <span class=\"link-text\" ng-click=\"ctrl.addNewSceneDialog(scene, $index)\">Edit</span>\n                        <span class=\"link-text--opacity\" ng-click=\"ctrl.deleteScene($index)\">Delete</span>\n                        <img src=\"" + __webpack_require__(326) + "\" ng-click=\"ctrl.copyScene(scene, $index)\">\n                        <img src=\"" + __webpack_require__(327) + "\" ng-click=\"ctrl.copyScene(scene, $index)\" dnd-handle>\n                    </div>\n                </div>\n                <div class=\"row advance-settings\" dnd-nodrag ng-class=\"{'expanded': ctrl.expandedStates[$index]}\">\n                    <h5>Select which capture modes this scene should be available for:</h5>\n                    <p>Use this to control where each scene is shown. A scene can be shown in one or multiple capture modes — like Photo, GIF, or Video.</p>\n                    <div class=\"capture-modes-column\">\n<!--                        <p>Each scene must be assigned to at least one capture mode (Photo, GIF, Boomerang, Video)</p>-->\n                        <md-checkbox ng-model=\"scene.captureModes[0].enabled\"\n                                   ng-disabled=\"!scene.enabled\"\n                                   ng-if=\"ctrl.activeModes.photo\"\n                                   ng-change=\"ctrl.onCaptureModeChange(scene, $index)\">\n                            Single Photo\n                        </md-checkbox>\n                        <md-checkbox ng-model=\"scene.captureModes[1].enabled\"\n                                   ng-disabled=\"!scene.enabled\"\n                                   ng-if=\"ctrl.activeModes.gif\"\n                                   ng-change=\"ctrl.onCaptureModeChange(scene, $index)\">\n                            GIF\n                        </md-checkbox>\n                        <md-checkbox ng-model=\"scene.captureModes[2].enabled\"\n                                   ng-disabled=\"!scene.enabled\"\n                                   ng-if=\"ctrl.activeModes.boomerang\"\n                                   ng-change=\"ctrl.onCaptureModeChange(scene, $index)\">\n                            Boomerang\n                        </md-checkbox>\n                        <md-checkbox ng-model=\"scene.captureModes[3].enabled\"\n                                   ng-disabled=\"!scene.enabled\"\n                                   ng-if=\"ctrl.activeModes.video\"\n                                   ng-change=\"ctrl.onCaptureModeChange(scene, $index)\">\n                            Video\n                        </md-checkbox>\n                        <div class=\"error-message\" ng-if=\"ctrl.captureModeErrors[$index]\">\n                            Please select at least one capture mode for this scene.\n                        </div>\n                    </div>\n                    <div class=\"ai-features-column\">\n                        <h5>Choose which AI & AR tools apply when this scene is active.</h5>\n                        <p>Select one AI or AR tool to apply to this scene. Only tools that have been activated in Tab 02 – AI & AR Features will appear here.\n                            Each scene supports exactly one AI tool, depending on the selected capture modes above.\n                            Some tools are limited to specific modes — we’ll show you a warning if there’s a conflict</p>\n                        <div class=\"ai-features-info\" ng-if=\"!scene.captureModes[3].enabled\">\n                            {{'Most AI features cannot be applied to Video mode. They work with Photo, GIF, and Boomerang modes.' | translate}}\n                        </div>\n                        <div class=\"ai-features-info\" ng-if=\"scene.captureModes[3].enabled\">\n                            {{'When Video capture mode is selected, only Video Chromakey can be assigned. Enable it in the Video settings tab first.' | translate}}\n                        </div>\n                        <div class=\"ai-features-dropdown\">\n                            <div class=\"dropdown-selected\" ng-click=\"ctrl.toggleDropdown($index)\">\n                                <span class=\"selected-features\"\n                                      title=\"{{ scene.selectedFeature ? scene.selectedFeature.name : 'Select Feature' }}\">\n                                    {{ scene.selectedFeature ? scene.selectedFeature.name : 'Select Feature' }}\n                                </span>\n                                <span class=\"clear-feature\" ng-if=\"scene.selectedFeature\" ng-click=\"$event.stopPropagation(); ctrl.clearFeature(scene)\">\n                                    <i class=\"material-icons\">close</i>\n                                </span>\n                                <span class=\"dropdown-arrow\" ng-class=\"{open: ctrl.dropdownOpen[$index]}\">&#9660;</span>\n                            </div>\n                            <div class=\"dropdown-list\" ng-show=\"ctrl.dropdownOpen[$index]\">\n                                <div class=\"ai-feature-group\" ng-repeat=\"group in ctrl.aiFeatureGroups\">\n                                    <div class=\"ai-feature-group-title\" ng-if=\"group.group\">{{ group.group }}</div>\n                                    <div class=\"ai-feature-item\"\n                                         ng-repeat=\"feature in group.features\"\n                                         ng-click=\"!ctrl.isFeatureDisabled(feature, scene) && ctrl.selectFeature(scene, feature)\"\n                                         ng-class=\"{disabled: ctrl.isFeatureDisabled(feature, scene), selected: ctrl.isFeatureSelected(scene, feature)}\">\n                                        {{ feature.name }}\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"ai-feature-error\" ng-if=\"ctrl.aiFeatureErrors[$index]\">\n                                {{ ctrl.aiFeatureErrors[$index] }}\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <p class=\"red-text\" ng-click=\"ctrl.toggleAdvancedSettings($index)\">\n                    {{ !ctrl.expandedStates[$index] ? 'Show' : 'Hide' }} Advanced Settings\n                    <img src=\"" + __webpack_require__(328) + "\" ng-if=\"!ctrl.expandedStates[$index]\">\n                    <img src=\"" + __webpack_require__(329) + "\" ng-if=\"ctrl.expandedStates[$index]\">\n                </p>\n            </div>\n        </div>\n    </div>\n    <div class=\"top-scroll\" ng-mouseover=\"ctrl.scrollTop()\" ng-mouseleave=\"ctrl.stopScroll()\" ng-if=\"ctrl.topScroll()\">\n        <i class=\"material-icons\">\n            keyboard_arrow_up\n        </i>\n    </div>\n    <div class=\"bottom-scroll\" ng-mouseover=\"ctrl.scrollBottom()\" ng-mouseleave=\"ctrl.stopScroll()\" ng-if=\"ctrl.bottomScroll()\">\n        <i class=\"material-icons\">\n            keyboard_arrow_down\n        </i>\n    </div>\n</div>\n<md-button class=\"md-primary md-raised\" ng-click=\"ctrl.addSceneDirect()\" ng-disabled=\"ctrl.aiFeature ? ctrl.model.scenesList.length >= 40 : ctrl.model.scenesList.length >= 20\">\n    <span ng-if=\"!ctrl.aiFeature\">Create new scene</span>\n    <span ng-if=\"ctrl.aiOverlay && ctrl.aiFeature\">Create new overlay</span>\n    <span ng-if=\"ctrl.aiBackground && ctrl.aiFeature\">Create new Target Image</span>\n</md-button>\n";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fase-swap-icon.svg";

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/copy-scene-icon.svg";

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/drag-scene-icon.svg";

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/display-settings.svg";

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/hide-settings.svg";

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	var _changeName = __webpack_require__(308);
	
	var _changeName2 = __webpack_require__(309);
	
	var _changeName3 = _interopRequireDefault(_changeName2);
	
	var _addScene = __webpack_require__(331);
	
	var _addScene2 = __webpack_require__(332);
	
	var _addScene3 = _interopRequireDefault(_addScene2);
	
	var _addScenePrompting = __webpack_require__(333);
	
	var _addScenePrompting2 = _interopRequireDefault(_addScenePrompting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Configuration", "$companies"];
	
	var REPLICATE_PROMPTING_FEATURE = "replicate_prompting";
	var VIDEO_CHROMAKEY_FEATURE = "video_chromakey";
	
	var ScenesListController = function (_$controller) {
	    ScenesListController.$inject = ["$injector", "$scope"];
	    (0, _inherits3.default)(ScenesListController, _$controller);
	
	    function ScenesListController($injector, $scope) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, ScenesListController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ScenesListController.__proto__ || (0, _getPrototypeOf2.default)(ScenesListController)).call(this, $injector, dependencies));
	
	        _this.$scope = $scope;
	        _this.activeScroll = null;
	        _this.expandedStates = {};
	        _this.captureModeErrors = {};
	        _this.aiFeatureErrors = {};
	
	        /**
	         * Gets the text to display for selected features in the dropdown
	         * @param {Object} scene - The scene object
	         * @returns {string} The text to display
	         */
	        _this.getSelectedFeaturesText = function (scene) {
	            if (!scene.selectedFeature) {
	                return "Select Feature";
	            }
	            return scene.selectedFeature.name;
	        };
	
	        /**
	         * AI feature groups configuration
	         * Defines the structure and available options for AI features
	         */
	        _this.aiFeatureGroups = [{
	            group: "Background AI",
	            features: [{ name: "Remove Background (online)", value: "remove_bg_online" }, { name: "Remove Background (offline)", value: "remove_bg_offline" }, { name: "Remove Background (video)", value: "remove_bg_video" }]
	        }, {
	            group: "Prompting AI",
	            features: [{ name: "Remove Background (promting)", value: REPLICATE_PROMPTING_FEATURE }]
	        }, {
	            group: "Face AI",
	            features: [{ name: "Aging Filter", value: "wandershare_api" }, { name: "FaceSwap", value: "faceswap" }, { name: "Multi FaceSwap", value: "multi_faceswap" }, { name: "AI Avatar", value: "ai_avatar" }]
	        }, {
	            group: "General",
	            features: [{ name: "2D to 3D", value: "2d_to_3d" }]
	        }, {
	            group: "Video",
	            features: [{ name: "Video Chromakey", value: VIDEO_CHROMAKEY_FEATURE }]
	        }];
	        _this.dropdownOpen = {};
	
	        /**
	         * Toggles the dropdown state for a specific scene
	         * @param {number} sceneIndex - Index of the scene
	         */
	        _this.toggleDropdown = function (sceneIndex) {
	            this.dropdownOpen[sceneIndex] = !this.dropdownOpen[sceneIndex];
	        };
	
	        /**
	         * Validates capture modes for a scene
	         * Ensures at least one capture mode is enabled
	         * @param {Object} scene - The scene object
	         * @param {number} index - Index of the scene
	         * @returns {boolean} Whether validation passed
	         */
	        _this.validateCaptureModes = function (scene, index) {
	            var hasEnabledMode = scene.captureModes.some(function (mode) {
	                return mode.enabled;
	            });
	            this.captureModeErrors[index] = !hasEnabledMode;
	            return hasEnabledMode;
	        };
	
	        /**
	         * Validates AI feature compatibility with capture modes
	         * Implements specific rules for different feature types
	         * @param {Object} scene - The scene object
	         * @param {number} index - Index of the scene
	         * @returns {boolean} Whether validation passed
	         */
	        _this.validateAIFeatureWithCaptureModes = function (scene, index) {
	            if (!scene.selectedFeature) {
	                this.aiFeatureErrors[index] = null;
	                return true;
	            }
	
	            var feature = scene.selectedFeature.value;
	            var isPhotoEnabled = scene.captureModes[0].enabled;
	            var isGifEnabled = scene.captureModes[1].enabled;
	            var isBoomerangEnabled = scene.captureModes[2].enabled;
	            var isVideoEnabled = scene.captureModes[3].enabled;
	
	            // Rule 1: FaceSwap features and Aging Filter only work with Photo mode
	            if (feature === "faceswap" || feature === "multi_faceswap" || feature === "wandershare_api") {
	                if (!isPhotoEnabled) {
	                    this.aiFeatureErrors[index] = "FaceSwap features and Aging Filter can only be used with Photo mode.";
	                    return false;
	                }
	                if (isGifEnabled || isBoomerangEnabled || isVideoEnabled) {
	                    this.aiFeatureErrors[index] = "FaceSwap features and Aging Filter can only be used with Photo mode. Please disable other capture modes.";
	                    return false;
	                }
	            }
	
	            // Rule 2: Remove BG (online/offline) cannot work with Boomerang or Video
	            if ((feature === "remove_bg_online" || feature === "remove_bg_offline") && (isBoomerangEnabled || isVideoEnabled)) {
	                this.aiFeatureErrors[index] = "Remove Background (online/offline) cannot be used with Boomerang or Video modes.";
	                return false;
	            }
	
	            // Rule 3: Prompting remove background works with Photo mode only
	            if (feature === REPLICATE_PROMPTING_FEATURE) {
	                if (!isPhotoEnabled) {
	                    this.aiFeatureErrors[index] = "Remove Background (promting) can only be used with Photo mode.";
	                    return false;
	                }
	                if (isGifEnabled || isBoomerangEnabled || isVideoEnabled) {
	                    this.aiFeatureErrors[index] = "Remove Background (promting) can only be used with Photo mode. Please disable other capture modes.";
	                    return false;
	                }
	            }
	
	            // Rule 4: Remove BG Video only works with Boomerang or Video
	            if (feature === "remove_bg_video") {
	                if (!(isBoomerangEnabled || isVideoEnabled)) {
	                    this.aiFeatureErrors[index] = "Remove Background (video) can only be used with Boomerang or Video modes.";
	                    return false;
	                }
	                if (isPhotoEnabled || isGifEnabled) {
	                    this.aiFeatureErrors[index] = "Remove Background (video) can only be used with Boomerang or Video modes. Please disable other capture modes.";
	                    return false;
	                }
	            }
	
	            // Rule 5: Video Chromakey only works with Video capture mode
	            if (feature === VIDEO_CHROMAKEY_FEATURE) {
	                if (!isVideoEnabled) {
	                    this.aiFeatureErrors[index] = "Video Chromakey can only be used with Video capture mode.";
	                    return false;
	                }
	                if (isPhotoEnabled || isGifEnabled || isBoomerangEnabled) {
	                    this.aiFeatureErrors[index] = "Video Chromakey can only be used with Video capture mode. Please disable other capture modes.";
	                    return false;
	                }
	            }
	
	            this.aiFeatureErrors[index] = null;
	            return true;
	        };
	
	        /**
	         * Handles capture mode changes
	         * Validates capture modes and AI feature compatibility
	         * @param {Object} scene - The scene object
	         * @param {number} index - Index of the changed capture mode
	         */
	        _this.onCaptureModeChange = function (scene, index) {
	            if (!this.validateCaptureModes(scene, index)) {
	                this.$mdToast.show(this.$mdToast.simple().textContent("Please select at least one capture mode for this scene.").position("top right").hideDelay(3000));
	            }
	
	            var sceneIndex = this.model.scenesList.indexOf(scene);
	            this.validateAIFeatureWithCaptureModes(scene, sceneIndex);
	            this.normalizeSceneFeatureState(scene, sceneIndex);
	        };
	
	        /**
	         * Handles AI feature selection
	         * @param {Object} scene - The scene object
	         * @param {Object} feature - The selected feature
	         */
	        _this.selectFeature = function (scene, feature) {
	            if (this.isFeatureDisabled(feature, scene)) {
	                return;
	            }
	
	            var sceneIndex = this.model.scenesList.indexOf(scene);
	
	            if (this.isFeatureSelected(scene, feature)) {
	                this.clearPromptingSettings(scene);
	                scene.selectedFeature = null;
	                this.aiFeatureErrors[sceneIndex] = null;
	            } else {
	                var promptingSettings = scene.selectedFeature && scene.selectedFeature.value === REPLICATE_PROMPTING_FEATURE && scene.selectedFeature.promting_settings ? angular.copy(scene.selectedFeature.promting_settings) : undefined;
	
	                scene.selectedFeature = angular.copy(feature);
	                if (feature.value === REPLICATE_PROMPTING_FEATURE && promptingSettings) {
	                    scene.selectedFeature.promting_settings = promptingSettings;
	                } else {
	                    this.clearPromptingSettings(scene);
	                }
	                // Validate and show message if needed, but don't prevent selection
	                this.validateAIFeatureWithCaptureModes(scene, sceneIndex);
	            }
	
	            this.dropdownOpen[sceneIndex] = false;
	        };
	
	        /**
	         * Checks if a feature is selected for a scene
	         * @param {Object} scene - The scene object
	         * @param {Object} feature - The feature to check
	         * @returns {boolean} Whether the feature is selected
	         */
	        _this.isFeatureSelected = function (scene, feature) {
	            if (!scene.selectedFeature) return false;
	            return scene.selectedFeature.value === feature.value;
	        };
	
	        /**
	         * Checks if a feature is disabled
	         * @param {Object} feature - The feature to check
	         * @returns {boolean} Whether the feature is disabled
	         */
	        _this.isFeatureDisabled = function (feature, scene) {
	            if (feature.value === REPLICATE_PROMPTING_FEATURE) {
	                return !this.isPromptingFeatureAvailable(scene);
	            }
	
	            if (feature.value === VIDEO_CHROMAKEY_FEATURE) {
	                if (!scene || !scene.captureModes || !scene.captureModes[3] || !scene.captureModes[3].enabled) {
	                    return true;
	                }
	                if (!this.activeFeatures) {
	                    return true;
	                }
	                return !this.activeFeatures.some(function (item) {
	                    return item.feature === VIDEO_CHROMAKEY_FEATURE && item.active;
	                });
	            }
	
	            if (!this.activeFeatures) return false;
	            return !this.activeFeatures.some(function (item) {
	                return item.feature === feature.value && item.active;
	            });
	        };
	
	        /**
	         * Clears the selected feature for a scene
	         * @param {Object} scene - The scene object
	         */
	        _this.clearFeature = function (scene) {
	            this.clearPromptingSettings(scene);
	            scene.selectedFeature = null;
	            this.aiFeatureErrors[this.model.scenesList.indexOf(scene)] = null;
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(ScenesListController, [{
	        key: "clearPromptingSettings",
	        value: function clearPromptingSettings(scene) {
	            if (!scene || !scene.selectedFeature || !scene.selectedFeature.promting_settings) {
	                return;
	            }
	            delete scene.selectedFeature.promting_settings;
	        }
	    }, {
	        key: "isPromptingFeatureScene",
	        value: function isPromptingFeatureScene(scene) {
	            return !!(scene && scene.selectedFeature && scene.selectedFeature.value === REPLICATE_PROMPTING_FEATURE);
	        }
	    }, {
	        key: "isVideoChromakeyFeatureScene",
	        value: function isVideoChromakeyFeatureScene(scene) {
	            return !!(scene && scene.selectedFeature && scene.selectedFeature.value === VIDEO_CHROMAKEY_FEATURE);
	        }
	    }, {
	        key: "isVideoChromakeyFeatureAvailable",
	        value: function isVideoChromakeyFeatureAvailable(scene) {
	            if (!scene || !scene.captureModes || scene.captureModes.length < 4) {
	                return false;
	            }
	            var isVideoEnabled = !!scene.captureModes[3].enabled;
	            var hasOtherModes = !!(scene.captureModes[0].enabled || scene.captureModes[1].enabled || scene.captureModes[2].enabled);
	            if (!isVideoEnabled || hasOtherModes) {
	                return false;
	            }
	            if (!this.activeFeatures) {
	                return false;
	            }
	            return this.activeFeatures.some(function (item) {
	                return item.feature === VIDEO_CHROMAKEY_FEATURE && item.active;
	            });
	        }
	    }, {
	        key: "isPromptingFeatureAvailable",
	        value: function isPromptingFeatureAvailable(scene) {
	            if (!this.promptingEnabled || !scene || !scene.captureModes || scene.captureModes.length < 4) {
	                return false;
	            }
	
	            var isPhotoEnabled = !!scene.captureModes[0].enabled;
	            var hasOtherModes = !!(scene.captureModes[1].enabled || scene.captureModes[2].enabled || scene.captureModes[3].enabled);
	
	            return isPhotoEnabled && !hasOtherModes;
	        }
	    }, {
	        key: "normalizeSceneFeatureState",
	        value: function normalizeSceneFeatureState(scene, index) {
	            if (!scene || !scene.selectedFeature) {
	                if (index !== undefined) {
	                    this.aiFeatureErrors[index] = null;
	                }
	                return;
	            }
	
	            if (!this.isPromptingFeatureScene(scene)) {
	                this.clearPromptingSettings(scene);
	            }
	
	            if (this.isPromptingFeatureScene(scene) && !this.isPromptingFeatureAvailable(scene)) {
	                this.clearFeature(scene);
	                if (index !== undefined) {
	                    this.aiFeatureErrors[index] = "Remove Background (promting) can only be used with Photo mode. Please disable other capture modes.";
	                }
	                return;
	            }
	
	            if (this.isVideoChromakeyFeatureScene(scene) && !this.isVideoChromakeyFeatureAvailable(scene)) {
	                if (index !== undefined) {
	                    this.aiFeatureErrors[index] = "Video Chromakey can only be used with Video capture mode. Please disable other capture modes.";
	                }
	                return;
	            }
	
	            if (index !== undefined) {
	                this.validateAIFeatureWithCaptureModes(scene, index);
	            }
	        }
	    }, {
	        key: "findFeatureDefinition",
	        value: function findFeatureDefinition(featureValue) {
	            for (var g = 0; g < this.aiFeatureGroups.length; g++) {
	                var features = this.aiFeatureGroups[g].features;
	                for (var f = 0; f < features.length; f++) {
	                    if (features[f].value === featureValue) {
	                        return features[f];
	                    }
	                }
	            }
	            return null;
	        }
	    }, {
	        key: "hydrateSceneSelectedFeature",
	        value: function hydrateSceneSelectedFeature(scene) {
	            if (!scene || !scene.selectedFeature) {
	                return;
	            }
	
	            var featureValue = void 0;
	            if (typeof scene.selectedFeature === "string") {
	                featureValue = scene.selectedFeature;
	            } else if (scene.selectedFeature.value) {
	                featureValue = scene.selectedFeature.value;
	            } else {
	                return;
	            }
	
	            var definition = this.findFeatureDefinition(featureValue);
	            if (!definition) {
	                return;
	            }
	
	            var promptingSettings = scene.selectedFeature.promting_settings;
	            if (!scene.selectedFeature.name || scene.selectedFeature.value !== definition.value) {
	                scene.selectedFeature = angular.copy(definition);
	                if (featureValue === REPLICATE_PROMPTING_FEATURE && promptingSettings) {
	                    scene.selectedFeature.promting_settings = angular.copy(promptingSettings);
	                }
	            }
	        }
	    }, {
	        key: "ensureSceneCaptureModes",
	        value: function ensureSceneCaptureModes(scene) {
	            if (!scene.captureModes || scene.captureModes.length < 4) {
	                scene.captureModes = [{ mode: "photo", enabled: true }, { mode: "gif", enabled: true }, { mode: "boomerang", enabled: true }, { mode: "video", enabled: true }];
	            }
	        }
	    }, {
	        key: "syncSceneCaptureModesFromActiveModes",
	        value: function syncSceneCaptureModesFromActiveModes() {
	            var _this2 = this;
	
	            if (!this.activeModes || !this.model || !this.model.scenesList) {
	                return;
	            }
	            this.model.scenesList.forEach(function (scene) {
	                _this2.ensureSceneCaptureModes(scene);
	                if (!_this2.activeModes.photo) {
	                    scene.captureModes[0].enabled = false;
	                }
	                if (!_this2.activeModes.gif) {
	                    scene.captureModes[1].enabled = false;
	                }
	                if (!_this2.activeModes.boomerang) {
	                    scene.captureModes[2].enabled = false;
	                }
	                if (!_this2.activeModes.video) {
	                    scene.captureModes[3].enabled = false;
	                }
	            });
	        }
	    }, {
	        key: "initializeSceneFeatureState",
	        value: function initializeSceneFeatureState() {
	            var _this3 = this;
	
	            if (!this.model || !this.model.scenesList) {
	                return;
	            }
	            this.syncSceneCaptureModesFromActiveModes();
	            this.model.scenesList.forEach(function (scene, index) {
	                _this3.hydrateSceneSelectedFeature(scene);
	                _this3.normalizeSceneFeatureState(scene, index);
	            });
	        }
	    }, {
	        key: "getSceneLimit",
	        value: function getSceneLimit() {
	            return this.aiFeature ? 40 : 20;
	        }
	    }, {
	        key: "getCaptureModes",
	        value: function getCaptureModes() {
	            return [{
	                mode: "photo",
	                enabled: !!(this.activeModes && this.activeModes.photo)
	            }, {
	                mode: "gif",
	                enabled: !!(this.activeModes && this.activeModes.gif)
	            }, {
	                mode: "boomerang",
	                enabled: !!(this.activeModes && this.activeModes.boomerang)
	            }, {
	                mode: "video",
	                enabled: !!(this.activeModes && this.activeModes.video)
	            }];
	        }
	    }, {
	        key: "buildDefaultScene",
	        value: function buildDefaultScene() {
	            var sceneNumber = this.model.scenesList.length + 1;
	            var title = "New scene " + sceneNumber;
	
	            if (this.aiOverlay) {
	                title = "New overlay " + sceneNumber;
	            }
	            if (this.aiBackground) {
	                title = "NEW TARGET IMAGE " + sceneNumber;
	            }
	
	            return {
	                updateScene: true,
	                finalBackground: null,
	                finalOverlay: null,
	                backgroundFiles: [],
	                overlayFiles: [],
	                animationTime: 1.5,
	                shouldOutputPhotoMirrored: true,
	                enabled: true,
	                title: title,
	                customLayoutHeight: null,
	                customLayoutWidth: null,
	                layoutAspectRatio: "square",
	                layoutHeight: this.model.layoutHeight,
	                layoutWidth: this.model.layoutWidth,
	                customPhotoHeight: null,
	                customPhotoWidth: null,
	                photoAspectRatio: "square",
	                photos: (0, _lodash.cloneDeep)(this.model.photos),
	                timestamp: new Date().getTime(),
	                previewStyle: "photo",
	                captureModes: this.getCaptureModes()
	            };
	        }
	    }, {
	        key: "addSceneDirect",
	        value: function addSceneDirect() {
	            if (this.model.scenesList.length >= this.getSceneLimit()) {
	                return;
	            }
	
	            this.model.scenesList.push(this.buildDefaultScene());
	            this.model.photos[0].image = true;
	            this.model.photos[0].gif = false;
	            this.model.photos[0].video = false;
	        }
	
	        /**
	         * Initializes the controller
	         * Sets up initial state and validates capture modes
	         */
	
	    }, {
	        key: "$onInit",
	        value: function $onInit() {
	            if (!this.model) {
	                this.model = { scenesList: [] };
	            } else {
	                if (!this.model.scenesList) {
	                    this.model.scenesList = [];
	                }
	            }
	            this.initializeSceneFeatureState();
	        }
	    }, {
	        key: "$onChanges",
	        value: function $onChanges(changes) {
	            if (!this.model || !this.model.scenesList) {
	                return;
	            }
	            if (changes.activeFeatures || changes.activeModes || changes.promptingEnabled) {
	                this.initializeSceneFeatureState();
	            }
	        }
	
	        /**
	         * Creates a copy of a scene
	         * @param {Object} scene - The scene to copy
	         * @param {number} index - Index where to insert the copy
	         */
	
	    }, {
	        key: "copyScene",
	        value: function copyScene(scene, index) {
	            if (this.model.scenesList.length < 20) {
	                var newScene = (0, _lodash.cloneDeep)(scene);
	                newScene.title = "Copy of " + scene.title;
	                newScene.timestamp = new Date().getTime();
	                delete newScene.$$hashKey;
	                this.model.scenesList.splice(index + 1, 0, newScene);
	            }
	        }
	
	        /**
	         * Gets the file from an array of files
	         * @param {Array} arr - Array of files
	         * @returns {string} The file path
	         */
	
	    }, {
	        key: "getFile",
	        value: function getFile(arr) {
	            if (!arr || !arr.length) return [];
	            return arr[0].attachment_file_alpha ? arr[0].attachment_file_alpha : arr[0].attachment_file;
	        }
	
	        /**
	         * Deletes a scene after confirmation
	         * @param {number} index - Index of the scene to delete
	         */
	
	    }, {
	        key: "deleteScene",
	        value: function deleteScene(index) {
	            var _this4 = this;
	
	            var confirm = this.$mdDialog.confirm().title("Delete scene?").textContent("This deletes all backgrounds, overlays and filters of this scene and cannot be undone.").ariaLabel("Scene delete").ok("DELETE").cancel("CANCEL");
	            this.$mdDialog.show(confirm).then(function () {
	                _this4.model.scenesList.splice(index, 1);
	                _this4.sortByEnabled();
	            });
	        }
	
	        /**
	         * Opens dialog to change scene name
	         * @param {Event} ev - The click event
	         * @param {Object} data - The scene data
	         */
	
	    }, {
	        key: "changeName",
	        value: function changeName(ev, data) {
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Change scene title",
	                controller: _changeName.ChangeNameController,
	                template: _changeName3.default,
	                targetEvent: ev,
	                locals: {
	                    callback: function callback(title) {
	                        data.title = title;
	                    },
	                    name: data.title,
	                    isUpperCase: true
	                }
	            });
	        }
	
	        /**
	         * Scrolls the list to the top
	         */
	
	    }, {
	        key: "scrollTop",
	        value: function scrollTop() {
	            clearInterval(this.activeScroll);
	            this.scrollList("top");
	        }
	
	        /**
	         * Scrolls the list to the bottom
	         */
	
	    }, {
	        key: "scrollBottom",
	        value: function scrollBottom() {
	            clearInterval(this.activeScroll);
	            this.scrollList("bottom");
	        }
	
	        /**
	         * Handles continuous scrolling
	         * @param {string} direction - Direction to scroll ("top" or "bottom")
	         */
	
	    }, {
	        key: "scrollList",
	        value: function scrollList(direction) {
	            var _this5 = this;
	
	            var el = document.getElementById("scenes-list");
	            clearInterval(this.activeScroll);
	            this.activeScroll = setInterval(function () {
	                el.scrollTop = direction === "top" ? el.scrollTop - 3 : el.scrollTop + 3;
	                if (el.scrollHeight === el.clientHeight + el.scrollTop || el.scrollTop === 0) {
	                    clearInterval(_this5.activeScroll);
	                }
	            }, 20);
	        }
	
	        /**
	         * Stops the scrolling animation
	         */
	
	    }, {
	        key: "stopScroll",
	        value: function stopScroll() {
	            clearInterval(this.activeScroll);
	        }
	
	        /**
	         * Checks if top scroll button should be shown
	         * @returns {boolean} Whether to show top scroll button
	         */
	
	    }, {
	        key: "topScroll",
	        value: function topScroll() {
	            var el = document.getElementById("scenes-list");
	            return el.scrollTop !== 0;
	        }
	
	        /**
	         * Checks if bottom scroll button should be shown
	         * @returns {boolean} Whether to show bottom scroll button
	         */
	
	    }, {
	        key: "bottomScroll",
	        value: function bottomScroll() {
	            var el = document.getElementById("scenes-list");
	            return el.scrollHeight !== el.clientHeight + el.scrollTop;
	        }
	
	        /**
	         * Opens dialog to add or edit a scene
	         * @param {Object} scene - The scene to edit (optional)
	         * @param {number} index - Index of the scene to edit (optional)
	         */
	
	    }, {
	        key: "addNewSceneDialog",
	        value: function addNewSceneDialog(scene, index) {
	            var _this6 = this;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Change scene title",
	                controller: _addScene.AddSceneController,
	                template: this.isPromptingFeatureScene(scene) ? _addScenePrompting2.default : _addScene3.default,
	                escapeToClose: false,
	                locals: {
	                    sceneNumber: this.model.scenesList.length + 1,
	                    company: this.company,
	                    scene: (0, _lodash.cloneDeep)(scene),
	                    isEdit: !!scene,
	                    modes: {
	                        single: this.single,
	                        gif: this.gif,
	                        boomerang: this.boomerang,
	                        video: this.video
	                    },
	                    globalData: {
	                        layoutHeight: this.model.layoutHeight,
	                        layoutWidth: this.model.layoutWidth,
	                        photos: this.model.photos
	                    },
	                    aiFeature: this.aiFeature,
	                    aiBackground: this.aiBackground,
	                    aiOverlay: this.aiOverlay,
	                    isPromptingMode: this.isPromptingFeatureScene(scene),
	                    promptingQuality: this.promptingQuality,
	                    hideBg: this.hideBg,
	                    unscreenIsActive: this.unscreenIsActive,
	                    callback: function callback(s) {
	                        if (scene) {
	                            _this6.model.scenesList[index] = s;
	                        } else {
	                            (0, _assign2.default)(s, { captureModes: _this6.getCaptureModes() });
	                            _this6.model.scenesList.push(s);
	                        }
	                        _this6.model.photos[0].image = true;
	                        _this6.model.photos[0].gif = false;
	                        _this6.model.photos[0].video = false;
	                    }
	                }
	            });
	        }
	
	        /**
	         * Calculates the height of the scenes list
	         * @returns {string} The height in pixels
	         */
	
	    }, {
	        key: "getListHeight",
	        value: function getListHeight() {
	            if (this.model.scenesList.length < 4) {
	                return 40 + 70 * this.model.scenesList.length + "px";
	            } else {
	                return "240px";
	            }
	        }
	
	        /**
	         * Sorts scenes by enabled status
	         * Ensures at least one scene is enabled
	         */
	
	    }, {
	        key: "sortByEnabled",
	        value: function sortByEnabled() {
	            this.model.scenesList = (0, _lodash.orderBy)(this.model.scenesList, "enabled", ["desc"]);
	
	            if (this.model.scenesList.length && this.checkIfAllDisabled(this.model.scenesList)) {
	                this.model.scenesList[0].enabled = true;
	            }
	        }
	
	        /**
	         * Checks if all scenes are disabled
	         * @param {Array} list - List of scenes
	         * @returns {boolean} Whether all scenes are disabled
	         */
	
	    }, {
	        key: "checkIfAllDisabled",
	        value: function checkIfAllDisabled(list) {
	            var disabled = true;
	            (0, _lodash.forEach)(list, function (s) {
	                if (s.enabled) {
	                    disabled = false;
	                }
	            });
	            return disabled;
	        }
	
	        /**
	         * Toggles advanced settings visibility and validates AI features
	         * @param {number} index - Index of the scene
	         */
	
	    }, {
	        key: "toggleAdvancedSettings",
	        value: function toggleAdvancedSettings(index) {
	            this.expandedStates[index] = !this.expandedStates[index];
	
	            // Validate AI features when expanding the settings block
	            if (this.expandedStates[index]) {
	                var scene = this.model.scenesList[index];
	                if (scene.selectedFeature) {
	                    this.validateAIFeatureWithCaptureModes(scene, index);
	                }
	            }
	        }
	
	        /**
	         * Handles feature deactivation
	         * @param {string} featureValue - Value of the deactivated feature
	         */
	
	    }, {
	        key: "handleFeatureDeactivation",
	        value: function handleFeatureDeactivation(featureValue) {
	            var _this7 = this;
	
	            if (!this.activeFeatures || !this.model || !this.model.scenesList) {
	                return;
	            }
	
	            var feature = this.activeFeatures.find(function (item) {
	                return item.feature === featureValue;
	            });
	            if (feature && !feature.active) {
	                this.model.scenesList.forEach(function (scene) {
	                    if (scene.selectedFeature && scene.selectedFeature.value === featureValue) {
	                        _this7.clearPromptingSettings(scene);
	                        scene.selectedFeature = null;
	                    }
	                });
	            }
	        }
	    }]);
	    return ScenesListController;
	}(_index.$controller);
	
	exports.default = ScenesListController;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AddSceneController = undefined;
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _lodash = __webpack_require__(101);
	
	var _fileSizes = __webpack_require__(277);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PROMPTING_SERVICE_OPTIONS = [{ value: "replicate_nano_banana_pro", label: "Nano Banana Pro" }, { value: "replicate_nano_banana_2", label: "Nano Banana 2" }, { value: "replicate_flux_kontext_pro", label: "Flux Kontext Pro" },
	// ur-119 models are not offered yet: remove "hidden" to show a model in the list
	{ value: "replicate_flux_2_pro", label: "Flux 2 Pro", hidden: true }, { value: "replicate_seedream_5_lite", label: "Seedream 5 Lite", hidden: true }, { value: "replicate_grok_imagine_image_quality", label: "Grok Imagine Image Quality", hidden: true }];
	
	var PROMPTING_DEFAULTS = {
	    replicate_nano_banana_pro: {
	        service: "replicate_nano_banana_pro",
	        prompt: "",
	        image_input: [],
	        aspect_ratio: "4:3",
	        resolution: "2K",
	        output_format: "jpg",
	        safety_filter_level: "block_only_high",
	        allow_fallback_model: false
	    },
	    replicate_nano_banana_2: {
	        service: "replicate_nano_banana_2",
	        prompt: "",
	        image_input: [],
	        aspect_ratio: "4:3",
	        resolution: "1K",
	        google_search: false,
	        image_search: false,
	        output_format: "jpg"
	    },
	    replicate_flux_kontext_pro: {
	        service: "replicate_flux_kontext_pro",
	        prompt: "",
	        input_image: "",
	        aspect_ratio: "4:3",
	        prompt_upsampling: false,
	        seed: null,
	        output_format: "png",
	        safety_tolerance: 2
	    },
	    replicate_flux_2_pro: {
	        service: "replicate_flux_2_pro",
	        prompt: "",
	        input_images: [],
	        aspect_ratio: "1:1",
	        resolution: "1 MP",
	        output_format: "jpg",
	        output_quality: 80,
	        safety_tolerance: 2,
	        prompt_upsampling: false
	    },
	    replicate_seedream_5_lite: {
	        service: "replicate_seedream_5_lite",
	        prompt: "",
	        image: [],
	        aspect_ratio: "match_input_image",
	        size: "2K",
	        sequential_image_generation: "disabled",
	        max_images: null,
	        output_format: "png"
	    },
	    replicate_grok_imagine_image_quality: {
	        service: "replicate_grok_imagine_image_quality",
	        prompt: "",
	        image: "",
	        aspect_ratio: "auto",
	        resolution: "2k"
	    }
	};
	
	var PROMPTING_OPTIONS = {
	    aspect_ratio: ["match_input_image", "1:1", "2:3", "3:2", "3:4", "4:3", "4:5", "5:4", "9:16", "16:9", "21:9", "1:4", "4:1", "1:8", "8:1"],
	    resolution: ["512px", "1K", "2K", "4K"],
	    output_format: ["jpg", "png"],
	    safety_filter_level: ["block_low_and_above", "block_medium_and_above", "block_only_high"],
	    replicate_flux_2_pro: {
	        aspect_ratio: ["match_input_image", "1:1", "2:3", "3:2", "3:4", "4:3", "4:5", "5:4", "9:16", "16:9", "21:9"],
	        resolution: ["1 MP", "2 MP", "4 MP"],
	        output_format: ["jpg", "png", "webp"]
	    },
	    replicate_seedream_5_lite: {
	        aspect_ratio: ["match_input_image", "1:1", "2:3", "3:2", "3:4", "4:3", "9:16", "16:9", "21:9"],
	        size: ["2K", "3K"],
	        sequential_image_generation: ["disabled", "auto"],
	        output_format: ["png", "jpeg"]
	    },
	    replicate_grok_imagine_image_quality: {
	        aspect_ratio: ["auto", "1:1", "2:3", "3:2", "3:4", "4:3", "9:16", "16:9"],
	        resolution: ["1k", "2k"]
	    }
	};
	
	function buildPromptingSettings(service, settings) {
	    var selectedService = service || "replicate_nano_banana_pro";
	    var existingSettings = (0, _lodash.cloneDeep)(settings || {});
	
	    if (!PROMPTING_DEFAULTS[selectedService]) {
	        return (0, _assign2.default)({}, existingSettings, { service: selectedService });
	    }
	
	    return (0, _assign2.default)({}, (0, _lodash.cloneDeep)(PROMPTING_DEFAULTS[selectedService]), existingSettings, { service: selectedService });
	}
	
	var AddSceneController = exports.AddSceneController = ["$scope", "$mdDialog", "sceneNumber", "callback", "company", "scene", "isEdit", "globalData", "modes", "hideBg", "$filter", "unscreenIsActive", "aiFeature", "aiBackground", "aiOverlay", "isPromptingMode", "promptingQuality", function AddSceneController($scope, $mdDialog, sceneNumber, callback, company, scene, isEdit, globalData, modes, hideBg, $filter, unscreenIsActive, aiFeature, aiBackground, aiOverlay, isPromptingMode, promptingQuality) {
	    "ngInject";
	
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	    $scope.callback = callback;
	    $scope.company = company;
	    $scope.isEdit = isEdit;
	    $scope.aiFeature = aiFeature;
	    $scope.aiOverlay = aiOverlay;
	    $scope.aiBackground = aiBackground;
	    $scope.isPromptingMode = !!isPromptingMode;
	    $scope.promptingQuality = promptingQuality || "normal";
	    $scope.promptingQualityLabel = {
	        pro: "Pro",
	        normal: "Normal",
	        faster: "Faster"
	    }[$scope.promptingQuality] || "Normal";
	    $scope.showEdit = false;
	    $scope.globalData = globalData;
	    $scope.modes = modes;
	    $scope.unscreenIsActive = unscreenIsActive;
	    $scope.allFiles = [];
	    $scope.defaultTypes = ".jpg,.jpeg,.png";
	    $scope.animatedBgFiles = ".gif,.mp4";
	    $scope.animatedOverlayFiles = ".mp4";
	    $scope.sorting = {
	        backgrounds: null,
	        overlays: null
	    };
	    $scope.fileSizes = _fileSizes.FILE_SIZES;
	    $scope.hideBg = hideBg;
	    $scope.promptingServiceOptions = PROMPTING_SERVICE_OPTIONS.filter(function (option) {
	        return !option.hidden;
	    });
	    $scope.promptingOptions = PROMPTING_OPTIONS;
	    $scope.promptingFormError = "";
	    var oldSceneName = "";
	
	    $scope.ensurePromptingSettings = function (selectedService) {
	        if (!$scope.scene.selectedFeature) {
	            $scope.scene.selectedFeature = {
	                name: "Remove Background (promting)",
	                value: "replicate_prompting"
	            };
	        }
	
	        $scope.scene.selectedFeature.promting_settings = buildPromptingSettings(selectedService || $scope.scene.selectedFeature.promting_settings && $scope.scene.selectedFeature.promting_settings.service, $scope.scene.selectedFeature.promting_settings);
	    };
	
	    $scope.onPromptingServiceChange = function () {
	        var currentService = $scope.scene.selectedFeature.promting_settings.service;
	        $scope.scene.selectedFeature.promting_settings = buildPromptingSettings(currentService);
	        $scope.promptingImageInputText = $scope.getPromptingArrayValue("image_input");
	    };
	
	    $scope.getPromptingArrayValue = function (fieldName) {
	        var values = $scope.scene.selectedFeature.promting_settings[fieldName];
	        return Array.isArray(values) ? values.join("\n") : "";
	    };
	
	    $scope.setPromptingArrayValue = function (fieldName, rawValue) {
	        $scope.scene.selectedFeature.promting_settings[fieldName] = (rawValue || "").split(/\r?\n|,/).map(function (item) {
	            return item.trim();
	        }).filter(Boolean);
	    };
	
	    $scope.onPromptingSingleImageUpload = function (file, fieldName) {
	        var settings = $scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings;
	        if (!settings) {
	            return;
	        }
	
	        var batch = Array.isArray(file) ? file : [file];
	        var firstValidFile = batch.find(function (item) {
	            return item && item.attachment_file;
	        });
	        if (firstValidFile) {
	            settings[fieldName] = firstValidFile.attachment_file;
	        }
	    };
	
	    $scope.clearPromptingSingleImage = function (fieldName) {
	        if ($scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings) {
	            $scope.scene.selectedFeature.promting_settings[fieldName] = "";
	        }
	    };
	
	    $scope.onPromptingInputImageUpload = function (file) {
	        $scope.onPromptingSingleImageUpload(file, "input_image");
	    };
	
	    $scope.clearPromptingInputImage = function () {
	        $scope.clearPromptingSingleImage("input_image");
	    };
	
	    $scope.onPromptingArrayImageUpload = function (file, fieldName) {
	        var settings = $scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings;
	        if (!settings) {
	            return;
	        }
	        if (!Array.isArray(settings[fieldName])) {
	            settings[fieldName] = [];
	        }
	        var batch = Array.isArray(file) ? file : [file];
	        (0, _lodash.forEach)(batch, function (f) {
	            if (f && f.attachment_file && settings[fieldName].indexOf(f.attachment_file) === -1) {
	                settings[fieldName].push(f.attachment_file);
	            }
	        });
	        $scope.promptingImageInputText = $scope.getPromptingArrayValue(fieldName);
	    };
	
	    $scope.removePromptingArrayImageAt = function (fieldName, index) {
	        var settings = $scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings;
	        if (!settings || !Array.isArray(settings[fieldName])) {
	            return;
	        }
	        settings[fieldName].splice(index, 1);
	        $scope.promptingImageInputText = $scope.getPromptingArrayValue(fieldName);
	    };
	
	    $scope.clearPromptingArrayImages = function (fieldName) {
	        var settings = $scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings;
	        if (!settings) {
	            return;
	        }
	        settings[fieldName] = [];
	        $scope.promptingImageInputText = "";
	    };
	
	    $scope.onPromptingImageInputUpload = function (file) {
	        $scope.onPromptingArrayImageUpload(file, "image_input");
	    };
	
	    $scope.removePromptingImageInputAt = function (index) {
	        $scope.removePromptingArrayImageAt("image_input", index);
	    };
	
	    $scope.clearPromptingImageInputAll = function () {
	        $scope.clearPromptingArrayImages("image_input");
	    };
	
	    $scope.isPromptingSettingsValid = function () {
	        if (!$scope.isPromptingMode) {
	            return true;
	        }
	
	        $scope.promptingFormError = "";
	        var settings = $scope.scene.selectedFeature && $scope.scene.selectedFeature.promting_settings;
	        if (!settings || !settings.service) {
	            $scope.promptingFormError = "Select a Replicate service.";
	            return false;
	        }
	
	        if (!settings.prompt || !settings.prompt.trim()) {
	            $scope.promptingFormError = "Prompt is required.";
	            return false;
	        }
	
	        if (settings.service === "replicate_flux_kontext_pro" && settings.safety_tolerance !== null && settings.safety_tolerance !== undefined && (settings.safety_tolerance < 0 || settings.safety_tolerance > 6)) {
	            $scope.promptingFormError = "Safety tolerance must be between 0 and 6.";
	            return false;
	        }
	
	        return true;
	    };
	
	    $scope.create = function () {
	        if (!$scope.isPromptingSettingsValid()) {
	            return;
	        }
	        $scope.callback($scope.scene);
	        $mdDialog.hide();
	    };
	    $scope.changeNameOpen = function () {
	        $scope.showEdit = true;
	        oldSceneName = $scope.scene.title;
	        setTimeout(function () {
	            document.getElementById("scene-name-change").focus();
	            document.addEventListener("keyup", $scope.changeNameUndo);
	            document.addEventListener("keyup", $scope.changeNameConfirm);
	            document.addEventListener("click", $scope.changeNameConfirm);
	        });
	    };
	
	    $scope.changeNameConfirm = function (e) {
	        if (!e) {
	            return;
	        }
	        var el = document.getElementById("scene-name-change");
	        if ((e.key === "Enter" || e.target && e.target.id !== el.id) && el && el.checkValidity()) {
	            $scope.showEdit = false;
	            document.removeEventListener("keyup", $scope.changeNameUndo);
	            document.removeEventListener("keyup", $scope.changeNameConfirm);
	            document.removeEventListener("click", $scope.changeNameConfirm);
	        }
	    };
	
	    $scope.changeNameUndo = function (e) {
	        if (e.key === "Escape") {
	            $scope.scene.title = oldSceneName;
	            $scope.showEdit = false;
	            document.removeEventListener("keyup", $scope.changeNameUndo);
	            document.removeEventListener("keyup", $scope.changeNameConfirm);
	            document.removeEventListener("click", $scope.changeNameConfirm);
	        }
	    };
	
	    $scope.onFilesUpload = function (files, type) {
	        if (type === "overlay") {
	            if ($scope.scene.enable_animated_overlay_files) {
	                $scope.scene.overlayFiles = files;
	            } else {
	                var _$scope$scene$overlay;
	
	                (_$scope$scene$overlay = $scope.scene.overlayFiles).push.apply(_$scope$scene$overlay, (0, _toConsumableArray3.default)(files));
	            }
	        } else {
	            if ($scope.scene.enable_animated_bg_files) {
	                $scope.scene.backgroundFiles = files;
	            } else {
	                var _$scope$scene$backgro;
	
	                (_$scope$scene$backgro = $scope.scene.backgroundFiles).push.apply(_$scope$scene$backgro, (0, _toConsumableArray3.default)(files));
	            }
	        }
	        $scope.checkAllFiles();
	        $scope.getAllFiles();
	    };
	    $scope.refreshStateOfSceneArray = function (value, type) {
	        if (type === "overlay") {
	            $scope.scene.overlayFiles = [];
	        } else {
	            $scope.scene.backgroundFiles = [];
	        }
	    };
	
	    $scope.checkIfSorted = function (arr) {
	        if (!arr || arr.length <= 1) return;
	        var originArr = (0, _lodash.cloneDeep)(arr);
	        var collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
	        var sortedAsc = (0, _lodash.cloneDeep)(arr).sort(function (a, b) {
	            return collator.compare($filter("getFileName")(a.attachment_file), $filter("getFileName")(b.attachment_file));
	        });
	        var sortedDesc = (0, _lodash.cloneDeep)(arr).sort(function (a, b) {
	            return collator.compare($filter("getFileName")(b.attachment_file), $filter("getFileName")(a.attachment_file));
	        });
	        if ((0, _lodash.isEqual)(originArr, sortedAsc)) {
	            return "asc";
	        } else if ((0, _lodash.isEqual)(originArr, sortedDesc)) {
	            return "desc";
	        } else {
	            return "unsorted";
	        }
	    };
	
	    $scope.checkAllFiles = function () {
	        $scope.sorting.backgrounds = $scope.checkIfSorted($scope.scene.backgroundFiles);
	        $scope.sorting.overlays = $scope.checkIfSorted($scope.scene.overlayFiles);
	    };
	    $scope.onDragStart = function () {
	        $scope.checkAllFiles();
	    };
	
	    $scope.sortFiles = function (type) {
	        var collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
	        if (type === "backgrounds") {
	            if ($scope.sorting.backgrounds === "asc") {
	                $scope.scene.backgroundFiles.sort(function (a, b) {
	                    return collator.compare($filter("getFileName")(b.attachment_file), $filter("getFileName")(a.attachment_file));
	                });
	            } else {
	                $scope.scene.backgroundFiles.sort(function (a, b) {
	                    return collator.compare($filter("getFileName")(a.attachment_file), $filter("getFileName")(b.attachment_file));
	                });
	            }
	        } else {
	            if ($scope.sorting.overlays === "asc") {
	                $scope.scene.overlayFiles.sort(function (a, b) {
	                    return collator.compare($filter("getFileName")(b.attachment_file), $filter("getFileName")(a.attachment_file));
	                });
	            } else {
	                $scope.scene.overlayFiles.sort(function (a, b) {
	                    return collator.compare($filter("getFileName")(a.attachment_file), $filter("getFileName")(b.attachment_file));
	                });
	            }
	        }
	        $scope.checkAllFiles();
	    };
	
	    $scope.getFiles = function (arr) {
	        if (!arr || !arr.length) return [];
	        var newArr = [];
	        (0, _lodash.forEach)(arr, function (file) {
	            if (file.attachment_file_alpha) {
	                newArr.push(file.attachment_file_alpha);
	            } else {
	                newArr.push(file.attachment_file);
	            }
	        });
	        return newArr;
	    };
	    /** Same as scenes-list: single URL for html-preview — avoids JSON url() + missing bgId before second dialog mounts */
	    $scope.getFile = function (arr) {
	        if (!arr || !arr.length) {
	            return [];
	        }
	        var file = arr[0];
	        return file.attachment_file_alpha ? file.attachment_file_alpha : file.attachment_file;
	    };
	    $scope.getAllFiles = function () {
	        $scope.allFiles = [].concat((0, _toConsumableArray3.default)($scope.getFiles($scope.scene.overlayFiles)), (0, _toConsumableArray3.default)($scope.getFiles($scope.scene.backgroundFiles)));
	    };
	    $scope.onLayoutChange = function () {
	        if ($scope.aiFeature) {
	            $scope.scene.photos[0].image = true;
	            $scope.scene.photos[0].gif = false;
	            $scope.scene.photos[0].video = false;
	        } else {
	            $scope.scene.photos[0].image = $scope.scene.previewStyle === "photo";
	            $scope.scene.photos[0].gif = $scope.scene.previewStyle === "gif";
	            $scope.scene.photos[0].video = $scope.scene.previewStyle === "boomerang";
	        }
	    };
	    $scope.selectModes = function () {
	        if ($scope.aiFeature) {
	            if ($scope.scene.layoutHeight > $scope.scene.layoutWidth) {
	                $scope.scene.layoutAspectRatio = "portrait";
	                $scope.scene.photoAspectRatio = "portrait";
	            } else {
	                $scope.scene.layoutAspectRatio = "landscape";
	                $scope.scene.photoAspectRatio = "landscape";
	            }
	        }
	        switch ($scope.scene.previewStyle) {
	            case "photo":
	                if ($scope.modes.single) {
	                    $scope.scene.previewStyle = "photo";
	                } else if (!$scope.modes.single) {
	                    $scope.scene.previewStyle = "gif";
	                } else if (!$scope.modes.gif) {
	                    $scope.scene.previewStyle = "boomerang";
	                }
	                break;
	            case "gif":
	                if (!$scope.modes.gif) {
	                    $scope.scene.previewStyle = "photo";
	                } else if (!$scope.modes.single) {
	                    $scope.scene.previewStyle = "boomerang";
	                }
	                break;
	            case "boomerang":
	                if (!$scope.modes.boomerang) {
	                    $scope.scene.previewStyle = "gif";
	                } else if (!$scope.modes.gif) {
	                    $scope.scene.previewStyle = "photo";
	                }
	                break;
	
	        }
	        $scope.onLayoutChange();
	    };
	    $scope.topScroll = function (id) {
	        var el = document.getElementById(id);
	        if (!el) return;
	
	        return el.scrollTop !== 0;
	    };
	    $scope.bottomScroll = function (id) {
	        var el = document.getElementById(id);
	        if (!el) return;
	
	        return el.scrollHeight !== el.clientHeight + el.scrollTop;
	    };
	    setTimeout(function () {
	        $scope.scene = $scope.isEdit ? scene : {
	            updateScene: true,
	            finalBackground: null,
	            finalOverlay: null,
	            backgroundFiles: [],
	            overlayFiles: [],
	            animationTime: 1.5,
	            shouldOutputPhotoMirrored: true,
	            enabled: true,
	            title: "",
	            customLayoutHeight: null,
	            customLayoutWidth: null,
	            layoutAspectRatio: "square",
	            layoutHeight: $scope.globalData.layoutHeight,
	            layoutWidth: $scope.globalData.layoutWidth,
	            customPhotoHeight: null,
	            customPhotoWidth: null,
	            photoAspectRatio: "square",
	            photos: $scope.globalData.photos,
	            timestamp: new Date().getTime(),
	            previewStyle: "photo"
	        };
	        if (!Array.isArray($scope.scene.overlayFiles)) {
	            $scope.scene.overlayFiles = [];
	        }
	        if (!Array.isArray($scope.scene.backgroundFiles)) {
	            $scope.scene.backgroundFiles = [];
	        }
	        if ($scope.isPromptingMode) {
	            $scope.ensurePromptingSettings();
	            $scope.promptingImageInputText = $scope.getPromptingArrayValue("image_input");
	        }
	        $scope.checkAllFiles();
	        $scope.selectModes();
	        $scope.getAllFiles();
	        if (!$scope.isEdit) {
	            $scope.scene.title = "New scene " + sceneNumber;
	            if ($scope.aiOverlay) {
	                $scope.scene.title = "New overlay " + sceneNumber;
	            }
	            if ($scope.aiBackground) {
	                $scope.scene.title = "NEW TARGET IMAGE " + sceneNumber;
	            }
	        }
	    });
	}];

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Create new configuration\"\n           class=\"scene-dialog\"\n           style=\"max-width: 600px\"\n           ng-style=\"{maxWidth: aiFeature ? '400px' : '600px'}\"\n           ng-class=\"{'ai-scene-dialog': aiFeature}\">\n    <md-dialog-content>\n        <div class=\"md-dialog-content\">\n            <h2 ng-if=\"!showEdit\">{{scene.title}}\n                <i class=\"material-icons\" title=\"Edit scene title\" ng-click=\"changeNameOpen()\">\n                    create\n                </i>\n            </h2>\n            <form layout layout-padding ng-if=\"showEdit\" name=\"titleEdit\">\n                <div layout=\"row\" flex=\"70\">\n                    <md-input-container flex>\n                        <label>Scene title</label>\n                        <!-- below is the material icons -->\n                        <input type=\"text\" ng-model=\"scene.title\" required minlength=\"3\" maxlength=\"24\" id=\"scene-name-change\" autocomplete=\"off\">\n                    </md-input-container>\n                    <div>\n                        <md-button\n                                ng-click=\"changeNameConfirm()\"\n                                ng-if=\"titleEdit.$valid\"\n                                class=\"md-primary\">{{'OK' | translate}}</md-button>\n                    </div>\n                </div>\n            </form>\n            <p ng-if=\"!aiFeature\">Upload your custom scene background, foreground overlay and color filter. <br>\n                They will be displayed in the live view already and applied on each photo/video</p>\n            <p ng-if=\"aiFeature\">The uploaded target image will be where the user's face is projected.</p>\n            <div class=\"line\"></div>\n        </div>\n        <div class=\"upload-main\">\n            <div class=\"upload-block\" ng-if=\"aiBackground\">\n                <div class=\"heading\">\n                    <i class=\"material-icons\">\n                        flip_to_back\n                    </i>\n                    <span ng-bind=\"aiFeature && aiBackground ? 'Target Image' : 'Scene background'\"></span>\n                </div>\n                <div class=\"ss-bg-info\">\n                    <div class=\"icon\">\n                        <i class=\"material-icons\">\n                            info\n                        </i>\n                    </div>\n                    <div class=\"info-text\">\n                        Dimension {{scene.layoutWidth}}x{{scene.layoutHeight}} px <br>\n                        Format {{!scene.enable_animated_bg_files ? defaultTypes : animatedBgFiles}}<br>\n                        Size {{fileSizes.scenes}} mb\n                    </div>\n                </div>\n                <md-switch class=\"animated-switch-block\"\n                           ng-if=\"!aiFeature\"\n                        md-invert\n                        ng-model=\"scene.enable_animated_bg_files\"\n                        ng-click=\"refreshStateOfSceneArray(scene.enable_animated_bg_files,'background');getAllFiles()\">\n                    Enable upload background animated files(.mp4,.gif)\n                </md-switch>\n                <upload\n                        uri=\"{{company + 'attachments-many/'}}\"\n                        custom-label=\"{{aiFeature && aiBackground ? 'Upload Target Image' : 'Upload Backgrounds'}}\"\n                        file-types=\"{{!scene.enable_animated_bg_files ? defaultTypes : animatedBgFiles}}\"\n                        multiple=\"!scene.enable_animated_bg_files\"\n                        max-size=\"fileSizes.scenes\"\n                        images-array=\"allFiles\"\n                        hide-error-popup=\"true\"\n                        is-overlay=\"false\"\n                        display-icon=\"true\"\n                        upload-animated-files=\"scene.enable_animated_bg_files\"\n                        callback=\"onFilesUpload(file, 'background')\">\n                </upload>\n                <div class=\"files-options\">\n                    <span>Uploaded backgrounds</span>\n                    <span class=\"option-btn-group\">\n                        <i class=\"material-icons\"\n                           title=\"Sort files\"\n                           ng-class=\"{active: sorting.backgrounds !== 'unsorted'}\"\n                           ng-show=\"scene.backgroundFiles.length > 1\"\n                            ng-click=\"sortFiles('backgrounds')\">\n                            sort_by_alpha\n                        </i>\n                        <i\n                                class=\"material-icons\"\n                                title=\"Delete all files\"\n                                ng-click=\"scene.backgroundFiles=[]; getAllFiles()\"\n                                ng-show=\"scene.backgroundFiles.length\">\n                            delete_forever\n                        </i>\n                    </span>\n                </div>\n                <div class=\"files-list\" dnd-list=\"scene.backgroundFiles\" id=\"background-files-list\">\n                    <div class=\"file\"\n                         ng-repeat=\"file in scene.backgroundFiles\"\n                         dnd-draggable=\"file\"\n                         dnd-effect-allowed=\"move\"\n                         dnd-moved=\"scene.backgroundFiles.splice($index, 1)\"\n                         dnd-dragend=\"checkAllFiles()\">\n                        <i class=\"material-icons drag-icon\">\n                            drag_handle\n                        </i>\n                        <span>{{file.attachment_file | getFileName}}</span>\n                        <i class=\"material-icons drag-icon\" title=\"Delete file\" ng-click=\"scene.backgroundFiles.splice($index, 1); getAllFiles()\">\n                            delete\n                        </i>\n                    </div>\n                </div>\n                <div class=\"top-scroll\" ng-if=\"topScroll('background-files-list')\">\n                    <i class=\"material-icons\">\n                        keyboard_arrow_up\n                    </i>\n                </div>\n                <div class=\"bottom-scroll\" ng-if=\"bottomScroll('background-files-list')\">\n                    <i class=\"material-icons\">\n                        keyboard_arrow_down\n                    </i>\n                </div>\n            </div>\n            <div class=\"upload-block\" ng-if=\"aiOverlay\">\n                <div class=\"heading\">\n                    <i class=\"material-icons\">\n                        flip_to_front\n                    </i>\n                    <span>Scene foreground</span>\n                </div>\n                <div class=\"ss-bg-info\">\n                    <div class=\"icon\">\n                        <i class=\"material-icons\">\n                            info\n                        </i>\n                    </div>\n                    <div class=\"info-text\">\n                        Dimension {{scene.layoutWidth}}x{{scene.layoutHeight}} px <br>\n                        Format {{!scene.enable_animated_overlay_files ? \".png\" : animatedOverlayFiles}} <br>\n                        Size {{fileSizes.scenes}} mb\n                    </div>\n                </div>\n<!--                <md-switch class=\"animated-switch-block\"-->\n<!--                        md-invert-->\n<!--                        ng-model=\"scene.enable_animated_overlay_files\"-->\n<!--                        ng-click=\"refreshStateOfSceneArray(scene.enable_animated_bg_files,'overlay');getAllFiles()\">-->\n<!--                    Enable upload overlay animated files(.mp4)-->\n<!--                </md-switch>-->\n                <upload\n                        uri=\"{{company + 'attachments-many/'}}\"\n                        custom-label=\"{{'Upload Overlays' | translate}}\"\n                        file-types=\"{{!scene.enable_animated_overlay_files ? '.png' : animatedOverlayFiles}}\"\n                        multiple=\"!scene.enable_animated_overlay_files\"\n                        images-array=\"allFiles\"\n                        max-size=\"fileSizes.scenes\"\n                        hide-error-popup=\"true\"\n                        display-icon=\"true\"\n                        callback=\"onFilesUpload(file, 'overlay')\"\n                        is-overlay=\"{{scene.enable_animated_overlay_files}}\"\n                        upload-animated-files=\"scene.enable_animated_overlay_files\"\n                        ng-class=\"{'block-upload': unscreenIsActive && scene.previewStyle === 'boomerang'}\">\n                </upload>\n                <div class=\"files-options\">\n                    <span>Uploaded overlays</span>\n                    <span class=\"option-btn-group\">\n                        <i\n                                class=\"material-icons\"\n                                title=\"Sort files\"\n                                ng-class=\"{active: sorting.overlays !== 'unsorted'}\"\n                                ng-show=\"scene.overlayFiles.length > 1\"\n                                ng-click=\"sortFiles('overlays')\">\n                            sort_by_alpha\n                        </i>\n                        <i\n                                class=\"material-icons\"\n                                title=\"Delete all files\"\n                                ng-click=\"scene.overlayFiles=[]; getAllFiles()\"\n                                ng-show=\"scene.overlayFiles.length\">\n                            delete_forever\n                        </i>\n                    </span>\n                </div>\n                <div class=\"files-list\" dnd-list=\"scene.overlayFiles\" id=\"overlay-files-list\">\n                    <div class=\"file\"\n                         ng-repeat=\"file in scene.overlayFiles\"\n                         dnd-draggable=\"file\"\n                         dnd-effect-allowed=\"move\"\n                         dnd-moved=\"scene.overlayFiles.splice($index, 1)\"\n                         dnd-dragend=\"checkAllFiles()\">\n                        <i class=\"material-icons drag-icon\">\n                            drag_handle\n                        </i>\n                        <span>{{file.attachment_file | getFileName}}</span>\n                        <i class=\"material-icons drag-icon\" title=\"Delete file\" ng-click=\"scene.overlayFiles.splice($index, 1); getAllFiles()\">\n                            delete\n                        </i>\n                    </div>\n                </div>\n                <div class=\"top-scroll\" ng-if=\"topScroll('overlay-files-list')\">\n                    <i class=\"material-icons\">\n                        keyboard_arrow_up\n                    </i>\n                </div>\n                <div class=\"bottom-scroll\" ng-if=\"bottomScroll('overlay-files-list')\">\n                    <i class=\"material-icons\">\n                        keyboard_arrow_down\n                    </i>\n                </div>\n            </div>\n        </div>\n        <div class=\"animation-time\" ng-class=\"{hidden: scene.previewStyle === 'photo' && scene.overlayFiles.length < 2 && scene.backgroundFiles.length < 2}\" ng-if=\"!aiFeature\">\n            <p>{{'Animation time: ' | translate}} <strong class=\"anim-time-counter\">{{ scene.animationTime }}</strong> {{'seconds' | translate}}</p>\n            <md-slider-container>\n                <md-slider\n                        min=\"1\"\n                        max=\"8\"\n                        step=\"0.5\"\n                        md-discrete\n                        ng-model=\"scene.animationTime\"\n                        aria-label=\"slider\">\n                </md-slider>\n            </md-slider-container>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'CANCEL' | translate}}</md-button>\n        <md-button\n                ng-click=\"create()\"\n                ng-disabled=\"!scene.title || scene.title.length < 3 || scene.overlayFiles.length === 0 && scene.backgroundFiles.length === 0\"\n                class=\"md-primary\">{{'SAVE' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>\n<md-dialog aria-label=\"Create new configuration\" class=\"dialog-transparent scene-dialog-transparent\">\n    <div class=\"preview\">\n        <html-preview\n                single=\"true\"\n                pr-width=\"{{scene.layoutWidth}}\"\n                pr-height=\"{{scene.layoutHeight}}\"\n                index=\"{{scene.layoutWidth > scene.layoutHeight ? (scene.layoutWidth * 2.2 / 1000) : (scene.layoutHeight * 2.2 / 1000)}}\"\n                background=\"{{getFile(scene.backgroundFiles)}}\"\n                overlay=\"{{getFile(scene.overlayFiles)}}\"\n                video-background=\"{{scene.enable_animated_bg_files ? getFile(scene.backgroundFiles) : null}}\"\n                video-overlay=\"{{scene.enable_animated_overlay_files ? getFile(scene.overlayFiles) : null}}\"\n                areas=\"{{scene.photos}}\"\n                animation-speed=\"{{scene.animationTime}}\"\n                style=\"margin: 0 auto\"\n                ignore-overflow=\"true\"\n                hide-title=\"true\"\n                bg-style=\"'crop'\"\n                bg-mode=\"'image'\"\n                ai-feature=\"aiFeature && aiBackground\"\n                ai-overlay=\"aiFeature && aiOverlay\"\n                hide-photo-bg=\"hideBg\">\n        </html-preview>\n    </div>\n    <div class=\"switch-holder\">\n        <md-radio-group\n                ng-model=\"scene.previewStyle\"\n                ng-class=\"{'hide-dots': (modes.single && !modes.gif && !modes.boomerang) || (!modes.single && modes.gif && !modes.boomerang) || (!modes.single && !modes.gif && modes.boomerang)}\"\n                ng-change=\"onLayoutChange()\"\n                class=\"radio-inline-custom\">\n            <p>Preview:</p>\n            <md-radio-button value=\"photo\" class=\"md-primary\" ng-hide=\"!modes.single\">{{'Photo' | translate}}</md-radio-button>\n            <md-radio-button value=\"gif\" class=\"md-primary\" ng-hide=\"!modes.gif\">{{'Gif' | translate}}</md-radio-button>\n            <md-radio-button value=\"boomerang\" class=\"md-primary\" ng-hide=\"!modes.boomerang\">{{'Boomerang' | translate}}</md-radio-button>\n        </md-radio-group>\n    </div>\n</md-dialog>\n";

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Prompting scene settings\"\n           class=\"scene-dialog promting-scene\"\n           style=\"max-width: 720px; width: 100%;\">\n    <md-dialog-content>\n        <div class=\"md-dialog-content\">\n            <h2 ng-if=\"!showEdit\">{{scene.title}}\n                <i class=\"material-icons\" title=\"Edit scene title\" ng-click=\"changeNameOpen()\">\n                    create\n                </i>\n            </h2>\n            <form layout layout-padding ng-if=\"showEdit\" name=\"titleEdit\">\n                <div layout=\"row\" flex=\"100\">\n                    <md-input-container flex>\n                        <label>Scene title</label>\n                        <input type=\"text\" ng-model=\"scene.title\" required minlength=\"3\" maxlength=\"24\" id=\"scene-name-change\" autocomplete=\"off\">\n                    </md-input-container>\n                    <div>\n                        <md-button\n                                ng-click=\"changeNameConfirm()\"\n                                ng-if=\"titleEdit.$valid\"\n                                class=\"md-primary\">{{'OK' | translate}}</md-button>\n                    </div>\n                </div>\n            </form>\n            <p>This scene uses Prompting flow with the currently selected Replicate quality preset.</p>\n            <p style=\"display:none\"><strong>Preset:</strong> {{promptingQualityLabel}}</p>\n            <p class=\"margin-bottom-30\">Backgrounds and overlays are managed from the scenes list. Use this dialog to configure `promting_settings` for the selected scene.</p>\n\n            <div ng-if=\"scene.selectedFeature && scene.selectedFeature.promting_settings\">\n                <md-input-container class=\"md-block margin-bottom-30\">\n                    <label>Replicate service</label>\n                    <md-select ng-model=\"scene.selectedFeature.promting_settings.service\"\n                               ng-change=\"onPromptingServiceChange()\">\n                        <md-option ng-repeat=\"service in promptingServiceOptions\" value=\"{{service.value}}\">\n                            {{service.label}}\n                        </md-option>\n                    </md-select>\n                </md-input-container>\n\n                <md-input-container class=\"md-block margin-bottom-30\">\n                    <label>Prompt</label>\n                    <textarea ng-model=\"scene.selectedFeature.promting_settings.prompt\"\n                              rows=\"4\"\n                              required></textarea>\n                </md-input-container>\n\n                <div ng-if=\"scene.selectedFeature.promting_settings.service === 'replicate_nano_banana_pro'\n                            || scene.selectedFeature.promting_settings.service === 'replicate_nano_banana_2'\" class=\"margin-bottom-30\">\n                    <div class=\"md-block margin-bottom-30\">\n                        <label class=\"md-body-1\">Upload image</label>\n                        <upload\n                                uri=\"{{company + 'attachments-many/'}}\"\n                                custom-label=\"{{'Upload reference images' | translate}}\"\n                                file-types=\"{{defaultTypes}}\"\n                                max-size=\"fileSizes.scenes\"\n                                multiple=\"true\"\n                                hide-error-popup=\"true\"\n                                is-overlay=\"false\"\n                                display-icon=\"true\"\n                                callback=\"onPromptingImageInputUpload(file)\">\n                        </upload>\n                        <div class=\"md-caption\" ng-repeat=\"url in scene.selectedFeature.promting_settings.image_input track by $index\"\n                             layout=\"row\" layout-align=\"start center\">\n                            <span flex title=\"{{url}}\">{{ url | getFileName:48 }}</span>\n                            <md-button class=\"md-icon-button\"\n                                       aria-label=\"{{'Remove' | translate}}\"\n                                       ng-click=\"removePromptingImageInputAt($index)\">\n                                <i class=\"material-icons\">close</i>\n                            </md-button>\n                        </div>\n                        <md-button class=\"md-primary md-raised\"\n                                   ng-click=\"clearPromptingImageInputAll()\"\n                                   ng-if=\"scene.selectedFeature.promting_settings.image_input.length\">\n                            {{'Clear all' | translate}}\n                        </md-button>\n                    </div>\n                </div>\n\n                <div ng-if=\"scene.selectedFeature.promting_settings.service === 'replicate_flux_kontext_pro'\" class=\"margin-bottom-30\">\n                    <div class=\"md-block\">\n                        <label class=\"md-body-1\">Upload image</label>\n                        <upload\n                                uri=\"{{company + 'attachments-many/'}}\"\n                                custom-label=\"{{'Upload input image' | translate}}\"\n                                file-types=\"{{defaultTypes}}\"\n                                max-size=\"fileSizes.scenes\"\n                                hide-error-popup=\"true\"\n                                is-overlay=\"false\"\n                                display-icon=\"true\"\n                                callback=\"onPromptingInputImageUpload(file)\">\n                        </upload>\n                        <p class=\"md-caption\" ng-if=\"scene.selectedFeature.promting_settings.input_image\"\n                           title=\"{{scene.selectedFeature.promting_settings.input_image}}\">\n                            {{'Current' | translate}}: {{ scene.selectedFeature.promting_settings.input_image | getFileName:48 }}\n                        </p>\n                        <md-button class=\"md-primary md-raised\"\n                                   ng-click=\"clearPromptingInputImage()\"\n                                   ng-if=\"scene.selectedFeature.promting_settings.input_image\">\n                            {{'Clear' | translate}}\n                        </md-button>\n                    </div>\n                </div>\n\n                <div ng-if=\"scene.selectedFeature.promting_settings.service === 'replicate_nano_banana_pro'\n                            || scene.selectedFeature.promting_settings.service === 'replicate_nano_banana_2'\n                            || scene.selectedFeature.promting_settings.service === 'replicate_flux_kontext_pro'\">\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Aspect ratio</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.aspect_ratio\">\n                            <md-option ng-repeat=\"option in promptingOptions.aspect_ratio\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                </div>\n\n                <div ng-if=\"scene.selectedFeature.promting_settings.service === 'replicate_nano_banana_pro'\n                            || scene.selectedFeature.promting_settings.service === 'replicate_nano_banana_2'\">\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Resolution</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.resolution\">\n                            <md-option ng-repeat=\"option in promptingOptions.resolution\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                </div>\n\n                <div ng-if=\"scene.selectedFeature.promting_settings.service === 'replicate_nano_banana_pro'\n                            || scene.selectedFeature.promting_settings.service === 'replicate_nano_banana_2'\n                            || scene.selectedFeature.promting_settings.service === 'replicate_flux_kontext_pro'\">\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Output format</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.output_format\">\n                            <md-option ng-repeat=\"option in promptingOptions.output_format\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                </div>\n\n                <div ng-if=\"scene.selectedFeature.promting_settings.service === 'replicate_nano_banana_pro'\">\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Safety filter level</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.safety_filter_level\">\n                            <md-option ng-repeat=\"option in promptingOptions.safety_filter_level\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-switch ng-model=\"scene.selectedFeature.promting_settings.allow_fallback_model\">\n                        Allow fallback model\n                    </md-switch>\n                </div>\n\n                <div ng-if=\"scene.selectedFeature.promting_settings.service === 'replicate_nano_banana_2'\">\n                    <md-switch ng-model=\"scene.selectedFeature.promting_settings.google_search\">\n                        Enable Google Web Search grounding\n                    </md-switch>\n                    <md-switch ng-model=\"scene.selectedFeature.promting_settings.image_search\">\n                        Enable Google Image Search grounding\n                    </md-switch>\n                </div>\n\n                <div ng-if=\"scene.selectedFeature.promting_settings.service === 'replicate_flux_kontext_pro'\">\n                    <md-switch ng-model=\"scene.selectedFeature.promting_settings.prompt_upsampling\">\n                        Enable prompt upsampling\n                        <span style=\"font-size: 12px; color: rgba(0, 0, 0, 0.54);\">\n                            (Automatic prompt improvement)\n                        </span>\n                    </md-switch>\n                    <md-input-container class=\"md-block\">\n                        <label>Seed</label>\n                        <input type=\"number\"\n                               step=\"1\"\n                               ng-model=\"scene.selectedFeature.promting_settings.seed\" required>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <label>Safety tolerance (0-6)</label>\n                        <input type=\"number\"\n                               min=\"0\"\n                               max=\"6\"\n                               step=\"1\"\n                               ng-model=\"scene.selectedFeature.promting_settings.safety_tolerance\">\n                    </md-input-container>\n                </div>\n\n                <div ng-if=\"scene.selectedFeature.promting_settings.service === 'replicate_flux_2_pro'\">\n                    <div class=\"md-block margin-bottom-30\">\n                        <label class=\"md-body-1\">Upload images</label>\n                        <upload\n                                uri=\"{{company + 'attachments-many/'}}\"\n                                custom-label=\"{{'Upload input images' | translate}}\"\n                                file-types=\"{{defaultTypes}}\"\n                                max-size=\"fileSizes.scenes\"\n                                multiple=\"true\"\n                                hide-error-popup=\"true\"\n                                is-overlay=\"false\"\n                                display-icon=\"true\"\n                                callback=\"onPromptingArrayImageUpload(file, 'input_images')\">\n                        </upload>\n                        <div class=\"md-caption\" ng-repeat=\"url in scene.selectedFeature.promting_settings.input_images track by $index\"\n                             layout=\"row\" layout-align=\"start center\">\n                            <span flex title=\"{{url}}\">{{ url | getFileName:48 }}</span>\n                            <md-button class=\"md-icon-button\"\n                                       aria-label=\"{{'Remove' | translate}}\"\n                                       ng-click=\"removePromptingArrayImageAt('input_images', $index)\">\n                                <i class=\"material-icons\">close</i>\n                            </md-button>\n                        </div>\n                        <md-button class=\"md-primary md-raised\"\n                                   ng-click=\"clearPromptingArrayImages('input_images')\"\n                                   ng-if=\"scene.selectedFeature.promting_settings.input_images.length\">\n                            {{'Clear all' | translate}}\n                        </md-button>\n                    </div>\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Aspect ratio</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.aspect_ratio\">\n                            <md-option ng-repeat=\"option in promptingOptions.replicate_flux_2_pro.aspect_ratio\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Resolution</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.resolution\">\n                            <md-option ng-repeat=\"option in promptingOptions.replicate_flux_2_pro.resolution\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Output format</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.output_format\">\n                            <md-option ng-repeat=\"option in promptingOptions.replicate_flux_2_pro.output_format\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <label>Output quality</label>\n                        <input type=\"number\"\n                               step=\"1\"\n                               ng-model=\"scene.selectedFeature.promting_settings.output_quality\">\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <label>Safety tolerance</label>\n                        <input type=\"number\"\n                               step=\"1\"\n                               ng-model=\"scene.selectedFeature.promting_settings.safety_tolerance\">\n                    </md-input-container>\n                    <md-switch ng-model=\"scene.selectedFeature.promting_settings.prompt_upsampling\">\n                        Enable prompt upsampling\n                    </md-switch>\n                </div>\n\n                <div ng-if=\"scene.selectedFeature.promting_settings.service === 'replicate_seedream_5_lite'\">\n                    <div class=\"md-block margin-bottom-30\">\n                        <label class=\"md-body-1\">Upload images</label>\n                        <upload\n                                uri=\"{{company + 'attachments-many/'}}\"\n                                custom-label=\"{{'Upload reference images' | translate}}\"\n                                file-types=\"{{defaultTypes}}\"\n                                max-size=\"fileSizes.scenes\"\n                                multiple=\"true\"\n                                hide-error-popup=\"true\"\n                                is-overlay=\"false\"\n                                display-icon=\"true\"\n                                callback=\"onPromptingArrayImageUpload(file, 'image')\">\n                        </upload>\n                        <div class=\"md-caption\" ng-repeat=\"url in scene.selectedFeature.promting_settings.image track by $index\"\n                             layout=\"row\" layout-align=\"start center\">\n                            <span flex title=\"{{url}}\">{{ url | getFileName:48 }}</span>\n                            <md-button class=\"md-icon-button\"\n                                       aria-label=\"{{'Remove' | translate}}\"\n                                       ng-click=\"removePromptingArrayImageAt('image', $index)\">\n                                <i class=\"material-icons\">close</i>\n                            </md-button>\n                        </div>\n                        <md-button class=\"md-primary md-raised\"\n                                   ng-click=\"clearPromptingArrayImages('image')\"\n                                   ng-if=\"scene.selectedFeature.promting_settings.image.length\">\n                            {{'Clear all' | translate}}\n                        </md-button>\n                    </div>\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Aspect ratio</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.aspect_ratio\">\n                            <md-option ng-repeat=\"option in promptingOptions.replicate_seedream_5_lite.aspect_ratio\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Size</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.size\">\n                            <md-option ng-repeat=\"option in promptingOptions.replicate_seedream_5_lite.size\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Sequential image generation</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.sequential_image_generation\">\n                            <md-option ng-repeat=\"option in promptingOptions.replicate_seedream_5_lite.sequential_image_generation\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <label>Maximum images</label>\n                        <input type=\"number\"\n                               step=\"1\"\n                               ng-model=\"scene.selectedFeature.promting_settings.max_images\">\n                    </md-input-container>\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Output format</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.output_format\">\n                            <md-option ng-repeat=\"option in promptingOptions.replicate_seedream_5_lite.output_format\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                </div>\n\n                <div ng-if=\"scene.selectedFeature.promting_settings.service === 'replicate_grok_imagine_image_quality'\">\n                    <div class=\"md-block margin-bottom-30\">\n                        <label class=\"md-body-1\">Upload image</label>\n                        <upload\n                                uri=\"{{company + 'attachments-many/'}}\"\n                                custom-label=\"{{'Upload input image' | translate}}\"\n                                file-types=\"{{defaultTypes}}\"\n                                max-size=\"fileSizes.scenes\"\n                                multiple=\"false\"\n                                hide-error-popup=\"true\"\n                                is-overlay=\"false\"\n                                display-icon=\"true\"\n                                callback=\"onPromptingSingleImageUpload(file, 'image')\">\n                        </upload>\n                        <p class=\"md-caption\" ng-if=\"scene.selectedFeature.promting_settings.image\"\n                           title=\"{{scene.selectedFeature.promting_settings.image}}\">\n                            {{'Current' | translate}}: {{ scene.selectedFeature.promting_settings.image | getFileName:48 }}\n                        </p>\n                        <md-button class=\"md-primary md-raised\"\n                                   ng-click=\"clearPromptingSingleImage('image')\"\n                                   ng-if=\"scene.selectedFeature.promting_settings.image\">\n                            {{'Clear' | translate}}\n                        </md-button>\n                    </div>\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Aspect ratio</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.aspect_ratio\">\n                            <md-option ng-repeat=\"option in promptingOptions.replicate_grok_imagine_image_quality.aspect_ratio\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-input-container class=\"md-block margin-bottom-30\">\n                        <label>Resolution</label>\n                        <md-select ng-model=\"scene.selectedFeature.promting_settings.resolution\">\n                            <md-option ng-repeat=\"option in promptingOptions.replicate_grok_imagine_image_quality.resolution\" value=\"{{option}}\">\n                                {{option}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                </div>\n<hr>\n                <div class=\"upload-block\">\n                    <h3>Scene foreground</h3>\n\n                    <div class=\"ss-bg-info\">\n                        <div class=\"info-text\">\n                            Dimension {{scene.layoutWidth}}x{{scene.layoutHeight}} px <br>\n                            Format {{!scene.enable_animated_overlay_files ? \".png\" : animatedOverlayFiles}} <br>\n                            Size {{fileSizes.scenes}} mb\n                        </div>\n                    </div>\n                    <upload\n                            uri=\"{{company + 'attachments-many/'}}\"\n                            custom-label=\"{{'Upload Overlays' | translate}}\"\n                            file-types=\"{{!scene.enable_animated_overlay_files ? '.png' : animatedOverlayFiles}}\"\n                            multiple=\"false\"\n                            images-array=\"allFiles\"\n                            max-size=\"fileSizes.scenes\"\n                            hide-error-popup=\"true\"\n                            display-icon=\"true\"\n                            callback=\"onFilesUpload(file, 'overlay')\"\n                            disabled=\"scene.overlayFiles.length >= 1\"\n                            is-overlay=\"{{scene.enable_animated_overlay_files}}\"\n                            upload-animated-files=\"scene.enable_animated_overlay_files\"\n                            ng-class=\"{'block-upload': unscreenIsActive && scene.previewStyle === 'boomerang'}\">\n                    </upload>\n                    <div class=\"files-options\">\n                        <span>Uploaded overlays</span>\n                    </div>\n                    <div class=\"files-list\" dnd-list=\"scene.overlayFiles\" id=\"overlay-files-list\">\n                        <div class=\"file\"\n                             ng-repeat=\"file in scene.overlayFiles\"\n                             dnd-draggable=\"file\"\n                             dnd-effect-allowed=\"move\"\n                             dnd-moved=\"scene.overlayFiles.splice($index, 1)\"\n                             dnd-dragend=\"checkAllFiles()\">\n                            <i class=\"material-icons drag-icon\">\n                                drag_handle\n                            </i>\n                            <span>{{file.attachment_file | getFileName}}</span>\n                            <i class=\"material-icons drag-icon\" title=\"Delete file\" ng-click=\"scene.overlayFiles.splice($index, 1); getAllFiles()\">\n                                delete\n                            </i>\n                        </div>\n                    </div>\n                    <div class=\"top-scroll\" ng-if=\"topScroll('overlay-files-list')\">\n                        <i class=\"material-icons\">\n                            keyboard_arrow_up\n                        </i>\n                    </div>\n                    <div class=\"bottom-scroll\" ng-if=\"bottomScroll('overlay-files-list')\">\n                        <i class=\"material-icons\">\n                            keyboard_arrow_down\n                        </i>\n                    </div>\n                </div>\n\n                <div class=\"error-message\" ng-if=\"promptingFormError\">\n                    {{promptingFormError}}\n                </div>\n            </div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'CANCEL' | translate}}</md-button>\n        <md-button\n                ng-click=\"create()\"\n                ng-disabled=\"!scene.title\n                    || scene.title.length < 3\n                    || !scene.selectedFeature\n                    || !scene.selectedFeature.promting_settings\n                    || !scene.selectedFeature.promting_settings.service\n                    || !scene.selectedFeature.promting_settings.prompt\n                    || !scene.selectedFeature.promting_settings.prompt.trim()\n                    || (scene.selectedFeature.promting_settings.service === 'replicate_flux_kontext_pro'\n                        && (scene.selectedFeature.promting_settings.seed === null\n                            || scene.selectedFeature.promting_settings.seed === undefined\n                            || scene.selectedFeature.promting_settings.seed === ''))\n                    || (scene.selectedFeature.promting_settings.service === 'replicate_flux_kontext_pro'\n                        && scene.selectedFeature.promting_settings.safety_tolerance !== null\n                        && scene.selectedFeature.promting_settings.safety_tolerance !== undefined\n                        && (scene.selectedFeature.promting_settings.safety_tolerance < 0\n                            || scene.selectedFeature.promting_settings.safety_tolerance > 6))\"\n                class=\"md-primary\">{{'SAVE' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>\n<md-dialog aria-label=\"Scene preview\" class=\"dialog-transparent scene-dialog-transparent\">\n    <div class=\"preview\">\n        <html-preview\n                single=\"true\"\n                pr-width=\"{{scene.layoutWidth}}\"\n                pr-height=\"{{scene.layoutHeight}}\"\n                index=\"{{scene.layoutWidth > scene.layoutHeight ? (scene.layoutWidth * 2.2 / 1000) : (scene.layoutHeight * 2.2 / 1000)}}\"\n                background=\"{{getFile(scene.backgroundFiles)}}\"\n                overlay=\"{{getFile(scene.overlayFiles)}}\"\n                video-background=\"{{scene.enable_animated_bg_files ? getFile(scene.backgroundFiles) : null}}\"\n                video-overlay=\"{{scene.enable_animated_overlay_files ? getFile(scene.overlayFiles) : null}}\"\n                areas=\"{{scene.photos}}\"\n                animation-speed=\"{{scene.animationTime}}\"\n                style=\"margin: 0 auto\"\n                ignore-overflow=\"true\"\n                hide-title=\"true\"\n                bg-style=\"'crop'\"\n                bg-mode=\"'image'\"\n                ai-feature=\"aiFeature && aiBackground\"\n                ai-overlay=\"aiFeature && aiOverlay\"\n                hide-photo-bg=\"hideBg\">\n        </html-preview>\n    </div>\n    <div class=\"switch-holder\">\n        <md-radio-group\n                ng-model=\"scene.previewStyle\"\n                ng-class=\"{'hide-dots': (modes.single && !modes.gif && !modes.boomerang) || (!modes.single && modes.gif && !modes.boomerang) || (!modes.single && !modes.gif && modes.boomerang)}\"\n                ng-change=\"onLayoutChange()\"\n                class=\"radio-inline-custom\">\n            <p>Preview:</p>\n            <md-radio-button value=\"photo\" class=\"md-primary\" ng-hide=\"!modes.single\">{{'Photo' | translate}}</md-radio-button>\n            <md-radio-button value=\"gif\" class=\"md-primary\" ng-hide=\"!modes.gif\">{{'Gif' | translate}}</md-radio-button>\n            <md-radio-button value=\"boomerang\" class=\"md-primary\" ng-hide=\"!modes.boomerang\">{{'Boomerang' | translate}}</md-radio-button>\n        </md-radio-group>\n    </div>\n</md-dialog>\n";

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(335);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./scenes-list.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./scenes-list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "scenes-list .scenes-title{position:relative;display:block;margin:0 0 5px;z-index:30;font-size:13px}scenes-list .main-scenes{width:calc(100% + 50px);position:relative;left:-50px;z-index:0;padding-top:10px}scenes-list .main-scenes.bordered:before{top:0;z-index:20}scenes-list .main-scenes.bordered:after,scenes-list .main-scenes.bordered:before{content:\"\";position:absolute;border-top:1px solid #d3d3d3;width:75%;max-width:540px;min-width:500px;left:50px}scenes-list .main-scenes.bordered:after{bottom:0}scenes-list .main-scenes .bottom-scroll,scenes-list .main-scenes .top-scroll{position:absolute;height:15px;width:25px;left:calc(50% - 50px);z-index:35;display:flex;align-items:center;justify-content:center}scenes-list .main-scenes .bottom-scroll i,scenes-list .main-scenes .top-scroll i{color:dimgray;font-size:28px}scenes-list .main-scenes .top-scroll{top:-10px;cursor:n-resize}scenes-list .main-scenes .bottom-scroll{bottom:-12px;cursor:s-resize}scenes-list .main-scenes .scroll-container{height:100%;width:100%;z-index:0;overflow:scroll}scenes-list .main-scenes .scroll-container .scroll-items{margin-left:50px}scenes-list .main-scenes .scroll-container{scrollbar-width:none;-ms-overflow-style:none}scenes-list .main-scenes .scroll-container::-webkit-scrollbar{width:0;height:0}scenes-list .scene{height:68px;box-shadow:0 1px 1px rgba(0,0,0,.16);border:1px solid #e9e9e9;width:75%;max-width:540px;min-width:500px;margin:10px 0;display:flex;border-radius:4px;position:relative;background-color:#fafafa}scenes-list .scene .default-layer{position:absolute;z-index:-1;width:calc(100% + 50px);height:calc(100% + 14px);top:-7px;left:-43px;background-color:#f9dbe0;display:flex;align-items:center}scenes-list .scene .default-layer i{margin-left:10px;color:#ed5680}scenes-list .scene:hover{box-shadow:0 2px 4px rgba(0,0,0,.16);background-color:#f0f0f0}scenes-list .scene .toggle{display:flex;align-items:center;justify-content:center;width:68px}scenes-list .scene .toggle md-switch{width:45px!important;transform:scale(.8)}scenes-list .scene .preview{display:flex;width:68px;align-items:center;justify-content:center}scenes-list .scene .preview .image-holder{width:54px;height:54px;display:flex;align-items:center;justify-content:center}scenes-list .scene .name{display:flex;align-items:center;justify-content:center;font-size:13px;padding:0 20px}scenes-list .scene .name .title{min-width:170px;text-transform:uppercase}scenes-list .scene .name .title .title-text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;display:inline-block;max-width:140px}scenes-list .scene .name .title i{color:gray;font-size:15px;cursor:pointer;outline:none;display:inline-block;position:relative;top:-2px}scenes-list .scene .name i{font-size:19px;margin:3px;cursor:default}scenes-list .scene .icons{flex-grow:1;display:flex;justify-content:flex-end;align-items:center;padding-right:10px}scenes-list .scene .icons i{color:dimgray;font-size:19px;margin:0 10px;cursor:pointer;outline:none}scenes-list .scene .icons i.copy-icon{font-size:17px}scenes-list .scene .icons i.drag-icon{font-size:26px}scenes-list .new-scene-version{min-height:158px;height:auto;display:flex;width:513px;padding:20px;flex-direction:column;justify-content:center;align-items:flex-start;border-radius:10px;background:#fff;margin-bottom:20px}scenes-list .new-scene-version .row{width:100%}scenes-list .new-scene-version .scene-item-header{margin-bottom:40px}scenes-list .new-scene-version .preview{min-width:60px;min-height:60px}scenes-list .new-scene-version .main-scene-info{margin-left:25px;flex-grow:1;flex-shrink:1;flex-basis:auto;width:auto}scenes-list .new-scene-version .main-scene-info .title{display:flex;align-items:center;margin-bottom:5px}scenes-list .new-scene-version .main-scene-info .title-text{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:normal}scenes-list .new-scene-version .main-scene-info .toggle{width:45px;margin-left:10px}scenes-list .new-scene-version .main-scene-info .toggle md-switch{margin:0!important}scenes-list .new-scene-version .main-scene-info .icons-list{display:flex;align-items:center}scenes-list .new-scene-version .main-scene-info .icons-list .icon-wrapper{display:flex;align-items:center;color:#666;font-size:14px;font-style:normal;font-weight:400;line-height:normal;margin-right:10px}scenes-list .new-scene-version .main-scene-info .icons-list .icon-wrapper .material-icons{margin-right:10px}scenes-list .new-scene-version .scenes-edit-block{display:grid;grid-template-columns:repeat(2,1fr);grid-template-rows:repeat(2,auto);gap:20px}scenes-list .new-scene-version .scenes-edit-block .link-text{color:#666}scenes-list .new-scene-version .scenes-edit-block .link-text,scenes-list .new-scene-version .scenes-edit-block .link-text--opacity{font-size:10px;font-style:normal;font-weight:400;line-height:normal;text-decoration-line:underline;text-decoration-style:solid;text-decoration-skip-ink:none;text-decoration-thickness:auto;text-underline-offset:auto;text-underline-position:from-font;cursor:pointer;text-align:end}scenes-list .new-scene-version .scenes-edit-block .link-text--opacity{color:#cdcdcd}scenes-list .new-scene-version .scenes-edit-block img{cursor:pointer}scenes-list .new-scene-version .advance-settings{flex-direction:column;max-height:0;overflow:hidden;transition:max-height .3s cubic-bezier(.4,0,.2,1)}scenes-list .new-scene-version .advance-settings.expanded{max-height:max-content}scenes-list .new-scene-version .advance-settings.expanded.md-select-open{max-height:800px}scenes-list .new-scene-version .advance-settings h5{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:20px;margin:5px 0}scenes-list .new-scene-version .advance-settings p{color:#666;font-size:14px;font-style:normal;font-weight:400;line-height:normal;margin:5px 0}scenes-list .new-scene-version .advance-settings .capture-modes-column{margin-top:8px;display:flex;flex-direction:column;gap:8px;margin-bottom:40px}scenes-list .new-scene-version .advance-settings .capture-modes-column md-checkbox{margin:0}scenes-list .new-scene-version .advance-settings .capture-modes-column md-checkbox.md-checked .md-icon{background-color:transparent;border-color:#1f1f1f}scenes-list .new-scene-version .advance-settings .capture-modes-column md-checkbox:not(.md-checked) .md-icon{border-color:#1f1f1f}scenes-list .new-scene-version .advance-settings .capture-modes-column md-checkbox.md-checked .md-icon:after{left:5px;height:12px}scenes-list .new-scene-version .advance-settings .capture-modes-column md-checkbox .md-label{color:#25282a;font-size:14px;font-style:normal;font-weight:400;line-height:normal}scenes-list .new-scene-version .advance-settings .capture-modes-column md-checkbox.md-checked .md-icon:after{border-color:#1f1f1f}scenes-list .new-scene-version .advance-settings .capture-modes-column .error-message{color:#f44336;font-size:12px;margin-top:8px;padding:4px 0}scenes-list .new-scene-version .red-text{cursor:pointer;display:flex;align-items:center;color:#ff1744;font-size:9px;font-style:normal;font-weight:700;line-height:normal;margin:0}scenes-list .new-scene-version .red-text img{margin-left:6px}scenes-list .dndDraggingSource{display:none}scenes-list .dndPlaceholder{height:3px;background-color:#f0f0f0;list-style-type:none;width:75%;max-width:540px;min-width:500px}scenes-list .dndDragging{background-color:#dcdcdc!important}.block-upload{opacity:.5;cursor:default;pointer-events:none}.upload-block .animated-switch-block{display:flex;flex-wrap:wrap;white-space:inherit;font-size:12px;height:auto}.upload-block .animated-switch-block .md-label{width:80%}.upload-block .files-list{height:110px!important}.ai-features-dropdown{position:relative;margin:16px 0}.ai-features-dropdown .ai-feature-error{color:#f44336;font-size:12px;margin-top:8px;padding:4px 0}.ai-features-dropdown .dropdown-selected{border:1px solid #e0e0e0;border-radius:4px;padding:8px 36px 8px 12px;font-size:14px;cursor:pointer;position:relative;color:#222;background:#fff;min-height:24px;transition:border-color .2s}.ai-features-dropdown .dropdown-selected:hover{border-color:#999}.ai-features-dropdown .dropdown-selected .selected-features{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:calc(100% - 60px);cursor:pointer;color:#222}.ai-features-dropdown .dropdown-selected .selected-features:hover{color:#666}.ai-features-dropdown .dropdown-selected .clear-feature{position:absolute;right:30px;top:50%;transform:translateY(-50%);cursor:pointer;color:#666;display:flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%}.ai-features-dropdown .dropdown-selected .clear-feature:hover{background-color:#f0f0f0;color:#333}.ai-features-dropdown .dropdown-selected .clear-feature i{font-size:16px}.ai-features-dropdown .dropdown-selected .dropdown-arrow{position:absolute;right:12px;top:50%;transform:translateY(-50%) rotate(0deg);transition:transform .2s;font-size:14px;pointer-events:none;color:#666}.ai-features-dropdown .dropdown-selected .dropdown-arrow.open{transform:translateY(-50%) rotate(180deg)}.ai-features-dropdown .dropdown-list{position:relative;left:0;right:0;background:#fff;border:1px solid #e0e0e0;z-index:1;max-height:400px;overflow-y:auto;box-shadow:0 2px 8px rgba(0,0,0,.08);margin-top:2px}.ai-features-dropdown .ai-feature-group-title{font-weight:700;margin:8px 0 4px;font-size:15px;padding-left:12px}.ai-features-dropdown .ai-feature-item{padding:8px 12px;font-size:14px;cursor:pointer;border-bottom:1px solid #f0f0f0;background:#fff;display:flex;align-items:center;gap:8px}.ai-features-dropdown .ai-feature-item.disabled{color:#ccc;pointer-events:none;cursor:default}.ai-features-dropdown .ai-feature-item.selected{background:#f5f5f5}.ai-features-dropdown .ai-feature-item:last-child{border-bottom:none}.ai-features-dropdown .ai-feature-item:hover{background:#f5f5f5}.ai-features-dropdown .ai-feature-item md-checkbox{margin:0;min-height:24px}.row.advance-settings.expanded.md-select-open{max-height:800px}.ai-features-column .ai-features-info{color:#856404;font-size:14px;font-style:italic;margin:8px 0;padding:8px;background-color:#fff3cd;border:1px solid #ffeeba;border-radius:4px}", ""]);
	
	// exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _liveView = __webpack_require__(337);
	
	var _liveView2 = _interopRequireDefault(_liveView);
	
	var _liveViewController = __webpack_require__(338);
	
	var _liveViewController2 = _interopRequireDefault(_liveViewController);
	
	__webpack_require__(339);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LiveViewComponent = {
	    template: _liveView2.default,
	    controller: _liveViewController2.default,
	    controllerAs: "ctrl",
	    bindings: {
	        model: "=",
	        config: "<",
	        general: "<",
	        callback: "&",
	        reset: "&",
	        isPortraite: "<",
	        sharingQr: "<",
	        sharingSms: "<",
	        sharingEmail: "<",
	        sharingPrint: "<",
	        showSingle: "<",
	        showGif: "<",
	        showBoomerang: "<",
	        showFilter: "<",
	        showScenes: "<",
	        isSingle: "<"
	    }
	};
	
	exports.default = LiveViewComponent;

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\" layout-sm=\"column\" layout-padding>\n    <div flex=\"50\">\n        <p style=\"text-align: left;margin-top: 0\">\n            <strong class=\"part-title bold\">Live View</strong>\n        </p>\n        <p class=\"part-title__sub-text\" flex=\"60\">{{'The Live View is where users can choose to take\n        a Photo, GIF or Boomerang.' |\n        translate}}</p>\n        <div class=\"custom-scene-screen\">\n            <md-switch\n                    md-invert\n                    class=\"custom-scene-screen__title\"\n                    ng-model=\"ctrl.model.customSceneScreen.enabled\">\n                {{'Custom Scene Screen' | translate}}\n            </md-switch>\n            <p class=\"part-title__sub-text\" flex=\"60\">\n                {{'Configure a custom multi-scene start screen with dedicated touchpoints and one shared background.' | translate}}\n            </p>\n            <div class=\"custom-scene-screen__settings\" ng-if=\"ctrl.model.customSceneScreen && ctrl.model.customSceneScreen.enabled\">\n                <md-input-container class=\"md-block custom-scene-screen__count\">\n                    <label>{{'Number of scenes' | translate}}</label>\n                    <input\n                            ng-model=\"ctrl.model.customSceneScreen.numberOfScenes\"\n                            ng-change=\"ctrl.onCustomSceneNumberChange()\"\n                            type=\"number\"\n                            min=\"1\"\n                            max=\"10\">\n                </md-input-container>\n\n                <div class=\"custom-scene-screen__background\">\n                    <p class=\"part-title__sub-text\">{{'Upload custom scene background' | translate}}</p>\n                    <upload\n                            model=\"ctrl.model.customSceneScreen.background\"\n                            uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                            custom-label=\"{{'Upload' | translate}}\"\n                            file-types=\".jpg,.jpeg,.gif,.png,.mp4,.mov,.webm\"\n                            max-size=\"ctrl.fileSizes.startScreen\"\n                            is-overlay=\"false\"\n                            display-icon=\"false\">\n                    </upload>\n                    <div class=\"file-title\" ng-if=\"ctrl.model.customSceneScreen.background.attachment_file\" title=\"{{ctrl.model.customSceneScreen.background.attachment_file | getFileName}}\">\n                        <span>Uploaded: {{ ctrl.model.customSceneScreen.background.attachment_file | getFileName : 12 }}</span>\n                        <md-button\n                                class=\"md-icon-button md-primary\"\n                                ng-click=\"ctrl.model.customSceneScreen.background.attachment_file = null\">\n                            <md-icon>delete</md-icon>\n                        </md-button>\n                    </div>\n                </div>\n\n                <div class=\"custom-scene-screen__touch-points\">\n                    <h6>{{'Touch Points' | translate}}</h6>\n                    <div class=\"custom-scene-screen__touch-point-item\"\n                         ng-repeat=\"touchPoint in ctrl.getCustomSceneTouchPoints() track by touchPoint.scene_index\">\n                        <div class=\"custom-scene-screen__touch-point-label\">\n                            <strong>Scene {{ (touchPoint.scene_index < 10 ? '0' : '') + touchPoint.scene_index }}</strong>\n                            <span ng-if=\"touchPoint.scene_title\">: {{touchPoint.scene_title}}</span>\n                        </div>\n                        <md-input-container class=\"md-block custom-scene-screen__title-input\">\n                            <label>{{'Scene name' | translate}}</label>\n                            <input\n                                    ng-model=\"ctrl.model.customSceneScreen.touchpoints[$index].scene_title\"\n                                    type=\"text\"\n                                    maxlength=\"60\"\n                                    placeholder=\"{{'Enter scene name' | translate}}\">\n                        </md-input-container>\n                        <div layout=\"row\" class=\"area-editor\">\n                            <start-screen-area\n                                    model=\"ctrl.model.customSceneScreen.touchpoints[$index]\"\n                                    pixel-width=\"ctrl.general.width\"\n                                    pixel-height=\"ctrl.general.height\"\n                                    company=\"ctrl.config.company\"\n                                    hide-upload-icons=\"false\"\n                                    short-upload-title=\"true\"\n                                    custom-buttons-options=\"false\">\n                            </start-screen-area>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n    </div>\n    <div flex=\"50\">\n        <div class=\"previews-container custom-scene-screen__preview\" ng-if=\"ctrl.model.customSceneScreen && ctrl.model.customSceneScreen.enabled\">\n            <h3>{{'Custom Scene Screen Preview' | translate}}</h3>\n            <html-preview\n                    ng-show=\"true\"\n                    pr-width=\"{{ctrl.general.width}}\"\n                    pr-height=\"{{ctrl.general.height}}\"\n                    index=\"{{ctrl.index}}\"\n                    background=\"{{ctrl.model.customSceneScreen.background.attachment_file ? [ctrl.model.customSceneScreen.background.attachment_file] : []}}\"\n                    video-background=\"{{ctrl.getCustomSceneVideoBackground()}}\"\n                    areas=\"{{ctrl.getCustomSceneAreas()}}\"\n                    related-values=\"true\"\n                    screen=\"screen-preview\"\n                    show-title=\"true\"\n                    hide-title=\"true\"\n                    ignore-overflow=\"true\"\n                    bg-mode=\"ctrl.model.customSceneScreen.background.attachment_file ? 'image' : 'color'\"\n                    bg-color=\"'#ffffff'\"\n                    bg-style=\"'stretch'\"\n                    transparency=\"0\"\n                    margin=\"true\"\n                    config-mode=\"true\">\n            </html-preview>\n        </div>\n    </div>\n</div>\n<hr>\n<div layout=\"row\" layout-sm=\"column\" layout-padding>\n    <div flex=\"50\">\n\n        <md-radio-group ng-model=\"ctrl.model.liveViewMode\" ng-change=\"ctrl.callback(); ctrl.setIndexValue()\" class=\"radio-row\">\n            <md-radio-button md-invert value=\"regular\">Square Live View</md-radio-button>\n            <md-radio-button md-invert value=\"fullscreen\">Fullscreen Live View</md-radio-button>\n        </md-radio-group>\n\n        <div class=\"row background-settings\" ng-if=\"ctrl.model.liveViewMode !== 'fullscreen'\">\n            <md-switch\n                    md-invert\n                    class=\"background-settings__title\"\n                    ng-model=\"ctrl.model.enabled\">\n                {{'Background' | translate}}\n            </md-switch>\n            <md-radio-group ng-model=\"ctrl.model.liveViewBackgroundMode\">\n                <md-radio-button value=\"color\">Use background color </md-radio-button>\n                <color-picker class=\"color-picker-label\"\n                              ng-model=\"ctrl.model.liveViewBackgroundColor\"\n                              options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n                <md-radio-button value=\"image\" class=\"upload-option\">Use background image\n                    <upload\n                            model=\"ctrl.model.liveViewBackground\"\n                            callback=\"ctrl.onGlobalLiveViewBackgroundUploaded(file)\"\n                            uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                            custom-label=\"{{'Upload' | translate}}\"\n                            file-types=\".jpg,.jpeg,.gif,.png\"\n                            max-size=\"ctrl.fileSizes.startScreen\"\n                            is-overlay=\"false\"\n                            display-icon=\"false\">\n                    </upload>\n                    <div class=\"file-title\" ng-if=\"ctrl.model.liveViewBackground.attachment_file\" title=\"{{ctrl.model.liveViewBackground.attachment_file | getFileName}}\">\n                        <span>Uploaded: {{ ctrl.model.liveViewBackground.attachment_file | getFileName : 12 }}</span>\n                        <md-button\n                                class=\"md-icon-button md-primary\"\n                                ng-click=\"ctrl.model.liveViewBackground.attachment_file = null\">\n                            <md-icon>delete</md-icon>\n                        </md-button>\n                    </div>\n                </md-radio-button>\n            </md-radio-group>\n            <p class=\"upload-container__sub-text\">\n                {{\"Dimension \" + ctrl.model.liveViewPreviewSize.width + \"x\" + ctrl.model.liveViewPreviewSize.height + \"px\"}} <br>\n                Allowed file formats: .jpg, .png, .gif or .mp4.<br>\n                Max. file size: {{ctrl.fileSizes.startScreen}}Mb / Max video length: 60 sec<br>\n            </p>\n            <md-switch\n                    ng-if=\"ctrl.model.liveViewMode !== 'fullscreen'\"\n                    md-invert\n                    ng-model=\"ctrl.model.forAllScenes\">\n                {{'Use this background for all scenes' | translate}}\n            </md-switch>\n        </div>\n        <div class=\"row background-settings\" ng-repeat=\"screen in ctrl.editScreems\"\n             ng-if=\"(!ctrl.model.forAllScenes && ctrl.model.liveViewMode !== 'fullscreen')\n                 || ($index && ctrl.model.liveViewMode === 'fullscreen')\">\n            <md-switch\n                    md-invert\n                    class=\"background-settings__title\"\n                    ng-model=\"ctrl.model[screen].enabled\">\n                {{'Background' | translate}}\n            </md-switch>\n            <md-radio-group ng-model=\"ctrl.model[screen].liveViewBackgroundMode\">\n                <md-radio-button value=\"color\">Use background color </md-radio-button>\n                <color-picker class=\"color-picker-label\"\n                              ng-model=\"ctrl.model[screen].liveViewBackgroundColor\"\n                              options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n                <md-radio-button value=\"image\" class=\"upload-option\">Use background image\n                    <upload\n                            model=\"ctrl.model[screen].liveViewBackground\"\n                            callback=\"ctrl.onScreenLiveViewBackgroundUploaded(file, screen)\"\n                            uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                            custom-label=\"{{'Upload' | translate}}\"\n                            file-types=\".jpg,.jpeg,.gif,.png,.mp4\"\n                            max-size=\"ctrl.fileSizes.startScreen\"\n                            is-overlay=\"false\"\n                            display-icon=\"false\">\n                    </upload>\n                    <div class=\"file-title\" ng-if=\"ctrl.model[screen].liveViewBackground.attachment_file\" title=\"{{ctrl.model[screen].liveViewBackground.attachment_file | getFileName}}\">\n                        <span>Uploaded: {{ ctrl.model[screen].liveViewBackground.attachment_file | getFileName : 12 }}</span>\n                        <md-button\n                                class=\"md-icon-button md-primary\"\n                                ng-click=\"ctrl.model[screen].liveViewBackground.attachment_file = null\">\n                            <md-icon>delete</md-icon>\n                        </md-button>\n                    </div>\n                </md-radio-button>\n            </md-radio-group>\n            <p class=\"upload-container__sub-text\">\n                {{\"Dimension \" + ctrl.model.liveViewPreviewSize.width + \"x\" + ctrl.model.liveViewPreviewSize.height + \"px\"}} <br>\n                Allowed file formats: .jpg, .png, .gif or .mp4.<br>\n                Max. file size: {{ctrl.fileSizes.startScreen}}Mb / Max video length: 60 sec<br>\n            </p>\n        </div>\n\n        <div class=\"mirror-block\">\n            <md-switch md-invert\n                       class=\"mirror-block__title\"\n                       ng-model=\"ctrl.model.shouldOutputPhotoMirrored\">\n                {{'Mirror Live View' | translate}}\n            </md-switch>\n            <span>{{'This will mirror the live view and ouput' | translate}}</span>\n            <p flex=\"60\" class=\"part-title__sub-text\">{{'Recommendation: Leave this on for a more natural user experience in front of the camera to mimic Mirror behaviour' | translate}}</p>\n        </div>\n\n\n\n        <div class=\"custom-btn-container\">\n            <p style=\"text-align: left;margin-top: 30px\">\n                <strong>Customize Photobooth App UI</strong>\n            </p>\n            <p class=\"part-title__sub-text\" flex=\"60\">{{'Here you change the appearance of the photobooth app. Upload you own button assets, change the location and dimension of buttons and more' |\n                translate}}</p>\n            <md-switch md-invert\n                       class=\"custom-btn-container__title\"\n                       ng-model=\"ctrl.model.customButtons.active\"\n                       ng-change=\"ctrl.callback()\">\n                {{'Custom UpReach UI buttons' | translate}}\n            </md-switch>\n            <md-switch md-invert\n                       class=\"custom-btn-container__title\"\n                       ng-model=\"ctrl.model.hideOutputPictureVideo\"\n                       ng-change=\"ctrl.callback()\">\n                {{'Do not show output picture / video' | translate}}\n            </md-switch>\n            <md-switch md-invert\n                       class=\"custom-btn-container__title\"\n                       ng-model=\"ctrl.model.hideSharingOptions\"\n                       ng-change=\"ctrl.callback()\">\n                {{'Do not show sharing options (QR code, e-mail, print, etc.)' | translate}}\n            </md-switch>\n            <p style=\"text-align: left;margin-top: 30px\" ng-show=\"ctrl.model.customButtons.active\">\n                <strong>General UI button settings</strong>\n            </p>\n            <div class=\"new-items-wrapper\" ng-show=\"ctrl.model.customButtons.active\">\n                <div layout=\"row\" class=\"area-editor\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.generalUiButtonsSettings.back\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Back button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.generalUiButtonsSettings.sharingBackBtn\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Sharing screen back button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.generalUiButtonsSettings.capture\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Capture button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.generalUiButtonsSettings.proceed\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Proceed button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\" ng-show=\"ctrl.sharingEmail\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.generalUiButtonsSettings.email\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Email button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\" ng-show=\"ctrl.sharingSms\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.generalUiButtonsSettings.sms\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'SMS button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\" ng-show=\"ctrl.sharingPrint\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.generalUiButtonsSettings.print\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Print button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.generalUiButtonsSettings.done\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Done button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\" ng-show=\"ctrl.sharingQr\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.generalUiButtonsSettings.qrCode\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            relative-size=\"true\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'QR code button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"sub-settings\" ng-show=\"ctrl.sharingQr\">\n                    <div class=\"row\">\n                        <p>QR code button Text</p>\n                        <input\n                                ng-model=\"ctrl.model.customButtons.generalUiButtonsSettings.qrCode.text\"\n                                type=\"text\">\n                    </div>\n                    <div class=\"row\">\n                        <p>QR code button Text size</p>\n                        <input\n                                ng-model=\"ctrl.model.customButtons.generalUiButtonsSettings.qrCode.textSize\"\n                                type=\"number\">\n                    </div>\n                    <div class=\"row\">\n                        <p>QR code button Text color</p>\n                        <color-picker class=\"color-picker-label\"\n                                      ng-model=\"ctrl.model.customButtons.generalUiButtonsSettings.qrCode.textColor\"\n                                      options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n                    </div>\n                </div>\n            </div>\n            <p style=\"text-align: left;margin-top: 30px\" ng-show=\"ctrl.model.customButtons.active\">\n                <strong>Capture mode button settings</strong>\n            </p>\n            <div class=\"new-items-wrapper\" ng-show=\"ctrl.model.customButtons.active\">\n                <div layout=\"row\" class=\"area-editor\" ng-show=\"ctrl.showSingle && ctrl.showGif || ctrl.showSingle && ctrl.showBoomerang || ctrl.showSingle && ctrl.showGif && ctrl.showBoomerang\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.captureModeButtonsSettings.single\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Single photo button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\" ng-show=\"ctrl.showSingle && ctrl.showGif || ctrl.showGif && ctrl.showBoomerang || ctrl.showSingle && ctrl.showGif && ctrl.showBoomerang\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.captureModeButtonsSettings.gif\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'GIF button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\" ng-show=\"ctrl.showSingle && ctrl.showBoomerang || ctrl.showGif && ctrl.showBoomerang || ctrl.showSingle && ctrl.showGif && ctrl.showBoomerang\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.captureModeButtonsSettings.boomerang\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Boomerang button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\" ng-if=\"!ctrl.isCustomSceneScreenEnabled()\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.captureModeButtonsSettings.scene\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            hide-size-options=\"true\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Scene/Filter popup position:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.captureModeButtonsSettings.filter\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Scene/Filter picker button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\">\n                    <start-screen-area\n                            model=\"ctrl.model.customButtons.generalUiButtonsSettings.close\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            hide-inputs-fields=\"true\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Scene/Filter close button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n                <div layout=\"row\" class=\"area-editor\" ng-if=\"!ctrl.isCustomSceneScreenEnabled()\">\n                    <div flex=\"30\">{{'Scene/Filter gallery pop up color:' | translate}}</div>\n                    <div flex=\"70\" class=\"color-picker-wrapper\">\n                        <p>\n                            Choose background color:\n                        </p>\n                        <color-picker class=\"color-picker-label\"\n                                      ng-model=\"ctrl.model.customButtons.captureModeButtonsSettings.scene.scenePopupColor\"\n                                      options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n                    </div>\n                </div>\n                <div layout=\"row\">\n                    <md-button class=\"md-primary md-raised\" style=\"float: right;margin-left: 0\" ng-click=\"ctrl.onResetButtonsValues()\">{{'Reset values to default according to screen orientation.' | translate}}</md-button>\n                </div>\n            </div>\n        </div>\n\n    </div>\n\n    <div flex=\"50\" class=\"preview-container\">\n        <div style=\"width: 500px\">\n            <p style=\"text-align: left;margin-top: 0;font-size: 20px\"><strong>Live View Previews</strong></p>\n        </div>\n\n        <div class=\"previews-container\" ng-if=\"!ctrl.model.customButtons.active\">\n            <live-view-preview\n                    enabled=\"ctrl.model.enabled\"\n                    screen=\"{{'photo'}}\"\n                    mode=\"{{ctrl.model.liveViewMode}}\"\n                    pr-width=\"{{ctrl.model.liveViewMode === 'fullscreen' ||ctrl.model.liveViewMode !== 'fullscreen' && ctrl.isPortraite ? ctrl.general.width : ctrl.model.liveViewPreviewSize.width}}\"\n                    pr-height=\"{{ctrl.model.liveViewMode === 'fullscreen' ||ctrl.model.liveViewMode !== 'fullscreen' && ctrl.isPortraite ? ctrl.general.height : ctrl.model.liveViewPreviewSize.height}}\"\n                    background=\"{{ctrl.getLiveViewBackgroundAttachment('photo')}}\"\n                    video-background=\"{{ctrl.getLiveViewVideoBackground('photo')}}\"\n                    bg-color=\"ctrl.getLiveViewBackgroundColor('photo')\"\n                    bg-mode=\"ctrl.getLiveViewBackgroundMode('photo')\"\n                    index=\"{{ctrl.index}}\"\n                    hide-title=\"true\"\n                    margin=\"true\"\n                    style=\"margin-bottom: 25px\"\n            ></live-view-preview>\n            <live-view-preview\n                    enabled=\"ctrl.model.forAllScenes ? ctrl.model.enabled : ctrl.model.filter.enabled\"\n                    screen=\"{{'filter'}}\"\n                    mode=\"{{ctrl.model.liveViewMode}}\"\n                    pr-width=\"{{ctrl.model.liveViewMode === 'fullscreen' || ctrl.isPortraite ? ctrl.general.width : ctrl.model.liveViewPreviewSize.width}}\"\n                    pr-height=\"{{ctrl.model.liveViewMode === 'fullscreen' || ctrl.isPortraite ? ctrl.general.height : ctrl.model.liveViewPreviewSize.height}}\"\n                    background=\"{{ctrl.getLiveViewBackgroundAttachment('filter')}}\"\n                    video-background=\"{{ctrl.getLiveViewVideoBackground('filter')}}\"\n                    bg-color=\"ctrl.getLiveViewBackgroundColor('filter')\"\n                    bg-mode=\"ctrl.getLiveViewBackgroundMode('filter')\"\n                    index=\"{{ctrl.index}}\"\n                    hide-title=\"true\"\n                    margin=\"true\"\n                    style=\"margin-bottom: 25px\"\n            ></live-view-preview>\n            <live-view-preview\n                    enabled=\"ctrl.model.liveViewMode === 'fullscreen' ? true : (ctrl.model.forAllScenes ? ctrl.model.enabled : ctrl.model.output.enabled)\"\n                    screen=\"{{'output'}}\"\n                    mode=\"{{ctrl.model.liveViewMode}}\"\n                    pr-width=\"{{ctrl.model.liveViewMode === 'fullscreen' || ctrl.isPortraite ? ctrl.general.width :ctrl.model.liveViewPreviewSize.width}}\"\n                    pr-height=\"{{ctrl.model.liveViewMode === 'fullscreen' || ctrl.isPortraite ? ctrl.general.height : ctrl.model.liveViewPreviewSize.height}}\"\n                    background=\"{{ctrl.getLiveViewBackgroundAttachment('output')}}\"\n                    video-background=\"{{ctrl.getLiveViewVideoBackground('output')}}\"\n                    bg-color=\"ctrl.getLiveViewBackgroundColor('output')\"\n                    bg-mode=\"ctrl.getLiveViewBackgroundMode('output')\"\n                    index=\"{{ctrl.index}}\"\n                    hide-title=\"true\"\n                    margin=\"true\"\n                    style=\"margin-bottom: 25px\"\n                    is-single=\"ctrl.isSingle\"\n                    is-portraite=\"ctrl.isPortraite\"\n                    hide-output-picture-video=\"ctrl.model.hideOutputPictureVideo\"\n                    hide-sharing-options=\"ctrl.model.hideSharingOptions\"\n            ></live-view-preview>\n        </div>\n        <div class=\"previews-container\" ng-if=\"ctrl.model.customButtons.active\">\n            <html-custom-btn-preview\n                    enabled=\"ctrl.model.forAllScenes ? ctrl.model.enabled : ctrl.model.output.enabled\"\n                    screen=\"{{'photo'}}\"\n                    mode=\"{{ctrl.model.liveViewMode}}\"\n                    pr-width=\"{{ctrl.model.liveViewMode === 'fullscreen' ||ctrl.model.liveViewMode !== 'fullscreen' && ctrl.isPortraite ? ctrl.general.width : ctrl.model.liveViewPreviewSize.width}}\"\n                    pr-height=\"{{ctrl.model.liveViewMode === 'fullscreen' ||ctrl.model.liveViewMode !== 'fullscreen' && ctrl.isPortraite ? ctrl.general.height : ctrl.model.liveViewPreviewSize.height}}\"\n                    index=\"{{ctrl.index}}\"\n                    related-values=\"true\"\n                    hide-overlay=\"false\"\n                    areas=\"{{ctrl.getCommonElements(ctrl.model.customButtons.generalUiButtonsSettings,ctrl.model.customButtons.captureModeButtonsSettings)}}\"\n                    video-background=\"{{ctrl.getLiveViewVideoBackground('photo')}}\"\n                    background=\"{{ctrl.getLiveViewBackgroundForPreview('photo')}}\"\n                    bg-color=\"ctrl.getLiveViewBackgroundColor('photo')\"\n                    bg-mode=\"ctrl.getLiveViewBackgroundMode('photo')\"\n                    bg-style=\"stretch\"\n                    scene-popup-color=\"ctrl.model.customButtons.captureModeButtonsSettings.scene.scenePopupColor\"\n                    transparency=\"0\"\n                    back-btn=\"true\"\n                    single-btn=\"ctrl.showSingle\"\n                    gif-btn=\"ctrl.showGif\"\n                    photo-btn=\"true\"\n                    boomerang-btn=\"ctrl.showBoomerang\"\n                    hide-photo-bg=\"true\"\n                    filter-btn=\"ctrl.shouldShowFilterSelector()\"\n                    scene-btn=\"ctrl.shouldShowSceneSelector()\"\n                    capture-btn=\"true\"\n                    proceed-btn=\"true\"\n                    display-popup=\"false\"\n                    hide-title=\"true\"\n                    margin=\"true\"\n                    style=\"margin-bottom: 25px\"\n            ></html-custom-btn-preview>\n            <html-custom-btn-preview\n                    enabled=\"ctrl.model.forAllScenes ? ctrl.model.enabled : ctrl.model.output.enabled\"\n                    screen=\"{{'filter'}}\"\n                    mode=\"{{ctrl.model.liveViewMode}}\"\n                    pr-width=\"{{ctrl.model.liveViewMode === 'fullscreen' ||ctrl.model.liveViewMode !== 'fullscreen' && ctrl.isPortraite ? ctrl.general.width : ctrl.model.liveViewPreviewSize.width}}\"\n                    pr-height=\"{{ctrl.model.liveViewMode === 'fullscreen' ||ctrl.model.liveViewMode !== 'fullscreen' && ctrl.isPortraite ? ctrl.general.height : ctrl.model.liveViewPreviewSize.height}}\"\n                    index=\"{{ctrl.index}}\"\n                    related-values=\"true\"\n                    hide-overlay=\"false\"\n                    areas=\"{{ctrl.getCommonElements(ctrl.model.customButtons.generalUiButtonsSettings,ctrl.model.customButtons.captureModeButtonsSettings)}}\"\n                    video-background=\"{{ctrl.getLiveViewVideoBackground('filter')}}\"\n                    background=\"{{ctrl.getLiveViewBackgroundForPreview('filter')}}\"\n                    bg-color=\"ctrl.getLiveViewBackgroundColor('filter')\"\n                    bg-mode=\"ctrl.getLiveViewBackgroundMode('filter')\"\n                    bg-style=\"stretch\"\n                    scene-popup-color=\"ctrl.model.customButtons.captureModeButtonsSettings.scene.scenePopupColor\"\n                    transparency=\"0\"\n                    back-btn=\"true\"\n                    single-btn=\"ctrl.showSingle\"\n                    gif-btn=\"ctrl.showGif\"\n                    photo-btn=\"true\"\n                    boomerang-btn=\"ctrl.showBoomerang\"\n                    hide-photo-bg=\"true\"\n                    filter-btn=\"ctrl.shouldShowFilterSelector()\"\n                    scene-btn=\"ctrl.shouldShowSceneSelector()\"\n                    capture-btn=\"true\"\n                    display-popup=\"true\"\n                    hide-title=\"true\"\n                    margin=\"true\"\n                    style=\"margin-bottom: 25px\"\n            ></html-custom-btn-preview>\n            <html-custom-btn-preview\n                    enabled=\"ctrl.model.liveViewMode === 'fullscreen' ? true : (ctrl.model.forAllScenes ? ctrl.model.enabled : ctrl.model.output.enabled)\"\n                    screen=\"{{'output'}}\"\n                    mode=\"{{ctrl.model.liveViewMode}}\"\n                    pr-width=\"{{ctrl.model.liveViewMode === 'fullscreen' || ctrl.isPortraite ? ctrl.general.width :ctrl.model.liveViewPreviewSize.width}}\"\n                    pr-height=\"{{ctrl.model.liveViewMode === 'fullscreen' || ctrl.isPortraite ? ctrl.general.height : ctrl.model.liveViewPreviewSize.height}}\"\n                    background=\"{{ctrl.getLiveViewBackgroundForPreview('output')}}\"\n                    bg-color=\"ctrl.getLiveViewBackgroundColor('output')\"\n                    bg-mode=\"ctrl.getLiveViewBackgroundMode('output')\"\n                    index=\"{{ctrl.index}}\"\n                    related-values=\"true\"\n                    hide-overlay=\"true\"\n                    areas=\"{{ctrl.getCommonElements(ctrl.model.customButtons.generalUiButtonsSettings,ctrl.model.customButtons.captureModeButtonsSettings)}}\"\n                    video-background=\"{{ctrl.getLiveViewVideoBackground('output')}}\"\n                    bg-style=\"stretch\"\n                    scene-popup-color=\"ctrl.model.customButtons.captureModeButtonsSettings.scene.scenePopupColor\"\n                    transparency=\"0\"\n                    sharing-back-btn=\"!ctrl.model.hideSharingOptions\"\n                    single-btn=\"false\"\n                    gif-btn=\"false\"\n                    photo-btn=\"false\"\n                    boomerang-btn=\"false\"\n                    hide-photo-bg=\"true\"\n                    filter-btn=\"false\"\n                    scene-btn=\"false\"\n                    capture-btn=\"false\"\n                    scene-btn=\"false\"\n                    display-popup=\"false\"\n                    email-btn=\"ctrl.sharingEmail && !ctrl.model.hideSharingOptions\"\n                    sms-btn=\"ctrl.sharingSms && !ctrl.model.hideSharingOptions\"\n                    done-btn=\"!ctrl.model.hideSharingOptions\"\n                    print-btn=\"ctrl.sharingPrint && !ctrl.model.hideSharingOptions\"\n                    qr-code-btn=\"ctrl.sharingQr && !ctrl.model.hideSharingOptions\"\n                    hide-output-picture-video=\"ctrl.model.hideOutputPictureVideo\"\n                    hide-sharing-options=\"ctrl.model.hideSharingOptions\"\n                    hide-title=\"true\"\n                    margin=\"true\"\n                    style=\"margin-bottom: 25px\"\n                    is-single=\"ctrl.isSingle\"\n                    is-portraite=\"ctrl.isPortraite\"\n            ></html-custom-btn-preview>\n        </div>\n    </div>\n</div>\n<hr>\n<div layout=\"row\" layout-sm=\"column\" layout-padding>\n    <div flex=\"50\" >\n        <!--Custom logo block start-->\n        <div class=\"custom-logo-container\">\n            <p style=\"text-align: left;margin-top: 30px\">\n                <strong>Loading Screen</strong>\n            </p>\n            <p class=\"part-title__sub-text\" flex=\"60\">{{'Loading screen that appears after taking a photo,GIF,boomerang of Video' |\n            translate}}</p>\n            <div class=\"row--alight-baseline\">\n                <div>\n                    <md-switch\n                            md-invert\n                            class=\"custom-logo-container__title\"\n                            ng-model=\"ctrl.model.customLogo.enabled\">\n                        {{'Custom Loading Screen Logo' | translate}}\n                    </md-switch>\n                    <p class=\"upload-container__sub-text\">\n                        Allowed file formats: .png<br>\n                        Max. file size: {{ctrl.fileSizes.customLogo}}mb<br>\n                    </p>\n                </div>\n                <upload\n                        model=\"ctrl.model.customLogo.file\"\n                        uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                        custom-label=\"{{'Upload Logo' | translate}}\"\n                        file-types=\".png\"\n                        max-size=\"ctrl.fileSizes.customLogo\"\n                        is-overlay=\"false\"\n                        ng-disabled=\"!ctrl.model.customLogo.enabled\"\n                        display-icon=\"false\">\n                </upload>\n                <div class=\"file-title\" ng-if=\"ctrl.model.customLogo.file.attachment_file\" title=\"{{ctrl.model.customLogo.file.attachment_file | getFileName}}\">\n                    <span>Uploaded: {{ ctrl.model.customLogo.file.attachment_file | getFileName : 12 }}</span>\n                    <md-button\n                            class=\"md-icon-button md-primary\"\n                            ng-click=\"ctrl.model.customLogo.file.attachment_file = null\">\n                        <md-icon>delete</md-icon>\n                    </md-button>\n                </div>\n\n            </div>\n            <div class=\"row--col\">\n                <md-switch\n                        md-invert\n                        class=\"custom-logo-container__title\"\n                        ng-model=\"ctrl.model.customLogo.hideDefaultLogo\"\n                        ng-disabled=\"!ctrl.model.customLogo.enabled\">\n                    {{'Hide Default Loading Screen Logo' | translate}}\n                </md-switch>\n            </div>\n            <div class=\"row--col\">\n                <md-switch\n                        md-invert\n                        class=\"custom-logo-container__title\"\n                        ng-model=\"ctrl.model.customLogo.background.enabled\">\n                    {{'Custom Loading Screen Background' | translate}}\n                </md-switch>\n                <md-radio-group ng-model=\"ctrl.model.customLogo.background.mode\" ng-disabled=\"!ctrl.model.customLogo.background.enabled\">\n                    <div class=\"radio-row\" ng-class=\"{'disabled-row': !ctrl.model.customLogo.background.enabled}\">\n                        <md-radio-button value=\"color\">Use background color</md-radio-button>\n                        <color-picker class=\"color-picker-label\"\n                                      ng-model=\"ctrl.model.customLogo.background.color\"\n                                      options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n                    </div>\n\n                    <div class=\"radio-row\">\n                        <md-radio-button value=\"image\" class=\"upload-option\">Use background image\n                        </md-radio-button>\n                        <upload\n                                model=\"ctrl.model.customLogo.background.image\"\n                                uri=\"{{ctrl.config.company + 'attachments/'}}\"\n                                custom-label=\"{{'Upload' | translate}}\"\n                                file-types=\".jpg,.jpeg,.gif,.png,.mp4\"\n                                max-size=\"ctrl.fileSizes.startScreen\"\n                                is-overlay=\"false\"\n                                ng-disabled=\"!ctrl.model.customLogo.background.enabled\"\n                                display-icon=\"false\">\n                        </upload>\n                        <div class=\"file-title\" ng-if=\"ctrl.model.customLogo.background.image.attachment_file\" title=\"{{ctrl.model.customLogo.background.image.attachment_file | getFileName}}\">\n                            <span>Uploaded: {{ ctrl.model.customLogo.background.image.attachment_file | getFileName : 12 }}</span>\n                            <md-button\n                                    class=\"md-icon-button md-primary\"\n                                    ng-click=\"ctrl.model.customLogo.background.image.attachment_file = null\">\n                                <md-icon>delete</md-icon>\n                            </md-button>\n                        </div>\n                    </div>\n                </md-radio-group>\n                <p class=\"upload-container__sub-text\">\n                    {{\"Dimension \" + ctrl.model.liveViewPreviewSize.width + \"x\" + ctrl.model.liveViewPreviewSize.height + \"px\"}} <br>\n                    Allowed file formats: .jpg, .png, .gif or .mp4.<br>\n                    Max. file size: {{ctrl.fileSizes.startScreen}}Mb / Max video length: 60 sec<br>\n                </p>\n            </div>\n            <div class=\"row--col\">\n                <md-switch\n                        md-invert\n                        class=\"custom-logo-container__title\"\n                        ng-model=\"ctrl.model.customLogo.screenText.enabled\">\n                    {{'Custom Loading Screen Text' | translate}}\n                </md-switch>\n                <div class=\"text-wrapper\">\n                    <div class=\"text-wrapper--item\">\n                        <md-input-container class=\"md-block\" >\n                            <label\n                                    ng-bind=\"'Your image is being created' | translate\"\n                                    for=\"custom-logo-text-title\"></label>\n                            <input\n                                    ng-model=\"ctrl.model.customLogo.screenText.title\"\n                                    type=\"text\"\n                                    ng-disabled=\"!ctrl.model.customLogo.screenText.enabled\"\n                                    id=\"custom-logo-text-title\">\n                        </md-input-container>\n                    </div>\n                    <div class=\"text-wrapper--item\">\n                        <md-input-container class=\"md-block\" >\n                            <label\n                                    ng-bind=\"'It may take a few seconds text' | translate\"\n                                    for=\"custom-logo-text-subtext\"></label>\n                            <input\n                                    ng-model=\"ctrl.model.customLogo.screenText.subText\"\n                                    type=\"text\"\n                                    ng-disabled=\"!ctrl.model.customLogo.screenText.enabled\"\n                                    id=\"custom-logo-text-subtext\">\n                        </md-input-container>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row--alight-center\" ng-class=\"{'disabled-row':!ctrl.model.customLogo.screenText.enabled}\">\n                <p>Custom Loading Screen Text color</p>\n                <color-picker class=\"color-picker-label\"\n                              ng-model=\"ctrl.model.customLogo.screenText.color\"\n                              options=\"ctrl.pickerOptions\" color-eyedropper></color-picker>\n            </div>\n            <hr>\n            <div class=\"row--alight-baseline\">\n                <div>\n                    <md-switch\n                            md-invert\n                            class=\"custom-logo-container__title\"\n                            ng-model=\"ctrl.model.customLogo.elements.doneButton.enabled\">\n                        {{'Custom Loading Done Button' | translate}}\n                    </md-switch>\n                </div>\n            </div>\n            <div class=\"row--alight-baseline\">\n                <div class=\"area-editor\">\n                    <start-screen-area\n                            model=\"ctrl.model.customLogo.elements.doneButton\"\n                            pixel-width=\"ctrl.json.admin.startScreenPreviewSize.width\"\n                            pixel-height=\"ctrl.json.admin.startScreenPreviewSize.height\"\n                            company=\"ctrl.config.company\"\n                            custom-buttons-options=\"true\"\n                            short-upload-title=\"true\"\n                            title=\"{{'Done button dimensions:' | translate}}\">\n                    </start-screen-area>\n                </div>\n            </div>\n            <hr>\n        </div>\n        <!--Custom logo block end-->\n    </div>\n    <div flex=\"50\" class=\"preview-container\">\n        <div class=\"previews-container\" ng-if=\"ctrl.model.customLogo.enabled\">\n            <html-preview\n                    screen=\"{{'custom_loader'}}\"\n                    mode=\"{{ctrl.model.liveViewMode}}\"\n                    pr-width=\"{{ctrl.model.liveViewMode === 'fullscreen' ||ctrl.model.liveViewMode !== 'fullscreen' && ctrl.isPortraite ? ctrl.general.width : ctrl.model.liveViewPreviewSize.width}}\"\n                    pr-height=\"{{ctrl.model.liveViewMode === 'fullscreen' ||ctrl.model.liveViewMode !== 'fullscreen' && ctrl.isPortraite ? ctrl.general.height : ctrl.model.liveViewPreviewSize.height}}\"\n                    index=\"{{ctrl.index}}\"\n                    related-values=\"true\"\n                    hide-overlay=\"true\"\n                    areas=\"{{ctrl.model.customLogo.elements}}\"\n                    video-background=\"{{ctrl.model.customLogo.background.image.attachment_file}}\"\n                    background=\"{{ctrl.model.customLogo.background.image.attachment_file}}\"\n                    show-title=\"true\"\n                    transparency=\"0\"\n                    bg-mode=\"ctrl.model.customLogo.background.mode\"\n                    bg-color=\"ctrl.model.customLogo.background.color\"\n                    bg-style=\"stretch\"\n                    margin=\"true\"\n                    text-color=\"{{ctrl.model.customLogo.screenText.color}}\"\n                    hide-default-logo=\"ctrl.model.customLogo.hideDefaultLogo\"\n                    style=\"margin-bottom: 25px\">\n            </html-preview>\n        </div>\n    </div>\n</div>\n\n<div layout=\"row\" class=\"general-footer\">\n    <div flex=\"100\" flex-sm=\"100\">\n        <div layout=\"row\" layout-sm=\"column\" layout-padding>\n            <div class=\"reset-btn-wrapper\" flex-sm=\"100\">\n                <p>\n                    <a href=\"#\"\n                       ng-click=\"ctrl.reset()\"\n                       class=\"md-primary reset-link\">\n                        {{'Reset' | translate}}\n                    </a>\n                    {{'This puts everything back to default settings' | translate}}\n                </p>\n                <md-button class=\"md-primary md-raised\" wz-next style=\"float: right\" >{{'Next' |\n                    translate}}\n                </md-button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(189);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(272);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isFinite = __webpack_require__(264);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _fileSizes = __webpack_require__(277);
	
	var _colorPicker = __webpack_require__(278);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LiveViewController = function (_$controller) {
	    LiveViewController.$inject = ["$injector", "$scope", "$photoTransform"];
	    (0, _inherits3.default)(LiveViewController, _$controller);
	
	    function LiveViewController($injector, $scope, $photoTransform) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, LiveViewController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (LiveViewController.__proto__ || (0, _getPrototypeOf2.default)(LiveViewController)).call(this, $injector));
	
	        _this.$scope = $scope;
	        _this.Math = Math;
	        _this.pickerOptions = (0, _assign2.default)({}, _colorPicker.COLOR_PICKER_SWATCH_OPTIONS);
	        _this.photoTransform = $photoTransform;
	        _this.editScreems = ["filter", "output"];
	        _this.index = 0;
	        _this.fileSizes = _fileSizes.FILE_SIZES;
	        return _this;
	    }
	
	    (0, _createClass3.default)(LiveViewController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this2 = this;
	
	            this.$scope.$watch(function () {
	                return _this2.model;
	            }, function () {
	                if (!_this2.model) {
	                    return;
	                }
	                if (_this2.model.shouldOutputPhotoMirrored === undefined) {
	                    _this2.model.shouldOutputPhotoMirrored = true;
	                }
	                if (_this2.model.hideOutputPictureVideo === undefined) {
	                    _this2.model.hideOutputPictureVideo = false;
	                }
	                if (_this2.model.hideSharingOptions === undefined) {
	                    _this2.model.hideSharingOptions = false;
	                }
	                _this2.normalizeLiveViewBackgroundModel();
	                _this2.ensureCustomSceneScreenModel();
	                _this2.setIndexValue();
	                if (_this2.model.customLogo && _this2.model.customLogo.hideDefaultLogo === undefined) {
	                    _this2.model.customLogo.hideDefaultLogo = false;
	                }
	                if (!_this2.model.customLogo || !_this2.model.customLogo.elements) {
	                    _this2.model.customLogo.elements = {
	                        doneButton: {
	                            x: 90,
	                            y: 90,
	                            width: 10,
	                            height: 10,
	                            enabled: false
	                        },
	                        title: {
	                            placeholder: "Your image is being created",
	                            enabled: false
	                        },
	                        text: {
	                            placeholder: "It may take a few seconds text",
	                            enabled: false
	                        },
	                        logo: {
	                            customIcon: _this2.model.customLogo.file
	                        }
	                    };
	                }
	            });
	            this.$scope.$watch(function () {
	                return _this2.model && _this2.model.customLogo && _this2.model.customLogo.file && _this2.model.customLogo.file.attachment_file;
	            }, function (newVal, oldVal) {
	                if (newVal === oldVal) {
	                    return;
	                }
	                if (newVal) {
	                    _this2.onCustomLogoFileChange();
	                } else {
	                    _this2.onCustomLogoFileRemove();
	                }
	            });
	            // Watch screen text enabled/disabled state
	            this.$scope.$watch(function () {
	                return _this2.model && _this2.model.customLogo && _this2.model.customLogo.screenText && _this2.model.customLogo.screenText.enabled;
	            }, function (newVal) {
	                _this2.syncCustomLogoScreenTextEnabled(newVal);
	            });
	
	            // Watch screen text title
	            this.$scope.$watch(function () {
	                return _this2.model && _this2.model.customLogo && _this2.model.customLogo.screenText && _this2.model.customLogo.screenText.title;
	            }, function (newVal) {
	                _this2.syncCustomLogoScreenTextTitle(newVal);
	            });
	
	            // Watch screen text subText
	            this.$scope.$watch(function () {
	                return _this2.model && _this2.model.customLogo && _this2.model.customLogo.screenText && _this2.model.customLogo.screenText.subText;
	            }, function (newVal) {
	                _this2.syncCustomLogoScreenTextSubText(newVal);
	            });
	            this.$scope.$watch(function () {
	                return _this2.general;
	            }, function () {
	                _this2.setIndexValue();
	            });
	            this.$scope.$watch(function () {
	                return _this2.model && _this2.model.customSceneScreen && _this2.model.customSceneScreen.numberOfScenes;
	            }, function (newVal, oldVal) {
	                if (newVal === oldVal && oldVal !== undefined) {
	                    return;
	                }
	                _this2.normalizeCustomScenesCount();
	                _this2.syncCustomSceneTouchPointsCount();
	            });
	            this.$scope.$watch(function () {
	                return _this2.model && _this2.model.customSceneScreen && _this2.model.customSceneScreen.enabled;
	            }, function (enabled) {
	                if (enabled) {
	                    _this2.ensureCustomSceneScreenModel();
	                    _this2.syncCustomSceneTouchPointsCount();
	                }
	            });
	        }
	    }, {
	        key: "ensureCustomSceneScreenModel",
	        value: function ensureCustomSceneScreenModel() {
	            if (!this.model) {
	                return;
	            }
	            if (!this.model.customSceneScreen) {
	                this.model.customSceneScreen = {};
	            }
	            if (this.model.customSceneScreen.enabled === undefined) {
	                this.model.customSceneScreen.enabled = false;
	            }
	            if (!this.model.customSceneScreen.background || (0, _typeof3.default)(this.model.customSceneScreen.background) !== "object") {
	                this.model.customSceneScreen.background = {};
	            }
	            if (!Array.isArray(this.model.customSceneScreen.touchpoints)) {
	                this.model.customSceneScreen.touchpoints = [];
	            }
	            if (this.model.customSceneScreen.numberOfScenes === undefined || this.model.customSceneScreen.numberOfScenes === null) {
	                this.model.customSceneScreen.numberOfScenes = 1;
	            }
	            this.normalizeCustomScenesCount();
	            this.syncCustomSceneTouchPointsCount();
	        }
	    }, {
	        key: "normalizeCustomScenesCount",
	        value: function normalizeCustomScenesCount() {
	            if (!this.model || !this.model.customSceneScreen) {
	                return;
	            }
	            var numericValue = parseInt(this.model.customSceneScreen.numberOfScenes, 10);
	            var normalized = (0, _isFinite2.default)(numericValue) && numericValue > 0 ? numericValue : 1;
	            this.model.customSceneScreen.numberOfScenes = normalized;
	        }
	    }, {
	        key: "getDefaultCustomSceneTouchPoint",
	        value: function getDefaultCustomSceneTouchPoint(index) {
	            var row = Math.floor(index / 4);
	            var col = index % 4;
	            return {
	                scene_index: index + 1,
	                scene_title: "",
	                width: 20,
	                height: 20,
	                x: 15 + col * 22,
	                y: 20 + row * 25,
	                angle: 0,
	                custom_icon: null,
	                customIcon: null
	            };
	        }
	    }, {
	        key: "syncCustomSceneTouchPointsCount",
	        value: function syncCustomSceneTouchPointsCount() {
	            if (!this.model || !this.model.customSceneScreen) {
	                return;
	            }
	            var desiredCount = this.model.customSceneScreen.numberOfScenes;
	            var currentTouchPoints = Array.isArray(this.model.customSceneScreen.touchpoints) ? this.model.customSceneScreen.touchpoints : [];
	            var nextTouchPoints = [];
	
	            for (var i = 0; i < desiredCount; i++) {
	                var existing = currentTouchPoints[i] || {};
	                var defaults = this.getDefaultCustomSceneTouchPoint(i);
	                var mergedTouchPoint = (0, _extends3.default)({}, defaults, existing, {
	                    scene_index: i + 1
	                });
	                if (mergedTouchPoint.customIcon && !mergedTouchPoint.custom_icon) {
	                    mergedTouchPoint.custom_icon = mergedTouchPoint.customIcon;
	                } else if (mergedTouchPoint.custom_icon && !mergedTouchPoint.customIcon) {
	                    mergedTouchPoint.customIcon = mergedTouchPoint.custom_icon;
	                }
	                nextTouchPoints.push(mergedTouchPoint);
	            }
	            if (!(0, _lodash.isEqual)(this.model.customSceneScreen.touchpoints, nextTouchPoints)) {
	                this.model.customSceneScreen.touchpoints = nextTouchPoints;
	            }
	        }
	    }, {
	        key: "onCustomSceneNumberChange",
	        value: function onCustomSceneNumberChange() {
	            this.normalizeCustomScenesCount();
	            this.syncCustomSceneTouchPointsCount();
	        }
	    }, {
	        key: "getCustomSceneTouchPoint",
	        value: function getCustomSceneTouchPoint(index) {
	            if (!this.model || !this.model.customSceneScreen || !Array.isArray(this.model.customSceneScreen.touchpoints)) {
	                return null;
	            }
	            return this.model.customSceneScreen.touchpoints[index] || null;
	        }
	    }, {
	        key: "getCustomSceneTouchPoints",
	        value: function getCustomSceneTouchPoints() {
	            if (!this.model || !this.model.customSceneScreen || !Array.isArray(this.model.customSceneScreen.touchpoints)) {
	                return [];
	            }
	            return this.model.customSceneScreen.touchpoints;
	        }
	    }, {
	        key: "getCustomSceneAreas",
	        value: function getCustomSceneAreas() {
	            var areas = {};
	            if (!this.model || !this.model.customSceneScreen || !Array.isArray(this.model.customSceneScreen.touchpoints)) {
	                return areas;
	            }
	            this.model.customSceneScreen.touchpoints.forEach(function (touchPoint, index) {
	                var rawIcon = touchPoint.custom_icon || touchPoint.customIcon || null;
	                var iconUrl = rawIcon && (typeof rawIcon === "undefined" ? "undefined" : (0, _typeof3.default)(rawIcon)) === "object" ? rawIcon.attachment_file || rawIcon.thumbnail_file || null : typeof rawIcon === "string" ? rawIcon : null;
	                var isVideoIcon = iconUrl ? /\.(mp4|mov|webm)$/i.test(iconUrl) : false;
	                var custom_icon = null;
	                if (rawIcon) {
	                    if ((typeof rawIcon === "undefined" ? "undefined" : (0, _typeof3.default)(rawIcon)) === "object") {
	                        if (rawIcon.attachment_file || rawIcon.thumbnail_file) {
	                            custom_icon = rawIcon;
	                        }
	                    } else if (typeof rawIcon === "string" && rawIcon.length > 0) {
	                        custom_icon = { attachment_file: rawIcon };
	                    }
	                }
	                areas["config" + (index + 1)] = {
	                    width: touchPoint.width || 20,
	                    height: touchPoint.height || 20,
	                    x: touchPoint.x || 15,
	                    y: touchPoint.y || 20,
	                    angle: touchPoint.angle || 0,
	                    title: touchPoint.scene_title || "",
	                    titleBtn: touchPoint.scene_title || "",
	                    font: "14px",
	                    custom_icon: custom_icon,
	                    customIcon: custom_icon,
	                    trueVideo: isVideoIcon
	                };
	            });
	            return areas;
	        }
	    }, {
	        key: "getCustomSceneVideoBackground",
	        value: function getCustomSceneVideoBackground() {
	            var bg = this.model && this.model.customSceneScreen ? this.model.customSceneScreen.background : null;
	            if (!bg || !bg.attachment_file) {
	                return "";
	            }
	            var file = bg.attachment_file;
	            return (/\.(mp4|mov|webm)$/i.test(file) ? file : ""
	            );
	        }
	    }, {
	        key: "isCustomSceneScreenEnabled",
	        value: function isCustomSceneScreenEnabled() {
	            return !!(this.model && this.model.customSceneScreen && this.model.customSceneScreen.enabled);
	        }
	    }, {
	        key: "shouldShowSceneSelector",
	        value: function shouldShowSceneSelector() {
	            return !!this.showScenes && !this.isCustomSceneScreenEnabled();
	        }
	    }, {
	        key: "shouldShowFilterSelector",
	        value: function shouldShowFilterSelector() {
	            return !!this.showFilter || this.shouldShowSceneSelector();
	        }
	    }, {
	        key: "onCustomLogoFileChange",
	        value: function onCustomLogoFileChange() {
	            if (!this.model || !this.model.customLogo) {
	                return;
	            }
	
	            var file = this.model.customLogo.file;
	
	            if (!this.model.customLogo.elements) {
	                this.model.customLogo.elements = {};
	            }
	
	            this.model.customLogo.elements.logo.customIcon = file;
	        }
	    }, {
	        key: "onCustomLogoFileRemove",
	        value: function onCustomLogoFileRemove() {
	            if (this.model && this.model.customLogo && this.model.customLogo.elements && this.model.customLogo.elements.logo) {
	                this.model.customLogo.elements.logo.customIcon = null;
	            }
	        }
	    }, {
	        key: "syncCustomLogoScreenTextEnabled",
	        value: function syncCustomLogoScreenTextEnabled(enabled) {
	            if (!this.model || !this.model.customLogo || this.model.customLogo.screenText === undefined) {
	                return;
	            }
	            this.model.customLogo.elements.title.enabled = !!enabled;
	            this.model.customLogo.elements.text.enabled = !!enabled;
	        }
	    }, {
	        key: "syncCustomLogoScreenTextTitle",
	        value: function syncCustomLogoScreenTextTitle(title) {
	            if (!this.model || !this.model.customLogo || this.model.customLogo.screenText === undefined) {
	                return;
	            }
	            this.model.customLogo.elements.title.placeholder = title;
	        }
	    }, {
	        key: "syncCustomLogoScreenTextSubText",
	        value: function syncCustomLogoScreenTextSubText(subText) {
	            if (!this.model || !this.model.customLogo || this.model.customLogo.screenText === undefined) {
	                return;
	            }
	            this.model.customLogo.elements.text.placeholder = subText;
	        }
	    }, {
	        key: "setIndexValue",
	        value: function setIndexValue() {
	            var height = this.model.liveViewMode === "fullscreen" ? this.general.height : this.model.liveViewPreviewSize.height;
	            var width = this.model.liveViewMode === "fullscreen" ? this.general.width : this.model.liveViewPreviewSize.width;
	            var sizeValue = height < width ? height : width;
	            this.index = sizeValue / 310;
	        }
	    }, {
	        key: "normalizeBackgroundField",
	        value: function normalizeBackgroundField(value) {
	            if (value === null || value === undefined || value === "") {
	                return {};
	            }
	            if (typeof value === "string") {
	                return { attachment_file: value };
	            }
	            if ((typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === "object") {
	                return value;
	            }
	            return {};
	        }
	    }, {
	        key: "normalizeLiveViewBackgroundModel",
	        value: function normalizeLiveViewBackgroundModel() {
	            if (!this.model) {
	                return;
	            }
	            this.model.liveViewBackground = this.normalizeBackgroundField(this.model.liveViewBackground);
	            if (this.model.filter) {
	                this.model.filter.liveViewBackground = this.normalizeBackgroundField(this.model.filter.liveViewBackground);
	            }
	            if (this.model.output) {
	                this.model.output.liveViewBackground = this.normalizeBackgroundField(this.model.output.liveViewBackground);
	            }
	        }
	    }, {
	        key: "getLiveViewBackgroundModel",
	        value: function getLiveViewBackgroundModel(screen) {
	            if (!this.model) {
	                return {};
	            }
	            var isFullscreen = this.model.liveViewMode === "fullscreen";
	            var forAllScenes = !!this.model.forAllScenes;
	
	            switch (screen) {
	                case "photo":
	                    return this.model.liveViewBackground;
	                case "filter":
	                    if (forAllScenes || isFullscreen) {
	                        return this.model.liveViewBackground;
	                    }
	                    return this.model.filter ? this.model.filter.liveViewBackground : {};
	                case "output":
	                    if (isFullscreen || !forAllScenes) {
	                        return this.model.output ? this.model.output.liveViewBackground : {};
	                    }
	                    return this.model.liveViewBackground;
	                default:
	                    return this.model.liveViewBackground;
	            }
	        }
	    }, {
	        key: "getLiveViewBackgroundAttachment",
	        value: function getLiveViewBackgroundAttachment(screen) {
	            var source = this.getLiveViewBackgroundModel(screen);
	            if (!source || !source.attachment_file) {
	                return "";
	            }
	            var file = source.attachment_file;
	            if (/\.(mp4|mov|webm)$/i.test(file)) {
	                return "";
	            }
	            return file;
	        }
	    }, {
	        key: "isLiveViewVideoAttachment",
	        value: function isLiveViewVideoAttachment(screen) {
	            return !!this.getLiveViewVideoBackground(screen);
	        }
	    }, {
	        key: "getLiveViewBackgroundForPreview",
	        value: function getLiveViewBackgroundForPreview(screen) {
	            var attachment = this.getLiveViewBackgroundAttachment(screen);
	            return attachment ? (0, _stringify2.default)([attachment]) : "[]";
	        }
	    }, {
	        key: "getLiveViewBackgroundMode",
	        value: function getLiveViewBackgroundMode(screen) {
	            if (!this.model) {
	                return "color";
	            }
	            var isFullscreen = this.model.liveViewMode === "fullscreen";
	            var forAllScenes = !!this.model.forAllScenes;
	
	            switch (screen) {
	                case "photo":
	                    return this.model.liveViewBackgroundMode || "color";
	                case "filter":
	                    if (forAllScenes) {
	                        return this.model.liveViewBackgroundMode || "color";
	                    }
	                    return this.model.filter && this.model.filter.liveViewBackgroundMode || "color";
	                case "output":
	                    if (isFullscreen && this.model.output && this.model.output.enabled) {
	                        return this.model.output.liveViewBackgroundMode || "color";
	                    }
	                    if (forAllScenes && !isFullscreen) {
	                        return this.model.liveViewBackgroundMode || "color";
	                    }
	                    return this.model.output && this.model.output.liveViewBackgroundMode || "color";
	                default:
	                    return "color";
	            }
	        }
	    }, {
	        key: "getLiveViewBackgroundColor",
	        value: function getLiveViewBackgroundColor(screen) {
	            if (!this.model) {
	                return "#ffffff";
	            }
	            var isFullscreen = this.model.liveViewMode === "fullscreen";
	            var forAllScenes = !!this.model.forAllScenes;
	
	            switch (screen) {
	                case "photo":
	                    return this.model.liveViewBackgroundColor || "#ffffff";
	                case "filter":
	                    if (forAllScenes) {
	                        return this.model.liveViewBackgroundColor || "#ffffff";
	                    }
	                    return this.model.filter && this.model.filter.liveViewBackgroundColor || "#ffffff";
	                case "output":
	                    if (isFullscreen && this.model.output && this.model.output.enabled && this.model.output.liveViewBackgroundMode === "color") {
	                        return this.model.output.liveViewBackgroundColor || "#ffffff";
	                    }
	                    if (forAllScenes && !isFullscreen) {
	                        return this.model.liveViewBackgroundColor || "#ffffff";
	                    }
	                    if (this.model.output && !this.model.output.enabled) {
	                        return "#ffffff";
	                    }
	                    return this.model.output && this.model.output.liveViewBackgroundColor || "#ffffff";
	                default:
	                    return "#ffffff";
	            }
	        }
	    }, {
	        key: "getFileType",
	        value: function getFileType(file) {
	            if (!file || !file.attachment_file || typeof file.attachment_file !== "string") {
	                return "";
	            }
	            var parts = file.attachment_file.split(".");
	            return parts[parts.length - 1];
	        }
	    }, {
	        key: "getLiveViewVideoBackground",
	        value: function getLiveViewVideoBackground(screen) {
	            var bg = this.getLiveViewBackgroundModel(screen);
	            if (!bg || !bg.attachment_file) {
	                return "";
	            }
	            var file = bg.attachment_file;
	            return (/\.(mp4|mov|webm)$/i.test(file) ? file : ""
	            );
	        }
	    }, {
	        key: "onModeChange",
	        value: function onModeChange() {
	            // color picker change handler placeholder
	        }
	    }, {
	        key: "onGlobalLiveViewBackgroundUploaded",
	        value: function onGlobalLiveViewBackgroundUploaded(_ref) {
	            var file = _ref.file;
	
	            if (file && this.model) {
	                this.model.liveViewBackgroundMode = "image";
	            }
	        }
	    }, {
	        key: "onScreenLiveViewBackgroundUploaded",
	        value: function onScreenLiveViewBackgroundUploaded(_ref2, screen) {
	            var file = _ref2.file;
	
	            if (file && this.model && this.model[screen]) {
	                this.model[screen].liveViewBackgroundMode = "image";
	            }
	        }
	    }, {
	        key: "getCommonElements",
	        value: function getCommonElements(obj1, obj2) {
	            if (!obj1 || !obj2) {
	                return [];
	            }
	            return (0, _extends3.default)({}, obj1, obj2);
	        }
	    }, {
	        key: "onResetButtonsValues",
	        value: function onResetButtonsValues() {
	            if (this.isPortraite) {
	                (0, _assign2.default)(this.model.customButtons, {
	                    generalUiButtonsSettings: {
	                        back: { width: 4.5, height: 4.5, x: 8, y: 7 },
	                        sharingBackBtn: { width: 3.5, height: 3.5, x: 8, y: 7 },
	                        capture: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                        proceed: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                        email: { width: 5.5, height: 5.5, x: 16.5, y: 88 },
	                        sms: { width: 3.5, height: 3.5, x: 35, y: 88 },
	                        print: { width: 3.5, height: 3.5, x: 45, y: 88 },
	                        done: { width: 6, height: 6, x: 89, y: 92.5 },
	                        qrCode: { width: 7, height: 7, x: 50, y: 11, text: "Scan me to download", textSize: 12, textColor: "black" },
	                        close: { width: 3.5, height: 3.5, x: 5, y: 28 },
	                        next: { width: 5, height: 5, x: 93, y: 50 },
	                        closeError: { width: 5, height: 5, x: 93, y: 50 }
	                    },
	                    captureModeButtonsSettings: {
	                        single: { width: 3.5, height: 3.5, x: 8, y: 44 },
	                        gif: { width: 3.5, height: 3.5, x: 8, y: 49 },
	                        boomerang: { width: 3.5, height: 3.5, x: 8, y: 55 },
	                        scene: { scenePopupColor: "#FFF", width: 36, height: 48, x: 50, y: 57 },
	                        filter: { width: 5, height: 5, x: 8, y: 38 }
	                    }
	                });
	            } else {
	                (0, _assign2.default)(this.model.customButtons, {
	                    generalUiButtonsSettings: {
	                        back: { width: 6, height: 6, x: 5, y: 7 },
	                        sharingBackBtn: { width: 6, height: 6, x: 5, y: 7 },
	                        capture: { width: 10, height: 10, x: 93, y: 50 },
	                        proceed: { width: 10, height: 10, x: 93, y: 50 },
	                        email: { width: 6, height: 6, x: 90, y: 40 },
	                        sms: { width: 6, height: 6, x: 90, y: 50 },
	                        print: { width: 6, height: 6, x: 90, y: 60 },
	                        done: { width: 10, height: 10, x: 90, y: 81 },
	                        qrCode: { width: 6, height: 6, x: 90, y: 30, text: "Scan me to download", textSize: 12, textColor: "black" },
	                        close: { width: 6, height: 6, x: 5, y: 28 },
	                        next: { width: 10, height: 10, x: 93, y: 50 },
	                        closeError: { width: 10, height: 10, x: 93, y: 50 }
	                    },
	                    captureModeButtonsSettings: {
	                        single: { width: 6, height: 6, x: 5, y: 44 },
	                        gif: { width: 6, height: 6, x: 5, y: 54 },
	                        boomerang: { width: 6, height: 6, x: 5, y: 65 },
	                        scene: { scenePopupColor: "#FFF", width: 36, height: 48, x: 22, y: 46 },
	                        filter: { width: 6, height: 6, x: 5, y: 33 }
	                    }
	                });
	            }
	        }
	    }]);
	    return LiveViewController;
	}(_index.$controller);
	
	exports.default = LiveViewController;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(340);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./live-view.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./live-view.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "live-view md-switch{margin-left:0!important}live-view md-switch .md-label{min-width:180px!important}live-view .setting-section{flex:1;max-width:275px;width:275px;min-width:275px;box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9;padding:10px 0 10px 20px;position:relative;margin:30px 0}live-view .setting-section.logo-disabled{color:#9e9e9e;opacity:.5}live-view .setting-section .md-label{min-width:180px}live-view .setting-section md-switch{font-size:18px}live-view .setting-section md-switch .md-container{transform:scale(1.2) translateX(20px)!important}live-view .setting-section upload{margin-top:15px}live-view .setting-section .file-title{width:50%;margin-left:10px;min-width:275px;font-size:14px;color:#a8a8a9;white-space:nowrap}live-view .setting-section .file-title md-icon{color:#a8a8a9!important}live-view .setting-section .file-title md-icon:hover{color:#848484}live-view .setting-section .slider-title{padding:0 0 0 7px;display:inline-block;color:#848484;margin-top:25px;font-size:16px}live-view .setting-section md-slider-container{padding:0 40px 0 8px}live-view .setting-section md-slider-container .md-sign{display:none}live-view .setting-section md-slider-container md-slider[md-discrete]:not([disabled]).md-active .md-thumb{transform:scale(.7)}live-view .setting-section md-slider-container .md-track-ticks{display:none}live-view .setting-section .logo-sel-cont{margin:0 40px 0 8px;font-size:16px}live-view .setting-section .logo-sel-cont .logo-selector{height:147px}live-view .setting-section .logo-sel-cont html-preview .preview-main{transform-origin:top left;transform:scale(.76)}live-view .setting-section .logo-sel-cont .logo-selector-title{width:100%;margin:0 auto;display:block;color:#848484}live-view .setting-section .logo-sel-cont .logo-selector{width:100%;margin:0 auto;position:relative}live-view .setting-section .logo-sel-cont .logo-selector md-radio-group{width:0;height:0;z-index:200}live-view .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button{position:absolute;margin:0}live-view .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.top-left{top:4%;left:8%}live-view .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.top-middle{top:4%;left:calc(50% - 10px)}live-view .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.top-right{top:4%;right:5%}live-view .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.bottom-left{bottom:15%;left:8%}live-view .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.bottom-middle{bottom:15%;left:calc(50% - 10px)}live-view .setting-section .logo-sel-cont .logo-selector md-radio-group md-radio-button.bottom-right{bottom:15%;right:5%}live-view .setting-section .logo-sel-cont .logo-selector img{width:100%}live-view .setting-section .ss-title{margin:22px 10px;font-size:18px}live-view .setting-section md-radio-group{font-size:15px;margin:10px 0 0 30px}live-view .setting-section md-radio-group md-radio-button{margin:0 0 30px 10px;font-size:15px}live-view .setting-section .ss-bg-info{display:flex;color:#848484;font-size:14px;margin:0 0 0 10px}live-view .setting-section .ss-bg-info.logo-info{margin-top:15px;margin-bottom:-15px}live-view .setting-section .ss-bg-info.ss-disabled{opacity:.7}live-view .setting-section .ss-bg-info.ss-disabled .icon{color:#848484}live-view .setting-section .ss-bg-info .icon{width:40px;color:#ee2737}live-view .setting-section .ss-tm-download{display:flex;color:#ee2737;font-size:14px;margin:10px 0 0 10px}live-view .setting-section .ss-tm-download.ss-disabled{opacity:.7;color:#848484}live-view .setting-section .ss-tm-download.ss-disabled .info-text{text-decoration:none;cursor:default}live-view .setting-section .ss-tm-download .icon{width:30px}live-view .setting-section .ss-tm-download .info-text{text-decoration:underline;cursor:pointer}live-view .setting-section .image-crop{display:flex;margin:10px 0 0 10px;align-items:center;color:#848484;font-size:14px}live-view .setting-section .image-crop.ss-disabled{opacity:.7}live-view .setting-section .image-crop md-switch{margin:0;width:40px;min-width:40px;transform:translateX(-32px)}live-view .setting-section .image-crop md-switch .md-label{min-width:2px}live-view .setting-section .image-crop md-switch .md-thumb{background-color:#ff4081}live-view .setting-section .image-crop md-switch .md-bar{background-color:rgba(255,64,129,.5)}live-view .setting-section .image-crop .title-crop{margin:0 5px;outline:none;cursor:pointer;font-size:14px}live-view .setting-section .image-crop .title-crop.crop-active{color:#ff4081}live-view .previews-container{display:flex;flex-flow:column;flex-wrap:nowrap}live-view .column{flex-flow:column!important}live-view .column live-view-preview{margin-top:20px}live-view .radio-row{display:flex}live-view .radio-row md-radio-button:first-child{margin-right:27px}live-view .background-settings{display:flex;flex-direction:column}live-view .background-settings__title{font-size:14px;font-weight:700}live-view .background-settings md-radio-group{position:relative}live-view .background-settings .color-picker-label{display:block;position:absolute;top:1px;left:200px;border-radius:50%;outline:none;border:1px solid #d3d3d3;width:16px;height:16px;cursor:pointer}live-view .background-settings .upload-option{display:flex;flex-direction:row}live-view .background-settings .upload-option .md-label{display:flex;align-items:center;pointer-events:unset}live-view .background-settings .upload-option .md-label upload label{width:105px}live-view .custom-scene-screen{margin-top:30px}live-view .custom-scene-screen__title .md-label{font-weight:700}live-view .custom-scene-screen__settings{display:flex;flex-direction:column;gap:16px;margin-top:10px}live-view .custom-scene-screen__count{max-width:220px}live-view .custom-scene-screen__background{display:flex;flex-direction:column;align-items:flex-start}live-view .custom-scene-screen__background .file-title{display:flex;align-items:center}live-view .custom-scene-screen__touch-points{display:flex;flex-direction:column;gap:10px}live-view .custom-scene-screen__touch-point-item{border:1px solid #e9e9e9;border-radius:6px;padding:10px 12px;background:#fff}live-view .custom-scene-screen__touch-point-label{margin-bottom:8px}live-view .custom-scene-screen__title-input{margin-bottom:6px;max-width:320px}live-view .custom-scene-screen__preview{margin-top:8px;margin-bottom:30px}.mirror-block{display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;margin-top:82px}.mirror-block strong{display:inline-block}.mirror-block__title .md-label{font-weight:700;font-size:14px}.mirror-block span{font-size:14px;font-style:normal;font-weight:400;line-height:normal}.custom-btn-container{flex-direction:column!important}.custom-btn-container .new-items-wrapper start-screen-area{min-width:575px}.custom-btn-container .new-items-wrapper .layout-row,.custom-btn-container .new-items-wrapper .layout-row start-screen-area{flex-wrap:wrap}.custom-btn-container .new-items-wrapper .layout-row start-screen-area .custom-width{max-width:65px}.custom-btn-container .new-items-wrapper .layout-row start-screen-area .custom-width md-input-container label{font-size:10px}.custom-btn-container .new-items-wrapper .layout-row start-screen-area .custom-width .md-errors-spacer{display:none}.custom-btn-container__title{font-size:14px;font-style:normal;font-weight:400;line-height:normal}.btn-nav-group{display:flex;flex-direction:column;align-items:flex-start;padding-left:0;padding-right:0}.btn-nav-group .md-button{padding-top:0;padding-bottom:0}.custom-logo-container .row--alight-center{display:flex;align-items:center}.custom-logo-container .row--alight-baseline{display:flex;align-items:baseline}.custom-logo-container .file-title,.custom-logo-container .row--col .md-label{display:flex;align-items:center}.custom-logo-container .radio-row{display:flex;align-items:center;padding:10px 0}.custom-logo-container .radio-row md-radio-button{margin:0;min-width:200px}.custom-logo-container .radio-row.disabled-row .color-picker-label{cursor:not-allowed;pointer-events:none}.custom-logo-container .upload-option .md-label{display:flex;align-items:center;pointer-events:unset}.custom-logo-container .color-picker-label{height:16px;width:16px;margin-left:25px;border-radius:50%;cursor:pointer;display:flex;border:1px solid #000}.custom-logo-container .text-wrapper{display:grid;grid-template-columns:auto auto;gap:20px}.custom-logo-container .disabled-row .color-picker-label{cursor:not-allowed;pointer-events:none}.sub-settings{display:flex;flex-direction:column}.sub-settings .row{display:flex;align-items:center}.sub-settings .row p{min-width:244px;margin-bottom:14px;margin-top:14px}.sub-settings .row input{border:none;background:transparent;border-bottom:1px solid #dcdcdc;height:20px}.sub-settings .row input[type=text]{min-width:272px}.sub-settings .row input[type=number]{width:43px}.sub-settings .row .color-picker-label{width:18px;height:18px;border-radius:100px;border:1px solid #000}", ""]);
	
	// exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _deploymentsRouter = __webpack_require__(342);
	
	var _deploymentsRouter2 = _interopRequireDefault(_deploymentsRouter);
	
	var _deploymentsComponent = __webpack_require__(343);
	
	var _deploymentsComponent2 = _interopRequireDefault(_deploymentsComponent);
	
	var _deploymentList = __webpack_require__(346);
	
	var _deploymentList2 = _interopRequireDefault(_deploymentList);
	
	var _deploymentUpdate = __webpack_require__(491);
	
	var _deploymentUpdate2 = _interopRequireDefault(_deploymentUpdate);
	
	var _deploymentSetting = __webpack_require__(497);
	
	var _deploymentSetting2 = _interopRequireDefault(_deploymentSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Module = angular.module("app.deployments", []).component("deployments", _deploymentsComponent2.default).component("deploymentList", _deploymentList2.default).component("deploymentUpdate", _deploymentUpdate2.default).component("deploymentSetting", _deploymentSetting2.default).config(_deploymentsRouter2.default);
	
	exports.default = Module;

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	"use strict";
	
	Router.$inject = ["$stateProvider", "$urlRouterProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Router;
	function Router($stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $urlRouterProvider.when("/app/deployments", "/app/deployments/");
	
	    $stateProvider.state({
	        name: "deployments",
	        url: "/app/deployments",
	        template: "<deployments></deployments>",
	        resolve: {
	            $title: function $title() {
	                return "Deployments | UpReach Cloud";
	            }
	        }
	    }).state({
	        name: "deployments.list",
	        url: "/?:code",
	        template: "<deployment-list></deployment-list>",
	        resolve: {
	            $title: function $title() {
	                return "Deployments | UpReach Cloud";
	            }
	        }
	    }).state({
	        name: "deployments.update",
	        url: "/:cid/?:isNew/?:company/:?code",
	        template: "<deployment-update></deployment-update>",
	        resolve: {
	            $title: function $title() {
	                return "Deployment Update | UpReach Cloud";
	            }
	        }
	    }).state({
	        name: "deployments.setting",
	        url: "/setting/:cid",
	        template: "<deployment-setting></deployment-setting>",
	        resolve: {
	            $title: function $title() {
	                return "Deployment Setting | UpReach Cloud";
	            }
	        }
	    });
	}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _deployments = __webpack_require__(344);
	
	var _deployments2 = _interopRequireDefault(_deployments);
	
	var _deployments3 = __webpack_require__(345);
	
	var _deployments4 = _interopRequireDefault(_deployments3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeploymentsComponent = {
		template: _deployments2.default,
		controller: _deployments4.default,
		controllerAs: "controller"
	};
	
	exports.default = DeploymentsComponent;

/***/ }),
/* 344 */
234,
/* 345 */
235,
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _deploymentList = __webpack_require__(347);
	
	var _deploymentList2 = _interopRequireDefault(_deploymentList);
	
	var _deploymentList3 = __webpack_require__(348);
	
	var _deploymentList4 = _interopRequireDefault(_deploymentList3);
	
	__webpack_require__(489);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Component = {
		template: _deploymentList2.default,
		controller: _deploymentList4.default,
		controllerAs: "controller"
	};
	
	exports.default = Component;

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports = "<md-content layout=\"column\" flex layout-align=\"top center\">\n    <md-card>\n        <md-toolbar class=\"md-table-toolbar md-default\" ng-hide=\"options.rowSelection && selected.length\">\n            <div class=\"md-toolbar-tools\">\n                <span>Deployments</span>\n                <div flex></div>\n                <div flex=\"70\" class=\"md-toolbar-tools md-toolbar-search\" ng-if=\"filter.show\" layout-align=\"center right\">\n                    <md-input-container md-no-float flex layout-align=\"center right\">\n                        <input ng-blur=\"controller.onSearchBlur()\" type=\"text\" id=\"search-field\" placeholder=\"Search in the Deployments\" ng-model=\"query.search\" ng-model-options=\"filter.options\" class=\"ng-pristine ng-valid ng-touched\" autofocus>\n                    </md-input-container>\n                    <button class=\"md-icon-button md-button md-ink-ripple\" type=\"button\" ng-click=\"controller.removeFilter()\" layout-align=\"center right\">\n                        <md-icon class=\"material-icons\">search</md-icon>\n                        <div class=\"md-ripple-container\"></div>\n                    </button>\n                </div>\n                <md-button class=\"md-icon-button md-button md-ink-ripple\" ng-click=\"controller.showFilter()\" ng-if=\"!filter.show\" ng-show=\"deployments._meta.count\">\n                    <md-icon class=\"material-icons\">search</md-icon>\n                    <div class=\"md-ripple-container\"></div>\n                </md-button>\n                <md-button\n                    class=\"md-icon-button\"\n                    ng-click=\"controller.addNew()\">\n                    <md-icon class=\"material-icons\">add</md-icon>\n                </md-button>\n            </div>\n        </md-toolbar>\n\n        <md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"options.rowSelection && selected.length\">\n            <div class=\"md-toolbar-tools\">\n                <span>{{selected.length}} {{selected.length > 1 ? 'items' : 'item'}} selected</span>\n            </div>\n        </md-toolbar>\n\n        <md-table-container ng-if=\"! deployments._meta.count\" class=\"no-items\">\n            <div ng-if=\"loading\" translate>Loading deployments...</div>\n            <div ng-if=\"!loading && !filter.show\" translate>You have no deployments available.<br/>Press the Plus button on the top right of this table to add your first deployment!</div>\n            <div ng-if=\"!loading && filter.show\" translate>No results found for: '{{ query.search }}'.</div>\n        </md-table-container>\n\n        <md-table-container ng-if=\"deployments._meta.count\">\n            <table md-table md-row-select=\"options.rowSelection\" multiple=\"{{options.multiSelect}}\" ng-model=\"selected\" md-progress=\"promise\">\n                <thead ng-if=\"!options.decapitate\" md-head md-order=\"query.order\" md-on-reorder=\"logOrder\">\n                <tr md-row>\n                    <th md-column md-order-by=\"_name\"><span>{{'Deployment Name' | translate}}</span></th>\n                    <th md-column md-order-by=\"_company__name\" ng-hide=\"controller.isClient()\"><span>{{'Client Name' | translate}}</span></th>\n                    <th md-column md-order-by=\"_logistics_type\" ng-hide=\"controller.isClient()\"><span>{{'Deployment type' | translate}}</span></th>\n                    <th md-column md-order-by=\"_location_city\" ng-hide=\"controller.isClient()\"><span>{{'Deployment Location' | translate}}</span></th>\n                    <th md-column md-order-by=\"_deployment_start\"><span>{{'Start Date' | translate}}</span></th>\n                    <th md-column md-order-by=\"_deployment_end\"><span>{{'End Date' | translate}}</span></th>\n                    <th md-column><span>{{'Duration' | translate}}</span></th>\n                    <th md-column><span>{{'Configurations' | translate}}</span></th>\n                    <th md-column md-order-by=\"_booth\"><span>{{'Booth Number' | translate}}</span></th>\n                    <th md-column md-order-by=\"_status\" ng-hide=\"controller.isClient()\"><span>{{'Status' | translate}}</span></th>\n                    <th md-column></th>\n                </tr>\n                </thead>\n                <tbody md-body>\n                <tr md-row md-select=\"deployment\" md-on-select=\"logItem\" md-auto-select=\"options.autoSelect\" class=\"md-row\"\n                    ng-repeat=\"item in deployments | filter: filter.search | orderBy: query.order | limitTo: query.limit : (query.page -1) * query.limit\"\n                    ui-sref=\"deployments.setting({cid: (item.url | getObjectId)})\">\n                    <td md-cell class=\"underline-on-hover show-button-on-hover\" ng-click=\"controller.editName($event, item)\" style=\"min-width: 150px\">{{item.name}}<md-button\n                            aria-label=\"{{'Edit deployment name' | translate }}\" class=\"md-icon-button\">\n                              <md-icon class=\"material-icons\">edit</md-icon>\n                        </md-button>\n                    </td>\n                    <td md-cell ng-hide=\"controller.isClient()\">  <!-- {{item.company | relation:companies:\"name\"}} -->\n                        <api-select-search\n                                model=\"item.company\"\n                                multiple=\"false\"\n                                collection=\"company\"\n                                selected-values=\"[item.company_info]\"\n                                on-value-change=\"controller.changeCompany(value, item)\"\n                                label=\"'No company'\"\n                                search-label=\"'Search company'\"></api-select-search>\n                    </td>\n\n                    <td md-cell ng-hide=\"controller.isClient()\">\n                        <span ng-bind=\"item.logistics_type | getObjectByKey:controller.logisticsType\"></span>\n                    </td>\n\n                    <!-- deployment location -->\n                    <td md-cell ng-hide=\"controller.isClient()\">\n                        <span ng-bind=\"item.location_address.city\"></span>\n                    </td>\n\n                    <!-- start date -->\n                    <td md-cell>\n                        <span ng-bind=\"item.deployment_start | defaultDateFormatDays\"></span>\n                    </td>\n\n                    <!-- end date -->\n                    <td md-cell>\n                        <span ng-bind=\"item.deployment_end | defaultDateFormatDays\"></span>\n                    </td>\n\n                    <!-- duration -->\n                    <td md-cell>\n                        <span ng-if=\"item.deployment_end && item.deployment_start\">\n                            {{[item.deployment_end, item.deployment_start] | datesDiffInDays}} {{'days' | translate}}\n                        </span>\n                    </td>\n\n                    <td md-cell class=\"truncated\"> <!-- {{item.deployment | relation:deployments:\"name\"}} -->\n                        <api-select-search\n                                model=\"item.configurations\"\n                                multiple=\"true\"\n                                collection=\"configuration\"\n                                selected-values=\"item.configurations_info\"\n                                on-value-change=\"controller.changeActiveConfig(value, item)\"\n                                label=\"'No config'\"\n                                search-label=\"'Search config'\"></api-select-search>\n                    </td>\n                    <td md-cell>\n                        <span ng-bind=\"item.booth_id\"></span>\n                    </td>\n\n                    <!-- deployment status -->\n                    <td md-cell ng-hide=\"controller.isClient()\">\n                        <md-select\n                                aria-label=\"Status\"\n                                ng-model=\"item.status\"\n                                ng-change=\"item.$update()\">\n                            <md-option ng-value=\"key\" ng-repeat=\"(key, value) in controller.status\">{{value | translate}}</md-option>\n                        </md-select>\n                    </td>\n\n                    <td md-cell  layout=\"row\" layout-align=\"center end\">\n                        <span flex></span>\n                        <md-menu md-position-mode=\"target-right target\" >\n                          <md-button aria-label=\"Menu options\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                              <md-icon class=\"material-icons\">more_vert</md-icon>\n                          </md-button>\n                          <md-menu-content width=\"4\" >\n                            <md-menu-item>\n                              <md-button ng-click=\"controller.showSecretID($event, item)\">\n                                  <div layout=\"row\" flex>\n                                    <p flex translate>Deployment ID</p>\n                                    <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">fingerprint</md-icon>\n                                  </div>\n                              </md-button>\n                            </md-menu-item>\n                              <md-menu-item>\n                                  <md-button ng-click=\"controller.applyDeployment($event, item)\">\n                                      <div layout=\"row\" flex>\n                                          <p flex translate>Install deployment on device</p>\n                                          <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">settings</md-icon>\n                                      </div>\n                                  </md-button>\n                              </md-menu-item>\n                              <md-menu-item\n                                      permission-hide=\"Sub-User\" ng-hide=\"!item.booth_id\">\n                                  <md-button ng-click=\"controller.removeDeployment(item)\">\n                                      <div layout=\"row\" flex>\n                                          <p flex translate>{{ \"Remove deployment\" }}</p>\n                                          <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">check_circle_outline</md-icon>\n                                      </div>\n                                  </md-button>\n                              </md-menu-item>\n                            <md-menu-item>\n                              <md-button ng-click=\"controller.addNew($event, item)\">\n                                  <div layout=\"row\" flex>\n                                    <p flex translate>Copy deployment</p>\n                                    <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">content_copy</md-icon>\n                                  </div>\n                              </md-button>\n                            </md-menu-item>\n                              <md-menu-item>\n                                  <md-button ng-click=\"controller.openInNewTab(item.url | getObjectId)\">\n                                      <div layout=\"row\" flex>\n                                          <p flex translate>Open in new tab</p>\n                                          <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">tab</md-icon>\n                                      </div>\n                                  </md-button>\n                              </md-menu-item>\n                            <md-menu-item>\n                              <md-button ng-click=\"controller.openDeleteDialog($event, item)\">\n                                  <div layout=\"row\" flex>\n                                    <p flex translate>Delete</p>\n                                    <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">delete</md-icon>\n                                  </div>\n                              </md-button>\n                            </md-menu-item>\n                          </md-menu-content>\n                        </md-menu>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <button md-button ng-if=\"canAddMore && !loading\" ng-click=\"controller.addMoreItems()\" style=\"color: #FF0051\">Load more</button>\n        <!--<md-table-pagination ng-if=\"deployments._meta.count > 10\" md-limit=\"10\" md-page=\"query.page\" md-page-select=\"true\" md-total=\"{{deployments._meta.count}}\"  ></md-table-pagination>-->\n    </md-card>\n</md-content>\n";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(239);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	var _secretidController = __webpack_require__(256);
	
	var _secretidController2 = _interopRequireDefault(_secretidController);
	
	var _secretid = __webpack_require__(257);
	
	var _secretid2 = _interopRequireDefault(_secretid);
	
	var _deploymentCreate = __webpack_require__(349);
	
	var _deploymentCreate2 = __webpack_require__(486);
	
	var _deploymentCreate3 = _interopRequireDefault(_deploymentCreate2);
	
	var _deploymentApply = __webpack_require__(487);
	
	var _deploymentApply2 = __webpack_require__(488);
	
	var _deploymentApply3 = _interopRequireDefault(_deploymentApply2);
	
	var _deleteDialog = __webpack_require__(260);
	
	var _deleteDialog2 = __webpack_require__(261);
	
	var _deleteDialog3 = _interopRequireDefault(_deleteDialog2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Company", "$Deployment", "$Configuration", "$companies", "gettextCatalog", "$mdEditDialog"];
	
	var Controller = function (_$controller) {
	    Controller.$inject = ["$injector", "$scope", "$state", "$stateParams", "$auth", "$window", "$ToastService", "$UndoDeleteService"];
	    (0, _inherits3.default)(Controller, _$controller);
	
	    function Controller($injector, $scope, $state, $stateParams, $auth, $window, $ToastService, $UndoDeleteService) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, Controller);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Controller.__proto__ || (0, _getPrototypeOf2.default)(Controller)).call(this, $injector, dependencies));
	
	        _this.$scope = $scope;
	        _this.$state = $state;
	        _this.$auth = $auth;
	        _this.$window = $window;
	        _this.$scope.loading = true;
	        _this.$scope.query = { page: 1, search: "" };
	        _this.$scope.filter = {};
	        _this.$scope.deployments = [];
	        _this.$scope.pageCount = 0;
	        _this.$scope.canAddMore = true;
	        _this.$stateParams = $stateParams;
	        _this.toastService = $ToastService;
	        _this.undoDelete = $UndoDeleteService;
	        _this.$scope.logOrder = function () {
	            _this.$scope.query.ordering = _this.$scope.query.order.replace("_", "");
	            _this.query(true);
	        };
	
	        _this.logisticsType = {
	            "by_upreach": "By UpReach",
	            "by_client": "By Client"
	        };
	
	        _this.status = {
	            "draft": "Draft",
	            "booked": "Booked",
	            "delivery": "Delivery",
	            "active": "Active",
	            "done": "Done"
	        };
	
	        _this.searchByKeyPress = function (event) {
	            var keyName = event.key;
	            var letters = "abcdefghijklmnopqrstuvwxyz";
	            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
	                _this.$scope.$apply(function () {
	                    _this.$scope.filter.show = true;
	                    if (!_this.$scope.query.search) {
	                        _this.$scope.query.search = keyName;
	                    }
	                });
	                (0, _lodash.delay)(function () {
	                    document.getElementById("search-field").focus();
	                }, 100);
	            }
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(Controller, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.$scope.filter.show = false;
	            this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
	            this.checkIfFromDropbox();
	            document.addEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "$onDestroy",
	        value: function $onDestroy() {
	            document.removeEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "query",
	        value: function query(isNew) {
	            var _this2 = this;
	
	            this.$scope.query.page = isNew ? 1 : this.$scope.query.page;
	            this.$scope.loading = true;
	
	            var deployments = this.$Deployment.query(this.$scope.query);
	
	            _promise2.default.all([deployments.$promise]).then(function () {
	                var _$scope$deployments;
	
	                _this2.$scope.query.page = deployments._meta.page || 1;
	                _this2.$scope.loading = false;
	
	                isNew ? _this2.$scope.deployments = deployments : (_$scope$deployments = _this2.$scope.deployments).push.apply(_$scope$deployments, (0, _toConsumableArray3.default)(deployments));
	                _this2.$scope.pageCount = deployments._meta.page_count;
	                _this2.$scope.canAddMore = _this2.$scope.query.page !== _this2.$scope.pageCount;
	
	                _this2.$scope.$apply();
	            });
	        }
	    }, {
	        key: "addMoreItems",
	        value: function addMoreItems() {
	            this.$scope.query.page++;
	            this.query();
	        }
	    }, {
	        key: "checkIfFromDropbox",
	        value: function checkIfFromDropbox() {
	            if (this.$stateParams && this.$stateParams.code && localStorage.getItem("dropboxDeployment")) {
	                var d = localStorage.getItem("dropboxDeployment");
	                d = JSON.parse(d);
	                this.$state.go("deployments.update", { cid: this.$filter("getObjectId")(d.url), code: this.$stateParams.code });
	            } else {
	                localStorage.removeItem("dropboxDeployment");
	            }
	        }
	    }, {
	        key: "onQueryFilterChange",
	        value: function onQueryFilterChange() {
	            var _this3 = this;
	
	            this.$scope.query.page = 1;
	            var newValue = (0, _lodash.clone)(this.$scope.query.search);
	            this.$scope.loading = true;
	            this.searhDelayTimeout = setTimeout(function () {
	                var prewValue = (0, _lodash.clone)(_this3.$scope.query.search);
	                if (prewValue === newValue) {
	                    clearTimeout(_this3.searhDelayTimeout);
	                    _this3.query(true);
	                }
	            }, 500);
	        }
	    }, {
	        key: "addNew",
	        value: function addNew(event) {
	            var _this4 = this;
	
	            var sourceDeployment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: this.gettext("Create new deployment"),
	                controller: _deploymentCreate.DeploymentCreateController,
	                template: _deploymentCreate3.default,
	                targetEvent: event,
	                locals: {
	                    callback: function callback(deployment) {
	                        _this4.createDeployment(deployment);
	                    },
	                    userCompany: this.$companies.getCached(),
	                    sourceDeployment: sourceDeployment
	                }
	            });
	        }
	    }, {
	        key: "createDeployment",
	        value: function createDeployment(configuration) {
	            var _this5 = this;
	
	            var deployment = this.$Deployment.create(configuration);
	            deployment.$promise.then(function () {
	                return _this5.$scope.deployments.unshift(deployment);
	            }).then(function () {
	                _this5.$state.go("deployments.update", { cid: _this5.$filter("getObjectId")(deployment.url), isNew: true });
	            });
	        }
	    }, {
	        key: "showSecretID",
	        value: function showSecretID(ev, item) {
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Set/Share Deployment ID",
	                controller: _secretidController2.default,
	                template: _secretid2.default,
	                targetEvent: ev,
	                escapeToClose: false,
	                locals: {
	                    selectedItem: item,
	                    secretKind: this.gettextCatalog.getString("Deployment")
	                }
	            });
	        }
	    }, {
	        key: "editName",
	        value: function editName(ev, item) {
	            var _this6 = this;
	
	            if (["md-icon", "button"].indexOf(ev.target.tagName.toLowerCase()) < 0) return; // workaround for editDialog requirement - currentTarget = table cell.
	
	            ev.stopPropagation();
	
	            var editDialog = {
	                modelValue: item.name,
	                placeholder: this.gettextCatalog.getString("Enter new name"),
	                save: function save(input) {
	                    item.name = input.$modelValue;
	                    item.$update().then(function () {
	                        _this6.toastService.showSimple("Saved new deployment name \"" + item.name + "\".", 5000);
	                    }).catch(function () {
	                        _this6.toastService.showError("Could not save new deployment name \"" + item.name + "\".");
	                    });
	                },
	                targetEvent: ev,
	                title: this.gettextCatalog.getString("Enter new name"),
	                validators: {
	                    "md-maxlength": 50
	                }
	            };
	
	            this.$mdEditDialog.small(editDialog).then(function () {
	                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                    args[_key] = arguments[_key];
	                }
	
	                console.log("$mdEditDialog promise resolved with args: ", args);
	            });
	        }
	    }, {
	        key: "applyDeployment",
	        value: function applyDeployment(ev, item) {
	            var _this7 = this;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: this.gettext("Apply deployment on device"),
	                controller: _deploymentApply.DeploymentApplyController,
	                template: _deploymentApply3.default,
	                targetEvent: ev,
	                locals: {
	                    callback: function callback(deployment) {
	                        _this7.sendDeployment(deployment);
	                    },
	                    deployment: item,
	                    hasBooth: !!item.booth_id
	                }
	            });
	        }
	    }, {
	        key: "sendDeployment",
	        value: function sendDeployment(item) {
	            var _this8 = this;
	
	            var title = "";
	            var text = "";
	            var button = "";
	
	            if (item.move.status && !item.replace.status) {
	                title = "Move deployment?";
	                text = "This will remove \u201C" + item.move.target + "\u201D and its Configurations from " + item.move.from + " and install it on " + item.move.to + ".";
	                button = "MOVE";
	            } else if (item.replace.status && !item.move.status) {
	                title = "Replace deployment?";
	                text = "This will remove \u201C" + item.replace.from + "\u201D and its Configurations from " + item.replace.target + " and install \u201C" + item.replace.to + "\u201D instead.";
	                button = "REPLACE";
	            } else if (item.replace.status && item.move.status) {
	                title = "Move & replace Deployment?";
	                text = "This will remove \u201C" + item.replace.from + "\u201D and its Configurations from " + item.move.to + ", then remove \u201C" + item.target + "\u201D and its Configurations from " + item.move.from + " and install it on " + item.move.to + ".";
	                button = " MOVE & REPLACE";
	            } else {
	                title = "Apply deployment?";
	                text = "This will apply \u201C" + item.target + "\u201D and its Configurations on " + item.req.booth_id + ".";
	                button = "APPLY";
	            }
	            var confirm = this.$mdDialog.confirm().title(title).textContent(text).ariaLabel("Deployment").ok(button).cancel("CANCEL");
	
	            this.$mdDialog.show(confirm).then(function () {
	                _this8.$auth.$http({
	                    url: "/api/booth-set-deployment/",
	                    method: "PUT",
	                    data: item.req
	                }).then(function () {
	                    _this8.toastService.showSimple("Deployment installed!", 5000);
	                    _this8.$state.go("auth.signin");
	                }).catch(function (resp) {
	                    resp.data.detail ? _this8.toastService.showError("Can't install deployment." + resp.data.detail, 5000) : _this8.toastService.showError("Can't install deployment. Booth is not online or has current deployment!", 5000);
	                });
	            });
	        }
	    }, {
	        key: "openDeleteDialog",
	        value: function openDeleteDialog(ev, item) {
	            var _this9 = this;
	
	            this.$mdDialog.show({
	                title: "Deployment Delete",
	                controller: _deleteDialog.DeleteDialogController,
	                template: _deleteDialog3.default,
	                targetEvent: event,
	                locals: {
	                    callback: function callback() {
	                        _this9.deleteItem(ev, item);
	                    },
	                    target: "deployment",
	                    item: item
	                }
	            });
	        }
	    }, {
	        key: "deleteItem",
	        value: function deleteItem(ev, item) {
	            var _this10 = this;
	
	            item.$delete().then(function () {
	                _this10.toastService.deleteToast("`Deleted deployment \"" + item.name + "\".", function () {
	                    _this10.undoDelete.undoDelete("deployments", _this10.$filter("getObjectId")(item.url)).then(function () {
	                        _this10.toastService.showSimple("Deletion undone", 5000);
	                        _this10.query(true);
	                    }).catch(function () {
	                        _this10.toastService.showError("Could not undone deletion", 5000);
	                    });
	                });
	                _this10.query(true);
	            }).catch(function () {
	                _this10.toastService.showError("Could not delete deployment \"" + item.name + "\".", 30000);
	            });
	        }
	    }, {
	        key: "removeFilter",
	        value: function removeFilter() {
	            this.$scope.filter.show = false;
	            this.$scope.query.search = "";
	        }
	    }, {
	        key: "showFilter",
	        value: function showFilter() {
	            this.$scope.filter.show = true;
	            (0, _lodash.delay)(function () {
	                document.getElementById("search-field").focus();
	            }, 100);
	        }
	    }, {
	        key: "changeActiveConfig",
	        value: function changeActiveConfig(value, item) {
	            var _this11 = this;
	
	            value = value || [];
	            item.$update().then(function () {
	                _this11.query(true);
	            }).catch(function () {
	                _this11.toastService.showError("Could not update deployment \"" + item.name + "\".", 5000);
	            });
	        }
	    }, {
	        key: "changeCompany",
	        value: function changeCompany(value, item) {
	            var _this12 = this;
	
	            if (value && value.length) {
	                item.$update().then(function () {
	                    _this12.query(true);
	                }).catch(function () {
	                    _this12.toastService.showError("Could not update deployment \"" + item.name + "\".", 5000);
	                });
	            }
	        }
	    }, {
	        key: "onSearchBlur",
	        value: function onSearchBlur() {
	            if (!this.$scope.query.search) {
	                this.$scope.filter.show = false;
	            }
	        }
	    }, {
	        key: "isClient",
	        value: function isClient() {
	            return this.$auth.isRole("Client") || this.$auth.isRole("Sub-User");
	        }
	    }, {
	        key: "openInNewTab",
	        value: function openInNewTab(id) {
	            this.$window.open(this.$window.location.href + "setting/" + id, "_blank");
	        }
	    }, {
	        key: "removeDeployment",
	        value: function removeDeployment(item) {
	            var _this13 = this;
	
	            var confirm = this.$mdDialog.confirm().title("Remove Deployment?").textContent("This will remove \u201C" + item.name + "\u201D and all its Configurations from " + item.booth_id + ". It will remain in the \n            UpReach Cloud and can be downloaded again any time.").ariaLabel("Deployment").ok("REMOVE").cancel("CANCEL");
	
	            this.$mdDialog.show(confirm).then(function () {
	                _this13.$auth.$http({
	                    url: "/api/booth-remove-deployment/",
	                    method: "PUT",
	                    data: { deployment_url: item.url, booth_id: item.booth_id }
	                }).then(function () {
	                    _this13.query(true);
	                    _this13.toastService.showSimple("Deployment removed", 5000);
	                }).catch(function () {
	                    _this13.toastService.showError("Can't remove deployment!", 5000);
	                });
	            });
	        }
	    }]);
	    return Controller;
	}(_index.$controller);
	
	exports.default = Controller;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DeploymentCreateController = undefined;
	
	var _omit2 = __webpack_require__(350);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FIELDS_TO_REMOVE = ["url", "created", "name", "secret_id", "uris", "booth", "configurations"];
	
	var DeploymentCreateController = exports.DeploymentCreateController = ["$scope", "$mdDialog", "callback", "userCompany", "sourceDeployment", function DeploymentCreateController($scope, $mdDialog, callback, userCompany, sourceDeployment) {
	    "ngInject";
	
	    $scope.deployment = {};
	    $scope.callback = callback;
	    $scope.sourceDeployment = sourceDeployment;
	
	    // clone deployment if sourceDeployment provided
	    $scope.sourceDeployment && ($scope.deployment = angular.copy((0, _omit3.default)(sourceDeployment, FIELDS_TO_REMOVE)));
	    $scope.deployment.name = $scope.sourceDeployment ? $scope.sourceDeployment.name + " (copy)" : "";
	    $scope.deployment.company = $scope.sourceDeployment ? $scope.sourceDeployment.company : userCompany.url;
	    $scope.selectedCompany = userCompany ? [userCompany] : [];
	    $scope.deployment.configurations = [];
	
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	
	    $scope.create = function () {
	        callback($scope.deployment);
	        document.onkeypress = function () {};
	        $mdDialog.hide();
	    };
	
	    document.onkeypress = function (ev) {
	        if (ev.key === "Enter") {
	            if ($scope.deployment.company && $scope.deployment.name && $scope.deployment.name.length >= 7) {
	                $scope.create();
	            }
	        }
	    };
	}];

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(351),
	    baseClone = __webpack_require__(352),
	    baseUnset = __webpack_require__(459),
	    castPath = __webpack_require__(460),
	    copyObject = __webpack_require__(402),
	    customOmitClone = __webpack_require__(473),
	    flatRest = __webpack_require__(475),
	    getAllKeysIn = __webpack_require__(439);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(353),
	    arrayEach = __webpack_require__(397),
	    assignValue = __webpack_require__(398),
	    baseAssign = __webpack_require__(401),
	    baseAssignIn = __webpack_require__(423),
	    cloneBuffer = __webpack_require__(427),
	    copyArray = __webpack_require__(428),
	    copySymbols = __webpack_require__(429),
	    copySymbolsIn = __webpack_require__(433),
	    getAllKeys = __webpack_require__(437),
	    getAllKeysIn = __webpack_require__(439),
	    getTag = __webpack_require__(440),
	    initCloneArray = __webpack_require__(445),
	    initCloneByTag = __webpack_require__(446),
	    initCloneObject = __webpack_require__(453),
	    isArray = __webpack_require__(409),
	    isBuffer = __webpack_require__(410),
	    isMap = __webpack_require__(455),
	    isObject = __webpack_require__(377),
	    isSet = __webpack_require__(457),
	    keys = __webpack_require__(403);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(354),
	    stackClear = __webpack_require__(362),
	    stackDelete = __webpack_require__(363),
	    stackGet = __webpack_require__(364),
	    stackHas = __webpack_require__(365),
	    stackSet = __webpack_require__(366);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(355),
	    listCacheDelete = __webpack_require__(356),
	    listCacheGet = __webpack_require__(359),
	    listCacheHas = __webpack_require__(360),
	    listCacheSet = __webpack_require__(361);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 355 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(357);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(358);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(357);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(357);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(357);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(354);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(354),
	    Map = __webpack_require__(367),
	    MapCache = __webpack_require__(382);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(368),
	    root = __webpack_require__(373);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(369),
	    getValue = __webpack_require__(381);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(370),
	    isMasked = __webpack_require__(378),
	    isObject = __webpack_require__(377),
	    toSource = __webpack_require__(380);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(371),
	    isObject = __webpack_require__(377);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(372),
	    getRawTag = __webpack_require__(375),
	    objectToString = __webpack_require__(376);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(373);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(374);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 374 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(372);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 377 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(379);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(373);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(383),
	    mapCacheDelete = __webpack_require__(391),
	    mapCacheGet = __webpack_require__(394),
	    mapCacheHas = __webpack_require__(395),
	    mapCacheSet = __webpack_require__(396);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(384),
	    ListCache = __webpack_require__(354),
	    Map = __webpack_require__(367);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(385),
	    hashDelete = __webpack_require__(387),
	    hashGet = __webpack_require__(388),
	    hashHas = __webpack_require__(389),
	    hashSet = __webpack_require__(390);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(386);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(368);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(386);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(386);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(386);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(392);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(393);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(392);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(392);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(392);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(399),
	    eq = __webpack_require__(358);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(400);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(368);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(402),
	    keys = __webpack_require__(403);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(398),
	    baseAssignValue = __webpack_require__(399);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(404),
	    baseKeys = __webpack_require__(418),
	    isArrayLike = __webpack_require__(422);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(405),
	    isArguments = __webpack_require__(406),
	    isArray = __webpack_require__(409),
	    isBuffer = __webpack_require__(410),
	    isIndex = __webpack_require__(412),
	    isTypedArray = __webpack_require__(413);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 405 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(407),
	    isObjectLike = __webpack_require__(408);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(371),
	    isObjectLike = __webpack_require__(408);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 409 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(373),
	    stubFalse = __webpack_require__(411);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 412 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(414),
	    baseUnary = __webpack_require__(416),
	    nodeUtil = __webpack_require__(417);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(371),
	    isLength = __webpack_require__(415),
	    isObjectLike = __webpack_require__(408);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 416 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(374);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(419),
	    nativeKeys = __webpack_require__(420);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(421);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(370),
	    isLength = __webpack_require__(415);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(402),
	    keysIn = __webpack_require__(424);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(404),
	    baseKeysIn = __webpack_require__(425),
	    isArrayLike = __webpack_require__(422);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(377),
	    isPrototype = __webpack_require__(419),
	    nativeKeysIn = __webpack_require__(426);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 426 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(373);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(402),
	    getSymbols = __webpack_require__(430);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(431),
	    stubArray = __webpack_require__(432);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 431 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 432 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(402),
	    getSymbolsIn = __webpack_require__(434);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(435),
	    getPrototype = __webpack_require__(436),
	    getSymbols = __webpack_require__(430),
	    stubArray = __webpack_require__(432);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(421);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(438),
	    getSymbols = __webpack_require__(430),
	    keys = __webpack_require__(403);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(435),
	    isArray = __webpack_require__(409);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(438),
	    getSymbolsIn = __webpack_require__(434),
	    keysIn = __webpack_require__(424);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(441),
	    Map = __webpack_require__(367),
	    Promise = __webpack_require__(442),
	    Set = __webpack_require__(443),
	    WeakMap = __webpack_require__(444),
	    baseGetTag = __webpack_require__(371),
	    toSource = __webpack_require__(380);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(368),
	    root = __webpack_require__(373);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(368),
	    root = __webpack_require__(373);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(368),
	    root = __webpack_require__(373);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(368),
	    root = __webpack_require__(373);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 445 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(447),
	    cloneDataView = __webpack_require__(449),
	    cloneRegExp = __webpack_require__(450),
	    cloneSymbol = __webpack_require__(451),
	    cloneTypedArray = __webpack_require__(452);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(448);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(373);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(447);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(372);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(447);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(454),
	    getPrototype = __webpack_require__(436),
	    isPrototype = __webpack_require__(419);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(377);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(456),
	    baseUnary = __webpack_require__(416),
	    nodeUtil = __webpack_require__(417);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(440),
	    isObjectLike = __webpack_require__(408);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(458),
	    baseUnary = __webpack_require__(416),
	    nodeUtil = __webpack_require__(417);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(440),
	    isObjectLike = __webpack_require__(408);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(460),
	    last = __webpack_require__(468),
	    parent = __webpack_require__(469),
	    toKey = __webpack_require__(471);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(409),
	    isKey = __webpack_require__(461),
	    stringToPath = __webpack_require__(463),
	    toString = __webpack_require__(466);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(409),
	    isSymbol = __webpack_require__(462);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(371),
	    isObjectLike = __webpack_require__(408);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(464);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(465);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(382);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(467);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(372),
	    arrayMap = __webpack_require__(351),
	    isArray = __webpack_require__(409),
	    isSymbol = __webpack_require__(462);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(470),
	    baseSlice = __webpack_require__(472);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(460),
	    toKey = __webpack_require__(471);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(462);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 472 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(474);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(371),
	    getPrototype = __webpack_require__(436),
	    isObjectLike = __webpack_require__(408);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(476),
	    overRest = __webpack_require__(479),
	    setToString = __webpack_require__(481);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(477);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(435),
	    isFlattenable = __webpack_require__(478);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(372),
	    isArguments = __webpack_require__(406),
	    isArray = __webpack_require__(409);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(480);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(482),
	    shortOut = __webpack_require__(485);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(483),
	    defineProperty = __webpack_require__(400),
	    identity = __webpack_require__(484);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 484 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 485 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Create new deployment\">\n    <md-dialog-content style=\"overflow: hidden; width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\" ng-if=\"!sourceDeployment\">{{'Create new deployment' | translate}}</h2>\n            <h2 class=\"md-title\" ng-if=\"sourceDeployment\">{{'Copy deployment' | translate}}</h2>\n            <form name=\"deploymentCreateForm\">\n                <md-input-container md-no-float class=\"md-inline-form\" style=\"width: 100%;\">\n                    <label for=\"deploymentName\">{{'Deployment name' | translate}}</label>\n                    <input\n                            flex=\"grow\"\n                            ng-model=\"deployment.name\"\n                            id=\"deploymentName\"\n                            flex-order=\"0\"\n                            md-autofocus\n                            required/>\n                </md-input-container>\n\n                <api-select-search\n                        model=\"deployment.company\"\n                        multiple=\"false\"\n                        collection=\"company\"\n                        selected-values=\"selectedCompany\"\n                        label=\"'Select company'\"\n                        width=\"100%\"\n                        search-label=\"'Search company'\"></api-select-search>\n            </form>\n        </div>\n\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n            ng-click=\"create()\"\n            class=\"md-primary\"\n            ng-disabled=\"!deployment.name || !deployment.company\">{{'Create' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>";

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DeploymentApplyController = undefined;
	
	var _lodash = __webpack_require__(101);
	
	var DeploymentApplyController = exports.DeploymentApplyController = ["$scope", "$mdDialog", "$BoothList", "callback", "deployment", "hasBooth", function DeploymentApplyController($scope, $mdDialog, $BoothList, callback, deployment, hasBooth) {
	    "ngInject";
	
	    $scope.deployment = deployment;
	    $scope.hasBooth = hasBooth;
	    $scope.boothId = deployment.booth_id;
	    $scope.boothDeployment = "";
	    $scope.copiedBooth = (0, _lodash.cloneDeep)(deployment.booth_id);
	    $scope.boothsArray = [];
	
	    $scope.apply = function () {
	        callback({ req: { deployment_url: deployment.url, booth_id: $scope.boothId },
	            replace: { status: !!$scope.boothDeployment && $scope.boothId !== $scope.copiedBooth, from: $scope.boothDeployment, to: $scope.deployment.name, target: $scope.boothId },
	            move: { status: $scope.hasBooth && $scope.boothId !== $scope.copiedBooth, from: $scope.copiedBooth, to: $scope.boothId, target: deployment.name },
	            target: deployment.name
	
	        });
	        $mdDialog.hide();
	    };
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	    $scope.loadBooths = function () {
	        var booths = $BoothList.query();
	        booths.$promise.then(function (data) {
	            $scope.boothsArray = data;
	        }).catch(function (e) {
	            console.log(e);
	        });
	
	        return booths;
	    };
	    $scope.updateValue = function (v) {
	        $scope.boothId = v;
	        var installedBooth = (0, _lodash.find)($scope.boothsArray, { booth_id: $scope.boothId });
	        if (installedBooth.deployment) {
	            $scope.boothDeployment = installedBooth.deployment.name;
	        }
	    };
	
	    $scope.loadBooths();
	}];

/***/ }),
/* 488 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Apply deployment\">\n    <md-dialog-content style=\"overflow: hidden; width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\">{{'Install deployment on device' | translate}}</h2>\n            <form name=\"deploymentApply\">\n<!--                <md-input-container md-no-float class=\"md-inline-form\" style=\"width: 100%;\">-->\n<!--                    <label for=\"deploymentName\">{{'Device id' | translate}}</label>-->\n<!--                    <input-->\n<!--                            ng-if=\"hasBooth\"-->\n<!--                            flex=\"grow\"-->\n<!--                            ng-model=\"boothId\"-->\n<!--                            id=\"deploymentName\"-->\n<!--                            flex-order=\"0\"-->\n<!--                            md-autofocus-->\n<!--                            readonly/>-->\n<!--                </md-input-container>-->\n\n                <select-search\n                        model=\"boothId\"\n                        item-label=\"booth_id\"\n                        item-value=\"booth_id\"\n                        collection=\"boothsArray\"\n                        on-value-change=\"updateValue(value)\">\n                </select-search>\n\n            </form>\n        </div>\n\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"apply()\"\n                class=\"md-primary\"\n                ng-disabled=\"deploymentApply.$invalid|| !boothId\">{{'Install' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>";

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(490);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./deployment-list.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./deployment-list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "deployment-list md-card{width:98%}deployment-list .truncated{max-width:150px}deployment-list table.md-table:not(.md-row-select) td.md-cell:nth-child(n+2):nth-last-child(n+2),deployment-list table.md-table:not(.md-row-select) th.md-column:nth-child(n+2):nth-last-child(n+2){padding:0 16px 0 0}deployment-list md-select.md-table-select>.md-select-value>span>.md-text{display:inline-block!important}", ""]);
	
	// exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _deploymentUpdate = __webpack_require__(492);
	
	var _deploymentUpdate2 = _interopRequireDefault(_deploymentUpdate);
	
	var _deploymentUpdate3 = __webpack_require__(493);
	
	var _deploymentUpdate4 = _interopRequireDefault(_deploymentUpdate3);
	
	__webpack_require__(495);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeploymentUpdateComponent = {
	    template: _deploymentUpdate2.default,
	    controller: _deploymentUpdate4.default,
	    controllerAs: "DeploymentUpdate"
	};
	
	exports.default = DeploymentUpdateComponent;

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\">\n  <div flex=\"70\" flex-offset=\"15\" flex-xs=\"100\" flex-offset-xs=\"0\">\n\n\n    <h2 class=\"page-title\" ng-if=\"DeploymentUpdate.isNew\" ng-bind=\"'Create a new deployment' | translate\"></h2>\n    <h2 class=\"page-title\" ng-if=\"!DeploymentUpdate.isNew\" ng-bind=\"'Update deployment' | translate\"></h2>\n\n    <div class=\"deployment-copy\">\n      <api-select-search\n              model=\"DeploymentUpdate.copiedDeployment\"\n              multiple=\"false\"\n              collection=\"deployment\"\n              selected-values=\"\"\n              on-value-change=\"DeploymentUpdate.copyDeployment()\"\n              label=\"'Copy an existing deployment'\"\n              search-label=\"'Search deployment'\"\n              full-value=\"\">\n      </api-select-search>\n    </div>\n\n    <form name=\"deploymentForm\">\n      <div style=\"margin: 0 auto\">\n\n        <h3 style=\"text-align: center\">{{'Deployment details' | translate}}</h3>\n\n        <div layout=\"column\">\n          <div flex=\"100\">\n            <md-input-container class=\"md-block md-short-input\">\n              <label\n                  ng-bind=\"'Deployment Name' | translate\"\n                  for=\"deploymentName\"></label>\n\n              <input\n                ng-model=\"DeploymentUpdate.deployment.name\"\n                type=\"text\"\n                name=\"deploymentName\"\n                id=\"deploymentName\"\n                maxlength=\"100\"\n                required>\n\n              <div ng-messages=\"deploymentForm.deploymentName.$error\" role=\"alert\">\n                <div ng-message=\"required\" ng-bind=\"'Please provide deployment name' | translate\"></div>\n              </div>\n            </md-input-container>\n          </div>\n        </div>\n\n        <div layout=\"column\" permission-hide=\"Client,Sub-User\">\n          <div flex=\"100\">\n            <p>{{'Deployment Status:' | translate}}</p>\n            <md-radio-group\n                ng-model=\"DeploymentUpdate.deployment.status\">\n              <md-radio-button value=\"draft\" class=\"md-primary\">{{'Draft' | translate}}</md-radio-button>\n              <md-radio-button value=\"booked\" class=\"md-primary\">{{'Booked' | translate}}</md-radio-button>\n              <md-radio-button value=\"delivery\" class=\"md-primary\">{{'Delivery' | translate}}</md-radio-button>\n              <md-radio-button value=\"active\" class=\"md-primary\">{{'Active' | translate}}</md-radio-button>\n              <md-radio-button value=\"done\" class=\"md-primary\">{{'Done' | translate}}</md-radio-button>\n            </md-radio-group>\n          </div>\n        </div>\n\n        <div layout=\"column\" permission-hide=\"Client,Sub-User\">\n          <div flex=\"100\">\n            <p>{{'Logistics handled by:' | translate}}</p>\n            <md-radio-group ng-model=\"DeploymentUpdate.deployment.logistics_type\">\n              <md-radio-button value=\"by_client\" class=\"md-primary\">{{'Client' | translate}}</md-radio-button>\n              <md-radio-button value=\"by_upreach\" class=\"md-primary\">{{'UpReach' | translate}}</md-radio-button>\n            </md-radio-group>\n          </div>\n        </div>\n\n        <div layout=\"column\" permission-hide=\"Admin,Manager\">\n          <div flex=\"100\">\n            <md-input-container class=\"md-block md-short-input\">\n              <input\n                      mdc-datetime-picker=\"\"\n                      date=\"true\"\n                      time=\"true\"\n                      type=\"text\"\n                      placeholder=\"{{'Deployment Starting Date & Time' | translate}}\"\n                      show-todays-date=\"\"\n                      minutes=\"true\"\n                      max-date=\"DeploymentUpdate.deployment.deployment_end\"\n                      auto-ok=\"true\"\n                      show-icon=\"true\"\n                      ng-model=\"DeploymentUpdate.deployment.deployment_start\"\n                      class=\"dtp-no-msclear dtp-input md-input\">\n            </md-input-container>\n\n            <md-input-container class=\"md-block md-short-input\">\n              <input\n                      mdc-datetime-picker=\"\"\n                      date=\"true\"\n                      time=\"true\"\n                      type=\"text\"\n                      placeholder=\"{{'Deployment Ending Date & Time' | translate}}\"\n                      show-todays-date=\"\"\n                      minutes=\"true\"\n                      min-date=\"DeploymentUpdate.deployment.deployment_start\"\n                      auto-ok=\"true\"\n                      show-icon=\"true\"\n                      ng-model=\"DeploymentUpdate.deployment.deployment_end\"\n                      class=\"dtp-no-msclear dtp-input md-input\">\n            </md-input-container>\n          </div>\n        </div>\n\n        <md-input-container class=\"md-block\">\n          <label\n                  ng-bind=\"'Photos retention time (days)' | translate\"\n                  for=\"deletion-files\"></label>\n          <input\n                  type=\"number\"\n                  min=\"1\"\n                  step=\"1\"\n                  max=\"365\"\n                  required\n                  name=\"deletionFiles\"\n                  id=\"deletion-files\"\n                  ng-model=\"DeploymentUpdate.deployment.delete_old_files\">\n\n          <div ng-messages=\"deploymentForm.deletionFiles.$error\" role=\"alert\">\n            <div ng-message=\"required\" ng-bind=\"'Please provide valid number of days' | translate\"></div>\n            <div ng-message=\"min\" ng-bind=\"'Select between 1 and 365 days' | translate\"></div>\n            <div ng-message=\"max\" ng-bind=\"'Select between 1 and 365 days' | translate\"></div>\n          </div>\n        </md-input-container>\n\n        <md-switch\n                md-invert\n                ng-model=\"DeploymentUpdate.deployment.local_data_saving\">\n          {{'Local data saving (in addition to cloud saving)' | translate}}\n        </md-switch>\n        <md-switch\n                md-invert\n                ng-model=\"DeploymentUpdate.deployment.only_local_data_saving\">\n          {{'Only local data saving / no cloud synchronization' | translate}}\n        </md-switch>\n\n        <md-input-container class=\"md-block\">\n          <label\n                  ng-bind=\"'Local data path' | translate\"\n                  for=\"local-data-path\"></label>\n          <input\n                  type=\"text\"\n                  name=\"localDataPath\"\n                  id=\"local-data-path\"\n                  ng-model=\"DeploymentUpdate.deployment.local_data_path\">\n        </md-input-container>\n\n        <!-- Dropbox connection -->\n        <div layout=\"column\">\n          <div flex=\"100\">\n            <h3 style=\"text-align: center\">{{'Dropbox connection' | translate}}</h3>\n            <span class=\"status-dropbox\">Status:</span>\n            <md-button ng-if=\"!DeploymentUpdate.deployment.dropbox_settings.token\" class=\"md-primary\" ng-click=\"DeploymentUpdate.connectToDropbox()\">Connect</md-button>\n            <md-button ng-if=\"DeploymentUpdate.deployment.dropbox_settings.token\" class=\"md-warn\" style=\"color: green\">Connected</md-button>\n            <md-button ng-if=\"DeploymentUpdate.deployment.dropbox_settings.token\" class=\"md-primary\" ng-click=\"DeploymentUpdate.disconnectFromDropbox()\">Disconnect</md-button>\n\n            <div class=\"dropbox-options\" ng-if=\"DeploymentUpdate.deployment.dropbox_settings.token\">\n              <h4>Select capture modes</h4>\n              <md-switch\n                      md-invert\n                      ng-model=\"DeploymentUpdate.deployment.dropbox_settings.captureModes.photo\">\n                {{'Single photo' | translate}}\n              </md-switch>\n              <md-switch\n                      md-invert\n                      ng-model=\"DeploymentUpdate.deployment.dropbox_settings.captureModes.gif\">\n                {{'Gif' | translate}}\n              </md-switch>\n              <md-switch\n                      md-invert\n                      ng-model=\"DeploymentUpdate.deployment.dropbox_settings.captureModes.boomerang\">\n                {{'Boomerang' | translate}}\n              </md-switch>\n\n              <h4>Select output types</h4>\n              <md-switch\n                      md-invert\n                      ng-model=\"DeploymentUpdate.deployment.dropbox_settings.outputTypes.printing\">\n                {{'Printing layouts' | translate}}\n              </md-switch>\n              <md-switch\n                      md-invert\n                      ng-model=\"DeploymentUpdate.deployment.dropbox_settings.outputTypes.sharing\">\n                {{'Sharing layouts' | translate}}\n              </md-switch>\n              <md-switch\n                      md-invert\n                      ng-model=\"DeploymentUpdate.deployment.dropbox_settings.outputTypes.original\">\n                {{'Original photos' | translate}}\n              </md-switch>\n\n              <h4>Conditions for sync</h4>\n                <span style=\"font-size: 11px\">Please note, by default all taken photos are synced with DropBox</span>\n              <md-switch\n                      md-invert\n                      ng-model=\"DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned\"\n                      ng-click=\"DeploymentUpdate.setCheckboxConditionValue(DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned)\">\n                {{'Only if a data form was signed ' | translate}}\n              </md-switch>\n              <md-switch\n                      md-invert\n                      class=\"checkbox-sync-item\"\n                      ng-model=\"DeploymentUpdate.checkboxConditions[0].checked\"\n                      ng-value=\"DeploymentUpdate.checkboxConditions[0].position\"\n                      ng-disabled=\"!DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned\"\n                      ng-class=\"{'disabled':!DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned}\">\n                {{'Sync if Checkbox 1 was selected by user ' | translate}}\n              </md-switch>\n              <span style=\"font-size: 11px;margin-left: 16px;font-weight: bolder\">OR</span>\n              <md-switch\n                      md-invert\n                      class=\"checkbox-sync-item\"\n                      ng-model=\"DeploymentUpdate.checkboxConditions[1].checked\"\n                      ng-value=\"DeploymentUpdate.checkboxConditions[1].position\"\n                      ng-disabled=\"!DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned\"\n                      ng-class=\"{'disabled':!DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned}\">\n                {{'Sync if Checkbox 2 was selected by user ' | translate}}\n              </md-switch>\n              <span style=\"font-size: 11px;margin-left: 16px;font-weight: bolder\">OR</span>\n              <md-switch\n                      md-invert\n                      class=\"checkbox-sync-item\"\n                      ng-model=\"DeploymentUpdate.checkboxConditions[2].checked\"\n                      ng-value=\"DeploymentUpdate.checkboxConditions[2].position\"\n                      ng-disabled=\"!DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned\"\n                      ng-class=\"{'disabled':!DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned}\">\n                {{'Sync if Checkbox 3 was selected by user ' | translate}}\n              </md-switch>\n              <span style=\"font-size: 11px;margin-left: 16px;font-weight: bolder\">OR</span>\n              <md-switch\n                      md-invert\n                      class=\"checkbox-sync-item\"\n                      ng-model=\"DeploymentUpdate.checkboxConditions[3].checked\"\n                      ng-value=\"DeploymentUpdate.checkboxConditions[3].position\"\n                      ng-disabled=\"!DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned\"\n                      ng-class=\"{'disabled':!DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned}\">\n                {{'Sync if Checkbox 4 was selected by user ' | translate}}\n              </md-switch>\n              <span style=\"font-size: 11px;margin-left: 16px;font-weight: bolder\">OR</span>\n              <md-switch\n                      md-invert\n                      class=\"checkbox-sync-item last-item\"\n                      ng-model=\"DeploymentUpdate.checkboxConditions[4].checked\"\n                      ng-value=\"DeploymentUpdate.checkboxConditions[4].position\"\n                      ng-disabled=\"!DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned\"\n                      ng-class=\"{'disabled':!DeploymentUpdate.deployment.dropbox_settings.conditions.dataFormWasSigned}\">\n                {{'Sync if Checkbox 5 was selected by user ' | translate}}\n              </md-switch>\n            </div>\n\n            <md-input-container class=\"md-block\" ng-if=\"DeploymentUpdate.deployment.dropbox_settings.token\">\n              <label\n                      ng-bind=\"'Folder' | translate\"\n                      for=\"folder\"></label>\n              <input\n                      type=\"text\"\n                      minlength=\"3\"\n                      maxlength=\"64\"\n                      ng-required=\"DeploymentUpdate.deployment.dropbox_settings.token\"\n                      ng-pattern=\"/^\\//i\"\n                      name=\"folder\"\n                      id=\"folder\"\n                      ng-model=\"DeploymentUpdate.deployment.dropbox_settings.folder\">\n\n              <div ng-messages=\"deploymentForm.folder.$error\" role=\"alert\">\n                <div ng-message=\"required\" ng-bind=\"'Please provide valid folder name' | translate\"></div>\n                <div ng-message=\"minlength\" ng-bind=\"'Folder should be at least 2 characters length' | translate\"></div>\n                <div ng-message=\"pattern\" ng-bind=\"'Folder path should start with / character' | translate\"></div>\n              </div>\n            </md-input-container>\n          </div>\n        </div>\n\n        <!-- Deployment location -->\n        <div layout=\"column\" permission-hide=\"Client,Sub-User\">\n          <div flex=\"100\">\n            <h3 style=\"text-align: center\">{{'Deployment location details' | translate}}</h3>\n            <address-form\n                model=\"DeploymentUpdate.deployment.location_address\"\n                location=\"true\">\n            </address-form>\n\n            <md-input-container class=\"md-block md-short-input\">\n              <input\n                  mdc-datetime-picker=\"\"\n                  date=\"true\"\n                  time=\"true\"\n                  type=\"text\"\n                  placeholder=\"{{'Deployment Starting Date & Time' | translate}}\"\n                  show-todays-date=\"\"\n                  minutes=\"true\"\n                  max-date=\"DeploymentUpdate.deployment.deployment_end\"\n                  auto-ok=\"true\"\n                  show-icon=\"true\"\n                  ng-model=\"DeploymentUpdate.deployment.deployment_start\"\n                  class=\"dtp-no-msclear dtp-input md-input\">\n            </md-input-container>\n\n            <md-input-container class=\"md-block md-short-input\">\n              <input\n                  mdc-datetime-picker=\"\"\n                  date=\"true\"\n                  time=\"true\"\n                  type=\"text\"\n                  placeholder=\"{{'Deployment Ending Date & Time' | translate}}\"\n                  show-todays-date=\"\"\n                  minutes=\"true\"\n                  min-date=\"DeploymentUpdate.deployment.deployment_start\"\n                  auto-ok=\"true\"\n                  show-icon=\"true\"\n                  ng-model=\"DeploymentUpdate.deployment.deployment_end\"\n                  class=\"dtp-no-msclear dtp-input md-input\">\n            </md-input-container>\n\n          </div>\n        </div>\n\n        <!-- Delivery -->\n        <div layout=\"column\" ng-show=\"DeploymentUpdate.deployment.logistics_type === 'by_upreach'\" permission-hide=\"Client,Sub-User\">\n          <div flex=\"100\">\n            <h3 style=\"text-align: center\">{{'Delivery' | translate}}</h3>\n            <address-form model=\"DeploymentUpdate.deployment.delivery_address\" ng-if=\"DeploymentUpdate.deployment.logistics_type === 'by_upreach'\"></address-form>\n\n            <md-input-container class=\"md-block md-short-input\">\n              <input\n                  mdc-datetime-picker=\"\"\n                  date=\"true\"\n                  time=\"true\"\n                  type=\"text\"\n                  placeholder=\"{{'Delivery Starting Date & Time' | translate}}\"\n                  show-todays-date=\"\"\n                  minutes=\"true\"\n                  max-date=\"DeploymentUpdate.deployment.delivery_end\"\n                  auto-ok=\"true\"\n                  show-icon=\"true\"\n                  ng-model=\"DeploymentUpdate.deployment.delivery_start\"\n                  class=\"dtp-no-msclear dtp-input md-input\">\n            </md-input-container>\n\n            <md-input-container class=\"md-block md-short-input\">\n              <input\n                  mdc-datetime-picker=\"\"\n                  date=\"true\"\n                  time=\"true\"\n                  type=\"text\"\n                  placeholder=\"{{'Delivery Ending Date & Time' | translate}}\"\n                  show-todays-date=\"\"\n                  minutes=\"true\"\n                  min-date=\"DeploymentUpdate.deployment.delivery_start\"\n                  auto-ok=\"true\"\n                  show-icon=\"true\"\n                  ng-model=\"DeploymentUpdate.deployment.delivery_end\"\n                  class=\"dtp-no-msclear dtp-input md-input\">\n            </md-input-container>\n\n          </div>\n        </div>\n\n        <!-- Collection -->\n        <div layout=\"column\" ng-show=\"DeploymentUpdate.deployment.logistics_type === 'by_upreach'\" permission-hide=\"Client,Sub-User\">\n          <div flex=\"100\">\n            <h3 style=\"text-align: center\">{{'Collection' | translate}}</h3>\n            <address-form model=\"DeploymentUpdate.deployment.collection_address\" ng-if=\"DeploymentUpdate.deployment.logistics_type === 'by_upreach'\"></address-form>\n\n            <md-input-container class=\"md-block md-short-input\">\n              <input\n                  mdc-datetime-picker=\"\"\n                  date=\"true\"\n                  time=\"true\"\n                  type=\"text\"\n                  placeholder=\"{{'Collection Starting Date & Time' | translate}}\"\n                  show-todays-date=\"\"\n                  minutes=\"true\"\n                  max-date=\"DeploymentUpdate.deployment.collection_end\"\n                  auto-ok=\"true\"\n                  show-icon=\"true\"\n                  ng-model=\"DeploymentUpdate.deployment.collection_start\"\n                  class=\"dtp-no-msclear dtp-input md-input\">\n            </md-input-container>\n\n            <md-input-container class=\"md-block md-short-input\">\n              <input\n                  mdc-datetime-picker=\"\"\n                  date=\"true\"\n                  time=\"true\"\n                  type=\"text\"\n                  placeholder=\"{{'Collection Ending Date & Time' | translate}}\"\n                  show-todays-date=\"\"\n                  minutes=\"true\"\n                  min-date=\"DeploymentUpdate.deployment.collection_start\"\n                  auto-ok=\"true\"\n                  show-icon=\"true\"\n                  ng-model=\"DeploymentUpdate.deployment.collection_end\"\n                  class=\"dtp-no-msclear dtp-input md-input\">\n            </md-input-container>\n\n          </div>\n        </div>\n\n        <!--Shipping info-->\n        <div layout=\"column\" ng-show=\"DeploymentUpdate.company === 'single'\" permission-hide=\"Client,Sub-User\">\n          <div flex=\"100\">\n            <h3 style=\"text-align: center\">{{'Shipping info' | translate}}</h3>\n\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Company Name' | translate\"\n                        for=\"ShcompanyName\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        name=\"ShcompanyName\"\n                        id=\"ShcompanyName\"\n                        ng-model=\"client.shipping_info.companyName\">\n\n                <div ng-messages=\"shippingForm.ShcompanyName.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide company name' | translate\"></div>\n                  <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                </div>\n              </md-input-container>\n            </div>\n\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Contact Person' | translate\"\n                        for=\"ShcontactPerson\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        name=\"ShcontactPerson\"\n                        id=\"ShcontactPerson\"\n                        ng-model=\"DeploymentUpdate.deployment.shipping_info.contactPerson\">\n\n                <div ng-messages=\"deploymentForm.ShcontactPerson.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide valid person name' | translate\"></div>\n                  <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                </div>\n              </md-input-container>\n\n\n            </div>\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Contact Person\\'s phone number' | translate\"\n                        for=\"ShcontactPersonNumber\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        ng-pattern=\"'^[0-9+ ]+$'\"\n                        name=\"ShcontactPersonNumber\"\n                        id=\"ShcontactPersonNumber\"\n                        ng-model=\"DeploymentUpdate.deployment.shipping_info.contactPersonPhoneNumber\">\n\n                <div ng-messages=\"deploymentForm.ShcontactPersonNumber.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide valid phone number' | translate\"></div>\n                  <div ng-message=\"pattern\" ng-bind=\"'Number should contain only \\'0-9\\' or \\'+\\' characters' | translate\"></div>\n                  <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                </div>\n              </md-input-container>\n            </div>\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Street' | translate\"\n                        for=\"street\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        name=\"street\"\n                        id=\"street\"\n                        ng-model=\"DeploymentUpdate.deployment.shipping_info.street\">\n\n                <div ng-messages=\"deploymentForm.street.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide valid street' | translate\"></div>\n                  <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                </div>\n              </md-input-container>\n            </div>\n            <div class=\"setting-row address\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'House number' | translate\"\n                        for=\"houseNumber\"></label>\n                <input\n                        type=\"number\"\n                        min=\"0\"\n                        max=\"99999\"\n                        name=\"houseNumber\"\n                        id=\"houseNumber\"\n                        ng-model=\"DeploymentUpdate.deployment.shipping_info.houseNumber\">\n\n                <div ng-messages=\"deploymentForm.houseNumber.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                </div>\n              </md-input-container>\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Zip Code' | translate\"\n                        for=\"zip\"></label>\n                <input\n                        type=\"number\"\n                        min=\"0\"\n                        name=\"zip\"\n                        id=\"zip\"\n                        ng-model=\"DeploymentUpdate.deployment.shipping_info.zip\">\n\n                <div ng-messages=\"deploymentForm.houseNumber.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                </div>\n              </md-input-container>\n            </div>\n            <div class=\"setting-row location\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'City' | translate\"\n                        for=\"city\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        name=\"city\"\n                        id=\"city\"\n                        ng-model=\"DeploymentUpdate.deployment.shipping_info.city\">\n\n                <div ng-messages=\"deploymentForm.houseNumber.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                </div>\n              </md-input-container>\n              <select-search\n                      model=\"DeploymentUpdate.deployment.shipping_info.country\"\n                      item-label=\"name\"\n                      item-value=\"code\"\n                      label=\"'Country' | translate\"\n                      collection=\"DeploymentUpdate.countries\">\n              </select-search>\n            </div>\n          </div>\n        </div>\n\n        <!--Billing info-->\n        <div layout=\"column\" ng-show=\"DeploymentUpdate.company === 'single'\" permission-hide=\"Client,Sub-User\">\n          <div flex=\"100\">\n            <h3 style=\"text-align: center\">{{'Billing info' | translate}}</h3>\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Company Name' | translate\"\n                        for=\"BlcompanyName\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        name=\"BlcompanyName\"\n                        id=\"BlcompanyName\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.companyName\">\n\n                <div ng-messages=\"billingForm.BlcompanyName.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide valid company name' | translate\"></div>\n                  <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                </div>\n              </md-input-container>\n            </div>\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Contact Person' | translate\"\n                        for=\"BlcontactPerson\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        name=\"BlcontactPerson\"\n                        id=\"BlcontactPerson\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.contactPerson\">\n\n                <div ng-messages=\"billingForm.BlcontactPerson.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide valid person name' | translate\"></div>\n                  <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                </div>\n              </md-input-container>\n            </div>\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Contact Person\\'s phone number' | translate\"\n                        for=\"BlcontactPersonNumber\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        ng-pattern=\"'^[0-9+ ]+$'\"\n                        name=\"BlcontactPersonNumber\"\n                        id=\"BlcontactPersonNumber\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.contactPersonPhoneNumber\">\n\n                <div ng-messages=\"billingForm.BlcontactPersonNumber.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide valid phone number' | translate\"></div>\n                  <div ng-message=\"pattern\" ng-bind=\"'Number should contain only \\'0-9\\' or \\'+\\' characters' | translate\"></div>\n                  <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                </div>\n              </md-input-container>\n            </div>\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Additional information' | translate\"\n                        for=\"additionalInfo\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"360\"\n                        name=\"additionalInfo\"\n                        id=\"additionalInfo\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.additionalInfo\">\n              </md-input-container>\n            </div>\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Street' | translate\"\n                        for=\"BlStreet\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        name=\"BlStreet\"\n                        id=\"BlStreet\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.street\">\n\n                <div ng-messages=\"billingForm.BlStreet.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'Please provide valid street' | translate\"></div>\n                  <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                </div>\n              </md-input-container>\n            </div>\n            <div class=\"setting-row address\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'House number' | translate\"\n                        for=\"BlhouseNumber\"></label>\n                <input\n                        type=\"number\"\n                        min=\"0\"\n                        max=\"99999\"\n                        name=\"BlhouseNumber\"\n                        id=\"BlhouseNumber\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.houseNumber\">\n\n                <div ng-messages=\"billingForm.BlhouseNumber.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                </div>\n              </md-input-container>\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Zip Code' | translate\"\n                        for=\"Blzip\"></label>\n                <input\n                        type=\"number\"\n                        min=\"0\"\n                        name=\"Blzip\"\n                        id=\"Blzip\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.zip\">\n\n                <div ng-messages=\"billingForm.Blzip.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                </div>\n              </md-input-container>\n            </div>\n            <div class=\"setting-row location\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'City' | translate\"\n                        for=\"Blcity\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        name=\"Blcity\"\n                        id=\"Blcity\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.city\">\n\n                <div ng-messages=\"billingForm.Blcity.$error\" role=\"alert\">\n                  <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                </div>\n              </md-input-container>\n              <select-search\n                      model=\"client.billing_info.country\"\n                      item-label=\"name\"\n                      item-value=\"code\"\n                      label=\"'Country' | translate\"\n                      collection=\"DeploymentUpdate.countries\">\n              </select-search>\n            </div>\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Tax ID' | translate\"\n                        for=\"tax\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        name=\"tax\"\n                        id=\"tax\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.tax\">\n              </md-input-container>\n            </div>\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'VAT ID' | translate\"\n                        for=\"vat\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        name=\"vat\"\n                        id=\"vat\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.vat\">\n              </md-input-container>\n            </div>\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'UpReach Supplier ID' | translate\"\n                        for=\"supplier\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"64\"\n                        name=\"supplier\"\n                        id=\"supplier\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.supplierID\">\n              </md-input-container>\n            </div>\n            <div class=\"setting-row\">\n              <md-input-container class=\"md-block\">\n                <label\n                        ng-bind=\"'Other reference' | translate\"\n                        for=\"other\"></label>\n                <input\n                        type=\"text\"\n                        minlength=\"2\"\n                        maxlength=\"360\"\n                        name=\"other\"\n                        id=\"other\"\n                        ng-model=\"DeploymentUpdate.deployment.billing_info.otherReferences\">\n              </md-input-container>\n            </div>\n          </div>\n        </div>\n\n<!--        Screen config-->\n        <section layout=\"column\" class=\"deploy-screen-orientation-section\">\n          <div class=\"col-6\">\n            <h5>Assign Configs</h5>\n            <p class=\"low-text\">Let visitors choose between multiple experiences (configs) on one device — great for events with multiple campaigns or brands. This enables a custom start screen with tappable areas.</p>\n            <div class=\"radio-group-section\">\n              <md-radio-group\n                      ng-model=\"DeploymentUpdate.deployment.screenOrientation\"\n                      ng-change=\"DeploymentUpdate.onScreenOrientationChange()\">\n                <div class=\"radio-option-wrapper grey-bg-block\">\n                  <md-radio-button ng-value=\"'preselected'\">\n                    Choose a Device / Resolution\n                  </md-radio-button>\n                  <p>🔽 Select a preset based on your device.<br>\n                    This will automatically apply the correct resolution and orientation.</p>\n                  <p>📌 Preset options cover common resolutions and tablet formats in both landscape and portrait.</p>\n                  <div class=\"dropdown-resolution-block\" >\n                    <div class=\"dropdown-selected\" ng-click=\"DeploymentUpdate.resolutionDropdownOpen = !DeploymentUpdate.resolutionDropdownOpen\">\n                      <span>{{ DeploymentUpdate.selectedResolution.label || 'Select resolution' }}</span>\n                      <span class=\"dropdown-arrow\"  ng-if=\"!DeploymentUpdate.resolutionDropdownOpen\">&#9660;</span>\n                    </div>\n                    <div class=\"dropdown-list\" ng-show=\"DeploymentUpdate.resolutionDropdownOpen\">\n                      <div class=\"dropdown-header\">Select a Preset</div>\n                      <div ng-repeat=\"resolution in DeploymentUpdate.resolutionOptions track by $index\">\n                        <div ng-if=\"resolution.group\" class=\"dropdown-group-title\">{{resolution.group}}</div>\n                        <div ng-if=\"resolution.group\" class=\"dropdown-divider\"></div>\n                        <div class=\"dropdown-item\"\n                             ng-if=\"!resolution.group\"\n                             ng-class=\"{selected: DeploymentUpdate.selectedResolution === resolution}\"\n                             ng-click=\"DeploymentUpdate.selectResolution(resolution)\">\n                          {{ resolution.label }}\n                          <span class=\"dropdown-arrow\" ng-class=\"{close: DeploymentUpdate.resolutionDropdownOpen}\" ng-show=\"DeploymentUpdate.resolutionDropdownOpen && (DeploymentUpdate.resolutionOptions.length - 1) === $index\">&#9660;</span>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"radio-option-wrapper grey-bg-block\">\n\n                  <md-radio-button ng-value=\"'custom'\">\n                    Custom Resolution\n                  </md-radio-button>\n                  <p>ℹ️ If your device isn't listed, select Custom and manually enter the screen width and height.</p>\n                  <div class=\"custom-input-block\">\n                    <md-input-container class=\"md-block\">\n                      <input\n                              ng-model=\"DeploymentUpdate.deployment.screen.width\"\n                              ng-disabled=\"DeploymentUpdate.deployment.screenOrientation === 'preselected'\"\n                              ng-change=\"DeploymentUpdate.onScreenSizeChange()\"\n                              type=\"number\"\n                              max=\"4000\"\n                              min=\"500\"\n                              step=\"2\"\n                              placeholder=\"Width (px)\">\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                      <input\n                              ng-model=\"DeploymentUpdate.deployment.screen.height\"\n                              ng-disabled=\"DeploymentUpdate.deployment.screenOrientation === 'preselected'\"\n                              ng-change=\"DeploymentUpdate.onScreenSizeChange()\"\n                              type=\"number\"\n                              max=\"4000\"\n                              min=\"500\"\n                              step=\"2\"\n                              placeholder=\"Height (px)\">\n                    </md-input-container>\n                  </div>\n                </div>\n              </md-radio-group>\n            </div>\n            <div class=\"choose-configs-block\">\n              <h6>Configs:</h6>\n              <p>Please select configs here via Dropdown</p>\n              <div class=\"configs-wrapper\">\n                <div class=\"config-item-wrapper\" ng-repeat=\"configInfo in DeploymentUpdate.deployment.multi_config.configurations_info track by $index\" ng-init=\"configIndex = $index\">\n                  <div class=\"dropdown-resolution-block\" ng-class=\"{'orientation-error': DeploymentUpdate.orientationErrors[configIndex]}\">\n                    <div class=\"dropdown-selected\" ng-click=\"DeploymentUpdate.configsDropdownOpen[configIndex] = !DeploymentUpdate.configsDropdownOpen[configIndex]\">\n                      <span>{{ DeploymentUpdate.selectedConfigsList[configIndex] ? DeploymentUpdate.selectedConfigsList[configIndex].name : (configInfo && configInfo.name) || 'Select config' }}</span>\n                      <span class=\"dropdown-arrow\" ng-class=\"{open: DeploymentUpdate.configsDropdownOpen[configIndex]}\">&#9660;</span>\n                    </div>\n                    <div class=\"orientation-error-message\" ng-if=\"DeploymentUpdate.orientationErrors[configIndex]\">\n                      <md-icon class=\"error-icon\">warning</md-icon>\n                      <span>Orientation conflict: deployment is {{ DeploymentUpdate.orientationErrors[configIndex].deploymentOrientation }}, configuration is {{ DeploymentUpdate.orientationErrors[configIndex].configOrientation }}</span>\n                    </div>\n                    <div class=\"dropdown-list\" ng-show=\"DeploymentUpdate.configsDropdownOpen[configIndex]\">\n                      <div class=\"dropdown-search\">\n                        <input type=\"text\"\n                               ng-model=\"DeploymentUpdate.searchConfigs[configIndex]\"\n                               ng-change=\"DeploymentUpdate.searchConfigurations(configIndex)\"\n                               placeholder=\"Search configs...\"\n                               class=\"search-input\">\n                      </div>\n                      <div ng-repeat=\"config in DeploymentUpdate.filteredConfigsList[configIndex] track by config.id\">\n                        <div class=\"dropdown-item\"\n                             ng-class=\"{\n                               selected: DeploymentUpdate.selectedConfigsList[configIndex] && DeploymentUpdate.selectedConfigsList[configIndex].id === config.id,\n                               disabled: DeploymentUpdate.isConfigSelected(config, configIndex)\n                             }\"\n                             ng-click=\"!DeploymentUpdate.isConfigSelected(config, configIndex) && DeploymentUpdate.selectConfig(config, configIndex)\">\n                          {{ config.name }}\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <md-button class=\"md-icon-button delete-config-button\" ng-click=\"DeploymentUpdate.removeConfig(configIndex)\" aria-label=\"Delete config\">\n                    <md-icon>delete</md-icon>\n                  </md-button>\n                </div>\n              </div>\n              <md-button class=\"md-primary add-config-button\" ng-click=\"DeploymentUpdate.addConfig()\">\n                <md-icon>add</md-icon>\n                <span>Add Config</span>\n              </md-button>\n            </div>\n          </div>\n          <div class=\"col-6\">\n            <div class=\"grey-bg-block\">\n              <h6>⚠️Important:</h6>\n              <p>When assigning more than one Configuration, you must set the screen orientation and resolution here at the deployment level.</p>\n              <p>All configs added to this deployment must match this screen setup exactly. (Orientation and pixel resolution must be the same.)</p>\n            </div>\n          </div>\n        </section>\n\n<!--        Multi - config-->\n        <section layout=\"column\" class=\"multi-config-section\">\n          <div class=\"col-6\">\n            <md-switch\n                    md-invert\n                    class=\"multi-config-section__title\"\n                    ng-model=\"DeploymentUpdate.deployment.multi_config.active\">\n              Multi-Config Start Screen\n            </md-switch>\n            <md-switch\n                    md-invert\n                    class=\"multi-config-section__title multi-config-switch__label--wrap\"\n                    ng-model=\"DeploymentUpdate.deployment.multi_config.show_multi_config_before_first_session\"\n                    ng-disabled=\"!DeploymentUpdate.deployment.multi_config.active\">\n              Show multi-config screen only before the first user session\n            </md-switch>\n            <p class=\"low-text\" style=\"margin-top: 20px\">Let visitors choose between multiple experiences (configs) on one device — great for events with multiple campaigns or brands. This enables a custom start screen with tappable areas.</p>\n\n            <div class=\"touch-points-section\" ng-if=\"DeploymentUpdate.deployment.multi_config.active\">\n              <h6>Touch Points and Thumbnails</h6>\n              <p class=\"low-text\">Size and scale of touchpoints in Multi-Touch Startscreen. Upload a custom Thumbnail (image or video) for each Config.</p>\n              <p class=\"low-text\">Accepted formats: .jpg, .png, .gif, .mp4, .mov, .webm</p>\n              <p class=\"low-text\">Dimension: As set above</p>\n              <p class=\"low-text\">Max size: 5 MB</p>\n\n              <div class=\"config-touch-points\" ng-repeat=\"configInfo in DeploymentUpdate.configurations_info track by $index\" ng-init=\"configIndex = $index\">\n                <div class=\"config-touch-point-item\">\n                  <div class=\"config-label\">\n                    <strong>Config {{ ($index + 1 < 10 ? '0' : '') + ($index + 1) }}</strong>\n                    <span ng-if=\"DeploymentUpdate.selectedConfigsList[configIndex]\">: {{ DeploymentUpdate.selectedConfigsList[configIndex].name }}</span>\n                  </div>\n                  <div layout=\"row\" class=\"area-editor\">\n                      <start-screen-area\n                            ng-if=\"DeploymentUpdate.deployment.multi_config.active && DeploymentUpdate.getConfigTouchPoint(configIndex)\"\n                            model=\"DeploymentUpdate.deployment.multi_config.configurations_info[configIndex]\"\n                            pixel-width=\"DeploymentUpdate.deployment.multi_config.screen_width\"\n                            pixel-height=\"DeploymentUpdate.deployment.multi_config.screen_height\"\n                            company=\"DeploymentUpdate.deployment.company_info.url\"\n                            hide-upload-icons=\"false\"\n                            short-upload-title=\"true\"\n                            custom-buttons-options=\"false\">\n                    </start-screen-area>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"background-options\" ng-if=\"DeploymentUpdate.deployment.multi_config.active\">\n              <h6>Background:</h6>\n              <p class=\"low-text\">Upload Background Asset</p>\n              <upload\n                      model=\"DeploymentUpdate.deployment.multi_config.background\"\n                      callback=\"DeploymentUpdate.checkBackgroundResolution()\"\n                      uri=\"{{DeploymentUpdate.companyAttachmentsUrl}}\"\n                      custom-label=\"{{'↑ Upload' | translate}}\"\n                      file-types=\".jpg,.jpeg,.gif,.png,.mp4\"\n                      max-size=\"DeploymentUpdate.fileSizes.startScreen\"\n                      is-overlay=\"false\"\n                      display-icon=\"false\">\n              </upload>\n              <div class=\"file-title\" ng-if=\"DeploymentUpdate.deployment.multi_config.background.attachment_file\" title=\"{{DeploymentUpdate.deployment.multi_config.background.attachment_file | getFileName}}\">\n                <span>Currently Uploaded: {{ DeploymentUpdate.deployment.multi_config.background.attachment_file | getFileName }}</span>\n                <md-button\n                        class=\"md-icon-button md-primary\"\n                        ng-click=\"DeploymentUpdate.clearMultiConfigBackground()\">\n                  <md-icon>delete</md-icon>\n                </md-button>\n              </div>\n              <p class=\"low-text\">Accepted formats: .jpg, .png, .gif, .mp4</p>\n              <p class=\"low-text\">Dimension: As set above</p>\n              <p class=\"low-text\">Max size: {{DeploymentUpdate.fileSizes.startScreen}} MB</p>\n            </div>\n          </div>\n          <div class=\"col-6 preview-part\" ng-if=\"DeploymentUpdate.deployment.multi_config.active\">\n            <h5>Screen Preview</h5>\n            <p>A live example of how your content will look based on your selected layout and resolution.</p>\n            <html-preview\n                    ng-show=\"true\"\n                    pr-width=\"{{DeploymentUpdate.deployment.screen.width}}\"\n                    pr-height=\"{{DeploymentUpdate.deployment.screen.height}}\"\n                    index=\"{{DeploymentUpdate.deployment.screen.width > DeploymentUpdate.deployment.screen.height ? (DeploymentUpdate.deployment.screen.width * 1.7 / 1000) : (DeploymentUpdate.deployment.screen.height * 1.7 / 1000)}}\"\n                    background=\"{{[DeploymentUpdate.deployment.multi_config.background.attachment_file]}}\"\n                    video-background=\"{{DeploymentUpdate.getMultiConfigVideoBackground()}}\"\n                    areas=\"{{DeploymentUpdate.getMultiConfigAreas()}}\"\n                    related-values=\"true\"\n                    screen=\"screen-preview\"\n                    show-title=\"true\"\n                    ignore-overflow=\"true\"\n                    bg-mode=\"DeploymentUpdate.deployment.multi_config.background.start_screen_background_mode\"\n                    bg-color=\"DeploymentUpdate.deployment.multi_config.background.start_screen_background_color\"\n                    bg-style=\"DeploymentUpdate.deployment.multi_config.background.start_screen_image_style\"\n                    transparency=\"DeploymentUpdate.deployment.multi_config.background.start_screen_live_view\"\n                    config-mode=\"true\">\n            </html-preview>\n          </div>\n\n        </section>\n        <section layout=\"column\" class=\"multi-config-section\" ng-if=\"DeploymentUpdate.deployment.multi_config.active\">\n          <div class=\"col-6\">\n            <div class=\"standby-deployment-options\">\n\n              <div >\n                <md-switch md-invert\n                           class=\"part-title\"\n                           ng-model=\"DeploymentUpdate.deployment.multi_config.standby_screen\"\n                           ng-change=\"DeploymentUpdate.changeStandByScreenState(DeploymentUpdate.deployment.multi_config.standby_screen)\">\n                  {{'Standby Screen' | translate}}\n                </md-switch>\n              </div>\n\n              <div ng-if=\"DeploymentUpdate.deployment.multi_config.standby_screen\">\n                <div>\n                  <p class=\"part-title__sub-text\">{{'The Standby Screen is what people will see when the\n                    device is not active. Users can close it by tapping anywhere on the screen.' |\n                    translate}}</p>\n                </div>\n              </div>\n\n              <div ng-if=\"DeploymentUpdate.deployment.multi_config.standby_screen\">\n                <div>\n\n                  <div ng-class=\"{'item-disabled': !DeploymentUpdate.deployment.multi_config.standby_screen}\">\n                    <p>{{'Idle time until the device goes into Standby:' | translate}} <strong>{{DeploymentUpdate.deployment.multi_config.standby_screen_activate_time}}</strong>\n                      {{'seconds' | translate}}</p>\n                    <md-slider-container class=\"slider-item\">\n                      <md-slider\n                              min=\"0\"\n                              max=\"60\"\n                              step=\"10\"\n                              md-discrete\n                              ng-model=\"DeploymentUpdate.deployment.multi_config.standby_screen_activate_time\"\n                              ng-disabled=\"!DeploymentUpdate.deployment.multi_config.standby_screen\"\n                              aria-label=\"slider\">\n                      </md-slider>\n                    </md-slider-container>\n\n                    <md-switch\n                            md-invert\n                            ng-model=\"DeploymentUpdate.deployment.multi_config.standby_screen_after_each_session\"\n                            class=\"paragraph\"\n                            ng-disabled=\"!DeploymentUpdate.deployment.multi_config.standby_screen\">\n                      {{'Display the Standby Screen after each session' | translate}}\n                    </md-switch>\n\n\n                    <div class=\"upload-container\">\n                      <upload\n                              model=\"DeploymentUpdate.deployment.multi_config.standby_screen_image\"\n                              uri=\"{{DeploymentUpdate.companyAttachmentsUrl}}\"\n                              callback=\"DeploymentUpdate.onStandbyUpload\"\n                              custom-label=\"{{'Upload a Standby Screen' | translate}}\"\n                              file-types=\".jpg,.jpeg,.gif,.png,.mp4\"\n                              max-size=\"DeploymentUpdate.fileSizes.startScreen\"\n                              is-overlay=\"false\"\n                              display-icon=\"false\"\n                              disabled=\"!DeploymentUpdate.deployment.multi_config.standby_screen\"\n                              upload-animated-files=\"false\">\n                      </upload>\n\n                      <div class=\"file-title\" ng-if=\"DeploymentUpdate.deployment.multi_config.standby_screen_image\" title=\"{{DeploymentUpdate.deployment.multi_config.standby_screen_image.attachment_file | getFileName}}\">\n                        <span>Currently Uploaded: {{ DeploymentUpdate.deployment.multi_config.standby_screen_image.attachment_file | getFileName }}</span>\n                        <md-button\n                                class=\"md-icon-button md-primary\"\n                                ng-click=\"DeploymentUpdate.clearStandbyScreenImage()\">\n                          <md-icon>delete</md-icon>\n                        </md-button>\n                      </div>\n                      <p class=\"low-text\">Accepted formats: .jpg, .png, .gif, .mp4</p>\n                      <p class=\"low-text\">Dimension: As set above</p>\n                      <p class=\"low-text\">Max size: {{DeploymentUpdate.fileSizes.startScreen}} MB</p>\n\n\n                    </div>\n\n\n                  </div>\n\n                </div>\n\n              </div>\n\n            </div>\n          </div>\n          <div class=\"col-6 preview-part\" ng-if=\"DeploymentUpdate.deployment.multi_config.standby_screen\">\n            <html-preview\n                    pr-width=\"{{DeploymentUpdate.deployment.screen.width}}\"\n                    pr-height=\"{{DeploymentUpdate.deployment.screen.height}}\"\n                    screen=\"standby\"\n                    index=\"{{DeploymentUpdate.deployment.screen.width > DeploymentUpdate.deployment.screen.height ? (DeploymentUpdate.deployment.screen.width * 1.7 / 1000) : (DeploymentUpdate.deployment.screen.height * 1.7 / 1000)}}\"\n                    background=\"{{[DeploymentUpdate.deployment.multi_config.standby_screen_image.attachment_file]}}\"\n                    video-background=\"{{DeploymentUpdate.getMultiConfigStandByVideoBackground() }}\"\n                    margin=\"true\"\n                    show-title=\"true\">\n            </html-preview>\n          </div>\n        </section>\n\n        <div layout=\"row\" layout-sm=\"column\" layout-padding layout-align=\"center center\">\n            <md-button\n                ng-disabled=\"deploymentForm.$invalid\"\n                class=\"md-primary md-raised\"\n                ng-click=\"DeploymentUpdate.saveDeployment()\">{{isNew ? 'Create deployment' : 'Save deployment' | translate}}\n            </md-button>\n        </div>\n      </div>\n    </form>\n\n  </div>\n</div>\n\n\n\n\n\n";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(272);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(189);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	var _countries = __webpack_require__(494);
	
	var _fileSizes = __webpack_require__(277);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Deployment", "$companies", "$BoothList", "$Configuration", "$resource"];
	
	var DeploymentUpdateController = function (_$controller) {
	    DeploymentUpdateController.$inject = ["$injector", "$stateParams", "$scope", "$element", "$ToastService", "$resource", "$q"];
	    (0, _inherits3.default)(DeploymentUpdateController, _$controller);
	
	    function DeploymentUpdateController($injector, $stateParams, $scope, $element, $ToastService, $resource, $q) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, DeploymentUpdateController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (DeploymentUpdateController.__proto__ || (0, _getPrototypeOf2.default)(DeploymentUpdateController)).call(this, $injector, dependencies));
	
	        _this.$scope = $scope;
	        _this.$stateParams = $stateParams;
	        _this.$element = $element;
	        _this.toastService = $ToastService;
	        _this.multiConfigResource = $resource("/api/configurations/:id/multi-config/", null, { update: { method: "PUT" } });
	        _this.deploymentMultiConfigResource = $resource("/api/deployments/:id/multi-config/", null, { update: { method: "PUT" } });
	        _this.$resource = $resource;
	        _this.$q = $q;
	        _this.isNew = _this.$stateParams.isNew;
	        _this.company = _this.$stateParams.company;
	        _this.companyAttachmentsUrl = null;
	        _this.copiedDeployment = {};
	        var cachedCompany = _this.$companies && _this.$companies.getCached ? _this.$companies.getCached() : null;
	        if (cachedCompany) {
	            _this.updateCompanyAttachmentsUrl({ company_info: cachedCompany, company: cachedCompany });
	        }
	        _this.countries = _countries.countries;
	        _this.checkboxConditions = [{
	            position: 1,
	            checked: false
	        }, {
	            position: 2,
	            checked: false
	        }, {
	            position: 3,
	            checked: false
	        }, {
	            position: 4,
	            checked: false
	        }, {
	            position: 5,
	            checked: false
	        }];
	        _this.configurations = [];
	        _this.configsList = [];
	        _this.selectedConfigsList = [];
	        _this.configsDropdownOpen = {};
	        _this.searchConfigs = {};
	        _this.filteredConfigsList = {};
	        _this.selectedConfigs = {};
	        _this.selectedConfig = null;
	        _this.searchTimeout = {};
	        _this.orientationErrors = {}; // Store orientation errors for each config index
	        _this.fileSizes = _fileSizes.FILE_SIZES; // File size limits for uploads
	        // Оновлюємо URI аплоада, якщо компанія підвантажиться/зміниться асинхронно
	        _this.$scope.$watch(function () {
	            return _this.deployment && (_this.deployment.company_info || _this.deployment.company);
	        }, function () {
	            if (_this.deployment) {
	                _this.updateCompanyAttachmentsUrl(_this.deployment);
	            }
	        });
	
	        _this.status = {
	            "draft": "Draft",
	            "booked": "Booked",
	            "delivery": "Delivery",
	            "active": "Active",
	            "done": "Done"
	        };
	
	        _this.resolutionOptions = [{ group: "Common Resolutions" }, { label: "1080p (1920 × 1080 – Landscape)", width: 1920, height: 1080 }, { label: "1080p (1080 × 1920 – Portrait)", width: 1080, height: 1920 }, { label: "4K UHD (3840 × 2160 – Landscape)", width: 3840, height: 2160 }, { label: "4K UHD (2160 × 3840 – Portrait)", width: 2160, height: 3840 }, { group: "Tablet Devices" }, { label: "iPad 10.2\" (2160 × 1620 – Landscape)", width: 2160, height: 1620 }, { label: "iPad 10.2\" (1620 × 2160 – Portrait)", width: 1620, height: 2160 }, { label: "Xiaomi (3048 × 2032 – Landscape)", width: 3048, height: 2032 }, { label: "Xiaomi (2032 × 3048 – Portrait)", width: 2032, height: 3048 }, { label: "Huawei (2880 × 1920 – Landscape)", width: 2880, height: 1920 }, { label: "Huawei (1920 × 2880 – Portrait)", width: 1920, height: 2880 }, { label: "Samsung (2960 × 1848 – Landscape)", width: 2960, height: 1848 }, { label: "Samsung (1848 × 2960 – Portrait)", width: 1848, height: 2960 }];
	        _this.selectedResolution = null;
	        _this.resolutionDropdownOpen = false;
	        _this.selectResolution = function (resolution) {
	            _this.selectedResolution = resolution;
	            _this.resolutionDropdownOpen = false;
	            if (!_this.deployment.screen) _this.deployment.screen = {};
	            _this.deployment.screen.width = resolution.width;
	            _this.deployment.screen.height = resolution.height;
	
	            // Ensure multi_config exists and update it with selected resolution
	            if (!_this.deployment.multi_config) {
	                _this.deployment.multi_config = {
	                    active: false,
	                    screen_orientation: _this.deployment.screenOrientation || "preselected",
	                    screen_width: resolution.width,
	                    screen_height: resolution.height,
	                    selected_resolution: {
	                        label: resolution.label,
	                        width: resolution.width,
	                        height: resolution.height
	                    },
	                    background: {
	                        attachment_file: null,
	                        start_screen_background_mode: "image",
	                        start_screen_background_color: "#ffffff",
	                        start_screen_image_style: "stretch",
	                        start_screen_live_view: false
	                    },
	                    configurations_info: []
	                };
	            } else {
	                // Update multi_config with selected resolution
	                _this.deployment.multi_config.screen_width = resolution.width;
	                _this.deployment.multi_config.screen_height = resolution.height;
	                _this.deployment.multi_config.selected_resolution = {
	                    label: resolution.label,
	                    width: resolution.width,
	                    height: resolution.height
	                };
	                // Ensure screenOrientation is set to preselected when selecting a preset
	                if (_this.deployment.screenOrientation !== "preselected") {
	                    _this.deployment.screenOrientation = "preselected";
	                    _this.deployment.multi_config.screen_orientation = "preselected";
	                }
	            }
	
	            // Re-check all configuration orientations when resolution changes
	            _this.recheckAllConfigOrientations();
	        };
	
	        var deployment = void 0;
	        if ($stateParams.cid && $stateParams.cid !== "create") {
	            deployment = _this.$Deployment.get({ id: $stateParams.cid });
	        } else {
	            deployment = _this.$Deployment.get({ url: _this.$companies.getCached().default_configuration });
	        }
	
	        deployment && deployment.$promise.then(function (deployment) {
	            if (deployment.configurations) {
	                _this.configurations = [].concat((0, _toConsumableArray3.default)(deployment.configurations));
	            }
	            if (deployment.multi_config && deployment.multi_config.configurations_info) {
	                _this.configurations_info = deployment.multi_config.configurations_info.map(function (ci) {
	                    return {
	                        id: ci.id,
	                        url: ci.url,
	                        name: ci.name,
	                        config_index: ci.config_index
	                    };
	                });
	            } else if (deployment.configurations_info) {
	                _this.configurations_info = [].concat((0, _toConsumableArray3.default)(deployment.configurations_info));
	            } else {
	                _this.configurations_info = [];
	            }
	            if (_this.$stateParams && _this.$stateParams.code && localStorage.getItem("dropboxDeployment")) {
	                _this.getDropboxToken();
	            } else {
	                _this.deployment = deployment;
	            }
	            _this.updateCompanyAttachmentsUrl(deployment);
	            deployment.deployment_start = deployment.deployment_start ? moment(deployment.deployment_start)._d : null;
	            deployment.deployment_end = deployment.deployment_end ? moment(deployment.deployment_end)._d : null;
	            deployment.delivery_start = deployment.delivery_start ? moment(deployment.delivery_start)._d : null;
	            deployment.delivery_end = deployment.delivery_end ? moment(deployment.delivery_end)._d : null;
	            deployment.collection_start = deployment.collection_start ? moment(deployment.collection_start)._d : null;
	            deployment.collection_end = deployment.collection_end ? moment(deployment.collection_end)._d : null;
	            if (deployment.local_data_saving === undefined) {
	                deployment.local_data_saving = false;
	            }
	            if (deployment.only_local_data_saving === undefined) {
	                deployment.only_local_data_saving = false;
	            }
	            if (deployment.local_data_path === undefined || deployment.local_data_path === null) {
	                deployment.local_data_path = "";
	            }
	            if (deployment.dropbox_settings) {
	                if (deployment.dropbox_settings.hasOwnProperty("token")) {
	                    if (!deployment.dropbox_settings.conditions.checkboxConditions) {
	                        deployment.dropbox_settings.conditions.checkboxConditions = _this.checkboxConditions;
	                    }
	                    _this.checkboxConditions = deployment.dropbox_settings.conditions.checkboxConditions;
	                }
	            }
	            // Initialize multi_config with screen orientation settings
	            // This object stores all multi-config related settings from radio-group-section
	            // It includes: screen_orientation, screen_width, screen_height, selected_resolution
	            // This object is part of the deployment and will be saved to the server
	
	            // First, determine screen orientation from multi_config if it exists, otherwise use deployment.screenOrientation
	            var screenOrientation = "preselected";
	            if (deployment.multi_config && deployment.multi_config.screen_orientation) {
	                screenOrientation = deployment.multi_config.screen_orientation;
	            } else if (deployment.screenOrientation) {
	                screenOrientation = deployment.screenOrientation;
	            }
	
	            if (!deployment.multi_config) {
	                // Initialize multi_config with screen orientation from deployment
	                deployment.multi_config = {
	                    id: null,
	                    active: false,
	                    screen_orientation: screenOrientation,
	                    screen_width: deployment.screen ? deployment.screen.width : firstOption ? firstOption.width : 1920,
	                    screen_height: deployment.screen ? deployment.screen.height : firstOption ? firstOption.height : 1080,
	                    selected_resolution: null, // Will be set after selectedResolution is determined
	                    standby_screen: false,
	                    standby_screen_activate_time: 30,
	                    standby_screen_after_each_session: false,
	                    standby_screen_image: { attachment_file: null },
	                    show_multi_config_before_first_session: false,
	                    background: {
	                        url: null,
	                        content_object: null,
	                        kind: null,
	                        is_overlay: false,
	                        attachment_file: null,
	                        original_name: null,
	                        thumbnail_file: null,
	                        first_frame: null,
	                        first_frame_alpha: null,
	                        attachment_file_alpha: null,
	                        start_screen_background_mode: "image",
	                        start_screen_background_color: "#ffffff",
	                        start_screen_image_style: "stretch",
	                        start_screen_live_view: false,
	                        created: null,
	                        modified: null,
	                        creator: null,
	                        configurations: []
	                    },
	                    configurations_info: [] // [{id,url,name,config_index,width,height,x,y,custom_icon,angle}]
	                };
	            } else {
	                // Ensure multi_config has all required properties
	                if (deployment.multi_config.active === undefined) {
	                    deployment.multi_config.active = false;
	                }
	                if (deployment.multi_config.background === undefined || deployment.multi_config.background === null) {
	                    var existingBg = deployment.multi_config.background || {};
	                    deployment.multi_config.background = {
	                        url: existingBg.url || null,
	                        content_object: null,
	                        kind: null,
	                        is_overlay: false,
	                        attachment_file: existingBg.attachment_file || null,
	                        original_name: null,
	                        thumbnail_file: null,
	                        first_frame: null,
	                        first_frame_alpha: null,
	                        attachment_file_alpha: null,
	                        start_screen_background_mode: "image",
	                        start_screen_background_color: "#ffffff",
	                        start_screen_image_style: "stretch",
	                        start_screen_live_view: false,
	                        created: null,
	                        modified: null,
	                        creator: null,
	                        configurations: []
	                    };
	                }
	                if (deployment.multi_config.standby_screen_image === undefined || deployment.multi_config.standby_screen_image === null) {
	                    deployment.multi_config.standby_screen_image = { attachment_file: null };
	                }
	                if (deployment.multi_config.configurations_info === undefined) {
	                    deployment.multi_config.configurations_info = [];
	                }
	
	                // Sync configurations_info with existing configs (legacy configList support)
	                var legacyList = deployment.multi_config.configList || deployment.multi_config.config_list;
	                if (legacyList && legacyList.length > 0) {
	                    deployment.multi_config.configurations_info = legacyList.map(function (tp, idx) {
	                        return {
	                            id: tp.configId || tp.config_id || null,
	                            url: tp.configUrl || tp.config_url || null,
	                            name: tp.name || null,
	                            config_index: tp.configIndex !== undefined ? tp.configIndex : idx,
	                            width: tp.width || 25,
	                            height: tp.height || 25,
	                            x: tp.x || 20 + idx * 20,
	                            y: tp.y || 60,
	                            custom_icon: tp.customIcon || tp.custom_icon || null,
	                            angle: tp.angle || 0
	                        };
	                    });
	                }
	
	                if (deployment.configurations_info && deployment.configurations_info.length > 0) {
	                    deployment.configurations_info.forEach(function (configInfo, index) {
	                        var existing = deployment.multi_config.configurations_info.find(function (tp) {
	                            return tp.config_index === index || tp.id === configInfo.id || tp.url === configInfo.url;
	                        });
	                        if (!existing) {
	                            deployment.multi_config.configurations_info.push({
	                                id: configInfo.id,
	                                url: configInfo.url,
	                                name: configInfo.name,
	                                config_index: index,
	                                width: 25,
	                                height: 25,
	                                x: 20 + index * 20,
	                                y: 60,
	                                custom_icon: null,
	                                angle: 0
	                            });
	                        } else {
	                            existing.config_index = index;
	                            existing.id = existing.id || configInfo.id;
	                            existing.url = existing.url || configInfo.url;
	                            existing.name = existing.name || configInfo.name;
	                        }
	                    });
	                }
	
	                // Update screenOrientation from multi_config (priority)
	                if (deployment.multi_config.screen_orientation) {
	                    screenOrientation = deployment.multi_config.screen_orientation;
	                    deployment.screenOrientation = screenOrientation;
	                } else if (deployment.screenOrientation) {
	                    deployment.multi_config.screen_orientation = deployment.screenOrientation;
	                    screenOrientation = deployment.screenOrientation;
	                } else {
	                    deployment.multi_config.screen_orientation = "preselected";
	                    screenOrientation = "preselected";
	                    deployment.screenOrientation = "preselected";
	                }
	            }
	
	            // Now initialize screen and selectedResolution based on screen_orientation
	            // CRITICAL: This must happen AFTER we've determined the correct screen_orientation
	            var firstOption = _this.resolutionOptions.find(function (opt) {
	                return !opt.group;
	            });
	
	            if (screenOrientation === "custom") {
	                // For custom mode: load dimensions from multi_config, clear selectedResolution
	                _this.selectedResolution = null;
	
	                if (!deployment.screen) {
	                    deployment.screen = {};
	                }
	
	                // Load dimensions from multi_config if they exist
	                if (deployment.multi_config && deployment.multi_config.screen_width && deployment.multi_config.screen_height) {
	                    deployment.screen.width = deployment.multi_config.screen_width;
	                    deployment.screen.height = deployment.multi_config.screen_height;
	                } else if (!deployment.screen.width || !deployment.screen.height) {
	                    // Fallback to defaults if no dimensions in multi_config
	                    deployment.screen.width = deployment.screen.width || 1920;
	                    deployment.screen.height = deployment.screen.height || 1080;
	                }
	            } else {
	                // For preselected mode: try to find resolution in options
	                if (!deployment.screen || !deployment.screen.width || !deployment.screen.height) {
	                    // If no screen dimensions, use first option or multi_config values
	                    if (deployment.multi_config && deployment.multi_config.screen_width && deployment.multi_config.screen_height) {
	                        deployment.screen = {
	                            width: deployment.multi_config.screen_width,
	                            height: deployment.multi_config.screen_height
	                        };
	                        // Try to find matching resolution
	                        var found = _this.resolutionOptions.find(function (opt) {
	                            return !opt.group && opt.width === deployment.multi_config.screen_width && opt.height === deployment.multi_config.screen_height;
	                        });
	                        if (found) {
	                            _this.selectedResolution = found;
	                        } else if (firstOption) {
	                            _this.selectedResolution = firstOption;
	                            deployment.screen.width = firstOption.width;
	                            deployment.screen.height = firstOption.height;
	                        }
	                    } else if (firstOption) {
	                        deployment.screen = {
	                            width: firstOption.width,
	                            height: firstOption.height
	                        };
	                        _this.selectedResolution = firstOption;
	                    }
	                } else {
	                    // Screen dimensions exist, try to find matching resolution
	                    var _found = _this.resolutionOptions.find(function (opt) {
	                        return !opt.group && opt.width === deployment.screen.width && opt.height === deployment.screen.height;
	                    });
	                    if (_found) {
	                        _this.selectedResolution = _found;
	                    }
	                }
	
	                // Restore selected_resolution from multi_config if it exists and matches
	                if (deployment.multi_config && deployment.multi_config.selected_resolution && !_this.selectedResolution) {
	                    var foundResolution = _this.resolutionOptions.find(function (opt) {
	                        return !opt.group && opt.width === deployment.multi_config.selected_resolution.width && opt.height === deployment.multi_config.selected_resolution.height;
	                    });
	                    if (foundResolution) {
	                        _this.selectedResolution = foundResolution;
	                        if (!deployment.screen) deployment.screen = {};
	                        deployment.screen.width = foundResolution.width;
	                        deployment.screen.height = foundResolution.height;
	                    }
	                }
	
	                // Update multi_config.selected_resolution based on selectedResolution
	                if (screenOrientation === "preselected" && _this.selectedResolution) {
	                    deployment.multi_config.selected_resolution = {
	                        label: _this.selectedResolution.label,
	                        width: _this.selectedResolution.width,
	                        height: _this.selectedResolution.height
	                    };
	                } else if (screenOrientation === "custom") {
	                    deployment.multi_config.selected_resolution = null;
	                }
	            }
	
	            // Ensure screenOrientation is synced with multi_config (final sync)
	            if (deployment.multi_config) {
	                deployment.multi_config.screen_orientation = screenOrientation;
	                deployment.screenOrientation = screenOrientation;
	            }
	            if (deployment.multi_config) {
	                if (deployment.multi_config.show_multi_config_before_first_session === undefined) {
	                    if (deployment.show_multi_config_before_first_session !== undefined) {
	                        deployment.multi_config.show_multi_config_before_first_session = !!deployment.show_multi_config_before_first_session;
	                    } else if (deployment.multi_config.showMultiConfigBeforeFirstSession !== undefined) {
	                        deployment.multi_config.show_multi_config_before_first_session = !!deployment.multi_config.showMultiConfigBeforeFirstSession;
	                    } else {
	                        deployment.multi_config.show_multi_config_before_first_session = false;
	                    }
	                }
	                delete deployment.show_multi_config_before_first_session;
	                delete deployment.showMultiConfigBeforeFirstSession;
	            }
	            // Зберігаємо початковий стан multi_config для відстеження змін
	            _this.initialMultiConfig = (0, _lodash.cloneDeep)(deployment.multi_config || null);
	
	            // Initialize configs after deployment data is loaded
	            // This ensures configurations_info is available when getConfigs processes it
	            _this.getConfigs();
	        }).catch(function (e) {
	            console.log(e);
	            _this.$state.go("deployments");
	        });
	        // Also get configs list initially (in case deployment is not loaded yet)
	        _this.getConfigs();
	        return _this;
	    }
	
	    (0, _createClass3.default)(DeploymentUpdateController, [{
	        key: "updateCompanyAttachmentsUrl",
	        value: function updateCompanyAttachmentsUrl(deployment) {
	            var companyUrl = this.extractCompanyUrl(deployment);
	            if (!companyUrl) {
	                this.companyAttachmentsUrl = null;
	                return;
	            }
	            var normalizedCompanyUrl = companyUrl.endsWith("/") ? companyUrl : companyUrl + "/";
	            this.companyAttachmentsUrl = normalizedCompanyUrl + "attachments/";
	        }
	    }, {
	        key: "extractCompanyUrl",
	        value: function extractCompanyUrl(deployment) {
	            if (!deployment) return null;
	
	            var companyInfo = deployment.company_info;
	            if (companyInfo) {
	                if ((typeof companyInfo === "undefined" ? "undefined" : (0, _typeof3.default)(companyInfo)) === "object" && companyInfo.url) {
	                    return companyInfo.url;
	                }
	                if (typeof companyInfo === "string" && companyInfo.length) {
	                    return companyInfo;
	                }
	            }
	
	            var company = deployment.company;
	            if (company) {
	                if ((typeof company === "undefined" ? "undefined" : (0, _typeof3.default)(company)) === "object" && company.url) {
	                    return company.url;
	                }
	                if (typeof company === "string" && company.length) {
	                    return company;
	                }
	            }
	
	            var cachedCompany = this.$companies && this.$companies.getCached ? this.$companies.getCached() : null;
	            if (cachedCompany && cachedCompany.url) {
	                return cachedCompany.url;
	            }
	
	            return null;
	        }
	    }, {
	        key: "copyDeployment",
	        value: function copyDeployment() {
	            var url = (0, _lodash.cloneDeep)(this.deployment.url);
	            var uris = (0, _lodash.cloneDeep)(this.deployment.uris);
	            var secret_id = (0, _lodash.cloneDeep)(this.deployment.secret_id);
	            var name = (0, _lodash.cloneDeep)(this.deployment.name);
	            this.deployment = (0, _lodash.cloneDeep)(this.copiedDeployment);
	            this.deployment.url = url;
	            this.deployment.uris = uris;
	            this.deployment.secret_id = secret_id;
	            this.deployment.name = name;
	            this.updateCompanyAttachmentsUrl(this.deployment);
	        }
	    }, {
	        key: "connectToDropbox",
	        value: function connectToDropbox() {
	            localStorage.setItem("dropboxDeployment", (0, _stringify2.default)(this.deployment));
	            var redirect = ( true ? ("https://cloud.upreach.com") : "http://localhost:3000") + "/app/deployments/";
	            var dropboxToken =  true ? ("q5ig98thtsqjrnh") : "lu4nbb05gj1922c";
	            window.location.href = "https://www.dropbox.com/oauth2/authorize?client_id=" + dropboxToken + "&redirect_uri=" + redirect + "&response_type=code&force_reauthentication=true&token_access_type=offline";
	        }
	    }, {
	        key: "getDropboxToken",
	        value: function getDropboxToken() {
	            var _this2 = this;
	
	            this.$auth.$http({
	                url: "/api/dropbox/token",
	                method: "POST",
	                data: { code: this.$stateParams.code }
	            }).then(function (resp) {
	                var d = localStorage.getItem("dropboxDeployment");
	                d = JSON.parse(d);
	                if (d.local_data_saving === undefined) {
	                    d.local_data_saving = false;
	                }
	                if (d.only_local_data_saving === undefined) {
	                    d.only_local_data_saving = false;
	                }
	                if (d.local_data_path === undefined || d.local_data_path === null) {
	                    d.local_data_path = "";
	                }
	                _this2.deployment = d;
	                _this2.updateCompanyAttachmentsUrl(_this2.deployment);
	                _this2.deployment.dropbox_settings = {
	                    token: resp.data.access_token,
	                    refresh_token: resp.data.refresh_token,
	                    folder: "/upreach/" + (0, _lodash.kebabCase)(_this2.deployment.name),
	                    outputTypes: {
	                        printing: true,
	                        sharing: true,
	                        original: true
	                    },
	                    captureModes: {
	                        photo: true,
	                        gif: true,
	                        boomerang: true,
	                        video: true
	                    },
	                    conditions: {
	                        dataPrivacyPopupAccepted: false,
	                        consentScreenConfirmed: false,
	                        dataFormWasSigned: false,
	                        checkboxConditions: _this2.checkboxConditions
	                    }
	                };
	                localStorage.removeItem("dropboxDeployment");
	            }).catch(function (err) {
	                console.log(err);
	                _this2.$state.go("deployments");
	            });
	        }
	    }, {
	        key: "disconnectFromDropbox",
	        value: function disconnectFromDropbox() {
	            var _this3 = this;
	
	            var confirm = this.$mdDialog.confirm().title("Disconnect from Dropbox?").textContent("This disconnects the Deployment " + this.deployment.name + " from your Dropbox account. ").ok("YES").cancel("NO");
	            this.$mdDialog.show(confirm).then(function () {
	                _this3.deployment.dropbox_settings = {};
	            });
	        }
	    }, {
	        key: "setCheckboxConditionValue",
	        value: function setCheckboxConditionValue(value) {
	            if (value) {
	                this.checkboxConditions.forEach(function (el) {
	                    el.checked = false;
	                });
	            }
	        }
	    }, {
	        key: "saveDeployment",
	        value: function saveDeployment() {
	            var _this4 = this;
	
	            if (this.deployment.booth === "No value") {
	                this.deployment.booth = null;
	            }
	            var deploymentId = this.deployment.id || this.deployment.pk || this.$stateParams.cid || (this.deployment.url ? this.deployment.url.replace(/\/$/, "").split("/").pop() : null);
	            // Update deployment configurations array before saving
	            if (this.configurations) {
	                // Filter out null values (empty slots)
	                this.deployment.configurations = this.configurations.filter(function (config) {
	                    return config !== null && config !== undefined;
	                });
	            }
	
	            // Ensure multi_config object exists and is properly initialized
	            if (!this.deployment.multi_config) {
	                this.deployment.multi_config = {
	                    active: false,
	                    screen_orientation: this.deployment.screenOrientation || "preselected",
	                    screen_width: this.deployment.screen ? this.deployment.screen.width : 1920,
	                    screen_height: this.deployment.screen ? this.deployment.screen.height : 1080,
	                    selected_resolution: null,
	                    standby_screen: false,
	                    standby_screen_activate_time: 30,
	                    standby_screen_after_each_session: false,
	                    standby_screen_image: null,
	                    show_multi_config_before_first_session: false,
	                    background: {
	                        attachment_file: null,
	                        start_screen_background_mode: "image",
	                        start_screen_background_color: "#ffffff",
	                        start_screen_image_style: "stretch",
	                        start_screen_live_view: false
	                    },
	                    configurations_info: []
	                };
	            }
	            if (this.deployment.multi_config.show_multi_config_before_first_session === undefined) {
	                if (this.deployment.show_multi_config_before_first_session !== undefined) {
	                    this.deployment.multi_config.show_multi_config_before_first_session = !!this.deployment.show_multi_config_before_first_session;
	                } else if (this.deployment.multi_config.showMultiConfigBeforeFirstSession !== undefined) {
	                    this.deployment.multi_config.show_multi_config_before_first_session = !!this.deployment.multi_config.showMultiConfigBeforeFirstSession;
	                } else {
	                    this.deployment.multi_config.show_multi_config_before_first_session = false;
	                }
	            }
	            delete this.deployment.show_multi_config_before_first_session;
	            delete this.deployment.showMultiConfigBeforeFirstSession;
	
	            // Sync all settings from radio-group-section to multi_config before saving
	            // Sync screenOrientation from deployment to multi_config
	            if (this.deployment.screenOrientation) {
	                this.deployment.multi_config.screen_orientation = this.deployment.screenOrientation;
	            }
	
	            // Sync screen dimensions from deployment.screen to multi_config
	            // This is critical for Custom Resolution to work properly
	            if (this.deployment.screenOrientation === "custom") {
	                // For custom mode, ensure screen object exists and sync to multi_config
	                if (!this.deployment.screen) {
	                    this.deployment.screen = {};
	                }
	                // Ensure multi_config has the latest values from screen inputs
	                if (this.deployment.screen.width !== undefined && this.deployment.screen.width !== null) {
	                    this.deployment.multi_config.screen_width = this.deployment.screen.width;
	                }
	                if (this.deployment.screen.height !== undefined && this.deployment.screen.height !== null) {
	                    this.deployment.multi_config.screen_height = this.deployment.screen.height;
	                }
	                // Clear selected_resolution for custom mode
	                this.deployment.multi_config.selected_resolution = null;
	            } else if (this.deployment.screen) {
	                // For preselected mode, also sync screen dimensions if they exist
	                if (this.deployment.screen.width !== undefined && this.deployment.screen.width !== null) {
	                    this.deployment.multi_config.screen_width = this.deployment.screen.width;
	                }
	                if (this.deployment.screen.height !== undefined && this.deployment.screen.height !== null) {
	                    this.deployment.multi_config.screen_height = this.deployment.screen.height;
	                }
	            }
	
	            // Sync selected_resolution if preselected mode
	            if (this.deployment.multi_config.screen_orientation === "preselected" && this.selectedResolution) {
	                this.deployment.multi_config.selected_resolution = {
	                    label: this.selectedResolution.label,
	                    width: this.selectedResolution.width,
	                    height: this.selectedResolution.height
	                };
	            }
	
	            // Sync configurations_info into multi_config before save
	            if (this.deployment.multi_config) {
	                if (!this.deployment.multi_config.configurations_info) {
	                    this.deployment.multi_config.configurations_info = [];
	                }
	                // Align indices and merge metadata from configurations_info list
	                var total = this.configurations ? this.configurations.length : 0;
	                var resultList = [];
	
	                var _loop = function _loop(i) {
	                    var info = _this4.configurations_info ? _this4.configurations_info[i] : null;
	                    // Get current touch point (may have been updated via UI)
	                    var currentTouchPoint = _this4.getConfigTouchPoint(i);
	                    var existing = _this4.deployment.multi_config.configurations_info.find(function (ci) {
	                        return ci.config_index === i;
	                    }) || {};
	
	                    // Sync custom_icon from current touch point or existing, prefer customIcon alias
	                    var customIcon = null;
	                    if (currentTouchPoint) {
	                        customIcon = currentTouchPoint.custom_icon || currentTouchPoint.customIcon || null;
	                    } else {
	                        customIcon = existing.custom_icon || existing.customIcon || null;
	                    }
	
	                    resultList.push({
	                        id: info ? info.id : existing.id || null,
	                        url: info ? info.url : existing.url || null,
	                        name: info ? info.name : existing.name || null,
	                        config_index: i,
	                        width: currentTouchPoint ? currentTouchPoint.width || existing.width || 25 : existing.width || 25,
	                        height: currentTouchPoint ? currentTouchPoint.height || existing.height || 25 : existing.height || 25,
	                        x: currentTouchPoint ? currentTouchPoint.x || existing.x || 20 + i * 20 : existing.x || 20 + i * 20,
	                        y: currentTouchPoint ? currentTouchPoint.y || existing.y || 60 : existing.y || 60,
	                        custom_icon: customIcon,
	                        customIcon: customIcon, // Keep alias in sync
	                        angle: currentTouchPoint ? currentTouchPoint.angle || existing.angle || 0 : existing.angle || 0
	                    });
	                };
	
	                for (var i = 0; i < total; i++) {
	                    _loop(i);
	                }
	                this.deployment.multi_config.configurations_info = resultList;
	            }
	
	            // Persist each multi_config configuration touch point before saving deployment
	            var saveMultiConfigPromises = [];
	            if (this.deployment.multi_config && this.deployment.multi_config.configurations_info && deploymentId) {
	                this.deployment.multi_config.configurations_info.forEach(function (tp) {
	                    if (!tp || !tp.id) return;
	                    var showFirst = _this4.deployment.multi_config.show_multi_config_before_first_session !== undefined ? !!_this4.deployment.multi_config.show_multi_config_before_first_session : false;
	                    var payload = {
	                        deployment: deploymentId,
	                        config_index: tp.config_index,
	                        width: tp.width,
	                        height: tp.height,
	                        x: tp.x,
	                        y: tp.y,
	                        angle: tp.angle,
	                        custom_icon: _this4.getAttachmentPk(tp.custom_icon),
	                        show_multi_config_before_first_session: showFirst
	                    };
	                    var action = _this4.multiConfigResource && _this4.multiConfigResource.update ? "update" : "save";
	                    saveMultiConfigPromises.push(_this4.multiConfigResource[action]({ id: tp.id }, payload).$promise);
	                });
	            }
	            // After touch points: save deployment multi_config, then deployment (strict order; no .finally — it could run before PUT finished)
	            var isMultiConfigChanged = this.hasMultiConfigChanged();
	            this.$q.all(saveMultiConfigPromises).then(function () {
	                if (_this4.deployment.multi_config && deploymentId) {
	                    // Ensure screen dimensions are synced before creating payload
	                    if (_this4.deployment.screenOrientation === "custom" && _this4.deployment.screen) {
	                        if (_this4.deployment.screen.width !== undefined && _this4.deployment.screen.width !== null) {
	                            _this4.deployment.multi_config.screen_width = _this4.deployment.screen.width;
	                        }
	                        if (_this4.deployment.screen.height !== undefined && _this4.deployment.screen.height !== null) {
	                            _this4.deployment.multi_config.screen_height = _this4.deployment.screen.height;
	                        }
	                    }
	
	                    var multiConfigPayload = {
	                        active: _this4.deployment.multi_config.active !== undefined ? _this4.deployment.multi_config.active : false,
	                        screen_orientation: _this4.deployment.multi_config.screen_orientation || "preselected",
	                        screen_width: _this4.deployment.multi_config.screen_width !== undefined && _this4.deployment.multi_config.screen_width !== null ? _this4.deployment.multi_config.screen_width : 1920,
	                        screen_height: _this4.deployment.multi_config.screen_height !== undefined && _this4.deployment.multi_config.screen_height !== null ? _this4.deployment.multi_config.screen_height : 1080,
	                        selected_resolution: _this4.deployment.multi_config.selected_resolution || null,
	                        show_multi_config_before_first_session: _this4.deployment.multi_config.show_multi_config_before_first_session !== undefined ? _this4.deployment.multi_config.show_multi_config_before_first_session : false,
	                        standby_screen: _this4.deployment.multi_config.standby_screen !== undefined ? _this4.deployment.multi_config.standby_screen : false,
	                        standby_screen_activate_time: _this4.deployment.multi_config.standby_screen_activate_time !== undefined ? _this4.deployment.multi_config.standby_screen_activate_time : 30,
	                        standby_screen_after_each_session: _this4.deployment.multi_config.standby_screen_after_each_session !== undefined ? _this4.deployment.multi_config.standby_screen_after_each_session : false,
	                        standby_screen_image: _this4.getAttachmentPk(_this4.deployment.multi_config.standby_screen_image),
	                        background: _this4.getAttachmentPk(_this4.deployment.multi_config.background)
	                    };
	
	                    var action = _this4.deploymentMultiConfigResource && _this4.deploymentMultiConfigResource.update ? "update" : "save";
	                    return _this4.deploymentMultiConfigResource[action]({ id: deploymentId }, multiConfigPayload).$promise;
	                }
	                return _this4.$q.resolve();
	            }).then(function () {
	                return _this4.$Deployment.update(_this4.deployment).$promise;
	            }).then(function () {
	                if (isMultiConfigChanged) {
	                    _this4.initialMultiConfig = (0, _lodash.cloneDeep)(_this4.deployment.multi_config || null);
	                }
	                _this4.toastService.showSimple("Deployment saved!", 5000);
	                _this4.$state.go("deployments");
	            }).catch(function (error) {
	                if (error && error.data && error.data.booth) {
	                    _this4.$mdDialog.show(_this4.$mdDialog.alert().clickOutsideToClose(true).title(_this4.gettext("Error")).htmlContent(_this4.gettext("Selected booth is already assigned to another deployment.")).ariaLabel(_this4.gettext("Error")).ok("OK"));
	                } else {
	                    var msg = error && error.data && (error.data.detail || error.data.message) ? String(error.data.detail || error.data.message) : "";
	                    _this4.toastService.showError(msg ? _this4.gettext("Could not save deployment.") + " " + msg : _this4.gettext("Could not save deployment."), 8000);
	                }
	            });
	        }
	    }, {
	        key: "hasMultiConfigChanged",
	        value: function hasMultiConfigChanged() {
	            if (typeof this.initialMultiConfig === "undefined") {
	                return false;
	            }
	            return !(0, _lodash.isEqual)(this.initialMultiConfig || null, this.deployment ? this.deployment.multi_config || null : null);
	        }
	    }, {
	        key: "onOrientationChange",
	        value: function onOrientationChange() {
	            console.log("onOrientationChange=>", this.deployment.multi_config);
	        }
	    }, {
	        key: "changeLayoutSize",
	        value: function changeLayoutSize() {
	            console.log("change size=>", this.deployment.multi_config.screen_height, this.deployment.multi_config.screen_width);
	        }
	    }, {
	        key: "getLayoutMinSize",
	        value: function getLayoutMinSize() {
	            //console.log("getLayoutMinSize");
	        }
	    }, {
	        key: "onStandbyUpload",
	        value: function onStandbyUpload() {
	            var img = this.deployment && this.deployment.multi_config ? this.deployment.multi_config.standby_screen_image : null;
	            console.log("Standby upload callback", img);
	        }
	    }, {
	        key: "changeStandByScreenState",
	        value: function changeStandByScreenState(enabled) {
	            if (!this.deployment || !this.deployment.multi_config) return;
	            // Тогл standby_screen відповідає тільки за свій boolean‑стан.
	            // Не очищаємо standby_screen_image при вимкненні, щоб не губити завантажений файл.
	            if (enabled && !this.deployment.multi_config.standby_screen_image) {
	                this.deployment.multi_config.standby_screen_image = { attachment_file: null };
	            }
	        }
	    }, {
	        key: "clearStandbyScreenImage",
	        value: function clearStandbyScreenImage() {
	            if (!this.deployment || !this.deployment.multi_config) return;
	            // Повністю очищаємо об'єкт standby_screen_image, щоб бекенд не отримував старий attachment
	            this.deployment.multi_config.standby_screen_image = null;
	        }
	    }, {
	        key: "clearMultiConfigBackground",
	        value: function clearMultiConfigBackground() {
	            if (!this.deployment || !this.deployment.multi_config) return;
	            // Повністю очищаємо background, щоб getAttachmentPk не тягнув старий url/id
	            this.deployment.multi_config.background = null;
	        }
	    }, {
	        key: "onScreenOrientationChange",
	        value: function onScreenOrientationChange() {
	            // Ensure multi_config exists
	            if (!this.deployment.multi_config) {
	                this.deployment.multi_config = {
	                    active: false,
	                    screen_orientation: this.deployment.screenOrientation || "preselected",
	                    screen_width: this.deployment.screen ? this.deployment.screen.width : 1920,
	                    screen_height: this.deployment.screen ? this.deployment.screen.height : 1080,
	                    selected_resolution: null,
	                    background: null,
	                    configurations_info: []
	                };
	            }
	
	            // Update multi_config with screen orientation from radio-group-section
	            this.deployment.multi_config.screen_orientation = this.deployment.screenOrientation;
	
	            if (this.deployment.screenOrientation === "preselected" && this.selectedResolution) {
	                if (!this.deployment.screen) this.deployment.screen = {};
	                this.deployment.screen.width = this.selectedResolution.width;
	                this.deployment.screen.height = this.selectedResolution.height;
	
	                // Update multi_config with preselected resolution
	                this.deployment.multi_config.screen_width = this.selectedResolution.width;
	                this.deployment.multi_config.screen_height = this.selectedResolution.height;
	                this.deployment.multi_config.selected_resolution = {
	                    label: this.selectedResolution.label,
	                    width: this.selectedResolution.width,
	                    height: this.selectedResolution.height
	                };
	            } else if (this.deployment.screenOrientation === "custom") {
	                // For custom, sync from screen object
	                if (this.deployment.screen) {
	                    this.deployment.multi_config.screen_width = this.deployment.screen.width || this.deployment.multi_config.screen_width;
	                    this.deployment.multi_config.screen_height = this.deployment.screen.height || this.deployment.multi_config.screen_height;
	                }
	                this.deployment.multi_config.selected_resolution = null;
	            }
	
	            // Re-check all configuration orientations when screen orientation changes
	            this.recheckAllConfigOrientations();
	        }
	    }, {
	        key: "onScreenSizeChange",
	        value: function onScreenSizeChange() {
	            // Ensure multi_config exists
	            if (!this.deployment.multi_config) {
	                this.deployment.multi_config = {
	                    active: false,
	                    screen_orientation: this.deployment.screenOrientation || "preselected",
	                    screen_width: this.deployment.screen ? this.deployment.screen.width : 1920,
	                    screen_height: this.deployment.screen ? this.deployment.screen.height : 1080,
	                    selected_resolution: null,
	                    background: null,
	                    configurations_info: []
	                };
	            }
	
	            // Ensure screen object exists
	            if (!this.deployment.screen) {
	                this.deployment.screen = {};
	            }
	
	            // Sync screen width/height changes to multi_config
	            // Use !== undefined && !== null to allow 0 values
	            if (this.deployment.screenOrientation === "custom") {
	                if (this.deployment.screen.width !== undefined && this.deployment.screen.width !== null) {
	                    this.deployment.multi_config.screen_width = this.deployment.screen.width;
	                }
	                if (this.deployment.screen.height !== undefined && this.deployment.screen.height !== null) {
	                    this.deployment.multi_config.screen_height = this.deployment.screen.height;
	                }
	                // Clear selected_resolution for custom mode
	                this.deployment.multi_config.selected_resolution = null;
	            } else if (this.deployment.screen.width !== undefined && this.deployment.screen.width !== null && this.deployment.screen.height !== undefined && this.deployment.screen.height !== null) {
	                // For preselected mode, also sync if screen dimensions are explicitly set
	                this.deployment.multi_config.screen_width = this.deployment.screen.width;
	                this.deployment.multi_config.screen_height = this.deployment.screen.height;
	            }
	
	            // Re-check all configuration orientations when screen size changes
	            this.recheckAllConfigOrientations();
	        }
	
	        /**
	         * Re-check orientation for all selected configurations
	         */
	
	    }, {
	        key: "recheckAllConfigOrientations",
	        value: function recheckAllConfigOrientations() {
	            var _this5 = this;
	
	            if (!this.selectedConfigsList || !this.configurations_info) {
	                return;
	            }
	
	            // Check each selected configuration
	            this.selectedConfigsList.forEach(function (config, index) {
	                if (config && _this5.configurations_info[index]) {
	                    // Re-check orientation for this config
	                    _this5.checkConfigOrientation(config, index);
	                }
	            });
	        }
	    }, {
	        key: "getConfigs",
	        value: function getConfigs() {
	            var _this6 = this;
	
	            var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	            var configs = null;
	            configs = this.$Configuration.query({ ordering: "name", search: search });
	            configs.$promise.then(function (resp) {
	                _this6.configsList = resp;
	
	                // Initialize configurations array from configurations_info if it exists
	                if (_this6.configurations_info && _this6.configurations_info.length > 0) {
	                    // Ensure configurations array matches configurations_info
	                    if (!_this6.configurations || _this6.configurations.length !== _this6.configurations_info.length) {
	                        _this6.configurations = _this6.configurations_info.map(function (configInfo) {
	                            return configInfo.url;
	                        });
	                    }
	
	                    // Initialize selectedConfigsList from configurations_info
	                    _this6.configurations_info.forEach(function (configInfo, index) {
	                        // Try to find matching config in configsList
	                        var foundConfig = _this6.configsList.find(function (config) {
	                            return config.url === configInfo.url || config.id === configInfo.id;
	                        });
	                        if (foundConfig) {
	                            _this6.selectedConfigsList[index] = foundConfig;
	                            // Check orientation for loaded configurations
	                            _this6.checkConfigOrientation(foundConfig, index);
	                        } else {
	                            // If not found in list, create a temporary object from configInfo
	                            _this6.selectedConfigsList[index] = {
	                                id: configInfo.id,
	                                url: configInfo.url,
	                                name: configInfo.name
	                            };
	                            // Still check orientation even if config not in list
	                            _this6.checkConfigOrientation(_this6.selectedConfigsList[index], index);
	                        }
	                        // Initialize filtered list for this dropdown
	                        _this6.filteredConfigsList[index] = [].concat((0, _toConsumableArray3.default)(_this6.configsList));
	                    });
	                } else {
	                    // Initialize filtered list for each dropdown
	                    if (_this6.configurations) {
	                        _this6.configurations.forEach(function (configId, index) {
	                            // Initialize filtered list for this dropdown
	                            if (!_this6.filteredConfigsList[index] || _this6.filteredConfigsList[index].length === 0) {
	                                _this6.filteredConfigsList[index] = [].concat((0, _toConsumableArray3.default)(_this6.configsList));
	                            }
	                            // Try to find matching config if configId is not null
	                            if (configId) {
	                                _this6.configsList.forEach(function (config) {
	                                    if (config.url === configId) {
	                                        _this6.selectedConfigsList[index] = config;
	                                    }
	                                });
	                            }
	                        });
	                    }
	                }
	
	                // Ensure all existing configuration indices have filtered lists initialized
	                if (_this6.configurations) {
	                    _this6.configurations.forEach(function (configId, index) {
	                        if (!_this6.filteredConfigsList[index]) {
	                            _this6.filteredConfigsList[index] = [].concat((0, _toConsumableArray3.default)(_this6.configsList));
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: "searchConfigurations",
	        value: function searchConfigurations(index) {
	            var _this7 = this;
	
	            var searchTerm = this.searchConfigs[index] ? this.searchConfigs[index].toLowerCase() : "";
	
	            // Clear previous timeout
	            if (this.searchTimeout[index]) {
	                clearTimeout(this.searchTimeout[index]);
	            }
	
	            // If search term is less than 3 characters, show full list
	            if (!searchTerm || searchTerm.length < 3) {
	                this.filteredConfigsList[index] = [].concat((0, _toConsumableArray3.default)(this.configsList));
	                return;
	            }
	
	            // Set new timeout for search
	            this.searchTimeout[index] = setTimeout(function () {
	                // Use API search
	                var configs = _this7.$Configuration.query({ ordering: "name", search: searchTerm });
	                configs.$promise.then(function (resp) {
	                    _this7.filteredConfigsList[index] = resp;
	                });
	            }, 300); // 300ms debounce
	        }
	    }, {
	        key: "isConfigSelected",
	        value: function isConfigSelected(config, currentIndex) {
	            if (!config || !config.name) {
	                return false;
	            }
	
	            // Check already chosen configs (excluding current dropdown)
	            var name = config.name;
	            var usedInSelected = this.selectedConfigsList && this.selectedConfigsList.some(function (selected, idx) {
	                return idx !== currentIndex && selected && selected.name === name;
	            });
	
	            var configsInfo = this.deployment && this.deployment.multi_config && this.deployment.multi_config.configurations_info;
	            var usedInInfo = configsInfo && configsInfo.some(function (info, idx) {
	                return idx !== currentIndex && info && info.name === name;
	            });
	
	            return !!(usedInSelected || usedInInfo);
	        }
	    }, {
	        key: "selectConfig",
	        value: function selectConfig(config, index) {
	            this.selectedConfigsList[index] = config;
	            this.configsDropdownOpen[index] = false;
	            this.searchConfigs[index] = ""; // Clear search after selection
	
	            // Update the configurations array with the selected config's URL
	            // Ensure arrays
	            if (!this.configurations) this.configurations = [];
	            if (!this.configurations_info) this.configurations_info = [];
	            if (!this.deployment.multi_config) this.deployment.multi_config = { configurations_info: [] };
	            if (!this.deployment.multi_config.configurations_info) this.deployment.multi_config.configurations_info = [];
	
	            // Update or add the config at the specific index (legacy)
	            if (this.configurations[index] !== config.url) {
	                this.configurations[index] = config.url;
	            }
	
	            // Update configurations_info
	            this.configurations_info[index] = {
	                id: config.id,
	                url: config.url,
	                name: config.name
	            };
	
	            // Mirror into multi_config.configurations_info
	            var existing = this.deployment.multi_config.configurations_info[index] || {};
	            this.deployment.multi_config.configurations_info[index] = {
	                id: config.id,
	                url: config.url,
	                name: config.name,
	                config_index: index,
	                width: existing.width || 25,
	                height: existing.height || 25,
	                x: existing.x || 20 + index * 20,
	                y: existing.y || 60,
	                custom_icon: existing.custom_icon || null,
	                angle: existing.angle || 0
	            };
	
	            // Persist touch-point data for this config to backend multi-config endpoint
	            var touchPoint = this.deployment.multi_config.configurations_info[index];
	            var deploymentId = this.deployment.id || this.deployment.pk || this.$stateParams.cid || (this.deployment.url ? this.deployment.url.replace(/\/$/, "").split("/").pop() : null);
	            if (!deploymentId) {
	                console.error("Cannot save multi-config: deployment ID is missing");
	                return;
	            }
	            var showFirst = this.deployment.multi_config && this.deployment.multi_config.show_multi_config_before_first_session !== undefined ? !!this.deployment.multi_config.show_multi_config_before_first_session : false;
	            var payload = {
	                deployment: deploymentId,
	                config_index: touchPoint.config_index,
	                width: touchPoint.width,
	                height: touchPoint.height,
	                x: touchPoint.x,
	                y: touchPoint.y,
	                angle: touchPoint.angle,
	                custom_icon: this.getAttachmentPk(touchPoint.custom_icon),
	                show_multi_config_before_first_session: showFirst
	            };
	            // Persist touch-point data for this config to backend multi-config endpoint
	            if (!this.multiConfigResource || !this.multiConfigResource.save) {
	                // Lazy fallback in case resource was not initialized
	                this.multiConfigResource = this.$injector.get("$resource")("/api/configurations/:id/multi-config/");
	            }
	            if (this.multiConfigResource && this.multiConfigResource.save) {
	                this.multiConfigResource.save({ id: config.id }, payload);
	            }
	
	            // Initialize touch point settings for this config in multi_config
	            this.initializeConfigTouchPoint(index, config);
	
	            // Check orientation compatibility
	            this.checkConfigOrientation(config, index);
	        }
	
	        /**
	         * Extract attachment PK/UUID from URL
	         * @param {Object|string} attachment - Attachment object with url property or URL string
	         * @returns {string|null} UUID/PK or null
	         */
	
	    }, {
	        key: "getAttachmentPk",
	        value: function getAttachmentPk(attachment) {
	            if (!attachment) return null;
	
	            var url = null;
	            if (typeof attachment === "string") {
	                url = attachment;
	            } else if (attachment.url) {
	                url = attachment.url;
	            } else if (attachment.id) {
	                return attachment.id;
	            } else if (attachment.pk) {
	                return attachment.pk;
	            }
	
	            if (!url) return null;
	
	            // Extract UUID from URL like "/api/attachments/c76adf9a-b863-488f-940f-ce953bad3878/"
	            var match = url.match(/\/api\/attachments\/([a-f0-9-]+)\//i);
	            if (match && match[1]) {
	                return match[1];
	            }
	
	            // Fallback: try to extract UUID from any URL format
	            var parts = url.split("/").filter(function (p) {
	                return p.length > 0;
	            });
	            var uuidPattern = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
	            for (var i = parts.length - 1; i >= 0; i--) {
	                if (uuidPattern.test(parts[i])) {
	                    return parts[i];
	                }
	            }
	
	            return null;
	        }
	
	        /**
	         * Get deployment orientation based on screen dimensions
	         * @returns {string} 'landscape' or 'portrait'
	         */
	
	    }, {
	        key: "getDeploymentOrientation",
	        value: function getDeploymentOrientation() {
	            if (!this.deployment || !this.deployment.screen) {
	                return null;
	            }
	            var width = this.deployment.screen.width;
	            var height = this.deployment.screen.height;
	
	            if (!width || !height) {
	                return null;
	            }
	
	            return width > height ? "landscape" : "portrait";
	        }
	
	        /**
	         * Check if configuration orientation matches deployment orientation
	         * @param {Object} config - Configuration object
	         * @param {number} index - Index of the configuration in the list
	         */
	
	    }, {
	        key: "checkConfigOrientation",
	        value: function checkConfigOrientation(config, index) {
	            var _this8 = this;
	
	            // Clear previous error for this index
	            this.orientationErrors[index] = null;
	
	            // Get deployment orientation
	            var deploymentOrientation = this.getDeploymentOrientation();
	
	            if (!deploymentOrientation) {
	                // Can't check if deployment orientation is not set
	                return;
	            }
	
	            // Fetch configuration details from API
	            var configUrl = config.url;
	            if (!configUrl) {
	                return;
	            }
	
	            // Use $Configuration service to get full config data
	            var configResource = this.$Configuration.get({ url: configUrl });
	            configResource.$promise.then(function (configData) {
	                // Check if config has json.admin.general.screenOrientation (legacy) or screen_orientation (new)
	                if (configData.json && configData.json.admin && configData.json.admin.general && (configData.json.admin.general.screenOrientation || configData.json.admin.general.screen_orientation)) {
	
	                    var configOrientation = configData.json.admin.general.screenOrientation || configData.json.admin.general.screen_orientation;
	
	                    // Normalize orientation values (landscape/portrait)
	                    var normalizedDeploymentOrientation = deploymentOrientation;
	                    var normalizedConfigOrientation = configOrientation === "portrait" ? "portrait" : "landscape";
	
	                    // Check if orientations match
	                    if (normalizedDeploymentOrientation !== normalizedConfigOrientation) {
	                        // Orientation mismatch - set error
	                        _this8.orientationErrors[index] = {
	                            deploymentOrientation: normalizedDeploymentOrientation,
	                            configOrientation: normalizedConfigOrientation,
	                            configName: config.name
	                        };
	
	                        // Show error message
	                        var deploymentOrientationText = normalizedDeploymentOrientation === "landscape" ? "landscape" : "portrait";
	                        var configOrientationText = normalizedConfigOrientation === "landscape" ? "landscape" : "portrait";
	
	                        _this8.toastService.showSimple("Orientation conflict: deployment has " + deploymentOrientationText + " orientation, but configuration \"" + config.name + "\" has " + configOrientationText + " orientation.", 8000);
	                    } else {
	                        // Orientations match - clear error
	                        _this8.orientationErrors[index] = null;
	                    }
	                }
	            }).catch(function (error) {
	                console.error("Error checking configuration orientation:", error);
	                // Don't set error if we can't fetch config data
	            });
	        }
	
	        /**
	         * Get file extension
	         * @param {string} file
	         * @returns {string}
	         */
	
	    }, {
	        key: "getFileType",
	        value: function getFileType(file) {
	            if (!file || typeof file !== "string") {
	                return "";
	            }
	            var cleanFile = file.split("?")[0];
	            var parts = cleanFile.split(".");
	            return parts.length > 1 ? parts.pop().toLowerCase() : "";
	        }
	
	        /**
	         * Initialize or get touch point settings for a configuration
	         * @param {number} index - Index of the configuration
	         * @param {Object} config - Configuration object
	         * @returns {Object} Touch point settings object
	         */
	
	    }, {
	        key: "initializeConfigTouchPoint",
	        value: function initializeConfigTouchPoint(index, config) {
	            if (!this.deployment || !this.deployment.multi_config) {
	                return null;
	            }
	
	            if (!this.deployment.multi_config.configurations_info) {
	                this.deployment.multi_config.configurations_info = [];
	            }
	
	            // Find existing touch point settings for this config
	            var touchPoint = this.deployment.multi_config.configurations_info.find(function (tp) {
	                return tp.config_index === index;
	            });
	
	            if (!touchPoint) {
	                // Initialize default touch point settings
	                touchPoint = {
	                    config_index: index,
	                    config_id: config.id,
	                    config_url: config.url,
	                    width: 25, // Default width in %
	                    height: 25, // Default height in %
	                    x: 20 + index * 20, // Default x position, spaced out
	                    y: 60, // Default y position
	                    custom_icon: null, // Thumbnail image (start-screen-area uses model.custom_icon)
	                    customIcon: null, // compatibility alias for UI components
	                    angle: 0 // Rotation angle
	                };
	                this.deployment.multi_config.configurations_info.push(touchPoint);
	            } else {
	                // Update config reference if changed
	                touchPoint.config_id = config.id;
	                touchPoint.config_url = config.url;
	            }
	            // Keep alias in sync (upload component may set customIcon)
	            if (touchPoint.customIcon && !touchPoint.custom_icon) {
	                touchPoint.custom_icon = touchPoint.customIcon;
	            } else {
	                touchPoint.customIcon = touchPoint.custom_icon;
	            }
	            // Mark video icons to help preview render correctly
	            var iconUrl = touchPoint.custom_icon && (0, _typeof3.default)(touchPoint.custom_icon) === "object" ? touchPoint.custom_icon.attachment_file || touchPoint.custom_icon.thumbnail_file || null : typeof touchPoint.custom_icon === "string" ? touchPoint.custom_icon : null;
	            touchPoint.trueVideo = iconUrl ? /\.(mp4|mov|webm)$/i.test(iconUrl) : false;
	
	            return touchPoint;
	        }
	
	        /**
	         * Get touch point settings for a configuration by index
	         * @param {number} index - Index of the configuration
	         * @returns {Object} Touch point settings object
	         */
	
	    }, {
	        key: "getConfigTouchPoint",
	        value: function getConfigTouchPoint(index) {
	            if (!this.deployment || !this.deployment.multi_config || !this.deployment.multi_config.configurations_info) {
	                return null;
	            }
	
	            var touchPoint = this.deployment.multi_config.configurations_info.find(function (tp) {
	                return tp.config_index === index;
	            });
	
	            if (!touchPoint && this.configurations_info && this.configurations_info[index]) {
	                // Initialize if not exists
	                var configInfo = this.configurations_info[index];
	                touchPoint = this.initializeConfigTouchPoint(index, {
	                    id: configInfo.id,
	                    url: configInfo.url,
	                    name: configInfo.name
	                });
	            }
	
	            // Ensure customIcon and custom_icon are in sync (upload component may set customIcon)
	            if (touchPoint) {
	                // Priority: customIcon (set by upload component) > custom_icon
	                if (touchPoint.customIcon && touchPoint.customIcon !== touchPoint.custom_icon) {
	                    touchPoint.custom_icon = touchPoint.customIcon;
	                } else if (touchPoint.custom_icon && !touchPoint.customIcon) {
	                    touchPoint.customIcon = touchPoint.custom_icon;
	                }
	            }
	
	            return touchPoint;
	        }
	
	        /**
	         * Get all touch point areas formatted for html-preview component
	         * @returns {Object} Object with area keys for html-preview
	         */
	
	    }, {
	        key: "getMultiConfigAreas",
	        value: function getMultiConfigAreas() {
	            if (!this.deployment || !this.deployment.multi_config || !this.deployment.multi_config.configurations_info) {
	                return {};
	            }
	
	            // Convert configurations_info to areas format expected by html-preview
	            // html-preview expects an object with keys, not an array
	            var areas = {};
	            this.deployment.multi_config.configurations_info.forEach(function (touchPoint) {
	                var areaKey = "config" + touchPoint.config_index;
	
	                // Process custom icon (support both custom_icon and customIcon coming from upload widget)
	                var rawIcon = touchPoint.custom_icon || touchPoint.customIcon || null;
	                var iconUrl = rawIcon && (typeof rawIcon === "undefined" ? "undefined" : (0, _typeof3.default)(rawIcon)) === "object" ? rawIcon.attachment_file || rawIcon.thumbnail_file || null : typeof rawIcon === "string" ? rawIcon : null;
	                var isVideoIcon = iconUrl ? /\.(mp4|mov|webm)$/i.test(iconUrl) : false;
	                // Keep custom_icon even for video (html-preview will render <video/>)
	                var custom_icon = null;
	                if (rawIcon) {
	                    if ((typeof rawIcon === "undefined" ? "undefined" : (0, _typeof3.default)(rawIcon)) === "object") {
	                        if (rawIcon.attachment_file || rawIcon.thumbnail_file) {
	                            custom_icon = rawIcon;
	                        }
	                    } else if (typeof rawIcon === "string" && rawIcon.length > 0) {
	                        custom_icon = { attachment_file: rawIcon };
	                    }
	                }
	
	                areas[areaKey] = {
	                    width: touchPoint.width || 25,
	                    height: touchPoint.height || 25,
	                    x: touchPoint.x || 20,
	                    y: touchPoint.y || 60,
	                    custom_icon: custom_icon,
	                    customIcon: custom_icon, // compatibility for preview component
	                    trueVideo: isVideoIcon, // mark for video rendering in html-preview
	                    angle: touchPoint.angle || 0
	                };
	            });
	
	            return areas;
	        }
	
	        /**
	         * Get video background for multi config preview
	         * @returns {string}
	         */
	
	    }, {
	        key: "getMultiConfigVideoBackground",
	        value: function getMultiConfigVideoBackground() {
	            if (!this.deployment || !this.deployment.multi_config || !this.deployment.multi_config.background || !this.deployment.multi_config.background.attachment_file) {
	                return "";
	            }
	
	            var file = this.deployment.multi_config.background.attachment_file;
	            return this.getFileType(file) === "mp4" ? file : "";
	        }
	
	        /**
	         * Get video background for standby screen preview
	         * @returns {string}
	         */
	
	    }, {
	        key: "getMultiConfigStandByVideoBackground",
	        value: function getMultiConfigStandByVideoBackground() {
	            if (!this.deployment || !this.deployment.multi_config || !this.deployment.multi_config.standby_screen_image || !this.deployment.multi_config.standby_screen_image.attachment_file) {
	                return "";
	            }
	
	            var file = this.deployment.multi_config.standby_screen_image.attachment_file;
	            return this.getFileType(file) === "mp4" ? file : "";
	        }
	
	        /**
	         * Check background resolution for multi_config
	         */
	
	    }, {
	        key: "checkBackgroundResolution",
	        value: function checkBackgroundResolution() {
	            var _this9 = this;
	
	            setTimeout(function () {
	                if (_this9.deployment && _this9.deployment.multi_config && _this9.deployment.multi_config.background && _this9.deployment.multi_config.background.attachment_file) {
	
	                    var isVideo = _this9.deployment.multi_config.background.attachment_file.indexOf(".mp4") !== -1;
	                    var VALID_RESOLUTION = _this9.deployment.multi_config.screen_width / _this9.deployment.multi_config.screen_height;
	                    var media = isVideo ? new Video() : new Image();
	                    media.src = _this9.deployment.multi_config.background.attachment_file;
	
	                    if (isVideo) {
	                        media.onloadeddata = function () {
	                            if (media.videoWidth / media.videoHeight !== VALID_RESOLUTION) {
	                                // Resolution mismatch - could show warning if needed
	                            }
	                        };
	                    } else {
	                        media.onload = function () {
	                            if (media.width / media.height !== VALID_RESOLUTION) {
	                                // Resolution mismatch - could show warning if needed
	                            }
	                        };
	                    }
	                }
	
	                function Video() {
	                    return document.createElement("video");
	                }
	            });
	        }
	    }, {
	        key: "addConfig",
	        value: function addConfig() {
	            // Add a new empty configuration slot
	            if (!this.configurations) {
	                this.configurations = [];
	            }
	            if (!this.configurations_info) {
	                this.configurations_info = [];
	            }
	
	            var newIndex = this.configurations.length;
	            this.configurations.push(null);
	            this.selectedConfigsList[newIndex] = null;
	            this.configsDropdownOpen[newIndex] = false;
	            this.searchConfigs[newIndex] = "";
	
	            // Ensure multi_config configs_info has placeholder
	            if (!this.deployment.multi_config) {
	                this.deployment.multi_config = { configurations_info: [] };
	            }
	            if (!this.deployment.multi_config.configurations_info) {
	                this.deployment.multi_config.configurations_info = [];
	            }
	            this.deployment.multi_config.configurations_info[newIndex] = {
	                config_index: newIndex,
	                width: 25,
	                height: 25,
	                x: 20 + newIndex * 20,
	                y: 60,
	                custom_icon: null,
	                angle: 0,
	                id: null,
	                url: null,
	                name: null
	            };
	
	            // Initialize filtered list for the new dropdown
	            // Use a copy of the full configs list
	            if (this.configsList && this.configsList.length > 0) {
	                this.filteredConfigsList[newIndex] = [].concat((0, _toConsumableArray3.default)(this.configsList));
	            } else {
	                this.filteredConfigsList[newIndex] = [];
	                // If configs list is not loaded yet, ensure it gets loaded
	                if (!this.configsList || this.configsList.length === 0) {
	                    this.getConfigs();
	                }
	            }
	        }
	    }, {
	        key: "removeConfig",
	        value: function removeConfig(index) {
	            var _this10 = this;
	
	            if (!this.configurations || index < 0 || index >= this.configurations.length) {
	                return;
	            }
	
	            // Clear timeout if exists
	            if (this.searchTimeout[index] !== undefined) {
	                clearTimeout(this.searchTimeout[index]);
	            }
	
	            // Remove configuration at the specified index
	            this.configurations.splice(index, 1);
	
	            // Remove from configurations_info if it exists
	            if (this.configurations_info && this.configurations_info.length > index) {
	                this.configurations_info.splice(index, 1);
	            }
	
	            // Remove touch point settings from multi_config.configurations_info
	            if (this.deployment && this.deployment.multi_config && this.deployment.multi_config.configurations_info) {
	                // Remove touch point for this index
	                this.deployment.multi_config.configurations_info = this.deployment.multi_config.configurations_info.filter(function (tp) {
	                    return tp.config_index !== index;
	                });
	                // Update config_index for remaining touch points (shift down)
	                this.deployment.multi_config.configurations_info.forEach(function (tp) {
	                    if (tp.config_index > index) {
	                        tp.config_index = tp.config_index - 1;
	                    }
	                });
	            }
	
	            // Rebuild data structures to maintain proper indexing after removal
	            var newSelectedConfigsList = [];
	            var newConfigsDropdownOpen = {};
	            var newSearchConfigs = {};
	            var newFilteredConfigsList = {};
	            var newSearchTimeout = {};
	
	            // Rebuild arrays/objects with correct indices
	            for (var i = 0; i < this.configurations.length; i++) {
	                // For arrays, shift elements down
	                if (i < index) {
	                    // Keep existing data for indices before the removed one
	                    newSelectedConfigsList[i] = this.selectedConfigsList[i] || null;
	                    if (this.configsDropdownOpen[i] !== undefined) {
	                        newConfigsDropdownOpen[i] = this.configsDropdownOpen[i];
	                    }
	                    if (this.searchConfigs[i] !== undefined) {
	                        newSearchConfigs[i] = this.searchConfigs[i];
	                    }
	                    if (this.filteredConfigsList[i] !== undefined) {
	                        newFilteredConfigsList[i] = this.filteredConfigsList[i];
	                    }
	                } else {
	                    // Shift data from next index to current index
	                    var sourceIndex = i + 1;
	                    newSelectedConfigsList[i] = this.selectedConfigsList[sourceIndex] || null;
	                    if (this.configsDropdownOpen[sourceIndex] !== undefined) {
	                        newConfigsDropdownOpen[i] = this.configsDropdownOpen[sourceIndex];
	                    }
	                    if (this.searchConfigs[sourceIndex] !== undefined) {
	                        newSearchConfigs[i] = this.searchConfigs[sourceIndex];
	                    }
	                    if (this.filteredConfigsList[sourceIndex] !== undefined) {
	                        newFilteredConfigsList[i] = this.filteredConfigsList[sourceIndex];
	                    } else if (this.configsList && this.configsList.length > 0) {
	                        // Initialize with full list if not exists
	                        newFilteredConfigsList[i] = [].concat((0, _toConsumableArray3.default)(this.configsList));
	                    }
	                }
	            }
	
	            // Update all data structures
	            this.selectedConfigsList = newSelectedConfigsList;
	            this.configsDropdownOpen = newConfigsDropdownOpen;
	            this.searchConfigs = newSearchConfigs;
	            this.filteredConfigsList = newFilteredConfigsList;
	            this.searchTimeout = newSearchTimeout;
	
	            // Trim multi_config configurations_info to match current configs length
	            if (this.deployment && this.deployment.multi_config && this.deployment.multi_config.configurations_info) {
	                this.deployment.multi_config.configurations_info = this.deployment.multi_config.configurations_info.filter(function (tp) {
	                    return tp.config_index < _this10.configurations.length;
	                }).map(function (tp, idx) {
	                    return (0, _extends3.default)({}, tp, {
	                        config_index: idx
	                    });
	                });
	            }
	        }
	    }]);
	    return DeploymentUpdateController;
	}(_index.$controller);
	
	exports.default = DeploymentUpdateController;

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var countries = exports.countries = [{ name: "Afghanistan", code: "AF" }, { name: "Åland Islands", code: "AX" }, { name: "Albania", code: "AL" }, { name: "Algeria", code: "DZ" }, { name: "American Samoa", code: "AS" }, { name: "Andorra", code: "AD" }, { name: "Angola", code: "AO" }, { name: "Anguilla", code: "AI" }, { name: "Antarctica", code: "AQ" }, { name: "Antigua and Barbuda", code: "AG" }, { name: "Argentina", code: "AR" }, { name: "Armenia", code: "AM" }, { name: "Aruba", code: "AW" }, { name: "Australia", code: "AU" }, { name: "Austria", code: "AT" }, { name: "Azerbaijan", code: "AZ" }, { name: "Bahamas", code: "BS" }, { name: "Bahrain", code: "BH" }, { name: "Bangladesh", code: "BD" }, { name: "Barbados", code: "BB" }, { name: "Belarus", code: "BY" }, { name: "Belgium", code: "BE" }, { name: "Belize", code: "BZ" }, { name: "Benin", code: "BJ" }, { name: "Bermuda", code: "BM" }, { name: "Bhutan", code: "BT" }, { name: "Bolivia", code: "BO" }, { name: "Bosnia and Herzegovina", code: "BA" }, { name: "Botswana", code: "BW" }, { name: "Bouvet Island", code: "BV" }, { name: "Brazil", code: "BR" }, { name: "British Indian Ocean Territory", code: "IO" }, { name: "Brunei Darussalam", code: "BN" }, { name: "Bulgaria", code: "BG" }, { name: "Burkina Faso", code: "BF" }, { name: "Burundi", code: "BI" }, { name: "Cambodia", code: "KH" }, { name: "Cameroon", code: "CM" }, { name: "Canada", code: "CA" }, { name: "Cape Verde", code: "CV" }, { name: "Cayman Islands", code: "KY" }, { name: "Central African Republic", code: "CF" }, { name: "Chad", code: "TD" }, { name: "Chile", code: "CL" }, { name: "China", code: "CN" }, { name: "Christmas Island", code: "CX" }, { name: "Cocos (Keeling) Islands", code: "CC" }, { name: "Colombia", code: "CO" }, { name: "Comoros", code: "KM" }, { name: "Congo", code: "CG" }, { name: "Congo, The Democratic Republic of the", code: "CD" }, { name: "Cook Islands", code: "CK" }, { name: "Costa Rica", code: "CR" }, { name: "Cote D\"Ivoire", code: "CI" }, { name: "Croatia", code: "HR" }, { name: "Cuba", code: "CU" }, { name: "Cyprus", code: "CY" }, { name: "Czech Republic", code: "CZ" }, { name: "Denmark", code: "DK" }, { name: "Djibouti", code: "DJ" }, { name: "Dominica", code: "DM" }, { name: "Dominican Republic", code: "DO" }, { name: "Ecuador", code: "EC" }, { name: "Egypt", code: "EG" }, { name: "El Salvador", code: "SV" }, { name: "Equatorial Guinea", code: "GQ" }, { name: "Eritrea", code: "ER" }, { name: "Estonia", code: "EE" }, { name: "Ethiopia", code: "ET" }, { name: "Falkland Islands (Malvinas)", code: "FK" }, { name: "Faroe Islands", code: "FO" }, { name: "Fiji", code: "FJ" }, { name: "Finland", code: "FI" }, { name: "France", code: "FR" }, { name: "French Guiana", code: "GF" }, { name: "French Polynesia", code: "PF" }, { name: "French Southern Territories", code: "TF" }, { name: "Gabon", code: "GA" }, { name: "Gambia", code: "GM" }, { name: "Georgia", code: "GE" }, { name: "Germany", code: "DE" }, { name: "Ghana", code: "GH" }, { name: "Gibraltar", code: "GI" }, { name: "Greece", code: "GR" }, { name: "Greenland", code: "GL" }, { name: "Grenada", code: "GD" }, { name: "Guadeloupe", code: "GP" }, { name: "Guam", code: "GU" }, { name: "Guatemala", code: "GT" }, { name: "Guernsey", code: "GG" }, { name: "Guinea", code: "GN" }, { name: "Guinea-Bissau", code: "GW" }, { name: "Guyana", code: "GY" }, { name: "Haiti", code: "HT" }, { name: "Heard Island and Mcdonald Islands", code: "HM" }, { name: "Holy See (Vatican City State)", code: "VA" }, { name: "Honduras", code: "HN" }, { name: "Hong Kong", code: "HK" }, { name: "Hungary", code: "HU" }, { name: "Iceland", code: "IS" }, { name: "India", code: "IN" }, { name: "Indonesia", code: "ID" }, { name: "Iran, Islamic Republic Of", code: "IR" }, { name: "Iraq", code: "IQ" }, { name: "Ireland", code: "IE" }, { name: "Isle of Man", code: "IM" }, { name: "Israel", code: "IL" }, { name: "Italy", code: "IT" }, { name: "Jamaica", code: "JM" }, { name: "Japan", code: "JP" }, { name: "Jersey", code: "JE" }, { name: "Jordan", code: "JO" }, { name: "Kazakhstan", code: "KZ" }, { name: "Kenya", code: "KE" }, { name: "Kiribati", code: "KI" }, { name: "Korea, Democratic People\"S Republic of", code: "KP" }, { name: "Korea, Republic of", code: "KR" }, { name: "Kuwait", code: "KW" }, { name: "Kyrgyzstan", code: "KG" }, { name: "Lao People\"S Democratic Republic", code: "LA" }, { name: "Latvia", code: "LV" }, { name: "Lebanon", code: "LB" }, { name: "Lesotho", code: "LS" }, { name: "Liberia", code: "LR" }, { name: "Libyan Arab Jamahiriya", code: "LY" }, { name: "Liechtenstein", code: "LI" }, { name: "Lithuania", code: "LT" }, { name: "Luxembourg", code: "LU" }, { name: "Macao", code: "MO" }, { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" }, { name: "Madagascar", code: "MG" }, { name: "Malawi", code: "MW" }, { name: "Malaysia", code: "MY" }, { name: "Maldives", code: "MV" }, { name: "Mali", code: "ML" }, { name: "Malta", code: "MT" }, { name: "Marshall Islands", code: "MH" }, { name: "Martinique", code: "MQ" }, { name: "Mauritania", code: "MR" }, { name: "Mauritius", code: "MU" }, { name: "Mayotte", code: "YT" }, { name: "Mexico", code: "MX" }, { name: "Micronesia, Federated States of", code: "FM" }, { name: "Moldova, Republic of", code: "MD" }, { name: "Monaco", code: "MC" }, { name: "Mongolia", code: "MN" }, { name: "Montserrat", code: "MS" }, { name: "Morocco", code: "MA" }, { name: "Mozambique", code: "MZ" }, { name: "Myanmar", code: "MM" }, { name: "Namibia", code: "NA" }, { name: "Nauru", code: "NR" }, { name: "Nepal", code: "NP" }, { name: "Netherlands", code: "NL" }, { name: "Netherlands Antilles", code: "AN" }, { name: "New Caledonia", code: "NC" }, { name: "New Zealand", code: "NZ" }, { name: "Nicaragua", code: "NI" }, { name: "Niger", code: "NE" }, { name: "Nigeria", code: "NG" }, { name: "Niue", code: "NU" }, { name: "Norfolk Island", code: "NF" }, { name: "Northern Mariana Islands", code: "MP" }, { name: "Norway", code: "NO" }, { name: "Oman", code: "OM" }, { name: "Pakistan", code: "PK" }, { name: "Palau", code: "PW" }, { name: "Palestinian Territory, Occupied", code: "PS" }, { name: "Panama", code: "PA" }, { name: "Papua New Guinea", code: "PG" }, { name: "Paraguay", code: "PY" }, { name: "Peru", code: "PE" }, { name: "Philippines", code: "PH" }, { name: "Pitcairn", code: "PN" }, { name: "Poland", code: "PL" }, { name: "Portugal", code: "PT" }, { name: "Puerto Rico", code: "PR" }, { name: "Qatar", code: "QA" }, { name: "Reunion", code: "RE" }, { name: "Romania", code: "RO" }, { name: "Russian Federation", code: "RU" }, { name: "RWANDA", code: "RW" }, { name: "Saint Helena", code: "SH" }, { name: "Saint Kitts and Nevis", code: "KN" }, { name: "Saint Lucia", code: "LC" }, { name: "Saint Pierre and Miquelon", code: "PM" }, { name: "Saint Vincent and the Grenadines", code: "VC" }, { name: "Samoa", code: "WS" }, { name: "San Marino", code: "SM" }, { name: "Sao Tome and Principe", code: "ST" }, { name: "Saudi Arabia", code: "SA" }, { name: "Senegal", code: "SN" }, { name: "Serbia and Montenegro", code: "CS" }, { name: "Seychelles", code: "SC" }, { name: "Sierra Leone", code: "SL" }, { name: "Singapore", code: "SG" }, { name: "Slovakia", code: "SK" }, { name: "Slovenia", code: "SI" }, { name: "Solomon Islands", code: "SB" }, { name: "Somalia", code: "SO" }, { name: "South Africa", code: "ZA" }, { name: "South Georgia and the South Sandwich Islands", code: "GS" }, { name: "Spain", code: "ES" }, { name: "Sri Lanka", code: "LK" }, { name: "Sudan", code: "SD" }, { name: "Suriname", code: "SR" }, { name: "Svalbard and Jan Mayen", code: "SJ" }, { name: "Swaziland", code: "SZ" }, { name: "Sweden", code: "SE" }, { name: "Switzerland", code: "CH" }, { name: "Syrian Arab Republic", code: "SY" }, { name: "Taiwan, Province of China", code: "TW" }, { name: "Tajikistan", code: "TJ" }, { name: "Tanzania, United Republic of", code: "TZ" }, { name: "Thailand", code: "TH" }, { name: "Timor-Leste", code: "TL" }, { name: "Togo", code: "TG" }, { name: "Tokelau", code: "TK" }, { name: "Tonga", code: "TO" }, { name: "Trinidad and Tobago", code: "TT" }, { name: "Tunisia", code: "TN" }, { name: "Turkey", code: "TR" }, { name: "Turkmenistan", code: "TM" }, { name: "Turks and Caicos Islands", code: "TC" }, { name: "Tuvalu", code: "TV" }, { name: "Uganda", code: "UG" }, { name: "Ukraine", code: "UA" }, { name: "United Arab Emirates", code: "AE" }, { name: "United Kingdom", code: "GB" }, { name: "United States", code: "US" }, { name: "United States Minor Outlying Islands", code: "UM" }, { name: "Uruguay", code: "UY" }, { name: "Uzbekistan", code: "UZ" }, { name: "Vanuatu", code: "VU" }, { name: "Venezuela", code: "VE" }, { name: "Viet Nam", code: "VN" }, { name: "Virgin Islands, British", code: "VG" }, { name: "Virgin Islands, U.S.", code: "VI" }, { name: "Wallis and Futuna", code: "WF" }, { name: "Western Sahara", code: "EH" }, { name: "Yemen", code: "YE" }, { name: "Zambia", code: "ZM" }, { name: "Zimbabwe", code: "ZW" }];

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(496);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./deployment-update.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./deployment-update.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "deployment-update{font-size:14px}deployment-update h2{padding:10px 0 30px}deployment-update md-radio-button{display:inline-block;margin-right:32px}deployment-update .disabled{opacity:.5;pointer-events:none;cursor:none}deployment-update .deployment-copy{position:relative;width:100%}deployment-update .deployment-copy md-input-container{position:absolute;right:-20%;margin-top:-80px;min-width:240px}deployment-update .location{display:flex}deployment-update .location md-input-container,deployment-update .location select-search{width:50%}deployment-update .location select-search md-input-container{width:100%}deployment-update .status-dropbox{line-height:30px;position:relative;top:1px}deployment-update .dropbox-options md-switch{display:flex;justify-content:space-between;margin:16px}deployment-update .dropbox-options md-switch.checkbox-sync-item{margin-top:5px;margin-bottom:5px}deployment-update .dropbox-options md-switch.checkbox-sync-item.last-item{margin-bottom:16px}deployment-update .deploy-screen-orientation-section,deployment-update .multi-config-section{display:flex;flex-direction:row}deployment-update .deploy-screen-orientation-section .col-6,deployment-update .multi-config-section .col-6{width:48%;display:flex;flex-wrap:wrap;padding-left:10px;padding-right:10px}deployment-update .deploy-screen-orientation-section .col-6 h5,deployment-update .multi-config-section .col-6 h5{color:#25282a;font-size:20px;font-style:normal;font-weight:700;line-height:28px;margin:0}deployment-update .deploy-screen-orientation-section .col-6 .low-text,deployment-update .multi-config-section .col-6 .low-text{color:#666;font-size:14px;font-style:normal;font-weight:400;line-height:normal}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block,deployment-update .multi-config-section .col-6 .choose-configs-block{width:100%}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block h6,deployment-update .multi-config-section .col-6 .choose-configs-block h6{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:normal;margin-top:10px;margin-bottom:6px}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block p,deployment-update .multi-config-section .col-6 .choose-configs-block p{color:#666;font-size:14px;font-style:normal;font-weight:400;line-height:normal;margin-top:0;margin-bottom:16px}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper{margin-bottom:16px}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .dropdown-selected,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper .dropdown-selected{background-color:transparent}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .dropdown-search,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper .dropdown-search{display:flex}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper{display:flex;align-items:flex-start;gap:12px;margin-bottom:12px}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block{flex:1;background-color:transparent;padding:0}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block.orientation-error,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block.orientation-error{border:2px solid #e53935;border-radius:8px;padding:8px}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block.orientation-error .dropdown-selected,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block.orientation-error .dropdown-selected{border-color:#e53935;color:#e53935}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block .orientation-error-message,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block .orientation-error-message{display:flex;align-items:center;gap:8px;margin-top:8px;padding:8px 12px;background-color:#ffebee;border-left:4px solid #e53935;border-radius:4px;color:#c62828;font-size:13px;line-height:1.4}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block .orientation-error-message .error-icon,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block .orientation-error-message .error-icon{color:#e53935;font-size:20px;width:20px;height:20px}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button{margin:0;padding:0;min-width:40px;min-height:40px;width:40px;height:40px;color:#666}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button:hover,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button:hover{background-color:rgba(229,57,53,.1);color:#e53935}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button md-icon,deployment-update .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button md-icon{color:inherit}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .dropdown-resolution-block,deployment-update .multi-config-section .col-6 .choose-configs-block .dropdown-resolution-block{background-color:transparent;margin-bottom:12px}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .add-config-button,deployment-update .multi-config-section .col-6 .choose-configs-block .add-config-button{background-color:#e53935!important;color:#fff!important;border-radius:8px;padding:10px 20px;margin-top:8px;min-height:40px;box-shadow:0 2px 4px rgba(0,0,0,.1);transition:background-color .3s ease}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .add-config-button:hover,deployment-update .multi-config-section .col-6 .choose-configs-block .add-config-button:hover{background-color:#c62828!important}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .add-config-button md-icon,deployment-update .multi-config-section .col-6 .choose-configs-block .add-config-button md-icon{color:#fff;margin-right:8px}deployment-update .deploy-screen-orientation-section .col-6 .choose-configs-block .add-config-button span,deployment-update .multi-config-section .col-6 .choose-configs-block .add-config-button span{color:#fff;font-weight:500}deployment-update .deploy-screen-orientation-section .radio-group-section,deployment-update .multi-config-section .radio-group-section{width:100%}deployment-update .deploy-screen-orientation-section .radio-option-wrapper,deployment-update .multi-config-section .radio-option-wrapper{margin-bottom:20px}deployment-update .deploy-screen-orientation-section .radio-option-wrapper .custom-input-block,deployment-update .multi-config-section .radio-option-wrapper .custom-input-block{display:flex;padding:20px;align-items:flex-start;align-self:stretch;border-radius:10px;background:#fff}deployment-update .deploy-screen-orientation-section .grey-bg-block,deployment-update .multi-config-section .grey-bg-block{display:flex;border-radius:5px;background:#f4f4f4;padding:20px 18px;flex-direction:column;height:fit-content}deployment-update .deploy-screen-orientation-section .grey-bg-block h6,deployment-update .multi-config-section .grey-bg-block h6{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:20px;margin-top:0;margin-bottom:0}deployment-update .deploy-screen-orientation-section .grey-bg-block p,deployment-update .multi-config-section .grey-bg-block p{color:#434648;font-size:14px;font-style:normal;font-weight:400;line-height:normal}deployment-update .multi-config-section{display:flex;flex-direction:row}deployment-update .multi-config-section .col-6{width:50%;display:flex;flex-wrap:wrap}deployment-update .multi-config-section .col-6 .low-text{margin-top:0;color:#666;font-size:14px;font-style:normal;font-weight:400;line-height:normal;margin-bottom:8px}deployment-update .multi-config-section .col-6 md-switch .md-label{color:#25282a;font-size:20px;font-style:normal;font-weight:700;line-height:28px}deployment-update .multi-config-section .col-6 md-switch.multi-config-switch__label--wrap{align-items:flex-start;max-width:100%}deployment-update .multi-config-section .col-6 md-switch.multi-config-switch__label--wrap .md-container{margin-top:2px}deployment-update .multi-config-section .col-6 md-switch.multi-config-switch__label--wrap .md-label{white-space:normal;overflow-wrap:break-word;word-wrap:break-word;max-width:100%;flex:1 1 auto;min-width:0;text-align:left}deployment-update .multi-config-section .col-6 .touch-points-section{width:100%;margin-top:24px;margin-bottom:24px}deployment-update .multi-config-section .col-6 .touch-points-section h6{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:normal;margin-top:0;margin-bottom:8px}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points{margin-top:20px}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item{margin-bottom:24px;padding:16px;background:#f9f9f9;border-radius:8px}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .config-label{margin-bottom:12px;color:#25282a;font-size:14px;font-weight:600}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .config-label strong{color:#25282a}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor{margin:0}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area{width:100%}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .custom-width{min-width:80px;max-width:unset}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .custom-width .md-input{color:#25282a;font-size:14px;border-bottom-color:#000}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .custom-width md-input-container.md-input-has-value label{color:gray;font-size:14px}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .upload-container{flex-direction:column;margin-left:10px;min-width:180px}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .upload-container .md-button.md-primary.md-raised{margin-top:0;width:105px;background-color:#e53935!important}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .upload-container .file-title{margin-left:0!important;flex-direction:row!important;justify-content:flex-start!important}deployment-update .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .upload-container .file-title span{text-overflow:ellipsis;overflow:hidden;width:90px;white-space:nowrap}deployment-update .multi-config-section .col-6 .background-options{width:100%;margin-top:24px}deployment-update .multi-config-section .col-6 .background-options h6{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:normal;margin-top:0;margin-bottom:8px}deployment-update .multi-config-section .col-6 .background-options .file-title{display:flex;align-items:center;margin-top:12px;gap:8px}deployment-update .multi-config-section .col-6 .background-options .file-title span{color:#666;font-size:14px}deployment-update .multi-config-section .col-6.preview-part{align-content:flex-start;justify-content:flex-start}deployment-update .multi-config-section .col-6.preview-part html-preview .preview-main .area.bordered{border:2px solid #000;background-color:#fff}deployment-update .multi-config-section .col-6.preview-part html-preview .preview-main .area.bordered:before{content:\"\";position:absolute;width:100%;height:100%;z-index:60;background:linear-gradient(to top left,transparent 0,transparent calc(50% - 1px),#000 50%,transparent calc(50% + 1px),transparent),linear-gradient(to top right,transparent 0,transparent calc(50% - 1px),#000 50%,transparent calc(50% + 1px),transparent)}@media screen and (max-width:750px){deployment-update .deployment-copy{position:relative;display:flex;justify-content:center}deployment-update .deployment-copy md-input-container{position:static;margin-top:0}}deployment-update .dropdown-resolution-block{position:relative;padding:20px;border-radius:10px;background:#fff}deployment-update .dropdown-resolution-block .dropdown-search{padding:8px 12px;border-bottom:1px solid #dcdcdc}deployment-update .dropdown-resolution-block .dropdown-search .search-input{width:100%;padding:8px;border:1px solid #dcdcdc;border-radius:4px;font-size:14px}deployment-update .dropdown-resolution-block .dropdown-search .search-input:focus{outline:none;border-color:#666}deployment-update .dropdown-resolution-block .dropdown-selected{border-bottom:2px solid #222;padding:10px 36px 10px 0;font-size:15px;cursor:pointer;position:relative;color:#222;background:#fff;min-height:24px}deployment-update .dropdown-resolution-block .dropdown-list{position:relative;left:0;right:0;background:#fff;z-index:1;overflow-y:auto;margin-top:2px}deployment-update .dropdown-resolution-block .dropdown-list:last-child{border-bottom:1px solid #000}deployment-update .dropdown-resolution-block .dropdown-item{padding:8px 12px;font-size:14px;cursor:pointer;border-bottom:1px solid #dcdcdc;background:#fff}deployment-update .dropdown-resolution-block .dropdown-item:last-child{display:flex;justify-content:space-between}deployment-update .dropdown-resolution-block .dropdown-item.selected,deployment-update .dropdown-resolution-block .dropdown-item:hover{background:#f5f5f5}deployment-update .dropdown-resolution-block .dropdown-header{font-size:14px;color:#888;padding:12px 12px 4px;font-weight:400}deployment-update .dropdown-resolution-block .dropdown-group-title{padding:4px 7px;color:#25282a;font-size:15px;font-style:normal;font-weight:700;line-height:normal}deployment-update .dropdown-resolution-block .dropdown-divider{border-bottom:1px solid #e0e0e0;margin:0 0 4px}deployment-update .dropdown-resolution-block .dropdown-item.selected{background:#e9f0fa;font-weight:500}deployment-update .dropdown-resolution-block .dropdown-item.disabled{color:#a0a0a0;cursor:not-allowed;pointer-events:none;background:#f5f5f5}deployment-update .dropdown-arrow{position:absolute;right:0;top:50%;transform:translateY(-50%) rotate(0deg);font-size:18px;pointer-events:none}deployment-update .dropdown-arrow.open{transform:translateY(-50%) rotate(180deg)}deployment-update .dropdown-arrow.close{top:auto;transform:translateY(0) rotate(180deg)}deployment-update .touch-points-section .upload-container .file-title{display:flex;align-items:center}", ""]);
	
	// exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _deploymentSetting = __webpack_require__(498);
	
	var _deploymentSetting2 = _interopRequireDefault(_deploymentSetting);
	
	var _deploymentSetting3 = __webpack_require__(499);
	
	var _deploymentSetting4 = _interopRequireDefault(_deploymentSetting3);
	
	__webpack_require__(500);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeploymentSettingComponent = {
	    template: _deploymentSetting2.default,
	    controller: _deploymentSetting4.default,
	    controllerAs: "DeploymentSetting"
	};
	
	exports.default = DeploymentSettingComponent;

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\">\n    <div flex=\"100\" flex-offset=\"15\" flex-xs=\"100\" flex-offset-xs=\"0\" class=\"main-content\" ng-if=\"!isLoading\" style=\"padding-bottom: 50px;\">\n        <h3>{{ company.name }} - Deployment Settings</h3>\n\n        <div class=\"settings-block\">\n            <div class=\"header\">\n                <h4>Deployment Details</h4>\n                <md-icon ng-if=\"deployment.url\" class=\"material-icons\" title=\"Edit\" ui-sref=\"deployments.update({cid: (deployment.url | getObjectId), company: company.client_type})\">edit</md-icon>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Deployment Name:</span>\n                <span ng-if=\"deployment.name && deployment.name.length\">{{ deployment.name }}</span>\n                <span ng-if=\"!deployment.name || !deployment.name.length\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Deployment ID:</span>\n                <span ng-if=\"deployment.secret_id && deployment.secret_id.length\">{{ deployment.secret_id }}</span>\n                <span ng-if=\"!deployment.secret_id || !deployment.secret_id.length\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\" permission-hide=\"Client,Sub-User\">\n                <span>Deployment Status:</span>\n                <span ng-if=\"deployment.status && deployment.status.length\">{{ DeploymentSetting.updateStatus(deployment.status) }}</span>\n                <span ng-if=\"!deployment.status || !deployment.status.length\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Booth number:</span>\n                <span ng-if=\"deployment.booth && deployment.booth.length\">{{ booth.booth_id }}</span>\n                <span ng-if=\"!deployment.booth || !deployment.booth.length\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\" permission-hide=\"Client,Sub-User\">\n                <span>Logistics handled by:</span>\n                <span ng-if=\"deployment.logistics_type && deployment.logistics_type.length\">{{ deployment.logistics_type === 'by_upreach' ? 'UpReach' : 'Client' }}</span>\n                <span ng-if=\"!deployment.logistics_type || !deployment.logistics_type.length\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n            <div class=\"setting-row\" permission-hide=\"Admin,Manager\">\n                <span>Deployment Starting Date & Time:</span>\n                <span ng-if=\"deployment.deployment_start\">{{ DeploymentSetting.updateDate(deployment.deployment_start) }}</span>\n                <span ng-if=\"!deployment.deployment_start\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n            <div class=\"setting-row\" permission-hide=\"Admin,Manager\">\n                <span>Deployment End Date & Time:</span>\n                <span ng-if=\"deployment.deployment_end\">{{ DeploymentSetting.updateDate(deployment.deployment_end) }}</span>\n                <span ng-if=\"!deployment.deployment_end\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Photos retention time (days):</span>\n                <span ng-if=\"deployment.delete_old_files\">{{ deployment.delete_old_files }}</span>\n                <span ng-if=\"!deployment.delete_old_files\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Local data saving:</span>\n                <span ng-if=\"deployment.local_data_saving\">Active</span>\n                <span ng-if=\"!deployment.local_data_saving\" class=\"no-provided\">Not active</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Only local data saving / no cloud synchronization:</span>\n                <span ng-if=\"deployment.only_local_data_saving\">Active</span>\n                <span ng-if=\"!deployment.only_local_data_saving\" class=\"no-provided\">Not active</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Local data path:</span>\n                <span ng-if=\"deployment.local_data_path && deployment.local_data_path.length\">{{ deployment.local_data_path }}</span>\n                <span ng-if=\"!deployment.local_data_path || !deployment.local_data_path.length\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n        </div>\n\n        <div class=\"settings-block\">\n            <div class=\"header\">\n                <h4>Dropbox connection</h4>\n                <md-icon ng-if=\"deployment.url\" class=\"material-icons\" title=\"Edit\" ui-sref=\"deployments.update({cid: (deployment.url | getObjectId), company: company.client_type})\">edit</md-icon>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Status:</span>\n                <span ng-if=\"deployment.dropbox_settings.token && deployment.dropbox_settings.token.length\" class=\"dropbox-connected\">Connected</span>\n                <span ng-if=\"!deployment.dropbox_settings.token || !deployment.dropbox_settings.token.length\" class=\"no-provided not-connected\">Not connected</span>\n            </div>\n            <div ng-if=\"deployment.dropbox_settings.token && deployment.dropbox_settings.token.length\">\n                <h5>Capture modes:</h5>\n                <div class=\"setting-row\">\n                    <span>Single photo</span>\n                    <span ng-if=\"deployment.dropbox_settings.captureModes.photo\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.captureModes.photo\" class=\"no-provided\">Not active</span>\n                </div>\n                <div class=\"setting-row\">\n                    <span>Gif</span>\n                    <span ng-if=\"deployment.dropbox_settings.captureModes.gif\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.captureModes.gif\" class=\"no-provided\">Not active</span>\n                </div>\n                <div class=\"setting-row\">\n                    <span>Boomerang</span>\n                    <span ng-if=\"deployment.dropbox_settings.captureModes.boomerang\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.captureModes.boomerang\" class=\"no-provided\">Not active</span>\n                </div>\n\n                <h5>Output types:</h5>\n                <div class=\"setting-row\">\n                    <span>Printing layouts</span>\n                    <span ng-if=\"deployment.dropbox_settings.outputTypes.printing\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.outputTypes.printing\" class=\"no-provided\">Not active</span>\n                </div>\n                <div class=\"setting-row\">\n                    <span>Sharing layouts</span>\n                    <span ng-if=\"deployment.dropbox_settings.outputTypes.sharing\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.outputTypes.sharing\" class=\"no-provided\">Not active</span>\n                </div>\n                <div class=\"setting-row\">\n                    <span>Original photos</span>\n                    <span ng-if=\"deployment.dropbox_settings.outputTypes.original\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.outputTypes.original\" class=\"no-provided\">Not active</span>\n                </div>\n\n                <h5>Conditions for sync:</h5>\n                <span style=\"font-size: 11px\">Please note, by default all taken photos are synced with DropBox</span>\n                <!--                <div class=\"setting-row\">-->\n<!--                    <span>Only when data privacy pop-up was accepted</span>-->\n<!--                    <span ng-if=\"deployment.dropbox_settings.conditions.dataPrivacyPopupAccepted\">Active</span>-->\n<!--                    <span ng-if=\"!deployment.dropbox_settings.conditions.dataPrivacyPopupAccepted\" class=\"no-provided\">Not active</span>-->\n<!--                </div>-->\n<!--                <div class=\"setting-row\">-->\n<!--                    <span>Only if user consent screen was confirmed with “yes”</span>-->\n<!--                    <span ng-if=\"deployment.dropbox_settings.conditions.consentScreenConfirmed\">Active</span>-->\n<!--                    <span ng-if=\"!deployment.dropbox_settings.conditions.consentScreenConfirmed\" class=\"no-provided\">Not active</span>-->\n<!--                </div>-->\n                <div class=\"setting-row\">\n                    <span>Only if a data form was signed</span>\n                    <span ng-if=\"deployment.dropbox_settings.conditions.dataFormWasSigned\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.conditions.dataFormWasSigned\" class=\"no-provided\">Not active</span>\n                </div>\n                <div class=\"setting-row\">\n                    <span>Checkbox 1 was selected by user</span>\n                    <span ng-if=\"deployment.dropbox_settings.conditions.checkboxConditions[0].checked\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.conditions.checkboxConditions[0].checked\" class=\"no-provided\">Not active</span>\n                </div>\n                <div class=\"setting-row\">\n                    <span>Checkbox 2 was selected by user</span>\n                    <span ng-if=\"deployment.dropbox_settings.conditions.checkboxConditions[1].checked\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.conditions.checkboxConditions[1].checked\" class=\"no-provided\">Not active</span>\n                </div>\n                <div class=\"setting-row\">\n                    <span>Checkbox 3 was selected by user</span>\n                    <span ng-if=\"deployment.dropbox_settings.conditions.checkboxConditions[2].checked\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.conditions.checkboxConditions[2].checked\" class=\"no-provided\">Not active</span>\n                </div>\n                <div class=\"setting-row\">\n                    <span>Checkbox 4 was selected by user</span>\n                    <span ng-if=\"deployment.dropbox_settings.conditions.checkboxConditions[3].checked\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.conditions.checkboxConditions[3].checked\" class=\"no-provided\">Not active</span>\n                </div>\n                <div class=\"setting-row\">\n                    <span>Checkbox 5 was selected by user</span>\n                    <span ng-if=\"deployment.dropbox_settings.conditions.checkboxConditions[4].checked\">Active</span>\n                    <span ng-if=\"!deployment.dropbox_settings.conditions.checkboxConditions[4].checked\" class=\"no-provided\">Not active</span>\n                </div>\n<!--                <div class=\"setting-row\">-->\n<!--                    <span>Only if all checkboxes from data forms were checked</span>-->\n<!--                    <span ng-if=\"deployment.dropbox_settings.conditions.allCheckboxesChecked\">Active</span>-->\n<!--                    <span ng-if=\"!deployment.dropbox_settings.conditions.allCheckboxesChecked\" class=\"no-provided\">Not active</span>-->\n<!--                </div>-->\n\n                <div class=\"setting-row\">\n                    <span>Folder</span>\n                    <span ng-if=\"deployment.dropbox_settings.folder\">{{ deployment.dropbox_settings.folder }}</span>\n                    <span ng-if=\"!deployment.dropbox_settings.folder\" class=\"no-provided\">(not provided)</span>\n                </div>\n            </div>\n\n\n        </div>\n\n        <div class=\"settings-block\" permission-hide=\"Client,Sub-User\">\n            <div class=\"header\">\n                <h4>Deployment Location Details</h4>\n                <md-icon ng-if=\"deployment.url\" class=\"material-icons\" title=\"Edit\" ui-sref=\"deployments.update({cid: (deployment.url | getObjectId), company: company.client_type})\">edit</md-icon>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Location Name:</span>\n                <span ng-if=\"deployment.location_address && deployment.location_address.locationName\">{{ deployment.location_address.locationName }}</span>\n                <span ng-if=\"!deployment.location_address || !deployment.location_address.locationName\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Address:</span>\n                <span ng-if=\"deployment.location_address && (deployment.location_address.street || deployment.location_address.houseNo)\">{{ deployment.location_address.street }} {{ deployment.location_address.houseNo }}</span>\n                <span ng-if=\"!deployment.location_address || (!deployment.location_address.street && !deployment.location_address.houseNo)\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Zip Code:</span>\n                <span ng-if=\"deployment.location_address && deployment.location_address.zipCode\">{{ deployment.location_address.zipCode }}</span>\n                <span ng-if=\"!deployment.location_address || !deployment.location_address.zipCode\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>City:</span>\n                <span ng-if=\"deployment.location_address && deployment.location_address.city\">{{ deployment.location_address.city }}</span>\n                <span ng-if=\"!deployment.location_address || !deployment.location_address.city\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Country:</span>\n                <span ng-if=\"deployment.location_address && deployment.location_address.country\">{{ DeploymentSetting.updateCountry(deployment.location_address.country) }}</span>\n                <span ng-if=\"!deployment.location_address || !deployment.location_address.country\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Delivery Starting Date & Time:</span>\n                <span ng-if=\"deployment.deployment_start\">{{ DeploymentSetting.updateDate(deployment.deployment_start) }}</span>\n                <span ng-if=\"!deployment.deployment_start\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Delivery End Date & Time:</span>\n                <span ng-if=\"deployment.deployment_end\">{{ DeploymentSetting.updateDate(deployment.deployment_end) }}</span>\n                <span ng-if=\"!deployment.deployment_end\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n        </div>\n\n        <div class=\"settings-block\" ng-show=\"deployment.logistics_type === 'by_upreach'\" permission-hide=\"Client,Sub-User\">\n            <div class=\"header\">\n                <h4>Deployment Delivery Details</h4>\n                <md-icon ng-if=\"deployment.url\" class=\"material-icons\" title=\"Edit\" ui-sref=\"deployments.update({cid: (deployment.url | getObjectId), company: company.client_type})\">edit</md-icon>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Address:</span>\n                <span ng-if=\"deployment.delivery_address && (deployment.delivery_address.street || deployment.delivery_address.houseNo)\">{{ deployment.delivery_address.street }} {{ deployment.delivery_address.houseNo }}</span>\n                <span ng-if=\"!deployment.delivery_address || (!deployment.delivery_address.street && !deployment.delivery_address.houseNo)\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Zip Code:</span>\n                <span ng-if=\"deployment.delivery_address && deployment.delivery_address.zipCode\">{{ deployment.delivery_address.zipCode }}</span>\n                <span ng-if=\"!deployment.delivery_address || !deployment.delivery_address.zipCode\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>City:</span>\n                <span ng-if=\"deployment.delivery_address && deployment.delivery_address.city\">{{ deployment.delivery_address.city }}</span>\n                <span ng-if=\"!deployment.delivery_address || !deployment.delivery_address.city\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Country:</span>\n                <span ng-if=\"deployment.delivery_address && deployment.delivery_address.country\">{{ DeploymentSetting.updateCountry(deployment.delivery_address.country) }}</span>\n                <span ng-if=\"!deployment.delivery_address || !deployment.delivery_address.country\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Delivery Starting Date & Time:</span>\n                <span ng-if=\"deployment.delivery_start\">{{ DeploymentSetting.updateDate(deployment.delivery_start) }}</span>\n                <span ng-if=\"!deployment.delivery_start\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Delivery End Date & Time:</span>\n                <span ng-if=\"deployment.delivery_end\">{{ DeploymentSetting.updateDate(deployment.delivery_end) }}</span>\n                <span ng-if=\"!deployment.delivery_end\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n        </div>\n\n        <div class=\"settings-block\" ng-show=\"deployment.logistics_type === 'by_upreach'\" permission-hide=\"Client,Sub-User\">\n            <div class=\"header\">\n                <h4>Deployment Collection Details:</h4>\n                <md-icon ng-if=\"deployment.url\" class=\"material-icons\" title=\"Edit\" ui-sref=\"deployments.update({cid: (deployment.url | getObjectId), company: company.client_type})\">edit</md-icon>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Address:</span>\n                <span ng-if=\"deployment.collection_address && (deployment.collection_address.street || deployment.collection_address.houseNo)\">{{ deployment.collection_address.street }} {{ deployment.collection_address.houseNo }}</span>\n                <span ng-if=\"!deployment.collection_address || (!deployment.collection_address.street && !deployment.collection_address.houseNo)\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Zip Code:</span>\n                <span ng-if=\"deployment.collection_address && deployment.collection_address.zipCode\">{{ deployment.collection_address.zipCode }}</span>\n                <span ng-if=\"!deployment.collection_address || !deployment.collection_address.zipCode\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>City:</span>\n                <span ng-if=\"deployment.collection_address && deployment.collection_address.city\">{{ deployment.collection_address.city }}</span>\n                <span ng-if=\"!deployment.collection_address || !deployment.collection_address.city\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Country:</span>\n                <span ng-if=\"deployment.collection_address && deployment.collection_address.country\">{{ DeploymentSetting.updateCountry(deployment.collection_address.country) }}</span>\n                <span ng-if=\"!deployment.collection_address || !deployment.collection_address.country\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Delivery Starting Date & Time:</span>\n                <span ng-if=\"deployment.collection_start\">{{ DeploymentSetting.updateDate(deployment.collection_start) }}</span>\n                <span ng-if=\"!deployment.collection_start\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Delivery End Date & Time:</span>\n                <span ng-if=\"deployment.collection_end\">{{ DeploymentSetting.updateDate(deployment.collection_end) }}</span>\n                <span ng-if=\"!deployment.collection_end\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n        </div>\n\n        <div class=\"settings-block\" ng-show=\"company.client_type === 'single'\" permission-hide=\"Client,Sub-User\">\n            <div class=\"header\">\n                <h4>Shipping Information</h4>\n                <md-icon class=\"material-icons\" title=\"Edit\"  ui-sref=\"deployments.update({cid: (deployment.url | getObjectId), company: company.client_type})\">edit</md-icon>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Company Name:</span>\n                <span ng-if=\"deployment.shipping_info && deployment.shipping_info.companyName\">{{ deployment.shipping_info.companyName }}</span>\n                <span ng-if=\"!deployment.shipping_info || !deployment.shipping_info.companyName\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Contact person:</span>\n                <span ng-if=\"deployment.shipping_info && deployment.shipping_info.contactPerson\">{{ deployment.shipping_info.contactPerson }}</span>\n                <span ng-if=\"!deployment.shipping_info || !deployment.shipping_info.contactPerson\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Contact person phone number:</span>\n                <span ng-if=\"deployment.shipping_info && deployment.shipping_info.contactPersonPhoneNumber\">{{ deployment.shipping_info.contactPersonPhoneNumber }}</span>\n                <span ng-if=\"!deployment.shipping_info || !deployment.shipping_info.contactPersonPhoneNumber\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Address:</span>\n                <span>\n                   <span ng-if=\"deployment.shipping_info && deployment.shipping_info.street\">{{ deployment.shipping_info.street + \" \"}}</span>\n                   <span ng-if=\"deployment.shipping_info && deployment.shipping_info.houseNumber\">{{ deployment.shipping_info.houseNumber }}</span>\n                </span>\n                <span ng-if=\"(!deployment.shipping_info || !deployment.shipping_info.street) && (!deployment.shipping_info || !deployment.shipping_info.houseNumber)\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Zip Code:</span>\n                <span ng-if=\"deployment.shipping_info && deployment.shipping_info.zip\">{{ deployment.shipping_info.zip }}</span>\n                <span ng-if=\"!deployment.shipping_info || !deployment.shipping_info.zip\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>City:</span>\n                <span ng-if=\"deployment.shipping_info && deployment.shipping_info.city\">{{ deployment.shipping_info.city }}</span>\n                <span ng-if=\"!deployment.shipping_info || !deployment.shipping_info.city\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Country:</span>\n                <span ng-if=\"deployment.shipping_info && deployment.shipping_info.country\">{{ DeploymentSetting.updateCountry(deployment.shipping_info.country) }}</span>\n                <span ng-if=\"!deployment.shipping_info || !deployment.shipping_info.country\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n        </div>\n\n        <div class=\"settings-block\" ng-show=\"company.client_type === 'single'\" permission-hide=\"Client,Sub-User\">\n            <div class=\"header\">\n                <h4>Billing Information</h4>\n                <md-icon class=\"material-icons\" title=\"Edit\" ui-sref=\"deployments.update({cid: (deployment.url | getObjectId), company: company.client_type})\">edit</md-icon>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Company Name:</span>\n                <span ng-if=\"deployment.billing_info && deployment.billing_info.companyName\">{{ deployment.billing_info.companyName }}</span>\n                <span ng-if=\"!deployment.billing_info || !deployment.billing_info.companyName\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Contact person:</span>\n                <span ng-if=\"deployment.billing_info && deployment.billing_info.contactPerson\">{{ deployment.billing_info.contactPerson }}</span>\n                <span ng-if=\"!deployment.billing_info || !deployment.billing_info.contactPerson\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Contact person phone number:</span>\n                <span ng-if=\"deployment.billing_info && deployment.billing_info.contactPersonPhoneNumber\">{{ deployment.billing_info.contactPersonPhoneNumber }}</span>\n                <span ng-if=\"!deployment.billing_info || !deployment.billing_info.contactPersonPhoneNumber\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Additional information:</span>\n                <span ng-if=\"deployment.billing_info && deployment.billing_info.additionalInfo\">{{ deployment.billing_info.additionalInfo }}</span>\n                <span ng-if=\"!deployment.billing_info || !deployment.billing_info.additionalInfo\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Address:</span>\n                <span>\n                   <span ng-if=\"deployment.billing_info && deployment.billing_info.street\">{{ deployment.billing_info.street + \" \"}}</span>\n                   <span ng-if=\"deployment.billing_info && deployment.billing_info.houseNumber\">{{ deployment.billing_info.houseNumber }}</span>\n                </span>\n                <span ng-if=\"(!deployment.billing_info || !deployment.billing_info.street) && (!deployment.billing_info || !deployment.billing_info.houseNumber)\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Zip Code:</span>\n                <span ng-if=\"deployment.billing_info && deployment.billing_info.zip\">{{ deployment.billing_info.zip }}</span>\n                <span ng-if=\"!deployment.billing_info || !deployment.billing_info.zip\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>City:</span>\n                <span ng-if=\"deployment.billing_info && deployment.billing_info.city\">{{ deployment.billing_info.city }}</span>\n                <span ng-if=\"!deployment.billing_info || !deployment.billing_info.city\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Country:</span>\n                <span ng-if=\"deployment.billing_info && deployment.billing_info.country\">{{ DeploymentSetting.updateCountry(deployment.billing_info.country) }}</span>\n                <span ng-if=\"!deployment.billing_info || !deployment.billing_info.country\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Tax ID:</span>\n                <span ng-if=\"deployment.billing_info && deployment.billing_info.tax\">{{ deployment.billing_info.tax }}</span>\n                <span ng-if=\"!deployment.billing_info || !deployment.billing_info.tax\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>VAT ID:</span>\n                <span ng-if=\"deployment.billing_info && deployment.billing_info.vat\">{{ deployment.billing_info.vat }}</span>\n                <span ng-if=\"!deployment.billing_info || !deployment.billing_info.vat\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>UpReach Supplier ID:</span>\n                <span ng-if=\"deployment.billing_info && deployment.billing_info.supplierID\">{{ deployment.billing_info.supplierID }}</span>\n                <span ng-if=\"!deployment.billing_info || !deployment.billing_info.supplierID\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Other reference:</span>\n                <span ng-if=\"deployment.billing_info && deployment.billing_info.otherReferences\">{{ deployment.billing_info.otherReferences }}</span>\n                <span ng-if=\"!deployment.billing_info || !deployment.billing_info.otherReferences\" class=\"no-provided\">(not provided)</span>\n            </div>\n        </div>\n\n        <!--        Screen config-->\n        <div class=\"settings-block\">\n            <div class=\"header\">\n                <h4>Assign Configs</h4>\n                <md-icon ng-if=\"deployment.url\" class=\"material-icons\" title=\"Edit\" ui-sref=\"deployments.update({cid: (deployment.url | getObjectId), company: company.client_type})\">edit</md-icon>\n\n            </div>\n            <section layout=\"column\" class=\"setting-row deploy-screen-orientation-section\">\n                <div class=\"col-6\">\n\n                    <p class=\"low-text\">Let visitors choose between multiple experiences (configs) on one device — great for events with multiple campaigns or brands. This enables a custom start screen with tappable areas.</p>\n                    <div class=\"radio-group-section\">\n                        <div class=\"radio-option-wrapper grey-bg-block\">\n                            <div class=\"setting-row\">\n                                <span>Screen Orientation:</span>\n                                <span>{{ DeploymentSetting.getScreenOrientationText() }}</span>\n                            </div>\n                            <div class=\"setting-row\" ng-if=\"DeploymentSetting.getScreenOrientation() === 'preselected'\">\n                                <span>Selected Resolution:</span>\n                                <span>{{ DeploymentSetting.getFormattedResolution() }}</span>\n                            </div>\n                            <div class=\"setting-row\" ng-if=\"DeploymentSetting.getScreenOrientation() === 'custom'\">\n                                <span>Screen Width:</span>\n                                <span>{{ DeploymentSetting.getScreenWidth() }} px</span>\n                            </div>\n                            <div class=\"setting-row\" ng-if=\"DeploymentSetting.getScreenOrientation() === 'custom'\">\n                                <span>Screen Height:</span>\n                                <span>{{ DeploymentSetting.getScreenHeight() }} px</span>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n                <div class=\"col-6\">\n                    <div class=\"grey-bg-block\">\n                        <h6>⚠️Important:</h6>\n                        <p>When assigning more than one Configuration, you must set the screen orientation and resolution here at the deployment level.</p>\n                        <p>All configs added to this deployment must match this screen setup exactly. (Orientation and pixel resolution must be the same.)</p>\n                    </div>\n                </div>\n            </section>\n            <!--        Screen config end-->\n\n            <!--        Multi - config-->\n            <section layout=\"column\" class=\"setting-row multi-config-section\" ng-if=\"DeploymentSetting.getConfigurationsInfo().length > 0 || DeploymentSetting.isMultiConfigActive()\">\n                <div class=\"col-6\">\n                    <md-switch\n                            md-invert\n                            class=\"multi-config-section__title\"\n                            ng-checked=\"DeploymentSetting.isMultiConfigActive()\"\n                            ng-disabled=\"true\">\n                        Multi-Config Start Screen\n                    </md-switch>\n                    <md-switch\n                            md-invert\n                            class=\"multi-config-section__title multi-config-switch__label--wrap\"\n                            ng-checked=\"DeploymentSetting.isShowMultiConfigFirst()\"\n                            ng-disabled=\"true\">\n                        Show multi-config screen only before the first user session\n                    </md-switch>\n                    <p class=\"low-text\" >Let visitors choose between multiple experiences (configs) on one device — great for events with multiple campaigns or brands. This enables a custom start screen with tappable areas.</p>\n\n                    <div class=\"touch-points-section\" ng-if=\"DeploymentSetting.isMultiConfigActive()\">\n                        <div class=\"choose-configs-block\">\n                            <h6>Configs:</h6>\n                            <div class=\"configs-wrapper\">\n                                <div class=\"config-item-wrapper\" ng-repeat=\"configInfo in DeploymentSetting.getConfigurationsInfo() track by $index\">\n                                    <div class=\"dropdown-resolution-block\">\n                                        <div class=\"dropdown-selected\">\n                                            <span>{{ configInfo.name || ('Config ' + ($index + 1)) }}</span>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"config-item-wrapper\" ng-if=\"!DeploymentSetting.getConfigurationsInfo().length\">\n                                    <div class=\"dropdown-resolution-block\">\n                                        <div class=\"dropdown-selected\">\n                                            <span class=\"no-provided\">No configurations assigned</span>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-6 preview-part\" ng-if=\"DeploymentSetting.isMultiConfigActive()\">\n                    <h5>Screen Preview</h5>\n                    <p>A live example of how your content will look based on your selected layout and resolution.</p>\n                    <html-preview\n                            ng-show=\"true\"\n                            pr-width=\"{{ DeploymentSetting.getScreenWidth() }}\"\n                            pr-height=\"{{ DeploymentSetting.getScreenHeight() }}\"\n                            index=\"{{ DeploymentSetting.getScreenWidth() > DeploymentSetting.getScreenHeight() ? (DeploymentSetting.getScreenWidth() * 1.7 / 1000) : (DeploymentSetting.getScreenHeight() * 1.7 / 1000) }}\"\n                            background=\"{{ DeploymentSetting.getMultiConfigBackgroundFile() ? [DeploymentSetting.getMultiConfigBackgroundFile()] : [] }}\"\n                            video-background=\"{{ DeploymentSetting.getMultiConfigVideoBackground() }}\"\n                            areas=\"{{ DeploymentSetting.getMultiConfigAreas() }}\"\n                            related-values=\"true\"\n                            screen=\"screen-preview\"\n                            show-title=\"true\"\n                            ignore-overflow=\"true\"\n                            bg-mode=\"DeploymentSetting.getBackgroundMode()\"\n                            bg-color=\"DeploymentSetting.getBackgroundColor()\"\n                            bg-style=\"DeploymentSetting.getBackgroundStyle()\"\n                            transparency=\"DeploymentSetting.getBackgroundTransparency()\"\n                            config-mode=\"true\">\n                    </html-preview>\n\n                </div>\n            </section>\n\n            <section layout=\"column\" class=\"multi-config-section\" ng-if=\"DeploymentSetting.getStandbyAvailable()\">\n                <div class=\"col-6\">\n                    <div class=\"standby-deployment-options\">\n                        <div>\n                            <p class=\"part-title\">{{'Standby Screen' | translate}}</p>\n                        </div>\n\n                        <div>\n                            <p class=\"part-title__sub-text\">\n                                {{'The Standby Screen is what people will see when the device is not active. Users can close it by tapping anywhere on the screen.' | translate}}\n                            </p>\n                        </div>\n\n                        <div ng-class=\"{'item-disabled': !DeploymentSetting.isStandbyEnabled()}\">\n                            <p>{{'Idle time until the device goes into Standby:' | translate}} <strong>{{DeploymentSetting.getStandbyActivateTime()}}</strong> {{'seconds' | translate}}</p>\n\n                            <div class=\"setting-row\">\n                                <span>{{'After each session' | translate}}:</span>\n                                <span>{{ DeploymentSetting.getStandbyAfterEachSession() ? 'Yes' : 'No' }}</span>\n                            </div>\n\n                            <div class=\"setting-row\">\n                                <span>{{'Standby media' | translate}}:</span>\n                                <span ng-if=\"DeploymentSetting.getStandbyImage()\">{{ DeploymentSetting.getStandbyImage() | getFileName }}</span>\n                                <span ng-if=\"!DeploymentSetting.getStandbyImage()\" class=\"no-provided\">(not provided)</span>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-6 preview-part\" ng-if=\"DeploymentSetting.isStandbyEnabled()\">\n                    <html-preview\n                            pr-width=\"{{DeploymentSetting.getScreenWidth()}}\"\n                            pr-height=\"{{DeploymentSetting.getScreenHeight()}}\"\n                            screen=\"standby\"\n                            index=\"{{DeploymentSetting.getScreenWidth() > DeploymentSetting.getScreenHeight() ? (DeploymentSetting.getScreenWidth() * 1.7 / 1000) : (DeploymentSetting.getScreenHeight() * 1.7 / 1000)}}\"\n                            background=\"{{ DeploymentSetting.getStandbyImage() ? [DeploymentSetting.getStandbyImage()] : [] }}\"\n                            video-background=\"{{DeploymentSetting.getStandbyVideoBackground() }}\"\n                            margin=\"true\"\n                            show-title=\"true\">\n                    </html-preview>\n                </div>\n            </section>\n        </div>\n\n        <!--        Multi - config end-->\n\n    </div>\n    <div ng-if=\"!isLoading\" class=\"deployment-copy\" flex=\"15\">\n        <span ng-click=\"DeploymentSetting.openDeleteDialog(deployment)\">Delete Deployment</span>\n    </div>\n    <div ng-if=\"isLoading\" style=\"text-align: center; margin: 50px 0; width: 100%\">Loading ...</div>\n</div>\n";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _countries = __webpack_require__(494);
	
	var _lodash = __webpack_require__(101);
	
	var _deleteDialog = __webpack_require__(260);
	
	var _deleteDialog2 = __webpack_require__(261);
	
	var _deleteDialog3 = _interopRequireDefault(_deleteDialog2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Deployment", "$companies", "$Booth", "$Company"];
	
	var DeploymentSettingController = function (_$controller) {
	    DeploymentSettingController.$inject = ["$injector", "$stateParams", "$scope", "$ToastService"];
	    (0, _inherits3.default)(DeploymentSettingController, _$controller);
	
	    function DeploymentSettingController($injector, $stateParams, $scope, $ToastService) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, DeploymentSettingController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (DeploymentSettingController.__proto__ || (0, _getPrototypeOf2.default)(DeploymentSettingController)).call(this, $injector, dependencies));
	
	        _this.$scope = $scope;
	        _this.$stateParams = $stateParams;
	        _this.toastService = $ToastService;
	        _this.isNew = true;
	
	        _this.status = {
	            "draft": "Draft",
	            "booked": "Booked",
	            "delivery": "Delivery",
	            "active": "Active",
	            "done": "Done"
	        };
	
	        var deployment = void 0;
	        deployment = _this.$Deployment.get({ id: $stateParams.cid });
	
	        _this.$scope.isLoading = true;
	        deployment && deployment.$promise.then(function (deployment) {
	            _this.$scope.deployment = deployment;
	            _this.getCompany(deployment.company);
	            _this.getBooth(deployment.booth);
	        }).catch(function () {
	            _this.$state.go("deployments");
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(DeploymentSettingController, [{
	        key: "getCompany",
	        value: function getCompany(url) {
	            var _this2 = this;
	
	            var company = this.$Company.get({ url: url });
	            company && company.$promise.then(function (c) {
	                _this2.$scope.company = c;
	                _this2.$scope.isLoading = false;
	            }).catch(function (e) {
	                console.log(e);
	            });
	        }
	    }, {
	        key: "getBooth",
	        value: function getBooth(url) {
	            var _this3 = this;
	
	            var booth = this.$Booth.get({ url: url });
	            booth && booth.$promise.then(function (b) {
	                _this3.$scope.booth = b;
	            }).catch(function (e) {
	                console.log(e);
	            });
	        }
	    }, {
	        key: "openDeleteDialog",
	        value: function openDeleteDialog(item) {
	            var _this4 = this;
	
	            this.$mdDialog.show({
	                title: "Deployment Delete",
	                controller: _deleteDialog.DeleteDialogController,
	                template: _deleteDialog3.default,
	                targetEvent: event,
	                locals: {
	                    callback: function callback() {
	                        _this4.deleteItem(item);
	                    },
	                    target: "deployment",
	                    item: item
	                }
	            });
	        }
	    }, {
	        key: "deleteItem",
	        value: function deleteItem(item) {
	            var _this5 = this;
	
	            item.$delete().then(function () {
	                _this5.undoDelete.undoDelete("deployments", _this5.$filter("getObjectId")(item.url)).then(function () {
	                    _this5.toastService.showSimple("Deletion undone", 5000);
	                }).catch(function () {
	                    _this5.toastService.showError("Could not undone deletion", 5000);
	                });
	                _this5.$state.go("deployments");
	            }).catch(function () {
	                _this5.$state.go("deployments");
	                _this5.toastService.showError("Deployment deleted successfully \"" + item.name + "\".", 5000);
	            });
	        }
	    }, {
	        key: "updateDate",
	        value: function updateDate(date) {
	            date = moment(date).format("DD.MM.YYYY - HH:MM");
	            return date;
	        }
	    }, {
	        key: "updateStatus",
	        value: function updateStatus(status) {
	            return status.charAt(0).toUpperCase() + status.slice(1);
	        }
	    }, {
	        key: "updateCountry",
	        value: function updateCountry(country) {
	            var newValue = (0, _lodash.find)(_countries.countries, { code: country });
	            if (newValue) {
	                return newValue.name;
	            }
	            return null;
	        }
	
	        /**
	         * Get screen orientation display value
	         * @returns {string}
	         */
	
	    }, {
	        key: "getScreenOrientation",
	        value: function getScreenOrientation() {
	            if (!this.$scope.deployment) {
	                return "preselected";
	            }
	            var mc = this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig;
	            if (mc && mc.screen_orientation) {
	                return mc.screen_orientation;
	            }
	            if (mc && mc.screenOrientation) {
	                return mc.screenOrientation;
	            }
	            if (this.$scope.deployment.screenOrientation) {
	                return this.$scope.deployment.screenOrientation;
	            }
	            return "preselected";
	        }
	
	        /**
	         * Get screen width
	         * @returns {number}
	         */
	
	    }, {
	        key: "getScreenWidth",
	        value: function getScreenWidth() {
	            if (!this.$scope.deployment) {
	                return 1920;
	            }
	            var mc = this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig;
	            if (mc) {
	                if (mc.screen_width) return mc.screen_width;
	                if (mc.screenWidth) return mc.screenWidth;
	            }
	            if (this.$scope.deployment.screen && this.$scope.deployment.screen.width) {
	                return this.$scope.deployment.screen.width;
	            }
	            return 1920;
	        }
	
	        /**
	         * Get screen height
	         * @returns {number}
	         */
	
	    }, {
	        key: "getScreenHeight",
	        value: function getScreenHeight() {
	            if (!this.$scope.deployment) {
	                return 1080;
	            }
	            var mc = this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig;
	            if (mc) {
	                if (mc.screen_height) return mc.screen_height;
	                if (mc.screenHeight) return mc.screenHeight;
	            }
	            if (this.$scope.deployment.screen && this.$scope.deployment.screen.height) {
	                return this.$scope.deployment.screen.height;
	            }
	            return 1080;
	        }
	
	        /**
	         * Get selected resolution label
	         * @returns {string}
	         */
	
	    }, {
	        key: "getSelectedResolutionLabel",
	        value: function getSelectedResolutionLabel() {
	            if (!this.$scope.deployment) {
	                return "Not selected";
	            }
	            var mc = this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig;
	            if (mc && mc.selected_resolution && mc.selected_resolution.label) {
	                return mc.selected_resolution.label;
	            }
	            if (mc && mc.selectedResolution && mc.selectedResolution.label) {
	                return mc.selectedResolution.label;
	            }
	            return "Not selected";
	        }
	
	        /**
	         * Get formatted resolution display (e.g., "1080p (1920 x 1080 - Landscape)")
	         * @returns {string}
	         */
	
	    }, {
	        key: "getFormattedResolution",
	        value: function getFormattedResolution() {
	            var width = this.getScreenWidth();
	            var height = this.getScreenHeight();
	
	            if (!width || !height) {
	                return "Not selected";
	            }
	
	            // Determine orientation
	            var orientation = width > height ? "Landscape" : "Portrait";
	
	            // Get resolution label if available
	            var label = this.getSelectedResolutionLabel();
	            if (label && label !== "Not selected") {
	                // Try to extract resolution name from label
	                // Label format might be like "1080p", "1920x1080", "1080p (1920 x 1080)", etc.
	                var resolutionName = "";
	                if (label.includes("(")) {
	                    // Format: "1080p (1920 x 1080)" - extract the part before parenthesis
	                    resolutionName = label.split("(")[0].trim();
	                } else if (label.includes("x") || label.includes("X")) {
	                    // Format: "1920x1080" - try to extract resolution name
	                    var parts = label.split(/[xX]/);
	                    if (parts.length === 2) {
	                        var h = parseInt(parts[1].trim());
	                        // Common resolution names
	                        if (h === 1080) resolutionName = "1080p";else if (h === 720) resolutionName = "720p";else if (h === 1440) resolutionName = "1440p";else if (h === 2160) resolutionName = "4K";else resolutionName = label;
	                    } else {
	                        resolutionName = label;
	                    }
	                } else {
	                    // Format: "1080p" or similar
	                    resolutionName = label;
	                }
	
	                if (resolutionName) {
	                    return resolutionName + " (" + width + " x " + height + " - " + orientation + ")";
	                }
	            }
	
	            // Fallback: just show dimensions and orientation
	            return width + " x " + height + " - " + orientation;
	        }
	
	        /**
	         * Get screen orientation text
	         * @returns {string}
	         */
	
	    }, {
	        key: "getScreenOrientationText",
	        value: function getScreenOrientationText() {
	            var orientation = this.getScreenOrientation();
	            return orientation === "preselected" ? "Choose a Device / Resolution" : "Custom Resolution";
	        }
	
	        /**
	         * Get multi-config active status
	         * @returns {boolean}
	         */
	
	    }, {
	        key: "isMultiConfigActive",
	        value: function isMultiConfigActive() {
	            if (!this.$scope.deployment) {
	                return false;
	            }
	
	            var mc = this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig;
	            var hasAreas = mc && mc.configurations_info && mc.configurations_info.length > 0;
	            var hasTouchPoints = mc && mc.configList && mc.configList.length > 0;
	            var hasConfigsLegacy = this.$scope.deployment.configurations_info && this.$scope.deployment.configurations_info.length > 0;
	
	            if (mc && mc.active !== undefined) {
	                return mc.active === true || hasAreas || hasTouchPoints || hasConfigsLegacy;
	            }
	
	            return hasAreas || hasTouchPoints || hasConfigsLegacy;
	        }
	    }, {
	        key: "isShowMultiConfigFirst",
	        value: function isShowMultiConfigFirst() {
	            if (!this.$scope.deployment) {
	                return false;
	            }
	            var mc = this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig;
	            if (mc && mc.show_multi_config_before_first_session !== undefined) {
	                return !!mc.show_multi_config_before_first_session;
	            }
	            if (mc && mc.showMultiConfigBeforeFirstSession !== undefined) {
	                return !!mc.showMultiConfigBeforeFirstSession;
	            }
	            var d = this.$scope.deployment;
	            if (d.show_multi_config_before_first_session !== undefined) {
	                return !!d.show_multi_config_before_first_session;
	            }
	            if (d.showMultiConfigBeforeFirstSession !== undefined) {
	                return !!d.showMultiConfigBeforeFirstSession;
	            }
	            return false;
	        }
	
	        /**
	         * Get configurations info for display
	         * @returns {Array}
	         */
	
	    }, {
	        key: "getConfigurationsInfo",
	        value: function getConfigurationsInfo() {
	            if (!this.$scope.deployment) {
	                return [];
	            }
	            var mc = this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig;
	            if (mc && mc.configurations_info) {
	                return mc.configurations_info;
	            }
	            return this.$scope.deployment.configurations_info || [];
	        }
	
	        /**
	         * Get multi-config background
	         * @returns {Object|null}
	         */
	
	    }, {
	        key: "getMultiConfigBackground",
	        value: function getMultiConfigBackground() {
	            if (!this.$scope.deployment) {
	                return null;
	            }
	            var mc = this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig;
	            return mc && mc.background ? mc.background : null;
	        }
	
	        /**
	         * Get background file url (image/video) for preview
	         * @returns {string}
	         */
	
	    }, {
	        key: "getMultiConfigBackgroundFile",
	        value: function getMultiConfigBackgroundFile() {
	            var bg = this.getMultiConfigBackground();
	            if (!bg) return "";
	            // prefer attachment_file, fallback to thumbnail_file
	            if (bg.attachment_file) return bg.attachment_file;
	            if (bg.thumbnail_file) return bg.thumbnail_file;
	            return "";
	        }
	
	        // Standby helpers (read-only)
	
	    }, {
	        key: "getStandbyAvailable",
	        value: function getStandbyAvailable() {
	            if (!this.$scope.deployment) return false;
	            var mc = this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig;
	            return !!mc;
	        }
	    }, {
	        key: "isStandbyEnabled",
	        value: function isStandbyEnabled() {
	            var mc = this.$scope.deployment && (this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig);
	            return !!(mc && mc.standby_screen);
	        }
	    }, {
	        key: "getStandbyActivateTime",
	        value: function getStandbyActivateTime() {
	            var mc = this.$scope.deployment && (this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig);
	            return mc && mc.standby_screen_activate_time !== undefined ? mc.standby_screen_activate_time : 0;
	        }
	    }, {
	        key: "getStandbyAfterEachSession",
	        value: function getStandbyAfterEachSession() {
	            var mc = this.$scope.deployment && (this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig);
	            return !!(mc && mc.standby_screen_after_each_session);
	        }
	    }, {
	        key: "getStandbyImage",
	        value: function getStandbyImage() {
	            var mc = this.$scope.deployment && (this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig);
	            var img = mc && mc.standby_screen_image;
	            if (!img) return "";
	            return img.attachment_file || img.thumbnail_file || "";
	        }
	    }, {
	        key: "getStandbyVideoBackground",
	        value: function getStandbyVideoBackground() {
	            var file = this.getStandbyImage();
	            if (!file) return "";
	            var ext = (file.split(".").pop() || "").toLowerCase();
	            return ext === "mp4" ? file : "";
	        }
	
	        /**
	         * Get multi-config areas for preview
	         * @returns {Object}
	         */
	
	    }, {
	        key: "getMultiConfigAreas",
	        value: function getMultiConfigAreas() {
	            if (!this.$scope.deployment) {
	                return {};
	            }
	
	            var mc = this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig || {};
	            var configs = mc.configurations_info || this.$scope.deployment.configurations_info || [];
	            var areas = {};
	
	            configs.forEach(function (cfg, index) {
	                var key = "config" + (cfg.config_index !== undefined ? cfg.config_index : index);
	                var icon = cfg.custom_icon || null;
	                areas[key] = {
	                    width: cfg.width || 25,
	                    height: cfg.height || 25,
	                    x: cfg.x || 20,
	                    y: cfg.y || 60,
	                    angle: cfg.angle || 0,
	                    customIcon: icon ? {
	                        attachment_file: icon.attachment_file || "",
	                        thumbnail_file: icon.thumbnail_file || "",
	                        first_frame: icon.first_frame || "",
	                        original_name: icon.original_name || ""
	                    } : null
	                };
	            });
	
	            return areas;
	        }
	
	        /**
	         * Get video background for multi config preview
	         * @returns {string}
	         */
	
	    }, {
	        key: "getMultiConfigVideoBackground",
	        value: function getMultiConfigVideoBackground() {
	            var file = this.getMultiConfigBackgroundFile();
	            if (!file) return "";
	            var parts = file.split(".");
	            var extension = parts.length > 1 ? parts.pop().toLowerCase() : "";
	            return extension === "mp4" ? file : "";
	        }
	
	        /**
	         * Get config touch point by index
	         * @param {number} index
	         * @returns {Object|null}
	         */
	
	    }, {
	        key: "getConfigTouchPoint",
	        value: function getConfigTouchPoint(index) {
	            if (!this.$scope.deployment) {
	                return null;
	            }
	            var mc = this.$scope.deployment.multi_config || this.$scope.deployment.multiConfig;
	            if (!mc || !mc.configurations_info) {
	                return null;
	            }
	            return mc.configurations_info.find(function (cfg) {
	                return cfg.config_index === index;
	            }) || null;
	        }
	
	        /**
	         * Get background mode for html-preview
	         * @returns {string}
	         */
	
	    }, {
	        key: "getBackgroundMode",
	        value: function getBackgroundMode() {
	            var background = this.getMultiConfigBackground();
	            return background && background.start_screen_background_mode ? background.start_screen_background_mode : "image";
	        }
	
	        /**
	         * Get background color for html-preview
	         * @returns {string}
	         */
	
	    }, {
	        key: "getBackgroundColor",
	        value: function getBackgroundColor() {
	            var background = this.getMultiConfigBackground();
	            return background && background.start_screen_background_color ? background.start_screen_background_color : "#ffffff";
	        }
	
	        /**
	         * Get background style for html-preview
	         * @returns {string}
	         */
	
	    }, {
	        key: "getBackgroundStyle",
	        value: function getBackgroundStyle() {
	            var background = this.getMultiConfigBackground();
	            return background && background.start_screen_image_style ? background.start_screen_image_style : "stretch";
	        }
	
	        /**
	         * Get background transparency for html-preview
	         * @returns {boolean}
	         */
	
	    }, {
	        key: "getBackgroundTransparency",
	        value: function getBackgroundTransparency() {
	            var background = this.getMultiConfigBackground();
	            return background && background.start_screen_live_view ? background.start_screen_live_view : false;
	        }
	    }]);
	    return DeploymentSettingController;
	}(_index.$controller);
	
	exports.default = DeploymentSettingController;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(501);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./deployment-setting.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./deployment-setting.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "deployment-setting .main-content{text-align:center;min-width:400px}deployment-setting .main-content h3{padding:10px 0 30px}deployment-setting .main-content h5{text-align:left}deployment-setting .main-content .settings-block{margin:0 0 30px}deployment-setting .main-content .settings-block .header{position:relative}deployment-setting .main-content .settings-block .header md-icon{position:absolute;top:0;right:0;cursor:pointer}deployment-setting .main-content .settings-block .setting-row{display:flex;justify-content:space-between;padding:12px 0;font-size:12px}deployment-setting .main-content .settings-block .setting-row span:last-child{font-weight:600}deployment-setting .main-content .settings-block .setting-row span.no-provided{font-weight:400;color:gray}deployment-setting .main-content .settings-block .setting-row span.dropbox-connected{color:green}deployment-setting .main-content .settings-block .setting-row span.not-connected{color:red}deployment-setting .deployment-copy{text-align:right;padding:20px}deployment-setting .deployment-copy span{color:#ff3150;text-decoration:underline;font-size:12px;cursor:pointer}deployment-setting .deploy-screen-orientation-section,deployment-setting .multi-config-section{display:flex;flex-direction:row}deployment-setting .deploy-screen-orientation-section .col-6,deployment-setting .multi-config-section .col-6{width:48%;display:flex;flex-wrap:wrap;padding-left:10px;padding-right:10px}deployment-setting .deploy-screen-orientation-section .col-6 h5,deployment-setting .multi-config-section .col-6 h5{color:#25282a;font-size:20px;font-style:normal;font-weight:700;line-height:28px;margin:0}deployment-setting .deploy-screen-orientation-section .col-6 .low-text,deployment-setting .multi-config-section .col-6 .low-text{color:#666;font-size:14px;font-style:normal;font-weight:400;line-height:normal}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block,deployment-setting .multi-config-section .col-6 .choose-configs-block{width:100%}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block h6,deployment-setting .multi-config-section .col-6 .choose-configs-block h6{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:normal;margin-top:10px;margin-bottom:6px}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block p,deployment-setting .multi-config-section .col-6 .choose-configs-block p{color:#666;font-size:14px;font-style:normal;font-weight:400;line-height:normal;margin-top:0;margin-bottom:16px}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper{margin-bottom:16px}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .dropdown-selected,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper .dropdown-selected{background-color:transparent}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .dropdown-search,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper .dropdown-search{display:flex}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper{display:flex;align-items:flex-start;gap:12px;margin-bottom:12px}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block{flex:1;background-color:transparent;padding:0}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block.orientation-error,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block.orientation-error{border:2px solid #e53935;border-radius:8px;padding:8px}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block.orientation-error .dropdown-selected,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block.orientation-error .dropdown-selected{border-color:#e53935;color:#e53935}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block .orientation-error-message,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block .orientation-error-message{display:flex;align-items:center;gap:8px;margin-top:8px;padding:8px 12px;background-color:#ffebee;border-left:4px solid #e53935;border-radius:4px;color:#c62828;font-size:13px;line-height:1.4}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block .orientation-error-message .error-icon,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .dropdown-resolution-block .orientation-error-message .error-icon{color:#e53935;font-size:20px;width:20px;height:20px}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button{margin:0;padding:0;min-width:40px;min-height:40px;width:40px;height:40px;color:#666}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button:hover,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button:hover{background-color:rgba(229,57,53,.1);color:#e53935}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button md-icon,deployment-setting .multi-config-section .col-6 .choose-configs-block .configs-wrapper .config-item-wrapper .delete-config-button md-icon{color:inherit}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .dropdown-resolution-block,deployment-setting .multi-config-section .col-6 .choose-configs-block .dropdown-resolution-block{background-color:transparent;margin-bottom:12px}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .add-config-button,deployment-setting .multi-config-section .col-6 .choose-configs-block .add-config-button{background-color:#e53935!important;color:#fff!important;border-radius:8px;padding:10px 20px;margin-top:8px;min-height:40px;box-shadow:0 2px 4px rgba(0,0,0,.1);transition:background-color .3s ease}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .add-config-button:hover,deployment-setting .multi-config-section .col-6 .choose-configs-block .add-config-button:hover{background-color:#c62828!important}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .add-config-button md-icon,deployment-setting .multi-config-section .col-6 .choose-configs-block .add-config-button md-icon{color:#fff;margin-right:8px}deployment-setting .deploy-screen-orientation-section .col-6 .choose-configs-block .add-config-button span,deployment-setting .multi-config-section .col-6 .choose-configs-block .add-config-button span{color:#fff;font-weight:500}deployment-setting .deploy-screen-orientation-section .radio-group-section,deployment-setting .multi-config-section .radio-group-section{width:100%}deployment-setting .deploy-screen-orientation-section .radio-option-wrapper,deployment-setting .multi-config-section .radio-option-wrapper{margin-bottom:20px}deployment-setting .deploy-screen-orientation-section .radio-option-wrapper .custom-input-block,deployment-setting .multi-config-section .radio-option-wrapper .custom-input-block{display:flex;padding:20px;align-items:flex-start;align-self:stretch;border-radius:10px;background:#fff}deployment-setting .deploy-screen-orientation-section .grey-bg-block,deployment-setting .multi-config-section .grey-bg-block{display:flex;border-radius:5px;background:#f4f4f4;padding:20px 18px;flex-direction:column;height:fit-content}deployment-setting .deploy-screen-orientation-section .grey-bg-block h6,deployment-setting .multi-config-section .grey-bg-block h6{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:20px;margin-top:0;margin-bottom:0}deployment-setting .deploy-screen-orientation-section .grey-bg-block p,deployment-setting .multi-config-section .grey-bg-block p{color:#434648;font-size:14px;font-style:normal;font-weight:400;line-height:normal}deployment-setting .deploy-screen-orientation-section__title[disabled] .md-container,deployment-setting .multi-config-section__title[disabled] .md-container{opacity:.5}deployment-setting .multi-config-section{display:flex;flex-direction:row}deployment-setting .multi-config-section .col-6{width:50%;display:flex;flex-wrap:wrap}deployment-setting .multi-config-section .col-6 .low-text{margin-top:0;color:#666;font-size:14px;font-style:normal;font-weight:400;line-height:normal;margin-bottom:8px}deployment-setting .multi-config-section .col-6 md-switch .md-label{color:#25282a;font-size:20px;font-style:normal;font-weight:700;line-height:28px}deployment-setting .multi-config-section .col-6 md-switch.multi-config-switch__label--wrap{align-items:flex-start;max-width:100%}deployment-setting .multi-config-section .col-6 md-switch.multi-config-switch__label--wrap .md-container{margin-top:2px}deployment-setting .multi-config-section .col-6 md-switch.multi-config-switch__label--wrap .md-label{white-space:normal;overflow-wrap:break-word;word-wrap:break-word;max-width:100%;flex:1 1 auto;min-width:0;text-align:left}deployment-setting .multi-config-section .col-6 .touch-points-section{width:100%;margin-top:24px;margin-bottom:24px}deployment-setting .multi-config-section .col-6 .touch-points-section h6{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:normal;margin-top:0;margin-bottom:8px}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points{margin-top:20px}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item{margin-bottom:24px;padding:16px;background:#f9f9f9;border-radius:8px}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .config-label{margin-bottom:12px;color:#25282a;font-size:14px;font-weight:600}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .config-label strong{color:#25282a}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor{margin:0}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area{width:100%}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .custom-width{min-width:80px;max-width:unset}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .custom-width .md-input{color:#25282a;font-size:14px;border-bottom-color:#000}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .custom-width md-input-container.md-input-has-value label{color:gray;font-size:14px}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .upload-container{flex-direction:column;margin-left:10px;min-width:180px}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .upload-container .md-button.md-primary.md-raised{margin-top:0;width:105px;background-color:#e53935!important}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .upload-container .file-title{margin-left:0!important;flex-direction:row!important;justify-content:flex-start!important}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor start-screen-area .upload-container .file-title span{text-overflow:ellipsis;overflow:hidden;width:90px;white-space:nowrap}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor .readonly-touch-values{display:flex;flex-wrap:wrap;gap:12px;width:100%}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor .readonly-touch-values .setting-row{width:calc(50% - 6px);margin:0;padding:0}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor .readonly-touch-values .setting-row span{display:block;color:#25282a;font-size:14px}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor .readonly-touch-values .setting-row span:first-child{color:#666;font-weight:400;margin-bottom:4px;font-size:12px}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor .readonly-touch-values .setting-row span:last-child{font-weight:500}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor .upload-container{flex-direction:column;margin-left:10px;min-width:180px}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor .upload-container .file-title{margin-left:0!important;flex-direction:row!important;justify-content:flex-start!important;gap:8px}deployment-setting .multi-config-section .col-6 .touch-points-section .config-touch-points .config-touch-point-item .area-editor .upload-container .file-title span{color:#666;font-size:14px}deployment-setting .multi-config-section .col-6 .background-options{width:100%;margin-top:24px}deployment-setting .multi-config-section .col-6 .background-options h6{color:#25282a;font-size:14px;font-style:normal;font-weight:700;line-height:normal;margin-top:0;margin-bottom:8px}deployment-setting .multi-config-section .col-6 .background-options .file-title{display:flex;align-items:center;margin-top:12px;gap:8px}deployment-setting .multi-config-section .col-6 .background-options .file-title span{color:#666;font-size:14px}deployment-setting .multi-config-section .col-6.preview-part{align-content:flex-start;justify-content:flex-start}deployment-setting .multi-config-section .col-6.preview-part html-preview .preview-main .area.bordered{border:2px solid #000;background-color:#fff}deployment-setting .multi-config-section .col-6.preview-part html-preview .preview-main .area.bordered:before{content:\"\";position:absolute;width:100%;height:100%;z-index:60;background:linear-gradient(to top left,transparent 0,transparent calc(50% - 1px),#000 50%,transparent calc(50% + 1px),transparent),linear-gradient(to top right,transparent 0,transparent calc(50% - 1px),#000 50%,transparent calc(50% + 1px),transparent)}deployment-setting .multi-config-section .dropdown-resolution-block{position:relative;padding:20px;border-radius:10px;background:#fff}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-search{padding:8px 12px;border-bottom:1px solid #dcdcdc}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-search .search-input{width:100%;padding:8px;border:1px solid #dcdcdc;border-radius:4px;font-size:14px}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-search .search-input:focus{outline:none;border-color:#666}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-selected{border-bottom:2px solid #222;padding:10px 36px 10px 0;font-size:15px;position:relative;color:#222;background:#fff;min-height:24px}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-list{position:relative;left:0;right:0;background:#fff;z-index:1;overflow-y:auto;margin-top:2px}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-list:last-child{border-bottom:1px solid #000}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-item{padding:8px 12px;font-size:14px;cursor:pointer;border-bottom:1px solid #dcdcdc;background:#fff}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-item:last-child{display:flex;justify-content:space-between}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-item.selected,deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-item:hover{background:#f5f5f5}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-header{font-size:14px;color:#888;padding:12px 12px 4px;font-weight:400}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-group-title{padding:4px 7px;color:#25282a;font-size:15px;font-style:normal;font-weight:700;line-height:normal}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-divider{border-bottom:1px solid #e0e0e0;margin:0 0 4px}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-item.selected{background:#e9f0fa;font-weight:500}deployment-setting .multi-config-section .dropdown-resolution-block .dropdown-item.disabled{color:#a0a0a0;cursor:not-allowed;pointer-events:none;background:#f5f5f5}deployment-setting .multi-config-section .dropdown-arrow{position:absolute;right:0;top:50%;transform:translateY(-50%) rotate(0deg);font-size:18px;pointer-events:none}deployment-setting .multi-config-section .dropdown-arrow.open{transform:translateY(-50%) rotate(180deg)}deployment-setting .multi-config-section .dropdown-arrow.close{top:auto;transform:translateY(0) rotate(180deg)}deployment-setting .multi-config-section .touch-points-section .upload-container .file-title{display:flex;align-items:center}", ""]);
	
	// exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _clientsRouter = __webpack_require__(503);
	
	var _clientsRouter2 = _interopRequireDefault(_clientsRouter);
	
	var _clientsComponent = __webpack_require__(504);
	
	var _clientsComponent2 = _interopRequireDefault(_clientsComponent);
	
	var _clientList = __webpack_require__(507);
	
	var _clientList2 = _interopRequireDefault(_clientList);
	
	var _clientCreate = __webpack_require__(512);
	
	var _clientCreate2 = _interopRequireDefault(_clientCreate);
	
	var _clientSettings = __webpack_require__(517);
	
	var _clientSettings2 = _interopRequireDefault(_clientSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Module = angular.module("app.clients", []).component("clients", _clientsComponent2.default).component("clientList", _clientList2.default).component("clientCreate", _clientCreate2.default).component("clientSettings", _clientSettings2.default).config(_clientsRouter2.default);
	
	exports.default = Module;

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	"use strict";
	
	Router.$inject = ["$stateProvider", "$urlRouterProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Router;
	function Router($stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $urlRouterProvider.when("/app/clients", "/app/clients/");
	
	    $stateProvider.state({
	        name: "clients",
	        url: "/app/clients",
	        template: "<clients></clients>",
	        resolve: {
	            $title: function $title() {
	                return "Clients | UpReach Cloud";
	            }
	        }
	    }).state({
	        name: "clients.list",
	        url: "/:createdCompany",
	        template: "<client-list></client-list>",
	        resolve: {
	            $title: function $title() {
	                return "Clients | UpReach Cloud";
	            }
	        }
	    }).state({
	        name: "clients.create",
	        url: "/create/?:id",
	        template: "<client-create></client-create>",
	        resolve: {
	            $title: function $title() {
	                return "Client Create | UpReach Cloud";
	            }
	        }
	    }).state({
	        name: "clients.settings",
	        url: "/settings/:id",
	        template: "<client-settings></client-settings>",
	        resolve: {
	            $title: function $title() {
	                return "Client Setting | UpReach Cloud";
	            }
	        }
	    });
	}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _clients = __webpack_require__(505);
	
	var _clients2 = _interopRequireDefault(_clients);
	
	var _clients3 = __webpack_require__(506);
	
	var _clients4 = _interopRequireDefault(_clients3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigurationsComponent = {
	    template: _clients2.default,
	    controller: _clients4.default,
	    controllerAs: "controller"
	};
	
	exports.default = ConfigurationsComponent;

/***/ }),
/* 505 */
234,
/* 506 */
235,
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _clientList = __webpack_require__(508);
	
	var _clientList2 = _interopRequireDefault(_clientList);
	
	var _clientList3 = __webpack_require__(509);
	
	var _clientList4 = _interopRequireDefault(_clientList3);
	
	__webpack_require__(510);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Component = {
	    template: _clientList2.default,
	    controller: _clientList4.default,
	    controllerAs: "controller"
	};
	
	exports.default = Component;

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = "<md-content layout=\"column\" flex layout-align=\"top center\">\n    <md-card>\n        <md-toolbar class=\"md-table-toolbar md-default\">\n            <div class=\"md-toolbar-tools\">\n                <span>Clients</span>\n                <div flex></div>\n\n                <div flex=\"70\" class=\"md-toolbar-tools md-toolbar-search\" ng-if=\"filter.show\" layout=\"row\" layout-align=\"center right\">\n                    <md-input-container md-no-float flex>\n                        <input ng-blur=\"controller.onSearchBlur()\" type=\"text\" id=\"search-field\" placeholder=\"Search in the Client table\" ng-model=\"query.search\" ng-model-options=\"filter.options\" class=\"ng-pristine ng-valid ng-touched\">\n                    </md-input-container>\n                    <button class=\"md-icon-button md-button md-ink-ripple\" type=\"button\" ng-click=\"controller.removeFilter()\" layout-align=\"center right\">\n                        <md-icon class=\"material-icons\">search</md-icon>\n                        <div class=\"md-ripple-container\"></div>\n                    </button>\n                </div>\n                <md-button class=\"md-icon-button md-button md-ink-ripple\" ng-click=\"controller.showFilter()\" ng-if=\"!filter.show\" ng-show=\"companies.length\">\n                    <md-icon class=\"material-icons\">search</md-icon>\n                    <div class=\"md-ripple-container\"></div>\n                </md-button>\n\n                <md-button class=\"md-icon-button md-button md-ink-ripple\" ng-click=\"selectFilter.show = !selectFilter.show\" ng-class=\"{reverse: !selectFilter.show}\" ng-show=\"companies.length\">\n                    <md-icon class=\"material-icons\">filter_list</md-icon>\n                    <div class=\"md-ripple-container\"></div>\n                </md-button>\n\n                <md-button class=\"md-icon-button\" ui-sref=\"clients.create\">\n                    <md-icon class=\"material-icons\">add</md-icon>\n                </md-button>\n            </div>\n        </md-toolbar>\n\n        <!--<md-table-container ng-if=\"! configurations._meta.count\" class=\"no-items\">-->\n        <md-table-container ng-if=\"!companies.length\" class=\"no-items\">\n            <div ng-if=\"loading\" translate>Loading clients list...</div>\n            <div ng-if=\"!loading && !filter.show\" translate>You have not added any client yet.<br/> Press the Plus button on the top right of this table to add your first client!</div>\n            <div ng-if=\"!loading && filter.show\" translate>No results found for: '{{ query.search }}'</div>\n        </md-table-container>\n\n        <md-table-container ng-if=\"selectFilter.show\" class=\"filters\">\n            <div>\n                <span>Filter options:</span>\n            </div>\n            <div>\n                <md-select ng-model=\"selectFilter.managers\" ng-change=\"controller.setFilter()\" placeholder=\"Client Manager\">\n                    <md-option value=\"\">Any</md-option>\n                    <md-option value=\"{{user.url | getObjectId}}\" ng-repeat=\"user in managers\">{{user.first_name}} {{user.last_name}}</md-option>\n                </md-select>\n            </div>\n            <div class=\"divider\"></div>\n            <div>\n                <md-select ng-model=\"selectFilter.status\" ng-change=\"controller.setFilter()\" placeholder=\"Status\">\n                    <md-option value=\"\">Any</md-option>\n                    <md-option value=\"lead\" >Lead</md-option>\n                    <md-option value=\"booked\" >Booked</md-option>\n                </md-select>\n            </div>\n            <div class=\"divider\"></div>\n            <div>\n                <md-select ng-model=\"selectFilter.client_type\" ng-change=\"controller.setFilter()\" placeholder=\"Type\">\n                    <md-option value=\"\">Any</md-option>\n                    <md-option value=\"single\" >Single Rental</md-option>\n                    <md-option value=\"longterm\" >Long-term Rental</md-option>\n                    <md-option value=\"purchase\" >Purchase</md-option>\n                </md-select>\n            </div>\n        </md-table-container>\n\n        <!--<md-table-container ng-if=\"configurations._meta.count\">-->\n        <md-table-container ng-if=\"companies.length\">\n            <table md-table md-row-select=\"options.rowSelection\" multiple=\"{{options.multiSelect}}\" ng-model=\"selected\" md-progress=\"promise\">\n                <thead ng-if=\"!options.decapitate\" md-head md-order=\"query.order\" md-on-reorder=\"logOrder\">\n                    <tr md-row>\n                        <th md-column md-order-by=\"_name\"><span>{{'Client Name' | translate}}</span></th>\n                        <th md-column md-order-by=\"_managers__first_name\"><span>{{'Client Manager' | translate}}</span></th>\n                        <th md-column md-order-by=\"_status\"><span>{{'Status' | translate}}</span></th>\n                        <th md-column md-order-by=\"_client_type\"><span>{{'Type' | translate}}</span></th>\n                        <th md-column md-order-by=\"_admins__first_name\"><span>{{'Client Admin' | translate}}</span></th>\n                        <th></th>\n                    </tr>\n                </thead>\n                <tbody md-body>\n                <tr md-row ng-repeat=\"item in companies | orderBy: query.order | limitTo: query.limit : (query.page -1) * query.limit\" ui-sref=\"clients.settings({id: (item.url | getObjectId)})\">\n\n                    <td md-cell>{{item.name}}</td>\n                    <td md-cell title=\"{{controller.transformClientsArr(item.managers_info, true)}}\">{{controller.transformClientsArr(item.managers_info)}}</td>\n                    <td md-cell>{{item.status}}</td>\n                    <td md-cell>{{item.client_type}}</td>\n                    <td md-cell title=\"{{controller.transformClientsArr(item.admins_info, true)}}\">{{controller.transformClientsArr(item.admins_info)}}</td>\n\n                    <td md-cell  layout=\"row\" layout-align=\"center end\">\n                        <span flex></span>\n                        <md-menu md-position-mode=\"target-right target\" >\n                            <md-button aria-label=\"Menu options\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                                <md-icon class=\"material-icons\">more_vert</md-icon>\n                            </md-button>\n                            <md-menu-content width=\"1\" >\n                                <md-menu-item>\n                                    <md-button ng-click=\"controller.openInNewTab(item.url | getObjectId)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>Open in new tab</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">tab</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n                            </md-menu-content>\n                        </md-menu>\n                    </td>\n\n                </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <!--<md-table-pagination ng-if=\"companies._meta.count > 10\" md-limit=\"10\" md-page=\"query.page\" md-page-select=\"true\" md-total=\"{{companies._meta.count}}\"  ></md-table-pagination>-->\n\n        <button md-button ng-if=\"canAddMore && !loading\" ng-click=\"controller.addMoreItems()\" style=\"color: #FF0051\">Load more</button>\n\n    </md-card>\n</md-content>";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Company", "$Users"];
	
	var Controller = function (_$controller) {
	    Controller.$inject = ["$injector", "$scope", "$state", "$stateParams", "$window", "$ToastService"];
	    (0, _inherits3.default)(Controller, _$controller);
	
	    function Controller($injector, $scope, $state, $stateParams, $window, $ToastService) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, Controller);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Controller.__proto__ || (0, _getPrototypeOf2.default)(Controller)).call(this, $injector, dependencies));
	
	        _this.$state = $state;
	        _this.$stateParams = $stateParams;
	        _this.$scope = $scope;
	        _this.$window = $window;
	        _this.$scope.loading = true;
	        _this.$scope.query = { page: 1, search: "" };
	        _this.$scope.filter = {};
	        _this.$scope.selectedFilter = {};
	        _this.$scope.companies = [];
	        _this.$scope.pageCount = 0;
	        _this.$scope.canAddMore = true;
	        _this.toastService = $ToastService;
	        _this.$scope.logOrder = function () {
	            _this.$scope.query.ordering = _this.$scope.query.order.replace("_", "");
	            _this.query(true);
	        };
	
	        _this.searchByKeyPress = function (event) {
	            var keyName = event.key;
	            var letters = "abcdefghijklmnopqrstuvwxyz";
	            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
	                _this.$scope.$apply(function () {
	                    _this.$scope.filter.show = true;
	                    if (!_this.$scope.query.search) {
	                        _this.$scope.query.search = keyName;
	                    }
	                });
	                (0, _lodash.delay)(function () {
	                    document.getElementById("search-field").focus();
	                }, 100);
	            }
	        };
	
	        var managers = void 0;
	        managers = _this.$Users.query({ groups: 2 });
	        managers && managers.$promise.then(function (managers) {
	            _this.$scope.managers = managers;
	        }).catch(function (e) {
	            console.log(e);
	            _this.$state.go("clients");
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(Controller, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this2 = this;
	
	            this.$scope.selectFilter = { show: false };
	            this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
	            if (this.$stateParams.createdCompany) {
	                var confirm = this.$mdDialog.confirm().title("Company " + this.$stateParams.createdCompany + " created").textContent("Would you like to invite company admin?").ariaLabel("Confirm").ok("Yes").cancel("Invite later");
	
	                this.$mdDialog.show(confirm).then(function () {
	                    _this2.$state.go("users", { "createdCompany": _this2.$stateParams.createdCompany });
	                }, function () {
	                    // $scope.status = 'You decided to keep your debt.';
	                    _this2.$state.go("clients");
	                });
	            }
	            document.addEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "$onDestroy",
	        value: function $onDestroy() {
	            document.removeEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "query",
	        value: function query(isNew) {
	            var _this3 = this;
	
	            this.$scope.query.page = isNew ? 1 : this.$scope.query.page;
	
	            this.$Company.query(this.$scope.query).$promise.then(function (c) {
	                var _$scope$companies;
	
	                _this3.$scope.loading = false;
	
	                isNew ? _this3.$scope.companies = c : (_$scope$companies = _this3.$scope.companies).push.apply(_$scope$companies, (0, _toConsumableArray3.default)(c));
	                _this3.$scope.pageCount = c._meta.page_count;
	                _this3.$scope.canAddMore = _this3.$scope.query.page !== _this3.$scope.pageCount;
	            }).catch(function () {
	                _this3.toastService.showError("Can't load clients", 5000);
	            });
	        }
	    }, {
	        key: "transformClientsArr",
	        value: function transformClientsArr(arr, title) {
	            var newArr = [];
	            (0, _lodash.forEach)(arr, function (user) {
	                newArr.push(user.first_name + " " + user.last_name);
	            });
	            var str = newArr.length > 1 ? newArr.join(title ? "\n" : ", ") : newArr.join("");
	            return str.length > 25 && !title ? str.slice(0, 25) + " ..." : str;
	        }
	    }, {
	        key: "removeFilter",
	        value: function removeFilter() {
	            this.$scope.filter.show = false;
	            this.$scope.query.search = "";
	        }
	    }, {
	        key: "showFilter",
	        value: function showFilter() {
	            this.$scope.filter.show = true;
	            (0, _lodash.delay)(function () {
	                document.getElementById("search-field").focus();
	            }, 100);
	        }
	    }, {
	        key: "setFilter",
	        value: function setFilter() {
	            this.$scope.query.page = 1;
	            this.$scope.query.status = this.$scope.selectFilter.status || null;
	            this.$scope.query.client_type = this.$scope.selectFilter.client_type || null;
	            this.$scope.query.managers = this.$scope.selectFilter.managers || null;
	            this.query(true);
	        }
	    }, {
	        key: "onQueryFilterChange",
	        value: function onQueryFilterChange() {
	            var _this4 = this;
	
	            this.$scope.query.page = 1;
	            var newValue = (0, _lodash.clone)(this.$scope.query.search);
	            this.$scope.loading = true;
	            this.searhDelayTimeout = setTimeout(function () {
	                var prewValue = (0, _lodash.clone)(_this4.$scope.query.search);
	                if (prewValue === newValue) {
	                    clearTimeout(_this4.searhDelayTimeout);
	                    _this4.query(true);
	                }
	            }, 500);
	        }
	    }, {
	        key: "addMoreItems",
	        value: function addMoreItems() {
	            this.$scope.query.page++;
	            this.query();
	        }
	    }, {
	        key: "onSearchBlur",
	        value: function onSearchBlur() {
	            if (!this.$scope.query.search) {
	                this.$scope.filter.show = false;
	            }
	        }
	    }, {
	        key: "openInNewTab",
	        value: function openInNewTab(id) {
	            this.$window.open(this.$window.location.href + "settings/" + id, "_blank");
	        }
	    }]);
	    return Controller;
	}(_index.$controller);
	
	exports.default = Controller;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(511);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./client-list.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./client-list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "client-list md-table-container .md-table tr:hover td:first-child{text-decoration:underline}client-list .filters{display:flex;align-items:center;justify-content:flex-end;font-size:12px;font-weight:700;border-bottom:1px solid #d3d3d3}client-list .filters div{margin:0 10px;padding:0 20px}client-list .filters div md-select{width:120px;max-width:120px;margin:15px 0 18px}client-list .filters .divider{height:30px;border-left:1px solid #d3d3d3;padding:0}client-list .reverse{transform:rotate(180deg)}client-list md-select.md-table-select>.md-select-value>span>.md-text{display:inline-block!important}", ""]);
	
	// exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _clientCreate = __webpack_require__(513);
	
	var _clientCreate2 = _interopRequireDefault(_clientCreate);
	
	var _clientCreate3 = __webpack_require__(514);
	
	var _clientCreate4 = _interopRequireDefault(_clientCreate3);
	
	__webpack_require__(515);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClientCreateComponent = {
	    template: _clientCreate2.default,
	    controller: _clientCreate4.default,
	    controllerAs: "ClientCreate"
	};
	
	exports.default = ClientCreateComponent;

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\">\n    <div flex=\"20\" flex-offset=\"40\" flex-xs=\"100\" flex-offset-xs=\"0\" class=\"main-content\">\n        <h2 ng-show=\"isNew\">Create a new client</h2>\n        <h2 ng-show=\"!isNew\">Update client: {{ client.name }}</h2>\n\n        <div class=\"settings-block\">\n            <div class=\"header\">\n                <h4>General</h4>\n            </div>\n\n            <form name=\"general\">\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Client Company Name' | translate\"\n                                for=\"companyName\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"companyName\"\n                                id=\"companyName\"\n                                ng-model=\"client.name\"\n                                required>\n\n                        <div ng-messages=\"general.companyName.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'Please provide company name' | translate\"></div>\n                            <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <md-select ng-model=\"client.managers\"\n                                   placeholder=\"{{'Select Manager' | translate}}\"\n                                   permission-hide=\"Client,Sub-User\" multiple>\n                            <md-option ng-value=\"user.url\" ng-repeat=\"user in managers | filter:item.company:byCompany\">{{user.first_name}} {{user.last_name}}</md-option>\n                        </md-select>\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row\">\n                    <p>{{'Status:' | translate}}</p>\n                    <md-radio-group ng-model=\"client.status\" required>\n                        <md-radio-button value=\"lead\" class=\"md-primary\">{{'Lead' | translate}}</md-radio-button>\n                        <md-radio-button value=\"booked\" class=\"md-primary\">{{'Booked' | translate}}</md-radio-button>\n                    </md-radio-group>\n                </div>\n                <div class=\"setting-row\">\n                    <p>{{'Type:' | translate}}</p>\n                    <md-radio-group ng-model=\"client.client_type\" required>\n                        <md-radio-button value=\"single\" class=\"md-primary\">{{'Single Rental' | translate}}</md-radio-button>\n                        <md-radio-button value=\"longterm\" class=\"md-primary\">{{'Long-term Rental' | translate}}</md-radio-button>\n                        <md-radio-button value=\"purchase\" class=\"md-primary\">{{'Purchase' | translate}}</md-radio-button>\n                    </md-radio-group>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <md-select ng-model=\"client.admins\"\n                                   placeholder=\"{{'Select Admin' | translate}}\"\n                                   permission-hide=\"Client,Sub-User\" multiple>\n                            <md-option ng-value=\"user.url\" ng-repeat=\"user in admins | filter:item.company:byCompany\">{{user.first_name}} {{user.last_name}}</md-option>\n                        </md-select>\n                </div>\n            </form>\n        </div>\n\n        <div class=\"settings-block\">\n            <div class=\"header\">\n                <h4>Design</h4>\n            </div>\n\n            <div class=\"setting-row uploader-container\">\n                <div class=\"title-holder\">\n                    <span>Client Logo in color</span>\n                    <span>SVG or PNG, transparent background</span>\n                </div>\n                <div class=\"uploader-holder\">\n                    <upload\n                            ng-if=\"!client.default_design.clientLogoColored\"\n                            id=\"colored-logo-1\"\n                            model=\"client.default_design.clientLogoColored\"\n                            uri=\"{{client.uris.attachments}}\"\n                            custom-label=\"{{'Upload Logo (colored)' | translate}}\"\n                            is-overlay=\"false\"\n                            display-icon=\"true\"\n                            file-types=\".jpg,.jpeg,.gif,.png\">\n                    </upload>\n                    <div class=\"canvas-holder\" ng-if=\"client.default_design.clientLogoColored\">\n                        <canvas-preview\n                                style=\"width: 100px\"\n                                background-image=\"{{client.default_design.clientLogoColored.attachment_file}}\"\n                                width=\"100\"\n                                height=\"75\">\n                        </canvas-preview>\n                        <md-button\n                                class=\"md-icon-button md-primary\"\n                                ng-click=\"client.default_design.clientLogoColored = null\">\n                            <md-icon style=\"color: gray\">delete</md-icon>\n                        </md-button>\n                    </div>\n\n                </div>\n            </div>\n            <div class=\"setting-row uploader-container\">\n                <div class=\"title-holder\">\n                    <span>Client Logo in black <small>(Optional)</small></span>\n                    <span>SVG or PNG, transparent background</span>\n                </div>\n                <div class=\"uploader-holder\">\n                    <upload\n                            ng-if=\"!client.default_design.clientLogoBlack\"\n                            model=\"client.default_design.clientLogoBlack\"\n                            uri=\"{{client.uris.attachments}}\"\n                            custom-label=\"{{'Upload Logo (black)' | translate}}\"\n                            is-overlay=\"false\"\n                            display-icon=\"true\"\n                            file-types=\".jpg,.jpeg,.gif,.png\">\n                    </upload>\n                    <div class=\"canvas-holder\" ng-if=\"client.default_design.clientLogoBlack\">\n                        <canvas-preview\n                                style=\"width: 100px\"\n                                background-image=\"{{client.default_design.clientLogoBlack.attachment_file}}\"\n                                width=\"100\"\n                                height=\"75\">\n                        </canvas-preview>\n                        <md-button\n                                class=\"md-icon-button md-primary\"\n                                ng-click=\"client.default_design.clientLogoBlack = null\">\n                            <md-icon style=\"color: gray\">delete</md-icon>\n                        </md-button>\n                    </div>\n                </div>\n            </div>\n            <div class=\"setting-row uploader-container\">\n                <div class=\"title-holder\">\n                    <span>Client Logo in white<small>(Optional)</small></span>\n                    <span>SVG or PNG, transparent background</span>\n                </div>\n                <div class=\"uploader-holder\">\n                    <upload\n                            ng-if=\"!client.default_design.clientLogoWhite\"\n                            model=\"client.default_design.clientLogoWhite\"\n                            uri=\"{{client.uris.attachments}}\"\n                            custom-label=\"{{'Upload Logo (white)' | translate}}\"\n                            is-overlay=\"false\"\n                            display-icon=\"true\"\n                            file-types=\".jpg,.jpeg,.gif,.png\">\n                    </upload>\n                    <div class=\"canvas-holder\" ng-if=\"client.default_design.clientLogoWhite\">\n                        <canvas-preview\n                                style=\"width: 100px\"\n                                background-image=\"{{client.default_design.clientLogoWhite.attachment_file}}\"\n                                width=\"100\"\n                                height=\"75\">\n                        </canvas-preview>\n                        <md-button\n                                class=\"md-icon-button md-primary\"\n                                ng-click=\"client.default_design.clientLogoWhite = null\">\n                            <md-icon style=\"color: gray\">delete</md-icon>\n                        </md-button>\n                    </div>\n                </div>\n            </div>\n            <div class=\"setting-row color-preview\">\n                <div class=\"label\">\n                    <div class=\"label-container\">\n                        <span>Default color: <small>(Optional)</small></span>\n                    </div>\n                    <div class=\"inputs-holder\">\n                        <form name=\"colorsForm\">\n                            <md-input-container>\n                                <label\n                                        ng-bind=\"'R' | translate\"\n                                        for=\"colorR\"></label>\n                                <input\n                                        type=\"number\"\n                                        min=\"0\"\n                                        max=\"255\"\n                                        name=\"colorR\"\n                                        id=\"colorR\"\n                                        ng-model=\"colorsValue.R\"\n                                        ng-change=\"ClientCreate.changeHEX()\">\n                            </md-input-container>\n                            <md-input-container>\n                                <label\n                                        ng-bind=\"'G' | translate\"\n                                        for=\"colorG\"></label>\n                                <input\n                                        type=\"number\"\n                                        min=\"0\"\n                                        max=\"255\"\n                                        name=\"colorG\"\n                                        id=\"colorG\"\n                                        ng-model=\"colorsValue.G\"\n                                        ng-change=\"ClientCreate.changeHEX()\">\n                            </md-input-container>\n                            <md-input-container>\n                                <label\n                                        ng-bind=\"'B' | translate\"\n                                        for=\"colorB\"></label>\n                                <input\n                                        type=\"number\"\n                                        min=\"0\"\n                                        max=\"255\"\n                                        name=\"colorB\"\n                                        id=\"colorB\"\n                                        ng-model=\"colorsValue.B\"\n                                        ng-change=\"ClientCreate.changeHEX()\">\n                            </md-input-container>\n                            <span class=\"color-divider\">OR</span>\n                            <md-input-container>\n                                <label\n                                        ng-bind=\"'HEX' | translate\"\n                                        for=\"HEX\"></label>\n                                <input\n                                        type=\"text\"\n                                        minlength=\"6\"\n                                        maxlength=\"6\"\n                                        name=\"HEX\"\n                                        id=\"HEX\"\n                                        ng-model=\"colorsValue.HEX\"\n                                        ng-pattern=\"/^[A-Fa-f0-9]+$/\"\n                                        ng-change=\"ClientCreate.changeRGB()\">\n                            </md-input-container>\n                        </form>\n                    </div>\n                </div>\n                <div class=\"color-pallet\">\n                    <div class=\"label-container\">\n                        <span>Preview:</span>\n                    </div>\n                    <div class=\"color-holder\" ng-style=\"{backgroundColor: ClientCreate.setColor()}\">\n\n                    </div>\n                </div>\n            </div>\n            <div class=\"setting-row\">\n                <p>{{'Default design theme:' | translate}}</p>\n                <md-radio-group ng-model=\"client.default_design.theme\">\n                    <md-radio-button value=\"light\" class=\"md-primary\">{{'Light' | translate}}</md-radio-button>\n                    <md-radio-button value=\"dark\" class=\"md-primary\">{{'Dark' | translate}}</md-radio-button>\n                </md-radio-group>\n            </div>\n\n        </div>\n\n        <div class=\"settings-block smaller\">\n            <div class=\"header\">\n                <h4>Shipping Information</h4>\n            </div>\n            <form name=\"shippingForm\">\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Company Name' | translate\"\n                                for=\"ShcompanyName\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"ShcompanyName\"\n                                id=\"ShcompanyName\"\n                                ng-model=\"client.shipping_info.companyName\">\n\n                        <div ng-messages=\"shippingForm.ShcompanyName.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'Please provide company name' | translate\"></div>\n                            <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Contact Person' | translate\"\n                                for=\"ShcontactPerson\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"ShcontactPerson\"\n                                id=\"ShcontactPerson\"\n                                ng-model=\"client.shipping_info.contactPerson\">\n\n                        <div ng-messages=\"shippingForm.ShcontactPerson.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'Please provide valid person name' | translate\"></div>\n                            <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                        </div>\n                    </md-input-container>\n\n\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Contact Person\\'s phone number' | translate\"\n                                for=\"ShcontactPersonNumber\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                ng-pattern=\"'^[0-9+ ]+$'\"\n                                name=\"ShcontactPersonNumber\"\n                                id=\"ShcontactPersonNumber\"\n                                ng-model=\"client.shipping_info.contactPersonPhoneNumber\">\n\n                        <div ng-messages=\"shippingForm.ShcontactPersonNumber.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'Please provide valid phone number' | translate\"></div>\n                            <div ng-message=\"pattern\" ng-bind=\"'Number should contain only \\'0-9\\' or \\'+\\' characters' | translate\"></div>\n                            <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Street' | translate\"\n                                for=\"street\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"street\"\n                                id=\"street\"\n                                ng-model=\"client.shipping_info.street\">\n\n                        <div ng-messages=\"shippingForm.street.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'Please provide valid street' | translate\"></div>\n                            <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row address\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'House number' | translate\"\n                                for=\"houseNumber\"></label>\n                        <input\n                                type=\"number\"\n                                min=\"0\"\n                                max=\"99999\"\n                                name=\"houseNumber\"\n                                id=\"houseNumber\"\n                                ng-model=\"client.shipping_info.houseNumber\">\n\n                        <div ng-messages=\"shippingForm.houseNumber.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Zip Code' | translate\"\n                                for=\"zip\"></label>\n                        <input\n                                type=\"number\"\n                                min=\"0\"\n                                name=\"zip\"\n                                id=\"zip\"\n                                ng-model=\"client.shipping_info.zip\">\n\n                        <div ng-messages=\"shippingForm.houseNumber.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row location\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'City' | translate\"\n                                for=\"city\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"city\"\n                                id=\"city\"\n                                ng-model=\"client.shipping_info.city\">\n\n                        <div ng-messages=\"shippingForm.houseNumber.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                    <select-search\n                            model=\"client.shipping_info.country\"\n                            item-label=\"name\"\n                            item-value=\"code\"\n                            label=\"'Country' | translate\"\n                            collection=\"countries\"\n                            permission-hide=\"Client,Sub-User\">\n                    </select-search>\n                </div>\n            </form>\n\n        </div>\n\n        <div class=\"settings-block smaller\">\n            <div class=\"header\">\n                <h4>Billing Information</h4>\n            </div>\n\n            <form name=\"billingForm\">\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Company Name' | translate\"\n                                for=\"BlcompanyName\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"BlcompanyName\"\n                                id=\"BlcompanyName\"\n                                ng-model=\"client.billing_info.companyName\">\n\n                        <div ng-messages=\"billingForm.BlcompanyName.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'Please provide valid company name' | translate\"></div>\n                            <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Contact Person' | translate\"\n                                for=\"BlcontactPerson\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"BlcontactPerson\"\n                                id=\"BlcontactPerson\"\n                                ng-model=\"client.billing_info.contactPerson\">\n\n                        <div ng-messages=\"billingForm.BlcontactPerson.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'Please provide valid person name' | translate\"></div>\n                            <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Contact Person\\'s phone number' | translate\"\n                                for=\"BlcontactPersonNumber\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                ng-pattern=\"'^[0-9+ ]+$'\"\n                                name=\"BlcontactPersonNumber\"\n                                id=\"BlcontactPersonNumber\"\n                                ng-model=\"client.billing_info.contactPersonPhoneNumber\">\n\n                        <div ng-messages=\"billingForm.BlcontactPersonNumber.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'Please provide valid phone number' | translate\"></div>\n                            <div ng-message=\"pattern\" ng-bind=\"'Number should contain only \\'0-9\\' or \\'+\\' characters' | translate\"></div>\n                            <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Additional information' | translate\"\n                                for=\"additionalInfo\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"360\"\n                                name=\"additionalInfo\"\n                                id=\"additionalInfo\"\n                                ng-model=\"client.billing_info.additionalInfo\">\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Street' | translate\"\n                                for=\"BlStreet\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"BlStreet\"\n                                id=\"BlStreet\"\n                                ng-model=\"client.billing_info.street\">\n\n                        <div ng-messages=\"billingForm.BlStreet.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'Please provide valid street' | translate\"></div>\n                            <div ng-message=\"minlength\" ng-bind=\"'This field should contain at least 2 characters' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row address\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'House number' | translate\"\n                                for=\"BlhouseNumber\"></label>\n                        <input\n                                type=\"number\"\n                                min=\"0\"\n                                max=\"99999\"\n                                name=\"BlhouseNumber\"\n                                id=\"BlhouseNumber\"\n                                ng-model=\"client.billing_info.houseNumber\">\n\n                        <div ng-messages=\"billingForm.BlhouseNumber.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Zip Code' | translate\"\n                                for=\"Blzip\"></label>\n                        <input\n                                type=\"number\"\n                                min=\"0\"\n                                name=\"Blzip\"\n                                id=\"Blzip\"\n                                ng-model=\"client.billing_info.zip\">\n\n                        <div ng-messages=\"billingForm.Blzip.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row location\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'City' | translate\"\n                                for=\"Blcity\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"Blcity\"\n                                id=\"Blcity\"\n                                ng-model=\"client.billing_info.city\">\n\n                        <div ng-messages=\"billingForm.Blcity.$error\" role=\"alert\">\n                            <div ng-message=\"required\" ng-bind=\"'This field is required' | translate\"></div>\n                        </div>\n                    </md-input-container>\n                    <select-search\n                            model=\"client.billing_info.country\"\n                            item-label=\"name\"\n                            item-value=\"code\"\n                            label=\"'Country' | translate\"\n                            collection=\"countries\"\n                            permission-hide=\"Client,Sub-User\">\n                    </select-search>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Tax ID' | translate\"\n                                for=\"tax\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"tax\"\n                                id=\"tax\"\n                                ng-model=\"client.billing_info.tax\">\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'VAT ID' | translate\"\n                                for=\"vat\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"vat\"\n                                id=\"vat\"\n                                ng-model=\"client.billing_info.vat\">\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'UpReach Supplier ID' | translate\"\n                                for=\"supplier\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"64\"\n                                name=\"supplier\"\n                                id=\"supplier\"\n                                ng-model=\"client.billing_info.supplierID\">\n                    </md-input-container>\n                </div>\n                <div class=\"setting-row\">\n                    <md-input-container class=\"md-block\">\n                        <label\n                                ng-bind=\"'Other reference' | translate\"\n                                for=\"other\"></label>\n                        <input\n                                type=\"text\"\n                                minlength=\"2\"\n                                maxlength=\"360\"\n                                name=\"other\"\n                                id=\"other\"\n                                ng-model=\"client.billing_info.otherReferences\">\n                    </md-input-container>\n                </div>\n            </form>\n\n        </div>\n        <div layout=\"row\" layout-sm=\"column\" layout-padding layout-align=\"center center\">\n            <md-button\n                    class=\"md-primary md-raised\"\n                    ng-click=\"ClientCreate.saveClient()\"\n                    ng-disabled=\"general.$invalid || colorsForm.$invalid || shippingForm.$invalid || billingForm.$invalid\"\n                   >{{isNew ? 'Create Client' : 'Update client' | translate}}\n            </md-button>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _countries = __webpack_require__(494);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Company", "$Users"];
	
	var ClientCreateController = function (_$controller) {
	    ClientCreateController.$inject = ["$injector", "$scope", "$state"];
	    (0, _inherits3.default)(ClientCreateController, _$controller);
	
	    function ClientCreateController($injector, $scope, $state) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, ClientCreateController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ClientCreateController.__proto__ || (0, _getPrototypeOf2.default)(ClientCreateController)).call(this, $injector, dependencies));
	
	        _this.$state = $state;
	        _this.$scope = $scope;
	        _this.$scope.countries = _countries.countries;
	        _this.$scope.colorsValue = {
	            R: 0,
	            G: 0,
	            B: 0,
	            HEX: "000000"
	        };
	        _this.$scope.id = _this.$stateParams.id;
	        _this.$scope.isNew = !_this.$stateParams.id && _this.$scope.id !== 0;
	
	        if (_this.$scope.isNew) {
	            _this.$scope.client = {};
	            _this.$Company.create({ name: "Draft" }).$promise.then(function (cl) {
	                _this.$scope.client = cl;
	                _this.$scope.client.name = "";
	            }).catch(function (error) {
	                console.log(error);
	            });
	        } else {
	            var company = void 0;
	            company = _this.$Company.get({ id: _this.$stateParams.id });
	
	            company && company.$promise.then(function (company) {
	                _this.$scope.client = company;
	                if (company.default_design) {
	                    _this.$scope.colorsValue = company.default_design.colorsValue;
	                }
	                console.log("Companies: ", _this.$scope.client);
	            }).catch(function (e) {
	                console.log(e);
	                _this.$state.go("clients");
	            });
	        }
	
	        var managers = void 0;
	        // TODO: change this to api-search
	        managers = _this.$Users.query({ groups: 2, page_size: 100000 });
	        managers && managers.$promise.then(function (managers) {
	            _this.$scope.managers = managers;
	            (0, _lodash.forEach)(_this.$scope.managers, function (m) {
	                m.url = "" + (("https://cloud.upreach.com") || "https://cloud.upreach.com") + m.url;
	            });
	        }).catch(function (e) {
	            console.log(e);
	            _this.$state.go("clients");
	        });
	
	        var admins = void 0;
	        admins = _this.$Users.query({ groups: 3, page_size: 100000 });
	        admins && admins.$promise.then(function (admins) {
	            _this.$scope.admins = admins;
	            (0, _lodash.forEach)(_this.$scope.admins, function (m) {
	                m.url = "" + (("https://cloud.upreach.com") || "https://cloud.upreach.com") + m.url;
	            });
	        }).catch(function (e) {
	            console.log(e);
	            _this.$state.go("clients");
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(ClientCreateController, [{
	        key: "changeHEX",
	        value: function changeHEX() {
	            var c = this.$scope.colorsValue;
	
	            if ((c.R || c.R === 0) && (c.G || c.G === 0) && (c.B || c.B === 0)) {
	                c.HEX = "" + componentToHex(c.R) + componentToHex(c.G) + componentToHex(c.B);
	            }
	
	            function componentToHex(cl) {
	                var hex = cl.toString(16);
	                return hex.length === 1 ? "0" + hex : hex;
	            }
	        }
	    }, {
	        key: "changeRGB",
	        value: function changeRGB() {
	            var c = this.$scope.colorsValue;
	            if (c.HEX) {
	                var bigint = parseInt(c.HEX, 16);
	                c.R = bigint >> 16 & 255;
	                c.G = bigint >> 8 & 255;
	                c.B = bigint & 255;
	            }
	        }
	    }, {
	        key: "setColor",
	        value: function setColor() {
	            var c = this.$scope.colorsValue;
	            if (c.HEX) {
	                return "#" + c.HEX;
	            }
	            if ((c.R || c.R === 0) && (c.G || c.G === 0) && (c.B || c.B === 0)) {
	                return "rgb(" + c.R + "," + c.G + "," + c.B + ")";
	            }
	            return "#000000";
	        }
	    }, {
	        key: "saveClient",
	        value: function saveClient() {
	            var _this2 = this;
	
	            var c = this.$scope.colorsValue;
	
	            if (this.$scope.client.single) {
	                this.$scope.client.logistics_handling = "admin";
	            } else {
	                this.$scope.client.logistics_handling = "client";
	            }
	            if (this.$scope.client.default_design) {
	                this.$scope.client.default_design.colors = {
	                    rgb: "rgb(" + c.R + "," + c.G + "," + c.B + ")",
	                    hex: "#" + c.HEX
	                };
	                this.$scope.client.default_design.colorsValue = this.$scope.colorsValue;
	            }
	
	            this.$Company.update(this.$scope.client).$promise.then(function () {
	                var toast = _this2.$mdToast.simple().textContent(_this2.gettext("Client data saved!")).highlightAction(true).highlightClass("md-accent").position("bottom right");
	                _this2.$mdToast.show(toast);
	                if (_this2.$scope.isNew) {
	                    _this2.$state.go("clients.list", { "createdCompany": _this2.$scope.client.name });
	                } else {
	                    _this2.$state.go("clients.list");
	                }
	            }).catch(function (error) {
	                if (error.data.booth) {
	                    _this2.$mdDialog.show(_this2.$mdDialog.alert().clickOutsideToClose(true).title(_this2.gettext("Error")).htmlContent(_this2.gettext("Can't save client info")).ariaLabel(_this2.gettext("Error")).ok("OK"));
	                }
	            });
	        }
	    }]);
	    return ClientCreateController;
	}(_index.$controller);
	
	exports.default = ClientCreateController;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(516);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./client-create.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./client-create.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "client-create .main-content{min-width:400px;max-width:400px;width:400px}client-create .main-content h2{text-align:center;margin:20px 0 50px;display:block;font-size:1.5em}client-create .main-content .settings-block .header{text-align:center}client-create .main-content .settings-block .setting-row{font-size:12px}client-create .main-content .settings-block .setting-row md-radio-group md-radio-button{display:inline-block;padding:0 10px 0 0}client-create .main-content .settings-block .uploader-container{display:flex;justify-content:space-between;margin:25px 0}client-create .main-content .settings-block .uploader-container .canvas-holder{display:flex;align-items:center}client-create .main-content .settings-block .uploader-container .title-holder span{display:block;color:gray;margin-top:5px}client-create .main-content .settings-block .uploader-container .title-holder span small{float:right;position:relative;top:2px}client-create .main-content .settings-block .uploader-container .title-holder span:last-child{font-size:10px;margin-top:10px}client-create .main-content .settings-block .color-preview{display:flex;justify-content:space-between}client-create .main-content .settings-block .color-preview .label .label-container span{display:block;color:gray;margin-top:5px;width:186px}client-create .main-content .settings-block .color-preview .label .label-container span small{float:right;position:relative;top:2px}client-create .main-content .settings-block .color-preview .label .inputs-holder md-input-container{width:45px}client-create .main-content .settings-block .color-preview .label .inputs-holder .color-divider{color:grey;display:inline-block;position:relative;top:-7px}client-create .main-content .settings-block .color-preview #HEX{width:70px}client-create .main-content .settings-block .color-preview .color-pallet .label-container span{display:block;color:gray}client-create .main-content .settings-block .color-preview .color-pallet .color-holder{width:70px;height:28px;background-color:#00b0ff;margin:15px 4px 0 0}client-create .main-content .settings-block .address md-input-container{display:inline-block}client-create .main-content .settings-block .location{display:flex}client-create .main-content .settings-block .location md-input-container,client-create .main-content .settings-block .location select-search{width:50%}client-create .main-content .settings-block .location select-search md-input-container{width:100%}client-create .main-content .smaller{padding:0 20px}", ""]);
	
	// exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _clientSettings = __webpack_require__(518);
	
	var _clientSettings2 = _interopRequireDefault(_clientSettings);
	
	var _clientSettings3 = __webpack_require__(519);
	
	var _clientSettings4 = _interopRequireDefault(_clientSettings3);
	
	__webpack_require__(520);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClientSettingsComponent = {
	    template: _clientSettings2.default,
	    controller: _clientSettings4.default,
	    controllerAs: "ClientSettings"
	};
	
	exports.default = ClientSettingsComponent;

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	module.exports = "<div layout=\"row\">\n    <div ng-show=\"!company\" flex=\"30\" flex-offset=\"35\" flex-xs=\"100\" flex-offset-xs=\"0\" class=\"loading\">Loading ...</div>\n    <div flex=\"30\" flex-offset=\"35\" flex-xs=\"100\" flex-offset-xs=\"0\" class=\"main-content\" ng-show=\"company\">\n        <h3>{{company.name}} - Client Settings</h3>\n\n        <div class=\"client-delete\">\n            <md-button ng-click=\"ClientSettings.openDeleteDialog()\">Delete client</md-button>\n        </div>\n\n        <div class=\"settings-block\">\n            <div class=\"header\">\n                <h4>General</h4>\n                <md-icon class=\"material-icons\" title=\"Edit\" ng-click=\"ClientSettings.editClient(company.url)\">edit</md-icon>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Client Company Name:</span>\n                <span ng-if=\"company.name\">{{ company.name }}</span>\n                <span ng-if=\"!company.name\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Client Manager:</span>\n                <span ng-if=\"company.managers_info.length\" title=\"{{ClientSettings.transformClientsArr(company.managers_info, true)}}\">{{ClientSettings.transformClientsArr(company.managers_info)}}</span>\n                <span ng-if=\"!company.managers_info.length\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Status:</span>\n                <span ng-if=\"company.status\">{{ company.status }}</span>\n                <span ng-if=\"!company.status\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Type:</span>\n                <span ng-if=\"company.client_type\">{{ company.client_type }}</span>\n                <span ng-if=\"!company.client_type\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Client Admin</span>\n                <span ng-if=\"company.admins_info.length\"  title=\"{{ClientSettings.transformClientsArr(company.admins_info, true)}}\">{{ ClientSettings.transformClientsArr(company.admins_info) }}</span>\n                <span ng-if=\"!company.admins_info.length\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n        </div>\n\n        <div class=\"settings-block\">\n            <div class=\"header\">\n                <h4>Design</h4>\n                <md-icon class=\"material-icons\" title=\"Edit\" ng-click=\"ClientSettings.editClient(company.url)\">edit</md-icon>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Client Logo in color:</span>\n                <span\n                        ng-if=\"company.default_design.clientLogoColored.attachment_file\"\n                        title=\"{{company.default_design.clientLogoColored.attachment_file | getFileName}}\"\n                >{{ company.default_design.clientLogoColored.attachment_file | getFileName:25 }}</span>\n                <span ng-if=\"!company.default_design.clientLogoColored.attachment_file\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Client Logo in black:</span>\n                <span\n                        ng-if=\"company.default_design.clientLogoBlack.attachment_file\"\n                        title=\"{{company.default_design.clientLogoBlack.attachment_file | getFileName}}\"\n                >{{ company.default_design.clientLogoBlack.attachment_file | getFileName:25 }}</span>\n                <span ng-if=\"!company.default_design.clientLogoBlack.attachment_file\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Client Logo in white:</span>\n                <span\n                        ng-if=\"company.default_design.clientLogoWhite.attachment_file\"\n                        title=\"{{company.default_design.clientLogoWhite.attachment_file | getFileName}}\"\n                >{{ company.default_design.clientLogoWhite.attachment_file | getFileName:25 }}</span>\n                <span ng-if=\"!company.default_design.clientLogoWhite.attachment_file\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Default color:</span>\n                <div class=\"color-block\">\n                    <div class=\"color-area\" ng-style=\"{backgroundColor: company.default_design.colors.rgb}\"></div>\n                    <div class=\"color-labels\">\n                        <span>{{company.default_design.colors.rgb}}</span><br>\n                        <span>{{company.default_design.colors.hex}}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"setting-row\">\n                <span>Default design theme:</span>\n                <span ng-if=\"company.default_design && company.default_design.theme\">{{ company.default_design.theme }}</span>\n                <span ng-if=\"!company.default_design || !company.default_design.theme\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n        </div>\n\n        <div class=\"settings-block\">\n            <div class=\"header\">\n                <h4>Shipping Information</h4>\n                <md-icon class=\"material-icons\" title=\"Edit\"  ng-click=\"ClientSettings.editClient(company.url)\">edit</md-icon>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Company Name:</span>\n                <span ng-if=\"company.shipping_info && company.shipping_info.companyName\">{{ company.shipping_info.companyName }}</span>\n                <span ng-if=\"!company.shipping_info || !company.shipping_info.companyName\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Contact person:</span>\n                <span ng-if=\"company.shipping_info && company.shipping_info.contactPerson\">{{ company.shipping_info.contactPerson }}</span>\n                <span ng-if=\"!company.shipping_info || !company.shipping_info.contactPerson\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Contact person phone number:</span>\n                <span ng-if=\"company.shipping_info && company.shipping_info.contactPersonPhoneNumber\">{{ company.shipping_info.contactPersonPhoneNumber }}</span>\n                <span ng-if=\"!company.shipping_info || !company.shipping_info.contactPersonPhoneNumber\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Address:</span>\n                <span>\n                   <span ng-if=\"company.shipping_info && company.shipping_info.street\">{{ company.shipping_info.street + \" \"}}</span>\n                   <span ng-if=\"company.shipping_info && company.shipping_info.houseNumber\">{{ company.shipping_info.houseNumber }}</span>\n                </span>\n                <span ng-if=\"(!company.shipping_info || !company.shipping_info.street) && (!company.shipping_info || !company.shipping_info.houseNumber)\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Zip Code:</span>\n                <span ng-if=\"company.shipping_info && company.shipping_info.zip\">{{ company.shipping_info.zip }}</span>\n                <span ng-if=\"!company.shipping_info || !company.shipping_info.zip\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>City:</span>\n                <span ng-if=\"company.shipping_info && company.shipping_info.city\">{{ company.shipping_info.city }}</span>\n                <span ng-if=\"!company.shipping_info || !company.shipping_info.city\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Country:</span>\n                <span ng-if=\"company.shipping_info && company.shipping_info.country\">{{ ClientSettings.updateCountry(company.shipping_info.country) }}</span>\n                <span ng-if=\"!company.shipping_info || !company.shipping_info.country\" class=\"no-provided\">(not provided)</span>\n            </div>\n\n        </div>\n\n        <div class=\"settings-block\">\n            <div class=\"header\">\n                <h4>Billing Information</h4>\n                <md-icon class=\"material-icons\" title=\"Edit\" ng-click=\"ClientSettings.editClient(company.url)\">edit</md-icon>\n            </div>\n\n            <div class=\"setting-row\">\n                <span>Company Name:</span>\n                <span ng-if=\"company.billing_info && company.billing_info.companyName\">{{ company.billing_info.companyName }}</span>\n                <span ng-if=\"!company.billing_info || !company.billing_info.companyName\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Contact person:</span>\n                <span ng-if=\"company.billing_info && company.billing_info.contactPerson\">{{ company.billing_info.contactPerson }}</span>\n                <span ng-if=\"!company.billing_info || !company.billing_info.contactPerson\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Contact person phone number:</span>\n                <span ng-if=\"company.billing_info && company.billing_info.contactPersonPhoneNumber\">{{ company.billing_info.contactPersonPhoneNumber }}</span>\n                <span ng-if=\"!company.billing_info || !company.billing_info.contactPersonPhoneNumber\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Additional information:</span>\n                <span ng-if=\"company.billing_info && company.billing_info.additionalInfo\">{{ company.billing_info.additionalInfo }}</span>\n                <span ng-if=\"!company.billing_info || !company.billing_info.additionalInfo\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Address:</span>\n                <span>\n                   <span ng-if=\"company.billing_info && company.billing_info.street\">{{ company.billing_info.street + \" \"}}</span>\n                   <span ng-if=\"company.billing_info && company.billing_info.houseNumber\">{{ company.billing_info.houseNumber }}</span>\n                </span>\n                <span ng-if=\"(!company.billing_info || !company.billing_info.street) && (!company.billing_info || !company.billing_info.houseNumber)\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Zip Code:</span>\n                <span ng-if=\"company.billing_info && company.billing_info.zip\">{{ company.billing_info.zip }}</span>\n                <span ng-if=\"!company.billing_info || !company.billing_info.zip\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>City:</span>\n                <span ng-if=\"company.billing_info && company.billing_info.city\">{{ company.billing_info.city }}</span>\n                <span ng-if=\"!company.billing_info || !company.billing_info.city\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Country:</span>\n                <span ng-if=\"company.billing_info && company.billing_info.country\">{{ ClientSettings.updateCountry(company.billing_info.country) }}</span>\n                <span ng-if=\"!company.billing_info || !company.billing_info.country\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Tax ID:</span>\n                <span ng-if=\"company.billing_info && company.billing_info.tax\">{{ company.billing_info.tax }}</span>\n                <span ng-if=\"!company.billing_info || !company.billing_info.tax\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>VAT ID:</span>\n                <span ng-if=\"company.billing_info && company.billing_info.vat\">{{ company.billing_info.vat }}</span>\n                <span ng-if=\"!company.billing_info || !company.billing_info.vat\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>UpReach Supplier ID:</span>\n                <span ng-if=\"company.billing_info && company.billing_info.supplierID\">{{ company.billing_info.supplierID }}</span>\n                <span ng-if=\"!company.billing_info || !company.billing_info.supplierID\" class=\"no-provided\">(not provided)</span>\n            </div>\n            <div class=\"setting-row\">\n                <span>Other reference:</span>\n                <span ng-if=\"company.billing_info && company.billing_info.otherReferences\">{{ company.billing_info.otherReferences }}</span>\n                <span ng-if=\"!company.billing_info || !company.billing_info.otherReferences\" class=\"no-provided\">(not provided)</span>\n            </div>\n        </div>\n\n    </div>\n</div>";

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	var _countries = __webpack_require__(494);
	
	var _deleteDialog = __webpack_require__(260);
	
	var _deleteDialog2 = __webpack_require__(261);
	
	var _deleteDialog3 = _interopRequireDefault(_deleteDialog2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Company"];
	
	var ClientSettingsController = function (_$controller) {
	    ClientSettingsController.$inject = ["$injector", "$stateParams", "$scope", "$state", "$ToastService", "$UndoDeleteService"];
	    (0, _inherits3.default)(ClientSettingsController, _$controller);
	
	    function ClientSettingsController($injector, $stateParams, $scope, $state, $ToastService, $UndoDeleteService) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, ClientSettingsController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ClientSettingsController.__proto__ || (0, _getPrototypeOf2.default)(ClientSettingsController)).call(this, $injector, dependencies));
	
	        _this.$scope = $scope;
	        _this.$stateParams = $stateParams;
	        _this.$state = $state;
	        _this.toastService = $ToastService;
	        _this.undoDelete = $UndoDeleteService;
	
	        var company = void 0;
	        company = _this.$Company.get({ id: $stateParams.id });
	
	        company && company.$promise.then(function (company) {
	            _this.$scope.company = company;
	        }).catch(function () {
	            _this.$state.go("clients");
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(ClientSettingsController, [{
	        key: "editClient",
	        value: function editClient(url) {
	            var itemsArr = url.split("/");
	            var itemId = itemsArr[itemsArr.length - 2];
	            this.$state.go("clients.create", { id: itemId });
	        }
	    }, {
	        key: "transformClientsArr",
	        value: function transformClientsArr(arr, title) {
	            var newArr = [];
	            (0, _lodash.forEach)(arr, function (user) {
	                newArr.push(user.first_name + " " + user.last_name);
	            });
	            var str = newArr.length > 1 ? newArr.join(title ? "\n" : ", ") : newArr.join("");
	            return str.length > 25 && !title ? str.slice(0, 25) + " ..." : str;
	        }
	    }, {
	        key: "updateCountry",
	        value: function updateCountry(country) {
	            var newValue = (0, _lodash.find)(_countries.countries, { code: country });
	            if (newValue) {
	                return newValue.name;
	            }
	            return null;
	        }
	    }, {
	        key: "openDeleteDialog",
	        value: function openDeleteDialog() {
	            var _this2 = this;
	
	            this.$mdDialog.show({
	                title: "Deployment Delete",
	                controller: _deleteDialog.DeleteDialogController,
	                template: _deleteDialog3.default,
	                targetEvent: event,
	                locals: {
	                    callback: function callback() {
	                        _this2.deleteClient();
	                    },
	                    target: "company",
	                    item: this.$scope.company
	                }
	            });
	        }
	    }, {
	        key: "deleteClient",
	        value: function deleteClient() {
	            var _this3 = this;
	
	            var client = this.$scope.company;
	            client.$delete().then(function () {
	                _this3.toastService.deleteToast("Deleted client \"" + client.name + "\".", function () {
	                    _this3.undoDelete.undoDelete("companies", _this3.$filter("getObjectId")(client.url)).then(function () {
	                        _this3.toastService.showSimple("Deletion undone", 5000);
	                    }).catch(function () {
	                        _this3.toastService.showError("Could not undone deletion", 5000);
	                    });
	                });
	                _this3.$state.go("clients");
	            }).catch(function () {
	                _this3.toastService.showError("Could not delete client \"" + client.name + "\".", 5000);
	            });
	        }
	    }]);
	    return ClientSettingsController;
	}(_index.$controller);
	
	exports.default = ClientSettingsController;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(521);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./client-settings.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./client-settings.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "client-settings .loading{text-align:center;margin-top:50px}client-settings .client-delete{position:relative;width:100%}client-settings .client-delete button{color:#ff0051;position:absolute;right:-80%;margin-top:-50px}client-settings .main-content{text-align:center;min-width:400px}client-settings .main-content .settings-block{margin:0 0 30px}client-settings .main-content .settings-block .header{position:relative}client-settings .main-content .settings-block .header md-icon{position:absolute;top:0;right:0;cursor:pointer}client-settings .main-content .settings-block .setting-row{display:flex;justify-content:space-between;padding:12px 0;font-size:12px}client-settings .main-content .settings-block .setting-row span:last-child{font-weight:600}client-settings .main-content .settings-block .setting-row span.no-provided{font-weight:400;color:gray}client-settings .main-content .settings-block .setting-row .color-block{display:flex}client-settings .main-content .settings-block .setting-row .color-block .color-area{width:70px;height:28px;background-color:#00b0ff;margin:1px 4px 0 0}client-settings .main-content .settings-block .setting-row .color-block .color-labels{text-align:left}client-settings .main-content .settings-block .setting-row .color-block .color-labels span{font-weight:700;line-height:17px}", ""]);
	
	// exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _boothsRouter = __webpack_require__(523);
	
	var _boothsRouter2 = _interopRequireDefault(_boothsRouter);
	
	var _boothsComponent = __webpack_require__(524);
	
	var _boothsComponent2 = _interopRequireDefault(_boothsComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Module = angular.module("app.booths", []).component("booths", _boothsComponent2.default).config(_boothsRouter2.default);
	
	exports.default = Module;

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	"use strict";
	
	Router.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Router;
	function Router($stateProvider) {
	    "ngInject";
	
	    $stateProvider.state({
	        name: "booths",
	        url: "/app/devices",
	        template: "<booths></booths>",
	        resolve: {
	            $title: function $title() {
	                return "Devices | UpReach Cloud";
	            }
	        }
	    });
	}

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _booths = __webpack_require__(525);
	
	var _booths2 = _interopRequireDefault(_booths);
	
	var _booths3 = __webpack_require__(526);
	
	var _booths4 = _interopRequireDefault(_booths3);
	
	__webpack_require__(533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoothsComponent = {
	    template: _booths2.default,
	    controller: _booths4.default,
	    controllerAs: "controller"
	};
	
	exports.default = BoothsComponent;

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	module.exports = "<md-content layout=\"column\" flex layout-align=\"top center\">\n    <md-card>\n        <md-toolbar class=\"md-table-toolbar md-default\">\n            <div class=\"md-toolbar-tools\">\n                <span>Booths</span>\n                <div flex></div>\n\n                <div flex=\"70\" class=\"md-toolbar-tools md-toolbar-search\" ng-if=\"filter.show\" layout=\"row\" layout-align=\"center right\">\n                    <md-input-container md-no-float flex>\n                        <input ng-blur=\"controller.onSearchBlur()\" type=\"text\" id=\"search-field\" placeholder=\"Search in the Booths table\" ng-model=\"query.search\" ng-model-options=\"filter.options\" class=\"ng-pristine ng-valid ng-touched\">\n                    </md-input-container>\n                    <button class=\"md-icon-button md-button md-ink-ripple\" type=\"button\" ng-click=\"controller.removeFilter()\" layout-align=\"center right\">\n                        <md-icon class=\"material-icons\">search</md-icon>\n                        <div class=\"md-ripple-container\"></div>\n                    </button>\n                </div>\n                <md-button class=\"md-icon-button md-button md-ink-ripple\" ng-click=\"controller.showFilter()\" ng-if=\"!filter.show\" ng-show=\"boothsArray.length\">\n                    <md-icon class=\"material-icons\">search</md-icon>\n                    <div class=\"md-ripple-container\"></div>\n                </md-button>\n<!--                <md-button class=\"md-icon-button md-button md-ink-ripple\" ng-click=\"selectFilter.show = !selectFilter.show\" ng-class=\"{reverse: !selectFilter.show}\" ng-show=\"boothsArray.length\">-->\n<!--                    <md-icon class=\"material-icons\">filter_list</md-icon>-->\n<!--                    <div class=\"md-ripple-container\"></div>-->\n<!--                </md-button>-->\n\n            </div>\n        </md-toolbar>\n\n        <!--<md-table-container ng-if=\"! configurations._meta.count\" class=\"no-items\">-->\n        <md-table-container ng-if=\"!boothsArray.length\" class=\"no-items\">\n            <div ng-if=\"loading\" translate>Loading booths list...</div>\n            <div ng-if=\"!loading && filter.show\" translate>No results found for: '{{ query.search }}'</div>\n        </md-table-container>\n        <!--Filters go here-->\n        <md-table-container ng-if=\"selectFilter.show\" class=\"filters\">\n           <div>\n               <span>Filter options:</span>\n           </div>\n            <div>\n                <md-select multiple ng-model=\"selectFilter.value\" ng-change=\"controller.testFilter()\" placeholder=\"Company\">\n                    <md-option value=\"{{item.url}}\" ng-repeat=\"item in companies\">{{ item.name }}</md-option>\n                </md-select>\n            </div>\n            <div class=\"divider\"></div>\n            <div>\n                <md-select multiple ng-model=\"selectFilter.value\" ng-change=\"controller.testFilter()\" placeholder=\"Configuration\">\n                    <md-option value=\"{{item.url}}\" ng-repeat=\"item in configurationsArray\">{{item.name}}</md-option>\n                </md-select>\n            </div>\n        </md-table-container>\n\n        <!--<md-table-container ng-if=\"configurations._meta.count\">-->\n        <md-table-container ng-if=\"boothsArray.length\">\n            <table md-table md-row-select=\"options.rowSelection\" multiple=\"{{options.multiSelect}}\" ng-model=\"selected\" md-progress=\"promise\">\n                <thead ng-if=\"!options.decapitate\" md-head md-order=\"query.order\" md-on-reorder=\"logOrder\">\n                <tr md-row>\n                    <th md-column md-order-by=\"_booth_id\"><span>{{'ID' | translate}}</span></th>\n                    <th md-column md-order-by=\"_app_version\"><span>{{'Current App version' | translate}}</span></th>\n                    <th md-column md-order-by=\"_company__name\" ng-hide=\"controller.isClient()\"><span>{{'Company name' | translate}}</span></th>\n                    <th md-column md-order-by=\"_booth_type\" ng-hide=\"controller.isClient()\"><span>{{'Booth type' | translate}}</span></th>\n                    <th md-column md-order-by=\"_deployment__name\"><span>{{'Deployment' | translate}}</span></th>\n                    <th md-column md-order-by=\"_current_configuration__name\"><span>{{'Active configuration' | translate}}</span></th>\n                    <th md-column md-order-by=\"_deployment__status\" ng-hide=\"controller.isClient()\"><span>{{'Status' | translate}}</span></th>\n                    <th md-column md-order-by=\"_status_state\"><span>{{'Online status' | translate}}</span></th>\n                    <th md-column></th>\n                </tr>\n                </thead>\n                <tbody md-body>\n                <tr md-row ng-repeat=\"item in boothsArray | orderBy: query.order | limitTo: query.limit : (query.page -1) * query.limit\">\n\n                    <td md-cell>{{item.booth_id}}</td>\n                    <td md-cell>{{item.app_version}}</td>\n                    <td md-cell ng-hide=\"controller.isClient()\">\n                        <span permission-hide=\"Admin,Manager\">{{item.company_info.name}}</span>\n                        <api-select-search\n                                model=\"item.company\"\n                                multiple=\"false\"\n                                permision-show=\"Admin\"\n                                collection=\"company\"\n                                selected-values=\"[item.company_info]\"\n                                on-value-change=\"controller.changeCompany(value, item)\"\n                                label=\"'No company'\"\n                                search-label=\"'Search company'\"></api-select-search>\n                    </td>\n                    <td md-cell ng-hide=\"controller.isClient()\">\n                        <!--<span>{{item.booth_type}}</span>-->\n                        <md-select\n                                aria-label=\"Type\"\n                                ng-model=\"item.booth_type\"\n                                ng-change=\"controller.updateBooth(item)\">\n                            <md-option value=\"single\">Single Rental</md-option>\n                            <md-option value=\"longterm\">Long-term Rental</md-option>\n                            <md-option value=\"purchase\">Purchase</md-option>\n                        </md-select>\n                    </td>\n                    <td md-cell>\n                        <span>{{item.deployment.name}}</span>\n                    </td>\n                    <td md-cell>{{item.current_configuration.name}}</td>\n                    <td md-cell ng-hide=\"controller.isClient()\">{{item.deployment.status}}</td>\n                    <td md-cell>\n                        <span ng-class=\"controller.getBoothStatusClass(item.status)\">{{item.status}} <span ng-show=\"controller.isBoothOnline(item.status)\">&bull;</span></span>\n                    </td>\n                    <td md-cell>\n                        <md-menu md-position-mode=\"target-right target\" permission-hide=\"Sub-User\">\n                            <md-button aria-label=\"Menu options\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                                <md-icon class=\"material-icons\">more_vert</md-icon>\n                            </md-button>\n                            <md-menu-content>\n\n<!--                                <md-menu-item-->\n<!--                                        ng-show=\"controller.isAvailableForUser(item)\" >-->\n<!--                                    <md-button ng-click=\"controller.setConfigurationId(item)\">-->\n<!--                                        <div layout=\"row\" flex>-->\n<!--                                            <p flex translate>{{ \"Apply Configuration\" }}</p>-->\n<!--                                            <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">settings</md-icon>-->\n<!--                                        </div>-->\n<!--                                    </md-button>-->\n<!--                                </md-menu-item>-->\n\n                                <md-menu-item\n                                        ng-hide=\"controller.$auth.isRole('Sub-User')\">\n                                    <md-button ng-click=\"controller.openVersionDialog(item)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>{{ \"Update App\" }}</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">check_circle_outline</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n\n                                <md-menu-item\n                                        ng-hide=\"!item.deployment || !controller.isBoothOnline(item.status)\">\n                                    <md-button ng-click=\"controller.removeDeployment(item)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>{{ \"Remove deployment\" }}</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">check_circle_outline</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n\n                                <md-menu-item\n                                        ng-show=\"controller.canClientUpdateViewer(item) && controller.isBoothOnline(item.status)\">\n                                    <md-button ng-click=\"controller.updateTeamViewer(item, false)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>{{ \"Start Team Viewer\" }}</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">turned_in</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n\n                                <md-menu-item\n                                        ng-show=\"controller.canClientUpdateViewer(item) && controller.isBoothOnline(item.status)\">\n                                    <md-button ng-click=\"controller.updateTeamViewer(item, true)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>{{ \"Close Team Viewer\" }}</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">turned_in_not</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n\n                                <md-menu-item\n                                        ng-show=\"controller.canClientUpdateViewer(item) && controller.isBoothOnline(item.status)\">\n                                    <md-button ng-click=\"controller.updateDropbox(item, false)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>{{ \"Start Dropbox\" }}</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">cloud_queue</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n\n                                <md-menu-item\n                                        ng-show=\"controller.canClientUpdateViewer(item) && controller.isBoothOnline(item.status)\">\n                                    <md-button ng-click=\"controller.updateDropbox(item, true)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>{{ \"Stop Dropbox\" }}</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">cloud_off</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n\n                                <md-menu-item\n                                        ng-hide=\"controller.$auth.isRole('Sub-User')\">\n                                    <md-button ng-click=\"controller.openPasswordDialog(item, false)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>{{ \"Set App password\" }}</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">lock</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n\n                                <md-menu-item\n                                    ng-hide=\"controller.$auth.isRole('Sub-User')\">\n                                    <md-button ng-click=\"controller.openPasswordDialog(item, true)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>{{ \"Set Exit password\" }}</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">lock</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n                            </md-menu-content>\n                        </md-menu>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <button md-button ng-if=\"canAddMore && !loading\" ng-click=\"controller.addMoreItems()\" style=\"color: #FF0051\">Load more</button>\n\n    </md-card>\n</md-content>";

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(189);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(239);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	var _setConfiguration = __webpack_require__(527);
	
	var _setConfiguration2 = __webpack_require__(528);
	
	var _setConfiguration3 = _interopRequireDefault(_setConfiguration2);
	
	var _applyVersion = __webpack_require__(529);
	
	var _applyVersion2 = __webpack_require__(530);
	
	var _applyVersion3 = _interopRequireDefault(_applyVersion2);
	
	var _setPassword = __webpack_require__(531);
	
	var _setPassword2 = __webpack_require__(532);
	
	var _setPassword3 = _interopRequireDefault(_setPassword2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// let process = require("process");
	
	var dependencies = ["$Company", "$Configuration", "$Deployment", "$companies", "$Booth", "$SetConfigToBooth", "$Version", "$ApplyAppVersion"];
	
	var Controller = function (_$controller) {
	    Controller.$inject = ["$injector", "$scope", "$state", "$interval", "$auth", "$ToastService"];
	    (0, _inherits3.default)(Controller, _$controller);
	
	    function Controller($injector, $scope, $state, $interval, $auth, $ToastService) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, Controller);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Controller.__proto__ || (0, _getPrototypeOf2.default)(Controller)).call(this, $injector, dependencies));
	
	        _this.$state = $state;
	        _this.$scope = $scope;
	        _this.$auth = $auth;
	        _this.toastService = $ToastService;
	        _this.$scope.loading = true;
	        _this.$scope.query = { page: 1, search: "" };
	        _this.$scope.filter = {};
	        _this.$scope.selectFilter = {};
	        _this.$scope.boothsArray = [];
	        _this.$scope.pageCount = 0;
	        _this.$scope.canAddMore = true;
	        _this.socket = null;
	        _this.channelName = "";
	        _this.$scope.logOrder = function () {
	            _this.$scope.query.ordering = _this.$scope.query.order.replace("_", "");
	            _this.query(true);
	        };
	
	        _this.searchByKeyPress = function (event) {
	            var keyName = event.key;
	            var letters = "abcdefghijklmnopqrstuvwxyz";
	            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
	                _this.$scope.$apply(function () {
	                    _this.$scope.filter.show = true;
	                    if (!_this.$scope.query.search) {
	                        _this.$scope.query.search = keyName;
	                    }
	                });
	                (0, _lodash.delay)(function () {
	                    document.getElementById("search-field").focus();
	                }, 100);
	            }
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(Controller, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.$scope.filter.show = false;
	            this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
	            document.addEventListener("keypress", this.searchByKeyPress);
	            this.startWebSocket();
	        }
	    }, {
	        key: "startWebSocket",
	        value: function startWebSocket() {
	            var _this2 = this;
	
	            this.socket = new WebSocket("wss://" + ( true ? ("https://cloud.upreach.com").split("//")[1] : "cloud.upreach.com") + "/ws/user/?token=" + this.$auth.getToken().split(" ")[1]);
	            this.socket.onmessage = function (e) {
	                try {
	                    var data = JSON.parse(e.data);
	                    switch (data.action) {
	                        case "booth-update":
	                            for (var i = 0; i < _this2.$scope.boothsArray.length; i++) {
	                                if (_this2.$scope.boothsArray[i].booth_id === data.entity.booth_id) {
	                                    _this2.$scope.boothsArray[i] = data.entity;
	                                }
	                            }
	                            _this2.$scope.$apply(function () {
	                                return _this2.$scope.boothsArray;
	                            });
	                            return;
	                        case "booth-delete":
	                            for (var _i = 0; _i < _this2.$scope.boothsArray.length; _i++) {
	                                if (_this2.$scope.boothsArray[_i].booth_id === data.entity.booth_id) {
	                                    _this2.$scope.boothsArray.splice(_i, 1);
	                                }
	                            }
	                            _this2.$scope.$apply(function () {
	                                return _this2.$scope.boothsArray;
	                            });
	                            return;
	                        case "send-channel-name":
	                            _this2.channelName = data.channel_name;
	                            return;
	                    }
	                } catch (e) {
	                    console.log(e);
	                }
	            };
	            this.socket.onopen = function () {
	                console.log("CONNECTION Opened!", _this2.socket);
	            };
	            this.socket.onclose = function () {
	                console.log("CONNECTION Closed!", _this2.socket);
	                _this2.socket = null;
	                setTimeout(function () {
	                    if (_this2.startWebSocket) {
	                        console.log("CONNECTION Try to reconnect!", _this2.socket);
	                        _this2.startWebSocket();
	                    }
	                }, 5000);
	            };
	            this.socket.onerror = function (e) {
	                console.log("CONNECTION Error!", e);
	            };
	        }
	    }, {
	        key: "$onDestroy",
	        value: function $onDestroy() {
	            this.socket.close();
	            this.startWebSocket = null;
	            this.socket = null;
	            document.removeEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "query",
	        value: function query(isNew) {
	            var _this3 = this;
	
	            this.$scope.query.page = isNew ? 1 : this.$scope.query.page;
	            this.$scope.loading = true;
	            var booths = this.$Booth.query(this.$scope.query);
	
	            _promise2.default.all([booths.$promise]).then(function () {
	                var _$scope$boothsArray;
	
	                _this3.$scope.loading = false;
	
	                isNew ? _this3.$scope.boothsArray = booths : (_$scope$boothsArray = _this3.$scope.boothsArray).push.apply(_$scope$boothsArray, (0, _toConsumableArray3.default)(booths));
	                _this3.$scope.pageCount = booths._meta.page_count;
	                _this3.$scope.canAddMore = _this3.$scope.query.page !== _this3.$scope.pageCount;
	                _this3.sendBoothIds();
	
	                _this3.$scope.$apply();
	            });
	        }
	    }, {
	        key: "removeFilter",
	        value: function removeFilter() {
	            this.$scope.filter.show = false;
	            this.$scope.query.search = "";
	        }
	    }, {
	        key: "showFilter",
	        value: function showFilter() {
	            this.$scope.filter.show = true;
	            (0, _lodash.delay)(function () {
	                document.getElementById("search-field").focus();
	            }, 100);
	        }
	    }, {
	        key: "addMoreItems",
	        value: function addMoreItems() {
	            this.$scope.query.page++;
	            this.query();
	        }
	    }, {
	        key: "sendBoothIds",
	        value: function sendBoothIds() {
	            if (!this.socket) {
	                return;
	            }
	            var ids = [];
	            (0, _lodash.forEach)(this.$scope.boothsArray, function (b) {
	                ids.push(b.booth_id);
	            });
	            this.socket.send((0, _stringify2.default)({ action: "current-channel", channel_name: this.channelName, booth_ids: ids }));
	        }
	    }, {
	        key: "onQueryFilterChange",
	        value: function onQueryFilterChange() {
	            var _this4 = this;
	
	            this.$scope.query.page = 1;
	            var newValue = (0, _lodash.clone)(this.$scope.query.search);
	            this.$scope.loading = true;
	            this.searhDelayTimeout = setTimeout(function () {
	                var prewValue = (0, _lodash.clone)(_this4.$scope.query.search);
	                if (prewValue === newValue) {
	                    clearTimeout(_this4.searhDelayTimeout);
	                    _this4.query(true);
	                }
	            }, 500);
	        }
	    }, {
	        key: "updateBooth",
	        value: function updateBooth(booth) {
	            var _this5 = this;
	
	            var id = booth.url.split("/")[booth.url.split("/").length - 2];
	            this.$scope.loading = true;
	            this.$auth.$http({
	                url: "/api/booths/" + id + "/",
	                method: "PUT",
	                data: { booth_type: booth.booth_type, company: booth.company }
	            }).then(function () {
	                _this5.$scope.loading = false;
	            }).catch(function () {});
	        }
	    }, {
	        key: "setConfigurationId",
	        value: function setConfigurationId(item) {
	            var _this6 = this;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Create new configuration",
	                controller: _setConfiguration.SetConfigurationController,
	                template: _setConfiguration3.default,
	                targetEvent: item,
	                locals: {
	                    callback: function callback(configuration) {
	                        _this6.applyConfiguration(configuration, item);
	                    },
	                    activeDeployment: item.deployment,
	                    configurationsArray: this.$scope.configurationsArray
	                }
	            });
	        }
	    }, {
	        key: "openVersionDialog",
	        value: function openVersionDialog(item) {
	            var _this7 = this;
	
	            var os_name = { os_name: "Windows" };
	            if (item.os_name) {
	                (0, _assign2.default)(os_name, item.os_name);
	            } else {
	                if (item.booth_id.includes("AN-")) {
	                    (0, _assign2.default)(os_name, { os_name: "Android" });
	                }
	            }
	            var versions = this.$Version.query(os_name);
	            versions.$promise.then(function (resp) {
	                var parentEl = angular.element(document.body);
	                _this7.$mdDialog.show({
	                    parent: parentEl,
	                    title: "Create new configuration",
	                    controller: _applyVersion.ApplyVersionController,
	                    template: _applyVersion3.default,
	                    targetEvent: item,
	                    locals: {
	                        callback: function callback(version) {
	                            _this7.applyAppVersion(version, item);
	                        },
	                        versions: resp,
	                        currentVersion: item.app_version
	                    }
	                });
	            }).catch(function () {
	                _this7.toastService.showError("Can't get versions list.", 5000);
	            });
	        }
	    }, {
	        key: "openPasswordDialog",
	        value: function openPasswordDialog(item, isExit) {
	            var _this8 = this;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: isExit ? "Set Exit password to booth" : "Set App password",
	                controller: _setPassword.SetPasswordController,
	                template: _setPassword3.default,
	                targetEvent: item,
	                locals: {
	                    callback: function callback(password) {
	                        _this8.applyPassword(password, item, isExit);
	                    },
	                    title: isExit ? "Set exit password to booth" : "Set app password",
	                    password: isExit ? item.exit_password || null : item.password || null
	                }
	            });
	        }
	    }, {
	        key: "applyConfiguration",
	        value: function applyConfiguration(config, booth) {
	            var _this9 = this;
	
	            var q = {
	                configuration_url: config.config,
	                booth_id: booth.booth_id
	            };
	            this.$SetConfigToBooth.update(q).$promise.then(function () {
	                _this9.toastService.showSimple("Configuration successfully applied.", 5000);
	                _this9.query(true);
	            }).catch(function () {
	                _this9.toastService.showError("Can't apply configuration.", 5000);
	            });
	        }
	    }, {
	        key: "applyAppVersion",
	        value: function applyAppVersion(version, booth) {
	            var _this10 = this;
	
	            var q = {
	                version: version,
	                booth_id: booth.booth_id
	            };
	            this.$ApplyAppVersion.update(q).$promise.then(function () {
	                _this10.toastService.showSimple("New version applied.", 5000);
	                _this10.query(true);
	            }).catch(function () {
	                _this10.toastService.showError("Can't apply version.", 5000);
	            });
	        }
	    }, {
	        key: "applyPassword",
	        value: function applyPassword(password, booth, isExit) {
	            var _this11 = this;
	
	            var q = {
	                new_password: password,
	                booth_id: booth.booth_id
	            };
	
	            var auth = isExit ? this.$auth.$http({
	                url: "/api/booth-set-exit-password/",
	                method: "PUT",
	                data: q
	            }) : this.$auth.$http({
	                url: "/api/booth-set-app-password/",
	                method: "PUT",
	                data: q
	            });
	            auth.then(function () {
	                _this11.toastService.showSimple("Password set!", 5000);
	            }).catch(function () {
	                _this11.toastService.showError("Can't set password.", 5000);
	            });
	        }
	    }, {
	        key: "isAvailableForUser",
	        value: function isAvailableForUser(booth) {
	            var userRoles = this.$auth.getUser().groups_names;
	
	            if (!booth.deployment) {
	                return false;
	            }
	
	            if ((0, _lodash.includes)(userRoles, "Admin") || (0, _lodash.includes)(userRoles, "Manager")) {
	                return true;
	            }
	
	            if (booth.booth_type !== "single") {
	                return true;
	            }
	
	            return booth.deployment.is_active;
	        }
	    }, {
	        key: "updateTeamViewer",
	        value: function updateTeamViewer(booth, isClose) {
	            var _this12 = this;
	
	            this.$auth.$http({
	                url: "/api/booth-teamviewer/",
	                method: "PUT",
	                data: { action: isClose ? "kill-teamviewer" : "start-teamviewer", booth_id: booth.booth_id }
	            }).then(function () {
	                _this12.toastService.showSimple("Team Viewer " + (isClose ? "close" : "open") + " request sent", 5000);
	            }).catch(function () {
	                _this12.toastService.showError("Can't send request!", 5000);
	            });
	        }
	    }, {
	        key: "updateDropbox",
	        value: function updateDropbox(booth, isClose) {
	            var _this13 = this;
	
	            this.$auth.$http({
	                url: "/api/booth-dropbox/",
	                method: "PUT",
	                data: { action: isClose ? "kill-dropbox" : "start-dropbox", booth_id: booth.booth_id }
	            }).then(function () {
	                _this13.toastService.showSimple("Dropbox " + (isClose ? "close" : "start") + " request sent", 5000);
	            }).catch(function () {
	                _this13.toastService.showError("Can't send request!", 5000);
	            });
	        }
	    }, {
	        key: "canClientUpdateViewer",
	        value: function canClientUpdateViewer(booth) {
	
	            if (booth.booth_type === "single" && this.isClient()) {
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: "removeDeployment",
	        value: function removeDeployment(item) {
	            var _this14 = this;
	
	            var confirm = this.$mdDialog.confirm().title("Remove Deployment?").textContent("This will remove \u201C" + item.deployment.name + "\u201D and all its Configurations from " + item.booth_id + ". It will remain in the \n            UpReach Cloud and can be downloaded again any time.").ariaLabel("Deployment").ok("REMOVE").cancel("CANCEL");
	
	            this.$mdDialog.show(confirm).then(function () {
	                _this14.$auth.$http({
	                    url: "/api/booth-remove-deployment/",
	                    method: "PUT",
	                    data: { deployment_url: item.deployment.url, booth_id: item.booth_id }
	                }).then(function () {
	                    _this14.toastService.showSimple("Deployment removed", 5000);
	                }).catch(function () {
	                    _this14.toastService.showError("Can't remove deployment!", 5000);
	                });
	            });
	        }
	    }, {
	        key: "changeCompany",
	        value: function changeCompany(value, item) {
	            this.updateBooth(item);
	        }
	    }, {
	        key: "onSearchBlur",
	        value: function onSearchBlur() {
	            if (!this.$scope.query.search) {
	                this.$scope.filter.show = false;
	            }
	        }
	    }, {
	        key: "isClient",
	        value: function isClient() {
	            return this.$auth.isRole("Client") || this.$auth.isRole("Sub-User");
	        }
	    }, {
	        key: "getBoothStatusClass",
	        value: function getBoothStatusClass(status) {
	            if (status.indexOf("online") !== -1) {
	                return "online";
	            } else if (status.indexOf("error") !== -1) {
	                return "error";
	            } else {
	                return "";
	            }
	        }
	    }, {
	        key: "isBoothOnline",
	        value: function isBoothOnline(status) {
	            return status.indexOf("online") !== -1;
	        }
	    }]);
	    return Controller;
	}(_index.$controller);
	
	exports.default = Controller;

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SetConfigurationController = exports.SetConfigurationController = ["$scope", "$mdDialog", "callback", function SetConfigurationController($scope, $mdDialog, callback) {
	    "ngInject";
	
	    $scope.callback = callback;
	    // $scope.configurationsArray = configurationsArray;
	    // $scope.deployment = activeDeployment;
	
	    // $scope.filteredConfig = cloneDeep(filter($scope.configurationsArray, (c) => {
	    //     return includes($scope.deployment.configurations, c.url);
	    // }));
	
	    $scope.configObjects = {
	        config: null
	    };
	
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	
	    $scope.create = function () {
	        callback($scope.configObjects);
	        document.onkeypress = function () {};
	        $mdDialog.hide();
	    };
	
	    document.onkeypress = function (ev) {
	        if (ev.key === "Enter") {
	            if ($scope.configObjects.config) {
	                $scope.create();
	            }
	        }
	    };
	}];

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Create new configuration\">\n    <md-dialog-content style=\"overflow: hidden; width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\">{{'Apply Configuration' | translate}}</h2>\n            <form name=\"configurationCreateForm\">\n                <api-select-search\n                        model=\"configObjects.config\"\n                        multiple=\"false\"\n                        collection=\"configuration\"\n                        label=\"'Select configuration'\"\n                        search-label=\"'Search configuration'\"\n                        width=\"250px\"></api-select-search>\n            </form>\n        </div>\n\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"create()\"\n                class=\"md-primary\"\n                ng-disabled=\"!configObjects.config\">{{'Apply' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>";

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ApplyVersionController = undefined;
	
	var _lodash = __webpack_require__(101);
	
	var ApplyVersionController = exports.ApplyVersionController = ["$scope", "$mdDialog", "callback", "versions", function ApplyVersionController($scope, $mdDialog, callback, versions) {
	    "ngInject";
	
	    $scope.callback = callback;
	    $scope.versions = (0, _lodash.orderBy)(versions, function (v) {
	        return v.version.replace(/[^\d.]/g, "").split(".").map(function (n) {
	            return +n + 100000;
	        }).join(".");
	    }, ["desc"]);
	    $scope.versions = $scope.versions.splice(0, 4);
	
	    $scope.selectedVersion = {
	        version: null
	    };
	
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	
	    $scope.create = function () {
	        callback($scope.selectedVersion.version);
	        document.onkeypress = function () {};
	        $mdDialog.hide();
	    };
	
	    document.onkeypress = function (ev) {
	        if (ev.key === "Enter") {
	            if ($scope.selectedVersion.version) {
	                $scope.create();
	            }
	        }
	    };
	}];

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Create new configuration\">\n    <md-dialog-content style=\"overflow: hidden; width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\">{{'Update App Version' | translate}}</h2>\n            <form name=\"configurationCreateForm\">\n                <md-input-container md-no-float class=\"md-inline-form\" style=\"width: 100%;\" ng-if=\"versions.length\">\n                    <label for=\"configurationCompany\">{{'Version' | translate}}</label>\n                    <md-select ng-model=\"selectedVersion.version\" id=\"configurationCompany\" required>\n                        <md-option ng-value=\"item.version\" ng-repeat=\"item in versions\">{{item.version}}</md-option>\n                    </md-select>\n                </md-input-container>\n                <p style=\"text-align: center\" ng-if=\"!versions.length\">Any available version</p>\n            </form>\n        </div>\n\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"create()\"\n                class=\"md-primary\"\n                ng-disabled=\"configurationCreateForm.$invalid || !versions.length\">{{'Update' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>";

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SetPasswordController = exports.SetPasswordController = ["$scope", "$mdDialog", "callback", "title", "password", function SetPasswordController($scope, $mdDialog, callback, title, password) {
	    "ngInject";
	
	    $scope.callback = callback;
	    $scope.title = title;
	    $scope.password = password || null;
	
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	
	    $scope.set = function () {
	        callback($scope.password);
	        document.onkeypress = function () {};
	        $mdDialog.hide();
	    };
	
	    document.onkeypress = function (ev) {
	        if (ev.key === "Enter") {
	            if ($scope.password && $scope.password.length >= 7) {
	                $scope.create();
	            }
	        }
	    };
	}];

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Create new configuration\">\n    <md-dialog-content style=\"overflow: hidden; width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\">{{title | translate}}</h2>\n            <form name=\"setPassword\">\n                <md-input-container md-no-float class=\"md-inline-form\" style=\"width: 100%;\" >\n                    <label for=\"password\">{{Password | translate}}</label>\n                    <input\n                            type=\"text\"\n                            id=\"password\"\n                            name=\"password\"\n                            ng-model=\"password\"\n                            autocomplete=\"new-password\"\n                            required\n                            placeholder=\"password\"\n                            minlength=\"7\"\n                            maxlength=\"100\">\n\n                    <div ng-messages=\"setPassword.password.$error\" role=\"alert\">\n                        <div ng-message-exp=\"['required', 'maxlength', 'minlength']\"\n                             ng-bind=\"'Your password should be at least 7 characters long' | translate\">\n                        </div>\n                    </div>\n                </md-input-container>\n            </form>\n        </div>\n\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"set()\"\n                class=\"md-primary\"\n                ng-disabled=\"setPassword.$invalid\">{{'Set' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>";

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(534);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./booths.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./booths.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "booths md-card{width:98%}booths .reverse{transform:rotate(180deg)}booths .filters{display:flex;align-items:center;justify-content:flex-end;font-size:12px;font-weight:700;border-bottom:1px solid #d3d3d3}booths .filters div{margin:0 10px;padding:0 20px}booths .filters div md-select{width:130px;max-width:130px;margin:15px 0 18px}booths .filters .divider{height:30px;border-left:1px solid #d3d3d3;padding:0}booths .online{color:#2a0}booths .error{color:#b71c1c}", ""]);
	
	// exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usersRouter = __webpack_require__(536);
	
	var _usersRouter2 = _interopRequireDefault(_usersRouter);
	
	var _usersComponent = __webpack_require__(537);
	
	var _usersComponent2 = _interopRequireDefault(_usersComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Module = angular.module("app.users", []).component("users", _usersComponent2.default).config(_usersRouter2.default);
	
	exports.default = Module;

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	"use strict";
	
	Router.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Router;
	function Router($stateProvider) {
	    "ngInject";
	
	    $stateProvider.state({
	        name: "users",
	        url: "/app/users/:createdCompany",
	        template: "<users></users>",
	        resolve: {
	            $title: function $title() {
	                return "Users | UpReach Cloud";
	            }
	        }
	    });
	}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _users = __webpack_require__(538);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _users3 = __webpack_require__(539);
	
	var _users4 = _interopRequireDefault(_users3);
	
	__webpack_require__(542);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoothsComponent = {
	    template: _users2.default,
	    controller: _users4.default,
	    controllerAs: "controller"
	};
	
	exports.default = BoothsComponent;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<md-content layout=\"column\" flex layout-align=\"top center\">\n    <md-card>\n        <md-toolbar class=\"md-table-toolbar md-default\">\n            <div class=\"md-toolbar-tools\">\n                <span>Users</span>\n                <div flex></div>\n\n                <div flex=\"70\" class=\"md-toolbar-tools md-toolbar-search\" ng-if=\"filter.show\" layout=\"row\" layout-align=\"center right\">\n                    <md-input-container md-no-float flex>\n                        <input ng-blur=\"controller.onSearchBlur()\" type=\"text\" id=\"search-field\" placeholder=\"Search in the Users table\" ng-model=\"query.search\" ng-model-options=\"filter.options\" class=\"ng-pristine ng-valid ng-touched\">\n                    </md-input-container>\n                    <button class=\"md-icon-button md-button md-ink-ripple\" type=\"button\" ng-click=\"controller.removeFilter()\" layout-align=\"center right\">\n                        <md-icon class=\"material-icons\">search</md-icon>\n                        <div class=\"md-ripple-container\"></div>\n                    </button>\n                </div>\n                <md-button class=\"md-icon-button md-button md-ink-ripple\" ng-click=\"controller.showFilter()\" ng-if=\"!filter.show\" ng-show=\"users.length\">\n                    <md-icon class=\"material-icons\">search</md-icon>\n                    <div class=\"md-ripple-container\"></div>\n                </md-button>\n                <md-button class=\"md-icon-button md-button md-ink-ripple\" title=\"Send invitation\" ng-click=\"controller.openInviteDialog($event)\" permission-hide=\"Sub-User\">\n                    <md-icon class=\"material-icons\">person_add</md-icon>\n                    <div class=\"md-ripple-container\"></div>\n                </md-button>\n\n            </div>\n        </md-toolbar>\n\n        <md-table-container ng-if=\"!users._meta.count\" class=\"no-items\">\n            <div ng-if=\"loading\" translate>Loading users list...</div>\n            <div ng-if=\"!loading && filter.show\" translate>No results found for: '{{ query.search }}'</div>\n        </md-table-container>\n\n        <!--<md-table-container ng-if=\"configurations._meta.count\">-->\n        <md-table-container ng-if=\"users.length\">\n            <table md-table md-row-select=\"options.rowSelection\" multiple=\"{{options.multiSelect}}\" ng-model=\"selected\" md-progress=\"promise\">\n                <thead ng-if=\"!options.decapitate\" md-head md-order=\"query.order\" md-on-reorder=\"logOrder\">\n                <tr md-row>\n                    <th md-column md-order-by=\"_first_name\"><span>{{'First name' | translate}}</span></th>\n                    <th md-column md-order-by=\"_last_name\"><span>{{'Last name' | translate}}</span></th>\n                    <th md-column md-order-by=\"_email\"><span>{{'Email' | translate}}</span></th>\n                    <th md-column md-order-by=\"_client\"><span>{{'Client' | translate}}</span></th>\n                    <th md-column md-order-by=\"_groups_names\"><span>{{'Group' | translate}}</span></th>\n                    <th md-column></th>\n                </tr>\n                </thead>\n                <tbody md-body>\n                <tr md-row ng-repeat=\"item in users | orderBy: query.order | limitTo: query.limit : (query.page -1) * query.limit\">\n\n                    <td md-cell>{{item.first_name}}</td>\n                    <td md-cell>{{item.last_name}}</td>\n                    <td md-cell>{{item.email}}</td>\n                    <td md-cell>{{item.company.name}}</td>\n                    <td md-cell>{{controller.transformGroupsView(item.groups_names)}}</td>\n\n                    <td md-cell>\n                        <md-menu md-position-mode=\"target-right target\" permission-hide=\"Sub-User\">\n                            <md-button aria-label=\"Menu options\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                                <md-icon class=\"material-icons\">more_vert</md-icon>\n                            </md-button>\n                            <md-menu-content width=\"2\" >\n                                <md-menu-item>\n                                    <md-button ng-click=\"controller.resetPassword(item.email)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>{{ \"Reset password\" }}</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 0 auto 6px;\">restore</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n\n                                <md-menu-item>\n                                    <md-button ng-click=\"controller.setTwoFactorAuth(item.two_factor_enabled,item.url)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>{{ \"Enable 2FA\" }}</p>\n                                            <div class=\"icon-wrapper\">\n                                                <img src=\"" + __webpack_require__(220) + "\" alt=\"2factorAuth-icon\">\n                                            </div>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n\n                                <md-menu-item>\n                                    <md-button ng-click=\"controller.deleteUser(item)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>{{ \"Delete user\" }}</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 0 auto 6px;\">delete</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n                            </md-menu-content>\n                        </md-menu>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n\n        <button md-button ng-if=\"canAddMore && !loading\" ng-click=\"controller.addMoreItems()\" style=\"color: #FF0051\">Load more</button>\n\n        <!--<md-table-pagination ng-if=\"users._meta.count > 10\" md-limit=\"10\" md-page=\"query.page\" md-page-select=\"true\" md-total=\"{{users._meta.count}}\"  ></md-table-pagination>-->\n\n    </md-card>\n</md-content>\n";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	var _inviteNew = __webpack_require__(540);
	
	var _inviteNew2 = __webpack_require__(541);
	
	var _inviteNew3 = _interopRequireDefault(_inviteNew2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Users", "$Company", "$Invitations"];
	
	var Controller = function (_$controller) {
	    Controller.$inject = ["$injector", "$scope", "$state", "$stateParams", "$ToastService", "$UndoDeleteService", "$auth", "$mdDialog"];
	    (0, _inherits3.default)(Controller, _$controller);
	
	    function Controller($injector, $scope, $state, $stateParams, $ToastService, $UndoDeleteService, $auth, $mdDialog) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, Controller);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Controller.__proto__ || (0, _getPrototypeOf2.default)(Controller)).call(this, $injector, dependencies));
	
	        _this.$state = $state;
	        _this.$scope = $scope;
	        _this.$stateParams = $stateParams;
	        _this.toastService = $ToastService;
	        _this.$scope.loading = true;
	        _this.$scope.query = { page: 1, search: "" };
	        _this.$scope.filter = {};
	        _this.$scope.selectFilter = {};
	        _this.$scope.users = [];
	        _this.$scope.pageCount = 0;
	        _this.$scope.canAddMore = true;
	        _this.undoDelete = $UndoDeleteService;
	        _this.$auth = $auth;
	        _this.$mdDialog = $mdDialog;
	        _this.$scope.logOrder = function () {
	            _this.$scope.query.ordering = _this.$scope.query.order.replace("_", "");
	            _this.query(true);
	        };
	
	        _this.searchByKeyPress = function (event) {
	            var keyName = event.key;
	            var letters = "abcdefghijklmnopqrstuvwxyz";
	            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
	                _this.$scope.$apply(function () {
	                    _this.$scope.filter.show = true;
	                    if (!_this.$scope.query.search) {
	                        _this.$scope.query.search = keyName;
	                    }
	                });
	                (0, _lodash.delay)(function () {
	                    document.getElementById("search-field").focus();
	                }, 100);
	            }
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Controller, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.$scope.filter.show = false;
	            this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
	            if (this.$stateParams.createdCompany) {
	                this.openInviteDialog(null, this.$stateParams.createdCompany);
	            }
	            document.addEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "$onDestroy",
	        value: function $onDestroy() {
	            document.removeEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "query",
	        value: function query(isNew) {
	            var _this2 = this;
	
	            this.$scope.query.page = isNew ? 1 : this.$scope.query.page;
	
	            var users = this.$Users.query(this.$scope.query);
	            this.$scope.loading = true;
	
	            users.$promise.then(function (resp) {
	                var _$scope$users;
	
	                isNew ? _this2.$scope.users = resp : (_$scope$users = _this2.$scope.users).push.apply(_$scope$users, (0, _toConsumableArray3.default)(resp));
	                _this2.$scope.loading = false;
	                _this2.$scope.pageCount = resp._meta.page_count;
	
	                _this2.$scope.canAddMore = _this2.$scope.query.page !== _this2.$scope.pageCount;
	            });
	        }
	    }, {
	        key: "removeFilter",
	        value: function removeFilter() {
	            this.$scope.filter.show = false;
	            this.$scope.query.search = "";
	        }
	    }, {
	        key: "showFilter",
	        value: function showFilter() {
	            this.$scope.filter.show = true;
	            (0, _lodash.delay)(function () {
	                document.getElementById("search-field").focus();
	            }, 100);
	        }
	    }, {
	        key: "addMoreItems",
	        value: function addMoreItems() {
	            this.$scope.query.page++;
	            this.query();
	        }
	    }, {
	        key: "onQueryFilterChange",
	        value: function onQueryFilterChange() {
	            var _this3 = this;
	
	            this.$scope.query.page = 1;
	            var newValue = (0, _lodash.clone)(this.$scope.query.search);
	            this.$scope.loading = true;
	            this.searhDelayTimeout = setTimeout(function () {
	                var prewValue = (0, _lodash.clone)(_this3.$scope.query.search);
	                if (prewValue === newValue) {
	                    clearTimeout(_this3.searhDelayTimeout);
	                    _this3.query(true);
	                }
	            }, 500);
	        }
	    }, {
	        key: "transformGroupsView",
	        value: function transformGroupsView(arr) {
	            return arr.join(", ");
	        }
	    }, {
	        key: "openInviteDialog",
	        value: function openInviteDialog(item, selectedCompany) {
	            var _this4 = this;
	
	            var companies = this.$Company.query({ page_size: 100 });
	            companies.$promise.then(function (resp) {
	                var parentEl = angular.element(document.body);
	                _this4.$mdDialog.show({
	                    parent: parentEl,
	                    title: "Create new configuration",
	                    controller: _inviteNew.InviteNewController,
	                    template: _inviteNew3.default,
	                    targetEvent: item,
	                    locals: {
	                        callback: function callback(invitation) {
	                            _this4.sendInvitation(invitation);
	                        },
	                        companiesArray: resp,
	                        selectedCompany: selectedCompany
	                    }
	                });
	            }).catch(function () {
	                _this4.toastService.showError("Can't send invitation.", 5000);
	            });
	        }
	    }, {
	        key: "sendInvitation",
	        value: function sendInvitation(invitation) {
	            var _this5 = this;
	
	            var invite = this.$Invitations.create(invitation);
	            invite.$promise.then(function () {
	                _this5.toastService.showSimple("Invitation sent.", 5000);
	            }).catch(function () {
	                _this5.toastService.showError("Can't send invitation.");
	            });
	        }
	    }, {
	        key: "resetPassword",
	        value: function resetPassword(email) {
	            var _this6 = this;
	
	            this.$auth.$http({
	                url: "/api/password/reset/",
	                method: "POST",
	                data: { email: email }
	            }).then(function () {
	                _this6.toastService.showSimple("Reset link sent.", 5000);
	            }, function () {
	                _this6.toastService.showError("Can't reset password.");
	            });
	        }
	    }, {
	        key: "onSearchBlur",
	        value: function onSearchBlur() {
	            if (!this.$scope.query.search) {
	                this.$scope.filter.show = false;
	            }
	        }
	    }, {
	        key: "checkAccount",
	        value: function checkAccount(deletedUserEmail, callback) {
	            var currentUser = this.$auth.getUser();
	            var currentUserEmail = currentUser ? currentUser.email : null;
	
	            if (currentUserEmail && currentUserEmail === deletedUserEmail) {
	                var confirm = this.$mdDialog.confirm().title("Warning").textContent("You are trying to delete your own account. After this your access to UpReach cloud may be lost!").ariaLabel("Own Account Delete").ok("DELETE").cancel("CANCEL");
	                this.$mdDialog.show(confirm).then(function () {
	                    callback(true);
	                }).catch(function () {});
	            } else {
	                callback(false);
	            }
	        }
	    }, {
	        key: "deleteUser",
	        value: function deleteUser(user) {
	            var _this7 = this;
	
	            this.checkAccount(user.email, function (isOwnAccount) {
	                user.$delete().then(function () {
	                    if (!isOwnAccount) {
	                        _this7.toastService.deleteToast("Deleted user " + user.first_name + " " + user.last_name, function () {
	                            _this7.undoDelete.undoDelete("users", _this7.$filter("getObjectId")(user.url)).then(function () {
	                                _this7.toastService.showSimple("Deletion undone", 5000);
	                                _this7.query(true);
	                            }).catch(function () {
	                                _this7.toastService.showError("Could not undone deletion", 5000);
	                            });
	                        });
	                        _this7.query(true);
	                    } else {
	                        _this7.$auth.logout();
	                    }
	                }, function () {
	                    _this7.toastService.showError("Can't delete user!", 5000);
	                });
	            });
	        }
	    }, {
	        key: "setTwoFactorAuth",
	        value: function setTwoFactorAuth(two_factor_enabled, id) {
	            var _this8 = this;
	
	            var userId = id.split("/api/users/")[1].split("/")[0];
	            var twoFactorEnabled = two_factor_enabled;
	            this.$auth.twoFactorAuthenticationState({ enable: !two_factor_enabled, user: userId }).then(function (resp) {
	                var userIndex = _this8.$scope.users.findIndex(function (item) {
	                    return item.url === id;
	                });
	                if (userIndex !== -1) {
	                    _this8.$scope.users[userIndex].two_factor_enabled = !_this8.$scope.users[userIndex].two_factor_enabled;
	                }
	                var msg = resp && resp.detail ? resp.detail : "2Factor is " + !two_factor_enabled;
	                if (twoFactorEnabled == false) {
	                    _this8.$mdToast.show({
	                        template: "<md-toast class=\"custom-toast\">" + "<h4>Two-Factor Authentication Email Sent</h4>" + "<div class=\"custom-toast-content\">" + "We've sent a verification email to the selected user. They'll need to enter a security code on their next login to complete the setup.</div>" + "</md-toast>",
	                        position: "top right",
	                        hideDelay: 3000
	                    });
	                } else {
	                    _this8.$mdToast.show(_this8.$mdToast.simple().textContent(msg).position("top right").hideDelay(3000));
	                }
	            });
	        }
	    }]);
	    return Controller;
	}(_index.$controller);
	
	exports.default = Controller;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InviteNewController = undefined;
	
	var _lodash = __webpack_require__(101);
	
	var InviteNewController = exports.InviteNewController = ["$scope", "$mdDialog", "$auth", "callback", "companiesArray", "selectedCompany", function InviteNewController($scope, $mdDialog, $auth, callback, companiesArray, selectedCompany) {
	    "ngInject";
	
	    $scope.callback = callback;
	    $scope.companies = companiesArray;
	    $scope.selectedCompany = selectedCompany;
	    $scope.groups = [{ title: "Admin", url: "/api/groups/1/" }, { title: "Manager", url: "/api/groups/2/" }, { title: "Client", url: "/api/groups/3/" }, { title: "Sub-User", url: "/api/groups/4/" }];
	    $scope.user = $auth.getUser();
	
	    if ($scope.user.groups_names.indexOf("Admin") !== -1) {
	        $scope.groups = $scope.groups.slice(0, 4);
	    } else if ($scope.user.groups_names.indexOf("Manager") !== -1) {
	        $scope.groups = $scope.groups.slice(2, 4);
	    } else if ($scope.user.groups_names.indexOf("Client") !== -1) {
	        $scope.groups = $scope.groups.slice(3, 4);
	    } else if ($scope.user.groups_names.indexOf("Sub-User") !== -1) {
	        $scope.groups = $scope.groups.slice(4, 4);
	    }
	
	    $scope.inviteObj = {
	        email: "",
	        company: "",
	        group: "",
	        clients: []
	    };
	
	    if ($scope.selectedCompany) {
	        var c = (0, _lodash.find)($scope.companies, { name: $scope.selectedCompany });
	        $scope.inviteObj.company = c.url;
	        $scope.inviteObj.group = "/api/groups/3/";
	    }
	
	    $scope.closeDialog = function () {
	        $mdDialog.hide();
	    };
	
	    $scope.invite = function () {
	        callback($scope.inviteObj);
	        document.onkeypress = function () {};
	        $mdDialog.hide();
	    };
	
	    document.onkeypress = function (ev) {
	        if (ev.key === "Enter") {
	            if ($scope.inviteForm.$valid) {
	                $scope.create();
	            }
	        }
	    };
	}];

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Invite new users\">\n    <md-dialog-content style=\"overflow: hidden; width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\">{{'Invite new user' | translate}}</h2>\n            <form name=\"inviteForm\">\n                <md-input-container md-no-float class=\"md-inline-form\" style=\"width: 100%; height: 54px;\">\n                    <label for=\"email\">Email</label>\n                    <input type=\"email\" ng-model=\"inviteObj.email\" required id=\"email\">\n                </md-input-container>\n\n                <md-input-container md-no-float class=\"md-inline-form\" style=\"width: 100%; height: 54px;\">\n                    <label for=\"company\">Company</label>\n                    <md-select ng-model=\"inviteObj.company\" required id=\"company\">\n                        <md-option ng-repeat=\"item in companies\" ng-value=\"item.url\">{{item.name}}</md-option>\n                    </md-select>\n                </md-input-container>\n\n                <md-input-container md-no-float class=\"md-inline-form\" style=\"width: 100%; height: 54px;\">\n                    <label for=\"group\">Group</label>\n                    <md-select ng-model=\"inviteObj.group\" required id=\"group\">\n                        <md-option ng-repeat=\"item in groups\" ng-value=\"item.url\">{{item.title}}</md-option>\n                    </md-select>\n                </md-input-container>\n\n                <md-input-container ng-if=\"inviteObj.group === '/api/groups/2/'\" md-no-float class=\"md-inline-form\" style=\"width: 100%; height: 54px\">\n                    <label for=\"clients\">Clients</label>\n                    <md-select ng-model=\"inviteObj.clients\" required multiple id=\"clients\">\n                        <md-option ng-repeat=\"item in companies\" ng-value=\"item.url\">{{item.name}}</md-option>\n                    </md-select>\n                </md-input-container>\n            </form>\n        </div>\n\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"invite()\"\n                class=\"md-primary\"\n                ng-disabled=\"inviteForm.$invalid\">{{'Invite' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>";

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(543);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./users.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./users.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "users md-card{width:85%}", ""]);
	
	// exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.addressComponent = undefined;
	
	var _address = __webpack_require__(545);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _address3 = __webpack_require__(546);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addressComponent = exports.addressComponent = {
		template: _address2.default,
		controller: _address3.addressController,
		controllerAs: "address",
		bindings: {
			model: "=",
			location: "@"
		}
	};

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	module.exports = "\n<form name=\"addressForm\"></form>\n\t<div layout=\"column\">\n\t\t<div flex=\"100\">\n\t\t\t<md-input-container\n\t\t\t\t\tclass=\"md-block md-short-input\"\n\t\t\t\t\tng-if=\"address.location\">\n\t\t\t\t<label\n\t\t\t\t\t\tng-bind=\"'Deployment Location Name' | translate\"\n\t\t\t\t\t\tfor=\"locationName\"></label>\n\n\t\t\t\t<input\n\t\t\t\t\t\tng-model=\"address.model.locationName\"\n\t\t\t\t\t\ttype=\"text\"\n\t\t\t\t\t\tname=\"locationName\"\n\t\t\t\t\t\tid=\"locationName\"\n\t\t\t\t\t\tmaxlength=\"100\">\n\t\t\t</md-input-container>\n\n\t\t\t<md-input-container class=\"md-block md-short-input\">\n\t\t\t\t<label\n\t\t\t\t\t\tng-bind=\"'Street' | translate\"\n\t\t\t\t\t\tfor=\"street\"></label>\n\n\t\t\t\t<input\n\t\t\t\t\t\tng-model=\"address.model.street\"\n\t\t\t\t\t\ttype=\"text\"\n\t\t\t\t\t\tname=\"street\"\n\t\t\t\t\t\tid=\"street\"\n\t\t\t\t\t\tmaxlength=\"100\">\n\t\t\t</md-input-container>\n\n\t\t</div>\n\t</div>\n\n\t<div layout=\"row\">\n\t\t<div flex=\"50\">\n\t\t\t<md-input-container class=\"md-block md-short-input\">\n\t\t\t\t<label\n\t\t\t\t\t\tng-bind=\"'House Number' | translate\"\n\t\t\t\t\t\tfor=\"house\"></label>\n\n\t\t\t\t<input\n\t\t\t\t\tng-model=\"address.model.houseNo\"\n\t\t\t\t\ttype=\"text\"\n\t\t\t\t\tname=\"street\"\n\t\t\t\t\tid=\"house\"\n\t\t\t\t\tmaxlength=\"100\">\n\t\t\t</md-input-container>\n\t\t</div>\n\t\t<div flex=\"50\">\n\t\t\t<md-input-container class=\"md-block md-short-input\">\n\t\t\t\t<label\n\t\t\t\t\t\tng-bind=\"'Zip Code' | translate\"\n\t\t\t\t\t\tfor=\"zipcode\"></label>\n\n\t\t\t\t<input\n\t\t\t\t\tng-model=\"address.model.zipCode\"\n\t\t\t\t\ttype=\"text\"\n\t\t\t\t\tname=\"zipcode\"\n\t\t\t\t\tid=\"zipcode\"\n\t\t\t\t\tmaxlength=\"100\">\n\t\t\t</md-input-container>\n\t\t</div>\n\t</div>\n\n\t<div layout=\"row\">\n\t\t<div flex=\"50\">\n\t\t\t<md-input-container class=\"md-block md-short-input\">\n\t\t\t\t<label\n\t\t\t\t\t\tng-bind=\"'City' | translate\"\n\t\t\t\t\t\tfor=\"city\"></label>\n\n\t\t\t\t<input\n\t\t\t\t\tng-model=\"address.model.city\"\n\t\t\t\t\ttype=\"text\"\n\t\t\t\t\tname=\"city\"\n\t\t\t\t\tid=\"city\"\n\t\t\t\t\tmaxlength=\"100\">\n\t\t\t</md-input-container>\n\t\t</div>\n\t\t<div flex=\"50\">\n\t\t\t<select-search\n\t\t\t\tmodel=\"address.model.country\"\n\t\t\t\titem-label=\"name\"\n\t\t\t\titem-value=\"code\"\n\t\t\t\tlabel=\"'Country' | translate\"\n\t\t\t\tcollection=\"address.countries\">\n\t\t\t</select-search>\n\n\n\t\t\t<!--<md-input-container class=\"md-block md-short-input\">-->\n\t\t\t\t<!--<label ng-bind=\"'Country' | translate\"></label>-->\n\n\t\t\t\t<!--<input-->\n\t\t\t\t\t<!--type=\"text\"-->\n\t\t\t\t\t<!--maxlength=\"100\"-->\n\t\t\t\t\t<!--permission-hide=\"Admin,Manager\"-->\n\t\t\t\t\t<!--ng-value=\"address.model.country | getObjectByKeyValue:address.countries:'code':'name'\"-->\n\t\t\t\t\t<!--disabled>-->\n\t\t\t<!--</md-input-container>-->\n\n\t\t</div>\n\t</div>\n";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.addressController = undefined;
	
	var _extends2 = __webpack_require__(272);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	var _countries = __webpack_require__(494);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addressController = exports.addressController = function (_ActiveController) {
		addressController.$inject = ["$injector", "$rootScope", "$element", "$scope"];
		(0, _inherits3.default)(addressController, _ActiveController);
	
		function addressController($injector, $rootScope, $element, $scope) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, addressController);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (addressController.__proto__ || (0, _getPrototypeOf2.default)(addressController)).call(this, $injector));
	
			_this.$rootScope = $rootScope;
			_this.$element = angular.element($element);
			_this.$scope = $scope;
			_this.countries = _countries.countries;
	
			_this.componentId = angular.copy(Math.random().toString(36).substr(2, 10));
	
			_this.initial = {
				locationName: "",
				street: "",
				houseNo: "",
				zipCode: "",
				city: "",
				country: ""
			};
			return _this;
		}
	
		(0, _createClass3.default)(addressController, [{
			key: "$onInit",
			value: function $onInit() {
				var _this2 = this;
	
				typeof this.location === "undefined" && (this.location = false);
	
				this.$scope.$watch(function () {
					return _this2.model;
				}, function () {
					_this2.model = (0, _extends3.default)({}, _this2.initial, _this2.model);
				}, true);
			}
		}]);
		return addressController;
	}(_controller2.default);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.selectSearchComponent = undefined;
	
	var _selectSearch = __webpack_require__(548);
	
	var _selectSearch2 = _interopRequireDefault(_selectSearch);
	
	var _selectSearch3 = __webpack_require__(549);
	
	__webpack_require__(550);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectSearchComponent = exports.selectSearchComponent = {
		template: _selectSearch2.default,
		controller: _selectSearch3.selectSearchController,
		controllerAs: "selectSearch",
		bindings: {
			model: "=",
			itemLabel: "@",
			itemValue: "@",
			label: "<",
			searchLabel: "<",
			collection: "<",
			required: "@",
			onValueChange: "&",
			allowNoValue: "@"
		}
	};

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	module.exports = "<md-input-container>\n\t<label>{{selectSearch.label}}</label>\n\t<md-select ng-model=\"selectSearch.model\"\n\t\t\t\t\t\t md-on-close=\"selectSearch.clearSearchTerm()\"\n\t\t\t\t\t\t data-md-container-class=\"select-with-searchbox\"\n\t\t\t\t\t\t ng-required=\"selectSearch.required == 'true'\"\n\t\t\t\t\t\t ng-change=\"selectSearch.change(selectSearch.model)\">\n\t\t<md-select-header class=\"select-header\">\n\t\t\t<input ng-model=\"selectSearch.searchTerm\"\n\t\t\t\t\t\t type=\"search\"\n\t\t\t\t\t\t placeholder=\"{{selectSearch.searchLabel || 'Search...'}}\"\n\t\t\t\t\t\t class=\"header-searchbox md-text\">\n\t\t</md-select-header>\n\t\t<md-optgroup label=\"{{selectSearch.label}}\">\n\t\t\t<md-option value=\"No value\" ng-if=\"selectSearch.allowNoValue\">No value</md-option>\n\t\t\t<md-option ng-value=\"item[selectSearch.itemValue]\" ng-repeat=\"item in selectSearch.collection | filter:selectSearch.searchFilter(selectSearch.searchTerm)\">{{item[selectSearch.itemLabel]}}</md-option>\n\t\t</md-optgroup>\n\t</md-select>\n</md-input-container>\n";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.selectSearchController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectSearchController = exports.selectSearchController = function (_ActiveController) {
		selectSearchController.$inject = ["$injector", "$rootScope", "$element"];
		(0, _inherits3.default)(selectSearchController, _ActiveController);
	
		function selectSearchController($injector, $rootScope, $element) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, selectSearchController);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (selectSearchController.__proto__ || (0, _getPrototypeOf2.default)(selectSearchController)).call(this, $injector));
	
			_this.$rootScope = $rootScope;
			_this.$element = angular.element($element);
			_this.componentId = angular.copy(Math.random().toString(36).substr(2, 10));
			return _this;
		}
	
		(0, _createClass3.default)(selectSearchController, [{
			key: "$onInit",
			value: function $onInit() {
				this.$element.find("input").on("keydown", function (ev) {
					ev.stopPropagation();
				});
			}
		}, {
			key: "searchFilter",
			value: function searchFilter(query) {
				try {
					var re = new RegExp(query, "gi");
					return function (item) {
						return item[item.name ? "name" : "booth_id"].match(re);
					};
				} catch (e) {
					return;
				}
			}
		}, {
			key: "clearSearchTerm",
			value: function clearSearchTerm() {
				this.searchTerm = "";
			}
		}, {
			key: "change",
			value: function change(model) {
				this.onValueChange({ value: model });
			}
		}]);
		return selectSearchController;
	}(_controller2.default);

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(551);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./select-search.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./select-search.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, ".select-with-searchbox md-content{margin-top:48px;padding:0;min-height:0}.select-with-searchbox .header-searchbox{border:none;outline:none;height:100%;width:100%;padding:0}.select-with-searchbox .select-header{box-shadow:0 1px 0 0 rgba(0,0,0,.1),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12);padding-left:10.667px;height:48px;cursor:pointer;display:flex;align-items:center;width:100%;position:fixed;top:0;left:0;right:0;background-color:#fff}.select-with-searchbox md-content._md{max-height:240px;padding:0}", ""]);
	
	// exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.apiSelectSearchComponent = undefined;
	
	var _apiSelectSearch = __webpack_require__(553);
	
	var _apiSelectSearch2 = _interopRequireDefault(_apiSelectSearch);
	
	var _apiSelectSearch3 = __webpack_require__(554);
	
	__webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiSelectSearchComponent = exports.apiSelectSearchComponent = {
	    template: _apiSelectSearch2.default,
	    controller: _apiSelectSearch3.apiSelectSearchController,
	    controllerAs: "apiSelectSearch",
	    bindings: {
	        model: "=",
	        itemLabel: "@",
	        itemValue: "@",
	        label: "<",
	        searchLabel: "<",
	        collection: "@",
	        required: "@",
	        onValueChange: "&",
	        allowNoValue: "@",
	        multiple: "<",
	        selectedValues: "<",
	        width: "@",
	        fullValue: "<"
	    }
	};

/***/ }),
/* 553 */
/***/ (function(module, exports) {

	module.exports = "<md-input-container title=\"{{apiSelectSearch.transformConfigurationArray(apiSelectSearch.model)}}\" ng-show=\"apiSelectSearch.multiple\" ng-style=\"{width: apiSelectSearch.width}\">\n    <label>{{apiSelectSearch.label}}</label>\n    <md-select\n                aria-label=\"Select\"\n                ng-model=\"apiSelectSearch.model\"\n                md-on-close=\"apiSelectSearch.change(apiSelectSearch.model)\"\n                data-md-container-class=\"select-with-searchbox\"\n                ng-required=\"apiSelectSearch.required == 'true'\"\n                multiple\n                md-on-open=\"apiSelectSearch.onFocus()\">\n        <md-select-header class=\"select-header\">\n            <input ng-model=\"apiSelectSearch.searchTerm\"\n                   type=\"search\"\n                   ng-change=\"apiSelectSearch.searchFilter(apiSelectSearch.searchTerm)\"\n                   placeholder=\"{{apiSelectSearch.searchLabel || 'Search...'}}\"\n                   class=\"header-searchbox md-text\">\n        </md-select-header>\n        <md-optgroup>\n            <md-option ng-value=\"item.url\" ng-repeat=\"item in apiSelectSearch.elementsArray\">{{item.name}}</md-option>\n        </md-optgroup>\n    </md-select>\n</md-input-container>\n\n<md-input-container ng-show=\"!apiSelectSearch.multiple\" ng-style=\"{width: apiSelectSearch.width}\">\n    <label>{{apiSelectSearch.label}}</label>\n    <md-select\n            aria-label=\"Select\"\n            ng-model=\"apiSelectSearch.model\"\n            md-on-close=\"apiSelectSearch.change(apiSelectSearch.model)\"\n            data-md-container-class=\"select-with-searchbox\"\n            ng-required=\"apiSelectSearch.required == 'true'\"\n            md-on-open=\"apiSelectSearch.onFocus()\">\n        <md-select-header class=\"select-header\">\n            <input ng-model=\"apiSelectSearch.searchTerm\"\n                   type=\"search\"\n                   ng-change=\"apiSelectSearch.searchFilter(apiSelectSearch.searchTerm)\"\n                   placeholder=\"{{apiSelectSearch.searchLabel || 'Search...'}}\"\n                   class=\"header-searchbox md-text\">\n        </md-select-header>\n        <md-optgroup>\n            <md-option ng-value=\"apiSelectSearch.fullValue ? item : item.url\" ng-repeat=\"item in apiSelectSearch.elementsArray\">{{item.name}}</md-option>\n        </md-optgroup>\n    </md-select>\n</md-input-container>";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.apiSelectSearchController = undefined;
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Company", "$Deployment", "$Configuration", "$companies"];
	
	var apiSelectSearchController = exports.apiSelectSearchController = function (_ActiveController) {
	    apiSelectSearchController.$inject = ["$injector", "$rootScope", "$element", "$timeout"];
	    (0, _inherits3.default)(apiSelectSearchController, _ActiveController);
	
	    function apiSelectSearchController($injector, $rootScope, $element, $timeout) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, apiSelectSearchController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (apiSelectSearchController.__proto__ || (0, _getPrototypeOf2.default)(apiSelectSearchController)).call(this, $injector, dependencies));
	
	        _this.$rootScope = $rootScope;
	        _this.$element = angular.element($element);
	        _this.componentId = angular.copy(Math.random().toString(36).substr(2, 10));
	        _this.elementsArray = [];
	        _this.searchTerm = "";
	        _this.$timeout = $timeout;
	        return _this;
	    }
	
	    (0, _createClass3.default)(apiSelectSearchController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.$element.find("input").on("keydown", function (ev) {
	                ev.stopPropagation();
	            });
	            if (this.selectedValues) {
	                var _elementsArray;
	
	                (_elementsArray = this.elementsArray).push.apply(_elementsArray, (0, _toConsumableArray3.default)(this.selectedValues));
	            }
	            this.prewModel = this.model;
	        }
	    }, {
	        key: "searchFilter",
	        value: function searchFilter() {
	            var _this2 = this;
	
	            var newValue = (0, _lodash.clone)(this.searchTerm);
	            this.searhDelayTimeout = setTimeout(function () {
	                var prewValue = (0, _lodash.clone)(_this2.searchTerm);
	                if (prewValue === newValue) {
	                    clearTimeout(_this2.searhDelayTimeout);
	                    _this2.onFocus(_this2.searchTerm);
	                }
	            }, 2000);
	        }
	    }, {
	        key: "clearSearchTerm",
	        value: function clearSearchTerm() {
	            this.searchTerm = "";
	        }
	    }, {
	        key: "change",
	        value: function change(model) {
	            if (this.collection === "configuration") {
	                if (this.shouldUpdateConfigList(model, this.prewModel)) {
	                    this.onValueChange({ value: model });
	                }
	                this.prewModel = model;
	            } else {
	                if (this.prewModel !== model) {
	                    this.onValueChange({ value: model });
	                    this.prewModel = model;
	                }
	            }
	        }
	    }, {
	        key: "shouldUpdateConfigList",
	        value: function shouldUpdateConfigList(newValue, previousValue) {
	            var shouldUpdate = false;
	
	            if (newValue.length !== previousValue.length) {
	                shouldUpdate = true;
	            } else {
	                newValue.forEach(function (m, i) {
	                    if (previousValue[i] !== m) {
	                        shouldUpdate = true;
	                    }
	                });
	            }
	
	            return shouldUpdate;
	        }
	    }, {
	        key: "onFocus",
	        value: function onFocus(search) {
	            var _this3 = this;
	
	            var elements = null;
	            switch (this.collection) {
	                case "company":
	                    elements = this.$Company.query({ ordering: "name", search: search });
	                    break;
	
	                case "configuration":
	                    elements = this.$Configuration.query({ ordering: "name", search: search });
	                    break;
	
	                case "deployment":
	                    elements = this.$Deployment.query({ ordering: "name", search: search });
	                    break;
	
	            }
	            elements.$promise.then(function (resp) {
	                var _elementsArray3;
	
	                _this3.elementsArray = [];
	                if (_this3.selectedValues && !_this3.searchTerm.length) {
	                    var _elementsArray2;
	
	                    (_elementsArray2 = _this3.elementsArray).push.apply(_elementsArray2, (0, _toConsumableArray3.default)(_this3.selectedValues));
	                }
	                (_elementsArray3 = _this3.elementsArray).push.apply(_elementsArray3, (0, _toConsumableArray3.default)(resp));
	                _this3.elementsArray = (0, _lodash.uniqBy)(_this3.elementsArray, "url");
	            });
	        }
	    }, {
	        key: "transformConfigurationArray",
	        value: function transformConfigurationArray(array) {
	            if (!this.elementsArray.length) {
	                return;
	            }
	            var newArray = [];
	            newArray = (0, _lodash.filter)(this.elementsArray, function (c) {
	                if (c) {
	                    return (0, _lodash.includes)(array, c.url);
	                }
	            });
	            var namesArray = [];
	            (0, _lodash.forEach)(newArray, function (c) {
	                namesArray.push(c.name);
	            });
	            namesArray = namesArray.toString().replace(/,/g, "\n");
	            return namesArray;
	        }
	    }]);
	    return apiSelectSearchController;
	}(_controller2.default);

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(556);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./api-select-search.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./api-select-search.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "api-select-search md-input-container{margin:0;width:120px}api-select-search md-input-container.md-input-focused:not([md-no-float]) .md-select-placeholder span:first-child{transform:none}api-select-search label{display:none}api-select-search .select-with-searchbox md-content{margin-top:48px;padding:0;min-height:0}api-select-search .select-with-searchbox .header-searchbox{border:none;outline:none;height:100%;width:100%;padding:0}api-select-search .select-with-searchbox .select-header{box-shadow:0 1px 0 0 rgba(0,0,0,.1),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12);padding-left:10.667px;height:48px;cursor:pointer;display:flex;align-items:center;width:100%;position:fixed;top:0;left:0;right:0;background-color:#fff}api-select-search .select-with-searchbox md-content._md{max-height:240px;padding:0}", ""]);
	
	// exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.htmlPreviewComponent = undefined;
	
	var _htmlPreview = __webpack_require__(558);
	
	var _htmlPreview2 = _interopRequireDefault(_htmlPreview);
	
	var _htmlPreview3 = __webpack_require__(562);
	
	__webpack_require__(713);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var htmlPreviewComponent = exports.htmlPreviewComponent = {
	    template: _htmlPreview2.default,
	    controller: _htmlPreview3.htmlPreviewController,
	    controllerAs: "preview",
	    bindings: {
	        prWidth: "@",
	        prHeight: "@",
	        index: "@",
	        background: "@",
	        videoBackground: "@",
	        videoOverlay: "@",
	        areas: "@",
	        gif: "@",
	        strip: "@",
	        ratio: "@",
	        gifSpeed: "@",
	        overlay: "@",
	        videoTime: "<",
	        videoSpeed: "<",
	        animationSpeed: "@",
	        printerBleed: "@",
	        printDpi: "@", //  DPI for 3mm bleed in changeSize (A1–A6, 10×15, 15×20)
	        relatedValues: "@",
	        ignoreOverflow: "<",
	        hideOverlay: "<",
	        hideTitle: "<",
	        logo: "<",
	        logoSize: "<",
	        logoPosition: "<",
	        logoType: "<",
	        bgMode: "<",
	        bgColor: "<",
	        bgStyle: "<",
	        hideLogo: "<",
	        hideDefaultLogo: "<",
	        single: "<",
	        boomerang: "<",
	        video: "<",
	        logosArr: "=",
	        hideGifIcon: "<",
	        hidePhotoIcon: "<",
	        hideBoomerangIcon: "<",
	        hideVideoIcon: "<",
	        hideScene: "<",
	        transparency: "<",
	        scenes: "<",
	        hidePhotoBg: "<",
	        badgeActive: "<",
	        liveViewOpacity: "@",
	        margin: "<",
	        showTitle: "<",
	        screen: "@",
	        aiFeature: "<",
	        aiOverlay: "<",
	        mirror: "<",
	        videoMode: "<",
	        textColor: "@"
	    }
	};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"preview-title\" ng-if=\"preview.showTitle\">\n    <p class=\"part-title\" ng-if=\"preview.screen === 'general'\"><strong>{{'Screen Preview' | translate}}</strong></p>\n    <p class=\"part-title\" ng-if=\"preview.screen === 'standby'\"><strong>{{'Standby Screen Preview' | translate}}</strong></p>\n    <p class=\"part-title\" ng-if=\"preview.screen === 'start-screen'\"><strong>{{'Start Screen Preview' | translate}}</strong></p>\n    <p class=\"part-title\" ng-if=\"preview.screen === 'custom_loader'\"><strong>{{'Custom Logo Preview' | translate}}</strong></p>\n</div>\n<div\n        class=\"preview-main\"\n        ng-style=\"{width: preview.width, height: preview.height}\"\n        ng-class=\"{'red-border': preview.isOverflow && !preview.ignoreOverflow,'ignore-margin': preview.margin}\"\n        id=\"{{preview.uniqueId}}\">\n    <video\n        class=\"video-mode-preview\"\n        ng-if=\"preview.video-mode && (preview.width < preview.height)\"\n        ng-src=\"{{preview.portraiteVideoModeVideo}}\"\n        style=\"width: 100%;height: auto;position: relative;z-index: 1;\"\n        loop\n        muted\n        autoplay></video>\n    <video\n            class=\"video-mode-preview\"\n            ng-if=\"preview.video-mode && (preview.width > preview.height)\"\n            ng-src=\"{{preview.landscapeVideoModeVideo}}\"\n            style=\"width: 100%;height: auto;position: relative;z-index: 1;\"\n            loop\n            muted\n            autoplay></video>\n    <div class=\"video-mode-preview-settings\"\n         ng-if=\"preview.video-mode\">\n        <div class=\"recorder-btn\">\n            <span>MM:SS</span>\n            <img src=\"" + __webpack_require__(559) + "\">\n        </div>\n        <img style=\"margin-bottom: 8px;margin-top: 8px\" src=\"" + __webpack_require__(560) + "\">\n        <img src=\"" + __webpack_require__(561) + "\">\n    </div>\n    <video\n            class=\"live-view-bg\"\n            ng-if=\"preview.transparency.enabled && preview.liveViewVideo\"\n            ng-src=\"{{preview.liveViewVideo}}\"\n            ng-style=\"{width: preview.width, height: preview.height}\"\n            muted\n            loop\n            autoplay></video>\n    <div\n            id=\"{{preview.bgId}}\"\n            class=\"back-image\"\n            ng-class=\"{crop: preview.bgStyle === 'crop'}\"\n            ng-style=\"{width: preview.width, height: preview.height, backgroundImage: 'url(' + preview.background + ')', opacity: preview.setOpacity(preview.transparency.backgroundOpacity)}\"\n            ng-show=\"preview.bgMode !== 'color'\"></div>\n    <div\n            class=\"back-color\"\n            ng-style=\"{width: preview.width, height: preview.height, backgroundColor: preview.bgColor, opacity: preview.setOpacity(preview.transparency.backgroundOpacity)}\"\n            ng-show=\"preview.bgMode && preview.bgMode === 'color'\"></div>\n    <video\n            class=\"video-bg\"\n            ng-if=\"preview.videoBackground && preview.isVideo(preview.videoBackground)\"\n            ng-src=\"{{preview.background}}\"\n            ng-class=\"{crop: preview.bgStyle === 'crop'}\"\n            ng-style=\"{width: preview.width, height: preview.height, opacity: preview.setOpacity(preview.transparency.backgroundOpacity)}\"\n            muted\n            loop\n            autoplay></video>\n    <div class=\"start-logo\"\n            ng-if=\"preview.logo && preview.logoType === 'start'\"\n            ng-hide=\"preview.hideLogo\"\n            ng-style=\"{width: preview.logoStyle.width, top:  preview.logoStyle.top, bottom: preview.logoStyle.bottom, left: preview.logoStyle.left, right: preview.logoStyle.right, height: preview.logoStyle.height, backgroundImage: 'url(' + preview.logo + ')'}\">\n    </div>\n    <div\n            ng-if=\"preview.screen !== 'custom_loader' || (preview.screen === 'custom_loader' && preview.areas.doneButton && preview.areas.doneButton.enabled)\"\n            class=\"area\"\n            ng-repeat=\"area in preview.renderedArray\"\n            ng-hide=\"area.hide\"\n            ng-class=\"{'transparent': preview.screen === 'custom_loader' && area.customIcon.attachment_file,bordered: ((area.gif || area.customIcon) && !preview.hideOverlay) || area.isConfig, 'no-bg': preview.hidePhotoBg && !preview.aiOverlay, 'ai-overlay': preview.aiOverlay,'transparent-bg': preview.bgMode !== 'color' && preview.hasBackgroundImage(preview.background),'video-mode':preview.video-mode, 'config-area': area.isConfig}\"\n            ng-style=\"{width: area.width, height: area.height, top: area.y, left: area.x, transform: 'rotate('+ area.angle +')', opacity: preview.liveViewOpacity ? preview.liveViewOpacity/100 : preview.setOpacity(preview.transparency.iconsOpacity)}\">\n        <img\n                class=\"start-screen-area hide\"\n                ng-if=\"area.gif && preview.gif === 'true' && !preview.scenes.enabled\"\n                ng-src=\"{{area.gif}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n\n        <img\n                ng-if=\"(preview.gif === 'false' || area.isConfig) && area.customIcon && area.customIcon.attachment_file && !area.videoTag && !preview.scenes.enabled\"\n                ng-src=\"{{area.customIcon.attachment_file}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%', objectFit: 'cover'}\">\n        <img\n                ng-if=\"preview.screen === 'custom_loader' && area.customIcon.attachment_file\"\n                ng-if=\"area.customIcon && area.customIcon.attachment_file && !area.videoTag && !preview.scenes.enabled\"\n                ng-src=\"{{area.customIcon.attachment_file}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%', objectFit: 'cover'}\">\n\n        <img\n                ng-if=\"area.image && !area.videoTag && !preview.scenes.enabled\"\n                ng-show=\"!preview.aiFeature\"\n                ng-src=\"{{area.image}}\"\n                alt=\"img\"\n                ng-style=\"{width: area.width, height: area.height, objectFit: 'cover'}\">\n\n        <img\n                ng-if=\"area.frames && !preview.scenes.enabled\"\n                ng-src=\"{{preview.gifFrame}}\"\n                alt=\"img\"\n                ng-style=\"{width: area.width, height: area.height, objectFit: 'cover'}\">\n\n        <img\n                ng-if=\"area.video && !area.videoTag && !preview.scenes.enabled\"\n                ng-src=\"{{preview.boomerangFrame}}\"\n                alt=\"img\"\n                ng-style=\"{width: area.width, height: area.height, objectFit: 'cover'}\">\n        <video\n                ng-if=\"area.videoTag && area.videoSrc && !preview.scenes.enabled\"\n                ng-src=\"{{area.videoSrc}}\"\n                autoplay\n                loop\n                muted\n                playsinline\n                ng-style=\"{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}\">\n        </video>\n        <video\n                ng-if=\"preview.screen === 'custom_loader' && area.videoTag && area.videoSrc && !preview.scenes.enabled\"\n                ng-src=\"{{area.videoSrc}}\"\n                autoplay\n                loop\n                muted\n                playsinline\n                ng-style=\"{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}\">\n        </video>\n\n        <scene-preview\n                ng-if=\"preview.scenes && preview.scenes.enabled\"\n                layout-width=\"area.width\"\n                layout-height=\"area.height\"\n                scene-width=\"preview.scenes.layoutWidth\"\n                scene-height=\"preview.scenes.layoutHeight\"\n                photo=\"preview.scenes.scenesList[0].photos[0]\"\n                overlay-files=\"preview.scenes.scenesList[0].overlayFiles\"\n                background-files=\"preview.scenes.scenesList[0].backgroundFiles\"\n                image=\"area.image\"\n                photo-index=\"$index\"\n                hide-photo-bg=\"preview.hidePhotoBg\"\n                hide-scene=\"preview.hideScene\">\n        </scene-preview>\n\n        <div\n                ng-if=\"(preview.hideTitle || preview.scenes.enabled) && !area.isConfig\"\n                class=\"title\"\n                ng-style=\"{width: area.width, height: area.height, fontSize: area.font, lineHeight: area.height}\">\n            {{area.title}}\n        </div>\n        <div\n                class=\"area-title-below-inline\"\n                ng-if=\"(preview.hideTitle || preview.scenes.enabled) && area.isConfig && area.title\"\n                ng-style=\"{fontSize: area.font}\">\n            {{area.title}}\n        </div>\n        <div\n                ng-if=\"area.gif && preview.gif === 'true' && !preview.scenes.enabled\"\n                class=\"title--titleBtn\"\n                ng-style=\"{fontSize: area.font}\">\n            {{area.titleBtn}}\n        </div>\n\n    </div>\n    <div class=\"custom-loader-logo\"\n         ng-if=\"preview.screen === 'custom_loader' && (preview.areas.logo.customIcon || !preview.hideDefaultLogo)\"\n         style=\"position: relative;display: flex;align-items: center;justify-content: center;margin-top: 5%;\">\n        <img ng-if=\"preview.areas.logo.customIcon\" ng-src=\"{{preview.areas.logo.customIcon.attachment_file}}\" alt=\"custom loader logo\" style=\"width: auto\" ng-style=\"{height: preview.getLogoHeight()}\">\n        <svg ng-if=\"!preview.areas.logo.customIcon && !preview.hideDefaultLogo\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\" fill=\"none\" style=\"width: auto\" ng-style=\"{height: preview.getLogoHeight()}\">\n            <g clip-path=\"url(#clip0_4728_27198)\">\n                <path d=\"M64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64C49.6731 64 64 49.6731 64 32Z\" fill=\"#FF1744\"/>\n                <path d=\"M12.4219 35.1476V22.2266H16.8263V34.5104C16.8263 37.5432 18.532 38.5626 20.696 38.5626C22.911 38.5626 24.5912 37.5432 24.5912 34.5104V22.2266H28.9956V35.1476C29.0212 40.1938 25.406 42.4364 20.696 42.4364C16.0371 42.4364 12.4219 40.1938 12.4219 35.1476Z\" fill=\"white\"/>\n                <path d=\"M38.6442 33.8988H35.8436V42.1816H31.4648V22.2266H39.357C43.7868 22.2266 45.951 24.928 45.951 28.241C45.951 30.6368 44.6526 32.4716 42.6922 33.3382L47.9368 42.1816H43.1504L38.6442 33.8988ZM35.8692 30.4584H39.077C40.8846 30.4584 41.6992 29.5918 41.6992 28.1646C41.6992 26.763 40.8846 25.871 39.077 25.871H35.8692V30.4584Z\" fill=\"white\"/>\n                <path d=\"M52.3658 27.8339C50.6346 27.8339 49.2344 26.4321 49.2344 24.6991C49.2344 22.9661 50.6346 21.5645 52.3658 21.5645C54.097 21.5645 55.4972 22.9661 55.4972 24.6991C55.5228 26.4067 54.097 27.8339 52.3658 27.8339Z\" fill=\"white\"/>\n            </g>\n            <defs>\n                <clipPath id=\"clip0_4728_27198\">\n                    <rect width=\"64\" height=\"64\" fill=\"white\"/>\n                </clipPath>\n            </defs>\n        </svg>\n    </div>\n    <div class=\"custom-loader-wrapper\"\n         ng-if=\"preview.screen === 'custom_loader'\"\n         style=\"height: 38.3%;width: 49.23%;top: calc(50% - (38.3% / 2));position: absolute;left: calc(50% - (49.23% / 2));display: flex;flex-direction: column;justify-content: space-evenly;align-items: center\">\n        <div class=\"loader-image-wrapper\" style=\"width: 50px;height: 50px;display: flex;justify-content: center;align-items: center\">\n            <svg width=\"186\" height=\"186\" viewBox=\"0 0 186 186\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"transparent\" style=\"width: 100%;height: 100%\">\n                <path d=\"M19.5781 101.974C19.5781 144.777 54.2749 179.474 97.0781 179.474C139.881 179.474 174.578 144.777 174.578 101.974C174.578 59.1704 139.881 24.4736 97.0781 24.4736\"\n                      ng-attr-stroke=\"{{preview.textColor}}\"\n                      stroke-width=\"6.52632\"\n                      stroke-linecap=\"round\"\n                      stroke-linejoin=\"round\"/>\n                <path d=\"M83.5795 111.21H79.593L74.1724 102.764L68.7949 111.21H64.8084L72.3513 99.9822L65.0952 89.1841H69.0674L74.1868 97.1572L79.3205 89.1841H83.2784L76.008 99.9535L83.5795 111.21ZM104.831 111.21H100.845L95.4244 102.764L90.0469 111.21H86.0603L93.6032 99.9822L86.3471 89.1841H90.3193L95.4387 97.1572L100.572 89.1841H104.53L97.2599 99.9535L104.831 111.21ZM112.088 98.5195C109.435 98.5195 107.269 96.3542 107.269 93.6726C107.269 91.034 109.435 88.8973 112.088 88.8973C114.74 88.8973 116.877 91.034 116.877 93.6726C116.877 96.3542 114.74 98.5195 112.088 98.5195ZM113.077 111.21H109.908L122.728 89.1841H125.868L113.077 111.21ZM112.088 96.053C113.407 96.053 114.439 94.9919 114.439 93.6726C114.439 92.3963 113.378 91.3208 112.088 91.3208C110.768 91.3208 109.707 92.382 109.707 93.6726C109.707 94.9919 110.768 96.053 112.088 96.053ZM123.789 111.44C121.122 111.44 118.985 109.289 118.985 106.622C118.985 103.983 121.15 101.846 123.789 101.846C126.442 101.846 128.593 103.983 128.593 106.622C128.593 109.275 126.442 111.44 123.789 111.44ZM123.789 109.002C125.108 109.002 126.155 107.941 126.155 106.622C126.155 105.345 125.08 104.27 123.789 104.27C122.47 104.27 121.423 105.317 121.423 106.622C121.423 107.941 122.47 109.002 123.789 109.002Z\"\n                      ng-attr-fill=\"{{preview.textColor}}\"/>\n            </svg>\n        </div>\n\n        <p style=\"word-wrap: break-word;text-align: center;font-size: 14px;font-style: normal;font-weight: 800;line-height: normal;margin: 0;\" ng-if=\"preview.areas.title.enabled\"\n           ng-style=\"{color: preview.textColor}\">{{preview.areas.title.placeholder !== '' ? preview.areas.title.placeholder :'Your image is being created'}}</p>\n        <p style=\"word-wrap: break-word;text-align: center;font-size: 10px;font-style: normal;font-weight: 400;line-height: normal;margin:0\" ng-if=\"preview.areas.text.enabled\"\n           ng-style=\"{color: preview.textColor}\">{{preview.areas.text.placeholder != '' ? preview.areas.text.placeholder : 'It may take a few seconds text'}}</p>\n\n    </div>\n\n    <!-- Photo Strips: vertical (portrait) / horizontal (landscape) by prHeight vs prWidth, not by ratio -->\n    <div\n            class=\"vertical-strip\"\n            ng-style=\"{height: preview.height}\"\n            ng-if=\"preview.strip === 'true' && (Number(preview.prHeight) > Number(preview.prWidth))\"></div>\n\n    <div\n            class=\"horizontal-strip\"\n            ng-style=\"{width: preview.width}\"\n            ng-if=\"preview.strip === 'true' && (Number(preview.prHeight) <= Number(preview.prWidth))\"></div>\n\n    <div\n            id=\"{{preview.overlayId}}\"\n            class=\"overlay-image\"\n            ng-style=\"{width: preview.width, height: preview.height, backgroundImage: 'url(' + preview.overlay + ')'}\"\n            ng-hide=\"preview.hideOverlay\"\n            ng-class=\"{crop: preview.bgStyle === 'crop'}\"></div>\n\n    <video\n            ng-if=\"preview.videoOverlay !== null && preview.isVideo(preview.videoOverlay)\"\n            class=\"video-overlay video-bg overlay-image\"\n            ng-src=\"{{preview.overlay}}\"\n            ng-class=\"{crop: preview.bgStyle === 'crop'}\"\n            ng-style=\"{width: preview.width, height: preview.height}\"\n            muted\n            loop\n            autoplay></video>\n\n    <div\n            class=\"logo-digital\"\n            ng-if=\"preview.logoType === 'digital' && preview.bgMode === 'color'\"\n            ng-hide=\"preview.hideLogo\"\n            ng-style=\"{backgroundColor: preview.bgColor}\">\n\n    </div>\n\n    <div\n            class=\"logo-digital bg-image-digital\"\n            ng-if=\"preview.logoType === 'digital' && preview.bgMode === 'image'\"\n            ng-hide=\"preview.hideLogo\"\n            ng-style=\"{backgroundImage: 'url(' + preview.background + ')'}\">\n\n    </div>\n\n    <div\n            class=\"bg-digital\"\n            ng-if=\"preview.logoType === 'digital'\"\n            ng-hide=\"preview.hideLogo || !preview.logo\"\n            ng-style=\"{backgroundImage: 'url(' + preview.logo + ')'}\">\n    </div>\n\n    <div\n            class=\"logo-print\"\n            ng-repeat=\"lg in preview.logosArr\"\n            ng-if=\"preview.logoType === 'print' || preview.logoType === 'strip'\"\n            ng-hide=\"preview.hideLogo\"\n            ng-style=\"{backgroundImage: 'url(' + preview.logo + ')', width: lg.width, height: lg.height, top: lg.top, bottom: lg.bottom, left: lg.left, right: lg.right}\">\n    </div>\n\n    <div\n            ng-if=\"preview.printerBleed === 'true'\"\n            class=\"print-bleed\"\n            ng-style=\"{width: preview.bleed.width, height: preview.bleed.height, top: preview.bleed.top, left: preview.bleed.left}\">\n\n    </div>\n\n    <div\n            ng-if=\"preview.badgeActive\"\n            class=\"badge-block\">\n        <div class=\"triangle-logo\"></div>\n        <img src=\"" + __webpack_require__(157) + "\" alt=\"logo\">\n\n    </div>\n</div>\n";

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/record-video-btn-icon.png";

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/pause-btn-icon.png";

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/vdeo-back-btn-icon.png";

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.htmlPreviewController = undefined;
	
	var _slicedToArray2 = __webpack_require__(280);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(185);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var htmlPreviewController = exports.htmlPreviewController = function (_ActiveController) {
	  htmlPreviewController.$inject = ["$injector", "$rootScope", "$element", "$scope", "$timeout"];
	  (0, _inherits3.default)(htmlPreviewController, _ActiveController);
	
	  function htmlPreviewController($injector, $rootScope, $element, $scope, $timeout) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, htmlPreviewController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (htmlPreviewController.__proto__ || (0, _getPrototypeOf2.default)(htmlPreviewController)).call(this, $injector));
	
	    _this.$rootScope = $rootScope;
	    _this.$element = angular.element($element);
	    _this.$scope = $scope;
	    _this.width = 0;
	    _this.height = 0;
	    _this.renderedArray = [];
	    _this.uniqueId = "id-" + Math.random();
	    _this.bgId = "bg-" + Math.random();
	    _this.overlayId = "overlay-" + Math.random();
	    _this.boomerangId = "boomerang-" + Math.random();
	    _this.$timeout = $timeout;
	    _this.boomerangCount = null;
	
	    $scope.$watch(function () {
	      return _this.areas;
	    }, function () {
	      var divider = Number(_this.index);
	      try {
	        _this.areas = JSON.parse(_this.areas);
	        _this.renderedArray = [];
	        _this.areas && (0, _keys2.default)(_this.areas).forEach(function (area) {
	          if (!_this.areas[area].x && _this.areas[area].x !== 0 || !_this.areas[area].y && _this.areas[area].y !== 0) {
	            return false;
	          }
	          var el = {};
	          // Basic values
	          if (!_this.relatedValues) {
	            el = {
	              x: Math.round(_this.areas[area].x / divider) + "px",
	              y: Math.round(_this.areas[area].y / divider) + "px",
	              width: _this.areas[area].width ? Math.round(_this.areas[area].width / divider) + "px" : 0,
	              height: _this.areas[area].height ? Math.round(_this.areas[area].height / divider) + "px" : 0
	            };
	          } else {
	            el = {
	              x: _this.areas[area].x,
	              y: _this.areas[area].y,
	              width: _this.areas[area].width / 100 * _this.prHeight / _this.prWidth * 100,
	              height: _this.areas[area].height
	            };
	            el.x -= el.width / 2;
	            el.y -= el.height / 2;
	            el.width += "%";
	            el.height += "%";
	            el.x += "%";
	            el.y += "%";
	          }
	
	          // Gif background
	          switch (area) {
	            case "single":
	              if (_this.hidePhotoIcon) {
	                el.hide = true;
	              }
	              el.gif = __webpack_require__(563);
	              el.titleBtn = "Photo";
	              break;
	            case "gif":
	              if (_this.hideGifIcon) {
	                el.hide = true;
	              }
	              el.gif = __webpack_require__(564);
	              el.titleBtn = "Gif";
	              break;
	            case "boomerang":
	              if (_this.hideBoomerangIcon) {
	                el.hide = true;
	              }
	              el.gif = __webpack_require__(565);
	              el.titleBtn = "Boomerang";
	              break;
	            case "video":
	              if (_this.hideVideoIcon) {
	                el.hide = true;
	              }
	              el.gif = __webpack_require__(565);
	              el.titleBtn = "Video";
	              break;
	            case "trueVideo":
	              if (_this.hideVideoIcon) {
	                el.hide = true;
	              }
	              el.gif = __webpack_require__(565);
	              el.titleBtn = "Video";
	              break;
	          }
	
	          // Image background
	          if (_this.areas[area].image) {
	            if (_this.single) {
	              el.image = __webpack_require__(313);
	            } else if (!_this.areas[area].title) {
	              el.image = __webpack_require__(566);
	            } else {
	              if (_this.boomerang) {
	                el.image = __webpack_require__(567)("./b" + _this.areas[area].title[0] * 30 + ".png");
	              } else {
	                el.image = __webpack_require__(693)("./" + _this.areas[area].title[0] + ".png");
	              }
	
	              if (_this.video) {
	                el.image = __webpack_require__(567)("./b" + _this.areas[area].title[0] * 30 + ".png");
	              } else {
	                el.image = __webpack_require__(693)("./" + _this.areas[area].title[0] + ".png");
	              }
	
	              var mainSide = _this.areas[area].height < _this.areas[area].width ? "height" : "width";
	              el.title = _this.areas[area].title;
	              el.font = Math.round(_this.areas[area][mainSide] / divider * 0.55) + "px";
	            }
	          } else if (_this.areas[area].gif) {
	            _this.drawGif([1, 2, 3]);
	            el.frames = true;
	          } else if (_this.areas[area].video) {
	            el.video = true;
	          } else if (_this.areas[area].trueVideo) {
	            el.trueVideo = true;
	          }
	          el.angle = _this.areas[area].angle + "deg";
	          el.videoSrc = null;
	          el.videoTag = false;
	
	          // Mark config areas for multi-config feature
	          if (area.startsWith("config")) {
	            el.isConfig = true;
	          }
	
	          // Keep custom title available for all area types (including customIcon areas)
	          if (_this.areas[area].title !== undefined && _this.areas[area].title !== null) {
	            el.title = _this.areas[area].title;
	            el.font = _this.areas[area].font || "14px";
	          }
	
	          // Handle customIcon: can be an attachment object or a string
	          if (_this.areas[area].customIcon) {
	            var customIcon = _this.areas[area].customIcon;
	            // Check if customIcon is an object (after JSON.parse it should be)
	            if (customIcon && (typeof customIcon === "undefined" ? "undefined" : (0, _typeof3.default)(customIcon)) === "object") {
	              // It's an attachment object - check for attachment_file or thumbnail_file
	              var file = customIcon.attachment_file || customIcon.thumbnail_file;
	              if (file) {
	                el.customIcon = { attachment_file: file };
	                if (/\.(mp4|mov|webm)$/i.test(file)) {
	                  el.videoSrc = file;
	                  el.videoTag = true;
	                }
	              }
	            } else if (typeof customIcon === "string" && customIcon.length > 0) {
	              // It's a string URL
	              el.customIcon = { attachment_file: customIcon };
	              if (/\.(mp4|mov|webm)$/i.test(customIcon)) {
	                el.videoSrc = customIcon;
	                el.videoTag = true;
	              }
	            }
	          }
	          // If trueVideo and still no videoSrc, try direct link from area
	          if (el.trueVideo && !el.videoSrc) {
	            var directVideo = _this.areas[area].video || _this.areas[area].trueVideo;
	            if (directVideo && typeof directVideo === "string" && /\.(mp4|mov|webm)$/i.test(directVideo)) {
	              el.videoSrc = directVideo;
	              el.videoTag = true;
	            }
	          }
	
	          _this.renderedArray.push(el);
	        });
	      } catch (e) {
	        //
	      }
	    });
	
	    $scope.$watch(function () {
	      return _this.prWidth;
	    }, function () {
	      _this.changeSize();
	      _this.changeLogoPosition();
	    });
	
	    $scope.$watch(function () {
	      return _this.prHeight;
	    }, function () {
	      _this.changeSize();
	      _this.changeLogoPosition();
	    });
	
	    $scope.$watch(function () {
	      return _this.index;
	    }, function () {
	      _this.changeSize();
	    });
	
	    //  On DPI change, recalculate bleed for new formats
	    $scope.$watch(function () {
	      return _this.printDpi;
	    }, function () {
	      _this.changeSize();
	    });
	
	    $scope.$watch(function () {
	      return _this.videoTime;
	    }, function () {
	      _this.makeBoomerang();
	    });
	
	    $scope.$watch(function () {
	      return _this.videoSpeed;
	    }, function () {
	      _this.makeBoomerang();
	    });
	
	    $scope.$watch(function () {
	      return _this.background;
	    }, function () {
	      _this.animateBackground();
	    });
	
	    $scope.$watch(function () {
	      return _this.overlay;
	    }, function () {
	      _this.animateOverlay();
	    });
	    $scope.$watch(function () {
	      return _this.animationSpeed;
	    }, function () {
	      _this.animateOverlay();
	      _this.animateBackground();
	    });
	    $scope.$watch(function () {
	      return _this.logo;
	    }, function () {
	      _this.setUpLogo();
	    });
	    $scope.$watch(function () {
	      return _this.logoSize;
	    }, function () {
	      _this.setUpLogo();
	    });
	    $scope.$watch(function () {
	      return _this.logoPosition;
	    }, function () {
	      _this.setUpLogo();
	    });
	    $scope.$watch(function () {
	      return _this.strip;
	    }, function () {
	      _this.changeLogoPosition();
	    });
	    $scope.$watch(function () {
	      return _this.videoOverlay;
	    });
	    $scope.$watch(function () {
	      return _this.aiFeature;
	    });
	    $scope.$watch(function () {
	      return _this.aiOverlay;
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(htmlPreviewController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.changeSize();
	      this.liveViewVideo = __webpack_require__(310);
	      this.portraiteVideoModeVideo = __webpack_require__(711);
	      this.landscapeVideoModeVideo = __webpack_require__(712);
	    }
	  }, {
	    key: "$onDestroy",
	    value: function $onDestroy() {
	      clearInterval(this.count);
	      clearInterval(this.countBackground);
	      clearInterval(this.countOverlay);
	      clearInterval(this.boomerangCount);
	    }
	  }, {
	    key: "changeSize",
	    value: function changeSize() {
	      this.width = Math.round(Number(this.prWidth) / Number(this.index)) + "px";
	      this.height = Math.round(Number(this.prHeight) / Number(this.index)) + "px";
	
	      var w = Number(this.prWidth);
	      var h = Number(this.prHeight);
	      var idx = Number(this.index);
	      //  4 old pairs — legacy bleed; for A1–A6, 10×15, 15×20: bleedPx = 3mm from DPI
	      var OLD_PAIRS = [[2520, 1890], [1844, 1240], [1890, 2520], [1240, 1844]];
	      var isOldPair = OLD_PAIRS.some(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            a = _ref2[0],
	            b = _ref2[1];
	
	        return w === a && h === b;
	      });
	      var dpi = this.printDpi ? Number(this.printDpi) : 300;
	
	      if (!isOldPair && dpi > 0) {
	        var bleedPx = Math.round(3 / 25.4 * dpi); // 3mm in pixels
	        this.bleed = {
	          width: (w - 2 * bleedPx) / idx + "px",
	          height: (h - 2 * bleedPx) / idx + "px",
	          top: bleedPx / idx + "px",
	          left: bleedPx / idx + "px"
	        };
	      } else if (w > h) {
	        if (w === 2520 && h === 1890) {
	          this.bleed = { width: 2476 / idx + "px", height: 1850 / idx + "px", top: 20 / idx + "px", left: 22 / idx + "px" };
	        } else {
	          this.bleed = { width: 1800 / idx + "px", height: 1200 / idx + "px", top: 22 / idx + "px", left: 20 / idx + "px" };
	        }
	      } else {
	        if (w === 1890 && h === 2520) {
	          this.bleed = { width: 1846 / idx + "px", height: 2476 / idx + "px", top: 22 / idx + "px", left: 20 / idx + "px" };
	        } else {
	          this.bleed = { width: 1200 / idx + "px", height: 1800 / idx + "px", top: 20 / idx + "px", left: 22 / idx + "px" };
	        }
	      }
	    }
	  }, {
	    key: "drawGif",
	    value: function drawGif(frames) {
	      var _this2 = this;
	
	      clearInterval(this.count);
	      var idx = 0;
	      this.gifFrame = __webpack_require__(693)("./" + frames[idx] + ".png");
	
	      this.count = setInterval(function () {
	        _this2.gifFrame = __webpack_require__(693)("./" + frames[idx] + ".png");
	        _this2.$scope.$apply(function () {
	          return _this2.gifFrame;
	        });
	        if (idx === frames.length - 1) {
	          idx = 0;
	        } else {
	          idx++;
	        }
	      }, this.gifSpeed ? Number(this.gifSpeed) / frames.length * 1000 : 667);
	    }
	
	    // checkOverflow() {
	    //     let el = document.getElementById(this.uniqueId);
	    //     this.isOverflow = el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
	    // }
	
	  }, {
	    key: "makeBoomerang",
	    value: function makeBoomerang() {
	      var _this3 = this;
	
	      clearInterval(this.boomerangCount);
	      var allFiles = 120;
	      var framesPerSecond = 24;
	      var time = this.videoTime <= 5 ? this.videoTime || 1.5 : 5; // Added mock for preview to be 5 seconds even if video time is longer (up to 8s);
	      var speed = this.videoSpeed || 1.5;
	      var startCount = allFiles - time * 24;
	      var direction = "forward";
	      var idx = 0;
	      var speedIndex = time * 2 / speed;
	      var imagesArr = [];
	      var loadedImages = 0;
	
	      var onImageLoad = function onImageLoad() {
	        loadedImages++;
	        clearInterval(_this3.boomerangCount);
	        if (loadedImages === imagesArr.length) {
	          clearInterval(_this3.boomerangCount);
	          _this3.boomerangCount = setInterval(function () {
	            _this3.boomerangFrame = imagesArr[Math.floor(idx)] ? imagesArr[Math.floor(idx)].src : "";
	            _this3.$scope.$apply(function () {
	              return _this3.boomerangFrame;
	            });
	            if (idx >= imagesArr.length && direction === "forward") {
	              direction = "backward";
	            } else if (idx <= 0 && direction === "backward") {
	              direction = "forward";
	            } else {
	              direction === "forward" ? idx += speedIndex : idx -= speedIndex;
	            }
	          }, 1000 / framesPerSecond);
	        }
	      };
	
	      for (var i = startCount; i <= 120; i++) {
	        var img = new Image();
	        img.src = __webpack_require__(567)("./b" + Math.floor(i) + ".png");
	        img.onload = function () {
	          onImageLoad();
	        };
	        imagesArr.push(img);
	      }
	    }
	  }, {
	    key: "animateBackground",
	    value: function animateBackground() {
	      var _this4 = this;
	
	      setTimeout(function () {
	        try {
	          var arr = JSON.parse(_this4.background);
	          var pr = document.getElementById(_this4.bgId);
	          if (!pr) return;
	          var images = [];
	          for (var i = 0; i < arr.length; i++) {
	            var image = new Image();
	            image.src = arr[i];
	            arr[i] = images.push(image);
	          }
	          clearInterval(_this4.countBackground);
	          if (arr.length > 1) {
	            var idx = 0;
	            _this4.countBackground = setInterval(function () {
	              pr.style.backgroundImage = "url(" + images[idx].src + ")";
	              if (idx === arr.length - 1) {
	                idx = 0;
	              } else {
	                idx++;
	              }
	            }, _this4.animationSpeed ? Number(_this4.animationSpeed) / arr.length * 1000 : 1000);
	          } else {
	            arr.length ? _this4.background = images[0].src : _this4.background = null;
	          }
	        } catch (e) {
	          //console.log(e);
	        }
	      });
	    }
	  }, {
	    key: "animateOverlay",
	    value: function animateOverlay() {
	      var _this5 = this;
	
	      setTimeout(function () {
	        try {
	          var arr = JSON.parse(_this5.overlay);
	          var pr = document.getElementById(_this5.overlayId);
	          var images = [];
	          for (var i = 0; i < arr.length; i++) {
	            var image = new Image();
	            image.src = arr[i];
	            arr[i] = images.push(image);
	          }
	          clearInterval(_this5.countOverlay);
	          if (arr.length > 1) {
	            var idx = 0;
	            _this5.countOverlay = setInterval(function () {
	              pr.style.backgroundImage = "url(" + images[idx].src + ")";
	              if (idx === arr.length - 1) {
	                idx = 0;
	              } else {
	                idx++;
	              }
	            }, _this5.animationSpeed ? Number(_this5.animationSpeed) / arr.length * 1000 : 1000);
	          } else {
	            arr.length ? _this5.overlay = images[0].src : _this5.overlay = null;
	          }
	        } catch (e) {
	          //console.log(e);
	        }
	      });
	    }
	  }, {
	    key: "setUpLogo",
	    value: function setUpLogo() {
	      var WIDTH_MULTIPLIER = 2.4;
	      var MAX_SIZE = 30;
	
	      this.logoStyle = {
	        width: this.logoSize * WIDTH_MULTIPLIER + "%",
	        height: this.logoSize + "%"
	      };
	
	      if (this.logoPosition <= 3) {
	        this.logoStyle.top = 5 + (MAX_SIZE - this.logoSize) / 2 + "%";
	      } else {
	        this.logoStyle.bottom = 5 + (MAX_SIZE - this.logoSize) / 2 + "%";
	      }
	
	      if (this.logoPosition === 1 || this.logoPosition === 4) {
	        this.logoStyle.left = "4%";
	        this.logoStyle.width = this.logoSize * (WIDTH_MULTIPLIER / 2) + "%";
	      } else if (this.logoPosition === 3 || this.logoPosition === 6) {
	        this.logoStyle.right = "4%";
	        this.logoStyle.width = this.logoSize * (WIDTH_MULTIPLIER / 2) + "%";
	      } else if (this.logoPosition === 2 || this.logoPosition === 5) {
	        this.logoStyle.left = 50 - this.logoSize * (WIDTH_MULTIPLIER / 2) + "%";
	      }
	    }
	  }, {
	    key: "changeLogoPosition",
	    value: function changeLogoPosition() {
	      if (this.prHeight > this.prWidth && this.strip === "false") {
	        this.logosArr = [{
	          width: "75%",
	          left: "12.5%",
	          bottom: "6%",
	          height: "15%"
	        }];
	      } else if (this.prHeight > this.prWidth && this.strip === "true") {
	        this.logosArr = [{
	          bottom: "2.5%",
	          height: "10%",
	          width: "40%",
	          left: "5%"
	        }, {
	          bottom: "2.5%",
	          height: "10%",
	          width: "40%",
	          right: "5%"
	        }];
	      } else if (this.prHeight < this.prWidth && this.strip === "false") {
	        this.logosArr = [{
	          width: "75%",
	          left: "12.5%",
	          bottom: "6%",
	          height: "15%"
	        }];
	      } else if (this.prHeight < this.prWidth && this.strip === "true") {
	        this.logosArr = [{
	          bottom: "52.5%",
	          height: "10%",
	          width: "75%",
	          left: "12.5%"
	        }, {
	          bottom: "2.5%",
	          height: "10%",
	          width: "75%",
	          left: "12.5%"
	        }];
	      }
	    }
	  }, {
	    key: "isVideo",
	    value: function isVideo(name) {
	      if (name === undefined || name === null) {
	        return false;
	      } else {
	        return name.indexOf(".mp4") !== -1 || name.indexOf(".webm") !== -1 || name.indexOf(".mov") !== -1;
	      }
	    }
	  }, {
	    key: "setOpacity",
	    value: function setOpacity(tr) {
	      if (!this.transparency || !this.transparency.enabled) {
	        return 1;
	      }
	      return tr / 100;
	    }
	  }, {
	    key: "checkForNullInUrl",
	    value: function checkForNullInUrl(url) {
	      // Перевіряємо, чи передано URL, інакше повертаємо false
	      if (!url || typeof url !== "string") {
	        return false;
	      }
	
	      // Перевіряємо наявність 'null' у рядку
	      var containsNull = url.includes("null");
	      return containsNull;
	    }
	  }, {
	    key: "hasBackgroundImage",
	    value: function hasBackgroundImage(url) {
	      if (!url || typeof url !== "string") {
	        return false;
	      }
	
	      var normalized = url.trim();
	      if (!normalized) {
	        return false;
	      }
	
	      return !this.checkForNullInUrl(normalized);
	    }
	  }, {
	    key: "getLogoHeight",
	    value: function getLogoHeight() {
	      return this.prHeight / this.index / 100 * 20 + "px";
	    }
	  }]);
	  return htmlPreviewController;
	}(_controller2.default);

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/photo.gif";

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/gif.gif";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/boomerang.gif";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/1.png";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./b0.png": 568,
		"./b1.png": 569,
		"./b10.png": 570,
		"./b100.png": 571,
		"./b101.png": 572,
		"./b102.png": 573,
		"./b103.png": 574,
		"./b104.png": 575,
		"./b105.png": 576,
		"./b106.png": 577,
		"./b107.png": 578,
		"./b108.png": 579,
		"./b109.png": 580,
		"./b11.png": 581,
		"./b110.png": 582,
		"./b111.png": 583,
		"./b112.png": 584,
		"./b113.png": 585,
		"./b114.png": 586,
		"./b115.png": 587,
		"./b116.png": 588,
		"./b117.png": 589,
		"./b118.png": 590,
		"./b119.png": 591,
		"./b12.png": 592,
		"./b120.png": 593,
		"./b121.png": 594,
		"./b122.png": 595,
		"./b123.png": 596,
		"./b124.png": 597,
		"./b13.png": 598,
		"./b14.png": 599,
		"./b15.png": 600,
		"./b16.png": 601,
		"./b17.png": 602,
		"./b18.png": 603,
		"./b19.png": 604,
		"./b2.png": 605,
		"./b20.png": 606,
		"./b21.png": 607,
		"./b22.png": 608,
		"./b23.png": 609,
		"./b24.png": 610,
		"./b25.png": 611,
		"./b26.png": 612,
		"./b27.png": 613,
		"./b28.png": 614,
		"./b29.png": 615,
		"./b3.png": 616,
		"./b30.png": 617,
		"./b31.png": 618,
		"./b32.png": 619,
		"./b33.png": 620,
		"./b34.png": 621,
		"./b35.png": 622,
		"./b36.png": 623,
		"./b37.png": 624,
		"./b38.png": 625,
		"./b39.png": 626,
		"./b4.png": 627,
		"./b40.png": 628,
		"./b41.png": 629,
		"./b42.png": 630,
		"./b43.png": 631,
		"./b44.png": 632,
		"./b45.png": 633,
		"./b46.png": 634,
		"./b47.png": 635,
		"./b48.png": 636,
		"./b49.png": 637,
		"./b5.png": 638,
		"./b50.png": 639,
		"./b51.png": 640,
		"./b52.png": 641,
		"./b53.png": 642,
		"./b54.png": 643,
		"./b55.png": 644,
		"./b56.png": 645,
		"./b57.png": 646,
		"./b58.png": 647,
		"./b59.png": 648,
		"./b6.png": 649,
		"./b60.png": 650,
		"./b61.png": 651,
		"./b62.png": 652,
		"./b63.png": 653,
		"./b64.png": 654,
		"./b65.png": 655,
		"./b66.png": 656,
		"./b67.png": 657,
		"./b68.png": 658,
		"./b69.png": 659,
		"./b7.png": 660,
		"./b70.png": 661,
		"./b71.png": 662,
		"./b72.png": 663,
		"./b73.png": 664,
		"./b74.png": 665,
		"./b75.png": 666,
		"./b76.png": 667,
		"./b77.png": 668,
		"./b78.png": 669,
		"./b79.png": 670,
		"./b8.png": 671,
		"./b80.png": 672,
		"./b81.png": 673,
		"./b82.png": 674,
		"./b83.png": 675,
		"./b84.png": 676,
		"./b85.png": 677,
		"./b86.png": 678,
		"./b87.png": 679,
		"./b88.png": 680,
		"./b89.png": 681,
		"./b9.png": 682,
		"./b90.png": 683,
		"./b91.png": 684,
		"./b92.png": 685,
		"./b93.png": 686,
		"./b94.png": 687,
		"./b95.png": 688,
		"./b96.png": 689,
		"./b97.png": 690,
		"./b98.png": 691,
		"./b99.png": 692
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 567;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b0.png";

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b1.png";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b10.png";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b100.png";

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b101.png";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b102.png";

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b103.png";

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b104.png";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b105.png";

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b106.png";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b107.png";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b108.png";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b109.png";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b11.png";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b110.png";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b111.png";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b112.png";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b113.png";

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b114.png";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b115.png";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b116.png";

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b117.png";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b118.png";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b119.png";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b12.png";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b120.png";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b121.png";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b122.png";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b123.png";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b124.png";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b13.png";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b14.png";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b15.png";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b16.png";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b17.png";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b18.png";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b19.png";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b2.png";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b20.png";

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b21.png";

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b22.png";

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b23.png";

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b24.png";

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b25.png";

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b26.png";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b27.png";

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b28.png";

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b29.png";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b3.png";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b30.png";

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b31.png";

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b32.png";

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b33.png";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b34.png";

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b35.png";

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b36.png";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b37.png";

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b38.png";

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b39.png";

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b4.png";

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b40.png";

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b41.png";

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b42.png";

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b43.png";

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b44.png";

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b45.png";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b46.png";

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b47.png";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b48.png";

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b49.png";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b5.png";

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b50.png";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b51.png";

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b52.png";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b53.png";

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b54.png";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b55.png";

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b56.png";

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b57.png";

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b58.png";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b59.png";

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b6.png";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b60.png";

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b61.png";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b62.png";

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b63.png";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b64.png";

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b65.png";

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b66.png";

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b67.png";

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b68.png";

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b69.png";

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b7.png";

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b70.png";

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b71.png";

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b72.png";

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b73.png";

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b74.png";

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b75.png";

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b76.png";

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b77.png";

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b78.png";

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b79.png";

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b8.png";

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b80.png";

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b81.png";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b82.png";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b83.png";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b84.png";

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b85.png";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b86.png";

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b87.png";

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b88.png";

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b89.png";

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b9.png";

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b90.png";

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b91.png";

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b92.png";

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b93.png";

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b94.png";

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b95.png";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b96.png";

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b97.png";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b98.png";

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b99.png";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./1.png": 566,
		"./1b.png": 694,
		"./2.png": 695,
		"./2b.png": 696,
		"./3.png": 697,
		"./3b.png": 698,
		"./4.png": 699,
		"./5.png": 700,
		"./6.png": 701,
		"./7.png": 702,
		"./8.png": 703,
		"./Booth-front.png": 298,
		"./SMS.png": 299,
		"./ai-preview/age-slider.png": 704,
		"./ai-preview/pause-btn-icon.png": 560,
		"./ai-preview/persona_Landscape_1920x1080.png": 705,
		"./ai-preview/persona_Portrait_1080x1920.png": 706,
		"./ai-preview/record-video-btn-icon.png": 559,
		"./ai-preview/vdeo-back-btn-icon.png": 561,
		"./boomerang-frames/b0.png": 568,
		"./boomerang-frames/b1.png": 569,
		"./boomerang-frames/b10.png": 570,
		"./boomerang-frames/b100.png": 571,
		"./boomerang-frames/b101.png": 572,
		"./boomerang-frames/b102.png": 573,
		"./boomerang-frames/b103.png": 574,
		"./boomerang-frames/b104.png": 575,
		"./boomerang-frames/b105.png": 576,
		"./boomerang-frames/b106.png": 577,
		"./boomerang-frames/b107.png": 578,
		"./boomerang-frames/b108.png": 579,
		"./boomerang-frames/b109.png": 580,
		"./boomerang-frames/b11.png": 581,
		"./boomerang-frames/b110.png": 582,
		"./boomerang-frames/b111.png": 583,
		"./boomerang-frames/b112.png": 584,
		"./boomerang-frames/b113.png": 585,
		"./boomerang-frames/b114.png": 586,
		"./boomerang-frames/b115.png": 587,
		"./boomerang-frames/b116.png": 588,
		"./boomerang-frames/b117.png": 589,
		"./boomerang-frames/b118.png": 590,
		"./boomerang-frames/b119.png": 591,
		"./boomerang-frames/b12.png": 592,
		"./boomerang-frames/b120.png": 593,
		"./boomerang-frames/b121.png": 594,
		"./boomerang-frames/b122.png": 595,
		"./boomerang-frames/b123.png": 596,
		"./boomerang-frames/b124.png": 597,
		"./boomerang-frames/b13.png": 598,
		"./boomerang-frames/b14.png": 599,
		"./boomerang-frames/b15.png": 600,
		"./boomerang-frames/b16.png": 601,
		"./boomerang-frames/b17.png": 602,
		"./boomerang-frames/b18.png": 603,
		"./boomerang-frames/b19.png": 604,
		"./boomerang-frames/b2.png": 605,
		"./boomerang-frames/b20.png": 606,
		"./boomerang-frames/b21.png": 607,
		"./boomerang-frames/b22.png": 608,
		"./boomerang-frames/b23.png": 609,
		"./boomerang-frames/b24.png": 610,
		"./boomerang-frames/b25.png": 611,
		"./boomerang-frames/b26.png": 612,
		"./boomerang-frames/b27.png": 613,
		"./boomerang-frames/b28.png": 614,
		"./boomerang-frames/b29.png": 615,
		"./boomerang-frames/b3.png": 616,
		"./boomerang-frames/b30.png": 617,
		"./boomerang-frames/b31.png": 618,
		"./boomerang-frames/b32.png": 619,
		"./boomerang-frames/b33.png": 620,
		"./boomerang-frames/b34.png": 621,
		"./boomerang-frames/b35.png": 622,
		"./boomerang-frames/b36.png": 623,
		"./boomerang-frames/b37.png": 624,
		"./boomerang-frames/b38.png": 625,
		"./boomerang-frames/b39.png": 626,
		"./boomerang-frames/b4.png": 627,
		"./boomerang-frames/b40.png": 628,
		"./boomerang-frames/b41.png": 629,
		"./boomerang-frames/b42.png": 630,
		"./boomerang-frames/b43.png": 631,
		"./boomerang-frames/b44.png": 632,
		"./boomerang-frames/b45.png": 633,
		"./boomerang-frames/b46.png": 634,
		"./boomerang-frames/b47.png": 635,
		"./boomerang-frames/b48.png": 636,
		"./boomerang-frames/b49.png": 637,
		"./boomerang-frames/b5.png": 638,
		"./boomerang-frames/b50.png": 639,
		"./boomerang-frames/b51.png": 640,
		"./boomerang-frames/b52.png": 641,
		"./boomerang-frames/b53.png": 642,
		"./boomerang-frames/b54.png": 643,
		"./boomerang-frames/b55.png": 644,
		"./boomerang-frames/b56.png": 645,
		"./boomerang-frames/b57.png": 646,
		"./boomerang-frames/b58.png": 647,
		"./boomerang-frames/b59.png": 648,
		"./boomerang-frames/b6.png": 649,
		"./boomerang-frames/b60.png": 650,
		"./boomerang-frames/b61.png": 651,
		"./boomerang-frames/b62.png": 652,
		"./boomerang-frames/b63.png": 653,
		"./boomerang-frames/b64.png": 654,
		"./boomerang-frames/b65.png": 655,
		"./boomerang-frames/b66.png": 656,
		"./boomerang-frames/b67.png": 657,
		"./boomerang-frames/b68.png": 658,
		"./boomerang-frames/b69.png": 659,
		"./boomerang-frames/b7.png": 660,
		"./boomerang-frames/b70.png": 661,
		"./boomerang-frames/b71.png": 662,
		"./boomerang-frames/b72.png": 663,
		"./boomerang-frames/b73.png": 664,
		"./boomerang-frames/b74.png": 665,
		"./boomerang-frames/b75.png": 666,
		"./boomerang-frames/b76.png": 667,
		"./boomerang-frames/b77.png": 668,
		"./boomerang-frames/b78.png": 669,
		"./boomerang-frames/b79.png": 670,
		"./boomerang-frames/b8.png": 671,
		"./boomerang-frames/b80.png": 672,
		"./boomerang-frames/b81.png": 673,
		"./boomerang-frames/b82.png": 674,
		"./boomerang-frames/b83.png": 675,
		"./boomerang-frames/b84.png": 676,
		"./boomerang-frames/b85.png": 677,
		"./boomerang-frames/b86.png": 678,
		"./boomerang-frames/b87.png": 679,
		"./boomerang-frames/b88.png": 680,
		"./boomerang-frames/b89.png": 681,
		"./boomerang-frames/b9.png": 682,
		"./boomerang-frames/b90.png": 683,
		"./boomerang-frames/b91.png": 684,
		"./boomerang-frames/b92.png": 685,
		"./boomerang-frames/b93.png": 686,
		"./boomerang-frames/b94.png": 687,
		"./boomerang-frames/b95.png": 688,
		"./boomerang-frames/b96.png": 689,
		"./boomerang-frames/b97.png": 690,
		"./boomerang-frames/b98.png": 691,
		"./boomerang-frames/b99.png": 692,
		"./boomerang-pr.png": 297,
		"./boomerang_print.png": 317,
		"./email.png": 300,
		"./favicon-180.png": 154,
		"./favicon-270.png": 155,
		"./favicon-32.png": 153,
		"./favicon-512.png": 156,
		"./favicon-old-512.png": 707,
		"./gif-pr.png": 296,
		"./gif_print.png": 316,
		"./icons/back-btn-icon.png": 708,
		"./icons/success-icon.png": 211,
		"./image-pr.png": 295,
		"./image_print.png": 315,
		"./photo.png": 313,
		"./upreach-logo-weiss.png": 709,
		"./upreach-logo-white.png": 710
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 693;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/1b.png";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/2.png";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/2b.png";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/3.png";

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/3b.png";

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/4.png";

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/5.png";

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/6.png";

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/7.png";

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/8.png";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/age-slider.png";

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/persona_Landscape_1920x1080.png";

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/persona_Portrait_1080x1920.png";

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/favicon-old-512.png";

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/back-btn-icon.png";

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/upreach-logo-weiss.png";

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/upreach-logo-white.png";

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "videos/video-preview-portraite.f04fa15f942c11581df917433f37e3f5.mp4";

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "videos/video-preview-lanscape.ef55023c725485e9a2a0e3cc2ef79c8f.mp4";

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(714);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./html-preview.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./html-preview.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "html-preview .preview-main{background-color:#999;background-size:100% 100%;position:relative;margin:0 auto;overflow:hidden;box-sizing:padding-box}html-preview .preview-main .back-color{position:absolute}html-preview .preview-main.red-border{border:1px solid red}html-preview .preview-main.ignore-margin{margin:0}html-preview .preview-main .start-logo{position:absolute;background-size:contain;background-repeat:no-repeat;background-position:50% 50%}html-preview .preview-main .bg-digital,html-preview .preview-main .logo-digital,html-preview .preview-main .logo-print{background-size:contain;background-repeat:no-repeat;background-position:50% 50%;position:absolute;z-index:14}html-preview .preview-main .bg-digital img,html-preview .preview-main .logo-digital img,html-preview .preview-main .logo-print img{object-fit:contain}html-preview .preview-main .logo-digital{width:100%;left:0;bottom:0;height:15%}html-preview .preview-main .bg-digital{width:95%;height:10%;bottom:2.5%;left:2.5%}html-preview .preview-main .bg-image-digital{background-size:cover;background-repeat:no-repeat;background-position:50% 50%}html-preview .preview-main .logo-strip-left,html-preview .preview-main .logo-strip-right{position:absolute;background-size:contain;background-repeat:no-repeat;background-position:50% 50%}html-preview .preview-main .area{position:absolute;box-sizing:border-box;overflow:hidden;background:#d3d3d3}html-preview .preview-main .area.config-area{overflow:visible}html-preview .preview-main .area.no-bg{background-color:transparent!important}html-preview .preview-main .area.transparent{background-color:transparent}html-preview .preview-main .area.bordered{border:1px solid #ff2c49;display:flex;align-items:center;justify-content:center;background-color:#fff}html-preview .preview-main .area.bordered:before{content:\"\";position:absolute;width:100%;height:100%;z-index:60;background:linear-gradient(to top left,transparent 0,transparent calc(50% - .8px),red 50%,transparent calc(50% + .8px),transparent),linear-gradient(to top right,transparent 0,transparent calc(50% - .8px),red 50%,transparent calc(50% + .8px),transparent)}html-preview .preview-main .area img{position:absolute;object-fit:fill}html-preview .preview-main .area video{position:absolute;object-fit:cover;background-color:#d5cfd2}html-preview .preview-main .area .title{z-index:10;position:absolute;text-align:center;color:#ff2c49}html-preview .preview-main .area .title--titleBtn{color:#000;font-size:10px;font-style:normal;font-weight:700;line-height:330%;z-index:10;position:relative}html-preview .preview-main .area .area-title-below-inline{position:absolute;top:calc(100% + 4px);left:50%;transform:translateX(-50%);min-width:100%;text-align:center;color:#ff2c49;font-weight:700;line-height:1.2;z-index:70;pointer-events:none;text-shadow:0 1px 1px hsla(0,0%,100%,.8)}html-preview .preview-main .area.ai-overlay,html-preview .preview-main .area.ai-overlay img{width:100%!important;height:100%!important}html-preview .preview-main .area.transparent-bg{background-color:transparent!important}html-preview .preview-main .area.video-mode,html-preview .preview-main .area.video-mode img{width:100%!important;height:100%!important}html-preview .preview-main .video-bg{position:absolute;object-fit:fill}html-preview .preview-main .video-bg.crop{object-fit:cover}html-preview .preview-main .live-view-bg{position:absolute;object-fit:cover}html-preview .preview-main .vertical-strip{border-left:2px dashed #ff2c49;left:50%;position:absolute;z-index:15}html-preview .preview-main .horizontal-strip{border-top:2px dashed #ff2c49;top:50%;position:absolute;z-index:15}html-preview .preview-main .back-image{position:absolute;z-index:0;background-size:100% 100%}html-preview .preview-main .back-image.crop{background-size:cover;background-position:50% 50%}html-preview .preview-main .back-image img{width:100%;height:100%}html-preview .preview-main .overlay-image{position:absolute;z-index:12;background-size:100% 100%}html-preview .preview-main .overlay-image img{width:100%;height:100%}html-preview .preview-main .overlay-image.crop{background-position:50% 50%;background-size:100% 100%}html-preview .preview-main .video-mode-preview-settings{position:absolute;right:19px;left:auto;top:0;bottom:0;width:30px;height:auto;z-index:2;display:flex;align-items:center;flex-direction:column;justify-content:center}html-preview .preview-main .video-mode-preview-settings .recorder-btn{display:flex;flex-direction:column}html-preview .preview-main .video-mode-preview-settings .recorder-btn span{width:100%;height:9px;padding:2.969px 0;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:2.969px;border-radius:2.078px;background:#fd3b31;color:#fff;text-align:center;font-size:5.048px;font-style:normal;font-weight:500;line-height:100%;text-transform:uppercase;margin-bottom:9px}html-preview .preview-main .video-mode-preview-settings img{width:100%}html-preview .print-bleed{position:absolute;border:1px dashed red;box-sizing:border-box;z-index:16}html-preview .badge-block{position:absolute;display:flex;right:0;bottom:0;z-index:20}html-preview .badge-block .triangle-logo{border-width:0 0 15px 15px;border-style:solid;width:0;height:0;line-height:0;border-color:transparent transparent #000}html-preview .badge-block img{background:#000;width:60px;height:15px;padding-right:8px}", ""]);
	
	// exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.scenePreviewComponent = undefined;
	
	var _scenePreview = __webpack_require__(716);
	
	var _scenePreview2 = _interopRequireDefault(_scenePreview);
	
	var _scenePreview3 = __webpack_require__(717);
	
	__webpack_require__(718);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scenePreviewComponent = exports.scenePreviewComponent = {
	    template: _scenePreview2.default,
	    controller: _scenePreview3.scenePreviewController,
	    controllerAs: "scene",
	    bindings: {
	        layoutWidth: "<",
	        layoutHeight: "<",
	        sceneWidth: "<",
	        sceneHeight: "<",
	        photo: "<",
	        overlayFiles: "<",
	        backgroundFiles: "<",
	        image: "<",
	        photoIndex: "<",
	        hidePhotoBg: "<",
	        hideScene: "<"
	    }
	};

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"scene\" ng-style=\"scene.mainSceneStyle\">\n    <div class=\"scene-bg\" ng-if=\"!scene.hideScene\" ng-style=\"{'background-image': scene.getBgImage()}\">\n\n    </div>\n    <img src=\"{{scene.image}}\" alt=\"photo\" ng-style=\"scene.photoStyle\" ng-class=\"{'no-bg': scene.hidePhotoBg}\">\n    <div class=\"scene-overlay\" ng-if=\"!scene.hideScene\" ng-style=\"{'background-image': scene.getOverlayImage()}\">\n\n    </div>\n</div>";

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.scenePreviewController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scenePreviewController = exports.scenePreviewController = function (_ActiveController) {
	    scenePreviewController.$inject = ["$injector", "$rootScope", "$element", "$scope"];
	    (0, _inherits3.default)(scenePreviewController, _ActiveController);
	
	    function scenePreviewController($injector, $rootScope, $element, $scope) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, scenePreviewController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (scenePreviewController.__proto__ || (0, _getPrototypeOf2.default)(scenePreviewController)).call(this, $injector));
	
	        _this.$rootScope = $rootScope;
	        _this.$element = angular.element($element);
	        _this.$scope = $scope;
	        _this.mainSceneStyle = {};
	        _this.photoStyle = {};
	        return _this;
	    }
	
	    (0, _createClass3.default)(scenePreviewController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this2 = this;
	
	            this.layoutWidth = this.removePixels(this.layoutWidth);
	            this.layoutHeight = this.removePixels(this.layoutHeight);
	            this.getSceneSize();
	
	            this.$scope.$watch(function () {
	                return _this2.sceneWidth;
	            }, function () {
	                _this2.getSceneSize();
	            });
	            this.$scope.$watch(function () {
	                return _this2.sceneHeight;
	            }, function () {
	                _this2.getSceneSize();
	            });
	            this.$scope.$watch(function () {
	                return _this2.photo ? _this2.photo.width : null;
	            }, function () {
	                _this2.getSceneSize();
	            });
	            this.$scope.$watch(function () {
	                return _this2.photo ? _this2.photo.height : null;
	            }, function () {
	                _this2.getSceneSize();
	            });
	            this.$scope.$watch(function () {
	                return _this2.photo ? _this2.photo.x : null;
	            }, function () {
	                _this2.getSceneSize();
	            });
	            this.$scope.$watch(function () {
	                return _this2.photo ? _this2.photo.y : null;
	            }, function () {
	                _this2.getSceneSize();
	            });
	            this.$scope.$watch(function () {
	                return _this2.photo ? _this2.photo.angle : null;
	            }, function () {
	                _this2.getSceneSize();
	            });
	            this.$scope.$watch(function () {
	                return _this2.hideScene;
	            }, function () {
	                _this2.getPhotoStyle();
	            });
	        }
	    }, {
	        key: "getSceneSize",
	        value: function getSceneSize() {
	            if (this.sceneWidth / this.sceneHeight > this.layoutWidth / this.layoutHeight) {
	                this.mainSceneStyle = {
	                    width: this.layoutHeight * this.sceneWidth / this.sceneHeight,
	                    height: this.layoutHeight,
	                    top: 0,
	                    right: (this.layoutHeight * (this.sceneWidth / this.sceneHeight) - this.layoutWidth) / 2
	                };
	            } else {
	                this.mainSceneStyle = {
	                    height: this.layoutWidth * this.sceneHeight / this.sceneWidth,
	                    width: this.layoutWidth,
	                    right: 0,
	                    bottom: (this.layoutWidth * (this.sceneHeight / this.sceneWidth) - this.layoutHeight) / 2
	                };
	            }
	            this.mainSceneStyle.width += "px";
	            this.mainSceneStyle.height += "px";
	            this.mainSceneStyle.bottom += "px";
	            this.mainSceneStyle.right += "px";
	            this.mainSceneStyle.top += "px";
	            this.getPhotoStyle();
	        }
	    }, {
	        key: "getPhotoStyle",
	        value: function getPhotoStyle() {
	            if (!this.photo) return;
	            if (this.hideScene) {
	                this.photoStyle = {
	                    width: 100 + "%",
	                    height: 100 + "%",
	                    left: 0,
	                    top: 0
	                };
	            } else {
	                this.photoStyle = {
	                    width: this.photo.width * 100 / this.sceneWidth + "%",
	                    height: this.photo.height * 100 / this.sceneHeight + "%",
	                    left: this.photo.x * 100 / this.sceneWidth + "%",
	                    top: this.photo.y * 100 / this.sceneHeight + "%",
	                    transform: "rotate(" + this.photo.angle + "deg)"
	                };
	            }
	        }
	    }, {
	        key: "removePixels",
	        value: function removePixels(value) {
	            value = value.substring(0, value.length - 2);
	            return Number(value);
	        }
	    }, {
	        key: "getBgImage",
	        value: function getBgImage() {
	            if (this.backgroundFiles && this.backgroundFiles.length) {
	                if (this.photoIndex === 0 || this.photoIndex === 3) {
	                    return "url(" + (this.backgroundFiles[0].attachment_file.includes(".gif") ? this.backgroundFiles[0].first_frame : this.backgroundFiles[0].attachment_file) + ")";
	                } else if (this.photoIndex === 1 || this.photoIndex === 4) {
	                    var average = Math.ceil(this.backgroundFiles.length / 2) - 1;
	                    return "url(" + (this.backgroundFiles[average].attachment_file.includes(".gif") ? this.backgroundFiles[average].first_frame : this.backgroundFiles[average].attachment_file) + ")";
	                } else if (this.photoIndex === 2 || this.photoIndex === 5) {
	                    return "url(" + (this.backgroundFiles[this.backgroundFiles.length - 1].attachment_file.includes(".gif") ? this.backgroundFiles[this.backgroundFiles.length - 1].first_frame : this.backgroundFiles[this.backgroundFiles.length - 1].attachment_file) + ")";
	                }
	            }
	        }
	    }, {
	        key: "getOverlayImage",
	        value: function getOverlayImage() {
	            if (this.overlayFiles && this.overlayFiles.length) {
	                if (this.photoIndex === 0 || this.photoIndex === 3) {
	                    return "url(" + (this.isMovie(this.overlayFiles[0].attachment_file) ? this.overlayFiles[0].first_frame_alpha : this.overlayFiles[0].attachment_file) + ")";
	                } else if (this.photoIndex === 1 || this.photoIndex === 4) {
	                    var average = Math.ceil(this.overlayFiles.length / 2) - 1;
	                    return "url(" + (this.isMovie(this.overlayFiles[average].attachment_file) ? this.overlayFiles[average].first_frame_alpha : this.overlayFiles[average].attachment_file) + ")";
	                } else if (this.photoIndex === 2 || this.photoIndex === 5) {
	                    return "url(" + (this.isMovie(this.overlayFiles[this.overlayFiles.length - 1].attachment_file) ? this.overlayFiles[this.overlayFiles.length - 1].first_frame_alpha : this.overlayFiles[this.overlayFiles.length - 1].attachment_file) + ")";
	                }
	            }
	        }
	    }, {
	        key: "isMovie",
	        value: function isMovie(name) {
	            if (name === undefined || name === null) {
	                return false;
	            } else {
	                return name.indexOf(".mp4") !== -1 || name.indexOf(".webm") !== -1;
	            }
	        }
	    }]);
	    return scenePreviewController;
	}(_controller2.default);

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(719);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./scene-preview.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./scene-preview.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "scene-preview .scene{position:relative;background-color:#fff}scene-preview .scene img{position:absolute;object-fit:cover!important;background:#d3d3d3}scene-preview .scene img.no-bg{background:none}scene-preview .scene .scene-bg,scene-preview .scene .scene-overlay{position:absolute;background-size:100% 100%;background-position:50% 50%;width:100%;height:100%}", ""]);
	
	// exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.startScreenAreaComponent = undefined;
	
	var _startScreenArea = __webpack_require__(721);
	
	var _startScreenArea2 = _interopRequireDefault(_startScreenArea);
	
	var _startScreenArea3 = __webpack_require__(722);
	
	__webpack_require__(723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var startScreenAreaComponent = exports.startScreenAreaComponent = {
	    template: _startScreenArea2.default,
	    controller: _startScreenArea3.startScreenAreaController,
	    controllerAs: "startArea",
	    bindings: {
	        model: "=",
	        isDisabled: "<",
	        relativeSize: "<",
	        pixelWidth: "<",
	        pixelHeight: "<",
	        company: "<",
	        hideInputsFields: "<",
	        hideUploadIcons: "<",
	        shortUploadTitle: "<",
	        hideSizeOptions: "<",
	        customButtonsOptions: "<",
	        hideUpload: "<",
	        // Keeps width / height (px) at this ratio: changing one changes the other
	        aspectRatio: "<",
	        // Out of range values stay in the model (marked invalid) instead of becoming undefined
	        keepInvalid: "<",
	        // Icon upload limit in mb, instead of the default one
	        maxSize: "<",
	        // Allowed formats and size, under the upload button
	        uploadHint: "@",
	        // Width in % of the layout width instead of its height (x/y stay the center)
	        screenWidthUnits: "<",
	        deletePrevious: "<",
	        title: "@"
	    }
	};

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	module.exports = "<span class=\"title-item\" ng-if=\"startArea.title.length > 0\" ng-bind=\"startArea.title\"></span>\n<div flex=\"20\" class=\"custom-width\">\n\n    <md-input-container class=\"md-block\" ng-class=\"{'hide': startArea.hideSizeOptions || startArea.hideInputsFields}\">\n        <label\n                ng-bind=\"'Width (%)' | translate\"\n                for=\"{{startArea.componentId + 'width'}}\"></label>\n        <input\n                ng-model=\"startArea.model.width\"\n                ng-model-options=\"{allowInvalid: startArea.keepInvalid}\"\n                ng-change=\"startArea.changeSize('width'); startArea.setValidation()\"\n                type=\"number\"\n                min=\"{{ startArea.validation.width.min }}\"\n                max=\"{{ startArea.validation.width.max }}\"\n                step=\"0.5\"\n                name=\"{{startArea.componentId + 'width'}}\"\n                id=\"{{startArea.componentId + 'width'}}\"\n                ng-disabled=\"startArea.isDisabled\">\n    </md-input-container>\n\n</div>\n<div flex=\"20\" class=\"custom-width\">\n\n    <md-input-container class=\"md-block\" ng-class=\"{'hide': startArea.hideSizeOptions || startArea.hideInputsFields}\">\n        <label\n                ng-bind=\"'Height (%)' | translate\"\n                for=\"{{startArea.componentId + 'height'}}\"></label>\n        <input\n                ng-model=\"startArea.model.height\"\n                ng-model-options=\"{allowInvalid: startArea.keepInvalid}\"\n                ng-change=\"startArea.changeSize('height'); startArea.setValidation()\"\n                type=\"number\"\n                min=\"{{ startArea.validation.height.min }}\"\n                max=\"{{ startArea.validation.height.max }}\"\n                step=\"0.5\"\n                name=\"{{startArea.componentId + 'height'}}\"\n                id=\"{{startArea.componentId + 'height'}}\"\n                ng-disabled=\"startArea.isDisabled\">\n    </md-input-container>\n\n</div>\n<div flex=\"15\" class=\"custom-width\">\n\n    <md-input-container class=\"md-block\" ng-class=\"{'hide': startArea.hideInputsFields}\">\n        <label\n                ng-bind=\"'X (%)' | translate\"\n                for=\"{{startArea.componentId + 'x'}}\"></label>\n        <input\n                ng-model=\"startArea.model.x\"\n                ng-model-options=\"{allowInvalid: startArea.keepInvalid}\"\n                ng-change=\"startArea.setValidation()\"\n                type=\"number\"\n                min=\"{{ startArea.validation.x.min }}\"\n                max=\"{{ startArea.validation.x.max }}\"\n                step=\"0.5\"\n                name=\"{{startArea.componentId + 'x'}}\"\n                id=\"{{startArea.componentId + 'x'}}\"\n                ng-disabled=\"startArea.isDisabled\">\n    </md-input-container>\n\n</div>\n<div flex=\"15\" class=\"custom-width\">\n\n    <md-input-container class=\"md-block\" ng-class=\"{'hide': startArea.hideInputsFields}\">\n        <label\n                ng-bind=\"'Y (%)' | translate\"\n                for=\"{{startArea.componentId + 'y'}}\"></label>\n        <input\n                ng-model=\"startArea.model.y\"\n                ng-model-options=\"{allowInvalid: startArea.keepInvalid}\"\n                ng-change=\"startArea.setValidation()\"\n                type=\"number\"\n                min=\"{{ startArea.validation.y.min }}\"\n                max=\"{{ startArea.validation.y.max }}\"\n                step=\"0.5\"\n                name=\"{{startArea.componentId + 'y'}}\"\n                id=\"{{startArea.componentId + 'y'}}\"\n                ng-disabled=\"startArea.isDisabled\">\n    </md-input-container>\n\n</div>\n\n<div class=\"upload-container\" flex=\"100\" ng-hide=\"startArea.relativeSize || startArea.hideUpload\">\n    <upload\n            model=\"startArea.model.customIcon\"\n            uri=\"{{startArea.company + 'attachments/'}}\"\n            delete-previous=\"startArea.deletePrevious\"\n            callback=\"startArea.onIconDownload()\"\n            custom-label=\"{{startArea.shortUploadTitle ? 'Upload' : 'Upload an icon'}}\"\n            is-overlay=\"false\"\n            display-icon=\"!startArea.hideUploadIcons\"\n            max-size=\"startArea.maxSize || (startArea.customButtonsOptions ? 2 : 200)\"\n            file-types=\"{{startArea.customButtonsOptions ? '.svg,.png,.mp4,.mov,.webm' : '.svg,.jpg,.jpeg,.gif,.png,.mp4,.mov,.webm'}}\">\n    </upload>\n\n    <div class=\"file-title\" ng-if=\"startArea.model.customIcon\">\n        <span title=\"{{startArea.model.customIcon.attachment_file | getFileName}}\">Uploaded: {{ startArea.model.customIcon.attachment_file | getFileName:12 }}</span>\n        <md-button\n                class=\"md-icon-button md-primary\"\n                ng-click=\"startArea.deleteCustomIcon()\">\n            <md-icon style=\"color: gray\">delete</md-icon>\n        </md-button>\n    </div>\n    <p class=\"upload-container__sub-text\" ng-if=\"startArea.uploadHint\" ng-bind=\"startArea.uploadHint\"></p>\n</div>\n";

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.startScreenAreaController = undefined;
	
	var _isFinite = __webpack_require__(264);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var startScreenAreaController = exports.startScreenAreaController = function (_ActiveController) {
	    startScreenAreaController.$inject = ["$injector", "$rootScope", "$scope", "$upload"];
	    (0, _inherits3.default)(startScreenAreaController, _ActiveController);
	
	    function startScreenAreaController($injector, $rootScope, $scope, $upload) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, startScreenAreaController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (startScreenAreaController.__proto__ || (0, _getPrototypeOf2.default)(startScreenAreaController)).call(this, $injector));
	
	        _this.$rootScope = $rootScope;
	        _this.$upload = $upload;
	        _this.componentId = angular.copy(Math.random().toString(36).substr(2, 10));
	        _this.validation = {
	            width: {
	                min: 0,
	                max: 100
	            },
	            height: {
	                min: 0,
	                max: 100
	            },
	            x: {
	                min: 0,
	                max: 100
	            },
	            y: {
	                min: 0,
	                max: 100
	            }
	        };
	
	        $scope.$watch(function () {
	            return _this.pixelWidth;
	        }, function () {
	            _this.setValidation();
	        });
	
	        $scope.$watch(function () {
	            return _this.pixelHeight;
	        }, function () {
	            _this.setValidation();
	        });
	
	        $scope.$watch(function () {
	            return _this.model ? _this.model.width : null;
	        }, function () {
	            _this.setValidation();
	        });
	
	        $scope.$watch(function () {
	            return _this.model ? _this.model.height : null;
	        }, function () {
	            _this.setValidation();
	        });
	
	        // Width and height limits depend on the position, which can change outside the inputs (dragging)
	        $scope.$watchGroup([function () {
	            return _this.model ? _this.model.x : null;
	        }, function () {
	            return _this.model ? _this.model.y : null;
	        }], function () {
	            _this.setValidation();
	        });
	
	        $scope.$watch(function () {
	            return _this.aspectRatio;
	        }, function () {
	            if (_this.model && _this.aspectRatio) {
	                _this.changeSize("height");
	                _this.setValidation();
	            }
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(startScreenAreaController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.setValidation();
	        }
	        /*
	        If animated icons activated width should be changed
	        alongside with height
	         */
	
	    }, {
	        key: "changeSize",
	        value: function changeSize(value) {
	
	            if (this.aspectRatio) {
	                // Invalid input leaves undefined in the model: keep the other value as it is
	                if (!(0, _isFinite2.default)(this.model[value])) {
	                    return;
	                }
	                // px ratio = width / height; with screenWidthUnits the width is % of the layout width, not height
	                var ratio = this.screenWidthUnits ? this.aspectRatio * this.pixelHeight / this.pixelWidth : this.aspectRatio;
	                if (value === "width") {
	                    this.model.height = this.roundHalf(this.model.width / ratio);
	                } else {
	                    this.model.width = this.roundHalf(this.model.height * ratio);
	                }
	                return;
	            }
	
	            if (!this.relativeSize) {
	                return;
	            }
	
	            if (value === "width") {
	                if (this.model.width > this.validation.height.max) {
	                    this.model.width = this.model.height;
	                } else {
	                    this.model.height = this.model.width;
	                }
	            } else {
	                if (this.model.height > this.validation.width.max) {
	                    this.model.height = this.model.width;
	                } else {
	                    this.model.width = this.model.height;
	                }
	            }
	        }
	
	        /**
	         * Currently area width set in % of layout height.
	         * For correct validation this should be change to % of width
	         * @param val
	         */
	
	    }, {
	        key: "getWidthInPercents",
	        value: function getWidthInPercents(val) {
	            if (!this.model) {
	                return val;
	            }
	            var pWidth = this.pixelHeight * (val / 100);
	            var percentVal = pWidth / this.pixelWidth * 100;
	
	            return this.roundHalf(percentVal);
	        }
	    }, {
	        key: "roundHalf",
	        value: function roundHalf(number) {
	            return Math.round(number * 2) / 2;
	        }
	    }, {
	        key: "setValidation",
	        value: function setValidation() {
	            if (!this.model) {
	                return;
	            }
	            // Width in % of the layout width: x and width use the same units
	            if (this.screenWidthUnits) {
	                this.validation = {
	                    width: { min: 0, max: this.getSizeToEdge(this.model.x, 100) * 2 },
	                    height: { min: 0, max: this.getSizeToEdge(this.model.y, 100) * 2 },
	                    x: { min: this.roundHalf(this.model.width / 2), max: this.roundHalf(100 - this.model.width / 2) },
	                    y: { min: this.roundHalf(this.model.height / 2), max: this.roundHalf(100 - this.model.height / 2) }
	                };
	                return;
	            }
	            this.validation = {
	                width: {
	                    min: 0,
	                    max: this.getSizeToEdge(this.roundHalf(this.model.x * (this.pixelWidth / this.pixelHeight)), this.roundHalf(this.pixelWidth / this.pixelHeight * 100)) * 2
	                },
	                height: {
	                    min: 0,
	                    max: this.getSizeToEdge(this.model.y, 100) * 2
	                },
	                x: {
	                    min: this.roundHalf(this.getWidthInPercents(this.model.width) / 2),
	                    max: this.roundHalf(100 - this.getWidthInPercents(this.model.width) / 2)
	                },
	                y: {
	                    min: this.roundHalf(this.model.height / 2),
	                    max: this.roundHalf(100 - this.model.height / 2)
	                }
	            };
	        }
	    }, {
	        key: "getSizeToEdge",
	        value: function getSizeToEdge(pos, layout) {
	            var half = layout / 2;
	            return pos > half ? layout - pos : pos;
	        }
	    }, {
	        key: "onIconDownload",
	        value: function onIconDownload() {
	            var _this2 = this;
	
	            setTimeout(function () {
	                // Sync customIcon and custom_icon if both exist in model
	                // Upload component sets customIcon, we need to sync it to custom_icon
	                if (_this2.model && _this2.model.customIcon) {
	                    // Always sync custom_icon to match customIcon (upload component updates customIcon)
	                    _this2.model.custom_icon = _this2.model.customIcon;
	                }
	
	                // Trigger digest cycle to update any watchers (like preview)
	                if (_this2.$scope && !_this2.$scope.$$phase && !_this2.$scope.$root.$$phase) {
	                    _this2.$scope.$apply();
	                }
	
	                var file = _this2.model && _this2.model.customIcon ? _this2.model.customIcon.attachment_file : null;
	                if (!file) return;
	                var lower = file.toLowerCase();
	                // Skip dimension autosize for video files
	                if (lower.indexOf(".mp4") !== -1 || lower.indexOf(".mov") !== -1 || lower.indexOf(".webm") !== -1) {
	                    return;
	                }
	
	                var image = new Image();
	                image.src = file;
	                image.onload = function () {
	                    var imgWidth = image.naturalWidth;
	                    var imgHeight = image.naturalHeight;
	                    if (imgHeight > imgWidth) {
	                        _this2.model.width = _this2.roundHalf(imgWidth / imgHeight * _this2.model.height);
	                    } else {
	                        _this2.model.height = _this2.roundHalf(imgHeight / imgWidth * _this2.model.width);
	                    }
	                    // Trigger digest cycle after image dimensions are updated
	                    if (_this2.$scope && !_this2.$scope.$$phase && !_this2.$scope.$root.$$phase) {
	                        _this2.$scope.$apply();
	                    }
	                };
	            });
	        }
	
	        /**
	         * Delete custom icon - clears both customIcon and custom_icon
	         */
	
	    }, {
	        key: "deleteCustomIcon",
	        value: function deleteCustomIcon() {
	            if (this.model) {
	                if (this.deletePrevious) {
	                    var attachment = this.model.customIcon || this.model.custom_icon;
	                    var attachmentsUri = this.company ? this.company + "attachments/" : null;
	                    this.$upload.deleteCompanyAttachment(attachmentsUri, attachment);
	                }
	                // Clear both customIcon and custom_icon to ensure proper cleanup
	                this.model.customIcon = null;
	                this.model.custom_icon = null;
	                // Trigger digest cycle to update preview and UI
	                if (this.$scope && !this.$scope.$$phase && !this.$scope.$root.$$phase) {
	                    this.$scope.$apply();
	                }
	            }
	        }
	    }]);
	    return startScreenAreaController;
	}(_controller2.default);

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(724);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./start-screen-area.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./start-screen-area.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "start-screen-area{display:flex}start-screen-area .title-item{min-width:290px;padding-top:10px}start-screen-area .md-input-invalid label,start-screen-area .ng-invalid{border-color:#dd2c00!important}start-screen-area .ng-invalid{border-width:0 0 2px!important}start-screen-area .upload-container{position:relative;top:-10px}start-screen-area .upload-container .file-title{width:100%!important;margin-left:10px!important;min-width:200px!important;font-size:12px;color:gray}", ""]);
	
	// exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.photoInputComponent = undefined;
	
	var _photoInput = __webpack_require__(726);
	
	var _photoInput2 = _interopRequireDefault(_photoInput);
	
	var _photoInput3 = __webpack_require__(727);
	
	__webpack_require__(728);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var photoInputComponent = exports.photoInputComponent = {
	    template: _photoInput2.default,
	    controller: _photoInput3.photoInputController,
	    controllerAs: "photoInput",
	    bindings: {
	        model: "=",
	        isDisabled: "<",
	        ratio: "@",
	        customRatio: "<",
	        layoutWidth: "<",
	        layoutHeight: "<"
	    }
	};

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	module.exports = "<form name=\"{{ + 'form-' + photoInput.componentId}}\">\n    <span class=\"ph-name\" ng-if=\"photoInput.model.title\">{{photoInput.model.title}}.</span>\n\n    <span>Size</span>\n    <md-input-container class=\"md-block\">\n        <input\n                name=\"{{'width' + photoInput.componentId}}\"\n                ng-model=\"photoInput.model.width\"\n                ng-change=\"photoInput.changeSize('width')\"\n                placeholder=\"Width\"\n                type=\"number\"\n                min=\"0\"\n                ng-disabled=\"photoInput.isDisabled\"\n                ng-required=\"!photoInput.isDisabled\">\n    </md-input-container>\n\n    <md-input-container class=\"md-block\">\n        <input\n                name=\"{{'height' + photoInput.componentId}}\"\n                ng-model=\"photoInput.model.height\"\n                ng-change=\"photoInput.changeSize('height')\"\n                placeholder=\"Height\"\n                type=\"number\"\n                min=\"0\"\n                ng-disabled=\"photoInput.isDisabled\"\n                ng-required=\"!photoInput.isDisabled\">\n    </md-input-container>\n\n    <span>Position</span>\n    <md-input-container class=\"md-block\">\n        <input\n                name=\"{{'x' + photoInput.componentId}}\"\n                ng-model=\"photoInput.model.x\"\n                placeholder=\"X\"\n                type=\"number\"\n                ng-disabled=\"photoInput.isDisabled\"\n                ng-required=\"!photoInput.isDisabled\">\n    </md-input-container>\n    <md-input-container class=\"md-block\">\n        <input\n                name=\"{{'y' + photoInput.componentId}}\"\n                ng-model=\"photoInput.model.y\"\n                placeholder=\"Y\"\n                type=\"number\"\n                ng-disabled=\"photoInput.isDisabled\"\n                ng-required=\"!photoInput.isDisabled\">\n    </md-input-container>\n\n    <span>Rotation</span>\n    <md-input-container class=\"md-block\">\n        <input\n                name=\"{{'angle' + photoInput.componentId}}\"\n                ng-model=\"photoInput.model.angle\"\n                ng-blur=\"photoInput.model.angle = photoInput.model.angle || 0\"\n                placeholder=\"Angle\"\n                type=\"number\"\n                min=\"0\"\n                max=\"360\"\n                ng-disabled=\"photoInput.isDisabled\"\n                ng-required=\"!photoInput.isDisabled\">\n    </md-input-container>\n\n    <div class=\"error\">\n        <span ng-if=\"(!photoInput.model.width && photoInput.model.width !== 0)\"> Invalid width; </span>\n        <span ng-if=\"(!photoInput.model.height && photoInput.model.height !== 0)\">Invalid height; </span>\n        <span ng-if=\"(!photoInput.model.x && photoInput.model.x !== 0)\">Invalid X offset; </span>\n        <span ng-if=\"(!photoInput.model.y && photoInput.model.y !== 0)\">Invalid Y offset; </span>\n    </div>\n</form>\n";

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.photoInputController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var photoInputController = exports.photoInputController = function (_ActiveController) {
	    photoInputController.$inject = ["$injector", "$rootScope"];
	    (0, _inherits3.default)(photoInputController, _ActiveController);
	
	    function photoInputController($injector, $rootScope) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, photoInputController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (photoInputController.__proto__ || (0, _getPrototypeOf2.default)(photoInputController)).call(this, $injector));
	
	        _this.$rootScope = $rootScope;
	        _this.componentId = angular.copy(Math.random().toString(36).substr(2, 10));
	        return _this;
	    }
	
	    (0, _createClass3.default)(photoInputController, [{
	        key: "changeSize",
	        value: function changeSize(value) {
	            if (!this.ratio && !this.customRatio) {
	                return;
	            }
	
	            var wIndex = void 0,
	                hIndex = void 0;
	
	            switch (this.ratio) {
	                case "square":
	                    wIndex = 1;
	                    hIndex = 1;
	                    break;
	                case "landscape":
	                    wIndex = 3;
	                    hIndex = 2;
	                    break;
	                case "portrait":
	                    wIndex = 2;
	                    hIndex = 3;
	                    break;
	                case "custom":
	                    wIndex = this.customRatio.width ? this.customRatio.width : this.layoutWidth;
	                    hIndex = this.customRatio.height ? this.customRatio.height : this.layoutHeight;
	                    break;
	                default:
	                    wIndex = 1;
	                    hIndex = 1;
	                    break;
	            }
	
	            if (value === "height") {
	                this.model.width = Math.round(this.model.height * wIndex / hIndex);
	            } else {
	                this.model.height = Math.round(this.model.width * hIndex / wIndex);
	            }
	        }
	    }]);
	    return photoInputController;
	}(_controller2.default);

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(729);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./photo-input.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./photo-input.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "photo-input form{position:relative;display:inline-block}photo-input form .error{position:absolute;padding:0 9px;bottom:3px;font-size:12px;color:red}photo-input .md-input-invalid label,photo-input .ng-invalid{border-color:#dd2c00!important}photo-input .ng-invalid{border-width:0 0 2px!important}", ""]);
	
	// exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.phoneMsgComponent = undefined;
	
	var _phoneMsg = __webpack_require__(731);
	
	var _phoneMsg2 = _interopRequireDefault(_phoneMsg);
	
	var _phoneMsg3 = __webpack_require__(732);
	
	__webpack_require__(733);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var phoneMsgComponent = exports.phoneMsgComponent = {
	    template: _phoneMsg2.default,
	    controller: _phoneMsg3.phoneMsgController,
	    controllerAs: "phoneMsg",
	    bindings: {
	        text: "<"
	    }
	};

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"phone-bg\">\n    <div class=\"fromThem\">\n        <p>{{phoneMsg.text}} <span ng-if=\"phoneMsg.text.length\" class=\"link\">https://live.upreach.com/DbOwGI</span></p>\n    </div>\n</div>";

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.phoneMsgController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var phoneMsgController = exports.phoneMsgController = function (_ActiveController) {
	    phoneMsgController.$inject = ["$injector"];
	    (0, _inherits3.default)(phoneMsgController, _ActiveController);
	
	    function phoneMsgController($injector) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, phoneMsgController);
	        return (0, _possibleConstructorReturn3.default)(this, (phoneMsgController.__proto__ || (0, _getPrototypeOf2.default)(phoneMsgController)).call(this, $injector));
	    }
	
	    return phoneMsgController;
	}(_controller2.default);

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(734);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./phone-msg.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./phone-msg.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "phone-msg .phone-bg{padding:0 30px 150px 0;background-color:#fff;position:relative}phone-msg .fromThem{background:#e5e5ea;color:#000;float:left;clear:both;border-bottom-left-radius:30px 0px\\9;position:relative;padding:5px 20px;border-radius:15px;width:200px;min-height:50px;font-size:15px}phone-msg .fromThem p{white-space:pre-line}phone-msg .fromThem:before{content:\"\";position:absolute;z-index:2;bottom:-2px;left:-7px;height:19px;border-left:20px solid #e5e5ea;border-bottom-right-radius:16px 14px;transform:translateY(-2px);border-bottom-right-radius:15px 0px\\9;transform:translate(-1px,-2px)\\9}phone-msg .fromThem:after{content:\"\";position:absolute;z-index:3;bottom:-2px;left:19px;width:11px;height:20px;background:#fff;border-bottom-right-radius:10px;transform:translate(-30px,-2px)}phone-msg .link{word-break:break-all;color:blue;text-decoration:underline}", ""]);
	
	// exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.emailPreviewComponent = undefined;
	
	var _emailPreview = __webpack_require__(736);
	
	var _emailPreview2 = _interopRequireDefault(_emailPreview);
	
	var _emailPreview3 = __webpack_require__(737);
	
	__webpack_require__(738);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emailPreviewComponent = exports.emailPreviewComponent = {
	    template: _emailPreview2.default,
	    controller: _emailPreview3.emailPreviewController,
	    controllerAs: "emailPreview",
	    bindings: {
	        title: "<",
	        text: "<",
	        data: "@",
	        template: "@"
	    }
	};

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"preview-container\">\n    <div class=\"header\">\n        <div class=\"logo\">\n            <img src=\"" + __webpack_require__(157) + "\" alt=\"logo\">\n        </div>\n        <div class=\"title\">{{emailPreview.title}}</div>\n    </div>\n\n    <div class=\"divider\"></div>\n\n    <div class=\"text-custom\">\n        <span>{{emailPreview.text}}</span>\n    </div>\n\n    <div class=\"tip-text\">\n        <span>{{ emailPreview.currentText.tip }}</span>\n    </div>\n    <div class=\"photo-holder\">\n        <div class=\"preview\" ng-show=\"emailPreview.previews.print.enabled\">\n            <html-preview\n                    single=\"emailPreview.single\"\n                    boomerang=\"emailPreview.boomerang\"\n                    pr-width=\"{{emailPreview.mainBooth.printFile.finalSize.width}}\"\n                    pr-height=\"{{emailPreview.mainBooth.printFile.finalSize.height}}\"\n                    index=\"{{emailPreview.mainBooth.printFile.finalSize.width / 105}}\"\n                    overlay=\"{{emailPreview.mainBooth.printingOverlayFiles}}\"\n                    background=\"{{emailPreview.mainBooth.printingBackgroundFiles}}\"\n                    areas=\"{{ emailPreview.mergeArrays(emailPreview.mainBooth.printAreas, emailPreview.mainBooth.stripAreas)}}\"\n                    hide-title=\"true\"\n                    logo-type=\"emailPreview.logoType\"\n                    bg-color=\"emailPreview.data.startScreenBackgroundColor\"\n                    bg-style=\"'crop'\"\n                    logo=\"emailPreview.data.startScreenLogo.file.attachment_file\"\n                    bg-mode=\"emailPreview.mainBooth.printingBackgroundMode\"\n                    hide-logo=\"!emailPreview.data.startScreenLogo.enabled || !emailPreview.data.digitalStartScreenDesign\"\n                    logos-arr=\"emailPreview.mainBooth.printingLogos\">\n            </html-preview>\n        </div>\n        <div class=\"preview\" ng-show=\"emailPreview.previews.digital.enabled\">\n            <html-preview\n                    pr-width=\"{{emailPreview.mainBooth.sharingFile.finalSize.width}}\"\n                    pr-height=\"{{emailPreview.mainBooth.sharingFile.finalSize.height}}\"\n                    index=\"{{emailPreview.mainBooth.sharingFile.finalSize.width / emailPreview.fixedWidth}}\"\n                    overlay=\"{{emailPreview.mainBooth.sharingOverlayFiles}}\"\n                    background=\"{{emailPreview.mainBooth.sharingBackgroundFiles}}\"\n                    areas=\"{{ emailPreview.mainBooth.shareAreas}}\"\n                    hide-title=\"true\"\n                    logo-type=\"'digital'\"\n                    bg-color=\"emailPreview.data.startScreenBackgroundColor\"\n                    logo=\"emailPreview.data.startScreenLogo.file.attachment_file\"\n                    bg-mode=\"emailPreview.mainBooth.sharingBackgroundMode\"\n                    hide-logo=\"!emailPreview.data.startScreenLogo.enabled || !emailPreview.data.digitalStartScreenDesign\">\n            </html-preview>\n        </div>\n    </div>\n    <div class=\"clearfix\"></div>\n    <div class=\"sharer-title\">\n        <span>{{ emailPreview.currentText.sharer }}</span>\n    </div>\n    <div class=\"share-steps\">\n        <span>{{ emailPreview.currentText.step1 }}</span>\n    </div>\n    <div class=\"share-steps\">\n        <span>{{ emailPreview.currentText.step2 }}</span>\n    </div>\n</div>";

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.emailPreviewController = undefined;
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emailPreviewController = exports.emailPreviewController = function (_ActiveController) {
	    emailPreviewController.$inject = ["$injector", "$ToViewValue", "$scope"];
	    (0, _inherits3.default)(emailPreviewController, _ActiveController);
	
	    function emailPreviewController($injector, $ToViewValue, $scope) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, emailPreviewController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (emailPreviewController.__proto__ || (0, _getPrototypeOf2.default)(emailPreviewController)).call(this, $injector));
	
	        _this.toViewValue = $ToViewValue;
	        _this.previews = {
	            print: {},
	            digital: {}
	        };
	        _this.mainBooth = null;
	        _this.boomerang = false;
	        _this.single = false;
	        _this.textTemplate = {
	            english: {
	                tip: "(Preview - please scroll down to the bottom of the email to download the video attachment.)",
	                sharer: "How to share your image on Social Media:",
	                step1: "1. Save your image locally on your device (on your phone: tap and hold the image)",
	                step2: "2. Open Instagram, WhatsApp, Facebook or another app of your choice"
	            },
	            germanFormal: {
	                tip: "(Vorschau - bitte ans Ende der E-Mail scrollen, um den Video-Anhang herunterzuladen.)",
	                sharer: "So teilen Sie Ihr Bild in Social Media:",
	                step1: "1. Speichern Sie Ihr Foto lokal auf Ihrem Ger&auml;t ab (am Handy: auf das Bild tippen und gedr&uuml;ckt halten)",
	                step2: "2. &Ouml;ffnen Sie Instagram&#44; WhatsApp&#44; Facebook oder eine andere App Ihrer Wahl"
	            },
	            germanInformal: {
	                tip: "(Vorschau - bitte ans Ende der E-Mail scrollen, um den Video-Anhang herunterzuladen.)",
	                sharer: "So teilst du dein Bild&nbsp;in Social Media:",
	                step1: "1. Speichere dein Foto lokal auf deinem Ger&auml;t ab (am Handy: auf das Bild tippen und gedr&uuml;ckt halten)",
	                step2: "2. &Ouml;ffne Instagram&#44; WhatsApp&#44; Facebook oder eine andere App deiner Wahl"
	            }
	        };
	        _this.currentText = "uiufis";
	        $scope.$watch(function () {
	            return _this.template;
	        }, function () {
	            switch (_this.template) {
	                case "English":
	                    _this.currentText = (0, _lodash.cloneDeep)(_this.textTemplate.english);
	                    break;
	                case "German formal":
	                    _this.currentText = (0, _lodash.cloneDeep)(_this.textTemplate.germanFormal);
	                    break;
	                case "German informal":
	                    _this.currentText = (0, _lodash.cloneDeep)(_this.textTemplate.germanInformal);
	                    break;
	            }
	        });
	
	        $scope.$watch(function () {
	            return _this.data;
	        }, function () {
	            if (_this.data) {
	                _this.boomerang = false;
	                _this.single = false;
	                try {
	                    _this.data = JSON.parse(_this.data);
	                    if (!_this.data.gifBooth.enabled && !_this.data.photoBooth.enabled && !_this.data.boomerangBooth.enabled && !_this.data.videoBooth.enabled) {
	                        return;
	                    }
	                    _this.data.photoBooth.printAreas = _this.toViewValue.getArrayOfPrintingPhotos("photoBooth", _this.data);
	                    _this.data.photoBooth.shareAreas = _this.toViewValue.getSharingPhoto("photoBooth", _this.data);
	
	                    _this.data.gifBooth.printAreas = _this.toViewValue.getArrayOfPrintingPhotos("gifBooth", _this.data);
	                    _this.data.gifBooth.stripAreas = _this.toViewValue.getStrippedPhotos("gifBooth", _this.data);
	                    _this.data.gifBooth.shareAreas = _this.toViewValue.getSharingPhoto("gifBooth", _this.data);
	
	                    _this.data.boomerangBooth.printAreas = _this.toViewValue.getArrayOfPrintingPhotos("boomerangBooth", _this.data);
	                    _this.data.boomerangBooth.stripAreas = _this.toViewValue.getStrippedPhotos("boomerangBooth", _this.data);
	                    _this.data.boomerangBooth.shareAreas = _this.toViewValue.getSharingPhoto("boomerangBooth", _this.data);
	
	                    _this.previews.print.enabled = _this.data.photoBooth.allowPrinting || _this.data.gifBooth.allowPrinting || _this.data.boomerangBooth.allowPrinting;
	                    _this.previews.digital.enabled = _this.data.photoBooth.allowSharing || _this.data.gifBooth.allowSharing || _this.data.boomerangBooth.allowSharing || _this.data.videoBooth.allowSharing;
	
	                    if (_this.data.gifBooth.enabled) {
	                        _this.mainBooth = _this.data.gifBooth;
	                        _this.logoType = "strip";
	                    } else if (_this.data.boomerangBooth.enabled) {
	                        _this.mainBooth = _this.data.boomerangBooth;
	                        _this.logoType = "strip";
	                        _this.boomerang = true;
	                    } else if (_this.data.photoBooth.enabled) {
	                        _this.mainBooth = _this.data.photoBooth;
	                        _this.logoType = "print";
	                        _this.single = true;
	                    }
	                    _this.mainBooth.printAreas[0].random = Math.random() + "sf";
	                    _this.mainBooth.shareAreas[0].random = Math.random() + "sf";
	                    _this.fixedWidth = _this.previews.print.enabled && _this.previews.digital.enabled ? 107 : 224;
	                } catch (e) {
	                    //console.log(e);
	                }
	            }
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(emailPreviewController, [{
	        key: "mergeArrays",
	        value: function mergeArrays(arr1, arr2) {
	            if (!arr2) return arr1;
	            return [].concat((0, _toConsumableArray3.default)(arr1), (0, _toConsumableArray3.default)(arr2));
	        }
	    }]);
	    return emailPreviewController;
	}(_controller2.default);

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(739);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./email-preview.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./email-preview.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "email-preview .preview-container{width:278px;height:555px;background-color:hsla(0,0%,100%,.3);background-color:#f9f9f9;overflow-y:hidden;overflow-x:visible}email-preview .preview-container .header{background-color:#000}email-preview .preview-container .header .logo{height:37px}email-preview .preview-container .header .logo img{height:auto;width:71px;margin:14px 50px}email-preview .preview-container .header .title{color:#fff;font-size:20px;font-weight:bolder;text-align:center;padding:10px 20px 23px;position:relative;min-height:20px}email-preview .preview-container .divider{height:4px;background-image:linear-gradient(45deg,#fe753a,#ff3150 100%,#fe8036 0)}email-preview .preview-container .text-custom{min-height:70px;padding:20px 10px;text-align:center;display:flex;justify-content:center;align-items:center;font-size:14px;font-family:HKNova-Medium;white-space:pre-line;position:relative}email-preview .preview-container .tip-text{font-size:11px;display:flex;align-items:center;justify-content:center;text-align:center;padding:0 5px}email-preview .preview-container .photo-holder{padding:10px 25px 30px;min-height:160px;display:flex}email-preview .preview-container .photo-holder .preview{flex:1}email-preview .preview-container .clearfix{clear:both}email-preview .preview-container .sharer-title{height:60px;font-size:14px;font-weight:bolder;text-align:center;display:flex;justify-content:center;align-items:center}email-preview .preview-container .share-steps{height:50px;font-size:13px;text-align:center;display:flex;justify-content:center;align-items:center}", ""]);
	
	// exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loaderComponent = undefined;
	
	var _loader = __webpack_require__(741);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	__webpack_require__(742);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loaderComponent = exports.loaderComponent = {
	    template: _loader2.default
	};

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"preloader\">\n    <div id=\"loader\"></div>\n</div>";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(743);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./loader.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./loader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "body{background-color:#222}#preloader{position:fixed;top:0;left:0;width:100%;height:100%}#loader{display:block;position:relative;left:50%;top:50%;width:150px;height:150px;margin:-75px 0 0 -75px;border-radius:50%;border:3px solid transparent;border-top-color:#ff0046;animation:spin 2s linear infinite}#loader:before{content:\"\";position:absolute;top:5px;left:5px;right:5px;bottom:5px;border-radius:50%;border:3px solid transparent;border-top-color:#ff3038;animation:spin 3s linear infinite}#loader:after{content:\"\";position:absolute;top:15px;left:15px;right:15px;bottom:15px;border-radius:50%;border:3px solid transparent;border-top-color:#ff6626;animation:spin 1.5s linear infinite}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AnalyticsModule = undefined;
	
	var _analytics = __webpack_require__(745);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _analyticsDetail = __webpack_require__(750);
	
	var _analyticsDetail2 = _interopRequireDefault(_analyticsDetail);
	
	var _analyticsRouter = __webpack_require__(769);
	
	var _analyticsRouter2 = _interopRequireDefault(_analyticsRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsModule = exports.AnalyticsModule = angular.module("analytics", []).component("analytics", _analytics2.default).component("analyticsDetail", _analyticsDetail2.default).config(_analyticsRouter2.default);

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _analytics = __webpack_require__(746);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _analytics3 = __webpack_require__(747);
	
	var _analytics4 = _interopRequireDefault(_analytics3);
	
	__webpack_require__(748);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsComponent = {
	    template: _analytics2.default,
	    controller: _analytics4.default,
	    controllerAs: "Analytics"
	};
	
	exports.default = AnalyticsComponent;

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	module.exports = "<md-content layout=\"column\" flex layout-align=\"top center\">\n  <md-card>\n    <md-toolbar class=\"md-table-toolbar md-default\" ng-hide=\"options.rowSelection && selected.length\">\n      <div class=\"md-toolbar-tools\">\n        <span>Analytics</span>\n        <div flex></div>\n        <div flex=\"70\" class=\"md-toolbar-tools md-toolbar-search\" ng-if=\"filter.show\" layout-align=\"center right\">\n          <md-input-container md-no-float flex layout-align=\"center right\">\n            <input ng-blur=\"Analytics.onSearchBlur()\" type=\"text\" id=\"search-field\" placeholder=\"Search in the Deployments\" ng-model=\"query.search\" ng-model-options=\"filter.options\" class=\"ng-pristine ng-valid ng-touched\" autofocus>\n          </md-input-container>\n          <button class=\"md-icon-button md-button md-ink-ripple\" type=\"button\" ng-click=\"Analytics.removeFilter()\" layout-align=\"center right\">\n            <md-icon class=\"material-icons\">search</md-icon>\n            <div class=\"md-ripple-container\"></div>\n          </button>\n        </div>\n        <md-button class=\"md-icon-button md-button md-ink-ripple\" ng-click=\"Analytics.showFilter()\" ng-if=\"!filter.show\" ng-show=\"deployments._meta.count\">\n          <md-icon class=\"material-icons\">search</md-icon>\n          <div class=\"md-ripple-container\"></div>\n        </md-button>\n      </div>\n    </md-toolbar>\n\n    <md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"options.rowSelection && selected.length\">\n      <div class=\"md-toolbar-tools\">\n        <span>{{selected.length}} {{selected.length > 1 ? 'items' : 'item'}} selected</span>\n      </div>\n    </md-toolbar>\n\n    <md-table-container ng-if=\"! deployments._meta.count\" class=\"no-items\">\n      <div ng-if=\"loading\" translate>Loading deployments...</div>\n      <div ng-if=\"!loading && !filter.show\" translate>You have no deployments available.</div>\n      <div ng-if=\"!loading && filter.show\" translate>No results found for: '{{ query.search }}'.</div>\n    </md-table-container>\n\n    <md-table-container ng-if=\"deployments._meta.count\">\n      <table md-table md-row-select=\"options.rowSelection\" multiple=\"{{options.multiSelect}}\" ng-model=\"selected\" md-progress=\"promise\">\n        <thead ng-if=\"!options.decapitate\" md-head md-order=\"query.order\" md-on-reorder=\"logOrder\">\n        <tr md-row>\n          <th md-column md-order-by=\"_name\"><span>{{'Deployment Name' | translate}}</span></th>\n          <th md-column md-order-by=\"_company__name\" ng-hide=\"Analytics.isClient()\"><span>{{'Client Name' | translate}}</span></th>\n          <th md-column md-order-by=\"_logistics_type\" ng-hide=\"Analytics.isClient()\"><span>{{'Deployment type' | translate}}</span></th>\n          <th md-column md-order-by=\"_location_city\" ng-hide=\"Analytics.isClient()\"><span>{{'Deployment Location' | translate}}</span></th>\n          <th md-column md-order-by=\"_deployment_start\"><span>{{'Start Date' | translate}}</span></th>\n          <th md-column md-order-by=\"_deployment_end\"><span>{{'End Date' | translate}}</span></th>\n          <th md-column></th>\n        </tr>\n        </thead>\n        <tbody md-body>\n        <tr md-row md-select=\"deployment\" md-on-select=\"logItem\" md-auto-select=\"options.autoSelect\" class=\"md-row\"\n            ng-repeat=\"item in deployments | filter: filter.search | orderBy: query.order | limitTo: query.limit : (query.page -1) * query.limit\"\n            ui-sref=\"analyticsDetail({id: (item.url | getObjectId)})\">\n          <td md-cell class=\"underline-on-hover show-button-on-hover\" style=\"min-width: 150px\">{{item.name}}\n          </td>\n          <td md-cell ng-hide=\"Analytics.isClient()\">\n            <span> {{item.company_info.name}}\n            </span>\n          </td>\n\n          <td md-cell ng-hide=\"Analytics.isClient()\">\n            <span ng-bind=\"item.logistics_type | getObjectByKey:Analytics.logisticsType\"></span>\n          </td>\n\n          <!-- deployment location -->\n          <td md-cell ng-hide=\"Analytics.isClient()\">\n            <span ng-bind=\"item.location_address.city\"></span>\n          </td>\n\n          <!-- start date -->\n          <td md-cell>\n            <span ng-bind=\"item.deployment_start | defaultDateFormatDays\"></span>\n          </td>\n\n          <!-- end date -->\n          <td md-cell>\n            <span ng-bind=\"item.deployment_end | defaultDateFormatDays\"></span>\n          </td>\n\n          <td md-cell  layout=\"row\" layout-align=\"center end\">\n            <span flex></span>\n            <md-menu md-position-mode=\"target-right target\" >\n              <md-button aria-label=\"Menu options\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                <md-icon class=\"material-icons\">more_vert</md-icon>\n              </md-button>\n              <md-menu-content width=\"1\" >\n                <md-menu-item>\n                  <md-button ng-click=\"Analytics.openInNewTab(item.url | getObjectId)\">\n                    <div layout=\"row\" flex>\n                      <p flex translate>Open in new tab</p>\n                      <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">tab</md-icon>\n                    </div>\n                  </md-button>\n                </md-menu-item>\n              </md-menu-content>\n            </md-menu>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n\n    <button md-button ng-if=\"canAddMore && !loading\" ng-click=\"Analytics.addMoreItems()\" style=\"color: #FF0051\">Load more</button>\n  </md-card>\n</md-content>\n\n\n\n\n";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(239);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Forms", "$companies", "$Booth", "$service", "$Deployment", "$Company"];
	
	var AnalyticsController = function (_$controller) {
	    AnalyticsController.$inject = ["$injector", "$stateParams", "$scope", "$element", "$auth", "$window"];
	    (0, _inherits3.default)(AnalyticsController, _$controller);
	
	    function AnalyticsController($injector, $stateParams, $scope, $element, $auth, $window) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, AnalyticsController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AnalyticsController.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsController)).call(this, $injector, dependencies));
	
	        _this.$scope = $scope;
	        _this.$stateParams = $stateParams;
	        _this.$element = $element;
	        _this.$auth = $auth;
	        _this.$window = $window;
	        _this.$scope.loading = true;
	        _this.$scope.query = { page: 1, search: "" };
	        _this.$scope.filter = {};
	        _this.$scope.deployments = [];
	        _this.$scope.pageCount = 0;
	        _this.$scope.canAddMore = true;
	        _this.$scope.logOrder = function () {
	            _this.$scope.query.ordering = _this.$scope.query.order.replace("_", "");
	            _this.query(true);
	        };
	        _this.logisticsType = {
	            "by_upreach": "By UpReach",
	            "by_client": "By Client"
	        };
	
	        _this.searchByKeyPress = function (event) {
	            var keyName = event.key;
	            var letters = "abcdefghijklmnopqrstuvwxyz";
	            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
	                _this.$scope.$apply(function () {
	                    _this.$scope.filter.show = true;
	                    if (!_this.$scope.query.search) {
	                        _this.$scope.query.search = keyName;
	                    }
	                });
	                (0, _lodash.delay)(function () {
	                    document.getElementById("search-field").focus();
	                }, 100);
	            }
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(AnalyticsController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.$scope.filter.show = false;
	            this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
	            document.addEventListener("keypress", this.searchByKeyPress);
	            //this.$scope.$watch("query.page", angular.bind(this, this.query));
	            //this.query();
	        }
	    }, {
	        key: "$onDestroy",
	        value: function $onDestroy() {
	            document.removeEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "query",
	        value: function query(isNew) {
	            var _this2 = this;
	
	            var deployments = this.$Deployment.query(this.$scope.query);
	
	            _promise2.default.all([deployments.$promise]).then(function () {
	                var _$scope$deployments;
	
	                _this2.$scope.query.page = deployments._meta.page || 1;
	                _this2.$scope.loading = false;
	
	                isNew ? _this2.$scope.deployments = deployments : (_$scope$deployments = _this2.$scope.deployments).push.apply(_$scope$deployments, (0, _toConsumableArray3.default)(deployments));
	                _this2.$scope.pageCount = deployments._meta.page_count;
	                _this2.$scope.canAddMore = _this2.$scope.query.page !== _this2.$scope.pageCount;
	
	                _this2.$scope.$apply();
	            });
	        }
	    }, {
	        key: "addMoreItems",
	        value: function addMoreItems() {
	            this.$scope.query.page++;
	            this.query();
	        }
	    }, {
	        key: "onQueryFilterChange",
	        value: function onQueryFilterChange() {
	            var _this3 = this;
	
	            this.$scope.query.page = 1;
	            var newValue = (0, _lodash.clone)(this.$scope.query.search);
	            this.$scope.loading = true;
	            this.searhDelayTimeout = setTimeout(function () {
	                var prewValue = (0, _lodash.clone)(_this3.$scope.query.search);
	                if (prewValue === newValue) {
	                    clearTimeout(_this3.searhDelayTimeout);
	                    _this3.query(true);
	                }
	            }, 500);
	        }
	    }, {
	        key: "removeFilter",
	        value: function removeFilter() {
	            this.$scope.filter.show = false;
	            this.$scope.query.search = "";
	        }
	    }, {
	        key: "showFilter",
	        value: function showFilter() {
	            this.$scope.filter.show = true;
	            (0, _lodash.delay)(function () {
	                document.getElementById("search-field").focus();
	            }, 100);
	        }
	    }, {
	        key: "onSearchBlur",
	        value: function onSearchBlur() {
	            if (!this.$scope.query.search) {
	                this.$scope.filter.show = false;
	            }
	        }
	    }, {
	        key: "isClient",
	        value: function isClient() {
	            return this.$auth.isRole("Client") || this.$auth.isRole("Sub-User");
	        }
	    }, {
	        key: "openInNewTab",
	        value: function openInNewTab(id) {
	            this.$window.open(this.$window.location.href + id, "_blank");
	        }
	    }]);
	    return AnalyticsController;
	}(_index.$controller);
	
	exports.default = AnalyticsController;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(749);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./analytics.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./analytics.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "analytics md-card{width:85%}analytics .truncated{max-width:150px}analytics table.md-table:not(.md-row-select) td.md-cell:nth-child(n+2):nth-last-child(n+2),analytics table.md-table:not(.md-row-select) th.md-column:nth-child(n+2):nth-last-child(n+2){padding:0 16px 0 0}analytics md-select.md-table-select>.md-select-value>span>.md-text{display:inline-block!important}", ""]);
	
	// exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _analyticsDetail = __webpack_require__(751);
	
	var _analyticsDetail2 = _interopRequireDefault(_analyticsDetail);
	
	var _analyticsDetail3 = __webpack_require__(752);
	
	var _analyticsDetail4 = _interopRequireDefault(_analyticsDetail3);
	
	__webpack_require__(767);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsDetailComponent = {
	    template: _analyticsDetail2.default,
	    controller: _analyticsDetail4.default,
	    controllerAs: "details"
	};
	
	exports.default = AnalyticsDetailComponent;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<loader ng-if=\"!details.analyticsData\"></loader>\n<div id=\"analytic\">\n    <div class=\"header-info\" ng-if=\"details.analyticsData\" data-html2canvas-ignore>\n        <div layout=\"row\">\n            <dvi layout=\"column\" style=\"background: #f6f6f6; margin: 25px 0 40px 0\">\n                <span class=\"main-info\"><i class=\"material-icons\">insert_chart</i><span>KPI Report | {{details.analyticsData.company_name}} | {{details.analyticsData.name}}</span></span>\n                <span class=\"data-ranges\" ng-hide=\"details.showDatePicker\">\n            {{details.editData(details.analyticsData.date_range.start_date)}} -\n            {{details.editData(details.analyticsData.date_range.end_date)}}\n            <i class=\"material-icons\" data-html2canvas-ignore ng-click=\"details.openPicker()\" id=\"open-icon\">edit</i>\n            </span>\n                <div class=\"date-container\" ng-show=\"details.showDatePicker\" id=\"date-container\">\n                    <md-input-container class=\"md-block md-short-input\">\n                        <input\n                                ng-change=\"details.loadData(true)\"\n                                mdc-datetime-picker=\"\"\n                                date=\"true\"\n                                time=\"true\"\n                                type=\"text\"\n                                placeholder=\"{{'Report time frame start' | translate}}\"\n                                show-todays-date=\"\"\n                                minutes=\"true\"\n                                min-date=\"details.minDate\"\n                                max-date=\"details.analyticsData.date_range.end_date\"\n                                auto-ok=\"true\"\n                                show-icon=\"true\"\n                                ng-model=\"details.analyticsData.date_range.start_date\"\n                                class=\"dtp-no-msclear dtp-input md-input\"\n                                required>\n                    </md-input-container>\n                    <span class=\"divider\">-</span>\n                    <md-input-container class=\"md-block md-short-input\">\n                        <input\n                                ng-change=\"details.loadData(true)\"\n                                mdc-datetime-picker=\"\"\n                                readonly\n                                date=\"true\"\n                                time=\"true\"\n                                type=\"text\"\n                                placeholder=\"{{'Report time frame end' | translate}}\"\n                                show-todays-date=\"\"\n                                minutes=\"true\"\n                                min-date=\"details.analyticsData.date_range.start_date\"\n                                max-date=\"details.maxDate\"\n                                auto-ok=\"true\"\n                                show-icon=\"true\"\n                                ng-model=\"details.analyticsData.date_range.end_date\"\n                                class=\"dtp-no-msclear dtp-input md-input\"\n                                required>\n                    </md-input-container>\n                </div>\n            </dvi>\n        </div>\n\n\n        <md-button class=\"md-raised md-primary download-btn settings\" ng-click=\"details.openReportSettings()\">\n            <i class=\"material-icons\">\n                tune\n            </i>\n            <span>SETTINGS</span>\n        </md-button>\n        <div class=\"export-block\" >\n            <md-button class=\"md-primary md-raised export-btn\"\n                       ng-click=\"details.showMenu = !details.showMenu\" ng-blur=\"details.hideExportMenu()\">\n                <i class=\"material-icons\">\n                    screen_share\n                </i>\n                EXPORT\n            </md-button>\n            <div class=\"export-menu\" ng-if=\"details.showMenu\" ng-hide=\"details.loading || details.showDatePicker\">\n                <div class=\"export-item\" ng-click=\"details.createPDF()\">\n                    <i class=\"material-icons\">\n                        picture_as_pdf\n                    </i>\n                    <strong>PDF</strong>\n                    <span>EXPORT</span>\n                </div>\n                <div class=\"export-item\" ng-click=\"details.createXLS()\">\n                    <img ng-src=\"{{details.tableIcon}}\" alt=\"\">\n                    <strong>XLS</strong>\n                    <span>EXPORT</span>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"header-info\" ng-if=\"details.analyticsData\" id=\"pdf-logo\">\n        <div class=\"logo-container\">\n            <img src=\"" + __webpack_require__(157) + "\" alt=\"logo\">\n        </div>\n        <span class=\"main-info\">KPI Report | {{details.analyticsData.company_name}} | {{details.analyticsData.name}}</span>\n        <span class=\"data-ranges\">{{details.editData(details.analyticsData.date_range.start_date)}} - {{details.editData(details.analyticsData.date_range.end_date)}}</span>\n    </div>\n\n    <div class=\"tb-cont\" layout=\"column\" ng-if=\"details.analyticsData && !details.loading\">\n\n        <div class=\"tb-main\" id=\"tb-main\" layout=\"row\" ng-if=\"details.analyticsData.report_settings.photo_system || details.analyticsData.report_settings.live_gallery\">\n\n            <div class=\"left-titles\">\n                <strong>Total</strong>\n                <strong ng-if=\"details.analyticsData.report_settings.unique\">Unique</strong>\n            </div>\n\n            <div class=\"analytics-block\" >\n                <div class=\"analytics-block-item\" ng-if=\"details.analyticsData.report_settings.photo_system\">\n                    <div class=\"analytics-block-head\" >\n                        <p>\n                            Photo System\n                        </p>\n                    </div>\n                    <div layout=\"row\">\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.sessions\">\n                            <div class=\"analytics-data-head\">\n                                <i class=\"material-icons\">\n                                    camera_alt\n                                </i>\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item sub\" >\n                                    <p>Sessions</p>\n                                    <span>{{details.analyticsData.photo_system.total.sessions || 0}}</span>\n                                </div>\n                                <div class=\"analytics-data-item sub\" ng-if=\"details.analyticsData.report_settings.photo && details.analyticsData.report_settings.photo !== null\">\n                                    <p>Photo</p>\n                                    <span>{{details.analyticsData.photo_system.total.photo || 0}}</span>\n                                </div>\n                                <div class=\"analytics-data-item sub\" ng-if=\"details.analyticsData.report_settings.gif && details.analyticsData.report_settings.gif !== null\">\n                                    <p>GIF</p>\n                                    <span>{{details.analyticsData.photo_system.total.gif || 0}}</span>\n                                </div>\n                                <div class=\"analytics-data-item sub\" ng-if=\"details.analyticsData.report_settings.boomerang && details.analyticsData.report_settings.boomerang !== null\">\n                                    <p>Boomerang</p>\n                                    <span>{{details.analyticsData.photo_system.total.boomerang || 0}}</span>\n                                </div>\n                                <div class=\"analytics-data-item sub\" ng-if=\"details.analyticsData.report_settings.video && details.analyticsData.report_settings.video !== null\">\n                                    <p>Video</p>\n                                    <span>{{details.analyticsData.photo_system.total.video || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.emails\">\n                            <div class=\"analytics-data-head\">\n                                <i class=\"material-icons\">email</i>\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item sub\">\n                                    <p>Emails</p>\n                                    <span>{{details.analyticsData.photo_system.total.emails || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.photo_system.unique.emails || 0}}</span>\n                                </div>\n                                <div class=\"analytics-data-item sub\" ng-if=\"details.analyticsData.report_settings.delivered  && details.analyticsData.report_settings.delivered !== null\">\n                                    <p>Delivered</p>\n                                    <span>{{details.analyticsData.photo_system.total.delivered || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.photo_system.unique.delivered || 0}}</span>\n                                </div>\n                                <div class=\"analytics-data-item sub\" ng-if=\"details.analyticsData.report_settings.opens && details.analyticsData.report_settings.opens !== null\">\n                                    <p>Opens</p>\n                                    <span>{{details.analyticsData.photo_system.total.opens || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.photo_system.unique.opens || 0}}</span>\n                                </div>\n                                <div class=\"analytics-data-item sub\" ng-if=\"details.analyticsData.report_settings.clicks && details.analyticsData.report_settings.clicks !== null\">\n                                    <p>Clicks</p>\n                                    <span>{{details.analyticsData.photo_system.total.clicks || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.photo_system.unique.clicks || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.messages && details.analyticsData.report_settings.messages !== null\">\n                            <div class=\"analytics-data-head\">\n                                <i class=\"material-icons\">textsms</i>\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\" >\n                                    <h5>SMS</h5>\n                                    <span>{{details.analyticsData.photo_system.total.messages || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.photo_system.unique.messages || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.prints && details.analyticsData.report_settings.prints !== null\">\n                            <div class=\"analytics-data-head\">\n                                <i class=\"material-icons\">print</i>\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>Prints</h5>\n                                    <span>{{details.analyticsData.photo_system.total.prints || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.photo_system.unique.prints || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.qr_code_scans && details.analyticsData.report_settings.qr_code_scans !== null\">\n                            <div class=\"analytics-data-head\">\n                                <i class=\"material-icons\">phone_iphone</i>\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>QR Code Scans</h5>\n                                    <span>{{details.analyticsData.photo_system.total.qr_code_scans || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.photo_system.unique.qr_code_scans || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"analytics-block-item\" ng-if=\"details.analyticsData.report_settings.live_gallery\">\n                    <div class=\"analytics-block-head\" id=\"analytics-block-item\">\n                        <p>\n                            Live Gallery\n                        </p>\n                    </div>\n                    <div layout=\"row\">\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.views && details.analyticsData.report_settings.views !== null\">\n                            <div class=\"analytics-data-head\">\n                                <i class=\"material-icons\">remove_red_eye</i>\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>Views</h5>\n                                    <span>{{details.analyticsData.live_gallery.total.views || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.live_gallery.unique.views || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.avg_visit_time && details.analyticsData.report_settings.avg_visit_time !== null\">\n                            <div class=\"analytics-data-head\">\n                                <i class=\"material-icons\">timer</i>\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>Ø Visit duration (s)</h5>\n                                    <span>{{details.analyticsData.live_gallery.total.avg_visit_time || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.downloads && details.analyticsData.report_settings.downloads !== null\">\n                            <div class=\"analytics-data-head\">\n                               <i class=\"material-icons\">get_app</i>\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>Downloads</h5>\n                                    <span>{{details.analyticsData.live_gallery.total.downloads || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.live_gallery.unique.downloads || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.whats_app && details.analyticsData.report_settings.whats_app !== null\">\n                            <div class=\"analytics-data-head\">\n                                <img ng-src=\"{{details.whatsappIcon}}\" alt=\"\">\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>WhatsApp</h5>\n                                    <span>{{details.analyticsData.live_gallery.total.whats_app || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.live_gallery.unique.whats_app || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.facebook && details.analyticsData.report_settings.facebook !== null\">\n                            <div class=\"analytics-data-head\">\n                                <img ng-src=\"{{details.facebookIcon}}\" alt=\"\">\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>Facebook</h5>\n                                    <span>{{details.analyticsData.live_gallery.total.facebook || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.live_gallery.unique.facebook || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.mesenger && details.analyticsData.report_settings.mesenger !== null\">\n                            <div class=\"analytics-data-head\">\n                                <i class=\"material-icons\">textsms</i>\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>Messenger</h5>\n                                    <span>{{details.analyticsData.live_gallery.total.mesenger || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.live_gallery.unique.mesenger || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.email && details.analyticsData.report_settings.email !== null\">\n                            <div class=\"analytics-data-head\">\n                                <i class=\"material-icons\">mail_outline</i>\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>Email</h5>\n                                    <span>{{details.analyticsData.live_gallery.total.email || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.live_gallery.unique.email || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.twitter && details.analyticsData.report_settings.twitter !== null\">\n                            <div class=\"analytics-data-head\">\n                                <img ng-src=\"{{details.twitterIcon}}\" alt=\"\">\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>Twitter</h5>\n                                    <span>{{details.analyticsData.live_gallery.total.twitter || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.live_gallery.unique.twitter || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.instagram && details.analyticsData.report_settings.instagram !== null\">\n                            <div class=\"analytics-data-head\">\n                                <img ng-src=\"{{details.instagramIcon}}\" alt=\"\">\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>Instagram</h5>\n                                    <span>{{details.analyticsData.live_gallery.total.instagram || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.live_gallery.unique.instagram || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"analytics-data\" ng-if=\"details.analyticsData.report_settings.tiktok && details.analyticsData.report_settings.tiktok !== null\">\n                            <div class=\"analytics-data-head\">\n                                <img ng-src=\"{{details.tiktokIcon}}\" alt=\"\">\n                            </div>\n                            <div layout=\"row\">\n                                <div class=\"analytics-data-item\">\n                                    <h5>Tiktok</h5>\n                                    <span>{{details.analyticsData.live_gallery.total.tiktok || 0}}</span>\n                                    <span ng-if=\"details.analyticsData.report_settings.unique\">{{details.analyticsData.live_gallery.unique.tiktok || 0}}</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n<!--                <div class=\"analytics-block-item\" >-->\n<!--                    <div class=\"analytics-block-head\">-->\n<!--                        <p>-->\n<!--                            Custom KPIs-->\n<!--                        </p>-->\n<!--                    </div>-->\n<!--                    <div layout=\"row\">-->\n<!--                        <div class=\"analytics-data\" ng-repeat=\"kpi in details.analyticsData.custom_kpis\" ng-if=\"details.analyticsData.custom_kpis\">-->\n<!--                            <div class=\"analytics-data-head\">-->\n<!--                                <i class=\"material-icons\">remove_red_eye</i>-->\n<!--                            </div>-->\n<!--                            <div layout=\"row\">-->\n<!--                                <div class=\"analytics-data-item\">-->\n<!--                                    <h5>{{kpi.name}}</h5>-->\n<!--                                    <span>{{kpi.value}}</span>-->\n<!--                                </div>-->\n<!--                            </div>-->\n<!--                        </div>-->\n<!--                    </div>-->\n<!--                </div>-->\n            </div>\n        </div>\n        <div style=\"width: 100vw; margin-top: 150px; text-align: center\" ng-if=\"!details.analyticsData.report_settings.photo_system && !details.analyticsData.report_settings.live_gallery\">\n            No data to show\n        </div>\n        <div>\n            <div class=\"charts-container\">\n                <div ng-if=\"details.analyticsData.photo_system.diagram != null && details.analyticsData.report_settings.sessions\" class=\"ch-holder\" flex=\"30\" layout=\"column\">\n                    <strong class=\"pie-title\">Capture Modes</strong>\n                    <img ng-src=\"{{details.analyticsData.photo_system.diagram}}\" alt=\"\">\n                </div>\n                <div class=\"ch-holder\" flex=\"30\" ng-if=\"details.analyticsData.report_settings.photo_system && details.showPhotoSystem\">\n                    <two-bar-chart\n                            unique=\"details.analyticsData.report_settings.unique\"\n                            data=\"details.firstCharData\"\n                            header=\"'Photo System Shares'\"\n                            lines=\"6\"></two-bar-chart>\n                </div>\n                <div class=\"ch-holder\" flex=\"30\" ng-if=\"details.analyticsData.report_settings.live_gallery && details.showGallery\">\n                    <two-bar-chart\n                            unique=\"details.analyticsData.report_settings.unique\"\n                            data=\"details.secondCharData\"\n                            header=\"'Live Gallery Shares'\"\n                            lines=\"6\"></two-bar-chart>\n                </div>\n\n                <div class=\"white-td\" ng-if=\"details.analyticsData.other.emails !== null && details.analyticsData.other.messages !== null\"></div>\n            </div>\n        </div>\n    </div>\n\n    <loader ng-if=\"details.loading\" data-html2canvas-ignore></loader>\n\n    <div id=\"footer-pdf\">\n        <div class=\"footer-cont\">\n            <div class=\"spacer\"></div>\n            <div class=\"info\">\n                <span>UpReach GmbH</span><br>\n                <span>Keithstraße 2-4</span><br>\n                <span>10787 Berlin</span><br>\n                <span>info@upreach.com</span><br>\n            </div>\n            <div class=\"info\">\n                <span>Registergericht - Amtsgericht Charlottenburg • HRB 187758 B</span><br>\n                <span>USt-IdNr. DE332091439</span><br>\n                <span>Geschäftsführer: Danny Fandrich</span><br>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _jspdf = __webpack_require__(753);
	
	var _jspdf2 = _interopRequireDefault(_jspdf);
	
	var _html2canvas = __webpack_require__(754);
	
	var _html2canvas2 = _interopRequireDefault(_html2canvas);
	
	var _lodash = __webpack_require__(101);
	
	var _downloadDialog = __webpack_require__(755);
	
	var _downloadDialog2 = __webpack_require__(756);
	
	var _downloadDialog3 = _interopRequireDefault(_downloadDialog2);
	
	var _reportSettingsDialog = __webpack_require__(757);
	
	var _reportSettingsDialog2 = __webpack_require__(760);
	
	var _reportSettingsDialog3 = _interopRequireDefault(_reportSettingsDialog2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Forms"];
	
	var AnalyticsDetailController = function (_$controller) {
	    AnalyticsDetailController.$inject = ["$injector", "$stateParams", "$scope", "$document", "$timeout"];
	    (0, _inherits3.default)(AnalyticsDetailController, _$controller);
	
	    function AnalyticsDetailController($injector, $stateParams, $scope, $document, $timeout) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, AnalyticsDetailController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AnalyticsDetailController.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsDetailController)).call(this, $injector, dependencies));
	
	        _this.$scope = $scope;
	        _this.$timeout = $timeout;
	        _this.$stateParams = $stateParams;
	        _this.id = _this.$stateParams.id;
	        _this.showDatePicker = false;
	        _this.loading = false;
	        _this.showPhotoSystem = false;
	        _this.showGallery = false;
	        _this.facebookIcon = __webpack_require__(761);
	        _this.twitterIcon = __webpack_require__(762);
	        _this.whatsappIcon = __webpack_require__(763);
	        _this.tableIcon = __webpack_require__(764);
	        _this.tiktokIcon = __webpack_require__(765);
	        _this.instagramIcon = __webpack_require__(766);
	
	        $document[0].getElementsByTagName("app")[0].onclick = function (e) {
	            var a = e.target;
	            var isContainer = false;
	            var elements = [];
	            while (a) {
	                elements.unshift(a);
	                a = a.parentNode;
	            }
	            (0, _lodash.forEach)(elements, function (el) {
	                if (el.id === "date-container" || el.id === "open-icon") {
	                    isContainer = true;
	                }
	            });
	            _this.showDatePicker = isContainer;
	            _this.$scope.$apply(function () {
	                return _this.showDatePicker;
	            });
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(AnalyticsDetailController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.loadData(false);
	        }
	    }, {
	        key: "hideExportMenu",
	        value: function hideExportMenu() {
	            var _this2 = this;
	
	            this.$timeout(function () {
	                _this2.showMenu = false;
	            }, 300);
	        }
	    }, {
	        key: "openReportSettings",
	        value: function openReportSettings() {
	            var _this3 = this;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Settings",
	                controller: _reportSettingsDialog.ReportSettingsDialogController,
	                template: _reportSettingsDialog3.default,
	                targetEvent: event,
	                locals: {
	                    callback: function callback(obj) {
	                        _this3.loading = true;
	
	                        var dataRange = "";
	                        if (_this3.analyticsData && _this3.analyticsData.date_range) {
	                            dataRange = "?start_date=" + moment(_this3.analyticsData.date_range.start_date).utc().format("YYYY-MM-DD HH:mm:SS") + "&end_date=" + moment(_this3.analyticsData.date_range.end_date).utc().format("YYYY-MM-DD HH:mm:SS");
	                        }
	                        _this3.$auth.$http({
	                            url: "/api/analytics/" + _this3.id + dataRange,
	                            method: "PUT",
	                            data: { report_settings: obj }
	                        }).then(function (resp) {
	                            _this3.analyticsData = resp.data;
	                            _this3.fillDataForCharts();
	                            _this3.loading = false;
	                        });
	                    },
	                    reportSettings: this.analyticsData.report_settings
	                }
	            });
	        }
	    }, {
	        key: "fillDataForCharts",
	        value: function fillDataForCharts() {
	            var _this4 = this;
	
	            this.showPhotoSystem = false;
	            this.showGallery = false;
	            if (this.analyticsData.report_settings.live_gallery) {
	                this.secondCharData = [{
	                    value1: this.analyticsData.report_settings.downloads ? this.analyticsData.live_gallery.total.downloads : false,
	                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.downloads : false,
	                    label: "Downloads",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.live_gallery.total.downloads ? this.analyticsData.report_settings.downloads : false
	                }, {
	                    value1: this.analyticsData.report_settings.whats_app ? this.analyticsData.live_gallery.total.whats_app : false,
	                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.whats_app : false,
	                    label: "WhatsApp",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.live_gallery.total.whats_app ? this.analyticsData.report_settings.whats_app : false
	                }, {
	                    value1: this.analyticsData.report_settings.facebook ? this.analyticsData.live_gallery.total.facebook : false,
	                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.facebook : false,
	                    label: "Facebook",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.live_gallery.total.facebook ? this.analyticsData.report_settings.facebook : false
	                }, {
	                    value1: this.analyticsData.report_settings.mesenger ? this.analyticsData.live_gallery.total.mesenger : false,
	                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.mesenger : false,
	                    label: "Messenger",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.live_gallery.total.mesenger ? this.analyticsData.report_settings.mesenger : false
	                }, {
	                    value1: this.analyticsData.report_settings.email ? this.analyticsData.live_gallery.total.email : false,
	                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.email : false,
	                    label: "Email",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)"
	                }, {
	                    value1: this.analyticsData.report_settings.twitter ? this.analyticsData.live_gallery.total.twitter : false,
	                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.twitter : false,
	                    label: "Twitter",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.live_gallery.total.twitter ? this.analyticsData.report_settings.twitter : false
	                }, {
	                    value1: this.analyticsData.report_settings.facebook ? this.analyticsData.live_gallery.total.facebook : false,
	                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.facebook : false,
	                    label: "Facebook",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.live_gallery.total.facebook ? this.analyticsData.report_settings.facebook : false
	                }, {
	                    value1: this.analyticsData.report_settings.instagram ? this.analyticsData.live_gallery.total.instagram : false,
	                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.instagram : false,
	                    label: "Instagram",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.live_gallery.total.instagram ? this.analyticsData.report_settings.instagram : false
	                }, {
	                    value1: this.analyticsData.report_settings.tiktok ? this.analyticsData.live_gallery.total.tiktok : false,
	                    value2: this.analyticsData.live_gallery.unique ? this.analyticsData.live_gallery.unique.tiktok : false,
	                    label: "Tiktok",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.live_gallery.total.tiktok ? this.analyticsData.report_settings.tiktok : false
	                }];
	            }
	
	            (0, _lodash.forEach)(this.secondCharData, function (char) {
	                char.active ? _this4.showGallery = true : false;
	            });
	
	            if (this.analyticsData.report_settings.photo_system) {
	                this.firstCharData = [{
	                    value1: this.analyticsData.photo_system.total.emails,
	                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.emails : false,
	                    label: "Emails",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.photo_system.total.emails ? this.analyticsData.report_settings.emails : false
	                }, {
	                    value1: this.analyticsData.photo_system.total.delivered,
	                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.delivered : false,
	                    label: "Delivered",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.photo_system.total.delivered ? this.analyticsData.report_settings.delivered : false
	                }, {
	                    value1: this.analyticsData.photo_system.total.opens,
	                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.opens : false,
	                    label: "Opens",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.photo_system.total.opens ? this.analyticsData.report_settings.opens : false
	                }, {
	                    value1: this.analyticsData.photo_system.total.clicks,
	                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.clicks : false,
	                    label: "Clicks",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.photo_system.total.clicks ? this.analyticsData.report_settings.clicks : false
	                }, {
	                    value1: this.analyticsData.photo_system.total.messages,
	                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.messages : false,
	                    label: "SMS",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.photo_system.total.messages ? this.analyticsData.report_settings.messages : false
	                }, {
	                    value1: this.analyticsData.photo_system.total.prints,
	                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.prints : false,
	                    label: "Prints",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.photo_system.total.prints ? this.analyticsData.report_settings.prints : false
	                }, {
	                    value1: this.analyticsData.photo_system.total.qr_code_scans,
	                    value2: this.analyticsData.photo_system.unique ? this.analyticsData.photo_system.unique.qr_code_scans : false,
	                    label: "QR Code...",
	                    color1: "#EE2737",
	                    color2: "rgb(241, 145, 163)",
	                    active: this.analyticsData.photo_system.total.qr_code_scans ? this.analyticsData.report_settings.qr_code_scans : false
	                }];
	                (0, _lodash.forEach)(this.firstCharData, function (char) {
	                    char.active ? _this4.showPhotoSystem = true : false;
	                });
	            }
	        }
	    }, {
	        key: "createPDF",
	        value: function createPDF() {
	            var _this5 = this;
	
	            var doc = new _jspdf2.default({ format: "a4", orientation: "l" });
	            var file = document.getElementById("analytic");
	            this.showDatePicker = false;
	
	            (0, _html2canvas2.default)(file, {
	                windowWidth: 1920,
	                windowHeight: 1480,
	                width: 1920,
	                height: 1480,
	                scrollX: 0,
	                scrollY: 0,
	                backgroundColor: "#fafafa",
	                scale: 2,
	                onclone: function onclone(el) {
	                    // Change output pdf styles here
	                    el.getElementById("pdf-logo").style.display = "flex";
	                    el.getElementById("footer-pdf").style.display = "block";
	                }
	            }).then(function (canvas) {
	                var data = canvas.toDataURL();
	
	                doc.addImage(data, "PNG", 0, 0, 300, 0, null, "FAST");
	                //doc.setDisplayMode("fullpage");
	                doc.save(moment(_this5.analyticsData.date_range.start_date).format("YYYYMMDD") + "-" + moment(_this5.analyticsData.date_range.end_date).format("YYYYMMDD") + "_" + _this5.analyticsData.company_name + "_" + _this5.analyticsData.name + "_" + moment().format("YYYYMMDD") + ".pdf");
	            });
	        }
	    }, {
	        key: "editData",
	        value: function editData(data) {
	            return moment(data).locale("en").format("DD MMM YYYY");
	        }
	    }, {
	        key: "openPicker",
	        value: function openPicker() {
	            this.showDatePicker = !this.showDatePicker;
	        }
	    }, {
	        key: "createXLS",
	        value: function createXLS() {
	            var _this6 = this;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Create new configuration",
	                controller: _downloadDialog.DownloadDialogController,
	                template: _downloadDialog3.default,
	                targetEvent: event,
	                locals: {
	                    callback: function callback(obj) {
	                        var dataRange = "";
	                        if (_this6.analyticsData && _this6.analyticsData.date_range) {
	                            dataRange = "?start_date=" + moment(_this6.analyticsData.date_range.start_date).utc().format("YYYY-MM-DD HH:mm:SS") + "&end_date=" + moment(_this6.analyticsData.date_range.end_date).utc().format("YYYY-MM-DD HH:mm:SS");
	                        }
	                        var conditionsQuery = "&photo=" + obj.captureModes.photo + "&gif=" + obj.captureModes.gif + "&boomerang=" + obj.captureModes.boomerang + "&dataPrivacyPopupAccepted=" + obj.conditions.dataPrivacyPopupAccepted + "&consentScreenConfirmed=" + obj.conditions.consentScreenConfirmed + "&dataFormWasSigned=" + obj.conditions.dataFormWasSigned;
	                        _this6.$auth.$http({
	                            url: "/api/analytics/" + _this6.id + "/download" + dataRange + conditionsQuery,
	                            method: "GET"
	                        }).then(function (resp) {
	                            var link = document.createElement("a");
	                            link.href = resp.data.file_url;
	                            link.click();
	                            link.remove();
	                        });
	                    }
	                }
	            });
	        }
	    }, {
	        key: "loadData",
	        value: function loadData(reload) {
	            var _this7 = this;
	
	            var dataRange = "";
	            if (reload && this.analyticsData && this.analyticsData.date_range) {
	                this.analyticsData.date_range.start_date = this.analyticsData.date_range.start_date || this.minDate;
	                this.analyticsData.date_range.end_date = this.analyticsData.date_range.end_date || this.maxDate;
	                this.loading = true;
	                dataRange = "?start_date=" + moment(this.analyticsData.date_range.start_date).utc().format("YYYY-MM-DD HH:mm:SS") + "&end_date=" + moment(this.analyticsData.date_range.end_date).utc().format("YYYY-MM-DD HH:mm:SS");
	            }
	            this.$auth.$http({
	                url: "/api/analytics/" + this.id + dataRange,
	                method: "GET"
	            }).then(function (resp) {
	                _this7.analyticsData = resp.data;
	                _this7.analyticsData.date_range.start_date = _this7.analyticsData.date_range.start_date ? moment(_this7.analyticsData.date_range.start_date)._d : null;
	                _this7.analyticsData.date_range.end_date = _this7.analyticsData.date_range.end_date ? moment(_this7.analyticsData.date_range.end_date)._d : null;
	                if (reload) {
	                    _this7.showDatePicker = false;
	                    _this7.loading = false;
	                } else {
	                    _this7.minDate = _this7.analyticsData.date_range.start_date;
	                    _this7.maxDate = _this7.analyticsData.date_range.end_date;
	                }
	                if (_this7.analyticsData.report_settings === null) {
	                    _this7.analyticsData.report_settings = {
	                        gif: true,
	                        email: true,
	                        opens: true,
	                        photo: true,
	                        views: true,
	                        clicks: true,
	                        emails: true,
	                        prints: true,
	                        unique: true,
	                        twitter: true,
	                        instagram: true,
	                        tiktok: true,
	                        facebook: true,
	                        mesenger: true,
	                        messages: true,
	                        sessions: true,
	                        boomerang: true,
	                        video: true,
	                        delivered: true,
	                        downloads: false,
	                        whats_app: true,
	                        live_gallery: true,
	                        photo_system: true,
	                        qr_code_scans: true,
	                        avg_visit_time: true,
	                        show_custom_kpis: false
	                    };
	                }
	                _this7.fillDataForCharts();
	            });
	        }
	    }]);
	    return AnalyticsDetailController;
	}(_index.$controller);
	
	exports.default = AnalyticsDetailController;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {!function(t){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):t()}(function(){"use strict";
	/** @license
	   * jsPDF - PDF Document creation from JavaScript
	   * Version 1.5.3 Built on 2018-12-27T14:11:42.696Z
	   *                      CommitID d93d28db14
	   *
	   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
	   *               2010 Aaron Spike, https://github.com/acspike
	   *               2012 Willow Systems Corporation, willow-systems.com
	   *               2012 Pablo Hess, https://github.com/pablohess
	   *               2012 Florian Jenett, https://github.com/fjenett
	   *               2013 Warren Weckesser, https://github.com/warrenweckesser
	   *               2013 Youssef Beddad, https://github.com/lifof
	   *               2013 Lee Driscoll, https://github.com/lsdriscoll
	   *               2013 Stefan Slonevskiy, https://github.com/stefslon
	   *               2013 Jeremy Morel, https://github.com/jmorel
	   *               2013 Christoph Hartmann, https://github.com/chris-rock
	   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	   *               2014 James Makes, https://github.com/dollaruw
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *               2014 Steven Spungin, https://github.com/Flamenco
	   *               2014 Kenneth Glassey, https://github.com/Gavvers
	   *
	   * Licensed under the MIT License
	   *
	   * Contributor(s):
	   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
	   *    kim3er, mfo, alnorth, Flamenco
	   */function se(t){return(se="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t){if("object"!==se(t.console)){t.console={};for(var e,n,r=t.console,i=function(){},o=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=o.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=i)}var s,l,h,u,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,o,a=0,s=0,l="",h=[];if(!t)return t;for(;e=(o=t.charCodeAt(a++)<<16|t.charCodeAt(a++)<<8|t.charCodeAt(a++))>>18&63,n=o>>12&63,r=o>>6&63,i=63&o,h[s++]=c.charAt(e)+c.charAt(n)+c.charAt(r)+c.charAt(i),a<t.length;);l=h.join("");var u=t.length%3;return(u?l.slice(0,u-3):l)+"===".slice(u||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,o,a,s=0,l=0,h=[];if(!t)return t;for(t+="";e=(a=c.indexOf(t.charAt(s++))<<18|c.indexOf(t.charAt(s++))<<12|(i=c.indexOf(t.charAt(s++)))<<6|(o=c.indexOf(t.charAt(s++))))>>16&255,n=a>>8&255,r=255&a,h[l++]=64==i?String.fromCharCode(e):64==o?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return h.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),n=e.length>>>0;if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var r=arguments[1],i=0;i<n;){var o=e[i];if(t.call(r,o,i,e))return o;i++}},configurable:!0,writable:!0}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,l=!{toString:null}.propertyIsEnumerable("toString"),u=(h=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!==se(t)&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(l)for(n=0;n<u;n++)s.call(t,h[n])&&r.push(h[n]);return r})),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")}),Number.isInteger=Number.isInteger||function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var t,e,n,_,l,F,P,p,d,k,a,o,s,h,u,c,r,i,f,g,m,y,v,w,b,x,I,C,B,N,L,A,S,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y,J,X,K,Z,Q,$,tt,et,nt,rt,it,ot,at,st,lt=function(ie){function oe(o){if("object"!==se(o))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var a={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");a.hasOwnProperty(t)||(a[t]={});var r=Math.random().toString(35);return a[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in a)if(a[e][t])return delete a[e][t],0===Object.keys(a[e]).length&&delete a[e],!0;return!1},this.publish=function(t){if(a.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in a[t]){var i=a[t][r];try{i[0].apply(o,e)}catch(t){ie.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}},this.getTopics=function(){return a}}function ae(t,e,i,n){var r={},o=[],a=1;"object"===se(t)&&(t=(r=t).orientation,e=r.unit||e,i=r.format||i,n=r.compress||r.compressPdf||n,o=r.filters||(!0===n?["FlateEncode"]:o),a="number"==typeof r.userUnit?Math.abs(r.userUnit):1),e=e||"mm",t=(""+(t||"P")).toLowerCase();var s=r.putOnlyUsedFonts||!0,K={},l={internal:{},__private__:{}};l.__private__.PubSub=oe;var h="1.3",u=l.__private__.getPdfVersion=function(){return h},c=(l.__private__.setPdfVersion=function(t){h=t},{a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]}),f=(l.__private__.getPageFormats=function(){return c},l.__private__.getPageFormat=function(t){return c[t]});"string"==typeof i&&(i=f(i)),i=i||f("a4");var p,Z=l.f2=l.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},Q=l.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return t.toFixed(3)},d="00000000000000000000000000000000",g=l.__private__.getFileId=function(){return d},m=l.__private__.setFileId=function(t){return t=t||"12345678901234567890123456789012".split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join(""),d=t};l.setFileId=function(t){return m(t),this},l.getFileId=function(){return g()};var y=l.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),n=e<0?"+":"-",r=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),o=[n,P(r),"'",P(i),"'"].join("");return["D:",t.getFullYear(),P(t.getMonth()+1),P(t.getDate()),P(t.getHours()),P(t.getMinutes()),P(t.getSeconds()),o].join("")},v=l.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),o=parseInt(t.substr(12,2),10),a=parseInt(t.substr(14,2),10);parseInt(t.substr(16,2),10),parseInt(t.substr(20,2),10);return new Date(e,n,r,i,o,a,0)},w=l.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),"object"===se(t)&&"[object Date]"===Object.prototype.toString.call(t))e=y(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return p=e},b=l.__private__.getCreationDate=function(t){var e=p;return"jsDate"===t&&(e=v(p)),e};l.setCreationDate=function(t){return w(t),this},l.getCreationDate=function(t){return b(t)};var x,N,L,A,S,$,_,F,P=l.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},k=!1,I=[],C=[],B=0,tt=(l.__private__.setCustomOutputDestination=function(t){N=t},l.__private__.resetCustomOutputDestination=function(t){N=void 0},l.__private__.out=function(t){var e;return t="string"==typeof t?t:t.toString(),(e=void 0===N?k?I[x]:C:N).push(t),k||(B+=t.length+1),e}),j=l.__private__.write=function(t){return tt(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},E=l.__private__.getArrayBuffer=function(t){for(var e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},M=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]],et=(l.__private__.getStandardFonts=function(t){return M},r.fontSize||16),O=(l.__private__.setFontSize=l.setFontSize=function(t){return et=t,this},l.__private__.getFontSize=l.getFontSize=function(){return et}),nt=r.R2L||!1,q=(l.__private__.setR2L=l.setR2L=function(t){return nt=t,this},l.__private__.getR2L=l.getR2L=function(t){return nt},l.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^\d*\.?\d*\%$/.test(t))L=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');L=t}else L=parseInt(t,10)}),T=(l.__private__.getZoomMode=function(){return L},l.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');A=t}),R=(l.__private__.getPageMode=function(){return A},l.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');S=t}),D=(l.__private__.getLayoutMode=function(){return S},l.__private__.setDisplayMode=l.setDisplayMode=function(t,e,n){return q(t),R(e),T(n),this},{title:"",subject:"",author:"",keywords:"",creator:""}),U=(l.__private__.getDocumentProperty=function(t){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return D[t]},l.__private__.getDocumentProperties=function(t){return D},l.__private__.setDocumentProperties=l.setProperties=l.setDocumentProperties=function(t){for(var e in D)D.hasOwnProperty(e)&&t[e]&&(D[e]=t[e]);return this},l.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return D[t]=e},0),z=[],rt={},H={},W=0,V=[],G=[],it=new oe(l),Y=r.hotfixes||[],J=l.__private__.newObject=function(){var t=X();return ot(t,!0),t},X=l.__private__.newObjectDeferred=function(){return z[++U]=function(){return B},U},ot=function(t,e){return e="boolean"==typeof e&&e,z[t]=B,e&&tt(t+" 0 obj"),t},at=l.__private__.newAdditionalObject=function(){var t={objId:X(),content:""};return G.push(t),t},st=X(),lt=X(),ht=l.__private__.decodeColorString=function(t){var e=t.split(" ");if(2===e.length&&("g"===e[1]||"G"===e[1])){var n=parseFloat(e[0]);e=[n,n,n,"r"]}for(var r="#",i=0;i<3;i++)r+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return r},ut=l.__private__.encodeColorString=function(t){var e;"string"==typeof t&&(t={ch1:t});var n=t.ch1,r=t.ch2,i=t.ch3,o=t.ch4,a=(t.precision,"draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"]);if("string"==typeof n&&"#"!==n.charAt(0)){var s=new RGBColor(n);if(s.ok)n=s.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var l=parseInt(n.substr(1),16);n=l>>16&255,r=l>>8&255,i=255&l}if(void 0===r||void 0===o&&n===r&&r===i)if("string"==typeof n)e=n+" "+a[0];else switch(t.precision){case 2:e=Z(n/255)+" "+a[0];break;case 3:default:e=Q(n/255)+" "+a[0]}else if(void 0===o||"object"===se(o)){if(o&&!isNaN(o.a)&&0===o.a)return e=["1.000","1.000","1.000",a[1]].join(" ");if("string"==typeof n)e=[n,r,i,a[1]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),a[1]].join(" ");break;default:case 3:e=[Q(n/255),Q(r/255),Q(i/255),a[1]].join(" ")}}else if("string"==typeof n)e=[n,r,i,o,a[2]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),Z(o/255),a[2]].join(" ");break;case 3:default:e=[Q(n/255),Q(r/255),Q(i/255),Q(o/255),a[2]].join(" ")}return e},ct=l.__private__.getFilters=function(){return o},ft=l.__private__.putStream=function(t){var e=(t=t||{}).data||"",n=t.filters||ct(),r=t.alreadyAppliedFilters||[],i=t.addLength1||!1,o=e.length,a={};!0===n&&(n=["FlateEncode"]);var s=t.additionalKeyValues||[],l=(a=void 0!==ae.API.processDataByFilters?ae.API.processDataByFilters(e,n):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(r)?r.join(" "):r.toString());0!==a.data.length&&(s.push({key:"Length",value:a.data.length}),!0===i&&s.push({key:"Length1",value:o})),0!=l.length&&(l.split("/").length-1==1?s.push({key:"Filter",value:l}):s.push({key:"Filter",value:"["+l+"]"})),tt("<<");for(var h=0;h<s.length;h++)tt("/"+s[h].key+" "+s[h].value);tt(">>"),0!==a.data.length&&(tt("stream"),tt(a.data),tt("endstream"))},pt=l.__private__.putPage=function(t){t.mediaBox;var e=t.number,n=t.data,r=t.objId,i=t.contentsObjId;ot(r,!0);V[x].mediaBox.topRightX,V[x].mediaBox.bottomLeftX,V[x].mediaBox.topRightY,V[x].mediaBox.bottomLeftY;tt("<</Type /Page"),tt("/Parent "+t.rootDictionaryObjId+" 0 R"),tt("/Resources "+t.resourceDictionaryObjId+" 0 R"),tt("/MediaBox ["+parseFloat(Z(t.mediaBox.bottomLeftX))+" "+parseFloat(Z(t.mediaBox.bottomLeftY))+" "+Z(t.mediaBox.topRightX)+" "+Z(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&tt("/CropBox ["+Z(t.cropBox.bottomLeftX)+" "+Z(t.cropBox.bottomLeftY)+" "+Z(t.cropBox.topRightX)+" "+Z(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&tt("/BleedBox ["+Z(t.bleedBox.bottomLeftX)+" "+Z(t.bleedBox.bottomLeftY)+" "+Z(t.bleedBox.topRightX)+" "+Z(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&tt("/TrimBox ["+Z(t.trimBox.bottomLeftX)+" "+Z(t.trimBox.bottomLeftY)+" "+Z(t.trimBox.topRightX)+" "+Z(t.trimBox.topRightY)+"]"),null!==t.artBox&&tt("/ArtBox ["+Z(t.artBox.bottomLeftX)+" "+Z(t.artBox.bottomLeftY)+" "+Z(t.artBox.topRightX)+" "+Z(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&tt("/UserUnit "+t.userUnit),it.publish("putPage",{objId:r,pageContext:V[e],pageNumber:e,page:n}),tt("/Contents "+i+" 0 R"),tt(">>"),tt("endobj");var o=n.join("\n");return ot(i,!0),ft({data:o,filters:ct()}),tt("endobj"),r},dt=l.__private__.putPages=function(){var t,e,n=[];for(t=1;t<=W;t++)V[t].objId=X(),V[t].contentsObjId=X();for(t=1;t<=W;t++)n.push(pt({number:t,data:I[t],objId:V[t].objId,contentsObjId:V[t].contentsObjId,mediaBox:V[t].mediaBox,cropBox:V[t].cropBox,bleedBox:V[t].bleedBox,trimBox:V[t].trimBox,artBox:V[t].artBox,userUnit:V[t].userUnit,rootDictionaryObjId:st,resourceDictionaryObjId:lt}));ot(st,!0),tt("<</Type /Pages");var r="/Kids [";for(e=0;e<W;e++)r+=n[e]+" 0 R ";tt(r+"]"),tt("/Count "+W),tt(">>"),tt("endobj"),it.publish("postPutPages")},gt=function(){!function(){for(var t in rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&(e=rt[t],it.publish("putFont",{font:e,out:tt,newObject:J,putStream:ft}),!0!==e.isAlreadyPutted&&(e.objectNumber=J(),tt("<<"),tt("/Type /Font"),tt("/BaseFont /"+e.postScriptName),tt("/Subtype /Type1"),"string"==typeof e.encoding&&tt("/Encoding /"+e.encoding),tt("/FirstChar 32"),tt("/LastChar 255"),tt(">>"),tt("endobj")));var e}(),it.publish("putResources"),ot(lt,!0),tt("<<"),function(){for(var t in tt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),tt("/Font <<"),rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&tt("/"+t+" "+rt[t].objectNumber+" 0 R");tt(">>"),tt("/XObject <<"),it.publish("putXobjectDict"),tt(">>")}(),tt(">>"),tt("endobj"),it.publish("postPutResources")},mt=function(t,e,n){H.hasOwnProperty(e)||(H[e]={}),H[e][n]=t},yt=function(t,e,n,r,i){i=i||!1;var o="F"+(Object.keys(rt).length+1).toString(10),a={id:o,postScriptName:t,fontName:e,fontStyle:n,encoding:r,isStandardFont:i,metadata:{}};return it.publish("addFont",{font:a,instance:this}),void 0!==o&&(rt[o]=a,mt(o,e,n)),o},vt=l.__private__.pdfEscape=l.pdfEscape=function(t,e){return function(t,e){var n,r,i,o,a,s,l,h,u;if(i=(e=e||{}).sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&rt[$].metadata&&rt[$].metadata[i]&&rt[$].metadata[i].encoding&&(o=rt[$].metadata[i].encoding,!a&&rt[$].encoding&&(a=rt[$].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(l=!1,s=[],n=0,r=t.length;n<r;n++)(h=a[t.charCodeAt(n)])?s.push(String.fromCharCode(h)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(l=!0);t=s.join("")}for(n=t.length;void 0===l&&0!==n;)t.charCodeAt(n-1)>>8&&(l=!0),n--;if(!l)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((u=(h=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(u),s.push(h-(u<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},wt=l.__private__.beginPage=function(t,e){var n,r="string"==typeof e&&e.toLowerCase();if("string"==typeof t&&(n=f(t.toLowerCase()))&&(t=n[0],e=n[1]),Array.isArray(t)&&(e=t[1],t=t[0]),(isNaN(t)||isNaN(e))&&(t=i[0],e=i[1]),r){switch(r.substr(0,1)){case"l":t<e&&(r="s");break;case"p":e<t&&(r="s")}"s"===r&&(n=t,t=e,e=n)}(14400<t||14400<e)&&(console.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),t=Math.min(14400,t),e=Math.min(14400,e)),i=[t,e],k=!0,I[++W]=[],V[W]={objId:0,contentsObjId:0,userUnit:Number(a),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t),topRightY:Number(e)}},xt(W)},bt=function(){wt.apply(this,arguments),Dt(Rt),tt(Jt),0!==te&&tt(te+" J"),0!==ne&&tt(ne+" j"),it.publish("addPage",{pageNumber:W})},xt=function(t){0<t&&t<=W&&(x=t)},Nt=l.__private__.getNumberOfPages=l.getNumberOfPages=function(){return I.length-1},Lt=function(t,e,n){var r,i=void 0;return n=n||{},t=void 0!==t?t:rt[$].fontName,e=void 0!==e?e:rt[$].fontStyle,r=t.toLowerCase(),void 0!==H[r]&&void 0!==H[r][e]?i=H[r][e]:void 0!==H[t]&&void 0!==H[t][e]?i=H[t][e]:!1===n.disableWarning&&console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||n.noFallback||null==(i=H.times[e])&&(i=H.times.normal),i},At=l.__private__.putInfo=function(){for(var t in J(),tt("<<"),tt("/Producer (jsPDF "+ae.version+")"),D)D.hasOwnProperty(t)&&D[t]&&tt("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+vt(D[t])+")");tt("/CreationDate ("+p+")"),tt(">>"),tt("endobj")},St=l.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||st;switch(J(),tt("<<"),tt("/Type /Catalog"),tt("/Pages "+e+" 0 R"),L||(L="fullwidth"),L){case"fullwidth":tt("/OpenAction [3 0 R /FitH null]");break;case"fullheight":tt("/OpenAction [3 0 R /FitV null]");break;case"fullpage":tt("/OpenAction [3 0 R /Fit]");break;case"original":tt("/OpenAction [3 0 R /XYZ null null 1]");break;default:var n=""+L;"%"===n.substr(n.length-1)&&(L=parseInt(L)/100),"number"==typeof L&&tt("/OpenAction [3 0 R /XYZ null null "+Z(L)+"]")}switch(S||(S="continuous"),S){case"continuous":tt("/PageLayout /OneColumn");break;case"single":tt("/PageLayout /SinglePage");break;case"two":case"twoleft":tt("/PageLayout /TwoColumnLeft");break;case"tworight":tt("/PageLayout /TwoColumnRight")}A&&tt("/PageMode /"+A),it.publish("putCatalog"),tt(">>"),tt("endobj")},_t=l.__private__.putTrailer=function(){tt("trailer"),tt("<<"),tt("/Size "+(U+1)),tt("/Root "+U+" 0 R"),tt("/Info "+(U-1)+" 0 R"),tt("/ID [ <"+d+"> <"+d+"> ]"),tt(">>")},Ft=l.__private__.putHeader=function(){tt("%PDF-"+h),tt("%ºß¬à")},Pt=l.__private__.putXRef=function(){var t=1,e="0000000000";for(tt("xref"),tt("0 "+(U+1)),tt("0000000000 65535 f "),t=1;t<=U;t++){"function"==typeof z[t]?tt((e+z[t]()).slice(-10)+" 00000 n "):void 0!==z[t]?tt((e+z[t]).slice(-10)+" 00000 n "):tt("0000000000 00000 n ")}},kt=l.__private__.buildDocument=function(){k=!1,B=U=0,C=[],z=[],G=[],st=X(),lt=X(),it.publish("buildDocument"),Ft(),dt(),function(){it.publish("putAdditionalObjects");for(var t=0;t<G.length;t++){var e=G[t];ot(e.objId,!0),tt(e.content),tt("endobj")}it.publish("postPutAdditionalObjects")}(),gt(),At(),St();var t=B;return Pt(),_t(),tt("startxref"),tt(""+t),tt("%%EOF"),k=!0,C.join("\n")},It=l.__private__.getBlob=function(t){return new Blob([E(t)],{type:"application/pdf"})},Ct=l.output=l.__private__.output=((F=function(t,e){e=e||{};var n=kt();switch("string"==typeof e?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return n;case"save":l.save(e.filename);break;case"arraybuffer":return E(n);case"blob":return It(n);case"bloburi":case"bloburl":if(void 0!==ie.URL&&"function"==typeof ie.URL.createObjectURL)return ie.URL&&ie.URL.createObjectURL(It(n))||void 0;console.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":return"data:application/pdf;filename="+e.filename+";base64,"+btoa(n);case"dataurlnewwindow":var r='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring")+'"></iframe></body></html>',i=ie.open();if(null!==i&&i.document.write(r),i||"undefined"==typeof safari)return i;case"datauri":case"dataurl":return ie.document.location.href="data:application/pdf;filename="+e.filename+";base64,"+btoa(n);default:return null}}).foo=function(){try{return F.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!ie.console)throw new Error(n);ie.console.error(n,t),ie.alert&&alert(n)}},(F.foo.bar=F).foo),Bt=function(t){return!0===Array.isArray(Y)&&-1<Y.indexOf(t)};switch(e){case"pt":_=1;break;case"mm":_=72/25.4;break;case"cm":_=72/2.54;break;case"in":_=72;break;case"px":_=1==Bt("px_scaling")?.75:96/72;break;case"pc":case"em":_=12;break;case"ex":_=6;break;default:throw new Error("Invalid unit: "+e)}w(),m();var jt=l.__private__.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:V[t].objId,pageNumber:t,pageContext:V[t]}},Et=l.__private__.getPageInfoByObjId=function(t){for(var e in V)if(V[e].objId===t)break;if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");return jt(e)},Mt=l.__private__.getCurrentPageInfo=function(){return{objId:V[x].objId,pageNumber:x,pageContext:V[x]}};l.addPage=function(){return bt.apply(this,arguments),this},l.setPage=function(){return xt.apply(this,arguments),this},l.insertPage=function(t){return this.addPage(),this.movePage(x,t),this},l.movePage=function(t,e){if(e<t){for(var n=I[t],r=V[t],i=t;e<i;i--)I[i]=I[i-1],V[i]=V[i-1];I[e]=n,V[e]=r,this.setPage(e)}else if(t<e){for(n=I[t],r=V[t],i=t;i<e;i++)I[i]=I[i+1],V[i]=V[i+1];I[e]=n,V[e]=r,this.setPage(e)}return this},l.deletePage=function(){return function(t){0<t&&t<=W&&(I.splice(t,1),--W<x&&(x=W),this.setPage(x))}.apply(this,arguments),this};l.__private__.text=l.text=function(t,e,n,i){var r;"number"!=typeof t||"number"!=typeof e||"string"!=typeof n&&!Array.isArray(n)||(r=n,n=e,e=t,t=r);var o=arguments[3],a=arguments[4],s=arguments[5];if("object"===se(o)&&null!==o||("string"==typeof a&&(s=a,a=null),"string"==typeof o&&(s=o,o=null),"number"==typeof o&&(a=o,o=null),i={flags:o,angle:a,align:s}),(o=o||{}).noBOM=o.noBOM||!0,o.autoencode=o.autoencode||!0,isNaN(e)||isNaN(n)||null==t)throw new Error("Invalid arguments passed to jsPDF.text");if(0===t.length)return c;var l,h="",u="number"==typeof i.lineHeightFactor?i.lineHeightFactor:Tt,c=i.scope||this;function f(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):Array.isArray(t)&&1===e.length?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function p(t,e){var n;if("string"==typeof t)n=e(t)[0];else if(Array.isArray(t)){for(var r,i,o=t.concat(),a=[],s=o.length;s--;)"string"==typeof(r=o.shift())?a.push(e(r)[0]):Array.isArray(r)&&"string"===r[0]&&(i=e(r[0],r[1],r[2]),a.push([i[0],i[1],i[2]]));n=a}return n}var d=!1,g=!0;if("string"==typeof t)d=!0;else if(Array.isArray(t)){for(var m,y=t.concat(),v=[],w=y.length;w--;)("string"!=typeof(m=y.shift())||Array.isArray(m)&&"string"!=typeof m[0])&&(g=!1);d=g}if(!1===d)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');var b=rt[$].encoding;"WinAnsiEncoding"!==b&&"StandardEncoding"!==b||(t=p(t,function(t,e,n){return[(r=t,r=r.split("\t").join(Array(i.TabLen||9).join(" ")),vt(r,o)),e,n];var r})),"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]);var x=et/c.internal.scaleFactor,N=x*(Tt-1);switch(i.baseline){case"bottom":n-=N;break;case"top":n+=x-N;break;case"hanging":n+=x-2*N;break;case"middle":n+=x/2-N}0<(O=i.maxWidth||0)&&("string"==typeof t?t=c.splitTextToSize(t,O):"[object Array]"===Object.prototype.toString.call(t)&&(t=c.splitTextToSize(t.join(" "),O)));var L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("preProcessText",L),t=L.text;a=(i=L.options).angle;var A=c.internal.scaleFactor,S=[];if(a){a*=Math.PI/180;var _=Math.cos(a),F=Math.sin(a);S=[Z(_),Z(F),Z(-1*F),Z(_)]}void 0!==(M=i.charSpace)&&(h+=Q(M*A)+" Tc\n");i.lang;var P=-1,k=void 0!==i.renderingMode?i.renderingMode:i.stroke,I=c.internal.getCurrentPageInfo().pageContext;switch(k){case 0:case!1:case"fill":P=0;break;case 1:case!0:case"stroke":P=1;break;case 2:case"fillThenStroke":P=2;break;case 3:case"invisible":P=3;break;case 4:case"fillAndAddForClipping":P=4;break;case 5:case"strokeAndAddPathForClipping":P=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":P=6;break;case 7:case"addToPathForClipping":P=7}var C=void 0!==I.usedRenderingMode?I.usedRenderingMode:-1;-1!==P?h+=P+" Tr\n":-1!==C&&(h+="0 Tr\n"),-1!==P&&(I.usedRenderingMode=P);s=i.align||"left";var B=et*u,j=c.internal.pageSize.getWidth(),E=(A=c.internal.scaleFactor,rt[$]),M=i.charSpace||Qt,O=i.maxWidth||0,q=(o={},[]);if("[object Array]"===Object.prototype.toString.call(t)){var T,R;v=f(t);"left"!==s&&(R=v.map(function(t){return c.getStringUnitWidth(t,{font:E,charSpace:M,fontSize:et})*et/A}));var D,U=Math.max.apply(Math,R),z=0;if("right"===s){e-=R[0],t=[];var H=0;for(w=v.length;H<w;H++)U-R[H],T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])*A,-B),t.push([v[H],D,T]),z=R[H]}else if("center"===s){e-=R[0]/2,t=[];for(H=0,w=v.length;H<w;H++)(U-R[H])/2,T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])/2*A,-B),t.push([v[H],D,T]),z=R[H]}else if("left"===s){t=[];for(H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,t.push(v[H])}else{if("justify"!==s)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[];for(O=0!==O?O:j,H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,H<w-1&&q.push(((O-R[H])/(v[H].split(" ").length-1)*A).toFixed(2)),t.push([v[H],D,T])}}!0===("boolean"==typeof i.R2L?i.R2L:nt)&&(t=p(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]}));L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("postProcessText",L),t=L.text,l=L.mutex.isHex;v=f(t);t=[];var W,V,G,Y=0,J=(w=v.length,"");for(H=0;H<w;H++)J="",Array.isArray(v[H])?(W=parseFloat(v[H][1]),V=parseFloat(v[H][2]),G=(l?"<":"(")+v[H][0]+(l?">":")"),Y=1):(W=Wt(e),V=Vt(n),G=(l?"<":"(")+v[H]+(l?">":")")),void 0!==q&&void 0!==q[H]&&(J=q[H]+" Tw\n"),0!==S.length&&0===H?t.push(J+S.join(" ")+" "+W.toFixed(2)+" "+V.toFixed(2)+" Tm\n"+G):1===Y||0===Y&&0===H?t.push(J+W.toFixed(2)+" "+V.toFixed(2)+" Td\n"+G):t.push(J+G);t=0===Y?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var X="BT\n/"+$+" "+et+" Tf\n"+(et*u).toFixed(2)+" TL\n"+Kt+"\n";return X+=h,X+=t,tt(X+="ET"),K[$]=!0,c},l.__private__.lstext=l.lstext=function(t,e,n,r){return console.warn("jsPDF.lstext is deprecated"),this.text(t,e,n,{charSpace:r})},l.__private__.clip=l.clip=function(t){tt("evenodd"===t?"W*":"W"),tt("n")},l.__private__.clip_fixed=l.clip_fixed=function(t){console.log("clip_fixed is deprecated"),l.clip(t)};var Ot=l.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","F","DF","FD","f","f*","B","B*"].indexOf(t)&&(e=!0),e},qt=l.__private__.getStyle=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e};l.__private__.line=l.line=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw new Error("Invalid arguments passed to jsPDF.line");return this.lines([[n-t,r-e]],t,e)},l.__private__.lines=l.lines=function(t,e,n,r,i,o){var a,s,l,h,u,c,f,p,d,g,m,y;if("number"==typeof t&&(y=n,n=e,e=t,t=y),r=r||[1,1],o=o||!1,isNaN(e)||isNaN(n)||!Array.isArray(t)||!Array.isArray(r)||!Ot(i)||"boolean"!=typeof o)throw new Error("Invalid arguments passed to jsPDF.lines");for(tt(Q(Wt(e))+" "+Q(Vt(n))+" m "),a=r[0],s=r[1],h=t.length,g=e,m=n,l=0;l<h;l++)2===(u=t[l]).length?(g=u[0]*a+g,m=u[1]*s+m,tt(Q(Wt(g))+" "+Q(Vt(m))+" l")):(c=u[0]*a+g,f=u[1]*s+m,p=u[2]*a+g,d=u[3]*s+m,g=u[4]*a+g,m=u[5]*s+m,tt(Q(Wt(c))+" "+Q(Vt(f))+" "+Q(Wt(p))+" "+Q(Vt(d))+" "+Q(Wt(g))+" "+Q(Vt(m))+" c"));return o&&tt(" h"),null!==i&&tt(qt(i)),this},l.__private__.rect=l.rect=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.rect");return tt([Z(Wt(t)),Z(Vt(e)),Z(n*_),Z(-r*_),"re"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.triangle=l.triangle=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},l.__private__.roundedRect=l.roundedRect=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},l.__private__.ellipse=l.ellipse=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return tt([Z(Wt(t+n)),Z(Vt(e)),"m",Z(Wt(t+n)),Z(Vt(e-a)),Z(Wt(t+o)),Z(Vt(e-r)),Z(Wt(t)),Z(Vt(e-r)),"c"].join(" ")),tt([Z(Wt(t-o)),Z(Vt(e-r)),Z(Wt(t-n)),Z(Vt(e-a)),Z(Wt(t-n)),Z(Vt(e)),"c"].join(" ")),tt([Z(Wt(t-n)),Z(Vt(e+a)),Z(Wt(t-o)),Z(Vt(e+r)),Z(Wt(t)),Z(Vt(e+r)),"c"].join(" ")),tt([Z(Wt(t+o)),Z(Vt(e+r)),Z(Wt(t+n)),Z(Vt(e+a)),Z(Wt(t+n)),Z(Vt(e)),"c"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.circle=l.circle=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||!Ot(r))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,n,n,r)};l.setFont=function(t,e){return $=Lt(t,e,{disableWarning:!1}),this},l.setFontStyle=l.setFontType=function(t){return $=Lt(void 0,t),this};l.__private__.getFontList=l.getFontList=function(){var t,e,n,r={};for(t in H)if(H.hasOwnProperty(t))for(e in r[t]=n=[],H[t])H[t].hasOwnProperty(e)&&n.push(e);return r};l.addFont=function(t,e,n,r){yt.call(this,t,e,n,r=r||"Identity-H")};var Tt,Rt=r.lineWidth||.200025,Dt=l.__private__.setLineWidth=l.setLineWidth=function(t){return tt((t*_).toFixed(2)+" w"),this},Ut=(l.__private__.setLineDash=ae.API.setLineDash=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map(function(t){return(t*_).toFixed(3)}).join(" "),e=parseFloat((e*_).toFixed(3)),tt("["+t+"] "+e+" d"),this},l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt}),zt=(Ut=l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt},l.__private__.setLineHeightFactor=l.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(Tt=t),this}),Ht=l.__private__.getLineHeightFactor=l.getLineHeightFactor=function(){return Tt};zt(r.lineHeight);var Wt=l.__private__.getHorizontalCoordinate=function(t){return t*_},Vt=l.__private__.getVerticalCoordinate=function(t){return V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_},Gt=l.__private__.getHorizontalCoordinateString=function(t){return Z(t*_)},Yt=l.__private__.getVerticalCoordinateString=function(t){return Z(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_)},Jt=r.strokeColor||"0 G",Xt=(l.__private__.getStrokeColor=l.getDrawColor=function(){return ht(Jt)},l.__private__.setStrokeColor=l.setDrawColor=function(t,e,n,r){return Jt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2}),tt(Jt),this},r.fillColor||"0 g"),Kt=(l.__private__.getFillColor=l.getFillColor=function(){return ht(Xt)},l.__private__.setFillColor=l.setFillColor=function(t,e,n,r){return Xt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2}),tt(Xt),this},r.textColor||"0 g"),Zt=l.__private__.getTextColor=l.getTextColor=function(){return ht(Kt)},Qt=(l.__private__.setTextColor=l.setTextColor=function(t,e,n,r){return Kt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this},r.charSpace||0),$t=l.__private__.getCharSpace=l.getCharSpace=function(){return Qt},te=(l.__private__.setCharSpace=l.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return Qt=t,this},0);l.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2};l.__private__.setLineCap=l.setLineCap=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((te=e)+" J"),this};var ee,ne=0;l.__private__.setLineJoin=l.setLineJoin=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((ne=e)+" j"),this},l.__private__.setMiterLimit=l.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setMiterLimit");return ee=parseFloat(Z(t*_)),tt(ee+" M"),this};for(var re in l.save=function(r,t){if(r=r||"generated.pdf",(t=t||{}).returnPromise=t.returnPromise||!1,!1!==t.returnPromise)return new Promise(function(t,e){try{var n=le(It(kt()),r);"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911),t(n)}catch(t){e(t.message)}});le(It(kt()),r),"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911)},ae.API)ae.API.hasOwnProperty(re)&&("events"===re&&ae.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(it,ae.API.events):l[re]=ae.API[re]);return l.internal={pdfEscape:vt,getStyle:qt,getFont:function(){return rt[Lt.apply(l,arguments)]},getFontSize:O,getCharSpace:$t,getTextColor:Zt,getLineHeight:Ut,getLineHeightFactor:Ht,write:j,getHorizontalCoordinate:Wt,getVerticalCoordinate:Vt,getCoordinateString:Gt,getVerticalCoordinateString:Yt,collections:{},newObject:J,newAdditionalObject:at,newObjectDeferred:X,newObjectDeferredBegin:ot,getFilters:ct,putStream:ft,events:it,scaleFactor:_,pageSize:{getWidth:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},setWidth:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},getHeight:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},setHeight:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY}},output:Ct,getNumberOfPages:Nt,pages:I,out:tt,f2:Z,f3:Q,getPageInfo:jt,getPageInfoByObjId:Et,getCurrentPageInfo:Mt,getPDFVersion:u,hasHotfix:Bt},Object.defineProperty(l.internal.pageSize,"width",{get:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},set:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},enumerable:!0,configurable:!0}),Object.defineProperty(l.internal.pageSize,"height",{get:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},set:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY},enumerable:!0,configurable:!0}),function(t){for(var e=0,n=M.length;e<n;e++){var r=yt(t[e][0],t[e][1],t[e][2],M[e][3],!0);K[r]=!0;var i=t[e][0].split("-");mt(r,i[0],i[1]||"")}it.publish("addFonts",{fonts:rt,dictionary:H})}(M),$="F1",bt(i,t),it.publish("initialized"),l}return ae.API={events:[]},ae.version="1.5.3", true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return ae}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?(module.exports=ae,module.exports.jsPDF=ae):ie.jsPDF=ae,ae}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
	/**
	   * @license
	   * Copyright (c) 2016 Alexander Weidt,
	   * https://github.com/BiggA94
	   * 
	   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
	   */
	(function(t,e){var A,n=1,S=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},y=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},_=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},s=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(5)};t.__acroform__={};var r=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},v=function(t){return t*n},w=function(t){return t/n},l=function(t){var e=new j,n=Y.internal.getHeight(t)||0,r=Y.internal.getWidth(t)||0;return e.BBox=[0,0,Number(_(r)),Number(_(n))],e},i=t.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},o=t.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},a=t.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},b=t.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return a(t,e-1)},x=t.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return i(t,e-1)},N=t.__acroform__.clearBitForPdf=function(t,e,n){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return o(t,e-1)},c=t.__acroform__.calculateCoordinates=function(t){var e=this.internal.getHorizontalCoordinate,n=this.internal.getVerticalCoordinate,r=t[0],i=t[1],o=t[2],a=t[3],s={};return s.lowerLeft_X=e(r)||0,s.lowerLeft_Y=n(i+a)||0,s.upperRight_X=e(r+o)||0,s.upperRight_Y=n(i)||0,[Number(_(s.lowerLeft_X)),Number(_(s.lowerLeft_Y)),Number(_(s.upperRight_X)),Number(_(s.upperRight_Y))]},f=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=h(t,n),i=A.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(A.__private__.encodeColorString(t.color)),e.push("/"+i+" "+_(r.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var o=new l(t);return o.stream=e.join("\n"),o}},h=function(i,t){var e=i.maxFontSize||12,n=(i.fontName,{text:"",fontSize:""}),o=(t=")"==(t="("==t.substr(0,1)?t.substr(1):t).substr(t.length-1)?t.substr(0,t.length-1):t).split(" "),r=(A.__private__.encodeColorString(i.color),e),a=Y.internal.getHeight(i)||0;a=a<0?-a:a;var s=Y.internal.getWidth(i)||0;s=s<0?-s:s;var l=function(t,e,n){if(t+1<o.length){var r=e+" "+o[t+1];return F(r,i,n).width<=s-4}return!1};r++;t:for(;;){t="";var h=F("3",i,--r).height,u=i.multiline?a-r:(a-h)/2,c=-2,f=u+=2,p=0,d=0,g=0;if(r<=0){t="(...) Tj\n",t+="% Width of Text: "+F(t,i,r=12).width+", FieldWidth:"+s+"\n";break}g=F(o[0]+" ",i,r).width;var m="",y=0;for(var v in o)if(o.hasOwnProperty(v)){m=" "==(m+=o[v]+" ").substr(m.length-1)?m.substr(0,m.length-1):m;var w=parseInt(v);g=F(m+" ",i,r).width;var b=l(w,m,r),x=v>=o.length-1;if(b&&!x){m+=" ";continue}if(b||x){if(x)d=w;else if(i.multiline&&a<(h+2)*(y+2)+2)continue t}else{if(!i.multiline)continue t;if(a<(h+2)*(y+2)+2)continue t;d=w}for(var N="",L=p;L<=d;L++)N+=o[L]+" ";switch(N=" "==N.substr(N.length-1)?N.substr(0,N.length-1):N,g=F(N,i,r).width,i.textAlign){case"right":c=s-g-2;break;case"center":c=(s-g)/2;break;case"left":default:c=2}t+=_(c)+" "+_(f)+" Td\n",t+="("+S(N)+") Tj\n",t+=-_(c)+" 0 Td\n",f=-(r+2),g=0,p=d+1,y++,m=""}else;break}return n.text=t,n.fontSize=r,n},F=function(t,e,n){var r=A.internal.getFont(e.fontName,e.fontStyle),i=A.getStringUnitWidth(t,{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n);return{height:A.getStringUnitWidth("3",{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n)*1.5,width:i}},u={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},p=function(){A.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var t=A.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var e in t)if(t.hasOwnProperty(e)){var n=t[e];n.objId=void 0,n.hasAnnotation&&d.call(A,n)}},d=function(t){var e={type:"reference",object:t};void 0===A.internal.getPageInfo(t.page).pageContext.annotations.find(function(t){return t.type===e.type&&t.object===e.object})&&A.internal.getPageInfo(t.page).pageContext.annotations.push(e)},g=function(){if(void 0===A.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");A.internal.write("/AcroForm "+A.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")},m=function(){A.internal.events.unsubscribe(A.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete A.internal.acroformPlugin.acroFormDictionaryRoot._eventID,A.internal.acroformPlugin.printedOut=!0},L=function(t){var e=!t;t||(A.internal.newObjectDeferredBegin(A.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),A.internal.acroformPlugin.acroFormDictionaryRoot.putStream());t=t||A.internal.acroformPlugin.acroFormDictionaryRoot.Kids;for(var n in t)if(t.hasOwnProperty(n)){var r=t[n],i=[],o=r.Rect;if(r.Rect&&(r.Rect=c.call(this,r.Rect)),A.internal.newObjectDeferredBegin(r.objId,!0),r.DA=Y.createDefaultAppearanceStream(r),"object"===se(r)&&"function"==typeof r.getKeyValueListForStream&&(i=r.getKeyValueListForStream()),r.Rect=o,r.hasAppearanceStream&&!r.appearanceStreamContent){var a=f.call(this,r);i.push({key:"AP",value:"<</N "+a+">>"}),A.internal.acroformPlugin.xForms.push(a)}if(r.appearanceStreamContent){var s="";for(var l in r.appearanceStreamContent)if(r.appearanceStreamContent.hasOwnProperty(l)){var h=r.appearanceStreamContent[l];if(s+="/"+l+" ",s+="<<",1<=Object.keys(h).length||Array.isArray(h))for(var n in h){var u;if(h.hasOwnProperty(n))"function"==typeof(u=h[n])&&(u=u.call(this,r)),s+="/"+n+" "+u+" ",0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u)}else"function"==typeof(u=h)&&(u=u.call(this,r)),s+="/"+n+" "+u,0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u);s+=">>"}i.push({key:"AP",value:"<<\n"+s+">>"})}A.internal.putStream({additionalKeyValues:i}),A.internal.out("endobj")}e&&P.call(this,A.internal.acroformPlugin.xForms)},P=function(t){for(var e in t)if(t.hasOwnProperty(e)){var n=e,r=t[e];A.internal.newObjectDeferredBegin(r&&r.objId,!0),"object"===se(r)&&"function"==typeof r.putStream&&r.putStream(),delete t[n]}},k=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(A=this,M.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(u)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");n=A.internal.scaleFactor,A.internal.acroformPlugin.acroFormDictionaryRoot=new E,A.internal.acroformPlugin.acroFormDictionaryRoot._eventID=A.internal.events.subscribe("postPutResources",m),A.internal.events.subscribe("buildDocument",p),A.internal.events.subscribe("putCatalog",g),A.internal.events.subscribe("postPutPages",L),A.internal.acroformPlugin.isInitialized=!0}},I=t.__acroform__.arrayToPdfArray=function(t){if(Array.isArray(t)){for(var e="[",n=0;n<t.length;n++)switch(0!==n&&(e+=" "),se(t[n])){case"boolean":case"number":case"object":e+=t[n].toString();break;case"string":"/"!==t[n].substr(0,1)?e+="("+S(t[n].toString())+")":e+=t[n].toString()}return e+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var C=function(t){return(t=t||"").toString(),t="("+S(t)+")"},B=function(){var e;Object.defineProperty(this,"objId",{configurable:!0,get:function(){if(e||(e=A.internal.newObjectDeferred()),!e)throw new Error("AcroFormPDFObject: Couldn't create Object ID");return e},set:function(t){e=t}})};B.prototype.toString=function(){return this.objId+" 0 R"},B.prototype.putStream=function(){var t=this.getKeyValueListForStream();A.internal.putStream({data:this.stream,additionalKeyValues:t}),A.internal.out("endobj")},B.prototype.getKeyValueListForStream=function(){return function(t){var e=[],n=Object.getOwnPropertyNames(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n)if(!1===Object.getOwnPropertyDescriptor(t,n[r]).configurable){var i=n[r],o=t[i];o&&(Array.isArray(o)?e.push({key:i,value:I(o)}):o instanceof B?e.push({key:i,value:o.objId+" 0 R"}):"function"!=typeof o&&e.push({key:i,value:o}))}return e}(this)};var j=function(){B.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writeable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writeable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writeable:!0});var e,n=[];Object.defineProperty(this,"BBox",{configurable:!1,writeable:!0,get:function(){return n},set:function(t){n=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writeable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(t){e=t.trim()},get:function(){return e||null}})};r(j,B);var E=function(){B.call(this);var e,t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return t}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(e)return"("+e+")"},set:function(t){e=t}})};r(E,B);var M=function t(){B.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(e,3))},set:function(t){!0===Boolean(t)?this.F=x(e,3):this.F=N(e,3)}});var n=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');n=t}});var r=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==r.length)return r},set:function(t){r=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[0])?0:w(r[0])},set:function(t){r[0]=v(t)}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[1])?0:w(r[1])},set:function(t){r[1]=v(t)}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[2])?0:w(r[2])},set:function(t){r[2]=v(t)}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[3])?0:w(r[3])},set:function(t){r[3]=v(t)}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var o=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!o||o.length<1){if(this instanceof H)return;o="FieldObject"+t.FieldNum++}return"("+S(o)+")"},set:function(t){o=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return o},set:function(t){o=t}});var a="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return a},set:function(t){a=t}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var l=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return w(l)},set:function(t){l=v(t)}});var h=50;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return w(h)},set:function(t){h=v(t)}});var u="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return u},set:function(t){u=t}});var c="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!c||this instanceof H||this instanceof V))return C(c)},set:function(t){t=t.toString(),c=t}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof D==!1?C(f):f},set:function(t){t=t.toString(),f=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof D==!0?"/"+t:t}});var p=null;Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(p)return this instanceof D==!1?C(p):p},set:function(t){t=t.toString(),p=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(p.substr(1,p.length-1)):p},set:function(t){t=t.toString(),p=this instanceof D==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var d,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,writeable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,writeable:!0,get:function(){if(d)return d},set:function(t){d=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,1):this.Ff=N(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,2):this.Ff=N(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,3):this.Ff=N(this.Ff,3)}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t="left";switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0}}})};r(M,B);var O=function(){M.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var e=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){e=t}});var r=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return I(r)},set:function(t){var e,n;n=[],"string"==typeof(e=t)&&(n=function(t,e,n){n||(n=1);for(var r,i=[];r=e.exec(t);)i.push(r[n]);return i}(e,/\((.*?)\)/g)),r=n}}),this.getOptions=function(){return r},this.setOptions=function(t){r=t,this.sort&&r.sort()},this.addOption=function(t){t=(t=t||"").toString(),r.push(t),this.sort&&r.sort()},this.removeOption=function(t,e){for(e=e||!1,t=(t=t||"").toString();-1!==r.indexOf(t)&&(r.splice(r.indexOf(t),1),!1!==e););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,18):this.Ff=N(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=x(this.Ff,19):this.Ff=N(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=x(this.Ff,20),r.sort()):this.Ff=N(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,22):this.Ff=N(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,27):this.Ff=N(this.Ff,27)}}),this.hasAppearanceStream=!1};r(O,M);var q=function(){O.call(this),this.fontName="helvetica",this.combo=!1};r(q,O);var T=function(){q.call(this),this.combo=!0};r(T,q);var R=function(){T.call(this),this.edit=!0};r(R,T);var D=function(){M.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,15):this.Ff=N(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,16):this.Ff=N(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,17):this.Ff=N(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e,n={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){if(0!==Object.keys(n).length){var t,e=[];for(t in e.push("<<"),n)e.push("/"+t+" ("+n[t]+")");return e.push(">>"),e.join("\n")}},set:function(t){"object"===se(t)&&(n=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return n.CA||""},set:function(t){"string"==typeof t&&(n.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t}})};r(D,M);var U=function(){D.call(this),this.pushButton=!0};r(U,D);var z=function(){D.call(this),this.radio=!0,this.pushButton=!1;var e=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=void 0!==t?t:[]}})};r(z,D);var H=function(){var e,n;M.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return n},set:function(t){n=t}});var r,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t,e=[];for(t in e.push("<<"),i)e.push("/"+t+" ("+i[t]+")");return e.push(">>"),e.join("\n")},set:function(t){"object"===se(t)&&(i=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){r=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return r.substr(1,r.length-1)},set:function(t){r="/"+t}}),this.optionName=name,this.caption="l",this.appearanceState="Off",this._AppearanceType=Y.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(name)};r(H,M),z.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t&&"getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var n=this.Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n.optionName),n.caption=t.getCA()}},z.prototype.createOption=function(t){this.Kids.length;var e=new H;return e.Parent=this,e.optionName=t,this.Kids.push(e),J.call(this,e),e};var W=function(){D.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=Y.CheckBox.createAppearanceStream()};r(W,D);var V=function(){M.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,13):this.Ff=N(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,21):this.Ff=N(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,24):this.Ff=N(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,25):this.Ff=N(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){Number.isInteger(t)&&(e=t)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};r(V,M);var G=function(){V.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,14):this.Ff=N(this.Ff,14)}}),this.password=!0};r(G,V);var Y={CheckBox:{createAppearanceStream:function(){return{N:{On:Y.CheckBox.YesNormal},D:{On:Y.CheckBox.YesPushDown,Off:Y.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=l(t),n=[],r=A.internal.getFont(t.fontName,t.fontStyle).id,i=A.__private__.encodeColorString(t.color),o=h(t,t.caption);return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+_(o.fontSize)+" Tf "+i),n.push("BT"),n.push(o.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=l(t),n=A.internal.getFont(t.fontName,t.fontStyle).id,r=A.__private__.encodeColorString(t.color),i=[],o=Y.internal.getHeight(t),a=Y.internal.getWidth(t),s=h(t,t.caption);return i.push("1 g"),i.push("0 0 "+_(a)+" "+_(o)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+_(a-1)+" "+_(o-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+n+" "+_(s.fontSize)+" Tf "+r),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Circle.YesNormal,e.D[t]=Y.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4;r=Number((.9*r).toFixed(5));var i=Y.internal.Bezier_C,o=Number((r*i).toFixed(5));return n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+o+" "+o+" "+r+" 0 "+r+" c"),n.push("-"+o+" "+r+" -"+r+" "+o+" -"+r+" 0 c"),n.push("-"+r+" -"+o+" -"+o+" -"+r+" 0 -"+r+" c"),n.push(o+" -"+r+" "+r+" -"+o+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5)),a=Number((r*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Cross.YesNormal,e.D[t]=Y.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(_(r.x1.x)+" "+_(r.x1.y)+" m"),n.push(_(r.x2.x)+" "+_(r.x2.y)+" l"),n.push(_(r.x4.x)+" "+_(r.x4.y)+" m"),n.push(_(r.x3.x)+" "+_(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=Y.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),r.push("f"),r.push("q"),r.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(_(n.x1.x)+" "+_(n.x1.y)+" m"),r.push(_(n.x2.x)+" "+_(n.x2.y)+" l"),r.push(_(n.x4.x)+" "+_(n.x4.y)+" m"),r.push(_(n.x3.x)+" "+_(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=A.internal.getFont(t.fontName,t.fontStyle).id,n=A.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+n}};Y.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=Y.internal.getWidth(t),n=Y.internal.getHeight(t),r=Math.min(e,n);return{x1:{x:(e-r)/2,y:(n-r)/2+r},x2:{x:(e-r)/2+r,y:(n-r)/2},x3:{x:(e-r)/2,y:(n-r)/2},x4:{x:(e-r)/2+r,y:(n-r)/2+r}}}},Y.internal.getWidth=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[2])),e},Y.internal.getHeight=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[3])),e};var J=t.addField=function(t){if(k.call(this),!(t instanceof M))throw new Error("Invalid argument passed to jsPDF.addField.");return function(t){A.internal.acroformPlugin.printedOut&&(A.internal.acroformPlugin.printedOut=!1,A.internal.acroformPlugin.acroFormDictionaryRoot=null),A.internal.acroformPlugin.acroFormDictionaryRoot||k.call(A),A.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)}.call(this,t),t.page=A.internal.getCurrentPageInfo().pageNumber,this};t.addButton=function(t){if(t instanceof D==!1)throw new Error("Invalid argument passed to jsPDF.addButton.");return J.call(this,t)},t.addTextField=function(t){if(t instanceof V==!1)throw new Error("Invalid argument passed to jsPDF.addTextField.");return J.call(this,t)},t.addChoiceField=function(t){if(t instanceof O==!1)throw new Error("Invalid argument passed to jsPDF.addChoiceField.");return J.call(this,t)};"object"==se(e)&&void 0===e.ChoiceField&&void 0===e.ListBox&&void 0===e.ComboBox&&void 0===e.EditBox&&void 0===e.Button&&void 0===e.PushButton&&void 0===e.RadioButton&&void 0===e.CheckBox&&void 0===e.TextField&&void 0===e.PasswordField?(e.ChoiceField=O,e.ListBox=q,e.ComboBox=T,e.EditBox=R,e.Button=D,e.PushButton=U,e.RadioButton=z,e.CheckBox=W,e.TextField=V,e.PasswordField=G,e.AcroForm={Appearance:Y}):console.warn("AcroForm-Classes are not populated into global-namespace, because the class-Names exist already."),t.AcroFormChoiceField=O,t.AcroFormListBox=q,t.AcroFormComboBox=T,t.AcroFormEditBox=R,t.AcroFormButton=D,t.AcroFormPushButton=U,t.AcroFormRadioButton=z,t.AcroFormCheckBox=W,t.AcroFormTextField=V,t.AcroFormPasswordField=G,t.AcroFormAppearance=Y,t.AcroForm={ChoiceField:O,ListBox:q,ComboBox:T,EditBox:R,Button:D,PushButton:U,RadioButton:z,CheckBox:W,TextField:V,PasswordField:G,Appearance:Y}})((window.tmp=lt).API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),
	/** @license
	   * jsPDF addImage plugin
	   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
	   *               2013 Chris Dowling, https://github.com/gingerchris
	   *               2013 Trinh Ho, https://github.com/ineedfat
	   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
	   *               2013 Norah Smith, https://github.com/burnburnrocket
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *               2014 James Robb, https://github.com/jamesbrobb
	   *
	   * 
	   */
	function(x){var N="addImage_",l={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},h=x.getImageFileTypeByImageData=function(t,e){var n,r;e=e||"UNKNOWN";var i,o,a,s="UNKNOWN";for(a in x.isArrayBufferView(t)&&(t=x.arrayBufferToBinaryString(t)),l)for(i=l[a],n=0;n<i.length;n+=1){for(o=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t.charCodeAt(r)){o=!1;break}if(!0===o){s=a;break}}return"UNKNOWN"===s&&"UNKNOWN"!==e&&(console.warn('FileType of Image not recognized. Processing image as "'+e+'".'),s=e),s},n=function t(e){for(var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream,o=(0,this.internal.getFilters)();-1!==o.indexOf("FlateEncode");)o.splice(o.indexOf("FlateEncode"),1);e.n=n;var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.w}),a.push({key:"Height",value:e.h}),e.cs===this.color_spaces.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.cs}),e.cs===this.color_spaces.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bpc}),"dp"in e&&a.push({key:"DecodeParms",value:"<<"+e.dp+">>"}),"trns"in e&&e.trns.constructor==Array){for(var s="",l=0,h=e.trns.length;l<h;l++)s+=e.trns[l]+" "+e.trns[l]+" ";a.push({key:"Mask",value:"["+s+"]"})}"smask"in e&&a.push({key:"SMask",value:n+1+" 0 R"});var u=void 0!==e.f?["/"+e.f]:void 0;if(i({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u}),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,f={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(f.f=e.f),t.call(this,f)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),i({data:this.arrayBufferToBinaryString(new Uint8Array(e.pal))}),r("endobj"))},L=function(){var t=this.internal.collections[N+"images"];for(var e in t)n.call(this,t[e])},A=function(){var t,e=this.internal.collections[N+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},S=function(t){return"function"==typeof x["process"+t.toUpperCase()]},_=function(t){return"object"===se(t)&&1===t.nodeType},F=function(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return unescape(n);var r=x.loadFile(n);if(void 0!==r)return btoa(r)}if("CANVAS"===t.nodeName){var i=t;return t.toDataURL("image/jpeg",1)}(i=document.createElement("canvas")).width=t.clientWidth||t.width,i.height=t.clientHeight||t.height;var o=i.getContext("2d");if(!o)throw"addImage requires canvas to be supported by browser.";return o.drawImage(t,0,0,i.width,i.height),i.toDataURL("png"==(""+e).toLowerCase()?"image/png":"image/jpeg")},P=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n};x.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},x.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},x.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},x.sHashCode=function(t){var e,n=0;if(0===(t=t||"").length)return n;for(e=0;e<t.length;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;return n},x.isString=function(t){return"string"==typeof t},x.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+\/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==$/.test(t.substr(-2))&&(e=!1),e},x.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));\S*;*base64,(.+)$/g.exec(t)},x.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),n=null;if(2===e.length){var r=/^data:(\w*\/\w*);*(charset=[\w=-]*)*;*$/.exec(e[0]);Array.isArray(r)&&(n={mimeType:r[1],charset:r[2],data:e[1]})}return n},x.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},x.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},x.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},x.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},x.arrayBufferToBinaryString=function(t){if("function"==typeof atob)return atob(this.arrayBufferToBase64(t))},x.arrayBufferToBase64=function(t){for(var e,n="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=new Uint8Array(t),o=i.byteLength,a=o%3,s=o-a,l=0;l<s;l+=3)n+=r[(16515072&(e=i[l]<<16|i[l+1]<<8|i[l+2]))>>18]+r[(258048&e)>>12]+r[(4032&e)>>6]+r[63&e];return 1==a?n+=r[(252&(e=i[s]))>>2]+r[(3&e)<<4]+"==":2==a&&(n+=r[(64512&(e=i[s]<<8|i[s+1]))>>10]+r[(1008&e)>>4]+r[(15&e)<<2]+"="),n},x.createImageInfo=function(t,e,n,r,i,o,a,s,l,h,u,c,f){var p={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(p.f=o),l&&(p.dp=l),h&&(p.trns=h),u&&(p.pal=u),c&&(p.smask=c),f&&(p.p=f),p},x.addImage=function(t,e,n,r,i,o,a,s,l){var h="";if("string"!=typeof e){var u=o;o=i,i=r,r=n,n=e,e=u}if("object"===se(t)&&!_(t)&&"imageData"in t){var c=t;t=c.imageData,e=c.format||e||"UNKNOWN",n=c.x||n||0,r=c.y||r||0,i=c.w||i,o=c.h||o,a=c.alias||a,s=c.compression||s,l=c.rotation||c.angle||l}var f=this.internal.getFilters();if(void 0===s&&-1!==f.indexOf("FlateEncode")&&(s="SLOW"),"string"==typeof t&&(t=unescape(t)),isNaN(n)||isNaN(r))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var p,d,g,m,y,v,w,b=function(){var t=this.internal.collections[N+"images"];return t||(this.internal.collections[N+"images"]=t={},this.internal.events.subscribe("putResources",L),this.internal.events.subscribe("putXobjectDict",A)),t}.call(this);if(!((p=P(t,b))||(_(t)&&(t=F(t,e)),(null==(w=a)||0===w.length)&&(a="string"==typeof(v=t)?x.sHashCode(v):x.isArrayBufferView(v)?x.sHashCode(x.arrayBufferToBinaryString(v)):null),p=P(a,b)))){if(this.isString(t)&&(""!==(h=this.convertStringToImageData(t))?t=h:void 0!==(h=x.loadFile(t))&&(t=h)),e=this.getImageFileTypeByImageData(t,e),!S(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(d=t,t=this.binaryStringToUint8Array(t))),!(p=this["process"+e.toUpperCase()](t,(y=0,(m=b)&&(y=Object.keys?Object.keys(m).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(m)),y),a,((g=s)&&"string"==typeof g&&(g=g.toUpperCase()),g in x.image_compression?g:x.image_compression.NONE),d)))throw new Error("An unknown error occurred whilst processing the image")}return function(t,e,n,r,i,o,a,s){var l=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]}.call(this,n,r,i),h=this.internal.getCoordinateString,u=this.internal.getVerticalCoordinateString;if(n=l[0],r=l[1],a[o]=i,s){s*=Math.PI/180;var c=Math.cos(s),f=Math.sin(s),p=function(t){return t.toFixed(4)},d=[p(c),p(f),p(-1*f),p(c),0,0,"cm"]}this.internal.write("q"),s?(this.internal.write([1,"0","0",1,h(t),u(e+r),"cm"].join(" ")),this.internal.write(d.join(" ")),this.internal.write([h(n),"0","0",h(r),"0","0","cm"].join(" "))):this.internal.write([h(n),"0","0",h(r),h(t),u(e+r),"cm"].join(" ")),this.internal.write("/I"+i.i+" Do"),this.internal.write("Q")}.call(this,n,r,i,o,p,p.i,b,l),this},x.convertStringToImageData=function(t){var e,n="";if(this.isString(t)){var r;e=null!==(r=this.extractImageFromDataUrl(t))?r.data:t;try{n=atob(e)}catch(t){throw x.validateStringAsBase64(e)?new Error("atob-Error in jsPDF.convertStringToImageData "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertStringToImageData ")}}return n};var u=function(t,e){return t.subarray(e,e+5)};x.processJPEG=function(t,e,n,r,i,o){var a,s=this.decode.DCT_DECODE;if(!this.isString(t)&&!this.isArrayBuffer(t)&&!this.isArrayBufferView(t))return null;if(this.isString(t)&&(a=function(t){var e;if("JPEG"!==h(t))throw new Error("getJpegSize requires a binary string jpeg file");for(var n=256*t.charCodeAt(4)+t.charCodeAt(5),r=4,i=t.length;r<i;){if(r+=n,255!==t.charCodeAt(r))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(r+1)||193===t.charCodeAt(r+1)||194===t.charCodeAt(r+1)||195===t.charCodeAt(r+1)||196===t.charCodeAt(r+1)||197===t.charCodeAt(r+1)||198===t.charCodeAt(r+1)||199===t.charCodeAt(r+1))return e=256*t.charCodeAt(r+5)+t.charCodeAt(r+6),[256*t.charCodeAt(r+7)+t.charCodeAt(r+8),e,t.charCodeAt(r+9)];r+=2,n=256*t.charCodeAt(r)+t.charCodeAt(r+1)}}(t)),this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)&&(a=function(t){if(65496!=(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n=t.length,r=(t[4]<<8)+t[5],i=4;i<n;){if(r=((e=u(t,i+=r))[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&7<r)return{width:((e=u(t,i+5))[2]<<8)+e[3],height:(e[0]<<8)+e[1],numcomponents:e[4]};i+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")}(t),t=i||this.arrayBufferToBinaryString(t)),void 0===o)switch(a.numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;default:case 3:o=this.color_spaces.DEVICE_RGB}return this.createImageInfo(t,a.width,a.height,o,8,s,e,n)},x.processJPG=function(){return this.processJPEG.apply(this,arguments)},x.getImageProperties=function(t){var e,n,r="";if(_(t)&&(t=F(t)),this.isString(t)&&(""!==(r=this.convertStringToImageData(t))?t=r:void 0!==(r=x.loadFile(t))&&(t=r)),n=this.getImageFileTypeByImageData(t),!S(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(t=this.binaryStringToUint8Array(t))),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return{fileType:n,width:e.w,height:e.h,colorSpace:e.cs,compressionMode:e.f,bitsPerComponent:e.bpc}}}(lt.API),
	/**
	   * @license
	   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	t=lt.API,lt.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var e=this.internal.getPageInfoByObjId(t.objId),n=t.pageContext.annotations,r=function(t){if(void 0!==t&&""!=t)return!0},i=!1,o=0;o<n.length&&!i;o++)switch((l=n[o]).type){case"link":if(r(l.options.url)||r(l.options.pageNumber)){i=!0;break}case"reference":case"text":case"freetext":i=!0}if(0!=i){this.internal.write("/Annots ["),this.internal.pageSize.height;var a=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;for(o=0;o<n.length;o++){var l;switch((l=n[o]).type){case"reference":this.internal.write(" "+l.object.objId+" 0 R ");break;case"text":var h=this.internal.newAdditionalObject(),u=this.internal.newAdditionalObject(),c=l.title||"Note";m="<</Type /Annot /Subtype /Text "+(p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y)+"] ")+"/Contents ("+l.contents+")",m+=" /Popup "+u.objId+" 0 R",m+=" /P "+e.objId+" 0 R",m+=" /T ("+c+") >>",h.content=m;var f=h.objId+" 0 R";m="<</Type /Annot /Subtype /Popup "+(p="/Rect ["+a(l.bounds.x+30)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w+30)+" "+s(l.bounds.y)+"] ")+" /Parent "+f,l.open&&(m+=" /Open true"),m+=" >>",u.content=m,this.internal.write(h.objId,"0 R",u.objId,"0 R");break;case"freetext":var p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y+l.bounds.h)+"] ",d=l.color||"#000000";m="<</Type /Annot /Subtype /FreeText "+p+"/Contents ("+l.contents+")",m+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+d+")",m+=" /Border [0 0 0]",m+=" >>",this.internal.write(m);break;case"link":if(l.options.name){var g=this.annotations._nameMap[l.options.name];l.options.pageNumber=g.page,l.options.top=g.y}else l.options.top||(l.options.top=0);p="/Rect ["+a(l.x)+" "+s(l.y)+" "+a(l.x+l.w)+" "+s(l.y+l.h)+"] ";var m="";if(l.options.url)m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /A <</S /URI /URI ("+l.options.url+") >>";else if(l.options.pageNumber)switch(m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(l.options.pageNumber).objId+" 0 R",l.options.magFactor=l.options.magFactor||"XYZ",l.options.magFactor){case"Fit":m+=" /Fit]";break;case"FitH":m+=" /FitH "+l.options.top+"]";break;case"FitV":l.options.left=l.options.left||0,m+=" /FitV "+l.options.left+"]";break;case"XYZ":default:var y=s(l.options.top);l.options.left=l.options.left||0,void 0===l.options.zoom&&(l.options.zoom=0),m+=" /XYZ "+l.options.left+" "+y+" "+l.options.zoom+"]"}""!=m&&(m+=" >>",this.internal.write(m))}}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,n,r,i){this.internal.getCurrentPageInfo().pageContext.annotations.push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},
	/**
	   * @license
	   * Copyright (c) 2017 Aras Abbasi 
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	function(t){var h={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},a={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},e={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},n=[1570,1571,1573,1575];t.__arabicParser__={};var r=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==h[t.charCodeAt(0)]},u=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},i=t.__arabicParser__.isArabicEndLetter=function(t){return u(t)&&r(t)&&h[t.charCodeAt(0)].length<=2},o=t.__arabicParser__.isArabicAlfLetter=function(t){return u(t)&&0<=n.indexOf(t.charCodeAt(0))},s=(t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return u(t)&&r(t)&&1<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasFinalForm=function(t){return u(t)&&r(t)&&2<=h[t.charCodeAt(0)].length}),l=(t.__arabicParser__.arabicLetterHasInitialForm=function(t){return u(t)&&r(t)&&3<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasMedialForm=function(t){return u(t)&&r(t)&&4==h[t.charCodeAt(0)].length}),c=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=a,r=0,i="",o=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(o++,"number"==typeof(n=n[t.charCodeAt(e)])&&(r=-1!==(r=f(t.charAt(e),t.charAt(e-o),t.charAt(e+1)))?r:0,i+=String.fromCharCode(n),n=a,o=0),e===t.length-1&&(n=a,i+=t.charAt(e-(o-1)),e-=o-1,o=0)):(n=a,i+=t.charAt(e-o),e-=o,o=0);return i},f=(t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==e[t.charCodeAt(0)]},t.__arabicParser__.getCorrectForm=function(t,e,n){return u(t)?!1===r(t)?-1:!s(t)||!u(e)&&!u(n)||!u(n)&&i(e)||i(t)&&!u(e)||i(t)&&o(e)||i(t)&&i(e)?0:l(t)&&u(e)&&!i(e)&&u(n)&&s(n)?3:i(t)||!u(n)?1:2:-1}),p=t.__arabicParser__.processArabic=t.processArabic=function(t){var e=0,n=0,r=0,i="",o="",a="",s=(t=t||"").split("\\s+"),l=[];for(e=0;e<s.length;e+=1){for(l.push(""),n=0;n<s[e].length;n+=1)i=s[e][n],o=s[e][n-1],a=s[e][n+1],u(i)?(r=f(i,o,a),l[e]+=-1!==r?String.fromCharCode(h[i.charCodeAt(0)][r]):i):l[e]+=i;l[e]=c(l[e])}return l.join(" ")};t.events.push(["preProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([p(e[i][0]),e[i][1],e[i][2]]):r.push([p(e[i])]);t.text=r}else t.text=p(e)}])}(lt.API),lt.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},
	/**
	   * @license
	   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	e=lt.API,(n=function(){var e=void 0;Object.defineProperty(this,"pdf",{get:function(){return e},set:function(t){e=t}});var n=150;Object.defineProperty(this,"width",{get:function(){return n},set:function(t){n=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=n+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var i=[];Object.defineProperty(this,"childNodes",{get:function(){return i},set:function(t){i=t}});var o={};Object.defineProperty(this,"style",{get:function(){return o},set:function(t){o=t}}),Object.defineProperty(this,"parentNode",{get:function(){return!1}})}).prototype.getContext=function(t,e){var n;if("2d"!==(t=t||"2d"))return null;for(n in e)this.pdf.context2d.hasOwnProperty(n)&&(this.pdf.context2d[n]=e[n]);return(this.pdf.context2d._canvas=this).pdf.context2d},n.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},e.events.push(["initialized",function(){this.canvas=new n,this.canvas.pdf=this}]),
	/** 
	   * @license
	   * ====================================================================
	   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	   *               2013 Lee Driscoll, https://github.com/lsdriscoll
	   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	   *               2014 James Hall, james@parall.ax
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *
	   * 
	   * ====================================================================
	   */
	_=lt.API,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,p=function(t,e,n,r,i){F={x:t,y:e,w:n,h:r,ln:i}},d=function(){return F},k={left:0,top:0,bottom:0},_.setHeaderFunction=function(t){l=t},_.getTextDimensions=function(t,e){var n=this.table_font_size||this.internal.getFontSize(),r=(this.internal.getFont().fontStyle,(e=e||{}).scaleFactor||this.internal.scaleFactor),i=0,o=0,a=0;if("string"==typeof t)0!=(i=this.getStringUnitWidth(t)*n)&&(o=1);else{if("[object Array]"!==Object.prototype.toString.call(t))throw new Error("getTextDimensions expects text-parameter to be of type String or an Array of Strings.");for(var s=0;s<t.length;s++)i<(a=this.getStringUnitWidth(t[s])*n)&&(i=a);0!==i&&(o=t.length)}return{w:i/=r,h:Math.max((o*n*this.getLineHeightFactor()-n*(this.getLineHeightFactor()-1))/r,0)}},_.cellAddPage=function(){var t=this.margins||k;this.addPage(),p(t.left,t.top,void 0,void 0),P+=1},_.cellInitialize=function(){F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1},_.cell=function(t,e,n,r,i,o,a){var s=d(),l=!1;if(void 0!==s.ln)if(s.ln===o)t=s.x+s.w,e=s.y;else{var h=this.margins||k;s.y+s.h+r+13>=this.internal.pageSize.getHeight()-h.bottom&&(this.cellAddPage(),l=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=d().y+d().h,l&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var u=0;u<i.length;u++){var c=i[u],f=this.getStringUnitWidth(c)*this.internal.getFontSize()/this.internal.scaleFactor;this.text(c,t+n-f-3,e+this.internal.getLineHeight()*(u+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return p(t,e,n,r,o),this},_.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):o<i&&(o=i);return o},_.table=function(t,e,n,r,i){if(!n)throw"No data for PDF table";var o,a,s,l,h,u,c,f,p,d,g=[],m=[],y={},v={},w=[],b=[],x=!1,N=!0,L=12,A=k;if(A.width=this.internal.pageSize.getWidth(),i&&(!0===i.autoSize&&(x=!0),!1===i.printHeaders&&(N=!1),i.fontSize&&(L=i.fontSize),i.css&&void 0!==i.css["font-size"]&&(L=16*i.css["font-size"]),i.margins&&(A=i.margins)),this.lnMod=0,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,this.printHeaders=N,this.margins=A,this.setFontSize(L),this.table_font_size=L,null==r)g=Object.keys(n[0]);else if(r[0]&&"string"!=typeof r[0])for(a=0,s=r.length;a<s;a+=1)o=r[a],g.push(o.name),m.push(o.prompt),v[o.name]=o.width*(19.049976/25.4);else g=r;if(x)for(d=function(t){return t[o]},a=0,s=g.length;a<s;a+=1){for(y[o=g[a]]=n.map(d),w.push(this.getTextDimensions(m[a]||o,{scaleFactor:1}).w),c=0,l=(u=y[o]).length;c<l;c+=1)h=u[c],w.push(this.getTextDimensions(h,{scaleFactor:1}).w);v[o]=_.arrayMax(w),w=[]}if(N){var S=this.calculateLineHeight(g,v,m.length?m:g);for(a=0,s=g.length;a<s;a+=1)o=g[a],b.push([t,e,v[o],S,String(m.length?m[a]:o)]);this.setTableHeaderRow(b),this.printHeaderRow(1,!1)}for(a=0,s=n.length;a<s;a+=1)for(f=n[a],S=this.calculateLineHeight(g,v,f),c=0,p=g.length;c<p;c+=1)o=g[c],this.cell(t,e,v[o],S,f[o],a+2,o.align);return this.lastCellPos=F,this.table_x=t,this.table_y=e,this},_.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;i<a&&(i=a)}return i},_.setTableHeaderRow=function(t){this.tableHeaderRow=t},_.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,i,o;if(this.printingHeaderRow=!0,void 0!==l){var a=l(this,P);p(a[0],a[1],a[2],a[3],-1)}this.setFontStyle("bold");var s=[];for(i=0,o=this.tableHeaderRow.length;i<o;i+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[i],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,s.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));0<s.length&&this.setTableHeaderRow(s),this.setFontStyle("normal"),this.printingHeaderRow=!1},
	/**
	   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
	   *
	   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
	   */
	function(t,e){var l,i,o,h,u,c=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new M,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new j,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new j,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};t.events.push(["initialized",function(){this.context2d=new n(this),l=this.internal.f2,this.internal.f3,i=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,h=this.internal.getHorizontalCoordinate,u=this.internal.getVerticalCoordinate}]);var n=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}}),Object.defineProperty(this,"pdf",{get:function(){return t}});var e=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return e},set:function(t){e=Boolean(t)}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var r=0;Object.defineProperty(this,"posX",{get:function(){return r},set:function(t){isNaN(t)||(r=t)}});var i=0;Object.defineProperty(this,"posY",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=Boolean(t)}});var a=0;Object.defineProperty(this,"lastBreak",{get:function(){return a},set:function(t){a=t}});var s=[];Object.defineProperty(this,"pageBreaks",{get:function(){return s},set:function(t){s=t}});var l=new c;Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof c&&(l=t)}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t}});var h=[];Object.defineProperty(this,"ctxStack",{get:function(){return h},set:function(t){h=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=f(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=f(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var n=e[1],r=(e[2],e[3]),i=e[4],o=e[5],a=e[6];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i);var s="";("bold"===r||700<=parseInt(r,10)||"bold"===n)&&(s="bold"),"italic"===n&&(s+="italic"),0===s.length&&(s="normal");for(var l="",h=a.toLowerCase().replace(/"|'/g,"").split(/\s*,\s*/),u={arial:"Helvetica",verdana:"Helvetica",helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",courier:"Courier",times:"Times",cursive:"Times",fantasy:"Times",serif:"Times"},c=0;c<h.length;c++){if(void 0!==this.pdf.internal.getFont(h[c],s,{noFallback:!0,disableWarning:!0})){l=h[c];break}if("bolditalic"===s&&void 0!==this.pdf.internal.getFont(h[c],"bold",{noFallback:!0,disableWarning:!0}))l=h[c],s="bold";else if(void 0!==this.pdf.internal.getFont(h[c],"normal",{noFallback:!0,disableWarning:!0})){l=h[c],s="normal";break}}if(""===l)for(c=0;c<h.length;c++)if(u[h[c]]){l=u[h[c]];break}l=""===l?"Times":l,this.pdf.setFont(l,s)}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};n.prototype.fill=function(){r.call(this,"fill",!1)},n.prototype.stroke=function(){r.call(this,"stroke",!1)},n.prototype.beginPath=function(){this.path=[{type:"begin"}]},n.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"mt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(t,e)},n.prototype.closePath=function(){var t=new j(0,0),e=0;for(e=this.path.length-1;-1!==e;e--)if("begin"===this.path[e].type&&"object"===se(this.path[e+1])&&"number"==typeof this.path[e+1].x){t=new j(this.path[e+1].x,this.path[e+1].y),this.path.push({type:"lt",x:t.x,y:t.y});break}"object"===se(this.path[e+2])&&"number"==typeof this.path[e+2].x&&this.path.push(JSON.parse(JSON.stringify(this.path[e+2]))),this.path.push({type:"close"}),this.ctx.lastPoint=new j(t.x,t.y)},n.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"lt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(n.x,n.y)},n.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),r.call(this,null,!0)},n.prototype.quadraticCurveTo=function(t,e,n,r){if(isNaN(n)||isNaN(r)||isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new j(n,r)),o=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:i.x,y:i.y}),this.ctx.lastPoint=new j(i.x,i.y)},n.prototype.bezierCurveTo=function(t,e,n,r,i,o){if(isNaN(i)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var a=this.ctx.transform.applyToPoint(new j(i,o)),s=this.ctx.transform.applyToPoint(new j(t,e)),l=this.ctx.transform.applyToPoint(new j(n,r));this.path.push({type:"bct",x1:s.x,y1:s.y,x2:l.x,y2:l.y,x:a.x,y:a.y}),this.ctx.lastPoint=new j(a.x,a.y)},n.prototype.arc=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i))throw console.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var a=this.ctx.transform.applyToPoint(new j(t,e));t=a.x,e=a.y;var s=this.ctx.transform.applyToPoint(new j(0,n)),l=this.ctx.transform.applyToPoint(new j(0,0));n=Math.sqrt(Math.pow(s.x-l.x,2)+Math.pow(s.y-l.y,2))}Math.abs(i-r)>=2*Math.PI&&(r=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,counterclockwise:o})},n.prototype.arcTo=function(t,e,n,r,i){throw new Error("arcTo not implemented.")},n.prototype.rect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.lineTo(t+n,e),this.lineTo(t,e)},n.prototype.fillRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!N.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,n,r),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin)}},n.prototype.strokeRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");L.call(this)||(this.beginPath(),this.rect(t,e,n,r),this.stroke())},n.prototype.clearRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,n,r))},n.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var r=new c(this.ctx);this.ctxStack.push(this.ctx),this.ctx=r}},n.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin)},n.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var f=function(t){var e,n,r,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))i=r=n=e=0;else{var o=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==o)e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=1;else if(null!==(o=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/.exec(t)))e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=parseFloat(o[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var a=new RGBColor(t);t=a.ok?a.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16)}}return{r:e,g:n,b:r,a:i,style:t}},N=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},L=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};n.prototype.fillText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(r=isNaN(r)?void 0:r,!N.call(this)){n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.strokeText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!L.call(this)){r=isNaN(r)?void 0:r,n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.measureText=function(t){if("string"!=typeof t)throw console.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,n=this.pdf.internal.scaleFactor,r=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*r/e.internal.scaleFactor;return new function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this}({width:i*=Math.round(96*n/72*1e4)/1e4})},n.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var n=new M(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.rotate=function(t){if(isNaN(t))throw console.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new M(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},n.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var n=new M(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.transform=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o))throw console.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var a=new M(t,e,n,r,i,o);this.ctx.transform=this.ctx.transform.multiply(a)},n.prototype.setTransform=function(t,e,n,r,i,o){t=isNaN(t)?1:t,e=isNaN(e)?0:e,n=isNaN(n)?0:n,r=isNaN(r)?1:r,i=isNaN(i)?0:i,o=isNaN(o)?0:o,this.ctx.transform=new M(t,e,n,r,i,o)},n.prototype.drawImage=function(t,e,n,r,i,o,a,s,l){var h=this.pdf.getImageProperties(t),u=1,c=1,f=1,p=1;void 0!==r&&void 0!==s&&(f=s/r,p=l/i,u=h.width/r*s/r,c=h.height/i*l/i),void 0===o&&(o=e,a=n,n=e=0),void 0!==r&&void 0===s&&(s=r,l=i),void 0===r&&void 0===s&&(s=h.width,l=h.height);var d=this.ctx.transform.decompose(),g=B(d.rotate.shx);d.scale.sx,d.scale.sy;for(var m,y=new M,v=((y=(y=(y=y.multiply(d.translate)).multiply(d.skew)).multiply(d.scale)).applyToPoint(new j(s,l)),y.applyToRectangle(new E(o-e*f,a-n*p,r*u,i*c))),w=F.call(this,v),b=[],x=0;x<w.length;x+=1)-1===b.indexOf(w[x])&&b.push(w[x]);if(b.sort(),this.autoPaging)for(var N=b[0],L=b[b.length-1],A=N;A<L+1;A++){if(this.pdf.setPage(A),0!==this.ctx.clip_path.length){var S=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(m,this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY),k.call(this,"fill",!0),this.path=S}var _=JSON.parse(JSON.stringify(v));_=P([_],this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY)[0],this.pdf.addImage(t,"jpg",_.x,_.y,_.w,_.h,null,null,g)}else this.pdf.addImage(t,"jpg",v.x,v.y,v.w,v.h,null,null,g)};var F=function(t,e,n){var r=[];switch(e=e||this.pdf.internal.pageSize.width,n=n||this.pdf.internal.pageSize.height,t.type){default:case"mt":case"lt":r.push(Math.floor((t.y+this.posY)/n)+1);break;case"arc":r.push(Math.floor((t.y+this.posY-t.radius)/n)+1),r.push(Math.floor((t.y+this.posY+t.radius)/n)+1);break;case"qct":var i=w(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);r.push(Math.floor(i.y/n)+1),r.push(Math.floor((i.y+i.h)/n)+1);break;case"bct":var o=b(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);r.push(Math.floor(o.y/n)+1),r.push(Math.floor((o.y+o.h)/n)+1);break;case"rect":r.push(Math.floor((t.y+this.posY)/n)+1),r.push(Math.floor((t.y+t.h+this.posY)/n)+1)}for(var a=0;a<r.length;a+=1)for(;this.pdf.internal.getNumberOfPages()<r[a];)v.call(this);return r},v=function(){var t=this.fillStyle,e=this.strokeStyle,n=this.font,r=this.lineCap,i=this.lineWidth,o=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=n,this.lineCap=r,this.lineWidth=i,this.lineJoin=o},P=function(t,e,n){for(var r=0;r<t.length;r++)switch(t[r].type){case"bct":t[r].x2+=e,t[r].y2+=n;case"qct":t[r].x1+=e,t[r].y1+=n;case"mt":case"lt":case"arc":default:t[r].x+=e,t[r].y+=n}return t},r=function(t,e){for(var n,r,i=this.fillStyle,o=this.strokeStyle,a=(this.font,this.lineCap),s=this.lineWidth,l=this.lineJoin,h=JSON.parse(JSON.stringify(this.path)),u=JSON.parse(JSON.stringify(this.path)),c=[],f=0;f<u.length;f++)if(void 0!==u[f].x)for(var p=F.call(this,u[f]),d=0;d<p.length;d+=1)-1===c.indexOf(p[d])&&c.push(p[d]);for(f=0;f<c.length;f++)for(;this.pdf.internal.getNumberOfPages()<c[f];)v.call(this);if(c.sort(),this.autoPaging){var g=c[0],m=c[c.length-1];for(f=g;f<m+1;f++){if(this.pdf.setPage(f),this.fillStyle=i,this.strokeStyle=o,this.lineCap=a,this.lineWidth=s,this.lineJoin=l,0!==this.ctx.clip_path.length){var y=this.path;n=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(n,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),k.call(this,t,!0),this.path=y}r=JSON.parse(JSON.stringify(h)),this.path=P(r,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),!1!==e&&0!==f||k.call(this,t,e)}}else k.call(this,t,e);this.path=h},k=function(t,e){if(("stroke"!==t||e||!L.call(this))&&("stroke"===t||e||!N.call(this))){var n=[];this.ctx.globalAlpha;this.ctx.fillOpacity<1&&this.ctx.fillOpacity;for(var r,i=this.path,o=0;o<i.length;o++){var a=i[o];switch(a.type){case"begin":n.push({begin:!0});break;case"close":n.push({close:!0});break;case"mt":n.push({start:a,deltas:[],abs:[]});break;case"lt":var s=n.length;if(!isNaN(i[o-1].x)){var l=[a.x-i[o-1].x,a.y-i[o-1].y];if(0<s)for(;0<=s;s--)if(!0!==n[s-1].close&&!0!==n[s-1].begin){n[s-1].deltas.push(l),n[s-1].abs.push(a);break}}break;case"bct":l=[a.x1-i[o-1].x,a.y1-i[o-1].y,a.x2-i[o-1].x,a.y2-i[o-1].y,a.x-i[o-1].x,a.y-i[o-1].y];n[n.length-1].deltas.push(l);break;case"qct":var h=i[o-1].x+2/3*(a.x1-i[o-1].x),u=i[o-1].y+2/3*(a.y1-i[o-1].y),c=a.x+2/3*(a.x1-a.x),f=a.y+2/3*(a.y1-a.y),p=a.x,d=a.y;l=[h-i[o-1].x,u-i[o-1].y,c-i[o-1].x,f-i[o-1].y,p-i[o-1].x,d-i[o-1].y];n[n.length-1].deltas.push(l);break;case"arc":n.push({deltas:[],abs:[],arc:!0}),Array.isArray(n[n.length-1].abs)&&n[n.length-1].abs.push(a)}}r=e?null:"stroke"===t?"stroke":"fill";for(o=0;o<n.length;o++){if(n[o].arc)for(var g=n[o].abs,m=0;m<g.length;m++){var y=g[m];if(void 0!==y.startAngle){var v=B(y.startAngle),w=B(y.endAngle),b=y.x,x=y.y;A.call(this,b,x,y.radius,v,w,y.counterclockwise,r,e)}else I.call(this,y.x,y.y)}if(!n[o].arc&&!0!==n[o].close&&!0!==n[o].begin){b=n[o].start.x,x=n[o].start.y;C.call(this,n[o].deltas,b,x,null,null)}}r&&S.call(this,r),e&&_.call(this)}},a=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,n=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e-n;case"hanging":return t+e-2*n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}};n.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},n.prototype.createPattern=function(){return this.createLinearGradient()},n.prototype.createRadialGradient=function(){return this.createLinearGradient()};var A=function(t,e,n,r,i,o,a,s){this.pdf.internal.scaleFactor;for(var l=y(r),h=y(i),u=g.call(this,n,l,h,o),c=0;c<u.length;c++){var f=u[c];0===c&&p.call(this,f.x1+t,f.y1+e),d.call(this,t,e,f.x2,f.y2,f.x3,f.y3,f.x4,f.y4)}s?_.call(this):S.call(this,a)},S=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},_=function(){this.pdf.clip()},p=function(t,e){this.pdf.internal.out(i(t)+" "+o(e)+" m")},s=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var n=this.ctx.transform.applyToPoint(new j(t.x,t.y)),r=this.ctx.transform.decompose(),i=new M;i=(i=(i=i.multiply(r.translate)).multiply(r.skew)).multiply(r.scale);for(var o,a=this.pdf.getTextDimensions(t.text),s=this.ctx.transform.applyToRectangle(new E(t.x,t.y,a.w,a.h)),l=i.applyToRectangle(new E(t.x,t.y-a.h,a.w,a.h)),h=F.call(this,l),u=[],c=0;c<h.length;c+=1)-1===u.indexOf(h[c])&&u.push(h[c]);if(u.sort(),!0===this.autoPaging)for(var f=u[0],p=u[u.length-1],d=f;d<p+1;d++){if(this.pdf.setPage(d),0!==this.ctx.clip_path.length){var g=this.path;o=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(o,this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY),k.call(this,"fill",!0),this.path=g}var m=JSON.parse(JSON.stringify(s));if(m=P([m],this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY)[0],.01<=t.scale){var y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,m.x,m.y,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}else{if(.01<=t.scale){y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,n.x+this.posX,n.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}},I=function(t,e,n,r){n=n||0,r=r||0,this.pdf.internal.out(i(t+n)+" "+o(e+r)+" l")},C=function(t,e,n){return this.pdf.lines(t,e,n,null,null)},d=function(t,e,n,r,i,o,a,s){this.pdf.internal.out([l(h(n+t)),l(u(r+e)),l(h(i+t)),l(u(o+e)),l(h(a+t)),l(u(s+e)),"c"].join(" "))},g=function(t,e,n,r){var i=2*Math.PI,o=e;(o<i||i<o)&&(o%=i);var a=n;(a<i||i<a)&&(a%=i);for(var s=[],l=Math.PI/2,h=r?-1:1,u=e,c=Math.min(i,Math.abs(a-o));1e-5<c;){var f=u+h*Math.min(c,l);s.push(m.call(this,t,u,f)),c-=Math.abs(f-u),u=f}return s},m=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,l=a*a+s*s,h=l+a*i+s*o,u=4/3*(Math.sqrt(2*l*h)-h)/(a*o-s*i),c=a-u*s,f=s+u*a,p=c,d=-f,g=r+e,m=Math.cos(g),y=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:c*m-f*y,y2:c*y+f*m,x3:p*m-d*y,y3:p*y+d*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}},B=function(t){return 180*t/Math.PI},y=function(t){return t*Math.PI/180},w=function(t,e,n,r,i,o){var a=t+.5*(n-t),s=e+.5*(r-e),l=i+.5*(n-i),h=o+.5*(r-o),u=Math.min(t,i,a,l),c=Math.max(t,i,a,l),f=Math.min(e,o,s,h),p=Math.max(e,o,s,h);return new E(u,f,c-u,p-f)},b=function(t,e,n,r,i,o,a,s){for(var l,h,u,c,f,p,d,g,m,y,v,w,b,x=n-t,N=r-e,L=i-n,A=o-r,S=a-i,_=s-o,F=0;F<41;F++)g=(p=(h=t+(l=F/40)*x)+l*((c=n+l*L)-h))+l*(c+l*(i+l*S-c)-p),m=(d=(u=e+l*N)+l*((f=r+l*A)-u))+l*(f+l*(o+l*_-f)-d),b=0==F?(w=y=g,v=m):(y=Math.min(y,g),v=Math.min(v,m),w=Math.max(w,g),Math.max(b,m));return new E(Math.round(y),Math.round(v),Math.round(w-y),Math.round(b-v))},j=function(t,e){var n=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var r=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},E=function(t,e,n,r){j.call(this,t,e),this.type="rect";var i=n||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var o=r||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return o},set:function(t){isNaN(t)||(o=parseFloat(t))}}),this},M=function(t,e,n,r,i,o){var a=[];return Object.defineProperty(this,"sx",{get:function(){return a[0]},set:function(t){a[0]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shy",{get:function(){return a[1]},set:function(t){a[1]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shx",{get:function(){return a[2]},set:function(t){a[2]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"sy",{get:function(){return a[3]},set:function(t){a[3]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"tx",{get:function(){return a[4]},set:function(t){a[4]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"ty",{get:function(){return a[5]},set:function(t){a[5]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(this,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(this,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(this,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),this.sx=isNaN(t)?1:t,this.shy=isNaN(e)?0:e,this.shx=isNaN(n)?0:n,this.sy=isNaN(r)?1:r,this.tx=isNaN(i)?0:i,this.ty=isNaN(o)?0:o,this};M.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,n=t.sx*this.shy+t.shy*this.sy,r=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,o=t.tx*this.sx+t.ty*this.shx+this.tx,a=t.tx*this.shy+t.ty*this.sy+this.ty;return new M(e,n,r,i,o,a)},M.prototype.decompose=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty,a=Math.sqrt(t*t+e*e),s=(t/=a)*n+(e/=a)*r;n-=t*s,r-=e*s;var l=Math.sqrt(n*n+r*r);return s/=l,t*(r/=l)<e*(n/=l)&&(t=-t,e=-e,s=-s,a=-a),{scale:new M(a,0,0,l,0,0),translate:new M(1,0,0,1,i,o),rotate:new M(t,e,-e,t,0,0),skew:new M(1,0,s,1,0,0)}},M.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,n=t.x*this.shy+t.y*this.sy+this.ty;return new j(e,n)},M.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),n=this.applyToPoint(new j(t.x+t.w,t.y+t.h));return new E(e.x,e.y,n.x-e.x,n.y-e.y)},M.prototype.clone=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty;return new M(t,e,n,r,i,o)}}(lt.API,"undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
	/**
	   * jsPDF filters PlugIn
	   * Copyright (c) 2014 Aras Abbasi 
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	a=lt.API,o=function(t){var r,e,n,i,o,a,s,l,h,u;for(/[^\x00-\xFF]/.test(t),e=[],n=0,i=(t+=r="\0\0\0\0".slice(t.length%4||4)).length;n<i;n+=4)0!==(o=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(a=(o=((o=((o=((o=(o-(u=o%85))/85)-(h=o%85))/85)-(l=o%85))/85)-(s=o%85))/85)%85,e.push(a+33,s+33,l+33,h+33,u+33)):e.push(122);return function(t,e){for(var n=r.length;0<n;n--)t.pop()}(e),String.fromCharCode.apply(String,e)+"~>"},s=function(t){var r,e,n,i,o,a=String,s="length",l="charCodeAt",h="slice",u="replace";for(t[h](-2),t=t[h](0,-2)[u](/\s/g,"")[u]("z","!!!!!"),n=[],i=0,o=(t+=r="uuuuu"[h](t[s]%5||5))[s];i<o;i+=5)e=52200625*(t[l](i)-33)+614125*(t[l](i+1)-33)+7225*(t[l](i+2)-33)+85*(t[l](i+3)-33)+(t[l](i+4)-33),n.push(255&e>>24,255&e>>16,255&e>>8,255&e);return function(t,e){for(var n=r[s];0<n;n--)t.pop()}(n),a.fromCharCode.apply(a,n)},h=function(t){for(var e="",n=0;n<t.length;n+=1)e+=("0"+t.charCodeAt(n).toString(16)).slice(-2);return e+=">"},u=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var n="",r=0;r<t.length;r+=2)n+=String.fromCharCode("0x"+(t[r]+t[r+1]));return n},c=function(t,e){e=Object.assign({predictor:1,colors:1,bitsPerComponent:8,columns:1},e);for(var n,r,i=[],o=t.length;o--;)i[o]=t.charCodeAt(o);return n=a.adler32cs.from(t),(r=new Deflater(6)).append(new Uint8Array(i)),t=r.flush(),(i=new Uint8Array(t.length+6)).set(new Uint8Array([120,156])),i.set(t,2),i.set(new Uint8Array([255&n,n>>8&255,n>>16&255,n>>24&255]),t.length+2),t=String.fromCharCode.apply(null,i)},a.processDataByFilters=function(t,e){var n=0,r=t||"",i=[];for("string"==typeof(e=e||[])&&(e=[e]),n=0;n<e.length;n+=1)switch(e[n]){case"ASCII85Decode":case"/ASCII85Decode":r=s(r),i.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":r=o(r),i.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":r=u(r),i.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":r=h(r),i.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":r=c(r),i.push("/FlateDecode");break;default:throw'The filter: "'+e[n]+'" is not implemented'}return{data:r,reverseChain:i.reverse().join(" ")}},(
	/**
	   * jsPDF fileloading PlugIn
	   * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	r=lt.API).loadFile=function(t,e,n){var r;e=e||!0,n=n||function(){};try{r=function(t,e,n){var r=new XMLHttpRequest,i=[],o=0,a=function(t){var e=t.length,n=String.fromCharCode;for(o=0;o<e;o+=1)i.push(n(255&t.charCodeAt(o)));return i.join("")};if(r.open("GET",t,!e),r.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(r.onload=function(){return a(this.responseText)}),r.send(null),200===r.status)return e?a(r.responseText):void 0;console.warn('Unable to load file "'+t+'"')}(t,e)}catch(t){r=void 0}return r},r.loadImageFile=r.loadFile,
	/**
	   * Copyright (c) 2018 Erik Koopmans
	   * Released under the MIT License.
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	i=lt.API,f="undefined"!=typeof window&&window||"undefined"!=typeof global&&global,g=function(t){var e=se(t);return"undefined"===e?"undefined":"string"===e||t instanceof String?"string":"number"===e||t instanceof Number?"number":"function"===e||t instanceof Function?"function":t&&t.constructor===Array?"array":t&&1===t.nodeType?"element":"object"===e?"object":"unknown"},m=function(t,e){var n=document.createElement(t);if(e.className&&(n.className=e.className),e.innerHTML){n.innerHTML=e.innerHTML;for(var r=n.getElementsByTagName("script"),i=r.length;0<i--;null)r[i].parentNode.removeChild(r[i])}for(var o in e.style)n.style[o]=e.style[o];return n},(((y=function t(e){var n=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),r=t.convert(Promise.resolve(),n);return r=(r=r.setProgress(1,t,1,[t])).set(e)}).prototype=Object.create(Promise.prototype)).constructor=y).convert=function(t,e){return t.__proto__=e||y.prototype,t},y.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{}}},y.prototype.from=function(t,e){return this.then(function(){switch(e=e||function(t){switch(g(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.set({src:m("div",{innerHTML:t})});case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}})},y.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},y.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then(function(){var t={position:"relative",display:"inline-block",width:Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:"white"},e=function t(e,n){for(var r=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==n&&1===i.nodeType&&"SCRIPT"===i.nodeName||r.appendChild(t(i,n));return 1===e.nodeType&&("CANVAS"===e.nodeName?(r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(r.value=e.value),r.addEventListener("load",function(){r.scrollTop=e.scrollTop,r.scrollLeft=e.scrollLeft},!0)),r}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=m("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=m("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(m("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"})},y.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=Object.assign({},this.opt.html2canvas);if(delete t.onrendered,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,t)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=this.opt.jsPDF,e=Object.assign({async:!0,allowTaint:!0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete e.onrendered,t.context2d.autoPaging=!0,t.context2d.posX=this.opt.x,t.context2d.posY=this.opt.y,e.windowHeight=e.windowHeight||0,e.windowHeight=0==e.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):e.windowHeight,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,e)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then(function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t})},y.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then(function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF})},y.prototype.output=function(t,e,n){return"img"===(n=n||"pdf").toLowerCase()||"image"===n.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},y.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){return this.prop.pdf.output(t,e)})},y.prototype.outputImg=function(t,e){return this.thenList([function(){return this.prop.img||this.toImg()}]).then(function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}})},y.prototype.isHtml2CanvasLoaded=function(){var t=void 0!==f.html2canvas;return t||console.error("html2canvas not loaded."),t},y.prototype.save=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then(function(){this.prop.pdf.save(this.opt.filename)})},y.prototype.doCallback=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){this.prop.callback(this.prop.pdf)})},y.prototype.set=function(e){if("object"!==g(e))return this;var t=Object.keys(e||{}).map(function(t){if(t in y.template.prop)return function(){this.prop[t]=e[t]};switch(t){case"margin":return this.setMargin.bind(this,e.margin);case"jsPDF":return function(){return this.opt.jsPDF=e.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,e.pageSize);default:return function(){this.opt[t]=e[t]}}},this);return this.then(function(){return this.thenList(t)})},y.prototype.get=function(e,n){return this.then(function(){var t=e in y.template.prop?this.prop[e]:this.opt[e];return n?n(t):t})},y.prototype.setMargin=function(t){return this.then(function(){switch(g(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t}).then(this.setPageSize)},y.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then(function(){(t=t||lt.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t})},y.prototype.setProgress=function(t,e,n,r){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=n&&(this.progress.n=n),null!=r&&(this.progress.stack=r),this.progress.ratio=this.progress.val/this.progress.state,this},y.prototype.updateProgress=function(t,e,n,r){return this.setProgress(t?this.progress.val+t:null,e||null,n?this.progress.n+n:null,r?this.progress.stack.concat(r):null)},y.prototype.then=function(t,e){var n=this;return this.thenCore(t,e,function(e,t){return n.updateProgress(null,null,1,[e]),Promise.prototype.then.call(this,function(t){return n.updateProgress(null,e),t}).then(e,t).then(function(t){return n.updateProgress(1),t})})},y.prototype.thenCore=function(t,e,n){n=n||Promise.prototype.then;var r=this;t&&(t=t.bind(r)),e&&(e=e.bind(r));var i=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?r:y.convert(Object.assign({},r),Promise.prototype),o=n.call(i,t,e);return y.convert(o,r.__proto__)},y.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},y.prototype.thenList=function(t){var e=this;return t.forEach(function(t){e=e.thenCore(t)}),e},y.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return y.convert(e,this)},y.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},y.prototype.error=function(t){return this.then(function(){throw new Error(t)})},y.prototype.using=y.prototype.set,y.prototype.saveAs=y.prototype.save,y.prototype.export=y.prototype.output,y.prototype.run=y.prototype.then,lt.getPageSize=function(t,e,n){if("object"===se(t)){var r=t;t=r.orientation,e=r.unit||e,n=r.format||n}e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();var i=(""+n).toLowerCase(),o={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(e){case"pt":var a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw"Invalid unit: "+e}if(o.hasOwnProperty(i))var s=o[i][1]/a,l=o[i][0]/a;else try{s=n[1],l=n[0]}catch(t){throw new Error("Invalid format: "+n)}if("p"===t||"portrait"===t){if(t="p",s<l){var h=l;l=s,s=h}}else{if("l"!==t&&"landscape"!==t)throw"Invalid orientation: "+t;t="l",l<s&&(h=l,l=s,s=h)}return{width:l,height:s,unit:e,k:a}},i.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.jsPDF;var n=new y(e);return e.worker?n:n.from(t).doCallback()},lt.API.addJS=function(t){return b=t,this.internal.events.subscribe("postPutResources",function(t){v=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(v+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),w=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+b+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==v&&void 0!==w&&this.internal.out("/Names <</JavaScript "+v+" 0 R>>")}),this},(
	/**
	   * @license
	   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	x=lt.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a,!1)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,l=[];for(r=0;r<s;r++){var h=t.internal.newObject();l.push(h);var u=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+u.objId+" 0 R /XYZ null null null]>> endobj")}var c=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<l.length;r++)t.internal.write("(page_"+(r+1)+")"+l[r]+" 0 R");t.internal.write(" ] >>","endobj"),t.internal.newObject(),t.internal.write("<< /Dests "+c+" 0 R"),t.internal.write(">>","endobj")}}]),x.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+namesOid+" 0 R"))}]),x.events.push(["initialized",function(){var a=this;a.outline={createNamedDestinations:!1,root:{children:[]}},a.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},a.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=a,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},a.outline.genIds_r=function(t){t.id=a.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},a.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},a.outline.renderItems=function(t){this.ctx.pdf.internal.getCoordinateString;for(var e=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<t.children.length;n++){var r=t.children[n];this.objStart(r),this.line("/Title "+this.makeString(r.title)),this.line("/Parent "+this.makeRef(t)),0<n&&this.line("/Prev "+this.makeRef(t.children[n-1])),n<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[n+1])),0<r.children.length&&(this.line("/First "+this.makeRef(r.children[0])),this.line("/Last "+this.makeRef(r.children[r.children.length-1])));var i=this.count=this.count_r({count:0},r);if(0<i&&this.line("/Count "+i),r.options&&r.options.pageNumber){var o=a.internal.getPageInfo(r.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+e(0)+" 0]")}this.objEnd()}for(n=0;n<t.children.length;n++)r=t.children[n],this.renderItems(r)},a.outline.line=function(t){this.ctx.val+=t+"\r\n"},a.outline.makeRef=function(t){return t.id+" 0 R"},a.outline.makeString=function(t){return"("+a.internal.pdfEscape(t)+")"},a.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},a.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},a.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
	/**
	   * @license
	   * 
	   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
	   *
	   * 
	   * ====================================================================
	   */
	I=lt.API,C=function(){var t="function"==typeof Deflater;if(!t)throw new Error("requires deflate.js for compression");return t},B=function(t,e,n,r){var i=5,o=E;switch(r){case I.image_compression.FAST:i=3,o=j;break;case I.image_compression.MEDIUM:i=6,o=M;break;case I.image_compression.SLOW:i=9,o=O}t=A(t,e,n,o);var a=new Uint8Array(N(i)),s=L(t),l=new Deflater(i),h=l.append(t),u=l.flush(),c=a.length+h.length+u.length,f=new Uint8Array(c+4);return f.set(a),f.set(h,a.length),f.set(u,a.length+h.length),f[c++]=s>>>24&255,f[c++]=s>>>16&255,f[c++]=s>>>8&255,f[c++]=255&s,I.arrayBufferToBinaryString(f)},N=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,[n,255&(r+=31-r%31)]},L=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;0<o;){for(o-=n=e<o?e:o;i+=r+=t[a++],--n;);r%=65521,i%=65521}return(i<<16|r)>>>0},A=function(t,e,n,r){for(var i,o,a,s=t.length/e,l=new Uint8Array(t.length+s),h=T(),u=0;u<s;u++){if(a=u*e,i=t.subarray(a,a+e),r)l.set(r(i,n,o),a+u);else{for(var c=0,f=h.length,p=[];c<f;c++)p[c]=h[c](i,n,o);var d=R(p.concat());l.set(p[d],a+u)}o=i}return l},S=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},j=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},E=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},M=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},O=function(t,e,n){var r,i,o,a,s=[],l=0,h=t.length;for(s[0]=4;l<h;l++)r=t[l-e]||0,i=n&&n[l]||0,o=n&&n[l-e]||0,a=q(r,i,o),s[l+1]=t[l]-a+256&255;return s},q=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},T=function(){return[S,j,E,M,O]},R=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=D(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},D=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},I.processPNG=function(t,e,n,r,i){var o,a,s,l,h,u,c=this.color_spaces.DEVICE_RGB,f=this.decode.FLATE_DECODE,p=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if("function"!=typeof PNG||"function"!=typeof kt)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,p=o.bits,c=o.colorSpace,l=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits)for(var d,g=(_=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*o.colors),y=new Uint8Array(g),v=o.pixelBitlength-o.bits,w=0,b=0;w<g;w++){for(x=_[w],d=0;d<v;)m[b++]=x>>>d&255,d+=o.bits;y[w]=x>>>d&255}if(16===o.bits){g=(_=new Uint32Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*(32/o.pixelBitlength)*o.colors),y=new Uint8Array(g*(32/o.pixelBitlength));for(var x,N=1<o.colors,L=b=w=0;w<g;)x=_[w++],m[b++]=x>>>0&255,N&&(m[b++]=x>>>16&255,x=_[w++],m[b++]=x>>>0&255),y[L++]=x>>>16&255;p=8}r!==I.image_compression.NONE&&C()?(t=B(m,o.width*o.colors,o.colors,r),u=B(y,o.width,1,r)):(t=m,u=y,f=null)}if(3===o.colorType&&(c=this.color_spaces.INDEXED,h=o.palette,o.transparency.indexed)){var A=o.transparency.indexed,S=0;for(w=0,g=A.length;w<g;++w)S+=A[w];if((S/=255)==g-1&&-1!==A.indexOf(0))s=[A.indexOf(0)];else if(S!==g){var _=o.decodePixels();for(y=new Uint8Array(_.length),w=0,g=_.length;w<g;w++)y[w]=A[_[w]];u=B(y,o.width,1)}}var F=function(t){var e;switch(t){case I.image_compression.FAST:e=11;break;case I.image_compression.MEDIUM:e=13;break;case I.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return a=f===this.decode.FLATE_DECODE?"/Predictor "+F+" /Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width:"/Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(u&&this.isArrayBuffer(u)||this.isArrayBufferView(u))&&(u=this.arrayBufferToBinaryString(u)),this.createImageInfo(t,o.width,o.height,c,p,f,e,n,a,s,h,u,F)}throw new Error("Unsupported PNG image data, try using JPEG instead.")},(
	/**
	   * @license
	   * Copyright (c) 2017 Aras Abbasi 
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	U=lt.API).processGIF89A=function(t,e,n,r,i){var o=new At(t),a=o.width,s=o.height,l=[];o.decodeAndBlitFrameRGBA(0,l);var h={data:l,width:a,height:s},u=new _t(100).encode(h,100);return U.processJPEG.call(this,u,e,n,r)},U.processGIF87A=U.processGIF89A,(
	/**
	   * Copyright (c) 2018 Aras Abbasi 
	   *
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	z=lt.API).processBMP=function(t,e,n,r,i){var o=new Ft(t,!1),a=o.width,s=o.height,l={data:o.getData(),width:a,height:s},h=new _t(100).encode(l,100);return z.processJPEG.call(this,h,e,n,r)},lt.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
	/** @license
	   * MIT license.
	   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *
	   * 
	   * ====================================================================
	   */
	H=lt.API,W=H.getCharWidthsArray=function(t,e){var n,r,i,o=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),s=e.charSpace||this.internal.getCharSpace(),l=e.widths?e.widths:o.metadata.Unicode.widths,h=l.fof?l.fof:1,u=e.kerning?e.kerning:o.metadata.Unicode.kerning,c=u.fof?u.fof:1,f=0,p=l[0]||h,d=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),"function"==typeof o.metadata.widthOfString?d.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i))+s*(1e3/a)||0)/1e3):d.push((l[i]||p)/h+(u[i]&&u[i][f]||0)/c),f=i;return d},V=H.getArraySum=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},G=H.getStringUnitWidth=function(t,e){var n=(e=e||{}).fontSize||this.internal.getFontSize(),r=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return"function"==typeof r.metadata.widthOfString?r.metadata.widthOfString(t,n,i)/n:V(W.apply(this,arguments))},Y=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var l=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(l,o)),s=0,l=o),s+=e[o],o++;return l!==o&&i.push(t.slice(l,o)),i},J=function(t,e,n){n||(n={});var r,i,o,a,s,l,h=[],u=[h],c=n.textIndent||0,f=0,p=0,d=t.split(" "),g=W.apply(this,[" ",n])[0];if(l=-1===n.lineIndent?d[0].length+2:n.lineIndent||0){var m=Array(l).join(" "),y=[];d.map(function(t){1<(t=t.split(/\s*\n/)).length?y=y.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):y.push(t[0])}),d=y,l=G.apply(this,[m,n])}for(o=0,a=d.length;o<a;o++){var v=0;if(r=d[o],l&&"\n"==r[0]&&(r=r.substr(1),v=1),i=W.apply(this,[r,n]),e<c+f+(p=V(i))||v){if(e<p){for(s=Y.apply(this,[r,i,e-(c+f),e]),h.push(s.shift()),h=[s.pop()];s.length;)u.push([s.shift()]);p=V(i.slice(r.length-(h[0]?h[0].length:0)))}else h=[r];u.push(h),c=p+l,f=g}else h.push(r),c+=f+p,f=g}if(l)var w=function(t,e){return(e?m:"")+t.join(" ")};else w=function(t){return t.join(" ")};return u.map(w)},H.splitTextToSize=function(t,e,n){var r,i=(n=n||{}).fontSize||this.internal.getFontSize(),o=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{font:r.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var a=1*this.internal.scaleFactor*e/i;o.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,o.lineIndent=n.lineIndent;var s,l,h=[];for(s=0,l=r.length;s<l;s++)h=h.concat(J.apply(this,[r[s],a,o]));return h},
	/** @license
	   jsPDF standard_fonts_metrics plugin
	   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	   * MIT license.
	   * 
	   * ====================================================================
	   */
	X=lt.API,Z={codePages:["WinAnsiEncoding"],WinAnsiEncoding:(K=function(t){for(var e="klmnopqrstuvwxyz",n={},r=0;r<e.length;r++)n[e[r]]="0123456789abcdef"[r];var i,o,a,s,l,h={},u=1,c=h,f=[],p="",d="",g=t.length-1;for(r=1;r!=g;)l=t[r],r+=1,"'"==l?o=o?(s=o.join(""),i):[]:o?o.push(l):"{"==l?(f.push([c,s]),c={},s=i):"}"==l?((a=f.pop())[0][a[1]]=c,s=i,c=a[0]):"-"==l?u=-1:s===i?n.hasOwnProperty(l)?(p+=n[l],s=parseInt(p,16)*u,u=1,p=""):p+=l:n.hasOwnProperty(l)?(d+=n[l],c[s]=parseInt(d,16)*u,u=1,s=i,d=""):d+=l;return h})("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},Q={Unicode:{Courier:Z,"Courier-Bold":Z,"Courier-BoldOblique":Z,"Courier-Oblique":Z,Helvetica:Z,"Helvetica-Bold":Z,"Helvetica-BoldOblique":Z,"Helvetica-Oblique":Z,"Times-Roman":Z,"Times-Bold":Z,"Times-BoldItalic":Z,"Times-Italic":Z}},$={Unicode:{"Courier-Oblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":K("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":K("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:K("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:K("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":K("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":K("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}},X.events.push(["addFont",function(t){var e,n,r,i=t.font,o="Unicode";(e=$[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).widths=e.widths,n.kerning=e.kerning),(r=Q[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).encoding=r).codePages&&r.codePages.length&&(i.encoding=r.codePages[0])}]),
	/**
	   * @license
	   * Licensed under the MIT License.
	   * http://opensource.org/licenses/mit-license
	   */
	tt=lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")(),tt.API.events.push(["addFont",function(t){var e=t.font,n=t.instance;if(void 0!==n&&n.existsFileInVFS(e.postScriptName)){var r=n.getFileFromVFS(e.postScriptName);if("string"!=typeof r)throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').");e.metadata=tt.API.TTFFont.open(e.postScriptName,e.fontName,r,e.encoding),e.metadata.Unicode=e.metadata.Unicode||{encoding:{},kerning:{},widths:[]},e.metadata.glyIdsUsed=[0]}else if(!1===e.isStandardFont)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').")}]),(
	/** @license
	   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	   * 
	   * 
	   * ====================================================================
	   */
	et=lt.API).addSvg=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function o(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var a,s,l,h,u,c,f,p,d=(h=document,p=h.createElement("iframe"),u=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(f=(c=h).createElement("style")).type="text/css",f.styleSheet?f.styleSheet.cssText=u:f.appendChild(c.createTextNode(u)),c.getElementsByTagName("head")[0].appendChild(f),p.name="childframe",p.setAttribute("width",0),p.setAttribute("height",0),p.setAttribute("frameborder","0"),p.setAttribute("scrolling","no"),p.setAttribute("seamless","seamless"),p.setAttribute("class","jsPDF_sillysvg_iframe"),h.body.appendChild(p),p),g=(a=t,(l=((s=d).contentWindow||s.contentDocument).document).write(a),l.close(),l.getElementsByTagName("svg")[0]),m=[1,1],y=parseFloat(g.getAttribute("width")),v=parseFloat(g.getAttribute("height"));y&&v&&(r&&i?m=[r/y,i/v]:r?m=[r/y,r/y]:i&&(m=[i/v,i/v]));var w,b,x,N,L=g.childNodes;for(w=0,b=L.length;w<b;w++)(x=L[w]).tagName&&"PATH"===x.tagName.toUpperCase()&&((N=o(x.getAttribute("d").split(" ")))[0]=N[0]*m[0]+e,N[1]=N[1]*m[1]+n,this.lines.call(this,N[2],N[0],N[1],m));return this},et.addSVG=et.addSvg,et.addSvgAsImage=function(t,e,n,r,i,o,a,s){if(isNaN(e)||isNaN(n))throw console.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(r)||isNaN(i))throw console.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var l=document.createElement("canvas");l.width=r,l.height=i;var h=l.getContext("2d");return h.fillStyle="#fff",h.fillRect(0,0,l.width,l.height),canvg(l,t,{ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0,ignoreClear:!0}),this.addImage(l.toDataURL("image/jpeg",1),e,n,r,i,a,s),this},lt.API.putTotalPages=function(t){var e,n=0;n=parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var r=1;r<=this.internal.getNumberOfPages();r++)for(var i=0;i<this.internal.pages[r].length;i++)this.internal.pages[r][i]=this.internal.pages[r][i].replace(e,n);return this},lt.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},a=Object.keys(o),s=[],l=0,h=0,u=0,c=!0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var p=a.length;for(u=0;u<p;u+=1)n[a[u]].value=n[a[u]].defaultValue,n[a[u]].explicitSet=!1}if("object"===se(t))for(r in t)if(i=t[r],f(a,r)&&void 0!==i){if("boolean"===n[r].type&&"boolean"==typeof i)n[r].value=i;else if("name"===n[r].type&&f(n[r].valueSet,i))n[r].value=i;else if("integer"===n[r].type&&Number.isInteger(i))n[r].value=i;else if("array"===n[r].type){for(l=0;l<i.length;l+=1)if(c=!0,1===i[l].length&&"number"==typeof i[l][0])s.push(String(i[l]-1));else if(1<i[l].length){for(h=0;h<i[l].length;h+=1)"number"!=typeof i[l][h]&&(c=!1);!0===c&&s.push([i[l][0]-1,i[l][1]-1].join(" "))}n[r].value="["+s.join(" ")+"]"}else n[r].value=n[r].defaultValue;n[r].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
	/** ==================================================================== 
	   * jsPDF XMP metadata plugin
	   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
	   * 
	   * 
	   * ====================================================================
	   */
	nt=lt.API,ot=it=rt="",nt.addMetadata=function(t,e){return it=e||"http://jspdf.default.namespaceuri/",rt=t,this.internal.events.subscribe("postPutResources",function(){if(rt){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+it+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(rt)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),o=unescape(encodeURIComponent("</x:xmpmeta>")),a=n.length+r.length+i.length+e.length+o.length;ot=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+a+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+o),this.internal.write("endstream"),this.internal.write("endobj")}else ot=""}),this.internal.events.subscribe("putCatalog",function(){ot&&this.internal.write("/Metadata "+ot+" 0 R")}),this},function(f,t){var e=f.API;var m=e.pdfEscape16=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],o=[""],a=0,s=t.length;a<s;++a){if(n=e.metadata.characterToGlyph(t.charCodeAt(a)),e.metadata.glyIdsUsed.push(n),e.metadata.toUnicode[n]=t.charCodeAt(a),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return o.join("");n=n.toString(16),o.push(i[4-n.length],n)}return o.join("")},p=function(t){var e,n,r,i,o,a,s;for(o="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",r=[],a=0,s=(n=Object.keys(t).sort(function(t,e){return t-e})).length;a<s;a++)e=n[a],100<=r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar",r=[]),i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),r.push("<"+e+"><"+i+">");return r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar\n"),o+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"Identity-H"===t.encoding){for(var i=t.metadata.Unicode.widths,o=t.metadata.subset.encode(t.metadata.glyIdsUsed,1),a="",s=0;s<o.length;s++)a+=String.fromCharCode(o[s]);var l=n();r({data:a,addLength1:!0}),e("endobj");var h=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var u=n();e("<<"),e("/Type /FontDescriptor"),e("/FontName /"+t.fontName),e("/FontFile2 "+l+" 0 R"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/Flags "+t.metadata.flags),e("/StemV "+t.metadata.stemV),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e(">>"),e("endobj");var c=n();e("<<"),e("/Type /Font"),e("/BaseFont /"+t.fontName),e("/FontDescriptor "+u+" 0 R"),e("/W "+f.API.PDFObject.convert(i)),e("/CIDToGIDMap /Identity"),e("/DW 1000"),e("/Subtype /CIDFontType2"),e("/CIDSystemInfo"),e("<<"),e("/Supplement 0"),e("/Registry (Adobe)"),e("/Ordering ("+t.encoding+")"),e(">>"),e(">>"),e("endobj"),t.objectNumber=n(),e("<<"),e("/Type /Font"),e("/Subtype /Type0"),e("/ToUnicode "+h+" 0 R"),e("/BaseFont /"+t.fontName),e("/Encoding /"+t.encoding),e("/DescendantFonts ["+c+" 0 R]"),e(">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"WinAnsiEncoding"===t.encoding){t.metadata.Unicode.widths;for(var i=t.metadata.rawData,o="",a=0;a<i.length;a++)o+=String.fromCharCode(i[a]);var s=n();r({data:o,addLength1:!0}),e("endobj");var l=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var h=n();for(e("<<"),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e("/StemV "+t.metadata.stemV),e("/Type /FontDescriptor"),e("/FontFile2 "+s+" 0 R"),e("/Flags 96"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/FontName /"+t.fontName),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e(">>"),e("endobj"),t.objectNumber=n(),a=0;a<t.metadata.hmtx.widths.length;a++)t.metadata.hmtx.widths[a]=parseInt(t.metadata.hmtx.widths[a]*(1e3/t.metadata.head.unitsPerEm));e("<</Subtype/TrueType/Type/Font/ToUnicode "+l+" 0 R/BaseFont/"+t.fontName+"/FontDescriptor "+h+" 0 R/Encoding/"+t.encoding+" /FirstChar 29 /LastChar 255 /Widths "+f.API.PDFObject.convert(t.metadata.hmtx.widths)+">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);var h=function(t){var e,n,r=t.text||"",i=t.x,o=t.y,a=t.options||{},s=t.mutex||{},l=s.pdfEscape,h=s.activeFontKey,u=s.fonts,c=(s.activeFontSize,""),f=0,p="",d=u[n=h].encoding;if("Identity-H"!==u[n].encoding)return{text:r,x:i,y:o,options:a,mutex:s};for(p=r,n=h,"[object Array]"===Object.prototype.toString.call(r)&&(p=r[0]),f=0;f<p.length;f+=1)u[n].metadata.hasOwnProperty("cmap")&&(e=u[n].metadata.cmap.unicode.codeMap[p[f].charCodeAt(0)]),e?c+=p[f]:p[f].charCodeAt(0)<256&&u[n].metadata.hasOwnProperty("Unicode")?c+=p[f]:c+="";var g="";return parseInt(n.slice(1))<14||"WinAnsiEncoding"===d?g=function(t){for(var e="",n=0;n<t.length;n++)e+=""+t.charCodeAt(n).toString(16);return e}(l(c,n)):"Identity-H"===d&&(g=m(c,u[n])),s.isHex=!0,{text:g,x:i,y:o,options:a,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",n=t.x,r=t.y,i=t.options,o=t.mutex,a=(i.lang,[]),s={text:e,x:n,y:r,options:i,mutex:o};if("[object Array]"===Object.prototype.toString.call(e)){var l=0;for(l=0;l<e.length;l+=1)"[object Array]"===Object.prototype.toString.call(e[l])&&3===e[l].length?a.push([h(Object.assign({},s,{text:e[l][0]})).text,e[l][1],e[l][2]]):a.push(h(Object.assign({},s,{text:e[l]})).text);t.text=a}else t.text=h(Object.assign({},s,{text:e})).text}])}(lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")()),at=lt.API,st=function(t){return void 0!==t&&(void 0===t.vFS&&(t.vFS={}),!0)},at.existsFileInVFS=function(t){return!!st(this.internal)&&void 0!==this.internal.vFS[t]},at.addFileToVFS=function(t,e){return st(this.internal),this.internal.vFS[t]=e,this},at.getFileFromVFS=function(t){return st(this.internal),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null},lt.API.addHTML=function(t,d,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof d&&(s=d,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,y=e.scaleFactor,v=e.pageSize.getWidth(),w=e.pageSize.getHeight();if((s=s||{}).onrendered=function(l){d=parseInt(d)||0,g=parseInt(g)||0;var t=s.dim||{},h=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(w,l.height/y),u=t.w||Math.min(v,l.width/y)-d,c=s.format||"JPEG",f=s.imageCompression||"SLOW";if(l.height>w-h.top-h.bottom&&s.pagesplit){var p=function(t,e,n,r,i){var o=document.createElement("canvas");o.height=i,o.width=r;var a=o.getContext("2d");return a.mozImageSmoothingEnabled=!1,a.webkitImageSmoothingEnabled=!1,a.msImageSmoothingEnabled=!1,a.imageSmoothingEnabled=!1,a.fillStyle=s.backgroundColor||"#ffffff",a.fillRect(0,0,r,i),a.drawImage(t,e,n,r,i,0,0,r,i),o},n=function(){for(var t,e,n=0,r=0,i={},o=!1;;){var a;if(r=0,i.top=0!==n?h.top:g,i.left=0!==n?h.left:d,o=(v-h.left-h.right)*y<l.width,"content"===h.useFor?0===n?(t=Math.min((v-h.left)*y,l.width),e=Math.min((w-h.top)*y,l.height-n)):(t=Math.min(v*y,l.width),e=Math.min(w*y,l.height-n),i.top=0):(t=Math.min((v-h.left-h.right)*y,l.width),e=Math.min((w-h.bottom-h.top)*y,l.height-n)),o)for(;;){"content"===h.useFor&&(0===r?t=Math.min((v-h.left)*y,l.width):(t=Math.min(v*y,l.width-r),i.left=0));var s=[a=p(l,r,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f];if(this.addImage.apply(this,s),(r+=t)>=l.width)break;this.addPage()}else s=[a=p(l,0,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f],this.addImage.apply(this,s);if((n+=e)>=l.height)break;this.addPage()}m(u,n,null,s)}.bind(this);if("CANVAS"===l.nodeName){var r=new Image;r.onload=n,r.src=l.toDataURL("image/png"),l=r}else n()}else{var i=Math.random().toString(35),o=[l,d,g,u,e,c,i,f];this.addImage.apply(this,o),m(u,e,i,o)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"==typeof rasterizeHTML)return null;var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||v*y,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})},
	/**
	   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
	   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	   *               2014 Diego Casorran, https://github.com/diegocr
	   *               2014 Daniel Husar, https://github.com/danielhusar
	   *               2014 Wolfgang Gassler, https://github.com/woolfg
	   *               2014 Steven Spungin, https://github.com/flamenco
	   *
	   * @license
	   * 
	   * ====================================================================
	   */
	function(t){var P,k,i,a,s,l,h,u,I,w,f,c,p,n,C,B,d,g,m,j;P=function(){return function(t){return e.prototype=t,new e};function e(){}}(),w=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,a=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},c=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},p=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[t])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:(e=t.match(/([\d\.]+)(px)/),Array.isArray(e)&&3===e.length?n[t]=parseFloat(e[1])/16:n[t]=1)},I=function(t){var e,n,r,i,o;return o=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(o,null):o.currentStyle?o.currentStyle:o.style,n=void 0,(e={})["font-family"]=c((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=l[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=p(r("font-size"))||1,e["line-height"]=p(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&p(r("margin-top"))||0,e["margin-bottom"]=n&&p(r("margin-bottom"))||0,e["padding-top"]=n&&p(r("padding-top"))||0,e["padding-bottom"]=n&&p(r("padding-bottom"))||0,e["margin-left"]=n&&p(r("margin-left"))||0,e["margin-right"]=n&&p(r("margin-right"))||0,e["padding-left"]=n&&p(r("padding-left"))||0,e["padding-right"]=n&&p(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=h[r("cssFloat")]||"none",e.clear=u[r("clear")]||"none",e.color=r("color"),e},C=function(t,e,n){var r,i,o,a,s;if(o=!1,a=i=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},j=function(t,e){var n,r,i,o,a,s,l,h,u;for(n=[],r=[],i=0,u=t.rows[0].cells.length,l=t.clientWidth;i<u;)h=t.rows[0].cells[i],r[i]={name:h.textContent.toLowerCase().replace(/\s+/g,""),prompt:h.textContent.replace(/\r?\n/g,""),width:h.clientWidth/l*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var E={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},M=1;k=function(t,i,e){var n,r,o,a,s,l,h,u;for(r=t.childNodes,n=void 0,(s="block"===(o=I(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(o)),a=0,l=r.length;a<l;){if("object"===se(n=r[a])){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var c=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,k(c,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||E[n.nodeName])if(3===n.nodeType){var p=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)p=M+++". "+p;else{var d=o["font-size"],g=(3-.75*d)*i.pdf.internal.scaleFactor,m=.75*d*i.pdf.internal.scaleFactor,y=1.74*d/i.pdf.internal.scaleFactor;u=function(t,e){this.pdf.circle(t+g,e+m,y,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(p,o)}else"string"==typeof n&&i.addText(n,o);else{var v;if("IMG"===n.nodeName){var w=n.getAttribute("src");v=B[i.pdf.sHashCode(w)||w]}if(v){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var b=I(n),x=i.x,N=12/i.pdf.internal.scaleFactor,L=(b["margin-left"]+b["padding-left"])*N,A=(b["margin-right"]+b["padding-right"])*N,S=(b["margin-top"]+b["padding-top"])*N,_=(b["margin-bottom"]+b["padding-bottom"])*N;void 0!==b.float&&"right"===b.float?x+=i.settings.width-n.width-A:x+=L,i.pdf.addImage(v,x,i.y+S,n.width,n.height),v=void 0,"right"===b.float||"left"===b.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!E[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===b.float?-n.width-L-A:0,i.y+n.height+S+_,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===I(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+L+A,"left"===b.float&&(i.x+=n.width+L+A)):i.y+=n.height+S+_}else if("TABLE"===n.nodeName)h=j(n,i),i.y+=10,i.pdf.table(i.x,i.y,h.rows,h.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:I(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)M=1,C(n,i,e)||k(n,i,e),i.y+=10;else if("LI"===n.nodeName){var F=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,C(n,i,e)||k(n,i,e),i.x=F}else"BR"===n.nodeName?(i.y+=o["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",P(o))):C(n,i,e)||k(n,i,e)}}a++}if(e.outY=i.y,s)return i.setBlockBoundary(u)},B={},d=function(t,o,e,n){var a,r=t.getElementsByTagName("img"),i=r.length,s=0;function l(){o.pdf.internal.events.publish("imagesLoaded"),n(a)}function h(e,n,r){if(e){var i=new Image;a=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=o.pdf.sHashCode(e)||e;B[t]=B[t]||i}--s||l()},i.src=e}}for(;i--;)h(r[i].getAttribute("src"),r[i].width,r[i].height);return s||l()},g=function(t,o,a){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=o.pdf.internal.write,n=o.y;o.pdf.internal.write=function(){},k(s,o,a);var l=Math.ceil(o.y-n)+5;o.y=n,o.pdf.internal.write=e,o.pdf.margins_doc.bottom+=l;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=o.y;o.y=o.pdf.internal.pageSize.getHeight()-o.pdf.margins_doc.bottom,o.pdf.margins_doc.bottom-=l;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");k(s,o,a),o.pdf.margins_doc.bottom+=l,o.y=n},i=s.getElementsByTagName("span"),h=0;h<i.length;++h)-1<(" "+i[h].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&o.pdf.internal.events.subscribe("htmlRenderingFinished",o.pdf.putTotalPages.bind(o.pdf,"###jsPDFVarTotalPages###"),!0);o.pdf.internal.events.subscribe("addPage",r,!1),r(),E.FOOTER=1}},m=function(t,e,n,r,i,o){if(!e)return!1;var a,s,l,h;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(a=e.replace(/<\/?script[^>]*?>/gi,""),h="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(l=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",l.innerHTML='<iframe style="height:1px;width:1px" name="'+h+'" />',document.body.appendChild(l),(s=window.frames[h]).document.open(),s.document.writeln(a),s.document.close(),e=s.document.body);var u,c=new f(t,n,r,i);return d.call(this,e,c,i.elementHandlers,function(t){g(e,c,i.elementHandlers),k(e,c,i.elementHandlers),c.pdf.internal.events.publish("htmlRenderingFinished"),u=c.dispose(),"function"==typeof o?o(u):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),u||{x:c.x,y:c.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g;for(12,c=this.pdf.internal.scaleFactor,o={},s=l=h=g=a=i=u=r=void 0,p=[f=[]],n=0,d=this.settings.width;t.length;)if(a=t.shift(),g=e.shift(),a)if((i=o[(r=g["font-family"])+(u=g["font-style"])])||(i=this.pdf.internal.getFont(r,u).metadata.Unicode,o[r+u]=i),h={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},l=this.pdf.getStringUnitWidth(a,h)*h.fontSize/c,"\u2028"==a)f=[],p.push(f);else if(d<n+l){for(s=this.pdf.splitTextToSize(a,d,h),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],p.push(f);n=this.pdf.getStringUnitWidth(f[0][0],h)*h.fontSize/c}else f.push([a,g]),n+=l;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<p.length;++m){var y=this.pdf.getStringUnitWidth(p[m][0][0],h)*h.fontSize/c;0<m&&(p[m][0][1]=P(p[m][0][1]));var v=d-y;if("right"===g["text-align"])p[m][0][1]["margin-left"]=v;else if("center"===g["text-align"])p[m][0][1]["margin-left"]=v/2;else if("justify"===g["text-align"]){var w=p[m][0][0].split(" ").length-1;p[m][0][1]["word-spacing"]=v/w,m===p.length-1&&(p[m][0][1]["word-spacing"]=0)}}return p},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=i)e=parseInt(i[1]),n=parseInt(i[2]),r=parseInt(i[3]);else{if("string"==typeof t&&"#"!=t.charAt(0)){var o=new RGBColor(t);t=o.ok?o.toHex():"#000000"}e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)}if("string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;if(r=w(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),l=a=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,c=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,u=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,c=((e["margin-top"]||0)+(e["padding-top"]||0))*n),h=this.pdf.internal.write,o=i=void 0,this.y+=c,h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var d=0;s.length;){for(i=l=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(l=Math.max(l,a[i][1]["line-height"],a[i][1]["font-size"]),p=7*a[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==a[0][1]["margin-left"]&&0<a[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-d,d=m),h(g+Math.max(e["margin-left"]||0,0)*n,(-12*l).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=l*n,this.executeWatchFunctions(a[0][1])&&0<s.length){var y=[],v=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(y.push(t[e][0]+" "),v.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(w(y),v),h("ET","Q"),h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-p/2),h("ET","Q"),this.y+=u}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},l={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},h={none:"none",right:"right",left:"left"},u={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(lt.API),lt.API,("undefined"!=typeof window&&window||"undefined"!=typeof global&&global).html2pdf=function(t,a,e){var n=a.canvas;if(n){var r,i;if((n.pdf=a).annotations={_nameMap:[],createAnnotation:function(t,e){var n,r=a.context2d._wrapX(e.left),i=a.context2d._wrapY(e.top),o=(a.context2d._page(e.top),t.indexOf("#"));n=0<=o?{name:t.substring(o+1)}:{url:t},a.link(r,i,e.right-e.left,e.bottom-e.top,n)},setName:function(t,e){var n=a.context2d._wrapX(e.left),r=a.context2d._wrapY(e.top),i=a.context2d._page(e.top);this._nameMap[t]={page:i,x:n,y:r}}},n.annotations=a.annotations,a.context2d._pageBreakAt=function(t){this.pageBreaks.push(t)},a.context2d._gotoPage=function(t){for(;a.internal.getNumberOfPages()<t;)a.addPage();a.setPage(t)},"string"==typeof t){t=t.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"");var o,s,l=document.createElement("iframe");document.body.appendChild(l),null!=(o=l.contentDocument)&&null!=o||(o=l.contentWindow.document),o.open(),o.write(t),o.close(),r=o.body,s=o.body||{},t=o.documentElement||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight)}else s=(r=t).body||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight);var h={async:!0,allowTaint:!0,backgroundColor:"#ffffff",canvas:n,imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1,windowHeight:i=a.internal.pageSize.getHeight(),scrollY:i};a.context2d.pageWrapYEnabled=!0,a.context2d.pageWrapY=a.internal.pageSize.getHeight(),html2canvas(r,h).then(function(t){e&&(l&&l.parentElement.removeChild(l),e(a))})}else alert("jsPDF canvas plugin not installed")},window.tmp=html2pdf,function(f){var r=f.BlobBuilder||f.WebKitBlobBuilder||f.MSBlobBuilder||f.MozBlobBuilder;f.URL=f.URL||f.webkitURL||function(t,e){return(e=document.createElement("a")).href=t,e};var n=f.Blob,p=URL.createObjectURL,d=URL.revokeObjectURL,o=f.Symbol&&f.Symbol.toStringTag,t=!1,e=!1,g=!!f.ArrayBuffer,i=r&&r.prototype.append&&r.prototype.getBlob;try{t=2===new Blob(["ä"]).size,e=2===new Blob([new Uint8Array([1,2])]).size}catch(t){}function a(t){return t.map(function(t){if(t.buffer instanceof ArrayBuffer){var e=t.buffer;if(t.byteLength!==e.byteLength){var n=new Uint8Array(t.byteLength);n.set(new Uint8Array(e,t.byteOffset,t.byteLength)),e=n.buffer}return e}return t})}function s(t,e){e=e||{};var n=new r;return a(t).forEach(function(t){n.append(t)}),e.type?n.getBlob(e.type):n.getBlob()}function l(t,e){return new n(a(t),e||{})}if(f.Blob&&(s.prototype=Blob.prototype,l.prototype=Blob.prototype),o)try{File.prototype[o]="File",Blob.prototype[o]="Blob",FileReader.prototype[o]="FileReader"}catch(t){}function h(){var t=!!f.ActiveXObject||"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style,e=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;t&&e&&(XMLHttpRequest.prototype.send=function(t){t instanceof Blob&&this.setRequestHeader("Content-Type",t.type),e.call(this,t)});try{new File([],"")}catch(t){try{var n=new Function('class File extends Blob {constructor(chunks, name, opts) {opts = opts || {};super(chunks, opts || {});this.name = name;this.lastModifiedDate = opts.lastModified ? new Date(opts.lastModified) : new Date;this.lastModified = +this.lastModifiedDate;}};return new File([], ""), File')();f.File=n}catch(t){n=function(t,e,n){var r=new Blob(t,n),i=n&&void 0!==n.lastModified?new Date(n.lastModified):new Date;return r.name=e,r.lastModifiedDate=i,r.lastModified=+i,r.toString=function(){return"[object File]"},o&&(r[o]="File"),r};f.File=n}}}t?(h(),f.Blob=e?f.Blob:l):i?(h(),f.Blob=s):function(){function a(t){for(var e=[],n=0;n<t.length;n++){var r=t.charCodeAt(n);r<128?e.push(r):r<2048?e.push(192|r>>6,128|63&r):r<55296||57344<=r?e.push(224|r>>12,128|r>>6&63,128|63&r):(n++,r=65536+((1023&r)<<10|1023&t.charCodeAt(n)),e.push(240|r>>18,128|r>>12&63,128|r>>6&63,128|63&r))}return e}function e(t){var e,n,r,i,o,a;for(e="",r=t.length,n=0;n<r;)switch((i=t[n++])>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:e+=String.fromCharCode(i);break;case 12:case 13:o=t[n++],e+=String.fromCharCode((31&i)<<6|63&o);break;case 14:o=t[n++],a=t[n++],e+=String.fromCharCode((15&i)<<12|(63&o)<<6|(63&a)<<0)}return e}function s(t){for(var e=new Array(t.byteLength),n=new Uint8Array(t),r=e.length;r--;)e[r]=n[r];return e}function n(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",n=[],r=0;r<t.length;r+=3){var i=t[r],o=r+1<t.length,a=o?t[r+1]:0,s=r+2<t.length,l=s?t[r+2]:0,h=i>>2,u=(3&i)<<4|a>>4,c=(15&a)<<2|l>>6,f=63&l;s||(f=64,o||(c=64)),n.push(e[h],e[u],e[c],e[f])}return n.join("")}var t=Object.create||function(t){function e(){}return e.prototype=t,new e};if(g)var r=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],l=ArrayBuffer.isView||function(t){return t&&-1<r.indexOf(Object.prototype.toString.call(t))};function h(t,e){for(var n=0,r=(t=t||[]).length;n<r;n++){var i=t[n];i instanceof h?t[n]=i._buffer:"string"==typeof i?t[n]=a(i):g&&(ArrayBuffer.prototype.isPrototypeOf(i)||l(i))?t[n]=s(i):g&&(o=i)&&DataView.prototype.isPrototypeOf(o)?t[n]=s(i.buffer):t[n]=a(String(i))}var o;this._buffer=[].concat.apply([],t),this.size=this._buffer.length,this.type=e&&e.type||""}function i(t,e,n){var r=h.call(this,t,n=n||{})||this;return r.name=e,r.lastModifiedDate=n.lastModified?new Date(n.lastModified):new Date,r.lastModified=+r.lastModifiedDate,r}if(h.prototype.slice=function(t,e,n){return new h([this._buffer.slice(t||0,e||this._buffer.length)],{type:n})},h.prototype.toString=function(){return"[object Blob]"},(i.prototype=t(h.prototype)).constructor=i,Object.setPrototypeOf)Object.setPrototypeOf(i,h);else try{i.__proto__=h}catch(t){}function o(){if(!(this instanceof o))throw new TypeError("Failed to construct 'FileReader': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");var n=document.createDocumentFragment();this.addEventListener=n.addEventListener,this.dispatchEvent=function(t){var e=this["on"+t.type];"function"==typeof e&&e(t),n.dispatchEvent(t)},this.removeEventListener=n.removeEventListener}function u(t,e,n){if(!(e instanceof h))throw new TypeError("Failed to execute '"+n+"' on 'FileReader': parameter 1 is not of type 'Blob'.");t.result="",setTimeout(function(){this.readyState=o.LOADING,t.dispatchEvent(new Event("load")),t.dispatchEvent(new Event("loadend"))})}i.prototype.toString=function(){return"[object File]"},o.EMPTY=0,o.LOADING=1,o.DONE=2,o.prototype.error=null,o.prototype.onabort=null,o.prototype.onerror=null,o.prototype.onload=null,o.prototype.onloadend=null,o.prototype.onloadstart=null,o.prototype.onprogress=null,o.prototype.readAsDataURL=function(t){u(this,t,"readAsDataURL"),this.result="data:"+t.type+";base64,"+n(t._buffer)},o.prototype.readAsText=function(t){u(this,t,"readAsText"),this.result=e(t._buffer)},o.prototype.readAsArrayBuffer=function(t){u(this,t,"readAsText"),this.result=t._buffer.slice()},o.prototype.abort=function(){},URL.createObjectURL=function(t){return t instanceof h?"data:"+t.type+";base64,"+n(t._buffer):p.call(URL,t)},URL.revokeObjectURL=function(t){d&&d.call(URL,t)};var c=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;c&&(XMLHttpRequest.prototype.send=function(t){t instanceof h?(this.setRequestHeader("Content-Type",t.type),c.call(this,e(t._buffer))):c.call(this,t)}),f.FileReader=o,f.File=i,f.Blob=h}()}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var ht,ut,ct,ft,pt,dt,gt,mt,yt,vt,wt,bt,xt,Nt,Lt,le=le||function(s){if(!(void 0===s||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var t=s.document,l=function(){return s.URL||s.webkitURL||s},h=t.createElementNS("http://www.w3.org/1999/xhtml","a"),u="download"in h,c=/constructor/i.test(s.HTMLElement)||s.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),p=s.setImmediate||s.setTimeout,d=function(t){p(function(){throw t},0)},g=function(t){setTimeout(function(){"string"==typeof t?l().revokeObjectURL(t):t.remove()},4e4)},m=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},r=function(t,n,e){e||(t=m(t));var r,i=this,o="application/octet-stream"===t.type,a=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){d(t)}}}(i,"writestart progress write writeend".split(" "))};if(i.readyState=i.INIT,u)return r=l().createObjectURL(t),void p(function(){var t,e;h.href=r,h.download=n,t=h,e=new MouseEvent("click"),t.dispatchEvent(e),a(),g(r),i.readyState=i.DONE},0);!function(){if((f||o&&c)&&s.FileReader){var e=new FileReader;return e.onloadend=function(){var t=f?e.result:e.result.replace(/^data:[^;]*;/,"data:attachment/file;");s.open(t,"_blank")||(s.location.href=t),t=void 0,i.readyState=i.DONE,a()},e.readAsDataURL(t),i.readyState=i.INIT}r||(r=l().createObjectURL(t)),o?s.location.href=r:s.open(r,"_blank")||(s.location.href=r);i.readyState=i.DONE,a(),g(r)}()},e=r.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=m(t)),navigator.msSaveOrOpenBlob(t,e)}:(e.abort=function(){},e.readyState=e.INIT=0,e.WRITING=1,e.DONE=2,e.error=e.onwritestart=e.onprogress=e.onwrite=e.onabort=e.onerror=e.onwriteend=null,function(t,e,n){return new r(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0);function At(x){var t=0;if(71!==x[t++]||73!==x[t++]||70!==x[t++]||56!==x[t++]||56!=(x[t++]+1&253)||97!==x[t++])throw"Invalid GIF 87a/89a header.";var N=x[t++]|x[t++]<<8,e=x[t++]|x[t++]<<8,n=x[t++],r=n>>7,i=1<<(7&n)+1;x[t++];x[t++];var o=null;r&&(o=t,t+=3*i);var a=!0,s=[],l=0,h=null,u=0,c=null;for(this.width=N,this.height=e;a&&t<x.length;)switch(x[t++]){case 33:switch(x[t++]){case 255:if(11!==x[t]||78==x[t+1]&&69==x[t+2]&&84==x[t+3]&&83==x[t+4]&&67==x[t+5]&&65==x[t+6]&&80==x[t+7]&&69==x[t+8]&&50==x[t+9]&&46==x[t+10]&&48==x[t+11]&&3==x[t+12]&&1==x[t+13]&&0==x[t+16])t+=14,c=x[t++]|x[t++]<<8,t++;else for(t+=12;;){if(0===(A=x[t++]))break;t+=A}break;case 249:if(4!==x[t++]||0!==x[t+4])throw"Invalid graphics extension block.";var f=x[t++];l=x[t++]|x[t++]<<8,h=x[t++],0==(1&f)&&(h=null),u=f>>2&7,t++;break;case 254:for(;;){if(0===(A=x[t++]))break;t+=A}break;default:throw"Unknown graphic control label: 0x"+x[t-1].toString(16)}break;case 44:var p=x[t++]|x[t++]<<8,d=x[t++]|x[t++]<<8,g=x[t++]|x[t++]<<8,m=x[t++]|x[t++]<<8,y=x[t++],v=y>>6&1,w=o,b=!1;if(y>>7){b=!0;w=t,t+=3*(1<<(7&y)+1)}var L=t;for(t++;;){var A;if(0===(A=x[t++]))break;t+=A}s.push({x:p,y:d,width:g,height:m,has_local_palette:b,palette_offset:w,data_offset:L,data_length:t-L,transparent_index:h,interlaced:!!v,delay:l,disposal:u});break;case 59:a=!1;break;default:throw"Unknown gif block: 0x"+x[t-1].toString(16)}this.numFrames=function(){return s.length},this.loopCount=function(){return c},this.frameInfo=function(t){if(t<0||t>=s.length)throw"Frame index out of range.";return s[t]},this.decodeAndBlitFrameBGRA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=b,e[f++]=w,e[f++]=v,e[f++]=255}--h}},this.decodeAndBlitFrameRGBA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=v,e[f++]=w,e[f++]=b,e[f++]=255}--h}}}function St(t,e,n,r){for(var i=t[e++],o=1<<i,a=o+1,s=a+1,l=i+1,h=(1<<l)-1,u=0,c=0,f=0,p=t[e++],d=new Int32Array(4096),g=null;;){for(;u<16&&0!==p;)c|=t[e++]<<u,u+=8,1===p?p=t[e++]:--p;if(u<l)break;var m=c&h;if(c>>=l,u-=l,m!==o){if(m===a)break;for(var y=m<s?m:g,v=0,w=y;o<w;)w=d[w]>>8,++v;var b=w;if(r<f+v+(y!==m?1:0))return void console.log("Warning, gif stream longer than expected.");n[f++]=b;var x=f+=v;for(y!==m&&(n[f++]=b),w=y;v--;)w=d[w],n[--x]=255&w,w>>=8;null!==g&&s<4096&&(d[s++]=g<<8|b,h+1<=s&&l<12&&(++l,h=h<<1|1)),g=m}else s=a+1,h=(1<<(l=i+1))-1,g=null}return f!==r&&console.log("Warning, gif stream shorter than expected."),n}try{exports.GifWriter=function(y,t,e,n){var v=0,r=void 0===(n=void 0===n?{}:n).loop?null:n.loop,w=void 0===n.palette?null:n.palette;if(t<=0||e<=0||65535<t||65535<e)throw"Width/Height invalid.";function b(t){var e=t.length;if(e<2||256<e||e&e-1)throw"Invalid code/color length, must be power of 2 and 2 .. 256.";return e}y[v++]=71,y[v++]=73,y[v++]=70,y[v++]=56,y[v++]=57,y[v++]=97;var i=0,o=0;if(null!==w){for(var a=b(w);a>>=1;)++i;if(a=1<<i,--i,void 0!==n.background){if(a<=(o=n.background))throw"Background index out of range.";if(0===o)throw"Background index explicitly passed as 0."}}if(y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=(null!==w?128:0)|i,y[v++]=o,y[v++]=0,null!==w)for(var s=0,l=w.length;s<l;++s){var h=w[s];y[v++]=h>>16&255,y[v++]=h>>8&255,y[v++]=255&h}if(null!==r){if(r<0||65535<r)throw"Loop count invalid.";y[v++]=33,y[v++]=255,y[v++]=11,y[v++]=78,y[v++]=69,y[v++]=84,y[v++]=83,y[v++]=67,y[v++]=65,y[v++]=80,y[v++]=69,y[v++]=50,y[v++]=46,y[v++]=48,y[v++]=3,y[v++]=1,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=0}var x=!1;this.addFrame=function(t,e,n,r,i,o){if(!0===x&&(--v,x=!1),o=void 0===o?{}:o,t<0||e<0||65535<t||65535<e)throw"x/y invalid.";if(n<=0||r<=0||65535<n||65535<r)throw"Width/Height invalid.";if(i.length<n*r)throw"Not enough pixels for the frame size.";var a=!0,s=o.palette;if(null==s&&(a=!1,s=w),null==s)throw"Must supply either a local or global palette.";for(var l=b(s),h=0;l>>=1;)++h;l=1<<h;var u=void 0===o.delay?0:o.delay,c=void 0===o.disposal?0:o.disposal;if(c<0||3<c)throw"Disposal out of range.";var f=!1,p=0;if(void 0!==o.transparent&&null!==o.transparent&&(f=!0,(p=o.transparent)<0||l<=p))throw"Transparent color index.";if((0!==c||f||0!==u)&&(y[v++]=33,y[v++]=249,y[v++]=4,y[v++]=c<<2|(!0===f?1:0),y[v++]=255&u,y[v++]=u>>8&255,y[v++]=p,y[v++]=0),y[v++]=44,y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=255&n,y[v++]=n>>8&255,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=!0===a?128|h-1:0,!0===a)for(var d=0,g=s.length;d<g;++d){var m=s[d];y[v++]=m>>16&255,y[v++]=m>>8&255,y[v++]=255&m}v=function(e,n,t,r){e[n++]=t;var i=n++,o=1<<t,a=o-1,s=o+1,l=s+1,h=t+1,u=0,c=0;function f(t){for(;t<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++)}function p(t){c|=t<<u,u+=h,f(8)}var d=r[0]&a,g={};p(o);for(var m=1,y=r.length;m<y;++m){var v=r[m]&a,w=d<<8|v,b=g[w];if(void 0===b){for(c|=d<<u,u+=h;8<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++);4096===l?(p(o),l=s+1,h=t+1,g={}):(1<<h<=l&&++h,g[w]=l++),d=v}else d=b}return p(d),p(s),f(1),i+1===n?e[i]=0:(e[i]=n-i-1,e[n++]=0),n}(y,v,h<2?2:h,i)},this.end=function(){return!1===x&&(y[v++]=59,x=!0),v}},exports.GifReader=At}catch(t){}
	/*
	    Copyright (c) 2008, Adobe Systems Incorporated
	    All rights reserved.
	
	    Redistribution and use in source and binary forms, with or without 
	    modification, are permitted provided that the following conditions are
	    met:
	
	    * Redistributions of source code must retain the above copyright notice, 
	      this list of conditions and the following disclaimer.
	    
	    * Redistributions in binary form must reproduce the above copyright
	      notice, this list of conditions and the following disclaimer in the 
	      documentation and/or other materials provided with the distribution.
	    
	    * Neither the name of Adobe Systems Incorporated nor the names of its 
	      contributors may be used to endorse or promote products derived from 
	      this software without specific prior written permission.
	
	    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
	    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
	    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
	    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
	    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
	    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	  */
	function _t(t){var N,L,A,S,e,c=Math.floor,_=new Array(64),F=new Array(64),P=new Array(64),k=new Array(64),y=new Array(65535),v=new Array(65535),Z=new Array(64),w=new Array(64),I=[],C=0,B=7,j=new Array(64),E=new Array(64),M=new Array(64),n=new Array(256),O=new Array(2048),b=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],q=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],T=[0,1,2,3,4,5,6,7,8,9,10,11],R=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],D=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],U=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],z=[0,1,2,3,4,5,6,7,8,9,10,11],H=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],W=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function r(t,e){for(var n=0,r=0,i=new Array,o=1;o<=16;o++){for(var a=1;a<=t[o];a++)i[e[r]]=[],i[e[r]][0]=n,i[e[r]][1]=o,r++,n++;n*=2}return i}function V(t){for(var e=t[0],n=t[1]-1;0<=n;)e&1<<n&&(C|=1<<B),n--,--B<0&&(255==C?(G(255),G(0)):G(C),B=7,C=0)}function G(t){I.push(t)}function Y(t){G(t>>8&255),G(255&t)}function J(t,e,n,r,i){for(var o,a=i[0],s=i[240],l=function(t,e){var n,r,i,o,a,s,l,h,u,c,f=0;for(u=0;u<8;++u){n=t[f],r=t[f+1],i=t[f+2],o=t[f+3],a=t[f+4],s=t[f+5],l=t[f+6];var p=n+(h=t[f+7]),d=n-h,g=r+l,m=r-l,y=i+s,v=i-s,w=o+a,b=o-a,x=p+w,N=p-w,L=g+y,A=g-y;t[f]=x+L,t[f+4]=x-L;var S=.707106781*(A+N);t[f+2]=N+S,t[f+6]=N-S;var _=.382683433*((x=b+v)-(A=m+d)),F=.5411961*x+_,P=1.306562965*A+_,k=.707106781*(L=v+m),I=d+k,C=d-k;t[f+5]=C+F,t[f+3]=C-F,t[f+1]=I+P,t[f+7]=I-P,f+=8}for(u=f=0;u<8;++u){n=t[f],r=t[f+8],i=t[f+16],o=t[f+24],a=t[f+32],s=t[f+40],l=t[f+48];var B=n+(h=t[f+56]),j=n-h,E=r+l,M=r-l,O=i+s,q=i-s,T=o+a,R=o-a,D=B+T,U=B-T,z=E+O,H=E-O;t[f]=D+z,t[f+32]=D-z;var W=.707106781*(H+U);t[f+16]=U+W,t[f+48]=U-W;var V=.382683433*((D=R+q)-(H=M+j)),G=.5411961*D+V,Y=1.306562965*H+V,J=.707106781*(z=q+M),X=j+J,K=j-J;t[f+40]=K+G,t[f+24]=K-G,t[f+8]=X+Y,t[f+56]=X-Y,f++}for(u=0;u<64;++u)c=t[u]*e[u],Z[u]=0<c?c+.5|0:c-.5|0;return Z}(t,e),h=0;h<64;++h)w[b[h]]=l[h];var u=w[0]-n;n=w[0],0==u?V(r[0]):(V(r[v[o=32767+u]]),V(y[o]));for(var c=63;0<c&&0==w[c];c--);if(0==c)return V(a),n;for(var f,p=1;p<=c;){for(var d=p;0==w[p]&&p<=c;++p);var g=p-d;if(16<=g){f=g>>4;for(var m=1;m<=f;++m)V(s);g&=15}o=32767+w[p],V(i[(g<<4)+v[o]]),V(y[o]),p++}return 63!=c&&V(a),n}function X(t){if(t<=0&&(t=1),100<t&&(t=100),e!=t){(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],n=0;n<64;n++){var r=c((e[n]*t+50)/100);r<1?r=1:255<r&&(r=255),_[b[n]]=r}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],o=0;o<64;o++){var a=c((i[o]*t+50)/100);a<1?a=1:255<a&&(a=255),F[b[o]]=a}for(var s=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],l=0,h=0;h<8;h++)for(var u=0;u<8;u++)P[l]=1/(_[b[l]]*s[h]*s[u]*8),k[l]=1/(F[b[l]]*s[h]*s[u]*8),l++})(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),e=t}}this.encode=function(t,e){var n,r;(new Date).getTime();e&&X(e),I=new Array,C=0,B=7,Y(65496),Y(65504),Y(16),G(74),G(70),G(73),G(70),G(0),G(1),G(1),G(0),Y(1),Y(1),G(0),G(0),function(){Y(65499),Y(132),G(0);for(var t=0;t<64;t++)G(_[t]);G(1);for(var e=0;e<64;e++)G(F[e])}(),n=t.width,r=t.height,Y(65472),Y(17),G(8),Y(r),Y(n),G(3),G(1),G(17),G(0),G(2),G(17),G(1),G(3),G(17),G(1),function(){Y(65476),Y(418),G(0);for(var t=0;t<16;t++)G(q[t+1]);for(var e=0;e<=11;e++)G(T[e]);G(16);for(var n=0;n<16;n++)G(R[n+1]);for(var r=0;r<=161;r++)G(D[r]);G(1);for(var i=0;i<16;i++)G(U[i+1]);for(var o=0;o<=11;o++)G(z[o]);G(17);for(var a=0;a<16;a++)G(H[a+1]);for(var s=0;s<=161;s++)G(W[s])}(),Y(65498),Y(12),G(3),G(1),G(0),G(2),G(17),G(3),G(17),G(0),G(63),G(0);var i=0,o=0,a=0;C=0,B=7,this.encode.displayName="_encode_";for(var s,l,h,u,c,f,p,d,g,m=t.data,y=t.width,v=t.height,w=4*y,b=0;b<v;){for(s=0;s<w;){for(f=c=w*b+s,p=-1,g=d=0;g<64;g++)f=c+(d=g>>3)*w+(p=4*(7&g)),v<=b+d&&(f-=w*(b+1+d-v)),w<=s+p&&(f-=s+p-w+4),l=m[f++],h=m[f++],u=m[f++],j[g]=(O[l]+O[h+256>>0]+O[u+512>>0]>>16)-128,E[g]=(O[l+768>>0]+O[h+1024>>0]+O[u+1280>>0]>>16)-128,M[g]=(O[l+1280>>0]+O[h+1536>>0]+O[u+1792>>0]>>16)-128;i=J(j,P,i,N,A),o=J(E,k,o,L,S),a=J(M,k,a,L,S),s+=32}b+=8}if(0<=B){var x=[];x[1]=B+1,x[0]=(1<<B+1)-1,V(x)}return Y(65497),new Uint8Array(I)},function(){(new Date).getTime();t||(t=50),function(){for(var t=String.fromCharCode,e=0;e<256;e++)n[e]=t(e)}(),N=r(q,T),L=r(U,z),A=r(R,D),S=r(H,W),function(){for(var t=1,e=2,n=1;n<=15;n++){for(var r=t;r<e;r++)v[32767+r]=n,y[32767+r]=[],y[32767+r][1]=n,y[32767+r][0]=r;for(var i=-(e-1);i<=-t;i++)v[32767+i]=n,y[32767+i]=[],y[32767+i][1]=n,y[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)O[t]=19595*t,O[t+256>>0]=38470*t,O[t+512>>0]=7471*t+32768,O[t+768>>0]=-11059*t,O[t+1024>>0]=-21709*t,O[t+1280>>0]=32768*t+8421375,O[t+1536>>0]=-27439*t,O[t+1792>>0]=-5329*t}(),X(t),(new Date).getTime()}()}function Ft(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}window.tmp=At,lt.API.adler32cs=(dt="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,gt=null,mt=function(){if(!dt)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(gt=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==gt&&t instanceof gt}}(),yt=null!==gt?function(t){return new gt(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},vt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+(255&e.charCodeAt(i)))%65521,r=(r+n)%65521;return(r<<16|n)>>>0},wt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+e[i])%65521,r=(r+n)%65521;return(r<<16|n)>>>0},xt=(bt={}).Adler32=(((pt=(ft=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0}).prototype={}).constructor=ft).from=((ht=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=vt(1,t.toString())}).prototype=pt,ht),ft.fromUtf8=((ut=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());this.checksum=vt(1,e)}).prototype=pt,ut),dt&&(ft.fromBuffer=((ct=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(1,e)}).prototype=pt,ct)),pt.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=vt(this.checksum,t)},pt.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return this.checksum=vt(this.checksum,e)},dt&&(pt.updateBuffer=function(t){if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(this.checksum,e)}),pt.clone=function(){return new xt(this.checksum)},ft),bt.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return vt(1,t.toString())},bt.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return vt(1,e)},dt&&(bt.fromBuffer=function(t){if(!mt(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return wt(1,e)}),bt),function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var d,g,c,f,i,o,a,s=e,m=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],y=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],v={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},l={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},h=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],u=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),w=!1,b=0;this.__bidiEngine__={};var x=function(t){var e=t.charCodeAt(),n=e>>8,r=l[n];return void 0!==r?s[256*r+(255&e)]:252===n||253===n?"AL":u.test(n)?"L":8===n?"R":"N"},p=function(t){for(var e,n=0;n<t.length;n++){if("L"===(e=x(t.charAt(n))))return!1;if("R"===e)return!0}return!1},N=function(t,e,n,r){var i,o,a,s,l=e[r];switch(l){case"L":case"R":w=!1;break;case"N":case"AN":break;case"EN":w&&(l="AN");break;case"AL":w=!0,l="R";break;case"WS":l="N";break;case"CS":r<1||r+1>=e.length||"EN"!==(i=n[r-1])&&"AN"!==i||"EN"!==(o=e[r+1])&&"AN"!==o?l="N":w&&(o="AN"),l=o===i?o:"N";break;case"ES":l="EN"===(i=0<r?n[r-1]:"B")&&r+1<e.length&&"EN"===e[r+1]?"EN":"N";break;case"ET":if(0<r&&"EN"===n[r-1]){l="EN";break}if(w){l="N";break}for(a=r+1,s=e.length;a<s&&"ET"===e[a];)a++;l=a<s&&"EN"===e[a]?"EN":"N";break;case"NSM":if(c&&!f){for(s=e.length,a=r+1;a<s&&"NSM"===e[a];)a++;if(a<s){var h=t[r],u=1425<=h&&h<=2303||64286===h;if(i=e[a],u&&("R"===i||"AL"===i)){l="R";break}}}l=r<1||"B"===(i=e[r-1])?"N":n[r-1];break;case"B":d=!(w=!1),l=b;break;case"S":g=!0,l="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":w=!1;break;case"BN":l="N"}return l},L=function(t,e,n){var r=t.split("");return n&&A(r,n,{hiLevel:b}),r.reverse(),e&&e.reverse(),r.join("")},A=function(t,e,n){var r,i,o,a,s,l=-1,h=t.length,u=0,c=[],f=b?y:m,p=[];for(g=d=w=!1,i=0;i<h;i++)p[i]=x(t[i]);for(o=0;o<h;o++){if(s=u,c[o]=N(t,p,c,o),r=240&(u=f[s][v[c[o]]]),u&=15,e[o]=a=f[u][5],0<r)if(16===r){for(i=l;i<o;i++)e[i]=1;l=-1}else l=-1;if(f[u][6])-1===l&&(l=o);else if(-1<l){for(i=l;i<o;i++)e[i]=a;l=-1}"B"===p[o]&&(e[o]=0),n.hiLevel|=a}g&&function(t,e,n){for(var r=0;r<n;r++)if("S"===t[r]){e[r]=b;for(var i=r-1;0<=i&&"WS"===t[i];i--)e[i]=b}}(p,e,h)},S=function(t,e,n,r,i){if(!(i.hiLevel<t)){if(1===t&&1===b&&!d)return e.reverse(),void(n&&n.reverse());for(var o,a,s,l,h=e.length,u=0;u<h;){if(r[u]>=t){for(s=u+1;s<h&&r[s]>=t;)s++;for(l=u,a=s-1;l<a;l++,a--)o=e[l],e[l]=e[a],e[a]=o,n&&(o=n[l],n[l]=n[a],n[a]=o);u=s}u++}}},_=function(t,e,n){var r=t.split(""),i={hiLevel:b};return n||(n=[]),A(r,n,i),function(t,e,n){if(0!==n.hiLevel&&a)for(var r,i=0;i<t.length;i++)1===e[i]&&0<=(r=h.indexOf(t[i]))&&(t[i]=h[r+1])}(r,n,i),S(2,r,e,n,i),S(1,r,e,n,i),r.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,n){if(function(t,e){if(e)for(var n=0;n<t.length;n++)e[n]=n;void 0===f&&(f=p(t)),void 0===o&&(o=p(t))}(t,e),c||!i||o)if(c&&i&&f^o)b=f?1:0,t=L(t,e,n);else if(!c&&i&&o)b=f?1:0,t=_(t,e,n),t=L(t,e);else if(!c||f||i||o){if(c&&!i&&f^o)t=L(t,e),t=f?(b=0,_(t,e,n)):(b=1,t=_(t,e,n),L(t,e));else if(c&&f&&!i&&o)b=1,t=_(t,e,n),t=L(t,e);else if(!c&&!i&&f^o){var r=a;f?(b=1,t=_(t,e,n),b=0,a=!1,t=_(t,e,n),a=r):(b=0,t=_(t,e,n),t=L(t,e),a=!(b=1),t=_(t,e,n),a=r,t=L(t,e))}}else b=0,t=_(t,e,n);else b=f?1:0,t=_(t,e,n);return t},this.__bidiEngine__.setOptions=function(t){t&&(c=t.isInputVisual,i=t.isOutputVisual,f=t.isInputRtl,o=t.isOutputRtl,a=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],o=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([o.doBidiReorder(e[i][0]),e[i][1],e[i][2]]):r.push([o.doBidiReorder(e[i])]);t.text=r}else t.text=o.doBidiReorder(e)}])}(lt),window.tmp=_t,Ft.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var n=this.datav.getUint8(this.pos++,!0),r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:r,blue:n,quad:o}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},Ft.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){console.log("bit decode error:"+t)}},Ft.prototype.bit1=function(){var t=Math.ceil(this.width/8),e=t%4,n=0<=this.height?this.height-1:-this.height;for(n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++)for(var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var l=this.palette[o>>7-s&1];this.data[a+4*s]=l.blue,this.data[a+4*s+1]=l.green,this.data[a+4*s+2]=l.red,this.data[a+4*s+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++){var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+2*i*4,s=o>>4,l=15&o,h=this.palette[s];if(this.data[a]=h.blue,this.data[a+1]=h.green,this.data[a+2]=h.red,this.data[a+3]=255,2*i+1>=this.width)break;h=this.palette[l],this.data[a+4]=h.blue,this.data[a+4+1]=h.green,this.data[a+4+2]=h.red,this.data[a+4+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;0<=e;e--){for(var n=this.bottom_up?e:this.height-1-e,r=0;r<this.width;r++){var i=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+4*r;if(i<this.palette.length){var a=this.palette[i];this.data[o]=a.red,this.data[o+1]=a.green,this.data[o+2]=a.blue,this.data[o+3]=255}else this.data[o]=255,this.data[o+1]=255,this.data[o+2]=255,this.data[o+3]=255}0!=t&&(this.pos+=4-t)}},Ft.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<this.width;i++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var a=(o&e)/e*255|0,s=(o>>5&e)/e*255|0,l=(o>>10&e)/e*255|0,h=o>>15?255:0,u=r*this.width*4+4*i;this.data[u]=l,this.data[u+1]=s,this.data[u+2]=a,this.data[u+3]=h}this.pos+=t}},Ft.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),n=parseInt("111111",2),r=this.height-1;0<=r;r--){for(var i=this.bottom_up?r:this.height-1-r,o=0;o<this.width;o++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(a&e)/e*255|0,l=(a>>5&n)/n*255|0,h=(a>>11)/e*255|0,u=i*this.width*4+4*o;this.data[u]=h,this.data[u+1]=l,this.data[u+2]=s,this.data[u+3]=255}this.pos+=t}},Ft.prototype.bit24=function(){for(var t=this.height-1;0<=t;t--){for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=e*this.width*4+4*n;this.data[a]=o,this.data[a+1]=i,this.data[a+2]=r,this.data[a+3]=255}this.pos+=this.width%4}},Ft.prototype.bit32=function(){for(var t=this.height-1;0<=t;t--)for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*n;this.data[s]=o,this.data[s+1]=i,this.data[s+2]=r,this.data[s+3]=a}},Ft.prototype.getData=function(){return this.data},window.tmp=Ft,
	/*
	   Copyright (c) 2013 Gildas Lormeau. All rights reserved.
	
	   Redistribution and use in source and binary forms, with or without
	   modification, are permitted provided that the following conditions are met:
	
	   1. Redistributions of source code must retain the above copyright notice,
	   this list of conditions and the following disclaimer.
	
	   2. Redistributions in binary form must reproduce the above copyright 
	   notice, this list of conditions and the following disclaimer in 
	   the documentation and/or other materials provided with the distribution.
	
	   3. The names of the authors may not be used to endorse or promote products
	   derived from this software without specific prior written permission.
	
	   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
	   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
	   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
	   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
	   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
	   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	   */
	function(t){var d=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ct(){var p=this;function l(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}p.build_tree=function(t){var e,n,r,i=p.dyn_tree,o=p.stat_desc.static_tree,a=p.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<a;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,o&&(t.static_len-=o[2*r+1]);for(p.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=a;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,o,a,s=p.dyn_tree,l=p.stat_desc.static_tree,h=p.stat_desc.extra_bits,u=p.stat_desc.extra_base,c=p.stat_desc.max_length,f=0;for(i=0;i<=d;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)c<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=c,f++),s[2*n+1]=i,n>p.max_code||(t.bl_count[i]++,o=0,u<=n&&(o=h[n-u]),a=s[2*n],t.opt_len+=a*(i+o),l&&(t.static_len+=a*(l[2*n+1]+o)));if(0!==f){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,f-=2}while(0<f);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>p.max_code||(s[2*r+1]!=i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,o,a=[],s=0;for(r=1;r<=d;r++)a[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(o=t[2*i+1])&&(t[2*i]=l(a[o]++,o))}(i,p.max_code,t.bl_count)}}function ft(t,e,n,r,i){this.static_tree=t,this.extra_bits=e,this.extra_base=n,this.elems=r,this.max_length=i}ct._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ct.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ct.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ct.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ct.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ct.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ct.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ct.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ct.extra_lbits,257,286,d),ft.static_d_desc=new ft(ft.static_dtree,ct.extra_dbits,0,30,d),ft.static_bl_desc=new ft(null,ct.extra_blbits,0,19,7);function n(t,e,n,r,i){this.good_length=t,this.max_lazy=e,this.nice_length=n,this.max_chain=r,this.func=i}var pt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],dt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""];function gt(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function r(){var l,h,u,c,f,p,d,g,i,m,y,v,w,a,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,s,O,q,T,R,D,U,o,z,H,W,V=this,G=new ct,Y=new ct,J=new ct;function X(){var t;for(t=0;t<286;t++)s[2*t]=0;for(t=0;t<30;t++)O[2*t]=0;for(t=0;t<19;t++)q[2*t]=0;s[512]=1,V.opt_len=V.static_len=0,D=o=0}function K(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<l?q[2*r]+=a:0!==r?(r!=i&&q[2*r]++,q[32]++):a<=10?q[34]++:q[36]++,i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4))}function Z(t){V.pending_buf[V.pending++]=t}function Q(t){Z(255&t),Z(t>>>8&255)}function $(t,e){var n,r=e;16-r<W?(Q(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;$(65535&e[n],65535&e[n+1])}function et(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<l)for(;tt(r,q),0!=--a;);else 0!==r?(r!=i&&(tt(r,q),a--),tt(16,q),$(a-3,2)):a<=10?(tt(17,q),$(a-3,3)):(tt(18,q),$(a-11,7));i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4)}}function nt(){16==W?(Q(H),W=H=0):8<=W&&(Z(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(V.pending_buf[U+2*D]=t>>>8&255,V.pending_buf[U+2*D+1]=255&t,V.pending_buf[T+D]=255&e,D++,0===t?s[2*e]++:(o++,t--,s[2*(ct._length_code[e]+256+1)]++,O[2*ct.d_code(t)]++),0==(8191&D)&&2<B){for(n=8*D,r=_-N,i=0;i<30;i++)n+=O[2*i]*(5+ct.extra_dbits[i]);if(n>>>=3,o<Math.floor(D/2)&&n<Math.floor(r/2))return!0}return D==R-1}function it(t,e){var n,r,i,o,a=0;if(0!==D)for(;n=V.pending_buf[U+2*a]<<8&65280|255&V.pending_buf[U+2*a+1],r=255&V.pending_buf[T+a],a++,0===n?tt(r,t):(tt((i=ct._length_code[r])+256+1,t),0!==(o=ct.extra_lbits[i])&&$(r-=ct.base_length[i],o),tt(i=ct.d_code(--n),e),0!==(o=ct.extra_dbits[i])&&$(n-=ct.base_dist[i],o)),a<D;);tt(256,t),z=t[513]}function ot(){8<W?Q(H):0<W&&Z(255&H),W=H=0}function at(t,e,n){var r,i,o;$(0+(n?1:0),3),r=t,i=e,o=!0,ot(),z=8,o&&(Q(i),Q(~i)),V.pending_buf.set(g.subarray(r,r+i),V.pending),V.pending+=i}function e(t,e,n){var r,i,o=0;0<B?(G.build_tree(V),Y.build_tree(V),o=function(){var t;for(K(s,G.max_code),K(O,Y.max_code),J.build_tree(V),t=18;3<=t&&0===q[2*ct.bl_order[t]+1];t--);return V.opt_len+=3*(t+1)+5+5+4,t}(),r=V.opt_len+3+7>>>3,(i=V.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!=t?at(t,e,n):i==r?($(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):($(4+(n?1:0),3),function(t,e,n){var r;for($(t-257,5),$(e-1,5),$(n-4,4),r=0;r<n;r++)$(q[2*ct.bl_order[r]+1],3);et(s,t-1),et(O,e-1)}(G.max_code+1,Y.max_code+1,o+1),it(s,O)),X(),n&&ot()}function st(t){e(0<=N?N:-1,_-N,t),N=_,l.flush_pending()}function lt(){var t,e,n,r;do{if(0===(r=i-P-_)&&0===_&&0===P)r=f;else if(-1==r)r--;else if(f+f-262<=_){for(g.set(g.subarray(f,f+f),0),F-=f,_-=f,N-=f,n=t=w;e=65535&y[--n],y[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===l.avail_in)return;t=l.read_buf(g,_+P,r),3<=(P+=t)&&(v=((v=255&g[_])<<x^255&g[_+1])&b)}while(P<262&&0!==l.avail_in)}function ht(t){var e,n,r=I,i=_,o=k,a=f-262<_?_-(f-262):0,s=M,l=d,h=_+258,u=g[i+o-1],c=g[i+o];E<=k&&(r>>=2),P<s&&(s=P);do{if(g[(e=t)+o]==c&&g[e+o-1]==u&&g[e]==g[i]&&g[++e]==g[i+1]){i+=2,e++;do{}while(g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&i<h);if(n=258-(h-i),i=h-258,o<n){if(F=t,s<=(o=n))break;u=g[i+o-1],c=g[i+o]}}}while((t=65535&m[t&l])>a&&0!=--r);return o<=P?o:P}function ut(t){return t.total_in=t.total_out=0,t.msg=null,V.pending=0,V.pending_out=0,h=113,c=0,G.dyn_tree=s,G.stat_desc=ft.static_l_desc,Y.dyn_tree=O,Y.stat_desc=ft.static_d_desc,J.dyn_tree=q,J.stat_desc=ft.static_bl_desc,W=H=0,z=8,X(),function(){var t;for(i=2*f,t=y[w-1]=0;t<w-1;t++)y[t]=0;C=pt[B].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain,L=k=2,v=S=P=N=_=0}(),0}V.depth=[],V.bl_count=[],V.heap=[],s=[],O=[],q=[],V.pqdownheap=function(t,e){for(var n=V.heap,r=n[e],i=e<<1;i<=V.heap_len&&(i<V.heap_len&&gt(t,n[i+1],n[i],V.depth)&&i++,!gt(t,r,n[i],V.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},V.deflateInit=function(t,e,n,r,i,o){return r||(r=8),i||(i=8),o||(o=0),t.msg=null,-1==e&&(e=6),i<1||9<i||8!=r||n<9||15<n||e<0||9<e||o<0||2<o?-2:(t.dstate=V,d=(f=1<<(p=n))-1,b=(w=1<<(a=i+7))-1,x=Math.floor((a+3-1)/3),g=new Uint8Array(2*f),m=[],y=[],R=1<<i+6,V.pending_buf=new Uint8Array(4*R),u=4*R,U=Math.floor(R/2),T=3*R,B=e,j=o,ut(t))},V.deflateEnd=function(){return 42!=h&&113!=h&&666!=h?-2:(V.pending_buf=null,g=m=y=null,V.dstate=null,113==h?-3:0)},V.deflateParams=function(t,e,n){var r=0;return-1==e&&(e=6),e<0||9<e||n<0||2<n?-2:(pt[B].func!=pt[e].func&&0!==t.total_in&&(r=t.deflate(1)),B!=e&&(C=pt[B=e].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain),j=n,r)},V.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||42!=h)return-2;if(i<3)return 0;for(f-262<i&&(o=n-(i=f-262)),g.set(e.subarray(o,o+i),0),N=_=i,v=((v=255&g[0])<<x^255&g[1])&b,r=0;r<=i-3;r++)v=(v<<x^255&g[r+2])&b,m[r&d]=y[v],y[v]=r;return 0},V.deflate=function(t,e){var n,r,i,o,a,s;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666==h&&4!=e)return t.msg=dt[4],-2;if(0===t.avail_out)return t.msg=dt[7],-5;if(l=t,o=c,c=e,42==h&&(r=8+(p-8<<4)<<8,3<(i=(B-1&255)>>1)&&(i=3),r|=i<<6,0!==_&&(r|=32),h=113,Z((s=r+=31-r%31)>>8&255),Z(255&s)),0!==V.pending){if(l.flush_pending(),0===l.avail_out)return c=-1,0}else if(0===l.avail_in&&e<=o&&4!=e)return l.msg=dt[7],-5;if(666==h&&0!==l.avail_in)return t.msg=dt[7],-5;if(0!==l.avail_in||0!==P||0!=e&&666!=h){switch(a=-1,pt[B].func){case 0:a=function(t){var e,n=65535;for(u-5<n&&(n=u-5);;){if(P<=1){if(lt(),0===P&&0==t)return 0;if(0===P)break}if(_+=P,e=N+n,((P=0)===_||e<=_)&&(P=_-e,_=e,st(!1),0===l.avail_out))return 0;if(f-262<=_-N&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 1:a=function(t){for(var e,n=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_),0!==n&&(_-n&65535)<=f-262&&2!=j&&(L=ht(n)),3<=L)if(e=rt(_-F,L-3),P-=L,L<=C&&3<=P){for(L--;v=(v<<x^255&g[++_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_,0!=--L;);_++}else _+=L,L=0,v=((v=255&g[_])<<x^255&g[_+1])&b;else e=rt(0,255&g[_]),P--,_++;if(e&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 2:a=function(t){for(var e,n,r=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),k=L,A=F,L=2,0!==r&&k<C&&(_-r&65535)<=f-262&&(2!=j&&(L=ht(r)),L<=5&&(1==j||3==L&&4096<_-F)&&(L=2)),3<=k&&L<=k){for(n=_+P-3,e=rt(_-1-A,k-3),P-=k-1,k-=2;++_<=n&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),0!=--k;);if(S=0,L=2,_++,e&&(st(!1),0===l.avail_out))return 0}else if(0!==S){if((e=rt(0,255&g[_-1]))&&st(!1),_++,P--,0===l.avail_out)return 0}else S=1,_++,P--}return 0!==S&&(e=rt(0,255&g[_-1]),S=0),st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e)}if(2!=a&&3!=a||(h=666),0==a||2==a)return 0===l.avail_out&&(c=-1),0;if(1==a){if(1==e)$(2,3),tt(256,ft.static_ltree),nt(),1+z+10-W<9&&($(2,3),tt(256,ft.static_ltree),nt()),z=7;else if(at(0,0,!1),3==e)for(n=0;n<w;n++)y[n]=0;if(l.flush_pending(),0===l.avail_out)return c=-1,0}}return 4!=e?0:1}}function i(){this.next_in_index=0,this.next_out_index=0,this.avail_in=0,this.total_in=0,this.avail_out=0,this.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=d),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this.avail_in;return n<r&&(r=n),0===r?0:(this.avail_in-=r,t.set(this.next_in.subarray(this.next_in_index,this.next_in_index+r),e),this.next_in_index+=r,this.total_in+=r,r)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var o=t.zip||t;o.Deflater=o._jzlib_Deflater=function(t){var s=new i,l=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=l,this.append=function(t,e){var n,r=[],i=0,o=0,a=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!=s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512==s.next_out_index?r.push(new Uint8Array(l)):r.push(new Uint8Array(l.subarray(0,s.next_out_index)))),a+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!=i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(a),r.forEach(function(t){n.set(t,o),o+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!=(t=s.deflate(4))&&0!=t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(l.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()).RGBColor=function(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6)),t=(t=t.replace(/ /g,"")).toLowerCase();var n={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"};for(var r in n)t==r&&(t=n[r]);for(var i=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],o=0;o<i.length;o++){var a=i[o].re,s=i[o].process,l=a.exec(t);l&&(e=s(l),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:255<this.r?255:this.r,this.g=this.g<0||isNaN(this.g)?0:255<this.g?255:this.g,this.b=this.b<0||isNaN(this.b)?0:255<this.b?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),n=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==n.length&&(n="0"+n),"#"+t+e+n}},function(t){var n="+".charCodeAt(0),r="/".charCodeAt(0),i="0".charCodeAt(0),o="a".charCodeAt(0),a="A".charCodeAt(0),s="-".charCodeAt(0),l="_".charCodeAt(0),u=function(t){var e=t.charCodeAt(0);return e===n||e===s?62:e===r||e===l?63:e<i?-1:e<i+10?e-i+26+26:e<a+26?e-a:e<o+26?e-o+26:void 0};t.API.TTFFont=function(){function i(t,e,n){var r;if(this.rawData=t,r=this.contents=new J(t),this.contents.pos=4,"ttcf"===r.readString(4)){if(!e)throw new Error("Must specify a font name for TTC files.");throw new Error("Font "+e+" not found in TTC file.")}r.pos=0,this.parse(),this.subset=new P(this),this.registerTTF()}return i.open=function(t,e,n,r){if("string"!=typeof n)throw new Error("Invalid argument supplied in TTFFont.open");return new i(function(t){var e,n,r,i,o,a;if(0<t.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var s=t.length;o="="===t.charAt(s-2)?2:"="===t.charAt(s-1)?1:0,a=new Uint8Array(3*t.length/4-o),r=0<o?t.length-4:t.length;var l=0;function h(t){a[l++]=t}for(n=e=0;e<r;e+=4,n+=3)h((16711680&(i=u(t.charAt(e))<<18|u(t.charAt(e+1))<<12|u(t.charAt(e+2))<<6|u(t.charAt(e+3))))>>16),h((65280&i)>>8),h(255&i);return 2===o?h(255&(i=u(t.charAt(e))<<2|u(t.charAt(e+1))>>4)):1===o&&(h((i=u(t.charAt(e))<<10|u(t.charAt(e+1))<<4|u(t.charAt(e+2))>>2)>>8&255),h(255&i)),a}(n),e,r)},i.prototype.parse=function(){return this.directory=new e(this.contents),this.head=new p(this),this.name=new b(this),this.cmap=new y(this),this.toUnicode=new Map,this.hhea=new g(this),this.maxp=new x(this),this.hmtx=new N(this),this.post=new v(this),this.os2=new m(this),this.loca=new F(this),this.glyf=new A(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},i.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),!0&(t=n>>16)&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},i.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},i.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},i.prototype.widthOfString=function(t,e,n){var r,i,o,a,s;for(i=a=o=0,s=(t=""+t).length;0<=s?a<s:s<a;i=0<=s?++a:--a)r=t.charCodeAt(i),o+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return o*(e/1e3)},i.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},i}();var h,J=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r;for(n=[],e=r=0;0<=t?r<t:t<r;e=0<=t?++r:--r)n[e]=String.fromCharCode(this.readByte());return n.join("")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:r<n;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,o,a,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),o=this.readByte(),a=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^o)+256*(255^a)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*o+256*a+s},t.prototype.writeLongLong=function(t){var e,n;return e=Math.floor(t/4294967296),n=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(n>>24&255),this.writeByte(n>>16&255),this.writeByte(n>>8&255),this.writeByte(255&n)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;0<=t?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),e=function(){var d;function t(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return t.prototype.encode=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;for(p in c=Object.keys(t).length,a=Math.log(2),h=16*Math.floor(Math.log(c)/a),i=Math.floor(h/a),l=16*c-h,(n=new J).writeInt(this.scalarType),n.writeShort(c),n.writeShort(h),n.writeShort(i),n.writeShort(l),r=16*c,s=n.pos+r,o=null,f=[],t)for(u=t[p],n.writeString(p),n.writeInt(d(u)),n.writeInt(s),n.writeInt(u.length),f=f.concat(u),"head"===p&&(o=s),s+=u.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-d(n.data),n.pos=o+8,n.writeUInt32(e),n.data},d=function(t){var e,n,r,i;for(t=L.call(t);t.length%4;)t.push(0);for(n=new J(t),r=e=0,i=t.length;r<i;r+=4)e+=n.readUInt32();return 4294967295&e},t}(),c={}.hasOwnProperty,f=function(t,e){for(var n in e)c.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t};h=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var p=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return(e=new J).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),d=function(){function t(n,t){var e,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),u=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=m=0;m<256;s=++m)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),c=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,d=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),l=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),h=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,a=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=y=0,w=i.length;y<w;s=++y)for(g=i[s],e=v=p=d[s];p<=g?v<=g:g<=v;e=p<=g?++v:--v)0===h[s]?o=e+l[s]:0!==(o=a[h[s]/2+(e-p)-(c-s)]||0)&&(o+=l[s]),this.codeMap[e]=65535&o}n.pos=u}return t.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y;switch(k=new J,o=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(d=0,g=function(){var t,e;for(e=[],p=t=0;t<256;p=++t)e.push(0);return e}(),y={0:0},i={},I=0,E=o.length;I<E;I++)null==y[W=t[r=o[I]]]&&(y[W]=++d),i[r]={old:t[r],new:y[t[r]]},g[r]=y[t[r]];return k.writeUInt16(1),k.writeUInt16(0),k.writeUInt32(12),k.writeUInt16(0),k.writeUInt16(262),k.writeUInt16(0),k.write(g),{charMap:i,subtable:k.data,maxGlyphID:d+1};case"unicode":for(F=[],u=[],y={},n={},m=l=null,C=v=0,M=o.length;C<M;C++)null==y[b=t[r=o[C]]]&&(y[b]=++v),n[r]={old:b,new:y[b]},a=y[b]-r,null!=m&&a===l||(m&&u.push(m),F.push(r),l=a),m=r;for(m&&u.push(m),u.push(65535),F.push(65535),S=2*(A=F.length),L=2*Math.pow(Math.log(A)/Math.LN2,2),c=Math.log(L/2)/Math.LN2,N=2*A-L,s=[],x=[],f=[],p=B=0,O=F.length;B<O;p=++B){if(_=F[p],h=u[p],65535===_){s.push(0),x.push(0);break}if(32768<=_-(P=n[_].new))for(s.push(0),x.push(2*(f.length+A-p)),r=j=_;_<=h?j<=h:h<=j;r=_<=h?++j:--j)f.push(n[r].new);else s.push(P-_),x.push(0)}for(k.writeUInt16(3),k.writeUInt16(1),k.writeUInt32(12),k.writeUInt16(4),k.writeUInt16(16+8*A+2*f.length),k.writeUInt16(0),k.writeUInt16(S),k.writeUInt16(L),k.writeUInt16(c),k.writeUInt16(N),z=0,q=u.length;z<q;z++)r=u[z],k.writeUInt16(r);for(k.writeUInt16(0),H=0,T=F.length;H<T;H++)r=F[H],k.writeUInt16(r);for(V=0,R=s.length;V<R;V++)a=s[V],k.writeUInt16(a);for(G=0,D=x.length;G<D;G++)w=x[G],k.writeUInt16(w);for(Y=0,U=f.length;Y<U;Y++)d=f[Y],k.writeUInt16(d);return{charMap:n,subtable:k.data,maxGlyphID:v+1}}},t}(),y=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:n<r;0<=n?++r:--r)e=new d(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=d.encode(t,e),(r=new J).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},e}(),g=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),m=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="OS/2",e.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},e}(),v=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="post",e.prototype.parse=function(r){var t,e,n,i;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:for(e=r.readUInt16(),this.glyphNameIndex=[],n=0;0<=e?n<e:e<n;0<=e?++n:--n)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],i=[];r.pos<this.offset+this.length;)t=r.readByte(),i.push(this.names.push(r.readString(t)));return i;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},e}(),w=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},b=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="name",e.prototype.parse=function(t){var e,n,r,i,o,a,s,l,h,u,c,f;for(t.pos=this.offset,t.readShort(),e=t.readShort(),a=t.readShort(),n=[],i=h=0;0<=e?h<e:e<h;i=0<=e?++h:--h)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+a+t.readShort()});for(s={},i=u=0,c=n.length;u<c;i=++u)r=n[i],t.pos=r.offset,l=t.readString(r.length),o=new w(l,r),null==s[f=r.nameID]&&(s[f]=[]),s[r.nameID].push(o);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),x=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),N=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hmtx",e.prototype.parse=function(n){var t,r,i,e,o,a,s;for(n.pos=this.offset,this.metrics=[],e=0,a=this.file.hhea.numberOfMetrics;0<=a?e<a:a<e;0<=a?++e:--e)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(r=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],t=0;0<=r?t<r:r<t;0<=r?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)i=n[t],r.push(i.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],o=0;0<=r?o<r:r<o;0<=r?++o:--o)s.push(this.widths.push(t));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),L=[].slice,A=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="glyf",e.prototype.parse=function(t){return this.cache={}},e.prototype.glyphFor=function(t){var e,n,r,i,o,a,s,l,h,u;return(t=t)in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,o=(a=new J(e.read(r))).readShort(),l=a.readShort(),u=a.readShort(),s=a.readShort(),h=a.readShort(),this.cache[t]=-1===o?new _(a,l,u,s,h):new S(a,o,l,u,s,h),this.cache[t]))},e.prototype.encode=function(t,e,n){var r,i,o,a,s;for(o=[],i=[],a=0,s=e.length;a<s;a++)r=t[e[a]],i.push(o.length),r&&(o=o.concat(r.encode(n)));return i.push(o.length),{table:o,offsets:i}},e}(),S=function(){function t(t,e,n,r,i,o){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=o,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),_=function(){function t(t,e,n,r,i){var o,a;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],o=this.raw;a=o.readShort(),this.glyphOffsets.push(o.pos),this.glyphIDs.push(o.readShort()),32&a;)o.pos+=1&a?4:2,128&a?o.pos+=8:64&a?o.pos+=4:8&a&&(o.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(t){var e,n,r,i,o;for(n=new J(L.call(this.raw.data)),e=r=0,i=(o=this.glyphIDs).length;r<i;e=++r)o[e],n.pos=this.glyphOffsets[e];return n.data},t}(),F=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="loca",e.prototype.parse=function(r){var t;return r.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=2)n.push(2*r.readUInt16());return n}.call(this):function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=4)n.push(r.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,o=0;o<n.length;++o)if(n[o]=r,i<e.length&&e[i]==o){++i,n[o]=r;var a=this.offsets[o],s=this.offsets[o+1]-a;0<s&&(r+=s)}for(var l=new Array(4*n.length),h=0;h<n.length;++h)l[4*h+3]=255&n[h],l[4*h+2]=(65280&n[h])>>8,l[4*h+1]=(16711680&n[h])>>16,l[4*h]=(4278190080&n[h])>>24;return l},e}(),P=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},t.prototype.glyphsFor=function(t){var e,n,r,i,o,a,s;for(r={},o=0,a=t.length;o<a;o++)r[i=t[o]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},t.prototype.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m;for(r in n=y.encode(this.generateCmap(),"unicode"),o=this.glyphsFor(t),f={0:0},m=n.charMap)f[(s=m[r]).old]=s.new;for(p in c=n.maxGlyphID,o)p in f||(f[p]=c++);return h=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(f),u=Object.keys(h).sort(function(t,e){return t-e}),d=function(){var t,e,n;for(n=[],t=0,e=u.length;t<e;t++)a=u[t],n.push(h[a]);return n}(),i=this.font.glyf.encode(o,d,f),l=this.font.loca.encode(i.offsets,d),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:l,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();t.API.PDFObject=function(){var o;function a(){}return o=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},a.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(a.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+o(r.getUTCFullYear(),4)+o(r.getUTCMonth(),2)+o(r.getUTCDate(),2)+o(r.getUTCHours(),2)+o(r.getUTCMinutes(),2)+o(r.getUTCSeconds(),2)+"Z)";if("[object Object]"!=={}.toString.call(r))return""+r;for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+a.convert(n));return e.push(">>"),e.join("\n")},a}()}(lt),
	/*
	  # PNG.js
	  # Copyright (c) 2011 Devon Govett
	  # MIT LICENSE
	  # 
	  # 
	  */
	Nt="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),Lt=function(){var h,n,r;function i(t){var e,n,r,i,o,a,s,l,h,u,c,f,p,d;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),h=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===h&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(u=r-this.transparency.indexed.length))for(p=0;0<=u?p<u:u<p;0<=u?++p:--p)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(c=this.read(e)).indexOf(0),l=String.fromCharCode.apply(String,c.slice(0,s)),this.text[l]=String.fromCharCode.apply(String,c.slice(s+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(d=this.colorType)||6===d,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.load=function(t,e,n){var r;return"function"==typeof e&&(n=e),(r=new XMLHttpRequest).open("GET",t,!0),r.responseType="arraybuffer",r.onload=function(){var t;return t=new i(new Uint8Array(r.response||r.mozResponseArrayBuffer)),"function"==typeof(null!=e?e.getContext:void 0)&&t.render(e),"function"==typeof n?n(t):void 0},r.send(null)},i.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(C){var B=this.pixelBitlength/8,j=new Uint8Array(this.width*this.height*B),E=0,M=this;if(null==C&&(C=this.imgData),0===C.length)return new Uint8Array(0);function t(t,e,n,r){var i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S=Math.ceil((M.width-t)/n),_=Math.ceil((M.height-e)/r),F=M.width==S&&M.height==_;for(y=B*S,g=F?j:new Uint8Array(y*_),h=C.length,o=m=0;m<_&&E<h;){switch(C[E++]){case 0:for(s=b=0;b<y;s=b+=1)g[o++]=C[E++];break;case 1:for(s=x=0;x<y;s=x+=1)i=C[E++],l=s<B?0:g[o-B],g[o++]=(i+l)%256;break;case 2:for(s=N=0;N<y;s=N+=1)i=C[E++],a=(s-s%B)/B,v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(v+i)%256;break;case 3:for(s=L=0;L<y;s=L+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(i+Math.floor((l+v)/2))%256;break;case 4:for(s=A=0;A<y;s=A+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],0===m?v=w=0:(v=g[(m-1)*y+a*B+s%B],w=a&&g[(m-1)*y+(a-1)*B+s%B]),u=l+v-w,c=Math.abs(u-l),p=Math.abs(u-v),d=Math.abs(u-w),f=c<=p&&c<=d?l:p<=d?v:w,g[o++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+C[E-1])}if(!F){var P=((e+m*r)*M.width+t)*B,k=m*y;for(s=0;s<S;s+=1){for(var I=0;I<B;I+=1)j[P++]=g[k++];P+=(n-1)*B}}m++}}return C=(C=new kt(C)).getBytes(),1==M.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),j},i.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,l;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,n.length,e=a=t=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(l=o[t++])?l:255;return i},i.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,l,h,u,c,f;if(r=this.colors,u=null,n=this.hasAlphaChannel,this.palette.length&&(u=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),h=(i=t.data||t).length,a=u||e,o=s=0,1===r)for(;o<h;)l=u?4*e[o/4]:s,c=a[l++],i[o++]=c,i[o++]=c,i[o++]=c,i[o++]=n?a[l++]:255,s=l;else for(;o<h;)l=u?4*e[o/4]:s,i[o++]=a[l++],i[o++]=a[l++],i[o++]=a[l++],i[o++]=n?a[l++]:255,s=l},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{n=Nt.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return-1}return h=function(t){var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},i.prototype.decodeFrames=function(t){var e,n,r,i,o,a,s,l;if(this.animation){for(l=[],n=o=0,a=(s=this.animation.frames).length;o<a;n=++o)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,l.push(e.image=h(r));return l}},i.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},i.prototype.animate=function(n){var r,i,o,a,s,t,l=this;return i=0,t=this.animation,a=t.numFrames,o=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%a,e=o[t],l.renderFrame(n,t),1<a&&i/a<s)return l.animation._timeout=setTimeout(r,e.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},i}(),Nt.PNG=Lt;
	/*
	   * Extracted from pdf.js
	   * https://github.com/andreasgal/pdf.js
	   *
	   * Copyright (c) 2011 Mozilla Foundation
	   *
	   * Contributors: Andreas Gal <gal@mozilla.com>
	   *               Chris G Jones <cjones@mozilla.com>
	   *               Shaon Barman <shaon.barman@gmail.com>
	   *               Vivien Nicolas <21@vingtetun.org>
	   *               Justin D'Arcangelo <justindarc@gmail.com>
	   *               Yury Delendik
	   *
	   * 
	   */
	var Pt=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),kt=function(){if("undefined"!=typeof Uint32Array){var k=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),I=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),C=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),B=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],j=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(Pt.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,o=this.bytesPos;n<t;)void 0===(e=i[o++])&&E("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=o,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<n;){var s;void 0===(s=o[a++])&&E("Bad encoding in flate stream"),i|=s<<r,r+=8}var l=e[i&(1<<n)-1],h=l>>16,u=65535&l;return(0==r||r<h||0==h)&&E("Bad encoding in flate stream"),this.codeBuf=i>>h,this.codeSize=r-h,this.bytesPos=a,u},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,l=2;a<=n;++a,s<<=1,l<<=1)for(var h=0;h<e;++h)if(t[h]==a){var u=0,c=s;for(r=0;r<a;++r)u=u<<1|1&c,c>>=1;for(r=u;r<i;r+=l)o[r]=a<<16|h;++s}return[o,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var o=t.getBits(n)+r;0<o--;)e[l++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=B,r=j;else if(2==e){for(var i=this.getBits(5)+257,o=this.getBits(5)+1,a=this.getBits(4)+4,s=Array(k.length),l=0;l<a;)s[k[l++]]=this.getBits(3);for(var h=this.generateHuffmanTable(s),u=0,c=(l=0,i+o),f=new Array(c);l<c;){var p=this.getCode(h);16==p?t(this,f,2,3,u):17==p?t(this,f,3,3,u=0):18==p?t(this,f,7,11,u=0):f[l++]=u=p}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,c))}else E("Unknown block type in flate stream");for(var d=(_=this.buffer)?_.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)d<=g+1&&(d=(_=this.ensureBuffer(g+1)).length),_[g++]=m;else{if(256==m)return void(this.bufferLength=g);var y=(m=I[m-=257])>>16;0<y&&(y=this.getBits(y));u=(65535&m)+y;m=this.getCode(r),0<(y=(m=C[m])>>16)&&(y=this.getBits(y));var v=(65535&m)+y;d<=g+u&&(d=(_=this.ensureBuffer(g+u)).length);for(var w=0;w<u;++w,++g)_[g]=_[g-v]}}}else{var b,x=this.bytes,N=this.bytesPos;void 0===(b=x[N++])&&E("Bad block header in flate stream");var L=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),L|=b<<8,void 0===(b=x[N++])&&E("Bad block header in flate stream");var A=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),(A|=b<<8)!=(65535&~L)&&E("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var S=this.bufferLength,_=this.ensureBuffer(S+L),F=S+L;this.bufferLength=F;for(var P=S;P<F;++P){if(void 0===(b=x[N++])){this.eof=!0;break}_[P]=b}this.bytesPos=N}},t}function E(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||E("Invalid header in flate stream"),8!=(15&n)&&E("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&E("Bad FCHECK in flate stream"),32&r&&E("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,Pt.call(this)}}();window.tmp=kt});try{module.exports=jsPDF}catch(t){}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * html2canvas 1.0.0-rc.3 <https://html2canvas.hertzen.com>
	 * Copyright (c) 2019 Niklas von Hertzen <https://hertzen.com>
	 * Released under MIT License
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global = global || self, global.html2canvas = factory());
	}(this, function () { 'use strict';
	
	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation. All rights reserved.
	    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	    this file except in compliance with the License. You may obtain a copy of the
	    License at http://www.apache.org/licenses/LICENSE-2.0
	
	    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	    MERCHANTABLITY OR NON-INFRINGEMENT.
	
	    See the Apache Version 2.0 License for specific language governing permissions
	    and limitations under the License.
	    ***************************************************************************** */
	    /* global Reflect, Promise */
	
	    var extendStatics = function(d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	
	    function __extends(d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    }
	
	    var __assign = function() {
	        __assign = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign.apply(this, arguments);
	    };
	
	    function __awaiter(thisArg, _arguments, P, generator) {
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    }
	
	    function __generator(thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    }
	
	    var Bounds = /** @class */ (function () {
	        function Bounds(x, y, w, h) {
	            this.left = x;
	            this.top = y;
	            this.width = w;
	            this.height = h;
	        }
	        Bounds.prototype.add = function (x, y, w, h) {
	            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
	        };
	        Bounds.fromClientRect = function (clientRect) {
	            return new Bounds(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
	        };
	        return Bounds;
	    }());
	    var parseBounds = function (node) {
	        return Bounds.fromClientRect(node.getBoundingClientRect());
	    };
	    var parseDocumentSize = function (document) {
	        var body = document.body;
	        var documentElement = document.documentElement;
	        if (!body || !documentElement) {
	            throw new Error("Unable to get document size");
	        }
	        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
	        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
	        return new Bounds(0, 0, width, height);
	    };
	
	    /*
	     * css-line-break 1.1.1 <https://github.com/niklasvh/css-line-break#readme>
	     * Copyright (c) 2019 Niklas von Hertzen <https://hertzen.com>
	     * Released under MIT License
	     */
	    var toCodePoints = function (str) {
	        var codePoints = [];
	        var i = 0;
	        var length = str.length;
	        while (i < length) {
	            var value = str.charCodeAt(i++);
	            if (value >= 0xd800 && value <= 0xdbff && i < length) {
	                var extra = str.charCodeAt(i++);
	                if ((extra & 0xfc00) === 0xdc00) {
	                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
	                }
	                else {
	                    codePoints.push(value);
	                    i--;
	                }
	            }
	            else {
	                codePoints.push(value);
	            }
	        }
	        return codePoints;
	    };
	    var fromCodePoint = function () {
	        var codePoints = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            codePoints[_i] = arguments[_i];
	        }
	        if (String.fromCodePoint) {
	            return String.fromCodePoint.apply(String, codePoints);
	        }
	        var length = codePoints.length;
	        if (!length) {
	            return '';
	        }
	        var codeUnits = [];
	        var index = -1;
	        var result = '';
	        while (++index < length) {
	            var codePoint = codePoints[index];
	            if (codePoint <= 0xffff) {
	                codeUnits.push(codePoint);
	            }
	            else {
	                codePoint -= 0x10000;
	                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
	            }
	            if (index + 1 === length || codeUnits.length > 0x4000) {
	                result += String.fromCharCode.apply(String, codeUnits);
	                codeUnits.length = 0;
	            }
	        }
	        return result;
	    };
	    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	    // Use a lookup table to find the index.
	    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
	    for (var i = 0; i < chars.length; i++) {
	        lookup[chars.charCodeAt(i)] = i;
	    }
	    var decode = function (base64) {
	        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
	        if (base64[base64.length - 1] === '=') {
	            bufferLength--;
	            if (base64[base64.length - 2] === '=') {
	                bufferLength--;
	            }
	        }
	        var buffer = typeof ArrayBuffer !== 'undefined' &&
	            typeof Uint8Array !== 'undefined' &&
	            typeof Uint8Array.prototype.slice !== 'undefined'
	            ? new ArrayBuffer(bufferLength)
	            : new Array(bufferLength);
	        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
	        for (i = 0; i < len; i += 4) {
	            encoded1 = lookup[base64.charCodeAt(i)];
	            encoded2 = lookup[base64.charCodeAt(i + 1)];
	            encoded3 = lookup[base64.charCodeAt(i + 2)];
	            encoded4 = lookup[base64.charCodeAt(i + 3)];
	            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	        }
	        return buffer;
	    };
	    var polyUint16Array = function (buffer) {
	        var length = buffer.length;
	        var bytes = [];
	        for (var i = 0; i < length; i += 2) {
	            bytes.push((buffer[i + 1] << 8) | buffer[i]);
	        }
	        return bytes;
	    };
	    var polyUint32Array = function (buffer) {
	        var length = buffer.length;
	        var bytes = [];
	        for (var i = 0; i < length; i += 4) {
	            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
	        }
	        return bytes;
	    };
	
	    /** Shift size for getting the index-2 table offset. */
	    var UTRIE2_SHIFT_2 = 5;
	    /** Shift size for getting the index-1 table offset. */
	    var UTRIE2_SHIFT_1 = 6 + 5;
	    /**
	     * Shift size for shifting left the index array values.
	     * Increases possible data size with 16-bit index values at the cost
	     * of compactability.
	     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
	     */
	    var UTRIE2_INDEX_SHIFT = 2;
	    /**
	     * Difference between the two shift sizes,
	     * for getting an index-1 offset from an index-2 offset. 6=11-5
	     */
	    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
	    /**
	     * The part of the index-2 table for U+D800..U+DBFF stores values for
	     * lead surrogate code _units_ not code _points_.
	     * Values for lead surrogate code _points_ are indexed with this portion of the table.
	     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
	     */
	    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
	    /** Number of entries in a data block. 32=0x20 */
	    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
	    /** Mask for getting the lower bits for the in-data-block offset. */
	    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
	    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
	    /** Count the lengths of both BMP pieces. 2080=0x820 */
	    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
	    /**
	     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
	     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
	     */
	    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
	    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
	    /**
	     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
	     * Variable length, for code points up to highStart, where the last single-value range starts.
	     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
	     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
	     *
	     * The part of the index-2 table for supplementary code points starts
	     * after this index-1 table.
	     *
	     * Both the index-1 table and the following part of the index-2 table
	     * are omitted completely if there is only BMP data.
	     */
	    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
	    /**
	     * Number of index-1 entries for the BMP. 32=0x20
	     * This part of the index-1 table is omitted from the serialized form.
	     */
	    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
	    /** Number of entries in an index-2 block. 64=0x40 */
	    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
	    /** Mask for getting the lower bits for the in-index-2-block offset. */
	    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
	    var slice16 = function (view, start, end) {
	        if (view.slice) {
	            return view.slice(start, end);
	        }
	        return new Uint16Array(Array.prototype.slice.call(view, start, end));
	    };
	    var slice32 = function (view, start, end) {
	        if (view.slice) {
	            return view.slice(start, end);
	        }
	        return new Uint32Array(Array.prototype.slice.call(view, start, end));
	    };
	    var createTrieFromBase64 = function (base64) {
	        var buffer = decode(base64);
	        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
	        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
	        var headerLength = 24;
	        var index = slice16(view16, headerLength / 2, view32[4] / 2);
	        var data = view32[5] === 2
	            ? slice16(view16, (headerLength + view32[4]) / 2)
	            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
	        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
	    };
	    var Trie = /** @class */ (function () {
	        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
	            this.initialValue = initialValue;
	            this.errorValue = errorValue;
	            this.highStart = highStart;
	            this.highValueIndex = highValueIndex;
	            this.index = index;
	            this.data = data;
	        }
	        /**
	         * Get the value for a code point as stored in the Trie.
	         *
	         * @param codePoint the code point
	         * @return the value
	         */
	        Trie.prototype.get = function (codePoint) {
	            var ix;
	            if (codePoint >= 0) {
	                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
	                    // Ordinary BMP code point, excluding leading surrogates.
	                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
	                    // 16 bit data is stored in the index array itself.
	                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	                if (codePoint <= 0xffff) {
	                    // Lead Surrogate Code Point.  A Separate index section is stored for
	                    // lead surrogate code units and code points.
	                    //   The main index has the code unit data.
	                    //   For this function, we need the code point data.
	                    // Note: this expression could be refactored for slightly improved efficiency, but
	                    //       surrogate code points will be so rare in practice that it's not worth it.
	                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	                if (codePoint < this.highStart) {
	                    // Supplemental code point, use two-level lookup.
	                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
	                    ix = this.index[ix];
	                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
	                    ix = this.index[ix];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	                if (codePoint <= 0x10ffff) {
	                    return this.data[this.highValueIndex];
	                }
	            }
	            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
	            return this.errorValue;
	        };
	        return Trie;
	    }());
	
	    var base64 = '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';
	
	    /* @flow */
	    var LETTER_NUMBER_MODIFIER = 50;
	    // Non-tailorable Line Breaking Classes
	    var BK = 1; //  Cause a line break (after)
	    var CR = 2; //  Cause a line break (after), except between CR and LF
	    var LF = 3; //  Cause a line break (after)
	    var CM = 4; //  Prohibit a line break between the character and the preceding character
	    var NL = 5; //  Cause a line break (after)
	    var WJ = 7; //  Prohibit line breaks before and after
	    var ZW = 8; //  Provide a break opportunity
	    var GL = 9; //  Prohibit line breaks before and after
	    var SP = 10; // Enable indirect line breaks
	    var ZWJ = 11; // Prohibit line breaks within joiner sequences
	    // Break Opportunities
	    var B2 = 12; //  Provide a line break opportunity before and after the character
	    var BA = 13; //  Generally provide a line break opportunity after the character
	    var BB = 14; //  Generally provide a line break opportunity before the character
	    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
	    var CB = 16; //   Provide a line break opportunity contingent on additional information
	    // Characters Prohibiting Certain Breaks
	    var CL = 17; //  Prohibit line breaks before
	    var CP = 18; //  Prohibit line breaks before
	    var EX = 19; //  Prohibit line breaks before
	    var IN = 20; //  Allow only indirect line breaks between pairs
	    var NS = 21; //  Allow only indirect line breaks before
	    var OP = 22; //  Prohibit line breaks after
	    var QU = 23; //  Act like they are both opening and closing
	    // Numeric Context
	    var IS = 24; //  Prevent breaks after any and before numeric
	    var NU = 25; //  Form numeric expressions for line breaking purposes
	    var PO = 26; //  Do not break following a numeric expression
	    var PR = 27; //  Do not break in front of a numeric expression
	    var SY = 28; //  Prevent a break before; and allow a break after
	    // Other Characters
	    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
	    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
	    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
	    var EB = 32; //  Do not break from following Emoji Modifier
	    var EM = 33; //  Do not break from preceding Emoji Base
	    var H2 = 34; //  Form Korean syllable blocks
	    var H3 = 35; //  Form Korean syllable blocks
	    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
	    var ID = 37; //  Break before or after; except in some numeric context
	    var JL = 38; //  Form Korean syllable blocks
	    var JV = 39; //  Form Korean syllable blocks
	    var JT = 40; //  Form Korean syllable blocks
	    var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
	    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
	    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
	    var BREAK_MANDATORY = '!';
	    var BREAK_NOT_ALLOWED = '×';
	    var BREAK_ALLOWED = '÷';
	    var UnicodeTrie = createTrieFromBase64(base64);
	    var ALPHABETICS = [AL, HL];
	    var HARD_LINE_BREAKS = [BK, CR, LF, NL];
	    var SPACE = [SP, ZW];
	    var PREFIX_POSTFIX = [PR, PO];
	    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);
	    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
	    var HYPHEN = [HY, BA];
	    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
	        if (lineBreak === void 0) { lineBreak = 'strict'; }
	        var types = [];
	        var indicies = [];
	        var categories = [];
	        codePoints.forEach(function (codePoint, index) {
	            var classType = UnicodeTrie.get(codePoint);
	            if (classType > LETTER_NUMBER_MODIFIER) {
	                categories.push(true);
	                classType -= LETTER_NUMBER_MODIFIER;
	            }
	            else {
	                categories.push(false);
	            }
	            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
	                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
	                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
	                    indicies.push(index);
	                    return types.push(CB);
	                }
	            }
	            if (classType === CM || classType === ZWJ) {
	                // LB10 Treat any remaining combining mark or ZWJ as AL.
	                if (index === 0) {
	                    indicies.push(index);
	                    return types.push(AL);
	                }
	                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
	                // the base character in all of the following rules. Treat ZWJ as if it were CM.
	                var prev = types[index - 1];
	                if (LINE_BREAKS.indexOf(prev) === -1) {
	                    indicies.push(indicies[index - 1]);
	                    return types.push(prev);
	                }
	                indicies.push(index);
	                return types.push(AL);
	            }
	            indicies.push(index);
	            if (classType === CJ) {
	                return types.push(lineBreak === 'strict' ? NS : ID);
	            }
	            if (classType === SA) {
	                return types.push(AL);
	            }
	            if (classType === AI) {
	                return types.push(AL);
	            }
	            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
	            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
	            // to take into account the actual line breaking properties for these characters.
	            if (classType === XX) {
	                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
	                    return types.push(ID);
	                }
	                else {
	                    return types.push(AL);
	                }
	            }
	            types.push(classType);
	        });
	        return [indicies, types, categories];
	    };
	    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
	        var current = classTypes[currentIndex];
	        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
	            var i = currentIndex;
	            while (i <= classTypes.length) {
	                i++;
	                var next = classTypes[i];
	                if (next === b) {
	                    return true;
	                }
	                if (next !== SP) {
	                    break;
	                }
	            }
	        }
	        if (current === SP) {
	            var i = currentIndex;
	            while (i > 0) {
	                i--;
	                var prev = classTypes[i];
	                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
	                    var n = currentIndex;
	                    while (n <= classTypes.length) {
	                        n++;
	                        var next = classTypes[n];
	                        if (next === b) {
	                            return true;
	                        }
	                        if (next !== SP) {
	                            break;
	                        }
	                    }
	                }
	                if (prev !== SP) {
	                    break;
	                }
	            }
	        }
	        return false;
	    };
	    var previousNonSpaceClassType = function (currentIndex, classTypes) {
	        var i = currentIndex;
	        while (i >= 0) {
	            var type = classTypes[i];
	            if (type === SP) {
	                i--;
	            }
	            else {
	                return type;
	            }
	        }
	        return 0;
	    };
	    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
	        if (indicies[index] === 0) {
	            return BREAK_NOT_ALLOWED;
	        }
	        var currentIndex = index - 1;
	        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
	            return BREAK_NOT_ALLOWED;
	        }
	        var beforeIndex = currentIndex - 1;
	        var afterIndex = currentIndex + 1;
	        var current = classTypes[currentIndex];
	        // LB4 Always break after hard line breaks.
	        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
	        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
	        var next = classTypes[afterIndex];
	        if (current === CR && next === LF) {
	            return BREAK_NOT_ALLOWED;
	        }
	        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
	            return BREAK_MANDATORY;
	        }
	        // LB6 Do not break before hard line breaks.
	        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB7 Do not break before spaces or zero width space.
	        if (SPACE.indexOf(next) !== -1) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
	        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
	            return BREAK_ALLOWED;
	        }
	        // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
	        if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB11 Do not break before or after Word joiner and related characters.
	        if (current === WJ || next === WJ) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB12 Do not break after NBSP and related characters.
	        if (current === GL) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
	        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
	        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB14 Do not break after ‘[’, even after spaces.
	        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB15 Do not break within ‘”[’, even with intervening spaces.
	        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
	        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB17 Do not break within ‘——’, even with intervening spaces.
	        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB18 Break after spaces.
	        if (current === SP) {
	            return BREAK_ALLOWED;
	        }
	        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
	        if (current === QU || next === QU) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB20 Break before and after unresolved CB.
	        if (next === CB || current === CB) {
	            return BREAK_ALLOWED;
	        }
	        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
	        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB21a Don't break after Hebrew + Hyphen.
	        if (before === HL && HYPHEN.indexOf(current) !== -1) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB21b Don’t break between Solidus and Hebrew letters.
	        if (current === SY && next === HL) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
	        if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB23 Do not break between digits and letters.
	        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
	        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
	            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
	        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
	            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB25 Do not break between the following pairs of classes relevant to numbers:
	        if (
	        // (PR | PO) × ( OP | HY )? NU
	        ([PR, PO].indexOf(current) !== -1 &&
	            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
	            // ( OP | HY ) × NU
	            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
	            // NU ×	(NU | SY | IS)
	            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
	        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
	            var prevIndex = currentIndex;
	            while (prevIndex >= 0) {
	                var type = classTypes[prevIndex];
	                if (type === NU) {
	                    return BREAK_NOT_ALLOWED;
	                }
	                else if ([SY, IS].indexOf(type) !== -1) {
	                    prevIndex--;
	                }
	                else {
	                    break;
	                }
	            }
	        }
	        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
	        if ([PR, PO].indexOf(next) !== -1) {
	            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
	            while (prevIndex >= 0) {
	                var type = classTypes[prevIndex];
	                if (type === NU) {
	                    return BREAK_NOT_ALLOWED;
	                }
	                else if ([SY, IS].indexOf(type) !== -1) {
	                    prevIndex--;
	                }
	                else {
	                    break;
	                }
	            }
	        }
	        // LB26 Do not break a Korean syllable.
	        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
	            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
	            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB27 Treat a Korean Syllable Block the same as ID.
	        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
	            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB28 Do not break between alphabetics (“at”).
	        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
	        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
	        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP) ||
	            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
	        // indicators preceding the position of the break.
	        if (current === RI && next === RI) {
	            var i = indicies[currentIndex];
	            var count = 1;
	            while (i > 0) {
	                i--;
	                if (classTypes[i] === RI) {
	                    count++;
	                }
	                else {
	                    break;
	                }
	            }
	            if (count % 2 !== 0) {
	                return BREAK_NOT_ALLOWED;
	            }
	        }
	        // LB30b Do not break between an emoji base and an emoji modifier.
	        if (current === EB && next === EM) {
	            return BREAK_NOT_ALLOWED;
	        }
	        return BREAK_ALLOWED;
	    };
	    var cssFormattedClasses = function (codePoints, options) {
	        if (!options) {
	            options = { lineBreak: 'normal', wordBreak: 'normal' };
	        }
	        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
	        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
	            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
	        }
	        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
	            ? isLetterNumber.map(function (letterNumber, i) {
	                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
	            })
	            : undefined;
	        return [indicies, classTypes, forbiddenBreakpoints];
	    };
	    var Break = /** @class */ (function () {
	        function Break(codePoints, lineBreak, start, end) {
	            this.codePoints = codePoints;
	            this.required = lineBreak === BREAK_MANDATORY;
	            this.start = start;
	            this.end = end;
	        }
	        Break.prototype.slice = function () {
	            return fromCodePoint.apply(void 0, this.codePoints.slice(this.start, this.end));
	        };
	        return Break;
	    }());
	    var LineBreaker = function (str, options) {
	        var codePoints = toCodePoints(str);
	        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
	        var length = codePoints.length;
	        var lastEnd = 0;
	        var nextIndex = 0;
	        return {
	            next: function () {
	                if (nextIndex >= length) {
	                    return { done: true, value: null };
	                }
	                var lineBreak = BREAK_NOT_ALLOWED;
	                while (nextIndex < length &&
	                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
	                        BREAK_NOT_ALLOWED) { }
	                if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
	                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
	                    lastEnd = nextIndex;
	                    return { value: value, done: false };
	                }
	                return { done: true, value: null };
	            },
	        };
	    };
	
	    // https://www.w3.org/TR/css-syntax-3
	    var TokenType;
	    (function (TokenType) {
	        TokenType[TokenType["STRING_TOKEN"] = 0] = "STRING_TOKEN";
	        TokenType[TokenType["BAD_STRING_TOKEN"] = 1] = "BAD_STRING_TOKEN";
	        TokenType[TokenType["LEFT_PARENTHESIS_TOKEN"] = 2] = "LEFT_PARENTHESIS_TOKEN";
	        TokenType[TokenType["RIGHT_PARENTHESIS_TOKEN"] = 3] = "RIGHT_PARENTHESIS_TOKEN";
	        TokenType[TokenType["COMMA_TOKEN"] = 4] = "COMMA_TOKEN";
	        TokenType[TokenType["HASH_TOKEN"] = 5] = "HASH_TOKEN";
	        TokenType[TokenType["DELIM_TOKEN"] = 6] = "DELIM_TOKEN";
	        TokenType[TokenType["AT_KEYWORD_TOKEN"] = 7] = "AT_KEYWORD_TOKEN";
	        TokenType[TokenType["PREFIX_MATCH_TOKEN"] = 8] = "PREFIX_MATCH_TOKEN";
	        TokenType[TokenType["DASH_MATCH_TOKEN"] = 9] = "DASH_MATCH_TOKEN";
	        TokenType[TokenType["INCLUDE_MATCH_TOKEN"] = 10] = "INCLUDE_MATCH_TOKEN";
	        TokenType[TokenType["LEFT_CURLY_BRACKET_TOKEN"] = 11] = "LEFT_CURLY_BRACKET_TOKEN";
	        TokenType[TokenType["RIGHT_CURLY_BRACKET_TOKEN"] = 12] = "RIGHT_CURLY_BRACKET_TOKEN";
	        TokenType[TokenType["SUFFIX_MATCH_TOKEN"] = 13] = "SUFFIX_MATCH_TOKEN";
	        TokenType[TokenType["SUBSTRING_MATCH_TOKEN"] = 14] = "SUBSTRING_MATCH_TOKEN";
	        TokenType[TokenType["DIMENSION_TOKEN"] = 15] = "DIMENSION_TOKEN";
	        TokenType[TokenType["PERCENTAGE_TOKEN"] = 16] = "PERCENTAGE_TOKEN";
	        TokenType[TokenType["NUMBER_TOKEN"] = 17] = "NUMBER_TOKEN";
	        TokenType[TokenType["FUNCTION"] = 18] = "FUNCTION";
	        TokenType[TokenType["FUNCTION_TOKEN"] = 19] = "FUNCTION_TOKEN";
	        TokenType[TokenType["IDENT_TOKEN"] = 20] = "IDENT_TOKEN";
	        TokenType[TokenType["COLUMN_TOKEN"] = 21] = "COLUMN_TOKEN";
	        TokenType[TokenType["URL_TOKEN"] = 22] = "URL_TOKEN";
	        TokenType[TokenType["BAD_URL_TOKEN"] = 23] = "BAD_URL_TOKEN";
	        TokenType[TokenType["CDC_TOKEN"] = 24] = "CDC_TOKEN";
	        TokenType[TokenType["CDO_TOKEN"] = 25] = "CDO_TOKEN";
	        TokenType[TokenType["COLON_TOKEN"] = 26] = "COLON_TOKEN";
	        TokenType[TokenType["SEMICOLON_TOKEN"] = 27] = "SEMICOLON_TOKEN";
	        TokenType[TokenType["LEFT_SQUARE_BRACKET_TOKEN"] = 28] = "LEFT_SQUARE_BRACKET_TOKEN";
	        TokenType[TokenType["RIGHT_SQUARE_BRACKET_TOKEN"] = 29] = "RIGHT_SQUARE_BRACKET_TOKEN";
	        TokenType[TokenType["UNICODE_RANGE_TOKEN"] = 30] = "UNICODE_RANGE_TOKEN";
	        TokenType[TokenType["WHITESPACE_TOKEN"] = 31] = "WHITESPACE_TOKEN";
	        TokenType[TokenType["EOF_TOKEN"] = 32] = "EOF_TOKEN";
	    })(TokenType || (TokenType = {}));
	    var FLAG_UNRESTRICTED = 1 << 0;
	    var FLAG_ID = 1 << 1;
	    var FLAG_INTEGER = 1 << 2;
	    var FLAG_NUMBER = 1 << 3;
	    var LINE_FEED = 0x000a;
	    var SOLIDUS = 0x002f;
	    var REVERSE_SOLIDUS = 0x005c;
	    var CHARACTER_TABULATION = 0x0009;
	    var SPACE$1 = 0x0020;
	    var QUOTATION_MARK = 0x0022;
	    var EQUALS_SIGN = 0x003d;
	    var NUMBER_SIGN = 0x0023;
	    var DOLLAR_SIGN = 0x0024;
	    var PERCENTAGE_SIGN = 0x0025;
	    var APOSTROPHE = 0x0027;
	    var LEFT_PARENTHESIS = 0x0028;
	    var RIGHT_PARENTHESIS = 0x0029;
	    var LOW_LINE = 0x005f;
	    var HYPHEN_MINUS = 0x002d;
	    var EXCLAMATION_MARK = 0x0021;
	    var LESS_THAN_SIGN = 0x003c;
	    var GREATER_THAN_SIGN = 0x003e;
	    var COMMERCIAL_AT = 0x0040;
	    var LEFT_SQUARE_BRACKET = 0x005b;
	    var RIGHT_SQUARE_BRACKET = 0x005d;
	    var CIRCUMFLEX_ACCENT = 0x003d;
	    var LEFT_CURLY_BRACKET = 0x007b;
	    var QUESTION_MARK = 0x003f;
	    var RIGHT_CURLY_BRACKET = 0x007d;
	    var VERTICAL_LINE = 0x007c;
	    var TILDE = 0x007e;
	    var CONTROL = 0x0080;
	    var REPLACEMENT_CHARACTER = 0xfffd;
	    var ASTERISK = 0x002a;
	    var PLUS_SIGN = 0x002b;
	    var COMMA = 0x002c;
	    var COLON = 0x003a;
	    var SEMICOLON = 0x003b;
	    var FULL_STOP = 0x002e;
	    var NULL = 0x0000;
	    var BACKSPACE = 0x0008;
	    var LINE_TABULATION = 0x000b;
	    var SHIFT_OUT = 0x000e;
	    var INFORMATION_SEPARATOR_ONE = 0x001f;
	    var DELETE = 0x007f;
	    var EOF = -1;
	    var ZERO = 0x0030;
	    var a = 0x0061;
	    var e = 0x0065;
	    var f = 0x0066;
	    var u = 0x0075;
	    var z = 0x007a;
	    var A = 0x0041;
	    var E = 0x0045;
	    var F = 0x0046;
	    var U = 0x0055;
	    var Z = 0x005a;
	    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
	    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
	    var isHex = function (codePoint) {
	        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
	    };
	    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
	    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
	    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
	    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
	    var isWhiteSpace = function (codePoint) {
	        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE$1;
	    };
	    var isNameStartCodePoint = function (codePoint) {
	        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
	    };
	    var isNameCodePoint = function (codePoint) {
	        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
	    };
	    var isNonPrintableCodePoint = function (codePoint) {
	        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
	            codePoint === LINE_TABULATION ||
	            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
	            codePoint === DELETE);
	    };
	    var isValidEscape = function (c1, c2) {
	        if (c1 !== REVERSE_SOLIDUS) {
	            return false;
	        }
	        return c2 !== LINE_FEED;
	    };
	    var isIdentifierStart = function (c1, c2, c3) {
	        if (c1 === HYPHEN_MINUS) {
	            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
	        }
	        else if (isNameStartCodePoint(c1)) {
	            return true;
	        }
	        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
	            return true;
	        }
	        return false;
	    };
	    var isNumberStart = function (c1, c2, c3) {
	        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
	            if (isDigit(c2)) {
	                return true;
	            }
	            return c2 === FULL_STOP && isDigit(c3);
	        }
	        if (c1 === FULL_STOP) {
	            return isDigit(c2);
	        }
	        return isDigit(c1);
	    };
	    var stringToNumber = function (codePoints) {
	        var c = 0;
	        var sign = 1;
	        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
	            if (codePoints[c] === HYPHEN_MINUS) {
	                sign = -1;
	            }
	            c++;
	        }
	        var integers = [];
	        while (isDigit(codePoints[c])) {
	            integers.push(codePoints[c++]);
	        }
	        var int = integers.length ? parseInt(fromCodePoint.apply(void 0, integers), 10) : 0;
	        if (codePoints[c] === FULL_STOP) {
	            c++;
	        }
	        var fraction = [];
	        while (isDigit(codePoints[c])) {
	            fraction.push(codePoints[c++]);
	        }
	        var fracd = fraction.length;
	        var frac = fracd ? parseInt(fromCodePoint.apply(void 0, fraction), 10) : 0;
	        if (codePoints[c] === E || codePoints[c] === e) {
	            c++;
	        }
	        var expsign = 1;
	        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
	            if (codePoints[c] === HYPHEN_MINUS) {
	                expsign = -1;
	            }
	            c++;
	        }
	        var exponent = [];
	        while (isDigit(codePoints[c])) {
	            exponent.push(codePoints[c++]);
	        }
	        var exp = exponent.length ? parseInt(fromCodePoint.apply(void 0, exponent), 10) : 0;
	        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
	    };
	    var LEFT_PARENTHESIS_TOKEN = {
	        type: TokenType.LEFT_PARENTHESIS_TOKEN
	    };
	    var RIGHT_PARENTHESIS_TOKEN = {
	        type: TokenType.RIGHT_PARENTHESIS_TOKEN
	    };
	    var COMMA_TOKEN = { type: TokenType.COMMA_TOKEN };
	    var SUFFIX_MATCH_TOKEN = { type: TokenType.SUFFIX_MATCH_TOKEN };
	    var PREFIX_MATCH_TOKEN = { type: TokenType.PREFIX_MATCH_TOKEN };
	    var COLUMN_TOKEN = { type: TokenType.COLUMN_TOKEN };
	    var DASH_MATCH_TOKEN = { type: TokenType.DASH_MATCH_TOKEN };
	    var INCLUDE_MATCH_TOKEN = { type: TokenType.INCLUDE_MATCH_TOKEN };
	    var LEFT_CURLY_BRACKET_TOKEN = {
	        type: TokenType.LEFT_CURLY_BRACKET_TOKEN
	    };
	    var RIGHT_CURLY_BRACKET_TOKEN = {
	        type: TokenType.RIGHT_CURLY_BRACKET_TOKEN
	    };
	    var SUBSTRING_MATCH_TOKEN = { type: TokenType.SUBSTRING_MATCH_TOKEN };
	    var BAD_URL_TOKEN = { type: TokenType.BAD_URL_TOKEN };
	    var BAD_STRING_TOKEN = { type: TokenType.BAD_STRING_TOKEN };
	    var CDO_TOKEN = { type: TokenType.CDO_TOKEN };
	    var CDC_TOKEN = { type: TokenType.CDC_TOKEN };
	    var COLON_TOKEN = { type: TokenType.COLON_TOKEN };
	    var SEMICOLON_TOKEN = { type: TokenType.SEMICOLON_TOKEN };
	    var LEFT_SQUARE_BRACKET_TOKEN = {
	        type: TokenType.LEFT_SQUARE_BRACKET_TOKEN
	    };
	    var RIGHT_SQUARE_BRACKET_TOKEN = {
	        type: TokenType.RIGHT_SQUARE_BRACKET_TOKEN
	    };
	    var WHITESPACE_TOKEN = { type: TokenType.WHITESPACE_TOKEN };
	    var EOF_TOKEN = { type: TokenType.EOF_TOKEN };
	    var Tokenizer = /** @class */ (function () {
	        function Tokenizer() {
	            this._value = [];
	        }
	        Tokenizer.prototype.write = function (chunk) {
	            this._value = this._value.concat(toCodePoints(chunk));
	        };
	        Tokenizer.prototype.read = function () {
	            var tokens = [];
	            var token = this.consumeToken();
	            while (token !== EOF_TOKEN) {
	                tokens.push(token);
	                token = this.consumeToken();
	            }
	            return tokens;
	        };
	        Tokenizer.prototype.consumeToken = function () {
	            var codePoint = this.consumeCodePoint();
	            switch (codePoint) {
	                case QUOTATION_MARK:
	                    return this.consumeStringToken(QUOTATION_MARK);
	                case NUMBER_SIGN:
	                    var c1 = this.peekCodePoint(0);
	                    var c2 = this.peekCodePoint(1);
	                    var c3 = this.peekCodePoint(2);
	                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
	                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
	                        var value = this.consumeName();
	                        return { type: TokenType.HASH_TOKEN, value: value, flags: flags };
	                    }
	                    break;
	                case DOLLAR_SIGN:
	                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
	                        this.consumeCodePoint();
	                        return SUFFIX_MATCH_TOKEN;
	                    }
	                    break;
	                case APOSTROPHE:
	                    return this.consumeStringToken(APOSTROPHE);
	                case LEFT_PARENTHESIS:
	                    return LEFT_PARENTHESIS_TOKEN;
	                case RIGHT_PARENTHESIS:
	                    return RIGHT_PARENTHESIS_TOKEN;
	                case ASTERISK:
	                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
	                        this.consumeCodePoint();
	                        return SUBSTRING_MATCH_TOKEN;
	                    }
	                    break;
	                case PLUS_SIGN:
	                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
	                        this.reconsumeCodePoint(codePoint);
	                        return this.consumeNumericToken();
	                    }
	                    break;
	                case COMMA:
	                    return COMMA_TOKEN;
	                case HYPHEN_MINUS:
	                    var e1 = codePoint;
	                    var e2 = this.peekCodePoint(0);
	                    var e3 = this.peekCodePoint(1);
	                    if (isNumberStart(e1, e2, e3)) {
	                        this.reconsumeCodePoint(codePoint);
	                        return this.consumeNumericToken();
	                    }
	                    if (isIdentifierStart(e1, e2, e3)) {
	                        this.reconsumeCodePoint(codePoint);
	                        return this.consumeIdentLikeToken();
	                    }
	                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
	                        this.consumeCodePoint();
	                        this.consumeCodePoint();
	                        return CDC_TOKEN;
	                    }
	                    break;
	                case FULL_STOP:
	                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
	                        this.reconsumeCodePoint(codePoint);
	                        return this.consumeNumericToken();
	                    }
	                    break;
	                case SOLIDUS:
	                    if (this.peekCodePoint(0) === ASTERISK) {
	                        this.consumeCodePoint();
	                        while (true) {
	                            var c = this.consumeCodePoint();
	                            if (c === ASTERISK) {
	                                c = this.consumeCodePoint();
	                                if (c === SOLIDUS) {
	                                    return this.consumeToken();
	                                }
	                            }
	                            if (c === EOF) {
	                                return this.consumeToken();
	                            }
	                        }
	                    }
	                    break;
	                case COLON:
	                    return COLON_TOKEN;
	                case SEMICOLON:
	                    return SEMICOLON_TOKEN;
	                case LESS_THAN_SIGN:
	                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
	                        this.peekCodePoint(1) === HYPHEN_MINUS &&
	                        this.peekCodePoint(2) === HYPHEN_MINUS) {
	                        this.consumeCodePoint();
	                        this.consumeCodePoint();
	                        return CDO_TOKEN;
	                    }
	                    break;
	                case COMMERCIAL_AT:
	                    var a1 = this.peekCodePoint(0);
	                    var a2 = this.peekCodePoint(1);
	                    var a3 = this.peekCodePoint(2);
	                    if (isIdentifierStart(a1, a2, a3)) {
	                        var value = this.consumeName();
	                        return { type: TokenType.AT_KEYWORD_TOKEN, value: value };
	                    }
	                    break;
	                case LEFT_SQUARE_BRACKET:
	                    return LEFT_SQUARE_BRACKET_TOKEN;
	                case REVERSE_SOLIDUS:
	                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
	                        this.reconsumeCodePoint(codePoint);
	                        return this.consumeIdentLikeToken();
	                    }
	                    break;
	                case RIGHT_SQUARE_BRACKET:
	                    return RIGHT_SQUARE_BRACKET_TOKEN;
	                case CIRCUMFLEX_ACCENT:
	                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
	                        this.consumeCodePoint();
	                        return PREFIX_MATCH_TOKEN;
	                    }
	                    break;
	                case LEFT_CURLY_BRACKET:
	                    return LEFT_CURLY_BRACKET_TOKEN;
	                case RIGHT_CURLY_BRACKET:
	                    return RIGHT_CURLY_BRACKET_TOKEN;
	                case u:
	                case U:
	                    var u1 = this.peekCodePoint(0);
	                    var u2 = this.peekCodePoint(1);
	                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
	                        this.consumeCodePoint();
	                        this.consumeUnicodeRangeToken();
	                    }
	                    this.reconsumeCodePoint(codePoint);
	                    return this.consumeIdentLikeToken();
	                case VERTICAL_LINE:
	                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
	                        this.consumeCodePoint();
	                        return DASH_MATCH_TOKEN;
	                    }
	                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
	                        this.consumeCodePoint();
	                        return COLUMN_TOKEN;
	                    }
	                    break;
	                case TILDE:
	                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
	                        this.consumeCodePoint();
	                        return INCLUDE_MATCH_TOKEN;
	                    }
	                    break;
	                case EOF:
	                    return EOF_TOKEN;
	            }
	            if (isWhiteSpace(codePoint)) {
	                this.consumeWhiteSpace();
	                return WHITESPACE_TOKEN;
	            }
	            if (isDigit(codePoint)) {
	                this.reconsumeCodePoint(codePoint);
	                return this.consumeNumericToken();
	            }
	            if (isNameStartCodePoint(codePoint)) {
	                this.reconsumeCodePoint(codePoint);
	                return this.consumeIdentLikeToken();
	            }
	            return { type: TokenType.DELIM_TOKEN, value: fromCodePoint(codePoint) };
	        };
	        Tokenizer.prototype.consumeCodePoint = function () {
	            var value = this._value.shift();
	            return typeof value === 'undefined' ? -1 : value;
	        };
	        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
	            this._value.unshift(codePoint);
	        };
	        Tokenizer.prototype.peekCodePoint = function (delta) {
	            if (delta >= this._value.length) {
	                return -1;
	            }
	            return this._value[delta];
	        };
	        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
	            var digits = [];
	            var codePoint = this.consumeCodePoint();
	            while (isHex(codePoint) && digits.length < 6) {
	                digits.push(codePoint);
	                codePoint = this.consumeCodePoint();
	            }
	            var questionMarks = false;
	            while (codePoint === QUESTION_MARK && digits.length < 6) {
	                digits.push(codePoint);
	                codePoint = this.consumeCodePoint();
	                questionMarks = true;
	            }
	            if (questionMarks) {
	                var start_1 = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
	                var end = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
	                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start_1, end: end };
	            }
	            var start = parseInt(fromCodePoint.apply(void 0, digits), 16);
	            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
	                this.consumeCodePoint();
	                codePoint = this.consumeCodePoint();
	                var endDigits = [];
	                while (isHex(codePoint) && endDigits.length < 6) {
	                    endDigits.push(codePoint);
	                    codePoint = this.consumeCodePoint();
	                }
	                var end = parseInt(fromCodePoint.apply(void 0, endDigits), 16);
	                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: end };
	            }
	            else {
	                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: start };
	            }
	        };
	        Tokenizer.prototype.consumeIdentLikeToken = function () {
	            var value = this.consumeName();
	            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
	                this.consumeCodePoint();
	                return this.consumeUrlToken();
	            }
	            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
	                this.consumeCodePoint();
	                return { type: TokenType.FUNCTION_TOKEN, value: value };
	            }
	            return { type: TokenType.IDENT_TOKEN, value: value };
	        };
	        Tokenizer.prototype.consumeUrlToken = function () {
	            var value = [];
	            this.consumeWhiteSpace();
	            if (this.peekCodePoint(0) === EOF) {
	                return { type: TokenType.URL_TOKEN, value: '' };
	            }
	            var next = this.peekCodePoint(0);
	            if (next === APOSTROPHE || next === QUOTATION_MARK) {
	                var stringToken = this.consumeStringToken(this.consumeCodePoint());
	                if (stringToken.type === TokenType.STRING_TOKEN) {
	                    this.consumeWhiteSpace();
	                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
	                        this.consumeCodePoint();
	                        return { type: TokenType.URL_TOKEN, value: stringToken.value };
	                    }
	                }
	                this.consumeBadUrlRemnants();
	                return BAD_URL_TOKEN;
	            }
	            while (true) {
	                var codePoint = this.consumeCodePoint();
	                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
	                    return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
	                }
	                else if (isWhiteSpace(codePoint)) {
	                    this.consumeWhiteSpace();
	                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
	                        this.consumeCodePoint();
	                        return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
	                    }
	                    this.consumeBadUrlRemnants();
	                    return BAD_URL_TOKEN;
	                }
	                else if (codePoint === QUOTATION_MARK ||
	                    codePoint === APOSTROPHE ||
	                    codePoint === LEFT_PARENTHESIS ||
	                    isNonPrintableCodePoint(codePoint)) {
	                    this.consumeBadUrlRemnants();
	                    return BAD_URL_TOKEN;
	                }
	                else if (codePoint === REVERSE_SOLIDUS) {
	                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
	                        value.push(this.consumeEscapedCodePoint());
	                    }
	                    else {
	                        this.consumeBadUrlRemnants();
	                        return BAD_URL_TOKEN;
	                    }
	                }
	                else {
	                    value.push(codePoint);
	                }
	            }
	        };
	        Tokenizer.prototype.consumeWhiteSpace = function () {
	            while (isWhiteSpace(this.peekCodePoint(0))) {
	                this.consumeCodePoint();
	            }
	        };
	        Tokenizer.prototype.consumeBadUrlRemnants = function () {
	            while (true) {
	                var codePoint = this.consumeCodePoint();
	                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
	                    return;
	                }
	                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
	                    this.consumeEscapedCodePoint();
	                }
	            }
	        };
	        Tokenizer.prototype.consumeStringSlice = function (count) {
	            var SLICE_STACK_SIZE = 60000;
	            var value = '';
	            while (count > 0) {
	                var amount = Math.min(SLICE_STACK_SIZE, count);
	                value += fromCodePoint.apply(void 0, this._value.splice(0, amount));
	                count -= amount;
	            }
	            this._value.shift();
	            return value;
	        };
	        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
	            var value = '';
	            var i = 0;
	            do {
	                var codePoint = this._value[i];
	                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
	                    value += this.consumeStringSlice(i);
	                    return { type: TokenType.STRING_TOKEN, value: value };
	                }
	                if (codePoint === LINE_FEED) {
	                    this._value.splice(0, i);
	                    return BAD_STRING_TOKEN;
	                }
	                if (codePoint === REVERSE_SOLIDUS) {
	                    var next = this._value[i + 1];
	                    if (next !== EOF && next !== undefined) {
	                        if (next === LINE_FEED) {
	                            value += this.consumeStringSlice(i);
	                            i = -1;
	                            this._value.shift();
	                        }
	                        else if (isValidEscape(codePoint, next)) {
	                            value += this.consumeStringSlice(i);
	                            value += fromCodePoint(this.consumeEscapedCodePoint());
	                            i = -1;
	                        }
	                    }
	                }
	                i++;
	            } while (true);
	        };
	        Tokenizer.prototype.consumeNumber = function () {
	            var repr = [];
	            var type = FLAG_INTEGER;
	            var c1 = this.peekCodePoint(0);
	            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
	                repr.push(this.consumeCodePoint());
	            }
	            while (isDigit(this.peekCodePoint(0))) {
	                repr.push(this.consumeCodePoint());
	            }
	            c1 = this.peekCodePoint(0);
	            var c2 = this.peekCodePoint(1);
	            if (c1 === FULL_STOP && isDigit(c2)) {
	                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
	                type = FLAG_NUMBER;
	                while (isDigit(this.peekCodePoint(0))) {
	                    repr.push(this.consumeCodePoint());
	                }
	            }
	            c1 = this.peekCodePoint(0);
	            c2 = this.peekCodePoint(1);
	            var c3 = this.peekCodePoint(2);
	            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
	                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
	                type = FLAG_NUMBER;
	                while (isDigit(this.peekCodePoint(0))) {
	                    repr.push(this.consumeCodePoint());
	                }
	            }
	            return [stringToNumber(repr), type];
	        };
	        Tokenizer.prototype.consumeNumericToken = function () {
	            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
	            var c1 = this.peekCodePoint(0);
	            var c2 = this.peekCodePoint(1);
	            var c3 = this.peekCodePoint(2);
	            if (isIdentifierStart(c1, c2, c3)) {
	                var unit = this.consumeName();
	                return { type: TokenType.DIMENSION_TOKEN, number: number, flags: flags, unit: unit };
	            }
	            if (c1 === PERCENTAGE_SIGN) {
	                this.consumeCodePoint();
	                return { type: TokenType.PERCENTAGE_TOKEN, number: number, flags: flags };
	            }
	            return { type: TokenType.NUMBER_TOKEN, number: number, flags: flags };
	        };
	        Tokenizer.prototype.consumeEscapedCodePoint = function () {
	            var codePoint = this.consumeCodePoint();
	            if (isHex(codePoint)) {
	                var hex = fromCodePoint(codePoint);
	                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
	                    hex += fromCodePoint(this.consumeCodePoint());
	                }
	                if (isWhiteSpace(this.peekCodePoint(0))) {
	                    this.consumeCodePoint();
	                }
	                var hexCodePoint = parseInt(hex, 16);
	                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
	                    return REPLACEMENT_CHARACTER;
	                }
	                return hexCodePoint;
	            }
	            if (codePoint === EOF) {
	                return REPLACEMENT_CHARACTER;
	            }
	            return codePoint;
	        };
	        Tokenizer.prototype.consumeName = function () {
	            var result = '';
	            while (true) {
	                var codePoint = this.consumeCodePoint();
	                if (isNameCodePoint(codePoint)) {
	                    result += fromCodePoint(codePoint);
	                }
	                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
	                    result += fromCodePoint(this.consumeEscapedCodePoint());
	                }
	                else {
	                    this.reconsumeCodePoint(codePoint);
	                    return result;
	                }
	            }
	        };
	        return Tokenizer;
	    }());
	
	    var Parser = /** @class */ (function () {
	        function Parser(tokens) {
	            this._tokens = tokens;
	        }
	        Parser.create = function (value) {
	            var tokenizer = new Tokenizer();
	            tokenizer.write(value);
	            return new Parser(tokenizer.read());
	        };
	        Parser.parseValue = function (value) {
	            return Parser.create(value).parseComponentValue();
	        };
	        Parser.parseValues = function (value) {
	            return Parser.create(value).parseComponentValues();
	        };
	        Parser.prototype.parseComponentValue = function () {
	            var token = this.consumeToken();
	            while (token.type === TokenType.WHITESPACE_TOKEN) {
	                token = this.consumeToken();
	            }
	            if (token.type === TokenType.EOF_TOKEN) {
	                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
	            }
	            this.reconsumeToken(token);
	            var value = this.consumeComponentValue();
	            do {
	                token = this.consumeToken();
	            } while (token.type === TokenType.WHITESPACE_TOKEN);
	            if (token.type === TokenType.EOF_TOKEN) {
	                return value;
	            }
	            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
	        };
	        Parser.prototype.parseComponentValues = function () {
	            var values = [];
	            while (true) {
	                var value = this.consumeComponentValue();
	                if (value.type === TokenType.EOF_TOKEN) {
	                    return values;
	                }
	                values.push(value);
	                values.push();
	            }
	        };
	        Parser.prototype.consumeComponentValue = function () {
	            var token = this.consumeToken();
	            switch (token.type) {
	                case TokenType.LEFT_CURLY_BRACKET_TOKEN:
	                case TokenType.LEFT_SQUARE_BRACKET_TOKEN:
	                case TokenType.LEFT_PARENTHESIS_TOKEN:
	                    return this.consumeSimpleBlock(token.type);
	                case TokenType.FUNCTION_TOKEN:
	                    return this.consumeFunction(token);
	            }
	            return token;
	        };
	        Parser.prototype.consumeSimpleBlock = function (type) {
	            var block = { type: type, values: [] };
	            var token = this.consumeToken();
	            while (true) {
	                if (token.type === TokenType.EOF_TOKEN || isEndingTokenFor(token, type)) {
	                    return block;
	                }
	                this.reconsumeToken(token);
	                block.values.push(this.consumeComponentValue());
	                token = this.consumeToken();
	            }
	        };
	        Parser.prototype.consumeFunction = function (functionToken) {
	            var cssFunction = {
	                name: functionToken.value,
	                values: [],
	                type: TokenType.FUNCTION
	            };
	            while (true) {
	                var token = this.consumeToken();
	                if (token.type === TokenType.EOF_TOKEN || token.type === TokenType.RIGHT_PARENTHESIS_TOKEN) {
	                    return cssFunction;
	                }
	                this.reconsumeToken(token);
	                cssFunction.values.push(this.consumeComponentValue());
	            }
	        };
	        Parser.prototype.consumeToken = function () {
	            var token = this._tokens.shift();
	            return typeof token === 'undefined' ? EOF_TOKEN : token;
	        };
	        Parser.prototype.reconsumeToken = function (token) {
	            this._tokens.unshift(token);
	        };
	        return Parser;
	    }());
	    var isDimensionToken = function (token) { return token.type === TokenType.DIMENSION_TOKEN; };
	    var isNumberToken = function (token) { return token.type === TokenType.NUMBER_TOKEN; };
	    var isIdentToken = function (token) { return token.type === TokenType.IDENT_TOKEN; };
	    var isStringToken = function (token) { return token.type === TokenType.STRING_TOKEN; };
	    var isIdentWithValue = function (token, value) {
	        return isIdentToken(token) && token.value === value;
	    };
	    var nonWhiteSpace = function (token) { return token.type !== TokenType.WHITESPACE_TOKEN; };
	    var nonFunctionArgSeperator = function (token) {
	        return token.type !== TokenType.WHITESPACE_TOKEN && token.type !== TokenType.COMMA_TOKEN;
	    };
	    var parseFunctionArgs = function (tokens) {
	        var args = [];
	        var arg = [];
	        tokens.forEach(function (token) {
	            if (token.type === TokenType.COMMA_TOKEN) {
	                if (arg.length === 0) {
	                    throw new Error("Error parsing function args, zero tokens for arg");
	                }
	                args.push(arg);
	                arg = [];
	                return;
	            }
	            if (token.type !== TokenType.WHITESPACE_TOKEN) {
	                arg.push(token);
	            }
	        });
	        if (arg.length) {
	            args.push(arg);
	        }
	        return args;
	    };
	    var isEndingTokenFor = function (token, type) {
	        if (type === TokenType.LEFT_CURLY_BRACKET_TOKEN && token.type === TokenType.RIGHT_CURLY_BRACKET_TOKEN) {
	            return true;
	        }
	        if (type === TokenType.LEFT_SQUARE_BRACKET_TOKEN && token.type === TokenType.RIGHT_SQUARE_BRACKET_TOKEN) {
	            return true;
	        }
	        return type === TokenType.LEFT_PARENTHESIS_TOKEN && token.type === TokenType.RIGHT_PARENTHESIS_TOKEN;
	    };
	
	    var isLength = function (token) {
	        return token.type === TokenType.NUMBER_TOKEN || token.type === TokenType.DIMENSION_TOKEN;
	    };
	
	    var isLengthPercentage = function (token) {
	        return token.type === TokenType.PERCENTAGE_TOKEN || isLength(token);
	    };
	    var parseLengthPercentageTuple = function (tokens) {
	        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
	    };
	    var ZERO_LENGTH = {
	        type: TokenType.NUMBER_TOKEN,
	        number: 0,
	        flags: FLAG_INTEGER
	    };
	    var FIFTY_PERCENT = {
	        type: TokenType.PERCENTAGE_TOKEN,
	        number: 50,
	        flags: FLAG_INTEGER
	    };
	    var HUNDRED_PERCENT = {
	        type: TokenType.PERCENTAGE_TOKEN,
	        number: 100,
	        flags: FLAG_INTEGER
	    };
	    var getAbsoluteValueForTuple = function (tuple, width, height) {
	        var x = tuple[0], y = tuple[1];
	        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
	    };
	    var getAbsoluteValue = function (token, parent) {
	        if (token.type === TokenType.PERCENTAGE_TOKEN) {
	            return (token.number / 100) * parent;
	        }
	        if (isDimensionToken(token)) {
	            switch (token.unit) {
	                case 'rem':
	                case 'em':
	                    return 16 * token.number; // TODO use correct font-size
	                case 'px':
	                default:
	                    return token.number;
	            }
	        }
	        return token.number;
	    };
	
	    var DEG = 'deg';
	    var GRAD = 'grad';
	    var RAD = 'rad';
	    var TURN = 'turn';
	    var angle = {
	        name: 'angle',
	        parse: function (value) {
	            if (value.type === TokenType.DIMENSION_TOKEN) {
	                switch (value.unit) {
	                    case DEG:
	                        return (Math.PI * value.number) / 180;
	                    case GRAD:
	                        return (Math.PI / 200) * value.number;
	                    case RAD:
	                        return value.number;
	                    case TURN:
	                        return Math.PI * 2 * value.number;
	                }
	            }
	            throw new Error("Unsupported angle type");
	        }
	    };
	    var isAngle = function (value) {
	        if (value.type === TokenType.DIMENSION_TOKEN) {
	            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
	                return true;
	            }
	        }
	        return false;
	    };
	    var parseNamedSide = function (tokens) {
	        var sideOrCorner = tokens
	            .filter(isIdentToken)
	            .map(function (ident) { return ident.value; })
	            .join(' ');
	        switch (sideOrCorner) {
	            case 'to bottom right':
	            case 'to right bottom':
	            case 'left top':
	            case 'top left':
	                return [ZERO_LENGTH, ZERO_LENGTH];
	            case 'to top':
	            case 'bottom':
	                return deg(0);
	            case 'to bottom left':
	            case 'to left bottom':
	            case 'right top':
	            case 'top right':
	                return [ZERO_LENGTH, HUNDRED_PERCENT];
	            case 'to right':
	            case 'left':
	                return deg(90);
	            case 'to top left':
	            case 'to left top':
	            case 'right bottom':
	            case 'bottom right':
	                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
	            case 'to bottom':
	            case 'top':
	                return deg(180);
	            case 'to top right':
	            case 'to right top':
	            case 'left bottom':
	            case 'bottom left':
	                return [HUNDRED_PERCENT, ZERO_LENGTH];
	            case 'to left':
	            case 'right':
	                return deg(270);
	        }
	        return 0;
	    };
	    var deg = function (deg) { return (Math.PI * deg) / 180; };
	
	    var color = {
	        name: 'color',
	        parse: function (value) {
	            if (value.type === TokenType.FUNCTION) {
	                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
	                if (typeof colorFunction === 'undefined') {
	                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
	                }
	                return colorFunction(value.values);
	            }
	            if (value.type === TokenType.HASH_TOKEN) {
	                if (value.value.length === 3) {
	                    var r = value.value.substring(0, 1);
	                    var g = value.value.substring(1, 2);
	                    var b = value.value.substring(2, 3);
	                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
	                }
	                if (value.value.length === 4) {
	                    var r = value.value.substring(0, 1);
	                    var g = value.value.substring(1, 2);
	                    var b = value.value.substring(2, 3);
	                    var a = value.value.substring(3, 4);
	                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
	                }
	                if (value.value.length === 6) {
	                    var r = value.value.substring(0, 2);
	                    var g = value.value.substring(2, 4);
	                    var b = value.value.substring(4, 6);
	                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
	                }
	                if (value.value.length === 8) {
	                    var r = value.value.substring(0, 2);
	                    var g = value.value.substring(2, 4);
	                    var b = value.value.substring(4, 6);
	                    var a = value.value.substring(6, 8);
	                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
	                }
	            }
	            if (value.type === TokenType.IDENT_TOKEN) {
	                var namedColor = COLORS[value.value.toUpperCase()];
	                if (typeof namedColor !== 'undefined') {
	                    return namedColor;
	                }
	            }
	            return COLORS.TRANSPARENT;
	        }
	    };
	    var isTransparent = function (color) { return (0xff & color) === 0; };
	    var asString = function (color) {
	        var alpha = 0xff & color;
	        var blue = 0xff & (color >> 8);
	        var green = 0xff & (color >> 16);
	        var red = 0xff & (color >> 24);
	        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
	    };
	    var pack = function (r, g, b, a) {
	        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
	    };
	    var getTokenColorValue = function (token, i) {
	        if (token.type === TokenType.NUMBER_TOKEN) {
	            return token.number;
	        }
	        if (token.type === TokenType.PERCENTAGE_TOKEN) {
	            var max = i === 3 ? 1 : 255;
	            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
	        }
	        return 0;
	    };
	    var rgb = function (args) {
	        var tokens = args.filter(nonFunctionArgSeperator);
	        if (tokens.length === 3) {
	            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
	            return pack(r, g, b, 1);
	        }
	        if (tokens.length === 4) {
	            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
	            return pack(r, g, b, a);
	        }
	        return 0;
	    };
	    function hue2rgb(t1, t2, hue) {
	        if (hue < 0) {
	            hue += 1;
	        }
	        if (hue >= 1) {
	            hue -= 1;
	        }
	        if (hue < 1 / 6) {
	            return (t2 - t1) * hue * 6 + t1;
	        }
	        else if (hue < 1 / 2) {
	            return t2;
	        }
	        else if (hue < 2 / 3) {
	            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
	        }
	        else {
	            return t1;
	        }
	    }
	    var hsl = function (args) {
	        var tokens = args.filter(nonFunctionArgSeperator);
	        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
	        var h = (hue.type === TokenType.NUMBER_TOKEN ? deg(hue.number) : angle.parse(hue)) / (Math.PI * 2);
	        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
	        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
	        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
	        if (s === 0) {
	            return pack(l * 255, l * 255, l * 255, 1);
	        }
	        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
	        var t1 = l * 2 - t2;
	        var r = hue2rgb(t1, t2, h + 1 / 3);
	        var g = hue2rgb(t1, t2, h);
	        var b = hue2rgb(t1, t2, h - 1 / 3);
	        return pack(r * 255, g * 255, b * 255, a);
	    };
	    var SUPPORTED_COLOR_FUNCTIONS = {
	        hsl: hsl,
	        hsla: hsl,
	        rgb: rgb,
	        rgba: rgb
	    };
	    var COLORS = {
	        ALICEBLUE: 0xf0f8ffff,
	        ANTIQUEWHITE: 0xfaebd7ff,
	        AQUA: 0x00ffffff,
	        AQUAMARINE: 0x7fffd4ff,
	        AZURE: 0xf0ffffff,
	        BEIGE: 0xf5f5dcff,
	        BISQUE: 0xffe4c4ff,
	        BLACK: 0x000000ff,
	        BLANCHEDALMOND: 0xffebcdff,
	        BLUE: 0x0000ffff,
	        BLUEVIOLET: 0x8a2be2ff,
	        BROWN: 0xa52a2aff,
	        BURLYWOOD: 0xdeb887ff,
	        CADETBLUE: 0x5f9ea0ff,
	        CHARTREUSE: 0x7fff00ff,
	        CHOCOLATE: 0xd2691eff,
	        CORAL: 0xff7f50ff,
	        CORNFLOWERBLUE: 0x6495edff,
	        CORNSILK: 0xfff8dcff,
	        CRIMSON: 0xdc143cff,
	        CYAN: 0x00ffffff,
	        DARKBLUE: 0x00008bff,
	        DARKCYAN: 0x008b8bff,
	        DARKGOLDENROD: 0xb886bbff,
	        DARKGRAY: 0xa9a9a9ff,
	        DARKGREEN: 0x006400ff,
	        DARKGREY: 0xa9a9a9ff,
	        DARKKHAKI: 0xbdb76bff,
	        DARKMAGENTA: 0x8b008bff,
	        DARKOLIVEGREEN: 0x556b2fff,
	        DARKORANGE: 0xff8c00ff,
	        DARKORCHID: 0x9932ccff,
	        DARKRED: 0x8b0000ff,
	        DARKSALMON: 0xe9967aff,
	        DARKSEAGREEN: 0x8fbc8fff,
	        DARKSLATEBLUE: 0x483d8bff,
	        DARKSLATEGRAY: 0x2f4f4fff,
	        DARKSLATEGREY: 0x2f4f4fff,
	        DARKTURQUOISE: 0x00ced1ff,
	        DARKVIOLET: 0x9400d3ff,
	        DEEPPINK: 0xff1493ff,
	        DEEPSKYBLUE: 0x00bfffff,
	        DIMGRAY: 0x696969ff,
	        DIMGREY: 0x696969ff,
	        DODGERBLUE: 0x1e90ffff,
	        FIREBRICK: 0xb22222ff,
	        FLORALWHITE: 0xfffaf0ff,
	        FORESTGREEN: 0x228b22ff,
	        FUCHSIA: 0xff00ffff,
	        GAINSBORO: 0xdcdcdcff,
	        GHOSTWHITE: 0xf8f8ffff,
	        GOLD: 0xffd700ff,
	        GOLDENROD: 0xdaa520ff,
	        GRAY: 0x808080ff,
	        GREEN: 0x008000ff,
	        GREENYELLOW: 0xadff2fff,
	        GREY: 0x808080ff,
	        HONEYDEW: 0xf0fff0ff,
	        HOTPINK: 0xff69b4ff,
	        INDIANRED: 0xcd5c5cff,
	        INDIGO: 0x4b0082ff,
	        IVORY: 0xfffff0ff,
	        KHAKI: 0xf0e68cff,
	        LAVENDER: 0xe6e6faff,
	        LAVENDERBLUSH: 0xfff0f5ff,
	        LAWNGREEN: 0x7cfc00ff,
	        LEMONCHIFFON: 0xfffacdff,
	        LIGHTBLUE: 0xadd8e6ff,
	        LIGHTCORAL: 0xf08080ff,
	        LIGHTCYAN: 0xe0ffffff,
	        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
	        LIGHTGRAY: 0xd3d3d3ff,
	        LIGHTGREEN: 0x90ee90ff,
	        LIGHTGREY: 0xd3d3d3ff,
	        LIGHTPINK: 0xffb6c1ff,
	        LIGHTSALMON: 0xffa07aff,
	        LIGHTSEAGREEN: 0x20b2aaff,
	        LIGHTSKYBLUE: 0x87cefaff,
	        LIGHTSLATEGRAY: 0x778899ff,
	        LIGHTSLATEGREY: 0x778899ff,
	        LIGHTSTEELBLUE: 0xb0c4deff,
	        LIGHTYELLOW: 0xffffe0ff,
	        LIME: 0x00ff00ff,
	        LIMEGREEN: 0x32cd32ff,
	        LINEN: 0xfaf0e6ff,
	        MAGENTA: 0xff00ffff,
	        MAROON: 0x800000ff,
	        MEDIUMAQUAMARINE: 0x66cdaaff,
	        MEDIUMBLUE: 0x0000cdff,
	        MEDIUMORCHID: 0xba55d3ff,
	        MEDIUMPURPLE: 0x9370dbff,
	        MEDIUMSEAGREEN: 0x3cb371ff,
	        MEDIUMSLATEBLUE: 0x7b68eeff,
	        MEDIUMSPRINGGREEN: 0x00fa9aff,
	        MEDIUMTURQUOISE: 0x48d1ccff,
	        MEDIUMVIOLETRED: 0xc71585ff,
	        MIDNIGHTBLUE: 0x191970ff,
	        MINTCREAM: 0xf5fffaff,
	        MISTYROSE: 0xffe4e1ff,
	        MOCCASIN: 0xffe4b5ff,
	        NAVAJOWHITE: 0xffdeadff,
	        NAVY: 0x000080ff,
	        OLDLACE: 0xfdf5e6ff,
	        OLIVE: 0x808000ff,
	        OLIVEDRAB: 0x6b8e23ff,
	        ORANGE: 0xffa500ff,
	        ORANGERED: 0xff4500ff,
	        ORCHID: 0xda70d6ff,
	        PALEGOLDENROD: 0xeee8aaff,
	        PALEGREEN: 0x98fb98ff,
	        PALETURQUOISE: 0xafeeeeff,
	        PALEVIOLETRED: 0xdb7093ff,
	        PAPAYAWHIP: 0xffefd5ff,
	        PEACHPUFF: 0xffdab9ff,
	        PERU: 0xcd853fff,
	        PINK: 0xffc0cbff,
	        PLUM: 0xdda0ddff,
	        POWDERBLUE: 0xb0e0e6ff,
	        PURPLE: 0x800080ff,
	        REBECCAPURPLE: 0x663399ff,
	        RED: 0xff0000ff,
	        ROSYBROWN: 0xbc8f8fff,
	        ROYALBLUE: 0x4169e1ff,
	        SADDLEBROWN: 0x8b4513ff,
	        SALMON: 0xfa8072ff,
	        SANDYBROWN: 0xf4a460ff,
	        SEAGREEN: 0x2e8b57ff,
	        SEASHELL: 0xfff5eeff,
	        SIENNA: 0xa0522dff,
	        SILVER: 0xc0c0c0ff,
	        SKYBLUE: 0x87ceebff,
	        SLATEBLUE: 0x6a5acdff,
	        SLATEGRAY: 0x708090ff,
	        SLATEGREY: 0x708090ff,
	        SNOW: 0xfffafaff,
	        SPRINGGREEN: 0x00ff7fff,
	        STEELBLUE: 0x4682b4ff,
	        TAN: 0xd2b48cff,
	        TEAL: 0x008080ff,
	        THISTLE: 0xd8bfd8ff,
	        TOMATO: 0xff6347ff,
	        TRANSPARENT: 0x00000000,
	        TURQUOISE: 0x40e0d0ff,
	        VIOLET: 0xee82eeff,
	        WHEAT: 0xf5deb3ff,
	        WHITE: 0xffffffff,
	        WHITESMOKE: 0xf5f5f5ff,
	        YELLOW: 0xffff00ff,
	        YELLOWGREEN: 0x9acd32ff
	    };
	
	    var PropertyDescriptorParsingType;
	    (function (PropertyDescriptorParsingType) {
	        PropertyDescriptorParsingType[PropertyDescriptorParsingType["VALUE"] = 0] = "VALUE";
	        PropertyDescriptorParsingType[PropertyDescriptorParsingType["LIST"] = 1] = "LIST";
	        PropertyDescriptorParsingType[PropertyDescriptorParsingType["IDENT_VALUE"] = 2] = "IDENT_VALUE";
	        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TYPE_VALUE"] = 3] = "TYPE_VALUE";
	        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TOKEN_VALUE"] = 4] = "TOKEN_VALUE";
	    })(PropertyDescriptorParsingType || (PropertyDescriptorParsingType = {}));
	
	    var BACKGROUND_CLIP;
	    (function (BACKGROUND_CLIP) {
	        BACKGROUND_CLIP[BACKGROUND_CLIP["BORDER_BOX"] = 0] = "BORDER_BOX";
	        BACKGROUND_CLIP[BACKGROUND_CLIP["PADDING_BOX"] = 1] = "PADDING_BOX";
	        BACKGROUND_CLIP[BACKGROUND_CLIP["CONTENT_BOX"] = 2] = "CONTENT_BOX";
	    })(BACKGROUND_CLIP || (BACKGROUND_CLIP = {}));
	    var backgroundClip = {
	        name: 'background-clip',
	        initialValue: 'border-box',
	        prefix: false,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            return tokens.map(function (token) {
	                if (isIdentToken(token)) {
	                    switch (token.value) {
	                        case 'padding-box':
	                            return BACKGROUND_CLIP.PADDING_BOX;
	                        case 'content-box':
	                            return BACKGROUND_CLIP.CONTENT_BOX;
	                    }
	                }
	                return BACKGROUND_CLIP.BORDER_BOX;
	            });
	        }
	    };
	
	    var backgroundColor = {
	        name: "background-color",
	        initialValue: 'transparent',
	        prefix: false,
	        type: PropertyDescriptorParsingType.TYPE_VALUE,
	        format: 'color'
	    };
	
	    var parseColorStop = function (args) {
	        var color$1 = color.parse(args[0]);
	        var stop = args[1];
	        return stop && isLengthPercentage(stop) ? { color: color$1, stop: stop } : { color: color$1, stop: null };
	    };
	    var processColorStops = function (stops, lineLength) {
	        var first = stops[0];
	        var last = stops[stops.length - 1];
	        if (first.stop === null) {
	            first.stop = ZERO_LENGTH;
	        }
	        if (last.stop === null) {
	            last.stop = HUNDRED_PERCENT;
	        }
	        var processStops = [];
	        var previous = 0;
	        for (var i = 0; i < stops.length; i++) {
	            var stop_1 = stops[i].stop;
	            if (stop_1 !== null) {
	                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
	                if (absoluteValue > previous) {
	                    processStops.push(absoluteValue);
	                }
	                else {
	                    processStops.push(previous);
	                }
	                previous = absoluteValue;
	            }
	            else {
	                processStops.push(null);
	            }
	        }
	        var gapBegin = null;
	        for (var i = 0; i < processStops.length; i++) {
	            var stop_2 = processStops[i];
	            if (stop_2 === null) {
	                if (gapBegin === null) {
	                    gapBegin = i;
	                }
	            }
	            else if (gapBegin !== null) {
	                var gapLength = i - gapBegin;
	                var beforeGap = processStops[gapBegin - 1];
	                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
	                for (var g = 1; g <= gapLength; g++) {
	                    processStops[gapBegin + g - 1] = gapValue * g;
	                }
	                gapBegin = null;
	            }
	        }
	        return stops.map(function (_a, i) {
	            var color = _a.color;
	            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
	        });
	    };
	    var getAngleFromCorner = function (corner, width, height) {
	        var centerX = width / 2;
	        var centerY = height / 2;
	        var x = getAbsoluteValue(corner[0], width) - centerX;
	        var y = centerY - getAbsoluteValue(corner[1], height);
	        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
	    };
	    var calculateGradientDirection = function (angle, width, height) {
	        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
	        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
	        var halfWidth = width / 2;
	        var halfHeight = height / 2;
	        var halfLineLength = lineLength / 2;
	        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
	        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
	        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
	    };
	    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
	    var findCorner = function (width, height, x, y, closest) {
	        var corners = [[0, 0], [0, height], [width, 0], [width, height]];
	        return corners.reduce(function (stat, corner) {
	            var cx = corner[0], cy = corner[1];
	            var d = distance(x - cx, y - cy);
	            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
	                return {
	                    optimumCorner: corner,
	                    optimumDistance: d
	                };
	            }
	            return stat;
	        }, {
	            optimumDistance: closest ? Infinity : -Infinity,
	            optimumCorner: null
	        }).optimumCorner;
	    };
	    var calculateRadius = function (gradient, x, y, width, height) {
	        var rx = 0;
	        var ry = 0;
	        switch (gradient.size) {
	            case CSSRadialExtent.CLOSEST_SIDE:
	                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
	                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
	                if (gradient.shape === CSSRadialShape.CIRCLE) {
	                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
	                }
	                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
	                    rx = Math.min(Math.abs(x), Math.abs(x - width));
	                    ry = Math.min(Math.abs(y), Math.abs(y - height));
	                }
	                break;
	            case CSSRadialExtent.CLOSEST_CORNER:
	                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
	                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
	                if (gradient.shape === CSSRadialShape.CIRCLE) {
	                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
	                }
	                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
	                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
	                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
	                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
	                    rx = distance(cx - x, (cy - y) / c);
	                    ry = c * rx;
	                }
	                break;
	            case CSSRadialExtent.FARTHEST_SIDE:
	                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
	                if (gradient.shape === CSSRadialShape.CIRCLE) {
	                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
	                }
	                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
	                    rx = Math.max(Math.abs(x), Math.abs(x - width));
	                    ry = Math.max(Math.abs(y), Math.abs(y - height));
	                }
	                break;
	            case CSSRadialExtent.FARTHEST_CORNER:
	                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
	                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
	                if (gradient.shape === CSSRadialShape.CIRCLE) {
	                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
	                }
	                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
	                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
	                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
	                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
	                    rx = distance(cx - x, (cy - y) / c);
	                    ry = c * rx;
	                }
	                break;
	        }
	        if (Array.isArray(gradient.size)) {
	            rx = getAbsoluteValue(gradient.size[0], width);
	            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
	        }
	        return [rx, ry];
	    };
	
	    var linearGradient = function (tokens) {
	        var angle$1 = deg(180);
	        var stops = [];
	        parseFunctionArgs(tokens).forEach(function (arg, i) {
	            if (i === 0) {
	                var firstToken = arg[0];
	                if (firstToken.type === TokenType.IDENT_TOKEN && firstToken.value === 'to') {
	                    angle$1 = parseNamedSide(arg);
	                    return;
	                }
	                else if (isAngle(firstToken)) {
	                    angle$1 = angle.parse(firstToken);
	                    return;
	                }
	            }
	            var colorStop = parseColorStop(arg);
	            stops.push(colorStop);
	        });
	        return { angle: angle$1, stops: stops, type: CSSImageType.LINEAR_GRADIENT };
	    };
	
	    var prefixLinearGradient = function (tokens) {
	        var angle$1 = deg(180);
	        var stops = [];
	        parseFunctionArgs(tokens).forEach(function (arg, i) {
	            if (i === 0) {
	                var firstToken = arg[0];
	                if (firstToken.type === TokenType.IDENT_TOKEN &&
	                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
	                    angle$1 = parseNamedSide(arg);
	                    return;
	                }
	                else if (isAngle(firstToken)) {
	                    angle$1 = (angle.parse(firstToken) + deg(270)) % deg(360);
	                    return;
	                }
	            }
	            var colorStop = parseColorStop(arg);
	            stops.push(colorStop);
	        });
	        return {
	            angle: angle$1,
	            stops: stops,
	            type: CSSImageType.LINEAR_GRADIENT
	        };
	    };
	
	    var testRangeBounds = function (document) {
	        var TEST_HEIGHT = 123;
	        if (document.createRange) {
	            var range = document.createRange();
	            if (range.getBoundingClientRect) {
	                var testElement = document.createElement('boundtest');
	                testElement.style.height = TEST_HEIGHT + "px";
	                testElement.style.display = 'block';
	                document.body.appendChild(testElement);
	                range.selectNode(testElement);
	                var rangeBounds = range.getBoundingClientRect();
	                var rangeHeight = Math.round(rangeBounds.height);
	                document.body.removeChild(testElement);
	                if (rangeHeight === TEST_HEIGHT) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
	    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
	    var testSVG = function (document) {
	        var img = new Image();
	        var canvas = document.createElement('canvas');
	        var ctx = canvas.getContext('2d');
	        if (!ctx) {
	            return false;
	        }
	        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
	        try {
	            ctx.drawImage(img, 0, 0);
	            canvas.toDataURL();
	        }
	        catch (e) {
	            return false;
	        }
	        return true;
	    };
	    var isGreenPixel = function (data) {
	        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
	    };
	    var testForeignObject = function (document) {
	        var canvas = document.createElement('canvas');
	        var size = 100;
	        canvas.width = size;
	        canvas.height = size;
	        var ctx = canvas.getContext('2d');
	        if (!ctx) {
	            return Promise.reject(false);
	        }
	        ctx.fillStyle = 'rgb(0, 255, 0)';
	        ctx.fillRect(0, 0, size, size);
	        var img = new Image();
	        var greenImageSrc = canvas.toDataURL();
	        img.src = greenImageSrc;
	        var svg = createForeignObjectSVG(size, size, 0, 0, img);
	        ctx.fillStyle = 'red';
	        ctx.fillRect(0, 0, size, size);
	        return loadSerializedSVG(svg)
	            .then(function (img) {
	            ctx.drawImage(img, 0, 0);
	            var data = ctx.getImageData(0, 0, size, size).data;
	            ctx.fillStyle = 'red';
	            ctx.fillRect(0, 0, size, size);
	            var node = document.createElement('div');
	            node.style.backgroundImage = "url(" + greenImageSrc + ")";
	            node.style.height = size + "px";
	            // Firefox 55 does not render inline <img /> tags
	            return isGreenPixel(data)
	                ? loadSerializedSVG(createForeignObjectSVG(size, size, 0, 0, node))
	                : Promise.reject(false);
	        })
	            .then(function (img) {
	            ctx.drawImage(img, 0, 0);
	            // Edge does not render background-images
	            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
	        })
	            .catch(function () { return false; });
	    };
	    var createForeignObjectSVG = function (width, height, x, y, node) {
	        var xmlns = 'http://www.w3.org/2000/svg';
	        var svg = document.createElementNS(xmlns, 'svg');
	        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
	        svg.setAttributeNS(null, 'width', width.toString());
	        svg.setAttributeNS(null, 'height', height.toString());
	        foreignObject.setAttributeNS(null, 'width', '100%');
	        foreignObject.setAttributeNS(null, 'height', '100%');
	        foreignObject.setAttributeNS(null, 'x', x.toString());
	        foreignObject.setAttributeNS(null, 'y', y.toString());
	        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
	        svg.appendChild(foreignObject);
	        foreignObject.appendChild(node);
	        return svg;
	    };
	    var loadSerializedSVG = function (svg) {
	        return new Promise(function (resolve, reject) {
	            var img = new Image();
	            img.onload = function () { return resolve(img); };
	            img.onerror = reject;
	            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
	        });
	    };
	    var FEATURES = {
	        get SUPPORT_RANGE_BOUNDS() {
	            var value = testRangeBounds(document);
	            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
	            return value;
	        },
	        get SUPPORT_SVG_DRAWING() {
	            var value = testSVG(document);
	            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
	            return value;
	        },
	        get SUPPORT_FOREIGNOBJECT_DRAWING() {
	            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
	                ? testForeignObject(document)
	                : Promise.resolve(false);
	            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
	            return value;
	        },
	        get SUPPORT_CORS_IMAGES() {
	            var value = testCORS();
	            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
	            return value;
	        },
	        get SUPPORT_RESPONSE_TYPE() {
	            var value = testResponseType();
	            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
	            return value;
	        },
	        get SUPPORT_CORS_XHR() {
	            var value = 'withCredentials' in new XMLHttpRequest();
	            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
	            return value;
	        }
	    };
	
	    var Logger = /** @class */ (function () {
	        function Logger(id) {
	            this.id = id;
	            this.start = Date.now();
	        }
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Logger.prototype.debug = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line no-console
	            if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
	                // eslint-disable-next-line no-console
	                console.debug.apply(console, [this.id, this.getTime() + "ms"].concat(args));
	            }
	            else {
	                this.info.apply(this, args);
	            }
	        };
	        Logger.prototype.getTime = function () {
	            return Date.now() - this.start;
	        };
	        Logger.create = function (id) {
	            Logger.instances[id] = new Logger(id);
	        };
	        Logger.destroy = function (id) {
	            delete Logger.instances[id];
	        };
	        Logger.getInstance = function (id) {
	            var instance = Logger.instances[id];
	            if (typeof instance === 'undefined') {
	                throw new Error("No logger instance found with id " + id);
	            }
	            return instance;
	        };
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Logger.prototype.info = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line no-console
	            if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
	                // eslint-disable-next-line no-console
	                console.info.apply(console, [this.id, this.getTime() + "ms"].concat(args));
	            }
	        };
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Logger.prototype.error = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line no-console
	            if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
	                // eslint-disable-next-line no-console
	                console.error.apply(console, [this.id, this.getTime() + "ms"].concat(args));
	            }
	            else {
	                this.info.apply(this, args);
	            }
	        };
	        Logger.instances = {};
	        return Logger;
	    }());
	
	    var CacheStorage = /** @class */ (function () {
	        function CacheStorage() {
	        }
	        CacheStorage.create = function (name, options) {
	            return (CacheStorage._caches[name] = new Cache(name, options));
	        };
	        CacheStorage.destroy = function (name) {
	            delete CacheStorage._caches[name];
	        };
	        CacheStorage.open = function (name) {
	            var cache = CacheStorage._caches[name];
	            if (typeof cache !== 'undefined') {
	                return cache;
	            }
	            throw new Error("Cache with key \"" + name + "\" not found");
	        };
	        CacheStorage.getOrigin = function (url) {
	            var link = CacheStorage._link;
	            if (!link) {
	                return 'about:blank';
	            }
	            link.href = url;
	            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
	            return link.protocol + link.hostname + link.port;
	        };
	        CacheStorage.isSameOrigin = function (src) {
	            return CacheStorage.getOrigin(src) === CacheStorage._origin;
	        };
	        CacheStorage.setContext = function (window) {
	            CacheStorage._link = window.document.createElement('a');
	            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
	        };
	        CacheStorage.getInstance = function () {
	            var current = CacheStorage._current;
	            if (current === null) {
	                throw new Error("No cache instance attached");
	            }
	            return current;
	        };
	        CacheStorage.attachInstance = function (cache) {
	            CacheStorage._current = cache;
	        };
	        CacheStorage.detachInstance = function () {
	            CacheStorage._current = null;
	        };
	        CacheStorage._caches = {};
	        CacheStorage._origin = 'about:blank';
	        CacheStorage._current = null;
	        return CacheStorage;
	    }());
	    var Cache = /** @class */ (function () {
	        function Cache(id, options) {
	            this.id = id;
	            this._options = options;
	            this._cache = {};
	        }
	        Cache.prototype.addImage = function (src) {
	            var result = Promise.resolve();
	            if (this.has(src)) {
	                return result;
	            }
	            if (isBlobImage(src) || isRenderable(src)) {
	                this._cache[src] = this.loadImage(src);
	                return result;
	            }
	            return result;
	        };
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Cache.prototype.match = function (src) {
	            return this._cache[src];
	        };
	        Cache.prototype.loadImage = function (key) {
	            return __awaiter(this, void 0, void 0, function () {
	                var isSameOrigin, useCORS, useProxy, src;
	                var _this = this;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            isSameOrigin = CacheStorage.isSameOrigin(key);
	                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
	                            useProxy = !isInlineImage(key) &&
	                                !isSameOrigin &&
	                                typeof this._options.proxy === 'string' &&
	                                FEATURES.SUPPORT_CORS_XHR &&
	                                !useCORS;
	                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !useProxy && !useCORS) {
	                                return [2 /*return*/];
	                            }
	                            src = key;
	                            if (!useProxy) return [3 /*break*/, 2];
	                            return [4 /*yield*/, this.proxy(src)];
	                        case 1:
	                            src = _a.sent();
	                            _a.label = 2;
	                        case 2:
	                            Logger.getInstance(this.id).debug("Added image " + key.substring(0, 256));
	                            return [4 /*yield*/, new Promise(function (resolve, reject) {
	                                    var img = new Image();
	                                    img.onload = function () { return resolve(img); };
	                                    img.onerror = reject;
	                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
	                                    if (isInlineBase64Image(src) || useCORS) {
	                                        img.crossOrigin = 'anonymous';
	                                    }
	                                    img.src = src;
	                                    if (img.complete === true) {
	                                        // Inline XML images may fail to parse, throwing an Error later on
	                                        setTimeout(function () { return resolve(img); }, 500);
	                                    }
	                                    if (_this._options.imageTimeout > 0) {
	                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
	                                    }
	                                })];
	                        case 3: return [2 /*return*/, _a.sent()];
	                    }
	                });
	            });
	        };
	        Cache.prototype.has = function (key) {
	            return typeof this._cache[key] !== 'undefined';
	        };
	        Cache.prototype.keys = function () {
	            return Promise.resolve(Object.keys(this._cache));
	        };
	        Cache.prototype.proxy = function (src) {
	            var _this = this;
	            var proxy = this._options.proxy;
	            if (!proxy) {
	                throw new Error('No proxy defined');
	            }
	            var key = src.substring(0, 256);
	            return new Promise(function (resolve, reject) {
	                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
	                var xhr = new XMLHttpRequest();
	                xhr.onload = function () {
	                    if (xhr.status === 200) {
	                        if (responseType === 'text') {
	                            resolve(xhr.response);
	                        }
	                        else {
	                            var reader_1 = new FileReader();
	                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
	                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
	                            reader_1.readAsDataURL(xhr.response);
	                        }
	                    }
	                    else {
	                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
	                    }
	                };
	                xhr.onerror = reject;
	                xhr.open('GET', proxy + "?url=" + encodeURIComponent(src) + "&responseType=" + responseType);
	                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
	                    xhr.responseType = responseType;
	                }
	                if (_this._options.imageTimeout) {
	                    var timeout_1 = _this._options.imageTimeout;
	                    xhr.timeout = timeout_1;
	                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
	                }
	                xhr.send();
	            });
	        };
	        return Cache;
	    }());
	    var INLINE_SVG = /^data:image\/svg\+xml/i;
	    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
	    var INLINE_IMG = /^data:image\/.*/i;
	    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
	    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
	    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
	    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
	    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };
	
	    var webkitGradient = function (tokens) {
	        var angle = deg(180);
	        var stops = [];
	        var type = CSSImageType.LINEAR_GRADIENT;
	        var shape = CSSRadialShape.CIRCLE;
	        var size = CSSRadialExtent.FARTHEST_CORNER;
	        var position = [];
	        parseFunctionArgs(tokens).forEach(function (arg, i) {
	            var firstToken = arg[0];
	            if (i === 0) {
	                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
	                    type = CSSImageType.LINEAR_GRADIENT;
	                    return;
	                }
	                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
	                    type = CSSImageType.RADIAL_GRADIENT;
	                    return;
	                }
	            }
	            if (firstToken.type === TokenType.FUNCTION) {
	                if (firstToken.name === 'from') {
	                    var color$1 = color.parse(firstToken.values[0]);
	                    stops.push({ stop: ZERO_LENGTH, color: color$1 });
	                }
	                else if (firstToken.name === 'to') {
	                    var color$1 = color.parse(firstToken.values[0]);
	                    stops.push({ stop: HUNDRED_PERCENT, color: color$1 });
	                }
	                else if (firstToken.name === 'color-stop') {
	                    var values = firstToken.values.filter(nonFunctionArgSeperator);
	                    if (values.length === 2) {
	                        var color$1 = color.parse(values[1]);
	                        var stop_1 = values[0];
	                        if (isNumberToken(stop_1)) {
	                            stops.push({
	                                stop: { type: TokenType.PERCENTAGE_TOKEN, number: stop_1.number * 100, flags: stop_1.flags },
	                                color: color$1
	                            });
	                        }
	                    }
	                }
	            }
	        });
	        return type === CSSImageType.LINEAR_GRADIENT
	            ? {
	                angle: (angle + deg(180)) % deg(360),
	                stops: stops,
	                type: type
	            }
	            : { size: size, shape: shape, stops: stops, position: position, type: type };
	    };
	
	    var CLOSEST_SIDE = 'closest-side';
	    var FARTHEST_SIDE = 'farthest-side';
	    var CLOSEST_CORNER = 'closest-corner';
	    var FARTHEST_CORNER = 'farthest-corner';
	    var CIRCLE = 'circle';
	    var ELLIPSE = 'ellipse';
	    var COVER = 'cover';
	    var CONTAIN = 'contain';
	    var radialGradient = function (tokens) {
	        var shape = CSSRadialShape.CIRCLE;
	        var size = CSSRadialExtent.FARTHEST_CORNER;
	        var stops = [];
	        var position = [];
	        parseFunctionArgs(tokens).forEach(function (arg, i) {
	            var isColorStop = true;
	            if (i === 0) {
	                var isAtPosition_1 = false;
	                isColorStop = arg.reduce(function (acc, token) {
	                    if (isAtPosition_1) {
	                        if (isIdentToken(token)) {
	                            switch (token.value) {
	                                case 'center':
	                                    position.push(FIFTY_PERCENT);
	                                    return acc;
	                                case 'top':
	                                case 'left':
	                                    position.push(ZERO_LENGTH);
	                                    return acc;
	                                case 'right':
	                                case 'bottom':
	                                    position.push(HUNDRED_PERCENT);
	                                    return acc;
	                            }
	                        }
	                        else if (isLengthPercentage(token) || isLength(token)) {
	                            position.push(token);
	                        }
	                    }
	                    else if (isIdentToken(token)) {
	                        switch (token.value) {
	                            case CIRCLE:
	                                shape = CSSRadialShape.CIRCLE;
	                                return false;
	                            case ELLIPSE:
	                                shape = CSSRadialShape.ELLIPSE;
	                                return false;
	                            case 'at':
	                                isAtPosition_1 = true;
	                                return false;
	                            case CLOSEST_SIDE:
	                                size = CSSRadialExtent.CLOSEST_SIDE;
	                                return false;
	                            case COVER:
	                            case FARTHEST_SIDE:
	                                size = CSSRadialExtent.FARTHEST_SIDE;
	                                return false;
	                            case CONTAIN:
	                            case CLOSEST_CORNER:
	                                size = CSSRadialExtent.CLOSEST_CORNER;
	                                return false;
	                            case FARTHEST_CORNER:
	                                size = CSSRadialExtent.FARTHEST_CORNER;
	                                return false;
	                        }
	                    }
	                    else if (isLength(token) || isLengthPercentage(token)) {
	                        if (!Array.isArray(size)) {
	                            size = [];
	                        }
	                        size.push(token);
	                        return false;
	                    }
	                    return acc;
	                }, isColorStop);
	            }
	            if (isColorStop) {
	                var colorStop = parseColorStop(arg);
	                stops.push(colorStop);
	            }
	        });
	        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
	    };
	
	    var prefixRadialGradient = function (tokens) {
	        var shape = CSSRadialShape.CIRCLE;
	        var size = CSSRadialExtent.FARTHEST_CORNER;
	        var stops = [];
	        var position = [];
	        parseFunctionArgs(tokens).forEach(function (arg, i) {
	            var isColorStop = true;
	            if (i === 0) {
	                isColorStop = arg.reduce(function (acc, token) {
	                    if (isIdentToken(token)) {
	                        switch (token.value) {
	                            case 'center':
	                                position.push(FIFTY_PERCENT);
	                                return false;
	                            case 'top':
	                            case 'left':
	                                position.push(ZERO_LENGTH);
	                                return false;
	                            case 'right':
	                            case 'bottom':
	                                position.push(HUNDRED_PERCENT);
	                                return false;
	                        }
	                    }
	                    else if (isLengthPercentage(token) || isLength(token)) {
	                        position.push(token);
	                        return false;
	                    }
	                    return acc;
	                }, isColorStop);
	            }
	            else if (i === 1) {
	                isColorStop = arg.reduce(function (acc, token) {
	                    if (isIdentToken(token)) {
	                        switch (token.value) {
	                            case CIRCLE:
	                                shape = CSSRadialShape.CIRCLE;
	                                return false;
	                            case ELLIPSE:
	                                shape = CSSRadialShape.ELLIPSE;
	                                return false;
	                            case CONTAIN:
	                            case CLOSEST_SIDE:
	                                size = CSSRadialExtent.CLOSEST_SIDE;
	                                return false;
	                            case FARTHEST_SIDE:
	                                size = CSSRadialExtent.FARTHEST_SIDE;
	                                return false;
	                            case CLOSEST_CORNER:
	                                size = CSSRadialExtent.CLOSEST_CORNER;
	                                return false;
	                            case COVER:
	                            case FARTHEST_CORNER:
	                                size = CSSRadialExtent.FARTHEST_CORNER;
	                                return false;
	                        }
	                    }
	                    else if (isLength(token) || isLengthPercentage(token)) {
	                        if (!Array.isArray(size)) {
	                            size = [];
	                        }
	                        size.push(token);
	                        return false;
	                    }
	                    return acc;
	                }, isColorStop);
	            }
	            if (isColorStop) {
	                var colorStop = parseColorStop(arg);
	                stops.push(colorStop);
	            }
	        });
	        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
	    };
	
	    var CSSImageType;
	    (function (CSSImageType) {
	        CSSImageType[CSSImageType["URL"] = 0] = "URL";
	        CSSImageType[CSSImageType["LINEAR_GRADIENT"] = 1] = "LINEAR_GRADIENT";
	        CSSImageType[CSSImageType["RADIAL_GRADIENT"] = 2] = "RADIAL_GRADIENT";
	    })(CSSImageType || (CSSImageType = {}));
	    var isLinearGradient = function (background) {
	        return background.type === CSSImageType.LINEAR_GRADIENT;
	    };
	    var isRadialGradient = function (background) {
	        return background.type === CSSImageType.RADIAL_GRADIENT;
	    };
	    var CSSRadialShape;
	    (function (CSSRadialShape) {
	        CSSRadialShape[CSSRadialShape["CIRCLE"] = 0] = "CIRCLE";
	        CSSRadialShape[CSSRadialShape["ELLIPSE"] = 1] = "ELLIPSE";
	    })(CSSRadialShape || (CSSRadialShape = {}));
	    var CSSRadialExtent;
	    (function (CSSRadialExtent) {
	        CSSRadialExtent[CSSRadialExtent["CLOSEST_SIDE"] = 0] = "CLOSEST_SIDE";
	        CSSRadialExtent[CSSRadialExtent["FARTHEST_SIDE"] = 1] = "FARTHEST_SIDE";
	        CSSRadialExtent[CSSRadialExtent["CLOSEST_CORNER"] = 2] = "CLOSEST_CORNER";
	        CSSRadialExtent[CSSRadialExtent["FARTHEST_CORNER"] = 3] = "FARTHEST_CORNER";
	    })(CSSRadialExtent || (CSSRadialExtent = {}));
	    var image = {
	        name: 'image',
	        parse: function (value) {
	            if (value.type === TokenType.URL_TOKEN) {
	                var image_1 = { url: value.value, type: CSSImageType.URL };
	                CacheStorage.getInstance().addImage(value.value);
	                return image_1;
	            }
	            if (value.type === TokenType.FUNCTION) {
	                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
	                if (typeof imageFunction === 'undefined') {
	                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
	                }
	                return imageFunction(value.values);
	            }
	            throw new Error("Unsupported image type");
	        }
	    };
	    var SUPPORTED_IMAGE_FUNCTIONS = {
	        'linear-gradient': linearGradient,
	        '-moz-linear-gradient': prefixLinearGradient,
	        '-ms-linear-gradient': prefixLinearGradient,
	        '-o-linear-gradient': prefixLinearGradient,
	        '-webkit-linear-gradient': prefixLinearGradient,
	        'radial-gradient': radialGradient,
	        '-moz-radial-gradient': prefixRadialGradient,
	        '-ms-radial-gradient': prefixRadialGradient,
	        '-o-radial-gradient': prefixRadialGradient,
	        '-webkit-radial-gradient': prefixRadialGradient,
	        '-webkit-gradient': webkitGradient
	    };
	
	    var backgroundImage = {
	        name: 'background-image',
	        initialValue: 'none',
	        type: PropertyDescriptorParsingType.LIST,
	        prefix: false,
	        parse: function (tokens) {
	            if (tokens.length === 0) {
	                return [];
	            }
	            var first = tokens[0];
	            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
	                return [];
	            }
	            return tokens.filter(nonFunctionArgSeperator).map(image.parse);
	        }
	    };
	
	    var backgroundOrigin = {
	        name: 'background-origin',
	        initialValue: 'border-box',
	        prefix: false,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            return tokens.map(function (token) {
	                if (isIdentToken(token)) {
	                    switch (token.value) {
	                        case 'padding-box':
	                            return 1 /* PADDING_BOX */;
	                        case 'content-box':
	                            return 2 /* CONTENT_BOX */;
	                    }
	                }
	                return 0 /* BORDER_BOX */;
	            });
	        }
	    };
	
	    var backgroundPosition = {
	        name: 'background-position',
	        initialValue: '0% 0%',
	        type: PropertyDescriptorParsingType.LIST,
	        prefix: false,
	        parse: function (tokens) {
	            return parseFunctionArgs(tokens)
	                .map(function (values) { return values.filter(isLengthPercentage); })
	                .map(parseLengthPercentageTuple);
	        }
	    };
	
	    var BACKGROUND_REPEAT;
	    (function (BACKGROUND_REPEAT) {
	        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT"] = 0] = "REPEAT";
	        BACKGROUND_REPEAT[BACKGROUND_REPEAT["NO_REPEAT"] = 1] = "NO_REPEAT";
	        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_X"] = 2] = "REPEAT_X";
	        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_Y"] = 3] = "REPEAT_Y";
	    })(BACKGROUND_REPEAT || (BACKGROUND_REPEAT = {}));
	    var backgroundRepeat = {
	        name: 'background-repeat',
	        initialValue: 'repeat',
	        prefix: false,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            return parseFunctionArgs(tokens)
	                .map(function (values) {
	                return values
	                    .filter(isIdentToken)
	                    .map(function (token) { return token.value; })
	                    .join(' ');
	            })
	                .map(parseBackgroundRepeat);
	        }
	    };
	    var parseBackgroundRepeat = function (value) {
	        switch (value) {
	            case 'no-repeat':
	                return BACKGROUND_REPEAT.NO_REPEAT;
	            case 'repeat-x':
	            case 'repeat no-repeat':
	                return BACKGROUND_REPEAT.REPEAT_X;
	            case 'repeat-y':
	            case 'no-repeat repeat':
	                return BACKGROUND_REPEAT.REPEAT_Y;
	            case 'repeat':
	            default:
	                return BACKGROUND_REPEAT.REPEAT;
	        }
	    };
	
	    var BACKGROUND_SIZE;
	    (function (BACKGROUND_SIZE) {
	        BACKGROUND_SIZE["AUTO"] = "auto";
	        BACKGROUND_SIZE["CONTAIN"] = "contain";
	        BACKGROUND_SIZE["COVER"] = "cover";
	    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
	    var backgroundSize = {
	        name: 'background-size',
	        initialValue: '0',
	        prefix: false,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
	        }
	    };
	    var isBackgroundSizeInfoToken = function (value) {
	        return isIdentToken(value) || isLengthPercentage(value);
	    };
	
	    var borderColorForSide = function (side) { return ({
	        name: "border-" + side + "-color",
	        initialValue: 'transparent',
	        prefix: false,
	        type: PropertyDescriptorParsingType.TYPE_VALUE,
	        format: 'color'
	    }); };
	    var borderTopColor = borderColorForSide('top');
	    var borderRightColor = borderColorForSide('right');
	    var borderBottomColor = borderColorForSide('bottom');
	    var borderLeftColor = borderColorForSide('left');
	
	    var borderRadiusForSide = function (side) { return ({
	        name: "border-radius-" + side,
	        initialValue: '0 0',
	        prefix: false,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) { return parseLengthPercentageTuple(tokens.filter(isLengthPercentage)); }
	    }); };
	    var borderTopLeftRadius = borderRadiusForSide('top-left');
	    var borderTopRightRadius = borderRadiusForSide('top-right');
	    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
	    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
	
	    var BORDER_STYLE;
	    (function (BORDER_STYLE) {
	        BORDER_STYLE[BORDER_STYLE["NONE"] = 0] = "NONE";
	        BORDER_STYLE[BORDER_STYLE["SOLID"] = 1] = "SOLID";
	    })(BORDER_STYLE || (BORDER_STYLE = {}));
	    var borderStyleForSide = function (side) { return ({
	        name: "border-" + side + "-style",
	        initialValue: 'solid',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (style) {
	            switch (style) {
	                case 'none':
	                    return BORDER_STYLE.NONE;
	            }
	            return BORDER_STYLE.SOLID;
	        }
	    }); };
	    var borderTopStyle = borderStyleForSide('top');
	    var borderRightStyle = borderStyleForSide('right');
	    var borderBottomStyle = borderStyleForSide('bottom');
	    var borderLeftStyle = borderStyleForSide('left');
	
	    var borderWidthForSide = function (side) { return ({
	        name: "border-" + side + "-width",
	        initialValue: '0',
	        type: PropertyDescriptorParsingType.VALUE,
	        prefix: false,
	        parse: function (token) {
	            if (isDimensionToken(token)) {
	                return token.number;
	            }
	            return 0;
	        }
	    }); };
	    var borderTopWidth = borderWidthForSide('top');
	    var borderRightWidth = borderWidthForSide('right');
	    var borderBottomWidth = borderWidthForSide('bottom');
	    var borderLeftWidth = borderWidthForSide('left');
	
	    var color$1 = {
	        name: "color",
	        initialValue: 'transparent',
	        prefix: false,
	        type: PropertyDescriptorParsingType.TYPE_VALUE,
	        format: 'color'
	    };
	
	    var display = {
	        name: 'display',
	        initialValue: 'inline-block',
	        prefix: false,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            return tokens.filter(isIdentToken).reduce(function (bit, token) {
	                return bit | parseDisplayValue(token.value);
	            }, 0 /* NONE */);
	        }
	    };
	    var parseDisplayValue = function (display) {
	        switch (display) {
	            case 'block':
	                return 2 /* BLOCK */;
	            case 'inline':
	                return 4 /* INLINE */;
	            case 'run-in':
	                return 8 /* RUN_IN */;
	            case 'flow':
	                return 16 /* FLOW */;
	            case 'flow-root':
	                return 32 /* FLOW_ROOT */;
	            case 'table':
	                return 64 /* TABLE */;
	            case 'flex':
	            case '-webkit-flex':
	                return 128 /* FLEX */;
	            case 'grid':
	                return 256 /* GRID */;
	            case 'ruby':
	                return 512 /* RUBY */;
	            case 'subgrid':
	                return 1024 /* SUBGRID */;
	            case 'list-item':
	                return 2048 /* LIST_ITEM */;
	            case 'table-row-group':
	                return 4096 /* TABLE_ROW_GROUP */;
	            case 'table-header-group':
	                return 8192 /* TABLE_HEADER_GROUP */;
	            case 'table-footer-group':
	                return 16384 /* TABLE_FOOTER_GROUP */;
	            case 'table-row':
	                return 32768 /* TABLE_ROW */;
	            case 'table-cell':
	                return 65536 /* TABLE_CELL */;
	            case 'table-column-group':
	                return 131072 /* TABLE_COLUMN_GROUP */;
	            case 'table-column':
	                return 262144 /* TABLE_COLUMN */;
	            case 'table-caption':
	                return 524288 /* TABLE_CAPTION */;
	            case 'ruby-base':
	                return 1048576 /* RUBY_BASE */;
	            case 'ruby-text':
	                return 2097152 /* RUBY_TEXT */;
	            case 'ruby-base-container':
	                return 4194304 /* RUBY_BASE_CONTAINER */;
	            case 'ruby-text-container':
	                return 8388608 /* RUBY_TEXT_CONTAINER */;
	            case 'contents':
	                return 16777216 /* CONTENTS */;
	            case 'inline-block':
	                return 33554432 /* INLINE_BLOCK */;
	            case 'inline-list-item':
	                return 67108864 /* INLINE_LIST_ITEM */;
	            case 'inline-table':
	                return 134217728 /* INLINE_TABLE */;
	            case 'inline-flex':
	                return 268435456 /* INLINE_FLEX */;
	            case 'inline-grid':
	                return 536870912 /* INLINE_GRID */;
	        }
	        return 0 /* NONE */;
	    };
	
	    var FLOAT;
	    (function (FLOAT) {
	        FLOAT[FLOAT["NONE"] = 0] = "NONE";
	        FLOAT[FLOAT["LEFT"] = 1] = "LEFT";
	        FLOAT[FLOAT["RIGHT"] = 2] = "RIGHT";
	        FLOAT[FLOAT["INLINE_START"] = 3] = "INLINE_START";
	        FLOAT[FLOAT["INLINE_END"] = 4] = "INLINE_END";
	    })(FLOAT || (FLOAT = {}));
	    var float = {
	        name: 'float',
	        initialValue: 'none',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (float) {
	            switch (float) {
	                case 'left':
	                    return FLOAT.LEFT;
	                case 'right':
	                    return FLOAT.RIGHT;
	                case 'inline-start':
	                    return FLOAT.INLINE_START;
	                case 'inline-end':
	                    return FLOAT.INLINE_END;
	            }
	            return FLOAT.NONE;
	        }
	    };
	
	    var letterSpacing = {
	        name: 'letter-spacing',
	        initialValue: '0',
	        prefix: false,
	        type: PropertyDescriptorParsingType.VALUE,
	        parse: function (token) {
	            if (token.type === TokenType.IDENT_TOKEN && token.value === 'normal') {
	                return 0;
	            }
	            if (token.type === TokenType.NUMBER_TOKEN) {
	                return token.number;
	            }
	            if (token.type === TokenType.DIMENSION_TOKEN) {
	                return token.number;
	            }
	            return 0;
	        }
	    };
	
	    var LINE_BREAK;
	    (function (LINE_BREAK) {
	        LINE_BREAK["NORMAL"] = "normal";
	        LINE_BREAK["STRICT"] = "strict";
	    })(LINE_BREAK || (LINE_BREAK = {}));
	    var lineBreak = {
	        name: 'line-break',
	        initialValue: 'normal',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (lineBreak) {
	            switch (lineBreak) {
	                case 'strict':
	                    return LINE_BREAK.STRICT;
	                case 'normal':
	                default:
	                    return LINE_BREAK.NORMAL;
	            }
	        }
	    };
	
	    var lineHeight = {
	        name: 'line-height',
	        initialValue: 'normal',
	        prefix: false,
	        type: PropertyDescriptorParsingType.TOKEN_VALUE
	    };
	    var computeLineHeight = function (token, fontSize) {
	        if (isIdentToken(token) && token.value === 'normal') {
	            return 1.2 * fontSize;
	        }
	        else if (token.type === TokenType.NUMBER_TOKEN) {
	            return fontSize * token.number;
	        }
	        else if (isLengthPercentage(token)) {
	            return getAbsoluteValue(token, fontSize);
	        }
	        return fontSize;
	    };
	
	    var listStyleImage = {
	        name: 'list-style-image',
	        initialValue: 'none',
	        type: PropertyDescriptorParsingType.VALUE,
	        prefix: false,
	        parse: function (token) {
	            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
	                return null;
	            }
	            return image.parse(token);
	        }
	    };
	
	    var LIST_STYLE_POSITION;
	    (function (LIST_STYLE_POSITION) {
	        LIST_STYLE_POSITION[LIST_STYLE_POSITION["INSIDE"] = 0] = "INSIDE";
	        LIST_STYLE_POSITION[LIST_STYLE_POSITION["OUTSIDE"] = 1] = "OUTSIDE";
	    })(LIST_STYLE_POSITION || (LIST_STYLE_POSITION = {}));
	    var listStylePosition = {
	        name: 'list-style-position',
	        initialValue: 'outside',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (position) {
	            switch (position) {
	                case 'inside':
	                    return LIST_STYLE_POSITION.INSIDE;
	                case 'outside':
	                default:
	                    return LIST_STYLE_POSITION.OUTSIDE;
	            }
	        }
	    };
	
	    var LIST_STYLE_TYPE;
	    (function (LIST_STYLE_TYPE) {
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["NONE"] = -1] = "NONE";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISC"] = 0] = "DISC";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CIRCLE"] = 1] = "CIRCLE";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SQUARE"] = 2] = "SQUARE";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL"] = 3] = "DECIMAL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_DECIMAL"] = 4] = "CJK_DECIMAL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL_LEADING_ZERO"] = 5] = "DECIMAL_LEADING_ZERO";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ROMAN"] = 6] = "LOWER_ROMAN";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ROMAN"] = 7] = "UPPER_ROMAN";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_GREEK"] = 8] = "LOWER_GREEK";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ALPHA"] = 9] = "LOWER_ALPHA";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ALPHA"] = 10] = "UPPER_ALPHA";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARABIC_INDIC"] = 11] = "ARABIC_INDIC";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARMENIAN"] = 12] = "ARMENIAN";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["BENGALI"] = 13] = "BENGALI";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CAMBODIAN"] = 14] = "CAMBODIAN";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_EARTHLY_BRANCH"] = 15] = "CJK_EARTHLY_BRANCH";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_HEAVENLY_STEM"] = 16] = "CJK_HEAVENLY_STEM";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_IDEOGRAPHIC"] = 17] = "CJK_IDEOGRAPHIC";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DEVANAGARI"] = 18] = "DEVANAGARI";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ETHIOPIC_NUMERIC"] = 19] = "ETHIOPIC_NUMERIC";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GEORGIAN"] = 20] = "GEORGIAN";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GUJARATI"] = 21] = "GUJARATI";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GURMUKHI"] = 22] = "GURMUKHI";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HEBREW"] = 22] = "HEBREW";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA"] = 23] = "HIRAGANA";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA_IROHA"] = 24] = "HIRAGANA_IROHA";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_FORMAL"] = 25] = "JAPANESE_FORMAL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_INFORMAL"] = 26] = "JAPANESE_INFORMAL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KANNADA"] = 27] = "KANNADA";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA"] = 28] = "KATAKANA";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA_IROHA"] = 29] = "KATAKANA_IROHA";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KHMER"] = 30] = "KHMER";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANGUL_FORMAL"] = 31] = "KOREAN_HANGUL_FORMAL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_FORMAL"] = 32] = "KOREAN_HANJA_FORMAL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_INFORMAL"] = 33] = "KOREAN_HANJA_INFORMAL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LAO"] = 34] = "LAO";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ARMENIAN"] = 35] = "LOWER_ARMENIAN";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MALAYALAM"] = 36] = "MALAYALAM";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MONGOLIAN"] = 37] = "MONGOLIAN";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MYANMAR"] = 38] = "MYANMAR";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ORIYA"] = 39] = "ORIYA";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["PERSIAN"] = 40] = "PERSIAN";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_FORMAL"] = 41] = "SIMP_CHINESE_FORMAL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_INFORMAL"] = 42] = "SIMP_CHINESE_INFORMAL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TAMIL"] = 43] = "TAMIL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TELUGU"] = 44] = "TELUGU";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["THAI"] = 45] = "THAI";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TIBETAN"] = 46] = "TIBETAN";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_FORMAL"] = 47] = "TRAD_CHINESE_FORMAL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_INFORMAL"] = 48] = "TRAD_CHINESE_INFORMAL";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ARMENIAN"] = 49] = "UPPER_ARMENIAN";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_OPEN"] = 50] = "DISCLOSURE_OPEN";
	        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_CLOSED"] = 51] = "DISCLOSURE_CLOSED";
	    })(LIST_STYLE_TYPE || (LIST_STYLE_TYPE = {}));
	    var listStyleType = {
	        name: 'list-style-type',
	        initialValue: 'none',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (type) {
	            switch (type) {
	                case 'disc':
	                    return LIST_STYLE_TYPE.DISC;
	                case 'circle':
	                    return LIST_STYLE_TYPE.CIRCLE;
	                case 'square':
	                    return LIST_STYLE_TYPE.SQUARE;
	                case 'decimal':
	                    return LIST_STYLE_TYPE.DECIMAL;
	                case 'cjk-decimal':
	                    return LIST_STYLE_TYPE.CJK_DECIMAL;
	                case 'decimal-leading-zero':
	                    return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
	                case 'lower-roman':
	                    return LIST_STYLE_TYPE.LOWER_ROMAN;
	                case 'upper-roman':
	                    return LIST_STYLE_TYPE.UPPER_ROMAN;
	                case 'lower-greek':
	                    return LIST_STYLE_TYPE.LOWER_GREEK;
	                case 'lower-alpha':
	                    return LIST_STYLE_TYPE.LOWER_ALPHA;
	                case 'upper-alpha':
	                    return LIST_STYLE_TYPE.UPPER_ALPHA;
	                case 'arabic-indic':
	                    return LIST_STYLE_TYPE.ARABIC_INDIC;
	                case 'armenian':
	                    return LIST_STYLE_TYPE.ARMENIAN;
	                case 'bengali':
	                    return LIST_STYLE_TYPE.BENGALI;
	                case 'cambodian':
	                    return LIST_STYLE_TYPE.CAMBODIAN;
	                case 'cjk-earthly-branch':
	                    return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
	                case 'cjk-heavenly-stem':
	                    return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
	                case 'cjk-ideographic':
	                    return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
	                case 'devanagari':
	                    return LIST_STYLE_TYPE.DEVANAGARI;
	                case 'ethiopic-numeric':
	                    return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
	                case 'georgian':
	                    return LIST_STYLE_TYPE.GEORGIAN;
	                case 'gujarati':
	                    return LIST_STYLE_TYPE.GUJARATI;
	                case 'gurmukhi':
	                    return LIST_STYLE_TYPE.GURMUKHI;
	                case 'hebrew':
	                    return LIST_STYLE_TYPE.HEBREW;
	                case 'hiragana':
	                    return LIST_STYLE_TYPE.HIRAGANA;
	                case 'hiragana-iroha':
	                    return LIST_STYLE_TYPE.HIRAGANA_IROHA;
	                case 'japanese-formal':
	                    return LIST_STYLE_TYPE.JAPANESE_FORMAL;
	                case 'japanese-informal':
	                    return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
	                case 'kannada':
	                    return LIST_STYLE_TYPE.KANNADA;
	                case 'katakana':
	                    return LIST_STYLE_TYPE.KATAKANA;
	                case 'katakana-iroha':
	                    return LIST_STYLE_TYPE.KATAKANA_IROHA;
	                case 'khmer':
	                    return LIST_STYLE_TYPE.KHMER;
	                case 'korean-hangul-formal':
	                    return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
	                case 'korean-hanja-formal':
	                    return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
	                case 'korean-hanja-informal':
	                    return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
	                case 'lao':
	                    return LIST_STYLE_TYPE.LAO;
	                case 'lower-armenian':
	                    return LIST_STYLE_TYPE.LOWER_ARMENIAN;
	                case 'malayalam':
	                    return LIST_STYLE_TYPE.MALAYALAM;
	                case 'mongolian':
	                    return LIST_STYLE_TYPE.MONGOLIAN;
	                case 'myanmar':
	                    return LIST_STYLE_TYPE.MYANMAR;
	                case 'oriya':
	                    return LIST_STYLE_TYPE.ORIYA;
	                case 'persian':
	                    return LIST_STYLE_TYPE.PERSIAN;
	                case 'simp-chinese-formal':
	                    return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
	                case 'simp-chinese-informal':
	                    return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
	                case 'tamil':
	                    return LIST_STYLE_TYPE.TAMIL;
	                case 'telugu':
	                    return LIST_STYLE_TYPE.TELUGU;
	                case 'thai':
	                    return LIST_STYLE_TYPE.THAI;
	                case 'tibetan':
	                    return LIST_STYLE_TYPE.TIBETAN;
	                case 'trad-chinese-formal':
	                    return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
	                case 'trad-chinese-informal':
	                    return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
	                case 'upper-armenian':
	                    return LIST_STYLE_TYPE.UPPER_ARMENIAN;
	                case 'disclosure-open':
	                    return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
	                case 'disclosure-closed':
	                    return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
	                case 'none':
	                default:
	                    return LIST_STYLE_TYPE.NONE;
	            }
	        }
	    };
	
	    var marginForSide = function (side) { return ({
	        name: "margin-" + side,
	        initialValue: '0',
	        prefix: false,
	        type: PropertyDescriptorParsingType.TOKEN_VALUE
	    }); };
	    var marginTop = marginForSide('top');
	    var marginRight = marginForSide('right');
	    var marginBottom = marginForSide('bottom');
	    var marginLeft = marginForSide('left');
	
	    var OVERFLOW;
	    (function (OVERFLOW) {
	        OVERFLOW[OVERFLOW["VISIBLE"] = 0] = "VISIBLE";
	        OVERFLOW[OVERFLOW["HIDDEN"] = 1] = "HIDDEN";
	        OVERFLOW[OVERFLOW["SCROLL"] = 2] = "SCROLL";
	        OVERFLOW[OVERFLOW["AUTO"] = 3] = "AUTO";
	    })(OVERFLOW || (OVERFLOW = {}));
	    var overflow = {
	        name: 'overflow',
	        initialValue: 'visible',
	        prefix: false,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            return tokens.filter(isIdentToken).map(function (overflow) {
	                switch (overflow.value) {
	                    case 'hidden':
	                        return OVERFLOW.HIDDEN;
	                    case 'scroll':
	                        return OVERFLOW.SCROLL;
	                    case 'auto':
	                        return OVERFLOW.AUTO;
	                    case 'visible':
	                    default:
	                        return OVERFLOW.VISIBLE;
	                }
	            });
	        }
	    };
	
	    var OVERFLOW_WRAP;
	    (function (OVERFLOW_WRAP) {
	        OVERFLOW_WRAP["NORMAL"] = "normal";
	        OVERFLOW_WRAP["BREAK_WORD"] = "break-word";
	    })(OVERFLOW_WRAP || (OVERFLOW_WRAP = {}));
	    var overflowWrap = {
	        name: 'overflow-wrap',
	        initialValue: 'normal',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (overflow) {
	            switch (overflow) {
	                case 'break-word':
	                    return OVERFLOW_WRAP.BREAK_WORD;
	                case 'normal':
	                default:
	                    return OVERFLOW_WRAP.NORMAL;
	            }
	        }
	    };
	
	    var paddingForSide = function (side) { return ({
	        name: "padding-" + side,
	        initialValue: '0',
	        prefix: false,
	        type: PropertyDescriptorParsingType.TYPE_VALUE,
	        format: 'length-percentage'
	    }); };
	    var paddingTop = paddingForSide('top');
	    var paddingRight = paddingForSide('right');
	    var paddingBottom = paddingForSide('bottom');
	    var paddingLeft = paddingForSide('left');
	
	    var TEXT_ALIGN;
	    (function (TEXT_ALIGN) {
	        TEXT_ALIGN[TEXT_ALIGN["LEFT"] = 0] = "LEFT";
	        TEXT_ALIGN[TEXT_ALIGN["CENTER"] = 1] = "CENTER";
	        TEXT_ALIGN[TEXT_ALIGN["RIGHT"] = 2] = "RIGHT";
	    })(TEXT_ALIGN || (TEXT_ALIGN = {}));
	    var textAlign = {
	        name: 'text-align',
	        initialValue: 'left',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (textAlign) {
	            switch (textAlign) {
	                case 'right':
	                    return TEXT_ALIGN.RIGHT;
	                case 'center':
	                case 'justify':
	                    return TEXT_ALIGN.CENTER;
	                case 'left':
	                default:
	                    return TEXT_ALIGN.LEFT;
	            }
	        }
	    };
	
	    var POSITION;
	    (function (POSITION) {
	        POSITION[POSITION["STATIC"] = 0] = "STATIC";
	        POSITION[POSITION["RELATIVE"] = 1] = "RELATIVE";
	        POSITION[POSITION["ABSOLUTE"] = 2] = "ABSOLUTE";
	        POSITION[POSITION["FIXED"] = 3] = "FIXED";
	        POSITION[POSITION["STICKY"] = 4] = "STICKY";
	    })(POSITION || (POSITION = {}));
	    var position = {
	        name: 'position',
	        initialValue: 'static',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (position) {
	            switch (position) {
	                case 'relative':
	                    return POSITION.RELATIVE;
	                case 'absolute':
	                    return POSITION.ABSOLUTE;
	                case 'fixed':
	                    return POSITION.FIXED;
	                case 'sticky':
	                    return POSITION.STICKY;
	            }
	            return POSITION.STATIC;
	        }
	    };
	
	    var textShadow = {
	        name: 'text-shadow',
	        initialValue: 'none',
	        type: PropertyDescriptorParsingType.LIST,
	        prefix: false,
	        parse: function (tokens) {
	            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
	                return [];
	            }
	            return parseFunctionArgs(tokens).map(function (values) {
	                var shadow = {
	                    color: COLORS.TRANSPARENT,
	                    offsetX: ZERO_LENGTH,
	                    offsetY: ZERO_LENGTH,
	                    blur: ZERO_LENGTH
	                };
	                var c = 0;
	                for (var i = 0; i < values.length; i++) {
	                    var token = values[i];
	                    if (isLength(token)) {
	                        if (c === 0) {
	                            shadow.offsetX = token;
	                        }
	                        else if (c === 1) {
	                            shadow.offsetY = token;
	                        }
	                        else {
	                            shadow.blur = token;
	                        }
	                        c++;
	                    }
	                    else {
	                        shadow.color = color.parse(token);
	                    }
	                }
	                return shadow;
	            });
	        }
	    };
	
	    var TEXT_TRANSFORM;
	    (function (TEXT_TRANSFORM) {
	        TEXT_TRANSFORM[TEXT_TRANSFORM["NONE"] = 0] = "NONE";
	        TEXT_TRANSFORM[TEXT_TRANSFORM["LOWERCASE"] = 1] = "LOWERCASE";
	        TEXT_TRANSFORM[TEXT_TRANSFORM["UPPERCASE"] = 2] = "UPPERCASE";
	        TEXT_TRANSFORM[TEXT_TRANSFORM["CAPITALIZE"] = 3] = "CAPITALIZE";
	    })(TEXT_TRANSFORM || (TEXT_TRANSFORM = {}));
	    var textTransform = {
	        name: 'text-transform',
	        initialValue: 'none',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (textTransform) {
	            switch (textTransform) {
	                case 'uppercase':
	                    return TEXT_TRANSFORM.UPPERCASE;
	                case 'lowercase':
	                    return TEXT_TRANSFORM.LOWERCASE;
	                case 'capitalize':
	                    return TEXT_TRANSFORM.CAPITALIZE;
	            }
	            return TEXT_TRANSFORM.NONE;
	        }
	    };
	
	    var transform = {
	        name: 'transform',
	        initialValue: 'none',
	        prefix: true,
	        type: PropertyDescriptorParsingType.VALUE,
	        parse: function (token) {
	            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
	                return null;
	            }
	            if (token.type === TokenType.FUNCTION) {
	                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
	                if (typeof transformFunction === 'undefined') {
	                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
	                }
	                return transformFunction(token.values);
	            }
	            return null;
	        }
	    };
	    var matrix = function (args) {
	        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
	        return values.length === 6 ? values : null;
	    };
	    // doesn't support 3D transforms at the moment
	    var matrix3d = function (args) {
	        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
	        var a1 = values[0], b1 = values[1], _a = values[2], _b = values[3], a2 = values[4], b2 = values[5], _c = values[6], _d = values[7], _e = values[8], _f = values[9], _g = values[10], _h = values[11], a4 = values[12], b4 = values[13], _j = values[14], _k = values[15];
	        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
	    };
	    var SUPPORTED_TRANSFORM_FUNCTIONS = {
	        matrix: matrix,
	        matrix3d: matrix3d
	    };
	
	    var DEFAULT_VALUE = {
	        type: TokenType.PERCENTAGE_TOKEN,
	        number: 50,
	        flags: FLAG_INTEGER
	    };
	    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
	    var transformOrigin = {
	        name: 'transform-origin',
	        initialValue: '50% 50%',
	        prefix: true,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            var origins = tokens.filter(isLengthPercentage);
	            if (origins.length !== 2) {
	                return DEFAULT;
	            }
	            return [origins[0], origins[1]];
	        }
	    };
	
	    var VISIBILITY;
	    (function (VISIBILITY) {
	        VISIBILITY[VISIBILITY["VISIBLE"] = 0] = "VISIBLE";
	        VISIBILITY[VISIBILITY["HIDDEN"] = 1] = "HIDDEN";
	        VISIBILITY[VISIBILITY["COLLAPSE"] = 2] = "COLLAPSE";
	    })(VISIBILITY || (VISIBILITY = {}));
	    var visibility = {
	        name: 'visible',
	        initialValue: 'none',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (visibility) {
	            switch (visibility) {
	                case 'hidden':
	                    return VISIBILITY.HIDDEN;
	                case 'collapse':
	                    return VISIBILITY.COLLAPSE;
	                case 'visible':
	                default:
	                    return VISIBILITY.VISIBLE;
	            }
	        }
	    };
	
	    var WORD_BREAK;
	    (function (WORD_BREAK) {
	        WORD_BREAK["NORMAL"] = "normal";
	        WORD_BREAK["BREAK_ALL"] = "break-all";
	        WORD_BREAK["KEEP_ALL"] = "keep-all";
	    })(WORD_BREAK || (WORD_BREAK = {}));
	    var wordBreak = {
	        name: 'word-break',
	        initialValue: 'normal',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (wordBreak) {
	            switch (wordBreak) {
	                case 'break-all':
	                    return WORD_BREAK.BREAK_ALL;
	                case 'keep-all':
	                    return WORD_BREAK.KEEP_ALL;
	                case 'normal':
	                default:
	                    return WORD_BREAK.NORMAL;
	            }
	        }
	    };
	
	    var zIndex = {
	        name: 'z-index',
	        initialValue: 'auto',
	        prefix: false,
	        type: PropertyDescriptorParsingType.VALUE,
	        parse: function (token) {
	            if (token.type === TokenType.IDENT_TOKEN) {
	                return { auto: true, order: 0 };
	            }
	            if (isNumberToken(token)) {
	                return { auto: false, order: token.number };
	            }
	            throw new Error("Invalid z-index number parsed");
	        }
	    };
	
	    var opacity = {
	        name: 'opacity',
	        initialValue: '1',
	        type: PropertyDescriptorParsingType.VALUE,
	        prefix: false,
	        parse: function (token) {
	            if (isNumberToken(token)) {
	                return token.number;
	            }
	            return 1;
	        }
	    };
	
	    var textDecorationColor = {
	        name: "text-decoration-color",
	        initialValue: 'transparent',
	        prefix: false,
	        type: PropertyDescriptorParsingType.TYPE_VALUE,
	        format: 'color'
	    };
	
	    var textDecorationLine = {
	        name: 'text-decoration-line',
	        initialValue: 'none',
	        prefix: false,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            return tokens
	                .filter(isIdentToken)
	                .map(function (token) {
	                switch (token.value) {
	                    case 'underline':
	                        return 1 /* UNDERLINE */;
	                    case 'overline':
	                        return 2 /* OVERLINE */;
	                    case 'line-through':
	                        return 3 /* LINE_THROUGH */;
	                    case 'none':
	                        return 4 /* BLINK */;
	                }
	                return 0 /* NONE */;
	            })
	                .filter(function (line) { return line !== 0 /* NONE */; });
	        }
	    };
	
	    var fontFamily = {
	        name: "font-family",
	        initialValue: '',
	        prefix: false,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            return tokens.filter(isStringToken$1).map(function (token) { return token.value; });
	        }
	    };
	    var isStringToken$1 = function (token) {
	        return token.type === TokenType.STRING_TOKEN || token.type === TokenType.IDENT_TOKEN;
	    };
	
	    var fontSize = {
	        name: "font-size",
	        initialValue: '0',
	        prefix: false,
	        type: PropertyDescriptorParsingType.TYPE_VALUE,
	        format: 'length'
	    };
	
	    var fontWeight = {
	        name: 'font-weight',
	        initialValue: 'normal',
	        type: PropertyDescriptorParsingType.VALUE,
	        prefix: false,
	        parse: function (token) {
	            if (isNumberToken(token)) {
	                return token.number;
	            }
	            if (isIdentToken(token)) {
	                switch (token.value) {
	                    case 'bold':
	                        return 700;
	                    case 'normal':
	                    default:
	                        return 400;
	                }
	            }
	            return 400;
	        }
	    };
	
	    var fontVariant = {
	        name: 'font-variant',
	        initialValue: 'none',
	        type: PropertyDescriptorParsingType.LIST,
	        prefix: false,
	        parse: function (tokens) {
	            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
	        }
	    };
	
	    var FONT_STYLE;
	    (function (FONT_STYLE) {
	        FONT_STYLE["NORMAL"] = "normal";
	        FONT_STYLE["ITALIC"] = "italic";
	        FONT_STYLE["OBLIQUE"] = "oblique";
	    })(FONT_STYLE || (FONT_STYLE = {}));
	    var fontStyle = {
	        name: 'font-style',
	        initialValue: 'normal',
	        prefix: false,
	        type: PropertyDescriptorParsingType.IDENT_VALUE,
	        parse: function (overflow) {
	            switch (overflow) {
	                case 'oblique':
	                    return FONT_STYLE.OBLIQUE;
	                case 'italic':
	                    return FONT_STYLE.ITALIC;
	                case 'normal':
	                default:
	                    return FONT_STYLE.NORMAL;
	            }
	        }
	    };
	
	    var contains = function (bit, value) { return (bit & value) !== 0; };
	
	    var content = {
	        name: 'content',
	        initialValue: 'none',
	        type: PropertyDescriptorParsingType.LIST,
	        prefix: false,
	        parse: function (tokens) {
	            if (tokens.length === 0) {
	                return [];
	            }
	            var first = tokens[0];
	            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
	                return [];
	            }
	            return tokens;
	        }
	    };
	
	    var counterIncrement = {
	        name: 'counter-increment',
	        initialValue: 'none',
	        prefix: true,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            if (tokens.length === 0) {
	                return null;
	            }
	            var first = tokens[0];
	            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
	                return null;
	            }
	            var increments = [];
	            var filtered = tokens.filter(nonWhiteSpace);
	            for (var i = 0; i < filtered.length; i++) {
	                var counter = filtered[i];
	                var next = filtered[i + 1];
	                if (counter.type === TokenType.IDENT_TOKEN) {
	                    var increment = next && isNumberToken(next) ? next.number : 1;
	                    increments.push({ counter: counter.value, increment: increment });
	                }
	            }
	            return increments;
	        }
	    };
	
	    var counterReset = {
	        name: 'counter-reset',
	        initialValue: 'none',
	        prefix: true,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            if (tokens.length === 0) {
	                return [];
	            }
	            var resets = [];
	            var filtered = tokens.filter(nonWhiteSpace);
	            for (var i = 0; i < filtered.length; i++) {
	                var counter = filtered[i];
	                var next = filtered[i + 1];
	                if (isIdentToken(counter) && counter.value !== 'none') {
	                    var reset = next && isNumberToken(next) ? next.number : 0;
	                    resets.push({ counter: counter.value, reset: reset });
	                }
	            }
	            return resets;
	        }
	    };
	
	    var quotes = {
	        name: 'quotes',
	        initialValue: 'none',
	        prefix: true,
	        type: PropertyDescriptorParsingType.LIST,
	        parse: function (tokens) {
	            if (tokens.length === 0) {
	                return null;
	            }
	            var first = tokens[0];
	            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
	                return null;
	            }
	            var quotes = [];
	            var filtered = tokens.filter(isStringToken);
	            if (filtered.length % 2 !== 0) {
	                return null;
	            }
	            for (var i = 0; i < filtered.length; i += 2) {
	                var open_1 = filtered[i].value;
	                var close_1 = filtered[i + 1].value;
	                quotes.push({ open: open_1, close: close_1 });
	            }
	            return quotes;
	        }
	    };
	    var getQuote = function (quotes, depth, open) {
	        if (!quotes) {
	            return '';
	        }
	        var quote = quotes[Math.min(depth, quotes.length - 1)];
	        if (!quote) {
	            return '';
	        }
	        return open ? quote.open : quote.close;
	    };
	
	    var boxShadow = {
	        name: 'box-shadow',
	        initialValue: 'none',
	        type: PropertyDescriptorParsingType.LIST,
	        prefix: false,
	        parse: function (tokens) {
	            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
	                return [];
	            }
	            return parseFunctionArgs(tokens).map(function (values) {
	                var shadow = {
	                    color: 0x000000ff,
	                    offsetX: ZERO_LENGTH,
	                    offsetY: ZERO_LENGTH,
	                    blur: ZERO_LENGTH,
	                    spread: ZERO_LENGTH,
	                    inset: false
	                };
	                var c = 0;
	                for (var i = 0; i < values.length; i++) {
	                    var token = values[i];
	                    if (isIdentWithValue(token, 'inset')) {
	                        shadow.inset = true;
	                    }
	                    else if (isLength(token)) {
	                        if (c === 0) {
	                            shadow.offsetX = token;
	                        }
	                        else if (c === 1) {
	                            shadow.offsetY = token;
	                        }
	                        else if (c === 2) {
	                            shadow.blur = token;
	                        }
	                        else {
	                            shadow.spread = token;
	                        }
	                        c++;
	                    }
	                    else {
	                        shadow.color = color.parse(token);
	                    }
	                }
	                return shadow;
	            });
	        }
	    };
	
	    var CSSParsedDeclaration = /** @class */ (function () {
	        function CSSParsedDeclaration(declaration) {
	            this.backgroundClip = parse(backgroundClip, declaration.backgroundClip);
	            this.backgroundColor = parse(backgroundColor, declaration.backgroundColor);
	            this.backgroundImage = parse(backgroundImage, declaration.backgroundImage);
	            this.backgroundOrigin = parse(backgroundOrigin, declaration.backgroundOrigin);
	            this.backgroundPosition = parse(backgroundPosition, declaration.backgroundPosition);
	            this.backgroundRepeat = parse(backgroundRepeat, declaration.backgroundRepeat);
	            this.backgroundSize = parse(backgroundSize, declaration.backgroundSize);
	            this.borderTopColor = parse(borderTopColor, declaration.borderTopColor);
	            this.borderRightColor = parse(borderRightColor, declaration.borderRightColor);
	            this.borderBottomColor = parse(borderBottomColor, declaration.borderBottomColor);
	            this.borderLeftColor = parse(borderLeftColor, declaration.borderLeftColor);
	            this.borderTopLeftRadius = parse(borderTopLeftRadius, declaration.borderTopLeftRadius);
	            this.borderTopRightRadius = parse(borderTopRightRadius, declaration.borderTopRightRadius);
	            this.borderBottomRightRadius = parse(borderBottomRightRadius, declaration.borderBottomRightRadius);
	            this.borderBottomLeftRadius = parse(borderBottomLeftRadius, declaration.borderBottomLeftRadius);
	            this.borderTopStyle = parse(borderTopStyle, declaration.borderTopStyle);
	            this.borderRightStyle = parse(borderRightStyle, declaration.borderRightStyle);
	            this.borderBottomStyle = parse(borderBottomStyle, declaration.borderBottomStyle);
	            this.borderLeftStyle = parse(borderLeftStyle, declaration.borderLeftStyle);
	            this.borderTopWidth = parse(borderTopWidth, declaration.borderTopWidth);
	            this.borderRightWidth = parse(borderRightWidth, declaration.borderRightWidth);
	            this.borderBottomWidth = parse(borderBottomWidth, declaration.borderBottomWidth);
	            this.borderLeftWidth = parse(borderLeftWidth, declaration.borderLeftWidth);
	            this.boxShadow = parse(boxShadow, declaration.boxShadow);
	            this.color = parse(color$1, declaration.color);
	            this.display = parse(display, declaration.display);
	            this.float = parse(float, declaration.cssFloat);
	            this.fontFamily = parse(fontFamily, declaration.fontFamily);
	            this.fontSize = parse(fontSize, declaration.fontSize);
	            this.fontStyle = parse(fontStyle, declaration.fontStyle);
	            this.fontVariant = parse(fontVariant, declaration.fontVariant);
	            this.fontWeight = parse(fontWeight, declaration.fontWeight);
	            this.letterSpacing = parse(letterSpacing, declaration.letterSpacing);
	            this.lineBreak = parse(lineBreak, declaration.lineBreak);
	            this.lineHeight = parse(lineHeight, declaration.lineHeight);
	            this.listStyleImage = parse(listStyleImage, declaration.listStyleImage);
	            this.listStylePosition = parse(listStylePosition, declaration.listStylePosition);
	            this.listStyleType = parse(listStyleType, declaration.listStyleType);
	            this.marginTop = parse(marginTop, declaration.marginTop);
	            this.marginRight = parse(marginRight, declaration.marginRight);
	            this.marginBottom = parse(marginBottom, declaration.marginBottom);
	            this.marginLeft = parse(marginLeft, declaration.marginLeft);
	            this.opacity = parse(opacity, declaration.opacity);
	            var overflowTuple = parse(overflow, declaration.overflow);
	            this.overflowX = overflowTuple[0];
	            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
	            this.overflowWrap = parse(overflowWrap, declaration.overflowWrap);
	            this.paddingTop = parse(paddingTop, declaration.paddingTop);
	            this.paddingRight = parse(paddingRight, declaration.paddingRight);
	            this.paddingBottom = parse(paddingBottom, declaration.paddingBottom);
	            this.paddingLeft = parse(paddingLeft, declaration.paddingLeft);
	            this.position = parse(position, declaration.position);
	            this.textAlign = parse(textAlign, declaration.textAlign);
	            this.textDecorationColor = parse(textDecorationColor, declaration.textDecorationColor || declaration.color);
	            this.textDecorationLine = parse(textDecorationLine, declaration.textDecorationLine);
	            this.textShadow = parse(textShadow, declaration.textShadow);
	            this.textTransform = parse(textTransform, declaration.textTransform);
	            this.transform = parse(transform, declaration.transform);
	            this.transformOrigin = parse(transformOrigin, declaration.transformOrigin);
	            this.visibility = parse(visibility, declaration.visibility);
	            this.wordBreak = parse(wordBreak, declaration.wordBreak);
	            this.zIndex = parse(zIndex, declaration.zIndex);
	        }
	        CSSParsedDeclaration.prototype.isVisible = function () {
	            return this.display > 0 && this.opacity > 0 && this.visibility === VISIBILITY.VISIBLE;
	        };
	        CSSParsedDeclaration.prototype.isTransparent = function () {
	            return isTransparent(this.backgroundColor);
	        };
	        CSSParsedDeclaration.prototype.isTransformed = function () {
	            return this.transform !== null;
	        };
	        CSSParsedDeclaration.prototype.isPositioned = function () {
	            return this.position !== POSITION.STATIC;
	        };
	        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
	            return this.isPositioned() && !this.zIndex.auto;
	        };
	        CSSParsedDeclaration.prototype.isFloating = function () {
	            return this.float !== FLOAT.NONE;
	        };
	        CSSParsedDeclaration.prototype.isInlineLevel = function () {
	            return (contains(this.display, 4 /* INLINE */) ||
	                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
	                contains(this.display, 268435456 /* INLINE_FLEX */) ||
	                contains(this.display, 536870912 /* INLINE_GRID */) ||
	                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
	                contains(this.display, 134217728 /* INLINE_TABLE */));
	        };
	        return CSSParsedDeclaration;
	    }());
	    var CSSParsedPseudoDeclaration = /** @class */ (function () {
	        function CSSParsedPseudoDeclaration(declaration) {
	            this.content = parse(content, declaration.content);
	            this.quotes = parse(quotes, declaration.quotes);
	        }
	        return CSSParsedPseudoDeclaration;
	    }());
	    var CSSParsedCounterDeclaration = /** @class */ (function () {
	        function CSSParsedCounterDeclaration(declaration) {
	            this.counterIncrement = parse(counterIncrement, declaration.counterIncrement);
	            this.counterReset = parse(counterReset, declaration.counterReset);
	        }
	        return CSSParsedCounterDeclaration;
	    }());
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var parse = function (descriptor, style) {
	        var tokenizer = new Tokenizer();
	        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
	        tokenizer.write(value);
	        var parser = new Parser(tokenizer.read());
	        switch (descriptor.type) {
	            case PropertyDescriptorParsingType.IDENT_VALUE:
	                var token = parser.parseComponentValue();
	                return descriptor.parse(isIdentToken(token) ? token.value : descriptor.initialValue);
	            case PropertyDescriptorParsingType.VALUE:
	                return descriptor.parse(parser.parseComponentValue());
	            case PropertyDescriptorParsingType.LIST:
	                return descriptor.parse(parser.parseComponentValues());
	            case PropertyDescriptorParsingType.TOKEN_VALUE:
	                return parser.parseComponentValue();
	            case PropertyDescriptorParsingType.TYPE_VALUE:
	                switch (descriptor.format) {
	                    case 'angle':
	                        return angle.parse(parser.parseComponentValue());
	                    case 'color':
	                        return color.parse(parser.parseComponentValue());
	                    case 'image':
	                        return image.parse(parser.parseComponentValue());
	                    case 'length':
	                        var length_1 = parser.parseComponentValue();
	                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
	                    case 'length-percentage':
	                        var value_1 = parser.parseComponentValue();
	                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
	                }
	        }
	        throw new Error("Attempting to parse unsupported css format type " + descriptor.format);
	    };
	
	    var ElementContainer = /** @class */ (function () {
	        function ElementContainer(element) {
	            this.styles = new CSSParsedDeclaration(window.getComputedStyle(element, null));
	            this.textNodes = [];
	            this.elements = [];
	            if (this.styles.transform !== null && isHTMLElementNode(element)) {
	                // getBoundingClientRect takes transforms into account
	                element.style.transform = 'none';
	            }
	            this.bounds = parseBounds(element);
	            this.flags = 0;
	        }
	        return ElementContainer;
	    }());
	
	    var TextBounds = /** @class */ (function () {
	        function TextBounds(text, bounds) {
	            this.text = text;
	            this.bounds = bounds;
	        }
	        return TextBounds;
	    }());
	    var parseTextBounds = function (value, styles, node) {
	        var textList = breakText(value, styles);
	        var textBounds = [];
	        var offset = 0;
	        textList.forEach(function (text) {
	            if (styles.textDecorationLine.length || text.trim().length > 0) {
	                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
	                    textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length)));
	                }
	                else {
	                    var replacementNode = node.splitText(text.length);
	                    textBounds.push(new TextBounds(text, getWrapperBounds(node)));
	                    node = replacementNode;
	                }
	            }
	            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
	                node = node.splitText(text.length);
	            }
	            offset += text.length;
	        });
	        return textBounds;
	    };
	    var getWrapperBounds = function (node) {
	        var ownerDocument = node.ownerDocument;
	        if (ownerDocument) {
	            var wrapper = ownerDocument.createElement('html2canvaswrapper');
	            wrapper.appendChild(node.cloneNode(true));
	            var parentNode = node.parentNode;
	            if (parentNode) {
	                parentNode.replaceChild(wrapper, node);
	                var bounds = parseBounds(wrapper);
	                if (wrapper.firstChild) {
	                    parentNode.replaceChild(wrapper.firstChild, wrapper);
	                }
	                return bounds;
	            }
	        }
	        return new Bounds(0, 0, 0, 0);
	    };
	    var getRangeBounds = function (node, offset, length) {
	        var ownerDocument = node.ownerDocument;
	        if (!ownerDocument) {
	            throw new Error('Node has no owner document');
	        }
	        var range = ownerDocument.createRange();
	        range.setStart(node, offset);
	        range.setEnd(node, offset + length);
	        return Bounds.fromClientRect(range.getBoundingClientRect());
	    };
	    var breakText = function (value, styles) {
	        return styles.letterSpacing !== 0 ? toCodePoints(value).map(function (i) { return fromCodePoint(i); }) : breakWords(value, styles);
	    };
	    var breakWords = function (str, styles) {
	        var breaker = LineBreaker(str, {
	            lineBreak: styles.lineBreak,
	            wordBreak: styles.overflowWrap === OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : styles.wordBreak
	        });
	        var words = [];
	        var bk;
	        while (!(bk = breaker.next()).done) {
	            if (bk.value) {
	                words.push(bk.value.slice());
	            }
	        }
	        return words;
	    };
	
	    var TextContainer = /** @class */ (function () {
	        function TextContainer(node, styles) {
	            this.text = transform$1(node.data, styles.textTransform);
	            this.textBounds = parseTextBounds(this.text, styles, node);
	        }
	        return TextContainer;
	    }());
	    var transform$1 = function (text, transform) {
	        switch (transform) {
	            case TEXT_TRANSFORM.LOWERCASE:
	                return text.toLowerCase();
	            case TEXT_TRANSFORM.CAPITALIZE:
	                return text.replace(CAPITALIZE, capitalize);
	            case TEXT_TRANSFORM.UPPERCASE:
	                return text.toUpperCase();
	            default:
	                return text;
	        }
	    };
	    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
	    var capitalize = function (m, p1, p2) {
	        if (m.length > 0) {
	            return p1 + p2.toUpperCase();
	        }
	        return m;
	    };
	
	    var ImageElementContainer = /** @class */ (function (_super) {
	        __extends(ImageElementContainer, _super);
	        function ImageElementContainer(img) {
	            var _this = _super.call(this, img) || this;
	            _this.src = img.currentSrc || img.src;
	            _this.intrinsicWidth = img.naturalWidth;
	            _this.intrinsicHeight = img.naturalHeight;
	            CacheStorage.getInstance().addImage(_this.src);
	            return _this;
	        }
	        return ImageElementContainer;
	    }(ElementContainer));
	
	    var CanvasElementContainer = /** @class */ (function (_super) {
	        __extends(CanvasElementContainer, _super);
	        function CanvasElementContainer(canvas) {
	            var _this = _super.call(this, canvas) || this;
	            _this.canvas = canvas;
	            _this.intrinsicWidth = canvas.width;
	            _this.intrinsicHeight = canvas.height;
	            return _this;
	        }
	        return CanvasElementContainer;
	    }(ElementContainer));
	
	    var SVGElementContainer = /** @class */ (function (_super) {
	        __extends(SVGElementContainer, _super);
	        function SVGElementContainer(img) {
	            var _this = _super.call(this, img) || this;
	            var s = new XMLSerializer();
	            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
	            _this.intrinsicWidth = img.width.baseVal.value;
	            _this.intrinsicHeight = img.height.baseVal.value;
	            CacheStorage.getInstance().addImage(_this.svg);
	            return _this;
	        }
	        return SVGElementContainer;
	    }(ElementContainer));
	
	    var LIElementContainer = /** @class */ (function (_super) {
	        __extends(LIElementContainer, _super);
	        function LIElementContainer(element) {
	            var _this = _super.call(this, element) || this;
	            _this.value = element.value;
	            return _this;
	        }
	        return LIElementContainer;
	    }(ElementContainer));
	
	    var OLElementContainer = /** @class */ (function (_super) {
	        __extends(OLElementContainer, _super);
	        function OLElementContainer(element) {
	            var _this = _super.call(this, element) || this;
	            _this.start = element.start;
	            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
	            return _this;
	        }
	        return OLElementContainer;
	    }(ElementContainer));
	
	    var CHECKBOX_BORDER_RADIUS = [
	        {
	            type: TokenType.DIMENSION_TOKEN,
	            flags: 0,
	            unit: 'px',
	            number: 3
	        }
	    ];
	    var RADIO_BORDER_RADIUS = [
	        {
	            type: TokenType.PERCENTAGE_TOKEN,
	            flags: 0,
	            number: 50
	        }
	    ];
	    var reformatInputBounds = function (bounds) {
	        if (bounds.width > bounds.height) {
	            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
	        }
	        else if (bounds.width < bounds.height) {
	            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
	        }
	        return bounds;
	    };
	    var getInputValue = function (node) {
	        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
	        return value.length === 0 ? node.placeholder || '' : value;
	    };
	    var CHECKBOX = 'checkbox';
	    var RADIO = 'radio';
	    var PASSWORD = 'password';
	    var INPUT_COLOR = 0x2a2a2aff;
	    var InputElementContainer = /** @class */ (function (_super) {
	        __extends(InputElementContainer, _super);
	        function InputElementContainer(input) {
	            var _this = _super.call(this, input) || this;
	            _this.type = input.type.toLowerCase();
	            _this.checked = input.checked;
	            _this.value = getInputValue(input);
	            if (_this.type === CHECKBOX || _this.type === RADIO) {
	                _this.styles.backgroundColor = 0xdededeff;
	                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
	                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
	                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle =
	                    BORDER_STYLE.SOLID;
	                _this.styles.backgroundClip = [BACKGROUND_CLIP.BORDER_BOX];
	                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
	                _this.bounds = reformatInputBounds(_this.bounds);
	            }
	            switch (_this.type) {
	                case CHECKBOX:
	                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
	                    break;
	                case RADIO:
	                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
	                    break;
	            }
	            return _this;
	        }
	        return InputElementContainer;
	    }(ElementContainer));
	
	    var SelectElementContainer = /** @class */ (function (_super) {
	        __extends(SelectElementContainer, _super);
	        function SelectElementContainer(element) {
	            var _this = _super.call(this, element) || this;
	            var option = element.options[element.selectedIndex || 0];
	            _this.value = option ? option.text || '' : '';
	            return _this;
	        }
	        return SelectElementContainer;
	    }(ElementContainer));
	
	    var TextareaElementContainer = /** @class */ (function (_super) {
	        __extends(TextareaElementContainer, _super);
	        function TextareaElementContainer(element) {
	            var _this = _super.call(this, element) || this;
	            _this.value = element.value;
	            return _this;
	        }
	        return TextareaElementContainer;
	    }(ElementContainer));
	
	    var parseColor = function (value) { return color.parse(Parser.create(value).parseComponentValue()); };
	    var IFrameElementContainer = /** @class */ (function (_super) {
	        __extends(IFrameElementContainer, _super);
	        function IFrameElementContainer(iframe) {
	            var _this = _super.call(this, iframe) || this;
	            _this.src = iframe.src;
	            _this.width = parseInt(iframe.width, 10);
	            _this.height = parseInt(iframe.height, 10);
	            _this.backgroundColor = _this.styles.backgroundColor;
	            try {
	                if (iframe.contentWindow &&
	                    iframe.contentWindow.document &&
	                    iframe.contentWindow.document.documentElement) {
	                    _this.tree = parseTree(iframe.contentWindow.document.documentElement);
	                    // http://www.w3.org/TR/css3-background/#special-backgrounds
	                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
	                        ? parseColor(getComputedStyle(iframe.contentWindow.document.documentElement)
	                            .backgroundColor)
	                        : COLORS.TRANSPARENT;
	                    var bodyBackgroundColor = iframe.contentWindow.document.body
	                        ? parseColor(getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
	                        : COLORS.TRANSPARENT;
	                    _this.backgroundColor = isTransparent(documentBackgroundColor)
	                        ? isTransparent(bodyBackgroundColor)
	                            ? _this.styles.backgroundColor
	                            : bodyBackgroundColor
	                        : documentBackgroundColor;
	                }
	            }
	            catch (e) { }
	            return _this;
	        }
	        return IFrameElementContainer;
	    }(ElementContainer));
	
	    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
	    var parseNodeTree = function (node, parent, root) {
	        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
	            nextNode = childNode.nextSibling;
	            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
	                parent.textNodes.push(new TextContainer(childNode, parent.styles));
	            }
	            else if (isElementNode(childNode)) {
	                var container = createContainer(childNode);
	                if (container.styles.isVisible()) {
	                    if (createsRealStackingContext(childNode, container, root)) {
	                        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
	                    }
	                    else if (createsStackingContext(container.styles)) {
	                        container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
	                    }
	                    if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
	                        container.flags |= 8 /* IS_LIST_OWNER */;
	                    }
	                    parent.elements.push(container);
	                    if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) {
	                        parseNodeTree(childNode, container, root);
	                    }
	                }
	            }
	        }
	    };
	    var createContainer = function (element) {
	        if (isImageElement(element)) {
	            return new ImageElementContainer(element);
	        }
	        if (isCanvasElement(element)) {
	            return new CanvasElementContainer(element);
	        }
	        if (isSVGElement(element)) {
	            return new SVGElementContainer(element);
	        }
	        if (isLIElement(element)) {
	            return new LIElementContainer(element);
	        }
	        if (isOLElement(element)) {
	            return new OLElementContainer(element);
	        }
	        if (isInputElement(element)) {
	            return new InputElementContainer(element);
	        }
	        if (isSelectElement(element)) {
	            return new SelectElementContainer(element);
	        }
	        if (isTextareaElement(element)) {
	            return new TextareaElementContainer(element);
	        }
	        if (isIFrameElement(element)) {
	            return new IFrameElementContainer(element);
	        }
	        return new ElementContainer(element);
	    };
	    var parseTree = function (element) {
	        var container = createContainer(element);
	        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
	        parseNodeTree(element, container, container);
	        return container;
	    };
	    var createsRealStackingContext = function (node, container, root) {
	        return (container.styles.isPositionedWithZIndex() ||
	            container.styles.opacity < 1 ||
	            container.styles.isTransformed() ||
	            (isBodyElement(node) && root.styles.isTransparent()));
	    };
	    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
	    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
	    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
	    var isHTMLElementNode = function (node) {
	        return typeof node.style !== 'undefined';
	    };
	    var isLIElement = function (node) { return node.tagName === 'LI'; };
	    var isOLElement = function (node) { return node.tagName === 'OL'; };
	    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
	    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
	    var isSVGElement = function (node) { return node.tagName === 'svg'; };
	    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
	    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
	    var isImageElement = function (node) { return node.tagName === 'IMG'; };
	    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
	    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
	    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
	    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
	    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
	
	    var CounterState = /** @class */ (function () {
	        function CounterState() {
	            this.counters = {};
	        }
	        CounterState.prototype.getCounterValue = function (name) {
	            var counter = this.counters[name];
	            if (counter && counter.length) {
	                return counter[counter.length - 1];
	            }
	            return 1;
	        };
	        CounterState.prototype.getCounterValues = function (name) {
	            var counter = this.counters[name];
	            return counter ? counter : [];
	        };
	        CounterState.prototype.pop = function (counters) {
	            var _this = this;
	            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
	        };
	        CounterState.prototype.parse = function (style) {
	            var _this = this;
	            var counterIncrement = style.counterIncrement;
	            var counterReset = style.counterReset;
	            if (counterIncrement !== null) {
	                counterIncrement.forEach(function (entry) {
	                    var counter = _this.counters[entry.counter];
	                    if (counter) {
	                        counter[Math.max(0, counter.length - 1)] += entry.increment;
	                    }
	                });
	            }
	            var counterNames = [];
	            counterReset.forEach(function (entry) {
	                var counter = _this.counters[entry.counter];
	                counterNames.push(entry.counter);
	                if (!counter) {
	                    counter = _this.counters[entry.counter] = [];
	                }
	                counter.push(entry.reset);
	            });
	            return counterNames;
	        };
	        return CounterState;
	    }());
	    var ROMAN_UPPER = {
	        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
	        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
	    };
	    var ARMENIAN = {
	        integers: [
	            9000,
	            8000,
	            7000,
	            6000,
	            5000,
	            4000,
	            3000,
	            2000,
	            1000,
	            900,
	            800,
	            700,
	            600,
	            500,
	            400,
	            300,
	            200,
	            100,
	            90,
	            80,
	            70,
	            60,
	            50,
	            40,
	            30,
	            20,
	            10,
	            9,
	            8,
	            7,
	            6,
	            5,
	            4,
	            3,
	            2,
	            1
	        ],
	        values: [
	            'Ք',
	            'Փ',
	            'Ւ',
	            'Ց',
	            'Ր',
	            'Տ',
	            'Վ',
	            'Ս',
	            'Ռ',
	            'Ջ',
	            'Պ',
	            'Չ',
	            'Ո',
	            'Շ',
	            'Ն',
	            'Յ',
	            'Մ',
	            'Ճ',
	            'Ղ',
	            'Ձ',
	            'Հ',
	            'Կ',
	            'Ծ',
	            'Խ',
	            'Լ',
	            'Ի',
	            'Ժ',
	            'Թ',
	            'Ը',
	            'Է',
	            'Զ',
	            'Ե',
	            'Դ',
	            'Գ',
	            'Բ',
	            'Ա'
	        ]
	    };
	    var HEBREW = {
	        integers: [
	            10000,
	            9000,
	            8000,
	            7000,
	            6000,
	            5000,
	            4000,
	            3000,
	            2000,
	            1000,
	            400,
	            300,
	            200,
	            100,
	            90,
	            80,
	            70,
	            60,
	            50,
	            40,
	            30,
	            20,
	            19,
	            18,
	            17,
	            16,
	            15,
	            10,
	            9,
	            8,
	            7,
	            6,
	            5,
	            4,
	            3,
	            2,
	            1
	        ],
	        values: [
	            'י׳',
	            'ט׳',
	            'ח׳',
	            'ז׳',
	            'ו׳',
	            'ה׳',
	            'ד׳',
	            'ג׳',
	            'ב׳',
	            'א׳',
	            'ת',
	            'ש',
	            'ר',
	            'ק',
	            'צ',
	            'פ',
	            'ע',
	            'ס',
	            'נ',
	            'מ',
	            'ל',
	            'כ',
	            'יט',
	            'יח',
	            'יז',
	            'טז',
	            'טו',
	            'י',
	            'ט',
	            'ח',
	            'ז',
	            'ו',
	            'ה',
	            'ד',
	            'ג',
	            'ב',
	            'א'
	        ]
	    };
	    var GEORGIAN = {
	        integers: [
	            10000,
	            9000,
	            8000,
	            7000,
	            6000,
	            5000,
	            4000,
	            3000,
	            2000,
	            1000,
	            900,
	            800,
	            700,
	            600,
	            500,
	            400,
	            300,
	            200,
	            100,
	            90,
	            80,
	            70,
	            60,
	            50,
	            40,
	            30,
	            20,
	            10,
	            9,
	            8,
	            7,
	            6,
	            5,
	            4,
	            3,
	            2,
	            1
	        ],
	        values: [
	            'ჵ',
	            'ჰ',
	            'ჯ',
	            'ჴ',
	            'ხ',
	            'ჭ',
	            'წ',
	            'ძ',
	            'ც',
	            'ჩ',
	            'შ',
	            'ყ',
	            'ღ',
	            'ქ',
	            'ფ',
	            'ჳ',
	            'ტ',
	            'ს',
	            'რ',
	            'ჟ',
	            'პ',
	            'ო',
	            'ჲ',
	            'ნ',
	            'მ',
	            'ლ',
	            'კ',
	            'ი',
	            'თ',
	            'ჱ',
	            'ზ',
	            'ვ',
	            'ე',
	            'დ',
	            'გ',
	            'ბ',
	            'ა'
	        ]
	    };
	    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
	        if (value < min || value > max) {
	            return createCounterText(value, fallback, suffix.length > 0);
	        }
	        return (symbols.integers.reduce(function (string, integer, index) {
	            while (value >= integer) {
	                value -= integer;
	                string += symbols.values[index];
	            }
	            return string;
	        }, '') + suffix);
	    };
	    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
	        var string = '';
	        do {
	            if (!isNumeric) {
	                value--;
	            }
	            string = resolver(value) + string;
	            value /= codePointRangeLength;
	        } while (value * codePointRangeLength >= codePointRangeLength);
	        return string;
	    };
	    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
	        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
	        return ((value < 0 ? '-' : '') +
	            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
	                return fromCodePoint(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
	            }) +
	                suffix));
	    };
	    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
	        if (suffix === void 0) { suffix = '. '; }
	        var codePointRangeLength = symbols.length;
	        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
	    };
	    var CJK_ZEROS = 1 << 0;
	    var CJK_TEN_COEFFICIENTS = 1 << 1;
	    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
	    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
	    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
	        if (value < -9999 || value > 9999) {
	            return createCounterText(value, LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
	        }
	        var tmp = Math.abs(value);
	        var string = suffix;
	        if (tmp === 0) {
	            return numbers[0] + string;
	        }
	        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
	            var coefficient = tmp % 10;
	            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
	                string = numbers[coefficient] + string;
	            }
	            else if (coefficient > 1 ||
	                (coefficient === 1 && digit === 0) ||
	                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
	                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
	                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
	                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
	            }
	            else if (coefficient === 1 && digit > 0) {
	                string = multipliers[digit - 1] + string;
	            }
	            tmp = Math.floor(tmp / 10);
	        }
	        return (value < 0 ? negativeSign : '') + string;
	    };
	    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
	    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
	    var JAPANESE_NEGATIVE = 'マイナス';
	    var KOREAN_NEGATIVE = '마이너스';
	    var createCounterText = function (value, type, appendSuffix) {
	        var defaultSuffix = appendSuffix ? '. ' : '';
	        var cjkSuffix = appendSuffix ? '、' : '';
	        var koreanSuffix = appendSuffix ? ', ' : '';
	        var spaceSuffix = appendSuffix ? ' ' : '';
	        switch (type) {
	            case LIST_STYLE_TYPE.DISC:
	                return '•' + spaceSuffix;
	            case LIST_STYLE_TYPE.CIRCLE:
	                return '◦' + spaceSuffix;
	            case LIST_STYLE_TYPE.SQUARE:
	                return '◾' + spaceSuffix;
	            case LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
	                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
	                return string.length < 4 ? "0" + string : string;
	            case LIST_STYLE_TYPE.CJK_DECIMAL:
	                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
	            case LIST_STYLE_TYPE.LOWER_ROMAN:
	                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
	            case LIST_STYLE_TYPE.UPPER_ROMAN:
	                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	            case LIST_STYLE_TYPE.LOWER_GREEK:
	                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
	            case LIST_STYLE_TYPE.LOWER_ALPHA:
	                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
	            case LIST_STYLE_TYPE.UPPER_ALPHA:
	                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
	            case LIST_STYLE_TYPE.ARABIC_INDIC:
	                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
	            case LIST_STYLE_TYPE.ARMENIAN:
	            case LIST_STYLE_TYPE.UPPER_ARMENIAN:
	                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	            case LIST_STYLE_TYPE.LOWER_ARMENIAN:
	                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
	            case LIST_STYLE_TYPE.BENGALI:
	                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
	            case LIST_STYLE_TYPE.CAMBODIAN:
	            case LIST_STYLE_TYPE.KHMER:
	                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
	            case LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
	                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
	            case LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
	                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
	            case LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
	            case LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
	                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	            case LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
	                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	            case LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
	                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	            case LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
	                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	            case LIST_STYLE_TYPE.JAPANESE_INFORMAL:
	                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
	            case LIST_STYLE_TYPE.JAPANESE_FORMAL:
	                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	            case LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
	                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	            case LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
	                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
	            case LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
	                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	            case LIST_STYLE_TYPE.DEVANAGARI:
	                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
	            case LIST_STYLE_TYPE.GEORGIAN:
	                return createAdditiveCounter(value, 1, 19999, GEORGIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	            case LIST_STYLE_TYPE.GUJARATI:
	                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
	            case LIST_STYLE_TYPE.GURMUKHI:
	                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
	            case LIST_STYLE_TYPE.HEBREW:
	                return createAdditiveCounter(value, 1, 10999, HEBREW, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
	            case LIST_STYLE_TYPE.HIRAGANA:
	                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
	            case LIST_STYLE_TYPE.HIRAGANA_IROHA:
	                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
	            case LIST_STYLE_TYPE.KANNADA:
	                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
	            case LIST_STYLE_TYPE.KATAKANA:
	                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
	            case LIST_STYLE_TYPE.KATAKANA_IROHA:
	                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
	            case LIST_STYLE_TYPE.LAO:
	                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
	            case LIST_STYLE_TYPE.MONGOLIAN:
	                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
	            case LIST_STYLE_TYPE.MYANMAR:
	                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
	            case LIST_STYLE_TYPE.ORIYA:
	                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
	            case LIST_STYLE_TYPE.PERSIAN:
	                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
	            case LIST_STYLE_TYPE.TAMIL:
	                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
	            case LIST_STYLE_TYPE.TELUGU:
	                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
	            case LIST_STYLE_TYPE.THAI:
	                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
	            case LIST_STYLE_TYPE.TIBETAN:
	                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
	            case LIST_STYLE_TYPE.DECIMAL:
	            default:
	                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
	        }
	    };
	
	    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
	    var DocumentCloner = /** @class */ (function () {
	        function DocumentCloner(element, options) {
	            this.options = options;
	            this.scrolledElements = [];
	            this.referenceElement = element;
	            this.counters = new CounterState();
	            this.quoteDepth = 0;
	            if (!element.ownerDocument) {
	                throw new Error('Cloned element does not have an owner document');
	            }
	            this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
	        }
	        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
	            var _this = this;
	            var iframe = createIFrameContainer(ownerDocument, windowSize);
	            if (!iframe.contentWindow) {
	                return Promise.reject("Unable to find iframe window");
	            }
	            var scrollX = ownerDocument.defaultView.pageXOffset;
	            var scrollY = ownerDocument.defaultView.pageYOffset;
	            var cloneWindow = iframe.contentWindow;
	            var documentClone = cloneWindow.document;
	            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
	             if window url is about:blank, we can assign the url to current by writing onto the document
	             */
	            var iframeLoad = iframeLoader(iframe).then(function () {
	                _this.scrolledElements.forEach(restoreNodeScroll);
	                if (cloneWindow) {
	                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
	                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
	                        (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
	                        documentClone.documentElement.style.top = -windowSize.top + 'px';
	                        documentClone.documentElement.style.left = -windowSize.left + 'px';
	                        documentClone.documentElement.style.position = 'absolute';
	                    }
	                }
	                var onclone = _this.options.onclone;
	                if (typeof _this.clonedReferenceElement === 'undefined') {
	                    return Promise.reject("Error finding the " + _this.referenceElement.nodeName + " in the cloned document");
	                }
	                if (typeof onclone === 'function') {
	                    return Promise.resolve()
	                        .then(function () { return onclone(documentClone); })
	                        .then(function () { return iframe; });
	                }
	                return iframe;
	            });
	            documentClone.open();
	            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
	            // Chrome scrolls the parent document for some reason after the write to the cloned window???
	            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
	            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
	            documentClone.close();
	            return iframeLoad;
	        };
	        DocumentCloner.prototype.createElementClone = function (node) {
	            if (isCanvasElement(node)) {
	                return this.createCanvasClone(node);
	            }
	            /*
	            if (isIFrameElement(node)) {
	                return this.createIFrameClone(node);
	            }
	    */
	            if (isStyleElement(node)) {
	                return this.createStyleClone(node);
	            }
	            return node.cloneNode(false);
	        };
	        DocumentCloner.prototype.createStyleClone = function (node) {
	            try {
	                var sheet = node.sheet;
	                if (sheet && sheet.cssRules) {
	                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
	                        if (rule && typeof rule.cssText === 'string') {
	                            return css + rule.cssText;
	                        }
	                        return css;
	                    }, '');
	                    var style = node.cloneNode(false);
	                    style.textContent = css;
	                    return style;
	                }
	            }
	            catch (e) {
	                // accessing node.sheet.cssRules throws a DOMException
	                Logger.getInstance(this.options.id).error('Unable to access cssRules property', e);
	                if (e.name !== 'SecurityError') {
	                    throw e;
	                }
	            }
	            return node.cloneNode(false);
	        };
	        DocumentCloner.prototype.createCanvasClone = function (canvas) {
	            if (this.options.inlineImages && canvas.ownerDocument) {
	                var img = canvas.ownerDocument.createElement('img');
	                try {
	                    img.src = canvas.toDataURL();
	                    return img;
	                }
	                catch (e) {
	                    Logger.getInstance(this.options.id).info("Unable to clone canvas contents, canvas is tainted");
	                }
	            }
	            var clonedCanvas = canvas.cloneNode(false);
	            try {
	                clonedCanvas.width = canvas.width;
	                clonedCanvas.height = canvas.height;
	                var ctx = canvas.getContext('2d');
	                var clonedCtx = clonedCanvas.getContext('2d');
	                if (clonedCtx) {
	                    if (ctx) {
	                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
	                    }
	                    else {
	                        clonedCtx.drawImage(canvas, 0, 0);
	                    }
	                }
	                return clonedCanvas;
	            }
	            catch (e) { }
	            return clonedCanvas;
	        };
	        /*
	        createIFrameClone(iframe: HTMLIFrameElement) {
	            const tempIframe = <HTMLIFrameElement>iframe.cloneNode(false);
	            const iframeKey = generateIframeKey();
	            tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);
	
	            const {width, height} = parseBounds(iframe);
	
	            this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(iframe, this.options)
	                .then(documentElement => {
	                    return this.renderer(
	                        documentElement,
	                        {
	                            allowTaint: this.options.allowTaint,
	                            backgroundColor: '#ffffff',
	                            canvas: null,
	                            imageTimeout: this.options.imageTimeout,
	                            logging: this.options.logging,
	                            proxy: this.options.proxy,
	                            removeContainer: this.options.removeContainer,
	                            scale: this.options.scale,
	                            foreignObjectRendering: this.options.foreignObjectRendering,
	                            useCORS: this.options.useCORS,
	                            target: new CanvasRenderer(),
	                            width,
	                            height,
	                            x: 0,
	                            y: 0,
	                            windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
	                            windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
	                            scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
	                            scrollY: documentElement.ownerDocument.defaultView.pageYOffset
	                        },
	                    );
	                })
	                .then(
	                    (canvas: HTMLCanvasElement) =>
	                        new Promise((resolve, reject) => {
	                            const iframeCanvas = document.createElement('img');
	                            iframeCanvas.onload = () => resolve(canvas);
	                            iframeCanvas.onerror = (event) => {
	                                // Empty iframes may result in empty "data:," URLs, which are invalid from the <img>'s point of view
	                                // and instead of `onload` cause `onerror` and unhandled rejection warnings
	                                // https://github.com/niklasvh/html2canvas/issues/1502
	                                iframeCanvas.src == 'data:,' ? resolve(canvas) : reject(event);
	                            };
	                            iframeCanvas.src = canvas.toDataURL();
	                            if (tempIframe.parentNode && iframe.ownerDocument && iframe.ownerDocument.defaultView) {
	                                tempIframe.parentNode.replaceChild(
	                                    copyCSSStyles(
	                                        iframe.ownerDocument.defaultView.getComputedStyle(iframe),
	                                        iframeCanvas
	                                    ),
	                                    tempIframe
	                                );
	                            }
	                        })
	                );
	            return tempIframe;
	        }
	    */
	        DocumentCloner.prototype.cloneNode = function (node) {
	            if (isTextNode(node)) {
	                return document.createTextNode(node.data);
	            }
	            if (!node.ownerDocument) {
	                return node.cloneNode(false);
	            }
	            var window = node.ownerDocument.defaultView;
	            if (isHTMLElementNode(node) && window) {
	                var clone = this.createElementClone(node);
	                var style = window.getComputedStyle(node);
	                var styleBefore = window.getComputedStyle(node, ':before');
	                var styleAfter = window.getComputedStyle(node, ':after');
	                if (this.referenceElement === node) {
	                    this.clonedReferenceElement = clone;
	                }
	                if (isBodyElement(clone)) {
	                    createPseudoHideStyles(clone);
	                }
	                var counters = this.counters.parse(new CSSParsedCounterDeclaration(style));
	                var before_1 = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
	                for (var child = node.firstChild; child; child = child.nextSibling) {
	                    if (!isElementNode(child) ||
	                        (!isScriptElement(child) &&
	                            !child.hasAttribute(IGNORE_ATTRIBUTE) &&
	                            (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
	                        if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
	                            clone.appendChild(this.cloneNode(child));
	                        }
	                    }
	                }
	                if (before_1) {
	                    clone.insertBefore(before_1, clone.firstChild);
	                }
	                var after_1 = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
	                if (after_1) {
	                    clone.appendChild(after_1);
	                }
	                this.counters.pop(counters);
	                if (style && this.options.copyStyles && !isIFrameElement(node)) {
	                    copyCSSStyles(style, clone);
	                }
	                //this.inlineAllImages(clone);
	                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
	                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
	                }
	                if ((isTextareaElement(node) || isSelectElement(node)) &&
	                    (isTextareaElement(clone) || isSelectElement(clone))) {
	                    clone.value = node.value;
	                }
	                return clone;
	            }
	            return node.cloneNode(false);
	        };
	        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
	            var _this = this;
	            if (!style) {
	                return;
	            }
	            var value = style.content;
	            var document = clone.ownerDocument;
	            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
	                return;
	            }
	            this.counters.parse(new CSSParsedCounterDeclaration(style));
	            var declaration = new CSSParsedPseudoDeclaration(style);
	            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
	            copyCSSStyles(style, anonymousReplacedElement);
	            declaration.content.forEach(function (token) {
	                if (token.type === TokenType.STRING_TOKEN) {
	                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
	                }
	                else if (token.type === TokenType.URL_TOKEN) {
	                    var img = document.createElement('img');
	                    img.src = token.value;
	                    img.style.opacity = '1';
	                    anonymousReplacedElement.appendChild(img);
	                }
	                else if (token.type === TokenType.FUNCTION) {
	                    if (token.name === 'attr') {
	                        var attr = token.values.filter(isIdentToken);
	                        if (attr.length) {
	                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
	                        }
	                    }
	                    else if (token.name === 'counter') {
	                        var _a = token.values.filter(nonFunctionArgSeperator), counter = _a[0], counterStyle = _a[1];
	                        if (counter && isIdentToken(counter)) {
	                            var counterState = _this.counters.getCounterValue(counter.value);
	                            var counterType = counterStyle && isIdentToken(counterStyle)
	                                ? listStyleType.parse(counterStyle.value)
	                                : LIST_STYLE_TYPE.DECIMAL;
	                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
	                        }
	                    }
	                    else if (token.name === 'counters') {
	                        var _b = token.values.filter(nonFunctionArgSeperator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
	                        if (counter && isIdentToken(counter)) {
	                            var counterStates = _this.counters.getCounterValues(counter.value);
	                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
	                                ? listStyleType.parse(counterStyle.value)
	                                : LIST_STYLE_TYPE.DECIMAL;
	                            var separator = delim && delim.type === TokenType.STRING_TOKEN ? delim.value : '';
	                            var text = counterStates
	                                .map(function (value) { return createCounterText(value, counterType_1, false); })
	                                .join(separator);
	                            anonymousReplacedElement.appendChild(document.createTextNode(text));
	                        }
	                    }
	                }
	                else if (token.type === TokenType.IDENT_TOKEN) {
	                    switch (token.value) {
	                        case 'open-quote':
	                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
	                            break;
	                        case 'close-quote':
	                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
	                            break;
	                        default:
	                        //    console.log('ident', token, declaration);
	                    }
	                }
	            });
	            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
	            clone.className +=
	                pseudoElt === PseudoElementType.BEFORE
	                    ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
	                    : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
	            return anonymousReplacedElement;
	        };
	        return DocumentCloner;
	    }());
	    var PseudoElementType;
	    (function (PseudoElementType) {
	        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
	        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
	    })(PseudoElementType || (PseudoElementType = {}));
	    var createIFrameContainer = function (ownerDocument, bounds) {
	        var cloneIframeContainer = ownerDocument.createElement('iframe');
	        cloneIframeContainer.className = 'html2canvas-container';
	        cloneIframeContainer.style.visibility = 'hidden';
	        cloneIframeContainer.style.position = 'fixed';
	        cloneIframeContainer.style.left = '-10000px';
	        cloneIframeContainer.style.top = '0px';
	        cloneIframeContainer.style.border = '0';
	        cloneIframeContainer.width = bounds.width.toString();
	        cloneIframeContainer.height = bounds.height.toString();
	        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
	        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
	        ownerDocument.body.appendChild(cloneIframeContainer);
	        return cloneIframeContainer;
	    };
	    var iframeLoader = function (iframe) {
	        return new Promise(function (resolve, reject) {
	            var cloneWindow = iframe.contentWindow;
	            if (!cloneWindow) {
	                return reject("No window assigned for iframe");
	            }
	            var documentClone = cloneWindow.document;
	            cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = function () {
	                cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = null;
	                var interval = setInterval(function () {
	                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
	                        clearInterval(interval);
	                        resolve(iframe);
	                    }
	                }, 50);
	            };
	        });
	    };
	    var copyCSSStyles = function (style, target) {
	        // Edge does not provide value for cssText
	        for (var i = style.length - 1; i >= 0; i--) {
	            var property = style.item(i);
	            // Safari shows pseudoelements if content is set
	            if (property !== 'content') {
	                target.style.setProperty(property, style.getPropertyValue(property));
	            }
	        }
	        return target;
	    };
	    var serializeDoctype = function (doctype) {
	        var str = '';
	        if (doctype) {
	            str += '<!DOCTYPE ';
	            if (doctype.name) {
	                str += doctype.name;
	            }
	            if (doctype.internalSubset) {
	                str += doctype.internalSubset;
	            }
	            if (doctype.publicId) {
	                str += "\"" + doctype.publicId + "\"";
	            }
	            if (doctype.systemId) {
	                str += "\"" + doctype.systemId + "\"";
	            }
	            str += '>';
	        }
	        return str;
	    };
	    var restoreOwnerScroll = function (ownerDocument, x, y) {
	        if (ownerDocument &&
	            ownerDocument.defaultView &&
	            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
	            ownerDocument.defaultView.scrollTo(x, y);
	        }
	    };
	    var restoreNodeScroll = function (_a) {
	        var element = _a[0], x = _a[1], y = _a[2];
	        element.scrollLeft = x;
	        element.scrollTop = y;
	    };
	    var PSEUDO_BEFORE = ':before';
	    var PSEUDO_AFTER = ':after';
	    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
	    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
	    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
	    var createPseudoHideStyles = function (body) {
	        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
	    };
	    var createStyles = function (body, styles) {
	        var document = body.ownerDocument;
	        if (document) {
	            var style = document.createElement('style');
	            style.textContent = styles;
	            body.appendChild(style);
	        }
	    };
	
	    var PathType;
	    (function (PathType) {
	        PathType[PathType["VECTOR"] = 0] = "VECTOR";
	        PathType[PathType["BEZIER_CURVE"] = 1] = "BEZIER_CURVE";
	    })(PathType || (PathType = {}));
	    var equalPath = function (a, b) {
	        if (a.length === b.length) {
	            return a.some(function (v, i) { return v === b[i]; });
	        }
	        return false;
	    };
	    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
	        return path.map(function (point, index) {
	            switch (index) {
	                case 0:
	                    return point.add(deltaX, deltaY);
	                case 1:
	                    return point.add(deltaX + deltaW, deltaY);
	                case 2:
	                    return point.add(deltaX + deltaW, deltaY + deltaH);
	                case 3:
	                    return point.add(deltaX, deltaY + deltaH);
	            }
	            return point;
	        });
	    };
	
	    var Vector = /** @class */ (function () {
	        function Vector(x, y) {
	            this.type = PathType.VECTOR;
	            this.x = x;
	            this.y = y;
	        }
	        Vector.prototype.add = function (deltaX, deltaY) {
	            return new Vector(this.x + deltaX, this.y + deltaY);
	        };
	        return Vector;
	    }());
	
	    var lerp = function (a, b, t) {
	        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
	    };
	    var BezierCurve = /** @class */ (function () {
	        function BezierCurve(start, startControl, endControl, end) {
	            this.type = PathType.BEZIER_CURVE;
	            this.start = start;
	            this.startControl = startControl;
	            this.endControl = endControl;
	            this.end = end;
	        }
	        BezierCurve.prototype.subdivide = function (t, firstHalf) {
	            var ab = lerp(this.start, this.startControl, t);
	            var bc = lerp(this.startControl, this.endControl, t);
	            var cd = lerp(this.endControl, this.end, t);
	            var abbc = lerp(ab, bc, t);
	            var bccd = lerp(bc, cd, t);
	            var dest = lerp(abbc, bccd, t);
	            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
	        };
	        BezierCurve.prototype.add = function (deltaX, deltaY) {
	            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
	        };
	        BezierCurve.prototype.reverse = function () {
	            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
	        };
	        return BezierCurve;
	    }());
	    var isBezierCurve = function (path) { return path.type === PathType.BEZIER_CURVE; };
	
	    var BoundCurves = /** @class */ (function () {
	        function BoundCurves(element) {
	            var styles = element.styles;
	            var bounds = element.bounds;
	            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
	            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
	            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
	            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
	            var factors = [];
	            factors.push((tlh + trh) / bounds.width);
	            factors.push((blh + brh) / bounds.width);
	            factors.push((tlv + blv) / bounds.height);
	            factors.push((trv + brv) / bounds.height);
	            var maxFactor = Math.max.apply(Math, factors);
	            if (maxFactor > 1) {
	                tlh /= maxFactor;
	                tlv /= maxFactor;
	                trh /= maxFactor;
	                trv /= maxFactor;
	                brh /= maxFactor;
	                brv /= maxFactor;
	                blh /= maxFactor;
	                blv /= maxFactor;
	            }
	            var topWidth = bounds.width - trh;
	            var rightHeight = bounds.height - brv;
	            var bottomWidth = bounds.width - brh;
	            var leftHeight = bounds.height - blv;
	            var borderTopWidth = styles.borderTopWidth;
	            var borderRightWidth = styles.borderRightWidth;
	            var borderBottomWidth = styles.borderBottomWidth;
	            var borderLeftWidth = styles.borderLeftWidth;
	            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
	            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
	            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
	            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
	            this.topLeftBorderBox =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
	                    : new Vector(bounds.left, bounds.top);
	            this.topRightBorderBox =
	                trh > 0 || trv > 0
	                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
	                    : new Vector(bounds.left + bounds.width, bounds.top);
	            this.bottomRightBorderBox =
	                brh > 0 || brv > 0
	                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
	                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
	            this.bottomLeftBorderBox =
	                blh > 0 || blv > 0
	                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
	                    : new Vector(bounds.left, bounds.top + bounds.height);
	            this.topLeftPaddingBox =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
	            this.topRightPaddingBox =
	                trh > 0 || trv > 0
	                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderLeftWidth ? 0 : trh - borderLeftWidth, trv - borderTopWidth, CORNER.TOP_RIGHT)
	                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
	            this.bottomRightPaddingBox =
	                brh > 0 || brv > 0
	                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth), Math.max(0, brh - borderRightWidth), brv - borderBottomWidth, CORNER.BOTTOM_RIGHT)
	                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
	            this.bottomLeftPaddingBox =
	                blh > 0 || blv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + leftHeight, Math.max(0, blh - borderLeftWidth), blv - borderBottomWidth, CORNER.BOTTOM_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
	            this.topLeftContentBox =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
	            this.topRightContentBox =
	                trh > 0 || trv > 0
	                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
	                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
	            this.bottomRightContentBox =
	                brh > 0 || brv > 0
	                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
	                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
	            this.bottomLeftContentBox =
	                blh > 0 || blv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
	        }
	        return BoundCurves;
	    }());
	    var CORNER;
	    (function (CORNER) {
	        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
	        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
	        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
	        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
	    })(CORNER || (CORNER = {}));
	    var getCurvePoints = function (x, y, r1, r2, position) {
	        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
	        var ox = r1 * kappa; // control point offset horizontal
	        var oy = r2 * kappa; // control point offset vertical
	        var xm = x + r1; // x-middle
	        var ym = y + r2; // y-middle
	        switch (position) {
	            case CORNER.TOP_LEFT:
	                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
	            case CORNER.TOP_RIGHT:
	                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
	            case CORNER.BOTTOM_RIGHT:
	                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
	            case CORNER.BOTTOM_LEFT:
	            default:
	                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
	        }
	    };
	    var calculateBorderBoxPath = function (curves) {
	        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
	    };
	    var calculateContentBoxPath = function (curves) {
	        return [
	            curves.topLeftContentBox,
	            curves.topRightContentBox,
	            curves.bottomRightContentBox,
	            curves.bottomLeftContentBox
	        ];
	    };
	    var calculatePaddingBoxPath = function (curves) {
	        return [
	            curves.topLeftPaddingBox,
	            curves.topRightPaddingBox,
	            curves.bottomRightPaddingBox,
	            curves.bottomLeftPaddingBox
	        ];
	    };
	
	    var TransformEffect = /** @class */ (function () {
	        function TransformEffect(offsetX, offsetY, matrix) {
	            this.type = 0 /* TRANSFORM */;
	            this.offsetX = offsetX;
	            this.offsetY = offsetY;
	            this.matrix = matrix;
	            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
	        }
	        return TransformEffect;
	    }());
	    var ClipEffect = /** @class */ (function () {
	        function ClipEffect(path, target) {
	            this.type = 1 /* CLIP */;
	            this.target = target;
	            this.path = path;
	        }
	        return ClipEffect;
	    }());
	    var isTransformEffect = function (effect) {
	        return effect.type === 0 /* TRANSFORM */;
	    };
	    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
	
	    var StackingContext = /** @class */ (function () {
	        function StackingContext(container) {
	            this.element = container;
	            this.inlineLevel = [];
	            this.nonInlineLevel = [];
	            this.negativeZIndex = [];
	            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
	            this.positiveZIndex = [];
	            this.nonPositionedFloats = [];
	            this.nonPositionedInlineLevel = [];
	        }
	        return StackingContext;
	    }());
	    var ElementPaint = /** @class */ (function () {
	        function ElementPaint(element, parentStack) {
	            this.container = element;
	            this.effects = parentStack.slice(0);
	            this.curves = new BoundCurves(element);
	            if (element.styles.transform !== null) {
	                var offsetX = element.bounds.left + element.styles.transformOrigin[0].number;
	                var offsetY = element.bounds.top + element.styles.transformOrigin[1].number;
	                var matrix = element.styles.transform;
	                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
	            }
	            if (element.styles.overflowX !== OVERFLOW.VISIBLE) {
	                var borderBox = calculateBorderBoxPath(this.curves);
	                var paddingBox = calculatePaddingBoxPath(this.curves);
	                if (equalPath(borderBox, paddingBox)) {
	                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
	                }
	                else {
	                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
	                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
	                }
	            }
	        }
	        ElementPaint.prototype.getParentEffects = function () {
	            var effects = this.effects.slice(0);
	            if (this.container.styles.overflowX !== OVERFLOW.VISIBLE) {
	                var borderBox = calculateBorderBoxPath(this.curves);
	                var paddingBox = calculatePaddingBoxPath(this.curves);
	                if (!equalPath(borderBox, paddingBox)) {
	                    effects.push(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
	                }
	            }
	            return effects;
	        };
	        return ElementPaint;
	    }());
	    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
	        parent.container.elements.forEach(function (child) {
	            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
	            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
	            var paintContainer = new ElementPaint(child, parent.getParentEffects());
	            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
	                listItems.push(paintContainer);
	            }
	            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
	            if (treatAsRealStackingContext || createsStackingContext) {
	                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
	                var stack = new StackingContext(paintContainer);
	                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
	                    var order_1 = child.styles.zIndex.order;
	                    if (order_1 < 0) {
	                        var index_1 = 0;
	                        parentStack.negativeZIndex.some(function (current, i) {
	                            if (order_1 > current.element.container.styles.zIndex.order) {
	                                index_1 = i;
	                                return true;
	                            }
	                            return false;
	                        });
	                        parentStack.negativeZIndex.splice(index_1, 0, stack);
	                    }
	                    else if (order_1 > 0) {
	                        var index_2 = 0;
	                        parentStack.positiveZIndex.some(function (current, i) {
	                            if (order_1 > current.element.container.styles.zIndex.order) {
	                                index_2 = i + 1;
	                                return true;
	                            }
	                            return false;
	                        });
	                        parentStack.positiveZIndex.splice(index_2, 0, stack);
	                    }
	                    else {
	                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
	                    }
	                }
	                else {
	                    if (child.styles.isFloating()) {
	                        parentStack.nonPositionedFloats.push(stack);
	                    }
	                    else {
	                        parentStack.nonPositionedInlineLevel.push(stack);
	                    }
	                }
	                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
	            }
	            else {
	                if (child.styles.isInlineLevel()) {
	                    stackingContext.inlineLevel.push(paintContainer);
	                }
	                else {
	                    stackingContext.nonInlineLevel.push(paintContainer);
	                }
	                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
	            }
	            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
	                processListItems(child, listOwnerItems);
	            }
	        });
	    };
	    var processListItems = function (owner, elements) {
	        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
	        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
	        for (var i = 0; i < elements.length; i++) {
	            var item = elements[i];
	            if (item.container instanceof LIElementContainer &&
	                typeof item.container.value === 'number' &&
	                item.container.value !== 0) {
	                numbering = item.container.value;
	            }
	            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
	            numbering += reversed ? -1 : 1;
	        }
	    };
	    var parseStackingContexts = function (container) {
	        var paintContainer = new ElementPaint(container, []);
	        var root = new StackingContext(paintContainer);
	        var listItems = [];
	        parseStackTree(paintContainer, root, root, listItems);
	        processListItems(paintContainer.container, listItems);
	        return root;
	    };
	
	    var parsePathForBorder = function (curves, borderSide) {
	        switch (borderSide) {
	            case 0:
	                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
	            case 1:
	                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
	            case 2:
	                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
	            case 3:
	            default:
	                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
	        }
	    };
	    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
	        var path = [];
	        if (isBezierCurve(outer1)) {
	            path.push(outer1.subdivide(0.5, false));
	        }
	        else {
	            path.push(outer1);
	        }
	        if (isBezierCurve(outer2)) {
	            path.push(outer2.subdivide(0.5, true));
	        }
	        else {
	            path.push(outer2);
	        }
	        if (isBezierCurve(inner2)) {
	            path.push(inner2.subdivide(0.5, true).reverse());
	        }
	        else {
	            path.push(inner2);
	        }
	        if (isBezierCurve(inner1)) {
	            path.push(inner1.subdivide(0.5, false).reverse());
	        }
	        else {
	            path.push(inner1);
	        }
	        return path;
	    };
	
	    var paddingBox = function (element) {
	        var bounds = element.bounds;
	        var styles = element.styles;
	        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
	    };
	    var contentBox = function (element) {
	        var styles = element.styles;
	        var bounds = element.bounds;
	        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
	        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
	        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
	        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
	        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
	    };
	
	    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
	        if (backgroundOrigin === 0 /* BORDER_BOX */) {
	            return element.bounds;
	        }
	        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
	            return contentBox(element);
	        }
	        return paddingBox(element);
	    };
	    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
	        if (backgroundClip === BACKGROUND_CLIP.BORDER_BOX) {
	            return element.bounds;
	        }
	        if (backgroundClip === BACKGROUND_CLIP.CONTENT_BOX) {
	            return contentBox(element);
	        }
	        return paddingBox(element);
	    };
	    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
	        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
	        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
	        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
	        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
	        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
	        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
	        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
	        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
	        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
	    };
	    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
	    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
	    var calculateBackgroundSize = function (size, _a, bounds) {
	        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
	        var first = size[0], second = size[1];
	        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
	            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
	        }
	        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
	        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
	            if (hasIntrinsicValue(intrinsicProportion)) {
	                var targetRatio = bounds.width / bounds.height;
	                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
	                    ? [bounds.width, bounds.width / intrinsicProportion]
	                    : [bounds.height * intrinsicProportion, bounds.height];
	            }
	            return [bounds.width, bounds.height];
	        }
	        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
	        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
	        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
	        // If the background-size is auto or auto auto:
	        if (isAuto(first) && (!second || isAuto(second))) {
	            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
	            if (hasIntrinsicWidth && hasIntrinsicHeight) {
	                return [intrinsicWidth, intrinsicHeight];
	            }
	            // If the image has no intrinsic dimensions and has no intrinsic proportions,
	            // it's rendered at the size of the background positioning area.
	            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
	                return [bounds.width, bounds.height];
	            }
	            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
	            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
	            // The other dimension is computed using the specified dimension and the intrinsic proportions.
	            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
	                var width_1 = hasIntrinsicWidth
	                    ? intrinsicWidth
	                    : intrinsicHeight * intrinsicProportion;
	                var height_1 = hasIntrinsicHeight
	                    ? intrinsicHeight
	                    : intrinsicWidth / intrinsicProportion;
	                return [width_1, height_1];
	            }
	            // If the image has only one intrinsic dimension but has no intrinsic proportions,
	            // it's rendered using the specified dimension and the other dimension of the background positioning area.
	            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
	            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
	            return [width_2, height_2];
	        }
	        // If the image has intrinsic proportions, it's stretched to the specified dimension.
	        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
	        if (hasIntrinsicProportion) {
	            var width_3 = 0;
	            var height_3 = 0;
	            if (isLengthPercentage(first)) {
	                width_3 = getAbsoluteValue(first, bounds.width);
	            }
	            else if (isLengthPercentage(second)) {
	                height_3 = getAbsoluteValue(second, bounds.height);
	            }
	            if (isAuto(first)) {
	                width_3 = height_3 * intrinsicProportion;
	            }
	            else if (!second || isAuto(second)) {
	                height_3 = width_3 / intrinsicProportion;
	            }
	            return [width_3, height_3];
	        }
	        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
	        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
	        // if there is one. If there is no such intrinsic dimension,
	        // it becomes the corresponding dimension of the background positioning area.
	        var width = null;
	        var height = null;
	        if (isLengthPercentage(first)) {
	            width = getAbsoluteValue(first, bounds.width);
	        }
	        else if (second && isLengthPercentage(second)) {
	            height = getAbsoluteValue(second, bounds.height);
	        }
	        if (width !== null && (!second || isAuto(second))) {
	            height =
	                hasIntrinsicWidth && hasIntrinsicHeight
	                    ? (width / intrinsicWidth) * intrinsicHeight
	                    : bounds.height;
	        }
	        if (height !== null && isAuto(first)) {
	            width =
	                hasIntrinsicWidth && hasIntrinsicHeight
	                    ? (height / intrinsicHeight) * intrinsicWidth
	                    : bounds.width;
	        }
	        if (width !== null && height !== null) {
	            return [width, height];
	        }
	        throw new Error("Unable to calculate background-size for element");
	    };
	    var getBackgroundValueForIndex = function (values, index) {
	        var value = values[index];
	        if (typeof value === 'undefined') {
	            return values[0];
	        }
	        return value;
	    };
	    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
	        var x = _a[0], y = _a[1];
	        var width = _b[0], height = _b[1];
	        switch (repeat) {
	            case BACKGROUND_REPEAT.REPEAT_X:
	                return [
	                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
	                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
	                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
	                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
	                ];
	            case BACKGROUND_REPEAT.REPEAT_Y:
	                return [
	                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
	                ];
	            case BACKGROUND_REPEAT.NO_REPEAT:
	                return [
	                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
	                ];
	            default:
	                return [
	                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
	                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
	                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
	                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
	                ];
	        }
	    };
	
	    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
	
	    var SAMPLE_TEXT = 'Hidden Text';
	    var FontMetrics = /** @class */ (function () {
	        function FontMetrics(document) {
	            this._data = {};
	            this._document = document;
	        }
	        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
	            var container = this._document.createElement('div');
	            var img = this._document.createElement('img');
	            var span = this._document.createElement('span');
	            var body = this._document.body;
	            container.style.visibility = 'hidden';
	            container.style.fontFamily = fontFamily;
	            container.style.fontSize = fontSize;
	            container.style.margin = '0';
	            container.style.padding = '0';
	            body.appendChild(container);
	            img.src = SMALL_IMAGE;
	            img.width = 1;
	            img.height = 1;
	            img.style.margin = '0';
	            img.style.padding = '0';
	            img.style.verticalAlign = 'baseline';
	            span.style.fontFamily = fontFamily;
	            span.style.fontSize = fontSize;
	            span.style.margin = '0';
	            span.style.padding = '0';
	            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
	            container.appendChild(span);
	            container.appendChild(img);
	            var baseline = img.offsetTop - span.offsetTop + 2;
	            container.removeChild(span);
	            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
	            container.style.lineHeight = 'normal';
	            img.style.verticalAlign = 'super';
	            var middle = img.offsetTop - container.offsetTop + 2;
	            body.removeChild(container);
	            return { baseline: baseline, middle: middle };
	        };
	        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
	            var key = fontFamily + " " + fontSize;
	            if (typeof this._data[key] === 'undefined') {
	                this._data[key] = this.parseMetrics(fontFamily, fontSize);
	            }
	            return this._data[key];
	        };
	        return FontMetrics;
	    }());
	
	    var MASK_OFFSET = 10000;
	    var CanvasRenderer = /** @class */ (function () {
	        function CanvasRenderer(options) {
	            this._activeEffects = [];
	            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
	            this.ctx = this.canvas.getContext('2d');
	            this.options = options;
	            this.canvas.width = Math.floor(options.width * options.scale);
	            this.canvas.height = Math.floor(options.height * options.scale);
	            this.canvas.style.width = options.width + "px";
	            this.canvas.style.height = options.height + "px";
	            this.fontMetrics = new FontMetrics(document);
	            this.ctx.scale(this.options.scale, this.options.scale);
	            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
	            this.ctx.textBaseline = 'bottom';
	            this._activeEffects = [];
	            Logger.getInstance(options.id).debug("Canvas renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
	        }
	        CanvasRenderer.prototype.applyEffects = function (effects, target) {
	            var _this = this;
	            while (this._activeEffects.length) {
	                this.popEffect();
	            }
	            effects.filter(function (effect) { return contains(effect.target, target); }).forEach(function (effect) { return _this.applyEffect(effect); });
	        };
	        CanvasRenderer.prototype.applyEffect = function (effect) {
	            this.ctx.save();
	            if (isTransformEffect(effect)) {
	                this.ctx.translate(effect.offsetX, effect.offsetY);
	                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
	                this.ctx.translate(-effect.offsetX, -effect.offsetY);
	            }
	            if (isClipEffect(effect)) {
	                this.path(effect.path);
	                this.ctx.clip();
	            }
	            this._activeEffects.push(effect);
	        };
	        CanvasRenderer.prototype.popEffect = function () {
	            this._activeEffects.pop();
	            this.ctx.restore();
	        };
	        CanvasRenderer.prototype.renderStack = function (stack) {
	            return __awaiter(this, void 0, void 0, function () {
	                var styles;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            styles = stack.element.container.styles;
	                            if (!styles.isVisible()) return [3 /*break*/, 2];
	                            this.ctx.globalAlpha = styles.opacity;
	                            return [4 /*yield*/, this.renderStackContent(stack)];
	                        case 1:
	                            _a.sent();
	                            _a.label = 2;
	                        case 2: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderNode = function (paint) {
	            return __awaiter(this, void 0, void 0, function () {
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
	                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
	                        case 1:
	                            _a.sent();
	                            return [4 /*yield*/, this.renderNodeContent(paint)];
	                        case 2:
	                            _a.sent();
	                            _a.label = 3;
	                        case 3: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing) {
	            var _this = this;
	            if (letterSpacing === 0) {
	                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
	            }
	            else {
	                var letters = toCodePoints(text.text).map(function (i) { return fromCodePoint(i); });
	                letters.reduce(function (left, letter) {
	                    _this.ctx.fillText(letter, left, text.bounds.top + text.bounds.height);
	                    return left + _this.ctx.measureText(letter).width;
	                }, text.bounds.left);
	            }
	        };
	        CanvasRenderer.prototype.createFontStyle = function (styles) {
	            var fontVariant = styles.fontVariant
	                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
	                .join('');
	            var fontFamily = styles.fontFamily.join(', ');
	            var fontSize = isDimensionToken(styles.fontSize)
	                ? "" + styles.fontSize.number + styles.fontSize.unit
	                : styles.fontSize.number + "px";
	            return [
	                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
	                fontFamily,
	                fontSize
	            ];
	        };
	        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
	            return __awaiter(this, void 0, void 0, function () {
	                var _a, font, fontFamily, fontSize;
	                var _this = this;
	                return __generator(this, function (_b) {
	                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
	                    this.ctx.font = font;
	                    text.textBounds.forEach(function (text) {
	                        _this.ctx.fillStyle = asString(styles.color);
	                        _this.renderTextWithLetterSpacing(text, styles.letterSpacing);
	                        var textShadows = styles.textShadow;
	                        if (textShadows.length && text.text.trim().length) {
	                            textShadows
	                                .slice(0)
	                                .reverse()
	                                .forEach(function (textShadow) {
	                                _this.ctx.shadowColor = asString(textShadow.color);
	                                _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
	                                _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
	                                _this.ctx.shadowBlur = textShadow.blur.number;
	                                _this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
	                            });
	                            _this.ctx.shadowColor = '';
	                            _this.ctx.shadowOffsetX = 0;
	                            _this.ctx.shadowOffsetY = 0;
	                            _this.ctx.shadowBlur = 0;
	                        }
	                        if (styles.textDecorationLine.length) {
	                            _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
	                            styles.textDecorationLine.forEach(function (textDecorationLine) {
	                                switch (textDecorationLine) {
	                                    case 1 /* UNDERLINE */:
	                                        // Draws a line at the baseline of the font
	                                        // TODO As some browsers display the line as more than 1px if the font-size is big,
	                                        // need to take that into account both in position and size
	                                        var baseline = _this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
	                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
	                                        break;
	                                    case 2 /* OVERLINE */:
	                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
	                                        break;
	                                    case 3 /* LINE_THROUGH */:
	                                        // TODO try and find exact position for line-through
	                                        var middle = _this.fontMetrics.getMetrics(fontFamily, fontSize).middle;
	                                        _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
	                                        break;
	                                }
	                            });
	                        }
	                    });
	                    return [2 /*return*/];
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
	            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
	                var box = contentBox(container);
	                var path = calculatePaddingBoxPath(curves);
	                this.path(path);
	                this.ctx.save();
	                this.ctx.clip();
	                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
	                this.ctx.restore();
	            }
	        };
	        CanvasRenderer.prototype.renderNodeContent = function (paint) {
	            return __awaiter(this, void 0, void 0, function () {
	                var container, curves, styles, _i, _a, child, image, e_1, image, e_2, iframeRenderer, canvas, size, bounds, x, textBounds, img, image, url, e_3, bounds;
	                return __generator(this, function (_b) {
	                    switch (_b.label) {
	                        case 0:
	                            this.applyEffects(paint.effects, 4 /* CONTENT */);
	                            container = paint.container;
	                            curves = paint.curves;
	                            styles = container.styles;
	                            _i = 0, _a = container.textNodes;
	                            _b.label = 1;
	                        case 1:
	                            if (!(_i < _a.length)) return [3 /*break*/, 4];
	                            child = _a[_i];
	                            return [4 /*yield*/, this.renderTextNode(child, styles)];
	                        case 2:
	                            _b.sent();
	                            _b.label = 3;
	                        case 3:
	                            _i++;
	                            return [3 /*break*/, 1];
	                        case 4:
	                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
	                            _b.label = 5;
	                        case 5:
	                            _b.trys.push([5, 7, , 8]);
	                            return [4 /*yield*/, this.options.cache.match(container.src)];
	                        case 6:
	                            image = _b.sent();
	                            this.renderReplacedElement(container, curves, image);
	                            return [3 /*break*/, 8];
	                        case 7:
	                            e_1 = _b.sent();
	                            Logger.getInstance(this.options.id).error("Error loading image " + container.src);
	                            return [3 /*break*/, 8];
	                        case 8:
	                            if (container instanceof CanvasElementContainer) {
	                                this.renderReplacedElement(container, curves, container.canvas);
	                            }
	                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
	                            _b.label = 9;
	                        case 9:
	                            _b.trys.push([9, 11, , 12]);
	                            return [4 /*yield*/, this.options.cache.match(container.svg)];
	                        case 10:
	                            image = _b.sent();
	                            this.renderReplacedElement(container, curves, image);
	                            return [3 /*break*/, 12];
	                        case 11:
	                            e_2 = _b.sent();
	                            Logger.getInstance(this.options.id).error("Error loading svg " + container.svg.substring(0, 255));
	                            return [3 /*break*/, 12];
	                        case 12:
	                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
	                            iframeRenderer = new CanvasRenderer({
	                                id: this.options.id,
	                                scale: this.options.scale,
	                                backgroundColor: container.backgroundColor,
	                                x: 0,
	                                y: 0,
	                                scrollX: 0,
	                                scrollY: 0,
	                                width: container.width,
	                                height: container.height,
	                                cache: this.options.cache,
	                                windowWidth: container.width,
	                                windowHeight: container.height
	                            });
	                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
	                        case 13:
	                            canvas = _b.sent();
	                            this.ctx.drawImage(canvas, 0, 0, container.width, container.width, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
	                            _b.label = 14;
	                        case 14:
	                            if (container instanceof InputElementContainer) {
	                                size = Math.min(container.bounds.width, container.bounds.height);
	                                if (container.type === CHECKBOX) {
	                                    if (container.checked) {
	                                        this.ctx.save();
	                                        this.path([
	                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
	                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
	                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
	                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
	                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
	                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
	                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
	                                        ]);
	                                        this.ctx.fillStyle = asString(INPUT_COLOR);
	                                        this.ctx.fill();
	                                        this.ctx.restore();
	                                    }
	                                }
	                                else if (container.type === RADIO) {
	                                    if (container.checked) {
	                                        this.ctx.save();
	                                        this.ctx.beginPath();
	                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
	                                        this.ctx.fillStyle = asString(INPUT_COLOR);
	                                        this.ctx.fill();
	                                        this.ctx.restore();
	                                    }
	                                }
	                            }
	                            if (isTextInputElement(container) && container.value.length) {
	                                this.ctx.font = this.createFontStyle(styles)[0];
	                                this.ctx.fillStyle = asString(styles.color);
	                                this.ctx.textBaseline = 'middle';
	                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
	                                bounds = contentBox(container);
	                                x = 0;
	                                switch (container.styles.textAlign) {
	                                    case TEXT_ALIGN.CENTER:
	                                        x += bounds.width / 2;
	                                        break;
	                                    case TEXT_ALIGN.RIGHT:
	                                        x += bounds.width;
	                                        break;
	                                }
	                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
	                                this.ctx.save();
	                                this.path([
	                                    new Vector(bounds.left, bounds.top),
	                                    new Vector(bounds.left + bounds.width, bounds.top),
	                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
	                                    new Vector(bounds.left, bounds.top + bounds.height)
	                                ]);
	                                this.ctx.clip();
	                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing);
	                                this.ctx.restore();
	                                this.ctx.textBaseline = 'bottom';
	                                this.ctx.textAlign = 'left';
	                            }
	                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
	                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
	                            img = container.styles.listStyleImage;
	                            if (!(img.type === CSSImageType.URL)) return [3 /*break*/, 18];
	                            image = void 0;
	                            url = img.url;
	                            _b.label = 15;
	                        case 15:
	                            _b.trys.push([15, 17, , 18]);
	                            return [4 /*yield*/, this.options.cache.match(url)];
	                        case 16:
	                            image = _b.sent();
	                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
	                            return [3 /*break*/, 18];
	                        case 17:
	                            e_3 = _b.sent();
	                            Logger.getInstance(this.options.id).error("Error loading list-style-image " + url);
	                            return [3 /*break*/, 18];
	                        case 18: return [3 /*break*/, 20];
	                        case 19:
	                            if (paint.listValue && container.styles.listStyleType !== LIST_STYLE_TYPE.NONE) {
	                                this.ctx.font = this.createFontStyle(styles)[0];
	                                this.ctx.fillStyle = asString(styles.color);
	                                this.ctx.textBaseline = 'middle';
	                                this.ctx.textAlign = 'right';
	                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
	                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing);
	                                this.ctx.textBaseline = 'bottom';
	                                this.ctx.textAlign = 'left';
	                            }
	                            _b.label = 20;
	                        case 20: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderStackContent = function (stack) {
	            return __awaiter(this, void 0, void 0, function () {
	                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
	                return __generator(this, function (_p) {
	                    switch (_p.label) {
	                        case 0: 
	                        // https://www.w3.org/TR/css-position-3/#painting-order
	                        // 1. the background and borders of the element forming the stacking context.
	                        return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
	                        case 1:
	                            // https://www.w3.org/TR/css-position-3/#painting-order
	                            // 1. the background and borders of the element forming the stacking context.
	                            _p.sent();
	                            _i = 0, _a = stack.negativeZIndex;
	                            _p.label = 2;
	                        case 2:
	                            if (!(_i < _a.length)) return [3 /*break*/, 5];
	                            child = _a[_i];
	                            return [4 /*yield*/, this.renderStack(child)];
	                        case 3:
	                            _p.sent();
	                            _p.label = 4;
	                        case 4:
	                            _i++;
	                            return [3 /*break*/, 2];
	                        case 5: 
	                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
	                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
	                        case 6:
	                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
	                            _p.sent();
	                            _b = 0, _c = stack.nonInlineLevel;
	                            _p.label = 7;
	                        case 7:
	                            if (!(_b < _c.length)) return [3 /*break*/, 10];
	                            child = _c[_b];
	                            return [4 /*yield*/, this.renderNode(child)];
	                        case 8:
	                            _p.sent();
	                            _p.label = 9;
	                        case 9:
	                            _b++;
	                            return [3 /*break*/, 7];
	                        case 10:
	                            _d = 0, _e = stack.nonPositionedFloats;
	                            _p.label = 11;
	                        case 11:
	                            if (!(_d < _e.length)) return [3 /*break*/, 14];
	                            child = _e[_d];
	                            return [4 /*yield*/, this.renderStack(child)];
	                        case 12:
	                            _p.sent();
	                            _p.label = 13;
	                        case 13:
	                            _d++;
	                            return [3 /*break*/, 11];
	                        case 14:
	                            _f = 0, _g = stack.nonPositionedInlineLevel;
	                            _p.label = 15;
	                        case 15:
	                            if (!(_f < _g.length)) return [3 /*break*/, 18];
	                            child = _g[_f];
	                            return [4 /*yield*/, this.renderStack(child)];
	                        case 16:
	                            _p.sent();
	                            _p.label = 17;
	                        case 17:
	                            _f++;
	                            return [3 /*break*/, 15];
	                        case 18:
	                            _h = 0, _j = stack.inlineLevel;
	                            _p.label = 19;
	                        case 19:
	                            if (!(_h < _j.length)) return [3 /*break*/, 22];
	                            child = _j[_h];
	                            return [4 /*yield*/, this.renderNode(child)];
	                        case 20:
	                            _p.sent();
	                            _p.label = 21;
	                        case 21:
	                            _h++;
	                            return [3 /*break*/, 19];
	                        case 22:
	                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
	                            _p.label = 23;
	                        case 23:
	                            if (!(_k < _l.length)) return [3 /*break*/, 26];
	                            child = _l[_k];
	                            return [4 /*yield*/, this.renderStack(child)];
	                        case 24:
	                            _p.sent();
	                            _p.label = 25;
	                        case 25:
	                            _k++;
	                            return [3 /*break*/, 23];
	                        case 26:
	                            _m = 0, _o = stack.positiveZIndex;
	                            _p.label = 27;
	                        case 27:
	                            if (!(_m < _o.length)) return [3 /*break*/, 30];
	                            child = _o[_m];
	                            return [4 /*yield*/, this.renderStack(child)];
	                        case 28:
	                            _p.sent();
	                            _p.label = 29;
	                        case 29:
	                            _m++;
	                            return [3 /*break*/, 27];
	                        case 30: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.mask = function (paths) {
	            this.ctx.beginPath();
	            this.ctx.moveTo(0, 0);
	            this.ctx.lineTo(this.canvas.width, 0);
	            this.ctx.lineTo(this.canvas.width, this.canvas.height);
	            this.ctx.lineTo(0, this.canvas.height);
	            this.ctx.lineTo(0, 0);
	            this.formatPath(paths.slice(0).reverse());
	            this.ctx.closePath();
	        };
	        CanvasRenderer.prototype.path = function (paths) {
	            this.ctx.beginPath();
	            this.formatPath(paths);
	            this.ctx.closePath();
	        };
	        CanvasRenderer.prototype.formatPath = function (paths) {
	            var _this = this;
	            paths.forEach(function (point, index) {
	                var start = isBezierCurve(point) ? point.start : point;
	                if (index === 0) {
	                    _this.ctx.moveTo(start.x, start.y);
	                }
	                else {
	                    _this.ctx.lineTo(start.x, start.y);
	                }
	                if (isBezierCurve(point)) {
	                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
	                }
	            });
	        };
	        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
	            this.path(path);
	            this.ctx.fillStyle = pattern;
	            this.ctx.translate(offsetX, offsetY);
	            this.ctx.fill();
	            this.ctx.translate(-offsetX, -offsetY);
	        };
	        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
	            if (image.width === width && image.height === height) {
	                return image;
	            }
	            var canvas = this.canvas.ownerDocument.createElement('canvas');
	            canvas.width = width;
	            canvas.height = height;
	            var ctx = canvas.getContext('2d');
	            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
	            return canvas;
	        };
	        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
	            return __awaiter(this, void 0, void 0, function () {
	                var index, _loop_1, this_1, _i, _a, backgroundImage;
	                return __generator(this, function (_b) {
	                    switch (_b.label) {
	                        case 0:
	                            index = container.styles.backgroundImage.length - 1;
	                            _loop_1 = function (backgroundImage) {
	                                var image, url, e_4, _a, path, x, y, width, height, pattern, _b, path, x, y, width, height, _c, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _d, path, left, top_1, width, height, position, x, y, _e, rx, ry, radialGradient_1, midX, midY, f, invF;
	                                return __generator(this, function (_f) {
	                                    switch (_f.label) {
	                                        case 0:
	                                            if (!(backgroundImage.type === CSSImageType.URL)) return [3 /*break*/, 5];
	                                            image = void 0;
	                                            url = backgroundImage.url;
	                                            _f.label = 1;
	                                        case 1:
	                                            _f.trys.push([1, 3, , 4]);
	                                            return [4 /*yield*/, this_1.options.cache.match(url)];
	                                        case 2:
	                                            image = _f.sent();
	                                            return [3 /*break*/, 4];
	                                        case 3:
	                                            e_4 = _f.sent();
	                                            Logger.getInstance(this_1.options.id).error("Error loading background-image " + url);
	                                            return [3 /*break*/, 4];
	                                        case 4:
	                                            if (image) {
	                                                _a = calculateBackgroundRendering(container, index, [
	                                                    image.width,
	                                                    image.height,
	                                                    image.width / image.height
	                                                ]), path = _a[0], x = _a[1], y = _a[2], width = _a[3], height = _a[4];
	                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
	                                                this_1.renderRepeat(path, pattern, x, y);
	                                            }
	                                            return [3 /*break*/, 6];
	                                        case 5:
	                                            if (isLinearGradient(backgroundImage)) {
	                                                _b = calculateBackgroundRendering(container, index, [null, null, null]), path = _b[0], x = _b[1], y = _b[2], width = _b[3], height = _b[4];
	                                                _c = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _c[0], x0 = _c[1], x1 = _c[2], y0 = _c[3], y1 = _c[4];
	                                                canvas = document.createElement('canvas');
	                                                canvas.width = width;
	                                                canvas.height = height;
	                                                ctx = canvas.getContext('2d');
	                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
	                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
	                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
	                                                });
	                                                ctx.fillStyle = gradient_1;
	                                                ctx.fillRect(0, 0, width, height);
	                                                pattern = this_1.ctx.createPattern(canvas, 'repeat');
	                                                this_1.renderRepeat(path, pattern, x, y);
	                                            }
	                                            else if (isRadialGradient(backgroundImage)) {
	                                                _d = calculateBackgroundRendering(container, index, [
	                                                    null,
	                                                    null,
	                                                    null
	                                                ]), path = _d[0], left = _d[1], top_1 = _d[2], width = _d[3], height = _d[4];
	                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
	                                                x = getAbsoluteValue(position[0], width);
	                                                y = getAbsoluteValue(position[position.length - 1], height);
	                                                _e = calculateRadius(backgroundImage, x, y, width, height), rx = _e[0], ry = _e[1];
	                                                if (rx > 0 && rx > 0) {
	                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
	                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
	                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
	                                                    });
	                                                    this_1.path(path);
	                                                    this_1.ctx.fillStyle = radialGradient_1;
	                                                    if (rx !== ry) {
	                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
	                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
	                                                        f = ry / rx;
	                                                        invF = 1 / f;
	                                                        this_1.ctx.save();
	                                                        this_1.ctx.translate(midX, midY);
	                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
	                                                        this_1.ctx.translate(-midX, -midY);
	                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
	                                                        this_1.ctx.restore();
	                                                    }
	                                                    else {
	                                                        this_1.ctx.fill();
	                                                    }
	                                                }
	                                            }
	                                            _f.label = 6;
	                                        case 6:
	                                            index--;
	                                            return [2 /*return*/];
	                                    }
	                                });
	                            };
	                            this_1 = this;
	                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
	                            _b.label = 1;
	                        case 1:
	                            if (!(_i < _a.length)) return [3 /*break*/, 4];
	                            backgroundImage = _a[_i];
	                            return [5 /*yield**/, _loop_1(backgroundImage)];
	                        case 2:
	                            _b.sent();
	                            _b.label = 3;
	                        case 3:
	                            _i++;
	                            return [3 /*break*/, 1];
	                        case 4: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderBorder = function (color, side, curvePoints) {
	            return __awaiter(this, void 0, void 0, function () {
	                return __generator(this, function (_a) {
	                    this.path(parsePathForBorder(curvePoints, side));
	                    this.ctx.fillStyle = asString(color);
	                    this.ctx.fill();
	                    return [2 /*return*/];
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
	            return __awaiter(this, void 0, void 0, function () {
	                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
	                var _this = this;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            this.applyEffects(paint.effects, 2 /* BACKGROUND_BORDERS */);
	                            styles = paint.container.styles;
	                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
	                            borders = [
	                                { style: styles.borderTopStyle, color: styles.borderTopColor },
	                                { style: styles.borderRightStyle, color: styles.borderRightColor },
	                                { style: styles.borderBottomStyle, color: styles.borderBottomColor },
	                                { style: styles.borderLeftStyle, color: styles.borderLeftColor }
	                            ];
	                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
	                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
	                            this.ctx.save();
	                            this.path(backgroundPaintingArea);
	                            this.ctx.clip();
	                            if (!isTransparent(styles.backgroundColor)) {
	                                this.ctx.fillStyle = asString(styles.backgroundColor);
	                                this.ctx.fill();
	                            }
	                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
	                        case 1:
	                            _a.sent();
	                            this.ctx.restore();
	                            styles.boxShadow
	                                .slice(0)
	                                .reverse()
	                                .forEach(function (shadow) {
	                                _this.ctx.save();
	                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
	                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
	                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
	                                if (shadow.inset) {
	                                    _this.path(borderBoxArea);
	                                    _this.ctx.clip();
	                                    _this.mask(shadowPaintingArea);
	                                }
	                                else {
	                                    _this.mask(borderBoxArea);
	                                    _this.ctx.clip();
	                                    _this.path(shadowPaintingArea);
	                                }
	                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
	                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
	                                _this.ctx.shadowColor = asString(shadow.color);
	                                _this.ctx.shadowBlur = shadow.blur.number;
	                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
	                                _this.ctx.fill();
	                                _this.ctx.restore();
	                            });
	                            _a.label = 2;
	                        case 2:
	                            side = 0;
	                            _i = 0, borders_1 = borders;
	                            _a.label = 3;
	                        case 3:
	                            if (!(_i < borders_1.length)) return [3 /*break*/, 6];
	                            border = borders_1[_i];
	                            if (!(border.style !== BORDER_STYLE.NONE && !isTransparent(border.color))) return [3 /*break*/, 5];
	                            return [4 /*yield*/, this.renderBorder(border.color, side++, paint.curves)];
	                        case 4:
	                            _a.sent();
	                            _a.label = 5;
	                        case 5:
	                            _i++;
	                            return [3 /*break*/, 3];
	                        case 6: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.render = function (element) {
	            return __awaiter(this, void 0, void 0, function () {
	                var stack;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            if (this.options.backgroundColor) {
	                                this.ctx.fillStyle = asString(this.options.backgroundColor);
	                                this.ctx.fillRect(this.options.x - this.options.scrollX, this.options.y - this.options.scrollY, this.options.width, this.options.height);
	                            }
	                            stack = parseStackingContexts(element);
	                            return [4 /*yield*/, this.renderStack(stack)];
	                        case 1:
	                            _a.sent();
	                            this.applyEffects([], 2 /* BACKGROUND_BORDERS */);
	                            return [2 /*return*/, this.canvas];
	                    }
	                });
	            });
	        };
	        return CanvasRenderer;
	    }());
	    var isTextInputElement = function (container) {
	        if (container instanceof TextareaElementContainer) {
	            return true;
	        }
	        else if (container instanceof SelectElementContainer) {
	            return true;
	        }
	        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
	            return true;
	        }
	        return false;
	    };
	    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
	        switch (clip) {
	            case BACKGROUND_CLIP.BORDER_BOX:
	                return calculateBorderBoxPath(curves);
	            case BACKGROUND_CLIP.CONTENT_BOX:
	                return calculateContentBoxPath(curves);
	            case BACKGROUND_CLIP.PADDING_BOX:
	            default:
	                return calculatePaddingBoxPath(curves);
	        }
	    };
	    var canvasTextAlign = function (textAlign) {
	        switch (textAlign) {
	            case TEXT_ALIGN.CENTER:
	                return 'center';
	            case TEXT_ALIGN.RIGHT:
	                return 'right';
	            case TEXT_ALIGN.LEFT:
	            default:
	                return 'left';
	        }
	    };
	
	    var ForeignObjectRenderer = /** @class */ (function () {
	        function ForeignObjectRenderer(options) {
	            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
	            this.ctx = this.canvas.getContext('2d');
	            this.options = options;
	            this.canvas.width = Math.floor(options.width * options.scale);
	            this.canvas.height = Math.floor(options.height * options.scale);
	            this.canvas.style.width = options.width + "px";
	            this.canvas.style.height = options.height + "px";
	            this.ctx.scale(this.options.scale, this.options.scale);
	            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
	            Logger.getInstance(options.id).debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
	        }
	        ForeignObjectRenderer.prototype.render = function (element) {
	            return __awaiter(this, void 0, void 0, function () {
	                var svg, img;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            svg = createForeignObjectSVG(Math.max(this.options.windowWidth, this.options.width) * this.options.scale, Math.max(this.options.windowHeight, this.options.height) * this.options.scale, this.options.scrollX * this.options.scale, this.options.scrollY * this.options.scale, element);
	                            return [4 /*yield*/, loadSerializedSVG$1(svg)];
	                        case 1:
	                            img = _a.sent();
	                            if (this.options.backgroundColor) {
	                                this.ctx.fillStyle = asString(this.options.backgroundColor);
	                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
	                            }
	                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
	                            return [2 /*return*/, this.canvas];
	                    }
	                });
	            });
	        };
	        return ForeignObjectRenderer;
	    }());
	    var loadSerializedSVG$1 = function (svg) {
	        return new Promise(function (resolve, reject) {
	            var img = new Image();
	            img.onload = function () {
	                resolve(img);
	            };
	            img.onerror = reject;
	            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
	        });
	    };
	
	    var _this = undefined;
	    var parseColor$1 = function (value) { return color.parse(Parser.create(value).parseComponentValue()); };
	    var html2canvas = function (element, options) {
	        if (options === void 0) { options = {}; }
	        return renderElement(element, options);
	    };
	    CacheStorage.setContext(window);
	    var renderElement = function (element, opts) { return __awaiter(_this, void 0, void 0, function () {
	        var ownerDocument, defaultView, instanceName, _a, width, height, left, top, defaultResourceOptions, resourceOptions, defaultOptions, options, windowBounds, documentCloner, clonedElement, container, documentBackgroundColor, bodyBackgroundColor, bgColor, defaultBackgroundColor, backgroundColor, renderOptions, canvas, renderer, root, renderer;
	        return __generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    ownerDocument = element.ownerDocument;
	                    if (!ownerDocument) {
	                        throw new Error("Element is not attached to a Document");
	                    }
	                    defaultView = ownerDocument.defaultView;
	                    if (!defaultView) {
	                        throw new Error("Document is not attached to a Window");
	                    }
	                    instanceName = (Math.round(Math.random() * 1000) + Date.now()).toString(16);
	                    _a = isBodyElement(element) || isHTMLElement(element) ? parseDocumentSize(ownerDocument) : parseBounds(element), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
	                    defaultResourceOptions = {
	                        allowTaint: false,
	                        imageTimeout: 15000,
	                        proxy: undefined,
	                        useCORS: false
	                    };
	                    resourceOptions = __assign({}, defaultResourceOptions, opts);
	                    defaultOptions = {
	                        backgroundColor: '#ffffff',
	                        cache: opts.cache ? opts.cache : CacheStorage.create(instanceName, resourceOptions),
	                        logging: true,
	                        removeContainer: true,
	                        foreignObjectRendering: false,
	                        scale: defaultView.devicePixelRatio || 1,
	                        windowWidth: defaultView.innerWidth,
	                        windowHeight: defaultView.innerHeight,
	                        scrollX: defaultView.pageXOffset,
	                        scrollY: defaultView.pageYOffset,
	                        x: left,
	                        y: top,
	                        width: Math.ceil(width),
	                        height: Math.ceil(height),
	                        id: instanceName
	                    };
	                    options = __assign({}, defaultOptions, resourceOptions, opts);
	                    windowBounds = new Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);
	                    Logger.create(instanceName);
	                    Logger.getInstance(instanceName).debug("Starting document clone");
	                    documentCloner = new DocumentCloner(element, {
	                        id: instanceName,
	                        onclone: options.onclone,
	                        ignoreElements: options.ignoreElements,
	                        inlineImages: options.foreignObjectRendering,
	                        copyStyles: options.foreignObjectRendering
	                    });
	                    clonedElement = documentCloner.clonedReferenceElement;
	                    if (!clonedElement) {
	                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
	                    }
	                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
	                case 1:
	                    container = _b.sent();
	                    documentBackgroundColor = ownerDocument.documentElement
	                        ? parseColor$1(getComputedStyle(ownerDocument.documentElement).backgroundColor)
	                        : COLORS.TRANSPARENT;
	                    bodyBackgroundColor = ownerDocument.body
	                        ? parseColor$1(getComputedStyle(ownerDocument.body).backgroundColor)
	                        : COLORS.TRANSPARENT;
	                    bgColor = opts.backgroundColor;
	                    defaultBackgroundColor = typeof bgColor === 'string' ? parseColor$1(bgColor) : 0xffffffff;
	                    backgroundColor = element === ownerDocument.documentElement
	                        ? isTransparent(documentBackgroundColor)
	                            ? isTransparent(bodyBackgroundColor)
	                                ? defaultBackgroundColor
	                                : bodyBackgroundColor
	                            : documentBackgroundColor
	                        : defaultBackgroundColor;
	                    renderOptions = {
	                        id: instanceName,
	                        cache: options.cache,
	                        backgroundColor: backgroundColor,
	                        scale: options.scale,
	                        x: options.x,
	                        y: options.y,
	                        scrollX: options.scrollX,
	                        scrollY: options.scrollY,
	                        width: options.width,
	                        height: options.height,
	                        windowWidth: options.windowWidth,
	                        windowHeight: options.windowHeight
	                    };
	                    if (!options.foreignObjectRendering) return [3 /*break*/, 3];
	                    Logger.getInstance(instanceName).debug("Document cloned, using foreign object rendering");
	                    renderer = new ForeignObjectRenderer(renderOptions);
	                    return [4 /*yield*/, renderer.render(clonedElement)];
	                case 2:
	                    canvas = _b.sent();
	                    return [3 /*break*/, 5];
	                case 3:
	                    Logger.getInstance(instanceName).debug("Document cloned, using computed rendering");
	                    CacheStorage.attachInstance(options.cache);
	                    Logger.getInstance(instanceName).debug("Starting DOM parsing");
	                    root = parseTree(clonedElement);
	                    CacheStorage.detachInstance();
	                    if (backgroundColor === root.styles.backgroundColor) {
	                        root.styles.backgroundColor = COLORS.TRANSPARENT;
	                    }
	                    Logger.getInstance(instanceName).debug("Starting renderer");
	                    renderer = new CanvasRenderer(renderOptions);
	                    return [4 /*yield*/, renderer.render(root)];
	                case 4:
	                    canvas = _b.sent();
	                    _b.label = 5;
	                case 5:
	                    if (options.removeContainer === true) {
	                        if (!cleanContainer(container)) {
	                            Logger.getInstance(instanceName).error("Cannot detach cloned iframe as it is not in the DOM anymore");
	                        }
	                    }
	                    Logger.getInstance(instanceName).debug("Finished rendering");
	                    Logger.destroy(instanceName);
	                    CacheStorage.destroy(instanceName);
	                    return [2 /*return*/, canvas];
	            }
	        });
	    }); };
	    var cleanContainer = function (container) {
	        if (container.parentNode) {
	            container.parentNode.removeChild(container);
	            return true;
	        }
	        return false;
	    };
	
	    return html2canvas;
	
	}));
	//# sourceMappingURL=html2canvas.js.map


/***/ }),
/* 755 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DownloadDialogController = exports.DownloadDialogController = ["$scope", "$mdDialog", "callback", function DownloadDialogController($scope, $mdDialog, callback) {
	    "ngInject";
	
	    $scope.callback = callback;
	    $scope.downloadObj = {
	        captureModes: {
	            photo: true,
	            gif: true,
	            boomerang: true,
	            video: true
	        },
	        conditions: {
	            dataPrivacyPopupAccepted: false,
	            consentScreenConfirmed: false,
	            dataFormWasSigned: false,
	            checkboxConditions: [{
	                position: 1,
	                checked: false
	            }, {
	                position: 2,
	                checked: false
	            }, {
	                position: 3,
	                checked: false
	            }, {
	                position: 4,
	                checked: false
	            }, {
	                position: 5,
	                checked: false
	            }]
	        }
	    };
	
	    $scope.closeDialog = function () {
	        document.onkeypress = function () {};
	        $mdDialog.hide();
	    };
	
	    $scope.create = function () {
	        callback($scope.downloadObj);
	        document.onkeypress = function () {};
	        $mdDialog.hide();
	    };
	
	    $scope.checkOptions = function (option) {
	        if (option === "photo") {
	            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.boomerang && !$scope.downloadObj.captureModes.video) {
	                $scope.downloadObj.captureModes.photo = true;
	            }
	        }
	
	        if (option === "gif") {
	            if (!$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.boomerang && !$scope.downloadObj.captureModes.video) {
	                $scope.downloadObj.captureModes.gif = true;
	            }
	        }
	
	        if (option === "boomerang") {
	            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.video) {
	                $scope.downloadObj.captureModes.boomerang = true;
	            }
	        }
	
	        if (option === "video") {
	            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.boomerang) {
	                $scope.downloadObj.captureModes.video = true;
	            }
	        }
	    };
	
	    document.onkeypress = function (ev) {
	        if (ev.key === "Enter") {
	            $scope.create();
	        }
	    };
	}];

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Download xls\">\n    <md-dialog-content style=\"overflow: hidden; width: 600px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\">{{'Download XLS File' | translate}}</h2>\n            <form name=\"xlsDownloadForm\">\n                <h4>Select capture modes:</h4>\n                <md-switch\n                        md-invert\n                        ng-change=\"checkOptions('photo')\"\n                        ng-model=\"downloadObj.captureModes.photo\">\n                    {{'Single photo' | translate}}\n                </md-switch>\n                <md-switch\n                        md-invert\n                        ng-change=\"checkOptions('gif')\"\n                        ng-model=\"downloadObj.captureModes.gif\">\n                    {{'Gif' | translate}}\n                </md-switch>\n                <md-switch\n                        md-invert\n                        ng-change=\"checkOptions('boomerang')\"\n                        ng-model=\"downloadObj.captureModes.boomerang\">\n                    {{'Boomerang' | translate}}\n                </md-switch>\n                <md-switch\n                        md-invert\n                        ng-change=\"checkOptions('video')\"\n                        ng-model=\"downloadObj.captureModes.video\">\n                    {{'Video' | translate}}\n                </md-switch>\n                <h4>Data forms:</h4>\n                <md-switch\n                        md-invert\n                        ng-model=\"downloadObj.conditions.dataFormWasSigned\">\n                    {{'Only if a data form was signed' | translate}}\n                </md-switch>\n            </form>\n        </div>\n\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"create()\"\n                class=\"md-primary\">{{'Download' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>\n";

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ReportSettingsDialogController = undefined;
	
	var _lodash = __webpack_require__(101);
	
	__webpack_require__(758);
	
	var ReportSettingsDialogController = exports.ReportSettingsDialogController = ["$scope", "$mdDialog", "reportSettings", "callback", function ReportSettingsDialogController($scope, $mdDialog, reportSettings, callback) {
	    "ngInject";
	
	    $scope.callback = callback;
	    $scope.reportSettings = (0, _lodash.cloneDeep)(reportSettings);
	
	    $scope.saveSettings = function () {
	        $scope.callback($scope.reportSettings);
	        $scope.closeDialog();
	    };
	
	    $scope.changeRelatedToggles = function (toggle, value) {
	        switch (toggle) {
	            case "Photo System":
	                $scope.reportSettings.sessions = value;
	                $scope.reportSettings.photo = value;
	                $scope.reportSettings.gif = value;
	                $scope.reportSettings.boomerang = value;
	                $scope.reportSettings.video = value;
	                $scope.reportSettings.emails = value;
	                $scope.reportSettings.delivered = value;
	                $scope.reportSettings.opens = value;
	                $scope.reportSettings.clicks = value;
	                $scope.reportSettings.messages = value;
	                $scope.reportSettings.prints = value;
	                $scope.reportSettings.qr_code_scans = value;
	                break;
	            case "Sessions":
	                $scope.reportSettings.photo = value;
	                $scope.reportSettings.gif = value;
	                $scope.reportSettings.boomerang = value;
	                $scope.reportSettings.video = value;
	                value ? $scope.reportSettings.photo_system = true : $scope.isPhotoSystemTogglesActive();
	                break;
	            case "Emails":
	                $scope.reportSettings.delivered = value;
	                $scope.reportSettings.opens = value;
	                $scope.reportSettings.clicks = value;
	                value ? $scope.reportSettings.photo_system = true : $scope.isPhotoSystemTogglesActive();
	                break;
	            case "Live Gallery":
	                $scope.reportSettings.views = value;
	                $scope.reportSettings.avg_visit_time = value;
	                $scope.reportSettings.downloads = value;
	                $scope.reportSettings.whats_app = value;
	                $scope.reportSettings.facebook = value;
	                $scope.reportSettings.instagram = value;
	                $scope.reportSettings.tiktok = value;
	                $scope.reportSettings.mesenger = value;
	                $scope.reportSettings.email = value;
	                $scope.reportSettings.twitter = value;
	                break;
	        }
	    };
	
	    $scope.isGalleryTogglesActive = function () {
	        if (!$scope.reportSettings.views && !$scope.reportSettings.avg_visit_time && !$scope.reportSettings.downloads && !$scope.reportSettings.whats_app && !$scope.reportSettings.facebook && !$scope.reportSettings.instagram && !$scope.reportSettings.tiktok && !$scope.reportSettings.mesenger && !$scope.reportSettings.email && !$scope.reportSettings.twitter) {
	            $scope.reportSettings.live_gallery = false;
	        }
	    };
	
	    $scope.isPhotoSystemTogglesActive = function () {
	        if (!$scope.reportSettings.sessions && !$scope.reportSettings.photo && !$scope.reportSettings.gif && !$scope.reportSettings.emails && !$scope.reportSettings.delivered && !$scope.reportSettings.opens && !$scope.reportSettings.clicks && !$scope.reportSettings.messages && !$scope.reportSettings.prints && !$scope.reportSettings.qr_code_scans) {
	            $scope.reportSettings.photo_system = false;
	        }
	    };
	
	    $scope.setSessionsActive = function () {
	        if ($scope.reportSettings.photo || $scope.reportSettings.gif || $scope.reportSettings.emails) {
	            $scope.reportSettings.photo_system = true;
	            $scope.reportSettings.sessions = true;
	        }
	    };
	
	    $scope.setEmailActive = function () {
	        if ($scope.reportSettings.delivered || $scope.reportSettings.opens || $scope.reportSettings.clicks) {
	            $scope.reportSettings.photo_system = true;
	            $scope.reportSettings.emails = true;
	        }
	    };
	
	    $scope.closeDialog = function () {
	        document.onkeypress = function () {};
	        $mdDialog.hide();
	    };
	
	    document.onkeypress = function (ev) {
	        if (ev.key === "Enter") {
	            $scope.create();
	        }
	    };
	}];

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(759);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./report-settings-dialog.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./report-settings-dialog.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, ".report-settings .md-dialog-content{padding:10px 30px}.report-settings .md-dialog-content .dialog-title{padding:0 150px}.report-settings .md-dialog-content .dialog-title i{font-size:28px}.report-settings .md-dialog-content .dialog-title h2{font-size:18px;margin:5px 10px;font-weight:700}.report-settings .md-dialog-content .settings-form{margin:30px 0 20px;color:#828282}.report-settings .md-dialog-content .settings-form p{font-size:20px;margin-bottom:10px}.report-settings .md-dialog-content .settings-form span{font-size:13px}.report-settings .md-dialog-content .switches-holder{width:500px}.report-settings .md-dialog-content .switches-holder .main-switch{height:30px;margin:8px 0 0}.report-settings .md-dialog-content .switches-holder .main-switch .md-label{font-weight:700;color:#000}.report-settings .md-dialog-content .switches-holder .sub-switch .md-label{padding-left:22px;font-size:13px}.report-settings .md-dialog-content .switches-holder md-switch{margin:0 35px;height:22px}.report-settings .md-dialog-content .switches-holder md-switch .md-container{height:16px;width:30px;margin:0}.report-settings .md-dialog-content .switches-holder md-switch .md-bar{width:20px;height:7px}.report-settings .md-dialog-content .switches-holder md-switch .md-thumb-container{width:13px}.report-settings .md-dialog-content .switches-holder md-switch .md-thumb{top:1px;width:10px;height:10px}.report-settings .md-dialog-content .switches-holder md-switch .md-label{padding-left:5px;font-size:14px;color:#646464}", ""]);
	
	// exports


/***/ }),
/* 760 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Report Settings\" class=\"report-settings\">\n    <md-dialog-content style=\"overflow: hidden; width: 470px;\">\n        <div class=\"md-dialog-content\">\n            <div class=\"dialog-title\" layout=\"row\">\n                <i class=\"material-icons\">\n                    tune\n                </i>\n                <h2 class=\"md-title\">{{'Settings' | translate}}</h2>\n            </div>\n            <form name=\"reportSettingsForm\">\n                <div class=\"settings-form\" >\n                    <p>{{'General report Settings' | translate}}</p>\n                    <span>{{\"Select the KPIs you want to show in your deployment's report.\" | translate}}</span>\n                </div>\n                <div class=\"switches-holder\" layout=\"row\">\n                    <div style=\"margin-right: 10px\">\n                        <md-switch\n                                class=\"main-switch\"\n                                ng-model=\"reportSettings.unique\">\n                            {{'Unique KPIs' | translate}}\n                        </md-switch>\n                        <md-switch\n                                class=\"main-switch\"\n                                ng-change=\"changeRelatedToggles('Photo System', reportSettings.photo_system)\"\n                                ng-model=\"reportSettings.photo_system\">\n                            {{'Photo System' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"changeRelatedToggles('Sessions', reportSettings.sessions)\"\n                                ng-model=\"reportSettings.sessions\">\n                            {{'Sessions' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.photo ? setSessionsActive() : isPhotoSystemTogglesActive()\"\n                                class=\"sub-switch\"\n                                ng-model=\"reportSettings.photo\">\n                            {{'Photo' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.gif ? setSessionsActive() : isPhotoSystemTogglesActive()\"\n                                class=\"sub-switch\"\n                                ng-model=\"reportSettings.gif\">\n                            {{'GIF' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.boomerang ? setSessionsActive() : isPhotoSystemTogglesActive()\"\n                                class=\"sub-switch\"\n                                ng-model=\"reportSettings.boomerang\">\n                            {{'Boomerang' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.video ? setSessionsActive() : isPhotoSystemTogglesActive()\"\n                                class=\"sub-switch\"\n                                ng-model=\"reportSettings.video\">\n                            {{'Video' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"changeRelatedToggles('Emails', reportSettings.emails)\"\n                                ng-model=\"reportSettings.emails\">\n                            {{'Emails' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.delivered ? setEmailActive() : isPhotoSystemTogglesActive()\"\n                                class=\"sub-switch\"\n                                ng-model=\"reportSettings.delivered\">\n                            {{'Delivered' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.opens ? setEmailActive() : isPhotoSystemTogglesActive()\"\n                                class=\"sub-switch\"\n                                ng-model=\"reportSettings.opens\">\n                            {{'Opens' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.clicks ? setEmailActive() : isPhotoSystemTogglesActive()\"\n                                class=\"sub-switch\"\n                                ng-model=\"reportSettings.clicks\">\n                            {{'Clicks' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.messages ? reportSettings.photo_system = true : isPhotoSystemTogglesActive()\"\n                                ng-model=\"reportSettings.messages\">\n                            {{'SMS' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.prints ? reportSettings.photo_system = true : isPhotoSystemTogglesActive()\"\n                                ng-model=\"reportSettings.prints\">\n                            {{'Prints' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.qr_code_scans ? reportSettings.photo_system = true : isPhotoSystemTogglesActive()\"\n                                ng-model=\"reportSettings.qr_code_scans\">\n                            {{'QR Code Scans' | translate}}\n                        </md-switch>\n                    </div>\n                    <div>\n                        <md-switch\n                                ng-change=\"changeRelatedToggles('Live Gallery', reportSettings.live_gallery)\"\n                                class=\"main-switch\"\n                                ng-model=\"reportSettings.live_gallery\">\n                            {{'Live Gallery' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.views ? reportSettings.live_gallery = true : isGalleryTogglesActive()\"\n                                ng-model=\"reportSettings.views\">\n                            {{'Views ' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.avg_visit_time ? reportSettings.live_gallery = true : isGalleryTogglesActive()\"\n                                ng-model=\"reportSettings.avg_visit_time\">\n                            {{'Ø Visit duration (s)' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.downloads ? reportSettings.live_gallery = true : isGalleryTogglesActive()\"\n                                ng-model=\"reportSettings.downloads\">\n                            {{'Downloads' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.whats_app ? reportSettings.live_gallery = true : isGalleryTogglesActive()\"\n                                ng-model=\"reportSettings.whats_app\">\n                            {{'WhatsApp' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.facebook ? reportSettings.live_gallery = true : isGalleryTogglesActive()\"\n                                ng-model=\"reportSettings.facebook\">\n                            {{'Facebook' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.instagram ? reportSettings.live_gallery = true : isGalleryTogglesActive()\"\n                                ng-model=\"reportSettings.instagram\">\n                            {{'Instagram' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.tiktok ? reportSettings.live_gallery = true : isGalleryTogglesActive()\"\n                                ng-model=\"reportSettings.tiktok\">\n                            {{'Tiktok' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.mesenger ? reportSettings.live_gallery = true : isGalleryTogglesActive()\"\n                                ng-model=\"reportSettings.mesenger\">\n                            {{'Messenger' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.email ? reportSettings.live_gallery = true : isGalleryTogglesActive()\"\n                                ng-model=\"reportSettings.email\">\n                            {{'Email' | translate}}\n                        </md-switch>\n                        <md-switch\n                                ng-change=\"reportSettings.twitter ? reportSettings.live_gallery = true : isGalleryTogglesActive()\"\n                                ng-model=\"reportSettings.twitter\">\n                            {{'Twitter' | translate}}\n                        </md-switch>\n<!--                        <md-switch-->\n<!--                                ng-model=\"reportSettings.show_custom_kpis\">-->\n<!--                            {{'Custom KPIs' | translate}}-->\n<!--                        </md-switch>-->\n                    </div>\n                </div>\n\n\n<!--                <h4>Select capture modes:</h4>-->\n<!--                <md-switch-->\n<!--                        md-invert-->\n<!--                        ng-change=\"checkOptions('photo')\"-->\n<!--                        ng-model=\"downloadObj.captureModes.photo\">-->\n<!--                    {{'Single photo' | translate}}-->\n<!--                </md-switch>-->\n<!--                <md-switch-->\n<!--                        md-invert-->\n<!--                        ng-change=\"checkOptions('gif')\"-->\n<!--                        ng-model=\"downloadObj.captureModes.gif\">-->\n<!--                    {{'Gif' | translate}}-->\n<!--                </md-switch>-->\n<!--                <md-switch-->\n<!--                        md-invert-->\n<!--                        ng-change=\"checkOptions('boomerang')\"-->\n<!--                        ng-model=\"downloadObj.captureModes.boomerang\">-->\n<!--                    {{'Boomerang' | translate}}-->\n<!--                </md-switch>-->\n<!--                <h4>Conditions for sync</h4>-->\n<!--                &lt;!&ndash;                <md-switch&ndash;&gt;-->\n<!--                &lt;!&ndash;                        md-invert&ndash;&gt;-->\n<!--                &lt;!&ndash;                        ng-model=\"downloadObj.conditions.dataPrivacyPopupAccepted\">&ndash;&gt;-->\n<!--                &lt;!&ndash;                    {{'Only when data privacy pop-up was accepted' | translate}}&ndash;&gt;-->\n<!--                &lt;!&ndash;                </md-switch>&ndash;&gt;-->\n<!--                &lt;!&ndash;                <md-switch&ndash;&gt;-->\n<!--                &lt;!&ndash;                        md-invert&ndash;&gt;-->\n<!--                &lt;!&ndash;                        ng-model=\"downloadObj.conditions.consentScreenConfirmed\">&ndash;&gt;-->\n<!--                &lt;!&ndash;                    {{'Only if user consent screen was confirmed with “yes”' | translate}}&ndash;&gt;-->\n<!--                &lt;!&ndash;                </md-switch>&ndash;&gt;-->\n<!--                <md-switch-->\n<!--                        md-invert-->\n<!--                        ng-model=\"downloadObj.conditions.dataFormSigned\">-->\n<!--                    {{'Only if data forms were signed & submitted' | translate}}-->\n<!--                </md-switch>-->\n<!--                <md-switch-->\n<!--                        md-invert-->\n<!--                        ng-model=\"downloadObj.conditions.allCheckboxesChecked\">-->\n<!--                    {{'Only if all checkboxes from data forms were checked' | translate}}-->\n<!--                </md-switch>-->\n            </form>\n        </div>\n\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"saveSettings()\"\n                class=\"md-primary\">{{'SAVE' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>\n";

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/facebook-old.svg";

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/twitter.svg";

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/whatsapp.svg";

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/table_chart.svg";

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/TikTok.svg";

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/Instagram.svg";

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(768);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./analytics-detail.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./analytics-detail.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "#analytic{background-color:#fafafa}.header-info{display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative}.header-info .main-info{text-align:center;font-size:17px;font-weight:700;margin:10px 10px 15px}.header-info .main-info i{margin-left:-30px;font-size:36px}.header-info .main-info span{vertical-align:super}.header-info .data-ranges{font-size:11px;margin:0 0 15px;text-align:center}.header-info .data-ranges i{position:relative;cursor:pointer;color:gray;top:6px}.header-info .date-container{height:30px;margin:0 0 20px;display:flex;font-size:13px}.header-info .date-container span.divider{display:block;margin:14px 8px}.header-info .date-container input{width:130px}.header-info .date-container .dtp-clear{display:none}.header-info .export-block{right:110px;min-width:145px;position:absolute;top:25px;text-align:center;font-size:12px}.header-info .export-block .export-menu{box-shadow:0 2px 5px -1px rgba(0,0,0,.21)}.header-info .export-block .export-menu .export-item{cursor:pointer;height:20px;line-height:20px;outline:none}.header-info .export-block .export-menu .export-item i{vertical-align:middle;font-size:15px}.header-info .export-block .export-menu .export-item strong{font-size:10px;margin-left:3px}.header-info .export-block .export-menu .export-item span{font-size:10px}.header-info .export-block .export-menu .export-item:hover{transition:.3s;background:rgba(238,39,55,.2)}.header-info .export-block .export-menu .export-item:nth-child(2) img{margin-left:-2px;vertical-align:top;height:15px;width:15px}.header-info .export-block .export-menu .export-item:nth-child(2) strong{margin-left:4px;vertical-align:super}.header-info .export-block .export-menu .export-item:nth-child(2) span{vertical-align:super}.header-info .export-block .export-btn{box-shadow:none;margin:6px 0 0;min-height:24px;width:100%;line-height:20px;font-size:12px;font-weight:700}.header-info .export-block .export-btn i{font-size:20px;color:#fff;position:relative;line-height:12px;top:5px;left:-4px}.header-info .export-block .export-btn span{line-height:20px}.header-info .download-btn{box-shadow:none!important;min-height:24px;font-size:12px;padding:0 30px;font-weight:700;line-height:20px;width:auto;position:absolute;top:25px;right:57px}.header-info .download-btn.settings{right:267px}.header-info .download-btn i{font-size:20px;color:#fff;position:relative;line-height:12px;top:5px;left:-6px}.header-info .download-btn span{line-height:20px}#pdf-logo{display:none;flex-direction:column;color:#fff;background:#ee2737;margin-bottom:80px}#pdf-logo,#pdf-logo .logo-container{align-items:center;justify-content:center}#pdf-logo .logo-container{height:85px;display:flex}#pdf-logo .logo-container img{width:220px;position:relative;top:25px}#pdf-logo .main-info{font-size:22px;font-weight:700;margin:8px 0 20px}#pdf-logo .data-ranges{font-size:12px;margin:0 0 50px}#pdf-logo .divider-pdf{height:12px;width:100%;margin-top:50px;background:linear-gradient(45deg,#fe753a,#ee2737 100%,#fe8036 0)}#footer-pdf{display:none;background:#fafafa;border-top:1px solid #000;color:#000;margin:185px 50px 0;font-size:14px}#footer-pdf .footer-cont{height:130px;display:flex;align-items:center;justify-content:flex-start}#footer-pdf .footer-cont .spacer{width:10px}#footer-pdf .footer-cont .info{margin:0 30px 10px 10px}.tb-cont{display:flex;justify-content:space-around}.tb-cont .tb-main{flex:4;justify-content:center;margin:0 -1px 0 60px}.tb-cont .tb-main .left-titles{text-align:right;display:flex;flex-flow:column;padding-right:5px;margin-top:184px}.tb-cont .tb-main .left-titles strong{font-size:15px;margin:10px 0}.tb-cont .tb-side{flex:1;margin:0 60px 0 -1px}.tb-cont .analytics-block{display:flex;flex-flow:row;color:#fff;margin-right:110px;background:#fafafa}.tb-cont .analytics-block .analytics-block-item{width:fit-content}.tb-cont .analytics-block .analytics-block-head{text-align:center;font-size:17px;padding:10px 0;margin-left:3px;background-color:#000}.tb-cont .analytics-block .analytics-block-head p{margin:0}.tb-cont .analytics-block .analytics-data{background:#fafafa;border-top:3px solid #fafafa;border-left:3px solid #fafafa}.tb-cont .analytics-block .analytics-data .analytics-data-head{display:flex;height:34px;justify-content:center;background:#000;margin-bottom:3px}.tb-cont .analytics-block .analytics-data .analytics-data-head img{height:22px;margin-top:5px}.tb-cont .analytics-block .analytics-data .analytics-data-head i{line-height:34px}.tb-cont .analytics-block .analytics-data .sub{width:20px;margin-right:3px}.tb-cont .analytics-block .analytics-data .sub:last-child{margin:0}.tb-cont .analytics-block .analytics-data .sub p{line-height:47px!important}.tb-cont .analytics-block .analytics-data .analytics-data-item{display:flex;flex-flow:column;min-width:40px;background:#000;color:#fff}.tb-cont .analytics-block .analytics-data .analytics-data-item h5{max-width:120px;min-width:65px;margin:0;padding:40px 0;text-align:center;height:20px;line-height:16px;font-size:12px;width:5.5vw;background-color:#000}.tb-cont .analytics-block .analytics-data .analytics-data-item p{margin:35px 0 36px -35px;padding:2px 5px;font-size:12px;line-height:22px;width:89px;height:25px;text-align:center;transform:rotate(270deg);background-color:#000}.tb-cont .analytics-block .analytics-data .analytics-data-item:first-child p{font-weight:700}.tb-cont .analytics-block .analytics-data .analytics-data-item:last-child{border:none}.tb-cont .analytics-block .analytics-data .analytics-data-item span{border-top:3px solid #fafafa;color:#000;line-height:40px;font-size:13px;background-color:#ededee;text-align:center}.tb-cont .charts-container{display:flex;justify-content:center;flex-flow:row;margin-top:20px;text-align:center}.tb-cont .charts-container .ch-holder{max-width:450px}.tb-cont .charts-container .ch-holder .pie-title{font-family:HKNova-ExtraBold;margin-top:54px;margin-bottom:-64px;text-align:center;z-index:1}.tb-cont .charts-container .ch-holder img{margin:25px auto;height:300px}", ""]);
	
	// exports


/***/ }),
/* 769 */
/***/ (function(module, exports) {

	"use strict";
	
	Router.$inject = ["$stateProvider", "$urlRouterProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Router;
	function Router($stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $urlRouterProvider.when("/app/analytics", "/app/analytics/");
	
	    $stateProvider.state({
	        name: "analytics",
	        url: "/app/analytics/",
	        template: "<analytics></analytics>"
	    }).state({
	        name: "analyticsDetail",
	        url: "/app/analytics/:id",
	        template: "<analytics-detail></analytics-detail>"
	    });
	}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MediaModule = undefined;
	
	var _media = __webpack_require__(771);
	
	var _media2 = _interopRequireDefault(_media);
	
	var _media3 = __webpack_require__(780);
	
	var _media4 = _interopRequireDefault(_media3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaModule = exports.MediaModule = angular.module("media", []).component("media", _media2.default).config(_media4.default);

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _media = __webpack_require__(772);
	
	var _media2 = _interopRequireDefault(_media);
	
	var _media3 = __webpack_require__(773);
	
	var _media4 = _interopRequireDefault(_media3);
	
	__webpack_require__(778);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaComponent = {
	    template: _media2.default,
	    controller: _media4.default,
	    controllerAs: "media"
	};
	
	exports.default = MediaComponent;

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	module.exports = "<md-content layout=\"column\" flex layout-align=\"top center\">\n    <md-card>\n        <md-toolbar class=\"md-table-toolbar md-default\" ng-hide=\"options.rowSelection && selected.length\">\n            <div class=\"md-toolbar-tools\">\n                <span>Media</span>\n                <div flex></div>\n                <div flex=\"70\" class=\"md-toolbar-tools md-toolbar-search\" ng-if=\"filter.show\" layout-align=\"center right\">\n                    <md-input-container md-no-float flex layout-align=\"center right\">\n                        <input ng-blur=\"media.onSearchBlur()\" type=\"text\" id=\"search-field\" placeholder=\"Search in the Deployments\" ng-model=\"query.search\" ng-model-options=\"filter.options\" class=\"ng-pristine ng-valid ng-touched\" autofocus>\n                    </md-input-container>\n                    <button class=\"md-icon-button md-button md-ink-ripple\" type=\"button\" ng-click=\"media.removeFilter()\" layout-align=\"center right\">\n                        <md-icon class=\"material-icons\">search</md-icon>\n                        <div class=\"md-ripple-container\"></div>\n                    </button>\n                </div>\n                <md-button class=\"md-icon-button md-button md-ink-ripple\" ng-click=\"media.showFilter()\" ng-if=\"!filter.show\" ng-show=\"deployments._meta.count\">\n                    <md-icon class=\"material-icons\">search</md-icon>\n                    <div class=\"md-ripple-container\"></div>\n                </md-button>\n            </div>\n        </md-toolbar>\n\n        <md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"options.rowSelection && selected.length\">\n            <div class=\"md-toolbar-tools\">\n                <span>{{selected.length}} {{selected.length > 1 ? 'items' : 'item'}} selected</span>\n            </div>\n        </md-toolbar>\n\n        <md-table-container ng-if=\"! deployments._meta.count\" class=\"no-items\">\n            <div ng-if=\"loading\" translate>Loading deployments...</div>\n            <div ng-if=\"!loading && !filter.show\" translate>You have no deployments available.</div>\n            <div ng-if=\"!loading && filter.show\" translate>No results found for: '{{ query.search }}'.</div>\n        </md-table-container>\n\n        <md-table-container ng-if=\"deployments._meta.count\">\n            <table md-table md-row-select=\"options.rowSelection\" multiple=\"{{options.multiSelect}}\" ng-model=\"selected\" md-progress=\"promise\">\n                <thead ng-if=\"!options.decapitate\" md-head md-order=\"query.order\" md-on-reorder=\"logOrder\">\n                <tr md-row>\n                    <th md-column md-order-by=\"_name\"><span>{{'Deployment Name' | translate}}</span></th>\n                    <th md-column md-order-by=\"_company__name\" ng-hide=\"media.isClient()\"><span>{{'Client Name' | translate}}</span></th>\n                    <th md-column md-order-by=\"_logistics_type\" ng-hide=\"media.isClient()\"><span>{{'Deployment type' | translate}}</span></th>\n                    <th md-column md-order-by=\"_location_city\" ng-hide=\"media.isClient()\"><span>{{'Deployment Location' | translate}}</span></th>\n                    <th md-column md-order-by=\"_deployment_start\"><span>{{'Start Date' | translate}}</span></th>\n                    <th md-column md-order-by=\"_deployment_end\"><span>{{'End Date' | translate}}</span></th>\n                    <th md-column></th>\n                </tr>\n                </thead>\n                <tbody md-body>\n                <tr md-row md-select=\"deployment\" md-on-select=\"logItem\" md-auto-select=\"options.autoSelect\" class=\"md-row\"\n                    ng-repeat=\"item in deployments | filter: filter.search | orderBy: query.order | limitTo: query.limit : (query.page -1) * query.limit\"\n                    ui-sref=\"mediaDetail({id: (item.url | getObjectId)})\">\n                    <td md-cell class=\"underline-on-hover show-button-on-hover\" style=\"min-width: 150px\">{{item.name}}\n                    </td>\n                    <td md-cell ng-hide=\"media.isClient()\">\n                        <span> {{item.company_info.name}}\n                        </span>\n                    </td>\n\n                    <td md-cell ng-hide=\"media.isClient()\">\n                        <span ng-bind=\"item.logistics_type | getObjectByKey:media.logisticsType\"></span>\n                    </td>\n\n                    <!-- deployment location -->\n                    <td md-cell ng-hide=\"media.isClient()\">\n                        <span ng-bind=\"item.location_address.city\"></span>\n                    </td>\n\n                    <!-- start date -->\n                    <td md-cell>\n                        <span ng-bind=\"item.deployment_start | defaultDateFormatDays\"></span>\n                    </td>\n\n                    <!-- end date -->\n                    <td md-cell>\n                        <span ng-bind=\"item.deployment_end | defaultDateFormatDays\"></span>\n                    </td>\n                    <td md-cell layout=\"row\" layout-align=\"center end\">\n                        <span flex></span>\n                        <md-menu md-position-mode=\"target-right target\">\n                            <md-button aria-label=\"Menu options\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                                <md-icon class=\"material-icons\">more_vert</md-icon>\n                            </md-button>\n                            <md-menu-content width=\"1\" >\n                                <md-menu-item>\n                                    <md-button ng-click=\"media.getListOfOptions(item.url | getObjectId, item)\">\n                                        <div layout=\"row\" flex>\n                                            <p flex translate>Download all files as ZIP</p>\n                                            <md-icon class=\"material-icons\" style=\"margin: auto 3px auto 0;\">cloud_download</md-icon>\n                                        </div>\n                                    </md-button>\n                                </md-menu-item>\n                            </md-menu-content>\n                        </md-menu>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <button md-button ng-if=\"canAddMore && !loading\" ng-click=\"media.addMoreItems()\" style=\"color: #FF0051\">Load more</button>\n    </md-card>\n</md-content>\n\n\n\n\n";

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(239);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _index = __webpack_require__(183);
	
	var _lodash = __webpack_require__(101);
	
	var _mediaDownload = __webpack_require__(774);
	
	var _mediaDownload2 = __webpack_require__(775);
	
	var _mediaDownload3 = _interopRequireDefault(_mediaDownload2);
	
	var _downloadDialog = __webpack_require__(776);
	
	var _downloadDialog2 = __webpack_require__(777);
	
	var _downloadDialog3 = _interopRequireDefault(_downloadDialog2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependencies = ["$Forms", "$companies", "$Booth", "$service", "$Deployment", "$Company"];
	
	var MediaController = function (_$controller) {
	    MediaController.$inject = ["$injector", "$stateParams", "$scope", "$element", "$q", "$timeout", "$auth"];
	    (0, _inherits3.default)(MediaController, _$controller);
	
	    function MediaController($injector, $stateParams, $scope, $element, $q, $timeout, $auth) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, MediaController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (MediaController.__proto__ || (0, _getPrototypeOf2.default)(MediaController)).call(this, $injector, dependencies));
	
	        _this.$scope = $scope;
	        _this.$stateParams = $stateParams;
	        _this.$element = $element;
	        _this.$auth = $auth;
	        _this.$scope.loading = true;
	        _this.$scope.query = { page: 1, search: "" };
	        _this.$scope.filter = {};
	        _this.$scope.deployments = [];
	        _this.$scope.pageCount = 0;
	        _this.$scope.canAddMore = true;
	        _this.$q = $q;
	        _this.$timeout = $timeout;
	        _this.$scope.logOrder = function () {
	            _this.$scope.query.ordering = _this.$scope.query.order.replace("_", "");
	            _this.query(true);
	        };
	        _this.logisticsType = {
	            "by_upreach": "By UpReach",
	            "by_client": "By Client"
	        };
	
	        _this.searchByKeyPress = function (event) {
	            var keyName = event.key;
	            var letters = "abcdefghijklmnopqrstuvwxyz";
	            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
	                _this.$scope.$apply(function () {
	                    _this.$scope.filter.show = true;
	                    if (!_this.$scope.query.search) {
	                        _this.$scope.query.search = keyName;
	                    }
	                });
	                (0, _lodash.delay)(function () {
	                    document.getElementById("search-field").focus();
	                }, 100);
	            }
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(MediaController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.$scope.filter.show = false;
	            this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
	            document.addEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "$onDestroy",
	        value: function $onDestroy() {
	            document.removeEventListener("keypress", this.searchByKeyPress);
	        }
	    }, {
	        key: "query",
	        value: function query(isNew) {
	            var _this2 = this;
	
	            var deployments = this.$Deployment.query(this.$scope.query);
	
	            _promise2.default.all([deployments.$promise]).then(function () {
	                var _$scope$deployments;
	
	                _this2.$scope.query.page = deployments._meta.page || 1;
	                _this2.$scope.loading = false;
	
	                isNew ? _this2.$scope.deployments = deployments : (_$scope$deployments = _this2.$scope.deployments).push.apply(_$scope$deployments, (0, _toConsumableArray3.default)(deployments));
	                _this2.$scope.pageCount = deployments._meta.page_count;
	                _this2.$scope.canAddMore = _this2.$scope.query.page !== _this2.$scope.pageCount;
	
	                _this2.$scope.$apply();
	            });
	        }
	    }, {
	        key: "addMoreItems",
	        value: function addMoreItems() {
	            this.$scope.query.page++;
	            this.query();
	        }
	    }, {
	        key: "onQueryFilterChange",
	        value: function onQueryFilterChange() {
	            var _this3 = this;
	
	            this.$scope.query.page = 1;
	            var newValue = (0, _lodash.clone)(this.$scope.query.search);
	            this.$scope.loading = true;
	            this.searhDelayTimeout = setTimeout(function () {
	                var prewValue = (0, _lodash.clone)(_this3.$scope.query.search);
	                if (prewValue === newValue) {
	                    clearTimeout(_this3.searhDelayTimeout);
	                    _this3.query(true);
	                }
	            }, 500);
	        }
	    }, {
	        key: "removeFilter",
	        value: function removeFilter() {
	            this.$scope.filter.show = false;
	            this.$scope.query.search = "";
	        }
	    }, {
	        key: "showFilter",
	        value: function showFilter() {
	            this.$scope.filter.show = true;
	            (0, _lodash.delay)(function () {
	                document.getElementById("search-field").focus();
	            }, 100);
	        }
	    }, {
	        key: "downloadDialog",
	        value: function downloadDialog(id, rules) {
	            var _this4 = this;
	
	            var parentEl = angular.element(document.body);
	            this.$mdDialog.show({
	                parent: parentEl,
	                title: "Create new configuration",
	                controller: _downloadDialog.DownloadDialogController,
	                template: _downloadDialog3.default,
	                targetEvent: event,
	                locals: {
	                    callback: function callback(obj) {
	                        _this4.$auth.$http({
	                            url: "/api/live-gallery-zip/" + obj.timeRange,
	                            method: "PUT",
	                            data: obj.data
	                        }).then(function (resp) {
	                            if (resp.data && resp.data.zip_url) {
	                                _this4.createZip(resp.data.zip_url);
	                            } else {
	                                _this4.$mdToast.show(_this4.$mdToast.simple().position("bottom right").hideDelay(5000).textContent("This deployment has no photos!"));
	                            }
	                        }).catch(function (e) {
	                            console.log(e);
	                        });
	                    },
	                    id: id,
	                    minDate: this.minDate,
	                    maxDate: this.maxDate,
	                    rules: rules
	                }
	            });
	        }
	    }, {
	        key: "getListOfOptions",
	        value: function getListOfOptions(id, deployment) {
	            var _this5 = this;
	
	            this.minDate = deployment.deployment_start ? moment(deployment.deployment_start)._d : null;
	            this.maxDate = deployment.deployment_end ? moment(deployment.deployment_end)._d : null;
	            var date = "";
	            if (this.minDate && this.maxDate) {
	                date = "?start_date=" + moment(this.minDate).utc().format("YYYY-MM-DD HH:mm:SS") + "&end_date=" + moment(this.maxDate).utc().format("YYYY-MM-DD HH:mm:SS");
	            }
	            this.$auth.$http({
	                url: "/api/live-gallery-zip/" + date,
	                method: "PATCH",
	                data: {
	                    deployment: id,
	                    outputTypes: {
	                        printing: true,
	                        sharing: true,
	                        original: true
	                    },
	                    captureModes: {
	                        photo: true,
	                        gif: true,
	                        boomerang: true,
	                        video: true
	                    }
	                }
	            }).then(function (resp) {
	                _this5.downloadDialog(id, resp.data);
	            }).catch(function (e) {
	                console.log(e);
	            });
	        }
	    }, {
	        key: "createZip",
	        value: function createZip(zipUrl) {
	            var _this6 = this;
	
	            var dialog = {
	                title: "Download media",
	                controller: _mediaDownload.MediaDownloadController,
	                template: _mediaDownload3.default,
	                targetEvent: event,
	                onRemoving: function onRemoving() {
	                    clearInterval(interval);
	                }
	            };
	            this.created = false;
	            var interval = null;
	            var MAX_TRIES = 60; // *5 sec
	
	            this.$mdDialog.show(dialog);
	
	            var tryDownload = function tryDownload() {
	                _this6.downloadZip(zipUrl).then(function (resp) {
	                    _this6.$mdDialog.hide(dialog);
	                    _this6.created = true;
	                    window.location.assign(resp.data.file);
	                }).catch(function (e) {
	                    if (e.status === 510) {
	                        _this6.created = false;
	                    } else {
	                        _this6.created = true;
	                    }
	                });
	            };
	            var ping = 0;
	            interval = setInterval(function () {
	                if (_this6.created || ping >= MAX_TRIES) {
	                    clearInterval(interval);
	                    if (ping >= MAX_TRIES) {
	                        _this6.$mdToast.show(_this6.$mdToast.simple().position("bottom right").hideDelay(5000).textContent("Download time turned out!"));
	                        _this6.$mdDialog.hide(dialog);
	                    }
	                } else {
	                    ping++;
	                    tryDownload();
	                }
	            }, 5000);
	        }
	    }, {
	        key: "downloadZip",
	        value: function downloadZip(url) {
	            var _this7 = this;
	
	            return this.$auth.$http({
	                url: url,
	                method: "GET"
	            }).then(function (resp) {
	                return resp;
	            }).catch(function (e) {
	                return _this7.$q.reject(e);
	            });
	        }
	    }, {
	        key: "onSearchBlur",
	        value: function onSearchBlur() {
	            if (!this.$scope.query.search) {
	                this.$scope.filter.show = false;
	            }
	        }
	    }, {
	        key: "isClient",
	        value: function isClient() {
	            return this.$auth.isRole("Client") || this.$auth.isRole("Sub-User");
	        }
	    }]);
	    return MediaController;
	}(_index.$controller);
	
	exports.default = MediaController;

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MediaDownloadController = exports.MediaDownloadController = function MediaDownloadController() {
	    "ngInject";
	};

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Download\">\n    <md-dialog-content style=\"overflow: hidden; width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\">{{'Creating zip file' | translate}}</h2>\n            <md-progress-linear md-mode=\"indeterminate\"></md-progress-linear>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>";

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DownloadDialogController = undefined;
	
	var _lodash = __webpack_require__(101);
	
	var DownloadDialogController = exports.DownloadDialogController = ["$scope", "$mdDialog", "callback", "id", "minDate", "maxDate", "rules", function DownloadDialogController($scope, $mdDialog, callback, id, minDate, maxDate, rules) {
	    "ngInject";
	
	    $scope.callback = callback;
	    $scope.minDate = minDate;
	    $scope.maxDate = maxDate;
	    $scope.rules = rules;
	    $scope.dateRange = {
	        start: (0, _lodash.cloneDeep)(minDate),
	        end: (0, _lodash.cloneDeep)(maxDate)
	    };
	    $scope.downloadObj = {
	        deployment: id,
	        remove_bg: false,
	        outputTypes: {
	            printing: true,
	            sharing: true,
	            original: true,
	            remove_bg: false
	        },
	        captureModes: {
	            photo: true,
	            gif: true,
	            boomerang: true,
	            video: true
	        }
	    };
	
	    $scope.closeDialog = function () {
	        document.onkeypress = function () {};
	        $mdDialog.hide();
	    };
	
	    $scope.create = function () {
	        var date = "";
	        if (minDate && maxDate) {
	            date = "?start_date=" + moment($scope.dateRange.start).utc().format("YYYY-MM-DD HH:mm:SS") + "&end_date=" + moment($scope.dateRange.end).utc().format("YYYY-MM-DD HH:mm:SS");
	        }
	        if ($scope.downloadObj.outputTypes.remove_bg) {
	            $scope.downloadObj.remove_bg = true;
	        } else {
	            $scope.downloadObj.remove_bg = false;
	        }
	        callback({ data: $scope.downloadObj, timeRange: date });
	        document.onkeypress = function () {};
	        $mdDialog.hide();
	    };
	
	    $scope.checkOptions = function (option) {
	        if (option === "photo") {
	            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.boomerang && !$scope.downloadObj.captureModes.video) {
	                $scope.downloadObj.captureModes.photo = true;
	            }
	        }
	
	        if (option === "gif") {
	            if (!$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.boomerang && !$scope.downloadObj.captureModes.video) {
	                $scope.downloadObj.captureModes.gif = true;
	            }
	        }
	
	        if (option === "boomerang") {
	            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.video) {
	                $scope.downloadObj.captureModes.boomerang = true;
	            }
	        }
	
	        if (option === "video") {
	            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.boomerang) {
	                $scope.downloadObj.captureModes.video = true;
	            }
	        }
	    };
	
	    $scope.checkOutputs = function (option) {
	        if (option === "printing") {
	            if (!$scope.downloadObj.outputTypes.original && !$scope.downloadObj.outputTypes.sharing) {
	                $scope.downloadObj.outputTypes.printing = true;
	            }
	        }
	
	        if (option === "sharing") {
	            if (!$scope.downloadObj.outputTypes.original && !$scope.downloadObj.outputTypes.printing) {
	                $scope.downloadObj.outputTypes.sharing = true;
	            }
	        }
	
	        if (option === "original") {
	            if (!$scope.downloadObj.outputTypes.sharing && !$scope.downloadObj.outputTypes.printing) {
	                $scope.downloadObj.outputTypes.original = true;
	            }
	        }
	        if (option === "remove_bg") {
	            $scope.downloadObj.outputTypes.printing = false;
	            $scope.downloadObj.outputTypes.sharing = false;
	            $scope.downloadObj.outputTypes.original = false;
	        }
	    };
	
	    document.onkeypress = function (ev) {
	        if (ev.key === "Enter") {
	            $scope.create();
	        }
	    };
	}];

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Create new configuration\" class=\"media-download\">\n    <md-dialog-content style=\"width: 400px;\">\n        <div class=\"md-dialog-content\">\n            <h2 class=\"md-title\">{{'Download ZIP' | translate}}</h2>\n            <form name=\"zipDownloadForm\">\n                <h4 ng-hide=\"!rules.captureModes.photo && !rules.captureModes.gif && !rules.captureModes.boomerang\">\n                    Select capture modes:</h4>\n                <md-switch\n                        md-invert\n                        ng-hide=\"!rules.captureModes.photo\"\n                        ng-change=\"checkOptions('photo')\"\n                        ng-model=\"downloadObj.captureModes.photo\">\n                    {{'Single photo' | translate}}\n                </md-switch>\n                <md-switch\n                        md-invert\n                        ng-hide=\"!rules.captureModes.gif\"\n                        ng-change=\"checkOptions('gif')\"\n                        ng-model=\"downloadObj.captureModes.gif\">\n                    {{'Gif' | translate}}\n                </md-switch>\n                <md-switch\n                        md-invert\n                        ng-hide=\"!rules.captureModes.boomerang\"\n                        ng-change=\"checkOptions('boomerang')\"\n                        ng-model=\"downloadObj.captureModes.boomerang\">\n                    {{'Boomerang' | translate}}\n                </md-switch>\n                <md-switch\n                        md-invert\n                        ng-hide=\"!rules.captureModes.video\"\n                        ng-change=\"checkOptions('video')\"\n                        ng-model=\"downloadObj.captureModes.video\">\n                    {{'Video' | translate}}\n                </md-switch>\n\n                <h4 ng-hide=\"!rules.outputTypes.printing && !rules.outputTypes.sharing && !rules.outputTypes.original\">\n                    Select output types:</h4>\n                <md-switch\n                        md-invert\n                        ng-hide=\"!rules.outputTypes.printing\"\n                        ng-change=\"checkOutputs('printing')\"\n                        ng-model=\"downloadObj.outputTypes.printing\"\n                        ng-disabled=\"downloadObj.outputTypes.remove_bg\">\n                    {{'Printing layouts' | translate}}\n                </md-switch>\n                <md-switch\n                        md-invert\n                        ng-hide=\"!rules.outputTypes.sharing\"\n                        ng-change=\"checkOutputs('sharing')\"\n                        ng-model=\"downloadObj.outputTypes.sharing\"\n                        ng-disabled=\"downloadObj.outputTypes.remove_bg\">\n                    {{'Sharing layouts' | translate}}\n                </md-switch>\n                <md-switch\n                        md-invert\n                        ng-hide=\"!rules.outputTypes.original\"\n                        ng-change=\"checkOutputs('original')\"\n                        ng-model=\"downloadObj.outputTypes.original\"\n                        ng-disabled=\"downloadObj.outputTypes.remove_bg\">\n                    {{'Original photos' | translate}}\n                </md-switch>\n                <md-switch\n                        md-invert\n                        ng-hide=\"!rules.outputTypes.remove_bg\"\n                        ng-change=\"checkOutputs('remove_bg')\"\n                        ng-model=\"downloadObj.outputTypes.remove_bg\">\n                    {{'Original removeBg photos' | translate}}\n                </md-switch>\n\n                <h4>Select time range:</h4>\n\n                <div ng-show=\"minDate && maxDate\">\n                    <md-input-container class=\"md-block md-short-input\">\n                        <input\n                                mdc-datetime-picker=\"\"\n                                date=\"true\"\n                                time=\"true\"\n                                type=\"text\"\n                                placeholder=\"{{'Report time frame start' | translate}}\"\n                                show-todays-date=\"\"\n                                minutes=\"true\"\n                                min-date=\"minDate\"\n                                max-date=\"dateRange.end\"\n                                auto-ok=\"true\"\n                                show-icon=\"true\"\n                                ng-model=\"dateRange.start\"\n                                class=\"dtp-no-msclear dtp-input md-input\"\n                                required>\n                    </md-input-container>\n\n                    <md-input-container class=\"md-block md-short-input\">\n                        <input\n                                mdc-datetime-picker=\"\"\n                                readonly\n                                date=\"true\"\n                                time=\"true\"\n                                type=\"text\"\n                                placeholder=\"{{'Report time frame end' | translate}}\"\n                                show-todays-date=\"\"\n                                minutes=\"true\"\n                                min-date=\"dateRange.start\"\n                                max-date=\"maxDate\"\n                                auto-ok=\"true\"\n                                show-icon=\"true\"\n                                ng-model=\"dateRange.end\"\n                                class=\"dtp-no-msclear dtp-input md-input\"\n                                required>\n                    </md-input-container>\n                </div>\n\n            </form>\n        </div>\n\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"closeDialog()\">{{'Cancel' | translate}}</md-button>\n        <md-button\n                ng-click=\"create()\"\n                class=\"md-primary\">{{'Download' | translate}}</md-button>\n    </md-dialog-actions>\n</md-dialog>\n";

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(779);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./media.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./media.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "media{width:100%;min-width:800px}media md-card{width:98%}media .truncated{max-width:150px}media table.md-table:not(.md-row-select) td.md-cell:nth-child(n+2):nth-last-child(n+2),media table.md-table:not(.md-row-select) th.md-column:nth-child(n+2):nth-last-child(n+2){padding:0 16px 0 0}media md-select.md-table-select>.md-select-value>span>.md-text{display:inline-block!important}", ""]);
	
	// exports


/***/ }),
/* 780 */
/***/ (function(module, exports) {

	"use strict";
	
	Router.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Router;
	function Router($stateProvider) {
	    "ngInject";
	
	    $stateProvider.state({
	        name: "media",
	        url: "/app/media",
	        template: "<media></media>",
	        resolve: {
	            $title: function $title() {
	                return "Media | UpReach Cloud";
	            }
	        }
	    });
	}

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.formPreviewComponent = undefined;
	
	var _formPreview = __webpack_require__(782);
	
	var _formPreview2 = _interopRequireDefault(_formPreview);
	
	var _formPreviewController = __webpack_require__(784);
	
	__webpack_require__(785);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formPreviewComponent = exports.formPreviewComponent = {
	    template: _formPreview2.default,
	    controller: _formPreviewController.formPreviewController,
	    controllerAs: "form",
	    bindings: {
	        definedInputs: "<",
	        customInputs: "<",
	        checkboxes: "<",
	        signature: "<",
	        oneAnswer: "<",
	        enabled: "<"
	    }
	};

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<h3>Preview screen</h3>\n<p>A preview of all options and custom fields selected.</p>\n\n<div class=\"form\" ng-if=\"form.enabled\">\n    <div ng-repeat=\"input in form.definedFields\">\n        <div layout=\"row\" ng-if=\"!$index && input.active\" style=\"justify-content: space-between\">\n            <div class=\"input-item\" style=\"width: 46%\">\n                <p class=\"field-label\">{{input.title[0]}}<span>{{input.required ? '*' : ''}}</span></p>\n                <p class=\"placeholder\">{{input.placeholder[0]}}</p>\n            </div>\n            <div class=\"input-item\" style=\"width: 46%\">\n                <p class=\"field-label\">{{input.title[1]}}<span>{{input.required ? '*' : ''}}</span></p>\n                <p class=\"placeholder\">{{input.placeholder[1]}}</p>\n            </div>\n        </div>\n        <div class=\"input-item\" ng-if=\"$index && input.active\">\n            <p class=\"field-label\">{{input.title}} <span>{{input.required ? '*' : ''}}</span></p>\n            <p class=\"placeholder\">{{input.placeholder}}</p>\n        </div>\n    </div>\n    <div ng-repeat=\"input in form.customFields\">\n        <div class=\"input-item\" ng-if=\"input.active && input.inputMode === 'text'\">\n            <p class=\"field-label\">{{input.title}} <span>{{input.required ? '*' : ''}}</span></p>\n            <p  class=\"placeholder\">{{input.placeholder}}</p>\n        </div>\n        <div class=\"multiple-filed\" ng-if=\"input.active && input.inputMode === 'multiple'\">\n            <p class=\"field-label\">{{input.title}} <span>{{input.required ? '*' : ''}}</span></p>\n            <md-checkbox\n                    ng-if=\"choice.text && !form.oneAnswer\"\n                    ng-repeat=\"choice in input.choices\"\n                    ng-disabled=\"true\">{{choice.text}}</md-checkbox>\n            <md-radio-group\n                    ng-if=\"form.oneAnswer\"\n                    ng-disabled=\"true\">\n                <md-radio-button\n                        ng-if=\"choice.text\"\n                        ng-repeat=\"choice in input.choices\">{{choice.text}}</md-radio-button>\n            </md-radio-group>\n        </div>\n    </div>\n    <p ng-if=\"form.signature.active\" class=\"field-label\">Signature<span>{{form.signature.required ? '*' : ''}}</span></p>\n    <div ng-if=\"form.signature.active\" class=\"signature\">\n        <p class=\"placeholder\" style=\"text-align: center\">Use the touchscreen to sign. Thank you!</p>\n    </div>\n    <div class=\"checkbox\" ng-if=\"box.active\" layout=\"row\" ng-repeat=\"box in form.checkboxes\">\n        <div class=\"checkbox-button\" ng-if=\"!box.isInfobox\"></div>\n        <div class=\"checkbox-body\" ng-class=\"{'infobox-body': box.isInfobox}\">\n            <img class=\"infobox-icon\" src=\"" + __webpack_require__(783) + "\" alt=\"infobox-icon\" ng-if=\"box.isInfobox\">\n            <div class=\"checkbox-body-wrapper\">\n                <p class=\"field-label\" style=\"font-weight: bold\">{{box.title ? box.title : 'Checkbox ' + ($index + 1) + ' title'}}<span>{{box.required ? '*' : ''}}</span></p>\n                <p class=\"placeholder\">{{box.infoBoxCustomText ? box.infoBoxCustomText : 'Press here to review the full statement...'}}</p>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"form\" ng-if=\"!form.enabled\">\n    <p class=\"alert-text\">Please enable user consent, to show form preview</p>\n</div>\n";

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/infobox_icon.svg";

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.formPreviewController = undefined;
	
	var _extends2 = __webpack_require__(272);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	var _lodash = __webpack_require__(101);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formPreviewController = exports.formPreviewController = function (_ActiveController) {
	    formPreviewController.$inject = ["$injector", "$rootScope", "$element", "$scope"];
	    (0, _inherits3.default)(formPreviewController, _ActiveController);
	
	    function formPreviewController($injector, $rootScope, $element, $scope) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, formPreviewController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (formPreviewController.__proto__ || (0, _getPrototypeOf2.default)(formPreviewController)).call(this, $injector));
	
	        _this.$rootScope = $rootScope;
	        _this.$element = angular.element($element);
	        _this.$scope = $scope;
	        _this.definedFields = [];
	        _this.customFields = [];
	        return _this;
	    }
	
	    (0, _createClass3.default)(formPreviewController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this2 = this;
	
	            this.$scope.$watch(function () {
	                return _this2.definedInputs;
	            }, function () {
	                var inputs = _lodash2.default.cloneDeep(_this2.definedInputs);
	
	                if (inputs) {
	                    _this2.definedFields = inputs.map(function (input, i) {
	                        switch (i) {
	                            case 0:
	                                input.placeholder = ["Max", "Mustermann"];
	                                input.title = ["First Name", "Last Name"];
	                                break;
	                            case 1:
	                                input.placeholder = "email@box.com";
	                                input.title = "Email";
	                                break;
	                            case 2:
	                                input.placeholder = "0123456789";
	                                input.title = "Phone";
	                                break;
	                        }
	                        return input;
	                    });
	                }
	            }, true);
	
	            this.$scope.$watch(function () {
	                return _this2.customInputs;
	            }, function () {
	                var inputs = _lodash2.default.cloneDeep(_this2.customInputs);
	
	                if (inputs && inputs.length) {
	                    _this2.customFields = inputs.map(function (input) {
	                        return (0, _extends3.default)({}, input, {
	                            title: input.title,
	                            placeholder: "Please enter"
	                        });
	                    });
	                }
	            }, true);
	            this.$scope.$watch(function () {
	                return _this2.checkboxes;
	            }, function () {});
	        }
	    }]);
	    return formPreviewController;
	}(_controller2.default);

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(786);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./form-preview.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./form-preview.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, ".form{padding:1px 18px 24px;box-shadow:0 3px 6px rgba(0,0,0,.16);width:100%;min-height:700px;background:#fff}.form .input-item{border-bottom:2px solid #000;padding-bottom:4px;margin-bottom:15px}.form .field-label{color:#000;padding-top:15px;margin-bottom:0;margin-top:0;font-size:12px;overflow-wrap:break-word}.form .placeholder{text-align:left;color:#a9a8a8;margin:0}.form .signature{border:2px solid #000;border-radius:3px;height:120px;margin-top:3px}.form .signature p{line-height:120px}.form .multiple-filed{display:flex;flex-flow:column}.form .multiple-filed .field-label{margin-bottom:8px}.form .multiple-filed .md-label{color:#000}.form .multiple-filed md-checkbox,.form .multiple-filed md-radio-group{margin-left:20px}.form .checkbox{margin-top:56px}.form .checkbox .checkbox-button{border:6px solid #000;border-radius:5px;margin-right:14px;height:48px;width:48px;min-height:48px;min-width:48px;margin-top:3px}.form .checkbox .checkbox-body{max-width:calc(100% - 100px);padding:10px 12px;box-shadow:0 3px 6px rgba(0,0,0,.16);display:flex}.form .checkbox .checkbox-body.infobox-body{min-width:355px}.form .checkbox .checkbox-body .infobox-icon{width:40px;margin-right:35px}.form .checkbox .checkbox-body .checkbox-body-wrapper .field-label{color:#000;padding-top:0!important;margin-bottom:10px!important}.form .checkbox .checkbox-body .checkbox-body-wrapper .placeholder{padding-right:30px}.form .alert-text{text-align:center;margin-top:290px}", ""]);
	
	// exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _oneBarChart = __webpack_require__(788);
	
	var _oneBarChart2 = _interopRequireDefault(_oneBarChart);
	
	var _twoBarChart = __webpack_require__(793);
	
	var _twoBarChart2 = _interopRequireDefault(_twoBarChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartsModule = angular.module("app.charts", []).component("oneBarChart", _oneBarChart2.default).component("twoBarChart", _twoBarChart2.default);
	
	exports.default = ChartsModule;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OneBarChartComponent = undefined;
	
	var _oneBarChart = __webpack_require__(789);
	
	var _oneBarChart2 = _interopRequireDefault(_oneBarChart);
	
	var _oneBarChart3 = __webpack_require__(790);
	
	__webpack_require__(791);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OneBarChartComponent = exports.OneBarChartComponent = {
	    template: _oneBarChart2.default,
	    controller: _oneBarChart3.oneBarChartController,
	    controllerAs: "chart",
	    bindings: {
	        data: "<",
	        lines: "@"
	    }
	};
	exports.default = OneBarChartComponent;

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"main\">\n    <div\n            class=\"line\"\n            ng-repeat=\"line in chart.linesArr\" ng-style=\"{top: line.top + '%'}\">\n        <span>{{line.val}}</span>\n\n    </div>\n\n    <div class=\"titles\">\n        <div class=\"title\" ng-repeat=\"bar in chart.dataArr\">\n            <div class=\"color-preview\" ng-style=\"{backgroundColor: bar.color}\"></div>\n            <div><span><span ng-if=\"bar.symbol\">&empty; </span>{{bar.label}}</span></div>\n        </div>\n    </div>\n\n    <div\n            class=\"bars-holder\"\n            ng-style=\"{bottom: 100 - chart.maxOffset + '%', height: ((100 - (100 - chart.maxOffset)) - chart.minOffset) + '%'}\">\n\n        <div\n                class=\"bar\"\n                ng-repeat=\"bar in chart.dataArr\"\n                ng-style=\"{backgroundColor: bar.color, height: bar.value / chart.linesArr[0].val * 100 + '%'}\"\n                ng-class=\"{'no-value': (bar.value / chart.linesArr[0].val * 100) <= 2}\"\n                title=\"{{bar.label}}\">\n            <span ng-class=\"{top: (bar.value / chart.linesArr[0].val * 100) <= 9}\">{{bar.value}}</span>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.oneBarChartController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneBarChartController = exports.oneBarChartController = function (_ActiveController) {
	    oneBarChartController.$inject = ["$injector", "$rootScope", "$element", "$scope"];
	    (0, _inherits3.default)(oneBarChartController, _ActiveController);
	
	    function oneBarChartController($injector, $rootScope, $element, $scope) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, oneBarChartController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (oneBarChartController.__proto__ || (0, _getPrototypeOf2.default)(oneBarChartController)).call(this, $injector));
	
	        _this.$rootScope = $rootScope;
	        _this.$scope = $scope;
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(oneBarChartController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.linesArr = this.createLines(Number(this.lines));
	            this.minOffset = this.linesArr[0].top;
	            this.maxOffset = this.linesArr[this.linesArr.length - 1].top;
	
	            this.dataArr = this.data;
	            this.editData();
	        }
	    }, {
	        key: "createLines",
	        value: function createLines(amount) {
	            if (typeof amount !== "number" || amount <= 0) {
	                amount = 5;
	            }
	            var lines = [];
	            for (var i = 1; i <= amount; i++) {
	                lines.push({
	                    top: 100 / (amount + 1) * (i + 0.3)
	                });
	            }
	            return lines;
	        }
	    }, {
	        key: "editData",
	        value: function editData() {
	            this.getMaxValue(this.dataArr);
	        }
	    }, {
	        key: "getMaxValue",
	        value: function getMaxValue(data) {
	            var el = (0, _lodash.orderBy)(data, "value", "desc")[0].value || 1;
	            var dIndex = Math.floor(el / this.linesArr.length) || 1;
	            var elRounded = Math.ceil(el / dIndex) * dIndex || 1;
	            var step = Math.round(elRounded / (this.linesArr.length - 1)) || 1;
	            var stepIndex = el >= 10 ? 5 : 2;
	            step = Math.ceil(step / stepIndex) * stepIndex;
	
	            for (var i = 0; i < this.linesArr.length; i++) {
	                this.linesArr[this.linesArr.length - i - 1].val = i * step;
	            }
	        }
	    }]);
	    return oneBarChartController;
	}(_controller2.default);

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(792);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./one-bar-chart.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./one-bar-chart.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "one-bar-chart .main{border:1px solid #c9c9c9;height:400px;position:relative}one-bar-chart .main .line{border:1px solid transparent;border-bottom:1px solid #c9c9c9;position:absolute;width:calc(100% - 80px);left:60px}one-bar-chart .main .line:last-child{border-bottom:2px solid #a9a9a9}one-bar-chart .main .line span{position:absolute;top:-10px;font-size:12px;left:-58px;width:50px;text-align:right;color:#969696}one-bar-chart .main .titles{color:#9e9e9e;position:absolute;top:20px;width:100%;display:flex;justify-content:space-around;font-size:13px;align-items:center}one-bar-chart .main .titles .color-preview{width:13px;height:13px;margin:0 5px}one-bar-chart .main .titles .title{position:relative;display:flex;align-items:center;justify-content:center}one-bar-chart .main .bars-holder{position:absolute;width:calc(100% - 80px);left:60px;display:flex;justify-content:center;align-items:flex-end}one-bar-chart .main .bars-holder .bar{width:50px;min-width:45px;margin:0 1px;border-top-left-radius:5px;border-top-right-radius:5px;color:#fafafa;font-size:13px;text-align:center;position:relative;top:1px}one-bar-chart .main .bars-holder .bar.no-value{border-bottom:1px solid;border-color:transparent}one-bar-chart .main .bars-holder .bar span{cursor:default;line-height:30px}one-bar-chart .main .bars-holder .bar span.top{position:relative;top:-24px;color:#999}one-bar-chart .main .bars-holder .bar:hover{box-shadow:inset 500px 500px rgba(0,0,0,.2);transition-duration:.8s}@keyframes appearBar{0%{height:0}}", ""]);
	
	// exports


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TwoBarChartComponent = undefined;
	
	var _twoBarChart = __webpack_require__(794);
	
	var _twoBarChart2 = _interopRequireDefault(_twoBarChart);
	
	var _twoBarChart3 = __webpack_require__(795);
	
	__webpack_require__(796);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwoBarChartComponent = exports.TwoBarChartComponent = {
	    template: _twoBarChart2.default,
	    controller: _twoBarChart3.twoBarChartController,
	    controllerAs: "chartDouble",
	    bindings: {
	        data: "<",
	        lines: "@",
	        labels: "@",
	        header: "<",
	        unique: "<"
	    }
	};
	exports.default = TwoBarChartComponent;

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"main\">\n\n\n    <div\n            class=\"line\"\n            ng-repeat=\"line in chartDouble.linesArr\" ng-style=\"{top: line.top + '%'}\">\n        <strong>{{line.val}}</strong>\n\n    </div>\n\n    <div class=\"titles\">\n        <strong class=\"title\">\n            {{chartDouble.header}}\n        </strong>\n    </div>\n\n    <div\n            class=\"bars-holder\"\n            ng-style=\"{bottom: 100 - chartDouble.maxOffset + '%', height: ((100 - (100 - chartDouble.maxOffset)) - chartDouble.minOffset) + '%'}\">\n\n        <div\n                ng-if=\"bar.active\"\n                class=\"bar-container\"\n                ng-repeat=\"bar in chartDouble.dataArr\">\n\n            <div class=\"single-bar-container\">\n                <span class=\"bar-value\" ng-style=\"{color: bar.color1}\" ng-class=\"{top: (bar.value1 / chartDouble.linesArr[0].val * 100) <= 9}\">{{bar.value1 || 0}}</span>\n                <div\n                        class=\"bar\"\n                        ng-style=\"{backgroundColor: bar.color1, maxHeight: bar.value1 / chartDouble.linesArr[0].val * 100 + '%'}\"\n                        ng-class=\"{'no-value': (bar.value1 / chartDouble.linesArr[0].val * 100) <= 2}\"\n                        title=\"{{bar.label}}\">\n\n\n                </div>\n            </div>\n\n            <div class=\"single-bar-container\" ng-if=\"chartDouble.unique\">\n                <span class=\"bar-value\" ng-style=\"{color: bar.color2}\" ng-class=\"{top: (bar.value2 / chartDouble.linesArr[0].val * 100) <= 9}\">{{bar.value2 || 0}}</span>\n                <div    ng-if=\"chartDouble.unique\"\n                        class=\"bar\"\n                        ng-style=\"{backgroundColor: bar.color2, maxHeight: bar.value2 / chartDouble.linesArr[0].val * 100 + '%'}\"\n                        ng-class=\"{'no-value': (bar.value2 / chartDouble.linesArr[0].val * 100) <= 2}\"\n                        title=\"{{bar.label}}\">\n\n\n                </div>\n            </div>\n\n\n        </div>\n\n        <div class=\"main-title\">\n            <strong ng-if=\"bar.active\" ng-repeat=\"bar in chartDouble.dataArr\">{{bar.label}}</strong>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.twoBarChartController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var twoBarChartController = exports.twoBarChartController = function (_ActiveController) {
	    twoBarChartController.$inject = ["$injector", "$rootScope", "$element", "$scope"];
	    (0, _inherits3.default)(twoBarChartController, _ActiveController);
	
	    function twoBarChartController($injector, $rootScope, $element, $scope) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, twoBarChartController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (twoBarChartController.__proto__ || (0, _getPrototypeOf2.default)(twoBarChartController)).call(this, $injector));
	
	        _this.$rootScope = $rootScope;
	        _this.$scope = $scope;
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(twoBarChartController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.linesArr = this.createLines(Number(this.lines));
	            this.minOffset = this.linesArr[0].top;
	            this.maxOffset = this.linesArr[this.linesArr.length - 1].top;
	
	            this.dataArr = this.data;
	            this.editData();
	        }
	    }, {
	        key: "createLines",
	        value: function createLines(amount) {
	            if (typeof amount !== "number" || amount <= 0) {
	                amount = 5;
	            }
	            var lines = [];
	            for (var i = 1; i < amount; i++) {
	                lines.push({
	                    top: 100 / (amount + 1) * (i + 0.3)
	                });
	            }
	            return lines;
	        }
	    }, {
	        key: "editData",
	        value: function editData() {
	            this.getMaxValue(this.dataArr);
	        }
	    }, {
	        key: "getMaxValue",
	        value: function getMaxValue(data) {
	            var allValuesArr = [];
	            (0, _lodash.forEach)(data, function (el) {
	                typeof el.value1 === "number" ? allValuesArr.push(el.value1) : null;
	                typeof el.value2 === "number" ? allValuesArr.push(el.value2) : null;
	            });
	            var el = Math.max.apply(Math, allValuesArr) + Math.max.apply(Math, allValuesArr) / 3 || 1;
	            var dIndex = Math.floor(el / this.linesArr.length) || 1;
	            var elRounded = Math.ceil(el / dIndex) * dIndex || 1;
	            var step = Math.round(elRounded / (this.linesArr.length - 1)) || 1;
	            var stepIndex = el >= 10 ? 5 : 2;
	            step = Math.ceil(step / stepIndex) * stepIndex;
	
	            for (var i = 0; i < this.linesArr.length; i++) {
	                this.linesArr[this.linesArr.length - i - 1].val = i * step;
	            }
	        }
	    }]);
	    return twoBarChartController;
	}(_controller2.default);

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(797);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./two-bar-chart.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./two-bar-chart.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "two-bar-chart .main{height:310px;position:relative}two-bar-chart .main .line{border:1px solid transparent;border-bottom:1px solid #d3d3d3;position:absolute;width:calc(100% - 50px);left:60px}two-bar-chart .main .line:first-child{opacity:0}two-bar-chart .main .line:nth-child(5){border-bottom:1px solid #868686}two-bar-chart .main .line strong{position:absolute;top:-6px;font-size:12px;left:-58px;width:50px;text-align:right;color:#000}two-bar-chart .main .titles{color:#000;position:absolute;top:55px;width:100%;display:flex;justify-content:center;font-size:16px;align-items:center;font-family:HKNova-ExtraBold}two-bar-chart .main .titles .color-preview{width:13px;height:13px;margin:0 5px}two-bar-chart .main .titles .title{position:relative;display:flex;align-items:center;justify-content:center;margin:0 0 0 20px}two-bar-chart .main .bars-holder{position:absolute;width:calc(100% - 80px);margin:0 15px;left:60px;font-size:13px;display:flex;justify-content:center;align-items:flex-end}two-bar-chart .main .bars-holder .bar-container{display:flex;justify-content:center;width:45px;height:100%;margin:0 5px}two-bar-chart .main .bars-holder .single-bar-container{text-align:center;display:flex;height:100%;align-items:center;flex-flow:column;min-width:27px;margin-right:-11px}two-bar-chart .main .bars-holder .single-bar-container span{width:100%;margin-top:auto;font-size:11px}two-bar-chart .main .bars-holder .bar{flex:1;border-top-left-radius:3px;border-top-right-radius:3px;color:#fafafa;font-size:13px;width:15px;text-align:center;margin:0 1px;position:relative;top:1px}two-bar-chart .main .bars-holder .bar.no-value{border-bottom:1px solid;border-color:transparent}two-bar-chart .main .bars-holder .bar .bar-value{cursor:default;line-height:30px}two-bar-chart .main .bars-holder .bar .bar-value.top{position:relative;top:-24px;color:#999}two-bar-chart .main .bars-holder .bar:hover{box-shadow:inset 500px 500px rgba(0,0,0,.2);transition-duration:.8s}two-bar-chart .main .main-title{position:absolute;color:#000;bottom:-37px;font-size:12px;width:100%;display:flex;align-items:center;justify-content:center}two-bar-chart .main .main-title strong{width:60px;margin:0 15px -13px -15px;line-height:30px;text-align:end;white-space:nowrap;transform:rotate(-45deg)}@keyframes appearBar{0%{height:0}}", ""]);
	
	// exports


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.liveViewPreviewComponent = undefined;
	
	var _liveViewPreview = __webpack_require__(799);
	
	var _liveViewPreview2 = _interopRequireDefault(_liveViewPreview);
	
	var _liveViewPreviewController = __webpack_require__(801);
	
	__webpack_require__(802);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var liveViewPreviewComponent = exports.liveViewPreviewComponent = {
	    template: _liveViewPreview2.default,
	    controller: _liveViewPreviewController.liveViewPreviewController,
	    controllerAs: "preview",
	    bindings: {
	        enabled: "<",
	        prWidth: "@",
	        prHeight: "@",
	        background: "@",
	        videoBackground: "@",
	        index: "@",
	        bgColor: "<",
	        bgMode: "<",
	        screen: "@",
	        mode: "@",
	        hideTitle: "<",
	        isSingle: "<",
	        isPortraite: "<",
	        hideOutputPictureVideo: "<",
	        hideSharingOptions: "<"
	    }
	};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"preview-title\" ng-if=\"!preview.hideTitle\">\n    <p ng-if=\"preview.screen === 'photo'\">Live View photo mode</p>\n    <p ng-if=\"preview.screen === 'filter'\">Live View filter gallery</p>\n    <p ng-if=\"preview.screen === 'output'\">Live View output</p>\n</div>\n\n<div  class=\"live-preview-main\"\n      ng-class=\"{\n            'portrait': preview.orientation === 'portrait',\n            'filter': preview.screen === 'filter'\n        }\"\n      ng-style=\"{\n            width: preview.width + 'px',\n            height: preview.height + 'px',\n            backgroundColor: preview.bgMode === 'color' && preview.shouldShowBackgroundMedia() ? preview.bgColor : 'none',\n            backgroundImage: preview.shouldShowImageBackground() ? 'url(' + preview.background + ')' : 'none'\n        }\">\n\n    <video\n            class=\"video-bg\"\n            ng-if=\"preview.shouldShowVideoBackground()\"\n            ng-src=\"{{preview.videoBackground}}\"\n            ng-style=\"{\n                width: preview.width + 'px',\n                height: preview.height + 'px'\n            }\"\n            muted\n            loop\n            autoplay></video>\n\n    <img ng-if=\"preview.mode === 'fullscreen' && preview.screen !== 'output' \"\n         style=\"object-fit: cover; background: lightgray\"\n         ng-style=\"{\n            width: preview.width + 'px',\n            height: preview.height + 'px'\n        }\"\n         ng-src=\"../../../../assets/photo.png\" alt=\"\">\n\n    <div class=\"badge-block\" >\n        <div class=\"triangle-logo\"></div>\n    </div>\n\n    <div class=\"filter-container\" ng-if=\"preview.screen === 'filter'\">\n        <div class=\"filter-column\">\n            <div class=\"little-circle\"></div>\n            <div class=\"item-container\">\n                <div ng-repeat=\"i in [0, 1, 2, 3, 4]\" class=\"filter-item\" md-whiteframe=\"3\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"preview.screen === 'photo'\"\n         class=\"capture-button md-whiteframe-1dp\">\n        <img src=\"" + __webpack_require__(800) + "\" alt=\"\">\n    </div>\n\n    <div class=\"capture-block md-whiteframe-1dp\"\n         ng-if=\"preview.screen !== 'output' && preview.mode === 'regular'\"\n         ng-style=\"{\n                width: preview.captureSize + 'px',\n                height: (preview.orientation === 'portrait' ? preview.captureheight : preview.captureSize) + 'px'\n            }\">\n        <img style=\"width: 100%; height: 100%\"\n             ng-src=\"../../../../assets/photo.png\" alt=\"image\">\n    </div>\n\n    <div  ng-if=\"preview.screen === 'output'\"\n          ng-style=\"{\n                height: preview.outputHeight + 'px'\n            }\"\n          class=\"output-block\"\n          ng-class=\"{'single-output':preview.isSingle}\">\n        <div ng-if=\" !preview.hideSharingOptions\"><div ng-if=\"preview.orientation === 'landscape'\" class=\"circle\"></div></div>\n\n        <div class=\"preview-container\" ng-class=\"{'single-container':preview.isSingle,'portrait': preview.isPortraite,'opacity':preview.hideOutputPictureVideo}\">\n            <div class=\"qr-code\" ng-if=\"preview.isSingle && !preview.hideSharingOptions\"></div>\n            <div class=\"single-mode-preview\" ng-if=\"preview.isSingle\"></div>\n            <div class=\"print-preview\" ng-if=\"!preview.isSingle\"></div>\n            <div class=\"line\" ng-if=\"!preview.isSingle\"></div>\n            <div class=\"photo-preview\" ng-if=\"!preview.isSingle\"></div>\n        </div>\n\n        <div class=\"socials-column\" ng-if=\"!preview.hideSharingOptions\">\n            <div ng-if=\"preview.orientation === 'portrait'\" class=\"circle\"></div>\n            <div class=\"circle\"></div>\n            <div class=\"circle\"></div>\n            <div class=\"qr-code\" ng-if=\"!preview.isSingle\"></div>\n        </div>\n    </div>\n\n    <div class=\"bottom\"\n         md-whiteframe=\"3\"\n         ng-style=\"{\n                width: preview.screen === 'output'?  60 + '%' : preview.captureSize + 'px',\n                opacity: preview.screen === 'photo' && preview.mode === 'fullscreen' ? 0.7 : 1,\n                borderRadius: preview.screen === 'photo' && preview.mode === 'fullscreen' ? '25px' : 0\n            }\">\n    </div>\n</div>\n";

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/camera.svg";

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.liveViewPreviewController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var liveViewPreviewController = exports.liveViewPreviewController = function (_ActiveController) {
	    liveViewPreviewController.$inject = ["$injector", "$rootScope", "$element", "$scope", "$timeout"];
	    (0, _inherits3.default)(liveViewPreviewController, _ActiveController);
	
	    function liveViewPreviewController($injector, $rootScope, $element, $scope, $timeout) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, liveViewPreviewController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (liveViewPreviewController.__proto__ || (0, _getPrototypeOf2.default)(liveViewPreviewController)).call(this, $injector));
	
	        _this.$rootScope = $rootScope;
	        _this.$element = angular.element($element);
	        _this.$scope = $scope;
	        _this.orientation = "";
	        _this.width = 0;
	        _this.height = 0;
	        _this.captureSize = 0;
	        _this.outputHeight = 0;
	        _this.renderedArray = [];
	        _this.$timeout = $timeout;
	        _this.boomerangCount = null;
	
	        $scope.$watch(function () {
	            return _this.prWidth;
	        }, function () {
	            _this.changeSize();
	        });
	
	        $scope.$watch(function () {
	            return _this.prHeight;
	        }, function () {
	            _this.changeSize();
	        });
	
	        $scope.$watch(function () {
	            return _this.mode;
	        }, function () {
	            _this.changeSize();
	        });
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(liveViewPreviewController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.changeSize();
	        }
	    }, {
	        key: "changeSize",
	        value: function changeSize() {
	            this.width = Math.round(Number(this.prWidth) / Number(this.index));
	            this.height = Math.round(Number(this.prHeight) / Number(this.index));
	
	            this.orientation = this.width > this.height ? "landscape" : "portrait";
	
	            this.captureSize = Math.round(Number(this.width > this.height ? this.prHeight : this.prWidth) / Number(this.index)) - 60;
	            this.captureheight = Math.round(Number(this.width < this.height ? this.prHeight : this.prWidth) / Number(this.index)) - 60;
	
	            this.outputHeight = this.orientation !== "portrait" ? this.captureSize - this.captureheight / 6 : this.captureheight - this.captureheight / 4;
	        }
	    }, {
	        key: "isVideo",
	        value: function isVideo(name) {
	            if (name === undefined || name === null || name === "") {
	                return false;
	            }
	            return name.indexOf(".mp4") !== -1 || name.indexOf(".webm") !== -1 || name.indexOf(".mov") !== -1;
	        }
	    }, {
	        key: "shouldShowBackgroundMedia",
	        value: function shouldShowBackgroundMedia() {
	            return this.enabled && (this.mode !== "fullscreen" || this.screen === "output");
	        }
	    }, {
	        key: "shouldShowImageBackground",
	        value: function shouldShowImageBackground() {
	            return this.shouldShowBackgroundMedia() && this.bgMode === "image" && this.background && !(this.videoBackground && this.isVideo(this.videoBackground));
	        }
	    }, {
	        key: "shouldShowVideoBackground",
	        value: function shouldShowVideoBackground() {
	            return this.shouldShowBackgroundMedia() && this.bgMode === "image" && this.videoBackground && this.isVideo(this.videoBackground);
	        }
	    }]);
	    return liveViewPreviewController;
	}(_controller2.default);

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(803);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./live-view-preview.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./live-view-preview.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, ".preview-title p{text-align:left!important}.live-preview-main{background-size:cover;margin:20px 20px 20px 0;overflow:hidden;position:relative;box-shadow:0 3px 6px rgba(0,0,0,.16);border:1px solid #e9e9e9}.live-preview-main .video-bg{position:absolute;top:0;left:0;object-fit:cover;z-index:0}.live-preview-main .badge-block{position:absolute;display:flex;left:0;top:0;z-index:20}.live-preview-main .badge-block .triangle-logo{border-width:0 0 15px 15px;border-style:solid;width:20px;height:0;line-height:0;transform:rotate(-180deg);border-color:transparent transparent #000}.live-preview-main .filter-container{position:absolute;display:flex;left:0;top:9%;width:calc(50% - 125px);max-width:100px}.live-preview-main .filter-container .filter-column{display:flex;flex-flow:column;width:45px;margin:0 auto}.live-preview-main .filter-container .filter-column .little-circle{border-radius:50%;width:13px;height:13px;margin:4px auto;background:#000}.live-preview-main .filter-container .filter-column .filter-item{width:45px;height:45px;background:#000;margin-bottom:10px}.live-preview-main .capture-button{position:absolute;bottom:65px;right:calc(50% - 15px);background:#fff;width:30px;height:30px;border-radius:50%;border:2px solid #fff;display:flex;justify-content:center;align-items:center}.live-preview-main .circle{border-radius:50%;width:40px;height:40px;background:#000}.live-preview-main .output-block{display:flex;flex-flow:row;justify-content:space-around;align-items:center;min-width:380px;margin:50px auto 10px;position:absolute;z-index:10;left:0;right:0}.live-preview-main .output-block.single-output{position:absolute;width:100%;height:100%!important;display:flex;align-items:center;justify-content:center;margin:0}.live-preview-main .output-block.single-output .socials-column{bottom:7%}.live-preview-main .output-block .preview-container{display:flex;flex-flow:row;justify-content:space-between;align-items:center;width:60%;height:inherit;min-width:270px}.live-preview-main .output-block .preview-container.opacity{opacity:0}.live-preview-main .output-block .preview-container.single-container{justify-content:center}.live-preview-main .output-block .preview-container.single-container .qr-code{position:absolute;width:40px;height:40px;left:auto;right:auto;top:40px;background-color:#000}.live-preview-main .output-block .preview-container.single-container.portrait .single-mode-preview{background:#000;height:69%;width:72%}.live-preview-main .output-block .preview-container.single-container .single-mode-preview{background:#000;width:69%;height:46%}.live-preview-main .output-block .preview-container .print-preview{background:#000;height:177px;width:126px}.live-preview-main .output-block .preview-container .line{background:#8a8a8a;height:100%;border-radius:100%;width:2px;margin:0 2px}.live-preview-main .output-block .preview-container .photo-preview{background:#000;height:110px;width:110px}.live-preview-main .output-block .socials-column{display:flex;flex-flow:column;justify-content:space-between;align-items:center;height:150px}.live-preview-main .output-block .socials-column .qr-code{background:#000;width:35px;height:35px}.live-preview-main .capture-block{position:relative;background:#d3d3d3;margin:10px auto;z-index:1}.live-preview-main .capture-block img{object-fit:cover}.live-preview-main .bottom{position:absolute;bottom:4px;background:#000;left:50%;transform:translate(-50%);height:32px}.filter .bottom{width:50%!important}.portrait .capture-block{position:unset!important}.portrait .filter-container{max-width:unset!important;width:100%!important;height:67px!important;top:unset!important;bottom:50px}.portrait .filter-container .filter-column{width:85%}.portrait .filter-container .item-container{display:flex;flex-flow:row!important;justify-content:center}.portrait .filter-container .item-container .filter-item{margin:0 2px}.portrait .output-block{margin-top:14px;min-width:unset!important}.portrait .output-block .socials-column{position:absolute;flex-flow:row;height:50px;bottom:12%;width:80%;right:10%}", ""]);
	
	// exports


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.htmlCustomBtnPreviewComponent = undefined;
	
	var _htmlCustomBtnPreview = __webpack_require__(805);
	
	var _htmlCustomBtnPreview2 = _interopRequireDefault(_htmlCustomBtnPreview);
	
	var _htmlCustomBtnPreview3 = __webpack_require__(806);
	
	__webpack_require__(819);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var htmlCustomBtnPreviewComponent = exports.htmlCustomBtnPreviewComponent = {
	    template: _htmlCustomBtnPreview2.default,
	    controller: _htmlCustomBtnPreview3.htmlCustomBtnPreviewController,
	    controllerAs: "preview",
	    bindings: {
	        screen: "@",
	        prWidth: "@",
	        prHeight: "@",
	        index: "@",
	        background: "@",
	        videoBackground: "@",
	        videoOverlay: "@",
	        areas: "@",
	        mode: "@",
	        gif: "@",
	        strip: "@",
	        ratio: "@",
	        gifSpeed: "@",
	        overlay: "@",
	        videoTime: "<",
	        videoSpeed: "<",
	        animationSpeed: "@",
	        printerBleed: "@",
	        relatedValues: "@",
	        ignoreOverflow: "<",
	        hideOverlay: "<",
	        hideTitle: "<",
	        bgMode: "<",
	        bgColor: "<",
	        bgStyle: "<",
	        backBtn: "<",
	        sharingBackBtn: "<",
	        captureBtn: "<",
	        proceedBtn: "<",
	        emailBtn: "<",
	        smsBtn: "<",
	        printBtn: "<",
	        doneBtn: "<",
	        qrCodeBtn: "<",
	        singleBtn: "<",
	        boomerangBtn: "<",
	        gifBtn: "<",
	        sceneBtn: "<",
	        filterBtn: "<",
	        scenePopupColor: "<",
	        hideScene: "<",
	        transparency: "<",
	        scenes: "<",
	        hidePhotoBg: "<",
	        badgeActive: "<",
	        displayPopup: "<",
	        liveViewOpacity: "@",
	        enabled: "<",
	        margin: "<",
	        isSingle: "<",
	        isPortraite: "<",
	        hideOutputPictureVideo: "<",
	        hideSharingOptions: "<"
	    }
	};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"preview-title\" ng-if=\"!preview.hideTitle\">\n    <p ng-if=\"preview.screen === 'photo'\">Live View photo mode</p>\n    <p ng-if=\"preview.screen === 'filter'\">Live View filter gallery</p>\n    <p ng-if=\"preview.screen === 'output'\">Live View output</p>\n</div>\n\n<div\n        class=\"preview-main\"\n        ng-class=\"{\n            'red-border': preview.isOverflow && !preview.ignoreOverflow,\n            'portrait': preview.orientation === 'portrait',\n            'filter': preview.screen === 'filter',\n            'ignore-margin': preview.margin}\"\n        ng-style=\"{\n            width: preview.width,\n            height: preview.height,\n            backgroundColor: preview.bgMode === 'color' && preview.shouldShowBackgroundMedia() ? preview.bgColor : 'none',\n            backgroundImage: preview.shouldShowImageBackground() ? 'url(' + preview.background + ')' : 'none'\n        }\"\n        id=\"{{preview.uniqueId}}\">\n    <video\n            class=\"live-view-bg\"\n            ng-if=\"preview.transparency.enabled && preview.liveViewVideo\"\n            ng-src=\"{{preview.liveViewVideo}}\"\n            ng-style=\"{width: preview.width, height: preview.height}\"\n            muted\n            loop\n            autoplay></video>\n    <div\n            id=\"{{preview.bgId}}\"\n            class=\"back-image\"\n            ng-class=\"{crop: preview.bgStyle === 'crop'}\"\n            ng-style=\"{width: preview.width, height: preview.height, backgroundImage: preview.shouldShowImageBackground() ? 'url(' + preview.background + ')' : 'none', opacity: preview.setOpacity(preview.transparency.backgroundOpacity)}\"\n            ng-show=\"preview.shouldShowImageBackground()\"></div>\n    <div\n            class=\"back-color\"\n            ng-style=\"{width: preview.width, height: preview.height, backgroundColor: preview.bgColor, opacity: preview.transparency}\"\n            ng-show=\"preview.bgMode && preview.bgMode === 'color'\"></div>\n    <video\n            class=\"video-bg\"\n            ng-if=\"preview.shouldShowVideoBackground()\"\n            ng-src=\"{{preview.videoBackground}}\"\n            ng-class=\"{crop: preview.bgStyle === 'crop'}\"\n            ng-style=\"{width: preview.width, height: preview.height, opacity: preview.setOpacity(preview.transparency.backgroundOpacity)}\"\n            muted\n            loop\n            autoplay></video>\n    <div class=\"start-logo\"\n         ng-if=\"preview.logo && preview.logoType === 'start'\"\n         ng-hide=\"preview.hideLogo\"\n         ng-style=\"{width: preview.logoStyle.width, top:  preview.logoStyle.top, bottom: preview.logoStyle.bottom, left: preview.logoStyle.left, right: preview.logoStyle.right, height: preview.logoStyle.height, backgroundImage: 'url(' + preview.logo + ')'}\">\n    </div>\n    <img ng-if=\"preview.mode === 'fullscreen' && preview.screen !== 'output' \"\n         class=\"preview-photo-img\"\n         style=\"object-fit: cover; background: lightgray\"\n         ng-style=\"{\n            width: preview.width, height: preview.height\n        }\"\n         ng-src=\"../../../../assets/photo.png\" alt=\"\">\n\n    <div\n            class=\"area\"\n            ng-repeat=\"area in preview.renderedArray\"\n            ng-hide=\"area.hide\"\n            ng-class=\"{'no-bg': preview.hidePhotoBg,'scene-wrapper':area.scene && preview.sceneBtn === true}\"\n            ng-style=\"{width: area.width, height: area.height, top: area.y, left: area.x, transform: 'rotate('+ area.angle +')', opacity: preview.liveViewOpacity ? preview.liveViewOpacity/100 : preview.setOpacity(preview.transparency.iconsOpacity)}\">\n\n        <!--        back btn start-->\n        <img\n                class=\"start-screen-area back-btn\"\n                ng-if=\"area.back && preview.backBtn === true\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file : area.back}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <!--        back btn end-->\n\n        <!--        sharing back btn start-->\n        <img\n                class=\"start-screen-area back-btn\"\n                ng-if=\"area.sharingBackBtn && preview.sharingBackBtn === true\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file : area.sharingBackBtn}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <!--      sharing back btn end-->\n\n\n        <!--        filter btn start-->\n        <img\n                class=\"start-screen-area\"\n                ng-if=\"area.filter && preview.filterBtn === true\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :area.filter}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <!--        filter btn end-->\n\n        <!--    capture btn start-->\n        <img\n                class=\"start-screen-area\"\n                ng-if=\"area.capture && preview.captureBtn === true\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :area.capture}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <!--    capture btn end-->\n\n        <!--    proceed btn start-->\n        <img\n                class=\"start-screen-area\"\n                ng-if=\"area.proceed && preview.proceedBtn === true\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :area.proceed}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <!--    proceed btn end-->\n\n        <!--    gif btn start-->\n        <img\n                class=\"start-screen-area gif-btn\"\n                ng-if=\"area.gif && preview.gifBtn === true\"\n                ng-show=\"preview.singleBtn && preview.gifBtn || preview.gifBtn && preview.boomerangBtn || preview.singleBtn && preview.gifBtn && preview.boomerangBtn\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :area.gif}}\"\n                alt=\"img-gif\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <!--        gif btn end-->\n        <!--        photo btn start-->\n        <img\n                class=\"start-screen-area single-btn\"\n                ng-if=\"area.single && preview.singleBtn === true\"\n                ng-show=\"preview.singleBtn && preview.gifBtn || preview.singleBtn && preview.boomerangBtn || preview.singleBtn && preview.gifBtn && preview.boomerangBtn\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :area.single}}\"\n                alt=\"img-photo\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <!--        photo btn end-->\n\n        <!--        boomerang btn start-->\n\n        <img\n                class=\"start-screen-area\"\n                ng-if=\"area.boomerang && preview.boomerangBtn === true\"\n                ng-show=\"preview.singleBtn && preview.boomerangBtn || preview.gifBtn && preview.boomerangBtn || preview.singleBtn && preview.gifBtn && preview.boomerangBtn\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :area.boomerang}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <!--        boomerang btn end-->\n        <!--        scene popup start-->\n        <img class=\"popup-flag\" ng-src=\"../../../../assets/triangle-icon.png\"\n             ng-if=\"area.scene && preview.sceneBtn === true && preview.displayPopup === true\">\n        <div class=\"scene-popup\"\n             ng-if=\"area.scene && preview.sceneBtn === true && preview.displayPopup === true\"\n             ng-style=\"{'background-color':area.scenePopupColor, backgroundImage: 'url(' + (area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :'') + ')','background-position': 'center',\n    'background-repeat': 'no-repeat','background-size': 'cover'}\"\n        >\n            <div class=\"scene-item\"></div>\n            <div class=\"scene-item\"></div>\n            <div class=\"scene-item\"></div>\n            <div class=\"scene-item\"></div>\n        </div>\n        <!--        scene popup end-->\n\n\n        <img\n                class=\"start-screen-area\"\n                ng-if=\"area.email && preview.emailBtn === true\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :area.email}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <img\n                class=\"start-screen-area\"\n                ng-if=\"area.sms && preview.smsBtn === true\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :area.sms}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <img\n                class=\"start-screen-area\"\n                ng-if=\"area.print && preview.printBtn === true\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :area.print}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <img\n                class=\"start-screen-area\"\n                ng-if=\"area.done && preview.doneBtn === true\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :area.done}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n        <img\n                class=\"start-screen-area\"\n                ng-if=\"area.qrCode && preview.qrCodeBtn === true\"\n                ng-src=\"{{area.customIcon ? 'https://cloud.upreach.com/'+area.customIcon.attachment_file :area.qrCode}}\"\n                alt=\"img\"\n                ng-style=\"{width: '100%', height: '100%'}\">\n\n        <scene-preview\n                ng-if=\"preview.scenes && preview.scenes.enabled\"\n                layout-width=\"area.width\"\n                layout-height=\"area.height\"\n                scene-width=\"preview.scenes.layoutWidth\"\n                scene-height=\"preview.scenes.layoutHeight\"\n                photo=\"preview.scenes.scenesList[0].photos[0]\"\n                overlay-files=\"preview.scenes.scenesList[0].overlayFiles\"\n                background-files=\"preview.scenes.scenesList[0].backgroundFiles\"\n                image=\"area.image\"\n                photo-index=\"$index\"\n                hide-photo-bg=\"preview.hidePhotoBg\"\n                hide-scene=\"preview.hideScene\">\n        </scene-preview>\n\n    </div>\n\n    <div\n            class=\"vertical-strip\"\n            ng-style=\"{height: preview.height}\"\n            ng-if=\"preview.strip === 'true' && preview.ratio === 'portrait'\"></div>\n\n    <div\n            class=\"horizontal-strip\"\n            ng-style=\"{width: preview.width}\"\n            ng-if=\"preview.strip === 'true' && preview.ratio === 'landscape'\"></div>\n\n    <div\n            id=\"{{preview.overlayId}}\"\n            class=\"overlay-image\"\n            ng-style=\"{width: preview.width, height: preview.height, backgroundImage: 'url(' + preview.overlay + ')'}\"\n            ng-hide=\"preview.hideOverlay\"\n            ng-class=\"{crop: preview.bgStyle === 'crop'}\"></div>\n\n    <video\n            ng-if=\"preview.videoOverlay !== null && preview.isVideo(preview.videoOverlay)\"\n            class=\"video-overlay video-bg overlay-image\"\n            ng-src=\"{{preview.overlay}}\"\n            ng-class=\"{crop: preview.bgStyle === 'crop'}\"\n            ng-style=\"{width: preview.width, height: preview.height}\"\n            muted\n            loop\n            autoplay></video>\n\n    <div\n            class=\"logo-digital\"\n            ng-if=\"preview.logoType === 'digital' && preview.bgMode === 'color'\"\n            ng-hide=\"preview.hideLogo\"\n            ng-style=\"{backgroundColor: preview.bgColor}\">\n\n    </div>\n\n    <div\n            class=\"logo-digital bg-image-digital\"\n            ng-if=\"preview.logoType === 'digital' && preview.bgMode === 'image'\"\n            ng-hide=\"preview.hideLogo\"\n            ng-style=\"{backgroundImage: 'url(' + preview.background + ')'}\">\n\n    </div>\n\n    <div\n            class=\"bg-digital\"\n            ng-if=\"preview.logoType === 'digital'\"\n            ng-hide=\"preview.hideLogo || !preview.logo\"\n            ng-style=\"{backgroundImage: 'url(' + preview.logo + ')'}\">\n    </div>\n\n    <div\n            class=\"logo-print\"\n            ng-repeat=\"lg in preview.logosArr\"\n            ng-if=\"preview.logoType === 'print' || preview.logoType === 'strip'\"\n            ng-hide=\"preview.hideLogo\"\n            ng-style=\"{backgroundImage: 'url(' + preview.logo + ')', width: lg.width, height: lg.height, top: lg.top, bottom: lg.bottom, left: lg.left, right: lg.right}\">\n    </div>\n\n    <div\n            ng-if=\"preview.printerBleed === 'true'\"\n            class=\"print-bleed\"\n            ng-style=\"{width: preview.bleed.width, height: preview.bleed.height, top: preview.bleed.top, left: preview.bleed.left}\">\n\n    </div>\n\n    <div\n            ng-if=\"preview.badgeActive\"\n            class=\"badge-block\">\n        <div class=\"triangle-logo\"></div>\n        <img src=\"" + __webpack_require__(157) + "\" alt=\"logo\">\n\n    </div>\n\n    <div class=\"capture-block md-whiteframe-1dp\"\n         ng-if=\"preview.screen !== 'output' && preview.mode === 'regular'\"\n         ng-style=\"{\n                width: preview.captureSize + 'px',\n                height: (preview.orientation === 'portrait' ? preview.captureheight : preview.captureSize) + 'px'\n            }\">\n        <img style=\"width: 100%; height: 100%\"\n             ng-src=\"../../../../assets/photo.png\" alt=\"image\">\n    </div>\n    <div ng-if=\"preview.screen === 'output' && !preview.hideOutputPictureVideo\"\n         ng-style=\"{\n                height: preview.outputHeight + 'px'\n            }\"\n         class=\"output-block\"\n         ng-class=\"{'single-output':preview.isSingle}\">\n\n        <div class=\"preview-container\" ng-class=\"{'single-container':preview.isSingle,'portrait': preview.isPortraite}\">\n            <div class=\"single-mode-preview\" ng-if=\"preview.isSingle\"></div>\n            <div class=\"print-preview\" ng-if=\"!preview.isSingle\"></div>\n            <div class=\"line\" ng-if=\"!preview.isSingle\"></div>\n            <div class=\"photo-preview\" ng-if=\"!preview.isSingle\"></div>\n        </div>\n\n    </div>\n</div>\n";

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.htmlCustomBtnPreviewController = undefined;
	
	var _keys = __webpack_require__(185);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var htmlCustomBtnPreviewController = exports.htmlCustomBtnPreviewController = function (_ActiveController) {
	  htmlCustomBtnPreviewController.$inject = ["$injector", "$rootScope", "$element", "$scope", "$timeout"];
	  (0, _inherits3.default)(htmlCustomBtnPreviewController, _ActiveController);
	
	  function htmlCustomBtnPreviewController($injector, $rootScope, $element, $scope, $timeout) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, htmlCustomBtnPreviewController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (htmlCustomBtnPreviewController.__proto__ || (0, _getPrototypeOf2.default)(htmlCustomBtnPreviewController)).call(this, $injector));
	
	    _this.$rootScope = $rootScope;
	    _this.$element = angular.element($element);
	    _this.$scope = $scope;
	    _this.width = 0;
	    _this.height = 0;
	    _this.renderedArray = [];
	    _this.uniqueId = "id-" + Math.random();
	    _this.bgId = "bg-" + Math.random();
	    _this.overlayId = "overlay-" + Math.random();
	    _this.boomerangId = "boomerang-" + Math.random();
	    _this.$timeout = $timeout;
	    _this.boomerangCount = null;
	    _this.outputHeight = 0;
	
	    $scope.$watch(function () {
	      return _this.areas;
	    }, function () {
	      var divider = Number(_this.index);
	      try {
	        _this.areas = JSON.parse(_this.areas);
	        _this.renderedArray = [];
	        _this.areas && (0, _keys2.default)(_this.areas).forEach(function (area) {
	          if (!_this.areas[area].x && _this.areas[area].x !== 0 || !_this.areas[area].y && _this.areas[area].y !== 0) {
	            return false;
	          }
	          var el = {};
	          // Basic values
	          if (!_this.relatedValues) {
	            el = {
	              x: Math.round(_this.areas[area].x / divider) + "px",
	              y: Math.round(_this.areas[area].y / divider) + "px",
	              width: _this.areas[area].width ? Math.round(_this.areas[area].width / divider) + "px" : 0,
	              height: _this.areas[area].height ? Math.round(_this.areas[area].height / divider) + "px" : 0
	            };
	          } else {
	            el = {
	              x: _this.areas[area].x,
	              y: _this.areas[area].y,
	              width: _this.areas[area].width * 1.4 / 100 * _this.prHeight / _this.prWidth * 100,
	              height: _this.areas[area].height * 1.4
	            };
	
	            if (area === "scene") {
	              el.y -= 120 / (Number(_this.height.replace("px", "")) / 100);
	              el.x -= 95 / (Number(_this.width.replace("px", "")) / 100);
	              el.width = "95px";
	              el.height = "120px";
	            } else {
	              el.x -= el.width / 2;
	              el.y -= el.height / 2;
	              el.width += "%";
	              el.height += "%";
	            }
	            el.x += "%";
	            el.y += "%";
	          }
	          // Gif background
	          switch (area) {
	            case "back":
	              el.back = __webpack_require__(807);
	              break;
	            case "sharingBackBtn":
	              el.sharingBackBtn = __webpack_require__(807);
	              break;
	            case "filter":
	              el.filter = __webpack_require__(808);
	              break;
	            case "capture":
	              el.capture = __webpack_require__(809);
	              break;
	            case "proceed":
	              el.proceed = __webpack_require__(809);
	              break;
	            case "single":
	              el.single = __webpack_require__(810);
	              break;
	            case "gif":
	              el.gif = __webpack_require__(811);
	              break;
	            case "boomerang":
	              el.boomerang = __webpack_require__(812);
	              break;
	            case "email":
	              el.email = __webpack_require__(813);
	              break;
	            case "sms":
	              el.sms = __webpack_require__(814);
	              break;
	            case "print":
	              el.print = __webpack_require__(815);
	              break;
	            case "done":
	              el.done = __webpack_require__(816);
	              break;
	            case "qrCode":
	              el.qrCode = __webpack_require__(817);
	              break;
	            case "scene":
	              el.scene = __webpack_require__(818);
	              el.scenePopupColor = _this.areas[area].scenePopupColor;
	              break;
	          }
	          // Image background
	          if (_this.areas[area].image) {
	            if (_this.single) {
	              el.image = __webpack_require__(313);
	            } else if (!_this.areas[area].title) {
	              el.image = __webpack_require__(566);
	            } else {
	              if (_this.boomerang) {
	                el.image = __webpack_require__(567)("./b" + _this.areas[area].title[0] * 30 + ".png");
	              } else {
	                el.image = __webpack_require__(693)("./" + _this.areas[area].title[0] + ".png");
	              }
	
	              var mainSide = _this.areas[area].height < _this.areas[area].width ? "height" : "width";
	              el.title = _this.areas[area].title;
	              el.font = Math.round(_this.areas[area][mainSide] / divider * 0.55) + "px";
	            }
	          } else if (_this.areas[area].gif) {
	            _this.drawGif([1, 2, 3]);
	            el.frames = true;
	          } else if (_this.areas[area].video) {
	            el.video = true;
	          }
	          el.angle = _this.areas[area].angle + "deg";
	          if (_this.areas[area].customIcon && _this.areas[area].customIcon.attachment_file) {
	            el.customIcon = {
	              attachment_file: _this.areas[area].customIcon.attachment_file
	            };
	          }
	
	          _this.renderedArray.push(el);
	          if (el.video) {
	            _this.$timeout(function () {
	              _this.makeBoomerang();
	            });
	          }
	        });
	      } catch (e) {
	        //
	      }
	    });
	
	    $scope.$watch(function () {
	      return _this.prWidth;
	    }, function () {
	      _this.changeSize();
	    });
	
	    $scope.$watch(function () {
	      return _this.prHeight;
	    }, function () {
	      _this.changeSize();
	    });
	
	    $scope.$watch(function () {
	      return _this.index;
	    }, function () {
	      _this.changeSize();
	    });
	
	    $scope.$watch(function () {
	      return _this.videoTime;
	    }, function () {
	      _this.makeBoomerang();
	    });
	
	    $scope.$watch(function () {
	      return _this.videoSpeed;
	    }, function () {
	      _this.makeBoomerang();
	    });
	
	    $scope.$watch(function () {
	      return _this.background;
	    }, function () {
	      _this.animateBackground();
	    });
	
	    $scope.$watch(function () {
	      return _this.overlay;
	    }, function () {
	      _this.animateOverlay();
	    });
	    $scope.$watch(function () {
	      return _this.animationSpeed;
	    }, function () {
	      _this.animateOverlay();
	      _this.animateBackground();
	    });
	
	    $scope.$watch(function () {
	      return _this.videoOverlay;
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(htmlCustomBtnPreviewController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.changeSize();
	      this.liveViewVideo = __webpack_require__(310);
	    }
	  }, {
	    key: "$onDestroy",
	    value: function $onDestroy() {
	      clearInterval(this.count);
	      clearInterval(this.countBackground);
	      clearInterval(this.countOverlay);
	      clearInterval(this.boomerangCount);
	    }
	  }, {
	    key: "changeSize",
	    value: function changeSize() {
	      this.width = Math.round(Number(this.prWidth) / Number(this.index)) + "px";
	      this.height = Math.round(Number(this.prHeight) / Number(this.index)) + "px";
	      if (Number(this.prWidth) > Number(this.prHeight)) {
	        this.bleed = {
	          width: 1800 / Number(this.index) + "px",
	          height: 1200 / Number(this.index) + "px",
	          top: 22 / Number(this.index) + "px",
	          left: 20 / Number(this.index) + "px"
	        };
	      } else {
	        this.bleed = {
	          width: 1200 / Number(this.index) + "px",
	          height: 1800 / Number(this.index) + "px",
	          top: 20 / Number(this.index) + "px",
	          left: 22 / Number(this.index) + "px"
	        };
	      }
	
	      this.orientation = this.width > this.height ? "landscape" : "portrait";
	
	      this.captureSize = Math.round(Number(this.width > this.height ? this.prHeight : this.prWidth) / Number(this.index)) - 60;
	      this.captureheight = Math.round(Number(this.width < this.height ? this.prHeight : this.prWidth) / Number(this.index)) - 60;
	
	      this.outputHeight = this.orientation !== "portrait" ? this.captureSize - this.captureheight / 6 : this.captureheight - this.captureheight / 4;
	    }
	  }, {
	    key: "drawGif",
	    value: function drawGif(frames) {
	      var _this2 = this;
	
	      clearInterval(this.count);
	      var idx = 0;
	      this.gifFrame = __webpack_require__(693)("./" + frames[idx] + ".png");
	
	      this.count = setInterval(function () {
	        _this2.gifFrame = __webpack_require__(693)("./" + frames[idx] + ".png");
	        _this2.$scope.$apply(function () {
	          return _this2.gifFrame;
	        });
	        if (idx === frames.length - 1) {
	          idx = 0;
	        } else {
	          idx++;
	        }
	      }, this.gifSpeed ? Number(this.gifSpeed) / frames.length * 1000 : 667);
	    }
	  }, {
	    key: "makeBoomerang",
	    value: function makeBoomerang() {
	      var _this3 = this;
	
	      clearInterval(this.boomerangCount);
	      var allFiles = 120;
	      var framesPerSecond = 24;
	      var time = this.videoTime <= 5 ? this.videoTime || 1.5 : 5; // Added mock for preview to be 5 seconds even if video time is longer (up to 8s);
	      var speed = this.videoSpeed || 1.5;
	      var startCount = allFiles - time * 24;
	      var direction = "forward";
	      var idx = 0;
	      var speedIndex = time * 2 / speed;
	      var imagesArr = [];
	      var loadedImages = 0;
	
	      var onImageLoad = function onImageLoad() {
	        loadedImages++;
	        clearInterval(_this3.boomerangCount);
	        if (loadedImages === imagesArr.length) {
	          clearInterval(_this3.boomerangCount);
	          _this3.boomerangCount = setInterval(function () {
	            _this3.boomerangFrame = imagesArr[Math.floor(idx)] ? imagesArr[Math.floor(idx)].src : "";
	            _this3.$scope.$apply(function () {
	              return _this3.boomerangFrame;
	            });
	            if (idx >= imagesArr.length && direction === "forward") {
	              direction = "backward";
	            } else if (idx <= 0 && direction === "backward") {
	              direction = "forward";
	            } else {
	              direction === "forward" ? idx += speedIndex : idx -= speedIndex;
	            }
	          }, 1000 / framesPerSecond);
	        }
	      };
	
	      for (var i = startCount; i <= 120; i++) {
	        var img = new Image();
	        img.src = __webpack_require__(567)("./b" + Math.floor(i) + ".png");
	        img.onload = function () {
	          onImageLoad();
	        };
	        imagesArr.push(img);
	      }
	    }
	  }, {
	    key: "animateBackground",
	    value: function animateBackground() {
	      var _this4 = this;
	
	      setTimeout(function () {
	        try {
	          var arr = void 0;
	          try {
	            var parsed = JSON.parse(_this4.background);
	            arr = Array.isArray(parsed) ? parsed : _this4.background ? [_this4.background] : [];
	          } catch (parseError) {
	            arr = _this4.background ? [_this4.background] : [];
	          }
	          var pr = document.getElementById(_this4.bgId);
	          if (!pr) {
	            return;
	          }
	          var images = [];
	          for (var i = 0; i < arr.length; i++) {
	            var image = new Image();
	            image.src = arr[i];
	            arr[i] = images.push(image);
	          }
	          clearInterval(_this4.countBackground);
	          if (arr.length > 1) {
	            var idx = 0;
	            _this4.countBackground = setInterval(function () {
	              pr.style.backgroundImage = "url(" + images[idx].src + ")";
	              if (idx === arr.length - 1) {
	                idx = 0;
	              } else {
	                idx++;
	              }
	            }, _this4.animationSpeed ? Number(_this4.animationSpeed) / arr.length * 1000 : 1000);
	          } else if (arr.length === 1) {
	            var _image = images[0];
	            var applyBackground = function applyBackground() {
	              pr.style.backgroundImage = "url(" + _image.src + ")";
	              _this4.background = _image.src;
	            };
	            if (_image.complete) {
	              applyBackground();
	            } else {
	              _image.onload = applyBackground;
	            }
	          } else {
	            pr.style.backgroundImage = "none";
	            _this4.background = null;
	          }
	        } catch (e) {
	          //console.log(e);
	        }
	      });
	    }
	  }, {
	    key: "animateOverlay",
	    value: function animateOverlay() {
	      var _this5 = this;
	
	      setTimeout(function () {
	        try {
	          var arr = JSON.parse(_this5.overlay);
	          var pr = document.getElementById(_this5.overlayId);
	          var images = [];
	          for (var i = 0; i < arr.length; i++) {
	            var image = new Image();
	            image.src = arr[i];
	            arr[i] = images.push(image);
	          }
	          clearInterval(_this5.countOverlay);
	          if (arr.length > 1) {
	            var idx = 0;
	            _this5.countOverlay = setInterval(function () {
	              pr.style.backgroundImage = "url(" + images[idx].src + ")";
	              if (idx === arr.length - 1) {
	                idx = 0;
	              } else {
	                idx++;
	              }
	            }, _this5.animationSpeed ? Number(_this5.animationSpeed) / arr.length * 1000 : 1000);
	          } else {
	            arr.length ? _this5.overlay = images[0].src : _this5.overlay = null;
	          }
	        } catch (e) {
	          //console.log(e);
	        }
	      });
	    }
	  }, {
	    key: "isVideo",
	    value: function isVideo(name) {
	      if (name === undefined || name === null) {
	        return false;
	      } else {
	        return name.indexOf(".mp4") !== -1 || name.indexOf(".webm") !== -1 || name.indexOf(".mov") !== -1;
	      }
	    }
	  }, {
	    key: "shouldShowBackgroundMedia",
	    value: function shouldShowBackgroundMedia() {
	      return this.enabled && (this.mode !== "fullscreen" || this.screen === "output");
	    }
	  }, {
	    key: "shouldShowImageBackground",
	    value: function shouldShowImageBackground() {
	      return this.shouldShowBackgroundMedia() && this.bgMode === "image" && this.background && this.background !== "[]" && !(this.videoBackground && this.isVideo(this.videoBackground));
	    }
	  }, {
	    key: "shouldShowVideoBackground",
	    value: function shouldShowVideoBackground() {
	      return this.shouldShowBackgroundMedia() && this.bgMode === "image" && this.videoBackground && this.isVideo(this.videoBackground);
	    }
	  }, {
	    key: "setOpacity",
	    value: function setOpacity(tr) {
	      if (!this.transparency || !this.transparency.enabled) {
	        return 1;
	      }
	      return tr / 100;
	    }
	  }]);
	  return htmlCustomBtnPreviewController;
	}(_controller2.default);

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/back-btn-icon.svg";

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/effects-btn-icon.svg";

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/shoot-btn-icon.svg";

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/photo-icon.svg";

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/gif-icon.svg";

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/boomerang-icon.svg";

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/email-btn-icon.svg";

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/sms-btn-icon.svg";

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/print-btn-icon.svg";

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/done-btn-icon.svg";

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/qr-btn-icon.svg";

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/popup-icon.svg";

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(820);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./html-custom-btn-preview.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./html-custom-btn-preview.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "html-custom-btn-preview .preview-main{background-color:#fff;background-size:100% 100%;position:relative;margin:0 auto;overflow:hidden;box-sizing:border-box;box-shadow:0 3px 6px rgba(0,0,0,.16);border:0 solid #e9e9e9;margin:20px 20px 20px 0}html-custom-btn-preview .preview-main .back-color{position:absolute}html-custom-btn-preview .preview-main.red-border{border:1px solid red}html-custom-btn-preview .preview-main.ignore-margin{margin:0}html-custom-btn-preview .preview-main .capture-block{position:relative;background:#d3d3d3;margin:10px auto;z-index:1}html-custom-btn-preview .preview-main .capture-block img{object-fit:cover}html-custom-btn-preview .preview-main .start-logo{position:absolute;background-size:contain;background-repeat:no-repeat;background-position:50% 50%}html-custom-btn-preview .preview-main .bg-digital,html-custom-btn-preview .preview-main .logo-digital,html-custom-btn-preview .preview-main .logo-print{background-size:contain;background-repeat:no-repeat;background-position:50% 50%;position:absolute;z-index:14}html-custom-btn-preview .preview-main .bg-digital img,html-custom-btn-preview .preview-main .logo-digital img,html-custom-btn-preview .preview-main .logo-print img{object-fit:contain}html-custom-btn-preview .preview-main .logo-digital{width:100%;left:0;bottom:0;height:15%}html-custom-btn-preview .preview-main .bg-digital{width:95%;height:10%;bottom:2.5%;left:2.5%}html-custom-btn-preview .preview-main .bg-image-digital{background-size:cover;background-repeat:no-repeat;background-position:50% 50%}html-custom-btn-preview .preview-main .logo-strip-left,html-custom-btn-preview .preview-main .logo-strip-right{position:absolute;background-size:contain;background-repeat:no-repeat;background-position:50% 50%}html-custom-btn-preview .preview-main .area{position:absolute;box-sizing:border-box;overflow:hidden;background:#d3d3d3}html-custom-btn-preview .preview-main .area.no-bg{background-color:transparent!important}html-custom-btn-preview .preview-main .area.bordered{border:1px solid #ff2c49;display:flex;align-items:center;justify-content:center;background-color:#fff}html-custom-btn-preview .preview-main .area.bordered:before{content:\"\";position:absolute;width:100%;height:100%;z-index:60;background:linear-gradient(to top left,transparent 0,transparent calc(50% - .8px),red 50%,transparent calc(50% + .8px),transparent),linear-gradient(to top right,transparent 0,transparent calc(50% - .8px),red 50%,transparent calc(50% + .8px),transparent)}html-custom-btn-preview .preview-main .area img{position:absolute;object-fit:fill}html-custom-btn-preview .preview-main .area video{position:absolute;object-fit:cover;background-color:#d5cfd2}html-custom-btn-preview .preview-main .area .title{z-index:10;position:absolute;text-align:center;color:#ff2c49}html-custom-btn-preview .preview-main .area .title--titleBtn{color:#000;font-size:10px;font-style:normal;font-weight:700;line-height:330%;z-index:10;position:relative}html-custom-btn-preview .preview-main .area.scene-wrapper{overflow:unset}html-custom-btn-preview .preview-main .area.scene-wrapper .popup-flag{z-index:2}html-custom-btn-preview .preview-main .area.scene-wrapper .scene-popup{position:relative;z-index:2;box-shadow:0 0 31px -9px rgba(0,0,0,.75);width:258px;height:157px}html-custom-btn-preview .preview-main .area .popup-flag{position:absolute;top:15px;left:-10px;z-index:1}html-custom-btn-preview .preview-main .area .scene-popup{border-radius:10px;display:flex;align-items:center;justify-content:space-around;flex-wrap:wrap;padding:5px;box-sizing:border-box}html-custom-btn-preview .preview-main .area .scene-popup .scene-item{width:48%;height:48%;padding:3px;background-color:red;box-sizing:border-box}html-custom-btn-preview .preview-main .video-bg{position:absolute;object-fit:fill}html-custom-btn-preview .preview-main .video-bg.crop{object-fit:cover}html-custom-btn-preview .preview-main .live-view-bg{position:absolute;object-fit:cover}html-custom-btn-preview .preview-main .vertical-strip{border-left:2px dashed #ff2c49;left:50%;position:absolute;z-index:15}html-custom-btn-preview .preview-main .horizontal-strip{border-top:2px dashed #ff2c49;top:50%;position:absolute;z-index:15}html-custom-btn-preview .preview-main .back-image{position:absolute;z-index:0;background-size:100% 100%}html-custom-btn-preview .preview-main .back-image.crop{background-size:cover;background-position:50% 50%}html-custom-btn-preview .preview-main .back-image img{width:100%;height:100%}html-custom-btn-preview .preview-main .overlay-image{position:absolute;z-index:12;background-size:100% 100%}html-custom-btn-preview .preview-main .overlay-image img{width:100%;height:100%}html-custom-btn-preview .preview-main .overlay-image.crop{background-position:50% 50%;background-size:100% 100%}html-custom-btn-preview .print-bleed{position:absolute;border:1px dashed red;box-sizing:border-box;z-index:16}html-custom-btn-preview .badge-block{position:absolute;display:flex;right:0;bottom:0;z-index:20}html-custom-btn-preview .badge-block .triangle-logo{border-width:0 0 15px 15px;border-style:solid;width:0;height:0;line-height:0;border-color:transparent transparent #000}html-custom-btn-preview .badge-block img{background:#000;width:60px;height:15px;padding-right:8px}html-custom-btn-preview .output-block{display:flex;flex-flow:row;justify-content:space-around;align-items:center;min-width:380px;margin:50px auto 10px;position:relative;z-index:0;width:100%;height:100%!important;justify-content:center;margin:0}html-custom-btn-preview .output-block.single-output{position:absolute;width:100%;height:100%!important;display:flex;align-items:center;justify-content:center;margin:0}html-custom-btn-preview .output-block .preview-container{display:flex;flex-flow:row;justify-content:space-between;align-items:center;width:60%;height:inherit;min-width:270px}html-custom-btn-preview .output-block .preview-container.single-container{justify-content:center}html-custom-btn-preview .output-block .preview-container.single-container.portrait .single-mode-preview{background:#000;height:69%;width:72%}html-custom-btn-preview .output-block .preview-container.single-container .single-mode-preview{background:#000;width:69%;height:46%}html-custom-btn-preview .output-block .preview-container .print-preview{background:#000;height:177px;width:126px}html-custom-btn-preview .output-block .preview-container .line{background:#8a8a8a;height:100%;border-radius:100%;width:2px;margin:0 2px;opacity:0}html-custom-btn-preview .output-block .preview-container .photo-preview{background:#000;height:110px;width:110px}html-custom-btn-preview .output-block .socials-column{display:flex;flex-flow:column;justify-content:space-between;align-items:center;height:150px}html-custom-btn-preview .output-block .socials-column .qr-code{background:#000;width:35px;height:35px}.portrait .capture-block{position:unset!important}.portrait .filter-container{max-width:unset!important;width:100%!important;height:67px!important;top:unset!important;bottom:50px}.portrait .filter-container .filter-column{width:85%}.portrait .filter-container .item-container{display:flex;flex-flow:row!important;justify-content:center}.portrait .filter-container .item-container .filter-item{margin:0 2px}.portrait .output-block{margin-top:14px;min-width:unset!important}.portrait .output-block .socials-column{position:absolute;flex-flow:row;height:50px;bottom:12%;width:80%;right:10%}.portrait .scene-popup{width:95px!important;height:120px!important}", ""]);
	
	// exports


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.individualTextOutputPreviewComponent = undefined;
	
	var _individualTextOutputPreview = __webpack_require__(822);
	
	var _individualTextOutputPreview2 = _interopRequireDefault(_individualTextOutputPreview);
	
	var _individualTextOutputPreview3 = __webpack_require__(823);
	
	__webpack_require__(825);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Draws the Individual Text fields over a transcluded <html-preview> of the print layout.
	 * Text positions are px of the print canvas; with `editable` texts can be dragged.
	 */
	var individualTextOutputPreviewComponent = exports.individualTextOutputPreviewComponent = {
	    template: _individualTextOutputPreview2.default,
	    controller: _individualTextOutputPreview3.individualTextOutputPreviewController,
	    controllerAs: "textPreview",
	    transclude: true,
	    bindings: {
	        settings: "<",
	        canvasWidth: "<",
	        canvasHeight: "<",
	        index: "<",
	        editable: "<"
	    }
	};

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"individual-text-output\">\n    <ng-transclude></ng-transclude>\n    <div class=\"individual-text-output__layer\" ng-style=\"textPreview.getLayerStyle()\">\n        <div class=\"individual-text-output__text\"\n             ng-repeat=\"field in textPreview.settings.fields track by field.id\"\n             ng-if=\"field.enabled\"\n             ng-class=\"{'individual-text-output__text--editable': textPreview.editable, 'individual-text-output__text--placeholder': !field.output.text}\"\n             ng-style=\"textPreview.getTextStyle(field)\"\n             title=\"{{textPreview.editable ? 'X: ' + field.output.x + ' %, Y: ' + field.output.y + ' %' : ''}}\"\n             drag-move=\"textPreview.onDrag(field, $phase, $dx, $dy)\"><span class=\"individual-text-output__line\" ng-style=\"textPreview.getLineStyle(field)\">{{textPreview.getLineText(field)}}</span></div>\n        <div class=\"individual-text-output__guide individual-text-output__guide--x\"\n             ng-repeat=\"guide in textPreview.guides.x\"\n             ng-style=\"textPreview.getGuideStyle('x', guide)\"></div>\n        <div class=\"individual-text-output__guide individual-text-output__guide--y\"\n             ng-repeat=\"guide in textPreview.guides.y\"\n             ng-style=\"textPreview.getGuideStyle('y', guide)\"></div>\n    </div>\n</div>\n";

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.individualTextOutputPreviewController = undefined;
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	var _fontFace = __webpack_require__(824);
	
	var _individualText = __webpack_require__(263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Snap distance in px of the preview
	var SNAP_DISTANCE = 6;
	
	var individualTextOutputPreviewController = exports.individualTextOutputPreviewController = function (_ActiveController) {
	    individualTextOutputPreviewController.$inject = ["$injector", "$element", "$scope"];
	    (0, _inherits3.default)(individualTextOutputPreviewController, _ActiveController);
	
	    function individualTextOutputPreviewController($injector, $element, $scope) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, individualTextOutputPreviewController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (individualTextOutputPreviewController.__proto__ || (0, _getPrototypeOf2.default)(individualTextOutputPreviewController)).call(this, $injector));
	
	        _this.$element = $element;
	        _this.$scope = $scope;
	        _this.measureContext = document.createElement("canvas").getContext("2d");
	        _this.onFontLoad = function () {
	            return _this.$scope.$applyAsync();
	        };
	        _this.guides = { x: [], y: [] };
	        return _this;
	    }
	
	    (0, _createClass3.default)(individualTextOutputPreviewController, [{
	        key: "getScale",
	        value: function getScale() {
	            return Number(this.index) || 1;
	        }
	
	        /** Places the text layer exactly over html-preview's rendered layout. */
	
	    }, {
	        key: "getLayerStyle",
	        value: function getLayerStyle() {
	            var wrapper = this.$element[0].querySelector(".individual-text-output");
	            var layout = this.$element[0].querySelector(".preview-main");
	            var scale = this.getScale();
	            var left = 0;
	            var top = 0;
	            if (wrapper && layout) {
	                var wrapperRect = wrapper.getBoundingClientRect();
	                var layoutRect = layout.getBoundingClientRect();
	                left = layoutRect.left - wrapperRect.left + layout.clientLeft;
	                top = layoutRect.top - wrapperRect.top + layout.clientTop;
	            }
	            return {
	                left: left + "px",
	                top: top + "px",
	                width: this.canvasWidth / scale + "px",
	                height: this.canvasHeight / scale + "px"
	            };
	        }
	
	        /** Without a text the field name stands in, so the position can still be set. */
	
	    }, {
	        key: "getText",
	        value: function getText(field) {
	            return field.output.text || field.label.text;
	        }
	    }, {
	        key: "getFontFamily",
	        value: function getFontFamily(field) {
	            var family = (0, _fontFace.getAttachmentFontFamily)(field.font, this.onFontLoad);
	            return family ? "\"" + family + "\", sans-serif" : "sans-serif";
	        }
	
	        /** Canvas TextMetrics of the text in the field's font, px of the print canvas. */
	
	    }, {
	        key: "measure",
	        value: function measure(field, fontSize, text) {
	            this.measureContext.font = fontSize + "px " + this.getFontFamily(field);
	            return this.measureContext.measureText(text);
	        }
	
	        /** Shrinks the font between fontSize and minFontSize so the letters fit the box width. */
	
	    }, {
	        key: "getFittedFontSize",
	        value: function getFittedFontSize(field) {
	            var output = field.output;
	            var width = (0, _individualText.getInkWidth)(this.measure(field, output.fontSize, this.getText(field)));
	            var boxWidth = output.width * this.canvasWidth / 100;
	            if (!width || width <= boxWidth) {
	                return output.fontSize;
	            }
	            return Math.max(output.minFontSize, output.fontSize * boxWidth / width);
	        }
	
	        /** The line at the fitted font size, cut with "…" when it still does not fit, placed by the alignments. */
	
	    }, {
	        key: "getLine",
	        value: function getLine(field) {
	            var _this2 = this;
	
	            var output = field.output;
	            var fontSize = this.getFittedFontSize(field);
	            var box = (0, _individualText.getOutputBox)(output, this.canvasWidth, this.canvasHeight);
	            var text = (0, _individualText.cutTextToWidth)(this.getText(field), box.width, function (value) {
	                return (0, _individualText.getInkWidth)(_this2.measure(field, fontSize, value));
	            });
	            var layout = (0, _individualText.getTextLineLayout)(this.measure(field, fontSize, text), box.width, box.height, output.align, output.verticalAlign);
	            return { text: text, fontSize: fontSize, layout: layout };
	        }
	    }, {
	        key: "getLineText",
	        value: function getLineText(field) {
	            return this.getLine(field).text;
	        }
	    }, {
	        key: "getLineStyle",
	        value: function getLineStyle(field) {
	            var layout = this.getLine(field).layout;
	            var scale = this.getScale();
	            return {
	                left: layout.left / scale + "px",
	                top: layout.top / scale + "px",
	                lineHeight: layout.lineHeight / scale + "px"
	            };
	        }
	    }, {
	        key: "getTextStyle",
	        value: function getTextStyle(field) {
	            var output = field.output;
	            var scale = this.getScale();
	            var box = (0, _individualText.getOutputBox)(output, this.canvasWidth, this.canvasHeight);
	            return {
	                left: box.left / scale + "px",
	                top: box.top / scale + "px",
	                width: box.width / scale + "px",
	                height: box.height / scale + "px",
	                fontSize: this.getFittedFontSize(field) / scale + "px",
	                fontFamily: this.getFontFamily(field),
	                color: output.color
	            };
	        }
	    }, {
	        key: "getGuideStyle",
	        value: function getGuideStyle(axis, value) {
	            return axis === "x" ? { left: value / this.getScale() + "px" } : { top: value / this.getScale() + "px" };
	        }
	    }, {
	        key: "onDrag",
	        value: function onDrag(field, phase, dx, dy) {
	            var _this3 = this;
	
	            if (!this.editable) {
	                return;
	            }
	            if (phase === "start") {
	                this.dragStart = (0, _individualText.getOutputBox)(field.output, this.canvasWidth, this.canvasHeight);
	                return;
	            }
	            if (phase === "end") {
	                this.guides = { x: [], y: [] };
	                return;
	            }
	            var output = field.output;
	            var scale = this.getScale();
	            var guides = {
	                x: [0, this.canvasWidth / 2, this.canvasWidth],
	                y: [0, this.canvasHeight / 2, this.canvasHeight]
	            };
	            this.settings.fields.filter(function (other) {
	                return other.enabled && other !== field;
	            }).forEach(function (other) {
	                var _guides$x, _guides$y;
	
	                var box = (0, _individualText.getOutputBox)(other.output, _this3.canvasWidth, _this3.canvasHeight);
	                (_guides$x = guides.x).push.apply(_guides$x, (0, _toConsumableArray3.default)((0, _individualText.getBoxGuides)(box.left, box.width)));
	                (_guides$y = guides.y).push.apply(_guides$y, (0, _toConsumableArray3.default)((0, _individualText.getBoxGuides)(box.top, box.height)));
	            });
	            var start = this.dragStart;
	            var snapX = (0, _individualText.snapToGuides)(start.left + dx * scale, start.width, guides.x, SNAP_DISTANCE * scale);
	            var snapY = (0, _individualText.snapToGuides)(start.top + dy * scale, start.height, guides.y, SNAP_DISTANCE * scale);
	            (0, _individualText.moveOutput)(output, snapX.start, snapY.start, this.canvasWidth, this.canvasHeight);
	            (0, _individualText.clampOutputPosition)(output, this.canvasWidth, this.canvasHeight);
	            this.guides = {
	                x: snapX.guide === null ? [] : [snapX.guide],
	                y: snapY.guide === null ? [] : [snapY.guide]
	            };
	        }
	    }]);
	    return individualTextOutputPreviewController;
	}(_controller2.default);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(185);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.getAttachmentFontFamily = getAttachmentFontFamily;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Registers uploaded font attachments (.ttf/.otf/.woff) in the document so previews can use them.
	 * Returns the CSS font-family name right away; `onLoad` runs once the font is ready to render.
	 */
	var families = {};
	
	function getAttachmentFontFamily(attachment, onLoad) {
	    var url = attachment && attachment.attachment_file;
	    if (!url || typeof url !== "string" || !window.FontFace || !document.fonts) {
	        return "";
	    }
	    if (!families[url]) {
	        var family = "individual-font-" + (0, _keys2.default)(families).length;
	        var font = new window.FontFace(family, "url(\"" + url + "\")");
	        families[url] = { family: family, loaded: false, callbacks: [] };
	        font.load().then(function (loaded) {
	            document.fonts.add(loaded);
	            families[url].loaded = true;
	            families[url].callbacks.forEach(function (cb) {
	                return cb();
	            });
	            families[url].callbacks = [];
	        }, function (error) {
	            return console.log("Font loading failed", url, error);
	        });
	    }
	    var entry = families[url];
	    if (!entry.loaded && onLoad && entry.callbacks.indexOf(onLoad) === -1) {
	        entry.callbacks.push(onLoad);
	    }
	    return entry.family;
	}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(826);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./individual-text-output-preview.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./individual-text-output-preview.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, ".individual-text-output{position:relative;display:inline-block;text-align:left}.individual-text-output__layer{position:absolute;overflow:hidden;pointer-events:none;z-index:100}.individual-text-output__text{position:absolute;box-sizing:border-box;overflow:hidden}.individual-text-output__text--placeholder{opacity:.4}.individual-text-output__text--editable{pointer-events:auto;cursor:move;outline:1px dashed hsla(0,0%,100%,.8);box-shadow:0 0 0 1px rgba(0,0,0,.35);user-select:none}.individual-text-output__line{position:absolute;white-space:nowrap}.individual-text-output__guide{position:absolute;pointer-events:none;background:#f6264c}.individual-text-output__guide--x{top:0;bottom:0;width:1px}.individual-text-output__guide--y{left:0;right:0;height:1px}", ""]);
	
	// exports


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.individualTextScreenPreviewComponent = undefined;
	
	var _individualTextScreenPreview = __webpack_require__(828);
	
	var _individualTextScreenPreview2 = _interopRequireDefault(_individualTextScreenPreview);
	
	var _individualTextScreenPreview3 = __webpack_require__(829);
	
	__webpack_require__(830);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Preview of the Individual Text screen on the device. Every element can be dragged;
	 * the output picture is transcluded into its box. The fields show the text set in the cloud.
	 */
	var individualTextScreenPreviewComponent = exports.individualTextScreenPreviewComponent = {
	    template: _individualTextScreenPreview2.default,
	    controller: _individualTextScreenPreview3.individualTextScreenPreviewController,
	    controllerAs: "screenPreview",
	    transclude: true,
	    bindings: {
	        settings: "<",
	        screenWidth: "<",
	        screenHeight: "<",
	        index: "<"
	    }
	};

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"individual-text-screen\" ng-style=\"screenPreview.getScreenStyle()\">\n    <video class=\"individual-text-screen__background\"\n           ng-if=\"screenPreview.isVideo(screenPreview.getBackground())\"\n           ng-src=\"{{screenPreview.getBackground()}}\"\n           muted loop autoplay playsinline></video>\n\n    <div class=\"individual-text-screen__item individual-text-screen__output\"\n         ng-style=\"screenPreview.getAreaStyle(screenPreview.settings.outputPreview)\"\n         drag-move=\"screenPreview.onDrag(screenPreview.settings.outputPreview, $phase, $dx, $dy)\">\n        <ng-transclude></ng-transclude>\n    </div>\n\n    <div class=\"individual-text-screen__item individual-text-screen__explanation\"\n         ng-if=\"screenPreview.settings.explanation.enabled\"\n         ng-style=\"screenPreview.getExplanationStyle()\"\n         drag-move=\"screenPreview.onDrag(screenPreview.settings.explanation.area, $phase, $dx, $dy)\">\n        {{screenPreview.settings.explanation.text || ('Explanation' | translate)}}\n    </div>\n\n    <div class=\"individual-text-screen__item individual-text-screen__field\"\n         ng-repeat=\"field in screenPreview.settings.fields track by field.id\"\n         ng-if=\"field.enabled\"\n         ng-style=\"screenPreview.getAreaStyle(field.area)\"\n         drag-move=\"screenPreview.onDrag(field.area, $phase, $dx, $dy)\">\n        <span class=\"individual-text-screen__label\"\n              ng-style=\"screenPreview.getFont(field.font, field.label.fontSize, field.label.color)\">{{field.label.text}}</span>\n        <input class=\"individual-text-screen__input\"\n               type=\"text\"\n               value=\"{{field.output.text}}\"\n               readonly\n               tabindex=\"-1\"\n               ng-style=\"screenPreview.getInputStyle(field)\">\n    </div>\n\n    <div class=\"individual-text-screen__item individual-text-screen__done\"\n         ng-style=\"screenPreview.getAreaStyle(screenPreview.settings.doneButton)\"\n         drag-move=\"screenPreview.onDrag(screenPreview.settings.doneButton, $phase, $dx, $dy)\">\n        <video ng-if=\"screenPreview.isVideo(screenPreview.getDoneIcon())\"\n               ng-src=\"{{screenPreview.getDoneIcon()}}\"\n               muted loop autoplay playsinline></video>\n        <img ng-if=\"!screenPreview.isVideo(screenPreview.getDoneIcon())\"\n             ng-src=\"{{screenPreview.getDoneIcon()}}\" alt=\"\" draggable=\"false\">\n    </div>\n\n    <div class=\"individual-text-screen__guide individual-text-screen__guide--x\"\n         ng-repeat=\"guide in screenPreview.guides.x\"\n         ng-style=\"screenPreview.getGuideStyle('x', guide)\"></div>\n    <div class=\"individual-text-screen__guide individual-text-screen__guide--y\"\n         ng-repeat=\"guide in screenPreview.guides.y\"\n         ng-style=\"screenPreview.getGuideStyle('y', guide)\"></div>\n</div>\n";

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.individualTextScreenPreviewController = undefined;
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	var _fontFace = __webpack_require__(824);
	
	var _individualText = __webpack_require__(263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DONE_ICON = __webpack_require__(816);
	// Snap distance in px of the preview
	var SNAP_DISTANCE = 6;
	// Explanation line height, in font sizes (the scss line-height)
	var EXPLANATION_LINE_HEIGHT = 1.1;
	
	var individualTextScreenPreviewController = exports.individualTextScreenPreviewController = function (_ActiveController) {
	    individualTextScreenPreviewController.$inject = ["$injector", "$scope"];
	    (0, _inherits3.default)(individualTextScreenPreviewController, _ActiveController);
	
	    function individualTextScreenPreviewController($injector, $scope) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, individualTextScreenPreviewController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (individualTextScreenPreviewController.__proto__ || (0, _getPrototypeOf2.default)(individualTextScreenPreviewController)).call(this, $injector));
	
	        _this.$scope = $scope;
	        _this.onFontLoad = function () {
	            return _this.$scope.$applyAsync();
	        };
	        _this.guides = { x: [], y: [] };
	        _this.measureContext = document.createElement("canvas").getContext("2d");
	        return _this;
	    }
	
	    (0, _createClass3.default)(individualTextScreenPreviewController, [{
	        key: "getScale",
	        value: function getScale() {
	            return Number(this.index) || 1;
	        }
	    }, {
	        key: "getScreenStyle",
	        value: function getScreenStyle() {
	            var scale = this.getScale();
	            var background = this.getBackground();
	            return {
	                width: this.screenWidth / scale + "px",
	                height: this.screenHeight / scale + "px",
	                backgroundImage: background && !this.isVideo(background) ? "url(\"" + background + "\")" : "none"
	            };
	        }
	    }, {
	        key: "getBackground",
	        value: function getBackground() {
	            var background = this.settings.background;
	            return background && background.attachment_file;
	        }
	    }, {
	        key: "isVideo",
	        value: function isVideo(file) {
	            return typeof file === "string" && /\.(mp4|webm|mov)$/i.test(file);
	        }
	    }, {
	        key: "getAreaStyle",
	        value: function getAreaStyle(area) {
	            var box = (0, _individualText.getScreenBox)(area);
	            return {
	                width: box.width + "%",
	                height: box.height + "%",
	                left: box.left + "%",
	                top: box.top + "%"
	            };
	        }
	    }, {
	        key: "getFont",
	        value: function getFont(attachment, fontSize, color) {
	            var family = (0, _fontFace.getAttachmentFontFamily)(attachment, this.onFontLoad);
	            return {
	                fontFamily: family ? "\"" + family + "\", sans-serif" : "sans-serif",
	                fontSize: fontSize / this.getScale() + "px",
	                color: color
	            };
	        }
	    }, {
	        key: "getExplanationStyle",
	        value: function getExplanationStyle() {
	            var explanation = this.settings.explanation;
	            return (0, _assign2.default)(this.getAreaStyle(explanation.area), this.getFont(explanation.font, this.getExplanationFontSize(), explanation.color));
	        }
	
	        /** Lines of the text wrapped by words at maxWidth, with the measure context font. */
	
	    }, {
	        key: "countLines",
	        value: function countLines(text, maxWidth) {
	            var _this2 = this;
	
	            var lines = 1;
	            var line = "";
	            text.split(/\s+/).filter(Boolean).forEach(function (word) {
	                var next = line ? line + " " + word : word;
	                if (line && _this2.measureContext.measureText(next).width > maxWidth) {
	                    lines++;
	                    line = word;
	                } else {
	                    line = next;
	                }
	            });
	            return lines;
	        }
	
	        /**
	         * Like the text on the output picture: the biggest size from fontSize down to minFontSize
	         * at which the wrapped text fits the area (screen px). Text that does not fit at minFontSize is cut.
	         */
	
	    }, {
	        key: "getExplanationFontSize",
	        value: function getExplanationFontSize() {
	            var _this3 = this;
	
	            var explanation = this.settings.explanation;
	            var text = explanation.text || "Explanation";
	            var box = (0, _individualText.getScreenBox)(explanation.area);
	            var width = box.width * this.screenWidth / 100;
	            var height = box.height * this.screenHeight / 100;
	            var family = this.getFont(explanation.font, 1).fontFamily;
	            var fits = function fits(size) {
	                _this3.measureContext.font = size + "px " + family;
	                return _this3.countLines(text, width) * size * EXPLANATION_LINE_HEIGHT <= height && text.split(/\s+/).every(function (word) {
	                    return _this3.measureContext.measureText(word).width <= width;
	                });
	            };
	            var max = Number(explanation.fontSize) || 1;
	            var min = Math.min(Number(explanation.minFontSize) || max, max);
	            if (fits(max)) {
	                return max;
	            }
	            // Binary search of the biggest fitting size, 0.5 px precision
	            var low = min;
	            var high = max;
	            while (high - low > 0.5) {
	                var middle = (low + high) / 2;
	                if (fits(middle)) {
	                    low = middle;
	                } else {
	                    high = middle;
	                }
	            }
	            return low;
	        }
	    }, {
	        key: "getInputStyle",
	        value: function getInputStyle(field) {
	            var style = this.getFont(field.font, field.input.fontSize, field.input.textColor);
	            style.backgroundColor = field.label.color;
	            return style;
	        }
	    }, {
	        key: "getDoneIcon",
	        value: function getDoneIcon() {
	            var icon = this.settings.doneButton.customIcon;
	            return icon && icon.attachment_file || DONE_ICON;
	        }
	
	        /** Areas shown on the screen. */
	
	    }, {
	        key: "getVisibleAreas",
	        value: function getVisibleAreas() {
	            var settings = this.settings;
	            var areas = [settings.outputPreview, settings.doneButton];
	            if (settings.explanation.enabled) {
	                areas.push(settings.explanation.area);
	            }
	            settings.fields.forEach(function (field) {
	                return field.enabled && areas.push(field.area);
	            });
	            return areas;
	        }
	    }, {
	        key: "getGuideStyle",
	        value: function getGuideStyle(axis, value) {
	            return axis === "x" ? { left: value + "%" } : { top: value + "%" };
	        }
	    }, {
	        key: "onDrag",
	        value: function onDrag(area, phase, dx, dy) {
	            if (phase === "start") {
	                this.dragStart = (0, _individualText.getScreenBox)(area);
	                return;
	            }
	            if (phase === "end") {
	                this.guides = { x: [], y: [] };
	                return;
	            }
	            var scale = this.getScale();
	            var start = this.dragStart;
	            var guides = { x: [0, 50, 100], y: [0, 50, 100] };
	            this.getVisibleAreas().filter(function (other) {
	                return other !== area;
	            }).forEach(function (other) {
	                var _guides$x, _guides$y;
	
	                var box = (0, _individualText.getScreenBox)(other);
	                (_guides$x = guides.x).push.apply(_guides$x, (0, _toConsumableArray3.default)((0, _individualText.getBoxGuides)(box.left, box.width)));
	                (_guides$y = guides.y).push.apply(_guides$y, (0, _toConsumableArray3.default)((0, _individualText.getBoxGuides)(box.top, box.height)));
	            });
	            var snapX = (0, _individualText.snapToGuides)(start.left + dx * scale / this.screenWidth * 100, start.width, guides.x, SNAP_DISTANCE * scale / this.screenWidth * 100);
	            var snapY = (0, _individualText.snapToGuides)(start.top + dy * scale / this.screenHeight * 100, start.height, guides.y, SNAP_DISTANCE * scale / this.screenHeight * 100);
	            (0, _individualText.moveScreenArea)(area, snapX.start, snapY.start);
	            (0, _individualText.clampScreenArea)(area);
	            this.guides = {
	                x: snapX.guide === null ? [] : [snapX.guide],
	                y: snapY.guide === null ? [] : [snapY.guide]
	            };
	        }
	    }]);
	    return individualTextScreenPreviewController;
	}(_controller2.default);

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(831);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./individual-text-screen-preview.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./individual-text-screen-preview.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, ".individual-text-screen{position:relative;margin:0 auto;overflow:hidden;background-color:#4a4a4a;background-size:cover;background-position:50%;box-shadow:0 1px 4px rgba(0,0,0,.25)}.individual-text-screen__background{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;pointer-events:none}.individual-text-screen__item{position:absolute;box-sizing:border-box;cursor:move;user-select:none;outline:1px dashed hsla(0,0%,100%,.6)}.individual-text-screen__item:hover{outline-color:#f6264c}.individual-text-screen__explanation,.individual-text-screen__output{display:flex;align-items:center;justify-content:center}.individual-text-screen__explanation{text-align:center;line-height:1.1;overflow:hidden}.individual-text-screen__field{display:flex;flex-direction:column}.individual-text-screen__label{line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.individual-text-screen__input{flex:1;min-height:0;width:100%;margin-top:2px;padding:0 6px;border:none;border-radius:4px;box-sizing:border-box;pointer-events:none;outline:none}.individual-text-screen__done{display:flex;align-items:center;justify-content:center}.individual-text-screen__done img,.individual-text-screen__done video{width:100%;height:100%;object-fit:contain;pointer-events:none}.individual-text-screen__guide{position:absolute;z-index:200;pointer-events:none;background:#f6264c}.individual-text-screen__guide--x{top:0;bottom:0;width:1px}.individual-text-screen__guide--y{left:0;right:0;height:1px}", ""]);
	
	// exports


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.aiHtmlPreviewComponent = undefined;
	
	var _aiHtmlPreview = __webpack_require__(833);
	
	var _aiHtmlPreview2 = __webpack_require__(834);
	
	var _aiHtmlPreview3 = _interopRequireDefault(_aiHtmlPreview2);
	
	__webpack_require__(835);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var aiHtmlPreviewComponent = exports.aiHtmlPreviewComponent = {
	    template: _aiHtmlPreview3.default,
	    controller: _aiHtmlPreview.aiHtmlPreviewController,
	    controllerAs: "ai",
	    bindings: {
	        prWidth: "@",
	        prHeight: "@",
	        index: "@",
	        displaySlider: "<"
	    }
	};

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.aiHtmlPreviewController = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _controller = __webpack_require__(90);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var aiHtmlPreviewController = exports.aiHtmlPreviewController = function (_ActiveController) {
	    aiHtmlPreviewController.$inject = ["$injector", "$rootScope", "$element", "$scope", "$timeout"];
	    (0, _inherits3.default)(aiHtmlPreviewController, _ActiveController);
	
	    function aiHtmlPreviewController($injector, $rootScope, $element, $scope, $timeout) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, aiHtmlPreviewController);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (aiHtmlPreviewController.__proto__ || (0, _getPrototypeOf2.default)(aiHtmlPreviewController)).call(this, $injector));
	
	        _this.$rootScope = $rootScope;
	        _this.$element = angular.element($element);
	        _this.$scope = $scope;
	        _this.$timeout = $timeout;
	        _this.width = 0;
	        _this.height = 0;
	
	        $scope.$watch(function () {
	            return _this.prWidth;
	        }, function () {
	            _this.changeSize();
	        });
	
	        $scope.$watch(function () {
	            return _this.prHeight;
	        }, function () {
	            _this.changeSize();
	        });
	
	        $scope.$watch(function () {
	            return _this.index;
	        }, function () {
	            _this.changeSize();
	        });
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(aiHtmlPreviewController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.changeSize();
	        }
	    }, {
	        key: "changeSize",
	        value: function changeSize() {
	            this.width = Math.round(Number(this.prWidth) / Number(this.index)) + "px";
	            this.height = Math.round(Number(this.prHeight) / Number(this.index)) + "px";
	            if (Number(this.prWidth) > Number(this.prHeight)) {
	                this.bleed = {
	                    width: 1800 / Number(this.index) + "px",
	                    height: 1200 / Number(this.index) + "px",
	                    top: 22 / Number(this.index) + "px",
	                    left: 20 / Number(this.index) + "px"
	                };
	            } else {
	                this.bleed = {
	                    width: 1200 / Number(this.index) + "px",
	                    height: 1800 / Number(this.index) + "px",
	                    top: 20 / Number(this.index) + "px",
	                    left: 22 / Number(this.index) + "px"
	                };
	            }
	        }
	    }]);
	    return aiHtmlPreviewController;
	}(_controller2.default);

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"ai-html-preview-wrapper\"\n         ng-style=\"{width: ai.width, height: ai.height}\"\n         ng-class=\"{'portrait': ai.prHeight > ai.prWidth,'landscape': ai.prHeight < ai.prWidth}\"   >\n    <img src=\"" + __webpack_require__(704) + "\" id=\"ageSlider\" alt=\"age-slider\" ng-if=\"!ai.displaySlider\">\n    <img src=\"" + __webpack_require__(705) + "\" alt=\"persona\" class=\"persona\" ng-if=\"ai.prHeight < ai.prWidth\">\n\n</section>\n";

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(836);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./ai-html-preview.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./ai-html-preview.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, ".ai-html-preview-wrapper{display:flex;background-size:contain;background-position:50%;background-repeat:no-repeat;flex-direction:column-reverse}.ai-html-preview-wrapper.portrait{background-image:url(" + __webpack_require__(837) + ")}.ai-html-preview-wrapper.landscape{background-image:url(" + __webpack_require__(838) + ");position:relative}.ai-html-preview-wrapper.landscape .persona{width:100%;height:100%}.ai-html-preview-wrapper.landscape #ageSlider{position:absolute;width:auto;left:0;right:0}.ai-html-preview-wrapper #ageSlider{width:90%;margin:0 auto;margin-bottom:5px}", ""]);
	
	// exports


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/new-preview-background-portraite.jpeg";

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/BG_Landscape_1920x1080.jpg";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ServicesModule = undefined;
	
	var _auth = __webpack_require__(840);
	
	var _http = __webpack_require__(841);
	
	var _companies = __webpack_require__(842);
	
	var _photoTransform = __webpack_require__(843);
	
	var _toViewValue = __webpack_require__(844);
	
	var _toBoothValue = __webpack_require__(845);
	
	var _service = __webpack_require__(184);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _emailTemplate = __webpack_require__(846);
	
	var _detectChanges = __webpack_require__(848);
	
	var _toast = __webpack_require__(849);
	
	var _undoDelete = __webpack_require__(850);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServicesModule = angular.module("app.services", []).service("$auth", _auth.AuthService).service("$service", _service2.default).service("$companies", _companies.CompaniesService).service("$httpConfigurator", _http.httpConfiguratorService).service("$photoTransform", _photoTransform.PhotoTransformService).service("$ToViewValue", _toViewValue.ToViewValueService).service("$ToBoothValue", _toBoothValue.ToBoothValueService).service("$EmailTemplates", _emailTemplate.EmailTemplateService).service("$DetectChanges", _detectChanges.DetectChangesService).service("$ToastService", _toast.ToastService).service("$UndoDeleteService", _undoDelete.UndoDeleteService).factory("$Company", ["$resource", function ($resource) {
		return $resource("/api/companies/:id/");
	}]).factory("$Users", ["$resource", function ($resource) {
		return $resource("/api/users/:id/");
	}]).factory("$Configuration", ["$resource", function ($resource) {
		return $resource("/api/configurations/:id/");
	}]).factory("$Deployment", ["$resource", function ($resource) {
		return $resource("/api/deployments/:id/");
	}]).factory("$Booth", ["$resource", function ($resource) {
		return $resource("/api/booths/:id/");
	}]).factory("$SetConfigToBooth", ["$resource", function ($resource) {
		return $resource("/api/user-set-current-configuration-to-booth/");
	}]).factory("$Version", ["$resource", function ($resource) {
		return $resource("/api/app-versions/");
	}]).factory("$ApplyAppVersion", ["$resource", function ($resource) {
		return $resource("/api/booth-set-app-version/");
	}]).factory("$ConfigMultiConfig", ["$resource", function ($resource) {
		return $resource("/api/configurations/:id/multi-config/");
	}]).factory("$Forms", ["$resource", function ($resource) {
		return $resource("/api/forms/:id/");
	}]).factory("$BoothList", ["$resource", function ($resource) {
		return $resource("/api/booth-list/");
	}]).factory("$Invitations", ["$resource", function ($resource) {
		return $resource("/api/invitations/");
	}]).factory("$RemoveBg", ["$resource", function ($resource) {
		return $resource("/api/configurations/:id/remove-bg/");
	}]).factory("$Replicate", ["$resource", function ($resource) {
		return $resource("/api/configurations/:id/replicate-remove-bg/");
	}]);
	
	exports.ServicesModule = ServicesModule;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AuthService = undefined;
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(239);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _lodash = __webpack_require__(101);
	
	var _service = __webpack_require__(184);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _reference = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthService = exports.AuthService = function (_ActiveService) {
	    AuthService.$inject = ["$injector", "$httpConfigurator", "$rootScope"];
	    (0, _inherits3.default)(AuthService, _ActiveService);
	
	    /**
	     *
	     * @param $injector
	     * @param $httpConfigurator
	     * @param $rootScope
	     */
	    function AuthService($injector, $httpConfigurator, $rootScope) {
	
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, AuthService);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AuthService.__proto__ || (0, _getPrototypeOf2.default)(AuthService)).call(this, $injector));
	
	        _this.$injector = $injector;
	        _this.$httpConfigurator = $httpConfigurator;
	        _this.$rootScope = $rootScope;
	
	        _this.permission = null;
	
	        if (_this.isAuthenticated()) {
	            _this.$httpConfigurator.setHeaders(_this.getToken());
	        }
	        _this.user = _this.getUser();
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(AuthService, [{
	        key: "getUser",
	        value: function getUser() {
	            var user = this.cacheGet("user");
	            (0, _reference.update)(this.user, user);
	            return user;
	        }
	    }, {
	        key: "isRole",
	        value: function isRole(role) {
	            var user = this.getUser();
	            var roles = user.groups_names;
	            return roles.indexOf(role) !== -1;
	        }
	    }, {
	        key: "setUser",
	        value: function setUser(user) {
	            return this.cacheSet("user", user);
	        }
	    }, {
	        key: "getToken",
	        value: function getToken() {
	            return this.cacheGet("token");
	        }
	    }, {
	        key: "setToken",
	        value: function setToken(token) {
	            return this.cacheSet("token", "Token " + token);
	        }
	
	        /**
	         *
	         * @param state
	         * @returns {boolean}
	         */
	
	    }, {
	        key: "isNull",
	        value: function isNull(state) {
	            return null != state;
	        }
	
	        /**
	         *
	         * @returns {boolean}
	         */
	
	    }, {
	        key: "isAuthenticated",
	        value: function isAuthenticated() {
	            return this.isNull(this.getToken()) && this.isNull(this.getUser());
	        }
	    }, {
	        key: "logout",
	        value: function logout() {
	            var _this2 = this;
	
	            var cacheClear = function cacheClear() {
	                _this2.$httpConfigurator.clearHeaders();
	                _this2.cacheRemove("user");
	                _this2.cacheRemove("token");
	                _this2.cacheRemove("company");
	                _this2.cacheRemove("config");
	                (0, _lodash.defer)(function () {
	                    return window.location.reload();
	                });
	            };
	
	            if (this.isAuthenticated()) {
	                this.post(this.config.API.Logout, {}, { ignore401: true }).finally(function () {
	                    return cacheClear();
	                });
	            }
	        }
	
	        /**
	         *
	         * @returns {*|Promise.<TResult>}
	         */
	
	    }, {
	        key: "me",
	        value: function me() {
	            var _this3 = this;
	
	            return new _promise2.default(function (resolve, reject) {
	                _this3.get(_this3.getUser().url).then(function (user) {
	                    _this3.setUser(user);
	                    (0, _reference.update)(_this3.user, user);
	                    _this3.fetchPermissions(_this3.user).then(function () {
	                        return resolve();
	                    }).catch(function () {
	                        return reject();
	                    });
	                });
	            });
	        }
	    }, {
	        key: "fetchPermissions",
	        value: function fetchPermissions(user) {
	            var _this4 = this;
	
	            return new _promise2.default(function (resolve, reject) {
	                if (user.groups[0]) {
	                    _this4.get(user.groups[0]).then(function (data) {
	                        _this4.permission = data;
	                        _this4.$rootScope.$emit("$updatePermissions", true);
	                        resolve(data);
	                    }).catch(function (err) {
	                        return reject(err);
	                    });
	                } else {
	                    reject();
	                }
	            });
	        }
	    }, {
	        key: "getPermissions",
	        value: function getPermissions() {
	            if (this.permission) {
	                return this.permission.name;
	            }
	        }
	    }, {
	        key: "finalizeLogin",
	        value: function finalizeLogin(data) {
	            if (!data || !data.key || !data.user) {
	                console.error("finalizeLogin: data, key, or user is undefined", data);
	                return _promise2.default.reject(new Error("Invalid data for finalizeLogin"));
	            }
	            this.setToken(data.key);
	            this.setUser(data.user);
	            this.$httpConfigurator.setHeaders(this.getToken());
	            this.user = this.getUser();
	            return this.fetchPermissions(this.user);
	        }
	
	        /**
	         *
	         * @param data
	         * @returns {Function}
	         */
	
	    }, {
	        key: "authenticate",
	        value: function authenticate(data) {
	            var _this5 = this;
	
	            var fromTwoFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            return new _promise2.default(function (resolve, reject) {
	                _this5.post(_this5.config.API.Login, data).then(function (data) {
	                    if (data.requires_2fa) {
	                        resolve(data);
	                        return;
	                    }
	                    if (fromTwoFactor) {
	                        resolve(data);
	                        return;
	                    }
	                    _this5.finalizeLogin(data).then(function () {
	                        return resolve();
	                    }).catch(function (err) {
	                        return console.log(err);
	                    });
	                }).catch(function (errors) {
	                    if (fromTwoFactor) {
	                        _this5.notify.set(_this5.translate(errors.data.detail), "error");
	                    } else {
	                        _this5.notify.set(_this5.translate("Please provide valid email and password"), "error");
	                    }
	                    reject(errors);
	                });
	            });
	        }
	    }, {
	        key: "twoFactorAuthenticationState",
	        value: function twoFactorAuthenticationState(data) {
	            var _this6 = this;
	
	            return new _promise2.default(function (resolve, reject) {
	                _this6.post(_this6.config.API.TwoFactor, data).then(function (resp) {
	                    var user = _this6.getUser();
	                    (0, _assign2.default)(user, { two_factor_enabled: data.enable });
	                    _this6.setUser(user);
	                    resolve(resp);
	                }).catch(function (errors) {
	                    _this6.notify.set(_this6.translate("2Factor Authentication change state is fail."), "error");
	                    reject(errors);
	                });
	            });
	        }
	    }]);
	    return AuthService;
	}(_service2.default);

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.httpConfiguratorService = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var httpConfiguratorService = exports.httpConfiguratorService = function () {
		/**
	  *
	  * @param $http
	  * @param CONFIG
	  */
		httpConfiguratorService.$inject = ["$http", "CONFIG"];
		function httpConfiguratorService($http, CONFIG) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, httpConfiguratorService);
			this.$http = $http;
			this.CONFIG = CONFIG;
			this.sessionKey = "Authorization";
		}
	
		(0, _createClass3.default)(httpConfiguratorService, [{
			key: "setDefaultsHeaders",
			value: function setDefaultsHeaders() {
				var headers = this.$http.defaults.headers;
				var contentType = this.CONFIG.ContentType;
				if (false) {
					this.$http.defaults.headers.common["X-Origin"] = "http://localhost:3000";
				}
				if (undefined === headers.common["Content-Type"]) {
					this.$http.defaults.headers.common["Content-Type"] = contentType;
				}
				if (undefined === headers.Accept) {
					this.$http.defaults.headers.Accept = contentType;
				}
			}
		}, {
			key: "setHeaders",
			value: function setHeaders(token) {
				if (undefined === this.$http.defaults.headers.common[this.sessionKey]) {
					this.$http.defaults.headers.common[this.sessionKey] = token;
				}
			}
		}, {
			key: "clearHeaders",
			value: function clearHeaders() {
				delete this.$http.defaults.headers.common[this.sessionKey];
			}
		}]);
		return httpConfiguratorService;
	}();

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.CompaniesService = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _service = __webpack_require__(184);
	
	var _service2 = _interopRequireDefault(_service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompaniesService = exports.CompaniesService = function (_ActiveService) {
		CompaniesService.$inject = ["$injector", "CONFIG", "$auth"];
		(0, _inherits3.default)(CompaniesService, _ActiveService);
	
		/**
	  *
	  * @param $injector
	  * @param CONFIG
	  * @param $auth
	  */
		function CompaniesService($injector, CONFIG, $auth) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, CompaniesService);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (CompaniesService.__proto__ || (0, _getPrototypeOf2.default)(CompaniesService)).call(this, $injector));
	
			_this.CONFIG = CONFIG;
			_this.$auth = $auth;
			return _this;
		}
	
		(0, _createClass3.default)(CompaniesService, [{
			key: "set",
			value: function set(company) {
				this.cacheSet("company", company);
			}
		}, {
			key: "getCached",
			value: function getCached(key) {
				return this.cacheGet(key ? key : "company");
			}
		}, {
			key: "fetch",
			value: function fetch() {
				var _this2 = this;
	
				return this.get(this.$auth.getUser().company.url).then(function (company) {
					return _this2.cacheSet("company", company);
				});
			}
	
			// async $getCompanyProfiles () {
			// 	return this.activeGet("/api/company-profiles");
			// }
	
		}]);
		return CompaniesService;
	}(_service2.default);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PhotoTransformService = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_MARGIN = 15; // px
	var LARGE_CANVAS_SIDE = 1840; // px
	
	var PhotoTransformService = exports.PhotoTransformService = function () {
	    function PhotoTransformService() {
	        (0, _classCallCheck3.default)(this, PhotoTransformService);
	    }
	
	    (0, _createClass3.default)(PhotoTransformService, [{
	        key: "centrePhoto",
	        value: function centrePhoto(ph) {
	            if (ph.storedHeight > ph.height) {
	                ph.y += Math.round((ph.storedHeight - ph.height) / 2);
	            } else if (ph.storedHeight < ph.height) {
	                ph.y -= Math.round((ph.height - ph.storedHeight) / 2);
	            }
	
	            if (ph.storedWidth > ph.width) {
	                ph.x += Math.round((ph.storedWidth - ph.width) / 2);
	            } else if (ph.storedWidth < ph.width) {
	                ph.x -= Math.round((ph.width - ph.storedWidth) / 2);
	            }
	            return ph;
	        }
	    }, {
	        key: "getMargin",
	        value: function getMargin(arr, type) {
	            var defaultMargin = DEFAULT_MARGIN;
	
	            if (arr.length < 2) {
	                return defaultMargin;
	            }
	
	            var lastEl = arr[arr.length - 1];
	            var prewEl = arr[arr.length - 2];
	
	            var newMargin = 0;
	
	            if (type === "landscape") {
	                newMargin = lastEl.x - (prewEl.x + prewEl.width);
	            } else {
	                newMargin = lastEl.y - (prewEl.y + prewEl.height);
	            }
	
	            return newMargin < defaultMargin ? defaultMargin : newMargin;
	        }
	    }, {
	        key: "removeOverlap",
	        value: function removeOverlap(arr, ratio) {
	
	            if (arr.length <= 1) {
	                return arr;
	            }
	            var type = ratio === "landscape" ? "width" : "height";
	            var cr = ratio === "landscape" ? "x" : "y";
	
	            for (var i = 0; i < arr.length - 1; i++) {
	                var ph1 = arr[i];
	                var ph2 = arr[i + 1];
	
	                if (ph1[type] + ph1[cr] > ph2[cr] + DEFAULT_MARGIN) {
	                    ph2[cr] = ph1[type] + ph1[cr] + DEFAULT_MARGIN;
	                }
	            }
	
	            arr = (0, _lodash.filter)(arr, function (ph) {
	                return ph[cr] + ph[type] <= LARGE_CANVAS_SIDE;
	            });
	
	            return arr;
	        }
	    }]);
	    return PhotoTransformService;
	}();

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ToViewValueService = undefined;
	
	var _isFinite = __webpack_require__(264);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(101);
	
	var _printFormatsConstant = __webpack_require__(279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToViewValueService = exports.ToViewValueService = function () {
	    function ToViewValueService() {
	        (0, _classCallCheck3.default)(this, ToViewValueService);
	    }
	
	    (0, _createClass3.default)(ToViewValueService, [{
	        key: "getArrayOfPrintingPhotos",
	        value: function getArrayOfPrintingPhotos(type, mainConfig) {
	            var transformed = [];
	            // Guard: internalPhotos may be undefined/empty from backend
	            var internalPhotos = mainConfig[type].printFile && mainConfig[type].printFile.internalPhotos || [];
	
	            (0, _lodash.forEach)(internalPhotos, function (ph) {
	                if (ph.name.indexOf("b") === -1) {
	                    transformed.push({
	                        width: ph.size.width,
	                        height: ph.size.height,
	                        x: ph.pos.topX,
	                        y: ph.pos.topY,
	                        angle: ph.rotation,
	                        title: ph.name,
	                        image: true
	                    });
	                }
	            });
	
	            return transformed;
	        }
	    }, {
	        key: "getStrippedPhotos",
	        value: function getStrippedPhotos(type, mainConfig) {
	            var transformed = [];
	            var printFile = mainConfig[type].printFile || {};
	
	            if (!printFile.activePhotoStrip) {
	                return transformed;
	            }
	
	            // Guard for internalPhotos
	            var internalPhotos = printFile.internalPhotos || [];
	            (0, _lodash.forEach)(internalPhotos, function (ph) {
	                if (ph.name.indexOf("b") !== -1) {
	                    transformed.push({
	                        width: ph.size.width,
	                        height: ph.size.height,
	                        x: ph.pos.topX,
	                        y: ph.pos.topY,
	                        angle: ph.rotation,
	                        title: ph.name,
	                        image: true
	                    });
	                }
	            });
	
	            return transformed;
	        }
	    }, {
	        key: "getSharingPhoto",
	        value: function getSharingPhoto(type, mainConfig) {
	            var ph = mainConfig[type].sharingFile;
	            var transformed = [];
	            transformed.push({
	                width: ph.internalPictureSize.width,
	                height: ph.internalPictureSize.height,
	                x: ph.internalPicturePosition.topX,
	                y: ph.internalPicturePosition.topY,
	                angle: ph.internalPictureRotation,
	                video: type === "boomerangBooth",
	                trueVideo: type === "videoBooth",
	                gif: type === "gifBooth",
	                duration: mainConfig[type].playbackSpeed,
	                image: type === "photoBooth"
	            });
	
	            return transformed;
	        }
	
	        /**
	         * Using first photo define ratio
	         * @param type
	         * @returns {string}
	         */
	
	    }, {
	        key: "getPhotoCaptureRatio",
	        value: function getPhotoCaptureRatio(type, mainConfig) {
	            var internalPhotos = mainConfig[type].printFile && mainConfig[type].printFile.internalPhotos || [];
	            var ph = internalPhotos[0];
	
	            // Guard: empty internalPhotos or missing size
	            if (!ph || !ph.size) {
	                return "portrait";
	            }
	            if (ph.size.width / ph.size.height === 1) {
	                return "square";
	            } else if (Math.round(ph.size.width / ph.size.height * 10) === Math.round(2 / 3 * 10)) {
	                return "portrait";
	            } else if (Math.round(ph.size.width / ph.size.height * 10) === Math.round(3 / 2 * 10)) {
	                return "landscape";
	            } else {
	                return "custom";
	            }
	        }
	    }, {
	        key: "getLayoutCaptureRatio",
	        value: function getLayoutCaptureRatio(type, mainConfig) {
	            var ph = mainConfig[type].sharingFile;
	            var settingValue = "finalSize";
	
	            if (ph[settingValue].width / ph[settingValue].height === 1) {
	                return "square";
	            } else if (Math.round(ph[settingValue].width / ph[settingValue].height * 10) === Math.round(2 / 3 * 10)) {
	                return "portrait";
	            } else if (Math.round(ph[settingValue].width / ph[settingValue].height * 10) === Math.round(3 / 2 * 10)) {
	                return "landscape";
	            } else {
	                return "custom";
	            }
	        }
	
	        /**
	         * Resolves layoutAspectRatio (formatId) for view: first printLayoutFormat from config,
	         * else reverse lookup from finalSize. Supports A1–A6, 10×15, 15×20, 2:3, 3:2, 3:4, 4:3.
	         */
	
	    }, {
	        key: "getPrintLayoutRatio",
	        value: function getPrintLayoutRatio(type, mainConfig) {
	            var printFile = mainConfig[type].printFile || {};
	            var setting = printFile.finalSize;
	
	            if (printFile.printLayoutFormat && _printFormatsConstant.PRINT_FORMATS[printFile.printLayoutFormat]) {
	                return printFile.printLayoutFormat;
	            }
	
	            if (!setting || !setting.width || !setting.height) {
	                return "portrait";
	            }
	
	            var _getFormatAndDpiFromP = (0, _printFormatsConstant.getFormatAndDpiFromPixels)(setting.width, setting.height),
	                formatId = _getFormatAndDpiFromP.formatId;
	
	            return formatId;
	        }
	
	        /** Print DPI: from printFile.printDpi or reverse lookup from finalSize, fallback 300. */
	
	    }, {
	        key: "getPrintDpi",
	        value: function getPrintDpi(type, mainConfig) {
	            var printFile = mainConfig[type].printFile || {};
	            if (printFile.printDpi != null) {
	                return printFile.printDpi;
	            }
	            var setting = printFile.finalSize;
	            if (setting && setting.width && setting.height) {
	                var _getFormatAndDpiFromP2 = (0, _printFormatsConstant.getFormatAndDpiFromPixels)(setting.width, setting.height),
	                    dpi = _getFormatAndDpiFromP2.dpi;
	
	                return dpi;
	            }
	            return 300;
	        }
	    }, {
	        key: "getStartScreenValues",
	        value: function getStartScreenValues(values) {
	            var _this = this;
	
	            var modes = ["single", "gif", "boomerang", "video"];
	            (0, _lodash.forEach)(modes, function (mode) {
	                if (values[mode]) {
	                    values[mode].x = typeof values[mode].x === "string" ? _this.toNumber(values[mode].x) : _this.transformFromPixels(values[mode].x + 0.5 * values[mode].width, 1920);
	                    values[mode].y = typeof values[mode].y === "string" ? _this.toNumber(values[mode].y) : _this.transformFromPixels(values[mode].y + 0.5 * values[mode].height, 1080);
	                    values[mode].width = typeof values[mode].width === "string" ? _this.toNumber(values[mode].width) : _this.transformFromPixels(values[mode].width, 900);
	                    values[mode].height = typeof values[mode].height === "string" ? _this.toNumber(values[mode].height) : _this.transformFromPixels(values[mode].height, 900);
	                }
	            });
	
	            return values;
	        }
	    }, {
	        key: "toNumber",
	        value: function toNumber(val) {
	            if (!val) return val;
	            if (val.indexOf("-") !== -1) {
	                var str = val.split("-")[0];
	                return Number(str.replace(/[^0-9.]/g, ""));
	            }
	            return Number(val.replace(/[^0-9.]/g, ""));
	        }
	    }, {
	        key: "transformFromPixels",
	        value: function transformFromPixels(val, percent) {
	            var newVal = null;
	
	            if (!val) return null;
	
	            newVal = val / percent * 100;
	
	            return this.roundHalf(newVal);
	        }
	    }, {
	        key: "roundHalf",
	        value: function roundHalf(num) {
	            return Math.round(num * 2) / 2;
	        }
	    }, {
	        key: "detectAspectRatioObject",
	        value: function detectAspectRatioObject(width, height) {
	            // Перевіряємо, що width і height є числовими значеннями та більшими за нуль
	            if (!(0, _isFinite2.default)(width) || !(0, _isFinite2.default)(height) || width <= 0 || height <= 0) {
	                console.warn("Invalid input to detectAspectRatioObject:", width, height);
	                return { w: 1, h: 1 }; // або повернути null
	            }
	
	            function gcd(a, b) {
	                while (b !== 0) {
	                    var _ref = [b, a % b];
	                    a = _ref[0];
	                    b = _ref[1];
	                }
	                return a;
	            }
	
	            var divisor = gcd(width, height);
	
	            return {
	                w: width / divisor,
	                h: height / divisor
	            };
	        }
	    }, {
	        key: "transformScenes",
	        value: function transformScenes(scenes) {
	            var defaultLogic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	            var screen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	            if (!scenes) {
	                scenes = this.getDefaultScenes();
	            }
	            if (defaultLogic) {
	                scenes.sceneLayoutAspectRatio = this.getSceneLayoutRatio(scenes.finalSize);
	                if (scenes.sceneLayoutAspectRatio === "custom") {
	                    scenes.customLayoutHeight = scenes.pictureAspectRatio.height;
	                    scenes.customLayoutWidth = scenes.pictureAspectRatio.width;
	                }
	                scenes.layoutHeight = scenes.finalSize.height;
	                scenes.layoutWidth = scenes.finalSize.width;
	                scenes.photoAspectRatio = this.getSceneLayoutRatio(scenes.internalPictureSize);
	
	                if (scenes.photoAspectRatio === "custom") {
	                    scenes.customPhotoHeight = scenes.pictureAspectRatio.height;
	                    scenes.customPhotoWidth = scenes.pictureAspectRatio.width;
	                }
	
	                scenes.photos = this.transformScenePhoto(scenes.internalPictureSize, scenes.internalPicturePosition, scenes.internalPictureRotation);
	
	                (0, _lodash.forEach)(scenes.scenesList, function (s) {
	                    s.sceneLayoutAspectRatio = scenes.sceneLayoutAspectRatio;
	                    s.customLayoutHeight = scenes.customLayoutHeight;
	                    s.customLayoutWidth = scenes.customLayoutWidth;
	                    s.layoutHeight = scenes.layoutHeight;
	                    s.layoutWidth = scenes.layoutWidth;
	                    s.photoAspectRatio = scenes.photoAspectRatio;
	                    s.customPhotoHeight = scenes.customPhotoHeight;
	                    s.customPhotoWidth = scenes.customPhotoWidth;
	                    s.photos = scenes.photos;
	                });
	            } else {
	                scenes.sceneLayoutAspectRatio = this.getSceneLayoutRatio(scenes.finalSize);
	                if (scenes.sceneLayoutAspectRatio === "custom") {
	                    scenes.customLayoutHeight = scenes.layoutAspectRatio.height;
	                    scenes.customLayoutWidth = scenes.layoutAspectRatio.width;
	                }
	                scenes.layoutHeight = screen.height;
	                scenes.layoutWidth = screen.width;
	                scenes.photoAspectRatio = "custom";
	
	                if (scenes.photoAspectRatio === "custom") {
	                    scenes.customPhotoHeight = scenes.pictureAspectRatio.height;
	                    scenes.customPhotoWidth = scenes.pictureAspectRatio.width;
	                }
	
	                scenes.photos = this.transformScenePhoto(scenes.internalPictureSize, scenes.internalPicturePosition, scenes.internalPictureRotation);
	
	                (0, _lodash.forEach)(scenes.scenesList, function (s) {
	                    s.sceneLayoutAspectRatio = scenes.sceneLayoutAspectRatio;
	                    s.customLayoutHeight = scenes.customLayoutHeight;
	                    s.customLayoutWidth = scenes.customLayoutWidth;
	                    s.layoutHeight = scenes.layoutHeight;
	                    s.layoutWidth = scenes.layoutWidth;
	                    s.photoAspectRatio = scenes.photoAspectRatio;
	                    s.customPhotoHeight = scenes.customPhotoHeight;
	                    s.customPhotoWidth = scenes.customPhotoWidth;
	                    s.photos = scenes.photos;
	                });
	            }
	
	            return scenes;
	        }
	    }, {
	        key: "getSceneLayoutRatio",
	        value: function getSceneLayoutRatio(size) {
	            if (size.width / size.height === 1) {
	                return "square";
	            } else if (Math.round(size.width / size.height * 10) === Math.round(2 / 3 * 10)) {
	                return "portrait";
	            } else if (Math.round(size.width / size.height * 10) === Math.round(3 / 2 * 10)) {
	                return "landscape";
	            } else {
	                return "custom";
	            }
	        }
	    }, {
	        key: "transformScenePhoto",
	        value: function transformScenePhoto(size, position, rt) {
	            return [{
	                width: size.width,
	                height: size.height,
	                x: position.topX,
	                y: position.topY,
	                image: true,
	                angle: rt
	            }];
	        }
	    }, {
	        key: "getDefaultScenes",
	        value: function getDefaultScenes() {
	            return {
	                enabled: false,
	                finalSize: {
	                    width: 500,
	                    height: 500
	                },
	                internalPictureSize: {
	                    width: 500,
	                    height: 500
	                },
	                layoutAspectRatio: {
	                    width: null,
	                    height: null
	                },
	                pictureAspectRatio: {
	                    width: null,
	                    height: null
	                },
	                internalPicturePosition: {
	                    topX: 0,
	                    topY: 0
	                },
	                internalPictureRotation: 0,
	                scenesList: []
	            };
	        }
	
	        /** Default view: printDpi 300, printCanvas from getPixelsForFormat("portrait",300) — 2:3 with 3mm bleed. */
	
	    }, {
	        key: "getDefaultViewValue",
	        value: function getDefaultViewValue() {
	            var defP = (0, _printFormatsConstant.getPixelsForFormat)("portrait", 300);
	            return {
	                singlePhoto: {
	                    photoCaptureRatio: "custom",
	                    customPhotoWidth: null,
	                    customPhotoHeight: null,
	                    layoutAspectRatio: "portrait",
	                    printDpi: 300,
	                    printCanvasWidth: defP.width,
	                    printCanvasHeight: defP.height,
	                    strip: false,
	                    photosArr: [],
	                    strippedPhotosArr: [],
	                    digitalFormat: {
	                        layoutAspectRatio: "custom",
	                        photos: [{}],
	                        customPhotoWidth: null,
	                        customPhotoHeight: null,
	                        layoutHeight: 500,
	                        layoutWidth: 500
	                    }
	                },
	                gif: {
	                    photoCaptureRatio: "custom",
	                    customPhotoWidth: null,
	                    customPhotoHeight: null,
	                    layoutAspectRatio: "portrait",
	                    printDpi: 300,
	                    printCanvasWidth: defP.width,
	                    printCanvasHeight: defP.height,
	                    strip: true,
	                    photosArr: [],
	                    strippedPhotosArr: [],
	                    digitalFormat: {
	                        layoutAspectRatio: "custom",
	                        photos: [{}],
	                        customPhotoWidth: null,
	                        customPhotoHeight: null,
	                        layoutHeight: 500,
	                        layoutWidth: 500
	                    }
	                },
	                boomerang: {
	                    photoCaptureRatio: "custom",
	                    customPhotoWidth: null,
	                    customPhotoHeight: null,
	                    layoutAspectRatio: "portrait",
	                    printDpi: 300,
	                    printCanvasWidth: defP.width,
	                    printCanvasHeight: defP.height,
	                    strip: true,
	                    photosArr: [],
	                    strippedPhotosArr: [],
	                    digitalFormat: {
	                        layoutAspectRatio: "custom",
	                        photos: [{}],
	                        customPhotoWidth: null,
	                        customPhotoHeight: null,
	                        layoutHeight: 500,
	                        layoutWidth: 500
	                    }
	                },
	                video: {
	                    photoCaptureRatio: "custom",
	                    customPhotoWidth: null,
	                    customPhotoHeight: null,
	                    layoutAspectRatio: "portrait",
	                    printDpi: 300,
	                    printCanvasWidth: defP.width,
	                    printCanvasHeight: defP.height,
	                    strip: true,
	                    photosArr: [],
	                    strippedPhotosArr: [],
	                    digitalFormat: {
	                        layoutAspectRatio: "custom",
	                        photos: [{}],
	                        customPhotoWidth: null,
	                        customPhotoHeight: null,
	                        layoutHeight: 500,
	                        layoutWidth: 500
	                    }
	                }
	            };
	        }
	    }, {
	        key: "getDefaultStartScreenAreas",
	        value: function getDefaultStartScreenAreas() {
	            return {
	                single: {
	                    width: "25vh",
	                    height: "25vh",
	                    y: "60vh",
	                    x: "20vw"
	                },
	                gif: {
	                    width: "25vh",
	                    height: "25vh",
	                    y: "60vh",
	                    x: "40vw"
	                },
	                boomerang: {
	                    width: "25vh",
	                    height: "25vh",
	                    y: "60vh",
	                    x: "60vw"
	                },
	                video: {
	                    width: "25vh",
	                    height: "25vh",
	                    y: "60vh",
	                    x: "80vw"
	                }
	            };
	        }
	    }, {
	        key: "getDefaultLiveViewData",
	        value: function getDefaultLiveViewData() {
	            return {
	                enabled: true,
	                forAllScenes: true,
	                liveViewMode: "regular",
	                liveViewPreviewSize: {
	                    width: 1920,
	                    height: 1080
	                },
	                liveViewBackgroundMode: "color",
	                liveViewBackgroundColor: "#ffffff",
	                liveViewBackground: "",
	                filter: {
	                    enabled: true,
	                    liveViewBackgroundMode: "color",
	                    liveViewBackgroundColor: "#ffffff",
	                    liveViewBackground: ""
	                },
	                output: {
	                    enabled: true,
	                    liveViewBackgroundMode: "color",
	                    liveViewBackgroundColor: "#ffffff",
	                    liveViewBackground: ""
	                },
	                shouldOutputPhotoMirrored: true,
	                hideOutputPictureVideo: false,
	                hideSharingOptions: false,
	                customButtons: {
	                    active: false,
	                    generalUiButtonsSettings: {
	                        back: { width: 4.5, height: 4.5, x: 8, y: 7 },
	                        sharingBackBtn: { width: 3.5, height: 3.5, x: 8, y: 7 },
	                        capture: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                        proceed: { width: 5.5, height: 5.5, x: 92, y: 50 },
	                        email: { width: 5.5, height: 5.5, x: 16.5, y: 88 },
	                        sms: { width: 3.5, height: 3.5, x: 35, y: 88 },
	                        print: { width: 3.5, height: 3.5, x: 45, y: 88 },
	                        done: { width: 6, height: 6, x: 89, y: 92.5 },
	                        qrCode: { width: 7, height: 7, x: 50, y: 11, text: "Scan me to download", textSize: 12, textColor: "black" },
	                        close: { width: 3.5, height: 3.5, x: 5, y: 28 },
	                        next: { width: 5, height: 5, x: 93, y: 50 },
	                        closeError: { width: 5, height: 5, x: 93, y: 50 }
	                    },
	                    captureModeButtonsSettings: {
	                        single: { width: 3.5, height: 3.5, x: 8, y: 44 },
	                        gif: { width: 3.5, height: 3.5, x: 8, y: 49 },
	                        boomerang: { width: 3.5, height: 3.5, x: 8, y: 55 },
	                        scene: { scenePopupColor: "#FFF", width: 36, height: 48, x: 50, y: 57 },
	                        filter: { width: 5, height: 5, x: 8, y: 38 }
	                    }
	                }
	            };
	        }
	    }]);
	    return ToViewValueService;
	}();
	// Format maps, reverse lookup, getPixelsForFormat for layout/DPI

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ToBoothValueService = undefined;
	
	var _toConsumableArray2 = __webpack_require__(91);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToBoothValueService = exports.ToBoothValueService = function () {
	    function ToBoothValueService() {
	        (0, _classCallCheck3.default)(this, ToBoothValueService);
	    }
	
	    (0, _createClass3.default)(ToBoothValueService, [{
	        key: "transformSharingPhoto",
	        value: function transformSharingPhoto(value, main, fullscreenConf) {
	            var defaultLogic = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	            var config = main[value].digitalFormat;
	            var ph = main[value].digitalFormat.photos[0];
	
	            return {
	                finalSize: {
	                    width: fullscreenConf.liveView.liveViewMode === "fullscreen" ? fullscreenConf.general.width : config.layoutWidth,
	                    height: fullscreenConf.liveView.liveViewMode === "fullscreen" ? fullscreenConf.general.height : config.layoutHeight
	                },
	                internalPictureSize: {
	                    width: ph.width,
	                    height: ph.height
	                },
	                internalPicturePosition: {
	                    topX: ph.x,
	                    topY: ph.y
	                },
	                internalPictureRotation: ph.angle,
	                layoutAspectRatio: {
	                    width: defaultLogic ? fullscreenConf.liveView.liveViewMode === "fullscreen" ? fullscreenConf.general.aspectRatio.width : config.customPhotoWidth : this.detectAspectRatioObject(fullscreenConf.general.width, fullscreenConf.general.height).w,
	                    height: defaultLogic ? fullscreenConf.liveView.liveViewMode === "fullscreen" ? fullscreenConf.general.aspectRatio.height : config.customPhotoHeight : this.detectAspectRatioObject(fullscreenConf.general.width, fullscreenConf.general.height).h
	                }
	            };
	        }
	    }, {
	        key: "detectAspectRatioObject",
	        value: function detectAspectRatioObject(width, height) {
	            function gcd(a, b) {
	                return b === 0 ? a : gcd(b, a % b);
	            }
	
	            var divisor = gcd(width, height);
	
	            return {
	                w: width / divisor,
	                h: height / divisor
	            };
	        }
	    }, {
	        key: "transformPhotoAspectRatio",
	        value: function transformPhotoAspectRatio(value, main) {
	            var config = main[value];
	            var transformed = {
	                width: 0,
	                height: 0
	            };
	            switch (config.photoCaptureRatio) {
	                case "portrait":
	                    transformed.width = 2;
	                    transformed.height = 3;
	                    break;
	                case "landscape":
	                    transformed.width = 3;
	                    transformed.height = 2;
	                    break;
	                case "square":
	                    transformed.width = 1;
	                    transformed.height = 1;
	                    break;
	                case "custom":
	                    transformed.width = config.customPhotoWidth;
	                    transformed.height = config.customPhotoHeight;
	            }
	
	            return transformed;
	        }
	
	        /**
	         * View → booth: finalSize, printLayoutFormat, printDpi; internalPhotos ≥1 (fallback one frame on canvas).
	         */
	
	    }, {
	        key: "transformPrintingPhotos",
	        value: function transformPrintingPhotos(value, main) {
	            var config = main[value];
	            var photosArr = [];
	            var transformed = {
	                finalSize: {
	                    width: config.printCanvasWidth,
	                    height: config.printCanvasHeight
	                },
	                framesToPrint: 3,
	                internalPhotos: [],
	                activePhotoStrip: config.strip
	            };
	
	            // New fields for Android/WiFi; old Windows app ignores them
	            if (config.layoutAspectRatio) {
	                transformed.printLayoutFormat = config.layoutAspectRatio;
	            }
	            if (config.printDpi != null) {
	                transformed.printDpi = config.printDpi;
	            }
	
	            if (config.strip) {
	                photosArr = [].concat((0, _toConsumableArray3.default)(config.photosArr), (0, _toConsumableArray3.default)(config.strippedPhotosArr));
	            } else {
	                photosArr = [].concat((0, _toConsumableArray3.default)(config.photosArr));
	            }
	
	            (0, _lodash.forEach)(photosArr, function (ph) {
	                transformed.internalPhotos.push({
	                    size: {
	                        width: ph.width,
	                        height: ph.height
	                    },
	                    pos: {
	                        topX: ph.x,
	                        topY: ph.y
	                    },
	                    rotation: ph.angle,
	                    name: ph.title
	                });
	            });
	
	            // Critical for Electron/FFmpeg: internalPhotos must never be empty
	            if (transformed.internalPhotos.length === 0) {
	                transformed.internalPhotos.push({
	                    pos: { topX: 0, topY: 0 },
	                    size: { width: config.printCanvasWidth, height: config.printCanvasHeight },
	                    rotation: 0,
	                    name: "1"
	                });
	            }
	            return transformed;
	        }
	    }, {
	        key: "transformStartScreenAreas",
	        value: function transformStartScreenAreas(values) {
	            var modes = ["single", "gif", "boomerang", "video"];
	            (0, _lodash.forEach)(modes, function (mode) {
	                if (values[mode]) {
	                    values[mode].x = typeof values[mode].x === "number" ? "calc(" + values[mode].x + "vw - " + values[mode].width / 2 + "vh)" : 0;
	                    values[mode].y = typeof values[mode].y === "number" ? "calc(" + values[mode].y + "vh - " + values[mode].height / 2 + "vh)" : 0;
	                    values[mode].width = typeof values[mode].width === "number" ? values[mode].width + "vh" : 0;
	                    values[mode].height = typeof values[mode].height === "number" ? values[mode].height + "vh" : 0;
	                }
	            });
	
	            return values;
	        }
	    }, {
	        key: "transformScenes",
	        value: function transformScenes(scenes) {
	            var defaultLogic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	            var screen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	            if (defaultLogic) {
	                scenes.finalSize = {
	                    width: scenes.layoutWidth,
	                    height: scenes.layoutHeight
	                };
	                scenes.internalPictureSize = {
	                    width: scenes.photos[0].width,
	                    height: scenes.photos[0].height
	                };
	                scenes.layoutAspectRatio = this.getSceneRatio(scenes.sceneLayoutAspectRatio, scenes.customLayoutWidth, scenes.customLayoutHeight);
	                scenes.pictureAspectRatio = this.getSceneRatio(scenes.photoAspectRatio, scenes.customPhotoWidth, scenes.customPhotoHeight);
	                scenes.internalPicturePosition = {
	                    topX: scenes.photos[0].x,
	                    topY: scenes.photos[0].y
	                };
	                scenes.internalPictureRotation = scenes.photos[0].angle;
	
	                delete scenes.layoutWidth;
	                delete scenes.layoutHeight;
	                delete scenes.photos;
	                delete scenes.sceneLayoutAspectRatio;
	                delete scenes.photoAspectRatio;
	                delete scenes.customPhotoWidth;
	                delete scenes.customPhotoHeight;
	                delete scenes.customLayoutWidth;
	                delete scenes.customLayoutHeight;
	
	                (0, _lodash.forEach)(scenes.scenesList, function (s) {
	                    s.finalSize = scenes.finalSize;
	                    s.internalPictureSize = scenes.internalPictureSize;
	                    s.layoutAspectRatio = scenes.layoutAspectRatio;
	                    s.pictureAspectRatio = scenes.pictureAspectRatio;
	                    s.internalPicturePosition = scenes.internalPicturePosition;
	                    s.internalPictureRotation = scenes.internalPictureRotation;
	
	                    delete s.layoutWidth;
	                    delete s.layoutHeight;
	                    delete s.photos;
	                    delete s.sceneLayoutAspectRatio;
	                    delete s.photoAspectRatio;
	                    delete s.customPhotoWidth;
	                    delete s.customPhotoHeight;
	                    delete s.customLayoutWidth;
	                    delete s.customLayoutHeight;
	                });
	            } else {
	                scenes.finalSize = {
	                    width: screen.width,
	                    height: screen.height
	                };
	                scenes.internalPictureSize = {
	                    width: scenes.photos && scenes.photos.length > 0 ? scenes.photos[0].width : screen.width,
	                    height: scenes.photos && scenes.photos.length > 0 ? scenes.photos[0].height : screen.height
	                };
	                scenes.layoutAspectRatio = this.getSceneRatio(scenes.sceneLayoutAspectRatio, scenes.customLayoutWidth, scenes.customLayoutHeight);
	                scenes.pictureAspectRatio = this.getSceneRatio(scenes.photoAspectRatio, scenes.customPhotoWidth, scenes.customPhotoHeight);
	                scenes.internalPicturePosition = {
	                    topX: 0,
	                    topY: 0
	                };
	                scenes.internalPictureRotation = 0;
	
	                delete scenes.layoutWidth;
	                delete scenes.layoutHeight;
	                delete scenes.photos;
	                delete scenes.sceneLayoutAspectRatio;
	                delete scenes.photoAspectRatio;
	                delete scenes.customPhotoWidth;
	                delete scenes.customPhotoHeight;
	                delete scenes.customLayoutWidth;
	                delete scenes.customLayoutHeight;
	
	                (0, _lodash.forEach)(scenes.scenesList, function (s) {
	                    s.finalSize = scenes.finalSize;
	                    s.internalPictureSize = scenes.internalPictureSize;
	                    s.layoutAspectRatio = scenes.layoutAspectRatio;
	                    s.pictureAspectRatio = scenes.pictureAspectRatio;
	                    s.internalPicturePosition = scenes.internalPicturePosition;
	                    s.internalPictureRotation = scenes.internalPictureRotation;
	
	                    delete s.layoutWidth;
	                    delete s.layoutHeight;
	                    delete s.photos;
	                    delete s.sceneLayoutAspectRatio;
	                    delete s.photoAspectRatio;
	                    delete s.customPhotoWidth;
	                    delete s.customPhotoHeight;
	                    delete s.customLayoutWidth;
	                    delete s.customLayoutHeight;
	                });
	            }
	
	            return scenes;
	        }
	    }, {
	        key: "getSceneRatio",
	        value: function getSceneRatio(ratio, customW, customH) {
	            var transformed = {
	                width: 0,
	                height: 0
	            };
	            switch (ratio) {
	                case "portrait":
	                    transformed.width = 2;
	                    transformed.height = 3;
	                    break;
	                case "landscape":
	                    transformed.width = 3;
	                    transformed.height = 2;
	                    break;
	                case "square":
	                    transformed.width = 1;
	                    transformed.height = 1;
	                    break;
	                case "custom":
	                    transformed.width = customW;
	                    transformed.height = customH;
	            }
	
	            return transformed;
	        }
	
	        /**
	         * Set logo style to value that can be read by booth
	         */
	
	    }, {
	        key: "setLogoStyle",
	        value: function setLogoStyle(val) {
	            var WIDTH_MULTIPLIER = 2.4;
	            var MAX_SIZE = 30;
	
	            var style = {
	                width: val.size * +WIDTH_MULTIPLIER + "%",
	                height: val.size + "%"
	            };
	
	            if (val.position <= 3) {
	                style.top = 5 + (MAX_SIZE - val.size) / 2 + "%";
	            } else {
	                style.bottom = 5 + (MAX_SIZE - val.size) / 2 + "%";
	            }
	
	            if (val.position === 1 || val.position === 4) {
	                style.left = "4%";
	                style.width = val.size * (WIDTH_MULTIPLIER / 2) + "%";
	            } else if (val.position === 3 || val.position === 6) {
	                style.right = "4%";
	                style.width = val.size * (WIDTH_MULTIPLIER / 2) + "%";
	            } else if (val.position === 2 || val.position === 5) {
	                style.left = 50 - val.size * (WIDTH_MULTIPLIER / 2) + "%";
	            }
	
	            return style;
	        }
	    }]);
	    return ToBoothValueService;
	}();

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EmailTemplateService = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _emailTemplates = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailTemplateService = exports.EmailTemplateService = function () {
	    function EmailTemplateService() {
	        (0, _classCallCheck3.default)(this, EmailTemplateService);
	    }
	
	    (0, _createClass3.default)(EmailTemplateService, [{
	        key: "getTemplate",
	        value: function getTemplate(temp, title, text) {
	            var mainTemplate = _emailTemplates.TEMPLATES[temp];
	            mainTemplate = mainTemplate.replace(/###TITLE PLACEHOLDER###/g, title);
	            mainTemplate = mainTemplate.replace(/###TEXT PLACEHOLDER###/g, text);
	
	            return mainTemplate;
	        }
	    }, {
	        key: "replaceItems",
	        value: function replaceItems(template, title, text) {
	            template = template.replace(/<PHOTOS>/g, _emailTemplates.TEMPLATES.photosPreview);
	            template = template.replace(/LIVE_URL/g, "https://live.upreach.com/{{uid}}");
	            template = template.replace(/<TITLE>/g, this.getTitle(title));
	            template = template.replace(/<TEXT>/g, this.getText(text));
	            return template;
	        }
	    }, {
	        key: "getTitle",
	        value: function getTitle(title) {
	            return "<tr>\n\t\t\t<td bgcolor=\"#141414\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td bgcolor=\"#141414\" style=\"font-size:28px; line-height: 33px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color: #ffffff; font-weight: bold; text-align: center; padding-top: 0px; padding-bottom: 0px;\" valign=\"top\" align=\"center\">\n\t\t\t\t\t\t<p>" + title + "</p>\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>";
	        }
	    }, {
	        key: "getText",
	        value: function getText(text) {
	            return "<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n            <tbody>\n        \n                <tr>\n                    <td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n        \n                        <table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n                            <td bgcolor=\"#f5f7f8\" style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#000000; text-align: center; padding-bottom: 25px;\" valign=\"top\" align=\"center\">\n                                <p>" + text + "</p>\n                            </td>\n                        </table>\n                    </td>\n                    <!-- Change the background color in bgcolor=\"insert color here\"-->\n                </tr>\n            </tbody>\n\t    </table>";
	        }
	    }, {
	        key: "addLineBreaks",
	        value: function addLineBreaks(text) {
	            return text.replace(/\n/g, "<br/>");
	        }
	    }, {
	        key: "removeLineBreaks",
	        value: function removeLineBreaks(text) {
	            return text.replace(/<br\/>/g, "\n");
	        }
	    }]);
	    return EmailTemplateService;
	}();

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var TEMPLATES = exports.TEMPLATES = {
		germanInformal: "<!DOCTYPE HTML PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional //EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\">\n<html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">\n<head>\n  <!--[if gte mso 9]><xml>\n   <o:OfficeDocumentSettings>\n    <o:AllowPNG/>\n    <o:PixelsPerInch>96</o:PixelsPerInch>\n   </o:OfficeDocumentSettings>\n  </xml><![endif]-->\n  <meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\">\n  <meta name=\"viewport\" content=\"width=device-width\">\n  <!--[if !mso]><!--><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><!--<![endif]-->\n  <title></title>\n\n</head>\n<body style=\"margin: 0;\">\n\n\n<!-- Upreach black header line -->\n\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\n\t\t<tr>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"\n\t\t\t\t In case you have a program with a 'find-and-replace' funcion,\n\t\t\t\t just 'find' #141414 and 'replace' it with the desired color code -->\n\t\t\t<td bgcolor=\"#141414\" style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;\" valign=\"top\" align=\"center\">\n\t\t\t\t<a href=\"https://upreach.com/?utm_source=sharing-email&utm_medium=header&utm_content=upreach-logo\" target=\"_blank\" rel=\"noopener\">\n\n\t\t\t\t\t<!-- Change the client logo in src=\"insert client logo here\" -->\n\t\t\t\t\t<!-- Or remove the entire <img> tag to remove any logo -->\n\t\t\t\t\t<img style=\"height: 10px; width: 85px; padding-left: 50px;\" title=\"Image\" src=\"https://cloud.upreach.com/assets/upreach-logo-white.png\" alt=\"Image\" width=\"123\" align=\"left\" border=\"0\" />\n\t\t\t\t</a>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td bgcolor=\"#141414\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td bgcolor=\"#141414\" style=\"font-size:28px; line-height: 33px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color: #ffffff; font-weight: bold; text-align: center; padding-top: 0px; padding-bottom: 0px;\" valign=\"top\" align=\"center\">\n\t\t\t\t\t\t<p>###TITLE PLACEHOLDER###</p>\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t<td bgcolor=\"#141414\" style=\"font-size:12px; line-height: 0px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); background-color: #fe8036; text-align: center; padding-top: 4px; padding-bottom: 0px;\" valign=\"top\" align=\"center\">\n\t\t\t\t<!--<img src=\"https://i.ibb.co/Ky1bkFy/gradient-footer-50.jpg\" width=\"300px\">-->\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\t</tbody>\n\t</table>\n\n<!-- end Upreach black header line -->\n    \n<!-- Customer text -->\n\n    <table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td bgcolor=\"#f5f7f8\" style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#000000; text-align: center; padding-bottom: 25px;\" valign=\"top\" align=\"center\">\n\t\t\t\t\t\t<p>###TEXT PLACEHOLDER###</p>\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t</tr>\n\t</tbody>\n\t</table>\n    \n<!-- End of customer text -->\n\n<!-- Customer content goes here -->\n<!-- End of customer content -->\n\n\n\n<!-- Photo from photobooth -->\n\t<!-- wrapper -->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\" bgcolor=\"#f5f7f8\" style=\"padding-left: 10px; padding-right: 10px;\">\n\t<tbody><tr><td valign=\"top\" align=\"center\">\n\n\t<!--[if mso]>\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\">\n\t<![endif]-->\n\t<!--[if !mso]><!-->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\" style=\"width: 100%; max-width: 500px;\">\n\t<!--<![endif]-->\n\t<tbody><tr><td valign=\"top\" align=\"center\">\n\n\t<!--[if mso]>\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\">\n\t<![endif]-->\n\t<!--[if !mso]><!-->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\" style=\"width: 100%; max-width: 500px;\">\n\t<!--<![endif]-->\n\t<tbody>\n        <tr>\n            <td style=\"font-size:12px; text-align: center\" colspan=\"2\">(Vorschau - bitte ans Ende der E-Mail scrollen, um den Video-Anhang herunterzuladen.)</td>\n        </tr>\n\t\t<tr>\n\t\t\t<div style=\"max-height:0;max-width:0;overflow: visible;\">\n\t\t\t\t<td style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 10px; padding-bottom: 10px;\" valign=\"top\" align=\"center\">\n\t\t\t\t\t\t\t<!--[if mso]>\n\t\t\t\t\t\t\t<printimg style=\"height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:print_image\" alt=\"Image\" width=\"dynamic_width_mso\" align=\"top\" border=\"0\"/>\n\t\t\t\t\t\t\t<shareimg style=\"height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:gif_image\" alt=\"Image\" width=\"dynamic_width_mso\" align=\"center\" border=\"0\"/>\n\t\t\t\t\t\t\t<![endif]-->\n\n\t\t\t\t\t\t\t<!--[if !mso]><!-->\n\t\t\t\t\t\t\t<printimg style=\"height: 11px; width: dynamic_width; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:print_image\" alt=\"Image\" width=\"dynamic_width\" align=\"top\" border=\"0\" />\n\t\t\t\t\t\t\t<shareimg style=\"height: 11px; width: dynamic_width; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:gif_image\" alt=\"Image\" width=\"dynamic_width\" align=\"top\" border=\"0\" />\n\t\t\t\t\t\t\t<!--<![endif]-->\n\t\t\t\t</td>\n\t\t\t</div>\n\t\t</tr>\n\t</tbody>\n\t</table>\n\n\t<!-- closing wrapper -->\n\t\t</td></tr></tbody>\n\t</table>\n\t</td></tr></tbody>\n\t</table>\n\n<!-- End Photo from photobooth -->\n\n\n<!-- Upreach general links -->\n\t<table bgcolor=\"#f5f7f8\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\t<strong>So teilst du dein Bild&nbsp;in Social Media:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\t1. Speichere dein Foto&nbsp;lokal auf deinem Ger&auml;t ab\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\t(am Handy: auf das Bild tippen und gedr&uuml;ckt halten)\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\t2. &Ouml;ffne Instagram&#44; WhatsApp&#44; Facebook\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\toder eine andere App deiner Wahl\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\t3. Lade dein Bild hoch - viel Spa&szlig;!\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td align=\"center\" valign=\"middle\" width=\"300\" height=\"40\" style=\"padding: 5px; line-height: 20px;\">\n\t\t\t\t\t\t<a href=\"https://www.instagram.com/\" target=\"_blank\" style=\"background-color: #fe8036ec; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; padding: 10px 40px 10px 40px; margin: 0; font-family:sans-serif; font-size:12px; font-weight:bold; color: #ffffff; width: 202px; line-height: 24px; text-decoration: none;\">\n\t\t\t\t\t\t\tJetzt Instagram \xF6ffnen\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n        </tr>\n\n\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\t</tbody>\n\t</table>\n<!-- End Upreach general links -->\n\n\n\n\n\n\n<!-- Customer logo before footer upreach logo -->\n\t<table bgcolor=\"#f5f7f8\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\t</tbody>\n\t</table>\n<!-- end Customer logo before footer upreach logo -->\n\n\n<!-- Upreach black footer line -->\n\n\t<table bgcolor=\"#f5f7f8\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\n\n\t\t<tr>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t<td bgcolor=\"#141414\" style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;\" valign=\"top\" align=\"center\">\n\n\t\t\t\t<!-- Change the client logo in src=\"insert client logo here\" -->\n\t\t\t\t<!-- Or remove the entire <img> tag to remove any logo -->\n                <a href=\"https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-logo\" target=\"_blank\" rel=\"noopener\">\n                    <img style=\"height: 17.6px; width: auto; padding-bottom: 10px; padding-top: 10px;\" title=\"Image\" src=\"https://cloud.upreach.com/assets/upreach-logo-white.png\" alt=\"Image\" width=\"94\" align=\"center\" border=\"0\" />\n                </a> \n                <p style=\"color: #ffffff; text-align: center; \"><span style=\"font-style: italic;\">Copyright \xA9 2020 UpReach GmbH &amp; Co. KG</span><br>\n                Borsigstr. 27<br>\n                    10115 Berlin-Mitte<br>\n                    <br>\n                    <a href=\"mailto:mail@upreach.com\" style=\"color: #ffffff; text-decoration:underline;\" target=\"_blank\" rel=\"noopener\">mail@upreach.com</a> | <a style=\"text-decoration: underline; color: #ffffff;\" href=\"https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-url\">UpReach.com</a>\n                </p>\n\t\t\t</td>\n\t\t</tr>\n\t\t\n\t</tbody>\n\t</table>\n\t\t\t\t\t\t\t\t\t\n<!-- end UpReach black footer line -->\n\n<!-- UpReach gradient: background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); -->\n\n\n</body>\n</html>",
		germanFormal: "<!DOCTYPE HTML PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional //EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\">\n<html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">\n<head>\n  <!--[if gte mso 9]><xml>\n   <o:OfficeDocumentSettings>\n    <o:AllowPNG/>\n    <o:PixelsPerInch>96</o:PixelsPerInch>\n   </o:OfficeDocumentSettings>\n  </xml><![endif]-->\n  <meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\">\n  <meta name=\"viewport\" content=\"width=device-width\">\n  <!--[if !mso]><!--><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><!--<![endif]-->\n  <title></title>\n\n</head>\n<body style=\"margin: 0;\">\n\n\n<!-- Upreach black header line -->\n\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\n\t\t<tr>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"\n\t\t\t\t In case you have a program with a 'find-and-replace' funcion,\n\t\t\t\t just 'find' #141414 and 'replace' it with the desired color code -->\n\t\t\t<td bgcolor=\"#141414\" style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;\" valign=\"top\" align=\"center\">\n\t\t\t\t<a href=\"https://upreach.com/?utm_source=sharing-email&utm_medium=header&utm_content=upreach-logo\" target=\"_blank\" rel=\"noopener\">\n\n\t\t\t\t\t<!-- Change the client logo in src=\"insert client logo here\" -->\n\t\t\t\t\t<!-- Or remove the entire <img> tag to remove any logo -->\n\t\t\t\t\t<img style=\"height: 10px; width: 85px; padding-left: 50px;\" title=\"Image\" src=\"https://cloud.upreach.com/assets/upreach-logo-white.png\" alt=\"Image\" width=\"94\" align=\"left\" border=\"0\" />\n\t\t\t\t</a>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t<td bgcolor=\"#141414\" style=\"font-size:28px; line-height: 33px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color: #ffffff; font-weight: bold; text-align: center; padding-top: 0px; padding-bottom: 0px;\" valign=\"top\" align=\"center\">\n\t\t\t\t<p>###TITLE PLACEHOLDER###</p>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t<td bgcolor=\"#141414\" style=\"font-size:12px; line-height: 0px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); background-color: #fe8036; text-align: center; padding-top: 4px; padding-bottom: 0px;\" valign=\"top\" align=\"center\">\n\t\t\t\t<!--<img src=\"https://i.ibb.co/Ky1bkFy/gradient-footer-50.jpg\" width=\"300px\">-->\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\t</tbody>\n\t</table>\n\n<!-- end Upreach black header line -->\n\n<!-- Customer text -->\n\n    <table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td bgcolor=\"#f5f7f8\" style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#000000; text-align: center; padding-bottom: 25px;\" valign=\"top\" align=\"center\">\n\t\t\t\t\t\t<p>###TEXT PLACEHOLDER###</p>\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t</tr>\n\t</tbody>\n\t</table>\n    \n<!-- End of customer text -->\n\n<!-- Customer content goes here -->\n<!-- End of customer content -->\n\n\n\n<!-- Photo from photobooth -->\n\t<!-- wrapper -->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\" bgcolor=\"#f5f7f8\" style=\"padding-left: 10px; padding-right: 10px;\">\n\t<tbody><tr><td valign=\"top\" align=\"center\">\n\n\t<!--[if mso]>\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\">\n\t<![endif]-->\n\t<!--[if !mso]><!-->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\" style=\"width: 100%; max-width: 500px;\">\n\t<!--<![endif]-->\n\t<tbody><tr><td valign=\"top\" align=\"center\">\n\n\t<!--[if mso]>\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\">\n\t<![endif]-->\n\t<!--[if !mso]><!-->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\" style=\"width: 100%; max-width: 500px;\">\n\t<!--<![endif]-->\n\t<tbody>\n        <tr>\n            <td style=\"font-size:12px; text-align: center\" colspan=\"2\">(Vorschau - bitte ans Ende der E-Mail scrollen, um den Video-Anhang herunterzuladen.)</td>\n        </tr>\n\t\t<tr>\n\t\t\t<div style=\"max-height:0;max-width:0;overflow: visible;\">\n\t\t\t\t<td style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 10px; padding-bottom: 10px;\" valign=\"top\" align=\"center\">\n\t\t\t\t\t\t\t<!--[if mso]>\n\t\t\t\t\t\t\t<printimg style=\"height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:print_image\" alt=\"Image\" width=\"dynamic_width_mso\" align=\"top\" border=\"0\"/>\n\t\t\t\t\t\t\t<shareimg style=\"height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:gif_image\" alt=\"Image\" width=\"dynamic_width_mso\" align=\"center\" border=\"0\"/>\n\t\t\t\t\t\t\t<![endif]-->\n\n\t\t\t\t\t\t\t<!--[if !mso]><!-->\n\t\t\t\t\t\t\t<printimg style=\"height: 11px; width: dynamic_width; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:print_image\" alt=\"Image\" width=\"dynamic_width\" align=\"top\" border=\"0\" />\n\t\t\t\t\t\t\t<shareimg style=\"height: 11px; width: dynamic_width; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:gif_image\" alt=\"Image\" width=\"dynamic_width\" align=\"top\" border=\"0\" />\n\t\t\t\t\t\t\t<!--<![endif]-->\n\t\t\t\t</td>\n\t\t\t</div>\n\t\t</tr>\n\t</tbody>\n\t</table>\n\n\t<!-- closing wrapper -->\n\t\t</td></tr></tbody>\n\t</table>\n\t</td></tr></tbody>\n\t</table>\n\n<!-- End Photo from photobooth -->\n\n\n<!-- Upreach general links -->\n\t<table bgcolor=\"#f5f7f8\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t<strong>So teilen Sie Ihr Bild in Social Media:</strong>\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t1. Speichern Sie Ihr Foto&nbsp;lokal auf Ihrem Ger&auml;t ab\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t(am Handy: auf das Bild tippen und gedr&uuml;ckt halten)\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t2. &Ouml;ffnen Sie Instagram&#44; WhatsApp&#44; Facebook\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\toder eine andere App Ihrer Wahl\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t3. Laden Sie Ihr Bild hoch - viel Spa\xDF\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td align=\"center\" valign=\"middle\" width=\"300\" height=\"40\" style=\"padding: 5px; line-height: 20px;\">\n\t\t\t\t<a href=\"https://www.instagram.com/\" target=\"_blank\" style=\"background-color: #fe8036ec; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; padding: 10px 40px 10px 40px; margin: 0; font-family:sans-serif; font-size:12px; font-weight:bold; color: #ffffff; width: 202px; line-height: 24px; text-decoration: none;\">\n\t\t\t\t\tJetzt Instagram \xF6ffnen\n\t\t\t\t</a>\n\t\t\t</td>\n        </tr>\n\n\n\t</tbody>\n\t</table>\n<!-- End Upreach general links -->\n\n\n\n\n\n\n<!-- Customer logo before footer upreach logo -->\n\t<table bgcolor=\"#f5f7f8\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\t</tbody>\n\t</table>\n<!-- end Customer logo before footer upreach logo -->\n\n\n<!-- Upreach black footer line -->\n\n\t<table bgcolor=\"#f5f7f8\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\n\n\t\t<tr>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t<td bgcolor=\"#141414\" style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;\" valign=\"top\" align=\"center\">\n\n\t\t\t\t<!-- Change the client logo in src=\"insert client logo here\" -->\n\t\t\t\t<!-- Or remove the entire <img> tag to remove any logo -->\n                <a href=\"https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-logo\" target=\"_blank\" rel=\"noopener\">\n                    <img style=\"height: 17.6px; width: auto; padding-bottom: 10px; padding-top: 10px;\" title=\"Image\" src=\"https://cloud.upreach.com/assets/upreach-logo-white.png\" alt=\"Image\" width=\"94\" align=\"center\" border=\"0\" />\n                </a> \n                <p style=\"color: #ffffff; text-align: center; \"><span style=\"font-style: italic;\">Copyright \xA9 2020 UpReach GmbH &amp; Co. KG</span><br>\n                Borsigstr. 27<br>\n                    10115 Berlin-Mitte<br>\n                    <br>\n                    <a href=\"mailto:mail@upreach.com\" style=\"color: #ffffff; text-decoration:underline;\" target=\"_blank\" rel=\"noopener\">mail@upreach.com</a> | <a style=\"text-decoration: underline; color: #ffffff;\" href=\"https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-url\">UpReach.com</a>\n                </p>\n\t\t\t</td>\n\t\t</tr>\n\t\t\n\t</tbody>\n\t</table>\n\t\t\t\t\t\t\t\t\t\n<!-- end UpReach black footer line -->\n\n<!-- UpReach gradient: background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); -->\n\n\n</body>\n</html>",
		english: "<!DOCTYPE HTML PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional //EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\">\n<html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">\n<head>\n  <!--[if gte mso 9]><xml>\n   <o:OfficeDocumentSettings>\n    <o:AllowPNG/>\n    <o:PixelsPerInch>96</o:PixelsPerInch>\n   </o:OfficeDocumentSettings>\n  </xml><![endif]-->\n  <meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\">\n  <meta name=\"viewport\" content=\"width=device-width\">\n  <!--[if !mso]><!--><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><!--<![endif]-->\n  <title></title>\n\n</head>\n<body style=\"margin: 0;\">\n\n\n<!-- Upreach black header line -->\n\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\n\t\t<tr>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"\n\t\t\t\t In case you have a program with a 'find-and-replace' funcion,\n\t\t\t\t just 'find' #141414 and 'replace' it with the desired color code -->\n\t\t\t<td bgcolor=\"#141414\" style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;\" valign=\"top\" align=\"center\">\n\t\t\t\t<a href=\"https://upreach.com/?utm_source=sharing-email&utm_medium=header&utm_content=upreach-logo\" target=\"_blank\" rel=\"noopener\">\n\n\t\t\t\t\t<!-- Change the client logo in src=\"insert client logo here\" -->\n\t\t\t\t\t<!-- Or remove the entire <img> tag to remove any logo -->\n\t\t\t\t\t<img style=\"height: 10px; width: 85px; padding-left: 50px;\" title=\"Image\" src=\"https://cloud.upreach.com/assets/upreach-logo-white.png\" alt=\"Image\" width=\"123\" align=\"left\" border=\"0\" />\n\t\t\t\t</a>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td bgcolor=\"#141414\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td bgcolor=\"#141414\" style=\"font-size:28px; line-height: 33px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color: #ffffff; font-weight: bold; text-align: center; padding-top: 0px; padding-bottom: 0px;\" valign=\"top\" align=\"center\">\n\t\t\t\t\t\t<p>###TITLE PLACEHOLDER###</p>\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t<td bgcolor=\"#141414\" style=\"font-size:12px; line-height: 0px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); background-color: #fe8036; text-align: center; padding-top: 4px; padding-bottom: 0px;\" valign=\"top\" align=\"center\">\n\t\t\t\t<!--<img src=\"https://i.ibb.co/Ky1bkFy/gradient-footer-50.jpg\" width=\"300px\">-->\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\t</tbody>\n\t</table>\n\n<!-- end Upreach black header line -->\n\n<!-- Customer text -->\n\n    <table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td bgcolor=\"#f5f7f8\" style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#000000; text-align: center; padding-bottom: 25px;\" valign=\"top\" align=\"center\">\n\t\t\t\t\t\t<p>###TEXT PLACEHOLDER###</p>\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t</tr>\n\t</tbody>\n\t</table>\n    \n<!-- End of customer text -->\n\n<!-- Customer content goes here -->\n<!-- End of customer content -->\n\n\n\n<!-- Photo from photobooth -->\n\t<!-- wrapper -->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\" bgcolor=\"#f5f7f8\" style=\"padding-left: 10px; padding-right: 10px;\">\n\t<tbody><tr><td valign=\"top\" align=\"center\">\n\n\t<!--[if mso]>\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\">\n\t<![endif]-->\n\t<!--[if !mso]><!-->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\" style=\"width: 100%; max-width: 500px;\">\n\t<!--<![endif]-->\n\t<tbody><tr><td valign=\"top\" align=\"center\">\n\n\t<!--[if mso]>\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\">\n\t<![endif]-->\n\t<!--[if !mso]><!-->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\" style=\"width: 100%; max-width: 500px;\">\n\t<!--<![endif]-->\n\t<tbody>\n        <tr>\n            <td style=\"font-size:12px; text-align: center\" colspan=\"2\">(Preview - please scroll down to the bottom of the email to download the video attachment.)</td>\n        </tr>\n\t\t<tr>\n\t\t\t<div style=\"max-height:0;max-width:0;overflow: visible;\">\n\t\t\t\t<td style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 10px; padding-bottom: 10px;\" valign=\"top\" align=\"center\">\n\t\t\t\t\t\t\t<!--[if mso]>\n\t\t\t\t\t\t\t<printimg style=\"height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:print_image\" alt=\"Image\" width=\"dynamic_width_mso\" align=\"top\" border=\"0\"/>\n\t\t\t\t\t\t\t<shareimg style=\"height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:gif_image\" alt=\"Image\" width=\"dynamic_width_mso\" align=\"center\" border=\"0\"/>\n\t\t\t\t\t\t\t<![endif]-->\n\n\t\t\t\t\t\t\t<!--[if !mso]><!-->\n\t\t\t\t\t\t\t<printimg style=\"height: 11px; width: dynamic_width; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:print_image\" alt=\"Image\" width=\"dynamic_width\" align=\"top\" border=\"0\" />\n\t\t\t\t\t\t\t<shareimg style=\"height: 11px; width: dynamic_width; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:gif_image\" alt=\"Image\" width=\"dynamic_width\" align=\"top\" border=\"0\" />\n\t\t\t\t\t\t\t<!--<![endif]-->\n\t\t\t\t</td>\n\t\t\t</div>\n\t\t</tr>\n\t</tbody>\n\t</table>\n\n\t<!-- closing wrapper -->\n\t\t</td></tr></tbody>\n\t</table>\n\t</td></tr></tbody>\n\t</table>\n\n<!-- End Photo from photobooth -->\n\n\n<!-- Upreach general links -->\n\t<table bgcolor=\"#f5f7f8\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\t<strong>How to share your image on Social Media:</strong>\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\t1. Save your image locally on your device\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\t(on your phone: tap and hold the image)\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\t2. Open Instagram&#44; WhatsApp&#44; Facebook\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\tor another app of your choice\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t\t3. Upload your image - have fun!\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td align=\"center\" valign=\"middle\" width=\"300\" height=\"40\" style=\"padding: 5px; line-height: 20px;\">\n\t\t\t\t\t\t<a href=\"https://www.instagram.com/\" target=\"_blank\" style=\"background-color: #fe8036ec; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; padding: 10px 40px 10px 40px; margin: 0; font-family:sans-serif; font-size:12px; font-weight:bold; color: #ffffff; width: 202px; line-height: 24px; text-decoration: none;\">\n\t\t\t\t\t\t\tOpen Instagram now\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n        </tr>\n\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\n\t\t<tr>\n\t\t\t<td bgcolor=\"#f5f7f8\" align=\"center\" valign=\"top\">\n\t\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t\t<table style=\"max-width:500px; border:0; text-align:center;\" cellpadding=\"0\" cellspacing=\"0\">\n\t\t\t\t\t<td style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\t\t\t\t\t</td>\n\t\t\t\t</table>\n\t\t\t</td>\n\t\t</tr>\n\n\t</tbody>\n\t</table>\n<!-- End Upreach general links -->\n\n\n\n\n\n\n<!-- Customer logo before footer upreach logo -->\n\t<table bgcolor=\"#f5f7f8\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\t\t<tr>\n\t\t\t<td style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\" width=\"300\">\n\n\t\t\t</td>\n\t\t</tr>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\t</tbody>\n\t</table>\n<!-- end Customer logo before footer upreach logo -->\n\n\n<!-- Upreach black footer line -->\n\n\t<table bgcolor=\"#f5f7f8\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\n\t<tbody>\n\n\t\t<!-- spacer -->\n\t\t<tr>\n\t\t\t<td style=\"font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;\" valign=\"top\" align=\"center\">&nbsp;</td>\n\t\t</tr>\n\n\n\n\t\t<tr>\n\t\t\t<!-- Change the background color in bgcolor=\"insert color here\"-->\n\t\t\t<td bgcolor=\"#141414\" style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;\" valign=\"top\" align=\"center\">\n\n\t\t\t\t<!-- Change the client logo in src=\"insert client logo here\" -->\n\t\t\t\t<!-- Or remove the entire <img> tag to remove any logo -->\n                <a href=\"https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-logo\" target=\"_blank\" rel=\"noopener\">\n                    <img style=\"height: 17.6px; width: auto; padding-bottom: 10px; padding-top: 10px;\" title=\"Image\" src=\"https://cloud.upreach.com/assets/upreach-logo-white.png\" alt=\"Image\" width=\"94\" align=\"center\" border=\"0\" />\n                </a> \n                <p style=\"color: #ffffff; text-align: center; \"><span style=\"font-style: italic;\">Copyright \xA9 2020 UpReach GmbH &amp; Co. KG</span><br>\n                Borsigstr. 27<br>\n                    10115 Berlin-Mitte<br>\n                    <br>\n                    <a href=\"mailto:mail@upreach.com\" style=\"color: #ffffff; text-decoration:underline;\" target=\"_blank\" rel=\"noopener\">mail@upreach.com</a> | <a style=\"text-decoration: underline; color: #ffffff;\" href=\"https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-url\">UpReach.com</a>\n                </p>\n\t\t\t</td>\n\t\t</tr>\n\t\t\n\t</tbody>\n\t</table>\n\t\t\t\t\t\t\t\t\t\n<!-- end UpReach black footer line -->\n\n<!-- UpReach gradient: background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); -->\n\n\n</body>\n</html>",
		photosPreview: "\n    <!-- Photo from photobooth -->\n\t<!-- wrapper -->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\" bgcolor=\"#f5f7f8\" style=\"padding-left: 10px; padding-right: 10px;\">\n\t<tbody><tr><td valign=\"top\" align=\"center\">\n\n\t<!--[if mso]>\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\">\n\t<![endif]-->\n\t<!--[if !mso]><!-->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\" style=\"width: 100%; max-width: 500px;\">\n\t<!--<![endif]-->\n\t<tbody><tr><td valign=\"top\" align=\"center\">\n\n\t<!--[if mso]>\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\">\n\t<![endif]-->\n\t<!--[if !mso]><!-->\n\t<table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"500\" style=\"width: 100%; max-width: 500px;\">\n\t<!--<![endif]-->\n\t<tbody>\n\t\t<tr>\n\t\t\t<div style=\"max-height:0;max-width:0;overflow: visible;\">\n\t\t\t\t<td style=\"font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 10px; padding-bottom: 10px;\" valign=\"top\" align=\"center\">\n\t\t\t\t\t\t\t<!--[if mso]>\n\t\t\t\t\t\t\t<printimg style=\"height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:print_image\" alt=\"Image\" width=\"dynamic_width_mso\" align=\"top\" border=\"0\"/>\n\t\t\t\t\t\t\t<shareimg style=\"height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:gif_image\" alt=\"Image\" width=\"dynamic_width_mso\" align=\"center\" border=\"0\"/>\n\t\t\t\t\t\t\t<![endif]-->\n\n\t\t\t\t\t\t\t<!--[if !mso]><!-->\n\t\t\t\t\t\t\t<printimg style=\"height: 11px; width: dynamic_width; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:print_image\" alt=\"Image\" width=\"dynamic_width\" align=\"top\" border=\"0\" />\n\t\t\t\t\t\t\t<shareimg style=\"height: 11px; width: dynamic_width; height: auto; display: inline-block;\" title=\"Image\" src=\"cid:gif_image\" alt=\"Image\" width=\"dynamic_width\" align=\"top\" border=\"0\" />\n\t\t\t\t\t\t\t<!--<![endif]-->\n\t\t\t\t</td>\n\t\t\t</div>\n\t\t</tr>\n\t</tbody>\n\t</table>\n\n\t<!-- closing wrapper -->\n\t\t</td></tr></tbody>\n\t</table>\n\t</td></tr></tbody>\n\t</table>\n\n<!-- End Photo from photobooth -->"
	};

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DetectChangesService = undefined;
	
	var _assign = __webpack_require__(273);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetectChangesService = exports.DetectChangesService = function () {
	    function DetectChangesService() {
	        (0, _classCallCheck3.default)(this, DetectChangesService);
	    }
	
	    (0, _createClass3.default)(DetectChangesService, [{
	        key: "checkBoothPrintChange",
	        value: function checkBoothPrintChange(newVal, oldVal, newLogo, oldLogo) {
	            var newCloned = (0, _lodash.cloneDeep)(JSON.parse(angular.toJson(newVal)));
	            var oldCloned = (0, _lodash.cloneDeep)(JSON.parse(angular.toJson(oldVal)));
	
	            var newLogoCloned = (0, _lodash.cloneDeep)(JSON.parse(angular.toJson(newLogo)));
	            var oldLogoCloned = (0, _lodash.cloneDeep)(JSON.parse(angular.toJson(oldLogo)));
	
	            if (!(0, _lodash.isEqual)(newLogoCloned, oldLogoCloned)) {
	                return true;
	            }
	
	            if (newCloned.printingBackgroundMode !== oldCloned.printingBackgroundMode) {
	                return true;
	            }
	
	            if (newCloned.printingBackgroundColor !== oldCloned.printingBackgroundColor) {
	                return true;
	            }
	
	            if (!(0, _lodash.isEqual)(newCloned.printingLogos, oldCloned.printingLogos)) {
	                return true;
	            }
	
	            if (!(0, _lodash.isEqual)(newCloned.printFile, oldCloned.printFile)) {
	                return true;
	            }
	
	            if (!(0, _lodash.isEqual)(newCloned.printingOverlayFiles, oldCloned.printingOverlayFiles)) {
	                return true;
	            }
	
	            if (!(0, _lodash.isEqual)(newCloned.printingBackgroundFiles, oldCloned.printingBackgroundFiles)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: "checkBoothSharingChange",
	        value: function checkBoothSharingChange(newVal, oldVal, newLogo, oldLogo) {
	            var newCloned = (0, _lodash.cloneDeep)(JSON.parse(angular.toJson(newVal)));
	            var oldCloned = (0, _lodash.cloneDeep)(JSON.parse(angular.toJson(oldVal)));
	
	            var newLogoCloned = (0, _lodash.cloneDeep)(JSON.parse(angular.toJson(newLogo)));
	            var oldLogoCloned = (0, _lodash.cloneDeep)(JSON.parse(angular.toJson(oldLogo)));
	
	            if (!(0, _lodash.isEqual)(newLogoCloned, oldLogoCloned) && newCloned.startScreenDesignSharing) {
	                return true;
	            }
	
	            if (newCloned.startScreenDesignSharing !== oldCloned.startScreenDesignSharing) {
	                return true;
	            }
	
	            if (newCloned.playbackSpeed && oldCloned.playbackSpeed && newCloned.playbackSpeed !== oldCloned.playbackSpeed) {
	                return true;
	            }
	
	            if (newCloned.captureTime && oldCloned.captureTime && newCloned.captureTime !== oldCloned.captureTime) {
	                return true;
	            }
	
	            if (newCloned.sharingBackgroundMode !== oldCloned.sharingBackgroundMode && newCloned.startScreenDesignSharing) {
	                return true;
	            }
	
	            if (newCloned.sharingBackgroundColor !== oldCloned.sharingBackgroundColor && newCloned.startScreenDesignSharing) {
	                return true;
	            }
	
	            if (!(0, _lodash.isEqual)(newCloned.sharingLogos, oldCloned.sharingLogos) && newCloned.startScreenDesignSharing) {
	                return true;
	            }
	
	            if (!(0, _lodash.isEqual)(newCloned.sharingLogoAreas, oldCloned.sharingLogoAreas) && newCloned.startScreenDesignSharing) {
	                return true;
	            }
	
	            if (!(0, _lodash.isEqual)(newCloned.sharingFile, oldCloned.sharingFile)) {
	                return true;
	            }
	
	            if (!(0, _lodash.isEqual)(newCloned.sharingBackgroundFiles, oldCloned.sharingBackgroundFiles)) {
	                return true;
	            }
	
	            if (!(0, _lodash.isEqual)(newCloned.sharingOverlayFiles, oldCloned.sharingOverlayFiles)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: "detectScenesChanges",
	        value: function detectScenesChanges(newScenes, oldScenes) {
	            if (!oldScenes || !oldScenes.scenesList || !oldScenes.scenesList.length) {
	                return newScenes;
	            }
	            if (!newScenes || !newScenes.scenesList || !newScenes.scenesList.length) {
	
	                return newScenes;
	            }
	            (0, _lodash.forEach)(newScenes.scenesList, function (s) {
	                var oldScene = (0, _lodash.find)(oldScenes.scenesList, { timestamp: s.timestamp });
	                delete s.updateScene;
	                if (oldScene) {
	                    delete oldScene.updateScene;
	                }
	                if (!oldScene) {
	                    s.updateScene = true;
	                } else {
	                    s.updateScene = !(0, _lodash.isEqual)(s, oldScene);
	                }
	                if (s.updateScene) {
	                    console.log("Scene \"" + s.title + "\" will be updated");
	                }
	            });
	
	            if (newScenes.scenesBtnTitleShow && (newScenes.sceneBtnTitle === undefined || newScenes.sceneBtnTitle.length < 1)) {
	                (0, _assign2.default)(newScenes, { scenesBtnTitleShow: false, sceneBtnTitle: "" });
	            }
	
	            return newScenes;
	        }
	    }]);
	    return DetectChangesService;
	}();

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ToastService = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _service = __webpack_require__(184);
	
	var _service2 = _interopRequireDefault(_service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToastService = exports.ToastService = function (_ActiveService) {
	    ToastService.$inject = ["$injector", "$mdToast"];
	    (0, _inherits3.default)(ToastService, _ActiveService);
	
	    /**
	     *
	     * @param $injector
	     */
	    function ToastService($injector, $mdToast) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, ToastService);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ToastService.__proto__ || (0, _getPrototypeOf2.default)(ToastService)).call(this, $injector));
	
	        _this.$mdToast = $mdToast;
	        return _this;
	    }
	
	    (0, _createClass3.default)(ToastService, [{
	        key: "showSimple",
	        value: function showSimple(text, hideIn) {
	            this.$mdToast.show(this.$mdToast.simple().position("bottom right").hideDelay(hideIn).textContent(text));
	        }
	    }, {
	        key: "showError",
	        value: function showError(text, hideIn) {
	            var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "bottom right";
	
	            this.$mdToast.show(this.$mdToast.simple().position(position).hideDelay(hideIn).toastClass("error").textContent(text));
	        }
	    }, {
	        key: "deleteToast",
	        value: function deleteToast(text, callback) {
	            var toast = this.$mdToast.simple().textContent(text).action("UNDO").position("bottom right").hideDelay(15000);
	
	            this.$mdToast.show(toast).then(function (response) {
	                if (response === "ok") {
	                    callback();
	                } else {
	                    console.log("Toast dismissed.");
	                }
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }]);
	    return ToastService;
	}(_service2.default);

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UndoDeleteService = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _service = __webpack_require__(184);
	
	var _service2 = _interopRequireDefault(_service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UndoDeleteService = exports.UndoDeleteService = function (_ActiveService) {
	    UndoDeleteService.$inject = ["$injector", "$auth", "$q"];
	    (0, _inherits3.default)(UndoDeleteService, _ActiveService);
	
	    /**
	     *
	     * @param $injector
	     */
	    function UndoDeleteService($injector, $auth, $q) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, UndoDeleteService);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (UndoDeleteService.__proto__ || (0, _getPrototypeOf2.default)(UndoDeleteService)).call(this, $injector));
	
	        _this.$auth = $auth;
	        _this.$q = $q;
	        return _this;
	    }
	
	    (0, _createClass3.default)(UndoDeleteService, [{
	        key: "undoDelete",
	        value: function undoDelete(collection, id) {
	            var _this2 = this;
	
	            return this.$auth.$http({
	                url: "/api/" + collection + "/" + id + "/undo_delete/?all=true",
	                method: "PUT"
	            }).then(function () {
	                _this2.$q.resolve();
	            }).catch(function () {
	                _this2.$q.reject();
	            });
	        }
	    }]);
	    return UndoDeleteService;
	}(_service2.default);

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DirectivesModule = undefined;
	
	var _getModulesNames = __webpack_require__(1);
	
	var _getModulesNames2 = _interopRequireDefault(_getModulesNames);
	
	var _detectDevice = __webpack_require__(852);
	
	var _keepWidth = __webpack_require__(853);
	
	var _validator = __webpack_require__(854);
	
	var _confirmPassword = __webpack_require__(856);
	
	var _dragMove = __webpack_require__(857);
	
	var _colorEyedropper = __webpack_require__(858);
	
	var _availableSize = __webpack_require__(860);
	
	var _permissions = __webpack_require__(861);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DirectivesModule = exports.DirectivesModule = angular.module("app.directives", (0, _getModulesNames2.default)([])).directive("detectDevice", _detectDevice.detectDeviceDirective.create).directive("keepWidth", _keepWidth.keepWidthDirective.create).directive("permissionShow", _permissions.permissionShow.create).directive("permissionHide", _permissions.permissionHide.create).directive("permissionReadonly", _permissions.permissionReadonly.create).directive("validateJson", _validator.validateJsonDirective.create).directive("matchPassword", _confirmPassword.confirmPassword.create).directive("dragMove", _dragMove.dragMoveDirective.create).directive("colorEyedropper", _colorEyedropper.colorEyedropperDirective.create).directive("availableSize", _availableSize.availableSizeDirective.create);

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.detectDeviceDirective = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var detectDeviceDirective = function () {
		detectDeviceDirective.$inject = ["$uris"];
		function detectDeviceDirective($uris) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, detectDeviceDirective);
			this.$uris = $uris;
	
			this.restrict = "A";
		}
	
		(0, _createClass3.default)(detectDeviceDirective, [{
			key: "link",
			value: function link(scope, element) {
	
				angular.element(element).addClass(this.$uris.APP + "-app");
			}
		}], [{
			key: "create",
			value: function create() {
				return new (Function.prototype.bind.apply(detectDeviceDirective, [null].concat(Array.prototype.slice.call(arguments))))();
			}
		}]);
		return detectDeviceDirective;
	}();
	
	detectDeviceDirective.create.$inject = ["$uris"];
	
	exports.detectDeviceDirective = detectDeviceDirective;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.keepWidthDirective = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var keepWidthDirective = function () {
	    keepWidthDirective.$inject = ["$timeout"];
	    function keepWidthDirective($timeout) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, keepWidthDirective);
	        this.restrict = "A";
	        this.$timeout = $timeout;
	    }
	
	    (0, _createClass3.default)(keepWidthDirective, [{
	        key: "link",
	        value: function link(scope, element, attrs) {
	            this.$timeout(function () {
	                var width = element.prop("offsetWidth");
	                var otherCss = element.css("cssText");
	                attrs.$set("style", "width: " + (width + 32) + "px;" + otherCss);
	            });
	        }
	    }], [{
	        key: "create",
	        value: function create() {
	            return new (Function.prototype.bind.apply(keepWidthDirective, [null].concat(Array.prototype.slice.call(arguments))))();
	        }
	    }]);
	    return keepWidthDirective;
	}();
	
	keepWidthDirective.create.$inject = ["$timeout"];
	
	exports.keepWidthDirective = keepWidthDirective;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.validateJsonDirective = exports.validatorSelectDirective = exports.validatorDirective = exports.validatorButtonDirective = undefined;
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	
	var patterns = {
		'post_code': new RegExp(/^\d{2}-\d{3}$/),
		'vat_id': new RegExp(/^[a-zA-Z]{2}?[0-9]{10}$/),
		'email': new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
		'decimal': new RegExp(/^(\d+\.?\d{0,9}|\.\d{1,9})$/)
	};
	
	var examples = {
		"post_code": "xx-xxx",
		"vat_id": "XX1234567890",
		"email": "example@example.com",
		"required": "Pole wymagane",
		"decimal": "12,22"
	};
	
	var validatorDirective = function () {
		function validatorDirective() {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, validatorDirective);
			this.restrict = "A";
		}
	
		/**
	  *
	  * @param scope
	  * @param element
	  * @param attribute
	  */
	
	
		(0, _createClass3.default)(validatorDirective, [{
			key: 'link',
			value: function link(scope, element, attribute) {
	
				try {
					var formGroup = element.parent(),
					    label = formGroup.find("label"),
					    input = formGroup.find("input"),
					    labelText = null;
	
					element.on("keyup focus blur", function (event) {
						var validator = attribute.validator,
						    pattern = patterns[validator],
						    errorText = examples[validator];
	
						var value = event.currentTarget.value;
						var valid = void 0;
						if (validator === "required") {
							valid = !!value.length;
						} else if (validator === "") {
							valid = true;
						} else {
							valid = pattern.test(value);
						}
	
						if (attribute.min && parseInt(value) < parseInt(attribute.min)) {
							event.currentTarget.value = attribute.min;
						}
	
						if (attribute.max && parseInt(value) > parseInt(attribute.max)) {
							event.currentTarget.value = attribute.max;
						}
	
						if (!labelText) {
							labelText = label.text();
						}
	
						if (valid) {
							input.removeAttr("placeholder");
							formGroup.removeClass("has-error");
						} else {
							input.attr("placeholder", errorText);
							formGroup.addClass("has-error");
						}
					});
				} catch (e) {
					console.log(e);
				}
			}
		}], [{
			key: 'create',
			value: function create() {
				return new validatorDirective();
			}
		}]);
		return validatorDirective;
	}();
	
	var validatorButtonDirective = function () {
		function validatorButtonDirective() {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, validatorButtonDirective);
			this.restrict = "A";
		}
	
		/**
	  *
	  * @param scope
	  * @param element
	  * @param attribute
	  */
	
	
		(0, _createClass3.default)(validatorButtonDirective, [{
			key: 'link',
			value: function link(scope, element, attribute) {
	
				var container = $('form[name="' + attribute.validatorButton + '"]'),
				    parentScope = attribute.validatorButton.split("_")[0];
	
				if (!container.length) {
					container = $('[id="' + attribute.validatorButton + '"]');
				}
	
				element.on("click", function (e) {
					var inputs = container.find("input.form-control").not(".ng-hide");
	
					try {
						scope.$parent[parentScope].formIsValid = true;
					} catch (e) {}
	
					var typeheads = container.find(".ui-select-container").not(".ng-hide");
	
					angular.forEach(inputs, function (input) {
						if (input) {
							input.focus();
						}
					});
	
					angular.forEach(typeheads, function (typehead) {
						var _t = angular.element(typehead);
						if (_t.hasClass("ng-not-empty") || _t.attr("validator-select") == "false") {
							_t.removeClass("has-error");
						} else {
							_t.addClass("has-error");
						}
					});
	
					if (container.find(".has-error").length) {
	
						container.find('.has-error input:visible')[0].focus();
	
						try {
							scope.$parent[parentScope].formIsValid = false;
						} catch (e) {}
	
						e.preventDefault();
						e.stopPropagation();
	
						return false;
					}
				});
			}
		}], [{
			key: 'create',
			value: function create() {
				return new (Function.prototype.bind.apply(validatorButtonDirective, [null].concat(Array.prototype.slice.call(arguments))))();
			}
		}]);
		return validatorButtonDirective;
	}();
	
	var validatorSelectDirective = function () {
		function validatorSelectDirective() {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, validatorSelectDirective);
			this.restrict = "A";
			this.require = "uiSelect";
		}
	
		(0, _createClass3.default)(validatorSelectDirective, [{
			key: 'link',
			value: function link(scope, element, attributes, $select) {
	
				if (attributes.validatorSelect == "false") {
					return false;
				}
	
				var selected = void 0,
				    focus = void 0;
				scope.$watchGroup(["$select.selected", "$select.focus"], function (data) {
					selected = data[0];
					focus = data[1];
					if (!selected && focus) {
						element.addClass("has-error");
					}
					if ((typeof selected === 'undefined' ? 'undefined' : (0, _typeof3.default)(selected)) === "object" && focus) {
						element.removeClass("has-error");
					}
				});
			}
		}], [{
			key: 'create',
			value: function create() {
				return new (Function.prototype.bind.apply(validatorSelectDirective, [null].concat(Array.prototype.slice.call(arguments))))();
			}
		}]);
		return validatorSelectDirective;
	}();
	
	var validateJsonDirective = function () {
		function validateJsonDirective() {
			(0, _classCallCheck3.default)(this, validateJsonDirective);
	
			this.restrict = "A";
			this.require = "ngModel";
		}
	
		(0, _createClass3.default)(validateJsonDirective, [{
			key: 'link',
			value: function link(scope, element, attr, ctrl) {
	
				var customValidator = function customValidator(ngModelValue) {
					try {
						if (ngModelValue !== undefined && ngModelValue !== "" && ngModelValue !== null) {
							JSON.parse(ngModelValue);
							ctrl.$setValidity('jsonValidator', true);
						} else {
							ctrl.$setValidity('jsonValidator', true);
						}
					} catch (e) {
						ctrl.$setValidity('jsonValidator', false);
					}
					return ngModelValue;
				};
	
				ctrl.$parsers.push(customValidator);
			}
		}], [{
			key: 'create',
			value: function create() {
				return new (Function.prototype.bind.apply(validateJsonDirective, [null].concat(Array.prototype.slice.call(arguments))))();
			}
		}]);
		return validateJsonDirective;
	}();
	
	exports.validatorButtonDirective = validatorButtonDirective;
	exports.validatorDirective = validatorDirective;
	exports.validatorSelectDirective = validatorSelectDirective;
	exports.validateJsonDirective = validateJsonDirective;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(855)))

/***/ }),
/* 855 */,
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.confirmPassword = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var confirmPassword = function () {
	    confirmPassword.$inject = ["$compile"];
	    function confirmPassword($compile) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, confirmPassword);
	        this.$compile = $compile;
	        this.scope = {
	            otherModelValue: "=matchPassword"
	        };
	    }
	
	    (0, _createClass3.default)(confirmPassword, [{
	        key: "link",
	        value: function link(scope, element) {
	            var ngModel = angular.element(element).controller("ngModel");
	
	            ngModel.$validators.matchPassword = function (modelValue) {
	                return modelValue === scope.otherModelValue;
	            };
	
	            scope.$watch("otherModelValue", function () {
	                ngModel.$validate();
	            });
	        }
	    }], [{
	        key: "create",
	        value: function create() {
	            return new (Function.prototype.bind.apply(confirmPassword, [null].concat(Array.prototype.slice.call(arguments))))();
	        }
	    }]);
	    return confirmPassword;
	}();
	
	exports.confirmPassword = confirmPassword;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.dragMoveDirective = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Mouse drag for positioning preview elements.
	 * Evaluates the expression with $phase ("start" | "move" | "end") and $dx/$dy:
	 * the pointer offset in screen px from where the drag started.
	 * Usage: <div drag-move="ctrl.onDrag(item, $phase, $dx, $dy)"></div>
	 */
	var dragMoveDirective = function () {
	    dragMoveDirective.$inject = ["$parse"];
	    function dragMoveDirective($parse) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, dragMoveDirective);
	        this.restrict = "A";
	        this.$parse = $parse;
	    }
	
	    (0, _createClass3.default)(dragMoveDirective, [{
	        key: "link",
	        value: function link(scope, element, attrs) {
	            var handler = this.$parse(attrs.dragMove);
	            var startX = 0;
	            var startY = 0;
	
	            var call = function call(phase, event) {
	                scope.$applyAsync(function () {
	                    return handler(scope, {
	                        $phase: phase,
	                        $dx: event.clientX - startX,
	                        $dy: event.clientY - startY
	                    });
	                });
	            };
	            var onMove = function onMove(event) {
	                event.preventDefault();
	                call("move", event);
	            };
	            var onUp = function onUp(event) {
	                document.removeEventListener("mousemove", onMove);
	                document.removeEventListener("mouseup", onUp);
	                call("end", event);
	            };
	            var onDown = function onDown(event) {
	                if (event.button !== 0 || /^(INPUT|TEXTAREA|SELECT)$/.test(event.target.tagName)) {
	                    return;
	                }
	                event.preventDefault();
	                event.stopPropagation();
	                startX = event.clientX;
	                startY = event.clientY;
	                call("start", event);
	                document.addEventListener("mousemove", onMove);
	                document.addEventListener("mouseup", onUp);
	            };
	
	            element.on("mousedown", onDown);
	            scope.$on("$destroy", function () {
	                element.off("mousedown", onDown);
	                document.removeEventListener("mousemove", onMove);
	                document.removeEventListener("mouseup", onUp);
	            });
	        }
	    }], [{
	        key: "create",
	        value: function create() {
	            return new (Function.prototype.bind.apply(dragMoveDirective, [null].concat(Array.prototype.slice.call(arguments))))();
	        }
	    }]);
	    return dragMoveDirective;
	}();
	
	dragMoveDirective.create.$inject = ["$parse"];
	
	exports.dragMoveDirective = dragMoveDirective;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.colorEyedropperDirective = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _tinycolor = __webpack_require__(859);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds an eyedropper button to the panel of an angularjs-color-picker, like the native color input has.
	 * Uses the browser EyeDropper API (Chrome, Edge); where it is missing, no button is added.
	 * Usage: <color-picker ng-model="ctrl.color" options="ctrl.pickerOptions" color-eyedropper></color-picker>
	 */
	var colorEyedropperDirective = function () {
	    colorEyedropperDirective.$inject = ["$timeout"];
	    function colorEyedropperDirective($timeout) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, colorEyedropperDirective);
	        this.restrict = "A";
	        this.require = "ngModel";
	        this.$timeout = $timeout;
	    }
	
	    (0, _createClass3.default)(colorEyedropperDirective, [{
	        key: "link",
	        value: function link(scope, element, attrs, ngModel) {
	            if (!("EyeDropper" in window)) {
	                return;
	            }
	            var button = angular.element("<button type=\"button\" class=\"color-picker-action color-eyedropper\" tabindex=\"-1\" title=\"Pick a color from the screen\">" + "<i class=\"material-icons\">colorize</i></button>");
	            var onClick = function onClick(event) {
	                event.preventDefault();
	                new window.EyeDropper().open().then(function (result) {
	                    // Chrome can return "rgba(...)" instead of a hex string
	                    var color = (0, _tinycolor2.default)(result.sRGBHex);
	                    if (color.isValid()) {
	                        scope.$applyAsync(function () {
	                            return ngModel.$setViewValue(color.toHexString());
	                        });
	                    }
	                })
	                // Closed with Escape
	                .catch(angular.noop);
	            };
	            button.on("click", onClick);
	
	            // The picker template is rendered by its own directive: wait for its panel
	            this.$timeout(function () {
	                var actions = element[0].querySelector(".color-picker-actions");
	                if (actions) {
	                    angular.element(actions).append(button);
	                }
	            });
	
	            scope.$on("$destroy", function () {
	                return button.off("click", onClick);
	            });
	        }
	    }], [{
	        key: "create",
	        value: function create() {
	            return new (Function.prototype.bind.apply(colorEyedropperDirective, [null].concat(Array.prototype.slice.call(arguments))))();
	        }
	    }]);
	    return colorEyedropperDirective;
	}(); // Dependency of angularjs-color-picker
	
	
	colorEyedropperDirective.create.$inject = ["$timeout"];
	
	exports.colorEyedropperDirective = colorEyedropperDirective;

/***/ }),
/* 859 */,
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.availableSizeDirective = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Writes the free space for an element's content: {width: its width, height: the window height} (px),
	 * and updates it when the element or the window is resized.
	 * Usage: <div available-size="ctrl.previewSpace"></div>
	 */
	var availableSizeDirective = function () {
	    availableSizeDirective.$inject = ["$parse"];
	    function availableSizeDirective($parse) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, availableSizeDirective);
	        this.restrict = "A";
	        this.$parse = $parse;
	    }
	
	    (0, _createClass3.default)(availableSizeDirective, [{
	        key: "link",
	        value: function link(scope, element, attrs) {
	            var model = this.$parse(attrs.availableSize);
	            var update = function update() {
	                var size = { width: element[0].clientWidth, height: window.innerHeight };
	                var current = model(scope);
	                if (!current || current.width !== size.width || current.height !== size.height) {
	                    scope.$applyAsync(function () {
	                        return model.assign(scope, size);
	                    });
	                }
	            };
	
	            update();
	            window.addEventListener("resize", update);
	            var observer = window.ResizeObserver ? new window.ResizeObserver(update) : null;
	            if (observer) {
	                observer.observe(element[0]);
	            }
	
	            scope.$on("$destroy", function () {
	                window.removeEventListener("resize", update);
	                if (observer) {
	                    observer.disconnect();
	                }
	            });
	        }
	    }], [{
	        key: "create",
	        value: function create() {
	            return new (Function.prototype.bind.apply(availableSizeDirective, [null].concat(Array.prototype.slice.call(arguments))))();
	        }
	    }]);
	    return availableSizeDirective;
	}();
	
	availableSizeDirective.create.$inject = ["$parse"];
	
	exports.availableSizeDirective = availableSizeDirective;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.permissionReadonly = exports.permissionHide = exports.permissionShow = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _toUpper2 = __webpack_require__(862);
	
	var _toUpper3 = _interopRequireDefault(_toUpper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var permissionHide = function () {
		function permissionHide($auth, $rootScope) {
			(0, _classCallCheck3.default)(this, permissionHide);
	
			this.$auth = $auth;
			this.$rootScope = $rootScope;
			this.restrict = "A";
		}
	
		(0, _createClass3.default)(permissionHide, [{
			key: "checkGroup",
			value: function checkGroup(groups) {
				var grps = groups.split(",").map(function (el) {
					return (0, _toUpper3.default)(el);
				});
				return grps.indexOf((0, _toUpper3.default)(this.$auth.getPermissions())) > -1;
			}
		}, {
			key: "link",
			value: function link(scope, element, attributes) {
				var _this = this;
	
				var checkPermission = function checkPermission() {
					element = angular.element(element);
					if (_this.checkGroup(attributes["permissionHide"])) {
						element.remove();
					} else {
						element.removeClass("hidden");
					}
				};
	
				this.$rootScope.$on("$updatePermissions", function () {
					checkPermission();
				});
				checkPermission();
			}
		}], [{
			key: "create",
			value: function create() {
				return new (Function.prototype.bind.apply(permissionHide, [null].concat(Array.prototype.slice.call(arguments))))();
			}
		}]);
		return permissionHide;
	}();
	
	var permissionShow = function () {
		function permissionShow($auth, $rootScope) {
			(0, _classCallCheck3.default)(this, permissionShow);
	
			this.$auth = $auth;
			this.$rootScope = $rootScope;
			this.restrict = "A";
		}
	
		(0, _createClass3.default)(permissionShow, [{
			key: "checkGroup",
			value: function checkGroup(groups) {
				var grps = groups.split(",").map(function (el) {
					return (0, _toUpper3.default)(el);
				});
				return grps.indexOf((0, _toUpper3.default)(this.$auth.getPermissions())) > -1;
			}
		}, {
			key: "link",
			value: function link(scope, element, attributes) {
				var _this2 = this;
	
				var checkPermission = function checkPermission() {
					element = angular.element(element);
					if (!_this2.checkGroup(attributes["permissionShow"])) {
						element.remove();
					} else {
						element.removeClass("hidden");
					}
				};
	
				this.$rootScope.$on("$updatePermissions", function () {
					checkPermission();
				});
				checkPermission();
			}
		}], [{
			key: "create",
			value: function create() {
				return new (Function.prototype.bind.apply(permissionShow, [null].concat(Array.prototype.slice.call(arguments))))();
			}
		}]);
		return permissionShow;
	}();
	
	var permissionReadonly = function () {
		function permissionReadonly($auth, $rootScope) {
			(0, _classCallCheck3.default)(this, permissionReadonly);
	
			this.$auth = $auth;
			this.$rootScope = $rootScope;
			this.restrict = "A";
		}
	
		(0, _createClass3.default)(permissionReadonly, [{
			key: "checkGroup",
			value: function checkGroup(groups) {
				var grps = groups.split(",").map(function (el) {
					return (0, _toUpper3.default)(el);
				});
				return grps.indexOf((0, _toUpper3.default)(this.$auth.getPermissions())) > -1;
			}
		}, {
			key: "link",
			value: function link(scope, element, attributes) {
				var _this3 = this;
	
				var checkPermission = function checkPermission() {
					element = angular.element(element);
					if (_this3.checkGroup(attributes["permissionReadonly"])) {
						attributes.$set("disabled", true);
					} else {
						attributes.$set("disabled", false);
					}
				};
	
				this.$rootScope.$on("$updatePermissions", function () {
					checkPermission();
				});
				checkPermission();
			}
		}], [{
			key: "create",
			value: function create() {
				return new (Function.prototype.bind.apply(permissionReadonly, [null].concat(Array.prototype.slice.call(arguments))))();
			}
		}]);
		return permissionReadonly;
	}();
	
	permissionShow.create.$inject = ["$auth", "$rootScope"];
	permissionHide.create.$inject = ["$auth", "$rootScope"];
	permissionReadonly.create.$inject = ["$auth", "$rootScope"];
	
	exports.permissionShow = permissionShow;
	exports.permissionHide = permissionHide;
	exports.permissionReadonly = permissionReadonly;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(466);
	
	/**
	 * Converts `string`, as a whole, to upper case just like
	 * [String#toUpperCase](https://mdn.io/toUpperCase).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the upper cased string.
	 * @example
	 *
	 * _.toUpper('--foo-bar--');
	 * // => '--FOO-BAR--'
	 *
	 * _.toUpper('fooBar');
	 * // => 'FOOBAR'
	 *
	 * _.toUpper('__foo_bar__');
	 * // => '__FOO_BAR__'
	 */
	function toUpper(value) {
	  return toString(value).toUpperCase();
	}
	
	module.exports = toUpper;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.UtilityModule = undefined;
	
	var _historyBackButton = __webpack_require__(864);
	
	var _empty = __webpack_require__(865);
	
	var _empty2 = _interopRequireDefault(_empty);
	
	var _getAvatar = __webpack_require__(870);
	
	var _getAvatar2 = _interopRequireDefault(_getAvatar);
	
	var _confirm = __webpack_require__(871);
	
	var _uploadAvatar = __webpack_require__(875);
	
	var _fileChange = __webpack_require__(882);
	
	var _upload = __webpack_require__(883);
	
	var _info = __webpack_require__(889);
	
	var _dates = __webpack_require__(893);
	
	var _getFileName = __webpack_require__(894);
	
	var _getFileName2 = _interopRequireDefault(_getFileName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UtilityModule = exports.UtilityModule = angular.module("utility", [_empty2.default.name, _confirm.confirmModule.name, _uploadAvatar.uploadAvatarModule.name, _upload.uploadModule.name, _info.infoModule.name]).directive("fileChange", _fileChange.fileChangeDirective.create).directive("historyBackButton", _historyBackButton.historyBackButtonDirective.create).filter("getAvatar", _getAvatar2.default).filter("defaultDateFormat", _dates.defaultDateFormat).filter("defaultDateFormatDays", _dates.defaultDateFormatDays).filter("defaultDateFormatDaysAndHours", _dates.defaultDateFormatDaysAndHours).filter("defaultDateFormatHours", _dates.defaultDateFormatHours).filter("getFileName", _getFileName2.default);

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.historyBackButtonDirective = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var historyBackButtonDirective = function () {
		/**
	  *
	  * @param $state
	  */
		historyBackButtonDirective.$inject = ["$window"];
		function historyBackButtonDirective($window) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, historyBackButtonDirective);
			this.template = "\n      <small>\n        <a ng-bind=\"'HISTORY_BACK_BUTTON' | translate\"></a>\n      </small>\n    ";
			this.restrict = "E";
			this.$window = $window;
		}
	
		/**
	  *
	  * @param scope
	  * @param element
	  */
	
	
		(0, _createClass3.default)(historyBackButtonDirective, [{
			key: "link",
			value: function link(scope, element) {
				var _this = this;
	
				element.on("click", function (event) {
					event.preventDefault();
					_this.$window.history.back();
				});
			}
		}], [{
			key: "create",
			value: function create() {
				return new (Function.prototype.bind.apply(historyBackButtonDirective, [null].concat(Array.prototype.slice.call(arguments))))();
			}
		}]);
		return historyBackButtonDirective;
	}();
	
	historyBackButtonDirective.create.$inject = ["$window"];
	
	exports.historyBackButtonDirective = historyBackButtonDirective;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _empty = __webpack_require__(866);
	
	var _empty2 = _interopRequireDefault(_empty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyModule = angular.module("emptyModule", []).component("empty", _empty2.default);
	
	exports.default = emptyModule;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _empty = __webpack_require__(867);
	
	var _empty2 = _interopRequireDefault(_empty);
	
	__webpack_require__(868);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyComponent = {
		template: _empty2.default
	};
	
	exports.default = emptyComponent;

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	module.exports = "<h3 ng-bind=\"'EMPTY_PAGE' | translate\"></h3>";

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(869);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./empty.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./empty.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "empty{display:flex;padding:100px;justify-content:center}empty h3{color:#aaa}", ""]);
	
	// exports


/***/ }),
/* 870 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getAvatarFilter;
	function getAvatarFilter() {
		"ngInject";
	
		return function (input) {
			try {
				var avatar = input.uris.Avatar;
				return "" + avatar + (avatar.indexOf("timestamp") === -1 ? "?" : "&") + "s=200";
			} catch (e) {
				return "";
			}
		};
	}

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.confirmModule = undefined;
	
	var _confirm = __webpack_require__(872);
	
	var confirmModule = exports.confirmModule = angular.module("confirm", []).component("confirm", _confirm.confirmComponent);

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.confirmComponent = undefined;
	
	var _confirm = __webpack_require__(873);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _confirm3 = __webpack_require__(874);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var confirmComponent = exports.confirmComponent = {
		template: _confirm2.default,
		controller: _confirm3.destroyController,
		controllerAs: "confirm",
		bindings: {
			resolve: "<",
			close: "&",
			dismiss: "&",
			data: "<"
		}
	};

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"('confirm-modal-' + confirm.$getType()) | lowercase\">\n\t<div class=\"modal-header\">\n\t\t<h5 class=\"modal-title\" ng-bind=\"'CONFIRM_'+confirm.$getType()+'_RECORD' | translate\"></h5>\n\t\t<span class=\"glyphicon glyphicon-remove\" ng-click=\"confirm.$onClose()\"></span>\n\t</div>\n\t<div class=\"modal-body\">\n\t\t<p ng-bind=\"'CONFIRM_'+confirm.$getType()+'_RECORD_DESCRIPTION' | translate\"></p>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<div class=\"pull-left\">\n\t\t\t<button\n\t\t\t\tclass=\"btn btn-dark\"\n\t\t\t\ttype=\"submit\"\n\t\t\t\tng-click=\"confirm.$onClose()\"\n\t\t\t\tng-bind=\"'CANCEL' | translate\">\n\t\t\t</button>\n\t\t</div>\n\t\t<div class=\"pull-right\">\n\t\t\t<button\n\t\t\t\tclass=\"btn\"\n\t\t\t\tng-click=\"confirm.$onConfirm()\"\n\t\t\t\tng-class=\"confirm.$getType() === 'DESTROY' ? 'btn-danger' : 'btn-info'\"\n\t\t\t\tng-bind=\"(confirm.$getType()+'_RECORD') | translate\">\n\t\t\t</button>\n\t\t</div>\n\t\t<div class=\"clearfix\"></div>\n\t</div>\n</div>";

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.destroyController = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var destroyController = exports.destroyController = function () {
		function destroyController() {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, destroyController);
		}
	
		(0, _createClass3.default)(destroyController, [{
			key: "$onClose",
			value: function $onClose() {
				this.close({ $value: "cancel" });
			}
		}, {
			key: "$onConfirm",
			value: function $onConfirm() {
				this.close({ $value: "confirm" });
			}
		}, {
			key: "$getType",
			value: function $getType() {
				return (this.resolve.type || "confirm").toUpperCase();
			}
		}]);
		return destroyController;
	}();

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.uploadAvatarModule = undefined;
	
	var _uploadAvatar = __webpack_require__(876);
	
	var _uploadAvatar2 = __webpack_require__(881);
	
	var uploadAvatarModule = exports.uploadAvatarModule = angular.module("uploadAvatarModule", []).service("$uploadAvatar", _uploadAvatar2.uploadAvatarService).component("uploadAvatarOpen", _uploadAvatar.uploadAvatarOpenComponent);

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.uploadAvatarOpenComponent = undefined;
	
	var _uploadAvatarOpen = __webpack_require__(877);
	
	var _uploadAvatarOpen2 = _interopRequireDefault(_uploadAvatarOpen);
	
	var _uploadAvatar = __webpack_require__(878);
	
	__webpack_require__(879);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uploadAvatarOpenComponent = exports.uploadAvatarOpenComponent = {
		template: _uploadAvatarOpen2.default,
		controller: _uploadAvatar.uploadAvatarOpenController,
		controllerAs: "uploadAvatarOpen",
		require: {
			usersUpdate: "^^usersUpdate"
		}
	};

/***/ }),
/* 877 */
/***/ (function(module, exports) {

	module.exports = "<form\nclass=\"form-upload-avatar photo-update\"\nname=\"formUploadAvatar\"\nng-submit=\"uploadAvatarOpen.$onSubmit(formUploadAvatar, $event)\">\n\n  <input\n    id=\"avatar\"\n    name=\"avatar\"\n    type=\"file\"\n    class=\"inputfile inputfile-4\"\n    file-change=\"\"/>\n\n  <label for=\"avatar\">\n\n    <img class=\"img-responsive\" ng-src=\"{{ uploadAvatarOpen.usersUpdate.user | getAvatar }}\">\n\n    <figure>\n      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"17\" viewBox=\"0 0 20 17\">\n        <path d=\"M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z\"></path>\n      </svg>\n    </figure>\n  </label>\n\n</form>";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.uploadAvatarOpenController = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uploadAvatarOpenController = exports.uploadAvatarOpenController = function () {
		/**
	  *
	  * @param $uploadAvatar
	  */
		uploadAvatarOpenController.$inject = ["$uploadAvatar"];
		function uploadAvatarOpenController($uploadAvatar) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, uploadAvatarOpenController);
			this.$uploadAvatar = $uploadAvatar;
		}
	
		/**
	  *
	  * @param formUploadAvatar
	  * @param $event
	  */
	
	
		(0, _createClass3.default)(uploadAvatarOpenController, [{
			key: "$onSubmit",
			value: function $onSubmit(formUploadAvatar, $event) {
				var _this = this;
	
				this.$uploadAvatar.create($event.target[0].files).then(function () {
					return _this.usersUpdate.user.uris.Avatar = _this.usersUpdate.user.uris.Avatar + "?timestamp=" + Number(new Date());
				}).then(function () {
					return formUploadAvatar.$submitted = false;
				});
			}
		}]);
		return uploadAvatarOpenController;
	}();

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(880);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./upload-avatar.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./upload-avatar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.uploadAvatarService = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(37);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _service = __webpack_require__(184);
	
	var _service2 = _interopRequireDefault(_service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uploadAvatarService = exports.uploadAvatarService = function (_ActiveService) {
		uploadAvatarService.$inject = ["$injector", "$auth", "$httpConfigurator"];
		(0, _inherits3.default)(uploadAvatarService, _ActiveService);
	
		/**
	  *
	  * @param $injector
	  * @param $auth
	  * @param $httpConfigurator
	  */
		function uploadAvatarService($injector, $auth, $httpConfigurator) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, uploadAvatarService);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (uploadAvatarService.__proto__ || (0, _getPrototypeOf2.default)(uploadAvatarService)).call(this, $injector));
	
			_this.$auth = $auth;
			_this.$httpConfigurator = $httpConfigurator;
			return _this;
		}
	
		(0, _createClass3.default)(uploadAvatarService, [{
			key: "create",
			value: function create(avatar) {
				var _this2 = this;
	
				var deferred = this.$q.defer();
				var uri = this.$auth.user.uris.UploadAvatar;
				window.$.ajax({
					url: uri,
					type: "POST",
					data: avatar[0],
					cache: false,
					dataType: "json",
					processData: false,
					contentType: false,
					headers: {
						"X-RapidGAE-Session-User": this.$auth.getToken()
					},
					success: function success() {
						_this2.notify.set(_this2.translate("UPLOAD_AVATAR_SENDED"), "success");
						_this2.$auth.me();
						deferred.resolve();
					},
					error: function error(response) {
						if (response.status === 401) {
							_this2.$auth.logout();
						}
						if (response.status === 400) {
							_this2.notify.set(JSON.parse(response.responseText).error, "error");
						}
						deferred.reject();
					}
				});
				return deferred.promise;
			}
		}]);
		return uploadAvatarService;
	}(_service2.default);

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fileChangeDirective = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fileChangeDirective = function () {
		function fileChangeDirective() {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, fileChangeDirective);
			this.restrict = "A";
		}
	
		/**
	  *
	  * @param scope
	  * @param element
	  */
	
	
		(0, _createClass3.default)(fileChangeDirective, [{
			key: "link",
			value: function link(scope, element) {
				element.on("change", function (evt) {
					// Перевіряємо, чи є upload компонент у скоупі
					// Якщо є - викликаємо тільки його, щоб уникнути подвійного виклику
					if (scope.upload && typeof scope.upload.$onSubmit === "function") {
						scope.$applyAsync(function () {
							return scope.upload.$onSubmit(evt);
						});
					} else {
						// Якщо upload компонента немає, викликаємо стандартний submit
						element.parent().triggerHandler("submit", evt);
					}
				});
			}
		}], [{
			key: "create",
			value: function create() {
				return new (Function.prototype.bind.apply(fileChangeDirective, [null].concat(Array.prototype.slice.call(arguments))))();
			}
		}]);
		return fileChangeDirective;
	}();
	
	exports.fileChangeDirective = fileChangeDirective;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.uploadModule = undefined;
	
	var _upload = __webpack_require__(884);
	
	var _upload2 = __webpack_require__(888);
	
	var uploadModule = exports.uploadModule = angular.module("upload", []).service("$upload", _upload2.UploadService).component("upload", _upload.UploadComponent);

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UploadComponent = undefined;
	
	var _from = __webpack_require__(92);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _upload = __webpack_require__(885);
	
	var _upload2 = _interopRequireDefault(_upload);
	
	__webpack_require__(886);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UploadController = function () {
	    UploadController.$inject = ["$upload", "$element", "$mdDialog", "$ToastService"];
	    function UploadController($upload, $element, $mdDialog, $ToastService) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, UploadController);
	        this.$upload = $upload;
	        this.$element = $element;
	        this.id = Math.random().toString(36).substring(7);
	        this.disabled = !!this.disabled;
	        this.isUploading = false;
	        this.$mdDialog = $mdDialog;
	        this.toastService = $ToastService;
	    }
	
	    (0, _createClass3.default)(UploadController, [{
	        key: "getFilesFromEvent",
	        value: function getFilesFromEvent($event) {
	            // Prefer the real input element
	            if ($event && $event.target && $event.target.files) {
	                return $event.target.files;
	            }
	            // Fallback for form submit events (target can be the form, children are inputs)
	            if ($event && $event.target && $event.target[0] && $event.target[0].files) {
	                return $event.target[0].files;
	            }
	            // Last resort: pick the first input inside component
	            var inputEl = this.$element && this.$element.find ? this.$element.find("input")[0] : null;
	            return inputEl && inputEl.files ? inputEl.files : null;
	        }
	    }, {
	        key: "$onSubmit",
	        value: function $onSubmit($event) {
	            var _this = this;
	
	            var files = this.getFilesFromEvent($event);
	            if (!this.uri) {
	                this.showCustomError("Upload endpoint is not configured.");
	                return;
	            }
	            if (!files || !files.length) {
	                this.showCustomError("No files selected.");
	                return;
	            }
	            if (this.maxSize && !this.isFileSizeValid(files)) {
	                this.showCustomError("Maximum file size is " + this.maxSize + "mb");
	                return;
	            }
	            if (this.multiple) {
	                //create images to check width/height
	                var images = [];
	                var count = files.length;
	                var counter = 0;
	                var valid = true;
	
	                (0, _lodash.forEach)(files, function (f) {
	                    if (!_this.checkFileType(f.name)) {
	                        valid = false;
	                        return false;
	                    }
	                });
	                if (!valid) {
	                    return;
	                }
	                var incrementCounter = function incrementCounter() {
	                    counter++;
	                    if (counter === count) {
	                        // Check loaded images
	                        var validW = images[0].naturalWidth;
	                        var validH = images[0].naturalHeight;
	                        (0, _lodash.forEach)(images, function (img) {
	                            if (img.naturalHeight !== validH || img.naturalWidth !== validW) {
	                                valid = false;
	                                _this.showCustomError("Uploaded photos should be the same size!");
	                            }
	                        });
	
	                        if (!valid) {
	                            return;
	                        }
	
	                        // Check with first image
	                        if (_this.imagesArray && _this.imagesArray.length) {
	                            var firstImage = new Image();
	                            firstImage.src = _this.imagesArray[0];
	                            firstImage.onload = function () {
	                                var validWidth = firstImage.naturalWidth;
	                                var validHeight = firstImage.naturalHeight;
	
	                                (0, _lodash.forEach)(images, function (img) {
	                                    if (img.naturalWidth !== validWidth || img.naturalHeight !== validHeight) {
	                                        valid = false;
	                                    }
	                                });
	
	                                if (valid) {
	                                    _this.uploadFew(files);
	                                } else {
	                                    _this.showError(validWidth, validHeight);
	                                }
	                            };
	                        } else {
	                            _this.uploadFew(files);
	                        }
	                    }
	                };
	
	                (0, _lodash.forEach)(files, function (f) {
	                    var image = new Image();
	                    image.src = window.URL.createObjectURL(f);
	                    images.push(image);
	                });
	
	                (0, _lodash.forEach)(images, function (img) {
	                    img.addEventListener("load", incrementCounter, false);
	                });
	
	                //this.uploadFew($event);
	            } else {
	                if (!this.checkFileType(files[0].name)) {
	                    return;
	                }
	
	                if (this.fileTypes === ".pdf" || files[0].name.includes(".pdf") && this.fileTypes.includes(".pdf")) {
	                    //remove old file from backend
	                    if (this.oldFile) {
	                        if (this.oldFile !== undefined || this.oldFile !== "") {
	                            this.$upload.delete("/api/attachments/" + this.oldFile + "/");
	                        }
	                    }
	                    this.isUploading = true;
	                    this.upload(files);
	                } else {
	                    if (this.isVideo(files[0].name) || this.isFont(files[0].name)) {
	                        this.upload(files);
	                    } else {
	                        this.isUploading = true;
	                        var image = new Image();
	                        image.src = window.URL.createObjectURL(files[0]);
	                        image.onload = function () {
	                            var width = image.naturalWidth,
	                                height = image.naturalHeight;
	
	                            window.URL.revokeObjectURL(image.src);
	                            if (_this.imagesArray && _this.imagesArray.length) {
	                                var firstImage = new Image();
	                                firstImage.src = _this.imagesArray[0];
	                                firstImage.onload = function () {
	                                    var validWidth = firstImage.naturalWidth;
	                                    var validHeight = firstImage.naturalHeight;
	
	                                    if (width !== validWidth || height !== validHeight) {
	                                        _this.isUploading = false;
	                                        _this.showError(validWidth, validHeight);
	                                    } else {
	                                        _this.upload(files);
	                                    }
	                                };
	                            } else {
	                                _this.upload(files);
	                            }
	                        };
	                    }
	                }
	            }
	        }
	    }, {
	        key: "showError",
	        value: function showError(width, height) {
	            if (!this.hideErrorPopup) {
	                this.$mdDialog.show(this.$mdDialog.alert().clickOutsideToClose(true).title("Error").htmlContent("<p>All files should be the same size as first one (" + width + "x" + height + ")</p>").ariaLabel("Error").ok("OK").targetEvent(event));
	            } else {
	                this.toastService.showError("All files should be the same size as first one (" + width + "x" + height + ")", 5000, "top right");
	            }
	        }
	    }, {
	        key: "showCustomError",
	        value: function showCustomError(text) {
	            if (!this.hideErrorPopup) {
	                this.$mdDialog.show(this.$mdDialog.alert().clickOutsideToClose(true).title("Error").htmlContent("<p>" + text + "</p>").ariaLabel("Error").ok("OK").targetEvent(event));
	            } else {
	                this.toastService.showError(text, 5000, "top right");
	            }
	        }
	    }, {
	        key: "upload",
	        value: function upload(files) {
	            var _this2 = this;
	
	            var previousAttachment = this.deletePrevious ? this.model : null;
	            this.isUploading = true;
	            this.$upload.upload(files[0], this.uri, null, this.isOverlay).then(function (response) {
	                _this2.model = response.data;
	                _this2.removeReplacedAttachment(previousAttachment, response.data);
	                _this2.callback && _this2.callback({ file: response.data });
	            }, function (error) {
	                console.log(error);
	                if (error.status === 415) {
	                    _this2.showCustomError(error.data.detail);
	                }
	            }).then(function () {
	                return _this2.$element.find("input")[0].value = null;
	            }).finally(function () {
	                return _this2.isUploading = false;
	            });
	        }
	    }, {
	        key: "removeReplacedAttachment",
	        value: function removeReplacedAttachment(previousAttachment, nextAttachment) {
	            if (!this.deletePrevious || !previousAttachment) {
	                return;
	            }
	            var previousId = this.$upload.attachmentId(previousAttachment);
	            var nextId = this.$upload.attachmentId(nextAttachment);
	            if (!previousId || previousId === nextId) {
	                return;
	            }
	            this.$upload.deleteCompanyAttachment(this.uri, previousAttachment);
	        }
	    }, {
	        key: "uploadFew",
	        value: function uploadFew(files) {
	            var _this3 = this;
	
	            this.isUploading = true;
	            // `files` може бути FileList (array-like), тому конвертуємо в справжній масив
	            var filesArray = Array.isArray(files) ? files : (0, _from2.default)(files || []);
	            var collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
	            filesArray = filesArray.sort(function (a, b) {
	                return collator.compare(a.name, b.name);
	            });
	            this.$upload.uploadFew(filesArray, this.uri, null, this.isOverlay).then(function (response) {
	                //this.model = response.data;
	                _this3.callback && _this3.callback({ file: response.data });
	            }, function (error) {
	                console.log(error);
	            }).then(function () {
	                return _this3.$element.find("input")[0].value = null;
	            }).finally(function () {
	                return _this3.isUploading = false;
	            });
	        }
	    }, {
	        key: "checkFileType",
	        value: function checkFileType(file) {
	            if (!file) {
	                return false;
	            }
	            var fileExtention = file.split(".")[file.split(".").length - 1];
	            if (this.fileTypes.indexOf(fileExtention) === -1) {
	                this.$mdDialog.show(this.$mdDialog.alert().clickOutsideToClose(true).title("Error").htmlContent("<p><strong>" + fileExtention.toUpperCase() + "</strong> file type is not allowed!</p>").ariaLabel("Error").ok("OK").targetEvent(event));
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: "isVideo",
	        value: function isVideo(name) {
	            return name.indexOf(".mp4") !== -1 || name.indexOf(".webm") !== -1 || name.indexOf(".gif") !== -1 || name.indexOf(".mov") !== -1;
	        }
	    }, {
	        key: "isFont",
	        value: function isFont(name) {
	            return (/\.(ttf|otf|woff2?)$/i.test(name)
	            );
	        }
	    }, {
	        key: "isFileSizeValid",
	        value: function isFileSizeValid(files) {
	            var _this4 = this;
	
	            var valid = true;
	
	            (0, _lodash.forEach)(files, function (file) {
	                if (file.size > _this4.maxSize * 1000000) {
	                    valid = false;
	                }
	            });
	
	            return valid;
	        }
	    }]);
	    return UploadController;
	}();
	
	var UploadComponent = exports.UploadComponent = {
	    template: _upload2.default,
	    controller: UploadController,
	    controllerAs: "upload",
	    bindings: {
	        model: "=?",
	        uri: "@",
	        callback: "&",
	        customLabel: "@",
	        extraInfo: "@",
	        disabled: "<",
	        imagesArray: "<",
	        fileTypes: "@",
	        multiple: "<",
	        hideErrorPopup: "<",
	        maxSize: "<",
	        oldFile: "<",
	        deletePrevious: "<",
	        isOverlay: "@",
	        uploadAnimatedFiles: "<",
	        displayIcon: "@"
	    }
	};

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"upload.$onSubmit($event)\">\n    <label\n            for=\"upload_{{upload.id}}\"\n            class=\"md-button md-raised md-primary btn-file\"\n            ng-class=\"{'upload-disabled': upload.disabled}\"\n            ng-disabled=\"upload.disabled\">\n        <i class=\"material-icons\" ng-if=\"upload.displayIcon == 'true'\" ng-show=\"!upload.isUploading\">\n            file_upload\n        </i>\n        <span\n                ng-bind=\"upload.customLabel ? (upload.customLabel | translate) : ('Upload' | translate)\"\n                ng-show=\"!upload.isUploading\">\n        </span>\n        <md-progress-circular  md-diameter=\"20\" class=\"md-warn md-hue-3\" ng-show=\"upload.isUploading\"></md-progress-circular>\n    </label>\n    <span ng-if=\"upload.extraInfo\">{{upload.extraInfo}}</span>\n    <input\n            ng-if=\"upload.uploadAnimatedFiles\"\n            id=\"upload_{{upload.id}}\"\n            type=\"file\"\n            style=\"display: none\"\n            file-change data-field=\"fileUpload\"\n            accept=\"{{upload.fileTypes || '.jpg,.jpeg,.gif,.png,.mp4'}}\"\n            ng-disabled=\"upload.disabled\">\n    <input\n            ng-if=\"!upload.uploadAnimatedFiles\"\n            id=\"upload_{{upload.id}}\"\n            type=\"file\"\n            style=\"display: none\"\n            multiple\n            file-change data-field=\"fileUpload\"\n            accept=\"{{upload.fileTypes || '.jpg,.jpeg,.gif,.png,.mp4'}}\"\n            ng-disabled=\"upload.disabled\">\n</form>\n";

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(887);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(152)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./upload.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./upload.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(106)();
	// imports
	
	
	// module
	exports.push([module.id, "upload:not(.btn){display:block;clear:both}upload:not(.btn) label{font-weight:400;margin-bottom:0}upload:not(.btn) i{position:relative;top:7px}upload span{font-size:12px}upload label{height:36px;width:200px;color:#fff!important}upload label>md-progress-circular{margin:auto;margin-top:7px}upload label>md-progress-circular .md-left>.md-half-circle{border-left-color:#fff}upload label>md-progress-circular .md-right>.md-half-circle{border-right-color:#fff}upload .upload-disabled{background:rgba(238,39,55,.2)!important}", ""]);
	
	// exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.UploadService = undefined;
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UploadService = exports.UploadService = function () {
		/**
	  *
	  * @param $injector
	  * @param $companies
	  * @param $filter
	  */
		UploadService.$inject = ["$injector", "$http", "$auth"];
		function UploadService($injector, $http, $auth) {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, UploadService);
			this.$http = $http;
			this.$auth = $auth;
		}
	
		(0, _createClass3.default)(UploadService, [{
			key: "upload",
			value: function upload(file) {
				var uri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var contentObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
				var isOverlay = arguments[3];
	
				var formData = new FormData();
				formData.append("attachment_file", file);
				formData.append("creator", this.$auth.getUser().url);
				formData.append("content_object", contentObject || "");
				formData.append("is_overlay", isOverlay || false);
	
				var request = {
					method: "POST",
					url: uri,
					data: formData,
					headers: {
						"content-Type": undefined
					}
				};
	
				return this.$http(request);
			}
		}, {
			key: "uploadFew",
			value: function uploadFew(files) {
				var uri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var contentObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
				var isOverlay = arguments[3];
	
				var formData = new FormData();
				(0, _lodash.forEach)(files, function (file) {
					formData.append("attachment_file", file);
				});
				formData.append("creator", this.$auth.getUser().url);
				formData.append("content_object", contentObject || "");
				formData.append("is_overlay", isOverlay || false);
	
				var request = {
					method: "POST",
					url: uri,
					data: formData,
					headers: {
						"content-Type": undefined
					}
				};
	
				return this.$http(request);
			}
		}, {
			key: "delete",
			value: function _delete(uri) {
				return this.$http.delete(uri);
			}
		}, {
			key: "attachmentId",
			value: function attachmentId(attachment) {
				if (!attachment || (typeof attachment === "undefined" ? "undefined" : (0, _typeof3.default)(attachment)) !== "object") {
					return null;
				}
				if (attachment.id) {
					return attachment.id;
				}
				if (attachment.pk) {
					return attachment.pk;
				}
				var url = typeof attachment.url === "string" ? attachment.url : "";
				var match = url.match(/\/attachments\/([^/]+)\/?$/);
				return match ? match[1] : null;
			}
		}, {
			key: "deleteCompanyAttachment",
			value: function deleteCompanyAttachment(attachmentsUri, attachment) {
				var id = this.attachmentId(attachment);
				if (!id || !attachmentsUri) {
					return null;
				}
				var base = /\/$/.test(attachmentsUri) ? attachmentsUri : attachmentsUri + "/";
				return this.delete("" + base + id + "/");
			}
		}]);
		return UploadService;
	}();

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.infoModule = undefined;
	
	var _info = __webpack_require__(890);
	
	var infoModule = exports.infoModule = angular.module("info", []).component("info", _info.infoComponent);

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.infoComponent = undefined;
	
	var _info = __webpack_require__(891);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _info3 = __webpack_require__(892);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var infoComponent = exports.infoComponent = {
		template: _info2.default,
		controller: _info3.infoController,
		controllerAs: "info",
		bindings: {
			resolve: "<",
			close: "&",
			dismiss: "&",
			data: "<"
		}
	};

/***/ }),
/* 891 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\" ng-bind=\"info.resolve.title | translate\"></h5>\n</div>\n<div class=\"modal-body\" ng-if=\"info.resolve.content\">\n  <p class=\"\" ng-bind=\"info.resolve.content | translate\"></p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"pull-right\">\n    <button\n      class=\"btn btn-flat\"\n      type=\"submit\"\n      ng-click=\"info.$onClose()\"\n      ng-bind=\"'OK' | translate\">\n    </button>\n  </div>\n  <div class=\"clearfix\"></div>\n</div>";

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.infoController = undefined;
	
	var _classCallCheck2 = __webpack_require__(32);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(33);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var infoController = exports.infoController = function () {
		function infoController() {
			"ngInject";
	
			(0, _classCallCheck3.default)(this, infoController);
		}
	
		(0, _createClass3.default)(infoController, [{
			key: "$onClose",
			value: function $onClose() {
				this.close({ $value: "cancel" });
			}
		}, {
			key: "$onConfirm",
			value: function $onConfirm() {
				this.close({ $value: "confirm" });
			}
		}]);
		return infoController;
	}();

/***/ }),
/* 893 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultDateFormat = defaultDateFormat;
	exports.defaultDateFormatDays = defaultDateFormatDays;
	exports.defaultDateFormatDaysAndHours = defaultDateFormatDaysAndHours;
	exports.defaultDateFormatHours = defaultDateFormatHours;
	exports.defaultDateRange = defaultDateRange;
	exports.taskDateRange = taskDateRange;
	exports.datesDiffInDays = datesDiffInDays;
	exports.timeago = timeago;
	function defaultDateFormat() {
		return function (date) {
			return window.moment(date).format();
		};
	}
	
	function defaultDateFormatDays() {
		return function (date) {
			return date ? window.moment(date).format("YYYY-MM-DD") : "";
		};
	}
	
	function defaultDateFormatDaysAndHours() {
		return function (date) {
			return date ? window.moment(date).format("YYYY-MM-DD HH:mm") : "";
		};
	}
	
	function defaultDateFormatHours() {
		return function (date) {
			return date ? window.moment(date).format("HH:mm") : "";
		};
	}
	
	function defaultDateRange() {
		return function (dates) {
			return dates ? dates.map(function (date) {
				return window.moment(date).format("DD.MM HH:mm");
			}).join(" - ") : "";
		};
	}
	
	function taskDateRange() {
		return function (dates) {
			return dates ? dates.map(function (date) {
				return window.moment(date).format("YYYY-MM-DD HH:mm");
			}).join(" - ") : "";
		};
	}
	
	function datesDiffInDays() {
		return function (dates) {
			return dates ? window.moment(dates[0]).diff(window.moment(dates[1]), "days") : "";
		};
	}
	
	function timeago() {
		return function (string) {
			return window.moment(string).fromNow();
		};
	}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = getFileName;
	function getFileName() {
	    "ngInject";
	
	    var getNameFromPath = function getNameFromPath(path) {
	        var transformed = path.split("/");
	        return transformed[transformed.length - 1];
	    };
	
	    var removeCodeFromName = function removeCodeFromName(name) {
	        var fullFileName = name.split(".")[0];
	        var fileFormat = name.split(".")[1];
	        var transformedFileNameArray = fullFileName.split("_");
	        if (transformedFileNameArray.length <= 1) {
	            return name;
	        }
	        transformedFileNameArray.pop();
	
	        return transformedFileNameArray.join("_") + "." + fileFormat;
	    };
	
	    var trim = function trim(file, trimCount) {
	        var shouldCount = !!trimCount && file.length > trimCount;
	        trimCount = trimCount || file.length;
	        file = file.slice(0, trimCount) + (shouldCount ? " ..." : "");
	
	        return file;
	    };
	
	    return function (inputString) {
	        var trimCounter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        if (!inputString) {
	            return;
	        }
	        inputString = getNameFromPath(inputString);
	        inputString = removeCodeFromName(inputString);
	        inputString = trim(inputString, trimCounter);
	
	        return inputString;
	    };
	}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FiltersModule = undefined;
	
	var _me = __webpack_require__(896);
	
	var _isUnauthorized = __webpack_require__(897);
	
	var _isAuthorized = __webpack_require__(898);
	
	var _isActive = __webpack_require__(899);
	
	var _isAdmin = __webpack_require__(900);
	
	var _relations = __webpack_require__(901);
	
	var _countries = __webpack_require__(902);
	
	var _requestStatus = __webpack_require__(903);
	
	var _urlParse = __webpack_require__(904);
	
	var _date = __webpack_require__(938);
	
	var FiltersModule = exports.FiltersModule = angular.module("filters", []).filter("me", _me.me).filter("isMe", _me.isMe).filter("isUnauthorized", _isUnauthorized.isUnauthorized).filter("isAuthorized", _isAuthorized.isAuthorized).filter("isActive", _isActive.isActive).filter("isNotActive", _isActive.isNotActive).filter("isAdmin", _isAdmin.isAdmin).filter("canManageUsers", _isAdmin.canManageUsers).filter("hasPermission", _isAdmin.hasPermission).filter("countryTemplate", _countries.countryTemplate).filter("countriesTemplate", _countries.countriesTemplate).filter("requestStatus", _requestStatus.requestStatus).filter("relation", _relations.relationFilter).filter("urlParse", _urlParse.urlParse).filter("getObjectId", _urlParse.getObjectId).filter("getObjectByUrl", _urlParse.getObjectByUrl).filter("getObjectByKey", _urlParse.getObjectByKey).filter("getObjectByKeyValue", _urlParse.getObjectByKeyValue).filter("defaultDateFormatDays", _date.defaultDateFormatDays).filter("datesDiffInDays", _date.datesDiffInDays);

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	"use strict";
	
	me.$inject = ["$auth"];
	isMe.$inject = ["$auth"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.me = me;
	exports.isMe = isMe;
	function me($auth) {
	
		"ngInject";
	
		return function () {
			return $auth.getUser();
		};
	}
	
	function isMe($auth) {
	
		"ngInject";
	
		return function (userUrl) {
			return $auth.isAuthenticated() ? userUrl === $auth.getUser().uri : false;
		};
	}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	"use strict";
	
	isUnauthorized.$inject = ["$auth"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isUnauthorized = isUnauthorized;
	function isUnauthorized($auth) {
	
		"ngInject";
	
		return function () {
			return !$auth.isAuthenticated();
		};
	}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	"use strict";
	
	isAuthorized.$inject = ["$auth"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isAuthorized = isAuthorized;
	function isAuthorized($auth) {
	
		"ngInject";
	
		return function () {
			return $auth.isAuthenticated();
		};
	}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

	"use strict";
	
	isActive.$inject = ["$auth"];
	isNotActive.$inject = ["$auth"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isActive = isActive;
	exports.isNotActive = isNotActive;
	function isActive($auth) {
	
		"ngInject";
	
		return function () {
			return $auth.isAuthenticated() && $auth.getUser().extend.is_active === true;
		};
	}
	
	function isNotActive($auth) {
	
		"ngInject";
	
		return function () {
			return $auth.isAuthenticated() && $auth.getUser().extend.is_active === false;
		};
	}

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	"use strict";
	
	isAdmin.$inject = ["$auth"];
	canManageUsers.$inject = ["$auth"];
	hasPermission.$inject = ["$auth"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isAdmin = isAdmin;
	exports.canManageUsers = canManageUsers;
	exports.hasPermission = hasPermission;
	function isAdmin($auth) {
		"ngInject";
	
		return function () {
			return $auth.isAuthenticated() && $auth.getUser().permissions.split(",").indexOf("companies.manage") !== -1;
		};
	}
	
	function canManageUsers($auth) {
		"ngInject";
	
		return function () {
			return $auth.isAuthenticated() && ($auth.isAuthenticated() && $auth.getUser().permissions.split(",").indexOf("companies.manage") !== -1 || $auth.getUser().permissions.split(",").indexOf("user.company.manage") !== -1);
		};
	}
	
	function hasPermission($auth) {
		"ngInject";
	
		return function (permission) {
			return $auth.isAuthenticated() && $auth.getUser().permissions.split(",").indexOf(permission) !== -1;
		};
	}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.relationFilter = relationFilter;
	function relationFilter() {
	    return function (url, collection, fieldName) {
	        return url && collection[url] && collection[url][fieldName] || "";
	    };
	}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	countriesTemplate.$inject = ["$filter"];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.countriesTemplate = exports.countryTemplate = undefined;
	
	var _lodash = __webpack_require__(101);
	
	function countryTemplate() {
		return function (country) {
			return "\n\t\n\t\t<div>\n\t\t\t<span class=\"flag-icon " + country.code.toLowerCase() + "\"></span>\n\t\t\t<span>" + country.name_pl + "</span>\n\t\t</div>\n\t\n\t";
		};
	}
	
	function countriesTemplate($filter) {
		"ngInject";
	
		return function (countries) {
			(0, _lodash.map)(countries, function (country) {
				return $filter("countryTemplate")(country).trim();
			}).join("");
			return (0, _lodash.map)(countries, function (country) {
				return $filter("countryTemplate")(country).trim();
			}).join("");
		};
	}
	
	exports.countryTemplate = countryTemplate;
	exports.countriesTemplate = countriesTemplate;

/***/ }),
/* 903 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	function requestStatus() {
		"ngInject";
	
		return function (status) {
			switch (status) {
				case "pending":
					return "badge-warning";
				case "accepted":
					return "badge-success";
				case "rejected":
					return "badge-danger";
			}
		};
	}
	
	exports.requestStatus = requestStatus;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getObjectByKeyValue = exports.getObjectByKey = exports.getObjectByUrl = exports.getObjectId = exports.urlParse = undefined;
	
	var _last2 = __webpack_require__(468);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _find2 = __webpack_require__(905);
	
	var _find3 = _interopRequireDefault(_find2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var urlParse = exports.urlParse = function urlParse() {
	    "ngInject";
	
	    return function (url) {
	        return url.replace(/\/api/i, "");
	    };
	};
	
	var getObjectId = exports.getObjectId = function getObjectId() {
	    "ngInject";
	
	    return function (url) {
	        return (0, _last3.default)(url.replace(/\/$/, "").split("/"));
	    };
	};
	
	var getObjectByUrl = exports.getObjectByUrl = function getObjectByUrl() {
	    "ngInject";
	
	    return function (url, collection, prop) {
	        var item = (0, _find3.default)(collection, function (item) {
	            return item.url === url;
	        });
	        return item ? item[prop] : "";
	    };
	};
	
	var getObjectByKey = exports.getObjectByKey = function getObjectByKey() {
	    "ngInject";
	
	    return function (key, collection) {
	        return collection[key] || "";
	    };
	};
	
	var getObjectByKeyValue = exports.getObjectByKeyValue = function getObjectByKeyValue() {
	    "ngInject";
	
	    return function (value, collection, key, prop) {
	        var item = (0, _find3.default)(collection, function (item) {
	            return item[key] === value;
	        });
	        return item ? item[prop] : "";
	    };
	};

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(906),
	    findIndex = __webpack_require__(933);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(907),
	    isArrayLike = __webpack_require__(422),
	    keys = __webpack_require__(403);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(908),
	    baseMatchesProperty = __webpack_require__(925),
	    identity = __webpack_require__(484),
	    isArray = __webpack_require__(409),
	    property = __webpack_require__(930);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(909),
	    getMatchData = __webpack_require__(922),
	    matchesStrictComparable = __webpack_require__(924);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(353),
	    baseIsEqual = __webpack_require__(910);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(911),
	    isObjectLike = __webpack_require__(408);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(353),
	    equalArrays = __webpack_require__(912),
	    equalByTag = __webpack_require__(918),
	    equalObjects = __webpack_require__(921),
	    getTag = __webpack_require__(440),
	    isArray = __webpack_require__(409),
	    isBuffer = __webpack_require__(410),
	    isTypedArray = __webpack_require__(413);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(913),
	    arraySome = __webpack_require__(916),
	    cacheHas = __webpack_require__(917);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(382),
	    setCacheAdd = __webpack_require__(914),
	    setCacheHas = __webpack_require__(915);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 914 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 915 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 916 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 917 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(372),
	    Uint8Array = __webpack_require__(448),
	    eq = __webpack_require__(358),
	    equalArrays = __webpack_require__(912),
	    mapToArray = __webpack_require__(919),
	    setToArray = __webpack_require__(920);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 919 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 920 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(437);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(923),
	    keys = __webpack_require__(403);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(377);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 924 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(910),
	    get = __webpack_require__(926),
	    hasIn = __webpack_require__(927),
	    isKey = __webpack_require__(461),
	    isStrictComparable = __webpack_require__(923),
	    matchesStrictComparable = __webpack_require__(924),
	    toKey = __webpack_require__(471);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(470);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(928),
	    hasPath = __webpack_require__(929);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 928 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(460),
	    isArguments = __webpack_require__(406),
	    isArray = __webpack_require__(409),
	    isIndex = __webpack_require__(412),
	    isLength = __webpack_require__(415),
	    toKey = __webpack_require__(471);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(931),
	    basePropertyDeep = __webpack_require__(932),
	    isKey = __webpack_require__(461),
	    toKey = __webpack_require__(471);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 931 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(470);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(934),
	    baseIteratee = __webpack_require__(907),
	    toInteger = __webpack_require__(935);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 934 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(936);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(937);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(377),
	    isSymbol = __webpack_require__(462);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 938 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.defaultDateFormat = defaultDateFormat;
	exports.defaultDateFormatDays = defaultDateFormatDays;
	exports.defaultDateFormatDaysAndHours = defaultDateFormatDaysAndHours;
	exports.defaultDateFormatHours = defaultDateFormatHours;
	exports.defaultDateRange = defaultDateRange;
	exports.taskDateRange = taskDateRange;
	exports.datesDiffInDays = datesDiffInDays;
	function defaultDateFormat() {
	    return function (date) {
	        return window.moment(date).format();
	    };
	}
	
	function defaultDateFormatDays() {
	    return function (date) {
	        return date ? window.moment(date).format("YYYY-MM-DD") : "";
	    };
	}
	
	function defaultDateFormatDaysAndHours() {
	    return function (date) {
	        return date ? window.moment(date).format("YYYY-MM-DD HH:mm") : "";
	    };
	}
	
	function defaultDateFormatHours() {
	    return function (date) {
	        return date ? window.moment(date).format("HH:mm") : "";
	    };
	}
	
	function defaultDateRange() {
	    return function (dates) {
	        return dates ? dates.map(function (date) {
	            return window.moment(date).format("DD.MM HH:mm");
	        }).join(" - ") : "";
	    };
	}
	
	function taskDateRange() {
	    return function (dates) {
	        return dates ? dates.map(function (date) {
	            return window.moment(date).format("YYYY-MM-DD HH:mm");
	        }).join(" - ") : "";
	    };
	}
	
	function datesDiffInDays() {
	    return function (dates) {
	        return dates ? window.moment(dates[0]).diff(window.moment(dates[1]), "days") : "";
	    };
	}

/***/ })
]);


// WEBPACK FOOTER //
// app.383a8fff03366fab3d83.js